
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("tIJkD", function(module, exports) {
$parcel$export(module.exports, "Children", () => $059568069c6d3149$export$dca3b0875bd9a954, (v) => $059568069c6d3149$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $059568069c6d3149$export$16fa2f45be04daa8, (v) => $059568069c6d3149$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $059568069c6d3149$export$ffb0004e005737fa, (v) => $059568069c6d3149$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $059568069c6d3149$export$e2c29f18771995cb, (v) => $059568069c6d3149$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $059568069c6d3149$export$221d75b3f55bb0bd, (v) => $059568069c6d3149$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $059568069c6d3149$export$5f8d39834fd61797, (v) => $059568069c6d3149$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $059568069c6d3149$export$74bf444e3cd11ea5, (v) => $059568069c6d3149$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $059568069c6d3149$export$ae55be85d98224ed, (v) => $059568069c6d3149$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $059568069c6d3149$export$e530037191fcd5d7, (v) => $059568069c6d3149$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $059568069c6d3149$export$fd42f52fd3ae1109, (v) => $059568069c6d3149$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $059568069c6d3149$export$c8a8987d4410bf2d, (v) => $059568069c6d3149$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $059568069c6d3149$export$d38cd72104c1f0e9, (v) => $059568069c6d3149$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $059568069c6d3149$export$7d1e3a5e95ceca43, (v) => $059568069c6d3149$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $059568069c6d3149$export$257a8862b851cb5b, (v) => $059568069c6d3149$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $059568069c6d3149$export$a8257692ac88316c, (v) => $059568069c6d3149$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $059568069c6d3149$export$488013bae63b21da, (v) => $059568069c6d3149$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $059568069c6d3149$export$7c73462e0d25e514, (v) => $059568069c6d3149$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $059568069c6d3149$export$7568632d0d33d16d, (v) => $059568069c6d3149$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $059568069c6d3149$export$88948ce120ea2619, (v) => $059568069c6d3149$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $059568069c6d3149$export$35808ee640e87ca7, (v) => $059568069c6d3149$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $059568069c6d3149$export$fae74005e78b1a27, (v) => $059568069c6d3149$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $059568069c6d3149$export$dc8fbce3eb94dc1e, (v) => $059568069c6d3149$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $059568069c6d3149$export$6a7bc4e911dc01cf, (v) => $059568069c6d3149$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $059568069c6d3149$export$6d9c69b0de29b591, (v) => $059568069c6d3149$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $059568069c6d3149$export$f680877a34711e37, (v) => $059568069c6d3149$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $059568069c6d3149$export$d5a552a76deda3c2, (v) => $059568069c6d3149$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $059568069c6d3149$export$aaabe4eda9ed9969, (v) => $059568069c6d3149$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $059568069c6d3149$export$e5c5a5f917a5871c, (v) => $059568069c6d3149$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $059568069c6d3149$export$1538c33de8887b59, (v) => $059568069c6d3149$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $059568069c6d3149$export$13e3392192263954, (v) => $059568069c6d3149$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $059568069c6d3149$export$b8f5890fc79d6aca, (v) => $059568069c6d3149$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $059568069c6d3149$export$60241385465d0a34, (v) => $059568069c6d3149$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $059568069c6d3149$export$306c0aa65ff9ec16, (v) => $059568069c6d3149$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $059568069c6d3149$export$7b286972b8d8ccbf, (v) => $059568069c6d3149$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $059568069c6d3149$export$83d89fbfd8236492, (v) => $059568069c6d3149$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $059568069c6d3149$export$dca3b0875bd9a954;
var $059568069c6d3149$export$16fa2f45be04daa8;
var $059568069c6d3149$export$ffb0004e005737fa;
var $059568069c6d3149$export$e2c29f18771995cb;
var $059568069c6d3149$export$221d75b3f55bb0bd;
var $059568069c6d3149$export$5f8d39834fd61797;
var $059568069c6d3149$export$74bf444e3cd11ea5;
var $059568069c6d3149$export$ae55be85d98224ed;
var $059568069c6d3149$export$e530037191fcd5d7;
var $059568069c6d3149$export$fd42f52fd3ae1109;
var $059568069c6d3149$export$c8a8987d4410bf2d;
var $059568069c6d3149$export$d38cd72104c1f0e9;
var $059568069c6d3149$export$7d1e3a5e95ceca43;
var $059568069c6d3149$export$257a8862b851cb5b;
var $059568069c6d3149$export$a8257692ac88316c;
var $059568069c6d3149$export$488013bae63b21da;
var $059568069c6d3149$export$7c73462e0d25e514;
var $059568069c6d3149$export$7568632d0d33d16d;
var $059568069c6d3149$export$88948ce120ea2619;
var $059568069c6d3149$export$35808ee640e87ca7;
var $059568069c6d3149$export$fae74005e78b1a27;
var $059568069c6d3149$export$dc8fbce3eb94dc1e;
var $059568069c6d3149$export$6a7bc4e911dc01cf;
var $059568069c6d3149$export$6d9c69b0de29b591;
var $059568069c6d3149$export$f680877a34711e37;
var $059568069c6d3149$export$d5a552a76deda3c2;
var $059568069c6d3149$export$aaabe4eda9ed9969;
var $059568069c6d3149$export$e5c5a5f917a5871c;
var $059568069c6d3149$export$1538c33de8887b59;
var $059568069c6d3149$export$13e3392192263954;
var $059568069c6d3149$export$b8f5890fc79d6aca;
var $059568069c6d3149$export$60241385465d0a34;
var $059568069c6d3149$export$306c0aa65ff9ec16;
var $059568069c6d3149$export$7b286972b8d8ccbf;
var $059568069c6d3149$export$83d89fbfd8236492;
'use strict';
var $059568069c6d3149$var$l = Symbol.for("react.element"), $059568069c6d3149$var$n = Symbol.for("react.portal"), $059568069c6d3149$var$p = Symbol.for("react.fragment"), $059568069c6d3149$var$q = Symbol.for("react.strict_mode"), $059568069c6d3149$var$r = Symbol.for("react.profiler"), $059568069c6d3149$var$t = Symbol.for("react.provider"), $059568069c6d3149$var$u = Symbol.for("react.context"), $059568069c6d3149$var$v = Symbol.for("react.forward_ref"), $059568069c6d3149$var$w = Symbol.for("react.suspense"), $059568069c6d3149$var$x = Symbol.for("react.memo"), $059568069c6d3149$var$y = Symbol.for("react.lazy"), $059568069c6d3149$var$z = Symbol.iterator;
function $059568069c6d3149$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $059568069c6d3149$var$z && a[$059568069c6d3149$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $059568069c6d3149$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $059568069c6d3149$var$C = Object.assign, $059568069c6d3149$var$D = {};
function $059568069c6d3149$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $059568069c6d3149$var$D;
    this.updater = e || $059568069c6d3149$var$B;
}
$059568069c6d3149$var$E.prototype.isReactComponent = {};
$059568069c6d3149$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$059568069c6d3149$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $059568069c6d3149$var$F() {}
$059568069c6d3149$var$F.prototype = $059568069c6d3149$var$E.prototype;
function $059568069c6d3149$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $059568069c6d3149$var$D;
    this.updater = e || $059568069c6d3149$var$B;
}
var $059568069c6d3149$var$H = $059568069c6d3149$var$G.prototype = new $059568069c6d3149$var$F;
$059568069c6d3149$var$H.constructor = $059568069c6d3149$var$G;
$059568069c6d3149$var$C($059568069c6d3149$var$H, $059568069c6d3149$var$E.prototype);
$059568069c6d3149$var$H.isPureReactComponent = !0;
var $059568069c6d3149$var$I = Array.isArray, $059568069c6d3149$var$J = Object.prototype.hasOwnProperty, $059568069c6d3149$var$K = {
    current: null
}, $059568069c6d3149$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $059568069c6d3149$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$059568069c6d3149$var$J.call(b, d) && !$059568069c6d3149$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $059568069c6d3149$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $059568069c6d3149$var$K.current
    };
}
function $059568069c6d3149$var$N(a, b) {
    return {
        $$typeof: $059568069c6d3149$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $059568069c6d3149$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $059568069c6d3149$var$l;
}
function $059568069c6d3149$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $059568069c6d3149$var$P = /\/+/g;
function $059568069c6d3149$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $059568069c6d3149$var$escape("" + a.key) : b.toString(36);
}
function $059568069c6d3149$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $059568069c6d3149$var$l:
                case $059568069c6d3149$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $059568069c6d3149$var$Q(h, 0) : d, $059568069c6d3149$var$I(c) ? (e = "", null != a && (e = a.replace($059568069c6d3149$var$P, "$&/") + "/"), $059568069c6d3149$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($059568069c6d3149$var$O(c) && (c = $059568069c6d3149$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($059568069c6d3149$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($059568069c6d3149$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $059568069c6d3149$var$Q(k, g);
        h += $059568069c6d3149$var$R(k, b, e, f, c);
    }
    else if (f = $059568069c6d3149$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $059568069c6d3149$var$Q(k, g++), h += $059568069c6d3149$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $059568069c6d3149$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $059568069c6d3149$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $059568069c6d3149$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $059568069c6d3149$var$U = {
    current: null
}, $059568069c6d3149$var$V = {
    transition: null
}, $059568069c6d3149$var$W = {
    ReactCurrentDispatcher: $059568069c6d3149$var$U,
    ReactCurrentBatchConfig: $059568069c6d3149$var$V,
    ReactCurrentOwner: $059568069c6d3149$var$K
};
$059568069c6d3149$export$dca3b0875bd9a954 = {
    map: $059568069c6d3149$var$S,
    forEach: function(a, b, e) {
        $059568069c6d3149$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $059568069c6d3149$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $059568069c6d3149$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$059568069c6d3149$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$059568069c6d3149$export$16fa2f45be04daa8 = $059568069c6d3149$var$E;
$059568069c6d3149$export$ffb0004e005737fa = $059568069c6d3149$var$p;
$059568069c6d3149$export$e2c29f18771995cb = $059568069c6d3149$var$r;
$059568069c6d3149$export$221d75b3f55bb0bd = $059568069c6d3149$var$G;
$059568069c6d3149$export$5f8d39834fd61797 = $059568069c6d3149$var$q;
$059568069c6d3149$export$74bf444e3cd11ea5 = $059568069c6d3149$var$w;
$059568069c6d3149$export$ae55be85d98224ed = $059568069c6d3149$var$W;
$059568069c6d3149$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $059568069c6d3149$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $059568069c6d3149$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$059568069c6d3149$var$J.call(b, f) && !$059568069c6d3149$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $059568069c6d3149$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$059568069c6d3149$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $059568069c6d3149$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $059568069c6d3149$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$059568069c6d3149$export$c8a8987d4410bf2d = $059568069c6d3149$var$M;
$059568069c6d3149$export$d38cd72104c1f0e9 = function(a) {
    var b = $059568069c6d3149$var$M.bind(null, a);
    b.type = a;
    return b;
};
$059568069c6d3149$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$059568069c6d3149$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $059568069c6d3149$var$v,
        render: a
    };
};
$059568069c6d3149$export$a8257692ac88316c = $059568069c6d3149$var$O;
$059568069c6d3149$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $059568069c6d3149$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $059568069c6d3149$var$T
    };
};
$059568069c6d3149$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $059568069c6d3149$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$059568069c6d3149$export$7568632d0d33d16d = function(a) {
    var b = $059568069c6d3149$var$V.transition;
    $059568069c6d3149$var$V.transition = {};
    try {
        a();
    } finally{
        $059568069c6d3149$var$V.transition = b;
    }
};
$059568069c6d3149$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$059568069c6d3149$export$35808ee640e87ca7 = function(a, b) {
    return $059568069c6d3149$var$U.current.useCallback(a, b);
};
$059568069c6d3149$export$fae74005e78b1a27 = function(a) {
    return $059568069c6d3149$var$U.current.useContext(a);
};
$059568069c6d3149$export$dc8fbce3eb94dc1e = function() {};
$059568069c6d3149$export$6a7bc4e911dc01cf = function(a) {
    return $059568069c6d3149$var$U.current.useDeferredValue(a);
};
$059568069c6d3149$export$6d9c69b0de29b591 = function(a, b) {
    return $059568069c6d3149$var$U.current.useEffect(a, b);
};
$059568069c6d3149$export$f680877a34711e37 = function() {
    return $059568069c6d3149$var$U.current.useId();
};
$059568069c6d3149$export$d5a552a76deda3c2 = function(a, b, e) {
    return $059568069c6d3149$var$U.current.useImperativeHandle(a, b, e);
};
$059568069c6d3149$export$aaabe4eda9ed9969 = function(a, b) {
    return $059568069c6d3149$var$U.current.useInsertionEffect(a, b);
};
$059568069c6d3149$export$e5c5a5f917a5871c = function(a, b) {
    return $059568069c6d3149$var$U.current.useLayoutEffect(a, b);
};
$059568069c6d3149$export$1538c33de8887b59 = function(a, b) {
    return $059568069c6d3149$var$U.current.useMemo(a, b);
};
$059568069c6d3149$export$13e3392192263954 = function(a, b, e) {
    return $059568069c6d3149$var$U.current.useReducer(a, b, e);
};
$059568069c6d3149$export$b8f5890fc79d6aca = function(a) {
    return $059568069c6d3149$var$U.current.useRef(a);
};
$059568069c6d3149$export$60241385465d0a34 = function(a) {
    return $059568069c6d3149$var$U.current.useState(a);
};
$059568069c6d3149$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $059568069c6d3149$var$U.current.useSyncExternalStore(a, b, e);
};
$059568069c6d3149$export$7b286972b8d8ccbf = function() {
    return $059568069c6d3149$var$U.current.useTransition();
};
$059568069c6d3149$export$83d89fbfd8236492 = "18.2.0";

});

parcelRegister("lCoDQ", function(module, exports) {
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $fbd042e4a49259b8$export$ae55be85d98224ed, (v) => $fbd042e4a49259b8$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $fbd042e4a49259b8$export$d39a5bbd09211389, (v) => $fbd042e4a49259b8$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $fbd042e4a49259b8$export$882461b6382ed46c, (v) => $fbd042e4a49259b8$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $fbd042e4a49259b8$export$466bfc07425424d5, (v) => $fbd042e4a49259b8$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $fbd042e4a49259b8$export$cd75ccfd720a3cd4, (v) => $fbd042e4a49259b8$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $fbd042e4a49259b8$export$fa8d919ba61d84db, (v) => $fbd042e4a49259b8$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $fbd042e4a49259b8$export$757ceba2d55c277e, (v) => $fbd042e4a49259b8$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $fbd042e4a49259b8$export$b3890eb0ae9dca99, (v) => $fbd042e4a49259b8$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $fbd042e4a49259b8$export$502457920280e6be, (v) => $fbd042e4a49259b8$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $fbd042e4a49259b8$export$c78a37762a8d58e1, (v) => $fbd042e4a49259b8$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $fbd042e4a49259b8$export$dc54d992c10e8a18, (v) => $fbd042e4a49259b8$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $fbd042e4a49259b8$export$83d89fbfd8236492, (v) => $fbd042e4a49259b8$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.profiling.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $fbd042e4a49259b8$export$ae55be85d98224ed;
var $fbd042e4a49259b8$export$d39a5bbd09211389;
var $fbd042e4a49259b8$export$882461b6382ed46c;
var $fbd042e4a49259b8$export$466bfc07425424d5;
var $fbd042e4a49259b8$export$cd75ccfd720a3cd4;
var $fbd042e4a49259b8$export$fa8d919ba61d84db;
var $fbd042e4a49259b8$export$757ceba2d55c277e;
var $fbd042e4a49259b8$export$b3890eb0ae9dca99;
var $fbd042e4a49259b8$export$502457920280e6be;
var $fbd042e4a49259b8$export$c78a37762a8d58e1;
var $fbd042e4a49259b8$export$dc54d992c10e8a18;
var $fbd042e4a49259b8$export$83d89fbfd8236492;
'use strict';
/* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $gqzfn = parcelRequire("gqzfn");

var $9phqb = parcelRequire("9phqb");
function $fbd042e4a49259b8$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $fbd042e4a49259b8$var$da = new Set, $fbd042e4a49259b8$var$ea = {};
function $fbd042e4a49259b8$var$fa(a, b) {
    $fbd042e4a49259b8$var$ha(a, b);
    $fbd042e4a49259b8$var$ha(a + "Capture", b);
}
function $fbd042e4a49259b8$var$ha(a, b) {
    $fbd042e4a49259b8$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$fbd042e4a49259b8$var$da.add(b[a]);
}
var $fbd042e4a49259b8$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $fbd042e4a49259b8$var$ja = Object.prototype.hasOwnProperty, $fbd042e4a49259b8$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $fbd042e4a49259b8$var$la = {}, $fbd042e4a49259b8$var$ma = {};
function $fbd042e4a49259b8$var$na(a) {
    if ($fbd042e4a49259b8$var$ja.call($fbd042e4a49259b8$var$ma, a)) return !0;
    if ($fbd042e4a49259b8$var$ja.call($fbd042e4a49259b8$var$la, a)) return !1;
    if ($fbd042e4a49259b8$var$ka.test(a)) return $fbd042e4a49259b8$var$ma[a] = !0;
    $fbd042e4a49259b8$var$la[a] = !0;
    return !1;
}
function $fbd042e4a49259b8$var$oa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $fbd042e4a49259b8$var$pa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $fbd042e4a49259b8$var$oa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $fbd042e4a49259b8$var$qa(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $fbd042e4a49259b8$var$t = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $fbd042e4a49259b8$var$t[a] = new $fbd042e4a49259b8$var$qa(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $fbd042e4a49259b8$var$t[b] = new $fbd042e4a49259b8$var$qa(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $fbd042e4a49259b8$var$t[a] = new $fbd042e4a49259b8$var$qa(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $fbd042e4a49259b8$var$t[a] = new $fbd042e4a49259b8$var$qa(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $fbd042e4a49259b8$var$t[a] = new $fbd042e4a49259b8$var$qa(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $fbd042e4a49259b8$var$t[a] = new $fbd042e4a49259b8$var$qa(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $fbd042e4a49259b8$var$t[a] = new $fbd042e4a49259b8$var$qa(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $fbd042e4a49259b8$var$t[a] = new $fbd042e4a49259b8$var$qa(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $fbd042e4a49259b8$var$t[a] = new $fbd042e4a49259b8$var$qa(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $fbd042e4a49259b8$var$ra = /[\-:]([a-z])/g;
function $fbd042e4a49259b8$var$ta(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($fbd042e4a49259b8$var$ra, $fbd042e4a49259b8$var$ta);
    $fbd042e4a49259b8$var$t[b] = new $fbd042e4a49259b8$var$qa(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($fbd042e4a49259b8$var$ra, $fbd042e4a49259b8$var$ta);
    $fbd042e4a49259b8$var$t[b] = new $fbd042e4a49259b8$var$qa(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($fbd042e4a49259b8$var$ra, $fbd042e4a49259b8$var$ta);
    $fbd042e4a49259b8$var$t[b] = new $fbd042e4a49259b8$var$qa(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $fbd042e4a49259b8$var$t[a] = new $fbd042e4a49259b8$var$qa(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$fbd042e4a49259b8$var$t.xlinkHref = new $fbd042e4a49259b8$var$qa("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $fbd042e4a49259b8$var$t[a] = new $fbd042e4a49259b8$var$qa(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $fbd042e4a49259b8$var$ua(a, b, c, d) {
    var e = $fbd042e4a49259b8$var$t.hasOwnProperty(b) ? $fbd042e4a49259b8$var$t[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $fbd042e4a49259b8$var$pa(b, c, e, d) && (c = null), d || null === e ? $fbd042e4a49259b8$var$na(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $fbd042e4a49259b8$var$va = $gqzfn.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $fbd042e4a49259b8$var$wa = Symbol.for("react.element"), $fbd042e4a49259b8$var$xa = Symbol.for("react.portal"), $fbd042e4a49259b8$var$ya = Symbol.for("react.fragment"), $fbd042e4a49259b8$var$za = Symbol.for("react.strict_mode"), $fbd042e4a49259b8$var$Aa = Symbol.for("react.profiler"), $fbd042e4a49259b8$var$Ba = Symbol.for("react.provider"), $fbd042e4a49259b8$var$Ca = Symbol.for("react.context"), $fbd042e4a49259b8$var$Da = Symbol.for("react.forward_ref"), $fbd042e4a49259b8$var$Ea = Symbol.for("react.suspense"), $fbd042e4a49259b8$var$Fa = Symbol.for("react.suspense_list"), $fbd042e4a49259b8$var$Ga = Symbol.for("react.memo"), $fbd042e4a49259b8$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $fbd042e4a49259b8$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $fbd042e4a49259b8$var$Ja = Symbol.iterator;
function $fbd042e4a49259b8$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $fbd042e4a49259b8$var$Ja && a[$fbd042e4a49259b8$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $fbd042e4a49259b8$var$u = Object.assign, $fbd042e4a49259b8$var$La;
function $fbd042e4a49259b8$var$Ma(a) {
    if (void 0 === $fbd042e4a49259b8$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $fbd042e4a49259b8$var$La = b && b[1] || "";
    }
    return "\n" + $fbd042e4a49259b8$var$La + a;
}
var $fbd042e4a49259b8$var$Na = !1;
function $fbd042e4a49259b8$var$Oa(a, b) {
    if (!a || $fbd042e4a49259b8$var$Na) return "";
    $fbd042e4a49259b8$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $fbd042e4a49259b8$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $fbd042e4a49259b8$var$Ma(a) : "";
}
function $fbd042e4a49259b8$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $fbd042e4a49259b8$var$Ma(a.type);
        case 16:
            return $fbd042e4a49259b8$var$Ma("Lazy");
        case 13:
            return $fbd042e4a49259b8$var$Ma("Suspense");
        case 19:
            return $fbd042e4a49259b8$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $fbd042e4a49259b8$var$Oa(a.type, !1), a;
        case 11:
            return a = $fbd042e4a49259b8$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $fbd042e4a49259b8$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $fbd042e4a49259b8$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $fbd042e4a49259b8$var$ya:
            return "Fragment";
        case $fbd042e4a49259b8$var$xa:
            return "Portal";
        case $fbd042e4a49259b8$var$Aa:
            return "Profiler";
        case $fbd042e4a49259b8$var$za:
            return "StrictMode";
        case $fbd042e4a49259b8$var$Ea:
            return "Suspense";
        case $fbd042e4a49259b8$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $fbd042e4a49259b8$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $fbd042e4a49259b8$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $fbd042e4a49259b8$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $fbd042e4a49259b8$var$Ga:
            return b = a.displayName || null, null !== b ? b : $fbd042e4a49259b8$var$Qa(a.type) || "Memo";
        case $fbd042e4a49259b8$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $fbd042e4a49259b8$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $fbd042e4a49259b8$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $fbd042e4a49259b8$var$Qa(b);
        case 8:
            return b === $fbd042e4a49259b8$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $fbd042e4a49259b8$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $fbd042e4a49259b8$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $fbd042e4a49259b8$var$Ua(a) {
    var b = $fbd042e4a49259b8$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $fbd042e4a49259b8$var$Va(a) {
    a._valueTracker || (a._valueTracker = $fbd042e4a49259b8$var$Ua(a));
}
function $fbd042e4a49259b8$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $fbd042e4a49259b8$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $fbd042e4a49259b8$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $fbd042e4a49259b8$var$Ya(a, b) {
    var c = b.checked;
    return $fbd042e4a49259b8$var$u({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $fbd042e4a49259b8$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $fbd042e4a49259b8$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $fbd042e4a49259b8$var$$a(a, b) {
    b = b.checked;
    null != b && $fbd042e4a49259b8$var$ua(a, "checked", b, !1);
}
function $fbd042e4a49259b8$var$ab(a, b) {
    $fbd042e4a49259b8$var$$a(a, b);
    var c = $fbd042e4a49259b8$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $fbd042e4a49259b8$var$bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $fbd042e4a49259b8$var$bb(a, b.type, $fbd042e4a49259b8$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $fbd042e4a49259b8$var$cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $fbd042e4a49259b8$var$bb(a, b, c) {
    if ("number" !== b || $fbd042e4a49259b8$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $fbd042e4a49259b8$var$db = Array.isArray;
function $fbd042e4a49259b8$var$eb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $fbd042e4a49259b8$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $fbd042e4a49259b8$var$fb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($fbd042e4a49259b8$var$p(91));
    return $fbd042e4a49259b8$var$u({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $fbd042e4a49259b8$var$gb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($fbd042e4a49259b8$var$p(92));
            if ($fbd042e4a49259b8$var$db(c)) {
                if (1 < c.length) throw Error($fbd042e4a49259b8$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $fbd042e4a49259b8$var$Sa(c)
    };
}
function $fbd042e4a49259b8$var$hb(a, b) {
    var c = $fbd042e4a49259b8$var$Sa(b.value), d = $fbd042e4a49259b8$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $fbd042e4a49259b8$var$ib(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $fbd042e4a49259b8$var$jb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $fbd042e4a49259b8$var$kb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $fbd042e4a49259b8$var$jb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $fbd042e4a49259b8$var$lb, $fbd042e4a49259b8$var$mb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $fbd042e4a49259b8$var$lb = $fbd042e4a49259b8$var$lb || document.createElement("div");
        $fbd042e4a49259b8$var$lb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $fbd042e4a49259b8$var$lb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $fbd042e4a49259b8$var$nb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $fbd042e4a49259b8$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $fbd042e4a49259b8$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($fbd042e4a49259b8$var$pb).forEach(function(a) {
    $fbd042e4a49259b8$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $fbd042e4a49259b8$var$pb[b] = $fbd042e4a49259b8$var$pb[a];
    });
});
function $fbd042e4a49259b8$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $fbd042e4a49259b8$var$pb.hasOwnProperty(a) && $fbd042e4a49259b8$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $fbd042e4a49259b8$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $fbd042e4a49259b8$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $fbd042e4a49259b8$var$tb = $fbd042e4a49259b8$var$u({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $fbd042e4a49259b8$var$ub(a, b) {
    if (b) {
        if ($fbd042e4a49259b8$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($fbd042e4a49259b8$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($fbd042e4a49259b8$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($fbd042e4a49259b8$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($fbd042e4a49259b8$var$p(62));
    }
}
function $fbd042e4a49259b8$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $fbd042e4a49259b8$var$wb = null;
function $fbd042e4a49259b8$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $fbd042e4a49259b8$var$yb = null, $fbd042e4a49259b8$var$zb = null, $fbd042e4a49259b8$var$Ab = null;
function $fbd042e4a49259b8$var$Bb(a) {
    if (a = $fbd042e4a49259b8$var$Cb(a)) {
        if ("function" !== typeof $fbd042e4a49259b8$var$yb) throw Error($fbd042e4a49259b8$var$p(280));
        var b = a.stateNode;
        b && (b = $fbd042e4a49259b8$var$Db(b), $fbd042e4a49259b8$var$yb(a.stateNode, a.type, b));
    }
}
function $fbd042e4a49259b8$var$Eb(a) {
    $fbd042e4a49259b8$var$zb ? $fbd042e4a49259b8$var$Ab ? $fbd042e4a49259b8$var$Ab.push(a) : $fbd042e4a49259b8$var$Ab = [
        a
    ] : $fbd042e4a49259b8$var$zb = a;
}
function $fbd042e4a49259b8$var$Fb() {
    if ($fbd042e4a49259b8$var$zb) {
        var a = $fbd042e4a49259b8$var$zb, b = $fbd042e4a49259b8$var$Ab;
        $fbd042e4a49259b8$var$Ab = $fbd042e4a49259b8$var$zb = null;
        $fbd042e4a49259b8$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$fbd042e4a49259b8$var$Bb(b[a]);
    }
}
function $fbd042e4a49259b8$var$Gb(a, b) {
    return a(b);
}
function $fbd042e4a49259b8$var$Hb() {}
var $fbd042e4a49259b8$var$Ib = !1;
function $fbd042e4a49259b8$var$Jb(a, b, c) {
    if ($fbd042e4a49259b8$var$Ib) return a(b, c);
    $fbd042e4a49259b8$var$Ib = !0;
    try {
        return $fbd042e4a49259b8$var$Gb(a, b, c);
    } finally{
        if ($fbd042e4a49259b8$var$Ib = !1, null !== $fbd042e4a49259b8$var$zb || null !== $fbd042e4a49259b8$var$Ab) $fbd042e4a49259b8$var$Hb(), $fbd042e4a49259b8$var$Fb();
    }
}
function $fbd042e4a49259b8$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $fbd042e4a49259b8$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($fbd042e4a49259b8$var$p(231, b, typeof c));
    return c;
}
var $fbd042e4a49259b8$var$Lb = !1;
if ($fbd042e4a49259b8$var$ia) try {
    var $fbd042e4a49259b8$var$Mb = {};
    Object.defineProperty($fbd042e4a49259b8$var$Mb, "passive", {
        get: function() {
            $fbd042e4a49259b8$var$Lb = !0;
        }
    });
    window.addEventListener("test", $fbd042e4a49259b8$var$Mb, $fbd042e4a49259b8$var$Mb);
    window.removeEventListener("test", $fbd042e4a49259b8$var$Mb, $fbd042e4a49259b8$var$Mb);
} catch (a) {
    $fbd042e4a49259b8$var$Lb = !1;
}
function $fbd042e4a49259b8$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var $fbd042e4a49259b8$var$Ob = !1, $fbd042e4a49259b8$var$Pb = null, $fbd042e4a49259b8$var$Qb = !1, $fbd042e4a49259b8$var$Rb = null, $fbd042e4a49259b8$var$Sb = {
    onError: function(a) {
        $fbd042e4a49259b8$var$Ob = !0;
        $fbd042e4a49259b8$var$Pb = a;
    }
};
function $fbd042e4a49259b8$var$Tb(a, b, c, d, e, f, g, h, k) {
    $fbd042e4a49259b8$var$Ob = !1;
    $fbd042e4a49259b8$var$Pb = null;
    $fbd042e4a49259b8$var$Nb.apply($fbd042e4a49259b8$var$Sb, arguments);
}
function $fbd042e4a49259b8$var$Ub(a, b, c, d, e, f, g, h, k) {
    $fbd042e4a49259b8$var$Tb.apply(this, arguments);
    if ($fbd042e4a49259b8$var$Ob) {
        if ($fbd042e4a49259b8$var$Ob) {
            var l = $fbd042e4a49259b8$var$Pb;
            $fbd042e4a49259b8$var$Ob = !1;
            $fbd042e4a49259b8$var$Pb = null;
        } else throw Error($fbd042e4a49259b8$var$p(198));
        $fbd042e4a49259b8$var$Qb || ($fbd042e4a49259b8$var$Qb = !0, $fbd042e4a49259b8$var$Rb = l);
    }
}
function $fbd042e4a49259b8$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $fbd042e4a49259b8$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $fbd042e4a49259b8$var$Xb(a) {
    if ($fbd042e4a49259b8$var$Vb(a) !== a) throw Error($fbd042e4a49259b8$var$p(188));
}
function $fbd042e4a49259b8$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $fbd042e4a49259b8$var$Vb(a);
        if (null === b) throw Error($fbd042e4a49259b8$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $fbd042e4a49259b8$var$Xb(e), a;
                if (f === d) return $fbd042e4a49259b8$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($fbd042e4a49259b8$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($fbd042e4a49259b8$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($fbd042e4a49259b8$var$p(190));
    }
    if (3 !== c.tag) throw Error($fbd042e4a49259b8$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $fbd042e4a49259b8$var$Zb(a) {
    a = $fbd042e4a49259b8$var$Yb(a);
    return null !== a ? $fbd042e4a49259b8$var$$b(a) : null;
}
function $fbd042e4a49259b8$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $fbd042e4a49259b8$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $fbd042e4a49259b8$var$ac = $9phqb.unstable_scheduleCallback, $fbd042e4a49259b8$var$bc = $9phqb.unstable_cancelCallback, $fbd042e4a49259b8$var$cc = $9phqb.unstable_shouldYield, $fbd042e4a49259b8$var$dc = $9phqb.unstable_requestPaint, $fbd042e4a49259b8$var$A = $9phqb.unstable_now, $fbd042e4a49259b8$var$ec = $9phqb.unstable_getCurrentPriorityLevel, $fbd042e4a49259b8$var$fc = $9phqb.unstable_ImmediatePriority, $fbd042e4a49259b8$var$gc = $9phqb.unstable_UserBlockingPriority, $fbd042e4a49259b8$var$hc = $9phqb.unstable_NormalPriority, $fbd042e4a49259b8$var$ic = $9phqb.unstable_LowPriority, $fbd042e4a49259b8$var$jc = $9phqb.unstable_IdlePriority, $fbd042e4a49259b8$var$kc = null, $fbd042e4a49259b8$var$lc = null, $fbd042e4a49259b8$var$B = null, $fbd042e4a49259b8$var$mc = "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__;
function $fbd042e4a49259b8$var$nc(a, b) {
    if ($fbd042e4a49259b8$var$lc && "function" === typeof $fbd042e4a49259b8$var$lc.onCommitFiberRoot) try {
        var c = 128 === (a.current.flags & 128);
        switch(b){
            case 1:
                var d = $fbd042e4a49259b8$var$fc;
                break;
            case 4:
                d = $fbd042e4a49259b8$var$gc;
                break;
            case 16:
                d = $fbd042e4a49259b8$var$hc;
                break;
            case 536870912:
                d = $fbd042e4a49259b8$var$jc;
                break;
            default:
                d = $fbd042e4a49259b8$var$hc;
        }
        $fbd042e4a49259b8$var$lc.onCommitFiberRoot($fbd042e4a49259b8$var$kc, a, d, c);
    } catch (e) {}
}
function $fbd042e4a49259b8$var$oc(a) {
    $fbd042e4a49259b8$var$B = a;
}
function $fbd042e4a49259b8$var$pc() {
    for(var a = new Map, b = 1, c = 0; 31 > c; c++){
        var d = $fbd042e4a49259b8$var$qc(b);
        a.set(b, d);
        b *= 2;
    }
    return a;
}
function $fbd042e4a49259b8$var$rc() {
    null !== $fbd042e4a49259b8$var$B && "function" === typeof $fbd042e4a49259b8$var$B.markCommitStopped && $fbd042e4a49259b8$var$B.markCommitStopped();
}
function $fbd042e4a49259b8$var$sc(a) {
    null !== $fbd042e4a49259b8$var$B && "function" === typeof $fbd042e4a49259b8$var$B.markComponentRenderStarted && $fbd042e4a49259b8$var$B.markComponentRenderStarted(a);
}
function $fbd042e4a49259b8$var$tc() {
    null !== $fbd042e4a49259b8$var$B && "function" === typeof $fbd042e4a49259b8$var$B.markComponentRenderStopped && $fbd042e4a49259b8$var$B.markComponentRenderStopped();
}
function $fbd042e4a49259b8$var$uc(a) {
    null !== $fbd042e4a49259b8$var$B && "function" === typeof $fbd042e4a49259b8$var$B.markComponentLayoutEffectUnmountStarted && $fbd042e4a49259b8$var$B.markComponentLayoutEffectUnmountStarted(a);
}
function $fbd042e4a49259b8$var$vc() {
    null !== $fbd042e4a49259b8$var$B && "function" === typeof $fbd042e4a49259b8$var$B.markComponentLayoutEffectUnmountStopped && $fbd042e4a49259b8$var$B.markComponentLayoutEffectUnmountStopped();
}
function $fbd042e4a49259b8$var$wc(a) {
    null !== $fbd042e4a49259b8$var$B && "function" === typeof $fbd042e4a49259b8$var$B.markRenderStarted && $fbd042e4a49259b8$var$B.markRenderStarted(a);
}
function $fbd042e4a49259b8$var$xc() {
    null !== $fbd042e4a49259b8$var$B && "function" === typeof $fbd042e4a49259b8$var$B.markRenderStopped && $fbd042e4a49259b8$var$B.markRenderStopped();
}
function $fbd042e4a49259b8$var$yc(a, b) {
    null !== $fbd042e4a49259b8$var$B && "function" === typeof $fbd042e4a49259b8$var$B.markStateUpdateScheduled && $fbd042e4a49259b8$var$B.markStateUpdateScheduled(a, b);
}
var $fbd042e4a49259b8$var$Ac = Math.clz32 ? Math.clz32 : $fbd042e4a49259b8$var$zc, $fbd042e4a49259b8$var$Bc = Math.log, $fbd042e4a49259b8$var$Cc = Math.LN2;
function $fbd042e4a49259b8$var$zc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($fbd042e4a49259b8$var$Bc(a) / $fbd042e4a49259b8$var$Cc | 0) | 0;
}
function $fbd042e4a49259b8$var$qc(a) {
    if (a & 1) return "Sync";
    if (a & 2) return "InputContinuousHydration";
    if (a & 4) return "InputContinuous";
    if (a & 8) return "DefaultHydration";
    if (a & 16) return "Default";
    if (a & 32) return "TransitionHydration";
    if (a & 4194240) return "Transition";
    if (a & 130023424) return "Retry";
    if (a & 134217728) return "SelectiveHydration";
    if (a & 268435456) return "IdleHydration";
    if (a & 536870912) return "Idle";
    if (a & 1073741824) return "Offscreen";
}
var $fbd042e4a49259b8$var$Dc = 64, $fbd042e4a49259b8$var$Ec = 4194304;
function $fbd042e4a49259b8$var$Fc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $fbd042e4a49259b8$var$Gc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $fbd042e4a49259b8$var$Fc(h) : (f &= g, 0 !== f && (d = $fbd042e4a49259b8$var$Fc(f)));
    } else g = c & ~e, 0 !== g ? d = $fbd042e4a49259b8$var$Fc(g) : 0 !== f && (d = $fbd042e4a49259b8$var$Fc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $fbd042e4a49259b8$var$Ac(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $fbd042e4a49259b8$var$Hc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $fbd042e4a49259b8$var$Ic(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $fbd042e4a49259b8$var$Ac(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $fbd042e4a49259b8$var$Hc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $fbd042e4a49259b8$var$Jc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $fbd042e4a49259b8$var$Kc() {
    var a = $fbd042e4a49259b8$var$Dc;
    $fbd042e4a49259b8$var$Dc <<= 1;
    0 === ($fbd042e4a49259b8$var$Dc & 4194240) && ($fbd042e4a49259b8$var$Dc = 64);
    return a;
}
function $fbd042e4a49259b8$var$Lc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $fbd042e4a49259b8$var$Mc(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $fbd042e4a49259b8$var$Ac(b);
    a[b] = c;
}
function $fbd042e4a49259b8$var$Nc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $fbd042e4a49259b8$var$Ac(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $fbd042e4a49259b8$var$Oc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $fbd042e4a49259b8$var$Ac(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
function $fbd042e4a49259b8$var$Pc(a, b, c) {
    if ($fbd042e4a49259b8$var$mc) for(a = a.pendingUpdatersLaneMap; 0 < c;){
        var d = 31 - $fbd042e4a49259b8$var$Ac(c), e = 1 << d;
        a[d].add(b);
        c &= ~e;
    }
}
function $fbd042e4a49259b8$var$Qc(a, b) {
    if ($fbd042e4a49259b8$var$mc) for(var c = a.pendingUpdatersLaneMap, d = a.memoizedUpdaters; 0 < b;){
        var e = 31 - $fbd042e4a49259b8$var$Ac(b);
        a = 1 << e;
        e = c[e];
        0 < e.size && (e.forEach(function(a) {
            var b = a.alternate;
            null !== b && d.has(b) || d.add(a);
        }), e.clear());
        b &= ~a;
    }
}
var $fbd042e4a49259b8$var$E = 0;
function $fbd042e4a49259b8$var$Rc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $fbd042e4a49259b8$var$Sc, $fbd042e4a49259b8$var$Tc, $fbd042e4a49259b8$var$Uc, $fbd042e4a49259b8$var$Vc, $fbd042e4a49259b8$var$Wc, $fbd042e4a49259b8$var$Xc = !1, $fbd042e4a49259b8$var$Yc = [], $fbd042e4a49259b8$var$Zc = null, $fbd042e4a49259b8$var$$c = null, $fbd042e4a49259b8$var$ad = null, $fbd042e4a49259b8$var$bd = new Map, $fbd042e4a49259b8$var$cd = new Map, $fbd042e4a49259b8$var$dd = [], $fbd042e4a49259b8$var$ed = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $fbd042e4a49259b8$var$fd(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $fbd042e4a49259b8$var$Zc = null;
            break;
        case "dragenter":
        case "dragleave":
            $fbd042e4a49259b8$var$$c = null;
            break;
        case "mouseover":
        case "mouseout":
            $fbd042e4a49259b8$var$ad = null;
            break;
        case "pointerover":
        case "pointerout":
            $fbd042e4a49259b8$var$bd.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $fbd042e4a49259b8$var$cd.delete(b.pointerId);
    }
}
function $fbd042e4a49259b8$var$gd(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $fbd042e4a49259b8$var$Cb(b), null !== b && $fbd042e4a49259b8$var$Tc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $fbd042e4a49259b8$var$hd(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $fbd042e4a49259b8$var$Zc = $fbd042e4a49259b8$var$gd($fbd042e4a49259b8$var$Zc, a, b, c, d, e), !0;
        case "dragenter":
            return $fbd042e4a49259b8$var$$c = $fbd042e4a49259b8$var$gd($fbd042e4a49259b8$var$$c, a, b, c, d, e), !0;
        case "mouseover":
            return $fbd042e4a49259b8$var$ad = $fbd042e4a49259b8$var$gd($fbd042e4a49259b8$var$ad, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $fbd042e4a49259b8$var$bd.set(f, $fbd042e4a49259b8$var$gd($fbd042e4a49259b8$var$bd.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $fbd042e4a49259b8$var$cd.set(f, $fbd042e4a49259b8$var$gd($fbd042e4a49259b8$var$cd.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $fbd042e4a49259b8$var$id(a) {
    var b = $fbd042e4a49259b8$var$jd(a.target);
    if (null !== b) {
        var c = $fbd042e4a49259b8$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $fbd042e4a49259b8$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $fbd042e4a49259b8$var$Wc(a.priority, function() {
                        $fbd042e4a49259b8$var$Uc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $fbd042e4a49259b8$var$kd(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $fbd042e4a49259b8$var$ld(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $fbd042e4a49259b8$var$wb = d;
            c.target.dispatchEvent(d);
            $fbd042e4a49259b8$var$wb = null;
        } else return b = $fbd042e4a49259b8$var$Cb(c), null !== b && $fbd042e4a49259b8$var$Tc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $fbd042e4a49259b8$var$md(a, b, c) {
    $fbd042e4a49259b8$var$kd(a) && c.delete(b);
}
function $fbd042e4a49259b8$var$nd() {
    $fbd042e4a49259b8$var$Xc = !1;
    null !== $fbd042e4a49259b8$var$Zc && $fbd042e4a49259b8$var$kd($fbd042e4a49259b8$var$Zc) && ($fbd042e4a49259b8$var$Zc = null);
    null !== $fbd042e4a49259b8$var$$c && $fbd042e4a49259b8$var$kd($fbd042e4a49259b8$var$$c) && ($fbd042e4a49259b8$var$$c = null);
    null !== $fbd042e4a49259b8$var$ad && $fbd042e4a49259b8$var$kd($fbd042e4a49259b8$var$ad) && ($fbd042e4a49259b8$var$ad = null);
    $fbd042e4a49259b8$var$bd.forEach($fbd042e4a49259b8$var$md);
    $fbd042e4a49259b8$var$cd.forEach($fbd042e4a49259b8$var$md);
}
function $fbd042e4a49259b8$var$od(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $fbd042e4a49259b8$var$Xc || ($fbd042e4a49259b8$var$Xc = !0, $9phqb.unstable_scheduleCallback($9phqb.unstable_NormalPriority, $fbd042e4a49259b8$var$nd)));
}
function $fbd042e4a49259b8$var$pd(a) {
    function b(b) {
        return $fbd042e4a49259b8$var$od(b, a);
    }
    if (0 < $fbd042e4a49259b8$var$Yc.length) {
        $fbd042e4a49259b8$var$od($fbd042e4a49259b8$var$Yc[0], a);
        for(var c = 1; c < $fbd042e4a49259b8$var$Yc.length; c++){
            var d = $fbd042e4a49259b8$var$Yc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $fbd042e4a49259b8$var$Zc && $fbd042e4a49259b8$var$od($fbd042e4a49259b8$var$Zc, a);
    null !== $fbd042e4a49259b8$var$$c && $fbd042e4a49259b8$var$od($fbd042e4a49259b8$var$$c, a);
    null !== $fbd042e4a49259b8$var$ad && $fbd042e4a49259b8$var$od($fbd042e4a49259b8$var$ad, a);
    $fbd042e4a49259b8$var$bd.forEach(b);
    $fbd042e4a49259b8$var$cd.forEach(b);
    for(c = 0; c < $fbd042e4a49259b8$var$dd.length; c++)d = $fbd042e4a49259b8$var$dd[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $fbd042e4a49259b8$var$dd.length && (c = $fbd042e4a49259b8$var$dd[0], null === c.blockedOn);)$fbd042e4a49259b8$var$id(c), null === c.blockedOn && $fbd042e4a49259b8$var$dd.shift();
}
var $fbd042e4a49259b8$var$qd = $fbd042e4a49259b8$var$va.ReactCurrentBatchConfig, $fbd042e4a49259b8$var$rd = !0;
function $fbd042e4a49259b8$var$sd(a, b, c, d) {
    var e = $fbd042e4a49259b8$var$E, f = $fbd042e4a49259b8$var$qd.transition;
    $fbd042e4a49259b8$var$qd.transition = null;
    try {
        $fbd042e4a49259b8$var$E = 1, $fbd042e4a49259b8$var$td(a, b, c, d);
    } finally{
        $fbd042e4a49259b8$var$E = e, $fbd042e4a49259b8$var$qd.transition = f;
    }
}
function $fbd042e4a49259b8$var$ud(a, b, c, d) {
    var e = $fbd042e4a49259b8$var$E, f = $fbd042e4a49259b8$var$qd.transition;
    $fbd042e4a49259b8$var$qd.transition = null;
    try {
        $fbd042e4a49259b8$var$E = 4, $fbd042e4a49259b8$var$td(a, b, c, d);
    } finally{
        $fbd042e4a49259b8$var$E = e, $fbd042e4a49259b8$var$qd.transition = f;
    }
}
function $fbd042e4a49259b8$var$td(a, b, c, d) {
    if ($fbd042e4a49259b8$var$rd) {
        var e = $fbd042e4a49259b8$var$ld(a, b, c, d);
        if (null === e) $fbd042e4a49259b8$var$vd(a, b, d, $fbd042e4a49259b8$var$wd, c), $fbd042e4a49259b8$var$fd(a, d);
        else if ($fbd042e4a49259b8$var$hd(e, a, b, c, d)) d.stopPropagation();
        else if ($fbd042e4a49259b8$var$fd(a, d), b & 4 && -1 < $fbd042e4a49259b8$var$ed.indexOf(a)) {
            for(; null !== e;){
                var f = $fbd042e4a49259b8$var$Cb(e);
                null !== f && $fbd042e4a49259b8$var$Sc(f);
                f = $fbd042e4a49259b8$var$ld(a, b, c, d);
                null === f && $fbd042e4a49259b8$var$vd(a, b, d, $fbd042e4a49259b8$var$wd, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $fbd042e4a49259b8$var$vd(a, b, d, null, c);
    }
}
var $fbd042e4a49259b8$var$wd = null;
function $fbd042e4a49259b8$var$ld(a, b, c, d) {
    $fbd042e4a49259b8$var$wd = null;
    a = $fbd042e4a49259b8$var$xb(d);
    a = $fbd042e4a49259b8$var$jd(a);
    if (null !== a) {
        if (b = $fbd042e4a49259b8$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $fbd042e4a49259b8$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $fbd042e4a49259b8$var$wd = a;
    return null;
}
function $fbd042e4a49259b8$var$xd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($fbd042e4a49259b8$var$ec()){
                case $fbd042e4a49259b8$var$fc:
                    return 1;
                case $fbd042e4a49259b8$var$gc:
                    return 4;
                case $fbd042e4a49259b8$var$hc:
                case $fbd042e4a49259b8$var$ic:
                    return 16;
                case $fbd042e4a49259b8$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $fbd042e4a49259b8$var$yd = null, $fbd042e4a49259b8$var$zd = null, $fbd042e4a49259b8$var$Ad = null;
function $fbd042e4a49259b8$var$Bd() {
    if ($fbd042e4a49259b8$var$Ad) return $fbd042e4a49259b8$var$Ad;
    var a, b = $fbd042e4a49259b8$var$zd, c = b.length, d, e = "value" in $fbd042e4a49259b8$var$yd ? $fbd042e4a49259b8$var$yd.value : $fbd042e4a49259b8$var$yd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $fbd042e4a49259b8$var$Ad = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $fbd042e4a49259b8$var$Cd(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $fbd042e4a49259b8$var$Dd() {
    return !0;
}
function $fbd042e4a49259b8$var$Ed() {
    return !1;
}
function $fbd042e4a49259b8$var$Fd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $fbd042e4a49259b8$var$Dd : $fbd042e4a49259b8$var$Ed;
        this.isPropagationStopped = $fbd042e4a49259b8$var$Ed;
        return this;
    }
    $fbd042e4a49259b8$var$u(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $fbd042e4a49259b8$var$Dd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $fbd042e4a49259b8$var$Dd);
        },
        persist: function() {},
        isPersistent: $fbd042e4a49259b8$var$Dd
    });
    return b;
}
var $fbd042e4a49259b8$var$Gd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $fbd042e4a49259b8$var$Hd = $fbd042e4a49259b8$var$Fd($fbd042e4a49259b8$var$Gd), $fbd042e4a49259b8$var$Id = $fbd042e4a49259b8$var$u({}, $fbd042e4a49259b8$var$Gd, {
    view: 0,
    detail: 0
}), $fbd042e4a49259b8$var$Jd = $fbd042e4a49259b8$var$Fd($fbd042e4a49259b8$var$Id), $fbd042e4a49259b8$var$Kd, $fbd042e4a49259b8$var$Ld, $fbd042e4a49259b8$var$Md, $fbd042e4a49259b8$var$Od = $fbd042e4a49259b8$var$u({}, $fbd042e4a49259b8$var$Id, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $fbd042e4a49259b8$var$Nd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $fbd042e4a49259b8$var$Md && ($fbd042e4a49259b8$var$Md && "mousemove" === a.type ? ($fbd042e4a49259b8$var$Kd = a.screenX - $fbd042e4a49259b8$var$Md.screenX, $fbd042e4a49259b8$var$Ld = a.screenY - $fbd042e4a49259b8$var$Md.screenY) : $fbd042e4a49259b8$var$Ld = $fbd042e4a49259b8$var$Kd = 0, $fbd042e4a49259b8$var$Md = a);
        return $fbd042e4a49259b8$var$Kd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $fbd042e4a49259b8$var$Ld;
    }
}), $fbd042e4a49259b8$var$Pd = $fbd042e4a49259b8$var$Fd($fbd042e4a49259b8$var$Od), $fbd042e4a49259b8$var$Qd = $fbd042e4a49259b8$var$u({}, $fbd042e4a49259b8$var$Od, {
    dataTransfer: 0
}), $fbd042e4a49259b8$var$Rd = $fbd042e4a49259b8$var$Fd($fbd042e4a49259b8$var$Qd), $fbd042e4a49259b8$var$Sd = $fbd042e4a49259b8$var$u({}, $fbd042e4a49259b8$var$Id, {
    relatedTarget: 0
}), $fbd042e4a49259b8$var$Td = $fbd042e4a49259b8$var$Fd($fbd042e4a49259b8$var$Sd), $fbd042e4a49259b8$var$Ud = $fbd042e4a49259b8$var$u({}, $fbd042e4a49259b8$var$Gd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $fbd042e4a49259b8$var$Vd = $fbd042e4a49259b8$var$Fd($fbd042e4a49259b8$var$Ud), $fbd042e4a49259b8$var$Wd = $fbd042e4a49259b8$var$u({}, $fbd042e4a49259b8$var$Gd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $fbd042e4a49259b8$var$Xd = $fbd042e4a49259b8$var$Fd($fbd042e4a49259b8$var$Wd), $fbd042e4a49259b8$var$Yd = $fbd042e4a49259b8$var$u({}, $fbd042e4a49259b8$var$Gd, {
    data: 0
}), $fbd042e4a49259b8$var$Zd = $fbd042e4a49259b8$var$Fd($fbd042e4a49259b8$var$Yd), $fbd042e4a49259b8$var$$d = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $fbd042e4a49259b8$var$ae = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $fbd042e4a49259b8$var$be = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $fbd042e4a49259b8$var$ce(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $fbd042e4a49259b8$var$be[a]) ? !!b[a] : !1;
}
function $fbd042e4a49259b8$var$Nd() {
    return $fbd042e4a49259b8$var$ce;
}
var $fbd042e4a49259b8$var$de = $fbd042e4a49259b8$var$u({}, $fbd042e4a49259b8$var$Id, {
    key: function(a) {
        if (a.key) {
            var b = $fbd042e4a49259b8$var$$d[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $fbd042e4a49259b8$var$Cd(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $fbd042e4a49259b8$var$ae[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $fbd042e4a49259b8$var$Nd,
    charCode: function(a) {
        return "keypress" === a.type ? $fbd042e4a49259b8$var$Cd(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $fbd042e4a49259b8$var$Cd(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $fbd042e4a49259b8$var$ee = $fbd042e4a49259b8$var$Fd($fbd042e4a49259b8$var$de), $fbd042e4a49259b8$var$fe = $fbd042e4a49259b8$var$u({}, $fbd042e4a49259b8$var$Od, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $fbd042e4a49259b8$var$ge = $fbd042e4a49259b8$var$Fd($fbd042e4a49259b8$var$fe), $fbd042e4a49259b8$var$he = $fbd042e4a49259b8$var$u({}, $fbd042e4a49259b8$var$Id, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $fbd042e4a49259b8$var$Nd
}), $fbd042e4a49259b8$var$ie = $fbd042e4a49259b8$var$Fd($fbd042e4a49259b8$var$he), $fbd042e4a49259b8$var$je = $fbd042e4a49259b8$var$u({}, $fbd042e4a49259b8$var$Gd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $fbd042e4a49259b8$var$ke = $fbd042e4a49259b8$var$Fd($fbd042e4a49259b8$var$je), $fbd042e4a49259b8$var$le = $fbd042e4a49259b8$var$u({}, $fbd042e4a49259b8$var$Od, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $fbd042e4a49259b8$var$me = $fbd042e4a49259b8$var$Fd($fbd042e4a49259b8$var$le), $fbd042e4a49259b8$var$ne = [
    9,
    13,
    27,
    32
], $fbd042e4a49259b8$var$oe = $fbd042e4a49259b8$var$ia && "CompositionEvent" in window, $fbd042e4a49259b8$var$pe = null;
$fbd042e4a49259b8$var$ia && "documentMode" in document && ($fbd042e4a49259b8$var$pe = document.documentMode);
var $fbd042e4a49259b8$var$qe = $fbd042e4a49259b8$var$ia && "TextEvent" in window && !$fbd042e4a49259b8$var$pe, $fbd042e4a49259b8$var$re = $fbd042e4a49259b8$var$ia && (!$fbd042e4a49259b8$var$oe || $fbd042e4a49259b8$var$pe && 8 < $fbd042e4a49259b8$var$pe && 11 >= $fbd042e4a49259b8$var$pe), $fbd042e4a49259b8$var$se = String.fromCharCode(32), $fbd042e4a49259b8$var$te = !1;
function $fbd042e4a49259b8$var$ue(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $fbd042e4a49259b8$var$ne.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $fbd042e4a49259b8$var$ve(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $fbd042e4a49259b8$var$we = !1;
function $fbd042e4a49259b8$var$xe(a, b) {
    switch(a){
        case "compositionend":
            return $fbd042e4a49259b8$var$ve(b);
        case "keypress":
            if (32 !== b.which) return null;
            $fbd042e4a49259b8$var$te = !0;
            return $fbd042e4a49259b8$var$se;
        case "textInput":
            return a = b.data, a === $fbd042e4a49259b8$var$se && $fbd042e4a49259b8$var$te ? null : a;
        default:
            return null;
    }
}
function $fbd042e4a49259b8$var$ye(a, b) {
    if ($fbd042e4a49259b8$var$we) return "compositionend" === a || !$fbd042e4a49259b8$var$oe && $fbd042e4a49259b8$var$ue(a, b) ? (a = $fbd042e4a49259b8$var$Bd(), $fbd042e4a49259b8$var$Ad = $fbd042e4a49259b8$var$zd = $fbd042e4a49259b8$var$yd = null, $fbd042e4a49259b8$var$we = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $fbd042e4a49259b8$var$re && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $fbd042e4a49259b8$var$ze = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $fbd042e4a49259b8$var$Ae(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$fbd042e4a49259b8$var$ze[a.type] : "textarea" === b ? !0 : !1;
}
function $fbd042e4a49259b8$var$Be(a, b, c, d) {
    $fbd042e4a49259b8$var$Eb(d);
    b = $fbd042e4a49259b8$var$Ce(b, "onChange");
    0 < b.length && (c = new $fbd042e4a49259b8$var$Hd("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $fbd042e4a49259b8$var$De = null, $fbd042e4a49259b8$var$Ee = null;
function $fbd042e4a49259b8$var$Fe(a) {
    $fbd042e4a49259b8$var$Ge(a, 0);
}
function $fbd042e4a49259b8$var$He(a) {
    var b = $fbd042e4a49259b8$var$Ie(a);
    if ($fbd042e4a49259b8$var$Wa(b)) return a;
}
function $fbd042e4a49259b8$var$Je(a, b) {
    if ("change" === a) return b;
}
var $fbd042e4a49259b8$var$Ke = !1;
if ($fbd042e4a49259b8$var$ia) {
    var $fbd042e4a49259b8$var$Le;
    if ($fbd042e4a49259b8$var$ia) {
        var $fbd042e4a49259b8$var$Me = "oninput" in document;
        if (!$fbd042e4a49259b8$var$Me) {
            var $fbd042e4a49259b8$var$Ne = document.createElement("div");
            $fbd042e4a49259b8$var$Ne.setAttribute("oninput", "return;");
            $fbd042e4a49259b8$var$Me = "function" === typeof $fbd042e4a49259b8$var$Ne.oninput;
        }
        $fbd042e4a49259b8$var$Le = $fbd042e4a49259b8$var$Me;
    } else $fbd042e4a49259b8$var$Le = !1;
    $fbd042e4a49259b8$var$Ke = $fbd042e4a49259b8$var$Le && (!document.documentMode || 9 < document.documentMode);
}
function $fbd042e4a49259b8$var$Oe() {
    $fbd042e4a49259b8$var$De && ($fbd042e4a49259b8$var$De.detachEvent("onpropertychange", $fbd042e4a49259b8$var$Pe), $fbd042e4a49259b8$var$Ee = $fbd042e4a49259b8$var$De = null);
}
function $fbd042e4a49259b8$var$Pe(a) {
    if ("value" === a.propertyName && $fbd042e4a49259b8$var$He($fbd042e4a49259b8$var$Ee)) {
        var b = [];
        $fbd042e4a49259b8$var$Be(b, $fbd042e4a49259b8$var$Ee, a, $fbd042e4a49259b8$var$xb(a));
        $fbd042e4a49259b8$var$Jb($fbd042e4a49259b8$var$Fe, b);
    }
}
function $fbd042e4a49259b8$var$Qe(a, b, c) {
    "focusin" === a ? ($fbd042e4a49259b8$var$Oe(), $fbd042e4a49259b8$var$De = b, $fbd042e4a49259b8$var$Ee = c, $fbd042e4a49259b8$var$De.attachEvent("onpropertychange", $fbd042e4a49259b8$var$Pe)) : "focusout" === a && $fbd042e4a49259b8$var$Oe();
}
function $fbd042e4a49259b8$var$Re(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $fbd042e4a49259b8$var$He($fbd042e4a49259b8$var$Ee);
}
function $fbd042e4a49259b8$var$Se(a, b) {
    if ("click" === a) return $fbd042e4a49259b8$var$He(b);
}
function $fbd042e4a49259b8$var$Te(a, b) {
    if ("input" === a || "change" === a) return $fbd042e4a49259b8$var$He(b);
}
function $fbd042e4a49259b8$var$Ue(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $fbd042e4a49259b8$var$Ve = "function" === typeof Object.is ? Object.is : $fbd042e4a49259b8$var$Ue;
function $fbd042e4a49259b8$var$We(a, b) {
    if ($fbd042e4a49259b8$var$Ve(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$fbd042e4a49259b8$var$ja.call(b, e) || !$fbd042e4a49259b8$var$Ve(a[e], b[e])) return !1;
    }
    return !0;
}
function $fbd042e4a49259b8$var$Xe(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $fbd042e4a49259b8$var$Ye(a, b) {
    var c = $fbd042e4a49259b8$var$Xe(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $fbd042e4a49259b8$var$Xe(c);
    }
}
function $fbd042e4a49259b8$var$Ze(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $fbd042e4a49259b8$var$Ze(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $fbd042e4a49259b8$var$$e() {
    for(var a = window, b = $fbd042e4a49259b8$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $fbd042e4a49259b8$var$Xa(a.document);
    }
    return b;
}
function $fbd042e4a49259b8$var$af(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $fbd042e4a49259b8$var$bf(a) {
    var b = $fbd042e4a49259b8$var$$e(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $fbd042e4a49259b8$var$Ze(c.ownerDocument.documentElement, c)) {
        if (null !== d && $fbd042e4a49259b8$var$af(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $fbd042e4a49259b8$var$Ye(c, f);
                var g = $fbd042e4a49259b8$var$Ye(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $fbd042e4a49259b8$var$cf = $fbd042e4a49259b8$var$ia && "documentMode" in document && 11 >= document.documentMode, $fbd042e4a49259b8$var$df = null, $fbd042e4a49259b8$var$ef = null, $fbd042e4a49259b8$var$ff = null, $fbd042e4a49259b8$var$gf = !1;
function $fbd042e4a49259b8$var$hf(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $fbd042e4a49259b8$var$gf || null == $fbd042e4a49259b8$var$df || $fbd042e4a49259b8$var$df !== $fbd042e4a49259b8$var$Xa(d) || (d = $fbd042e4a49259b8$var$df, "selectionStart" in d && $fbd042e4a49259b8$var$af(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $fbd042e4a49259b8$var$ff && $fbd042e4a49259b8$var$We($fbd042e4a49259b8$var$ff, d) || ($fbd042e4a49259b8$var$ff = d, d = $fbd042e4a49259b8$var$Ce($fbd042e4a49259b8$var$ef, "onSelect"), 0 < d.length && (b = new $fbd042e4a49259b8$var$Hd("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $fbd042e4a49259b8$var$df)));
}
function $fbd042e4a49259b8$var$jf(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $fbd042e4a49259b8$var$kf = {
    animationend: $fbd042e4a49259b8$var$jf("Animation", "AnimationEnd"),
    animationiteration: $fbd042e4a49259b8$var$jf("Animation", "AnimationIteration"),
    animationstart: $fbd042e4a49259b8$var$jf("Animation", "AnimationStart"),
    transitionend: $fbd042e4a49259b8$var$jf("Transition", "TransitionEnd")
}, $fbd042e4a49259b8$var$lf = {}, $fbd042e4a49259b8$var$mf = {};
$fbd042e4a49259b8$var$ia && ($fbd042e4a49259b8$var$mf = document.createElement("div").style, "AnimationEvent" in window || (delete $fbd042e4a49259b8$var$kf.animationend.animation, delete $fbd042e4a49259b8$var$kf.animationiteration.animation, delete $fbd042e4a49259b8$var$kf.animationstart.animation), "TransitionEvent" in window || delete $fbd042e4a49259b8$var$kf.transitionend.transition);
function $fbd042e4a49259b8$var$nf(a) {
    if ($fbd042e4a49259b8$var$lf[a]) return $fbd042e4a49259b8$var$lf[a];
    if (!$fbd042e4a49259b8$var$kf[a]) return a;
    var b = $fbd042e4a49259b8$var$kf[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $fbd042e4a49259b8$var$mf) return $fbd042e4a49259b8$var$lf[a] = b[c];
    return a;
}
var $fbd042e4a49259b8$var$of = $fbd042e4a49259b8$var$nf("animationend"), $fbd042e4a49259b8$var$pf = $fbd042e4a49259b8$var$nf("animationiteration"), $fbd042e4a49259b8$var$qf = $fbd042e4a49259b8$var$nf("animationstart"), $fbd042e4a49259b8$var$rf = $fbd042e4a49259b8$var$nf("transitionend"), $fbd042e4a49259b8$var$sf = new Map, $fbd042e4a49259b8$var$tf = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $fbd042e4a49259b8$var$uf(a, b) {
    $fbd042e4a49259b8$var$sf.set(a, b);
    $fbd042e4a49259b8$var$fa(b, [
        a
    ]);
}
for(var $fbd042e4a49259b8$var$vf = 0; $fbd042e4a49259b8$var$vf < $fbd042e4a49259b8$var$tf.length; $fbd042e4a49259b8$var$vf++){
    var $fbd042e4a49259b8$var$wf = $fbd042e4a49259b8$var$tf[$fbd042e4a49259b8$var$vf], $fbd042e4a49259b8$var$xf = $fbd042e4a49259b8$var$wf.toLowerCase(), $fbd042e4a49259b8$var$yf = $fbd042e4a49259b8$var$wf[0].toUpperCase() + $fbd042e4a49259b8$var$wf.slice(1);
    $fbd042e4a49259b8$var$uf($fbd042e4a49259b8$var$xf, "on" + $fbd042e4a49259b8$var$yf);
}
$fbd042e4a49259b8$var$uf($fbd042e4a49259b8$var$of, "onAnimationEnd");
$fbd042e4a49259b8$var$uf($fbd042e4a49259b8$var$pf, "onAnimationIteration");
$fbd042e4a49259b8$var$uf($fbd042e4a49259b8$var$qf, "onAnimationStart");
$fbd042e4a49259b8$var$uf("dblclick", "onDoubleClick");
$fbd042e4a49259b8$var$uf("focusin", "onFocus");
$fbd042e4a49259b8$var$uf("focusout", "onBlur");
$fbd042e4a49259b8$var$uf($fbd042e4a49259b8$var$rf, "onTransitionEnd");
$fbd042e4a49259b8$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$fbd042e4a49259b8$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$fbd042e4a49259b8$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$fbd042e4a49259b8$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$fbd042e4a49259b8$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$fbd042e4a49259b8$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$fbd042e4a49259b8$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$fbd042e4a49259b8$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$fbd042e4a49259b8$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$fbd042e4a49259b8$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $fbd042e4a49259b8$var$zf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $fbd042e4a49259b8$var$Af = new Set("cancel close invalid load scroll toggle".split(" ").concat($fbd042e4a49259b8$var$zf));
function $fbd042e4a49259b8$var$Bf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $fbd042e4a49259b8$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $fbd042e4a49259b8$var$Ge(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $fbd042e4a49259b8$var$Bf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $fbd042e4a49259b8$var$Bf(e, h, l);
                f = k;
            }
        }
    }
    if ($fbd042e4a49259b8$var$Qb) throw a = $fbd042e4a49259b8$var$Rb, $fbd042e4a49259b8$var$Qb = !1, $fbd042e4a49259b8$var$Rb = null, a;
}
function $fbd042e4a49259b8$var$F(a, b) {
    var c = b[$fbd042e4a49259b8$var$Cf];
    void 0 === c && (c = b[$fbd042e4a49259b8$var$Cf] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($fbd042e4a49259b8$var$Df(b, a, 2, !1), c.add(d));
}
function $fbd042e4a49259b8$var$Ef(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $fbd042e4a49259b8$var$Df(c, a, d, b);
}
var $fbd042e4a49259b8$var$Ff = "_reactListening" + Math.random().toString(36).slice(2);
function $fbd042e4a49259b8$var$Gf(a) {
    if (!a[$fbd042e4a49259b8$var$Ff]) {
        a[$fbd042e4a49259b8$var$Ff] = !0;
        $fbd042e4a49259b8$var$da.forEach(function(b) {
            "selectionchange" !== b && ($fbd042e4a49259b8$var$Af.has(b) || $fbd042e4a49259b8$var$Ef(b, !1, a), $fbd042e4a49259b8$var$Ef(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$fbd042e4a49259b8$var$Ff] || (b[$fbd042e4a49259b8$var$Ff] = !0, $fbd042e4a49259b8$var$Ef("selectionchange", !1, b));
    }
}
function $fbd042e4a49259b8$var$Df(a, b, c, d) {
    switch($fbd042e4a49259b8$var$xd(b)){
        case 1:
            var e = $fbd042e4a49259b8$var$sd;
            break;
        case 4:
            e = $fbd042e4a49259b8$var$ud;
            break;
        default:
            e = $fbd042e4a49259b8$var$td;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$fbd042e4a49259b8$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $fbd042e4a49259b8$var$vd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $fbd042e4a49259b8$var$jd(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $fbd042e4a49259b8$var$Jb(function() {
        var d = f, e = $fbd042e4a49259b8$var$xb(c), g = [];
        a: {
            var h = $fbd042e4a49259b8$var$sf.get(a);
            if (void 0 !== h) {
                var k = $fbd042e4a49259b8$var$Hd, m = a;
                switch(a){
                    case "keypress":
                        if (0 === $fbd042e4a49259b8$var$Cd(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $fbd042e4a49259b8$var$ee;
                        break;
                    case "focusin":
                        m = "focus";
                        k = $fbd042e4a49259b8$var$Td;
                        break;
                    case "focusout":
                        m = "blur";
                        k = $fbd042e4a49259b8$var$Td;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $fbd042e4a49259b8$var$Td;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $fbd042e4a49259b8$var$Pd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $fbd042e4a49259b8$var$Rd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $fbd042e4a49259b8$var$ie;
                        break;
                    case $fbd042e4a49259b8$var$of:
                    case $fbd042e4a49259b8$var$pf:
                    case $fbd042e4a49259b8$var$qf:
                        k = $fbd042e4a49259b8$var$Vd;
                        break;
                    case $fbd042e4a49259b8$var$rf:
                        k = $fbd042e4a49259b8$var$ke;
                        break;
                    case "scroll":
                        k = $fbd042e4a49259b8$var$Jd;
                        break;
                    case "wheel":
                        k = $fbd042e4a49259b8$var$me;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $fbd042e4a49259b8$var$Xd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $fbd042e4a49259b8$var$ge;
                }
                var w = 0 !== (b & 4), C = !w && "scroll" === a, x = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var y = d, v; null !== y;){
                    v = y;
                    var D = v.stateNode;
                    5 === v.tag && null !== D && (v = D, null !== x && (D = $fbd042e4a49259b8$var$Kb(y, x), null != D && w.push($fbd042e4a49259b8$var$Hf(y, D, v))));
                    if (C) break;
                    y = y.return;
                }
                0 < w.length && (h = new k(h, m, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $fbd042e4a49259b8$var$wb && (m = c.relatedTarget || c.fromElement) && ($fbd042e4a49259b8$var$jd(m) || m[$fbd042e4a49259b8$var$If])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (m = c.relatedTarget || c.toElement, k = d, m = m ? $fbd042e4a49259b8$var$jd(m) : null, null !== m && (C = $fbd042e4a49259b8$var$Vb(m), m !== C || 5 !== m.tag && 6 !== m.tag)) m = null;
                    } else k = null, m = d;
                    if (k !== m) {
                        w = $fbd042e4a49259b8$var$Pd;
                        D = "onMouseLeave";
                        x = "onMouseEnter";
                        y = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = $fbd042e4a49259b8$var$ge, D = "onPointerLeave", x = "onPointerEnter", y = "pointer";
                        C = null == k ? h : $fbd042e4a49259b8$var$Ie(k);
                        v = null == m ? h : $fbd042e4a49259b8$var$Ie(m);
                        h = new w(D, y + "leave", k, c, e);
                        h.target = C;
                        h.relatedTarget = v;
                        D = null;
                        $fbd042e4a49259b8$var$jd(e) === d && (w = new w(x, y + "enter", m, c, e), w.target = v, w.relatedTarget = C, D = w);
                        C = D;
                        if (k && m) b: {
                            w = k;
                            x = m;
                            y = 0;
                            for(v = w; v; v = $fbd042e4a49259b8$var$Jf(v))y++;
                            v = 0;
                            for(D = x; D; D = $fbd042e4a49259b8$var$Jf(D))v++;
                            for(; 0 < y - v;)w = $fbd042e4a49259b8$var$Jf(w), y--;
                            for(; 0 < v - y;)x = $fbd042e4a49259b8$var$Jf(x), v--;
                            for(; y--;){
                                if (w === x || null !== x && w === x.alternate) break b;
                                w = $fbd042e4a49259b8$var$Jf(w);
                                x = $fbd042e4a49259b8$var$Jf(x);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && $fbd042e4a49259b8$var$Kf(g, h, k, w, !1);
                        null !== m && null !== C && $fbd042e4a49259b8$var$Kf(g, C, m, w, !0);
                    }
                }
            }
            a: {
                h = d ? $fbd042e4a49259b8$var$Ie(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var ca = $fbd042e4a49259b8$var$Je;
                else if ($fbd042e4a49259b8$var$Ae(h)) {
                    if ($fbd042e4a49259b8$var$Ke) ca = $fbd042e4a49259b8$var$Te;
                    else {
                        ca = $fbd042e4a49259b8$var$Re;
                        var R = $fbd042e4a49259b8$var$Qe;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (ca = $fbd042e4a49259b8$var$Se);
                if (ca && (ca = ca(a, d))) {
                    $fbd042e4a49259b8$var$Be(g, ca, c, e);
                    break a;
                }
                R && R(a, h, d);
                "focusout" === a && (R = h._wrapperState) && R.controlled && "number" === h.type && $fbd042e4a49259b8$var$bb(h, "number", h.value);
            }
            R = d ? $fbd042e4a49259b8$var$Ie(d) : window;
            switch(a){
                case "focusin":
                    if ($fbd042e4a49259b8$var$Ae(R) || "true" === R.contentEditable) $fbd042e4a49259b8$var$df = R, $fbd042e4a49259b8$var$ef = d, $fbd042e4a49259b8$var$ff = null;
                    break;
                case "focusout":
                    $fbd042e4a49259b8$var$ff = $fbd042e4a49259b8$var$ef = $fbd042e4a49259b8$var$df = null;
                    break;
                case "mousedown":
                    $fbd042e4a49259b8$var$gf = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $fbd042e4a49259b8$var$gf = !1;
                    $fbd042e4a49259b8$var$hf(g, c, e);
                    break;
                case "selectionchange":
                    if ($fbd042e4a49259b8$var$cf) break;
                case "keydown":
                case "keyup":
                    $fbd042e4a49259b8$var$hf(g, c, e);
            }
            var sa;
            if ($fbd042e4a49259b8$var$oe) b: {
                switch(a){
                    case "compositionstart":
                        var V = "onCompositionStart";
                        break b;
                    case "compositionend":
                        V = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        V = "onCompositionUpdate";
                        break b;
                }
                V = void 0;
            }
            else $fbd042e4a49259b8$var$we ? $fbd042e4a49259b8$var$ue(a, c) && (V = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (V = "onCompositionStart");
            V && ($fbd042e4a49259b8$var$re && "ko" !== c.locale && ($fbd042e4a49259b8$var$we || "onCompositionStart" !== V ? "onCompositionEnd" === V && $fbd042e4a49259b8$var$we && (sa = $fbd042e4a49259b8$var$Bd()) : ($fbd042e4a49259b8$var$yd = e, $fbd042e4a49259b8$var$zd = "value" in $fbd042e4a49259b8$var$yd ? $fbd042e4a49259b8$var$yd.value : $fbd042e4a49259b8$var$yd.textContent, $fbd042e4a49259b8$var$we = !0)), R = $fbd042e4a49259b8$var$Ce(d, V), 0 < R.length && (V = new $fbd042e4a49259b8$var$Zd(V, a, null, c, e), g.push({
                event: V,
                listeners: R
            }), sa ? V.data = sa : (sa = $fbd042e4a49259b8$var$ve(c), null !== sa && (V.data = sa))));
            if (sa = $fbd042e4a49259b8$var$qe ? $fbd042e4a49259b8$var$xe(a, c) : $fbd042e4a49259b8$var$ye(a, c)) d = $fbd042e4a49259b8$var$Ce(d, "onBeforeInput"), 0 < d.length && (e = new $fbd042e4a49259b8$var$Zd("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = sa);
        }
        $fbd042e4a49259b8$var$Ge(g, b);
    });
}
function $fbd042e4a49259b8$var$Hf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $fbd042e4a49259b8$var$Ce(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $fbd042e4a49259b8$var$Kb(a, c), null != f && d.unshift($fbd042e4a49259b8$var$Hf(a, f, e)), f = $fbd042e4a49259b8$var$Kb(a, b), null != f && d.push($fbd042e4a49259b8$var$Hf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $fbd042e4a49259b8$var$Jf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $fbd042e4a49259b8$var$Kf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $fbd042e4a49259b8$var$Kb(c, f), null != k && g.unshift($fbd042e4a49259b8$var$Hf(c, k, h))) : e || (k = $fbd042e4a49259b8$var$Kb(c, f), null != k && g.push($fbd042e4a49259b8$var$Hf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $fbd042e4a49259b8$var$Lf = /\r\n?/g, $fbd042e4a49259b8$var$Mf = /\u0000|\uFFFD/g;
function $fbd042e4a49259b8$var$Nf(a) {
    return ("string" === typeof a ? a : "" + a).replace($fbd042e4a49259b8$var$Lf, "\n").replace($fbd042e4a49259b8$var$Mf, "");
}
function $fbd042e4a49259b8$var$Of(a, b, c) {
    b = $fbd042e4a49259b8$var$Nf(b);
    if ($fbd042e4a49259b8$var$Nf(a) !== b && c) throw Error($fbd042e4a49259b8$var$p(425));
}
function $fbd042e4a49259b8$var$Pf() {}
var $fbd042e4a49259b8$var$Qf = null, $fbd042e4a49259b8$var$Rf = null;
function $fbd042e4a49259b8$var$Sf(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $fbd042e4a49259b8$var$Tf = "function" === typeof setTimeout ? setTimeout : void 0, $fbd042e4a49259b8$var$Uf = "function" === typeof clearTimeout ? clearTimeout : void 0, $fbd042e4a49259b8$var$Vf = "function" === typeof Promise ? Promise : void 0, $fbd042e4a49259b8$var$Xf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $fbd042e4a49259b8$var$Vf ? function(a) {
    return $fbd042e4a49259b8$var$Vf.resolve(null).then(a).catch($fbd042e4a49259b8$var$Wf);
} : $fbd042e4a49259b8$var$Tf;
function $fbd042e4a49259b8$var$Wf(a) {
    setTimeout(function() {
        throw a;
    });
}
function $fbd042e4a49259b8$var$Yf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $fbd042e4a49259b8$var$pd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $fbd042e4a49259b8$var$pd(b);
}
function $fbd042e4a49259b8$var$Zf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $fbd042e4a49259b8$var$$f(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $fbd042e4a49259b8$var$ag = Math.random().toString(36).slice(2), $fbd042e4a49259b8$var$bg = "__reactFiber$" + $fbd042e4a49259b8$var$ag, $fbd042e4a49259b8$var$cg = "__reactProps$" + $fbd042e4a49259b8$var$ag, $fbd042e4a49259b8$var$If = "__reactContainer$" + $fbd042e4a49259b8$var$ag, $fbd042e4a49259b8$var$Cf = "__reactEvents$" + $fbd042e4a49259b8$var$ag, $fbd042e4a49259b8$var$dg = "__reactListeners$" + $fbd042e4a49259b8$var$ag, $fbd042e4a49259b8$var$eg = "__reactHandles$" + $fbd042e4a49259b8$var$ag;
function $fbd042e4a49259b8$var$jd(a) {
    var b = a[$fbd042e4a49259b8$var$bg];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$fbd042e4a49259b8$var$If] || c[$fbd042e4a49259b8$var$bg]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $fbd042e4a49259b8$var$$f(a); null !== a;){
                if (c = a[$fbd042e4a49259b8$var$bg]) return c;
                a = $fbd042e4a49259b8$var$$f(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $fbd042e4a49259b8$var$Cb(a) {
    a = a[$fbd042e4a49259b8$var$bg] || a[$fbd042e4a49259b8$var$If];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $fbd042e4a49259b8$var$Ie(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($fbd042e4a49259b8$var$p(33));
}
function $fbd042e4a49259b8$var$Db(a) {
    return a[$fbd042e4a49259b8$var$cg] || null;
}
var $fbd042e4a49259b8$var$fg = [], $fbd042e4a49259b8$var$gg = -1;
function $fbd042e4a49259b8$var$hg(a) {
    return {
        current: a
    };
}
function $fbd042e4a49259b8$var$G(a) {
    0 > $fbd042e4a49259b8$var$gg || (a.current = $fbd042e4a49259b8$var$fg[$fbd042e4a49259b8$var$gg], $fbd042e4a49259b8$var$fg[$fbd042e4a49259b8$var$gg] = null, $fbd042e4a49259b8$var$gg--);
}
function $fbd042e4a49259b8$var$H(a, b) {
    $fbd042e4a49259b8$var$gg++;
    $fbd042e4a49259b8$var$fg[$fbd042e4a49259b8$var$gg] = a.current;
    a.current = b;
}
var $fbd042e4a49259b8$var$ig = {}, $fbd042e4a49259b8$var$I = $fbd042e4a49259b8$var$hg($fbd042e4a49259b8$var$ig), $fbd042e4a49259b8$var$jg = $fbd042e4a49259b8$var$hg(!1), $fbd042e4a49259b8$var$kg = $fbd042e4a49259b8$var$ig;
function $fbd042e4a49259b8$var$lg(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $fbd042e4a49259b8$var$ig;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $fbd042e4a49259b8$var$mg(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $fbd042e4a49259b8$var$ng() {
    $fbd042e4a49259b8$var$G($fbd042e4a49259b8$var$jg);
    $fbd042e4a49259b8$var$G($fbd042e4a49259b8$var$I);
}
function $fbd042e4a49259b8$var$og(a, b, c) {
    if ($fbd042e4a49259b8$var$I.current !== $fbd042e4a49259b8$var$ig) throw Error($fbd042e4a49259b8$var$p(168));
    $fbd042e4a49259b8$var$H($fbd042e4a49259b8$var$I, b);
    $fbd042e4a49259b8$var$H($fbd042e4a49259b8$var$jg, c);
}
function $fbd042e4a49259b8$var$pg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($fbd042e4a49259b8$var$p(108, $fbd042e4a49259b8$var$Ra(a) || "Unknown", e));
    return $fbd042e4a49259b8$var$u({}, c, d);
}
function $fbd042e4a49259b8$var$qg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $fbd042e4a49259b8$var$ig;
    $fbd042e4a49259b8$var$kg = $fbd042e4a49259b8$var$I.current;
    $fbd042e4a49259b8$var$H($fbd042e4a49259b8$var$I, a);
    $fbd042e4a49259b8$var$H($fbd042e4a49259b8$var$jg, $fbd042e4a49259b8$var$jg.current);
    return !0;
}
function $fbd042e4a49259b8$var$rg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($fbd042e4a49259b8$var$p(169));
    c ? (a = $fbd042e4a49259b8$var$pg(a, b, $fbd042e4a49259b8$var$kg), d.__reactInternalMemoizedMergedChildContext = a, $fbd042e4a49259b8$var$G($fbd042e4a49259b8$var$jg), $fbd042e4a49259b8$var$G($fbd042e4a49259b8$var$I), $fbd042e4a49259b8$var$H($fbd042e4a49259b8$var$I, a)) : $fbd042e4a49259b8$var$G($fbd042e4a49259b8$var$jg);
    $fbd042e4a49259b8$var$H($fbd042e4a49259b8$var$jg, c);
}
var $fbd042e4a49259b8$var$sg = null, $fbd042e4a49259b8$var$tg = !1, $fbd042e4a49259b8$var$ug = !1;
function $fbd042e4a49259b8$var$vg(a) {
    null === $fbd042e4a49259b8$var$sg ? $fbd042e4a49259b8$var$sg = [
        a
    ] : $fbd042e4a49259b8$var$sg.push(a);
}
function $fbd042e4a49259b8$var$wg(a) {
    $fbd042e4a49259b8$var$tg = !0;
    $fbd042e4a49259b8$var$vg(a);
}
function $fbd042e4a49259b8$var$xg() {
    if (!$fbd042e4a49259b8$var$ug && null !== $fbd042e4a49259b8$var$sg) {
        $fbd042e4a49259b8$var$ug = !0;
        var a = 0, b = $fbd042e4a49259b8$var$E;
        try {
            var c = $fbd042e4a49259b8$var$sg;
            for($fbd042e4a49259b8$var$E = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $fbd042e4a49259b8$var$sg = null;
            $fbd042e4a49259b8$var$tg = !1;
        } catch (e) {
            throw null !== $fbd042e4a49259b8$var$sg && ($fbd042e4a49259b8$var$sg = $fbd042e4a49259b8$var$sg.slice(a + 1)), $fbd042e4a49259b8$var$ac($fbd042e4a49259b8$var$fc, $fbd042e4a49259b8$var$xg), e;
        } finally{
            $fbd042e4a49259b8$var$E = b, $fbd042e4a49259b8$var$ug = !1;
        }
    }
    return null;
}
var $fbd042e4a49259b8$var$yg = [], $fbd042e4a49259b8$var$zg = 0, $fbd042e4a49259b8$var$Ag = null, $fbd042e4a49259b8$var$Bg = 0, $fbd042e4a49259b8$var$Cg = [], $fbd042e4a49259b8$var$Dg = 0, $fbd042e4a49259b8$var$Eg = null, $fbd042e4a49259b8$var$Fg = 1, $fbd042e4a49259b8$var$Gg = "";
function $fbd042e4a49259b8$var$Hg(a, b) {
    $fbd042e4a49259b8$var$yg[$fbd042e4a49259b8$var$zg++] = $fbd042e4a49259b8$var$Bg;
    $fbd042e4a49259b8$var$yg[$fbd042e4a49259b8$var$zg++] = $fbd042e4a49259b8$var$Ag;
    $fbd042e4a49259b8$var$Ag = a;
    $fbd042e4a49259b8$var$Bg = b;
}
function $fbd042e4a49259b8$var$Ig(a, b, c) {
    $fbd042e4a49259b8$var$Cg[$fbd042e4a49259b8$var$Dg++] = $fbd042e4a49259b8$var$Fg;
    $fbd042e4a49259b8$var$Cg[$fbd042e4a49259b8$var$Dg++] = $fbd042e4a49259b8$var$Gg;
    $fbd042e4a49259b8$var$Cg[$fbd042e4a49259b8$var$Dg++] = $fbd042e4a49259b8$var$Eg;
    $fbd042e4a49259b8$var$Eg = a;
    var d = $fbd042e4a49259b8$var$Fg;
    a = $fbd042e4a49259b8$var$Gg;
    var e = 32 - $fbd042e4a49259b8$var$Ac(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $fbd042e4a49259b8$var$Ac(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $fbd042e4a49259b8$var$Fg = 1 << 32 - $fbd042e4a49259b8$var$Ac(b) + e | c << e | d;
        $fbd042e4a49259b8$var$Gg = f + a;
    } else $fbd042e4a49259b8$var$Fg = 1 << f | c << e | d, $fbd042e4a49259b8$var$Gg = a;
}
function $fbd042e4a49259b8$var$Jg(a) {
    null !== a.return && ($fbd042e4a49259b8$var$Hg(a, 1), $fbd042e4a49259b8$var$Ig(a, 1, 0));
}
function $fbd042e4a49259b8$var$Kg(a) {
    for(; a === $fbd042e4a49259b8$var$Ag;)$fbd042e4a49259b8$var$Ag = $fbd042e4a49259b8$var$yg[--$fbd042e4a49259b8$var$zg], $fbd042e4a49259b8$var$yg[$fbd042e4a49259b8$var$zg] = null, $fbd042e4a49259b8$var$Bg = $fbd042e4a49259b8$var$yg[--$fbd042e4a49259b8$var$zg], $fbd042e4a49259b8$var$yg[$fbd042e4a49259b8$var$zg] = null;
    for(; a === $fbd042e4a49259b8$var$Eg;)$fbd042e4a49259b8$var$Eg = $fbd042e4a49259b8$var$Cg[--$fbd042e4a49259b8$var$Dg], $fbd042e4a49259b8$var$Cg[$fbd042e4a49259b8$var$Dg] = null, $fbd042e4a49259b8$var$Gg = $fbd042e4a49259b8$var$Cg[--$fbd042e4a49259b8$var$Dg], $fbd042e4a49259b8$var$Cg[$fbd042e4a49259b8$var$Dg] = null, $fbd042e4a49259b8$var$Fg = $fbd042e4a49259b8$var$Cg[--$fbd042e4a49259b8$var$Dg], $fbd042e4a49259b8$var$Cg[$fbd042e4a49259b8$var$Dg] = null;
}
var $fbd042e4a49259b8$var$Lg = null, $fbd042e4a49259b8$var$Mg = null, $fbd042e4a49259b8$var$J = !1, $fbd042e4a49259b8$var$Ng = null;
function $fbd042e4a49259b8$var$Og(a, b) {
    var c = $fbd042e4a49259b8$var$Pg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $fbd042e4a49259b8$var$Qg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $fbd042e4a49259b8$var$Lg = a, $fbd042e4a49259b8$var$Mg = $fbd042e4a49259b8$var$Zf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $fbd042e4a49259b8$var$Lg = a, $fbd042e4a49259b8$var$Mg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $fbd042e4a49259b8$var$Eg ? {
                id: $fbd042e4a49259b8$var$Fg,
                overflow: $fbd042e4a49259b8$var$Gg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $fbd042e4a49259b8$var$Pg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $fbd042e4a49259b8$var$Lg = a, $fbd042e4a49259b8$var$Mg = null, !0) : !1;
        default:
            return !1;
    }
}
function $fbd042e4a49259b8$var$Rg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $fbd042e4a49259b8$var$Sg(a) {
    if ($fbd042e4a49259b8$var$J) {
        var b = $fbd042e4a49259b8$var$Mg;
        if (b) {
            var c = b;
            if (!$fbd042e4a49259b8$var$Qg(a, b)) {
                if ($fbd042e4a49259b8$var$Rg(a)) throw Error($fbd042e4a49259b8$var$p(418));
                b = $fbd042e4a49259b8$var$Zf(c.nextSibling);
                var d = $fbd042e4a49259b8$var$Lg;
                b && $fbd042e4a49259b8$var$Qg(a, b) ? $fbd042e4a49259b8$var$Og(d, c) : (a.flags = a.flags & -4097 | 2, $fbd042e4a49259b8$var$J = !1, $fbd042e4a49259b8$var$Lg = a);
            }
        } else {
            if ($fbd042e4a49259b8$var$Rg(a)) throw Error($fbd042e4a49259b8$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $fbd042e4a49259b8$var$J = !1;
            $fbd042e4a49259b8$var$Lg = a;
        }
    }
}
function $fbd042e4a49259b8$var$Tg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $fbd042e4a49259b8$var$Lg = a;
}
function $fbd042e4a49259b8$var$Ug(a) {
    if (a !== $fbd042e4a49259b8$var$Lg) return !1;
    if (!$fbd042e4a49259b8$var$J) return $fbd042e4a49259b8$var$Tg(a), $fbd042e4a49259b8$var$J = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$fbd042e4a49259b8$var$Sf(a.type, a.memoizedProps));
    if (b && (b = $fbd042e4a49259b8$var$Mg)) {
        if ($fbd042e4a49259b8$var$Rg(a)) throw $fbd042e4a49259b8$var$Vg(), Error($fbd042e4a49259b8$var$p(418));
        for(; b;)$fbd042e4a49259b8$var$Og(a, b), b = $fbd042e4a49259b8$var$Zf(b.nextSibling);
    }
    $fbd042e4a49259b8$var$Tg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($fbd042e4a49259b8$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $fbd042e4a49259b8$var$Mg = $fbd042e4a49259b8$var$Zf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $fbd042e4a49259b8$var$Mg = null;
        }
    } else $fbd042e4a49259b8$var$Mg = $fbd042e4a49259b8$var$Lg ? $fbd042e4a49259b8$var$Zf(a.stateNode.nextSibling) : null;
    return !0;
}
function $fbd042e4a49259b8$var$Vg() {
    for(var a = $fbd042e4a49259b8$var$Mg; a;)a = $fbd042e4a49259b8$var$Zf(a.nextSibling);
}
function $fbd042e4a49259b8$var$Wg() {
    $fbd042e4a49259b8$var$Mg = $fbd042e4a49259b8$var$Lg = null;
    $fbd042e4a49259b8$var$J = !1;
}
function $fbd042e4a49259b8$var$Xg(a) {
    null === $fbd042e4a49259b8$var$Ng ? $fbd042e4a49259b8$var$Ng = [
        a
    ] : $fbd042e4a49259b8$var$Ng.push(a);
}
var $fbd042e4a49259b8$var$Yg = $fbd042e4a49259b8$var$va.ReactCurrentBatchConfig;
function $fbd042e4a49259b8$var$Zg(a, b) {
    if (a && a.defaultProps) {
        b = $fbd042e4a49259b8$var$u({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $fbd042e4a49259b8$var$$g = $fbd042e4a49259b8$var$hg(null), $fbd042e4a49259b8$var$ah = null, $fbd042e4a49259b8$var$bh = null, $fbd042e4a49259b8$var$ch = null;
function $fbd042e4a49259b8$var$dh() {
    $fbd042e4a49259b8$var$ch = $fbd042e4a49259b8$var$bh = $fbd042e4a49259b8$var$ah = null;
}
function $fbd042e4a49259b8$var$eh(a) {
    var b = $fbd042e4a49259b8$var$$g.current;
    $fbd042e4a49259b8$var$G($fbd042e4a49259b8$var$$g);
    a._currentValue = b;
}
function $fbd042e4a49259b8$var$fh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $fbd042e4a49259b8$var$gh(a, b) {
    $fbd042e4a49259b8$var$ah = a;
    $fbd042e4a49259b8$var$ch = $fbd042e4a49259b8$var$bh = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($fbd042e4a49259b8$var$hh = !0), a.firstContext = null);
}
function $fbd042e4a49259b8$var$ih(a) {
    var b = a._currentValue;
    if ($fbd042e4a49259b8$var$ch !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $fbd042e4a49259b8$var$bh) {
            if (null === $fbd042e4a49259b8$var$ah) throw Error($fbd042e4a49259b8$var$p(308));
            $fbd042e4a49259b8$var$bh = a;
            $fbd042e4a49259b8$var$ah.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $fbd042e4a49259b8$var$bh = $fbd042e4a49259b8$var$bh.next = a;
    }
    return b;
}
var $fbd042e4a49259b8$var$jh = null;
function $fbd042e4a49259b8$var$kh(a) {
    null === $fbd042e4a49259b8$var$jh ? $fbd042e4a49259b8$var$jh = [
        a
    ] : $fbd042e4a49259b8$var$jh.push(a);
}
function $fbd042e4a49259b8$var$lh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $fbd042e4a49259b8$var$kh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $fbd042e4a49259b8$var$mh(a, d);
}
function $fbd042e4a49259b8$var$mh(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $fbd042e4a49259b8$var$nh = !1;
function $fbd042e4a49259b8$var$oh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $fbd042e4a49259b8$var$ph(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $fbd042e4a49259b8$var$qh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $fbd042e4a49259b8$var$rh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($fbd042e4a49259b8$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $fbd042e4a49259b8$var$mh(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $fbd042e4a49259b8$var$kh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $fbd042e4a49259b8$var$mh(a, c);
}
function $fbd042e4a49259b8$var$sh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $fbd042e4a49259b8$var$Oc(a, c);
    }
}
function $fbd042e4a49259b8$var$th(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $fbd042e4a49259b8$var$uh(a, b, c, d) {
    var e = a.updateQueue;
    $fbd042e4a49259b8$var$nh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        null !== n && (n = n.updateQueue, h = n.lastBaseUpdate, h !== g && (null === h ? n.firstBaseUpdate = l : h.next = l, n.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        n = l = k = null;
        h = f;
        do {
            var r = h.lane, z = h.eventTime;
            if ((d & r) === r) {
                null !== n && (n = n.next = {
                    eventTime: z,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var m = a, w = h;
                    r = b;
                    z = c;
                    switch(w.tag){
                        case 1:
                            m = w.payload;
                            if ("function" === typeof m) {
                                q = m.call(z, q, r);
                                break a;
                            }
                            q = m;
                            break a;
                        case 3:
                            m.flags = m.flags & -65537 | 128;
                        case 0:
                            m = w.payload;
                            r = "function" === typeof m ? m.call(z, q, r) : m;
                            if (null === r || void 0 === r) break a;
                            q = $fbd042e4a49259b8$var$u({}, q, r);
                            break a;
                        case 2:
                            $fbd042e4a49259b8$var$nh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else z = {
                eventTime: z,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === n ? (l = n = z, k = q) : n = n.next = z, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $fbd042e4a49259b8$var$vh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $fbd042e4a49259b8$var$wh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($fbd042e4a49259b8$var$p(191, e));
            e.call(d);
        }
    }
}
var $fbd042e4a49259b8$var$xh = (new $gqzfn.Component).refs;
function $fbd042e4a49259b8$var$yh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $fbd042e4a49259b8$var$u({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $fbd042e4a49259b8$var$Ch = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $fbd042e4a49259b8$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $fbd042e4a49259b8$var$zh(), e = $fbd042e4a49259b8$var$Ah(a), f = $fbd042e4a49259b8$var$qh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $fbd042e4a49259b8$var$rh(a, f, e);
        null !== b && ($fbd042e4a49259b8$var$Bh(b, a, e, d), $fbd042e4a49259b8$var$sh(b, a, e));
        $fbd042e4a49259b8$var$yc(a, e);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $fbd042e4a49259b8$var$zh(), e = $fbd042e4a49259b8$var$Ah(a), f = $fbd042e4a49259b8$var$qh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $fbd042e4a49259b8$var$rh(a, f, e);
        null !== b && ($fbd042e4a49259b8$var$Bh(b, a, e, d), $fbd042e4a49259b8$var$sh(b, a, e));
        $fbd042e4a49259b8$var$yc(a, e);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $fbd042e4a49259b8$var$zh(), d = $fbd042e4a49259b8$var$Ah(a), e = $fbd042e4a49259b8$var$qh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $fbd042e4a49259b8$var$rh(a, e, d);
        null !== b && ($fbd042e4a49259b8$var$Bh(b, a, d, c), $fbd042e4a49259b8$var$sh(b, a, d));
        null !== $fbd042e4a49259b8$var$B && "function" === typeof $fbd042e4a49259b8$var$B.markForceUpdateScheduled && $fbd042e4a49259b8$var$B.markForceUpdateScheduled(a, d);
    }
};
function $fbd042e4a49259b8$var$Dh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$fbd042e4a49259b8$var$We(c, d) || !$fbd042e4a49259b8$var$We(e, f) : !0;
}
function $fbd042e4a49259b8$var$Eh(a, b, c) {
    var d = !1, e = $fbd042e4a49259b8$var$ig;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $fbd042e4a49259b8$var$ih(f) : (e = $fbd042e4a49259b8$var$mg(b) ? $fbd042e4a49259b8$var$kg : $fbd042e4a49259b8$var$I.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $fbd042e4a49259b8$var$lg(a, e) : $fbd042e4a49259b8$var$ig);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $fbd042e4a49259b8$var$Ch;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $fbd042e4a49259b8$var$Fh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $fbd042e4a49259b8$var$Ch.enqueueReplaceState(b, b.state, null);
}
function $fbd042e4a49259b8$var$Gh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $fbd042e4a49259b8$var$xh;
    $fbd042e4a49259b8$var$oh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $fbd042e4a49259b8$var$ih(f) : (f = $fbd042e4a49259b8$var$mg(b) ? $fbd042e4a49259b8$var$kg : $fbd042e4a49259b8$var$I.current, e.context = $fbd042e4a49259b8$var$lg(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($fbd042e4a49259b8$var$yh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $fbd042e4a49259b8$var$Ch.enqueueReplaceState(e, e.state, null), $fbd042e4a49259b8$var$uh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $fbd042e4a49259b8$var$Hh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($fbd042e4a49259b8$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($fbd042e4a49259b8$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $fbd042e4a49259b8$var$xh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($fbd042e4a49259b8$var$p(284));
        if (!c._owner) throw Error($fbd042e4a49259b8$var$p(290, a));
    }
    return a;
}
function $fbd042e4a49259b8$var$Ih(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($fbd042e4a49259b8$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $fbd042e4a49259b8$var$Jh(a) {
    var b = a._init;
    return b(a._payload);
}
function $fbd042e4a49259b8$var$Kh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $fbd042e4a49259b8$var$Lh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $fbd042e4a49259b8$var$Mh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $fbd042e4a49259b8$var$ya) return n(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $fbd042e4a49259b8$var$Ha && $fbd042e4a49259b8$var$Jh(f) === b.type)) return d = e(b, c.props), d.ref = $fbd042e4a49259b8$var$Hh(a, b, c), d.return = a, d;
        d = $fbd042e4a49259b8$var$Nh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $fbd042e4a49259b8$var$Hh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $fbd042e4a49259b8$var$Oh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $fbd042e4a49259b8$var$Ph(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $fbd042e4a49259b8$var$Mh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $fbd042e4a49259b8$var$wa:
                    return c = $fbd042e4a49259b8$var$Nh(b.type, b.key, b.props, null, a.mode, c), c.ref = $fbd042e4a49259b8$var$Hh(a, null, b), c.return = a, c;
                case $fbd042e4a49259b8$var$xa:
                    return b = $fbd042e4a49259b8$var$Oh(b, a.mode, c), b.return = a, b;
                case $fbd042e4a49259b8$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($fbd042e4a49259b8$var$db(b) || $fbd042e4a49259b8$var$Ka(b)) return b = $fbd042e4a49259b8$var$Ph(b, a.mode, c, null), b.return = a, b;
            $fbd042e4a49259b8$var$Ih(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $fbd042e4a49259b8$var$wa:
                    return c.key === e ? k(a, b, c, d) : null;
                case $fbd042e4a49259b8$var$xa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $fbd042e4a49259b8$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($fbd042e4a49259b8$var$db(c) || $fbd042e4a49259b8$var$Ka(c)) return null !== e ? null : n(a, b, c, d, null);
            $fbd042e4a49259b8$var$Ih(a, c);
        }
        return null;
    }
    function z(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $fbd042e4a49259b8$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $fbd042e4a49259b8$var$xa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $fbd042e4a49259b8$var$Ha:
                    var f = d._init;
                    return z(a, b, c, f(d._payload), e);
            }
            if ($fbd042e4a49259b8$var$db(d) || $fbd042e4a49259b8$var$Ka(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            $fbd042e4a49259b8$var$Ih(b, d);
        }
        return null;
    }
    function m(e, g, h, k) {
        for(var l = null, v = null, n = g, m = g = 0, y = null; null !== n && m < h.length; m++){
            n.index > m ? (y = n, n = null) : y = n.sibling;
            var x = r(e, n, h[m], k);
            if (null === x) {
                null === n && (n = y);
                break;
            }
            a && n && null === x.alternate && b(e, n);
            g = f(x, g, m);
            null === v ? l = x : v.sibling = x;
            v = x;
            n = y;
        }
        if (m === h.length) return c(e, n), $fbd042e4a49259b8$var$J && $fbd042e4a49259b8$var$Hg(e, m), l;
        if (null === n) {
            for(; m < h.length; m++)n = q(e, h[m], k), null !== n && (g = f(n, g, m), null === v ? l = n : v.sibling = n, v = n);
            $fbd042e4a49259b8$var$J && $fbd042e4a49259b8$var$Hg(e, m);
            return l;
        }
        for(n = d(e, n); m < h.length; m++)y = z(n, e, m, h[m], k), null !== y && (a && null !== y.alternate && n.delete(null === y.key ? m : y.key), g = f(y, g, m), null === v ? l = y : v.sibling = y, v = y);
        a && n.forEach(function(a) {
            return b(e, a);
        });
        $fbd042e4a49259b8$var$J && $fbd042e4a49259b8$var$Hg(e, m);
        return l;
    }
    function w(e, g, h, k) {
        var l = $fbd042e4a49259b8$var$Ka(h);
        if ("function" !== typeof l) throw Error($fbd042e4a49259b8$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($fbd042e4a49259b8$var$p(151));
        for(var n = l = null, m = g, v = g = 0, y = null, x = h.next(); null !== m && !x.done; v++, x = h.next()){
            m.index > v ? (y = m, m = null) : y = m.sibling;
            var w = r(e, m, x.value, k);
            if (null === w) {
                null === m && (m = y);
                break;
            }
            a && m && null === w.alternate && b(e, m);
            g = f(w, g, v);
            null === n ? l = w : n.sibling = w;
            n = w;
            m = y;
        }
        if (x.done) return c(e, m), $fbd042e4a49259b8$var$J && $fbd042e4a49259b8$var$Hg(e, v), l;
        if (null === m) {
            for(; !x.done; v++, x = h.next())x = q(e, x.value, k), null !== x && (g = f(x, g, v), null === n ? l = x : n.sibling = x, n = x);
            $fbd042e4a49259b8$var$J && $fbd042e4a49259b8$var$Hg(e, v);
            return l;
        }
        for(m = d(e, m); !x.done; v++, x = h.next())x = z(m, e, v, x.value, k), null !== x && (a && null !== x.alternate && m.delete(null === x.key ? v : x.key), g = f(x, g, v), null === n ? l = x : n.sibling = x, n = x);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $fbd042e4a49259b8$var$J && $fbd042e4a49259b8$var$Hg(e, v);
        return l;
    }
    function C(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $fbd042e4a49259b8$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $fbd042e4a49259b8$var$wa:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $fbd042e4a49259b8$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $fbd042e4a49259b8$var$Ha && $fbd042e4a49259b8$var$Jh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $fbd042e4a49259b8$var$Hh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $fbd042e4a49259b8$var$ya ? (d = $fbd042e4a49259b8$var$Ph(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $fbd042e4a49259b8$var$Nh(f.type, f.key, f.props, null, a.mode, h), h.ref = $fbd042e4a49259b8$var$Hh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $fbd042e4a49259b8$var$xa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $fbd042e4a49259b8$var$Oh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $fbd042e4a49259b8$var$Ha:
                    return l = f._init, C(a, d, l(f._payload), h);
            }
            if ($fbd042e4a49259b8$var$db(f)) return m(a, d, f, h);
            if ($fbd042e4a49259b8$var$Ka(f)) return w(a, d, f, h);
            $fbd042e4a49259b8$var$Ih(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $fbd042e4a49259b8$var$Mh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return C;
}
var $fbd042e4a49259b8$var$Qh = $fbd042e4a49259b8$var$Kh(!0), $fbd042e4a49259b8$var$Rh = $fbd042e4a49259b8$var$Kh(!1), $fbd042e4a49259b8$var$Sh = {}, $fbd042e4a49259b8$var$Th = $fbd042e4a49259b8$var$hg($fbd042e4a49259b8$var$Sh), $fbd042e4a49259b8$var$Uh = $fbd042e4a49259b8$var$hg($fbd042e4a49259b8$var$Sh), $fbd042e4a49259b8$var$Vh = $fbd042e4a49259b8$var$hg($fbd042e4a49259b8$var$Sh);
function $fbd042e4a49259b8$var$Wh(a) {
    if (a === $fbd042e4a49259b8$var$Sh) throw Error($fbd042e4a49259b8$var$p(174));
    return a;
}
function $fbd042e4a49259b8$var$Xh(a, b) {
    $fbd042e4a49259b8$var$H($fbd042e4a49259b8$var$Vh, b);
    $fbd042e4a49259b8$var$H($fbd042e4a49259b8$var$Uh, a);
    $fbd042e4a49259b8$var$H($fbd042e4a49259b8$var$Th, $fbd042e4a49259b8$var$Sh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $fbd042e4a49259b8$var$kb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $fbd042e4a49259b8$var$kb(b, a);
    }
    $fbd042e4a49259b8$var$G($fbd042e4a49259b8$var$Th);
    $fbd042e4a49259b8$var$H($fbd042e4a49259b8$var$Th, b);
}
function $fbd042e4a49259b8$var$Yh() {
    $fbd042e4a49259b8$var$G($fbd042e4a49259b8$var$Th);
    $fbd042e4a49259b8$var$G($fbd042e4a49259b8$var$Uh);
    $fbd042e4a49259b8$var$G($fbd042e4a49259b8$var$Vh);
}
function $fbd042e4a49259b8$var$Zh(a) {
    $fbd042e4a49259b8$var$Wh($fbd042e4a49259b8$var$Vh.current);
    var b = $fbd042e4a49259b8$var$Wh($fbd042e4a49259b8$var$Th.current);
    var c = $fbd042e4a49259b8$var$kb(b, a.type);
    b !== c && ($fbd042e4a49259b8$var$H($fbd042e4a49259b8$var$Uh, a), $fbd042e4a49259b8$var$H($fbd042e4a49259b8$var$Th, c));
}
function $fbd042e4a49259b8$var$$h(a) {
    $fbd042e4a49259b8$var$Uh.current === a && ($fbd042e4a49259b8$var$G($fbd042e4a49259b8$var$Th), $fbd042e4a49259b8$var$G($fbd042e4a49259b8$var$Uh));
}
var $fbd042e4a49259b8$var$L = $fbd042e4a49259b8$var$hg(0);
function $fbd042e4a49259b8$var$ai(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $fbd042e4a49259b8$var$bi = [];
function $fbd042e4a49259b8$var$ci() {
    for(var a = 0; a < $fbd042e4a49259b8$var$bi.length; a++)$fbd042e4a49259b8$var$bi[a]._workInProgressVersionPrimary = null;
    $fbd042e4a49259b8$var$bi.length = 0;
}
var $fbd042e4a49259b8$var$di = $fbd042e4a49259b8$var$va.ReactCurrentDispatcher, $fbd042e4a49259b8$var$ei = $fbd042e4a49259b8$var$va.ReactCurrentBatchConfig, $fbd042e4a49259b8$var$fi = 0, $fbd042e4a49259b8$var$M = null, $fbd042e4a49259b8$var$N = null, $fbd042e4a49259b8$var$O = null, $fbd042e4a49259b8$var$gi = !1, $fbd042e4a49259b8$var$hi = !1, $fbd042e4a49259b8$var$ii = 0, $fbd042e4a49259b8$var$ji = 0;
function $fbd042e4a49259b8$var$P() {
    throw Error($fbd042e4a49259b8$var$p(321));
}
function $fbd042e4a49259b8$var$ki(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$fbd042e4a49259b8$var$Ve(a[c], b[c])) return !1;
    return !0;
}
function $fbd042e4a49259b8$var$li(a, b, c, d, e, f) {
    $fbd042e4a49259b8$var$fi = f;
    $fbd042e4a49259b8$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $fbd042e4a49259b8$var$di.current = null === a || null === a.memoizedState ? $fbd042e4a49259b8$var$mi : $fbd042e4a49259b8$var$ni;
    a = c(d, e);
    if ($fbd042e4a49259b8$var$hi) {
        f = 0;
        do {
            $fbd042e4a49259b8$var$hi = !1;
            $fbd042e4a49259b8$var$ii = 0;
            if (25 <= f) throw Error($fbd042e4a49259b8$var$p(301));
            f += 1;
            $fbd042e4a49259b8$var$O = $fbd042e4a49259b8$var$N = null;
            b.updateQueue = null;
            $fbd042e4a49259b8$var$di.current = $fbd042e4a49259b8$var$oi;
            a = c(d, e);
        }while ($fbd042e4a49259b8$var$hi);
    }
    $fbd042e4a49259b8$var$di.current = $fbd042e4a49259b8$var$pi;
    b = null !== $fbd042e4a49259b8$var$N && null !== $fbd042e4a49259b8$var$N.next;
    $fbd042e4a49259b8$var$fi = 0;
    $fbd042e4a49259b8$var$O = $fbd042e4a49259b8$var$N = $fbd042e4a49259b8$var$M = null;
    $fbd042e4a49259b8$var$gi = !1;
    if (b) throw Error($fbd042e4a49259b8$var$p(300));
    return a;
}
function $fbd042e4a49259b8$var$qi() {
    var a = 0 !== $fbd042e4a49259b8$var$ii;
    $fbd042e4a49259b8$var$ii = 0;
    return a;
}
function $fbd042e4a49259b8$var$ri() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $fbd042e4a49259b8$var$O ? $fbd042e4a49259b8$var$M.memoizedState = $fbd042e4a49259b8$var$O = a : $fbd042e4a49259b8$var$O = $fbd042e4a49259b8$var$O.next = a;
    return $fbd042e4a49259b8$var$O;
}
function $fbd042e4a49259b8$var$si() {
    if (null === $fbd042e4a49259b8$var$N) {
        var a = $fbd042e4a49259b8$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $fbd042e4a49259b8$var$N.next;
    var b = null === $fbd042e4a49259b8$var$O ? $fbd042e4a49259b8$var$M.memoizedState : $fbd042e4a49259b8$var$O.next;
    if (null !== b) $fbd042e4a49259b8$var$O = b, $fbd042e4a49259b8$var$N = a;
    else {
        if (null === a) throw Error($fbd042e4a49259b8$var$p(310));
        $fbd042e4a49259b8$var$N = a;
        a = {
            memoizedState: $fbd042e4a49259b8$var$N.memoizedState,
            baseState: $fbd042e4a49259b8$var$N.baseState,
            baseQueue: $fbd042e4a49259b8$var$N.baseQueue,
            queue: $fbd042e4a49259b8$var$N.queue,
            next: null
        };
        null === $fbd042e4a49259b8$var$O ? $fbd042e4a49259b8$var$M.memoizedState = $fbd042e4a49259b8$var$O = a : $fbd042e4a49259b8$var$O = $fbd042e4a49259b8$var$O.next = a;
    }
    return $fbd042e4a49259b8$var$O;
}
function $fbd042e4a49259b8$var$ti(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $fbd042e4a49259b8$var$ui(a) {
    var b = $fbd042e4a49259b8$var$si(), c = b.queue;
    if (null === c) throw Error($fbd042e4a49259b8$var$p(311));
    c.lastRenderedReducer = a;
    var d = $fbd042e4a49259b8$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var n = l.lane;
            if (($fbd042e4a49259b8$var$fi & n) === n) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: n,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $fbd042e4a49259b8$var$M.lanes |= n;
                $fbd042e4a49259b8$var$vh |= n;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $fbd042e4a49259b8$var$Ve(d, b.memoizedState) || ($fbd042e4a49259b8$var$hh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $fbd042e4a49259b8$var$M.lanes |= f, $fbd042e4a49259b8$var$vh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $fbd042e4a49259b8$var$vi(a) {
    var b = $fbd042e4a49259b8$var$si(), c = b.queue;
    if (null === c) throw Error($fbd042e4a49259b8$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $fbd042e4a49259b8$var$Ve(f, b.memoizedState) || ($fbd042e4a49259b8$var$hh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $fbd042e4a49259b8$var$wi() {}
function $fbd042e4a49259b8$var$xi(a, b) {
    var c = $fbd042e4a49259b8$var$M, d = $fbd042e4a49259b8$var$si(), e = b(), f = !$fbd042e4a49259b8$var$Ve(d.memoizedState, e);
    f && (d.memoizedState = e, $fbd042e4a49259b8$var$hh = !0);
    d = d.queue;
    $fbd042e4a49259b8$var$yi($fbd042e4a49259b8$var$zi.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $fbd042e4a49259b8$var$O && $fbd042e4a49259b8$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $fbd042e4a49259b8$var$Ai(9, $fbd042e4a49259b8$var$Bi.bind(null, c, d, e, b), void 0, null);
        if (null === $fbd042e4a49259b8$var$Q) throw Error($fbd042e4a49259b8$var$p(349));
        0 !== ($fbd042e4a49259b8$var$fi & 30) || $fbd042e4a49259b8$var$Ci(c, b, e);
    }
    return e;
}
function $fbd042e4a49259b8$var$Ci(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $fbd042e4a49259b8$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $fbd042e4a49259b8$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $fbd042e4a49259b8$var$Bi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $fbd042e4a49259b8$var$Di(b) && $fbd042e4a49259b8$var$Ei(a);
}
function $fbd042e4a49259b8$var$zi(a, b, c) {
    return c(function() {
        $fbd042e4a49259b8$var$Di(b) && $fbd042e4a49259b8$var$Ei(a);
    });
}
function $fbd042e4a49259b8$var$Di(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$fbd042e4a49259b8$var$Ve(a, c);
    } catch (d) {
        return !0;
    }
}
function $fbd042e4a49259b8$var$Ei(a) {
    var b = $fbd042e4a49259b8$var$mh(a, 1);
    null !== b && $fbd042e4a49259b8$var$Bh(b, a, 1, -1);
}
function $fbd042e4a49259b8$var$Fi(a) {
    var b = $fbd042e4a49259b8$var$ri();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $fbd042e4a49259b8$var$ti,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $fbd042e4a49259b8$var$Gi.bind(null, $fbd042e4a49259b8$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $fbd042e4a49259b8$var$Ai(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $fbd042e4a49259b8$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $fbd042e4a49259b8$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $fbd042e4a49259b8$var$Ji() {
    return $fbd042e4a49259b8$var$si().memoizedState;
}
function $fbd042e4a49259b8$var$Ki(a, b, c, d) {
    var e = $fbd042e4a49259b8$var$ri();
    $fbd042e4a49259b8$var$M.flags |= a;
    e.memoizedState = $fbd042e4a49259b8$var$Ai(1 | b, c, void 0, void 0 === d ? null : d);
}
function $fbd042e4a49259b8$var$Li(a, b, c, d) {
    var e = $fbd042e4a49259b8$var$si();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $fbd042e4a49259b8$var$N) {
        var g = $fbd042e4a49259b8$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $fbd042e4a49259b8$var$ki(d, g.deps)) {
            e.memoizedState = $fbd042e4a49259b8$var$Ai(b, c, f, d);
            return;
        }
    }
    $fbd042e4a49259b8$var$M.flags |= a;
    e.memoizedState = $fbd042e4a49259b8$var$Ai(1 | b, c, f, d);
}
function $fbd042e4a49259b8$var$Mi(a, b) {
    return $fbd042e4a49259b8$var$Ki(8390656, 8, a, b);
}
function $fbd042e4a49259b8$var$yi(a, b) {
    return $fbd042e4a49259b8$var$Li(2048, 8, a, b);
}
function $fbd042e4a49259b8$var$Ni(a, b) {
    return $fbd042e4a49259b8$var$Li(4, 2, a, b);
}
function $fbd042e4a49259b8$var$Oi(a, b) {
    return $fbd042e4a49259b8$var$Li(4, 4, a, b);
}
function $fbd042e4a49259b8$var$Pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $fbd042e4a49259b8$var$Qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $fbd042e4a49259b8$var$Li(4, 4, $fbd042e4a49259b8$var$Pi.bind(null, b, a), c);
}
function $fbd042e4a49259b8$var$Ri() {}
function $fbd042e4a49259b8$var$Si(a, b) {
    var c = $fbd042e4a49259b8$var$si();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $fbd042e4a49259b8$var$ki(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $fbd042e4a49259b8$var$Ti(a, b) {
    var c = $fbd042e4a49259b8$var$si();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $fbd042e4a49259b8$var$ki(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $fbd042e4a49259b8$var$Ui(a, b, c) {
    if (0 === ($fbd042e4a49259b8$var$fi & 21)) return a.baseState && (a.baseState = !1, $fbd042e4a49259b8$var$hh = !0), a.memoizedState = c;
    $fbd042e4a49259b8$var$Ve(c, b) || (c = $fbd042e4a49259b8$var$Kc(), $fbd042e4a49259b8$var$M.lanes |= c, $fbd042e4a49259b8$var$vh |= c, a.baseState = !0);
    return b;
}
function $fbd042e4a49259b8$var$Vi(a, b) {
    var c = $fbd042e4a49259b8$var$E;
    $fbd042e4a49259b8$var$E = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $fbd042e4a49259b8$var$ei.transition;
    $fbd042e4a49259b8$var$ei.transition = {};
    try {
        a(!1), b();
    } finally{
        $fbd042e4a49259b8$var$E = c, $fbd042e4a49259b8$var$ei.transition = d;
    }
}
function $fbd042e4a49259b8$var$Wi() {
    return $fbd042e4a49259b8$var$si().memoizedState;
}
function $fbd042e4a49259b8$var$Xi(a, b, c) {
    var d = $fbd042e4a49259b8$var$Ah(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($fbd042e4a49259b8$var$Yi(a)) $fbd042e4a49259b8$var$Zi(b, c);
    else if (c = $fbd042e4a49259b8$var$lh(a, b, c, d), null !== c) {
        var e = $fbd042e4a49259b8$var$zh();
        $fbd042e4a49259b8$var$Bh(c, a, d, e);
        $fbd042e4a49259b8$var$$i(c, b, d);
    }
    $fbd042e4a49259b8$var$yc(a, d);
}
function $fbd042e4a49259b8$var$Gi(a, b, c) {
    var d = $fbd042e4a49259b8$var$Ah(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($fbd042e4a49259b8$var$Yi(a)) $fbd042e4a49259b8$var$Zi(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($fbd042e4a49259b8$var$Ve(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $fbd042e4a49259b8$var$kh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $fbd042e4a49259b8$var$lh(a, b, e, d);
        null !== c && (e = $fbd042e4a49259b8$var$zh(), $fbd042e4a49259b8$var$Bh(c, a, d, e), $fbd042e4a49259b8$var$$i(c, b, d));
    }
    $fbd042e4a49259b8$var$yc(a, d);
}
function $fbd042e4a49259b8$var$Yi(a) {
    var b = a.alternate;
    return a === $fbd042e4a49259b8$var$M || null !== b && b === $fbd042e4a49259b8$var$M;
}
function $fbd042e4a49259b8$var$Zi(a, b) {
    $fbd042e4a49259b8$var$hi = $fbd042e4a49259b8$var$gi = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $fbd042e4a49259b8$var$$i(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $fbd042e4a49259b8$var$Oc(a, c);
    }
}
var $fbd042e4a49259b8$var$pi = {
    readContext: $fbd042e4a49259b8$var$ih,
    useCallback: $fbd042e4a49259b8$var$P,
    useContext: $fbd042e4a49259b8$var$P,
    useEffect: $fbd042e4a49259b8$var$P,
    useImperativeHandle: $fbd042e4a49259b8$var$P,
    useInsertionEffect: $fbd042e4a49259b8$var$P,
    useLayoutEffect: $fbd042e4a49259b8$var$P,
    useMemo: $fbd042e4a49259b8$var$P,
    useReducer: $fbd042e4a49259b8$var$P,
    useRef: $fbd042e4a49259b8$var$P,
    useState: $fbd042e4a49259b8$var$P,
    useDebugValue: $fbd042e4a49259b8$var$P,
    useDeferredValue: $fbd042e4a49259b8$var$P,
    useTransition: $fbd042e4a49259b8$var$P,
    useMutableSource: $fbd042e4a49259b8$var$P,
    useSyncExternalStore: $fbd042e4a49259b8$var$P,
    useId: $fbd042e4a49259b8$var$P,
    unstable_isNewReconciler: !1
}, $fbd042e4a49259b8$var$mi = {
    readContext: $fbd042e4a49259b8$var$ih,
    useCallback: function(a, b) {
        $fbd042e4a49259b8$var$ri().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $fbd042e4a49259b8$var$ih,
    useEffect: $fbd042e4a49259b8$var$Mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $fbd042e4a49259b8$var$Ki(4194308, 4, $fbd042e4a49259b8$var$Pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $fbd042e4a49259b8$var$Ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $fbd042e4a49259b8$var$Ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $fbd042e4a49259b8$var$ri();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $fbd042e4a49259b8$var$ri();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $fbd042e4a49259b8$var$Xi.bind(null, $fbd042e4a49259b8$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $fbd042e4a49259b8$var$ri();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $fbd042e4a49259b8$var$Fi,
    useDebugValue: $fbd042e4a49259b8$var$Ri,
    useDeferredValue: function(a) {
        return $fbd042e4a49259b8$var$ri().memoizedState = a;
    },
    useTransition: function() {
        var a = $fbd042e4a49259b8$var$Fi(!1), b = a[0];
        a = $fbd042e4a49259b8$var$Vi.bind(null, a[1]);
        $fbd042e4a49259b8$var$ri().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $fbd042e4a49259b8$var$M, e = $fbd042e4a49259b8$var$ri();
        if ($fbd042e4a49259b8$var$J) {
            if (void 0 === c) throw Error($fbd042e4a49259b8$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $fbd042e4a49259b8$var$Q) throw Error($fbd042e4a49259b8$var$p(349));
            0 !== ($fbd042e4a49259b8$var$fi & 30) || $fbd042e4a49259b8$var$Ci(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $fbd042e4a49259b8$var$Mi($fbd042e4a49259b8$var$zi.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $fbd042e4a49259b8$var$Ai(9, $fbd042e4a49259b8$var$Bi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $fbd042e4a49259b8$var$ri(), b = $fbd042e4a49259b8$var$Q.identifierPrefix;
        if ($fbd042e4a49259b8$var$J) {
            var c = $fbd042e4a49259b8$var$Gg;
            var d = $fbd042e4a49259b8$var$Fg;
            c = (d & ~(1 << 32 - $fbd042e4a49259b8$var$Ac(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $fbd042e4a49259b8$var$ii++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $fbd042e4a49259b8$var$ji++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $fbd042e4a49259b8$var$ni = {
    readContext: $fbd042e4a49259b8$var$ih,
    useCallback: $fbd042e4a49259b8$var$Si,
    useContext: $fbd042e4a49259b8$var$ih,
    useEffect: $fbd042e4a49259b8$var$yi,
    useImperativeHandle: $fbd042e4a49259b8$var$Qi,
    useInsertionEffect: $fbd042e4a49259b8$var$Ni,
    useLayoutEffect: $fbd042e4a49259b8$var$Oi,
    useMemo: $fbd042e4a49259b8$var$Ti,
    useReducer: $fbd042e4a49259b8$var$ui,
    useRef: $fbd042e4a49259b8$var$Ji,
    useState: function() {
        return $fbd042e4a49259b8$var$ui($fbd042e4a49259b8$var$ti);
    },
    useDebugValue: $fbd042e4a49259b8$var$Ri,
    useDeferredValue: function(a) {
        var b = $fbd042e4a49259b8$var$si();
        return $fbd042e4a49259b8$var$Ui(b, $fbd042e4a49259b8$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $fbd042e4a49259b8$var$ui($fbd042e4a49259b8$var$ti)[0], b = $fbd042e4a49259b8$var$si().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $fbd042e4a49259b8$var$wi,
    useSyncExternalStore: $fbd042e4a49259b8$var$xi,
    useId: $fbd042e4a49259b8$var$Wi,
    unstable_isNewReconciler: !1
}, $fbd042e4a49259b8$var$oi = {
    readContext: $fbd042e4a49259b8$var$ih,
    useCallback: $fbd042e4a49259b8$var$Si,
    useContext: $fbd042e4a49259b8$var$ih,
    useEffect: $fbd042e4a49259b8$var$yi,
    useImperativeHandle: $fbd042e4a49259b8$var$Qi,
    useInsertionEffect: $fbd042e4a49259b8$var$Ni,
    useLayoutEffect: $fbd042e4a49259b8$var$Oi,
    useMemo: $fbd042e4a49259b8$var$Ti,
    useReducer: $fbd042e4a49259b8$var$vi,
    useRef: $fbd042e4a49259b8$var$Ji,
    useState: function() {
        return $fbd042e4a49259b8$var$vi($fbd042e4a49259b8$var$ti);
    },
    useDebugValue: $fbd042e4a49259b8$var$Ri,
    useDeferredValue: function(a) {
        var b = $fbd042e4a49259b8$var$si();
        return null === $fbd042e4a49259b8$var$N ? b.memoizedState = a : $fbd042e4a49259b8$var$Ui(b, $fbd042e4a49259b8$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $fbd042e4a49259b8$var$vi($fbd042e4a49259b8$var$ti)[0], b = $fbd042e4a49259b8$var$si().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $fbd042e4a49259b8$var$wi,
    useSyncExternalStore: $fbd042e4a49259b8$var$xi,
    useId: $fbd042e4a49259b8$var$Wi,
    unstable_isNewReconciler: !1
}, $fbd042e4a49259b8$var$aj = $9phqb.unstable_now, $fbd042e4a49259b8$var$bj = 0, $fbd042e4a49259b8$var$cj = -1, $fbd042e4a49259b8$var$dj = -1, $fbd042e4a49259b8$var$ej = -1, $fbd042e4a49259b8$var$fj = !1, $fbd042e4a49259b8$var$gj = !1;
function $fbd042e4a49259b8$var$hj(a, b) {
    if (0 <= $fbd042e4a49259b8$var$dj) {
        var c = $fbd042e4a49259b8$var$aj() - $fbd042e4a49259b8$var$dj;
        a.actualDuration += c;
        b && (a.selfBaseDuration = c);
        $fbd042e4a49259b8$var$dj = -1;
    }
}
function $fbd042e4a49259b8$var$ij(a) {
    if (0 <= $fbd042e4a49259b8$var$cj) {
        var b = $fbd042e4a49259b8$var$aj() - $fbd042e4a49259b8$var$cj;
        $fbd042e4a49259b8$var$cj = -1;
        for(a = a.return; null !== a;){
            switch(a.tag){
                case 3:
                    a.stateNode.effectDuration += b;
                    return;
                case 12:
                    a.stateNode.effectDuration += b;
                    return;
            }
            a = a.return;
        }
    }
}
function $fbd042e4a49259b8$var$jj(a) {
    if (0 <= $fbd042e4a49259b8$var$ej) {
        var b = $fbd042e4a49259b8$var$aj() - $fbd042e4a49259b8$var$ej;
        $fbd042e4a49259b8$var$ej = -1;
        for(a = a.return; null !== a;){
            switch(a.tag){
                case 3:
                    a = a.stateNode;
                    null !== a && (a.passiveEffectDuration += b);
                    return;
                case 12:
                    a = a.stateNode;
                    null !== a && (a.passiveEffectDuration += b);
                    return;
            }
            a = a.return;
        }
    }
}
function $fbd042e4a49259b8$var$kj() {
    $fbd042e4a49259b8$var$cj = $fbd042e4a49259b8$var$aj();
}
function $fbd042e4a49259b8$var$lj(a) {
    for(var b = a.child; b;)a.actualDuration += b.actualDuration, b = b.sibling;
}
function $fbd042e4a49259b8$var$mj(a, b) {
    try {
        var c = "", d = b;
        do c += $fbd042e4a49259b8$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $fbd042e4a49259b8$var$nj(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $fbd042e4a49259b8$var$oj(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $fbd042e4a49259b8$var$pj = "function" === typeof WeakMap ? WeakMap : Map;
function $fbd042e4a49259b8$var$qj(a, b, c) {
    c = $fbd042e4a49259b8$var$qh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $fbd042e4a49259b8$var$rj || ($fbd042e4a49259b8$var$rj = !0, $fbd042e4a49259b8$var$sj = d);
        $fbd042e4a49259b8$var$oj(a, b);
    };
    return c;
}
function $fbd042e4a49259b8$var$tj(a, b, c) {
    c = $fbd042e4a49259b8$var$qh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $fbd042e4a49259b8$var$oj(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $fbd042e4a49259b8$var$oj(a, b);
        "function" !== typeof d && (null === $fbd042e4a49259b8$var$uj ? $fbd042e4a49259b8$var$uj = new Set([
            this
        ]) : $fbd042e4a49259b8$var$uj.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $fbd042e4a49259b8$var$vj(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $fbd042e4a49259b8$var$pj;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), d = $fbd042e4a49259b8$var$wj.bind(null, a, b, c), $fbd042e4a49259b8$var$mc && $fbd042e4a49259b8$var$xj(a, c), b.then(d, d));
}
function $fbd042e4a49259b8$var$yj(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $fbd042e4a49259b8$var$zj(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $fbd042e4a49259b8$var$qh(-1, 1), b.tag = 2, $fbd042e4a49259b8$var$rh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $fbd042e4a49259b8$var$Aj = $fbd042e4a49259b8$var$va.ReactCurrentOwner, $fbd042e4a49259b8$var$hh = !1;
function $fbd042e4a49259b8$var$Bj(a, b, c, d) {
    b.child = null === a ? $fbd042e4a49259b8$var$Rh(b, null, c, d) : $fbd042e4a49259b8$var$Qh(b, a.child, c, d);
}
function $fbd042e4a49259b8$var$Cj(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $fbd042e4a49259b8$var$gh(b, e);
    $fbd042e4a49259b8$var$sc(b);
    d = $fbd042e4a49259b8$var$li(a, b, c, d, f, e);
    c = $fbd042e4a49259b8$var$qi();
    $fbd042e4a49259b8$var$tc();
    if (null !== a && !$fbd042e4a49259b8$var$hh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $fbd042e4a49259b8$var$Dj(a, b, e);
    $fbd042e4a49259b8$var$J && c && $fbd042e4a49259b8$var$Jg(b);
    b.flags |= 1;
    $fbd042e4a49259b8$var$Bj(a, b, d, e);
    return b.child;
}
function $fbd042e4a49259b8$var$Ej(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$fbd042e4a49259b8$var$Fj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $fbd042e4a49259b8$var$Gj(a, b, f, d, e);
        a = $fbd042e4a49259b8$var$Nh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $fbd042e4a49259b8$var$We;
        if (c(g, d) && a.ref === b.ref) return $fbd042e4a49259b8$var$Dj(a, b, e);
    }
    b.flags |= 1;
    a = $fbd042e4a49259b8$var$Lh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $fbd042e4a49259b8$var$Gj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($fbd042e4a49259b8$var$We(f, d) && a.ref === b.ref) {
            if ($fbd042e4a49259b8$var$hh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($fbd042e4a49259b8$var$hh = !0);
            else return b.lanes = a.lanes, $fbd042e4a49259b8$var$Dj(a, b, e);
        }
    }
    return $fbd042e4a49259b8$var$Hj(a, b, c, d, e);
}
function $fbd042e4a49259b8$var$Ij(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $fbd042e4a49259b8$var$H($fbd042e4a49259b8$var$Jj, $fbd042e4a49259b8$var$Kj), $fbd042e4a49259b8$var$Kj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $fbd042e4a49259b8$var$H($fbd042e4a49259b8$var$Jj, $fbd042e4a49259b8$var$Kj), $fbd042e4a49259b8$var$Kj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $fbd042e4a49259b8$var$H($fbd042e4a49259b8$var$Jj, $fbd042e4a49259b8$var$Kj);
            $fbd042e4a49259b8$var$Kj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $fbd042e4a49259b8$var$H($fbd042e4a49259b8$var$Jj, $fbd042e4a49259b8$var$Kj), $fbd042e4a49259b8$var$Kj |= d;
    $fbd042e4a49259b8$var$Bj(a, b, e, c);
    return b.child;
}
function $fbd042e4a49259b8$var$Lj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $fbd042e4a49259b8$var$Hj(a, b, c, d, e) {
    var f = $fbd042e4a49259b8$var$mg(c) ? $fbd042e4a49259b8$var$kg : $fbd042e4a49259b8$var$I.current;
    f = $fbd042e4a49259b8$var$lg(b, f);
    $fbd042e4a49259b8$var$gh(b, e);
    $fbd042e4a49259b8$var$sc(b);
    c = $fbd042e4a49259b8$var$li(a, b, c, d, f, e);
    d = $fbd042e4a49259b8$var$qi();
    $fbd042e4a49259b8$var$tc();
    if (null !== a && !$fbd042e4a49259b8$var$hh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $fbd042e4a49259b8$var$Dj(a, b, e);
    $fbd042e4a49259b8$var$J && d && $fbd042e4a49259b8$var$Jg(b);
    b.flags |= 1;
    $fbd042e4a49259b8$var$Bj(a, b, c, e);
    return b.child;
}
function $fbd042e4a49259b8$var$Mj(a, b, c, d, e) {
    if ($fbd042e4a49259b8$var$mg(c)) {
        var f = !0;
        $fbd042e4a49259b8$var$qg(b);
    } else f = !1;
    $fbd042e4a49259b8$var$gh(b, e);
    if (null === b.stateNode) $fbd042e4a49259b8$var$Nj(a, b), $fbd042e4a49259b8$var$Eh(b, c, d), $fbd042e4a49259b8$var$Gh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $fbd042e4a49259b8$var$ih(l) : (l = $fbd042e4a49259b8$var$mg(c) ? $fbd042e4a49259b8$var$kg : $fbd042e4a49259b8$var$I.current, l = $fbd042e4a49259b8$var$lg(b, l));
        var n = c.getDerivedStateFromProps, q = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $fbd042e4a49259b8$var$Fh(b, g, d, l);
        $fbd042e4a49259b8$var$nh = !1;
        var r = b.memoizedState;
        g.state = r;
        $fbd042e4a49259b8$var$uh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $fbd042e4a49259b8$var$jg.current || $fbd042e4a49259b8$var$nh ? ("function" === typeof n && ($fbd042e4a49259b8$var$yh(b, c, n, d), k = b.memoizedState), (h = $fbd042e4a49259b8$var$nh || $fbd042e4a49259b8$var$Dh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $fbd042e4a49259b8$var$ph(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $fbd042e4a49259b8$var$Zg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $fbd042e4a49259b8$var$ih(k) : (k = $fbd042e4a49259b8$var$mg(c) ? $fbd042e4a49259b8$var$kg : $fbd042e4a49259b8$var$I.current, k = $fbd042e4a49259b8$var$lg(b, k));
        var z = c.getDerivedStateFromProps;
        (n = "function" === typeof z || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $fbd042e4a49259b8$var$Fh(b, g, d, k);
        $fbd042e4a49259b8$var$nh = !1;
        r = b.memoizedState;
        g.state = r;
        $fbd042e4a49259b8$var$uh(b, d, g, e);
        var m = b.memoizedState;
        h !== q || r !== m || $fbd042e4a49259b8$var$jg.current || $fbd042e4a49259b8$var$nh ? ("function" === typeof z && ($fbd042e4a49259b8$var$yh(b, c, z, d), m = b.memoizedState), (l = $fbd042e4a49259b8$var$nh || $fbd042e4a49259b8$var$Dh(b, c, l, d, r, m, k) || !1) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, m, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, m, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = m), g.props = d, g.state = m, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $fbd042e4a49259b8$var$Oj(a, b, c, d, f, e);
}
function $fbd042e4a49259b8$var$Oj(a, b, c, d, e, f) {
    $fbd042e4a49259b8$var$Lj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $fbd042e4a49259b8$var$rg(b, c, !1), $fbd042e4a49259b8$var$Dj(a, b, f);
    d = b.stateNode;
    $fbd042e4a49259b8$var$Aj.current = b;
    if (g && "function" !== typeof c.getDerivedStateFromError) {
        var h = null;
        $fbd042e4a49259b8$var$dj = -1;
    } else $fbd042e4a49259b8$var$sc(b), h = d.render(), $fbd042e4a49259b8$var$tc();
    b.flags |= 1;
    null !== a && g ? (g = h, b.child = $fbd042e4a49259b8$var$Qh(b, a.child, null, f), b.child = $fbd042e4a49259b8$var$Qh(b, null, g, f)) : $fbd042e4a49259b8$var$Bj(a, b, h, f);
    b.memoizedState = d.state;
    e && $fbd042e4a49259b8$var$rg(b, c, !0);
    return b.child;
}
function $fbd042e4a49259b8$var$Pj(a) {
    var b = a.stateNode;
    b.pendingContext ? $fbd042e4a49259b8$var$og(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $fbd042e4a49259b8$var$og(a, b.context, !1);
    $fbd042e4a49259b8$var$Xh(a, b.containerInfo);
}
function $fbd042e4a49259b8$var$Qj(a, b, c, d, e) {
    $fbd042e4a49259b8$var$Wg();
    $fbd042e4a49259b8$var$Xg(e);
    b.flags |= 256;
    $fbd042e4a49259b8$var$Bj(a, b, c, d);
    return b.child;
}
var $fbd042e4a49259b8$var$Tj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $fbd042e4a49259b8$var$Uj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $fbd042e4a49259b8$var$Vj(a, b, c) {
    var d = b.pendingProps, e = $fbd042e4a49259b8$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $fbd042e4a49259b8$var$H($fbd042e4a49259b8$var$L, e & 1);
    if (null === a) {
        $fbd042e4a49259b8$var$Sg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g, b.mode & 2 && (f.actualDuration = 0, f.actualStartTime = -1, f.selfBaseDuration = 0, f.treeBaseDuration = 0)) : f = $fbd042e4a49259b8$var$Wj(g, d, 0, null), a = $fbd042e4a49259b8$var$Ph(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $fbd042e4a49259b8$var$Uj(c), b.memoizedState = $fbd042e4a49259b8$var$Tj, a) : $fbd042e4a49259b8$var$Xj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $fbd042e4a49259b8$var$Yj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.mode & 2 && (d.actualDuration = 0, d.actualStartTime = -1, d.selfBaseDuration = e.selfBaseDuration, d.treeBaseDuration = e.treeBaseDuration), b.deletions = null) : (d = $fbd042e4a49259b8$var$Lh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $fbd042e4a49259b8$var$Lh(h, f) : (f = $fbd042e4a49259b8$var$Ph(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $fbd042e4a49259b8$var$Uj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $fbd042e4a49259b8$var$Tj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $fbd042e4a49259b8$var$Lh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $fbd042e4a49259b8$var$Xj(a, b) {
    b = $fbd042e4a49259b8$var$Wj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $fbd042e4a49259b8$var$Zj(a, b, c, d) {
    null !== d && $fbd042e4a49259b8$var$Xg(d);
    $fbd042e4a49259b8$var$Qh(b, a.child, null, c);
    a = $fbd042e4a49259b8$var$Xj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $fbd042e4a49259b8$var$Yj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $fbd042e4a49259b8$var$nj(Error($fbd042e4a49259b8$var$p(422))), $fbd042e4a49259b8$var$Zj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $fbd042e4a49259b8$var$Wj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $fbd042e4a49259b8$var$Ph(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $fbd042e4a49259b8$var$Qh(b, a.child, null, g);
        b.child.memoizedState = $fbd042e4a49259b8$var$Uj(g);
        b.memoizedState = $fbd042e4a49259b8$var$Tj;
        return f;
    }
    if (0 === (b.mode & 1)) return $fbd042e4a49259b8$var$Zj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($fbd042e4a49259b8$var$p(419));
        d = $fbd042e4a49259b8$var$nj(f, d, void 0);
        return $fbd042e4a49259b8$var$Zj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($fbd042e4a49259b8$var$hh || h) {
        d = $fbd042e4a49259b8$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $fbd042e4a49259b8$var$mh(a, e), $fbd042e4a49259b8$var$Bh(d, a, e, -1));
        }
        $fbd042e4a49259b8$var$ak();
        d = $fbd042e4a49259b8$var$nj(Error($fbd042e4a49259b8$var$p(421)));
        return $fbd042e4a49259b8$var$Zj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $fbd042e4a49259b8$var$bk.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $fbd042e4a49259b8$var$Mg = $fbd042e4a49259b8$var$Zf(e.nextSibling);
    $fbd042e4a49259b8$var$Lg = b;
    $fbd042e4a49259b8$var$J = !0;
    $fbd042e4a49259b8$var$Ng = null;
    null !== a && ($fbd042e4a49259b8$var$Cg[$fbd042e4a49259b8$var$Dg++] = $fbd042e4a49259b8$var$Fg, $fbd042e4a49259b8$var$Cg[$fbd042e4a49259b8$var$Dg++] = $fbd042e4a49259b8$var$Gg, $fbd042e4a49259b8$var$Cg[$fbd042e4a49259b8$var$Dg++] = $fbd042e4a49259b8$var$Eg, $fbd042e4a49259b8$var$Fg = a.id, $fbd042e4a49259b8$var$Gg = a.overflow, $fbd042e4a49259b8$var$Eg = b);
    b = $fbd042e4a49259b8$var$Xj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $fbd042e4a49259b8$var$ck(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $fbd042e4a49259b8$var$fh(a.return, b, c);
}
function $fbd042e4a49259b8$var$dk(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $fbd042e4a49259b8$var$ek(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $fbd042e4a49259b8$var$Bj(a, b, d.children, c);
    d = $fbd042e4a49259b8$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $fbd042e4a49259b8$var$ck(a, c, b);
            else if (19 === a.tag) $fbd042e4a49259b8$var$ck(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $fbd042e4a49259b8$var$H($fbd042e4a49259b8$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $fbd042e4a49259b8$var$ai(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $fbd042e4a49259b8$var$dk(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $fbd042e4a49259b8$var$ai(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $fbd042e4a49259b8$var$dk(b, !0, c, null, f);
            break;
        case "together":
            $fbd042e4a49259b8$var$dk(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $fbd042e4a49259b8$var$Nj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $fbd042e4a49259b8$var$Dj(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $fbd042e4a49259b8$var$dj = -1;
    $fbd042e4a49259b8$var$vh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($fbd042e4a49259b8$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $fbd042e4a49259b8$var$Lh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $fbd042e4a49259b8$var$Lh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $fbd042e4a49259b8$var$fk(a, b, c) {
    switch(b.tag){
        case 3:
            $fbd042e4a49259b8$var$Pj(b);
            $fbd042e4a49259b8$var$Wg();
            break;
        case 5:
            $fbd042e4a49259b8$var$Zh(b);
            break;
        case 1:
            $fbd042e4a49259b8$var$mg(b.type) && $fbd042e4a49259b8$var$qg(b);
            break;
        case 4:
            $fbd042e4a49259b8$var$Xh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $fbd042e4a49259b8$var$H($fbd042e4a49259b8$var$$g, d._currentValue);
            d._currentValue = e;
            break;
        case 12:
            0 !== (c & b.childLanes) && (b.flags |= 4);
            d = b.stateNode;
            d.effectDuration = 0;
            d.passiveEffectDuration = 0;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $fbd042e4a49259b8$var$H($fbd042e4a49259b8$var$L, $fbd042e4a49259b8$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $fbd042e4a49259b8$var$Vj(a, b, c);
                $fbd042e4a49259b8$var$H($fbd042e4a49259b8$var$L, $fbd042e4a49259b8$var$L.current & 1);
                a = $fbd042e4a49259b8$var$Dj(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $fbd042e4a49259b8$var$H($fbd042e4a49259b8$var$L, $fbd042e4a49259b8$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $fbd042e4a49259b8$var$ek(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $fbd042e4a49259b8$var$H($fbd042e4a49259b8$var$L, $fbd042e4a49259b8$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $fbd042e4a49259b8$var$Ij(a, b, c);
    }
    return $fbd042e4a49259b8$var$Dj(a, b, c);
}
var $fbd042e4a49259b8$var$gk, $fbd042e4a49259b8$var$hk, $fbd042e4a49259b8$var$ik, $fbd042e4a49259b8$var$jk;
$fbd042e4a49259b8$var$gk = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$fbd042e4a49259b8$var$hk = function() {};
$fbd042e4a49259b8$var$ik = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $fbd042e4a49259b8$var$Wh($fbd042e4a49259b8$var$Th.current);
        var f = null;
        switch(c){
            case "input":
                e = $fbd042e4a49259b8$var$Ya(a, e);
                d = $fbd042e4a49259b8$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $fbd042e4a49259b8$var$u({}, e, {
                    value: void 0
                });
                d = $fbd042e4a49259b8$var$u({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $fbd042e4a49259b8$var$fb(a, e);
                d = $fbd042e4a49259b8$var$fb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $fbd042e4a49259b8$var$Pf);
        }
        $fbd042e4a49259b8$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($fbd042e4a49259b8$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($fbd042e4a49259b8$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $fbd042e4a49259b8$var$F("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$fbd042e4a49259b8$var$jk = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $fbd042e4a49259b8$var$kk(a, b) {
    if (!$fbd042e4a49259b8$var$J) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $fbd042e4a49259b8$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) {
        if (0 !== (a.mode & 2)) {
            for(var e = a.selfBaseDuration, f = a.child; null !== f;)c |= f.lanes | f.childLanes, d |= f.subtreeFlags & 14680064, d |= f.flags & 14680064, e += f.treeBaseDuration, f = f.sibling;
            a.treeBaseDuration = e;
        } else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    } else if (0 !== (a.mode & 2)) {
        e = a.actualDuration;
        f = a.selfBaseDuration;
        for(var g = a.child; null !== g;)c |= g.lanes | g.childLanes, d |= g.subtreeFlags, d |= g.flags, e += g.actualDuration, f += g.treeBaseDuration, g = g.sibling;
        a.actualDuration = e;
        a.treeBaseDuration = f;
    } else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $fbd042e4a49259b8$var$lk(a, b, c) {
    var d = b.pendingProps;
    $fbd042e4a49259b8$var$Kg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $fbd042e4a49259b8$var$S(b), null;
        case 1:
            return $fbd042e4a49259b8$var$mg(b.type) && $fbd042e4a49259b8$var$ng(), $fbd042e4a49259b8$var$S(b), null;
        case 3:
            d = b.stateNode;
            $fbd042e4a49259b8$var$Yh();
            $fbd042e4a49259b8$var$G($fbd042e4a49259b8$var$jg);
            $fbd042e4a49259b8$var$G($fbd042e4a49259b8$var$I);
            $fbd042e4a49259b8$var$ci();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $fbd042e4a49259b8$var$Ug(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $fbd042e4a49259b8$var$Ng && ($fbd042e4a49259b8$var$mk($fbd042e4a49259b8$var$Ng), $fbd042e4a49259b8$var$Ng = null));
            $fbd042e4a49259b8$var$hk(a, b);
            $fbd042e4a49259b8$var$S(b);
            return null;
        case 5:
            $fbd042e4a49259b8$var$$h(b);
            var e = $fbd042e4a49259b8$var$Wh($fbd042e4a49259b8$var$Vh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $fbd042e4a49259b8$var$ik(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($fbd042e4a49259b8$var$p(166));
                    $fbd042e4a49259b8$var$S(b);
                    return null;
                }
                a = $fbd042e4a49259b8$var$Wh($fbd042e4a49259b8$var$Th.current);
                if ($fbd042e4a49259b8$var$Ug(b)) {
                    d = b.stateNode;
                    a = b.type;
                    c = b.memoizedProps;
                    d[$fbd042e4a49259b8$var$bg] = b;
                    d[$fbd042e4a49259b8$var$cg] = c;
                    var f = 0 !== (b.mode & 1);
                    switch(a){
                        case "dialog":
                            $fbd042e4a49259b8$var$F("cancel", d);
                            $fbd042e4a49259b8$var$F("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $fbd042e4a49259b8$var$F("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $fbd042e4a49259b8$var$zf.length; e++)$fbd042e4a49259b8$var$F($fbd042e4a49259b8$var$zf[e], d);
                            break;
                        case "source":
                            $fbd042e4a49259b8$var$F("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $fbd042e4a49259b8$var$F("error", d);
                            $fbd042e4a49259b8$var$F("load", d);
                            break;
                        case "details":
                            $fbd042e4a49259b8$var$F("toggle", d);
                            break;
                        case "input":
                            $fbd042e4a49259b8$var$Za(d, c);
                            $fbd042e4a49259b8$var$F("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!c.multiple
                            };
                            $fbd042e4a49259b8$var$F("invalid", d);
                            break;
                        case "textarea":
                            $fbd042e4a49259b8$var$gb(d, c), $fbd042e4a49259b8$var$F("invalid", d);
                    }
                    $fbd042e4a49259b8$var$ub(a, c);
                    e = null;
                    for(var g in c)if (c.hasOwnProperty(g)) {
                        var h = c[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== c.suppressHydrationWarning && $fbd042e4a49259b8$var$Of(d.textContent, h, f), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== c.suppressHydrationWarning && $fbd042e4a49259b8$var$Of(d.textContent, h, f), e = [
                            "children",
                            "" + h
                        ]) : $fbd042e4a49259b8$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $fbd042e4a49259b8$var$F("scroll", d);
                    }
                    switch(a){
                        case "input":
                            $fbd042e4a49259b8$var$Va(d);
                            $fbd042e4a49259b8$var$cb(d, c, !0);
                            break;
                        case "textarea":
                            $fbd042e4a49259b8$var$Va(d);
                            $fbd042e4a49259b8$var$ib(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof c.onClick && (d.onclick = $fbd042e4a49259b8$var$Pf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $fbd042e4a49259b8$var$jb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$fbd042e4a49259b8$var$bg] = b;
                    a[$fbd042e4a49259b8$var$cg] = d;
                    $fbd042e4a49259b8$var$gk(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $fbd042e4a49259b8$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $fbd042e4a49259b8$var$F("cancel", a);
                                $fbd042e4a49259b8$var$F("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $fbd042e4a49259b8$var$F("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $fbd042e4a49259b8$var$zf.length; e++)$fbd042e4a49259b8$var$F($fbd042e4a49259b8$var$zf[e], a);
                                e = d;
                                break;
                            case "source":
                                $fbd042e4a49259b8$var$F("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $fbd042e4a49259b8$var$F("error", a);
                                $fbd042e4a49259b8$var$F("load", a);
                                e = d;
                                break;
                            case "details":
                                $fbd042e4a49259b8$var$F("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $fbd042e4a49259b8$var$Za(a, d);
                                e = $fbd042e4a49259b8$var$Ya(a, d);
                                $fbd042e4a49259b8$var$F("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $fbd042e4a49259b8$var$u({}, d, {
                                    value: void 0
                                });
                                $fbd042e4a49259b8$var$F("invalid", a);
                                break;
                            case "textarea":
                                $fbd042e4a49259b8$var$gb(a, d);
                                e = $fbd042e4a49259b8$var$fb(a, d);
                                $fbd042e4a49259b8$var$F("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $fbd042e4a49259b8$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $fbd042e4a49259b8$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $fbd042e4a49259b8$var$mb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $fbd042e4a49259b8$var$nb(a, k) : "number" === typeof k && $fbd042e4a49259b8$var$nb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($fbd042e4a49259b8$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $fbd042e4a49259b8$var$F("scroll", a) : null != k && $fbd042e4a49259b8$var$ua(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $fbd042e4a49259b8$var$Va(a);
                                $fbd042e4a49259b8$var$cb(a, d, !1);
                                break;
                            case "textarea":
                                $fbd042e4a49259b8$var$Va(a);
                                $fbd042e4a49259b8$var$ib(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $fbd042e4a49259b8$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $fbd042e4a49259b8$var$eb(a, !!d.multiple, f, !1) : null != d.defaultValue && $fbd042e4a49259b8$var$eb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $fbd042e4a49259b8$var$Pf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $fbd042e4a49259b8$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $fbd042e4a49259b8$var$jk(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($fbd042e4a49259b8$var$p(166));
                a = $fbd042e4a49259b8$var$Wh($fbd042e4a49259b8$var$Vh.current);
                $fbd042e4a49259b8$var$Wh($fbd042e4a49259b8$var$Th.current);
                if ($fbd042e4a49259b8$var$Ug(b)) {
                    d = b.stateNode;
                    a = b.memoizedProps;
                    d[$fbd042e4a49259b8$var$bg] = b;
                    if (c = d.nodeValue !== a) {
                        if (f = $fbd042e4a49259b8$var$Lg, null !== f) switch(f.tag){
                            case 3:
                                $fbd042e4a49259b8$var$Of(d.nodeValue, a, 0 !== (f.mode & 1));
                                break;
                            case 5:
                                !0 !== f.memoizedProps.suppressHydrationWarning && $fbd042e4a49259b8$var$Of(d.nodeValue, a, 0 !== (f.mode & 1));
                        }
                    }
                    c && (b.flags |= 4);
                } else d = (9 === a.nodeType ? a : a.ownerDocument).createTextNode(d), d[$fbd042e4a49259b8$var$bg] = b, b.stateNode = d;
            }
            $fbd042e4a49259b8$var$S(b);
            return null;
        case 13:
            $fbd042e4a49259b8$var$G($fbd042e4a49259b8$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($fbd042e4a49259b8$var$J && null !== $fbd042e4a49259b8$var$Mg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $fbd042e4a49259b8$var$Vg(), $fbd042e4a49259b8$var$Wg(), b.flags |= 98560, f = !1;
                else if (f = $fbd042e4a49259b8$var$Ug(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($fbd042e4a49259b8$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($fbd042e4a49259b8$var$p(317));
                        f[$fbd042e4a49259b8$var$bg] = b;
                        $fbd042e4a49259b8$var$S(b);
                        0 !== (b.mode & 2) && null !== d && (f = b.child, null !== f && (b.treeBaseDuration -= f.treeBaseDuration));
                    } else $fbd042e4a49259b8$var$Wg(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4, $fbd042e4a49259b8$var$S(b), 0 !== (b.mode & 2) && null !== d && (f = b.child, null !== f && (b.treeBaseDuration -= f.treeBaseDuration));
                    f = !1;
                } else null !== $fbd042e4a49259b8$var$Ng && ($fbd042e4a49259b8$var$mk($fbd042e4a49259b8$var$Ng), $fbd042e4a49259b8$var$Ng = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, 0 !== (b.mode & 2) && $fbd042e4a49259b8$var$lj(b), b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($fbd042e4a49259b8$var$L.current & 1) ? 0 === $fbd042e4a49259b8$var$T && ($fbd042e4a49259b8$var$T = 3) : $fbd042e4a49259b8$var$ak()));
            null !== b.updateQueue && (b.flags |= 4);
            $fbd042e4a49259b8$var$S(b);
            0 !== (b.mode & 2) && d && (d = b.child, null !== d && (b.treeBaseDuration -= d.treeBaseDuration));
            return null;
        case 4:
            return $fbd042e4a49259b8$var$Yh(), $fbd042e4a49259b8$var$hk(a, b), null === a && $fbd042e4a49259b8$var$Gf(b.stateNode.containerInfo), $fbd042e4a49259b8$var$S(b), null;
        case 10:
            return $fbd042e4a49259b8$var$eh(b.type._context), $fbd042e4a49259b8$var$S(b), null;
        case 17:
            return $fbd042e4a49259b8$var$mg(b.type) && $fbd042e4a49259b8$var$ng(), $fbd042e4a49259b8$var$S(b), null;
        case 19:
            $fbd042e4a49259b8$var$G($fbd042e4a49259b8$var$L);
            f = b.memoizedState;
            if (null === f) return $fbd042e4a49259b8$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $fbd042e4a49259b8$var$kk(f, !1);
                else {
                    if (0 !== $fbd042e4a49259b8$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $fbd042e4a49259b8$var$ai(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $fbd042e4a49259b8$var$kk(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(a = b.child; null !== a;)c = a, g = d, c.flags &= 14680066, f = c.alternate, null === f ? (c.childLanes = 0, c.lanes = g, c.child = null, c.subtreeFlags = 0, c.memoizedProps = null, c.memoizedState = null, c.updateQueue = null, c.dependencies = null, c.stateNode = null, c.selfBaseDuration = 0, c.treeBaseDuration = 0) : (c.childLanes = f.childLanes, c.lanes = f.lanes, c.child = f.child, c.subtreeFlags = 0, c.deletions = null, c.memoizedProps = f.memoizedProps, c.memoizedState = f.memoizedState, c.updateQueue = f.updateQueue, c.type = f.type, g = f.dependencies, c.dependencies = null === g ? null : {
                                lanes: g.lanes,
                                firstContext: g.firstContext
                            }, c.selfBaseDuration = f.selfBaseDuration, c.treeBaseDuration = f.treeBaseDuration), a = a.sibling;
                            $fbd042e4a49259b8$var$H($fbd042e4a49259b8$var$L, $fbd042e4a49259b8$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $fbd042e4a49259b8$var$A() > $fbd042e4a49259b8$var$nk && (b.flags |= 128, d = !0, $fbd042e4a49259b8$var$kk(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $fbd042e4a49259b8$var$ai(g), null !== a) {
                        if (b.flags |= 128, d = !0, a = a.updateQueue, null !== a && (b.updateQueue = a, b.flags |= 4), $fbd042e4a49259b8$var$kk(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$fbd042e4a49259b8$var$J) return $fbd042e4a49259b8$var$S(b), null;
                    } else 2 * $fbd042e4a49259b8$var$A() - f.renderingStartTime > $fbd042e4a49259b8$var$nk && 1073741824 !== c && (b.flags |= 128, d = !0, $fbd042e4a49259b8$var$kk(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (a = f.last, null !== a ? a.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $fbd042e4a49259b8$var$A(), b.sibling = null, a = $fbd042e4a49259b8$var$L.current, $fbd042e4a49259b8$var$H($fbd042e4a49259b8$var$L, d ? a & 1 | 2 : a & 1), b;
            $fbd042e4a49259b8$var$S(b);
            return null;
        case 22:
        case 23:
            return $fbd042e4a49259b8$var$ok(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($fbd042e4a49259b8$var$Kj & 1073741824) && ($fbd042e4a49259b8$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $fbd042e4a49259b8$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($fbd042e4a49259b8$var$p(156, b.tag));
}
function $fbd042e4a49259b8$var$pk(a, b) {
    $fbd042e4a49259b8$var$Kg(b);
    switch(b.tag){
        case 1:
            return $fbd042e4a49259b8$var$mg(b.type) && $fbd042e4a49259b8$var$ng(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, 0 !== (b.mode & 2) && $fbd042e4a49259b8$var$lj(b), b) : null;
        case 3:
            return $fbd042e4a49259b8$var$Yh(), $fbd042e4a49259b8$var$G($fbd042e4a49259b8$var$jg), $fbd042e4a49259b8$var$G($fbd042e4a49259b8$var$I), $fbd042e4a49259b8$var$ci(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $fbd042e4a49259b8$var$$h(b), null;
        case 13:
            $fbd042e4a49259b8$var$G($fbd042e4a49259b8$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($fbd042e4a49259b8$var$p(340));
                $fbd042e4a49259b8$var$Wg();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, 0 !== (b.mode & 2) && $fbd042e4a49259b8$var$lj(b), b) : null;
        case 19:
            return $fbd042e4a49259b8$var$G($fbd042e4a49259b8$var$L), null;
        case 4:
            return $fbd042e4a49259b8$var$Yh(), null;
        case 10:
            return $fbd042e4a49259b8$var$eh(b.type._context), null;
        case 22:
        case 23:
            return $fbd042e4a49259b8$var$ok(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $fbd042e4a49259b8$var$qk = !1, $fbd042e4a49259b8$var$rk = !1, $fbd042e4a49259b8$var$sk = "function" === typeof WeakSet ? WeakSet : Set, $fbd042e4a49259b8$var$U = null, $fbd042e4a49259b8$var$tk = null, $fbd042e4a49259b8$var$uk = null;
function $fbd042e4a49259b8$var$vk(a, b) {
    b.props = a.memoizedProps;
    b.state = a.memoizedState;
    if (a.mode & 2) try {
        $fbd042e4a49259b8$var$kj(), b.componentWillUnmount();
    } finally{
        $fbd042e4a49259b8$var$ij(a);
    }
    else b.componentWillUnmount();
}
function $fbd042e4a49259b8$var$wk(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            if (a.mode & 2) try {
                $fbd042e4a49259b8$var$kj(), c(null);
            } finally{
                $fbd042e4a49259b8$var$ij(a);
            }
            else c(null);
        } catch (d) {
            $fbd042e4a49259b8$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $fbd042e4a49259b8$var$xk(a, b, c) {
    try {
        c();
    } catch (d) {
        $fbd042e4a49259b8$var$W(a, b, d);
    }
}
var $fbd042e4a49259b8$var$yk = !1;
function $fbd042e4a49259b8$var$zk(a, b) {
    $fbd042e4a49259b8$var$Qf = $fbd042e4a49259b8$var$rd;
    a = $fbd042e4a49259b8$var$$e();
    if ($fbd042e4a49259b8$var$af(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (D) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, n = 0, q = a, r = null;
                b: for(;;){
                    for(var z;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (z = q.firstChild)) break;
                        r = q;
                        q = z;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++n === d && (k = g);
                        if (null !== (z = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = z;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $fbd042e4a49259b8$var$Rf = {
        focusedElem: a,
        selectionRange: c
    };
    $fbd042e4a49259b8$var$rd = !1;
    for($fbd042e4a49259b8$var$U = b; null !== $fbd042e4a49259b8$var$U;)if (b = $fbd042e4a49259b8$var$U, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $fbd042e4a49259b8$var$U = a;
    else for(; null !== $fbd042e4a49259b8$var$U;){
        b = $fbd042e4a49259b8$var$U;
        try {
            var m = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== m) {
                        var w = m.memoizedProps, C = m.memoizedState, x = b.stateNode, y = x.getSnapshotBeforeUpdate(b.elementType === b.type ? w : $fbd042e4a49259b8$var$Zg(b.type, w), C);
                        x.__reactInternalSnapshotBeforeUpdate = y;
                    }
                    break;
                case 3:
                    var v = b.stateNode.containerInfo;
                    1 === v.nodeType ? v.textContent = "" : 9 === v.nodeType && v.documentElement && v.removeChild(v.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($fbd042e4a49259b8$var$p(163));
            }
        } catch (D) {
            $fbd042e4a49259b8$var$W(b, b.return, D);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $fbd042e4a49259b8$var$U = a;
            break;
        }
        $fbd042e4a49259b8$var$U = b.return;
    }
    m = $fbd042e4a49259b8$var$yk;
    $fbd042e4a49259b8$var$yk = !1;
    return m;
}
function $fbd042e4a49259b8$var$Ak(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && (0 !== (a & 8) ? null !== $fbd042e4a49259b8$var$B && "function" === typeof $fbd042e4a49259b8$var$B.markComponentPassiveEffectUnmountStarted && $fbd042e4a49259b8$var$B.markComponentPassiveEffectUnmountStarted(b) : 0 !== (a & 4) && $fbd042e4a49259b8$var$uc(b), $fbd042e4a49259b8$var$xk(b, c, f), 0 !== (a & 8) ? null !== $fbd042e4a49259b8$var$B && "function" === typeof $fbd042e4a49259b8$var$B.markComponentPassiveEffectUnmountStopped && $fbd042e4a49259b8$var$B.markComponentPassiveEffectUnmountStopped() : 0 !== (a & 4) && $fbd042e4a49259b8$var$vc());
            }
            e = e.next;
        }while (e !== d);
    }
}
function $fbd042e4a49259b8$var$Bk(a, b) {
    var c = b.updateQueue;
    c = null !== c ? c.lastEffect : null;
    if (null !== c) {
        var d = c = c.next;
        do {
            if ((d.tag & a) === a) {
                0 !== (a & 8) ? null !== $fbd042e4a49259b8$var$B && "function" === typeof $fbd042e4a49259b8$var$B.markComponentPassiveEffectMountStarted && $fbd042e4a49259b8$var$B.markComponentPassiveEffectMountStarted(b) : 0 !== (a & 4) && null !== $fbd042e4a49259b8$var$B && "function" === typeof $fbd042e4a49259b8$var$B.markComponentLayoutEffectMountStarted && $fbd042e4a49259b8$var$B.markComponentLayoutEffectMountStarted(b);
                var e = d.create;
                d.destroy = e();
                0 !== (a & 8) ? null !== $fbd042e4a49259b8$var$B && "function" === typeof $fbd042e4a49259b8$var$B.markComponentPassiveEffectMountStopped && $fbd042e4a49259b8$var$B.markComponentPassiveEffectMountStopped() : 0 !== (a & 4) && null !== $fbd042e4a49259b8$var$B && "function" === typeof $fbd042e4a49259b8$var$B.markComponentLayoutEffectMountStopped && $fbd042e4a49259b8$var$B.markComponentLayoutEffectMountStopped();
            }
            d = d.next;
        }while (d !== c);
    }
}
function $fbd042e4a49259b8$var$Ck(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        if ("function" === typeof b) {
            if (a.mode & 2) try {
                $fbd042e4a49259b8$var$kj(), b(c);
            } finally{
                $fbd042e4a49259b8$var$ij(a);
            }
            else b(c);
        } else b.current = c;
    }
}
function $fbd042e4a49259b8$var$Dk(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $fbd042e4a49259b8$var$Dk(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$fbd042e4a49259b8$var$bg], delete b[$fbd042e4a49259b8$var$cg], delete b[$fbd042e4a49259b8$var$Cf], delete b[$fbd042e4a49259b8$var$dg], delete b[$fbd042e4a49259b8$var$eg]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $fbd042e4a49259b8$var$Ek(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $fbd042e4a49259b8$var$Fk(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $fbd042e4a49259b8$var$Ek(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $fbd042e4a49259b8$var$Gk(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $fbd042e4a49259b8$var$Pf));
    else if (4 !== d && (a = a.child, null !== a)) for($fbd042e4a49259b8$var$Gk(a, b, c), a = a.sibling; null !== a;)$fbd042e4a49259b8$var$Gk(a, b, c), a = a.sibling;
}
function $fbd042e4a49259b8$var$Hk(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($fbd042e4a49259b8$var$Hk(a, b, c), a = a.sibling; null !== a;)$fbd042e4a49259b8$var$Hk(a, b, c), a = a.sibling;
}
var $fbd042e4a49259b8$var$X = null, $fbd042e4a49259b8$var$Ik = !1;
function $fbd042e4a49259b8$var$Jk(a, b, c) {
    for(c = c.child; null !== c;)$fbd042e4a49259b8$var$Kk(a, b, c), c = c.sibling;
}
function $fbd042e4a49259b8$var$Kk(a, b, c) {
    if ($fbd042e4a49259b8$var$lc && "function" === typeof $fbd042e4a49259b8$var$lc.onCommitFiberUnmount) try {
        $fbd042e4a49259b8$var$lc.onCommitFiberUnmount($fbd042e4a49259b8$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $fbd042e4a49259b8$var$rk || $fbd042e4a49259b8$var$wk(c, b);
        case 6:
            var d = $fbd042e4a49259b8$var$X, e = $fbd042e4a49259b8$var$Ik;
            $fbd042e4a49259b8$var$X = null;
            $fbd042e4a49259b8$var$Jk(a, b, c);
            $fbd042e4a49259b8$var$X = d;
            $fbd042e4a49259b8$var$Ik = e;
            null !== $fbd042e4a49259b8$var$X && ($fbd042e4a49259b8$var$Ik ? (a = $fbd042e4a49259b8$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $fbd042e4a49259b8$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $fbd042e4a49259b8$var$X && ($fbd042e4a49259b8$var$Ik ? (a = $fbd042e4a49259b8$var$X, c = c.stateNode, 8 === a.nodeType ? $fbd042e4a49259b8$var$Yf(a.parentNode, c) : 1 === a.nodeType && $fbd042e4a49259b8$var$Yf(a, c), $fbd042e4a49259b8$var$pd(a)) : $fbd042e4a49259b8$var$Yf($fbd042e4a49259b8$var$X, c.stateNode));
            break;
        case 4:
            d = $fbd042e4a49259b8$var$X;
            e = $fbd042e4a49259b8$var$Ik;
            $fbd042e4a49259b8$var$X = c.stateNode.containerInfo;
            $fbd042e4a49259b8$var$Ik = !0;
            $fbd042e4a49259b8$var$Jk(a, b, c);
            $fbd042e4a49259b8$var$X = d;
            $fbd042e4a49259b8$var$Ik = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$fbd042e4a49259b8$var$rk && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $fbd042e4a49259b8$var$xk(c, b, g) : 0 !== (f & 4) && ($fbd042e4a49259b8$var$uc(c), c.mode & 2 ? ($fbd042e4a49259b8$var$kj(), $fbd042e4a49259b8$var$xk(c, b, g), $fbd042e4a49259b8$var$ij(c)) : $fbd042e4a49259b8$var$xk(c, b, g), $fbd042e4a49259b8$var$vc()));
                    e = e.next;
                }while (e !== d);
            }
            $fbd042e4a49259b8$var$Jk(a, b, c);
            break;
        case 1:
            if (!$fbd042e4a49259b8$var$rk && ($fbd042e4a49259b8$var$wk(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                $fbd042e4a49259b8$var$vk(c, d);
            } catch (h) {
                $fbd042e4a49259b8$var$W(c, b, h);
            }
            $fbd042e4a49259b8$var$Jk(a, b, c);
            break;
        case 21:
            $fbd042e4a49259b8$var$Jk(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($fbd042e4a49259b8$var$rk = (d = $fbd042e4a49259b8$var$rk) || null !== c.memoizedState, $fbd042e4a49259b8$var$Jk(a, b, c), $fbd042e4a49259b8$var$rk = d) : $fbd042e4a49259b8$var$Jk(a, b, c);
            break;
        default:
            $fbd042e4a49259b8$var$Jk(a, b, c);
    }
}
function $fbd042e4a49259b8$var$Lk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $fbd042e4a49259b8$var$sk);
        b.forEach(function(b) {
            var d = $fbd042e4a49259b8$var$Mk.bind(null, a, b);
            if (!c.has(b)) {
                c.add(b);
                if ($fbd042e4a49259b8$var$mc) {
                    if (null !== $fbd042e4a49259b8$var$tk && null !== $fbd042e4a49259b8$var$uk) $fbd042e4a49259b8$var$xj($fbd042e4a49259b8$var$uk, $fbd042e4a49259b8$var$tk);
                    else throw Error($fbd042e4a49259b8$var$p(413));
                }
                b.then(d, d);
            }
        });
    }
}
function $fbd042e4a49259b8$var$Nk(a, b, c) {
    $fbd042e4a49259b8$var$tk = c;
    $fbd042e4a49259b8$var$uk = a;
    $fbd042e4a49259b8$var$Ok(b, a);
    $fbd042e4a49259b8$var$uk = $fbd042e4a49259b8$var$tk = null;
}
function $fbd042e4a49259b8$var$Pk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $fbd042e4a49259b8$var$X = h.stateNode;
                        $fbd042e4a49259b8$var$Ik = !1;
                        break a;
                    case 3:
                        $fbd042e4a49259b8$var$X = h.stateNode.containerInfo;
                        $fbd042e4a49259b8$var$Ik = !0;
                        break a;
                    case 4:
                        $fbd042e4a49259b8$var$X = h.stateNode.containerInfo;
                        $fbd042e4a49259b8$var$Ik = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $fbd042e4a49259b8$var$X) throw Error($fbd042e4a49259b8$var$p(160));
            $fbd042e4a49259b8$var$Kk(f, g, e);
            $fbd042e4a49259b8$var$X = null;
            $fbd042e4a49259b8$var$Ik = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $fbd042e4a49259b8$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$fbd042e4a49259b8$var$Ok(b, a), b = b.sibling;
}
function $fbd042e4a49259b8$var$Ok(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $fbd042e4a49259b8$var$Pk(b, a);
            $fbd042e4a49259b8$var$Qk(a);
            if (d & 4) {
                try {
                    $fbd042e4a49259b8$var$Ak(3, a, a.return), $fbd042e4a49259b8$var$Bk(3, a);
                } catch (m) {
                    $fbd042e4a49259b8$var$W(a, a.return, m);
                }
                if (a.mode & 2) {
                    try {
                        $fbd042e4a49259b8$var$kj(), $fbd042e4a49259b8$var$Ak(5, a, a.return);
                    } catch (m) {
                        $fbd042e4a49259b8$var$W(a, a.return, m);
                    }
                    $fbd042e4a49259b8$var$ij(a);
                } else try {
                    $fbd042e4a49259b8$var$Ak(5, a, a.return);
                } catch (m) {
                    $fbd042e4a49259b8$var$W(a, a.return, m);
                }
            }
            break;
        case 1:
            $fbd042e4a49259b8$var$Pk(b, a);
            $fbd042e4a49259b8$var$Qk(a);
            d & 512 && null !== c && $fbd042e4a49259b8$var$wk(c, c.return);
            break;
        case 5:
            $fbd042e4a49259b8$var$Pk(b, a);
            $fbd042e4a49259b8$var$Qk(a);
            d & 512 && null !== c && $fbd042e4a49259b8$var$wk(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $fbd042e4a49259b8$var$nb(e, "");
                } catch (m) {
                    $fbd042e4a49259b8$var$W(a, a.return, m);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $fbd042e4a49259b8$var$$a(e, f);
                    $fbd042e4a49259b8$var$vb(h, g);
                    var l = $fbd042e4a49259b8$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var n = k[g], q = k[g + 1];
                        "style" === n ? $fbd042e4a49259b8$var$sb(e, q) : "dangerouslySetInnerHTML" === n ? $fbd042e4a49259b8$var$mb(e, q) : "children" === n ? $fbd042e4a49259b8$var$nb(e, q) : $fbd042e4a49259b8$var$ua(e, n, q, l);
                    }
                    switch(h){
                        case "input":
                            $fbd042e4a49259b8$var$ab(e, f);
                            break;
                        case "textarea":
                            $fbd042e4a49259b8$var$hb(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var z = f.value;
                            null != z ? $fbd042e4a49259b8$var$eb(e, !!f.multiple, z, !1) : r !== !!f.multiple && (null != f.defaultValue ? $fbd042e4a49259b8$var$eb(e, !!f.multiple, f.defaultValue, !0) : $fbd042e4a49259b8$var$eb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$fbd042e4a49259b8$var$cg] = f;
                } catch (m) {
                    $fbd042e4a49259b8$var$W(a, a.return, m);
                }
            }
            break;
        case 6:
            $fbd042e4a49259b8$var$Pk(b, a);
            $fbd042e4a49259b8$var$Qk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($fbd042e4a49259b8$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (m) {
                    $fbd042e4a49259b8$var$W(a, a.return, m);
                }
            }
            break;
        case 3:
            $fbd042e4a49259b8$var$Pk(b, a);
            $fbd042e4a49259b8$var$Qk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $fbd042e4a49259b8$var$pd(b.containerInfo);
            } catch (m) {
                $fbd042e4a49259b8$var$W(a, a.return, m);
            }
            break;
        case 4:
            $fbd042e4a49259b8$var$Pk(b, a);
            $fbd042e4a49259b8$var$Qk(a);
            break;
        case 13:
            $fbd042e4a49259b8$var$Pk(b, a);
            $fbd042e4a49259b8$var$Qk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($fbd042e4a49259b8$var$Rk = $fbd042e4a49259b8$var$A()));
            d & 4 && $fbd042e4a49259b8$var$Lk(a);
            break;
        case 22:
            n = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($fbd042e4a49259b8$var$rk = (l = $fbd042e4a49259b8$var$rk) || n, $fbd042e4a49259b8$var$Pk(b, a), $fbd042e4a49259b8$var$rk = l) : $fbd042e4a49259b8$var$Pk(b, a);
            $fbd042e4a49259b8$var$Qk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !n && 0 !== (a.mode & 1)) for($fbd042e4a49259b8$var$U = a, n = a.child; null !== n;){
                    for(q = $fbd042e4a49259b8$var$U = n; null !== $fbd042e4a49259b8$var$U;){
                        r = $fbd042e4a49259b8$var$U;
                        z = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                if (r.mode & 2) try {
                                    $fbd042e4a49259b8$var$kj(), $fbd042e4a49259b8$var$Ak(4, r, r.return);
                                } finally{
                                    $fbd042e4a49259b8$var$ij(r);
                                }
                                else $fbd042e4a49259b8$var$Ak(4, r, r.return);
                                break;
                            case 1:
                                $fbd042e4a49259b8$var$wk(r, r.return);
                                d = r.stateNode;
                                if ("function" === typeof d.componentWillUnmount) {
                                    c = r;
                                    b = r.return;
                                    try {
                                        $fbd042e4a49259b8$var$vk(c, d);
                                    } catch (m) {
                                        $fbd042e4a49259b8$var$W(c, b, m);
                                    }
                                }
                                break;
                            case 5:
                                $fbd042e4a49259b8$var$wk(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $fbd042e4a49259b8$var$Sk(q);
                                    continue;
                                }
                        }
                        null !== z ? (z.return = r, $fbd042e4a49259b8$var$U = z) : $fbd042e4a49259b8$var$Sk(q);
                    }
                    n = n.sibling;
                }
                a: for(n = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === n) {
                            n = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $fbd042e4a49259b8$var$rb("display", g));
                            } catch (m) {
                                $fbd042e4a49259b8$var$W(a, a.return, m);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === n) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (m) {
                            $fbd042e4a49259b8$var$W(a, a.return, m);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        n === q && (n = null);
                        q = q.return;
                    }
                    n === q && (n = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $fbd042e4a49259b8$var$Pk(b, a);
            $fbd042e4a49259b8$var$Qk(a);
            d & 4 && $fbd042e4a49259b8$var$Lk(a);
            break;
        case 21:
            break;
        default:
            $fbd042e4a49259b8$var$Pk(b, a), $fbd042e4a49259b8$var$Qk(a);
    }
}
function $fbd042e4a49259b8$var$Qk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($fbd042e4a49259b8$var$Ek(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($fbd042e4a49259b8$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($fbd042e4a49259b8$var$nb(e, ""), d.flags &= -33);
                    var f = $fbd042e4a49259b8$var$Fk(a);
                    $fbd042e4a49259b8$var$Hk(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $fbd042e4a49259b8$var$Fk(a);
                    $fbd042e4a49259b8$var$Gk(a, h, g);
                    break;
                default:
                    throw Error($fbd042e4a49259b8$var$p(161));
            }
        } catch (k) {
            $fbd042e4a49259b8$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $fbd042e4a49259b8$var$Tk(a, b, c) {
    $fbd042e4a49259b8$var$tk = c;
    $fbd042e4a49259b8$var$uk = b;
    $fbd042e4a49259b8$var$U = a;
    $fbd042e4a49259b8$var$Uk(a, b, c);
    $fbd042e4a49259b8$var$uk = $fbd042e4a49259b8$var$tk = null;
}
function $fbd042e4a49259b8$var$Uk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $fbd042e4a49259b8$var$U;){
        var e = $fbd042e4a49259b8$var$U, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $fbd042e4a49259b8$var$qk;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $fbd042e4a49259b8$var$rk;
                h = $fbd042e4a49259b8$var$qk;
                var l = $fbd042e4a49259b8$var$rk;
                $fbd042e4a49259b8$var$qk = g;
                if (($fbd042e4a49259b8$var$rk = k) && !l) for($fbd042e4a49259b8$var$U = e; null !== $fbd042e4a49259b8$var$U;)g = $fbd042e4a49259b8$var$U, k = g.child, 22 === g.tag && null !== g.memoizedState ? $fbd042e4a49259b8$var$Vk(e) : null !== k ? (k.return = g, $fbd042e4a49259b8$var$U = k) : $fbd042e4a49259b8$var$Vk(e);
                for(; null !== f;)$fbd042e4a49259b8$var$U = f, $fbd042e4a49259b8$var$Uk(f, b, c), f = f.sibling;
                $fbd042e4a49259b8$var$U = e;
                $fbd042e4a49259b8$var$qk = h;
                $fbd042e4a49259b8$var$rk = l;
            }
            $fbd042e4a49259b8$var$Wk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $fbd042e4a49259b8$var$U = f) : $fbd042e4a49259b8$var$Wk(a, b, c);
    }
}
function $fbd042e4a49259b8$var$Wk(a) {
    for(; null !== $fbd042e4a49259b8$var$U;){
        var b = $fbd042e4a49259b8$var$U;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        if (!$fbd042e4a49259b8$var$rk) {
                            if (b.mode & 2) try {
                                $fbd042e4a49259b8$var$kj(), $fbd042e4a49259b8$var$Bk(5, b);
                            } finally{
                                $fbd042e4a49259b8$var$ij(b);
                            }
                            else $fbd042e4a49259b8$var$Bk(5, b);
                        }
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$fbd042e4a49259b8$var$rk) {
                            if (null === c) {
                                if (b.mode & 2) try {
                                    $fbd042e4a49259b8$var$kj(), d.componentDidMount();
                                } finally{
                                    $fbd042e4a49259b8$var$ij(b);
                                }
                                else d.componentDidMount();
                            } else {
                                var e = b.elementType === b.type ? c.memoizedProps : $fbd042e4a49259b8$var$Zg(b.type, c.memoizedProps), f = c.memoizedState;
                                if (b.mode & 2) try {
                                    $fbd042e4a49259b8$var$kj(), d.componentDidUpdate(e, f, d.__reactInternalSnapshotBeforeUpdate);
                                } finally{
                                    $fbd042e4a49259b8$var$ij(b);
                                }
                                else d.componentDidUpdate(e, f, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var g = b.updateQueue;
                        null !== g && $fbd042e4a49259b8$var$wh(b, g, d);
                        break;
                    case 3:
                        var h = b.updateQueue;
                        if (null !== h) {
                            var k = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    k = b.child.stateNode;
                                    break;
                                case 1:
                                    k = b.child.stateNode;
                            }
                            $fbd042e4a49259b8$var$wh(b, h, k);
                        }
                        break;
                    case 5:
                        var l = b.stateNode;
                        if (null === c && b.flags & 4) {
                            k = l;
                            var n = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    n.autoFocus && k.focus();
                                    break;
                                case "img":
                                    n.src && (k.src = n.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        var q = b.memoizedProps, r = q.onCommit, z = q.onRender, m = b.stateNode.effectDuration;
                        k = $fbd042e4a49259b8$var$bj;
                        c = null === c ? "mount" : "update";
                        $fbd042e4a49259b8$var$fj && (c = "nested-update");
                        "function" === typeof z && z(b.memoizedProps.id, c, b.actualDuration, b.treeBaseDuration, b.actualStartTime, k);
                        "function" === typeof r && r(b.memoizedProps.id, c, m, k);
                        $fbd042e4a49259b8$var$Xk(b);
                        var w = b.return;
                        a: for(; null !== w;){
                            switch(w.tag){
                                case 3:
                                    w.stateNode.effectDuration += m;
                                    break a;
                                case 12:
                                    w.stateNode.effectDuration += m;
                                    break a;
                            }
                            w = w.return;
                        }
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var C = b.alternate;
                            if (null !== C) {
                                var x = C.memoizedState;
                                if (null !== x) {
                                    var y = x.dehydrated;
                                    null !== y && $fbd042e4a49259b8$var$pd(y);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($fbd042e4a49259b8$var$p(163));
                }
                $fbd042e4a49259b8$var$rk || b.flags & 512 && $fbd042e4a49259b8$var$Ck(b);
            } catch (v) {
                $fbd042e4a49259b8$var$W(b, b.return, v);
            }
        }
        if (b === a) {
            $fbd042e4a49259b8$var$U = null;
            break;
        }
        k = b.sibling;
        if (null !== k) {
            k.return = b.return;
            $fbd042e4a49259b8$var$U = k;
            break;
        }
        $fbd042e4a49259b8$var$U = b.return;
    }
}
function $fbd042e4a49259b8$var$Sk(a) {
    for(; null !== $fbd042e4a49259b8$var$U;){
        var b = $fbd042e4a49259b8$var$U;
        if (b === a) {
            $fbd042e4a49259b8$var$U = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $fbd042e4a49259b8$var$U = c;
            break;
        }
        $fbd042e4a49259b8$var$U = b.return;
    }
}
function $fbd042e4a49259b8$var$Vk(a) {
    for(; null !== $fbd042e4a49259b8$var$U;){
        var b = $fbd042e4a49259b8$var$U;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    if (b.mode & 2) try {
                        $fbd042e4a49259b8$var$kj();
                        var c = b.return;
                        try {
                            $fbd042e4a49259b8$var$Bk(4, b);
                        } catch (l) {
                            $fbd042e4a49259b8$var$W(b, c, l);
                        }
                    } finally{
                        $fbd042e4a49259b8$var$ij(b);
                    }
                    else {
                        var d = b.return;
                        try {
                            $fbd042e4a49259b8$var$Bk(4, b);
                        } catch (l) {
                            $fbd042e4a49259b8$var$W(b, d, l);
                        }
                    }
                    break;
                case 1:
                    var e = b.stateNode;
                    if ("function" === typeof e.componentDidMount) {
                        var f = b.return;
                        try {
                            e.componentDidMount();
                        } catch (l) {
                            $fbd042e4a49259b8$var$W(b, f, l);
                        }
                    }
                    var g = b.return;
                    try {
                        $fbd042e4a49259b8$var$Ck(b);
                    } catch (l) {
                        $fbd042e4a49259b8$var$W(b, g, l);
                    }
                    break;
                case 5:
                    var h = b.return;
                    try {
                        $fbd042e4a49259b8$var$Ck(b);
                    } catch (l) {
                        $fbd042e4a49259b8$var$W(b, h, l);
                    }
            }
        } catch (l) {
            $fbd042e4a49259b8$var$W(b, b.return, l);
        }
        if (b === a) {
            $fbd042e4a49259b8$var$U = null;
            break;
        }
        var k = b.sibling;
        if (null !== k) {
            k.return = b.return;
            $fbd042e4a49259b8$var$U = k;
            break;
        }
        $fbd042e4a49259b8$var$U = b.return;
    }
}
var $fbd042e4a49259b8$var$Yk = Math.ceil, $fbd042e4a49259b8$var$Zk = $fbd042e4a49259b8$var$va.ReactCurrentDispatcher, $fbd042e4a49259b8$var$$k = $fbd042e4a49259b8$var$va.ReactCurrentOwner, $fbd042e4a49259b8$var$al = $fbd042e4a49259b8$var$va.ReactCurrentBatchConfig, $fbd042e4a49259b8$var$K = 0, $fbd042e4a49259b8$var$Q = null, $fbd042e4a49259b8$var$Y = null, $fbd042e4a49259b8$var$Z = 0, $fbd042e4a49259b8$var$Kj = 0, $fbd042e4a49259b8$var$Jj = $fbd042e4a49259b8$var$hg(0), $fbd042e4a49259b8$var$T = 0, $fbd042e4a49259b8$var$bl = null, $fbd042e4a49259b8$var$vh = 0, $fbd042e4a49259b8$var$cl = 0, $fbd042e4a49259b8$var$dl = 0, $fbd042e4a49259b8$var$el = null, $fbd042e4a49259b8$var$fl = null, $fbd042e4a49259b8$var$Rk = 0, $fbd042e4a49259b8$var$nk = Infinity, $fbd042e4a49259b8$var$gl = null, $fbd042e4a49259b8$var$rj = !1, $fbd042e4a49259b8$var$sj = null, $fbd042e4a49259b8$var$uj = null, $fbd042e4a49259b8$var$hl = !1, $fbd042e4a49259b8$var$il = null, $fbd042e4a49259b8$var$jl = 0, $fbd042e4a49259b8$var$kl = [], $fbd042e4a49259b8$var$ll = 0, $fbd042e4a49259b8$var$ml = null, $fbd042e4a49259b8$var$nl = -1, $fbd042e4a49259b8$var$ol = 0;
function $fbd042e4a49259b8$var$zh() {
    return 0 !== ($fbd042e4a49259b8$var$K & 6) ? $fbd042e4a49259b8$var$A() : -1 !== $fbd042e4a49259b8$var$nl ? $fbd042e4a49259b8$var$nl : $fbd042e4a49259b8$var$nl = $fbd042e4a49259b8$var$A();
}
function $fbd042e4a49259b8$var$Ah(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($fbd042e4a49259b8$var$K & 2) && 0 !== $fbd042e4a49259b8$var$Z) return $fbd042e4a49259b8$var$Z & -$fbd042e4a49259b8$var$Z;
    if (null !== $fbd042e4a49259b8$var$Yg.transition) return 0 === $fbd042e4a49259b8$var$ol && ($fbd042e4a49259b8$var$ol = $fbd042e4a49259b8$var$Kc()), $fbd042e4a49259b8$var$ol;
    a = $fbd042e4a49259b8$var$E;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $fbd042e4a49259b8$var$xd(a.type);
    return a;
}
function $fbd042e4a49259b8$var$Bh(a, b, c, d) {
    if (50 < $fbd042e4a49259b8$var$ll) throw $fbd042e4a49259b8$var$ll = 0, $fbd042e4a49259b8$var$ml = null, Error($fbd042e4a49259b8$var$p(185));
    $fbd042e4a49259b8$var$Mc(a, c, d);
    if (0 === ($fbd042e4a49259b8$var$K & 2) || a !== $fbd042e4a49259b8$var$Q) $fbd042e4a49259b8$var$mc && $fbd042e4a49259b8$var$Pc(a, b, c), a === $fbd042e4a49259b8$var$Q && (0 === ($fbd042e4a49259b8$var$K & 2) && ($fbd042e4a49259b8$var$cl |= c), 4 === $fbd042e4a49259b8$var$T && $fbd042e4a49259b8$var$pl(a, $fbd042e4a49259b8$var$Z)), $fbd042e4a49259b8$var$ql(a, d), 1 === c && 0 === $fbd042e4a49259b8$var$K && 0 === (b.mode & 1) && ($fbd042e4a49259b8$var$nk = $fbd042e4a49259b8$var$A() + 500, $fbd042e4a49259b8$var$tg && $fbd042e4a49259b8$var$xg());
}
function $fbd042e4a49259b8$var$ql(a, b) {
    var c = a.callbackNode;
    $fbd042e4a49259b8$var$Ic(a, b);
    var d = $fbd042e4a49259b8$var$Gc(a, a === $fbd042e4a49259b8$var$Q ? $fbd042e4a49259b8$var$Z : 0);
    if (0 === d) null !== c && $fbd042e4a49259b8$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $fbd042e4a49259b8$var$bc(c);
        if (1 === b) 0 === a.tag ? $fbd042e4a49259b8$var$wg($fbd042e4a49259b8$var$rl.bind(null, a)) : $fbd042e4a49259b8$var$vg($fbd042e4a49259b8$var$rl.bind(null, a)), $fbd042e4a49259b8$var$Xf(function() {
            0 === ($fbd042e4a49259b8$var$K & 6) && $fbd042e4a49259b8$var$xg();
        }), c = null;
        else {
            switch($fbd042e4a49259b8$var$Rc(d)){
                case 1:
                    c = $fbd042e4a49259b8$var$fc;
                    break;
                case 4:
                    c = $fbd042e4a49259b8$var$gc;
                    break;
                case 16:
                    c = $fbd042e4a49259b8$var$hc;
                    break;
                case 536870912:
                    c = $fbd042e4a49259b8$var$jc;
                    break;
                default:
                    c = $fbd042e4a49259b8$var$hc;
            }
            c = $fbd042e4a49259b8$var$sl(c, $fbd042e4a49259b8$var$tl.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $fbd042e4a49259b8$var$tl(a, b) {
    $fbd042e4a49259b8$var$gj = $fbd042e4a49259b8$var$fj = !1;
    $fbd042e4a49259b8$var$nl = -1;
    $fbd042e4a49259b8$var$ol = 0;
    if (0 !== ($fbd042e4a49259b8$var$K & 6)) throw Error($fbd042e4a49259b8$var$p(327));
    var c = a.callbackNode;
    if ($fbd042e4a49259b8$var$ul() && a.callbackNode !== c) return null;
    var d = $fbd042e4a49259b8$var$Gc(a, a === $fbd042e4a49259b8$var$Q ? $fbd042e4a49259b8$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $fbd042e4a49259b8$var$vl(a, d);
    else {
        b = d;
        var e = $fbd042e4a49259b8$var$K;
        $fbd042e4a49259b8$var$K |= 2;
        var f = $fbd042e4a49259b8$var$wl();
        if ($fbd042e4a49259b8$var$Q !== a || $fbd042e4a49259b8$var$Z !== b) {
            if ($fbd042e4a49259b8$var$mc) {
                var g = a.memoizedUpdaters;
                0 < g.size && ($fbd042e4a49259b8$var$xj(a, $fbd042e4a49259b8$var$Z), g.clear());
                $fbd042e4a49259b8$var$Qc(a, b);
            }
            $fbd042e4a49259b8$var$gl = null;
            $fbd042e4a49259b8$var$nk = $fbd042e4a49259b8$var$A() + 500;
            $fbd042e4a49259b8$var$xl(a, b);
        }
        $fbd042e4a49259b8$var$wc(b);
        for(;;)try {
            $fbd042e4a49259b8$var$yl();
            break;
        } catch (h) {
            $fbd042e4a49259b8$var$zl(a, h);
        }
        $fbd042e4a49259b8$var$dh();
        $fbd042e4a49259b8$var$Zk.current = f;
        $fbd042e4a49259b8$var$K = e;
        null !== $fbd042e4a49259b8$var$Y ? (null !== $fbd042e4a49259b8$var$B && "function" === typeof $fbd042e4a49259b8$var$B.markRenderYielded && $fbd042e4a49259b8$var$B.markRenderYielded(), b = 0) : ($fbd042e4a49259b8$var$xc(), $fbd042e4a49259b8$var$Q = null, $fbd042e4a49259b8$var$Z = 0, b = $fbd042e4a49259b8$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $fbd042e4a49259b8$var$Jc(a), 0 !== e && (d = e, b = $fbd042e4a49259b8$var$Al(a, e)));
        if (1 === b) throw c = $fbd042e4a49259b8$var$bl, $fbd042e4a49259b8$var$xl(a, 0), $fbd042e4a49259b8$var$pl(a, d), $fbd042e4a49259b8$var$ql(a, $fbd042e4a49259b8$var$A()), c;
        if (6 === b) $fbd042e4a49259b8$var$pl(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$fbd042e4a49259b8$var$Bl(e) && (b = $fbd042e4a49259b8$var$vl(a, d), 2 === b && (f = $fbd042e4a49259b8$var$Jc(a), 0 !== f && (d = f, b = $fbd042e4a49259b8$var$Al(a, f))), 1 === b)) throw c = $fbd042e4a49259b8$var$bl, $fbd042e4a49259b8$var$xl(a, 0), $fbd042e4a49259b8$var$pl(a, d), $fbd042e4a49259b8$var$ql(a, $fbd042e4a49259b8$var$A()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($fbd042e4a49259b8$var$p(345));
                case 2:
                    $fbd042e4a49259b8$var$Dl(a, $fbd042e4a49259b8$var$fl, $fbd042e4a49259b8$var$gl);
                    break;
                case 3:
                    $fbd042e4a49259b8$var$pl(a, d);
                    if ((d & 130023424) === d && (b = $fbd042e4a49259b8$var$Rk + 500 - $fbd042e4a49259b8$var$A(), 10 < b)) {
                        if (0 !== $fbd042e4a49259b8$var$Gc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $fbd042e4a49259b8$var$zh();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $fbd042e4a49259b8$var$Tf($fbd042e4a49259b8$var$Dl.bind(null, a, $fbd042e4a49259b8$var$fl, $fbd042e4a49259b8$var$gl), b);
                        break;
                    }
                    $fbd042e4a49259b8$var$Dl(a, $fbd042e4a49259b8$var$fl, $fbd042e4a49259b8$var$gl);
                    break;
                case 4:
                    $fbd042e4a49259b8$var$pl(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;)g = 31 - $fbd042e4a49259b8$var$Ac(d), f = 1 << g, g = b[g], g > e && (e = g), d &= ~f;
                    d = e;
                    d = $fbd042e4a49259b8$var$A() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $fbd042e4a49259b8$var$Yk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $fbd042e4a49259b8$var$Tf($fbd042e4a49259b8$var$Dl.bind(null, a, $fbd042e4a49259b8$var$fl, $fbd042e4a49259b8$var$gl), d);
                        break;
                    }
                    $fbd042e4a49259b8$var$Dl(a, $fbd042e4a49259b8$var$fl, $fbd042e4a49259b8$var$gl);
                    break;
                case 5:
                    $fbd042e4a49259b8$var$Dl(a, $fbd042e4a49259b8$var$fl, $fbd042e4a49259b8$var$gl);
                    break;
                default:
                    throw Error($fbd042e4a49259b8$var$p(329));
            }
        }
    }
    $fbd042e4a49259b8$var$ql(a, $fbd042e4a49259b8$var$A());
    return a.callbackNode === c ? $fbd042e4a49259b8$var$tl.bind(null, a) : null;
}
function $fbd042e4a49259b8$var$Al(a, b) {
    var c = $fbd042e4a49259b8$var$el;
    a.current.memoizedState.isDehydrated && ($fbd042e4a49259b8$var$xl(a, b).flags |= 256);
    a = $fbd042e4a49259b8$var$vl(a, b);
    2 !== a && (b = $fbd042e4a49259b8$var$fl, $fbd042e4a49259b8$var$fl = c, null !== b && $fbd042e4a49259b8$var$mk(b));
    return a;
}
function $fbd042e4a49259b8$var$mk(a) {
    null === $fbd042e4a49259b8$var$fl ? $fbd042e4a49259b8$var$fl = a : $fbd042e4a49259b8$var$fl.push.apply($fbd042e4a49259b8$var$fl, a);
}
function $fbd042e4a49259b8$var$Bl(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$fbd042e4a49259b8$var$Ve(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $fbd042e4a49259b8$var$pl(a, b) {
    b &= ~$fbd042e4a49259b8$var$dl;
    b &= ~$fbd042e4a49259b8$var$cl;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $fbd042e4a49259b8$var$Ac(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $fbd042e4a49259b8$var$rl(a) {
    $fbd042e4a49259b8$var$fj = $fbd042e4a49259b8$var$gj;
    $fbd042e4a49259b8$var$gj = !1;
    if (0 !== ($fbd042e4a49259b8$var$K & 6)) throw Error($fbd042e4a49259b8$var$p(327));
    $fbd042e4a49259b8$var$ul();
    var b = $fbd042e4a49259b8$var$Gc(a, 0);
    if (0 === (b & 1)) return $fbd042e4a49259b8$var$ql(a, $fbd042e4a49259b8$var$A()), null;
    var c = $fbd042e4a49259b8$var$vl(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $fbd042e4a49259b8$var$Jc(a);
        0 !== d && (b = d, c = $fbd042e4a49259b8$var$Al(a, d));
    }
    if (1 === c) throw c = $fbd042e4a49259b8$var$bl, $fbd042e4a49259b8$var$xl(a, 0), $fbd042e4a49259b8$var$pl(a, b), $fbd042e4a49259b8$var$ql(a, $fbd042e4a49259b8$var$A()), c;
    if (6 === c) throw Error($fbd042e4a49259b8$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $fbd042e4a49259b8$var$Dl(a, $fbd042e4a49259b8$var$fl, $fbd042e4a49259b8$var$gl);
    $fbd042e4a49259b8$var$ql(a, $fbd042e4a49259b8$var$A());
    return null;
}
function $fbd042e4a49259b8$var$El(a, b) {
    var c = $fbd042e4a49259b8$var$K;
    $fbd042e4a49259b8$var$K |= 1;
    try {
        return a(b);
    } finally{
        $fbd042e4a49259b8$var$K = c, 0 === $fbd042e4a49259b8$var$K && ($fbd042e4a49259b8$var$nk = $fbd042e4a49259b8$var$A() + 500, $fbd042e4a49259b8$var$tg && $fbd042e4a49259b8$var$xg());
    }
}
function $fbd042e4a49259b8$var$Fl(a) {
    null !== $fbd042e4a49259b8$var$il && 0 === $fbd042e4a49259b8$var$il.tag && 0 === ($fbd042e4a49259b8$var$K & 6) && $fbd042e4a49259b8$var$ul();
    var b = $fbd042e4a49259b8$var$K;
    $fbd042e4a49259b8$var$K |= 1;
    var c = $fbd042e4a49259b8$var$al.transition, d = $fbd042e4a49259b8$var$E;
    try {
        if ($fbd042e4a49259b8$var$al.transition = null, $fbd042e4a49259b8$var$E = 1, a) return a();
    } finally{
        $fbd042e4a49259b8$var$E = d, $fbd042e4a49259b8$var$al.transition = c, $fbd042e4a49259b8$var$K = b, 0 === ($fbd042e4a49259b8$var$K & 6) && $fbd042e4a49259b8$var$xg();
    }
}
function $fbd042e4a49259b8$var$ok() {
    $fbd042e4a49259b8$var$Kj = $fbd042e4a49259b8$var$Jj.current;
    $fbd042e4a49259b8$var$G($fbd042e4a49259b8$var$Jj);
}
function $fbd042e4a49259b8$var$xl(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $fbd042e4a49259b8$var$Uf(c));
    if (null !== $fbd042e4a49259b8$var$Y) for(c = $fbd042e4a49259b8$var$Y.return; null !== c;){
        var d = c;
        $fbd042e4a49259b8$var$Kg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $fbd042e4a49259b8$var$ng();
                break;
            case 3:
                $fbd042e4a49259b8$var$Yh();
                $fbd042e4a49259b8$var$G($fbd042e4a49259b8$var$jg);
                $fbd042e4a49259b8$var$G($fbd042e4a49259b8$var$I);
                $fbd042e4a49259b8$var$ci();
                break;
            case 5:
                $fbd042e4a49259b8$var$$h(d);
                break;
            case 4:
                $fbd042e4a49259b8$var$Yh();
                break;
            case 13:
                $fbd042e4a49259b8$var$G($fbd042e4a49259b8$var$L);
                break;
            case 19:
                $fbd042e4a49259b8$var$G($fbd042e4a49259b8$var$L);
                break;
            case 10:
                $fbd042e4a49259b8$var$eh(d.type._context);
                break;
            case 22:
            case 23:
                $fbd042e4a49259b8$var$ok();
        }
        c = c.return;
    }
    $fbd042e4a49259b8$var$Q = a;
    $fbd042e4a49259b8$var$Y = a = $fbd042e4a49259b8$var$Lh(a.current, null);
    $fbd042e4a49259b8$var$Z = $fbd042e4a49259b8$var$Kj = b;
    $fbd042e4a49259b8$var$T = 0;
    $fbd042e4a49259b8$var$bl = null;
    $fbd042e4a49259b8$var$dl = $fbd042e4a49259b8$var$cl = $fbd042e4a49259b8$var$vh = 0;
    $fbd042e4a49259b8$var$fl = $fbd042e4a49259b8$var$el = null;
    if (null !== $fbd042e4a49259b8$var$jh) {
        for(b = 0; b < $fbd042e4a49259b8$var$jh.length; b++)if (c = $fbd042e4a49259b8$var$jh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $fbd042e4a49259b8$var$jh = null;
    }
    return a;
}
function $fbd042e4a49259b8$var$zl(a, b) {
    do {
        var c = $fbd042e4a49259b8$var$Y;
        try {
            $fbd042e4a49259b8$var$dh();
            $fbd042e4a49259b8$var$di.current = $fbd042e4a49259b8$var$pi;
            if ($fbd042e4a49259b8$var$gi) {
                for(var d = $fbd042e4a49259b8$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $fbd042e4a49259b8$var$gi = !1;
            }
            $fbd042e4a49259b8$var$fi = 0;
            $fbd042e4a49259b8$var$O = $fbd042e4a49259b8$var$N = $fbd042e4a49259b8$var$M = null;
            $fbd042e4a49259b8$var$hi = !1;
            $fbd042e4a49259b8$var$ii = 0;
            $fbd042e4a49259b8$var$$k.current = null;
            if (null === c || null === c.return) {
                $fbd042e4a49259b8$var$T = 1;
                $fbd042e4a49259b8$var$bl = b;
                $fbd042e4a49259b8$var$Y = null;
                break;
            }
            c.mode & 2 && $fbd042e4a49259b8$var$hj(c, !0);
            $fbd042e4a49259b8$var$tc();
            if (null !== b && "object" === typeof b && "function" === typeof b.then) {
                var f = b;
                null !== $fbd042e4a49259b8$var$B && "function" === typeof $fbd042e4a49259b8$var$B.markComponentSuspended && $fbd042e4a49259b8$var$B.markComponentSuspended(c, f, $fbd042e4a49259b8$var$Z);
            } else null !== $fbd042e4a49259b8$var$B && "function" === typeof $fbd042e4a49259b8$var$B.markComponentErrored && $fbd042e4a49259b8$var$B.markComponentErrored(c, b, $fbd042e4a49259b8$var$Z);
            a: {
                var g = a, h = c.return, k = c;
                f = b;
                b = $fbd042e4a49259b8$var$Z;
                k.flags |= 32768;
                $fbd042e4a49259b8$var$mc && $fbd042e4a49259b8$var$xj(g, b);
                if (null !== f && "object" === typeof f && "function" === typeof f.then) {
                    var l = f, n = k, q = n.tag;
                    if (0 === (n.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = n.alternate;
                        r ? (n.updateQueue = r.updateQueue, n.memoizedState = r.memoizedState, n.lanes = r.lanes) : (n.updateQueue = null, n.memoizedState = null);
                    }
                    var z = $fbd042e4a49259b8$var$yj(h);
                    if (null !== z) {
                        z.flags &= -257;
                        $fbd042e4a49259b8$var$zj(z, h, k, g, b);
                        z.mode & 1 && $fbd042e4a49259b8$var$vj(g, l, b);
                        b = z;
                        f = l;
                        var m = b.updateQueue;
                        if (null === m) {
                            var w = new Set;
                            w.add(f);
                            b.updateQueue = w;
                        } else m.add(f);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $fbd042e4a49259b8$var$vj(g, l, b);
                            $fbd042e4a49259b8$var$ak();
                            break a;
                        }
                        f = Error($fbd042e4a49259b8$var$p(426));
                    }
                } else if ($fbd042e4a49259b8$var$J && k.mode & 1) {
                    var C = $fbd042e4a49259b8$var$yj(h);
                    if (null !== C) {
                        0 === (C.flags & 65536) && (C.flags |= 256);
                        $fbd042e4a49259b8$var$zj(C, h, k, g, b);
                        $fbd042e4a49259b8$var$Xg($fbd042e4a49259b8$var$mj(f, k));
                        break a;
                    }
                }
                g = f = $fbd042e4a49259b8$var$mj(f, k);
                4 !== $fbd042e4a49259b8$var$T && ($fbd042e4a49259b8$var$T = 2);
                null === $fbd042e4a49259b8$var$el ? $fbd042e4a49259b8$var$el = [
                    g
                ] : $fbd042e4a49259b8$var$el.push(g);
                g = h;
                do {
                    switch(g.tag){
                        case 3:
                            g.flags |= 65536;
                            b &= -b;
                            g.lanes |= b;
                            var x = $fbd042e4a49259b8$var$qj(g, f, b);
                            $fbd042e4a49259b8$var$th(g, x);
                            break a;
                        case 1:
                            k = f;
                            var y = g.type, v = g.stateNode;
                            if (0 === (g.flags & 128) && ("function" === typeof y.getDerivedStateFromError || null !== v && "function" === typeof v.componentDidCatch && (null === $fbd042e4a49259b8$var$uj || !$fbd042e4a49259b8$var$uj.has(v)))) {
                                g.flags |= 65536;
                                b &= -b;
                                g.lanes |= b;
                                var D = $fbd042e4a49259b8$var$tj(g, k, b);
                                $fbd042e4a49259b8$var$th(g, D);
                                break a;
                            }
                    }
                    g = g.return;
                }while (null !== g);
            }
            $fbd042e4a49259b8$var$Gl(c);
        } catch (ca) {
            b = ca;
            $fbd042e4a49259b8$var$Y === c && null !== c && ($fbd042e4a49259b8$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $fbd042e4a49259b8$var$wl() {
    var a = $fbd042e4a49259b8$var$Zk.current;
    $fbd042e4a49259b8$var$Zk.current = $fbd042e4a49259b8$var$pi;
    return null === a ? $fbd042e4a49259b8$var$pi : a;
}
function $fbd042e4a49259b8$var$ak() {
    if (0 === $fbd042e4a49259b8$var$T || 3 === $fbd042e4a49259b8$var$T || 2 === $fbd042e4a49259b8$var$T) $fbd042e4a49259b8$var$T = 4;
    null === $fbd042e4a49259b8$var$Q || 0 === ($fbd042e4a49259b8$var$vh & 268435455) && 0 === ($fbd042e4a49259b8$var$cl & 268435455) || $fbd042e4a49259b8$var$pl($fbd042e4a49259b8$var$Q, $fbd042e4a49259b8$var$Z);
}
function $fbd042e4a49259b8$var$vl(a, b) {
    var c = $fbd042e4a49259b8$var$K;
    $fbd042e4a49259b8$var$K |= 2;
    var d = $fbd042e4a49259b8$var$wl();
    if ($fbd042e4a49259b8$var$Q !== a || $fbd042e4a49259b8$var$Z !== b) {
        if ($fbd042e4a49259b8$var$mc) {
            var e = a.memoizedUpdaters;
            0 < e.size && ($fbd042e4a49259b8$var$xj(a, $fbd042e4a49259b8$var$Z), e.clear());
            $fbd042e4a49259b8$var$Qc(a, b);
        }
        $fbd042e4a49259b8$var$gl = null;
        $fbd042e4a49259b8$var$xl(a, b);
    }
    $fbd042e4a49259b8$var$wc(b);
    for(;;)try {
        $fbd042e4a49259b8$var$Hl();
        break;
    } catch (f) {
        $fbd042e4a49259b8$var$zl(a, f);
    }
    $fbd042e4a49259b8$var$dh();
    $fbd042e4a49259b8$var$K = c;
    $fbd042e4a49259b8$var$Zk.current = d;
    if (null !== $fbd042e4a49259b8$var$Y) throw Error($fbd042e4a49259b8$var$p(261));
    $fbd042e4a49259b8$var$xc();
    $fbd042e4a49259b8$var$Q = null;
    $fbd042e4a49259b8$var$Z = 0;
    return $fbd042e4a49259b8$var$T;
}
function $fbd042e4a49259b8$var$Hl() {
    for(; null !== $fbd042e4a49259b8$var$Y;)$fbd042e4a49259b8$var$Il($fbd042e4a49259b8$var$Y);
}
function $fbd042e4a49259b8$var$yl() {
    for(; null !== $fbd042e4a49259b8$var$Y && !$fbd042e4a49259b8$var$cc();)$fbd042e4a49259b8$var$Il($fbd042e4a49259b8$var$Y);
}
function $fbd042e4a49259b8$var$Il(a) {
    var b = a.alternate;
    0 !== (a.mode & 2) ? ($fbd042e4a49259b8$var$dj = $fbd042e4a49259b8$var$aj(), 0 > a.actualStartTime && (a.actualStartTime = $fbd042e4a49259b8$var$aj()), b = $fbd042e4a49259b8$var$Jl(b, a, $fbd042e4a49259b8$var$Kj), $fbd042e4a49259b8$var$hj(a, !0)) : b = $fbd042e4a49259b8$var$Jl(b, a, $fbd042e4a49259b8$var$Kj);
    a.memoizedProps = a.pendingProps;
    null === b ? $fbd042e4a49259b8$var$Gl(a) : $fbd042e4a49259b8$var$Y = b;
    $fbd042e4a49259b8$var$$k.current = null;
}
function $fbd042e4a49259b8$var$Gl(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (0 === (b.mode & 2)) c = $fbd042e4a49259b8$var$lk(c, b, $fbd042e4a49259b8$var$Kj);
            else {
                var d = b;
                $fbd042e4a49259b8$var$dj = $fbd042e4a49259b8$var$aj();
                0 > d.actualStartTime && (d.actualStartTime = $fbd042e4a49259b8$var$aj());
                c = $fbd042e4a49259b8$var$lk(c, b, $fbd042e4a49259b8$var$Kj);
                $fbd042e4a49259b8$var$hj(b, !1);
            }
            if (null !== c) {
                $fbd042e4a49259b8$var$Y = c;
                return;
            }
        } else {
            c = $fbd042e4a49259b8$var$pk(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $fbd042e4a49259b8$var$Y = c;
                return;
            }
            if (0 !== (b.mode & 2)) {
                $fbd042e4a49259b8$var$hj(b, !1);
                c = b.actualDuration;
                for(d = b.child; null !== d;)c += d.actualDuration, d = d.sibling;
                b.actualDuration = c;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $fbd042e4a49259b8$var$T = 6;
                $fbd042e4a49259b8$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $fbd042e4a49259b8$var$Y = b;
            return;
        }
        $fbd042e4a49259b8$var$Y = b = a;
    }while (null !== b);
    0 === $fbd042e4a49259b8$var$T && ($fbd042e4a49259b8$var$T = 5);
}
function $fbd042e4a49259b8$var$Dl(a, b, c) {
    var d = $fbd042e4a49259b8$var$E, e = $fbd042e4a49259b8$var$al.transition;
    try {
        $fbd042e4a49259b8$var$al.transition = null, $fbd042e4a49259b8$var$E = 1, $fbd042e4a49259b8$var$Kl(a, b, c, d);
    } finally{
        $fbd042e4a49259b8$var$al.transition = e, $fbd042e4a49259b8$var$E = d;
    }
    return null;
}
function $fbd042e4a49259b8$var$Kl(a, b, c, d) {
    do $fbd042e4a49259b8$var$ul();
    while (null !== $fbd042e4a49259b8$var$il);
    if (0 !== ($fbd042e4a49259b8$var$K & 6)) throw Error($fbd042e4a49259b8$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    null !== $fbd042e4a49259b8$var$B && "function" === typeof $fbd042e4a49259b8$var$B.markCommitStarted && $fbd042e4a49259b8$var$B.markCommitStarted(e);
    if (null === c) return $fbd042e4a49259b8$var$rc(), null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($fbd042e4a49259b8$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $fbd042e4a49259b8$var$Nc(a, f);
    a === $fbd042e4a49259b8$var$Q && ($fbd042e4a49259b8$var$Y = $fbd042e4a49259b8$var$Q = null, $fbd042e4a49259b8$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $fbd042e4a49259b8$var$hl || ($fbd042e4a49259b8$var$hl = !0, $fbd042e4a49259b8$var$sl($fbd042e4a49259b8$var$hc, function() {
        $fbd042e4a49259b8$var$ul();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $fbd042e4a49259b8$var$al.transition;
        $fbd042e4a49259b8$var$al.transition = null;
        var g = $fbd042e4a49259b8$var$E;
        $fbd042e4a49259b8$var$E = 1;
        var h = $fbd042e4a49259b8$var$K;
        $fbd042e4a49259b8$var$K |= 4;
        $fbd042e4a49259b8$var$$k.current = null;
        $fbd042e4a49259b8$var$zk(a, c);
        $fbd042e4a49259b8$var$bj = $fbd042e4a49259b8$var$aj();
        $fbd042e4a49259b8$var$Nk(a, c, e);
        $fbd042e4a49259b8$var$bf($fbd042e4a49259b8$var$Rf);
        $fbd042e4a49259b8$var$rd = !!$fbd042e4a49259b8$var$Qf;
        $fbd042e4a49259b8$var$Rf = $fbd042e4a49259b8$var$Qf = null;
        a.current = c;
        null !== $fbd042e4a49259b8$var$B && "function" === typeof $fbd042e4a49259b8$var$B.markLayoutEffectsStarted && $fbd042e4a49259b8$var$B.markLayoutEffectsStarted(e);
        $fbd042e4a49259b8$var$Tk(c, a, e);
        null !== $fbd042e4a49259b8$var$B && "function" === typeof $fbd042e4a49259b8$var$B.markLayoutEffectsStopped && $fbd042e4a49259b8$var$B.markLayoutEffectsStopped();
        $fbd042e4a49259b8$var$dc();
        $fbd042e4a49259b8$var$K = h;
        $fbd042e4a49259b8$var$E = g;
        $fbd042e4a49259b8$var$al.transition = f;
    } else a.current = c, $fbd042e4a49259b8$var$bj = $fbd042e4a49259b8$var$aj();
    $fbd042e4a49259b8$var$hl && ($fbd042e4a49259b8$var$hl = !1, $fbd042e4a49259b8$var$il = a, $fbd042e4a49259b8$var$jl = e);
    f = a.pendingLanes;
    0 === f && ($fbd042e4a49259b8$var$uj = null);
    $fbd042e4a49259b8$var$nc(c.stateNode, d);
    $fbd042e4a49259b8$var$mc && a.memoizedUpdaters.clear();
    $fbd042e4a49259b8$var$ql(a, $fbd042e4a49259b8$var$A());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($fbd042e4a49259b8$var$rj) throw $fbd042e4a49259b8$var$rj = !1, a = $fbd042e4a49259b8$var$sj, $fbd042e4a49259b8$var$sj = null, a;
    0 !== ($fbd042e4a49259b8$var$jl & 1) && 0 !== a.tag && $fbd042e4a49259b8$var$ul();
    f = a.pendingLanes;
    0 !== (f & 1) ? ($fbd042e4a49259b8$var$gj = !0, a === $fbd042e4a49259b8$var$ml ? $fbd042e4a49259b8$var$ll++ : ($fbd042e4a49259b8$var$ll = 0, $fbd042e4a49259b8$var$ml = a)) : $fbd042e4a49259b8$var$ll = 0;
    $fbd042e4a49259b8$var$xg();
    $fbd042e4a49259b8$var$rc();
    return null;
}
function $fbd042e4a49259b8$var$ul() {
    if (null !== $fbd042e4a49259b8$var$il) {
        var a = $fbd042e4a49259b8$var$Rc($fbd042e4a49259b8$var$jl), b = $fbd042e4a49259b8$var$al.transition, c = $fbd042e4a49259b8$var$E;
        try {
            $fbd042e4a49259b8$var$al.transition = null;
            $fbd042e4a49259b8$var$E = 16 > a ? 16 : a;
            if (null === $fbd042e4a49259b8$var$il) var d = !1;
            else {
                a = $fbd042e4a49259b8$var$il;
                var e = $fbd042e4a49259b8$var$jl;
                $fbd042e4a49259b8$var$il = null;
                $fbd042e4a49259b8$var$jl = 0;
                if (0 !== ($fbd042e4a49259b8$var$K & 6)) throw Error($fbd042e4a49259b8$var$p(331));
                null !== $fbd042e4a49259b8$var$B && "function" === typeof $fbd042e4a49259b8$var$B.markPassiveEffectsStarted && $fbd042e4a49259b8$var$B.markPassiveEffectsStarted(e);
                e = $fbd042e4a49259b8$var$K;
                $fbd042e4a49259b8$var$K |= 4;
                for($fbd042e4a49259b8$var$U = a.current; null !== $fbd042e4a49259b8$var$U;){
                    var f = $fbd042e4a49259b8$var$U, g = f.child;
                    if (0 !== ($fbd042e4a49259b8$var$U.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($fbd042e4a49259b8$var$U = l; null !== $fbd042e4a49259b8$var$U;){
                                    var n = $fbd042e4a49259b8$var$U, q = n;
                                    switch(q.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            q.mode & 2 ? ($fbd042e4a49259b8$var$ej = $fbd042e4a49259b8$var$aj(), $fbd042e4a49259b8$var$Ak(8, q, f), $fbd042e4a49259b8$var$jj(q)) : $fbd042e4a49259b8$var$Ak(8, q, f);
                                    }
                                    var r = n.child;
                                    if (null !== r) r.return = n, $fbd042e4a49259b8$var$U = r;
                                    else for(; null !== $fbd042e4a49259b8$var$U;){
                                        n = $fbd042e4a49259b8$var$U;
                                        var z = n.sibling, m = n.return;
                                        $fbd042e4a49259b8$var$Dk(n);
                                        if (n === l) {
                                            $fbd042e4a49259b8$var$U = null;
                                            break;
                                        }
                                        if (null !== z) {
                                            z.return = m;
                                            $fbd042e4a49259b8$var$U = z;
                                            break;
                                        }
                                        $fbd042e4a49259b8$var$U = m;
                                    }
                                }
                            }
                            var w = f.alternate;
                            if (null !== w) {
                                var C = w.child;
                                if (null !== C) {
                                    w.child = null;
                                    do {
                                        var x = C.sibling;
                                        C.sibling = null;
                                        C = x;
                                    }while (null !== C);
                                }
                            }
                            $fbd042e4a49259b8$var$U = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $fbd042e4a49259b8$var$U = g;
                    else b: for(; null !== $fbd042e4a49259b8$var$U;){
                        f = $fbd042e4a49259b8$var$U;
                        if (0 !== (f.flags & 2048)) switch(k = f, k.tag){
                            case 0:
                            case 11:
                            case 15:
                                k.mode & 2 ? ($fbd042e4a49259b8$var$ej = $fbd042e4a49259b8$var$aj(), $fbd042e4a49259b8$var$Ak(9, k, k.return), $fbd042e4a49259b8$var$jj(k)) : $fbd042e4a49259b8$var$Ak(9, k, k.return);
                        }
                        var y = f.sibling;
                        if (null !== y) {
                            y.return = f.return;
                            $fbd042e4a49259b8$var$U = y;
                            break b;
                        }
                        $fbd042e4a49259b8$var$U = f.return;
                    }
                }
                var v = a.current;
                for($fbd042e4a49259b8$var$U = v; null !== $fbd042e4a49259b8$var$U;){
                    g = $fbd042e4a49259b8$var$U;
                    var D = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== D) D.return = g, $fbd042e4a49259b8$var$U = D;
                    else b: for(g = v; null !== $fbd042e4a49259b8$var$U;){
                        h = $fbd042e4a49259b8$var$U;
                        if (0 !== (h.flags & 2048)) try {
                            switch(l = h, l.tag){
                                case 0:
                                case 11:
                                case 15:
                                    if (l.mode & 2) {
                                        $fbd042e4a49259b8$var$ej = $fbd042e4a49259b8$var$aj();
                                        try {
                                            $fbd042e4a49259b8$var$Bk(9, l);
                                        } finally{
                                            $fbd042e4a49259b8$var$jj(l);
                                        }
                                    } else $fbd042e4a49259b8$var$Bk(9, l);
                            }
                        } catch (Rj) {
                            $fbd042e4a49259b8$var$W(h, h.return, Rj);
                        }
                        if (h === g) {
                            $fbd042e4a49259b8$var$U = null;
                            break b;
                        }
                        var ca = h.sibling;
                        if (null !== ca) {
                            ca.return = h.return;
                            $fbd042e4a49259b8$var$U = ca;
                            break b;
                        }
                        $fbd042e4a49259b8$var$U = h.return;
                    }
                }
                v = $fbd042e4a49259b8$var$kl;
                $fbd042e4a49259b8$var$kl = [];
                for(D = 0; D < v.length; D++){
                    var R = v[D];
                    if (0 !== (R.flags & 4)) switch(R.tag){
                        case 12:
                            var sa = R.stateNode.passiveEffectDuration, V = R.memoizedProps, Cl = V.id, Hi = V.onPostCommit;
                            ca = $fbd042e4a49259b8$var$bj;
                            var Ii = null === R.alternate ? "mount" : "update";
                            $fbd042e4a49259b8$var$fj && (Ii = "nested-update");
                            "function" === typeof Hi && Hi(Cl, Ii, sa, ca);
                            var ob = R.return;
                            b: for(; null !== ob;){
                                switch(ob.tag){
                                    case 3:
                                        ob.stateNode.passiveEffectDuration += sa;
                                        break b;
                                    case 12:
                                        ob.stateNode.passiveEffectDuration += sa;
                                        break b;
                                }
                                ob = ob.return;
                            }
                    }
                }
                null !== $fbd042e4a49259b8$var$B && "function" === typeof $fbd042e4a49259b8$var$B.markPassiveEffectsStopped && $fbd042e4a49259b8$var$B.markPassiveEffectsStopped();
                $fbd042e4a49259b8$var$K = e;
                $fbd042e4a49259b8$var$xg();
                if ($fbd042e4a49259b8$var$lc && "function" === typeof $fbd042e4a49259b8$var$lc.onPostCommitFiberRoot) try {
                    $fbd042e4a49259b8$var$lc.onPostCommitFiberRoot($fbd042e4a49259b8$var$kc, a);
                } catch (Rj) {}
                var Sj = a.current.stateNode;
                Sj.effectDuration = 0;
                Sj.passiveEffectDuration = 0;
                d = !0;
            }
            return d;
        } finally{
            $fbd042e4a49259b8$var$E = c, $fbd042e4a49259b8$var$al.transition = b;
        }
    }
    return !1;
}
function $fbd042e4a49259b8$var$Xk(a) {
    $fbd042e4a49259b8$var$kl.push(a);
    $fbd042e4a49259b8$var$hl || ($fbd042e4a49259b8$var$hl = !0, $fbd042e4a49259b8$var$sl($fbd042e4a49259b8$var$hc, function() {
        $fbd042e4a49259b8$var$ul();
        return null;
    }));
}
function $fbd042e4a49259b8$var$Ll(a, b, c) {
    b = $fbd042e4a49259b8$var$mj(c, b);
    b = $fbd042e4a49259b8$var$qj(a, b, 1);
    a = $fbd042e4a49259b8$var$rh(a, b, 1);
    b = $fbd042e4a49259b8$var$zh();
    null !== a && ($fbd042e4a49259b8$var$Mc(a, 1, b), $fbd042e4a49259b8$var$ql(a, b));
}
function $fbd042e4a49259b8$var$W(a, b, c) {
    if (3 === a.tag) $fbd042e4a49259b8$var$Ll(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $fbd042e4a49259b8$var$Ll(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $fbd042e4a49259b8$var$uj || !$fbd042e4a49259b8$var$uj.has(d))) {
                a = $fbd042e4a49259b8$var$mj(c, a);
                a = $fbd042e4a49259b8$var$tj(b, a, 1);
                b = $fbd042e4a49259b8$var$rh(b, a, 1);
                a = $fbd042e4a49259b8$var$zh();
                null !== b && ($fbd042e4a49259b8$var$Mc(b, 1, a), $fbd042e4a49259b8$var$ql(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $fbd042e4a49259b8$var$wj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $fbd042e4a49259b8$var$zh();
    a.pingedLanes |= a.suspendedLanes & c;
    $fbd042e4a49259b8$var$Q === a && ($fbd042e4a49259b8$var$Z & c) === c && (4 === $fbd042e4a49259b8$var$T || 3 === $fbd042e4a49259b8$var$T && ($fbd042e4a49259b8$var$Z & 130023424) === $fbd042e4a49259b8$var$Z && 500 > $fbd042e4a49259b8$var$A() - $fbd042e4a49259b8$var$Rk ? $fbd042e4a49259b8$var$xl(a, 0) : $fbd042e4a49259b8$var$dl |= c);
    $fbd042e4a49259b8$var$ql(a, b);
}
function $fbd042e4a49259b8$var$Ml(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $fbd042e4a49259b8$var$Ec, $fbd042e4a49259b8$var$Ec <<= 1, 0 === ($fbd042e4a49259b8$var$Ec & 130023424) && ($fbd042e4a49259b8$var$Ec = 4194304)));
    var c = $fbd042e4a49259b8$var$zh();
    a = $fbd042e4a49259b8$var$mh(a, b);
    null !== a && ($fbd042e4a49259b8$var$Mc(a, b, c), $fbd042e4a49259b8$var$ql(a, c));
}
function $fbd042e4a49259b8$var$bk(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $fbd042e4a49259b8$var$Ml(a, c);
}
function $fbd042e4a49259b8$var$Mk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($fbd042e4a49259b8$var$p(314));
    }
    null !== d && d.delete(b);
    $fbd042e4a49259b8$var$Ml(a, c);
}
var $fbd042e4a49259b8$var$Jl;
$fbd042e4a49259b8$var$Jl = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $fbd042e4a49259b8$var$jg.current) $fbd042e4a49259b8$var$hh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $fbd042e4a49259b8$var$hh = !1, $fbd042e4a49259b8$var$fk(a, b, c);
            $fbd042e4a49259b8$var$hh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $fbd042e4a49259b8$var$hh = !1, $fbd042e4a49259b8$var$J && 0 !== (b.flags & 1048576) && $fbd042e4a49259b8$var$Ig(b, $fbd042e4a49259b8$var$Bg, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $fbd042e4a49259b8$var$Nj(a, b);
            a = b.pendingProps;
            var e = $fbd042e4a49259b8$var$lg(b, $fbd042e4a49259b8$var$I.current);
            $fbd042e4a49259b8$var$gh(b, c);
            $fbd042e4a49259b8$var$sc(b);
            e = $fbd042e4a49259b8$var$li(null, b, d, a, e, c);
            var f = $fbd042e4a49259b8$var$qi();
            $fbd042e4a49259b8$var$tc();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $fbd042e4a49259b8$var$mg(d) ? (f = !0, $fbd042e4a49259b8$var$qg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $fbd042e4a49259b8$var$oh(b), e.updater = $fbd042e4a49259b8$var$Ch, b.stateNode = e, e._reactInternals = b, $fbd042e4a49259b8$var$Gh(b, d, a, c), b = $fbd042e4a49259b8$var$Oj(null, b, d, !0, f, c)) : (b.tag = 0, $fbd042e4a49259b8$var$J && f && $fbd042e4a49259b8$var$Jg(b), $fbd042e4a49259b8$var$Bj(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $fbd042e4a49259b8$var$Nj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $fbd042e4a49259b8$var$Nl(d);
                a = $fbd042e4a49259b8$var$Zg(d, a);
                switch(e){
                    case 0:
                        b = $fbd042e4a49259b8$var$Hj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $fbd042e4a49259b8$var$Mj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $fbd042e4a49259b8$var$Cj(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $fbd042e4a49259b8$var$Ej(null, b, d, $fbd042e4a49259b8$var$Zg(d.type, a), c);
                        break a;
                }
                throw Error($fbd042e4a49259b8$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $fbd042e4a49259b8$var$Zg(d, e), $fbd042e4a49259b8$var$Hj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $fbd042e4a49259b8$var$Zg(d, e), $fbd042e4a49259b8$var$Mj(a, b, d, e, c);
        case 3:
            a: {
                $fbd042e4a49259b8$var$Pj(b);
                if (null === a) throw Error($fbd042e4a49259b8$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $fbd042e4a49259b8$var$ph(a, b);
                $fbd042e4a49259b8$var$uh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $fbd042e4a49259b8$var$mj(Error($fbd042e4a49259b8$var$p(423)), b);
                        b = $fbd042e4a49259b8$var$Qj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $fbd042e4a49259b8$var$mj(Error($fbd042e4a49259b8$var$p(424)), b);
                        b = $fbd042e4a49259b8$var$Qj(a, b, d, c, e);
                        break a;
                    } else for($fbd042e4a49259b8$var$Mg = $fbd042e4a49259b8$var$Zf(b.stateNode.containerInfo.firstChild), $fbd042e4a49259b8$var$Lg = b, $fbd042e4a49259b8$var$J = !0, $fbd042e4a49259b8$var$Ng = null, c = $fbd042e4a49259b8$var$Rh(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $fbd042e4a49259b8$var$Wg();
                    if (d === e) {
                        b = $fbd042e4a49259b8$var$Dj(a, b, c);
                        break a;
                    }
                    $fbd042e4a49259b8$var$Bj(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $fbd042e4a49259b8$var$Zh(b), null === a && $fbd042e4a49259b8$var$Sg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $fbd042e4a49259b8$var$Sf(d, e) ? g = null : null !== f && $fbd042e4a49259b8$var$Sf(d, f) && (b.flags |= 32), $fbd042e4a49259b8$var$Lj(a, b), $fbd042e4a49259b8$var$Bj(a, b, g, c), b.child;
        case 6:
            return null === a && $fbd042e4a49259b8$var$Sg(b), null;
        case 13:
            return $fbd042e4a49259b8$var$Vj(a, b, c);
        case 4:
            return $fbd042e4a49259b8$var$Xh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $fbd042e4a49259b8$var$Qh(b, null, d, c) : $fbd042e4a49259b8$var$Bj(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $fbd042e4a49259b8$var$Zg(d, e), $fbd042e4a49259b8$var$Cj(a, b, d, e, c);
        case 7:
            return $fbd042e4a49259b8$var$Bj(a, b, b.pendingProps, c), b.child;
        case 8:
            return $fbd042e4a49259b8$var$Bj(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return b.flags |= 4, d = b.stateNode, d.effectDuration = 0, d.passiveEffectDuration = 0, $fbd042e4a49259b8$var$Bj(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $fbd042e4a49259b8$var$H($fbd042e4a49259b8$var$$g, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($fbd042e4a49259b8$var$Ve(f.value, g)) {
                        if (f.children === e.children && !$fbd042e4a49259b8$var$jg.current) {
                            b = $fbd042e4a49259b8$var$Dj(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $fbd042e4a49259b8$var$qh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var n = l.pending;
                                            null === n ? k.next = k : (k.next = n.next, n.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $fbd042e4a49259b8$var$fh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($fbd042e4a49259b8$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $fbd042e4a49259b8$var$fh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $fbd042e4a49259b8$var$Bj(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $fbd042e4a49259b8$var$gh(b, c), e = $fbd042e4a49259b8$var$ih(e), $fbd042e4a49259b8$var$sc(b), d = d(e), $fbd042e4a49259b8$var$tc(), b.flags |= 1, $fbd042e4a49259b8$var$Bj(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $fbd042e4a49259b8$var$Zg(d, b.pendingProps), e = $fbd042e4a49259b8$var$Zg(d.type, e), $fbd042e4a49259b8$var$Ej(a, b, d, e, c);
        case 15:
            return $fbd042e4a49259b8$var$Gj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $fbd042e4a49259b8$var$Zg(d, e), $fbd042e4a49259b8$var$Nj(a, b), b.tag = 1, $fbd042e4a49259b8$var$mg(d) ? (a = !0, $fbd042e4a49259b8$var$qg(b)) : a = !1, $fbd042e4a49259b8$var$gh(b, c), $fbd042e4a49259b8$var$Eh(b, d, e), $fbd042e4a49259b8$var$Gh(b, d, e, c), $fbd042e4a49259b8$var$Oj(null, b, d, !0, a, c);
        case 19:
            return $fbd042e4a49259b8$var$ek(a, b, c);
        case 22:
            return $fbd042e4a49259b8$var$Ij(a, b, c);
    }
    throw Error($fbd042e4a49259b8$var$p(156, b.tag));
};
function $fbd042e4a49259b8$var$xj(a, b) {
    $fbd042e4a49259b8$var$mc && a.memoizedUpdaters.forEach(function(c) {
        $fbd042e4a49259b8$var$Pc(a, c, b);
    });
}
function $fbd042e4a49259b8$var$sl(a, b) {
    return $fbd042e4a49259b8$var$ac(a, b);
}
function $fbd042e4a49259b8$var$Ol(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
    this.actualDuration = 0;
    this.actualStartTime = -1;
    this.treeBaseDuration = this.selfBaseDuration = 0;
}
function $fbd042e4a49259b8$var$Pg(a, b, c, d) {
    return new $fbd042e4a49259b8$var$Ol(a, b, c, d);
}
function $fbd042e4a49259b8$var$Fj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $fbd042e4a49259b8$var$Nl(a) {
    if ("function" === typeof a) return $fbd042e4a49259b8$var$Fj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $fbd042e4a49259b8$var$Da) return 11;
        if (a === $fbd042e4a49259b8$var$Ga) return 14;
    }
    return 2;
}
function $fbd042e4a49259b8$var$Lh(a, b) {
    var c = a.alternate;
    null === c ? (c = $fbd042e4a49259b8$var$Pg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null, c.actualDuration = 0, c.actualStartTime = -1);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    c.selfBaseDuration = a.selfBaseDuration;
    c.treeBaseDuration = a.treeBaseDuration;
    return c;
}
function $fbd042e4a49259b8$var$Nh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $fbd042e4a49259b8$var$Fj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $fbd042e4a49259b8$var$ya:
            return $fbd042e4a49259b8$var$Ph(c.children, e, f, b);
        case $fbd042e4a49259b8$var$za:
            g = 8;
            e |= 8;
            break;
        case $fbd042e4a49259b8$var$Aa:
            return a = $fbd042e4a49259b8$var$Pg(12, c, b, e | 2), a.elementType = $fbd042e4a49259b8$var$Aa, a.lanes = f, a.stateNode = {
                effectDuration: 0,
                passiveEffectDuration: 0
            }, a;
        case $fbd042e4a49259b8$var$Ea:
            return a = $fbd042e4a49259b8$var$Pg(13, c, b, e), a.elementType = $fbd042e4a49259b8$var$Ea, a.lanes = f, a;
        case $fbd042e4a49259b8$var$Fa:
            return a = $fbd042e4a49259b8$var$Pg(19, c, b, e), a.elementType = $fbd042e4a49259b8$var$Fa, a.lanes = f, a;
        case $fbd042e4a49259b8$var$Ia:
            return $fbd042e4a49259b8$var$Wj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $fbd042e4a49259b8$var$Ba:
                    g = 10;
                    break a;
                case $fbd042e4a49259b8$var$Ca:
                    g = 9;
                    break a;
                case $fbd042e4a49259b8$var$Da:
                    g = 11;
                    break a;
                case $fbd042e4a49259b8$var$Ga:
                    g = 14;
                    break a;
                case $fbd042e4a49259b8$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($fbd042e4a49259b8$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $fbd042e4a49259b8$var$Pg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $fbd042e4a49259b8$var$Ph(a, b, c, d) {
    a = $fbd042e4a49259b8$var$Pg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $fbd042e4a49259b8$var$Wj(a, b, c, d) {
    a = $fbd042e4a49259b8$var$Pg(22, a, d, b);
    a.elementType = $fbd042e4a49259b8$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $fbd042e4a49259b8$var$Mh(a, b, c) {
    a = $fbd042e4a49259b8$var$Pg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $fbd042e4a49259b8$var$Oh(a, b, c) {
    b = $fbd042e4a49259b8$var$Pg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $fbd042e4a49259b8$var$Pl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $fbd042e4a49259b8$var$Lc(0);
    this.expirationTimes = $fbd042e4a49259b8$var$Lc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $fbd042e4a49259b8$var$Lc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
    this.passiveEffectDuration = this.effectDuration = 0;
    this.memoizedUpdaters = new Set;
    a = this.pendingUpdatersLaneMap = [];
    for(b = 0; 31 > b; b++)a.push(new Set);
}
function $fbd042e4a49259b8$var$Ql(a, b, c, d, e, f, g, h, k) {
    a = new $fbd042e4a49259b8$var$Pl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    $fbd042e4a49259b8$var$mc && (b |= 2);
    f = $fbd042e4a49259b8$var$Pg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $fbd042e4a49259b8$var$oh(f);
    return a;
}
function $fbd042e4a49259b8$var$Rl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $fbd042e4a49259b8$var$xa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $fbd042e4a49259b8$var$Sl(a) {
    if (!a) return $fbd042e4a49259b8$var$ig;
    a = a._reactInternals;
    a: {
        if ($fbd042e4a49259b8$var$Vb(a) !== a || 1 !== a.tag) throw Error($fbd042e4a49259b8$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($fbd042e4a49259b8$var$mg(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($fbd042e4a49259b8$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($fbd042e4a49259b8$var$mg(c)) return $fbd042e4a49259b8$var$pg(a, c, b);
    }
    return b;
}
function $fbd042e4a49259b8$var$Tl(a, b, c, d, e, f, g, h, k) {
    a = $fbd042e4a49259b8$var$Ql(c, d, !0, a, e, f, g, h, k);
    a.context = $fbd042e4a49259b8$var$Sl(null);
    c = a.current;
    d = $fbd042e4a49259b8$var$zh();
    e = $fbd042e4a49259b8$var$Ah(c);
    f = $fbd042e4a49259b8$var$qh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $fbd042e4a49259b8$var$rh(c, f, e);
    a.current.lanes = e;
    $fbd042e4a49259b8$var$Mc(a, e, d);
    $fbd042e4a49259b8$var$ql(a, d);
    return a;
}
function $fbd042e4a49259b8$var$Ul(a, b, c, d) {
    var e = b.current, f = $fbd042e4a49259b8$var$zh(), g = $fbd042e4a49259b8$var$Ah(e);
    null !== $fbd042e4a49259b8$var$B && "function" === typeof $fbd042e4a49259b8$var$B.markRenderScheduled && $fbd042e4a49259b8$var$B.markRenderScheduled(g);
    c = $fbd042e4a49259b8$var$Sl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $fbd042e4a49259b8$var$qh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $fbd042e4a49259b8$var$rh(e, b, g);
    null !== a && ($fbd042e4a49259b8$var$Bh(a, e, g, f), $fbd042e4a49259b8$var$sh(a, e, g));
    return g;
}
function $fbd042e4a49259b8$var$Vl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $fbd042e4a49259b8$var$Wl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $fbd042e4a49259b8$var$Xl(a, b) {
    $fbd042e4a49259b8$var$Wl(a, b);
    (a = a.alternate) && $fbd042e4a49259b8$var$Wl(a, b);
}
function $fbd042e4a49259b8$var$Yl() {
    return null;
}
var $fbd042e4a49259b8$var$Zl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $fbd042e4a49259b8$var$$l(a) {
    this._internalRoot = a;
}
$fbd042e4a49259b8$var$am.prototype.render = $fbd042e4a49259b8$var$$l.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($fbd042e4a49259b8$var$p(409));
    $fbd042e4a49259b8$var$Ul(a, b, null, null);
};
$fbd042e4a49259b8$var$am.prototype.unmount = $fbd042e4a49259b8$var$$l.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $fbd042e4a49259b8$var$Fl(function() {
            $fbd042e4a49259b8$var$Ul(null, a, null, null);
        });
        b[$fbd042e4a49259b8$var$If] = null;
    }
};
function $fbd042e4a49259b8$var$am(a) {
    this._internalRoot = a;
}
$fbd042e4a49259b8$var$am.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $fbd042e4a49259b8$var$Vc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $fbd042e4a49259b8$var$dd.length && 0 !== b && b < $fbd042e4a49259b8$var$dd[c].priority; c++);
        $fbd042e4a49259b8$var$dd.splice(c, 0, a);
        0 === c && $fbd042e4a49259b8$var$id(a);
    }
};
function $fbd042e4a49259b8$var$bm(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $fbd042e4a49259b8$var$cm(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $fbd042e4a49259b8$var$dm() {}
function $fbd042e4a49259b8$var$em(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $fbd042e4a49259b8$var$Vl(g);
                f.call(a);
            };
        }
        var g = $fbd042e4a49259b8$var$Tl(b, d, a, 0, null, !1, !1, "", $fbd042e4a49259b8$var$dm);
        a._reactRootContainer = g;
        a[$fbd042e4a49259b8$var$If] = g.current;
        $fbd042e4a49259b8$var$Gf(8 === a.nodeType ? a.parentNode : a);
        $fbd042e4a49259b8$var$Fl();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $fbd042e4a49259b8$var$Vl(k);
            h.call(a);
        };
    }
    var k = $fbd042e4a49259b8$var$Ql(a, 0, !1, null, null, !1, !1, "", $fbd042e4a49259b8$var$dm);
    a._reactRootContainer = k;
    a[$fbd042e4a49259b8$var$If] = k.current;
    $fbd042e4a49259b8$var$Gf(8 === a.nodeType ? a.parentNode : a);
    $fbd042e4a49259b8$var$Fl(function() {
        $fbd042e4a49259b8$var$Ul(b, k, c, d);
    });
    return k;
}
function $fbd042e4a49259b8$var$fm(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $fbd042e4a49259b8$var$Vl(g);
                h.call(a);
            };
        }
        $fbd042e4a49259b8$var$Ul(b, g, a, e);
    } else g = $fbd042e4a49259b8$var$em(c, b, a, e, d);
    return $fbd042e4a49259b8$var$Vl(g);
}
$fbd042e4a49259b8$var$Sc = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $fbd042e4a49259b8$var$Fc(b.pendingLanes);
                0 !== c && ($fbd042e4a49259b8$var$Oc(b, c | 1), $fbd042e4a49259b8$var$ql(b, $fbd042e4a49259b8$var$A()), 0 === ($fbd042e4a49259b8$var$K & 6) && ($fbd042e4a49259b8$var$nk = $fbd042e4a49259b8$var$A() + 500, $fbd042e4a49259b8$var$xg()));
            }
            break;
        case 13:
            $fbd042e4a49259b8$var$Fl(function() {
                var b = $fbd042e4a49259b8$var$mh(a, 1);
                if (null !== b) {
                    var c = $fbd042e4a49259b8$var$zh();
                    $fbd042e4a49259b8$var$Bh(b, a, 1, c);
                }
            }), $fbd042e4a49259b8$var$Xl(a, 1);
    }
};
$fbd042e4a49259b8$var$Tc = function(a) {
    if (13 === a.tag) {
        var b = $fbd042e4a49259b8$var$mh(a, 134217728);
        if (null !== b) {
            var c = $fbd042e4a49259b8$var$zh();
            $fbd042e4a49259b8$var$Bh(b, a, 134217728, c);
        }
        $fbd042e4a49259b8$var$Xl(a, 134217728);
    }
};
$fbd042e4a49259b8$var$Uc = function(a) {
    if (13 === a.tag) {
        var b = $fbd042e4a49259b8$var$Ah(a), c = $fbd042e4a49259b8$var$mh(a, b);
        if (null !== c) {
            var d = $fbd042e4a49259b8$var$zh();
            $fbd042e4a49259b8$var$Bh(c, a, b, d);
        }
        $fbd042e4a49259b8$var$Xl(a, b);
    }
};
$fbd042e4a49259b8$var$Vc = function() {
    return $fbd042e4a49259b8$var$E;
};
$fbd042e4a49259b8$var$Wc = function(a, b) {
    var c = $fbd042e4a49259b8$var$E;
    try {
        return $fbd042e4a49259b8$var$E = a, b();
    } finally{
        $fbd042e4a49259b8$var$E = c;
    }
};
$fbd042e4a49259b8$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $fbd042e4a49259b8$var$ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $fbd042e4a49259b8$var$Db(d);
                        if (!e) throw Error($fbd042e4a49259b8$var$p(90));
                        $fbd042e4a49259b8$var$Wa(d);
                        $fbd042e4a49259b8$var$ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $fbd042e4a49259b8$var$hb(a, c);
            break;
        case "select":
            b = c.value, null != b && $fbd042e4a49259b8$var$eb(a, !!c.multiple, b, !1);
    }
};
$fbd042e4a49259b8$var$Gb = $fbd042e4a49259b8$var$El;
$fbd042e4a49259b8$var$Hb = $fbd042e4a49259b8$var$Fl;
var $fbd042e4a49259b8$var$gm = {
    usingClientEntryPoint: !1,
    Events: [
        $fbd042e4a49259b8$var$Cb,
        $fbd042e4a49259b8$var$Ie,
        $fbd042e4a49259b8$var$Db,
        $fbd042e4a49259b8$var$Eb,
        $fbd042e4a49259b8$var$Fb,
        $fbd042e4a49259b8$var$El
    ]
}, $fbd042e4a49259b8$var$hm = {
    findFiberByHostInstance: $fbd042e4a49259b8$var$jd,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
(function(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        a = $fbd042e4a49259b8$var$u({}, a, {
            getLaneLabelMap: $fbd042e4a49259b8$var$pc,
            injectProfilingHooks: $fbd042e4a49259b8$var$oc
        }), $fbd042e4a49259b8$var$kc = b.inject(a), $fbd042e4a49259b8$var$lc = b;
    } catch (c) {}
    return b.checkDCE ? !0 : !1;
})({
    bundleType: $fbd042e4a49259b8$var$hm.bundleType,
    version: $fbd042e4a49259b8$var$hm.version,
    rendererPackageName: $fbd042e4a49259b8$var$hm.rendererPackageName,
    rendererConfig: $fbd042e4a49259b8$var$hm.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $fbd042e4a49259b8$var$va.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $fbd042e4a49259b8$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $fbd042e4a49259b8$var$hm.findFiberByHostInstance || $fbd042e4a49259b8$var$Yl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
});
$fbd042e4a49259b8$export$ae55be85d98224ed = $fbd042e4a49259b8$var$gm;
$fbd042e4a49259b8$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$fbd042e4a49259b8$var$bm(b)) throw Error($fbd042e4a49259b8$var$p(200));
    return $fbd042e4a49259b8$var$Rl(a, b, null, c);
};
$fbd042e4a49259b8$export$882461b6382ed46c = function(a, b) {
    if (!$fbd042e4a49259b8$var$bm(a)) throw Error($fbd042e4a49259b8$var$p(299));
    var c = !1, d = "", e = $fbd042e4a49259b8$var$Zl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $fbd042e4a49259b8$var$Ql(a, 1, !1, null, null, c, !1, d, e);
    a[$fbd042e4a49259b8$var$If] = b.current;
    $fbd042e4a49259b8$var$Gf(8 === a.nodeType ? a.parentNode : a);
    return new $fbd042e4a49259b8$var$$l(b);
};
$fbd042e4a49259b8$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($fbd042e4a49259b8$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($fbd042e4a49259b8$var$p(268, a));
    }
    a = $fbd042e4a49259b8$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$fbd042e4a49259b8$export$cd75ccfd720a3cd4 = function(a) {
    return $fbd042e4a49259b8$var$Fl(a);
};
$fbd042e4a49259b8$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$fbd042e4a49259b8$var$cm(b)) throw Error($fbd042e4a49259b8$var$p(200));
    return $fbd042e4a49259b8$var$fm(null, a, b, !0, c);
};
$fbd042e4a49259b8$export$757ceba2d55c277e = function(a, b, c) {
    if (!$fbd042e4a49259b8$var$bm(a)) throw Error($fbd042e4a49259b8$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $fbd042e4a49259b8$var$Zl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $fbd042e4a49259b8$var$Tl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$fbd042e4a49259b8$var$If] = b.current;
    $fbd042e4a49259b8$var$Gf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $fbd042e4a49259b8$var$am(b);
};
$fbd042e4a49259b8$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$fbd042e4a49259b8$var$cm(b)) throw Error($fbd042e4a49259b8$var$p(200));
    return $fbd042e4a49259b8$var$fm(null, a, b, !1, c);
};
$fbd042e4a49259b8$export$502457920280e6be = function(a) {
    if (!$fbd042e4a49259b8$var$cm(a)) throw Error($fbd042e4a49259b8$var$p(40));
    return a._reactRootContainer ? ($fbd042e4a49259b8$var$Fl(function() {
        $fbd042e4a49259b8$var$fm(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$fbd042e4a49259b8$var$If] = null;
        });
    }), !0) : !1;
};
$fbd042e4a49259b8$export$c78a37762a8d58e1 = $fbd042e4a49259b8$var$El;
$fbd042e4a49259b8$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$fbd042e4a49259b8$var$cm(c)) throw Error($fbd042e4a49259b8$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($fbd042e4a49259b8$var$p(38));
    return $fbd042e4a49259b8$var$fm(a, b, c, !1, d);
};
$fbd042e4a49259b8$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";
/* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());

});
parcelRegister("gqzfn", function(module, exports) {
'use strict';

module.exports = (parcelRequire("tIJkD"));

});

parcelRegister("9phqb", function(module, exports) {
'use strict';

module.exports = (parcelRequire("fgRgE"));

});
parcelRegister("fgRgE", function(module, exports) {
$parcel$export(module.exports, "unstable_now", () => $b1e1ab7e08950333$export$c4744153514ff05d, (v) => $b1e1ab7e08950333$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $b1e1ab7e08950333$export$3e506c1ccc9cc1a7, (v) => $b1e1ab7e08950333$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $b1e1ab7e08950333$export$e26fe2ed2fa76875, (v) => $b1e1ab7e08950333$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $b1e1ab7e08950333$export$502329bbf4b505b1, (v) => $b1e1ab7e08950333$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $b1e1ab7e08950333$export$6e3807111c4874c4, (v) => $b1e1ab7e08950333$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $b1e1ab7e08950333$export$c27134553091fb3a, (v) => $b1e1ab7e08950333$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $b1e1ab7e08950333$export$33ee1acdc04fd2a2, (v) => $b1e1ab7e08950333$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $b1e1ab7e08950333$export$b00a404bbd5edef2, (v) => $b1e1ab7e08950333$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $b1e1ab7e08950333$export$8352ce38b91d0c62, (v) => $b1e1ab7e08950333$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $b1e1ab7e08950333$export$d66a1c1c77bd778b, (v) => $b1e1ab7e08950333$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $b1e1ab7e08950333$export$d3dfb8e4810cb555, (v) => $b1e1ab7e08950333$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $b1e1ab7e08950333$export$839f9183b0465a69, (v) => $b1e1ab7e08950333$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $b1e1ab7e08950333$export$72fdf0e06517287b, (v) => $b1e1ab7e08950333$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $b1e1ab7e08950333$export$4b844e58a3e414b4, (v) => $b1e1ab7e08950333$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $b1e1ab7e08950333$export$816d2913ae6b83b1, (v) => $b1e1ab7e08950333$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $b1e1ab7e08950333$export$61bcfe829111a1d0, (v) => $b1e1ab7e08950333$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $b1e1ab7e08950333$export$7ee8c9beb337bc3f, (v) => $b1e1ab7e08950333$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $b1e1ab7e08950333$export$b5836b71941fa3ed, (v) => $b1e1ab7e08950333$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $b1e1ab7e08950333$export$cf845f2c119da08a, (v) => $b1e1ab7e08950333$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b1e1ab7e08950333$export$c4744153514ff05d;
var $b1e1ab7e08950333$export$3e506c1ccc9cc1a7;
var $b1e1ab7e08950333$export$e26fe2ed2fa76875;
var $b1e1ab7e08950333$export$502329bbf4b505b1;
var $b1e1ab7e08950333$export$6e3807111c4874c4;
var $b1e1ab7e08950333$export$c27134553091fb3a;
var $b1e1ab7e08950333$export$33ee1acdc04fd2a2;
var $b1e1ab7e08950333$export$b00a404bbd5edef2;
var $b1e1ab7e08950333$export$8352ce38b91d0c62;
var $b1e1ab7e08950333$export$d66a1c1c77bd778b;
var $b1e1ab7e08950333$export$d3dfb8e4810cb555;
var $b1e1ab7e08950333$export$839f9183b0465a69;
var $b1e1ab7e08950333$export$72fdf0e06517287b;
var $b1e1ab7e08950333$export$4b844e58a3e414b4;
var $b1e1ab7e08950333$export$816d2913ae6b83b1;
var $b1e1ab7e08950333$export$61bcfe829111a1d0;
var $b1e1ab7e08950333$export$7ee8c9beb337bc3f;
var $b1e1ab7e08950333$export$b5836b71941fa3ed;
var $b1e1ab7e08950333$export$cf845f2c119da08a;
'use strict';
function $b1e1ab7e08950333$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $b1e1ab7e08950333$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $b1e1ab7e08950333$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $b1e1ab7e08950333$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $b1e1ab7e08950333$var$g(C, c)) n < e && 0 > $b1e1ab7e08950333$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $b1e1ab7e08950333$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $b1e1ab7e08950333$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $b1e1ab7e08950333$var$l = performance;
    $b1e1ab7e08950333$export$c4744153514ff05d = function() {
        return $b1e1ab7e08950333$var$l.now();
    };
} else {
    var $b1e1ab7e08950333$var$p = Date, $b1e1ab7e08950333$var$q = $b1e1ab7e08950333$var$p.now();
    $b1e1ab7e08950333$export$c4744153514ff05d = function() {
        return $b1e1ab7e08950333$var$p.now() - $b1e1ab7e08950333$var$q;
    };
}
var $b1e1ab7e08950333$var$r = [], $b1e1ab7e08950333$var$t = [], $b1e1ab7e08950333$var$u = 1, $b1e1ab7e08950333$var$v = null, $b1e1ab7e08950333$var$y = 3, $b1e1ab7e08950333$var$z = !1, $b1e1ab7e08950333$var$A = !1, $b1e1ab7e08950333$var$B = !1, $b1e1ab7e08950333$var$D = "function" === typeof setTimeout ? setTimeout : null, $b1e1ab7e08950333$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $b1e1ab7e08950333$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $b1e1ab7e08950333$var$G(a) {
    for(var b = $b1e1ab7e08950333$var$h($b1e1ab7e08950333$var$t); null !== b;){
        if (null === b.callback) $b1e1ab7e08950333$var$k($b1e1ab7e08950333$var$t);
        else if (b.startTime <= a) $b1e1ab7e08950333$var$k($b1e1ab7e08950333$var$t), b.sortIndex = b.expirationTime, $b1e1ab7e08950333$var$f($b1e1ab7e08950333$var$r, b);
        else break;
        b = $b1e1ab7e08950333$var$h($b1e1ab7e08950333$var$t);
    }
}
function $b1e1ab7e08950333$var$H(a) {
    $b1e1ab7e08950333$var$B = !1;
    $b1e1ab7e08950333$var$G(a);
    if (!$b1e1ab7e08950333$var$A) {
        if (null !== $b1e1ab7e08950333$var$h($b1e1ab7e08950333$var$r)) $b1e1ab7e08950333$var$A = !0, $b1e1ab7e08950333$var$I($b1e1ab7e08950333$var$J);
        else {
            var b = $b1e1ab7e08950333$var$h($b1e1ab7e08950333$var$t);
            null !== b && $b1e1ab7e08950333$var$K($b1e1ab7e08950333$var$H, b.startTime - a);
        }
    }
}
function $b1e1ab7e08950333$var$J(a, b) {
    $b1e1ab7e08950333$var$A = !1;
    $b1e1ab7e08950333$var$B && ($b1e1ab7e08950333$var$B = !1, $b1e1ab7e08950333$var$E($b1e1ab7e08950333$var$L), $b1e1ab7e08950333$var$L = -1);
    $b1e1ab7e08950333$var$z = !0;
    var c = $b1e1ab7e08950333$var$y;
    try {
        $b1e1ab7e08950333$var$G(b);
        for($b1e1ab7e08950333$var$v = $b1e1ab7e08950333$var$h($b1e1ab7e08950333$var$r); null !== $b1e1ab7e08950333$var$v && (!($b1e1ab7e08950333$var$v.expirationTime > b) || a && !$b1e1ab7e08950333$var$M());){
            var d = $b1e1ab7e08950333$var$v.callback;
            if ("function" === typeof d) {
                $b1e1ab7e08950333$var$v.callback = null;
                $b1e1ab7e08950333$var$y = $b1e1ab7e08950333$var$v.priorityLevel;
                var e = d($b1e1ab7e08950333$var$v.expirationTime <= b);
                b = $b1e1ab7e08950333$export$c4744153514ff05d();
                "function" === typeof e ? $b1e1ab7e08950333$var$v.callback = e : $b1e1ab7e08950333$var$v === $b1e1ab7e08950333$var$h($b1e1ab7e08950333$var$r) && $b1e1ab7e08950333$var$k($b1e1ab7e08950333$var$r);
                $b1e1ab7e08950333$var$G(b);
            } else $b1e1ab7e08950333$var$k($b1e1ab7e08950333$var$r);
            $b1e1ab7e08950333$var$v = $b1e1ab7e08950333$var$h($b1e1ab7e08950333$var$r);
        }
        if (null !== $b1e1ab7e08950333$var$v) var w = !0;
        else {
            var m = $b1e1ab7e08950333$var$h($b1e1ab7e08950333$var$t);
            null !== m && $b1e1ab7e08950333$var$K($b1e1ab7e08950333$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $b1e1ab7e08950333$var$v = null, $b1e1ab7e08950333$var$y = c, $b1e1ab7e08950333$var$z = !1;
    }
}
var $b1e1ab7e08950333$var$N = !1, $b1e1ab7e08950333$var$O = null, $b1e1ab7e08950333$var$L = -1, $b1e1ab7e08950333$var$P = 5, $b1e1ab7e08950333$var$Q = -1;
function $b1e1ab7e08950333$var$M() {
    return $b1e1ab7e08950333$export$c4744153514ff05d() - $b1e1ab7e08950333$var$Q < $b1e1ab7e08950333$var$P ? !1 : !0;
}
function $b1e1ab7e08950333$var$R() {
    if (null !== $b1e1ab7e08950333$var$O) {
        var a = $b1e1ab7e08950333$export$c4744153514ff05d();
        $b1e1ab7e08950333$var$Q = a;
        var b = !0;
        try {
            b = $b1e1ab7e08950333$var$O(!0, a);
        } finally{
            b ? $b1e1ab7e08950333$var$S() : ($b1e1ab7e08950333$var$N = !1, $b1e1ab7e08950333$var$O = null);
        }
    } else $b1e1ab7e08950333$var$N = !1;
}
var $b1e1ab7e08950333$var$S;
if ("function" === typeof $b1e1ab7e08950333$var$F) $b1e1ab7e08950333$var$S = function() {
    $b1e1ab7e08950333$var$F($b1e1ab7e08950333$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $b1e1ab7e08950333$var$T = new MessageChannel, $b1e1ab7e08950333$var$U = $b1e1ab7e08950333$var$T.port2;
    $b1e1ab7e08950333$var$T.port1.onmessage = $b1e1ab7e08950333$var$R;
    $b1e1ab7e08950333$var$S = function() {
        $b1e1ab7e08950333$var$U.postMessage(null);
    };
} else $b1e1ab7e08950333$var$S = function() {
    $b1e1ab7e08950333$var$D($b1e1ab7e08950333$var$R, 0);
};
function $b1e1ab7e08950333$var$I(a) {
    $b1e1ab7e08950333$var$O = a;
    $b1e1ab7e08950333$var$N || ($b1e1ab7e08950333$var$N = !0, $b1e1ab7e08950333$var$S());
}
function $b1e1ab7e08950333$var$K(a, b) {
    $b1e1ab7e08950333$var$L = $b1e1ab7e08950333$var$D(function() {
        a($b1e1ab7e08950333$export$c4744153514ff05d());
    }, b);
}
$b1e1ab7e08950333$export$3e506c1ccc9cc1a7 = 5;
$b1e1ab7e08950333$export$e26fe2ed2fa76875 = 1;
$b1e1ab7e08950333$export$502329bbf4b505b1 = 4;
$b1e1ab7e08950333$export$6e3807111c4874c4 = 3;
$b1e1ab7e08950333$export$c27134553091fb3a = null;
$b1e1ab7e08950333$export$33ee1acdc04fd2a2 = 2;
$b1e1ab7e08950333$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$b1e1ab7e08950333$export$8352ce38b91d0c62 = function() {
    $b1e1ab7e08950333$var$A || $b1e1ab7e08950333$var$z || ($b1e1ab7e08950333$var$A = !0, $b1e1ab7e08950333$var$I($b1e1ab7e08950333$var$J));
};
$b1e1ab7e08950333$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $b1e1ab7e08950333$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$b1e1ab7e08950333$export$d3dfb8e4810cb555 = function() {
    return $b1e1ab7e08950333$var$y;
};
$b1e1ab7e08950333$export$839f9183b0465a69 = function() {
    return $b1e1ab7e08950333$var$h($b1e1ab7e08950333$var$r);
};
$b1e1ab7e08950333$export$72fdf0e06517287b = function(a) {
    switch($b1e1ab7e08950333$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $b1e1ab7e08950333$var$y;
    }
    var c = $b1e1ab7e08950333$var$y;
    $b1e1ab7e08950333$var$y = b;
    try {
        return a();
    } finally{
        $b1e1ab7e08950333$var$y = c;
    }
};
$b1e1ab7e08950333$export$4b844e58a3e414b4 = function() {};
$b1e1ab7e08950333$export$816d2913ae6b83b1 = function() {};
$b1e1ab7e08950333$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $b1e1ab7e08950333$var$y;
    $b1e1ab7e08950333$var$y = a;
    try {
        return b();
    } finally{
        $b1e1ab7e08950333$var$y = c;
    }
};
$b1e1ab7e08950333$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $b1e1ab7e08950333$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $b1e1ab7e08950333$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $b1e1ab7e08950333$var$f($b1e1ab7e08950333$var$t, a), null === $b1e1ab7e08950333$var$h($b1e1ab7e08950333$var$r) && a === $b1e1ab7e08950333$var$h($b1e1ab7e08950333$var$t) && ($b1e1ab7e08950333$var$B ? ($b1e1ab7e08950333$var$E($b1e1ab7e08950333$var$L), $b1e1ab7e08950333$var$L = -1) : $b1e1ab7e08950333$var$B = !0, $b1e1ab7e08950333$var$K($b1e1ab7e08950333$var$H, c - d))) : (a.sortIndex = e, $b1e1ab7e08950333$var$f($b1e1ab7e08950333$var$r, a), $b1e1ab7e08950333$var$A || $b1e1ab7e08950333$var$z || ($b1e1ab7e08950333$var$A = !0, $b1e1ab7e08950333$var$I($b1e1ab7e08950333$var$J)));
    return a;
};
$b1e1ab7e08950333$export$b5836b71941fa3ed = $b1e1ab7e08950333$var$M;
$b1e1ab7e08950333$export$cf845f2c119da08a = function(a) {
    var b = $b1e1ab7e08950333$var$y;
    return function() {
        var c = $b1e1ab7e08950333$var$y;
        $b1e1ab7e08950333$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $b1e1ab7e08950333$var$y = c;
        }
    };
};

});



parcelRegister("ekOVf", function(module, exports) {
$parcel$export(module.exports, "Buffer", () => $a6fa6f0d2d81adb3$export$a143d493d941bafc, (v) => $a6fa6f0d2d81adb3$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $a6fa6f0d2d81adb3$export$e4cf37d7f6fb9e0a, (v) => $a6fa6f0d2d81adb3$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $a6fa6f0d2d81adb3$export$f99ded8fe4b79145, (v) => $a6fa6f0d2d81adb3$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $a6fa6f0d2d81adb3$export$599f31c3813fae4d, (v) => $a6fa6f0d2d81adb3$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $a6fa6f0d2d81adb3$export$a143d493d941bafc;
var $a6fa6f0d2d81adb3$export$e4cf37d7f6fb9e0a;
var $a6fa6f0d2d81adb3$export$f99ded8fe4b79145;
var $a6fa6f0d2d81adb3$export$599f31c3813fae4d;
'use strict';

var $4fuLn = parcelRequire("4fuLn");

var $2H7TK = parcelRequire("2H7TK");
const $a6fa6f0d2d81adb3$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$a6fa6f0d2d81adb3$export$a143d493d941bafc = $a6fa6f0d2d81adb3$var$Buffer;
$a6fa6f0d2d81adb3$export$e4cf37d7f6fb9e0a = $a6fa6f0d2d81adb3$var$SlowBuffer;
$a6fa6f0d2d81adb3$export$f99ded8fe4b79145 = 50;
const $a6fa6f0d2d81adb3$var$K_MAX_LENGTH = 0x7fffffff;
$a6fa6f0d2d81adb3$export$599f31c3813fae4d = $a6fa6f0d2d81adb3$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $a6fa6f0d2d81adb3$var$Buffer.TYPED_ARRAY_SUPPORT = $a6fa6f0d2d81adb3$var$typedArraySupport();
if (!$a6fa6f0d2d81adb3$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $a6fa6f0d2d81adb3$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($a6fa6f0d2d81adb3$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$a6fa6f0d2d81adb3$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($a6fa6f0d2d81adb3$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$a6fa6f0d2d81adb3$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $a6fa6f0d2d81adb3$var$createBuffer(length) {
    if (length > $a6fa6f0d2d81adb3$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $a6fa6f0d2d81adb3$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $a6fa6f0d2d81adb3$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $a6fa6f0d2d81adb3$var$allocUnsafe(arg);
    }
    return $a6fa6f0d2d81adb3$var$from(arg, encodingOrOffset, length);
}
$a6fa6f0d2d81adb3$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $a6fa6f0d2d81adb3$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $a6fa6f0d2d81adb3$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $a6fa6f0d2d81adb3$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($a6fa6f0d2d81adb3$var$isInstance(value, ArrayBuffer) || value && $a6fa6f0d2d81adb3$var$isInstance(value.buffer, ArrayBuffer)) return $a6fa6f0d2d81adb3$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($a6fa6f0d2d81adb3$var$isInstance(value, SharedArrayBuffer) || value && $a6fa6f0d2d81adb3$var$isInstance(value.buffer, SharedArrayBuffer))) return $a6fa6f0d2d81adb3$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $a6fa6f0d2d81adb3$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $a6fa6f0d2d81adb3$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $a6fa6f0d2d81adb3$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $a6fa6f0d2d81adb3$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $a6fa6f0d2d81adb3$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($a6fa6f0d2d81adb3$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($a6fa6f0d2d81adb3$var$Buffer, Uint8Array);
function $a6fa6f0d2d81adb3$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $a6fa6f0d2d81adb3$var$alloc(size, fill, encoding) {
    $a6fa6f0d2d81adb3$var$assertSize(size);
    if (size <= 0) return $a6fa6f0d2d81adb3$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $a6fa6f0d2d81adb3$var$createBuffer(size).fill(fill, encoding) : $a6fa6f0d2d81adb3$var$createBuffer(size).fill(fill);
    return $a6fa6f0d2d81adb3$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $a6fa6f0d2d81adb3$var$Buffer.alloc = function(size, fill, encoding) {
    return $a6fa6f0d2d81adb3$var$alloc(size, fill, encoding);
};
function $a6fa6f0d2d81adb3$var$allocUnsafe(size) {
    $a6fa6f0d2d81adb3$var$assertSize(size);
    return $a6fa6f0d2d81adb3$var$createBuffer(size < 0 ? 0 : $a6fa6f0d2d81adb3$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $a6fa6f0d2d81adb3$var$Buffer.allocUnsafe = function(size) {
    return $a6fa6f0d2d81adb3$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $a6fa6f0d2d81adb3$var$Buffer.allocUnsafeSlow = function(size) {
    return $a6fa6f0d2d81adb3$var$allocUnsafe(size);
};
function $a6fa6f0d2d81adb3$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$a6fa6f0d2d81adb3$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $a6fa6f0d2d81adb3$var$byteLength(string, encoding) | 0;
    let buf = $a6fa6f0d2d81adb3$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $a6fa6f0d2d81adb3$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $a6fa6f0d2d81adb3$var$checked(array.length) | 0;
    const buf = $a6fa6f0d2d81adb3$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $a6fa6f0d2d81adb3$var$fromArrayView(arrayView) {
    if ($a6fa6f0d2d81adb3$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $a6fa6f0d2d81adb3$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $a6fa6f0d2d81adb3$var$fromArrayLike(arrayView);
}
function $a6fa6f0d2d81adb3$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $a6fa6f0d2d81adb3$var$Buffer.prototype);
    return buf;
}
function $a6fa6f0d2d81adb3$var$fromObject(obj) {
    if ($a6fa6f0d2d81adb3$var$Buffer.isBuffer(obj)) {
        const len = $a6fa6f0d2d81adb3$var$checked(obj.length) | 0;
        const buf = $a6fa6f0d2d81adb3$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $a6fa6f0d2d81adb3$var$numberIsNaN(obj.length)) return $a6fa6f0d2d81adb3$var$createBuffer(0);
        return $a6fa6f0d2d81adb3$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $a6fa6f0d2d81adb3$var$fromArrayLike(obj.data);
}
function $a6fa6f0d2d81adb3$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $a6fa6f0d2d81adb3$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $a6fa6f0d2d81adb3$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $a6fa6f0d2d81adb3$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $a6fa6f0d2d81adb3$var$Buffer.alloc(+length);
}
$a6fa6f0d2d81adb3$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $a6fa6f0d2d81adb3$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$a6fa6f0d2d81adb3$var$Buffer.compare = function compare(a, b) {
    if ($a6fa6f0d2d81adb3$var$isInstance(a, Uint8Array)) a = $a6fa6f0d2d81adb3$var$Buffer.from(a, a.offset, a.byteLength);
    if ($a6fa6f0d2d81adb3$var$isInstance(b, Uint8Array)) b = $a6fa6f0d2d81adb3$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$a6fa6f0d2d81adb3$var$Buffer.isBuffer(a) || !$a6fa6f0d2d81adb3$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$a6fa6f0d2d81adb3$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$a6fa6f0d2d81adb3$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $a6fa6f0d2d81adb3$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $a6fa6f0d2d81adb3$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($a6fa6f0d2d81adb3$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$a6fa6f0d2d81adb3$var$Buffer.isBuffer(buf)) buf = $a6fa6f0d2d81adb3$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$a6fa6f0d2d81adb3$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $a6fa6f0d2d81adb3$var$byteLength(string, encoding) {
    if ($a6fa6f0d2d81adb3$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $a6fa6f0d2d81adb3$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $a6fa6f0d2d81adb3$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $a6fa6f0d2d81adb3$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $a6fa6f0d2d81adb3$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$a6fa6f0d2d81adb3$var$Buffer.byteLength = $a6fa6f0d2d81adb3$var$byteLength;
function $a6fa6f0d2d81adb3$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $a6fa6f0d2d81adb3$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $a6fa6f0d2d81adb3$var$utf8Slice(this, start, end);
        case 'ascii':
            return $a6fa6f0d2d81adb3$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $a6fa6f0d2d81adb3$var$latin1Slice(this, start, end);
        case 'base64':
            return $a6fa6f0d2d81adb3$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $a6fa6f0d2d81adb3$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$a6fa6f0d2d81adb3$var$Buffer.prototype._isBuffer = true;
function $a6fa6f0d2d81adb3$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$a6fa6f0d2d81adb3$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$a6fa6f0d2d81adb3$var$swap(this, i, i + 1);
    return this;
};
$a6fa6f0d2d81adb3$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $a6fa6f0d2d81adb3$var$swap(this, i, i + 3);
        $a6fa6f0d2d81adb3$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$a6fa6f0d2d81adb3$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $a6fa6f0d2d81adb3$var$swap(this, i, i + 7);
        $a6fa6f0d2d81adb3$var$swap(this, i + 1, i + 6);
        $a6fa6f0d2d81adb3$var$swap(this, i + 2, i + 5);
        $a6fa6f0d2d81adb3$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$a6fa6f0d2d81adb3$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $a6fa6f0d2d81adb3$var$utf8Slice(this, 0, length);
    return $a6fa6f0d2d81adb3$var$slowToString.apply(this, arguments);
};
$a6fa6f0d2d81adb3$var$Buffer.prototype.toLocaleString = $a6fa6f0d2d81adb3$var$Buffer.prototype.toString;
$a6fa6f0d2d81adb3$var$Buffer.prototype.equals = function equals(b) {
    if (!$a6fa6f0d2d81adb3$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $a6fa6f0d2d81adb3$var$Buffer.compare(this, b) === 0;
};
$a6fa6f0d2d81adb3$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $a6fa6f0d2d81adb3$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($a6fa6f0d2d81adb3$var$customInspectSymbol) $a6fa6f0d2d81adb3$var$Buffer.prototype[$a6fa6f0d2d81adb3$var$customInspectSymbol] = $a6fa6f0d2d81adb3$var$Buffer.prototype.inspect;
$a6fa6f0d2d81adb3$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($a6fa6f0d2d81adb3$var$isInstance(target, Uint8Array)) target = $a6fa6f0d2d81adb3$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$a6fa6f0d2d81adb3$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $a6fa6f0d2d81adb3$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($a6fa6f0d2d81adb3$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $a6fa6f0d2d81adb3$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($a6fa6f0d2d81adb3$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $a6fa6f0d2d81adb3$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $a6fa6f0d2d81adb3$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $a6fa6f0d2d81adb3$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$a6fa6f0d2d81adb3$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$a6fa6f0d2d81adb3$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $a6fa6f0d2d81adb3$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$a6fa6f0d2d81adb3$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $a6fa6f0d2d81adb3$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $a6fa6f0d2d81adb3$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($a6fa6f0d2d81adb3$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $a6fa6f0d2d81adb3$var$utf8Write(buf, string, offset, length) {
    return $a6fa6f0d2d81adb3$var$blitBuffer($a6fa6f0d2d81adb3$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $a6fa6f0d2d81adb3$var$asciiWrite(buf, string, offset, length) {
    return $a6fa6f0d2d81adb3$var$blitBuffer($a6fa6f0d2d81adb3$var$asciiToBytes(string), buf, offset, length);
}
function $a6fa6f0d2d81adb3$var$base64Write(buf, string, offset, length) {
    return $a6fa6f0d2d81adb3$var$blitBuffer($a6fa6f0d2d81adb3$var$base64ToBytes(string), buf, offset, length);
}
function $a6fa6f0d2d81adb3$var$ucs2Write(buf, string, offset, length) {
    return $a6fa6f0d2d81adb3$var$blitBuffer($a6fa6f0d2d81adb3$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$a6fa6f0d2d81adb3$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $a6fa6f0d2d81adb3$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $a6fa6f0d2d81adb3$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $a6fa6f0d2d81adb3$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $a6fa6f0d2d81adb3$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $a6fa6f0d2d81adb3$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$a6fa6f0d2d81adb3$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $a6fa6f0d2d81adb3$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $4fuLn.fromByteArray(buf);
    else return $4fuLn.fromByteArray(buf.slice(start, end));
}
function $a6fa6f0d2d81adb3$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $a6fa6f0d2d81adb3$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $a6fa6f0d2d81adb3$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $a6fa6f0d2d81adb3$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $a6fa6f0d2d81adb3$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $a6fa6f0d2d81adb3$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $a6fa6f0d2d81adb3$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $a6fa6f0d2d81adb3$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $a6fa6f0d2d81adb3$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $a6fa6f0d2d81adb3$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $a6fa6f0d2d81adb3$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$a6fa6f0d2d81adb3$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $a6fa6f0d2d81adb3$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $a6fa6f0d2d81adb3$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$a6fa6f0d2d81adb3$var$Buffer.prototype.readUintLE = $a6fa6f0d2d81adb3$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a6fa6f0d2d81adb3$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$a6fa6f0d2d81adb3$var$Buffer.prototype.readUintBE = $a6fa6f0d2d81adb3$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a6fa6f0d2d81adb3$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$a6fa6f0d2d81adb3$var$Buffer.prototype.readUint8 = $a6fa6f0d2d81adb3$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a6fa6f0d2d81adb3$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$a6fa6f0d2d81adb3$var$Buffer.prototype.readUint16LE = $a6fa6f0d2d81adb3$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a6fa6f0d2d81adb3$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$a6fa6f0d2d81adb3$var$Buffer.prototype.readUint16BE = $a6fa6f0d2d81adb3$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a6fa6f0d2d81adb3$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$a6fa6f0d2d81adb3$var$Buffer.prototype.readUint32LE = $a6fa6f0d2d81adb3$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a6fa6f0d2d81adb3$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$a6fa6f0d2d81adb3$var$Buffer.prototype.readUint32BE = $a6fa6f0d2d81adb3$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a6fa6f0d2d81adb3$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$a6fa6f0d2d81adb3$var$Buffer.prototype.readBigUInt64LE = $a6fa6f0d2d81adb3$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $a6fa6f0d2d81adb3$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $a6fa6f0d2d81adb3$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$a6fa6f0d2d81adb3$var$Buffer.prototype.readBigUInt64BE = $a6fa6f0d2d81adb3$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $a6fa6f0d2d81adb3$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $a6fa6f0d2d81adb3$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$a6fa6f0d2d81adb3$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a6fa6f0d2d81adb3$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$a6fa6f0d2d81adb3$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a6fa6f0d2d81adb3$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$a6fa6f0d2d81adb3$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a6fa6f0d2d81adb3$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$a6fa6f0d2d81adb3$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a6fa6f0d2d81adb3$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$a6fa6f0d2d81adb3$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a6fa6f0d2d81adb3$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$a6fa6f0d2d81adb3$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a6fa6f0d2d81adb3$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$a6fa6f0d2d81adb3$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a6fa6f0d2d81adb3$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$a6fa6f0d2d81adb3$var$Buffer.prototype.readBigInt64LE = $a6fa6f0d2d81adb3$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $a6fa6f0d2d81adb3$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $a6fa6f0d2d81adb3$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$a6fa6f0d2d81adb3$var$Buffer.prototype.readBigInt64BE = $a6fa6f0d2d81adb3$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $a6fa6f0d2d81adb3$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $a6fa6f0d2d81adb3$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$a6fa6f0d2d81adb3$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a6fa6f0d2d81adb3$var$checkOffset(offset, 4, this.length);
    return $2H7TK.read(this, offset, true, 23, 4);
};
$a6fa6f0d2d81adb3$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a6fa6f0d2d81adb3$var$checkOffset(offset, 4, this.length);
    return $2H7TK.read(this, offset, false, 23, 4);
};
$a6fa6f0d2d81adb3$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a6fa6f0d2d81adb3$var$checkOffset(offset, 8, this.length);
    return $2H7TK.read(this, offset, true, 52, 8);
};
$a6fa6f0d2d81adb3$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a6fa6f0d2d81adb3$var$checkOffset(offset, 8, this.length);
    return $2H7TK.read(this, offset, false, 52, 8);
};
function $a6fa6f0d2d81adb3$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$a6fa6f0d2d81adb3$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$a6fa6f0d2d81adb3$var$Buffer.prototype.writeUintLE = $a6fa6f0d2d81adb3$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $a6fa6f0d2d81adb3$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$a6fa6f0d2d81adb3$var$Buffer.prototype.writeUintBE = $a6fa6f0d2d81adb3$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $a6fa6f0d2d81adb3$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$a6fa6f0d2d81adb3$var$Buffer.prototype.writeUint8 = $a6fa6f0d2d81adb3$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a6fa6f0d2d81adb3$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$a6fa6f0d2d81adb3$var$Buffer.prototype.writeUint16LE = $a6fa6f0d2d81adb3$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a6fa6f0d2d81adb3$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$a6fa6f0d2d81adb3$var$Buffer.prototype.writeUint16BE = $a6fa6f0d2d81adb3$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a6fa6f0d2d81adb3$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$a6fa6f0d2d81adb3$var$Buffer.prototype.writeUint32LE = $a6fa6f0d2d81adb3$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a6fa6f0d2d81adb3$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$a6fa6f0d2d81adb3$var$Buffer.prototype.writeUint32BE = $a6fa6f0d2d81adb3$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a6fa6f0d2d81adb3$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $a6fa6f0d2d81adb3$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $a6fa6f0d2d81adb3$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $a6fa6f0d2d81adb3$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $a6fa6f0d2d81adb3$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$a6fa6f0d2d81adb3$var$Buffer.prototype.writeBigUInt64LE = $a6fa6f0d2d81adb3$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $a6fa6f0d2d81adb3$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$a6fa6f0d2d81adb3$var$Buffer.prototype.writeBigUInt64BE = $a6fa6f0d2d81adb3$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $a6fa6f0d2d81adb3$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$a6fa6f0d2d81adb3$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $a6fa6f0d2d81adb3$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$a6fa6f0d2d81adb3$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $a6fa6f0d2d81adb3$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$a6fa6f0d2d81adb3$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a6fa6f0d2d81adb3$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$a6fa6f0d2d81adb3$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a6fa6f0d2d81adb3$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$a6fa6f0d2d81adb3$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a6fa6f0d2d81adb3$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$a6fa6f0d2d81adb3$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a6fa6f0d2d81adb3$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$a6fa6f0d2d81adb3$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a6fa6f0d2d81adb3$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$a6fa6f0d2d81adb3$var$Buffer.prototype.writeBigInt64LE = $a6fa6f0d2d81adb3$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $a6fa6f0d2d81adb3$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$a6fa6f0d2d81adb3$var$Buffer.prototype.writeBigInt64BE = $a6fa6f0d2d81adb3$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $a6fa6f0d2d81adb3$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $a6fa6f0d2d81adb3$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $a6fa6f0d2d81adb3$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a6fa6f0d2d81adb3$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $2H7TK.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$a6fa6f0d2d81adb3$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $a6fa6f0d2d81adb3$var$writeFloat(this, value, offset, true, noAssert);
};
$a6fa6f0d2d81adb3$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $a6fa6f0d2d81adb3$var$writeFloat(this, value, offset, false, noAssert);
};
function $a6fa6f0d2d81adb3$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a6fa6f0d2d81adb3$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $2H7TK.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$a6fa6f0d2d81adb3$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $a6fa6f0d2d81adb3$var$writeDouble(this, value, offset, true, noAssert);
};
$a6fa6f0d2d81adb3$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $a6fa6f0d2d81adb3$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$a6fa6f0d2d81adb3$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$a6fa6f0d2d81adb3$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$a6fa6f0d2d81adb3$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$a6fa6f0d2d81adb3$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $a6fa6f0d2d81adb3$var$Buffer.isBuffer(val) ? val : $a6fa6f0d2d81adb3$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $a6fa6f0d2d81adb3$var$errors = {};
function $a6fa6f0d2d81adb3$var$E(sym, getMessage, Base) {
    $a6fa6f0d2d81adb3$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$a6fa6f0d2d81adb3$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$a6fa6f0d2d81adb3$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$a6fa6f0d2d81adb3$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $a6fa6f0d2d81adb3$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $a6fa6f0d2d81adb3$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $a6fa6f0d2d81adb3$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $a6fa6f0d2d81adb3$var$checkBounds(buf, offset, byteLength) {
    $a6fa6f0d2d81adb3$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $a6fa6f0d2d81adb3$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $a6fa6f0d2d81adb3$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $a6fa6f0d2d81adb3$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $a6fa6f0d2d81adb3$var$checkBounds(buf, offset, byteLength);
}
function $a6fa6f0d2d81adb3$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $a6fa6f0d2d81adb3$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $a6fa6f0d2d81adb3$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $a6fa6f0d2d81adb3$var$validateNumber(value, type);
        throw new $a6fa6f0d2d81adb3$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $a6fa6f0d2d81adb3$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $a6fa6f0d2d81adb3$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $a6fa6f0d2d81adb3$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $a6fa6f0d2d81adb3$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($a6fa6f0d2d81adb3$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $a6fa6f0d2d81adb3$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $a6fa6f0d2d81adb3$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $a6fa6f0d2d81adb3$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $a6fa6f0d2d81adb3$var$base64ToBytes(str) {
    return $4fuLn.toByteArray($a6fa6f0d2d81adb3$var$base64clean(str));
}
function $a6fa6f0d2d81adb3$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $a6fa6f0d2d81adb3$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $a6fa6f0d2d81adb3$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $a6fa6f0d2d81adb3$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $a6fa6f0d2d81adb3$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $a6fa6f0d2d81adb3$var$BufferBigIntNotDefined : fn;
}
function $a6fa6f0d2d81adb3$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("4fuLn", function(module, exports) {
$parcel$export(module.exports, "toByteArray", () => $31806d0c2ee0ac28$export$d622b2ad8d90c771, (v) => $31806d0c2ee0ac28$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $31806d0c2ee0ac28$export$6100ba28696e12de, (v) => $31806d0c2ee0ac28$export$6100ba28696e12de = v);
var $31806d0c2ee0ac28$export$a48f0734ac7c2329;
var $31806d0c2ee0ac28$export$d622b2ad8d90c771;
var $31806d0c2ee0ac28$export$6100ba28696e12de;
'use strict';
$31806d0c2ee0ac28$export$a48f0734ac7c2329 = $31806d0c2ee0ac28$var$byteLength;
$31806d0c2ee0ac28$export$d622b2ad8d90c771 = $31806d0c2ee0ac28$var$toByteArray;
$31806d0c2ee0ac28$export$6100ba28696e12de = $31806d0c2ee0ac28$var$fromByteArray;
var $31806d0c2ee0ac28$var$lookup = [];
var $31806d0c2ee0ac28$var$revLookup = [];
var $31806d0c2ee0ac28$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $31806d0c2ee0ac28$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $31806d0c2ee0ac28$var$i = 0, $31806d0c2ee0ac28$var$len = $31806d0c2ee0ac28$var$code.length; $31806d0c2ee0ac28$var$i < $31806d0c2ee0ac28$var$len; ++$31806d0c2ee0ac28$var$i){
    $31806d0c2ee0ac28$var$lookup[$31806d0c2ee0ac28$var$i] = $31806d0c2ee0ac28$var$code[$31806d0c2ee0ac28$var$i];
    $31806d0c2ee0ac28$var$revLookup[$31806d0c2ee0ac28$var$code.charCodeAt($31806d0c2ee0ac28$var$i)] = $31806d0c2ee0ac28$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$31806d0c2ee0ac28$var$revLookup['-'.charCodeAt(0)] = 62;
$31806d0c2ee0ac28$var$revLookup['_'.charCodeAt(0)] = 63;
function $31806d0c2ee0ac28$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $31806d0c2ee0ac28$var$byteLength(b64) {
    var lens = $31806d0c2ee0ac28$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $31806d0c2ee0ac28$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $31806d0c2ee0ac28$var$toByteArray(b64) {
    var tmp;
    var lens = $31806d0c2ee0ac28$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $31806d0c2ee0ac28$var$Arr($31806d0c2ee0ac28$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $31806d0c2ee0ac28$var$revLookup[b64.charCodeAt(i)] << 18 | $31806d0c2ee0ac28$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $31806d0c2ee0ac28$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $31806d0c2ee0ac28$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $31806d0c2ee0ac28$var$revLookup[b64.charCodeAt(i)] << 2 | $31806d0c2ee0ac28$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $31806d0c2ee0ac28$var$revLookup[b64.charCodeAt(i)] << 10 | $31806d0c2ee0ac28$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $31806d0c2ee0ac28$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $31806d0c2ee0ac28$var$tripletToBase64(num) {
    return $31806d0c2ee0ac28$var$lookup[num >> 18 & 0x3F] + $31806d0c2ee0ac28$var$lookup[num >> 12 & 0x3F] + $31806d0c2ee0ac28$var$lookup[num >> 6 & 0x3F] + $31806d0c2ee0ac28$var$lookup[num & 0x3F];
}
function $31806d0c2ee0ac28$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($31806d0c2ee0ac28$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $31806d0c2ee0ac28$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($31806d0c2ee0ac28$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($31806d0c2ee0ac28$var$lookup[tmp >> 2] + $31806d0c2ee0ac28$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($31806d0c2ee0ac28$var$lookup[tmp >> 10] + $31806d0c2ee0ac28$var$lookup[tmp >> 4 & 0x3F] + $31806d0c2ee0ac28$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("2H7TK", function(module, exports) {
$parcel$export(module.exports, "read", () => $1f65b9586eb00d5c$export$aafa59e2e03f2942, (v) => $1f65b9586eb00d5c$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $1f65b9586eb00d5c$export$68d8715fc104d294, (v) => $1f65b9586eb00d5c$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $1f65b9586eb00d5c$export$aafa59e2e03f2942;
var $1f65b9586eb00d5c$export$68d8715fc104d294;
$1f65b9586eb00d5c$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$1f65b9586eb00d5c$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("cJmfa", function(module, exports) {
/*
 * Copyright Joyent, Inc. and other Node contributors.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit
 * persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ 'use strict';

var $20DJU = parcelRequire("20DJU");
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
/*
 * define these here so at least they only have to be
 * compiled once on the first module load.
 */ var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, /*
   * RFC 2396: characters reserved for delimiting URLs.
   * We actually just auto-escape these.
   */ delims = [
    '<',
    '>',
    '"',
    '`',
    ' ',
    '\r',
    '\n',
    '\t'
], // RFC 2396: characters not allowed for various reasons.
unwise = [
    '{',
    '}',
    '|',
    '\\',
    '^',
    '`'
].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = [
    '\''
].concat(unwise), /*
   * Characters that are never ever allowed in a hostname.
   * Note that any invalid chars are also handled, but these
   * are the ones that are *expected* to be seen, so we fast-path
   * them.
   */ nonHostChars = [
    '%',
    '/',
    '?',
    ';',
    '#'
].concat(autoEscape), hostEndingChars = [
    '/',
    '?',
    '#'
], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
    javascript: true,
    'javascript:': true
}, // protocols that never have a hostname.
hostlessProtocol = {
    javascript: true,
    'javascript:': true
}, // protocols that always contain a // bit.
slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
};

var $ceUpL = parcelRequire("ceUpL");
function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && typeof url === 'object' && url instanceof Url) return url;
    var u = new Url();
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (typeof url !== 'string') throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    /*
   * Copy chrome, IE, opera backslash-handling behavior.
   * Back slashes before the query string get converted to forward slashes
   * See: https://code.google.com/p/chromium/issues/detail?id=25916
   */ var queryIndex = url.indexOf('?'), splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#', uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, '/');
    url = uSplit.join(splitter);
    var rest = url;
    /*
   * trim before proceeding.
   * This is to support parse stuff like "  http://foo.com  \n"
   */ rest = rest.trim();
    if (!slashesDenoteHost && url.split('#').length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = $ceUpL.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = '';
                this.query = {};
            }
            return this;
        }
    }
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    /*
   * figure out if it's got a host
   * user@server is *always* interpreted as a hostname, and url
   * resolution will treat //foo/bar as host=foo,path=bar because that's
   * how the browser resolves relative URLs.
   */ if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
        var slashes = rest.substr(0, 2) === '//';
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        /*
     * there's a hostname.
     * the first instance of /, ?, ;, or # ends the host.
     *
     * If there is an @ in the hostname, then non-host chars *are* allowed
     * to the left of the last @ sign, unless some host-ending character
     * comes *before* the @-sign.
     * URLs are obnoxious.
     *
     * ex:
     * http://a@b@c/ => user:a@b host:c
     * http://a@b?@c => user:a host:c path:/?@c
     */ /*
     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
     * Review our test case against browsers more comprehensively.
     */ // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < hostEndingChars.length; i++){
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        /*
     * at this point, either we have an explicit point where the
     * auth portion cannot go past, or the last @ char is the decider.
     */ var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf('@');
        else /*
       * atSign must be in auth portion.
       * http://a@b/c@d => host:b auth:a path:/c@d
       */ atSign = rest.lastIndexOf('@', hostEnd);
        /*
     * Now we have a portion which is definitely the auth.
     * Pull that off.
     */ if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < nonHostChars.length; i++){
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        /*
     * we've indicated that there is a hostname,
     * so even if it's empty, it has to be present.
     */ this.hostname = this.hostname || '';
        /*
     * if hostname begins with [ and ends with ]
     * assume that it's an IPv6 address.
     */ var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = '';
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) /*
               * we replace non-ASCII char with a temporary placeholder
               * we need this to make sure size of hostname is not
               * broken by replacing non-ASCII by nothing
               */ newpart += 'x';
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = '/' + notHost.join('.') + rest;
                        this.hostname = validParts.join('.');
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = '';
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) /*
       * IDNA Support: Returns a punycoded representation of "domain".
       * It only converts parts of the domain name that
       * have non-ASCII characters, i.e. it doesn't matter if
       * you call it with a domain that already is ASCII-only.
       */ this.hostname = $20DJU.toASCII(this.hostname);
        var p = this.port ? ':' + this.port : '';
        var h = this.hostname || '';
        this.host = h + p;
        this.href += this.host;
        /*
     * strip [ and ] from the hostname
     * the host field still retains them, though
     */ if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== '/') rest = '/' + rest;
        }
    }
    /*
   * now rest is set to the post-host stuff.
   * chop off any delim chars.
   */ if (!unsafeProtocol[lowerProto]) /*
     * First, make 100% sure that any "autoEscape" chars get
     * escaped, even if encodeURIComponent doesn't think they
     * need to be.
     */ for(var i = 0, l = autoEscape.length; i < l; i++){
        var ae = autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf('#');
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf('?');
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = $ceUpL.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = '';
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = '/';
    // to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || '';
        var s = this.search || '';
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    /*
   * ensure it's an object, and not a string url.
   * If it's an obj, this is a no-op.
   * this way, you can call url_format() on strings
   * to clean up potentially wonky urls.
   */ if (typeof obj === 'string') obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function() {
    var auth = this.auth || '';
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ':');
        auth += '@';
    }
    var protocol = this.protocol || '', pathname = this.pathname || '', hash = this.hash || '', host = false, query = '';
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
        if (this.port) host += ':' + this.port;
    }
    if (this.query && typeof this.query === 'object' && Object.keys(this.query).length) query = $ceUpL.stringify(this.query, {
        arrayFormat: 'repeat',
        addQueryPrefix: false
    });
    var search = this.search || query && '?' + query || '';
    if (protocol && protocol.substr(-1) !== ':') protocol += ':';
    /*
   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
   * unless they had them to begin with.
   */ if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = '//' + (host || '');
        if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
    } else if (!host) host = '';
    if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
    if (search && search.charAt(0) !== '?') search = '?' + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace('#', '%23');
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function(relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function(relative) {
    if (typeof relative === 'string') {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    /*
   * hash is always overridden, no matter what.
   * even href="" will remove it.
   */ result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === '') {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== 'protocol') result[rkey] = relative[rkey];
        }
        // urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
            result.pathname = '/';
            result.path = result.pathname;
        }
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        /*
     * if it's a known url protocol, then changing
     * the protocol does weird things
     * first, if it's not file:, then we MUST have a host,
     * and if there was a path
     * to begin with, then we MUST have a path.
     * if it is file:, then the host is dropped,
     * because that's known to be hostless.
     * anything else is assumed to be absolute.
     */ if (!slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || '').split('/');
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = '';
            if (!relative.hostname) relative.hostname = '';
            if (relPath[0] !== '') relPath.unshift('');
            if (relPath.length < 2) relPath.unshift('');
            result.pathname = relPath.join('/');
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || '';
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || '';
            var s = result.search || '';
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/', isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/', mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split('/') || [], relPath = relative.pathname && relative.pathname.split('/') || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    /*
   * if the url is a non-slashed url, then relative
   * links like ../.. should be able
   * to crawl up to the hostname, as well.  This is strange.
   * result.protocol has already been set by now.
   * Later on, put the first path part into the host field.
   */ if (psychotic) {
        result.hostname = '';
        result.port = null;
        if (result.host) {
            if (srcPath[0] === '') srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = '';
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === '') relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === '' ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        /*
     * it's relative
     * throw away the existing file, and take the new path instead.
     */ if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (relative.search != null) {
        /*
     * just pull out the search.
     * like href='?foo'.
     * Put this after the other two cases because it simplifies the booleans
     */ if (psychotic) {
            result.host = srcPath.shift();
            result.hostname = result.host;
            /*
       * occationaly the auth can get stuck only in host
       * this especially happens in cases like
       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
       */ var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.hostname = authInHost.shift();
                result.host = result.hostname;
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        // to support http.request
        if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        /*
     * no path at all.  easy.
     * we've already handled the other stuff above.
     */ result.pathname = null;
        // to support http.request
        if (result.search) result.path = '/' + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    /*
   * if a url ENDs in . or .., then it must get a trailing slash.
   * however, if it ends in anything else non-slashy,
   * then it must NOT get a trailing slash.
   */ var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';
    /*
   * strip single dots, resolve double dots to parent dir
   * if the path tries to go above the root, `up` ends up > 0
   */ var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === '.') srcPath.splice(i, 1);
        else if (last === '..') {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift('..');
    if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) srcPath.unshift('');
    if (hasTrailingSlash && srcPath.join('/').substr(-1) !== '/') srcPath.push('');
    var isAbsolute = srcPath[0] === '' || srcPath[0] && srcPath[0].charAt(0) === '/';
    // put the host back
    if (psychotic) {
        result.hostname = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
        result.host = result.hostname;
        /*
     * occationaly the auth can get stuck only in host
     * this especially happens in cases like
     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
     */ var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.hostname = authInHost.shift();
            result.host = result.hostname;
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift('');
    if (srcPath.length > 0) result.pathname = srcPath.join('/');
    else {
        result.pathname = null;
        result.path = null;
    }
    // to support request.http
    if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function() {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ':') this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;

});
parcelRegister("20DJU", function(module, exports) {
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == 'object' && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = '-', /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        'overflow': 'Overflow: input needs wider integers to process',
        'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
        'invalid-input': 'Invalid input'
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw new RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split('@');
        var result = '';
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + '@';
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, '\x2E');
        var labels = string.split('.');
        var encoded = map(labels, fn).join('.');
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = '';
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join('');
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error('not-basic');
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error('invalid-input');
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error('overflow');
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error('overflow');
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error('overflow');
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error('overflow');
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error('overflow');
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join('');
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ 'version': '1.4.1',
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ 'ucs2': {
            'decode': ucs2decode,
            'encode': ucs2encode
        },
        'decode': decode,
        'encode': encode,
        'toASCII': toASCII,
        'toUnicode': toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) define('punycode', function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) // in Node.js, io.js, or RingoJS v0.8.0+
        freeModule.exports = punycode;
        else // in Narwhal or RingoJS v0.7.0-
        for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else // in Rhino or a web browser
    root.punycode = punycode;
})(this);

});

parcelRegister("ceUpL", function(module, exports) {
'use strict';

var $eECYh = parcelRequire("eECYh");

var $5GHPN = parcelRequire("5GHPN");

var $8T2UJ = parcelRequire("8T2UJ");
module.exports = {
    formats: $8T2UJ,
    parse: $5GHPN,
    stringify: $eECYh
};

});
parcelRegister("eECYh", function(module, exports) {
'use strict';

var $2fAwm = parcelRequire("2fAwm");

var $cOjo3 = parcelRequire("cOjo3");

var $8T2UJ = parcelRequire("8T2UJ");
var $02c0d2b5b9cc6ed1$var$has = Object.prototype.hasOwnProperty;
var $02c0d2b5b9cc6ed1$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $02c0d2b5b9cc6ed1$var$isArray = Array.isArray;
var $02c0d2b5b9cc6ed1$var$push = Array.prototype.push;
var $02c0d2b5b9cc6ed1$var$pushToArray = function(arr, valueOrArray) {
    $02c0d2b5b9cc6ed1$var$push.apply(arr, $02c0d2b5b9cc6ed1$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $02c0d2b5b9cc6ed1$var$toISO = Date.prototype.toISOString;
var $02c0d2b5b9cc6ed1$var$defaultFormat = $8T2UJ.default;
var $02c0d2b5b9cc6ed1$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: $cOjo3.encode,
    encodeValuesOnly: false,
    filter: void 0,
    format: $02c0d2b5b9cc6ed1$var$defaultFormat,
    formatter: $8T2UJ.formatters[$02c0d2b5b9cc6ed1$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $02c0d2b5b9cc6ed1$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $02c0d2b5b9cc6ed1$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || typeof v === 'symbol' || typeof v === 'bigint';
};
var $02c0d2b5b9cc6ed1$var$sentinel = {};
var $02c0d2b5b9cc6ed1$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($02c0d2b5b9cc6ed1$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) throw new RangeError('Cyclic object value');
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($02c0d2b5b9cc6ed1$var$sentinel) === 'undefined') step = 0;
    }
    if (typeof filter === 'function') obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === 'comma' && $02c0d2b5b9cc6ed1$var$isArray(obj)) obj = $cOjo3.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $02c0d2b5b9cc6ed1$var$defaults.encoder, charset, 'key', format) : prefix;
        obj = '';
    }
    if ($02c0d2b5b9cc6ed1$var$isNonNullishPrimitive(obj) || $cOjo3.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $02c0d2b5b9cc6ed1$var$defaults.encoder, charset, 'key', format);
            return [
                formatter(keyValue) + '=' + formatter(encoder(obj, $02c0d2b5b9cc6ed1$var$defaults.encoder, charset, 'value', format))
            ];
        }
        return [
            formatter(prefix) + '=' + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === 'undefined') return values;
    var objKeys;
    if (generateArrayPrefix === 'comma' && $02c0d2b5b9cc6ed1$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $cOjo3.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(',') || null : void 0
            }
        ];
    } else if ($02c0d2b5b9cc6ed1$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, '%2E') : String(prefix);
    var adjustedPrefix = commaRoundTrip && $02c0d2b5b9cc6ed1$var$isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;
    if (allowEmptyArrays && $02c0d2b5b9cc6ed1$var$isArray(obj) && obj.length === 0) return adjustedPrefix + '[]';
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined' ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = $02c0d2b5b9cc6ed1$var$isArray(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');
        sideChannel.set(object, step);
        var valueSideChannel = $2fAwm();
        valueSideChannel.set($02c0d2b5b9cc6ed1$var$sentinel, sideChannel);
        $02c0d2b5b9cc6ed1$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === 'comma' && encodeValuesOnly && $02c0d2b5b9cc6ed1$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $02c0d2b5b9cc6ed1$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $02c0d2b5b9cc6ed1$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') throw new TypeError('Encoder has to be a function.');
    var charset = opts.charset || $02c0d2b5b9cc6ed1$var$defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    var format = $8T2UJ.default;
    if (typeof opts.format !== 'undefined') {
        if (!$02c0d2b5b9cc6ed1$var$has.call($8T2UJ.formatters, opts.format)) throw new TypeError('Unknown format option provided.');
        format = opts.format;
    }
    var formatter = $8T2UJ.formatters[format];
    var filter = $02c0d2b5b9cc6ed1$var$defaults.filter;
    if (typeof opts.filter === 'function' || $02c0d2b5b9cc6ed1$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in $02c0d2b5b9cc6ed1$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ('indices' in opts) arrayFormat = opts.indices ? 'indices' : 'repeat';
    else arrayFormat = $02c0d2b5b9cc6ed1$var$defaults.arrayFormat;
    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : $02c0d2b5b9cc6ed1$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : $02c0d2b5b9cc6ed1$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $02c0d2b5b9cc6ed1$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $02c0d2b5b9cc6ed1$var$defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? $02c0d2b5b9cc6ed1$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : $02c0d2b5b9cc6ed1$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : $02c0d2b5b9cc6ed1$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : $02c0d2b5b9cc6ed1$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : $02c0d2b5b9cc6ed1$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : $02c0d2b5b9cc6ed1$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : $02c0d2b5b9cc6ed1$var$defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $02c0d2b5b9cc6ed1$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $02c0d2b5b9cc6ed1$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if ($02c0d2b5b9cc6ed1$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== 'object' || obj === null) return '';
    var generateArrayPrefix = $02c0d2b5b9cc6ed1$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $2fAwm();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        var value = obj[key];
        if (options.skipNulls && value === null) continue;
        $02c0d2b5b9cc6ed1$var$pushToArray(keys, $02c0d2b5b9cc6ed1$var$stringify(value, key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';
    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += 'utf8=%26%2310003%3B&';
        else // encodeURIComponent('✓')
        prefix += 'utf8=%E2%9C%93&';
    }
    return joined.length > 0 ? prefix + joined : '';
};

});
parcelRegister("2fAwm", function(module, exports) {
'use strict';

var $aqgEe = parcelRequire("aqgEe");

var $6fZQw = parcelRequire("6fZQw");

var $dNUki = parcelRequire("dNUki");

var $4HvO4 = parcelRequire("4HvO4");

var $jTVBv = parcelRequire("jTVBv");
var $1a394fc2dec6f2c6$var$makeChannel = $jTVBv || $4HvO4 || $dNUki;
/** @type {import('.')} */ module.exports = function getSideChannel() {
    /** @typedef {ReturnType<typeof getSideChannel>} Channel */ /** @type {Channel | undefined} */ var $channelData;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $aqgEe('Side channel does not contain ' + $6fZQw(key));
        },
        'delete': function(key) {
            return !!$channelData && $channelData['delete'](key);
        },
        get: function(key) {
            return $channelData && $channelData.get(key);
        },
        has: function(key) {
            return !!$channelData && $channelData.has(key);
        },
        set: function(key, value) {
            if (!$channelData) $channelData = $1a394fc2dec6f2c6$var$makeChannel();
            $channelData.set(key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};

});
parcelRegister("aqgEe", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("6fZQw", function(module, exports) {
var $48e41e26b1b512b2$var$hasMap = typeof Map === 'function' && Map.prototype;
var $48e41e26b1b512b2$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $48e41e26b1b512b2$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var $48e41e26b1b512b2$var$mapSize = $48e41e26b1b512b2$var$hasMap && $48e41e26b1b512b2$var$mapSizeDescriptor && typeof $48e41e26b1b512b2$var$mapSizeDescriptor.get === 'function' ? $48e41e26b1b512b2$var$mapSizeDescriptor.get : null;
var $48e41e26b1b512b2$var$mapForEach = $48e41e26b1b512b2$var$hasMap && Map.prototype.forEach;
var $48e41e26b1b512b2$var$hasSet = typeof Set === 'function' && Set.prototype;
var $48e41e26b1b512b2$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $48e41e26b1b512b2$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var $48e41e26b1b512b2$var$setSize = $48e41e26b1b512b2$var$hasSet && $48e41e26b1b512b2$var$setSizeDescriptor && typeof $48e41e26b1b512b2$var$setSizeDescriptor.get === 'function' ? $48e41e26b1b512b2$var$setSizeDescriptor.get : null;
var $48e41e26b1b512b2$var$setForEach = $48e41e26b1b512b2$var$hasSet && Set.prototype.forEach;
var $48e41e26b1b512b2$var$hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var $48e41e26b1b512b2$var$weakMapHas = $48e41e26b1b512b2$var$hasWeakMap ? WeakMap.prototype.has : null;
var $48e41e26b1b512b2$var$hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var $48e41e26b1b512b2$var$weakSetHas = $48e41e26b1b512b2$var$hasWeakSet ? WeakSet.prototype.has : null;
var $48e41e26b1b512b2$var$hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var $48e41e26b1b512b2$var$weakRefDeref = $48e41e26b1b512b2$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $48e41e26b1b512b2$var$booleanValueOf = Boolean.prototype.valueOf;
var $48e41e26b1b512b2$var$objectToString = Object.prototype.toString;
var $48e41e26b1b512b2$var$functionToString = Function.prototype.toString;
var $48e41e26b1b512b2$var$$match = String.prototype.match;
var $48e41e26b1b512b2$var$$slice = String.prototype.slice;
var $48e41e26b1b512b2$var$$replace = String.prototype.replace;
var $48e41e26b1b512b2$var$$toUpperCase = String.prototype.toUpperCase;
var $48e41e26b1b512b2$var$$toLowerCase = String.prototype.toLowerCase;
var $48e41e26b1b512b2$var$$test = RegExp.prototype.test;
var $48e41e26b1b512b2$var$$concat = Array.prototype.concat;
var $48e41e26b1b512b2$var$$join = Array.prototype.join;
var $48e41e26b1b512b2$var$$arrSlice = Array.prototype.slice;
var $48e41e26b1b512b2$var$$floor = Math.floor;
var $48e41e26b1b512b2$var$bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var $48e41e26b1b512b2$var$gOPS = Object.getOwnPropertySymbols;
var $48e41e26b1b512b2$var$symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var $48e41e26b1b512b2$var$hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var $48e41e26b1b512b2$var$toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === $48e41e26b1b512b2$var$hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
var $48e41e26b1b512b2$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $48e41e26b1b512b2$var$gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $48e41e26b1b512b2$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $48e41e26b1b512b2$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$48e41e26b1b512b2$var$$floor(-num) : $48e41e26b1b512b2$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $48e41e26b1b512b2$var$$slice.call(str, intStr.length + 1);
            return $48e41e26b1b512b2$var$$replace.call(intStr, sepRegex, '$&_') + '.' + $48e41e26b1b512b2$var$$replace.call($48e41e26b1b512b2$var$$replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $48e41e26b1b512b2$var$$replace.call(str, sepRegex, '$&_');
}

var $2DlfF = parcelRequire("2DlfF");
var $48e41e26b1b512b2$var$inspectCustom = $2DlfF.custom;
var $48e41e26b1b512b2$var$inspectSymbol = $48e41e26b1b512b2$var$isSymbol($48e41e26b1b512b2$var$inspectCustom) ? $48e41e26b1b512b2$var$inspectCustom : null;
var $48e41e26b1b512b2$var$quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var $48e41e26b1b512b2$var$quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($48e41e26b1b512b2$var$has(opts, 'quoteStyle') && !$48e41e26b1b512b2$var$has($48e41e26b1b512b2$var$quotes, opts.quoteStyle)) throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($48e41e26b1b512b2$var$has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $48e41e26b1b512b2$var$has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    if ($48e41e26b1b512b2$var$has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($48e41e26b1b512b2$var$has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === 'undefined') return 'undefined';
    if (obj === null) return 'null';
    if (typeof obj === 'boolean') return obj ? 'true' : 'false';
    if (typeof obj === 'string') return $48e41e26b1b512b2$var$inspectString(obj, opts);
    if (typeof obj === 'number') {
        if (obj === 0) return Infinity / obj > 0 ? '0' : '-0';
        var str = String(obj);
        return numericSeparator ? $48e41e26b1b512b2$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? $48e41e26b1b512b2$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') return $48e41e26b1b512b2$var$isArray(obj) ? '[Array]' : '[Object]';
    var indent = $48e41e26b1b512b2$var$getIndent(opts, depth);
    if (typeof seen === 'undefined') seen = [];
    else if ($48e41e26b1b512b2$var$indexOf(seen, obj) >= 0) return '[Circular]';
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $48e41e26b1b512b2$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($48e41e26b1b512b2$var$has(opts, 'quoteStyle')) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === 'function' && !$48e41e26b1b512b2$var$isRegExp(obj)) {
        var name = $48e41e26b1b512b2$var$nameOf(obj);
        var keys = $48e41e26b1b512b2$var$arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $48e41e26b1b512b2$var$$join.call(keys, ', ') + ' }' : '');
    }
    if ($48e41e26b1b512b2$var$isSymbol(obj)) {
        var symString = $48e41e26b1b512b2$var$hasShammedSymbols ? $48e41e26b1b512b2$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : $48e41e26b1b512b2$var$symToString.call(obj);
        return typeof obj === 'object' && !$48e41e26b1b512b2$var$hasShammedSymbols ? $48e41e26b1b512b2$var$markBoxed(symString) : symString;
    }
    if ($48e41e26b1b512b2$var$isElement(obj)) {
        var s = '<' + $48e41e26b1b512b2$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += ' ' + attrs[i].name + '=' + $48e41e26b1b512b2$var$wrapQuotes($48e41e26b1b512b2$var$quote(attrs[i].value), 'double', opts);
        s += '>';
        if (obj.childNodes && obj.childNodes.length) s += '...';
        s += '</' + $48e41e26b1b512b2$var$$toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if ($48e41e26b1b512b2$var$isArray(obj)) {
        if (obj.length === 0) return '[]';
        var xs = $48e41e26b1b512b2$var$arrObjKeys(obj, inspect);
        if (indent && !$48e41e26b1b512b2$var$singleLineValues(xs)) return '[' + $48e41e26b1b512b2$var$indentedJoin(xs, indent) + ']';
        return '[ ' + $48e41e26b1b512b2$var$$join.call(xs, ', ') + ' ]';
    }
    if ($48e41e26b1b512b2$var$isError(obj)) {
        var parts = $48e41e26b1b512b2$var$arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !$48e41e26b1b512b2$var$isEnumerable.call(obj, 'cause')) return '{ [' + String(obj) + '] ' + $48e41e26b1b512b2$var$$join.call($48e41e26b1b512b2$var$$concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        if (parts.length === 0) return '[' + String(obj) + ']';
        return '{ [' + String(obj) + '] ' + $48e41e26b1b512b2$var$$join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if ($48e41e26b1b512b2$var$inspectSymbol && typeof obj[$48e41e26b1b512b2$var$inspectSymbol] === 'function' && $2DlfF) return $2DlfF(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') return obj.inspect();
    }
    if ($48e41e26b1b512b2$var$isMap(obj)) {
        var mapParts = [];
        if ($48e41e26b1b512b2$var$mapForEach) $48e41e26b1b512b2$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return $48e41e26b1b512b2$var$collectionOf('Map', $48e41e26b1b512b2$var$mapSize.call(obj), mapParts, indent);
    }
    if ($48e41e26b1b512b2$var$isSet(obj)) {
        var setParts = [];
        if ($48e41e26b1b512b2$var$setForEach) $48e41e26b1b512b2$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $48e41e26b1b512b2$var$collectionOf('Set', $48e41e26b1b512b2$var$setSize.call(obj), setParts, indent);
    }
    if ($48e41e26b1b512b2$var$isWeakMap(obj)) return $48e41e26b1b512b2$var$weakCollectionOf('WeakMap');
    if ($48e41e26b1b512b2$var$isWeakSet(obj)) return $48e41e26b1b512b2$var$weakCollectionOf('WeakSet');
    if ($48e41e26b1b512b2$var$isWeakRef(obj)) return $48e41e26b1b512b2$var$weakCollectionOf('WeakRef');
    if ($48e41e26b1b512b2$var$isNumber(obj)) return $48e41e26b1b512b2$var$markBoxed(inspect(Number(obj)));
    if ($48e41e26b1b512b2$var$isBigInt(obj)) return $48e41e26b1b512b2$var$markBoxed(inspect($48e41e26b1b512b2$var$bigIntValueOf.call(obj)));
    if ($48e41e26b1b512b2$var$isBoolean(obj)) return $48e41e26b1b512b2$var$markBoxed($48e41e26b1b512b2$var$booleanValueOf.call(obj));
    if ($48e41e26b1b512b2$var$isString(obj)) return $48e41e26b1b512b2$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== 'undefined' && obj === window) return '{ [object Window] }';
    if (typeof globalThis !== 'undefined' && obj === globalThis || typeof $parcel$global !== 'undefined' && obj === $parcel$global) return '{ [object globalThis] }';
    if (!$48e41e26b1b512b2$var$isDate(obj) && !$48e41e26b1b512b2$var$isRegExp(obj)) {
        var ys = $48e41e26b1b512b2$var$arrObjKeys(obj, inspect);
        var isPlainObject = $48e41e26b1b512b2$var$gPO ? $48e41e26b1b512b2$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && $48e41e26b1b512b2$var$toStringTag && Object(obj) === obj && $48e41e26b1b512b2$var$toStringTag in obj ? $48e41e26b1b512b2$var$$slice.call($48e41e26b1b512b2$var$toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $48e41e26b1b512b2$var$$join.call($48e41e26b1b512b2$var$$concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) return tag + '{}';
        if (indent) return tag + '{' + $48e41e26b1b512b2$var$indentedJoin(ys, indent) + '}';
        return tag + '{ ' + $48e41e26b1b512b2$var$$join.call(ys, ', ') + ' }';
    }
    return String(obj);
};
function $48e41e26b1b512b2$var$wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = $48e41e26b1b512b2$var$quotes[style];
    return quoteChar + s + quoteChar;
}
function $48e41e26b1b512b2$var$quote(s) {
    return $48e41e26b1b512b2$var$$replace.call(String(s), /"/g, '&quot;');
}
function $48e41e26b1b512b2$var$canTrustToString(obj) {
    return !$48e41e26b1b512b2$var$toStringTag || !(typeof obj === 'object' && ($48e41e26b1b512b2$var$toStringTag in obj || typeof obj[$48e41e26b1b512b2$var$toStringTag] !== 'undefined'));
}
function $48e41e26b1b512b2$var$isArray(obj) {
    return $48e41e26b1b512b2$var$toStr(obj) === '[object Array]' && $48e41e26b1b512b2$var$canTrustToString(obj);
}
function $48e41e26b1b512b2$var$isDate(obj) {
    return $48e41e26b1b512b2$var$toStr(obj) === '[object Date]' && $48e41e26b1b512b2$var$canTrustToString(obj);
}
function $48e41e26b1b512b2$var$isRegExp(obj) {
    return $48e41e26b1b512b2$var$toStr(obj) === '[object RegExp]' && $48e41e26b1b512b2$var$canTrustToString(obj);
}
function $48e41e26b1b512b2$var$isError(obj) {
    return $48e41e26b1b512b2$var$toStr(obj) === '[object Error]' && $48e41e26b1b512b2$var$canTrustToString(obj);
}
function $48e41e26b1b512b2$var$isString(obj) {
    return $48e41e26b1b512b2$var$toStr(obj) === '[object String]' && $48e41e26b1b512b2$var$canTrustToString(obj);
}
function $48e41e26b1b512b2$var$isNumber(obj) {
    return $48e41e26b1b512b2$var$toStr(obj) === '[object Number]' && $48e41e26b1b512b2$var$canTrustToString(obj);
}
function $48e41e26b1b512b2$var$isBoolean(obj) {
    return $48e41e26b1b512b2$var$toStr(obj) === '[object Boolean]' && $48e41e26b1b512b2$var$canTrustToString(obj);
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $48e41e26b1b512b2$var$isSymbol(obj) {
    if ($48e41e26b1b512b2$var$hasShammedSymbols) return obj && typeof obj === 'object' && obj instanceof Symbol;
    if (typeof obj === 'symbol') return true;
    if (!obj || typeof obj !== 'object' || !$48e41e26b1b512b2$var$symToString) return false;
    try {
        $48e41e26b1b512b2$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $48e41e26b1b512b2$var$isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !$48e41e26b1b512b2$var$bigIntValueOf) return false;
    try {
        $48e41e26b1b512b2$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $48e41e26b1b512b2$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $48e41e26b1b512b2$var$has(obj, key) {
    return $48e41e26b1b512b2$var$hasOwn.call(obj, key);
}
function $48e41e26b1b512b2$var$toStr(obj) {
    return $48e41e26b1b512b2$var$objectToString.call(obj);
}
function $48e41e26b1b512b2$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $48e41e26b1b512b2$var$$match.call($48e41e26b1b512b2$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $48e41e26b1b512b2$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $48e41e26b1b512b2$var$isMap(x) {
    if (!$48e41e26b1b512b2$var$mapSize || !x || typeof x !== 'object') return false;
    try {
        $48e41e26b1b512b2$var$mapSize.call(x);
        try {
            $48e41e26b1b512b2$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $48e41e26b1b512b2$var$isWeakMap(x) {
    if (!$48e41e26b1b512b2$var$weakMapHas || !x || typeof x !== 'object') return false;
    try {
        $48e41e26b1b512b2$var$weakMapHas.call(x, $48e41e26b1b512b2$var$weakMapHas);
        try {
            $48e41e26b1b512b2$var$weakSetHas.call(x, $48e41e26b1b512b2$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $48e41e26b1b512b2$var$isWeakRef(x) {
    if (!$48e41e26b1b512b2$var$weakRefDeref || !x || typeof x !== 'object') return false;
    try {
        $48e41e26b1b512b2$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $48e41e26b1b512b2$var$isSet(x) {
    if (!$48e41e26b1b512b2$var$setSize || !x || typeof x !== 'object') return false;
    try {
        $48e41e26b1b512b2$var$setSize.call(x);
        try {
            $48e41e26b1b512b2$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $48e41e26b1b512b2$var$isWeakSet(x) {
    if (!$48e41e26b1b512b2$var$weakSetHas || !x || typeof x !== 'object') return false;
    try {
        $48e41e26b1b512b2$var$weakSetHas.call(x, $48e41e26b1b512b2$var$weakSetHas);
        try {
            $48e41e26b1b512b2$var$weakMapHas.call(x, $48e41e26b1b512b2$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $48e41e26b1b512b2$var$isElement(x) {
    if (!x || typeof x !== 'object') return false;
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) return true;
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}
function $48e41e26b1b512b2$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return $48e41e26b1b512b2$var$inspectString($48e41e26b1b512b2$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = $48e41e26b1b512b2$var$quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $48e41e26b1b512b2$var$$replace.call($48e41e26b1b512b2$var$$replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, $48e41e26b1b512b2$var$lowbyte);
    return $48e41e26b1b512b2$var$wrapQuotes(s, 'single', opts);
}
function $48e41e26b1b512b2$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) return '\\' + x;
    return '\\x' + (n < 0x10 ? '0' : '') + $48e41e26b1b512b2$var$$toUpperCase.call(n.toString(16));
}
function $48e41e26b1b512b2$var$markBoxed(str) {
    return 'Object(' + str + ')';
}
function $48e41e26b1b512b2$var$weakCollectionOf(type) {
    return type + ' { ? }';
}
function $48e41e26b1b512b2$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $48e41e26b1b512b2$var$indentedJoin(entries, indent) : $48e41e26b1b512b2$var$$join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}
function $48e41e26b1b512b2$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($48e41e26b1b512b2$var$indexOf(xs[i], '\n') >= 0) return false;
    }
    return true;
}
function $48e41e26b1b512b2$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') baseIndent = '\t';
    else if (typeof opts.indent === 'number' && opts.indent > 0) baseIndent = $48e41e26b1b512b2$var$$join.call(Array(opts.indent + 1), ' ');
    else return null;
    return {
        base: baseIndent,
        prev: $48e41e26b1b512b2$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $48e41e26b1b512b2$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return '';
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $48e41e26b1b512b2$var$$join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}
function $48e41e26b1b512b2$var$arrObjKeys(obj, inspect) {
    var isArr = $48e41e26b1b512b2$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $48e41e26b1b512b2$var$has(obj, i) ? inspect(obj[i], obj) : '';
    }
    var syms = typeof $48e41e26b1b512b2$var$gOPS === 'function' ? $48e41e26b1b512b2$var$gOPS(obj) : [];
    var symMap;
    if ($48e41e26b1b512b2$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap['$' + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$48e41e26b1b512b2$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($48e41e26b1b512b2$var$hasShammedSymbols && symMap['$' + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($48e41e26b1b512b2$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        else xs.push(key + ': ' + inspect(obj[key], obj));
    }
    if (typeof $48e41e26b1b512b2$var$gOPS === 'function') {
        for(var j = 0; j < syms.length; j++)if ($48e41e26b1b512b2$var$isEnumerable.call(obj, syms[j])) xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});
parcelRegister("2DlfF", function(module, exports) {
"use strict";

});


parcelRegister("dNUki", function(module, exports) {
'use strict';

var $6fZQw = parcelRequire("6fZQw");

var $aqgEe = parcelRequire("aqgEe");
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('./list.d.ts').listGetNode} */ // eslint-disable-next-line consistent-return
var $a0cb8b39144b2d36$var$listGetNode = function(list, key, isDelete) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    // eslint-disable-next-line eqeqeq
    for(; (curr = prev.next) != null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        if (!isDelete) {
            // eslint-disable-next-line no-extra-parens
            curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
            list.next = curr; // eslint-disable-line no-param-reassign
        }
        return curr;
    }
};
/** @type {import('./list.d.ts').listGet} */ var $a0cb8b39144b2d36$var$listGet = function(objects, key) {
    if (!objects) return void 0;
    var node = $a0cb8b39144b2d36$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */ var $a0cb8b39144b2d36$var$listSet = function(objects, key, value) {
    var node = $a0cb8b39144b2d36$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('./list.d.ts').listHas} */ var $a0cb8b39144b2d36$var$listHas = function(objects, key) {
    if (!objects) return false;
    return !!$a0cb8b39144b2d36$var$listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */ // eslint-disable-next-line consistent-return
var $a0cb8b39144b2d36$var$listDelete = function(objects, key) {
    if (objects) return $a0cb8b39144b2d36$var$listGetNode(objects, key, true);
};
/** @type {import('.')} */ module.exports = function getSideChannelList() {
    /** @typedef {ReturnType<typeof getSideChannelList>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $aqgEe('Side channel does not contain ' + $6fZQw(key));
        },
        'delete': function(key) {
            var root = $o && $o.next;
            var deletedNode = $a0cb8b39144b2d36$var$listDelete($o, key);
            if (deletedNode && root && root === deletedNode) $o = void 0;
            return !!deletedNode;
        },
        get: function(key) {
            return $a0cb8b39144b2d36$var$listGet($o, key);
        },
        has: function(key) {
            return $a0cb8b39144b2d36$var$listHas($o, key);
        },
        set: function(key, value) {
            if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
            $o = {
                next: void 0
            };
            // eslint-disable-next-line no-extra-parens
            $a0cb8b39144b2d36$var$listSet(/** @type {NonNullable<typeof $o>} */ $o, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};

});

parcelRegister("4HvO4", function(module, exports) {
'use strict';

var $1XDuP = parcelRequire("1XDuP");

var $17AGv = parcelRequire("17AGv");

var $6fZQw = parcelRequire("6fZQw");

var $aqgEe = parcelRequire("aqgEe");
var $36c3d9b04b18d4a5$var$$Map = $1XDuP('%Map%', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */ var $36c3d9b04b18d4a5$var$$mapGet = $17AGv('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */ var $36c3d9b04b18d4a5$var$$mapSet = $17AGv('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $36c3d9b04b18d4a5$var$$mapHas = $17AGv('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $36c3d9b04b18d4a5$var$$mapDelete = $17AGv('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */ var $36c3d9b04b18d4a5$var$$mapSize = $17AGv('Map.prototype.size', true);
/** @type {import('.')} */ module.exports = !!$36c3d9b04b18d4a5$var$$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
    /** @typedef {ReturnType<typeof getSideChannelMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {Map<K, V> | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $aqgEe('Side channel does not contain ' + $6fZQw(key));
        },
        'delete': function(key) {
            if ($m) {
                var result = $36c3d9b04b18d4a5$var$$mapDelete($m, key);
                if ($36c3d9b04b18d4a5$var$$mapSize($m) === 0) $m = void 0;
                return result;
            }
            return false;
        },
        get: function(key) {
            if ($m) return $36c3d9b04b18d4a5$var$$mapGet($m, key);
        },
        has: function(key) {
            if ($m) return $36c3d9b04b18d4a5$var$$mapHas($m, key);
            return false;
        },
        set: function(key, value) {
            if (!$m) // @ts-expect-error TS can't handle narrowing a variable inside a closure
            $m = new $36c3d9b04b18d4a5$var$$Map();
            $36c3d9b04b18d4a5$var$$mapSet($m, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why TS is erroring here
    return channel;
};

});
parcelRegister("1XDuP", function(module, exports) {
'use strict';
var $16d9f04334554de1$var$undefined1;

var $kXw23 = parcelRequire("kXw23");

var $fgK0h = parcelRequire("fgK0h");

var $88hUK = parcelRequire("88hUK");

var $6RkYl = parcelRequire("6RkYl");

var $lnoh5 = parcelRequire("lnoh5");

var $aqgEe = parcelRequire("aqgEe");

var $i22cS = parcelRequire("i22cS");
var $16d9f04334554de1$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $16d9f04334554de1$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $16d9f04334554de1$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};
var $16d9f04334554de1$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($16d9f04334554de1$var$$gOPD) try {
    $16d9f04334554de1$var$$gOPD({}, '');
} catch (e) {
    $16d9f04334554de1$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $16d9f04334554de1$var$throwTypeError = function() {
    throw new $aqgEe();
};
var $16d9f04334554de1$var$ThrowTypeError = $16d9f04334554de1$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $16d9f04334554de1$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $16d9f04334554de1$var$$gOPD(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $16d9f04334554de1$var$throwTypeError;
        }
    }
}() : $16d9f04334554de1$var$throwTypeError;

var $16d9f04334554de1$var$hasSymbols = (parcelRequire("ejwPN"))();

var $16d9f04334554de1$var$hasProto = (parcelRequire("er0MT"))();
var $16d9f04334554de1$var$getProto = Object.getPrototypeOf || ($16d9f04334554de1$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $16d9f04334554de1$var$needsEval = {};
var $16d9f04334554de1$var$TypedArray = typeof Uint8Array === 'undefined' || !$16d9f04334554de1$var$getProto ? undefined : $16d9f04334554de1$var$getProto(Uint8Array);
var $16d9f04334554de1$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $16d9f04334554de1$var$hasSymbols && $16d9f04334554de1$var$getProto ? $16d9f04334554de1$var$getProto([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $16d9f04334554de1$var$needsEval,
    '%AsyncGenerator%': $16d9f04334554de1$var$needsEval,
    '%AsyncGeneratorFunction%': $16d9f04334554de1$var$needsEval,
    '%AsyncIteratorPrototype%': $16d9f04334554de1$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $kXw23,
    '%eval%': eval,
    '%EvalError%': $fgK0h,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $16d9f04334554de1$var$$Function,
    '%GeneratorFunction%': $16d9f04334554de1$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $16d9f04334554de1$var$hasSymbols && $16d9f04334554de1$var$getProto ? $16d9f04334554de1$var$getProto($16d9f04334554de1$var$getProto([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$16d9f04334554de1$var$hasSymbols || !$16d9f04334554de1$var$getProto ? undefined : $16d9f04334554de1$var$getProto(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': Object,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $88hUK,
    '%ReferenceError%': $6RkYl,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$16d9f04334554de1$var$hasSymbols || !$16d9f04334554de1$var$getProto ? undefined : $16d9f04334554de1$var$getProto(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $16d9f04334554de1$var$hasSymbols && $16d9f04334554de1$var$getProto ? $16d9f04334554de1$var$getProto(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $16d9f04334554de1$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $lnoh5,
    '%ThrowTypeError%': $16d9f04334554de1$var$ThrowTypeError,
    '%TypedArray%': $16d9f04334554de1$var$TypedArray,
    '%TypeError%': $aqgEe,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $i22cS,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};
if ($16d9f04334554de1$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $16d9f04334554de1$var$errorProto = $16d9f04334554de1$var$getProto($16d9f04334554de1$var$getProto(e));
    $16d9f04334554de1$var$INTRINSICS['%Error.prototype%'] = $16d9f04334554de1$var$errorProto;
}
var $16d9f04334554de1$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $16d9f04334554de1$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $16d9f04334554de1$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $16d9f04334554de1$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $16d9f04334554de1$var$getProto) value = $16d9f04334554de1$var$getProto(gen.prototype);
    }
    $16d9f04334554de1$var$INTRINSICS[name] = value;
    return value;
};
var $16d9f04334554de1$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $fa7Ft = parcelRequire("fa7Ft");

var $h7IDx = parcelRequire("h7IDx");
var $16d9f04334554de1$var$$concat = $fa7Ft.call(Function.call, Array.prototype.concat);
var $16d9f04334554de1$var$$spliceApply = $fa7Ft.call(Function.apply, Array.prototype.splice);
var $16d9f04334554de1$var$$replace = $fa7Ft.call(Function.call, String.prototype.replace);
var $16d9f04334554de1$var$$strSlice = $fa7Ft.call(Function.call, String.prototype.slice);
var $16d9f04334554de1$var$$exec = $fa7Ft.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $16d9f04334554de1$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $16d9f04334554de1$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $16d9f04334554de1$var$stringToPath = function stringToPath(string) {
    var first = $16d9f04334554de1$var$$strSlice(string, 0, 1);
    var last = $16d9f04334554de1$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $lnoh5('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $lnoh5('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $16d9f04334554de1$var$$replace(string, $16d9f04334554de1$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $16d9f04334554de1$var$$replace(subString, $16d9f04334554de1$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $16d9f04334554de1$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($h7IDx($16d9f04334554de1$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $16d9f04334554de1$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($h7IDx($16d9f04334554de1$var$INTRINSICS, intrinsicName)) {
        var value = $16d9f04334554de1$var$INTRINSICS[intrinsicName];
        if (value === $16d9f04334554de1$var$needsEval) value = $16d9f04334554de1$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $aqgEe('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $lnoh5('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $aqgEe('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $aqgEe('"allowMissing" argument must be a boolean');
    if ($16d9f04334554de1$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $lnoh5('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $16d9f04334554de1$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $16d9f04334554de1$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $16d9f04334554de1$var$$spliceApply(parts, $16d9f04334554de1$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $16d9f04334554de1$var$$strSlice(part, 0, 1);
        var last = $16d9f04334554de1$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $lnoh5('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($h7IDx($16d9f04334554de1$var$INTRINSICS, intrinsicRealName)) value = $16d9f04334554de1$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $aqgEe('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($16d9f04334554de1$var$$gOPD && i + 1 >= parts.length) {
                var desc = $16d9f04334554de1$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $h7IDx(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $16d9f04334554de1$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("kXw23", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("fgK0h", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("88hUK", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("6RkYl", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("lnoh5", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("i22cS", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("ejwPN", function(module, exports) {
'use strict';
var $02b074e430b83131$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $lPkww = parcelRequire("lPkww");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $02b074e430b83131$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $02b074e430b83131$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $lPkww();
};

});
parcelRegister("lPkww", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("er0MT", function(module, exports) {
'use strict';
var $a82432b516692562$var$test = {
    __proto__: null,
    foo: {}
};
// @ts-expect-error: TS errors on an inherited property for some reason
var $a82432b516692562$var$result = {
    __proto__: $a82432b516692562$var$test
}.foo === $a82432b516692562$var$test.foo && !($a82432b516692562$var$test instanceof Object);
/** @type {import('.')} */ module.exports = function hasProto() {
    return $a82432b516692562$var$result;
};

});

parcelRegister("fa7Ft", function(module, exports) {
'use strict';

var $57Aef = parcelRequire("57Aef");
module.exports = Function.prototype.bind || $57Aef;

});
parcelRegister("57Aef", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $3ba9b580398bc089$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $3ba9b580398bc089$var$toStr = Object.prototype.toString;
var $3ba9b580398bc089$var$max = Math.max;
var $3ba9b580398bc089$var$funcType = '[object Function]';
var $3ba9b580398bc089$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $3ba9b580398bc089$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $3ba9b580398bc089$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $3ba9b580398bc089$var$toStr.apply(target) !== $3ba9b580398bc089$var$funcType) throw new TypeError($3ba9b580398bc089$var$ERROR_MESSAGE + target);
    var args = $3ba9b580398bc089$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $3ba9b580398bc089$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $3ba9b580398bc089$var$concatty(args, arguments));
    };
    var boundLength = $3ba9b580398bc089$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $3ba9b580398bc089$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("h7IDx", function(module, exports) {
'use strict';
var $c775b70b16a6b97e$var$call = Function.prototype.call;
var $c775b70b16a6b97e$var$$hasOwn = Object.prototype.hasOwnProperty;

var $fa7Ft = parcelRequire("fa7Ft");
/** @type {import('.')} */ module.exports = $fa7Ft.call($c775b70b16a6b97e$var$call, $c775b70b16a6b97e$var$$hasOwn);

});


parcelRegister("17AGv", function(module, exports) {
'use strict';

var $1XDuP = parcelRequire("1XDuP");

var $8TVSL = parcelRequire("8TVSL");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $0d12e6ad32e7745d$var$$indexOf = $8TVSL([
    $1XDuP('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $1XDuP(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $0d12e6ad32e7745d$var$$indexOf(name, '.prototype.') > -1) return $8TVSL(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});
parcelRegister("8TVSL", function(module, exports) {
'use strict';

var $fa7Ft = parcelRequire("fa7Ft");

var $aqgEe = parcelRequire("aqgEe");

var $VN5ot = parcelRequire("VN5ot");

var $jtJUh = parcelRequire("jtJUh");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $aqgEe('a function is required');
    return $jtJUh($fa7Ft, $VN5ot, args);
};

});
parcelRegister("VN5ot", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("jtJUh", function(module, exports) {
'use strict';

var $fa7Ft = parcelRequire("fa7Ft");

var $gtj11 = parcelRequire("gtj11");

var $VN5ot = parcelRequire("VN5ot");

var $2yj6S = parcelRequire("2yj6S");
/** @type {import('./actualApply')} */ module.exports = $2yj6S || $fa7Ft.call($VN5ot, $gtj11);

});
parcelRegister("gtj11", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("2yj6S", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("jTVBv", function(module, exports) {
'use strict';

var $1XDuP = parcelRequire("1XDuP");

var $17AGv = parcelRequire("17AGv");

var $6fZQw = parcelRequire("6fZQw");

var $4HvO4 = parcelRequire("4HvO4");

var $aqgEe = parcelRequire("aqgEe");
var $e7cfd64e5a68059a$var$$WeakMap = $1XDuP('%WeakMap%', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */ var $e7cfd64e5a68059a$var$$weakMapGet = $17AGv('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */ var $e7cfd64e5a68059a$var$$weakMapSet = $17AGv('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $e7cfd64e5a68059a$var$$weakMapHas = $17AGv('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $e7cfd64e5a68059a$var$$weakMapDelete = $17AGv('WeakMap.prototype.delete', true);
/** @type {import('.')} */ module.exports = $e7cfd64e5a68059a$var$$WeakMap ? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
    /** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {WeakMap<K & object, V> | undefined} */ var $wm;
    /** @type {Channel | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $aqgEe('Side channel does not contain ' + $6fZQw(key));
        },
        'delete': function(key) {
            if ($e7cfd64e5a68059a$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $e7cfd64e5a68059a$var$$weakMapDelete($wm, key);
            } else if ($4HvO4) {
                if ($m) return $m['delete'](key);
            }
            return false;
        },
        get: function(key) {
            if ($e7cfd64e5a68059a$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $e7cfd64e5a68059a$var$$weakMapGet($wm, key);
            }
            return $m && $m.get(key);
        },
        has: function(key) {
            if ($e7cfd64e5a68059a$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $e7cfd64e5a68059a$var$$weakMapHas($wm, key);
            }
            return !!$m && $m.has(key);
        },
        set: function(key, value) {
            if ($e7cfd64e5a68059a$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if (!$wm) $wm = new $e7cfd64e5a68059a$var$$WeakMap();
                $e7cfd64e5a68059a$var$$weakMapSet($wm, key, value);
            } else if ($4HvO4) {
                if (!$m) $m = $4HvO4();
                // eslint-disable-next-line no-extra-parens
                /** @type {NonNullable<typeof $m>} */ $m.set(key, value);
            }
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
} : $4HvO4;

});


parcelRegister("cOjo3", function(module, exports) {
'use strict';

var $8T2UJ = parcelRequire("8T2UJ");
var $953931685045f391$var$has = Object.prototype.hasOwnProperty;
var $953931685045f391$var$isArray = Array.isArray;
var $953931685045f391$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    return array;
}();
var $953931685045f391$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($953931685045f391$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== 'undefined') compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $953931685045f391$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? {
        __proto__: null
    } : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== 'undefined') obj[i] = source[i];
    return obj;
};
var $953931685045f391$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== 'object' && typeof source !== 'function') {
        if ($953931685045f391$var$isArray(target)) target.push(source);
        else if (target && typeof target === 'object') {
            if (options && (options.plainObjects || options.allowPrototypes) || !$953931685045f391$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== 'object') return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($953931685045f391$var$isArray(target) && !$953931685045f391$var$isArray(source)) mergeTarget = $953931685045f391$var$arrayToObject(target, options);
    if ($953931685045f391$var$isArray(target) && $953931685045f391$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($953931685045f391$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($953931685045f391$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $953931685045f391$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $953931685045f391$var$decode = function(str, defaultDecoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $953931685045f391$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $953931685045f391$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === 'symbol') string = Symbol.prototype.toString.call(str);
    else if (typeof str !== 'string') string = String(str);
    if (charset === 'iso-8859-1') return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
    });
    var out = '';
    for(var j = 0; j < string.length; j += $953931685045f391$var$limit){
        var segment = string.length >= $953931685045f391$var$limit ? string.slice(j, j + $953931685045f391$var$limit) : string;
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $8T2UJ.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $953931685045f391$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $953931685045f391$var$hexTable[0xC0 | c >> 6] + $953931685045f391$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $953931685045f391$var$hexTable[0xE0 | c >> 12] + $953931685045f391$var$hexTable[0x80 | c >> 6 & 0x3F] + $953931685045f391$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = $953931685045f391$var$hexTable[0xF0 | c >> 18] + $953931685045f391$var$hexTable[0x80 | c >> 12 & 0x3F] + $953931685045f391$var$hexTable[0x80 | c >> 6 & 0x3F] + $953931685045f391$var$hexTable[0x80 | c & 0x3F];
        }
        out += arr.join('');
    }
    return out;
};
var $953931685045f391$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: 'o'
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $953931685045f391$var$compactQueue(queue);
    return value;
};
var $953931685045f391$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};
var $953931685045f391$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $953931685045f391$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $953931685045f391$var$maybeMap = function maybeMap(val, fn) {
    if ($953931685045f391$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: $953931685045f391$var$arrayToObject,
    assign: $953931685045f391$var$assign,
    combine: $953931685045f391$var$combine,
    compact: $953931685045f391$var$compact,
    decode: $953931685045f391$var$decode,
    encode: $953931685045f391$var$encode,
    isBuffer: $953931685045f391$var$isBuffer,
    isRegExp: $953931685045f391$var$isRegExp,
    maybeMap: $953931685045f391$var$maybeMap,
    merge: $953931685045f391$var$merge
};

});
parcelRegister("8T2UJ", function(module, exports) {
'use strict';
var $6785b875ee9890b7$var$replace = String.prototype.replace;
var $6785b875ee9890b7$var$percentTwenties = /%20/g;
var $6785b875ee9890b7$var$Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};
module.exports = {
    'default': $6785b875ee9890b7$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $6785b875ee9890b7$var$replace.call(value, $6785b875ee9890b7$var$percentTwenties, '+');
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $6785b875ee9890b7$var$Format.RFC1738,
    RFC3986: $6785b875ee9890b7$var$Format.RFC3986
};

});



parcelRegister("5GHPN", function(module, exports) {
'use strict';

var $cOjo3 = parcelRequire("cOjo3");
var $4242e099702c4405$var$has = Object.prototype.hasOwnProperty;
var $4242e099702c4405$var$isArray = Array.isArray;
var $4242e099702c4405$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $cOjo3.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictNullHandling: false,
    throwOnLimitExceeded: false
};
var $4242e099702c4405$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $4242e099702c4405$var$parseArrayValue = function(val, options, currentArrayLength) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) return val.split(',');
    if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $4242e099702c4405$var$isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $4242e099702c4405$var$charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
var $4242e099702c4405$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, options.throwOnLimitExceeded ? limit + 1 : limit);
    if (options.throwOnLimitExceeded && parts.length > limit) throw new RangeError('Parameter limit exceeded. Only ' + limit + ' parameter' + (limit === 1 ? '' : 's') + ' allowed.');
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf('utf8=') === 0) {
            if (parts[i] === $4242e099702c4405$var$charsetSentinel) charset = 'utf-8';
            else if (parts[i] === $4242e099702c4405$var$isoSentinel) charset = 'iso-8859-1';
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, $4242e099702c4405$var$defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), $4242e099702c4405$var$defaults.decoder, charset, 'key');
            val = $cOjo3.maybeMap($4242e099702c4405$var$parseArrayValue(part.slice(pos + 1), options, $4242e099702c4405$var$isArray(obj[key]) ? obj[key].length : 0), function(encodedVal) {
                return options.decoder(encodedVal, $4242e099702c4405$var$defaults.decoder, charset, 'value');
            });
        }
        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') val = $4242e099702c4405$var$interpretNumericEntities(String(val));
        if (part.indexOf('[]=') > -1) val = $4242e099702c4405$var$isArray(val) ? [
            val
        ] : val;
        var existing = $4242e099702c4405$var$has.call(obj, key);
        if (existing && options.duplicates === 'combine') obj[key] = $cOjo3.combine(obj[key], val);
        else if (!existing || options.duplicates === 'last') obj[key] = val;
    }
    return obj;
};
var $4242e099702c4405$var$parseObject = function(chain, val, options, valuesParsed) {
    var currentArrayLength = 0;
    if (chain.length > 0 && chain[chain.length - 1] === '[]') {
        var parentKey = chain.slice(0, -1).join('');
        currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
    }
    var leaf = valuesParsed ? val : $4242e099702c4405$var$parseArrayValue(val, options, currentArrayLength);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === '[]' && options.parseArrays) obj = options.allowEmptyArrays && (leaf === '' || options.strictNullHandling && leaf === null) ? [] : $cOjo3.combine([], leaf);
        else {
            obj = options.plainObjects ? {
                __proto__: null
            } : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === '') obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== '__proto__') obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $4242e099702c4405$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $4242e099702c4405$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $4242e099702c4405$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, check strictDepth option for throw, else just add whatever is left
    if (segment) {
        if (options.strictDepth === true) throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        keys.push('[' + key.slice(segment.index) + ']');
    }
    return $4242e099702c4405$var$parseObject(keys, val, options, valuesParsed);
};
var $4242e099702c4405$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $4242e099702c4405$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') throw new TypeError('Decoder has to be a function.');
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    if (typeof opts.throwOnLimitExceeded !== 'undefined' && typeof opts.throwOnLimitExceeded !== 'boolean') throw new TypeError('`throwOnLimitExceeded` option must be a boolean');
    var charset = typeof opts.charset === 'undefined' ? $4242e099702c4405$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === 'undefined' ? $4242e099702c4405$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') throw new TypeError('The duplicates option must be either combine, first, or last');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : $4242e099702c4405$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $4242e099702c4405$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : $4242e099702c4405$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : $4242e099702c4405$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : $4242e099702c4405$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $4242e099702c4405$var$defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : $4242e099702c4405$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : $4242e099702c4405$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : $4242e099702c4405$var$defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || $cOjo3.isRegExp(opts.delimiter) ? opts.delimiter : $4242e099702c4405$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : $4242e099702c4405$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : $4242e099702c4405$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : $4242e099702c4405$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : $4242e099702c4405$var$defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : $4242e099702c4405$var$defaults.strictDepth,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $4242e099702c4405$var$defaults.strictNullHandling,
        throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === 'boolean' ? opts.throwOnLimitExceeded : false
    };
};
module.exports = function(str, opts) {
    var options = $4242e099702c4405$var$normalizeParseOptions(opts);
    if (str === '' || str === null || typeof str === 'undefined') return options.plainObjects ? {
        __proto__: null
    } : {};
    var tempObj = typeof str === 'string' ? $4242e099702c4405$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? {
        __proto__: null
    } : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $4242e099702c4405$var$parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = $cOjo3.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $cOjo3.compact(obj);
};

});



parcelRegister("87DGy", function(module, exports) {
"use strict";
var $5e9dc2de8bafd96e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5e9dc2de8bafd96e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $5e9dc2de8bafd96e$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Storage = module.exports.Log = module.exports.EventLogger = module.exports.Diagnostics = void 0;



Object.defineProperty(module.exports, "Diagnostics", {
    enumerable: true,
    get: function() {
        return (parcelRequire("6wVPT")).Diagnostics;
    }
});

var $jgDpr = parcelRequire("jgDpr");
Object.defineProperty(module.exports, "EventLogger", {
    enumerable: true,
    get: function() {
        return $jgDpr.EventLogger;
    }
});

Object.defineProperty(module.exports, "Log", {
    enumerable: true,
    get: function() {
        return (parcelRequire("buErx")).Log;
    }
});


Object.defineProperty(module.exports, "Storage", {
    enumerable: true,
    get: function() {
        return (parcelRequire("cR1Bx")).Storage;
    }
});

$5e9dc2de8bafd96e$var$__exportStar((parcelRequire("7txeW")), module.exports);

$5e9dc2de8bafd96e$var$__exportStar((parcelRequire("8GMdc")), module.exports);

$5e9dc2de8bafd96e$var$__exportStar((parcelRequire("aQwjw")), module.exports);

$5e9dc2de8bafd96e$var$__exportStar((parcelRequire("lkT55")), module.exports);

$5e9dc2de8bafd96e$var$__exportStar((parcelRequire("6wVPT")), module.exports);

$5e9dc2de8bafd96e$var$__exportStar((parcelRequire("a0k0o")), module.exports);

$5e9dc2de8bafd96e$var$__exportStar((parcelRequire("g7zKQ")), module.exports);

$5e9dc2de8bafd96e$var$__exportStar((parcelRequire("4jiS5")), module.exports);

$5e9dc2de8bafd96e$var$__exportStar((parcelRequire("8FnMf")), module.exports);

$5e9dc2de8bafd96e$var$__exportStar((parcelRequire("lgqvU")), module.exports);

$5e9dc2de8bafd96e$var$__exportStar((parcelRequire("bPlJK")), module.exports);

$5e9dc2de8bafd96e$var$__exportStar((parcelRequire("buErx")), module.exports);

$5e9dc2de8bafd96e$var$__exportStar((parcelRequire("bwIp1")), module.exports);

$5e9dc2de8bafd96e$var$__exportStar((parcelRequire("4o8Rq")), module.exports);

$5e9dc2de8bafd96e$var$__exportStar((parcelRequire("g3P4K")), module.exports);

$5e9dc2de8bafd96e$var$__exportStar((parcelRequire("5ZbOq")), module.exports);

$5e9dc2de8bafd96e$var$__exportStar((parcelRequire("l2EVs")), module.exports);

$5e9dc2de8bafd96e$var$__exportStar((parcelRequire("ek3V7")), module.exports);

$5e9dc2de8bafd96e$var$__exportStar((parcelRequire("h9lZZ")), module.exports);

$5e9dc2de8bafd96e$var$__exportStar((parcelRequire("enDXY")), module.exports);

$5e9dc2de8bafd96e$var$__exportStar((parcelRequire("1EWFi")), module.exports);

$5e9dc2de8bafd96e$var$__exportStar((parcelRequire("j6vKQ")), module.exports);

$5e9dc2de8bafd96e$var$__exportStar((parcelRequire("4Hfj9")), module.exports);

$5e9dc2de8bafd96e$var$__exportStar((parcelRequire("3EHbk")), module.exports);

$5e9dc2de8bafd96e$var$__exportStar((parcelRequire("ccTlk")), module.exports);

$5e9dc2de8bafd96e$var$__exportStar((parcelRequire("354Xc")), module.exports);

$5e9dc2de8bafd96e$var$__exportStar((parcelRequire("3ZDsH")), module.exports);

$5e9dc2de8bafd96e$var$__exportStar((parcelRequire("56liM")), module.exports);

$5e9dc2de8bafd96e$var$__exportStar((parcelRequire("47Ws6")), module.exports);

$5e9dc2de8bafd96e$var$__exportStar((parcelRequire("g1Z01")), module.exports);

$5e9dc2de8bafd96e$var$__exportStar((parcelRequire("dbLnW")), module.exports);

$5e9dc2de8bafd96e$var$__exportStar((parcelRequire("sTwvd")), module.exports);

$5e9dc2de8bafd96e$var$__exportStar((parcelRequire("cR1Bx")), module.exports);

$5e9dc2de8bafd96e$var$__exportStar((parcelRequire("7UR8T")), module.exports);

$5e9dc2de8bafd96e$var$__exportStar((parcelRequire("8r058")), module.exports);

$5e9dc2de8bafd96e$var$__exportStar((parcelRequire("f6jUl")), module.exports);

$5e9dc2de8bafd96e$var$__exportStar((parcelRequire("3xGNu")), module.exports);

$5e9dc2de8bafd96e$var$__exportStar((parcelRequire("8oyuH")), module.exports);

$5e9dc2de8bafd96e$var$__exportStar((parcelRequire("4hmQg")), module.exports);

$5e9dc2de8bafd96e$var$__exportStar((parcelRequire("jPxYd")), module.exports);
Object.assign((0, (parcelRequire("7txeW"))._getStatsigGlobal)(), {
    Log: (parcelRequire("buErx")).Log,
    SDK_VERSION: (parcelRequire("3ZDsH")).SDK_VERSION
});

});
parcelRegister("7txeW", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ var $57150696beab2236$var$_a, $57150696beab2236$var$_b, $57150696beab2236$var$_c;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getInstance = module.exports._getStatsigGlobalFlag = module.exports._getStatsigGlobal = void 0;

var $buErx = parcelRequire("buErx");
const $57150696beab2236$var$_getStatsigGlobal = ()=>{
    // Avoid ReferenceError, which is happening with Cloudflare pages
    try {
        return typeof __STATSIG__ !== 'undefined' ? __STATSIG__ : $57150696beab2236$var$statsigGlobal;
    } catch (e) {
        return $57150696beab2236$var$statsigGlobal;
    }
};
module.exports._getStatsigGlobal = $57150696beab2236$var$_getStatsigGlobal;
const $57150696beab2236$var$_getStatsigGlobalFlag = (flag)=>{
    return (0, module.exports._getStatsigGlobal)()[flag];
};
module.exports._getStatsigGlobalFlag = $57150696beab2236$var$_getStatsigGlobalFlag;
const $57150696beab2236$var$_getInstance = (sdkKey)=>{
    const gbl = (0, module.exports._getStatsigGlobal)();
    if (!sdkKey) {
        if (gbl.instances && Object.keys(gbl.instances).length > 1) $buErx.Log.warn('Call made to Statsig global instance without an SDK key but there is more than one client instance. If you are using mulitple clients, please specify the SDK key.');
        return gbl.firstInstance;
    }
    return gbl.instances && gbl.instances[sdkKey];
};
module.exports._getInstance = $57150696beab2236$var$_getInstance;
const $57150696beab2236$var$GLOBAL_KEY = '__STATSIG__';
const $57150696beab2236$var$_window = typeof window !== 'undefined' ? window : {};
const $57150696beab2236$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : {};
const $57150696beab2236$var$_globalThis = typeof globalThis !== 'undefined' ? globalThis : {};
const $57150696beab2236$var$statsigGlobal = ($57150696beab2236$var$_c = ($57150696beab2236$var$_b = ($57150696beab2236$var$_a = $57150696beab2236$var$_window[$57150696beab2236$var$GLOBAL_KEY]) !== null && $57150696beab2236$var$_a !== void 0 ? $57150696beab2236$var$_a : $57150696beab2236$var$_global[$57150696beab2236$var$GLOBAL_KEY]) !== null && $57150696beab2236$var$_b !== void 0 ? $57150696beab2236$var$_b : $57150696beab2236$var$_globalThis[$57150696beab2236$var$GLOBAL_KEY]) !== null && $57150696beab2236$var$_c !== void 0 ? $57150696beab2236$var$_c : {
    instance: module.exports._getInstance
};
$57150696beab2236$var$_window[$57150696beab2236$var$GLOBAL_KEY] = $57150696beab2236$var$statsigGlobal;
$57150696beab2236$var$_global[$57150696beab2236$var$GLOBAL_KEY] = $57150696beab2236$var$statsigGlobal;
$57150696beab2236$var$_globalThis[$57150696beab2236$var$GLOBAL_KEY] = $57150696beab2236$var$statsigGlobal;

});
parcelRegister("buErx", function(module, exports) {
"use strict";
/* eslint-disable no-console */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Log = module.exports.LogLevel = void 0;
// intentionally spaced for formatting
const $85e1de3d791039fd$var$DEBUG = ' DEBUG ';
const $85e1de3d791039fd$var$_INFO = '  INFO ';
const $85e1de3d791039fd$var$_WARN = '  WARN ';
const $85e1de3d791039fd$var$ERROR = ' ERROR ';
function $85e1de3d791039fd$var$addTag(args) {
    args.unshift('[Statsig]');
    return args; // ['[Statsig]', ...args];
}
module.exports.LogLevel = {
    None: 0,
    Error: 1,
    Warn: 2,
    Info: 3,
    Debug: 4
};
class $85e1de3d791039fd$var$Log {
    static info(...args) {
        if ($85e1de3d791039fd$var$Log.level >= module.exports.LogLevel.Info) console.info($85e1de3d791039fd$var$_INFO, ...$85e1de3d791039fd$var$addTag(args));
    }
    static debug(...args) {
        if ($85e1de3d791039fd$var$Log.level >= module.exports.LogLevel.Debug) console.debug($85e1de3d791039fd$var$DEBUG, ...$85e1de3d791039fd$var$addTag(args));
    }
    static warn(...args) {
        if ($85e1de3d791039fd$var$Log.level >= module.exports.LogLevel.Warn) console.warn($85e1de3d791039fd$var$_WARN, ...$85e1de3d791039fd$var$addTag(args));
    }
    static error(...args) {
        if ($85e1de3d791039fd$var$Log.level >= module.exports.LogLevel.Error) console.error($85e1de3d791039fd$var$ERROR, ...$85e1de3d791039fd$var$addTag(args));
    }
}
module.exports.Log = $85e1de3d791039fd$var$Log;
$85e1de3d791039fd$var$Log.level = module.exports.LogLevel.Warn;

});


parcelRegister("6wVPT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Diagnostics = void 0;
const $4c12984236b72683$var$MARKER_MAP = new Map();
const $4c12984236b72683$var$ACT_START = 'start';
const $4c12984236b72683$var$ACT_END = 'end';
const $4c12984236b72683$var$DIAGNOSTICS_EVENT = 'statsig::diagnostics';
module.exports.Diagnostics = {
    _getMarkers: (sdkKey)=>{
        return $4c12984236b72683$var$MARKER_MAP.get(sdkKey);
    },
    _markInitOverallStart: (sdkKey)=>{
        $4c12984236b72683$var$_addMarker(sdkKey, $4c12984236b72683$var$_createMarker({}, $4c12984236b72683$var$ACT_START, 'overall'));
    },
    _markInitOverallEnd: (sdkKey, success, evaluationDetails)=>{
        $4c12984236b72683$var$_addMarker(sdkKey, $4c12984236b72683$var$_createMarker({
            success: success,
            error: success ? undefined : {
                name: 'InitializeError',
                message: 'Failed to initialize'
            },
            evaluationDetails: evaluationDetails
        }, $4c12984236b72683$var$ACT_END, 'overall'));
    },
    _markInitNetworkReqStart: (sdkKey, data)=>{
        $4c12984236b72683$var$_addMarker(sdkKey, $4c12984236b72683$var$_createMarker(data, $4c12984236b72683$var$ACT_START, 'initialize', 'network_request'));
    },
    _markInitNetworkReqEnd: (sdkKey, data)=>{
        $4c12984236b72683$var$_addMarker(sdkKey, $4c12984236b72683$var$_createMarker(data, $4c12984236b72683$var$ACT_END, 'initialize', 'network_request'));
    },
    _markInitProcessStart: (sdkKey)=>{
        $4c12984236b72683$var$_addMarker(sdkKey, $4c12984236b72683$var$_createMarker({}, $4c12984236b72683$var$ACT_START, 'initialize', 'process'));
    },
    _markInitProcessEnd: (sdkKey, data)=>{
        $4c12984236b72683$var$_addMarker(sdkKey, $4c12984236b72683$var$_createMarker(data, $4c12984236b72683$var$ACT_END, 'initialize', 'process'));
    },
    _clearMarkers: (sdkKey)=>{
        $4c12984236b72683$var$MARKER_MAP.delete(sdkKey);
    },
    _formatError (e) {
        if (!(e && typeof e === 'object')) return;
        return {
            code: $4c12984236b72683$var$_safeGetField(e, 'code'),
            name: $4c12984236b72683$var$_safeGetField(e, 'name'),
            message: $4c12984236b72683$var$_safeGetField(e, 'message')
        };
    },
    _getDiagnosticsData (res, attempt, body, e) {
        var _a;
        return {
            success: (res === null || res === void 0 ? void 0 : res.ok) === true,
            statusCode: res === null || res === void 0 ? void 0 : res.status,
            sdkRegion: (_a = res === null || res === void 0 ? void 0 : res.headers) === null || _a === void 0 ? void 0 : _a.get('x-statsig-region'),
            isDelta: body.includes('"is_delta":true') === true ? true : undefined,
            attempt: attempt,
            error: module.exports.Diagnostics._formatError(e)
        };
    },
    _enqueueDiagnosticsEvent (user, logger, sdk, options) {
        const markers = module.exports.Diagnostics._getMarkers(sdk);
        if (markers == null || markers.length <= 0) return -1;
        const overallInitDuration = markers[markers.length - 1].timestamp - markers[0].timestamp;
        module.exports.Diagnostics._clearMarkers(sdk);
        const event = $4c12984236b72683$var$_makeDiagnosticsEvent(user, {
            context: 'initialize',
            markers: markers.slice(),
            statsigOptions: options
        });
        logger.enqueue(event);
        return overallInitDuration;
    }
};
function $4c12984236b72683$var$_createMarker(data, action, key, step) {
    return Object.assign({
        key: key,
        action: action,
        step: step,
        timestamp: Date.now()
    }, data);
}
function $4c12984236b72683$var$_makeDiagnosticsEvent(user, data) {
    const latencyEvent = {
        eventName: $4c12984236b72683$var$DIAGNOSTICS_EVENT,
        user: user,
        value: null,
        metadata: data,
        time: Date.now()
    };
    return latencyEvent;
}
function $4c12984236b72683$var$_addMarker(sdkKey, marker) {
    var _a;
    const markers = (_a = $4c12984236b72683$var$MARKER_MAP.get(sdkKey)) !== null && _a !== void 0 ? _a : [];
    markers.push(marker);
    $4c12984236b72683$var$MARKER_MAP.set(sdkKey, markers);
}
function $4c12984236b72683$var$_safeGetField(data, field) {
    if (field in data) return data[field];
    return undefined;
}

});

parcelRegister("jgDpr", function(module, exports) {
"use strict";
var $e06e14cd0612a717$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventLogger = void 0;

var $8GMdc = parcelRequire("8GMdc");

var $lgqvU = parcelRequire("lgqvU");

var $buErx = parcelRequire("buErx");

var $4o8Rq = parcelRequire("4o8Rq");

var $ek3V7 = parcelRequire("ek3V7");

var $354Xc = parcelRequire("354Xc");

var $56liM = parcelRequire("56liM");

var $cR1Bx = parcelRequire("cR1Bx");

var $f6jUl = parcelRequire("f6jUl");

var $8oyuH = parcelRequire("8oyuH");
const $e06e14cd0612a717$var$DEFAULT_QUEUE_SIZE = 100;
const $e06e14cd0612a717$var$DEFAULT_FLUSH_INTERVAL_MS = 10000;
const $e06e14cd0612a717$var$MAX_DEDUPER_KEYS = 1000;
const $e06e14cd0612a717$var$DEDUPER_WINDOW_DURATION_MS = 600000;
const $e06e14cd0612a717$var$MAX_FAILED_LOGS = 500;
const $e06e14cd0612a717$var$QUICK_FLUSH_WINDOW_MS = 200;
const $e06e14cd0612a717$var$EVENT_LOGGER_MAP = {};
const $e06e14cd0612a717$var$RetryFailedLogsTrigger = {
    Startup: 'startup',
    GainedFocus: 'gained_focus'
};
class $e06e14cd0612a717$var$EventLogger {
    static _safeFlushAndForget(sdkKey) {
        var _a;
        (_a = $e06e14cd0612a717$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a.flush().catch(()=>{
        // noop
        });
    }
    static _safeRetryFailedLogs(sdkKey) {
        var _a;
        (_a = $e06e14cd0612a717$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a._retryFailedLogs($e06e14cd0612a717$var$RetryFailedLogsTrigger.GainedFocus);
    }
    setLogEventCompressionMode(mode) {
        this._network.setLogEventCompressionMode(mode);
    }
    setLoggingEnabled(loggingEnabled) {
        this._loggingEnabled = loggingEnabled;
    }
    enqueue(event) {
        if (!this._shouldLogEvent(event)) return;
        this._normalizeAndAppendEvent(event);
        this._quickFlushIfNeeded();
        if (this._queue.length > this._maxQueueSize) $e06e14cd0612a717$var$EventLogger._safeFlushAndForget(this._sdkKey);
    }
    incrementNonExposureCount(name) {
        var _a;
        const current = (_a = this._nonExposedChecks[name]) !== null && _a !== void 0 ? _a : 0;
        this._nonExposedChecks[name] = current + 1;
    }
    reset() {
        // attempt to flush any remaining events
        this.flush().catch(()=>{
        // noop
        });
        this._lastExposureTimeMap = {};
    }
    start() {
        var _a;
        const isServerEnv = (0, $ek3V7._isServerEnv)();
        if (isServerEnv && ((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always') return;
        $e06e14cd0612a717$var$EVENT_LOGGER_MAP[this._sdkKey] = this;
        if (!isServerEnv) (0, $8oyuH._subscribeToVisiblityChanged)((visibility)=>{
            if (visibility === 'background') $e06e14cd0612a717$var$EventLogger._safeFlushAndForget(this._sdkKey);
            else if (visibility === 'foreground') $e06e14cd0612a717$var$EventLogger._safeRetryFailedLogs(this._sdkKey);
        });
        this._retryFailedLogs($e06e14cd0612a717$var$RetryFailedLogsTrigger.Startup);
        this._startBackgroundFlushInterval();
    }
    stop() {
        return $e06e14cd0612a717$var$__awaiter(this, void 0, void 0, function*() {
            if (this._flushIntervalId) {
                clearInterval(this._flushIntervalId);
                this._flushIntervalId = null;
            }
            delete $e06e14cd0612a717$var$EVENT_LOGGER_MAP[this._sdkKey];
            yield this.flush();
        });
    }
    flush() {
        return $e06e14cd0612a717$var$__awaiter(this, void 0, void 0, function*() {
            this._appendAndResetNonExposedChecks();
            if (this._queue.length === 0) return;
            const events = this._queue;
            this._queue = [];
            yield this._sendEvents(events);
        });
    }
    /**
     * We 'Quick Flush' following the very first event enqueued
     * within the quick flush window
     */ _quickFlushIfNeeded() {
        if (this._hasRunQuickFlush) return;
        this._hasRunQuickFlush = true;
        if (Date.now() - this._creationTime > $e06e14cd0612a717$var$QUICK_FLUSH_WINDOW_MS) return;
        setTimeout(()=>$e06e14cd0612a717$var$EventLogger._safeFlushAndForget(this._sdkKey), $e06e14cd0612a717$var$QUICK_FLUSH_WINDOW_MS);
    }
    _shouldLogEvent(event) {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always' && (0, $ek3V7._isServerEnv)()) return false;
        if (!(0, $354Xc._isExposureEvent)(event)) return true;
        const user = event.user ? event.user : {
            statsigEnvironment: undefined
        };
        const userKey = (0, $8GMdc._getUserStorageKey)(this._sdkKey, user);
        const metadata = event.metadata ? event.metadata : {};
        const key = [
            event.eventName,
            userKey,
            metadata['gate'],
            metadata['config'],
            metadata['ruleID'],
            metadata['allocatedExperiment'],
            metadata['parameterName'],
            String(metadata['isExplicitParameter']),
            metadata['reason']
        ].join('|');
        const previous = this._lastExposureTimeMap[key];
        const now = Date.now();
        if (previous && now - previous < $e06e14cd0612a717$var$DEDUPER_WINDOW_DURATION_MS) return false;
        if (Object.keys(this._lastExposureTimeMap).length > $e06e14cd0612a717$var$MAX_DEDUPER_KEYS) this._lastExposureTimeMap = {};
        this._lastExposureTimeMap[key] = now;
        return true;
    }
    _sendEvents(events) {
        return $e06e14cd0612a717$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            if (this._loggingEnabled === 'disabled') {
                this._saveFailedLogsToStorage(events);
                return false;
            }
            try {
                const isClosing = (0, $8oyuH._isUnloading)();
                const shouldUseBeacon = isClosing && this._network.isBeaconSupported() && ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.networkOverrideFunc) == null;
                this._emitter({
                    name: 'pre_logs_flushed',
                    events: events
                });
                const response = shouldUseBeacon ? this._sendEventsViaBeacon(events) : yield this._sendEventsViaPost(events);
                if (response.success) {
                    this._emitter({
                        name: 'logs_flushed',
                        events: events
                    });
                    return true;
                } else {
                    $buErx.Log.warn('Failed to flush events.');
                    this._saveFailedLogsToStorage(events);
                    return false;
                }
            } catch (_c) {
                $buErx.Log.warn('Failed to flush events.');
                return false;
            }
        });
    }
    _sendEventsViaPost(events) {
        return $e06e14cd0612a717$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield this._network.post(this._getRequestData(events));
            const code = (_a = result === null || result === void 0 ? void 0 : result.code) !== null && _a !== void 0 ? _a : -1;
            return {
                success: code >= 200 && code < 300
            };
        });
    }
    _sendEventsViaBeacon(events) {
        return {
            success: this._network.beacon(this._getRequestData(events))
        };
    }
    _getRequestData(events) {
        return {
            sdkKey: this._sdkKey,
            data: {
                events: events
            },
            urlConfig: this._logEventUrlConfig,
            retries: 3,
            isCompressable: true,
            params: {
                [$4o8Rq.NetworkParam.EventCount]: String(events.length)
            },
            credentials: 'same-origin'
        };
    }
    _saveFailedLogsToStorage(events) {
        while(events.length > $e06e14cd0612a717$var$MAX_FAILED_LOGS)events.shift();
        const storageKey = this._getStorageKey();
        try {
            (0, $cR1Bx._setObjectInStorage)(storageKey, events);
        } catch (_a) {
            $buErx.Log.warn('Unable to save failed logs to storage');
        }
    }
    _retryFailedLogs(trigger) {
        const storageKey = this._getStorageKey();
        (()=>$e06e14cd0612a717$var$__awaiter(this, void 0, void 0, function*() {
                if (!$cR1Bx.Storage.isReady()) yield $cR1Bx.Storage.isReadyResolver();
                const events = (0, $cR1Bx._getObjectFromStorage)(storageKey);
                if (!events) return;
                if (trigger === $e06e14cd0612a717$var$RetryFailedLogsTrigger.Startup) $cR1Bx.Storage.removeItem(storageKey);
                const isSuccess = yield this._sendEvents(events);
                if (isSuccess && trigger === $e06e14cd0612a717$var$RetryFailedLogsTrigger.GainedFocus) $cR1Bx.Storage.removeItem(storageKey);
            }))().catch(()=>{
            $buErx.Log.warn('Failed to flush stored logs');
        });
    }
    _getStorageKey() {
        return `statsig.failed_logs.${(0, $lgqvU._DJB2)(this._sdkKey)}`;
    }
    _normalizeAndAppendEvent(event) {
        if (event.user) {
            event.user = Object.assign({}, event.user);
            delete event.user.privateAttributes;
        }
        const extras = {};
        const currentPage = this._getCurrentPageUrl();
        if (currentPage) extras.statsigMetadata = {
            currentPage: currentPage
        };
        const final = Object.assign(Object.assign({}, event), extras);
        $buErx.Log.debug('Enqueued Event:', final);
        this._queue.push(final);
    }
    _appendAndResetNonExposedChecks() {
        if (Object.keys(this._nonExposedChecks).length === 0) return;
        this._normalizeAndAppendEvent({
            eventName: 'statsig::non_exposed_checks',
            user: null,
            time: Date.now(),
            metadata: {
                checks: Object.assign({}, this._nonExposedChecks)
            }
        });
        this._nonExposedChecks = {};
    }
    _getCurrentPageUrl() {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.includeCurrentPageUrlWithEvents) === false) return;
        return (0, $ek3V7._getCurrentPageUrlSafe)();
    }
    _startBackgroundFlushInterval() {
        var _a, _b;
        const flushInterval = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingIntervalMs) !== null && _b !== void 0 ? _b : $e06e14cd0612a717$var$DEFAULT_FLUSH_INTERVAL_MS;
        const intervalId = setInterval(()=>{
            const logger = $e06e14cd0612a717$var$EVENT_LOGGER_MAP[this._sdkKey];
            if (!logger || logger._flushIntervalId !== intervalId) clearInterval(intervalId);
            else $e06e14cd0612a717$var$EventLogger._safeFlushAndForget(this._sdkKey);
        }, flushInterval);
        this._flushIntervalId = intervalId;
    }
    constructor(_sdkKey, _emitter, _network, _options){
        var _a, _b;
        this._sdkKey = _sdkKey;
        this._emitter = _emitter;
        this._network = _network;
        this._options = _options;
        this._queue = [];
        this._lastExposureTimeMap = {};
        this._nonExposedChecks = {};
        this._hasRunQuickFlush = false;
        this._creationTime = Date.now();
        this._loggingEnabled = (_a = _options === null || _options === void 0 ? void 0 : _options.loggingEnabled) !== null && _a !== void 0 ? _a : (_options === null || _options === void 0 ? void 0 : _options.disableLogging) === true ? $56liM.LoggingEnabledOption.disabled : $56liM.LoggingEnabledOption.browserOnly;
        if ((_options === null || _options === void 0 ? void 0 : _options.loggingEnabled) && _options.disableLogging !== undefined) $buErx.Log.warn('Detected both loggingEnabled and disableLogging options. loggingEnabled takes precedence - please remove disableLogging.');
        this._maxQueueSize = (_b = _options === null || _options === void 0 ? void 0 : _options.loggingBufferMaxSize) !== null && _b !== void 0 ? _b : $e06e14cd0612a717$var$DEFAULT_QUEUE_SIZE;
        const config = _options === null || _options === void 0 ? void 0 : _options.networkConfig;
        this._logEventUrlConfig = new $f6jUl.UrlConfiguration($4o8Rq.Endpoint._rgstr, config === null || config === void 0 ? void 0 : config.logEventUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.logEventFallbackUrls);
    }
}
module.exports.EventLogger = $e06e14cd0612a717$var$EventLogger;

});
parcelRegister("8GMdc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getStorageKey = module.exports._getUserStorageKey = void 0;

var $lgqvU = parcelRequire("lgqvU");
function $6537a4dc1789fec2$var$_getUserStorageKey(sdkKey, user, customKeyGenerator) {
    var _a;
    if (customKeyGenerator) return customKeyGenerator(sdkKey, user);
    const cids = user && user.customIDs ? user.customIDs : {};
    const parts = [
        `uid:${(_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ''}`,
        `cids:${Object.keys(cids).sort((leftKey, rightKey)=>leftKey.localeCompare(rightKey)).map((key)=>`${key}-${cids[key]}`).join(',')}`,
        `k:${sdkKey}`
    ];
    return (0, $lgqvU._DJB2)(parts.join('|'));
}
module.exports._getUserStorageKey = $6537a4dc1789fec2$var$_getUserStorageKey;
function $6537a4dc1789fec2$var$_getStorageKey(sdkKey, user, customKeyGenerator) {
    if (user) return $6537a4dc1789fec2$var$_getUserStorageKey(sdkKey, user, customKeyGenerator);
    return (0, $lgqvU._DJB2)(`k:${sdkKey}`);
}
module.exports._getStorageKey = $6537a4dc1789fec2$var$_getStorageKey;

});
parcelRegister("lgqvU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getSortedObject = module.exports._DJB2Object = module.exports._DJB2 = void 0;

var $8r058 = parcelRequire("8r058");
const $f7afa8adf474cfce$var$_DJB2 = (value)=>{
    let hash = 0;
    for(let i = 0; i < value.length; i++){
        const character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
};
module.exports._DJB2 = $f7afa8adf474cfce$var$_DJB2;
const $f7afa8adf474cfce$var$_DJB2Object = (value, maxLevels)=>{
    return (0, module.exports._DJB2)(JSON.stringify((0, module.exports._getSortedObject)(value, maxLevels)));
};
module.exports._DJB2Object = $f7afa8adf474cfce$var$_DJB2Object;
const $f7afa8adf474cfce$var$_getSortedObject = (object, maxDepth)=>{
    if (object == null) return null;
    const keys = Object.keys(object).sort();
    const sortedObject = {};
    keys.forEach((key)=>{
        const value = object[key];
        if (maxDepth === 0 || (0, $8r058._typeOf)(value) !== 'object') {
            sortedObject[key] = value;
            return;
        }
        sortedObject[key] = (0, module.exports._getSortedObject)(value, maxDepth != null ? maxDepth - 1 : maxDepth);
    });
    return sortedObject;
};
module.exports._getSortedObject = $f7afa8adf474cfce$var$_getSortedObject;

});
parcelRegister("8r058", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isTypeMatch = module.exports._typeOf = void 0;
function $6240e89c81000dd9$var$_typeOf(input) {
    return Array.isArray(input) ? 'array' : typeof input;
}
module.exports._typeOf = $6240e89c81000dd9$var$_typeOf;
function $6240e89c81000dd9$var$_isTypeMatch(a, b) {
    const typeOf = (x)=>Array.isArray(x) ? 'array' : x === null ? 'null' : typeof x;
    return typeOf(a) === typeOf(b);
}
module.exports._isTypeMatch = $6240e89c81000dd9$var$_isTypeMatch;

});



parcelRegister("4o8Rq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkParam = module.exports.NetworkDefault = module.exports.Endpoint = void 0;
module.exports.Endpoint = {
    _initialize: 'initialize',
    _rgstr: 'rgstr',
    _download_config_specs: 'download_config_specs'
};
module.exports.NetworkDefault = {
    [module.exports.Endpoint._rgstr]: 'https://prodregistryv2.org/v1',
    [module.exports.Endpoint._initialize]: 'https://featureassets.org/v1',
    [module.exports.Endpoint._download_config_specs]: 'https://api.statsigcdn.com/v1'
};
module.exports.NetworkParam = {
    EventCount: 'ec',
    SdkKey: 'k',
    SdkType: 'st',
    SdkVersion: 'sv',
    Time: 't',
    SessionID: 'sid',
    StatsigEncoded: 'se',
    IsGzipped: 'gz'
};

});

parcelRegister("ek3V7", function(module, exports) {

var $1CHRc = parcelRequire("1CHRc");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getUnloadEvent = module.exports._getCurrentPageUrlSafe = module.exports._addDocumentEventListenerSafe = module.exports._addWindowEventListenerSafe = module.exports._isServerEnv = module.exports._getDocumentSafe = module.exports._getWindowSafe = void 0;
const $a6d5f9721c132587$var$_getWindowSafe = ()=>{
    return typeof window !== 'undefined' ? window : null;
};
module.exports._getWindowSafe = $a6d5f9721c132587$var$_getWindowSafe;
const $a6d5f9721c132587$var$_getDocumentSafe = ()=>{
    var _a;
    const win = (0, module.exports._getWindowSafe)();
    return (_a = win === null || win === void 0 ? void 0 : win.document) !== null && _a !== void 0 ? _a : null;
};
module.exports._getDocumentSafe = $a6d5f9721c132587$var$_getDocumentSafe;
const $a6d5f9721c132587$var$_isServerEnv = ()=>{
    if ((0, module.exports._getDocumentSafe)() !== null) return false;
    const isNode = typeof $1CHRc !== 'undefined' && $1CHRc.versions != null && $1CHRc.versions.node != null;
    const isVercel = typeof EdgeRuntime === 'string';
    return isVercel || isNode;
};
module.exports._isServerEnv = $a6d5f9721c132587$var$_isServerEnv;
const $a6d5f9721c132587$var$_addWindowEventListenerSafe = (key, listener)=>{
    const win = (0, module.exports._getWindowSafe)();
    if (typeof (win === null || win === void 0 ? void 0 : win.addEventListener) === 'function') win.addEventListener(key, listener);
};
module.exports._addWindowEventListenerSafe = $a6d5f9721c132587$var$_addWindowEventListenerSafe;
const $a6d5f9721c132587$var$_addDocumentEventListenerSafe = (key, listener)=>{
    const doc = (0, module.exports._getDocumentSafe)();
    if (typeof (doc === null || doc === void 0 ? void 0 : doc.addEventListener) === 'function') doc.addEventListener(key, listener);
};
module.exports._addDocumentEventListenerSafe = $a6d5f9721c132587$var$_addDocumentEventListenerSafe;
const $a6d5f9721c132587$var$_getCurrentPageUrlSafe = ()=>{
    var _a;
    try {
        return (_a = (0, module.exports._getWindowSafe)()) === null || _a === void 0 ? void 0 : _a.location.href.split(/[?#]/)[0];
    } catch (_b) {
        return;
    }
};
module.exports._getCurrentPageUrlSafe = $a6d5f9721c132587$var$_getCurrentPageUrlSafe;
const $a6d5f9721c132587$var$_getUnloadEvent = ()=>{
    const win = (0, module.exports._getWindowSafe)();
    if (!win) return 'beforeunload';
    const eventType = 'onpagehide' in win ? 'pagehide' : 'beforeunload';
    return eventType;
};
module.exports._getUnloadEvent = $a6d5f9721c132587$var$_getUnloadEvent;

});
parcelRegister("1CHRc", function(module, exports) {
// shim for using process in browser
var $12eb5c2737f8339b$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $12eb5c2737f8339b$var$cachedSetTimeout;
var $12eb5c2737f8339b$var$cachedClearTimeout;
function $12eb5c2737f8339b$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $12eb5c2737f8339b$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $12eb5c2737f8339b$var$cachedSetTimeout = setTimeout;
        else $12eb5c2737f8339b$var$cachedSetTimeout = $12eb5c2737f8339b$var$defaultSetTimout;
    } catch (e) {
        $12eb5c2737f8339b$var$cachedSetTimeout = $12eb5c2737f8339b$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $12eb5c2737f8339b$var$cachedClearTimeout = clearTimeout;
        else $12eb5c2737f8339b$var$cachedClearTimeout = $12eb5c2737f8339b$var$defaultClearTimeout;
    } catch (e) {
        $12eb5c2737f8339b$var$cachedClearTimeout = $12eb5c2737f8339b$var$defaultClearTimeout;
    }
})();
function $12eb5c2737f8339b$var$runTimeout(fun) {
    if ($12eb5c2737f8339b$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($12eb5c2737f8339b$var$cachedSetTimeout === $12eb5c2737f8339b$var$defaultSetTimout || !$12eb5c2737f8339b$var$cachedSetTimeout) && setTimeout) {
        $12eb5c2737f8339b$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $12eb5c2737f8339b$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $12eb5c2737f8339b$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $12eb5c2737f8339b$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $12eb5c2737f8339b$var$runClearTimeout(marker) {
    if ($12eb5c2737f8339b$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($12eb5c2737f8339b$var$cachedClearTimeout === $12eb5c2737f8339b$var$defaultClearTimeout || !$12eb5c2737f8339b$var$cachedClearTimeout) && clearTimeout) {
        $12eb5c2737f8339b$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $12eb5c2737f8339b$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $12eb5c2737f8339b$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $12eb5c2737f8339b$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $12eb5c2737f8339b$var$queue = [];
var $12eb5c2737f8339b$var$draining = false;
var $12eb5c2737f8339b$var$currentQueue;
var $12eb5c2737f8339b$var$queueIndex = -1;
function $12eb5c2737f8339b$var$cleanUpNextTick() {
    if (!$12eb5c2737f8339b$var$draining || !$12eb5c2737f8339b$var$currentQueue) return;
    $12eb5c2737f8339b$var$draining = false;
    if ($12eb5c2737f8339b$var$currentQueue.length) $12eb5c2737f8339b$var$queue = $12eb5c2737f8339b$var$currentQueue.concat($12eb5c2737f8339b$var$queue);
    else $12eb5c2737f8339b$var$queueIndex = -1;
    if ($12eb5c2737f8339b$var$queue.length) $12eb5c2737f8339b$var$drainQueue();
}
function $12eb5c2737f8339b$var$drainQueue() {
    if ($12eb5c2737f8339b$var$draining) return;
    var timeout = $12eb5c2737f8339b$var$runTimeout($12eb5c2737f8339b$var$cleanUpNextTick);
    $12eb5c2737f8339b$var$draining = true;
    var len = $12eb5c2737f8339b$var$queue.length;
    while(len){
        $12eb5c2737f8339b$var$currentQueue = $12eb5c2737f8339b$var$queue;
        $12eb5c2737f8339b$var$queue = [];
        while(++$12eb5c2737f8339b$var$queueIndex < len)if ($12eb5c2737f8339b$var$currentQueue) $12eb5c2737f8339b$var$currentQueue[$12eb5c2737f8339b$var$queueIndex].run();
        $12eb5c2737f8339b$var$queueIndex = -1;
        len = $12eb5c2737f8339b$var$queue.length;
    }
    $12eb5c2737f8339b$var$currentQueue = null;
    $12eb5c2737f8339b$var$draining = false;
    $12eb5c2737f8339b$var$runClearTimeout(timeout);
}
$12eb5c2737f8339b$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $12eb5c2737f8339b$var$queue.push(new $12eb5c2737f8339b$var$Item(fun, args));
    if ($12eb5c2737f8339b$var$queue.length === 1 && !$12eb5c2737f8339b$var$draining) $12eb5c2737f8339b$var$runTimeout($12eb5c2737f8339b$var$drainQueue);
};
// v8 likes predictible objects
function $12eb5c2737f8339b$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$12eb5c2737f8339b$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$12eb5c2737f8339b$var$process.title = 'browser';
$12eb5c2737f8339b$var$process.browser = true;
$12eb5c2737f8339b$var$process.env = {};
$12eb5c2737f8339b$var$process.argv = [];
$12eb5c2737f8339b$var$process.version = ''; // empty string to avoid regexp issues
$12eb5c2737f8339b$var$process.versions = {};
function $12eb5c2737f8339b$var$noop() {}
$12eb5c2737f8339b$var$process.on = $12eb5c2737f8339b$var$noop;
$12eb5c2737f8339b$var$process.addListener = $12eb5c2737f8339b$var$noop;
$12eb5c2737f8339b$var$process.once = $12eb5c2737f8339b$var$noop;
$12eb5c2737f8339b$var$process.off = $12eb5c2737f8339b$var$noop;
$12eb5c2737f8339b$var$process.removeListener = $12eb5c2737f8339b$var$noop;
$12eb5c2737f8339b$var$process.removeAllListeners = $12eb5c2737f8339b$var$noop;
$12eb5c2737f8339b$var$process.emit = $12eb5c2737f8339b$var$noop;
$12eb5c2737f8339b$var$process.prependListener = $12eb5c2737f8339b$var$noop;
$12eb5c2737f8339b$var$process.prependOnceListener = $12eb5c2737f8339b$var$noop;
$12eb5c2737f8339b$var$process.listeners = function(name) {
    return [];
};
$12eb5c2737f8339b$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$12eb5c2737f8339b$var$process.cwd = function() {
    return '/';
};
$12eb5c2737f8339b$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$12eb5c2737f8339b$var$process.umask = function() {
    return 0;
};

});


parcelRegister("354Xc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._createLayerParameterExposure = module.exports._createConfigExposure = module.exports._mapExposures = module.exports._createGateExposure = module.exports._isExposureEvent = void 0;
const $23e5ae76e0d80000$var$CONFIG_EXPOSURE_NAME = 'statsig::config_exposure';
const $23e5ae76e0d80000$var$GATE_EXPOSURE_NAME = 'statsig::gate_exposure';
const $23e5ae76e0d80000$var$LAYER_EXPOSURE_NAME = 'statsig::layer_exposure';
const $23e5ae76e0d80000$var$_createExposure = (eventName, user, details, metadata, secondaryExposures)=>{
    if (details.bootstrapMetadata) metadata['bootstrapMetadata'] = details.bootstrapMetadata;
    return {
        eventName: eventName,
        user: user,
        value: null,
        metadata: $23e5ae76e0d80000$var$_addEvaluationDetailsToMetadata(details, metadata),
        secondaryExposures: secondaryExposures,
        time: Date.now()
    };
};
const $23e5ae76e0d80000$var$_isExposureEvent = ({ eventName: eventName })=>{
    return eventName === $23e5ae76e0d80000$var$GATE_EXPOSURE_NAME || eventName === $23e5ae76e0d80000$var$CONFIG_EXPOSURE_NAME || eventName === $23e5ae76e0d80000$var$LAYER_EXPOSURE_NAME;
};
module.exports._isExposureEvent = $23e5ae76e0d80000$var$_isExposureEvent;
const $23e5ae76e0d80000$var$_createGateExposure = (user, gate, exposureMapping)=>{
    var _a, _b, _c;
    const metadata = {
        gate: gate.name,
        gateValue: String(gate.value),
        ruleID: gate.ruleID
    };
    if (((_a = gate.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = gate.__evaluation.version;
    return $23e5ae76e0d80000$var$_createExposure($23e5ae76e0d80000$var$GATE_EXPOSURE_NAME, user, gate.details, metadata, $23e5ae76e0d80000$var$_mapExposures((_c = (_b = gate.__evaluation) === null || _b === void 0 ? void 0 : _b.secondary_exposures) !== null && _c !== void 0 ? _c : [], exposureMapping));
};
module.exports._createGateExposure = $23e5ae76e0d80000$var$_createGateExposure;
function $23e5ae76e0d80000$var$_mapExposures(exposures, exposureMapping) {
    return exposures.map((exposure)=>{
        if (typeof exposure === 'string') return (exposureMapping !== null && exposureMapping !== void 0 ? exposureMapping : {})[exposure];
        return exposure;
    }).filter((exposure)=>exposure != null);
}
module.exports._mapExposures = $23e5ae76e0d80000$var$_mapExposures;
const $23e5ae76e0d80000$var$_createConfigExposure = (user, config, exposureMapping)=>{
    var _a, _b, _c, _d;
    const metadata = {
        config: config.name,
        ruleID: config.ruleID
    };
    if (((_a = config.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = config.__evaluation.version;
    if (((_b = config.__evaluation) === null || _b === void 0 ? void 0 : _b.passed) != null) metadata['rulePassed'] = String(config.__evaluation.passed);
    return $23e5ae76e0d80000$var$_createExposure($23e5ae76e0d80000$var$CONFIG_EXPOSURE_NAME, user, config.details, metadata, $23e5ae76e0d80000$var$_mapExposures((_d = (_c = config.__evaluation) === null || _c === void 0 ? void 0 : _c.secondary_exposures) !== null && _d !== void 0 ? _d : [], exposureMapping));
};
module.exports._createConfigExposure = $23e5ae76e0d80000$var$_createConfigExposure;
const $23e5ae76e0d80000$var$_createLayerParameterExposure = (user, layer, parameterName, exposureMapping)=>{
    var _a, _b, _c, _d, _e, _f, _g;
    const evaluation = layer.__evaluation;
    const isExplicit = ((_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.explicit_parameters) === null || _a === void 0 ? void 0 : _a.includes(parameterName)) === true;
    let allocatedExperiment = '';
    let secondaryExposures = (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.undelegated_secondary_exposures) !== null && _b !== void 0 ? _b : [];
    if (isExplicit) {
        allocatedExperiment = (_c = evaluation.allocated_experiment_name) !== null && _c !== void 0 ? _c : '';
        secondaryExposures = (_d = evaluation.secondary_exposures) !== null && _d !== void 0 ? _d : [];
    }
    const parameterRuleIDs = (_e = layer.__evaluation) === null || _e === void 0 ? void 0 : _e.parameter_rule_ids;
    const metadata = {
        config: layer.name,
        parameterName: parameterName,
        ruleID: (_f = parameterRuleIDs === null || parameterRuleIDs === void 0 ? void 0 : parameterRuleIDs[parameterName]) !== null && _f !== void 0 ? _f : layer.ruleID,
        allocatedExperiment: allocatedExperiment,
        isExplicitParameter: String(isExplicit)
    };
    if (((_g = layer.__evaluation) === null || _g === void 0 ? void 0 : _g.version) != null) metadata['configVersion'] = layer.__evaluation.version;
    return $23e5ae76e0d80000$var$_createExposure($23e5ae76e0d80000$var$LAYER_EXPOSURE_NAME, user, layer.details, metadata, $23e5ae76e0d80000$var$_mapExposures(secondaryExposures, exposureMapping));
};
module.exports._createLayerParameterExposure = $23e5ae76e0d80000$var$_createLayerParameterExposure;
const $23e5ae76e0d80000$var$_addEvaluationDetailsToMetadata = (details, metadata)=>{
    metadata['reason'] = details.reason;
    if (details.lcut) metadata['lcut'] = String(details.lcut);
    if (details.receivedAt) metadata['receivedAt'] = String(details.receivedAt);
    return metadata;
};

});

parcelRegister("56liM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoggingEnabledOption = module.exports.LogEventCompressionMode = void 0;
module.exports.LogEventCompressionMode = {
    /** Do not compress request bodies */ Disabled: 'd',
    /** Compress request bodies unless a network proxy is configured */ Enabled: 'e',
    /** Always compress request bodies, even when a proxy is configured */ Forced: 'f'
};
module.exports.LoggingEnabledOption = {
    disabled: 'disabled',
    browserOnly: 'browser-only',
    always: 'always'
};

});

parcelRegister("cR1Bx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._setObjectInStorage = module.exports._getObjectFromStorage = module.exports.Storage = void 0;

var $buErx = parcelRequire("buErx");

var $ek3V7 = parcelRequire("ek3V7");
const $95bbade8a5e49568$var$inMemoryStore = {};
const $95bbade8a5e49568$var$_inMemoryProvider = {
    isReady: ()=>true,
    isReadyResolver: ()=>null,
    getProviderName: ()=>'InMemory',
    getItem: (key)=>$95bbade8a5e49568$var$inMemoryStore[key] ? $95bbade8a5e49568$var$inMemoryStore[key] : null,
    setItem: (key, value)=>{
        $95bbade8a5e49568$var$inMemoryStore[key] = value;
    },
    removeItem: (key)=>{
        delete $95bbade8a5e49568$var$inMemoryStore[key];
    },
    getAllKeys: ()=>Object.keys($95bbade8a5e49568$var$inMemoryStore)
};
let $95bbade8a5e49568$var$_localStorageProvider = null;
try {
    const win = (0, $ek3V7._getWindowSafe)();
    if (win && win.localStorage && typeof win.localStorage.getItem === 'function') $95bbade8a5e49568$var$_localStorageProvider = {
        isReady: ()=>true,
        isReadyResolver: ()=>null,
        getProviderName: ()=>'LocalStorage',
        getItem: (key)=>win.localStorage.getItem(key),
        setItem: (key, value)=>win.localStorage.setItem(key, value),
        removeItem: (key)=>win.localStorage.removeItem(key),
        getAllKeys: ()=>Object.keys(win.localStorage)
    };
} catch (error) {
    $buErx.Log.warn('Failed to setup localStorageProvider.');
}
let $95bbade8a5e49568$var$_main = $95bbade8a5e49568$var$_localStorageProvider !== null && $95bbade8a5e49568$var$_localStorageProvider !== void 0 ? $95bbade8a5e49568$var$_localStorageProvider : $95bbade8a5e49568$var$_inMemoryProvider;
let $95bbade8a5e49568$var$_current = $95bbade8a5e49568$var$_main;
function $95bbade8a5e49568$var$_inMemoryBreaker(action) {
    try {
        return action();
    } catch (error) {
        if (error instanceof Error && error.name === 'SecurityError') {
            module.exports.Storage._setProvider($95bbade8a5e49568$var$_inMemoryProvider);
            return null;
        }
        if (error instanceof Error && error.name === 'QuotaExceededError') {
            const allKeys = module.exports.Storage.getAllKeys();
            const statsigKeys = allKeys.filter((key)=>key.startsWith('statsig.'));
            error.message = `${error.message}. Statsig Keys: ${statsigKeys.length}`;
        }
        throw error;
    }
}
module.exports.Storage = {
    isReady: ()=>$95bbade8a5e49568$var$_current.isReady(),
    isReadyResolver: ()=>$95bbade8a5e49568$var$_current.isReadyResolver(),
    getProviderName: ()=>$95bbade8a5e49568$var$_current.getProviderName(),
    getItem: (key)=>$95bbade8a5e49568$var$_inMemoryBreaker(()=>$95bbade8a5e49568$var$_current.getItem(key)),
    setItem: (key, value)=>$95bbade8a5e49568$var$_inMemoryBreaker(()=>$95bbade8a5e49568$var$_current.setItem(key, value)),
    removeItem: (key)=>$95bbade8a5e49568$var$_current.removeItem(key),
    getAllKeys: ()=>$95bbade8a5e49568$var$_current.getAllKeys(),
    // StorageProviderManagment
    _setProvider: (newProvider)=>{
        $95bbade8a5e49568$var$_main = newProvider;
        $95bbade8a5e49568$var$_current = newProvider;
    },
    _setDisabled: (isDisabled)=>{
        if (isDisabled) $95bbade8a5e49568$var$_current = $95bbade8a5e49568$var$_inMemoryProvider;
        else $95bbade8a5e49568$var$_current = $95bbade8a5e49568$var$_main;
    }
};
function $95bbade8a5e49568$var$_getObjectFromStorage(key) {
    const value = module.exports.Storage.getItem(key);
    return JSON.parse(value !== null && value !== void 0 ? value : 'null');
}
module.exports._getObjectFromStorage = $95bbade8a5e49568$var$_getObjectFromStorage;
function $95bbade8a5e49568$var$_setObjectInStorage(key, obj) {
    module.exports.Storage.setItem(key, JSON.stringify(obj));
}
module.exports._setObjectInStorage = $95bbade8a5e49568$var$_setObjectInStorage;

});

parcelRegister("f6jUl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UrlConfiguration = void 0;

var $lgqvU = parcelRequire("lgqvU");

var $4o8Rq = parcelRequire("4o8Rq");
const $afe6dbd11560ecfa$var$ENDPOINT_DNS_KEY_MAP = {
    [$4o8Rq.Endpoint._initialize]: 'i',
    [$4o8Rq.Endpoint._rgstr]: 'e',
    [$4o8Rq.Endpoint._download_config_specs]: 'd'
};
class $afe6dbd11560ecfa$var$UrlConfiguration {
    getUrl() {
        var _a;
        return (_a = this.customUrl) !== null && _a !== void 0 ? _a : this.defaultUrl;
    }
    getChecksum() {
        var _a;
        const fallbacks = ((_a = this.fallbackUrls) !== null && _a !== void 0 ? _a : []).sort().join(',');
        return (0, $lgqvU._DJB2)(this.customUrl + fallbacks);
    }
    constructor(endpoint, customUrl, customApi, fallbackUrls){
        this.customUrl = null;
        this.fallbackUrls = null;
        this.endpoint = endpoint;
        this.endpointDnsKey = $afe6dbd11560ecfa$var$ENDPOINT_DNS_KEY_MAP[endpoint];
        if (customUrl) this.customUrl = customUrl;
        if (!customUrl && customApi) this.customUrl = customApi.endsWith('/') ? `${customApi}${endpoint}` : `${customApi}/${endpoint}`;
        if (fallbackUrls) this.fallbackUrls = fallbackUrls;
        const defaultApi = $4o8Rq.NetworkDefault[endpoint];
        this.defaultUrl = `${defaultApi}/${endpoint}`;
    }
}
module.exports.UrlConfiguration = $afe6dbd11560ecfa$var$UrlConfiguration;

});

parcelRegister("8oyuH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._notifyVisibilityChanged = module.exports._subscribeToVisiblityChanged = module.exports._isUnloading = module.exports._isCurrentlyVisible = void 0;

var $ek3V7 = parcelRequire("ek3V7");
const $61cb526bdca3f11e$var$FOREGROUND = 'foreground';
const $61cb526bdca3f11e$var$BACKGROUND = 'background';
const $61cb526bdca3f11e$var$LISTENERS = [];
let $61cb526bdca3f11e$var$current = $61cb526bdca3f11e$var$FOREGROUND;
let $61cb526bdca3f11e$var$isUnloading = false;
const $61cb526bdca3f11e$var$_isCurrentlyVisible = ()=>{
    return $61cb526bdca3f11e$var$current === $61cb526bdca3f11e$var$FOREGROUND;
};
module.exports._isCurrentlyVisible = $61cb526bdca3f11e$var$_isCurrentlyVisible;
const $61cb526bdca3f11e$var$_isUnloading = ()=>$61cb526bdca3f11e$var$isUnloading;
module.exports._isUnloading = $61cb526bdca3f11e$var$_isUnloading;
const $61cb526bdca3f11e$var$_subscribeToVisiblityChanged = (listener)=>{
    $61cb526bdca3f11e$var$LISTENERS.unshift(listener);
};
module.exports._subscribeToVisiblityChanged = $61cb526bdca3f11e$var$_subscribeToVisiblityChanged;
const $61cb526bdca3f11e$var$_notifyVisibilityChanged = (visibility)=>{
    if (visibility === $61cb526bdca3f11e$var$current) return;
    $61cb526bdca3f11e$var$current = visibility;
    $61cb526bdca3f11e$var$LISTENERS.forEach((l)=>l(visibility));
};
module.exports._notifyVisibilityChanged = $61cb526bdca3f11e$var$_notifyVisibilityChanged;
(0, $ek3V7._addWindowEventListenerSafe)('focus', ()=>{
    $61cb526bdca3f11e$var$isUnloading = false;
    (0, module.exports._notifyVisibilityChanged)($61cb526bdca3f11e$var$FOREGROUND);
});
(0, $ek3V7._addWindowEventListenerSafe)('blur', ()=>(0, module.exports._notifyVisibilityChanged)($61cb526bdca3f11e$var$BACKGROUND));
(0, $ek3V7._addDocumentEventListenerSafe)('visibilitychange', ()=>{
    (0, module.exports._notifyVisibilityChanged)(document.visibilityState === 'visible' ? $61cb526bdca3f11e$var$FOREGROUND : $61cb526bdca3f11e$var$BACKGROUND);
});
(0, $ek3V7._addWindowEventListenerSafe)((0, $ek3V7._getUnloadEvent)(), ()=>{
    $61cb526bdca3f11e$var$isUnloading = true;
    (0, module.exports._notifyVisibilityChanged)($61cb526bdca3f11e$var$BACKGROUND);
});

});


parcelRegister("3ZDsH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigMetadataProvider = module.exports.SDK_VERSION = void 0;
module.exports.SDK_VERSION = '3.21.1';
let $2e85ade96f70b866$var$metadata = {
    sdkVersion: module.exports.SDK_VERSION,
    sdkType: 'js-mono'
};
module.exports.StatsigMetadataProvider = {
    get: ()=>$2e85ade96f70b866$var$metadata,
    add: (additions)=>{
        $2e85ade96f70b866$var$metadata = Object.assign(Object.assign({}, $2e85ade96f70b866$var$metadata), additions);
    }
};

});

parcelRegister("aQwjw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("lkT55", function(module, exports) {
"use strict";
var $f886312e23aaa382$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeDataAdapterResult = module.exports.DataAdapterCore = void 0;

var $buErx = parcelRequire("buErx");

var $j6vKQ = parcelRequire("j6vKQ");

var $sTwvd = parcelRequire("sTwvd");

var $cR1Bx = parcelRequire("cR1Bx");

var $7UR8T = parcelRequire("7UR8T");
const $f886312e23aaa382$var$CACHE_LIMIT = 10;
class $f886312e23aaa382$var$DataAdapterCore {
    attach(sdkKey, options, _network) {
        this._sdkKey = sdkKey;
        this._options = options;
    }
    getDataSync(user) {
        const normalized = user && (0, $sTwvd._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        const inMem = this._inMemoryCache.get(cacheKey, normalized);
        if (inMem && this._getIsCacheValueValid(inMem)) return inMem;
        const cache = this._loadFromCache(cacheKey);
        if (cache && this._getIsCacheValueValid(cache)) {
            this._inMemoryCache.add(cacheKey, cache);
            return this._inMemoryCache.get(cacheKey, normalized);
        }
        return null;
    }
    setData(data, user) {
        const normalized = user && (0, $sTwvd._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        this._inMemoryCache.add(cacheKey, $f886312e23aaa382$var$_makeDataAdapterResult('Bootstrap', data, null, normalized));
    }
    _getIsCacheValueValid(current) {
        return current.stableID == null || current.stableID === $j6vKQ.StableID.get(this._getSdkKey());
    }
    _getDataAsyncImpl(current, user, options) {
        return $f886312e23aaa382$var$__awaiter(this, void 0, void 0, function*() {
            if (!$cR1Bx.Storage.isReady()) yield $cR1Bx.Storage.isReadyResolver();
            const cache = current !== null && current !== void 0 ? current : this.getDataSync(user);
            const ops = [
                this._fetchAndPrepFromNetwork(cache, user, options)
            ];
            if (options === null || options === void 0 ? void 0 : options.timeoutMs) ops.push(new Promise((r)=>setTimeout(r, options.timeoutMs)).then(()=>{
                $buErx.Log.debug('Fetching latest value timed out');
                return null;
            }));
            return yield Promise.race(ops);
        });
    }
    _prefetchDataImpl(user, options) {
        return $f886312e23aaa382$var$__awaiter(this, void 0, void 0, function*() {
            const normalized = user && (0, $sTwvd._normalizeUser)(user, this._options);
            const cacheKey = this._getCacheKey(normalized);
            const result = yield this._getDataAsyncImpl(null, normalized, options);
            if (result) this._inMemoryCache.add(cacheKey, Object.assign(Object.assign({}, result), {
                source: 'Prefetch'
            }));
        });
    }
    _fetchAndPrepFromNetwork(cachedResult, user, options) {
        return $f886312e23aaa382$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cachedData = (_a = cachedResult === null || cachedResult === void 0 ? void 0 : cachedResult.data) !== null && _a !== void 0 ? _a : null;
            const isCacheValidFor204 = cachedResult != null && this._isCachedResultValidFor204(cachedResult, user);
            const latest = yield this._fetchFromNetwork(cachedData, user, options, isCacheValidFor204);
            if (!latest) {
                $buErx.Log.debug('No response returned for latest value');
                return null;
            }
            const response = (0, $7UR8T._typedJsonParse)(latest, 'has_updates', 'Response');
            const sdkKey = this._getSdkKey();
            const stableID = $j6vKQ.StableID.get(sdkKey);
            let result = null;
            if ((response === null || response === void 0 ? void 0 : response.has_updates) === true) result = $f886312e23aaa382$var$_makeDataAdapterResult('Network', latest, stableID, user);
            else if (cachedData && (response === null || response === void 0 ? void 0 : response.has_updates) === false) result = $f886312e23aaa382$var$_makeDataAdapterResult('NetworkNotModified', cachedData, stableID, user);
            else return null;
            const cacheKey = this._getCacheKey(user);
            this._inMemoryCache.add(cacheKey, result);
            this._writeToCache(cacheKey, result);
            return result;
        });
    }
    _getSdkKey() {
        if (this._sdkKey != null) return this._sdkKey;
        $buErx.Log.error(`${this._adapterName} is not attached to a Client`);
        return '';
    }
    _loadFromCache(cacheKey) {
        var _a;
        const cache = (_a = $cR1Bx.Storage.getItem) === null || _a === void 0 ? void 0 : _a.call($cR1Bx.Storage, cacheKey);
        if (cache == null) return null;
        const result = (0, $7UR8T._typedJsonParse)(cache, 'source', 'Cached Result');
        return result ? Object.assign(Object.assign({}, result), {
            source: 'Cache'
        }) : null;
    }
    _writeToCache(cacheKey, result) {
        $cR1Bx.Storage.setItem(cacheKey, JSON.stringify(result));
        this._runLocalStorageCacheEviction(cacheKey);
    }
    _runLocalStorageCacheEviction(cacheKey) {
        var _a;
        const lastModifiedTimeMap = (_a = (0, $cR1Bx._getObjectFromStorage)(this._lastModifiedStoreKey)) !== null && _a !== void 0 ? _a : {};
        lastModifiedTimeMap[cacheKey] = Date.now();
        const evictable = $f886312e23aaa382$var$_getEvictableKey(lastModifiedTimeMap, $f886312e23aaa382$var$CACHE_LIMIT);
        if (evictable) {
            delete lastModifiedTimeMap[evictable];
            $cR1Bx.Storage.removeItem(evictable);
        }
        (0, $cR1Bx._setObjectInStorage)(this._lastModifiedStoreKey, lastModifiedTimeMap);
    }
    constructor(_adapterName, _cacheSuffix){
        this._adapterName = _adapterName;
        this._cacheSuffix = _cacheSuffix;
        this._options = null;
        this._sdkKey = null;
        this._lastModifiedStoreKey = `statsig.last_modified_time.${_cacheSuffix}`;
        this._inMemoryCache = new $f886312e23aaa382$var$InMemoryCache();
    }
}
module.exports.DataAdapterCore = $f886312e23aaa382$var$DataAdapterCore;
function $f886312e23aaa382$var$_makeDataAdapterResult(source, data, stableID, user) {
    return {
        source: source,
        data: data,
        receivedAt: Date.now(),
        stableID: stableID,
        fullUserHash: (0, $sTwvd._getFullUserHash)(user)
    };
}
module.exports._makeDataAdapterResult = $f886312e23aaa382$var$_makeDataAdapterResult;
class $f886312e23aaa382$var$InMemoryCache {
    get(cacheKey, user) {
        var _a;
        const result = this._data[cacheKey];
        const cached = result === null || result === void 0 ? void 0 : result.stableID;
        const provided = (_a = user === null || user === void 0 ? void 0 : user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (provided && cached && provided !== cached) {
            $buErx.Log.warn("'StatsigUser.customIDs.stableID' mismatch");
            return null;
        }
        return result;
    }
    add(cacheKey, value) {
        const oldest = $f886312e23aaa382$var$_getEvictableKey(this._data, $f886312e23aaa382$var$CACHE_LIMIT - 1);
        if (oldest) delete this._data[oldest];
        this._data[cacheKey] = value;
    }
    merge(values) {
        this._data = Object.assign(Object.assign({}, this._data), values);
    }
    constructor(){
        this._data = {};
    }
}
function $f886312e23aaa382$var$_getEvictableKey(data, limit) {
    const keys = Object.keys(data);
    if (keys.length <= limit) return null;
    return keys.reduce((prevKey, currKey)=>{
        const prev = data[prevKey];
        const current = data[currKey];
        if (typeof prev === 'object' && typeof current === 'object') return current.receivedAt < prev.receivedAt ? currKey : prevKey;
        return current < prev ? currKey : prevKey;
    });
}

});
parcelRegister("j6vKQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StableID = void 0;

var $8GMdc = parcelRequire("8GMdc");

var $buErx = parcelRequire("buErx");

var $ek3V7 = parcelRequire("ek3V7");

var $cR1Bx = parcelRequire("cR1Bx");

var $3xGNu = parcelRequire("3xGNu");
const $de8735a9ee475ec8$var$PROMISE_MAP = {};
const $de8735a9ee475ec8$var$COOKIE_ENABLED_MAP = {};
const $de8735a9ee475ec8$var$DISABLED_MAP = {};
module.exports.StableID = {
    cookiesEnabled: false,
    randomID: Math.random().toString(36),
    get: (sdkKey)=>{
        if ($de8735a9ee475ec8$var$DISABLED_MAP[sdkKey]) return null;
        if ($de8735a9ee475ec8$var$PROMISE_MAP[sdkKey] != null) return $de8735a9ee475ec8$var$PROMISE_MAP[sdkKey];
        let stableID = null;
        stableID = $de8735a9ee475ec8$var$_loadFromCookie(sdkKey);
        if (stableID != null) {
            $de8735a9ee475ec8$var$PROMISE_MAP[sdkKey] = stableID;
            $de8735a9ee475ec8$var$_persistToStorage(stableID, sdkKey);
            return stableID;
        }
        stableID = $de8735a9ee475ec8$var$_loadFromStorage(sdkKey);
        if (stableID == null) stableID = (0, $3xGNu.getUUID)();
        $de8735a9ee475ec8$var$_persistToStorage(stableID, sdkKey);
        $de8735a9ee475ec8$var$_persistToCookie(stableID, sdkKey);
        $de8735a9ee475ec8$var$PROMISE_MAP[sdkKey] = stableID;
        return stableID;
    },
    setOverride: (override, sdkKey)=>{
        $de8735a9ee475ec8$var$PROMISE_MAP[sdkKey] = override;
        $de8735a9ee475ec8$var$_persistToStorage(override, sdkKey);
        $de8735a9ee475ec8$var$_persistToCookie(override, sdkKey);
    },
    _setCookiesEnabled: (sdkKey, cookiesEnabled)=>{
        $de8735a9ee475ec8$var$COOKIE_ENABLED_MAP[sdkKey] = cookiesEnabled;
    },
    _setDisabled: (sdkKey, disabled)=>{
        $de8735a9ee475ec8$var$DISABLED_MAP[sdkKey] = disabled;
    }
};
function $de8735a9ee475ec8$var$_getStableIDStorageKey(sdkKey) {
    return `statsig.stable_id.${(0, $8GMdc._getStorageKey)(sdkKey)}`;
}
function $de8735a9ee475ec8$var$_persistToStorage(stableID, sdkKey) {
    const storageKey = $de8735a9ee475ec8$var$_getStableIDStorageKey(sdkKey);
    try {
        (0, $cR1Bx._setObjectInStorage)(storageKey, stableID);
    } catch (e) {
        $buErx.Log.warn('Failed to save StableID to storage');
    }
}
function $de8735a9ee475ec8$var$_loadFromStorage(sdkKey) {
    const storageKey = $de8735a9ee475ec8$var$_getStableIDStorageKey(sdkKey);
    return (0, $cR1Bx._getObjectFromStorage)(storageKey);
}
function $de8735a9ee475ec8$var$_loadFromCookie(sdkKey) {
    if (!$de8735a9ee475ec8$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $ek3V7._getDocumentSafe)() == null) return null;
    const cookies = document.cookie.split(';');
    for (const cookie of cookies){
        const [key, value] = cookie.trim().split('=');
        if (key === $de8735a9ee475ec8$var$_getCookieName(sdkKey)) return decodeURIComponent(value);
    }
    return null;
}
function $de8735a9ee475ec8$var$_persistToCookie(stableID, sdkKey) {
    if (!$de8735a9ee475ec8$var$COOKIE_ENABLED_MAP[sdkKey] || !document) return;
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    document.cookie = `${$de8735a9ee475ec8$var$_getCookieName(sdkKey)}=${encodeURIComponent(stableID)}; expires=${expiryDate.toUTCString()}; path=/`;
}
function $de8735a9ee475ec8$var$_getCookieName(sdkKey) {
    return `statsig.stable_id.${(0, $8GMdc._getStorageKey)(sdkKey)}`;
}

});
parcelRegister("3xGNu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUUID = void 0;
function $2945a6ce29b2ae65$var$getUUID() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    let d = new Date().getTime();
    let d2 = typeof performance !== 'undefined' && performance.now && performance.now() * 1000 || 0;
    const y = '89ab'[Math.floor(Math.random() * 4)];
    return `xxxxxxxx-xxxx-4xxx-${y}xxx-xxxxxxxxxxxx`.replace(/[xy]/g, (c)=>{
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
    });
}
module.exports.getUUID = $2945a6ce29b2ae65$var$getUUID;

});


parcelRegister("sTwvd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getFullUserHash = module.exports._normalizeUser = void 0;

var $lgqvU = parcelRequire("lgqvU");

var $buErx = parcelRequire("buErx");
function $056daf65a66d26d0$var$_normalizeUser(original, options, fallbackEnvironment) {
    try {
        const copy = JSON.parse(JSON.stringify(original));
        if (options != null && options.environment != null) copy.statsigEnvironment = options.environment;
        else if (fallbackEnvironment != null) copy.statsigEnvironment = {
            tier: fallbackEnvironment
        };
        return copy;
    } catch (error) {
        $buErx.Log.error('Failed to JSON.stringify user');
        return {
            statsigEnvironment: undefined
        };
    }
}
module.exports._normalizeUser = $056daf65a66d26d0$var$_normalizeUser;
function $056daf65a66d26d0$var$_getFullUserHash(user) {
    return user ? (0, $lgqvU._DJB2Object)(user) : null;
}
module.exports._getFullUserHash = $056daf65a66d26d0$var$_getFullUserHash;

});

parcelRegister("7UR8T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._typedJsonParse = void 0;

var $buErx = parcelRequire("buErx");
/**
 *
 * @param {string} data The values to parse into T
 * @param {string} guard A field that must exists on the parsed object for the parse to be valid
 * @param {string} error An error to print via Log.error() when parsing fails
 * @returns {T | null} The parse object T or null if it failed
 */ function $5c36fc5882c6765d$var$_typedJsonParse(data, guard, typeName) {
    try {
        const result = JSON.parse(data);
        if (result && typeof result === 'object' && guard in result) return result;
    } catch (_a) {
    // noop
    }
    $buErx.Log.error(`Failed to parse ${typeName}`);
    return null;
}
module.exports._typedJsonParse = $5c36fc5882c6765d$var$_typedJsonParse;

});


parcelRegister("a0k0o", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("g7zKQ", function(module, exports) {
"use strict";
var $bbc908ebca3c3209$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorBoundary = module.exports.EXCEPTION_ENDPOINT = void 0;

var $buErx = parcelRequire("buErx");

var $h9lZZ = parcelRequire("h9lZZ");

var $3ZDsH = parcelRequire("3ZDsH");
module.exports.EXCEPTION_ENDPOINT = 'https://statsigapi.net/v1/sdk_exception';
const $bbc908ebca3c3209$var$UNKNOWN_ERROR = '[Statsig] UnknownError';
class $bbc908ebca3c3209$var$ErrorBoundary {
    wrap(instance) {
        try {
            const obj = instance;
            $bbc908ebca3c3209$var$_getAllInstanceMethodNames(obj).forEach((name)=>{
                const original = obj[name];
                if ('$EB' in original) return;
                obj[name] = (...args)=>{
                    return this._capture(name, ()=>original.apply(instance, args));
                };
                obj[name].$EB = true;
            });
        } catch (err) {
            this._onError('eb:wrap', err);
        }
    }
    logError(tag, error) {
        this._onError(tag, error);
    }
    getLastSeenErrorAndReset() {
        const tempError = this._lastSeenError;
        this._lastSeenError = undefined;
        return tempError !== null && tempError !== void 0 ? tempError : null;
    }
    attachErrorIfNoneExists(error) {
        if (this._lastSeenError) return;
        this._lastSeenError = $bbc908ebca3c3209$var$_resolveError(error);
    }
    _capture(tag, task) {
        try {
            const res = task();
            if (res && res instanceof Promise) return res.catch((err)=>this._onError(tag, err));
            return res;
        } catch (error) {
            this._onError(tag, error);
            return null;
        }
    }
    _onError(tag, error) {
        try {
            $buErx.Log.warn(`Caught error in ${tag}`, {
                error: error
            });
            const impl = ()=>$bbc908ebca3c3209$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b, _c, _d, _e, _f, _g;
                    const unwrapped = error ? error : Error($bbc908ebca3c3209$var$UNKNOWN_ERROR);
                    const isError = unwrapped instanceof Error;
                    const name = isError ? unwrapped.name : 'No Name';
                    const resolvedError = $bbc908ebca3c3209$var$_resolveError(unwrapped);
                    this._lastSeenError = resolvedError;
                    if (this._seen.has(name)) return;
                    this._seen.add(name);
                    if ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.preventAllNetworkTraffic) {
                        (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                            name: 'error',
                            error: error,
                            tag: tag
                        });
                        return;
                    }
                    const sdkType = $h9lZZ.SDKType._get(this._sdkKey);
                    const statsigMetadata = $3ZDsH.StatsigMetadataProvider.get();
                    const info = isError ? unwrapped.stack : $bbc908ebca3c3209$var$_getDescription(unwrapped);
                    const body = Object.assign({
                        tag: tag,
                        exception: name,
                        info: info,
                        statsigOptions: $bbc908ebca3c3209$var$_getStatsigOptionLoggingCopy(this._options)
                    }, Object.assign(Object.assign({}, statsigMetadata), {
                        sdkType: sdkType
                    }));
                    const func = (_f = (_e = (_d = this._options) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.networkOverrideFunc) !== null && _f !== void 0 ? _f : fetch;
                    yield func(module.exports.EXCEPTION_ENDPOINT, {
                        method: 'POST',
                        headers: {
                            'STATSIG-API-KEY': this._sdkKey,
                            'STATSIG-SDK-TYPE': String(sdkType),
                            'STATSIG-SDK-VERSION': String(statsigMetadata.sdkVersion),
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(body)
                    });
                    (_g = this._emitter) === null || _g === void 0 || _g.call(this, {
                        name: 'error',
                        error: error,
                        tag: tag
                    });
                });
            impl().then(()=>{
            /* noop */ }).catch(()=>{
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    }
    constructor(_sdkKey, _options, _emitter, _lastSeenError){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._emitter = _emitter;
        this._lastSeenError = _lastSeenError;
        this._seen = new Set();
    }
}
module.exports.ErrorBoundary = $bbc908ebca3c3209$var$ErrorBoundary;
function $bbc908ebca3c3209$var$_resolveError(error) {
    if (error instanceof Error) return error;
    else if (typeof error === 'string') return new Error(error);
    else return new Error('An unknown error occurred.');
}
function $bbc908ebca3c3209$var$_getDescription(obj) {
    try {
        return JSON.stringify(obj);
    } catch (_a) {
        return $bbc908ebca3c3209$var$UNKNOWN_ERROR;
    }
}
function $bbc908ebca3c3209$var$_getAllInstanceMethodNames(instance) {
    const names = new Set();
    let proto = Object.getPrototypeOf(instance);
    while(proto && proto !== Object.prototype){
        Object.getOwnPropertyNames(proto).filter((prop)=>typeof (proto === null || proto === void 0 ? void 0 : proto[prop]) === 'function').forEach((name)=>names.add(name));
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(names);
}
function $bbc908ebca3c3209$var$_getStatsigOptionLoggingCopy(options) {
    if (!options) return {};
    const loggingCopy = {};
    Object.entries(options).forEach(([option, value])=>{
        const valueType = typeof value;
        switch(valueType){
            case 'number':
            case 'bigint':
            case 'boolean':
                loggingCopy[String(option)] = value;
                break;
            case 'string':
                if (value.length < 50) loggingCopy[String(option)] = value;
                else loggingCopy[String(option)] = 'set';
                break;
            case 'object':
                if (option === 'environment') loggingCopy['environment'] = value;
                else if (option === 'networkConfig') loggingCopy['networkConfig'] = value;
                else loggingCopy[String(option)] = value != null ? 'set' : 'unset';
                break;
            default:
        }
    });
    return loggingCopy;
}

});
parcelRegister("h9lZZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKType = void 0;
const $c7c457724196b1ee$var$SDK_CLIENT = {};
let $c7c457724196b1ee$var$suffix;
module.exports.SDKType = {
    _get: (sdkKey)=>{
        var _a;
        return ((_a = $c7c457724196b1ee$var$SDK_CLIENT[sdkKey]) !== null && _a !== void 0 ? _a : 'js-mono') + ($c7c457724196b1ee$var$suffix !== null && $c7c457724196b1ee$var$suffix !== void 0 ? $c7c457724196b1ee$var$suffix : '');
    },
    _setClientType (sdkKey, client) {
        $c7c457724196b1ee$var$SDK_CLIENT[sdkKey] = client;
    },
    _setBindingType (binding) {
        if (!$c7c457724196b1ee$var$suffix || $c7c457724196b1ee$var$suffix === '-react') $c7c457724196b1ee$var$suffix = '-' + binding;
    }
};

});


parcelRegister("4jiS5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("8FnMf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("bPlJK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("bwIp1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMemoKey = module.exports.MemoPrefix = void 0;
module.exports.MemoPrefix = {
    _gate: 'g',
    _dynamicConfig: 'c',
    _experiment: 'e',
    _configList: 'cl',
    _layer: 'l',
    _paramStore: 'p'
};
const $864520462ac5fc2e$var$EXIST_KEYS = new Set([]);
const $864520462ac5fc2e$var$DO_NOT_MEMO_KEYS = new Set([
    // Add keys that if exist, should not be memoized
    'userPersistedValues'
]);
function $864520462ac5fc2e$var$createMemoKey(prefix, name, options) {
    let cacheKey = `${prefix}|${name}`;
    if (!options) return cacheKey;
    for (const key of Object.keys(options)){
        if ($864520462ac5fc2e$var$DO_NOT_MEMO_KEYS.has(key)) return undefined;
        if ($864520462ac5fc2e$var$EXIST_KEYS.has(key)) cacheKey += `|${key}=true`;
        else cacheKey += `|${key}=${options[key]}`;
    }
    return cacheKey;
}
module.exports.createMemoKey = $864520462ac5fc2e$var$createMemoKey;

});

parcelRegister("g3P4K", function(module, exports) {
"use strict";
var $bb148bb6da761ffb$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkCore = void 0;

var $7txeW = parcelRequire("7txeW");

var $7txeW = parcelRequire("7txeW");

var $6wVPT = parcelRequire("6wVPT");

var $buErx = parcelRequire("buErx");

var $4o8Rq = parcelRequire("4o8Rq");

var $6GEjJ = parcelRequire("6GEjJ");

var $jPxYd = parcelRequire("jPxYd");

var $h9lZZ = parcelRequire("h9lZZ");

var $ek3V7 = parcelRequire("ek3V7");

var $enDXY = parcelRequire("enDXY");

var $j6vKQ = parcelRequire("j6vKQ");

var $3EHbk = parcelRequire("3EHbk");

var $3ZDsH = parcelRequire("3ZDsH");

var $56liM = parcelRequire("56liM");

var $8oyuH = parcelRequire("8oyuH");
const $bb148bb6da761ffb$var$DEFAULT_TIMEOUT_MS = 10000;
const $bb148bb6da761ffb$var$BACKOFF_BASE_MS = 500;
const $bb148bb6da761ffb$var$BACKOFF_MAX_MS = 30000;
const $bb148bb6da761ffb$var$RATE_LIMIT_WINDOW_MS = 1000;
const $bb148bb6da761ffb$var$RATE_LIMIT_MAX_REQ_COUNT = 50;
const $bb148bb6da761ffb$var$LEAK_RATE = $bb148bb6da761ffb$var$RATE_LIMIT_MAX_REQ_COUNT / $bb148bb6da761ffb$var$RATE_LIMIT_WINDOW_MS;
const $bb148bb6da761ffb$var$RETRYABLE_CODES = new Set([
    408,
    500,
    502,
    503,
    504,
    522,
    524,
    599
]);
class $bb148bb6da761ffb$var$NetworkCore {
    setLogEventCompressionMode(mode) {
        this._options.logEventCompressionMode = mode;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(this._fallbackResolver);
        this._fallbackResolver.setErrorBoundary(errorBoundary);
    }
    isBeaconSupported() {
        return typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function';
    }
    getLastUsedInitUrlAndReset() {
        const tempUrl = this._lastUsedInitUrl;
        this._lastUsedInitUrl = null;
        return tempUrl;
    }
    beacon(args) {
        if (!$bb148bb6da761ffb$var$_ensureValidSdkKey(args)) return false;
        const argsInternal = this._getInternalRequestArgs('POST', args);
        const url = this._getPopulatedURL(argsInternal);
        const nav = navigator;
        return nav.sendBeacon.bind(nav)(url, argsInternal.body);
    }
    post(args) {
        return $bb148bb6da761ffb$var$__awaiter(this, void 0, void 0, function*() {
            const argsInternal = this._getInternalRequestArgs('POST', args);
            this._tryEncodeBody(argsInternal);
            yield this._tryToCompressBody(argsInternal);
            return this._sendRequest(argsInternal);
        });
    }
    get(args) {
        const argsInternal = this._getInternalRequestArgs('GET', args);
        return this._sendRequest(argsInternal);
    }
    _sendRequest(args) {
        return $bb148bb6da761ffb$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d;
            if (!$bb148bb6da761ffb$var$_ensureValidSdkKey(args)) return null;
            if (this._netConfig.preventAllNetworkTraffic) return null;
            const { method: method, body: body, retries: retries, attempt: attempt } = args;
            const endpoint = args.urlConfig.endpoint;
            if (this._isRateLimited(endpoint)) {
                $buErx.Log.warn(`Request to ${endpoint} was blocked because you are making requests too frequently.`);
                return null;
            }
            const currentAttempt = attempt !== null && attempt !== void 0 ? attempt : 1;
            const abortController = typeof AbortController !== 'undefined' ? new AbortController() : null;
            const timeoutHandle = setTimeout(()=>{
                abortController === null || abortController === void 0 || abortController.abort(`Timeout of ${this._timeout}ms expired.`);
            }, this._timeout);
            const populatedUrl = this._getPopulatedURL(args);
            let response = null;
            const keepalive = (0, $8oyuH._isUnloading)();
            try {
                const config = {
                    method: method,
                    body: body,
                    headers: Object.assign({}, args.headers),
                    signal: abortController === null || abortController === void 0 ? void 0 : abortController.signal,
                    priority: args.priority,
                    keepalive: keepalive
                };
                $bb148bb6da761ffb$var$_tryMarkInitStart(args, currentAttempt);
                const bucket = this._leakyBucket[endpoint];
                if (bucket) {
                    bucket.lastRequestTime = Date.now();
                    this._leakyBucket[endpoint] = bucket;
                }
                const func = (_a = this._netConfig.networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch;
                response = yield func(populatedUrl, config);
                clearTimeout(timeoutHandle);
                if (!response.ok) {
                    const text = yield response.text().catch(()=>'No Text');
                    const err = new Error(`NetworkError: ${populatedUrl} ${text}`);
                    err.name = 'NetworkError';
                    throw err;
                }
                const text = yield response.text();
                $bb148bb6da761ffb$var$_tryMarkInitEnd(args, response, currentAttempt, text);
                this._fallbackResolver.tryBumpExpiryTime(args.sdkKey, args.urlConfig);
                return {
                    body: text,
                    code: response.status
                };
            } catch (error) {
                const errorMessage = $bb148bb6da761ffb$var$_getErrorMessage(abortController, error);
                const timedOut = $bb148bb6da761ffb$var$_didTimeout(abortController);
                $bb148bb6da761ffb$var$_tryMarkInitEnd(args, response, currentAttempt, '', error);
                const fallbackUpdated = yield this._fallbackResolver.tryFetchUpdatedFallbackInfo(args.sdkKey, args.urlConfig, errorMessage, timedOut);
                if (fallbackUpdated) args.fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
                if (!retries || currentAttempt > retries || !$bb148bb6da761ffb$var$RETRYABLE_CODES.has((_b = response === null || response === void 0 ? void 0 : response.status) !== null && _b !== void 0 ? _b : 500)) {
                    (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                        name: 'error',
                        error: error,
                        tag: $3EHbk.ErrorTag.NetworkError,
                        requestArgs: args
                    });
                    const formattedErrorMsg = `A networking error occurred during ${method} request to ${populatedUrl}.`;
                    $buErx.Log.error(formattedErrorMsg, errorMessage, error);
                    (_d = this._errorBoundary) === null || _d === void 0 || _d.attachErrorIfNoneExists(formattedErrorMsg);
                    return null;
                }
                yield $bb148bb6da761ffb$var$_exponentialBackoff(currentAttempt);
                return this._sendRequest(Object.assign(Object.assign({}, args), {
                    retries: retries,
                    attempt: currentAttempt + 1
                }));
            }
        });
    }
    _getLogEventCompressionMode(options) {
        // Handle backward compatibility for deprecated disableCompression flag
        let compressionMode = options === null || options === void 0 ? void 0 : options.logEventCompressionMode;
        if (!compressionMode && (options === null || options === void 0 ? void 0 : options.disableCompression) === true) compressionMode = $56liM.LogEventCompressionMode.Disabled;
        // Default to enabled if unset
        if (!compressionMode) compressionMode = $56liM.LogEventCompressionMode.Enabled;
        return compressionMode;
    }
    _isRateLimited(endpoint) {
        var _a;
        const now = Date.now();
        const bucket = (_a = this._leakyBucket[endpoint]) !== null && _a !== void 0 ? _a : {
            count: 0,
            lastRequestTime: now
        };
        const elapsed = now - bucket.lastRequestTime;
        const leakedRequests = Math.floor(elapsed * $bb148bb6da761ffb$var$LEAK_RATE);
        bucket.count = Math.max(0, bucket.count - leakedRequests);
        if (bucket.count >= $bb148bb6da761ffb$var$RATE_LIMIT_MAX_REQ_COUNT) return true;
        bucket.count += 1;
        bucket.lastRequestTime = now;
        this._leakyBucket[endpoint] = bucket;
        return false;
    }
    _getPopulatedURL(args) {
        var _a;
        const url = (_a = args.fallbackUrl) !== null && _a !== void 0 ? _a : args.urlConfig.getUrl();
        if (args.urlConfig.endpoint === $4o8Rq.Endpoint._initialize || args.urlConfig.endpoint === $4o8Rq.Endpoint._download_config_specs) this._lastUsedInitUrl = url;
        const params = Object.assign({
            [$4o8Rq.NetworkParam.SdkKey]: args.sdkKey,
            [$4o8Rq.NetworkParam.SdkType]: $h9lZZ.SDKType._get(args.sdkKey),
            [$4o8Rq.NetworkParam.SdkVersion]: $3ZDsH.SDK_VERSION,
            [$4o8Rq.NetworkParam.Time]: String(Date.now()),
            [$4o8Rq.NetworkParam.SessionID]: $enDXY.SessionID.get(args.sdkKey)
        }, args.params);
        const query = Object.keys(params).map((key)=>{
            return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
        }).join('&');
        return `${url}${query ? `?${query}` : ''}`;
    }
    _tryEncodeBody(args) {
        var _a;
        const win = (0, $ek3V7._getWindowSafe)();
        const body = args.body;
        if (!args.isStatsigEncodable || this._options.disableStatsigEncoding || typeof body !== 'string' || (0, $7txeW._getStatsigGlobalFlag)('no-encode') != null || !(win === null || win === void 0 ? void 0 : win.btoa)) return;
        try {
            args.body = win.btoa(body).split('').reverse().join('');
            args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                [$4o8Rq.NetworkParam.StatsigEncoded]: '1'
            });
        } catch (e) {
            $buErx.Log.warn(`Request encoding failed for ${args.urlConfig.getUrl()}`, e);
        }
    }
    _tryToCompressBody(args) {
        return $bb148bb6da761ffb$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const body = args.body;
            if (typeof body !== 'string' || !$bb148bb6da761ffb$var$_allowCompression(args, this._options)) return;
            try {
                const bytes = new TextEncoder().encode(body);
                const stream = new CompressionStream('gzip');
                const writer = stream.writable.getWriter();
                writer.write(bytes).catch($buErx.Log.error);
                writer.close().catch($buErx.Log.error);
                const reader = stream.readable.getReader();
                const chunks = [];
                let result;
                // eslint-disable-next-line no-await-in-loop
                while(!(result = yield reader.read()).done)chunks.push(result.value);
                const totalLength = chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
                const combined = new Uint8Array(totalLength);
                let offset = 0;
                for (const chunk of chunks){
                    combined.set(chunk, offset);
                    offset += chunk.length;
                }
                args.body = combined;
                args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                    [$4o8Rq.NetworkParam.IsGzipped]: '1'
                });
            } catch (e) {
                $buErx.Log.warn(`Request compression failed for ${args.urlConfig.getUrl()}`, e);
            }
        });
    }
    _getInternalRequestArgs(method, args) {
        const fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
        const result = Object.assign(Object.assign({}, args), {
            method: method,
            fallbackUrl: fallbackUrl
        });
        if ('data' in args) $bb148bb6da761ffb$var$_populateRequestBody(result, args.data);
        return result;
    }
    constructor(options, _emitter){
        this._emitter = _emitter;
        this._errorBoundary = null;
        this._timeout = $bb148bb6da761ffb$var$DEFAULT_TIMEOUT_MS;
        this._netConfig = {};
        this._options = {};
        this._leakyBucket = {};
        this._lastUsedInitUrl = null;
        if (options) this._options = options;
        if (this._options.networkConfig) this._netConfig = this._options.networkConfig;
        if (this._netConfig.networkTimeoutMs) this._timeout = this._netConfig.networkTimeoutMs;
        this._fallbackResolver = new $6GEjJ.NetworkFallbackResolver(this._options);
        this.setLogEventCompressionMode(this._getLogEventCompressionMode(options));
    }
}
module.exports.NetworkCore = $bb148bb6da761ffb$var$NetworkCore;
const $bb148bb6da761ffb$var$_ensureValidSdkKey = (args)=>{
    if (!args.sdkKey) {
        $buErx.Log.warn('Unable to make request without an SDK key');
        return false;
    }
    return true;
};
const $bb148bb6da761ffb$var$_populateRequestBody = (args, data)=>{
    const { sdkKey: sdkKey, fallbackUrl: fallbackUrl } = args;
    const stableID = $j6vKQ.StableID.get(sdkKey);
    const sessionID = $enDXY.SessionID.get(sdkKey);
    const sdkType = $h9lZZ.SDKType._get(sdkKey);
    args.body = JSON.stringify(Object.assign(Object.assign({}, data), {
        statsigMetadata: Object.assign(Object.assign({}, $3ZDsH.StatsigMetadataProvider.get()), {
            stableID: stableID,
            sessionID: sessionID,
            sdkType: sdkType,
            fallbackUrl: fallbackUrl
        })
    }));
};
function $bb148bb6da761ffb$var$_allowCompression(args, options) {
    if (!args.isCompressable) return false;
    // Never compress if 'no-compress' is set globally or required APIs are unavailable
    if ((0, $7txeW._getStatsigGlobalFlag)('no-compress') != null || typeof CompressionStream === 'undefined' || typeof TextEncoder === 'undefined') return false;
    const isProxy = args.urlConfig.customUrl != null || args.urlConfig.fallbackUrls != null;
    const flagEnabled = $jPxYd.SDKFlags.get(args.sdkKey, 'enable_log_event_compression') === true;
    switch(options.logEventCompressionMode){
        case $56liM.LogEventCompressionMode.Disabled:
            return false;
        case $56liM.LogEventCompressionMode.Enabled:
            // Only compress through proxy if flag is explicitly on
            if (isProxy && !flagEnabled) return false;
            return true;
        case $56liM.LogEventCompressionMode.Forced:
            return true;
        default:
            return false;
    }
}
function $bb148bb6da761ffb$var$_getErrorMessage(controller, error) {
    if ((controller === null || controller === void 0 ? void 0 : controller.signal.aborted) && typeof controller.signal.reason === 'string') return controller.signal.reason;
    if (typeof error === 'string') return error;
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    return 'Unknown Error';
}
function $bb148bb6da761ffb$var$_didTimeout(controller) {
    const timeout = (controller === null || controller === void 0 ? void 0 : controller.signal.aborted) && typeof controller.signal.reason === 'string' && controller.signal.reason.includes('Timeout');
    return timeout || false;
}
function $bb148bb6da761ffb$var$_tryMarkInitStart(args, attempt) {
    if (args.urlConfig.endpoint !== $4o8Rq.Endpoint._initialize) return;
    $6wVPT.Diagnostics._markInitNetworkReqStart(args.sdkKey, {
        attempt: attempt
    });
}
function $bb148bb6da761ffb$var$_tryMarkInitEnd(args, response, attempt, body, err) {
    if (args.urlConfig.endpoint !== $4o8Rq.Endpoint._initialize) return;
    $6wVPT.Diagnostics._markInitNetworkReqEnd(args.sdkKey, $6wVPT.Diagnostics._getDiagnosticsData(response, attempt, body, err));
}
function $bb148bb6da761ffb$var$_exponentialBackoff(attempt) {
    return $bb148bb6da761ffb$var$__awaiter(this, void 0, void 0, function*() {
        // 1*1*1000 1s
        // 2*2*1000 4s
        // 3*3*1000 9s
        // 4*4*1000 16s
        // 5*5*1000 25s
        yield new Promise((r)=>setTimeout(r, Math.min($bb148bb6da761ffb$var$BACKOFF_BASE_MS * (attempt * attempt), $bb148bb6da761ffb$var$BACKOFF_MAX_MS)));
    });
}

});
parcelRegister("6GEjJ", function(module, exports) {
"use strict";
var $4de5f07930c06cee$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isDomainFailure = module.exports.NetworkFallbackResolver = void 0;

var $hPIVf = parcelRequire("hPIVf");

var $lgqvU = parcelRequire("lgqvU");

var $buErx = parcelRequire("buErx");

var $cR1Bx = parcelRequire("cR1Bx");
const $4de5f07930c06cee$var$DEFAULT_TTL_MS = 604800000; // 7 days
const $4de5f07930c06cee$var$COOLDOWN_TIME_MS = 14400000; // 4 hours
class $4de5f07930c06cee$var$NetworkFallbackResolver {
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
    }
    tryBumpExpiryTime(sdkKey, urlConfig) {
        var _a;
        const info = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint];
        if (!info) return;
        info.expiryTime = Date.now() + $4de5f07930c06cee$var$DEFAULT_TTL_MS;
        $4de5f07930c06cee$var$_tryWriteFallbackInfoToCache(sdkKey, Object.assign(Object.assign({}, this._fallbackInfo), {
            [urlConfig.endpoint]: info
        }));
    }
    getActiveFallbackUrl(sdkKey, urlConfig) {
        var _a, _b;
        if (urlConfig.customUrl != null && urlConfig.fallbackUrls != null) return null;
        let info = this._fallbackInfo;
        if (info == null) {
            info = (_a = $4de5f07930c06cee$var$_readFallbackInfoFromCache(sdkKey)) !== null && _a !== void 0 ? _a : {};
            this._fallbackInfo = info;
        }
        const entry = info[urlConfig.endpoint];
        if (!entry || Date.now() > ((_b = entry.expiryTime) !== null && _b !== void 0 ? _b : 0) || urlConfig.getChecksum() !== entry.urlConfigChecksum) {
            delete info[urlConfig.endpoint];
            this._fallbackInfo = info;
            $4de5f07930c06cee$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
            return null;
        }
        if (entry.url) return entry.url;
        return null;
    }
    tryFetchUpdatedFallbackInfo(sdkKey, urlConfig, errorMessage, timedOut) {
        return $4de5f07930c06cee$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            try {
                if (!$4de5f07930c06cee$var$_isDomainFailure(errorMessage, timedOut)) return false;
                const canUseNetworkFallbacks = urlConfig.customUrl == null && urlConfig.fallbackUrls == null;
                const urls = canUseNetworkFallbacks ? yield this._tryFetchFallbackUrlsFromNetwork(urlConfig) : urlConfig.fallbackUrls;
                const newUrl = this._pickNewFallbackUrl((_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint], urls);
                if (!newUrl) return false;
                this._updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl);
                return true;
            } catch (error) {
                (_b = this._errorBoundary) === null || _b === void 0 || _b.logError('tryFetchUpdatedFallbackInfo', error);
                return false;
            }
        });
    }
    _updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl) {
        var _a, _b, _c;
        const newFallbackInfo = {
            urlConfigChecksum: urlConfig.getChecksum(),
            url: newUrl,
            expiryTime: Date.now() + $4de5f07930c06cee$var$DEFAULT_TTL_MS,
            previous: []
        };
        const endpoint = urlConfig.endpoint;
        const previousInfo = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[endpoint];
        if (previousInfo) newFallbackInfo.previous.push(...previousInfo.previous);
        if (newFallbackInfo.previous.length > 10) newFallbackInfo.previous = [];
        const previousUrl = (_c = (_b = this._fallbackInfo) === null || _b === void 0 ? void 0 : _b[endpoint]) === null || _c === void 0 ? void 0 : _c.url;
        if (previousUrl != null) newFallbackInfo.previous.push(previousUrl);
        this._fallbackInfo = Object.assign(Object.assign({}, this._fallbackInfo), {
            [endpoint]: newFallbackInfo
        });
        $4de5f07930c06cee$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
    }
    _tryFetchFallbackUrlsFromNetwork(urlConfig) {
        return $4de5f07930c06cee$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cooldown = this._dnsQueryCooldowns[urlConfig.endpoint];
            if (cooldown && Date.now() < cooldown) return null;
            this._dnsQueryCooldowns[urlConfig.endpoint] = Date.now() + $4de5f07930c06cee$var$COOLDOWN_TIME_MS;
            const result = [];
            const records = yield (0, $hPIVf._fetchTxtRecords)((_a = this._networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch);
            const path = $4de5f07930c06cee$var$_extractPathFromUrl(urlConfig.defaultUrl);
            for (const record of records){
                if (!record.startsWith(urlConfig.endpointDnsKey + '=')) continue;
                const parts = record.split('=');
                if (parts.length > 1) {
                    let baseUrl = parts[1];
                    if (baseUrl.endsWith('/')) baseUrl = baseUrl.slice(0, -1);
                    result.push(`https://${baseUrl}${path}`);
                }
            }
            return result;
        });
    }
    _pickNewFallbackUrl(currentFallbackInfo, urls) {
        var _a;
        if (urls == null) return null;
        const previouslyUsed = new Set((_a = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.previous) !== null && _a !== void 0 ? _a : []);
        const currentFallbackUrl = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.url;
        let found = null;
        for (const loopUrl of urls){
            const url = loopUrl.endsWith('/') ? loopUrl.slice(0, -1) : loopUrl;
            if (!previouslyUsed.has(loopUrl) && url !== currentFallbackUrl) {
                found = url;
                break;
            }
        }
        return found;
    }
    constructor(options){
        var _a;
        this._fallbackInfo = null;
        this._errorBoundary = null;
        this._dnsQueryCooldowns = {};
        this._networkOverrideFunc = (_a = options.networkConfig) === null || _a === void 0 ? void 0 : _a.networkOverrideFunc;
    }
}
module.exports.NetworkFallbackResolver = $4de5f07930c06cee$var$NetworkFallbackResolver;
function $4de5f07930c06cee$var$_isDomainFailure(errorMsg, timedOut) {
    var _a;
    const lowerErrorMsg = (_a = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.toLowerCase()) !== null && _a !== void 0 ? _a : '';
    return timedOut || lowerErrorMsg.includes('uncaught exception') || lowerErrorMsg.includes('failed to fetch') || lowerErrorMsg.includes('networkerror when attempting to fetch resource');
}
module.exports._isDomainFailure = $4de5f07930c06cee$var$_isDomainFailure;
function $4de5f07930c06cee$var$_getFallbackInfoStorageKey(sdkKey) {
    return `statsig.network_fallback.${(0, $lgqvU._DJB2)(sdkKey)}`;
}
function $4de5f07930c06cee$var$_tryWriteFallbackInfoToCache(sdkKey, info) {
    const hashKey = $4de5f07930c06cee$var$_getFallbackInfoStorageKey(sdkKey);
    if (!info || Object.keys(info).length === 0) {
        $cR1Bx.Storage.removeItem(hashKey);
        return;
    }
    $cR1Bx.Storage.setItem(hashKey, JSON.stringify(info));
}
function $4de5f07930c06cee$var$_readFallbackInfoFromCache(sdkKey) {
    const hashKey = $4de5f07930c06cee$var$_getFallbackInfoStorageKey(sdkKey);
    const data = $cR1Bx.Storage.getItem(hashKey);
    if (!data) return null;
    try {
        return JSON.parse(data);
    } catch (_a) {
        $buErx.Log.error('Failed to parse FallbackInfo');
        return null;
    }
}
function $4de5f07930c06cee$var$_extractPathFromUrl(urlString) {
    try {
        const url = new URL(urlString);
        return url.pathname;
    } catch (error) {
        return null;
    }
}

});
parcelRegister("hPIVf", function(module, exports) {
"use strict";
var $cfba0bc11a6bf4b4$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fetchTxtRecords = void 0;
// See example: https://github.com/statsig-io/private-js-client-monorepo/pull/340
const $cfba0bc11a6bf4b4$var$FEATURE_ASSETS_DNS_QUERY = new Uint8Array([
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x0d,
    0x66,
    0x65,
    0x61,
    0x74,
    0x75,
    0x72,
    0x65,
    0x61,
    0x73,
    0x73,
    0x65,
    0x74,
    0x73,
    0x03,
    0x6f,
    0x72,
    0x67,
    0x00,
    0x00,
    0x10,
    0x00,
    0x01
]);
const $cfba0bc11a6bf4b4$var$DNS_QUERY_ENDPOINT = 'https://cloudflare-dns.com/dns-query';
const $cfba0bc11a6bf4b4$var$DOMAIN_CHARS = [
    'i',
    'e',
    'd'
];
const $cfba0bc11a6bf4b4$var$MAX_START_LOOKUP = 200;
function $cfba0bc11a6bf4b4$var$_fetchTxtRecords(networkFunc) {
    return $cfba0bc11a6bf4b4$var$__awaiter(this, void 0, void 0, function*() {
        const response = yield networkFunc($cfba0bc11a6bf4b4$var$DNS_QUERY_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/dns-message',
                Accept: 'application/dns-message'
            },
            body: $cfba0bc11a6bf4b4$var$FEATURE_ASSETS_DNS_QUERY
        });
        if (!response.ok) {
            const err = new Error('Failed to fetch TXT records from DNS');
            err.name = 'DnsTxtFetchError';
            throw err;
        }
        const data = yield response.arrayBuffer();
        const bytes = new Uint8Array(data);
        return $cfba0bc11a6bf4b4$var$_parseDnsResponse(bytes);
    });
}
module.exports._fetchTxtRecords = $cfba0bc11a6bf4b4$var$_fetchTxtRecords;
function $cfba0bc11a6bf4b4$var$_parseDnsResponse(input) {
    // loop until we find the first valid domain char. One of [i=, e=, d=]
    const start = input.findIndex((byte, index)=>index < $cfba0bc11a6bf4b4$var$MAX_START_LOOKUP && String.fromCharCode(byte) === '=' && $cfba0bc11a6bf4b4$var$DOMAIN_CHARS.includes(String.fromCharCode(input[index - 1])));
    if (start === -1) {
        const err = new Error('Failed to parse TXT records from DNS');
        err.name = 'DnsTxtParseError';
        throw err;
    }
    // decode the remaining bytes as a string
    let result = '';
    for(let i = start - 1; i < input.length; i++)result += String.fromCharCode(input[i]);
    return result.split(',');
}

});


parcelRegister("jPxYd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKFlags = void 0;
const $e6fd218387017538$var$FLAGMAP = {};
module.exports.SDKFlags = {
    setFlags: (sdkKey, flags)=>{
        $e6fd218387017538$var$FLAGMAP[sdkKey] = flags;
    },
    get: (sdkKey, flagKey)=>{
        var _a, _b;
        return (_b = (_a = $e6fd218387017538$var$FLAGMAP[sdkKey]) === null || _a === void 0 ? void 0 : _a[flagKey]) !== null && _b !== void 0 ? _b : false;
    }
};

});

parcelRegister("enDXY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigSession = module.exports.SessionID = void 0;

var $7txeW = parcelRequire("7txeW");

var $8GMdc = parcelRequire("8GMdc");

var $buErx = parcelRequire("buErx");

var $cR1Bx = parcelRequire("cR1Bx");

var $3xGNu = parcelRequire("3xGNu");
const $a7823726f0d36039$var$MAX_SESSION_IDLE_TIME = 1800000; // 30 minutes
const $a7823726f0d36039$var$MAX_SESSION_AGE = 14400000; // 4 hours
const $a7823726f0d36039$var$PROMISE_MAP = {};
module.exports.SessionID = {
    get: (sdkKey)=>{
        return module.exports.StatsigSession.get(sdkKey).data.sessionID;
    }
};
module.exports.StatsigSession = {
    get: (sdkKey)=>{
        if ($a7823726f0d36039$var$PROMISE_MAP[sdkKey] == null) $a7823726f0d36039$var$PROMISE_MAP[sdkKey] = $a7823726f0d36039$var$_loadSession(sdkKey);
        const session = $a7823726f0d36039$var$PROMISE_MAP[sdkKey];
        return $a7823726f0d36039$var$_bumpSession(session);
    },
    overrideInitialSessionID: (override, sdkKey)=>{
        $a7823726f0d36039$var$PROMISE_MAP[sdkKey] = $a7823726f0d36039$var$_overrideSessionId(override, sdkKey);
    }
};
function $a7823726f0d36039$var$_loadSession(sdkKey) {
    let data = $a7823726f0d36039$var$_loadFromStorage(sdkKey);
    const now = Date.now();
    if (!data) data = {
        sessionID: (0, $3xGNu.getUUID)(),
        startTime: now,
        lastUpdate: now
    };
    return {
        data: data,
        sdkKey: sdkKey
    };
}
function $a7823726f0d36039$var$_overrideSessionId(override, sdkKey) {
    const now = Date.now();
    return {
        data: {
            sessionID: override,
            startTime: now,
            lastUpdate: now
        },
        sdkKey: sdkKey
    };
}
function $a7823726f0d36039$var$_bumpSession(session) {
    const now = Date.now();
    const data = session.data;
    const sdkKey = session.sdkKey;
    if ($a7823726f0d36039$var$_isIdle(data) || $a7823726f0d36039$var$_hasRunTooLong(data)) {
        data.sessionID = (0, $3xGNu.getUUID)();
        data.startTime = now;
        const client = __STATSIG__ === null || __STATSIG__ === void 0 ? void 0 : __STATSIG__.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }
    data.lastUpdate = now;
    $a7823726f0d36039$var$_persistToStorage(data, session.sdkKey);
    clearTimeout(session.idleTimeoutID);
    clearTimeout(session.ageTimeoutID);
    const lifetime = now - data.startTime;
    session.idleTimeoutID = $a7823726f0d36039$var$_createSessionTimeout(sdkKey, $a7823726f0d36039$var$MAX_SESSION_IDLE_TIME);
    session.ageTimeoutID = $a7823726f0d36039$var$_createSessionTimeout(sdkKey, $a7823726f0d36039$var$MAX_SESSION_AGE - lifetime);
    return session;
}
function $a7823726f0d36039$var$_createSessionTimeout(sdkKey, duration) {
    return setTimeout(()=>{
        var _a;
        const client = (_a = (0, $7txeW._getStatsigGlobal)()) === null || _a === void 0 ? void 0 : _a.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }, duration);
}
function $a7823726f0d36039$var$_isIdle({ lastUpdate: lastUpdate }) {
    return Date.now() - lastUpdate > $a7823726f0d36039$var$MAX_SESSION_IDLE_TIME;
}
function $a7823726f0d36039$var$_hasRunTooLong({ startTime: startTime }) {
    return Date.now() - startTime > $a7823726f0d36039$var$MAX_SESSION_AGE;
}
function $a7823726f0d36039$var$_getSessionIDStorageKey(sdkKey) {
    return `statsig.session_id.${(0, $8GMdc._getStorageKey)(sdkKey)}`;
}
function $a7823726f0d36039$var$_persistToStorage(session, sdkKey) {
    const storageKey = $a7823726f0d36039$var$_getSessionIDStorageKey(sdkKey);
    try {
        (0, $cR1Bx._setObjectInStorage)(storageKey, session);
    } catch (e) {
        $buErx.Log.warn('Failed to save SessionID');
    }
}
function $a7823726f0d36039$var$_loadFromStorage(sdkKey) {
    const storageKey = $a7823726f0d36039$var$_getSessionIDStorageKey(sdkKey);
    return (0, $cR1Bx._getObjectFromStorage)(storageKey);
}

});

parcelRegister("3EHbk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorTag = void 0;
module.exports.ErrorTag = {
    NetworkError: 'NetworkError'
};

});


parcelRegister("5ZbOq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("l2EVs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("1EWFi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fastApproxSizeOf = void 0;
const $13570887e38f233c$var$CURLY_AND_SQUARE_BRACKET_SIZE = 2; // [] for array, {} for object
const $13570887e38f233c$var$APPROX_ADDITIONAL_SIZE = 1; // additional size for comma and stuff
const $13570887e38f233c$var$_fastApproxSizeOf = (obj, max)=>{
    let size = 0;
    const keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const value = obj[key];
        size += key.length;
        if (typeof value === 'object' && value !== null) size += (0, module.exports._fastApproxSizeOf)(value, max) + $13570887e38f233c$var$CURLY_AND_SQUARE_BRACKET_SIZE;
        else size += String(value).length + $13570887e38f233c$var$APPROX_ADDITIONAL_SIZE;
        if (size >= max) // exit early if we've exceeded the max
        return size;
    }
    return size;
};
module.exports._fastApproxSizeOf = $13570887e38f233c$var$_fastApproxSizeOf;

});

parcelRegister("4Hfj9", function(module, exports) {
"use strict";
var $36b70d6677986e5a$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClientBase = void 0;

var $7txeW = parcelRequire("7txeW");

var $7txeW = parcelRequire("7txeW");

var $g7zKQ = parcelRequire("g7zKQ");

var $jgDpr = parcelRequire("jgDpr");

var $buErx = parcelRequire("buErx");

var $bwIp1 = parcelRequire("bwIp1");

var $ek3V7 = parcelRequire("ek3V7");

var $enDXY = parcelRequire("enDXY");

var $j6vKQ = parcelRequire("j6vKQ");

var $56liM = parcelRequire("56liM");

var $cR1Bx = parcelRequire("cR1Bx");
const $36b70d6677986e5a$var$MAX_MEMO_CACHE_SIZE = 3000;
class $36b70d6677986e5a$var$StatsigClientBase {
    /**
     * Updates runtime configuration options for the SDK, allowing toggling of certain behaviors such as logging and storage to comply with user preferences or regulations such as GDPR.
     *
     * @param {StatsigRuntimeMutableOptions} options - The configuration options that dictate the runtime behavior of the SDK.
     */ updateRuntimeOptions(options) {
        if (options.loggingEnabled) {
            this._options.loggingEnabled = options.loggingEnabled;
            this._logger.setLoggingEnabled(options.loggingEnabled);
        } else if (options.disableLogging != null) {
            this._options.disableLogging = options.disableLogging;
            this._logger.setLoggingEnabled(options.disableLogging ? 'disabled' : 'browser-only');
        }
        if (options.disableStorage != null) {
            this._options.disableStorage = options.disableStorage;
            $cR1Bx.Storage._setDisabled(options.disableStorage);
        }
        if (options.enableCookies != null) {
            this._options.enableCookies = options.enableCookies;
            $j6vKQ.StableID._setCookiesEnabled(this._sdkKey, options.enableCookies);
        }
        if (options.logEventCompressionMode) this._logger.setLogEventCompressionMode(options.logEventCompressionMode);
        else if (options.disableCompression) this._logger.setLogEventCompressionMode($56liM.LogEventCompressionMode.Disabled);
    }
    /**
     * Flushes any currently queued events.
     */ flush() {
        return this._logger.flush();
    }
    /**
     * Gracefully shuts down the SDK, ensuring that all pending events are send before the SDK stops.
     * This function emits a 'pre_shutdown' event and then waits for the logger to complete its shutdown process.
     *
     * @returns {Promise<void>} A promise that resolves when all shutdown procedures, including logging shutdown, have been completed.
     */ shutdown() {
        return $36b70d6677986e5a$var$__awaiter(this, void 0, void 0, function*() {
            this.$emt({
                name: 'pre_shutdown'
            });
            this._setStatus('Uninitialized', null);
            this._initializePromise = null;
            yield this._logger.stop();
        });
    }
    /**
     * Subscribes a callback function to a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     * Once subscribed, the listener callback will be invoked whenever the specified event is emitted.
     *
     * @param {StatsigClientEventName} event - The name of the event to subscribe to, or '*' to subscribe to all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to execute when the event occurs. The function receives event-specific data as its parameter.
     * @see {@link off} for unsubscribing from events.
     */ on(event, listener) {
        if (!this._listeners[event]) this._listeners[event] = [];
        this._listeners[event].push(listener);
    }
    /**
     * Unsubscribes a previously registered callback function from a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     *
     * @param {StatsigClientEventName} event - The name of the event from which to unsubscribe, or '*' to unsubscribe from all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to remove from the event's notification list.
     * @see {@link on} for subscribing to events.
     */ off(event, listener) {
        if (this._listeners[event]) {
            const index = this._listeners[event].indexOf(listener);
            if (index !== -1) this._listeners[event].splice(index, 1);
        }
    }
    $on(event, listener) {
        listener.__isInternal = true;
        this.on(event, listener);
    }
    $emt(event) {
        var _a;
        const barrier = (listener)=>{
            try {
                listener(event);
            } catch (error) {
                if (listener.__isInternal === true) {
                    this._errorBoundary.logError(`__emit:${event.name}`, error);
                    return;
                }
                $buErx.Log.error(`An error occurred in a StatsigClientEvent listener. This is not an issue with Statsig.`, event);
            }
        };
        if (this._listeners[event.name]) this._listeners[event.name].forEach((l)=>barrier(l));
        (_a = this._listeners['*']) === null || _a === void 0 || _a.forEach(barrier);
    }
    _setStatus(newStatus, values) {
        this.loadingStatus = newStatus;
        this._memoCache = {};
        this.$emt({
            name: 'values_updated',
            status: newStatus,
            values: values
        });
    }
    _enqueueExposure(name, exposure, options) {
        if ((options === null || options === void 0 ? void 0 : options.disableExposureLog) === true) {
            this._logger.incrementNonExposureCount(name);
            return;
        }
        this._logger.enqueue(exposure);
    }
    _memoize(prefix, fn) {
        return (name, options)=>{
            if (this._options.disableEvaluationMemoization) return fn(name, options);
            const memoKey = (0, $bwIp1.createMemoKey)(prefix, name, options);
            if (!memoKey) return fn(name, options);
            if (!(memoKey in this._memoCache)) {
                if (Object.keys(this._memoCache).length >= $36b70d6677986e5a$var$MAX_MEMO_CACHE_SIZE) this._memoCache = {};
                this._memoCache[memoKey] = fn(name, options);
            }
            return this._memoCache[memoKey];
        };
    }
    constructor(sdkKey, adapter, network, options){
        var _a, _b, _c, _d;
        this.loadingStatus = 'Uninitialized';
        this._initializePromise = null;
        this._listeners = {};
        const emitter = this.$emt.bind(this);
        (options === null || options === void 0 ? void 0 : options.logLevel) != null && ($buErx.Log.level = options.logLevel);
        (options === null || options === void 0 ? void 0 : options.disableStorage) && $cR1Bx.Storage._setDisabled(true);
        (options === null || options === void 0 ? void 0 : options.initialSessionID) && $enDXY.StatsigSession.overrideInitialSessionID(options.initialSessionID, sdkKey);
        (options === null || options === void 0 ? void 0 : options.storageProvider) && $cR1Bx.Storage._setProvider(options.storageProvider);
        (options === null || options === void 0 ? void 0 : options.enableCookies) && $j6vKQ.StableID._setCookiesEnabled(sdkKey, options.enableCookies);
        (options === null || options === void 0 ? void 0 : options.disableStableID) && $j6vKQ.StableID._setDisabled(sdkKey, true);
        this._sdkKey = sdkKey;
        this._options = options !== null && options !== void 0 ? options : {};
        this._memoCache = {};
        this.overrideAdapter = (_a = options === null || options === void 0 ? void 0 : options.overrideAdapter) !== null && _a !== void 0 ? _a : null;
        this._logger = new $jgDpr.EventLogger(sdkKey, emitter, network, options);
        this._errorBoundary = new $g7zKQ.ErrorBoundary(sdkKey, options, emitter);
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(adapter);
        this._errorBoundary.wrap(this._logger);
        network.setErrorBoundary(this._errorBoundary);
        this.dataAdapter = adapter;
        this.dataAdapter.attach(sdkKey, options, network);
        this.storageProvider = $cR1Bx.Storage;
        (_d = (_c = (_b = this.overrideAdapter) === null || _b === void 0 ? void 0 : _b.loadFromStorage) === null || _c === void 0 ? void 0 : _c.call(_b)) === null || _d === void 0 || _d.catch((e)=>this._errorBoundary.logError('OA::loadFromStorage', e));
        this._primeReadyRipcord();
        $36b70d6677986e5a$var$_assignGlobalInstance(sdkKey, this);
    }
}
module.exports.StatsigClientBase = $36b70d6677986e5a$var$StatsigClientBase;
function $36b70d6677986e5a$var$_assignGlobalInstance(sdkKey, client) {
    var _a;
    if ((0, $ek3V7._isServerEnv)()) return;
    const statsigGlobal = (0, $7txeW._getStatsigGlobal)();
    const instances = (_a = statsigGlobal.instances) !== null && _a !== void 0 ? _a : {};
    const inst = client;
    if (instances[sdkKey] != null) $buErx.Log.warn('Creating multiple Statsig clients with the same SDK key can lead to unexpected behavior. Multi-instance support requires different SDK keys.');
    instances[sdkKey] = inst;
    if (!statsigGlobal.firstInstance) statsigGlobal.firstInstance = inst;
    statsigGlobal.instances = instances;
    __STATSIG__ = statsigGlobal;
}

});

parcelRegister("ccTlk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataAdapterCachePrefix = void 0;
module.exports.DataAdapterCachePrefix = 'statsig.cached';

});

parcelRegister("47Ws6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("g1Z01", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeTypedGet = module.exports._mergeOverride = module.exports._makeLayer = module.exports._makeExperiment = module.exports._makeDynamicConfig = module.exports._makeFeatureGate = void 0;

var $buErx = parcelRequire("buErx");

var $8r058 = parcelRequire("8r058");
function $babc0e8da8426862$var$_makeEvaluation(name, details, evaluation, value) {
    var _a;
    return {
        name: name,
        details: details,
        ruleID: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.rule_id) !== null && _a !== void 0 ? _a : '',
        __evaluation: evaluation,
        value: value
    };
}
function $babc0e8da8426862$var$_makeFeatureGate(name, details, evaluation) {
    var _a;
    return Object.assign(Object.assign({}, $babc0e8da8426862$var$_makeEvaluation(name, details, evaluation, (evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) === true)), {
        idType: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeFeatureGate = $babc0e8da8426862$var$_makeFeatureGate;
function $babc0e8da8426862$var$_makeDynamicConfig(name, details, evaluation) {
    var _a;
    const value = (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, $babc0e8da8426862$var$_makeEvaluation(name, details, evaluation, value)), {
        get: $babc0e8da8426862$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value)
    });
}
module.exports._makeDynamicConfig = $babc0e8da8426862$var$_makeDynamicConfig;
function $babc0e8da8426862$var$_makeExperiment(name, details, evaluation) {
    var _a;
    const result = $babc0e8da8426862$var$_makeDynamicConfig(name, details, evaluation);
    return Object.assign(Object.assign({}, result), {
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeExperiment = $babc0e8da8426862$var$_makeExperiment;
function $babc0e8da8426862$var$_makeLayer(name, details, evaluation, exposeFunc) {
    var _a, _b;
    return Object.assign(Object.assign({}, $babc0e8da8426862$var$_makeEvaluation(name, details, evaluation, undefined)), {
        get: $babc0e8da8426862$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value, exposeFunc),
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null,
        __value: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _b !== void 0 ? _b : {}
    });
}
module.exports._makeLayer = $babc0e8da8426862$var$_makeLayer;
function $babc0e8da8426862$var$_mergeOverride(original, overridden, value, exposeFunc) {
    return Object.assign(Object.assign(Object.assign({}, original), overridden), {
        get: $babc0e8da8426862$var$_makeTypedGet(original.name, value, exposeFunc)
    });
}
module.exports._mergeOverride = $babc0e8da8426862$var$_mergeOverride;
function $babc0e8da8426862$var$_makeTypedGet(name, value, exposeFunc) {
    return (param, fallback)=>{
        var _a;
        const found = (_a = value === null || value === void 0 ? void 0 : value[param]) !== null && _a !== void 0 ? _a : null;
        if (found == null) return fallback !== null && fallback !== void 0 ? fallback : null;
        if (fallback != null && !(0, $8r058._isTypeMatch)(found, fallback)) {
            $buErx.Log.warn(`Parameter type mismatch. '${name}.${param}' was found to be type '${typeof found}' but fallback/return type is '${typeof fallback}'. See https://docs.statsig.com/client/javascript-sdk/#typed-getters`);
            return fallback !== null && fallback !== void 0 ? fallback : null;
        }
        exposeFunc === null || exposeFunc === void 0 || exposeFunc(param);
        return found;
    };
}
module.exports._makeTypedGet = $babc0e8da8426862$var$_makeTypedGet;

});

parcelRegister("dbLnW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("4hmQg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = module.exports.createUpdateDetails = void 0;
const $31da77debcf68bd8$var$createUpdateDetails = (success, source, initDuration, error, sourceUrl, warnings)=>{
    return {
        duration: initDuration,
        source: source,
        success: success,
        error: error,
        sourceUrl: sourceUrl,
        warnings: warnings
    };
};
module.exports.createUpdateDetails = $31da77debcf68bd8$var$createUpdateDetails;
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = {
    NO_NETWORK_DATA: 'No data was returned from the network. This may be due to a network timeout if a timeout value was specified in the options or ad blocker error.'
};

});


parcelRegister("g2TNZ", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ var $bae81efe407ed663$var$_a, $bae81efe407ed663$var$_b, $bae81efe407ed663$var$_c;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getInstance = module.exports._getStatsigGlobalFlag = module.exports._getStatsigGlobal = void 0;

var $734ad = parcelRequire("734ad");
const $bae81efe407ed663$var$_getStatsigGlobal = ()=>{
    // Avoid ReferenceError, which is happening with Cloudflare pages
    try {
        return typeof __STATSIG__ !== 'undefined' ? __STATSIG__ : $bae81efe407ed663$var$statsigGlobal;
    } catch (e) {
        return $bae81efe407ed663$var$statsigGlobal;
    }
};
module.exports._getStatsigGlobal = $bae81efe407ed663$var$_getStatsigGlobal;
const $bae81efe407ed663$var$_getStatsigGlobalFlag = (flag)=>{
    return (0, module.exports._getStatsigGlobal)()[flag];
};
module.exports._getStatsigGlobalFlag = $bae81efe407ed663$var$_getStatsigGlobalFlag;
const $bae81efe407ed663$var$_getInstance = (sdkKey)=>{
    const gbl = (0, module.exports._getStatsigGlobal)();
    if (!sdkKey) {
        if (gbl.instances && Object.keys(gbl.instances).length > 1) $734ad.Log.warn('Call made to Statsig global instance without an SDK key but there is more than one client instance. If you are using mulitple clients, please specify the SDK key.');
        return gbl.firstInstance;
    }
    return gbl.instances && gbl.instances[sdkKey];
};
module.exports._getInstance = $bae81efe407ed663$var$_getInstance;
const $bae81efe407ed663$var$GLOBAL_KEY = '__STATSIG__';
const $bae81efe407ed663$var$_window = typeof window !== 'undefined' ? window : {};
const $bae81efe407ed663$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : {};
const $bae81efe407ed663$var$_globalThis = typeof globalThis !== 'undefined' ? globalThis : {};
const $bae81efe407ed663$var$statsigGlobal = ($bae81efe407ed663$var$_c = ($bae81efe407ed663$var$_b = ($bae81efe407ed663$var$_a = $bae81efe407ed663$var$_window[$bae81efe407ed663$var$GLOBAL_KEY]) !== null && $bae81efe407ed663$var$_a !== void 0 ? $bae81efe407ed663$var$_a : $bae81efe407ed663$var$_global[$bae81efe407ed663$var$GLOBAL_KEY]) !== null && $bae81efe407ed663$var$_b !== void 0 ? $bae81efe407ed663$var$_b : $bae81efe407ed663$var$_globalThis[$bae81efe407ed663$var$GLOBAL_KEY]) !== null && $bae81efe407ed663$var$_c !== void 0 ? $bae81efe407ed663$var$_c : {
    instance: module.exports._getInstance
};
$bae81efe407ed663$var$_window[$bae81efe407ed663$var$GLOBAL_KEY] = $bae81efe407ed663$var$statsigGlobal;
$bae81efe407ed663$var$_global[$bae81efe407ed663$var$GLOBAL_KEY] = $bae81efe407ed663$var$statsigGlobal;
$bae81efe407ed663$var$_globalThis[$bae81efe407ed663$var$GLOBAL_KEY] = $bae81efe407ed663$var$statsigGlobal;

});
parcelRegister("734ad", function(module, exports) {
"use strict";
/* eslint-disable no-console */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Log = module.exports.LogLevel = void 0;
// intentionally spaced for formatting
const $521c0b07cba11972$var$DEBUG = ' DEBUG ';
const $521c0b07cba11972$var$_INFO = '  INFO ';
const $521c0b07cba11972$var$_WARN = '  WARN ';
const $521c0b07cba11972$var$ERROR = ' ERROR ';
function $521c0b07cba11972$var$addTag(args) {
    args.unshift('[Statsig]');
    return args; // ['[Statsig]', ...args];
}
module.exports.LogLevel = {
    None: 0,
    Error: 1,
    Warn: 2,
    Info: 3,
    Debug: 4
};
class $521c0b07cba11972$var$Log {
    static info(...args) {
        if ($521c0b07cba11972$var$Log.level >= module.exports.LogLevel.Info) console.info($521c0b07cba11972$var$_INFO, ...$521c0b07cba11972$var$addTag(args));
    }
    static debug(...args) {
        if ($521c0b07cba11972$var$Log.level >= module.exports.LogLevel.Debug) console.debug($521c0b07cba11972$var$DEBUG, ...$521c0b07cba11972$var$addTag(args));
    }
    static warn(...args) {
        if ($521c0b07cba11972$var$Log.level >= module.exports.LogLevel.Warn) console.warn($521c0b07cba11972$var$_WARN, ...$521c0b07cba11972$var$addTag(args));
    }
    static error(...args) {
        if ($521c0b07cba11972$var$Log.level >= module.exports.LogLevel.Error) console.error($521c0b07cba11972$var$ERROR, ...$521c0b07cba11972$var$addTag(args));
    }
}
module.exports.Log = $521c0b07cba11972$var$Log;
$521c0b07cba11972$var$Log.level = module.exports.LogLevel.Warn;

});


parcelRegister("4k5J2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Diagnostics = void 0;
const $325d789e1b7d2114$var$MARKER_MAP = new Map();
const $325d789e1b7d2114$var$ACT_START = 'start';
const $325d789e1b7d2114$var$ACT_END = 'end';
const $325d789e1b7d2114$var$DIAGNOSTICS_EVENT = 'statsig::diagnostics';
module.exports.Diagnostics = {
    _getMarkers: (sdkKey)=>{
        return $325d789e1b7d2114$var$MARKER_MAP.get(sdkKey);
    },
    _markInitOverallStart: (sdkKey)=>{
        $325d789e1b7d2114$var$_addMarker(sdkKey, $325d789e1b7d2114$var$_createMarker({}, $325d789e1b7d2114$var$ACT_START, 'overall'));
    },
    _markInitOverallEnd: (sdkKey, success, evaluationDetails)=>{
        $325d789e1b7d2114$var$_addMarker(sdkKey, $325d789e1b7d2114$var$_createMarker({
            success: success,
            error: success ? undefined : {
                name: 'InitializeError',
                message: 'Failed to initialize'
            },
            evaluationDetails: evaluationDetails
        }, $325d789e1b7d2114$var$ACT_END, 'overall'));
    },
    _markInitNetworkReqStart: (sdkKey, data)=>{
        $325d789e1b7d2114$var$_addMarker(sdkKey, $325d789e1b7d2114$var$_createMarker(data, $325d789e1b7d2114$var$ACT_START, 'initialize', 'network_request'));
    },
    _markInitNetworkReqEnd: (sdkKey, data)=>{
        $325d789e1b7d2114$var$_addMarker(sdkKey, $325d789e1b7d2114$var$_createMarker(data, $325d789e1b7d2114$var$ACT_END, 'initialize', 'network_request'));
    },
    _markInitProcessStart: (sdkKey)=>{
        $325d789e1b7d2114$var$_addMarker(sdkKey, $325d789e1b7d2114$var$_createMarker({}, $325d789e1b7d2114$var$ACT_START, 'initialize', 'process'));
    },
    _markInitProcessEnd: (sdkKey, data)=>{
        $325d789e1b7d2114$var$_addMarker(sdkKey, $325d789e1b7d2114$var$_createMarker(data, $325d789e1b7d2114$var$ACT_END, 'initialize', 'process'));
    },
    _clearMarkers: (sdkKey)=>{
        $325d789e1b7d2114$var$MARKER_MAP.delete(sdkKey);
    },
    _formatError (e) {
        if (!(e && typeof e === 'object')) return;
        return {
            code: $325d789e1b7d2114$var$_safeGetField(e, 'code'),
            name: $325d789e1b7d2114$var$_safeGetField(e, 'name'),
            message: $325d789e1b7d2114$var$_safeGetField(e, 'message')
        };
    },
    _getDiagnosticsData (res, attempt, body, e) {
        var _a;
        return {
            success: (res === null || res === void 0 ? void 0 : res.ok) === true,
            statusCode: res === null || res === void 0 ? void 0 : res.status,
            sdkRegion: (_a = res === null || res === void 0 ? void 0 : res.headers) === null || _a === void 0 ? void 0 : _a.get('x-statsig-region'),
            isDelta: body.includes('"is_delta":true') === true ? true : undefined,
            attempt: attempt,
            error: module.exports.Diagnostics._formatError(e)
        };
    },
    _enqueueDiagnosticsEvent (user, logger, sdk, options) {
        const markers = module.exports.Diagnostics._getMarkers(sdk);
        if (markers == null || markers.length <= 0) return -1;
        const overallInitDuration = markers[markers.length - 1].timestamp - markers[0].timestamp;
        module.exports.Diagnostics._clearMarkers(sdk);
        const event = $325d789e1b7d2114$var$_makeDiagnosticsEvent(user, {
            context: 'initialize',
            markers: markers.slice(),
            statsigOptions: options
        });
        logger.enqueue(event);
        return overallInitDuration;
    }
};
function $325d789e1b7d2114$var$_createMarker(data, action, key, step) {
    return Object.assign({
        key: key,
        action: action,
        step: step,
        timestamp: Date.now()
    }, data);
}
function $325d789e1b7d2114$var$_makeDiagnosticsEvent(user, data) {
    const latencyEvent = {
        eventName: $325d789e1b7d2114$var$DIAGNOSTICS_EVENT,
        user: user,
        value: null,
        metadata: data,
        time: Date.now()
    };
    return latencyEvent;
}
function $325d789e1b7d2114$var$_addMarker(sdkKey, marker) {
    var _a;
    const markers = (_a = $325d789e1b7d2114$var$MARKER_MAP.get(sdkKey)) !== null && _a !== void 0 ? _a : [];
    markers.push(marker);
    $325d789e1b7d2114$var$MARKER_MAP.set(sdkKey, markers);
}
function $325d789e1b7d2114$var$_safeGetField(data, field) {
    if (field in data) return data[field];
    return undefined;
}

});

parcelRegister("7dAGN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getStorageKey = module.exports._getUserStorageKey = void 0;

var $5xWeB = parcelRequire("5xWeB");
function $5416350474be1a6f$var$_getUserStorageKey(sdkKey, user, customKeyGenerator) {
    var _a;
    if (customKeyGenerator) return customKeyGenerator(sdkKey, user);
    const cids = user && user.customIDs ? user.customIDs : {};
    const parts = [
        `uid:${(_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ''}`,
        `cids:${Object.keys(cids).sort((leftKey, rightKey)=>leftKey.localeCompare(rightKey)).map((key)=>`${key}-${cids[key]}`).join(',')}`,
        `k:${sdkKey}`
    ];
    return (0, $5xWeB._DJB2)(parts.join('|'));
}
module.exports._getUserStorageKey = $5416350474be1a6f$var$_getUserStorageKey;
function $5416350474be1a6f$var$_getStorageKey(sdkKey, user, customKeyGenerator) {
    if (user) return $5416350474be1a6f$var$_getUserStorageKey(sdkKey, user, customKeyGenerator);
    return (0, $5xWeB._DJB2)(`k:${sdkKey}`);
}
module.exports._getStorageKey = $5416350474be1a6f$var$_getStorageKey;

});
parcelRegister("5xWeB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getSortedObject = module.exports._DJB2Object = module.exports._DJB2 = void 0;

var $23ExQ = parcelRequire("23ExQ");
const $409d3501282518d5$var$_DJB2 = (value)=>{
    let hash = 0;
    for(let i = 0; i < value.length; i++){
        const character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
};
module.exports._DJB2 = $409d3501282518d5$var$_DJB2;
const $409d3501282518d5$var$_DJB2Object = (value, maxLevels)=>{
    return (0, module.exports._DJB2)(JSON.stringify((0, module.exports._getSortedObject)(value, maxLevels)));
};
module.exports._DJB2Object = $409d3501282518d5$var$_DJB2Object;
const $409d3501282518d5$var$_getSortedObject = (object, maxDepth)=>{
    if (object == null) return null;
    const keys = Object.keys(object).sort();
    const sortedObject = {};
    keys.forEach((key)=>{
        const value = object[key];
        if (maxDepth === 0 || (0, $23ExQ._typeOf)(value) !== 'object') {
            sortedObject[key] = value;
            return;
        }
        sortedObject[key] = (0, module.exports._getSortedObject)(value, maxDepth != null ? maxDepth - 1 : maxDepth);
    });
    return sortedObject;
};
module.exports._getSortedObject = $409d3501282518d5$var$_getSortedObject;

});
parcelRegister("23ExQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isTypeMatch = module.exports._typeOf = void 0;
function $17fb4fed8588544f$var$_typeOf(input) {
    return Array.isArray(input) ? 'array' : typeof input;
}
module.exports._typeOf = $17fb4fed8588544f$var$_typeOf;
function $17fb4fed8588544f$var$_isTypeMatch(a, b) {
    const typeOf = (x)=>Array.isArray(x) ? 'array' : x === null ? 'null' : typeof x;
    return typeOf(a) === typeOf(b);
}
module.exports._isTypeMatch = $17fb4fed8588544f$var$_isTypeMatch;

});



parcelRegister("l3sJo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkParam = module.exports.NetworkDefault = module.exports.Endpoint = void 0;
module.exports.Endpoint = {
    _initialize: 'initialize',
    _rgstr: 'rgstr',
    _download_config_specs: 'download_config_specs'
};
module.exports.NetworkDefault = {
    [module.exports.Endpoint._rgstr]: 'https://prodregistryv2.org/v1',
    [module.exports.Endpoint._initialize]: 'https://featureassets.org/v1',
    [module.exports.Endpoint._download_config_specs]: 'https://api.statsigcdn.com/v1'
};
module.exports.NetworkParam = {
    EventCount: 'ec',
    SdkKey: 'k',
    SdkType: 'st',
    SdkVersion: 'sv',
    Time: 't',
    SessionID: 'sid',
    StatsigEncoded: 'se',
    IsGzipped: 'gz'
};

});

parcelRegister("3h5v5", function(module, exports) {

var $1CHRc = parcelRequire("1CHRc");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getUnloadEvent = module.exports._getCurrentPageUrlSafe = module.exports._addDocumentEventListenerSafe = module.exports._addWindowEventListenerSafe = module.exports._isServerEnv = module.exports._getDocumentSafe = module.exports._getWindowSafe = void 0;
const $262739df0cb67433$var$_getWindowSafe = ()=>{
    return typeof window !== 'undefined' ? window : null;
};
module.exports._getWindowSafe = $262739df0cb67433$var$_getWindowSafe;
const $262739df0cb67433$var$_getDocumentSafe = ()=>{
    var _a;
    const win = (0, module.exports._getWindowSafe)();
    return (_a = win === null || win === void 0 ? void 0 : win.document) !== null && _a !== void 0 ? _a : null;
};
module.exports._getDocumentSafe = $262739df0cb67433$var$_getDocumentSafe;
const $262739df0cb67433$var$_isServerEnv = ()=>{
    if ((0, module.exports._getDocumentSafe)() !== null) return false;
    const isNode = typeof $1CHRc !== 'undefined' && $1CHRc.versions != null && $1CHRc.versions.node != null;
    const isVercel = typeof EdgeRuntime === 'string';
    return isVercel || isNode;
};
module.exports._isServerEnv = $262739df0cb67433$var$_isServerEnv;
const $262739df0cb67433$var$_addWindowEventListenerSafe = (key, listener)=>{
    const win = (0, module.exports._getWindowSafe)();
    if (typeof (win === null || win === void 0 ? void 0 : win.addEventListener) === 'function') win.addEventListener(key, listener);
};
module.exports._addWindowEventListenerSafe = $262739df0cb67433$var$_addWindowEventListenerSafe;
const $262739df0cb67433$var$_addDocumentEventListenerSafe = (key, listener)=>{
    const doc = (0, module.exports._getDocumentSafe)();
    if (typeof (doc === null || doc === void 0 ? void 0 : doc.addEventListener) === 'function') doc.addEventListener(key, listener);
};
module.exports._addDocumentEventListenerSafe = $262739df0cb67433$var$_addDocumentEventListenerSafe;
const $262739df0cb67433$var$_getCurrentPageUrlSafe = ()=>{
    var _a;
    try {
        return (_a = (0, module.exports._getWindowSafe)()) === null || _a === void 0 ? void 0 : _a.location.href.split(/[?#]/)[0];
    } catch (_b) {
        return;
    }
};
module.exports._getCurrentPageUrlSafe = $262739df0cb67433$var$_getCurrentPageUrlSafe;
const $262739df0cb67433$var$_getUnloadEvent = ()=>{
    const win = (0, module.exports._getWindowSafe)();
    if (!win) return 'beforeunload';
    const eventType = 'onpagehide' in win ? 'pagehide' : 'beforeunload';
    return eventType;
};
module.exports._getUnloadEvent = $262739df0cb67433$var$_getUnloadEvent;

});

parcelRegister("kTyja", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._createLayerParameterExposure = module.exports._createConfigExposure = module.exports._mapExposures = module.exports._createGateExposure = module.exports._isExposureEvent = void 0;
const $f3638e983b95d5b5$var$CONFIG_EXPOSURE_NAME = 'statsig::config_exposure';
const $f3638e983b95d5b5$var$GATE_EXPOSURE_NAME = 'statsig::gate_exposure';
const $f3638e983b95d5b5$var$LAYER_EXPOSURE_NAME = 'statsig::layer_exposure';
const $f3638e983b95d5b5$var$_createExposure = (eventName, user, details, metadata, secondaryExposures)=>{
    if (details.bootstrapMetadata) metadata['bootstrapMetadata'] = details.bootstrapMetadata;
    return {
        eventName: eventName,
        user: user,
        value: null,
        metadata: $f3638e983b95d5b5$var$_addEvaluationDetailsToMetadata(details, metadata),
        secondaryExposures: secondaryExposures,
        time: Date.now()
    };
};
const $f3638e983b95d5b5$var$_isExposureEvent = ({ eventName: eventName })=>{
    return eventName === $f3638e983b95d5b5$var$GATE_EXPOSURE_NAME || eventName === $f3638e983b95d5b5$var$CONFIG_EXPOSURE_NAME || eventName === $f3638e983b95d5b5$var$LAYER_EXPOSURE_NAME;
};
module.exports._isExposureEvent = $f3638e983b95d5b5$var$_isExposureEvent;
const $f3638e983b95d5b5$var$_createGateExposure = (user, gate, exposureMapping)=>{
    var _a, _b, _c;
    const metadata = {
        gate: gate.name,
        gateValue: String(gate.value),
        ruleID: gate.ruleID
    };
    if (((_a = gate.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = gate.__evaluation.version;
    return $f3638e983b95d5b5$var$_createExposure($f3638e983b95d5b5$var$GATE_EXPOSURE_NAME, user, gate.details, metadata, $f3638e983b95d5b5$var$_mapExposures((_c = (_b = gate.__evaluation) === null || _b === void 0 ? void 0 : _b.secondary_exposures) !== null && _c !== void 0 ? _c : [], exposureMapping));
};
module.exports._createGateExposure = $f3638e983b95d5b5$var$_createGateExposure;
function $f3638e983b95d5b5$var$_mapExposures(exposures, exposureMapping) {
    return exposures.map((exposure)=>{
        if (typeof exposure === 'string') return (exposureMapping !== null && exposureMapping !== void 0 ? exposureMapping : {})[exposure];
        return exposure;
    }).filter((exposure)=>exposure != null);
}
module.exports._mapExposures = $f3638e983b95d5b5$var$_mapExposures;
const $f3638e983b95d5b5$var$_createConfigExposure = (user, config, exposureMapping)=>{
    var _a, _b, _c, _d;
    const metadata = {
        config: config.name,
        ruleID: config.ruleID
    };
    if (((_a = config.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = config.__evaluation.version;
    if (((_b = config.__evaluation) === null || _b === void 0 ? void 0 : _b.passed) != null) metadata['rulePassed'] = String(config.__evaluation.passed);
    return $f3638e983b95d5b5$var$_createExposure($f3638e983b95d5b5$var$CONFIG_EXPOSURE_NAME, user, config.details, metadata, $f3638e983b95d5b5$var$_mapExposures((_d = (_c = config.__evaluation) === null || _c === void 0 ? void 0 : _c.secondary_exposures) !== null && _d !== void 0 ? _d : [], exposureMapping));
};
module.exports._createConfigExposure = $f3638e983b95d5b5$var$_createConfigExposure;
const $f3638e983b95d5b5$var$_createLayerParameterExposure = (user, layer, parameterName, exposureMapping)=>{
    var _a, _b, _c, _d, _e, _f, _g;
    const evaluation = layer.__evaluation;
    const isExplicit = ((_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.explicit_parameters) === null || _a === void 0 ? void 0 : _a.includes(parameterName)) === true;
    let allocatedExperiment = '';
    let secondaryExposures = (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.undelegated_secondary_exposures) !== null && _b !== void 0 ? _b : [];
    if (isExplicit) {
        allocatedExperiment = (_c = evaluation.allocated_experiment_name) !== null && _c !== void 0 ? _c : '';
        secondaryExposures = (_d = evaluation.secondary_exposures) !== null && _d !== void 0 ? _d : [];
    }
    const parameterRuleIDs = (_e = layer.__evaluation) === null || _e === void 0 ? void 0 : _e.parameter_rule_ids;
    const metadata = {
        config: layer.name,
        parameterName: parameterName,
        ruleID: (_f = parameterRuleIDs === null || parameterRuleIDs === void 0 ? void 0 : parameterRuleIDs[parameterName]) !== null && _f !== void 0 ? _f : layer.ruleID,
        allocatedExperiment: allocatedExperiment,
        isExplicitParameter: String(isExplicit)
    };
    if (((_g = layer.__evaluation) === null || _g === void 0 ? void 0 : _g.version) != null) metadata['configVersion'] = layer.__evaluation.version;
    return $f3638e983b95d5b5$var$_createExposure($f3638e983b95d5b5$var$LAYER_EXPOSURE_NAME, user, layer.details, metadata, $f3638e983b95d5b5$var$_mapExposures(secondaryExposures, exposureMapping));
};
module.exports._createLayerParameterExposure = $f3638e983b95d5b5$var$_createLayerParameterExposure;
const $f3638e983b95d5b5$var$_addEvaluationDetailsToMetadata = (details, metadata)=>{
    metadata['reason'] = details.reason;
    if (details.lcut) metadata['lcut'] = String(details.lcut);
    if (details.receivedAt) metadata['receivedAt'] = String(details.receivedAt);
    return metadata;
};

});

parcelRegister("bZVno", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoggingEnabledOption = module.exports.LogEventCompressionMode = void 0;
module.exports.LogEventCompressionMode = {
    /** Do not compress request bodies */ Disabled: 'd',
    /** Compress request bodies unless a network proxy is configured */ Enabled: 'e',
    /** Always compress request bodies, even when a proxy is configured */ Forced: 'f'
};
module.exports.LoggingEnabledOption = {
    disabled: 'disabled',
    browserOnly: 'browser-only',
    always: 'always'
};

});

parcelRegister("c6J8p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._setObjectInStorage = module.exports._getObjectFromStorage = module.exports.Storage = void 0;

var $734ad = parcelRequire("734ad");

var $3h5v5 = parcelRequire("3h5v5");
const $8d090e6357099cf7$var$inMemoryStore = {};
const $8d090e6357099cf7$var$_inMemoryProvider = {
    isReady: ()=>true,
    isReadyResolver: ()=>null,
    getProviderName: ()=>'InMemory',
    getItem: (key)=>$8d090e6357099cf7$var$inMemoryStore[key] ? $8d090e6357099cf7$var$inMemoryStore[key] : null,
    setItem: (key, value)=>{
        $8d090e6357099cf7$var$inMemoryStore[key] = value;
    },
    removeItem: (key)=>{
        delete $8d090e6357099cf7$var$inMemoryStore[key];
    },
    getAllKeys: ()=>Object.keys($8d090e6357099cf7$var$inMemoryStore)
};
let $8d090e6357099cf7$var$_localStorageProvider = null;
try {
    const win = (0, $3h5v5._getWindowSafe)();
    if (win && win.localStorage && typeof win.localStorage.getItem === 'function') $8d090e6357099cf7$var$_localStorageProvider = {
        isReady: ()=>true,
        isReadyResolver: ()=>null,
        getProviderName: ()=>'LocalStorage',
        getItem: (key)=>win.localStorage.getItem(key),
        setItem: (key, value)=>win.localStorage.setItem(key, value),
        removeItem: (key)=>win.localStorage.removeItem(key),
        getAllKeys: ()=>Object.keys(win.localStorage)
    };
} catch (error) {
    $734ad.Log.warn('Failed to setup localStorageProvider.');
}
let $8d090e6357099cf7$var$_main = $8d090e6357099cf7$var$_localStorageProvider !== null && $8d090e6357099cf7$var$_localStorageProvider !== void 0 ? $8d090e6357099cf7$var$_localStorageProvider : $8d090e6357099cf7$var$_inMemoryProvider;
let $8d090e6357099cf7$var$_current = $8d090e6357099cf7$var$_main;
function $8d090e6357099cf7$var$_inMemoryBreaker(action) {
    try {
        return action();
    } catch (error) {
        if (error instanceof Error && error.name === 'SecurityError') {
            module.exports.Storage._setProvider($8d090e6357099cf7$var$_inMemoryProvider);
            return null;
        }
        if (error instanceof Error && error.name === 'QuotaExceededError') {
            const allKeys = module.exports.Storage.getAllKeys();
            const statsigKeys = allKeys.filter((key)=>key.startsWith('statsig.'));
            error.message = `${error.message}. Statsig Keys: ${statsigKeys.length}`;
        }
        throw error;
    }
}
module.exports.Storage = {
    isReady: ()=>$8d090e6357099cf7$var$_current.isReady(),
    isReadyResolver: ()=>$8d090e6357099cf7$var$_current.isReadyResolver(),
    getProviderName: ()=>$8d090e6357099cf7$var$_current.getProviderName(),
    getItem: (key)=>$8d090e6357099cf7$var$_inMemoryBreaker(()=>$8d090e6357099cf7$var$_current.getItem(key)),
    setItem: (key, value)=>$8d090e6357099cf7$var$_inMemoryBreaker(()=>$8d090e6357099cf7$var$_current.setItem(key, value)),
    removeItem: (key)=>$8d090e6357099cf7$var$_current.removeItem(key),
    getAllKeys: ()=>$8d090e6357099cf7$var$_current.getAllKeys(),
    // StorageProviderManagment
    _setProvider: (newProvider)=>{
        $8d090e6357099cf7$var$_main = newProvider;
        $8d090e6357099cf7$var$_current = newProvider;
    },
    _setDisabled: (isDisabled)=>{
        if (isDisabled) $8d090e6357099cf7$var$_current = $8d090e6357099cf7$var$_inMemoryProvider;
        else $8d090e6357099cf7$var$_current = $8d090e6357099cf7$var$_main;
    }
};
function $8d090e6357099cf7$var$_getObjectFromStorage(key) {
    const value = module.exports.Storage.getItem(key);
    return JSON.parse(value !== null && value !== void 0 ? value : 'null');
}
module.exports._getObjectFromStorage = $8d090e6357099cf7$var$_getObjectFromStorage;
function $8d090e6357099cf7$var$_setObjectInStorage(key, obj) {
    module.exports.Storage.setItem(key, JSON.stringify(obj));
}
module.exports._setObjectInStorage = $8d090e6357099cf7$var$_setObjectInStorage;

});

parcelRegister("h42ib", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UrlConfiguration = void 0;

var $5xWeB = parcelRequire("5xWeB");

var $l3sJo = parcelRequire("l3sJo");
const $c6c4969aab166379$var$ENDPOINT_DNS_KEY_MAP = {
    [$l3sJo.Endpoint._initialize]: 'i',
    [$l3sJo.Endpoint._rgstr]: 'e',
    [$l3sJo.Endpoint._download_config_specs]: 'd'
};
class $c6c4969aab166379$var$UrlConfiguration {
    getUrl() {
        var _a;
        return (_a = this.customUrl) !== null && _a !== void 0 ? _a : this.defaultUrl;
    }
    getChecksum() {
        var _a;
        const fallbacks = ((_a = this.fallbackUrls) !== null && _a !== void 0 ? _a : []).sort().join(',');
        return (0, $5xWeB._DJB2)(this.customUrl + fallbacks);
    }
    constructor(endpoint, customUrl, customApi, fallbackUrls){
        this.customUrl = null;
        this.fallbackUrls = null;
        this.endpoint = endpoint;
        this.endpointDnsKey = $c6c4969aab166379$var$ENDPOINT_DNS_KEY_MAP[endpoint];
        if (customUrl) this.customUrl = customUrl;
        if (!customUrl && customApi) this.customUrl = customApi.endsWith('/') ? `${customApi}${endpoint}` : `${customApi}/${endpoint}`;
        if (fallbackUrls) this.fallbackUrls = fallbackUrls;
        const defaultApi = $l3sJo.NetworkDefault[endpoint];
        this.defaultUrl = `${defaultApi}/${endpoint}`;
    }
}
module.exports.UrlConfiguration = $c6c4969aab166379$var$UrlConfiguration;

});

parcelRegister("fOEO6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._notifyVisibilityChanged = module.exports._subscribeToVisiblityChanged = module.exports._isUnloading = module.exports._isCurrentlyVisible = void 0;

var $3h5v5 = parcelRequire("3h5v5");
const $b83b2df8f940d43a$var$FOREGROUND = 'foreground';
const $b83b2df8f940d43a$var$BACKGROUND = 'background';
const $b83b2df8f940d43a$var$LISTENERS = [];
let $b83b2df8f940d43a$var$current = $b83b2df8f940d43a$var$FOREGROUND;
let $b83b2df8f940d43a$var$isUnloading = false;
const $b83b2df8f940d43a$var$_isCurrentlyVisible = ()=>{
    return $b83b2df8f940d43a$var$current === $b83b2df8f940d43a$var$FOREGROUND;
};
module.exports._isCurrentlyVisible = $b83b2df8f940d43a$var$_isCurrentlyVisible;
const $b83b2df8f940d43a$var$_isUnloading = ()=>$b83b2df8f940d43a$var$isUnloading;
module.exports._isUnloading = $b83b2df8f940d43a$var$_isUnloading;
const $b83b2df8f940d43a$var$_subscribeToVisiblityChanged = (listener)=>{
    $b83b2df8f940d43a$var$LISTENERS.unshift(listener);
};
module.exports._subscribeToVisiblityChanged = $b83b2df8f940d43a$var$_subscribeToVisiblityChanged;
const $b83b2df8f940d43a$var$_notifyVisibilityChanged = (visibility)=>{
    if (visibility === $b83b2df8f940d43a$var$current) return;
    $b83b2df8f940d43a$var$current = visibility;
    $b83b2df8f940d43a$var$LISTENERS.forEach((l)=>l(visibility));
};
module.exports._notifyVisibilityChanged = $b83b2df8f940d43a$var$_notifyVisibilityChanged;
(0, $3h5v5._addWindowEventListenerSafe)('focus', ()=>{
    $b83b2df8f940d43a$var$isUnloading = false;
    (0, module.exports._notifyVisibilityChanged)($b83b2df8f940d43a$var$FOREGROUND);
});
(0, $3h5v5._addWindowEventListenerSafe)('blur', ()=>(0, module.exports._notifyVisibilityChanged)($b83b2df8f940d43a$var$BACKGROUND));
(0, $3h5v5._addDocumentEventListenerSafe)('visibilitychange', ()=>{
    (0, module.exports._notifyVisibilityChanged)(document.visibilityState === 'visible' ? $b83b2df8f940d43a$var$FOREGROUND : $b83b2df8f940d43a$var$BACKGROUND);
});
(0, $3h5v5._addWindowEventListenerSafe)((0, $3h5v5._getUnloadEvent)(), ()=>{
    $b83b2df8f940d43a$var$isUnloading = true;
    (0, module.exports._notifyVisibilityChanged)($b83b2df8f940d43a$var$BACKGROUND);
});

});

parcelRegister("jWxsz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigMetadataProvider = module.exports.SDK_VERSION = void 0;
module.exports.SDK_VERSION = '3.22.0';
let $e84d6384bc1ef379$var$metadata = {
    sdkVersion: module.exports.SDK_VERSION,
    sdkType: 'js-mono'
};
module.exports.StatsigMetadataProvider = {
    get: ()=>$e84d6384bc1ef379$var$metadata,
    add: (additions)=>{
        $e84d6384bc1ef379$var$metadata = Object.assign(Object.assign({}, $e84d6384bc1ef379$var$metadata), additions);
    }
};

});

parcelRegister("fQeQM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("8DGg2", function(module, exports) {
"use strict";
var $64a2bec27b291727$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeDataAdapterResult = module.exports.DataAdapterCore = void 0;

var $734ad = parcelRequire("734ad");

var $kZdmh = parcelRequire("kZdmh");

var $c0GK9 = parcelRequire("c0GK9");

var $c6J8p = parcelRequire("c6J8p");

var $c9krb = parcelRequire("c9krb");
const $64a2bec27b291727$var$CACHE_LIMIT = 10;
class $64a2bec27b291727$var$DataAdapterCore {
    attach(sdkKey, options, _network) {
        this._sdkKey = sdkKey;
        this._options = options;
    }
    getDataSync(user) {
        const normalized = user && (0, $c0GK9._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        const inMem = this._inMemoryCache.get(cacheKey, normalized);
        if (inMem && this._getIsCacheValueValid(inMem)) return inMem;
        const cache = this._loadFromCache(cacheKey);
        if (cache && this._getIsCacheValueValid(cache)) {
            this._inMemoryCache.add(cacheKey, cache);
            return this._inMemoryCache.get(cacheKey, normalized);
        }
        return null;
    }
    setData(data, user) {
        const normalized = user && (0, $c0GK9._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        this._inMemoryCache.add(cacheKey, $64a2bec27b291727$var$_makeDataAdapterResult('Bootstrap', data, null, normalized));
    }
    _getIsCacheValueValid(current) {
        return current.stableID == null || current.stableID === $kZdmh.StableID.get(this._getSdkKey());
    }
    _getDataAsyncImpl(current, user, options) {
        return $64a2bec27b291727$var$__awaiter(this, void 0, void 0, function*() {
            if (!$c6J8p.Storage.isReady()) yield $c6J8p.Storage.isReadyResolver();
            const cache = current !== null && current !== void 0 ? current : this.getDataSync(user);
            const ops = [
                this._fetchAndPrepFromNetwork(cache, user, options)
            ];
            if (options === null || options === void 0 ? void 0 : options.timeoutMs) ops.push(new Promise((r)=>setTimeout(r, options.timeoutMs)).then(()=>{
                $734ad.Log.debug('Fetching latest value timed out');
                return null;
            }));
            return yield Promise.race(ops);
        });
    }
    _prefetchDataImpl(user, options) {
        return $64a2bec27b291727$var$__awaiter(this, void 0, void 0, function*() {
            const normalized = user && (0, $c0GK9._normalizeUser)(user, this._options);
            const cacheKey = this._getCacheKey(normalized);
            const result = yield this._getDataAsyncImpl(null, normalized, options);
            if (result) this._inMemoryCache.add(cacheKey, Object.assign(Object.assign({}, result), {
                source: 'Prefetch'
            }));
        });
    }
    _fetchAndPrepFromNetwork(cachedResult, user, options) {
        return $64a2bec27b291727$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cachedData = (_a = cachedResult === null || cachedResult === void 0 ? void 0 : cachedResult.data) !== null && _a !== void 0 ? _a : null;
            const isCacheValidFor204 = cachedResult != null && this._isCachedResultValidFor204(cachedResult, user);
            const latest = yield this._fetchFromNetwork(cachedData, user, options, isCacheValidFor204);
            if (!latest) {
                $734ad.Log.debug('No response returned for latest value');
                return null;
            }
            const response = (0, $c9krb._typedJsonParse)(latest, 'has_updates', 'Response');
            const sdkKey = this._getSdkKey();
            const stableID = $kZdmh.StableID.get(sdkKey);
            let result = null;
            if ((response === null || response === void 0 ? void 0 : response.has_updates) === true) result = $64a2bec27b291727$var$_makeDataAdapterResult('Network', latest, stableID, user);
            else if (cachedData && (response === null || response === void 0 ? void 0 : response.has_updates) === false) result = $64a2bec27b291727$var$_makeDataAdapterResult('NetworkNotModified', cachedData, stableID, user);
            else return null;
            const cacheKey = this._getCacheKey(user);
            this._inMemoryCache.add(cacheKey, result);
            this._writeToCache(cacheKey, result);
            return result;
        });
    }
    _getSdkKey() {
        if (this._sdkKey != null) return this._sdkKey;
        $734ad.Log.error(`${this._adapterName} is not attached to a Client`);
        return '';
    }
    _loadFromCache(cacheKey) {
        var _a;
        const cache = (_a = $c6J8p.Storage.getItem) === null || _a === void 0 ? void 0 : _a.call($c6J8p.Storage, cacheKey);
        if (cache == null) return null;
        const result = (0, $c9krb._typedJsonParse)(cache, 'source', 'Cached Result');
        return result ? Object.assign(Object.assign({}, result), {
            source: 'Cache'
        }) : null;
    }
    _writeToCache(cacheKey, result) {
        $c6J8p.Storage.setItem(cacheKey, JSON.stringify(result));
        this._runLocalStorageCacheEviction(cacheKey);
    }
    _runLocalStorageCacheEviction(cacheKey) {
        var _a;
        const lastModifiedTimeMap = (_a = (0, $c6J8p._getObjectFromStorage)(this._lastModifiedStoreKey)) !== null && _a !== void 0 ? _a : {};
        lastModifiedTimeMap[cacheKey] = Date.now();
        const evictable = $64a2bec27b291727$var$_getEvictableKey(lastModifiedTimeMap, $64a2bec27b291727$var$CACHE_LIMIT);
        if (evictable) {
            delete lastModifiedTimeMap[evictable];
            $c6J8p.Storage.removeItem(evictable);
        }
        (0, $c6J8p._setObjectInStorage)(this._lastModifiedStoreKey, lastModifiedTimeMap);
    }
    constructor(_adapterName, _cacheSuffix){
        this._adapterName = _adapterName;
        this._cacheSuffix = _cacheSuffix;
        this._options = null;
        this._sdkKey = null;
        this._lastModifiedStoreKey = `statsig.last_modified_time.${_cacheSuffix}`;
        this._inMemoryCache = new $64a2bec27b291727$var$InMemoryCache();
    }
}
module.exports.DataAdapterCore = $64a2bec27b291727$var$DataAdapterCore;
function $64a2bec27b291727$var$_makeDataAdapterResult(source, data, stableID, user) {
    return {
        source: source,
        data: data,
        receivedAt: Date.now(),
        stableID: stableID,
        fullUserHash: (0, $c0GK9._getFullUserHash)(user)
    };
}
module.exports._makeDataAdapterResult = $64a2bec27b291727$var$_makeDataAdapterResult;
class $64a2bec27b291727$var$InMemoryCache {
    get(cacheKey, user) {
        var _a;
        const result = this._data[cacheKey];
        const cached = result === null || result === void 0 ? void 0 : result.stableID;
        const provided = (_a = user === null || user === void 0 ? void 0 : user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (provided && cached && provided !== cached) {
            $734ad.Log.warn("'StatsigUser.customIDs.stableID' mismatch");
            return null;
        }
        return result;
    }
    add(cacheKey, value) {
        const oldest = $64a2bec27b291727$var$_getEvictableKey(this._data, $64a2bec27b291727$var$CACHE_LIMIT - 1);
        if (oldest) delete this._data[oldest];
        this._data[cacheKey] = value;
    }
    merge(values) {
        this._data = Object.assign(Object.assign({}, this._data), values);
    }
    constructor(){
        this._data = {};
    }
}
function $64a2bec27b291727$var$_getEvictableKey(data, limit) {
    const keys = Object.keys(data);
    if (keys.length <= limit) return null;
    return keys.reduce((prevKey, currKey)=>{
        const prev = data[prevKey];
        const current = data[currKey];
        if (typeof prev === 'object' && typeof current === 'object') return current.receivedAt < prev.receivedAt ? currKey : prevKey;
        return current < prev ? currKey : prevKey;
    });
}

});
parcelRegister("kZdmh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StableID = void 0;

var $7dAGN = parcelRequire("7dAGN");

var $734ad = parcelRequire("734ad");

var $3h5v5 = parcelRequire("3h5v5");

var $c6J8p = parcelRequire("c6J8p");

var $2I8e3 = parcelRequire("2I8e3");
const $f473ddd200f8baea$var$PROMISE_MAP = {};
const $f473ddd200f8baea$var$COOKIE_ENABLED_MAP = {};
const $f473ddd200f8baea$var$DISABLED_MAP = {};
module.exports.StableID = {
    cookiesEnabled: false,
    randomID: Math.random().toString(36),
    get: (sdkKey)=>{
        if ($f473ddd200f8baea$var$DISABLED_MAP[sdkKey]) return null;
        if ($f473ddd200f8baea$var$PROMISE_MAP[sdkKey] != null) return $f473ddd200f8baea$var$PROMISE_MAP[sdkKey];
        let stableID = null;
        stableID = $f473ddd200f8baea$var$_loadFromCookie(sdkKey);
        if (stableID != null) {
            $f473ddd200f8baea$var$PROMISE_MAP[sdkKey] = stableID;
            $f473ddd200f8baea$var$_persistToStorage(stableID, sdkKey);
            return stableID;
        }
        stableID = $f473ddd200f8baea$var$_loadFromStorage(sdkKey);
        if (stableID == null) stableID = (0, $2I8e3.getUUID)();
        $f473ddd200f8baea$var$_persistToStorage(stableID, sdkKey);
        $f473ddd200f8baea$var$_persistToCookie(stableID, sdkKey);
        $f473ddd200f8baea$var$PROMISE_MAP[sdkKey] = stableID;
        return stableID;
    },
    setOverride: (override, sdkKey)=>{
        $f473ddd200f8baea$var$PROMISE_MAP[sdkKey] = override;
        $f473ddd200f8baea$var$_persistToStorage(override, sdkKey);
        $f473ddd200f8baea$var$_persistToCookie(override, sdkKey);
    },
    _setCookiesEnabled: (sdkKey, cookiesEnabled)=>{
        $f473ddd200f8baea$var$COOKIE_ENABLED_MAP[sdkKey] = cookiesEnabled;
    },
    _setDisabled: (sdkKey, disabled)=>{
        $f473ddd200f8baea$var$DISABLED_MAP[sdkKey] = disabled;
    }
};
function $f473ddd200f8baea$var$_getStableIDStorageKey(sdkKey) {
    return `statsig.stable_id.${(0, $7dAGN._getStorageKey)(sdkKey)}`;
}
function $f473ddd200f8baea$var$_persistToStorage(stableID, sdkKey) {
    const storageKey = $f473ddd200f8baea$var$_getStableIDStorageKey(sdkKey);
    try {
        (0, $c6J8p._setObjectInStorage)(storageKey, stableID);
    } catch (e) {
        $734ad.Log.warn('Failed to save StableID to storage');
    }
}
function $f473ddd200f8baea$var$_loadFromStorage(sdkKey) {
    const storageKey = $f473ddd200f8baea$var$_getStableIDStorageKey(sdkKey);
    return (0, $c6J8p._getObjectFromStorage)(storageKey);
}
function $f473ddd200f8baea$var$_loadFromCookie(sdkKey) {
    if (!$f473ddd200f8baea$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $3h5v5._getDocumentSafe)() == null) return null;
    const cookies = document.cookie.split(';');
    for (const cookie of cookies){
        const [key, value] = cookie.trim().split('=');
        if (key === $f473ddd200f8baea$var$_getCookieName(sdkKey)) return decodeURIComponent(value);
    }
    return null;
}
function $f473ddd200f8baea$var$_persistToCookie(stableID, sdkKey) {
    if (!$f473ddd200f8baea$var$COOKIE_ENABLED_MAP[sdkKey] || !document) return;
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    document.cookie = `${$f473ddd200f8baea$var$_getCookieName(sdkKey)}=${encodeURIComponent(stableID)}; expires=${expiryDate.toUTCString()}; path=/`;
}
function $f473ddd200f8baea$var$_getCookieName(sdkKey) {
    return `statsig.stable_id.${(0, $7dAGN._getStorageKey)(sdkKey)}`;
}

});
parcelRegister("2I8e3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUUID = void 0;
function $1f9612477f04a331$var$getUUID() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    let d = new Date().getTime();
    let d2 = typeof performance !== 'undefined' && performance.now && performance.now() * 1000 || 0;
    const y = '89ab'[Math.floor(Math.random() * 4)];
    return `xxxxxxxx-xxxx-4xxx-${y}xxx-xxxxxxxxxxxx`.replace(/[xy]/g, (c)=>{
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
    });
}
module.exports.getUUID = $1f9612477f04a331$var$getUUID;

});


parcelRegister("c0GK9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getFullUserHash = module.exports._normalizeUser = void 0;

var $5xWeB = parcelRequire("5xWeB");

var $734ad = parcelRequire("734ad");
function $8be6a40da797dce5$var$_normalizeUser(original, options, fallbackEnvironment) {
    try {
        const copy = JSON.parse(JSON.stringify(original));
        if (options != null && options.environment != null) copy.statsigEnvironment = options.environment;
        else if (fallbackEnvironment != null) copy.statsigEnvironment = {
            tier: fallbackEnvironment
        };
        return copy;
    } catch (error) {
        $734ad.Log.error('Failed to JSON.stringify user');
        return {
            statsigEnvironment: undefined
        };
    }
}
module.exports._normalizeUser = $8be6a40da797dce5$var$_normalizeUser;
function $8be6a40da797dce5$var$_getFullUserHash(user) {
    return user ? (0, $5xWeB._DJB2Object)(user) : null;
}
module.exports._getFullUserHash = $8be6a40da797dce5$var$_getFullUserHash;

});

parcelRegister("c9krb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._typedJsonParse = void 0;

var $734ad = parcelRequire("734ad");
/**
 *
 * @param {string} data The values to parse into T
 * @param {string} guard A field that must exists on the parsed object for the parse to be valid
 * @param {string} error An error to print via Log.error() when parsing fails
 * @returns {T | null} The parse object T or null if it failed
 */ function $8d862dba059cc1c7$var$_typedJsonParse(data, guard, typeName) {
    try {
        const result = JSON.parse(data);
        if (result && typeof result === 'object' && guard in result) return result;
    } catch (_a) {
    // noop
    }
    $734ad.Log.error(`Failed to parse ${typeName}`);
    return null;
}
module.exports._typedJsonParse = $8d862dba059cc1c7$var$_typedJsonParse;

});


parcelRegister("6ZBfS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("hLWFM", function(module, exports) {
"use strict";
var $cf0456acd7d975e7$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorBoundary = module.exports.EXCEPTION_ENDPOINT = void 0;

var $734ad = parcelRequire("734ad");

var $561nR = parcelRequire("561nR");

var $jWxsz = parcelRequire("jWxsz");
module.exports.EXCEPTION_ENDPOINT = 'https://statsigapi.net/v1/sdk_exception';
const $cf0456acd7d975e7$var$UNKNOWN_ERROR = '[Statsig] UnknownError';
class $cf0456acd7d975e7$var$ErrorBoundary {
    wrap(instance) {
        try {
            const obj = instance;
            $cf0456acd7d975e7$var$_getAllInstanceMethodNames(obj).forEach((name)=>{
                const original = obj[name];
                if ('$EB' in original) return;
                obj[name] = (...args)=>{
                    return this._capture(name, ()=>original.apply(instance, args));
                };
                obj[name].$EB = true;
            });
        } catch (err) {
            this._onError('eb:wrap', err);
        }
    }
    logError(tag, error) {
        this._onError(tag, error);
    }
    getLastSeenErrorAndReset() {
        const tempError = this._lastSeenError;
        this._lastSeenError = undefined;
        return tempError !== null && tempError !== void 0 ? tempError : null;
    }
    attachErrorIfNoneExists(error) {
        if (this._lastSeenError) return;
        this._lastSeenError = $cf0456acd7d975e7$var$_resolveError(error);
    }
    _capture(tag, task) {
        try {
            const res = task();
            if (res && res instanceof Promise) return res.catch((err)=>this._onError(tag, err));
            return res;
        } catch (error) {
            this._onError(tag, error);
            return null;
        }
    }
    _onError(tag, error) {
        try {
            $734ad.Log.warn(`Caught error in ${tag}`, {
                error: error
            });
            const impl = ()=>$cf0456acd7d975e7$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b, _c, _d, _e, _f, _g;
                    const unwrapped = error ? error : Error($cf0456acd7d975e7$var$UNKNOWN_ERROR);
                    const isError = unwrapped instanceof Error;
                    const name = isError ? unwrapped.name : 'No Name';
                    const resolvedError = $cf0456acd7d975e7$var$_resolveError(unwrapped);
                    this._lastSeenError = resolvedError;
                    if (this._seen.has(name)) return;
                    this._seen.add(name);
                    if ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.preventAllNetworkTraffic) {
                        (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                            name: 'error',
                            error: error,
                            tag: tag
                        });
                        return;
                    }
                    const sdkType = $561nR.SDKType._get(this._sdkKey);
                    const statsigMetadata = $jWxsz.StatsigMetadataProvider.get();
                    const info = isError ? unwrapped.stack : $cf0456acd7d975e7$var$_getDescription(unwrapped);
                    const body = Object.assign({
                        tag: tag,
                        exception: name,
                        info: info,
                        statsigOptions: $cf0456acd7d975e7$var$_getStatsigOptionLoggingCopy(this._options)
                    }, Object.assign(Object.assign({}, statsigMetadata), {
                        sdkType: sdkType
                    }));
                    const func = (_f = (_e = (_d = this._options) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.networkOverrideFunc) !== null && _f !== void 0 ? _f : fetch;
                    yield func(module.exports.EXCEPTION_ENDPOINT, {
                        method: 'POST',
                        headers: {
                            'STATSIG-API-KEY': this._sdkKey,
                            'STATSIG-SDK-TYPE': String(sdkType),
                            'STATSIG-SDK-VERSION': String(statsigMetadata.sdkVersion),
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(body)
                    });
                    (_g = this._emitter) === null || _g === void 0 || _g.call(this, {
                        name: 'error',
                        error: error,
                        tag: tag
                    });
                });
            impl().then(()=>{
            /* noop */ }).catch(()=>{
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    }
    constructor(_sdkKey, _options, _emitter, _lastSeenError){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._emitter = _emitter;
        this._lastSeenError = _lastSeenError;
        this._seen = new Set();
    }
}
module.exports.ErrorBoundary = $cf0456acd7d975e7$var$ErrorBoundary;
function $cf0456acd7d975e7$var$_resolveError(error) {
    if (error instanceof Error) return error;
    else if (typeof error === 'string') return new Error(error);
    else return new Error('An unknown error occurred.');
}
function $cf0456acd7d975e7$var$_getDescription(obj) {
    try {
        return JSON.stringify(obj);
    } catch (_a) {
        return $cf0456acd7d975e7$var$UNKNOWN_ERROR;
    }
}
function $cf0456acd7d975e7$var$_getAllInstanceMethodNames(instance) {
    const names = new Set();
    let proto = Object.getPrototypeOf(instance);
    while(proto && proto !== Object.prototype){
        Object.getOwnPropertyNames(proto).filter((prop)=>typeof (proto === null || proto === void 0 ? void 0 : proto[prop]) === 'function').forEach((name)=>names.add(name));
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(names);
}
function $cf0456acd7d975e7$var$_getStatsigOptionLoggingCopy(options) {
    if (!options) return {};
    const loggingCopy = {};
    Object.entries(options).forEach(([option, value])=>{
        const valueType = typeof value;
        switch(valueType){
            case 'number':
            case 'bigint':
            case 'boolean':
                loggingCopy[String(option)] = value;
                break;
            case 'string':
                if (value.length < 50) loggingCopy[String(option)] = value;
                else loggingCopy[String(option)] = 'set';
                break;
            case 'object':
                if (option === 'environment') loggingCopy['environment'] = value;
                else if (option === 'networkConfig') loggingCopy['networkConfig'] = value;
                else loggingCopy[String(option)] = value != null ? 'set' : 'unset';
                break;
            default:
        }
    });
    return loggingCopy;
}

});
parcelRegister("561nR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKType = void 0;
const $3b5e961701cd3f20$var$SDK_CLIENT = {};
let $3b5e961701cd3f20$var$suffix;
module.exports.SDKType = {
    _get: (sdkKey)=>{
        var _a;
        return ((_a = $3b5e961701cd3f20$var$SDK_CLIENT[sdkKey]) !== null && _a !== void 0 ? _a : 'js-mono') + ($3b5e961701cd3f20$var$suffix !== null && $3b5e961701cd3f20$var$suffix !== void 0 ? $3b5e961701cd3f20$var$suffix : '');
    },
    _setClientType (sdkKey, client) {
        $3b5e961701cd3f20$var$SDK_CLIENT[sdkKey] = client;
    },
    _setBindingType (binding) {
        if (!$3b5e961701cd3f20$var$suffix || $3b5e961701cd3f20$var$suffix === '-react') $3b5e961701cd3f20$var$suffix = '-' + binding;
    }
};

});


parcelRegister("ydZTp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("dNYVh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("cqbQs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("1i5Ye", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMemoKey = module.exports.MemoPrefix = void 0;
module.exports.MemoPrefix = {
    _gate: 'g',
    _dynamicConfig: 'c',
    _experiment: 'e',
    _configList: 'cl',
    _layer: 'l',
    _paramStore: 'p'
};
const $0f0c1a7ef2085de2$var$EXIST_KEYS = new Set([]);
const $0f0c1a7ef2085de2$var$DO_NOT_MEMO_KEYS = new Set([
    // Add keys that if exist, should not be memoized
    'userPersistedValues'
]);
function $0f0c1a7ef2085de2$var$createMemoKey(prefix, name, options) {
    let cacheKey = `${prefix}|${name}`;
    if (!options) return cacheKey;
    for (const key of Object.keys(options)){
        if ($0f0c1a7ef2085de2$var$DO_NOT_MEMO_KEYS.has(key)) return undefined;
        if ($0f0c1a7ef2085de2$var$EXIST_KEYS.has(key)) cacheKey += `|${key}=true`;
        else cacheKey += `|${key}=${options[key]}`;
    }
    return cacheKey;
}
module.exports.createMemoKey = $0f0c1a7ef2085de2$var$createMemoKey;

});

parcelRegister("7g9eY", function(module, exports) {
"use strict";
var $54913203e62b8f2e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkCore = void 0;

var $g2TNZ = parcelRequire("g2TNZ");

var $g2TNZ = parcelRequire("g2TNZ");

var $4k5J2 = parcelRequire("4k5J2");

var $734ad = parcelRequire("734ad");

var $l3sJo = parcelRequire("l3sJo");

var $3WlY5 = parcelRequire("3WlY5");

var $gVlw5 = parcelRequire("gVlw5");

var $561nR = parcelRequire("561nR");

var $3h5v5 = parcelRequire("3h5v5");

var $cSz3w = parcelRequire("cSz3w");

var $kZdmh = parcelRequire("kZdmh");

var $70Ond = parcelRequire("70Ond");

var $jWxsz = parcelRequire("jWxsz");

var $bZVno = parcelRequire("bZVno");

var $fOEO6 = parcelRequire("fOEO6");
const $54913203e62b8f2e$var$DEFAULT_TIMEOUT_MS = 10000;
const $54913203e62b8f2e$var$BACKOFF_BASE_MS = 500;
const $54913203e62b8f2e$var$BACKOFF_MAX_MS = 30000;
const $54913203e62b8f2e$var$RATE_LIMIT_WINDOW_MS = 1000;
const $54913203e62b8f2e$var$RATE_LIMIT_MAX_REQ_COUNT = 50;
const $54913203e62b8f2e$var$LEAK_RATE = $54913203e62b8f2e$var$RATE_LIMIT_MAX_REQ_COUNT / $54913203e62b8f2e$var$RATE_LIMIT_WINDOW_MS;
const $54913203e62b8f2e$var$RETRYABLE_CODES = new Set([
    408,
    500,
    502,
    503,
    504,
    522,
    524,
    599
]);
class $54913203e62b8f2e$var$NetworkCore {
    setLogEventCompressionMode(mode) {
        this._options.logEventCompressionMode = mode;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(this._fallbackResolver);
        this._fallbackResolver.setErrorBoundary(errorBoundary);
    }
    isBeaconSupported() {
        return typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function';
    }
    getLastUsedInitUrlAndReset() {
        const tempUrl = this._lastUsedInitUrl;
        this._lastUsedInitUrl = null;
        return tempUrl;
    }
    beacon(args) {
        if (!$54913203e62b8f2e$var$_ensureValidSdkKey(args)) return false;
        const argsInternal = this._getInternalRequestArgs('POST', args);
        const url = this._getPopulatedURL(argsInternal);
        const nav = navigator;
        return nav.sendBeacon.bind(nav)(url, argsInternal.body);
    }
    post(args) {
        return $54913203e62b8f2e$var$__awaiter(this, void 0, void 0, function*() {
            const argsInternal = this._getInternalRequestArgs('POST', args);
            this._tryEncodeBody(argsInternal);
            yield this._tryToCompressBody(argsInternal);
            return this._sendRequest(argsInternal);
        });
    }
    get(args) {
        const argsInternal = this._getInternalRequestArgs('GET', args);
        return this._sendRequest(argsInternal);
    }
    _sendRequest(args) {
        return $54913203e62b8f2e$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d;
            if (!$54913203e62b8f2e$var$_ensureValidSdkKey(args)) return null;
            if (this._netConfig.preventAllNetworkTraffic) return null;
            const { method: method, body: body, retries: retries, attempt: attempt } = args;
            const endpoint = args.urlConfig.endpoint;
            if (this._isRateLimited(endpoint)) {
                $734ad.Log.warn(`Request to ${endpoint} was blocked because you are making requests too frequently.`);
                return null;
            }
            const currentAttempt = attempt !== null && attempt !== void 0 ? attempt : 1;
            const abortController = typeof AbortController !== 'undefined' ? new AbortController() : null;
            const timeoutHandle = setTimeout(()=>{
                abortController === null || abortController === void 0 || abortController.abort(`Timeout of ${this._timeout}ms expired.`);
            }, this._timeout);
            const populatedUrl = this._getPopulatedURL(args);
            let response = null;
            const keepalive = (0, $fOEO6._isUnloading)();
            try {
                const config = {
                    method: method,
                    body: body,
                    headers: Object.assign({}, args.headers),
                    signal: abortController === null || abortController === void 0 ? void 0 : abortController.signal,
                    priority: args.priority,
                    keepalive: keepalive
                };
                $54913203e62b8f2e$var$_tryMarkInitStart(args, currentAttempt);
                const bucket = this._leakyBucket[endpoint];
                if (bucket) {
                    bucket.lastRequestTime = Date.now();
                    this._leakyBucket[endpoint] = bucket;
                }
                const func = (_a = this._netConfig.networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch;
                response = yield func(populatedUrl, config);
                clearTimeout(timeoutHandle);
                if (!response.ok) {
                    const text = yield response.text().catch(()=>'No Text');
                    const err = new Error(`NetworkError: ${populatedUrl} ${text}`);
                    err.name = 'NetworkError';
                    throw err;
                }
                const text = yield response.text();
                $54913203e62b8f2e$var$_tryMarkInitEnd(args, response, currentAttempt, text);
                this._fallbackResolver.tryBumpExpiryTime(args.sdkKey, args.urlConfig);
                return {
                    body: text,
                    code: response.status
                };
            } catch (error) {
                const errorMessage = $54913203e62b8f2e$var$_getErrorMessage(abortController, error);
                const timedOut = $54913203e62b8f2e$var$_didTimeout(abortController);
                $54913203e62b8f2e$var$_tryMarkInitEnd(args, response, currentAttempt, '', error);
                const fallbackUpdated = yield this._fallbackResolver.tryFetchUpdatedFallbackInfo(args.sdkKey, args.urlConfig, errorMessage, timedOut);
                if (fallbackUpdated) args.fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
                if (!retries || currentAttempt > retries || !$54913203e62b8f2e$var$RETRYABLE_CODES.has((_b = response === null || response === void 0 ? void 0 : response.status) !== null && _b !== void 0 ? _b : 500)) {
                    (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                        name: 'error',
                        error: error,
                        tag: $70Ond.ErrorTag.NetworkError,
                        requestArgs: args
                    });
                    const formattedErrorMsg = `A networking error occurred during ${method} request to ${populatedUrl}.`;
                    $734ad.Log.error(formattedErrorMsg, errorMessage, error);
                    (_d = this._errorBoundary) === null || _d === void 0 || _d.attachErrorIfNoneExists(formattedErrorMsg);
                    return null;
                }
                yield $54913203e62b8f2e$var$_exponentialBackoff(currentAttempt);
                return this._sendRequest(Object.assign(Object.assign({}, args), {
                    retries: retries,
                    attempt: currentAttempt + 1
                }));
            }
        });
    }
    _getLogEventCompressionMode(options) {
        // Handle backward compatibility for deprecated disableCompression flag
        let compressionMode = options === null || options === void 0 ? void 0 : options.logEventCompressionMode;
        if (!compressionMode && (options === null || options === void 0 ? void 0 : options.disableCompression) === true) compressionMode = $bZVno.LogEventCompressionMode.Disabled;
        // Default to enabled if unset
        if (!compressionMode) compressionMode = $bZVno.LogEventCompressionMode.Enabled;
        return compressionMode;
    }
    _isRateLimited(endpoint) {
        var _a;
        const now = Date.now();
        const bucket = (_a = this._leakyBucket[endpoint]) !== null && _a !== void 0 ? _a : {
            count: 0,
            lastRequestTime: now
        };
        const elapsed = now - bucket.lastRequestTime;
        const leakedRequests = Math.floor(elapsed * $54913203e62b8f2e$var$LEAK_RATE);
        bucket.count = Math.max(0, bucket.count - leakedRequests);
        if (bucket.count >= $54913203e62b8f2e$var$RATE_LIMIT_MAX_REQ_COUNT) return true;
        bucket.count += 1;
        bucket.lastRequestTime = now;
        this._leakyBucket[endpoint] = bucket;
        return false;
    }
    _getPopulatedURL(args) {
        var _a;
        const url = (_a = args.fallbackUrl) !== null && _a !== void 0 ? _a : args.urlConfig.getUrl();
        if (args.urlConfig.endpoint === $l3sJo.Endpoint._initialize || args.urlConfig.endpoint === $l3sJo.Endpoint._download_config_specs) this._lastUsedInitUrl = url;
        const params = Object.assign({
            [$l3sJo.NetworkParam.SdkKey]: args.sdkKey,
            [$l3sJo.NetworkParam.SdkType]: $561nR.SDKType._get(args.sdkKey),
            [$l3sJo.NetworkParam.SdkVersion]: $jWxsz.SDK_VERSION,
            [$l3sJo.NetworkParam.Time]: String(Date.now()),
            [$l3sJo.NetworkParam.SessionID]: $cSz3w.SessionID.get(args.sdkKey)
        }, args.params);
        const query = Object.keys(params).map((key)=>{
            return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
        }).join('&');
        return `${url}${query ? `?${query}` : ''}`;
    }
    _tryEncodeBody(args) {
        var _a;
        const win = (0, $3h5v5._getWindowSafe)();
        const body = args.body;
        if (!args.isStatsigEncodable || this._options.disableStatsigEncoding || typeof body !== 'string' || (0, $g2TNZ._getStatsigGlobalFlag)('no-encode') != null || !(win === null || win === void 0 ? void 0 : win.btoa)) return;
        try {
            args.body = win.btoa(body).split('').reverse().join('');
            args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                [$l3sJo.NetworkParam.StatsigEncoded]: '1'
            });
        } catch (e) {
            $734ad.Log.warn(`Request encoding failed for ${args.urlConfig.getUrl()}`, e);
        }
    }
    _tryToCompressBody(args) {
        return $54913203e62b8f2e$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const body = args.body;
            if (typeof body !== 'string' || !$54913203e62b8f2e$var$_allowCompression(args, this._options)) return;
            try {
                const bytes = new TextEncoder().encode(body);
                const stream = new CompressionStream('gzip');
                const writer = stream.writable.getWriter();
                writer.write(bytes).catch($734ad.Log.error);
                writer.close().catch($734ad.Log.error);
                const reader = stream.readable.getReader();
                const chunks = [];
                let result;
                // eslint-disable-next-line no-await-in-loop
                while(!(result = yield reader.read()).done)chunks.push(result.value);
                const totalLength = chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
                const combined = new Uint8Array(totalLength);
                let offset = 0;
                for (const chunk of chunks){
                    combined.set(chunk, offset);
                    offset += chunk.length;
                }
                args.body = combined;
                args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                    [$l3sJo.NetworkParam.IsGzipped]: '1'
                });
            } catch (e) {
                $734ad.Log.warn(`Request compression failed for ${args.urlConfig.getUrl()}`, e);
            }
        });
    }
    _getInternalRequestArgs(method, args) {
        const fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
        const result = Object.assign(Object.assign({}, args), {
            method: method,
            fallbackUrl: fallbackUrl
        });
        if ('data' in args) $54913203e62b8f2e$var$_populateRequestBody(result, args.data);
        return result;
    }
    constructor(options, _emitter){
        this._emitter = _emitter;
        this._errorBoundary = null;
        this._timeout = $54913203e62b8f2e$var$DEFAULT_TIMEOUT_MS;
        this._netConfig = {};
        this._options = {};
        this._leakyBucket = {};
        this._lastUsedInitUrl = null;
        if (options) this._options = options;
        if (this._options.networkConfig) this._netConfig = this._options.networkConfig;
        if (this._netConfig.networkTimeoutMs) this._timeout = this._netConfig.networkTimeoutMs;
        this._fallbackResolver = new $3WlY5.NetworkFallbackResolver(this._options);
        this.setLogEventCompressionMode(this._getLogEventCompressionMode(options));
    }
}
module.exports.NetworkCore = $54913203e62b8f2e$var$NetworkCore;
const $54913203e62b8f2e$var$_ensureValidSdkKey = (args)=>{
    if (!args.sdkKey) {
        $734ad.Log.warn('Unable to make request without an SDK key');
        return false;
    }
    return true;
};
const $54913203e62b8f2e$var$_populateRequestBody = (args, data)=>{
    const { sdkKey: sdkKey, fallbackUrl: fallbackUrl } = args;
    const stableID = $kZdmh.StableID.get(sdkKey);
    const sessionID = $cSz3w.SessionID.get(sdkKey);
    const sdkType = $561nR.SDKType._get(sdkKey);
    args.body = JSON.stringify(Object.assign(Object.assign({}, data), {
        statsigMetadata: Object.assign(Object.assign({}, $jWxsz.StatsigMetadataProvider.get()), {
            stableID: stableID,
            sessionID: sessionID,
            sdkType: sdkType,
            fallbackUrl: fallbackUrl
        })
    }));
};
function $54913203e62b8f2e$var$_allowCompression(args, options) {
    if (!args.isCompressable) return false;
    // Never compress if 'no-compress' is set globally or required APIs are unavailable
    if ((0, $g2TNZ._getStatsigGlobalFlag)('no-compress') != null || typeof CompressionStream === 'undefined' || typeof TextEncoder === 'undefined') return false;
    const isProxy = args.urlConfig.customUrl != null || args.urlConfig.fallbackUrls != null;
    const flagEnabled = $gVlw5.SDKFlags.get(args.sdkKey, 'enable_log_event_compression') === true;
    switch(options.logEventCompressionMode){
        case $bZVno.LogEventCompressionMode.Disabled:
            return false;
        case $bZVno.LogEventCompressionMode.Enabled:
            // Only compress through proxy if flag is explicitly on
            if (isProxy && !flagEnabled) return false;
            return true;
        case $bZVno.LogEventCompressionMode.Forced:
            return true;
        default:
            return false;
    }
}
function $54913203e62b8f2e$var$_getErrorMessage(controller, error) {
    if ((controller === null || controller === void 0 ? void 0 : controller.signal.aborted) && typeof controller.signal.reason === 'string') return controller.signal.reason;
    if (typeof error === 'string') return error;
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    return 'Unknown Error';
}
function $54913203e62b8f2e$var$_didTimeout(controller) {
    const timeout = (controller === null || controller === void 0 ? void 0 : controller.signal.aborted) && typeof controller.signal.reason === 'string' && controller.signal.reason.includes('Timeout');
    return timeout || false;
}
function $54913203e62b8f2e$var$_tryMarkInitStart(args, attempt) {
    if (args.urlConfig.endpoint !== $l3sJo.Endpoint._initialize) return;
    $4k5J2.Diagnostics._markInitNetworkReqStart(args.sdkKey, {
        attempt: attempt
    });
}
function $54913203e62b8f2e$var$_tryMarkInitEnd(args, response, attempt, body, err) {
    if (args.urlConfig.endpoint !== $l3sJo.Endpoint._initialize) return;
    $4k5J2.Diagnostics._markInitNetworkReqEnd(args.sdkKey, $4k5J2.Diagnostics._getDiagnosticsData(response, attempt, body, err));
}
function $54913203e62b8f2e$var$_exponentialBackoff(attempt) {
    return $54913203e62b8f2e$var$__awaiter(this, void 0, void 0, function*() {
        // 1*1*1000 1s
        // 2*2*1000 4s
        // 3*3*1000 9s
        // 4*4*1000 16s
        // 5*5*1000 25s
        yield new Promise((r)=>setTimeout(r, Math.min($54913203e62b8f2e$var$BACKOFF_BASE_MS * (attempt * attempt), $54913203e62b8f2e$var$BACKOFF_MAX_MS)));
    });
}

});
parcelRegister("3WlY5", function(module, exports) {
"use strict";
var $2de7d44435f834ae$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isDomainFailure = module.exports.NetworkFallbackResolver = void 0;

var $21K3T = parcelRequire("21K3T");

var $5xWeB = parcelRequire("5xWeB");

var $734ad = parcelRequire("734ad");

var $c6J8p = parcelRequire("c6J8p");
const $2de7d44435f834ae$var$DEFAULT_TTL_MS = 604800000; // 7 days
const $2de7d44435f834ae$var$COOLDOWN_TIME_MS = 14400000; // 4 hours
class $2de7d44435f834ae$var$NetworkFallbackResolver {
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
    }
    tryBumpExpiryTime(sdkKey, urlConfig) {
        var _a;
        const info = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint];
        if (!info) return;
        info.expiryTime = Date.now() + $2de7d44435f834ae$var$DEFAULT_TTL_MS;
        $2de7d44435f834ae$var$_tryWriteFallbackInfoToCache(sdkKey, Object.assign(Object.assign({}, this._fallbackInfo), {
            [urlConfig.endpoint]: info
        }));
    }
    getActiveFallbackUrl(sdkKey, urlConfig) {
        var _a, _b;
        if (urlConfig.customUrl != null && urlConfig.fallbackUrls != null) return null;
        let info = this._fallbackInfo;
        if (info == null) {
            info = (_a = $2de7d44435f834ae$var$_readFallbackInfoFromCache(sdkKey)) !== null && _a !== void 0 ? _a : {};
            this._fallbackInfo = info;
        }
        const entry = info[urlConfig.endpoint];
        if (!entry || Date.now() > ((_b = entry.expiryTime) !== null && _b !== void 0 ? _b : 0) || urlConfig.getChecksum() !== entry.urlConfigChecksum) {
            delete info[urlConfig.endpoint];
            this._fallbackInfo = info;
            $2de7d44435f834ae$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
            return null;
        }
        if (entry.url) return entry.url;
        return null;
    }
    tryFetchUpdatedFallbackInfo(sdkKey, urlConfig, errorMessage, timedOut) {
        return $2de7d44435f834ae$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            try {
                if (!$2de7d44435f834ae$var$_isDomainFailure(errorMessage, timedOut)) return false;
                const canUseNetworkFallbacks = urlConfig.customUrl == null && urlConfig.fallbackUrls == null;
                const urls = canUseNetworkFallbacks ? yield this._tryFetchFallbackUrlsFromNetwork(urlConfig) : urlConfig.fallbackUrls;
                const newUrl = this._pickNewFallbackUrl((_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint], urls);
                if (!newUrl) return false;
                this._updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl);
                return true;
            } catch (error) {
                (_b = this._errorBoundary) === null || _b === void 0 || _b.logError('tryFetchUpdatedFallbackInfo', error);
                return false;
            }
        });
    }
    _updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl) {
        var _a, _b, _c;
        const newFallbackInfo = {
            urlConfigChecksum: urlConfig.getChecksum(),
            url: newUrl,
            expiryTime: Date.now() + $2de7d44435f834ae$var$DEFAULT_TTL_MS,
            previous: []
        };
        const endpoint = urlConfig.endpoint;
        const previousInfo = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[endpoint];
        if (previousInfo) newFallbackInfo.previous.push(...previousInfo.previous);
        if (newFallbackInfo.previous.length > 10) newFallbackInfo.previous = [];
        const previousUrl = (_c = (_b = this._fallbackInfo) === null || _b === void 0 ? void 0 : _b[endpoint]) === null || _c === void 0 ? void 0 : _c.url;
        if (previousUrl != null) newFallbackInfo.previous.push(previousUrl);
        this._fallbackInfo = Object.assign(Object.assign({}, this._fallbackInfo), {
            [endpoint]: newFallbackInfo
        });
        $2de7d44435f834ae$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
    }
    _tryFetchFallbackUrlsFromNetwork(urlConfig) {
        return $2de7d44435f834ae$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cooldown = this._dnsQueryCooldowns[urlConfig.endpoint];
            if (cooldown && Date.now() < cooldown) return null;
            this._dnsQueryCooldowns[urlConfig.endpoint] = Date.now() + $2de7d44435f834ae$var$COOLDOWN_TIME_MS;
            const result = [];
            const records = yield (0, $21K3T._fetchTxtRecords)((_a = this._networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch);
            const path = $2de7d44435f834ae$var$_extractPathFromUrl(urlConfig.defaultUrl);
            for (const record of records){
                if (!record.startsWith(urlConfig.endpointDnsKey + '=')) continue;
                const parts = record.split('=');
                if (parts.length > 1) {
                    let baseUrl = parts[1];
                    if (baseUrl.endsWith('/')) baseUrl = baseUrl.slice(0, -1);
                    result.push(`https://${baseUrl}${path}`);
                }
            }
            return result;
        });
    }
    _pickNewFallbackUrl(currentFallbackInfo, urls) {
        var _a;
        if (urls == null) return null;
        const previouslyUsed = new Set((_a = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.previous) !== null && _a !== void 0 ? _a : []);
        const currentFallbackUrl = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.url;
        let found = null;
        for (const loopUrl of urls){
            const url = loopUrl.endsWith('/') ? loopUrl.slice(0, -1) : loopUrl;
            if (!previouslyUsed.has(loopUrl) && url !== currentFallbackUrl) {
                found = url;
                break;
            }
        }
        return found;
    }
    constructor(options){
        var _a;
        this._fallbackInfo = null;
        this._errorBoundary = null;
        this._dnsQueryCooldowns = {};
        this._networkOverrideFunc = (_a = options.networkConfig) === null || _a === void 0 ? void 0 : _a.networkOverrideFunc;
    }
}
module.exports.NetworkFallbackResolver = $2de7d44435f834ae$var$NetworkFallbackResolver;
function $2de7d44435f834ae$var$_isDomainFailure(errorMsg, timedOut) {
    var _a;
    const lowerErrorMsg = (_a = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.toLowerCase()) !== null && _a !== void 0 ? _a : '';
    return timedOut || lowerErrorMsg.includes('uncaught exception') || lowerErrorMsg.includes('failed to fetch') || lowerErrorMsg.includes('networkerror when attempting to fetch resource');
}
module.exports._isDomainFailure = $2de7d44435f834ae$var$_isDomainFailure;
function $2de7d44435f834ae$var$_getFallbackInfoStorageKey(sdkKey) {
    return `statsig.network_fallback.${(0, $5xWeB._DJB2)(sdkKey)}`;
}
function $2de7d44435f834ae$var$_tryWriteFallbackInfoToCache(sdkKey, info) {
    const hashKey = $2de7d44435f834ae$var$_getFallbackInfoStorageKey(sdkKey);
    if (!info || Object.keys(info).length === 0) {
        $c6J8p.Storage.removeItem(hashKey);
        return;
    }
    $c6J8p.Storage.setItem(hashKey, JSON.stringify(info));
}
function $2de7d44435f834ae$var$_readFallbackInfoFromCache(sdkKey) {
    const hashKey = $2de7d44435f834ae$var$_getFallbackInfoStorageKey(sdkKey);
    const data = $c6J8p.Storage.getItem(hashKey);
    if (!data) return null;
    try {
        return JSON.parse(data);
    } catch (_a) {
        $734ad.Log.error('Failed to parse FallbackInfo');
        return null;
    }
}
function $2de7d44435f834ae$var$_extractPathFromUrl(urlString) {
    try {
        const url = new URL(urlString);
        return url.pathname;
    } catch (error) {
        return null;
    }
}

});
parcelRegister("21K3T", function(module, exports) {
"use strict";
var $179f67ae0694053f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fetchTxtRecords = void 0;
// See example: https://github.com/statsig-io/private-js-client-monorepo/pull/340
const $179f67ae0694053f$var$FEATURE_ASSETS_DNS_QUERY = new Uint8Array([
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x0d,
    0x66,
    0x65,
    0x61,
    0x74,
    0x75,
    0x72,
    0x65,
    0x61,
    0x73,
    0x73,
    0x65,
    0x74,
    0x73,
    0x03,
    0x6f,
    0x72,
    0x67,
    0x00,
    0x00,
    0x10,
    0x00,
    0x01
]);
const $179f67ae0694053f$var$DNS_QUERY_ENDPOINT = 'https://cloudflare-dns.com/dns-query';
const $179f67ae0694053f$var$DOMAIN_CHARS = [
    'i',
    'e',
    'd'
];
const $179f67ae0694053f$var$MAX_START_LOOKUP = 200;
function $179f67ae0694053f$var$_fetchTxtRecords(networkFunc) {
    return $179f67ae0694053f$var$__awaiter(this, void 0, void 0, function*() {
        const response = yield networkFunc($179f67ae0694053f$var$DNS_QUERY_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/dns-message',
                Accept: 'application/dns-message'
            },
            body: $179f67ae0694053f$var$FEATURE_ASSETS_DNS_QUERY
        });
        if (!response.ok) {
            const err = new Error('Failed to fetch TXT records from DNS');
            err.name = 'DnsTxtFetchError';
            throw err;
        }
        const data = yield response.arrayBuffer();
        const bytes = new Uint8Array(data);
        return $179f67ae0694053f$var$_parseDnsResponse(bytes);
    });
}
module.exports._fetchTxtRecords = $179f67ae0694053f$var$_fetchTxtRecords;
function $179f67ae0694053f$var$_parseDnsResponse(input) {
    // loop until we find the first valid domain char. One of [i=, e=, d=]
    const start = input.findIndex((byte, index)=>index < $179f67ae0694053f$var$MAX_START_LOOKUP && String.fromCharCode(byte) === '=' && $179f67ae0694053f$var$DOMAIN_CHARS.includes(String.fromCharCode(input[index - 1])));
    if (start === -1) {
        const err = new Error('Failed to parse TXT records from DNS');
        err.name = 'DnsTxtParseError';
        throw err;
    }
    // decode the remaining bytes as a string
    let result = '';
    for(let i = start - 1; i < input.length; i++)result += String.fromCharCode(input[i]);
    return result.split(',');
}

});


parcelRegister("gVlw5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKFlags = void 0;
const $c522a8f7744d5e0a$var$FLAGMAP = {};
module.exports.SDKFlags = {
    setFlags: (sdkKey, flags)=>{
        $c522a8f7744d5e0a$var$FLAGMAP[sdkKey] = flags;
    },
    get: (sdkKey, flagKey)=>{
        var _a, _b;
        return (_b = (_a = $c522a8f7744d5e0a$var$FLAGMAP[sdkKey]) === null || _a === void 0 ? void 0 : _a[flagKey]) !== null && _b !== void 0 ? _b : false;
    }
};

});

parcelRegister("cSz3w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigSession = module.exports.SessionID = void 0;

var $g2TNZ = parcelRequire("g2TNZ");

var $7dAGN = parcelRequire("7dAGN");

var $734ad = parcelRequire("734ad");

var $c6J8p = parcelRequire("c6J8p");

var $2I8e3 = parcelRequire("2I8e3");
const $9605b883b2b56dfc$var$MAX_SESSION_IDLE_TIME = 1800000; // 30 minutes
const $9605b883b2b56dfc$var$MAX_SESSION_AGE = 14400000; // 4 hours
const $9605b883b2b56dfc$var$PROMISE_MAP = {};
module.exports.SessionID = {
    get: (sdkKey)=>{
        return module.exports.StatsigSession.get(sdkKey).data.sessionID;
    }
};
module.exports.StatsigSession = {
    get: (sdkKey)=>{
        if ($9605b883b2b56dfc$var$PROMISE_MAP[sdkKey] == null) $9605b883b2b56dfc$var$PROMISE_MAP[sdkKey] = $9605b883b2b56dfc$var$_loadSession(sdkKey);
        const session = $9605b883b2b56dfc$var$PROMISE_MAP[sdkKey];
        return $9605b883b2b56dfc$var$_bumpSession(session);
    },
    overrideInitialSessionID: (override, sdkKey)=>{
        $9605b883b2b56dfc$var$PROMISE_MAP[sdkKey] = $9605b883b2b56dfc$var$_overrideSessionId(override, sdkKey);
    }
};
function $9605b883b2b56dfc$var$_loadSession(sdkKey) {
    let data = $9605b883b2b56dfc$var$_loadFromStorage(sdkKey);
    const now = Date.now();
    if (!data) data = {
        sessionID: (0, $2I8e3.getUUID)(),
        startTime: now,
        lastUpdate: now
    };
    return {
        data: data,
        sdkKey: sdkKey
    };
}
function $9605b883b2b56dfc$var$_overrideSessionId(override, sdkKey) {
    const now = Date.now();
    return {
        data: {
            sessionID: override,
            startTime: now,
            lastUpdate: now
        },
        sdkKey: sdkKey
    };
}
function $9605b883b2b56dfc$var$_bumpSession(session) {
    const now = Date.now();
    const data = session.data;
    const sdkKey = session.sdkKey;
    if ($9605b883b2b56dfc$var$_isIdle(data) || $9605b883b2b56dfc$var$_hasRunTooLong(data)) {
        data.sessionID = (0, $2I8e3.getUUID)();
        data.startTime = now;
        const client = __STATSIG__ === null || __STATSIG__ === void 0 ? void 0 : __STATSIG__.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }
    data.lastUpdate = now;
    $9605b883b2b56dfc$var$_persistToStorage(data, session.sdkKey);
    clearTimeout(session.idleTimeoutID);
    clearTimeout(session.ageTimeoutID);
    const lifetime = now - data.startTime;
    session.idleTimeoutID = $9605b883b2b56dfc$var$_createSessionTimeout(sdkKey, $9605b883b2b56dfc$var$MAX_SESSION_IDLE_TIME);
    session.ageTimeoutID = $9605b883b2b56dfc$var$_createSessionTimeout(sdkKey, $9605b883b2b56dfc$var$MAX_SESSION_AGE - lifetime);
    return session;
}
function $9605b883b2b56dfc$var$_createSessionTimeout(sdkKey, duration) {
    return setTimeout(()=>{
        var _a;
        const client = (_a = (0, $g2TNZ._getStatsigGlobal)()) === null || _a === void 0 ? void 0 : _a.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }, duration);
}
function $9605b883b2b56dfc$var$_isIdle({ lastUpdate: lastUpdate }) {
    return Date.now() - lastUpdate > $9605b883b2b56dfc$var$MAX_SESSION_IDLE_TIME;
}
function $9605b883b2b56dfc$var$_hasRunTooLong({ startTime: startTime }) {
    return Date.now() - startTime > $9605b883b2b56dfc$var$MAX_SESSION_AGE;
}
function $9605b883b2b56dfc$var$_getSessionIDStorageKey(sdkKey) {
    return `statsig.session_id.${(0, $7dAGN._getStorageKey)(sdkKey)}`;
}
function $9605b883b2b56dfc$var$_persistToStorage(session, sdkKey) {
    const storageKey = $9605b883b2b56dfc$var$_getSessionIDStorageKey(sdkKey);
    try {
        (0, $c6J8p._setObjectInStorage)(storageKey, session);
    } catch (e) {
        $734ad.Log.warn('Failed to save SessionID');
    }
}
function $9605b883b2b56dfc$var$_loadFromStorage(sdkKey) {
    const storageKey = $9605b883b2b56dfc$var$_getSessionIDStorageKey(sdkKey);
    return (0, $c6J8p._getObjectFromStorage)(storageKey);
}

});

parcelRegister("70Ond", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorTag = void 0;
module.exports.ErrorTag = {
    NetworkError: 'NetworkError'
};

});


parcelRegister("8CTpP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("iYN0W", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("6cHBa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fastApproxSizeOf = void 0;
const $4845aeca8d4aa0ea$var$CURLY_AND_SQUARE_BRACKET_SIZE = 2; // [] for array, {} for object
const $4845aeca8d4aa0ea$var$APPROX_ADDITIONAL_SIZE = 1; // additional size for comma and stuff
const $4845aeca8d4aa0ea$var$_fastApproxSizeOf = (obj, max)=>{
    let size = 0;
    const keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const value = obj[key];
        size += key.length;
        if (typeof value === 'object' && value !== null) size += (0, module.exports._fastApproxSizeOf)(value, max) + $4845aeca8d4aa0ea$var$CURLY_AND_SQUARE_BRACKET_SIZE;
        else size += String(value).length + $4845aeca8d4aa0ea$var$APPROX_ADDITIONAL_SIZE;
        if (size >= max) // exit early if we've exceeded the max
        return size;
    }
    return size;
};
module.exports._fastApproxSizeOf = $4845aeca8d4aa0ea$var$_fastApproxSizeOf;

});

parcelRegister("4tnuA", function(module, exports) {
"use strict";
var $341c17ee86e9aa56$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClientBase = void 0;

var $g2TNZ = parcelRequire("g2TNZ");

var $g2TNZ = parcelRequire("g2TNZ");

var $hLWFM = parcelRequire("hLWFM");

var $l7lyt = parcelRequire("l7lyt");

var $734ad = parcelRequire("734ad");

var $1i5Ye = parcelRequire("1i5Ye");

var $3h5v5 = parcelRequire("3h5v5");

var $cSz3w = parcelRequire("cSz3w");

var $kZdmh = parcelRequire("kZdmh");

var $bZVno = parcelRequire("bZVno");

var $c6J8p = parcelRequire("c6J8p");
const $341c17ee86e9aa56$var$MAX_MEMO_CACHE_SIZE = 3000;
class $341c17ee86e9aa56$var$StatsigClientBase {
    /**
     * Updates runtime configuration options for the SDK, allowing toggling of certain behaviors such as logging and storage to comply with user preferences or regulations such as GDPR.
     *
     * @param {StatsigRuntimeMutableOptions} options - The configuration options that dictate the runtime behavior of the SDK.
     */ updateRuntimeOptions(options) {
        if (options.loggingEnabled) {
            this._options.loggingEnabled = options.loggingEnabled;
            this._logger.setLoggingEnabled(options.loggingEnabled);
        } else if (options.disableLogging != null) {
            this._options.disableLogging = options.disableLogging;
            this._logger.setLoggingEnabled(options.disableLogging ? 'disabled' : 'browser-only');
        }
        if (options.disableStorage != null) {
            this._options.disableStorage = options.disableStorage;
            $c6J8p.Storage._setDisabled(options.disableStorage);
        }
        if (options.enableCookies != null) {
            this._options.enableCookies = options.enableCookies;
            $kZdmh.StableID._setCookiesEnabled(this._sdkKey, options.enableCookies);
        }
        if (options.logEventCompressionMode) this._logger.setLogEventCompressionMode(options.logEventCompressionMode);
        else if (options.disableCompression) this._logger.setLogEventCompressionMode($bZVno.LogEventCompressionMode.Disabled);
    }
    /**
     * Flushes any currently queued events.
     */ flush() {
        return this._logger.flush();
    }
    /**
     * Gracefully shuts down the SDK, ensuring that all pending events are send before the SDK stops.
     * This function emits a 'pre_shutdown' event and then waits for the logger to complete its shutdown process.
     *
     * @returns {Promise<void>} A promise that resolves when all shutdown procedures, including logging shutdown, have been completed.
     */ shutdown() {
        return $341c17ee86e9aa56$var$__awaiter(this, void 0, void 0, function*() {
            this.$emt({
                name: 'pre_shutdown'
            });
            this._setStatus('Uninitialized', null);
            this._initializePromise = null;
            yield this._logger.stop();
        });
    }
    /**
     * Subscribes a callback function to a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     * Once subscribed, the listener callback will be invoked whenever the specified event is emitted.
     *
     * @param {StatsigClientEventName} event - The name of the event to subscribe to, or '*' to subscribe to all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to execute when the event occurs. The function receives event-specific data as its parameter.
     * @see {@link off} for unsubscribing from events.
     */ on(event, listener) {
        if (!this._listeners[event]) this._listeners[event] = [];
        this._listeners[event].push(listener);
    }
    /**
     * Unsubscribes a previously registered callback function from a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     *
     * @param {StatsigClientEventName} event - The name of the event from which to unsubscribe, or '*' to unsubscribe from all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to remove from the event's notification list.
     * @see {@link on} for subscribing to events.
     */ off(event, listener) {
        if (this._listeners[event]) {
            const index = this._listeners[event].indexOf(listener);
            if (index !== -1) this._listeners[event].splice(index, 1);
        }
    }
    $on(event, listener) {
        listener.__isInternal = true;
        this.on(event, listener);
    }
    $emt(event) {
        var _a;
        const barrier = (listener)=>{
            try {
                listener(event);
            } catch (error) {
                if (listener.__isInternal === true) {
                    this._errorBoundary.logError(`__emit:${event.name}`, error);
                    return;
                }
                $734ad.Log.error(`An error occurred in a StatsigClientEvent listener. This is not an issue with Statsig.`, event);
            }
        };
        if (this._listeners[event.name]) this._listeners[event.name].forEach((l)=>barrier(l));
        (_a = this._listeners['*']) === null || _a === void 0 || _a.forEach(barrier);
    }
    _setStatus(newStatus, values) {
        this.loadingStatus = newStatus;
        this._memoCache = {};
        this.$emt({
            name: 'values_updated',
            status: newStatus,
            values: values
        });
    }
    _enqueueExposure(name, exposure, options) {
        if ((options === null || options === void 0 ? void 0 : options.disableExposureLog) === true) {
            this._logger.incrementNonExposureCount(name);
            return;
        }
        this._logger.enqueue(exposure);
    }
    _memoize(prefix, fn) {
        return (name, options)=>{
            if (this._options.disableEvaluationMemoization) return fn(name, options);
            const memoKey = (0, $1i5Ye.createMemoKey)(prefix, name, options);
            if (!memoKey) return fn(name, options);
            if (!(memoKey in this._memoCache)) {
                if (Object.keys(this._memoCache).length >= $341c17ee86e9aa56$var$MAX_MEMO_CACHE_SIZE) this._memoCache = {};
                this._memoCache[memoKey] = fn(name, options);
            }
            return this._memoCache[memoKey];
        };
    }
    constructor(sdkKey, adapter, network, options){
        var _a, _b, _c, _d;
        this.loadingStatus = 'Uninitialized';
        this._initializePromise = null;
        this._listeners = {};
        const emitter = this.$emt.bind(this);
        (options === null || options === void 0 ? void 0 : options.logLevel) != null && ($734ad.Log.level = options.logLevel);
        (options === null || options === void 0 ? void 0 : options.disableStorage) && $c6J8p.Storage._setDisabled(true);
        (options === null || options === void 0 ? void 0 : options.initialSessionID) && $cSz3w.StatsigSession.overrideInitialSessionID(options.initialSessionID, sdkKey);
        (options === null || options === void 0 ? void 0 : options.storageProvider) && $c6J8p.Storage._setProvider(options.storageProvider);
        (options === null || options === void 0 ? void 0 : options.enableCookies) && $kZdmh.StableID._setCookiesEnabled(sdkKey, options.enableCookies);
        (options === null || options === void 0 ? void 0 : options.disableStableID) && $kZdmh.StableID._setDisabled(sdkKey, true);
        this._sdkKey = sdkKey;
        this._options = options !== null && options !== void 0 ? options : {};
        this._memoCache = {};
        this.overrideAdapter = (_a = options === null || options === void 0 ? void 0 : options.overrideAdapter) !== null && _a !== void 0 ? _a : null;
        this._logger = new $l7lyt.EventLogger(sdkKey, emitter, network, options);
        this._errorBoundary = new $hLWFM.ErrorBoundary(sdkKey, options, emitter);
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(adapter);
        this._errorBoundary.wrap(this._logger);
        network.setErrorBoundary(this._errorBoundary);
        this.dataAdapter = adapter;
        this.dataAdapter.attach(sdkKey, options, network);
        this.storageProvider = $c6J8p.Storage;
        (_d = (_c = (_b = this.overrideAdapter) === null || _b === void 0 ? void 0 : _b.loadFromStorage) === null || _c === void 0 ? void 0 : _c.call(_b)) === null || _d === void 0 || _d.catch((e)=>this._errorBoundary.logError('OA::loadFromStorage', e));
        this._primeReadyRipcord();
        $341c17ee86e9aa56$var$_assignGlobalInstance(sdkKey, this);
    }
}
module.exports.StatsigClientBase = $341c17ee86e9aa56$var$StatsigClientBase;
function $341c17ee86e9aa56$var$_assignGlobalInstance(sdkKey, client) {
    var _a;
    if ((0, $3h5v5._isServerEnv)()) return;
    const statsigGlobal = (0, $g2TNZ._getStatsigGlobal)();
    const instances = (_a = statsigGlobal.instances) !== null && _a !== void 0 ? _a : {};
    const inst = client;
    if (instances[sdkKey] != null) $734ad.Log.warn('Creating multiple Statsig clients with the same SDK key can lead to unexpected behavior. Multi-instance support requires different SDK keys.');
    instances[sdkKey] = inst;
    if (!statsigGlobal.firstInstance) statsigGlobal.firstInstance = inst;
    statsigGlobal.instances = instances;
    __STATSIG__ = statsigGlobal;
}

});
parcelRegister("l7lyt", function(module, exports) {
"use strict";
var $f5faf8c8902b5b28$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventLogger = void 0;

var $7dAGN = parcelRequire("7dAGN");

var $5xWeB = parcelRequire("5xWeB");

var $734ad = parcelRequire("734ad");

var $l3sJo = parcelRequire("l3sJo");

var $3h5v5 = parcelRequire("3h5v5");

var $kTyja = parcelRequire("kTyja");

var $bZVno = parcelRequire("bZVno");

var $c6J8p = parcelRequire("c6J8p");

var $h42ib = parcelRequire("h42ib");

var $fOEO6 = parcelRequire("fOEO6");
const $f5faf8c8902b5b28$var$DEFAULT_QUEUE_SIZE = 100;
const $f5faf8c8902b5b28$var$DEFAULT_FLUSH_INTERVAL_MS = 10000;
const $f5faf8c8902b5b28$var$MAX_DEDUPER_KEYS = 1000;
const $f5faf8c8902b5b28$var$DEDUPER_WINDOW_DURATION_MS = 600000;
const $f5faf8c8902b5b28$var$MAX_FAILED_LOGS = 500;
const $f5faf8c8902b5b28$var$QUICK_FLUSH_WINDOW_MS = 200;
const $f5faf8c8902b5b28$var$EVENT_LOGGER_MAP = {};
const $f5faf8c8902b5b28$var$RetryFailedLogsTrigger = {
    Startup: 'startup',
    GainedFocus: 'gained_focus'
};
class $f5faf8c8902b5b28$var$EventLogger {
    static _safeFlushAndForget(sdkKey) {
        var _a;
        (_a = $f5faf8c8902b5b28$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a.flush().catch(()=>{
        // noop
        });
    }
    static _safeRetryFailedLogs(sdkKey) {
        var _a;
        (_a = $f5faf8c8902b5b28$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a._retryFailedLogs($f5faf8c8902b5b28$var$RetryFailedLogsTrigger.GainedFocus);
    }
    setLogEventCompressionMode(mode) {
        this._network.setLogEventCompressionMode(mode);
    }
    setLoggingEnabled(loggingEnabled) {
        this._loggingEnabled = loggingEnabled;
    }
    enqueue(event) {
        if (!this._shouldLogEvent(event)) return;
        this._normalizeAndAppendEvent(event);
        this._quickFlushIfNeeded();
        if (this._queue.length > this._maxQueueSize) $f5faf8c8902b5b28$var$EventLogger._safeFlushAndForget(this._sdkKey);
    }
    incrementNonExposureCount(name) {
        var _a;
        const current = (_a = this._nonExposedChecks[name]) !== null && _a !== void 0 ? _a : 0;
        this._nonExposedChecks[name] = current + 1;
    }
    reset() {
        // attempt to flush any remaining events
        this.flush().catch(()=>{
        // noop
        });
        this._lastExposureTimeMap = {};
    }
    start() {
        var _a;
        const isServerEnv = (0, $3h5v5._isServerEnv)();
        if (isServerEnv && ((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always') return;
        $f5faf8c8902b5b28$var$EVENT_LOGGER_MAP[this._sdkKey] = this;
        if (!isServerEnv) (0, $fOEO6._subscribeToVisiblityChanged)((visibility)=>{
            if (visibility === 'background') $f5faf8c8902b5b28$var$EventLogger._safeFlushAndForget(this._sdkKey);
            else if (visibility === 'foreground') $f5faf8c8902b5b28$var$EventLogger._safeRetryFailedLogs(this._sdkKey);
        });
        this._retryFailedLogs($f5faf8c8902b5b28$var$RetryFailedLogsTrigger.Startup);
        this._startBackgroundFlushInterval();
    }
    stop() {
        return $f5faf8c8902b5b28$var$__awaiter(this, void 0, void 0, function*() {
            if (this._flushIntervalId) {
                clearInterval(this._flushIntervalId);
                this._flushIntervalId = null;
            }
            delete $f5faf8c8902b5b28$var$EVENT_LOGGER_MAP[this._sdkKey];
            yield this.flush();
        });
    }
    flush() {
        return $f5faf8c8902b5b28$var$__awaiter(this, void 0, void 0, function*() {
            this._appendAndResetNonExposedChecks();
            if (this._queue.length === 0) return;
            const events = this._queue;
            this._queue = [];
            yield this._sendEvents(events);
        });
    }
    /**
     * We 'Quick Flush' following the very first event enqueued
     * within the quick flush window
     */ _quickFlushIfNeeded() {
        if (this._hasRunQuickFlush) return;
        this._hasRunQuickFlush = true;
        if (Date.now() - this._creationTime > $f5faf8c8902b5b28$var$QUICK_FLUSH_WINDOW_MS) return;
        setTimeout(()=>$f5faf8c8902b5b28$var$EventLogger._safeFlushAndForget(this._sdkKey), $f5faf8c8902b5b28$var$QUICK_FLUSH_WINDOW_MS);
    }
    _shouldLogEvent(event) {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always' && (0, $3h5v5._isServerEnv)()) return false;
        if (!(0, $kTyja._isExposureEvent)(event)) return true;
        const user = event.user ? event.user : {
            statsigEnvironment: undefined
        };
        const userKey = (0, $7dAGN._getUserStorageKey)(this._sdkKey, user);
        const metadata = event.metadata ? event.metadata : {};
        const key = [
            event.eventName,
            userKey,
            metadata['gate'],
            metadata['config'],
            metadata['ruleID'],
            metadata['allocatedExperiment'],
            metadata['parameterName'],
            String(metadata['isExplicitParameter']),
            metadata['reason']
        ].join('|');
        const previous = this._lastExposureTimeMap[key];
        const now = Date.now();
        if (previous && now - previous < $f5faf8c8902b5b28$var$DEDUPER_WINDOW_DURATION_MS) return false;
        if (Object.keys(this._lastExposureTimeMap).length > $f5faf8c8902b5b28$var$MAX_DEDUPER_KEYS) this._lastExposureTimeMap = {};
        this._lastExposureTimeMap[key] = now;
        return true;
    }
    _sendEvents(events) {
        return $f5faf8c8902b5b28$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            if (this._loggingEnabled === 'disabled') {
                this._saveFailedLogsToStorage(events);
                return false;
            }
            try {
                const isClosing = (0, $fOEO6._isUnloading)();
                const shouldUseBeacon = isClosing && this._network.isBeaconSupported() && ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.networkOverrideFunc) == null;
                this._emitter({
                    name: 'pre_logs_flushed',
                    events: events
                });
                const response = shouldUseBeacon ? this._sendEventsViaBeacon(events) : yield this._sendEventsViaPost(events);
                if (response.success) {
                    this._emitter({
                        name: 'logs_flushed',
                        events: events
                    });
                    return true;
                } else {
                    $734ad.Log.warn('Failed to flush events.');
                    this._saveFailedLogsToStorage(events);
                    return false;
                }
            } catch (_c) {
                $734ad.Log.warn('Failed to flush events.');
                return false;
            }
        });
    }
    _sendEventsViaPost(events) {
        return $f5faf8c8902b5b28$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield this._network.post(this._getRequestData(events));
            const code = (_a = result === null || result === void 0 ? void 0 : result.code) !== null && _a !== void 0 ? _a : -1;
            return {
                success: code >= 200 && code < 300
            };
        });
    }
    _sendEventsViaBeacon(events) {
        return {
            success: this._network.beacon(this._getRequestData(events))
        };
    }
    _getRequestData(events) {
        return {
            sdkKey: this._sdkKey,
            data: {
                events: events
            },
            urlConfig: this._logEventUrlConfig,
            retries: 3,
            isCompressable: true,
            params: {
                [$l3sJo.NetworkParam.EventCount]: String(events.length)
            },
            credentials: 'same-origin'
        };
    }
    _saveFailedLogsToStorage(events) {
        while(events.length > $f5faf8c8902b5b28$var$MAX_FAILED_LOGS)events.shift();
        const storageKey = this._getStorageKey();
        try {
            (0, $c6J8p._setObjectInStorage)(storageKey, events);
        } catch (_a) {
            $734ad.Log.warn('Unable to save failed logs to storage');
        }
    }
    _retryFailedLogs(trigger) {
        const storageKey = this._getStorageKey();
        (()=>$f5faf8c8902b5b28$var$__awaiter(this, void 0, void 0, function*() {
                if (!$c6J8p.Storage.isReady()) yield $c6J8p.Storage.isReadyResolver();
                const events = (0, $c6J8p._getObjectFromStorage)(storageKey);
                if (!events) return;
                if (trigger === $f5faf8c8902b5b28$var$RetryFailedLogsTrigger.Startup) $c6J8p.Storage.removeItem(storageKey);
                const isSuccess = yield this._sendEvents(events);
                if (isSuccess && trigger === $f5faf8c8902b5b28$var$RetryFailedLogsTrigger.GainedFocus) $c6J8p.Storage.removeItem(storageKey);
            }))().catch(()=>{
            $734ad.Log.warn('Failed to flush stored logs');
        });
    }
    _getStorageKey() {
        return `statsig.failed_logs.${(0, $5xWeB._DJB2)(this._sdkKey)}`;
    }
    _normalizeAndAppendEvent(event) {
        if (event.user) {
            event.user = Object.assign({}, event.user);
            delete event.user.privateAttributes;
        }
        const extras = {};
        const currentPage = this._getCurrentPageUrl();
        if (currentPage) extras.statsigMetadata = {
            currentPage: currentPage
        };
        const final = Object.assign(Object.assign({}, event), extras);
        $734ad.Log.debug('Enqueued Event:', final);
        this._queue.push(final);
    }
    _appendAndResetNonExposedChecks() {
        if (Object.keys(this._nonExposedChecks).length === 0) return;
        this._normalizeAndAppendEvent({
            eventName: 'statsig::non_exposed_checks',
            user: null,
            time: Date.now(),
            metadata: {
                checks: Object.assign({}, this._nonExposedChecks)
            }
        });
        this._nonExposedChecks = {};
    }
    _getCurrentPageUrl() {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.includeCurrentPageUrlWithEvents) === false) return;
        return (0, $3h5v5._getCurrentPageUrlSafe)();
    }
    _startBackgroundFlushInterval() {
        var _a, _b;
        const flushInterval = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingIntervalMs) !== null && _b !== void 0 ? _b : $f5faf8c8902b5b28$var$DEFAULT_FLUSH_INTERVAL_MS;
        const intervalId = setInterval(()=>{
            const logger = $f5faf8c8902b5b28$var$EVENT_LOGGER_MAP[this._sdkKey];
            if (!logger || logger._flushIntervalId !== intervalId) clearInterval(intervalId);
            else $f5faf8c8902b5b28$var$EventLogger._safeFlushAndForget(this._sdkKey);
        }, flushInterval);
        this._flushIntervalId = intervalId;
    }
    constructor(_sdkKey, _emitter, _network, _options){
        var _a, _b;
        this._sdkKey = _sdkKey;
        this._emitter = _emitter;
        this._network = _network;
        this._options = _options;
        this._queue = [];
        this._lastExposureTimeMap = {};
        this._nonExposedChecks = {};
        this._hasRunQuickFlush = false;
        this._creationTime = Date.now();
        this._loggingEnabled = (_a = _options === null || _options === void 0 ? void 0 : _options.loggingEnabled) !== null && _a !== void 0 ? _a : (_options === null || _options === void 0 ? void 0 : _options.disableLogging) === true ? $bZVno.LoggingEnabledOption.disabled : $bZVno.LoggingEnabledOption.browserOnly;
        if ((_options === null || _options === void 0 ? void 0 : _options.loggingEnabled) && _options.disableLogging !== undefined) $734ad.Log.warn('Detected both loggingEnabled and disableLogging options. loggingEnabled takes precedence - please remove disableLogging.');
        this._maxQueueSize = (_b = _options === null || _options === void 0 ? void 0 : _options.loggingBufferMaxSize) !== null && _b !== void 0 ? _b : $f5faf8c8902b5b28$var$DEFAULT_QUEUE_SIZE;
        const config = _options === null || _options === void 0 ? void 0 : _options.networkConfig;
        this._logEventUrlConfig = new $h42ib.UrlConfiguration($l3sJo.Endpoint._rgstr, config === null || config === void 0 ? void 0 : config.logEventUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.logEventFallbackUrls);
    }
}
module.exports.EventLogger = $f5faf8c8902b5b28$var$EventLogger;

});


parcelRegister("a5oTl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataAdapterCachePrefix = void 0;
module.exports.DataAdapterCachePrefix = 'statsig.cached';

});

parcelRegister("2RFmf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("85VP8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeTypedGet = module.exports._mergeOverride = module.exports._makeLayer = module.exports._makeExperiment = module.exports._makeDynamicConfig = module.exports._makeFeatureGate = void 0;

var $734ad = parcelRequire("734ad");

var $23ExQ = parcelRequire("23ExQ");
function $5e4ba4f8fed0714c$var$_makeEvaluation(name, details, evaluation, value) {
    var _a;
    return {
        name: name,
        details: details,
        ruleID: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.rule_id) !== null && _a !== void 0 ? _a : '',
        __evaluation: evaluation,
        value: value
    };
}
function $5e4ba4f8fed0714c$var$_makeFeatureGate(name, details, evaluation) {
    var _a;
    return Object.assign(Object.assign({}, $5e4ba4f8fed0714c$var$_makeEvaluation(name, details, evaluation, (evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) === true)), {
        idType: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeFeatureGate = $5e4ba4f8fed0714c$var$_makeFeatureGate;
function $5e4ba4f8fed0714c$var$_makeDynamicConfig(name, details, evaluation) {
    var _a;
    const value = (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, $5e4ba4f8fed0714c$var$_makeEvaluation(name, details, evaluation, value)), {
        get: $5e4ba4f8fed0714c$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value)
    });
}
module.exports._makeDynamicConfig = $5e4ba4f8fed0714c$var$_makeDynamicConfig;
function $5e4ba4f8fed0714c$var$_makeExperiment(name, details, evaluation) {
    var _a;
    const result = $5e4ba4f8fed0714c$var$_makeDynamicConfig(name, details, evaluation);
    return Object.assign(Object.assign({}, result), {
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeExperiment = $5e4ba4f8fed0714c$var$_makeExperiment;
function $5e4ba4f8fed0714c$var$_makeLayer(name, details, evaluation, exposeFunc) {
    var _a, _b;
    return Object.assign(Object.assign({}, $5e4ba4f8fed0714c$var$_makeEvaluation(name, details, evaluation, undefined)), {
        get: $5e4ba4f8fed0714c$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value, exposeFunc),
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null,
        __value: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _b !== void 0 ? _b : {}
    });
}
module.exports._makeLayer = $5e4ba4f8fed0714c$var$_makeLayer;
function $5e4ba4f8fed0714c$var$_mergeOverride(original, overridden, value, exposeFunc) {
    return Object.assign(Object.assign(Object.assign({}, original), overridden), {
        get: $5e4ba4f8fed0714c$var$_makeTypedGet(original.name, value, exposeFunc)
    });
}
module.exports._mergeOverride = $5e4ba4f8fed0714c$var$_mergeOverride;
function $5e4ba4f8fed0714c$var$_makeTypedGet(name, value, exposeFunc) {
    return (param, fallback)=>{
        var _a;
        const found = (_a = value === null || value === void 0 ? void 0 : value[param]) !== null && _a !== void 0 ? _a : null;
        if (found == null) return fallback !== null && fallback !== void 0 ? fallback : null;
        if (fallback != null && !(0, $23ExQ._isTypeMatch)(found, fallback)) {
            $734ad.Log.warn(`Parameter type mismatch. '${name}.${param}' was found to be type '${typeof found}' but fallback/return type is '${typeof fallback}'. See https://docs.statsig.com/client/javascript-sdk/#typed-getters`);
            return fallback !== null && fallback !== void 0 ? fallback : null;
        }
        exposeFunc === null || exposeFunc === void 0 || exposeFunc(param);
        return found;
    };
}
module.exports._makeTypedGet = $5e4ba4f8fed0714c$var$_makeTypedGet;

});

parcelRegister("1REJJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("9FhqT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = module.exports.createUpdateDetails = void 0;
const $7095772c17b78037$var$createUpdateDetails = (success, source, initDuration, error, sourceUrl, warnings)=>{
    return {
        duration: initDuration,
        source: source,
        success: success,
        error: error,
        sourceUrl: sourceUrl,
        warnings: warnings
    };
};
module.exports.createUpdateDetails = $7095772c17b78037$var$createUpdateDetails;
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = {
    NO_NETWORK_DATA: 'No data was returned from the network. This may be due to a network timeout if a timeout value was specified in the options or ad blocker error.'
};

});

parcelRegister("3UfL2", function(module, exports) {
$parcel$export(module.exports, "__extends", () => $2d82d33a11c2a1d9$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $2d82d33a11c2a1d9$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $2d82d33a11c2a1d9$export$3c9a16f847548506);
$parcel$export(module.exports, "__awaiter", () => $2d82d33a11c2a1d9$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $2d82d33a11c2a1d9$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__values", () => $2d82d33a11c2a1d9$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $2d82d33a11c2a1d9$export$8d051b38c9118094);
$parcel$export(module.exports, "__spread", () => $2d82d33a11c2a1d9$export$afc72e2116322959);
$parcel$export(module.exports, "__spreadArrays", () => $2d82d33a11c2a1d9$export$6388937ca91ccae8);
$parcel$export(module.exports, "__spreadArray", () => $2d82d33a11c2a1d9$export$1216008129fb82ed);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $2d82d33a11c2a1d9$var$extendStatics = function(d, b) {
    $2d82d33a11c2a1d9$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $2d82d33a11c2a1d9$var$extendStatics(d, b);
};
function $2d82d33a11c2a1d9$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $2d82d33a11c2a1d9$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $2d82d33a11c2a1d9$export$18ce0697a983be9b = function() {
    $2d82d33a11c2a1d9$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2d82d33a11c2a1d9$export$18ce0697a983be9b.apply(this, arguments);
};
function $2d82d33a11c2a1d9$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $2d82d33a11c2a1d9$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $2d82d33a11c2a1d9$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $2d82d33a11c2a1d9$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $2d82d33a11c2a1d9$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $2d82d33a11c2a1d9$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $2d82d33a11c2a1d9$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $2d82d33a11c2a1d9$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $2d82d33a11c2a1d9$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $2d82d33a11c2a1d9$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $2d82d33a11c2a1d9$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $2d82d33a11c2a1d9$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $2d82d33a11c2a1d9$export$45d3717a4c69092e(o, m, p);
}
function $2d82d33a11c2a1d9$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $2d82d33a11c2a1d9$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $2d82d33a11c2a1d9$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($2d82d33a11c2a1d9$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $2d82d33a11c2a1d9$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $2d82d33a11c2a1d9$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $2d82d33a11c2a1d9$export$10c90e4f7922046c(v) {
    return this instanceof $2d82d33a11c2a1d9$export$10c90e4f7922046c ? (this.v = v, this) : new $2d82d33a11c2a1d9$export$10c90e4f7922046c(v);
}
function $2d82d33a11c2a1d9$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $2d82d33a11c2a1d9$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $2d82d33a11c2a1d9$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $2d82d33a11c2a1d9$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $2d82d33a11c2a1d9$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $2d82d33a11c2a1d9$export$19a8beecd37a4c45 === "function" ? $2d82d33a11c2a1d9$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $2d82d33a11c2a1d9$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $2d82d33a11c2a1d9$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $2d82d33a11c2a1d9$var$ownKeys = function(o) {
    $2d82d33a11c2a1d9$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $2d82d33a11c2a1d9$var$ownKeys(o);
};
function $2d82d33a11c2a1d9$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $2d82d33a11c2a1d9$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $2d82d33a11c2a1d9$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $2d82d33a11c2a1d9$var$__setModuleDefault(result, mod);
    return result;
}
function $2d82d33a11c2a1d9$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $2d82d33a11c2a1d9$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $2d82d33a11c2a1d9$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $2d82d33a11c2a1d9$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $2d82d33a11c2a1d9$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $2d82d33a11c2a1d9$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $2d82d33a11c2a1d9$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $2d82d33a11c2a1d9$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $2d82d33a11c2a1d9$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $2d82d33a11c2a1d9$export$2e2bcd8739ae039 = {
    __extends: $2d82d33a11c2a1d9$export$a8ba968b8961cb8a,
    __assign: $2d82d33a11c2a1d9$export$18ce0697a983be9b,
    __rest: $2d82d33a11c2a1d9$export$3c9a16f847548506,
    __decorate: $2d82d33a11c2a1d9$export$29e00dfd3077644b,
    __param: $2d82d33a11c2a1d9$export$d5ad3fd78186038f,
    __esDecorate: $2d82d33a11c2a1d9$export$3a84e1ae4e97e9b0,
    __runInitializers: $2d82d33a11c2a1d9$export$d831c04e792af3d,
    __propKey: $2d82d33a11c2a1d9$export$6a2a36740a146cb8,
    __setFunctionName: $2d82d33a11c2a1d9$export$d1a06452d3489bc7,
    __metadata: $2d82d33a11c2a1d9$export$f1db080c865becb9,
    __awaiter: $2d82d33a11c2a1d9$export$1050f835b63b671e,
    __generator: $2d82d33a11c2a1d9$export$67ebef60e6f28a6,
    __createBinding: $2d82d33a11c2a1d9$export$45d3717a4c69092e,
    __exportStar: $2d82d33a11c2a1d9$export$f33643c0debef087,
    __values: $2d82d33a11c2a1d9$export$19a8beecd37a4c45,
    __read: $2d82d33a11c2a1d9$export$8d051b38c9118094,
    __spread: $2d82d33a11c2a1d9$export$afc72e2116322959,
    __spreadArrays: $2d82d33a11c2a1d9$export$6388937ca91ccae8,
    __spreadArray: $2d82d33a11c2a1d9$export$1216008129fb82ed,
    __await: $2d82d33a11c2a1d9$export$10c90e4f7922046c,
    __asyncGenerator: $2d82d33a11c2a1d9$export$e427f37a30a4de9b,
    __asyncDelegator: $2d82d33a11c2a1d9$export$bbd80228419bb833,
    __asyncValues: $2d82d33a11c2a1d9$export$e3b29a3d6162315f,
    __makeTemplateObject: $2d82d33a11c2a1d9$export$4fb47efe1390b86f,
    __importStar: $2d82d33a11c2a1d9$export$c21735bcef00d192,
    __importDefault: $2d82d33a11c2a1d9$export$da59b14a69baef04,
    __classPrivateFieldGet: $2d82d33a11c2a1d9$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $2d82d33a11c2a1d9$export$d40a35129aaff81f,
    __classPrivateFieldIn: $2d82d33a11c2a1d9$export$81fdc39f203e4e04,
    __addDisposableResource: $2d82d33a11c2a1d9$export$88ac25d8e944e405,
    __disposeResources: $2d82d33a11c2a1d9$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $2d82d33a11c2a1d9$export$889dfb5d17574b0b
};

});

parcelRegister("7kiUr", function(module, exports) {
$parcel$export(module.exports, "ApolloLink", () => ApolloLink);
$parcel$export(module.exports, "execute", () => execute);
$parcel$export(module.exports, "Observable", () => (parcelRequire("jdQxa")).default);

var $jdQxa = parcelRequire("jdQxa");

var $jptQV = parcelRequire("jptQV");

var $3UfL2 = parcelRequire("3UfL2");

var $gODea = parcelRequire("gODea");
function validateOperation(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context'
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw new (0, $jptQV.InvariantError)(2);
    }
    return operation;
}
var LinkError = function(_super) {
    (0, $3UfL2.__extends)(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error);
function isTerminating(link) {
    return link.request.length <= 1;
}
function toPromise(observable) {
    var completed = false;
    return new Promise(function(resolve, reject) {
        observable.subscribe({
            next: function(data) {
                if (completed) ;
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject
        });
    });
}
var makePromise = toPromise;
function fromPromise(promise) {
    return new (0, $jdQxa.default)(function(observer) {
        promise.then(function(value) {
            observer.next(value);
            observer.complete();
        }).catch(observer.error.bind(observer));
    });
}
function fromError(errorValue) {
    return new (0, $jdQxa.default)(function(observer) {
        observer.error(errorValue);
    });
}
function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== 'string' ? (0, $gODea.getOperationName)(transformedOperation.query) : '';
    return transformedOperation;
}
function createOperation(starting, operation) {
    var context = (0, $3UfL2.__assign)({}, starting);
    var setContext = function(next) {
        if (typeof next === 'function') context = (0, $3UfL2.__assign)({}, context, next(context));
        else context = (0, $3UfL2.__assign)({}, context, next);
    };
    var getContext = function() {
        return (0, $3UfL2.__assign)({}, context);
    };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext
    });
    Object.defineProperty(operation, 'toKey', {
        enumerable: false,
        value: function() {
            return getKey(operation);
        }
    });
    return operation;
}
function getKey(operation) {
    var query = operation.query, variables = operation.variables, operationName = operation.operationName;
    return JSON.stringify([
        operationName,
        query,
        variables
    ]);
}
function passthrough(op, forward) {
    return forward ? forward(op) : (0, $jdQxa.default).of();
}
function toLink(handler) {
    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
}
function empty() {
    return new ApolloLink(function() {
        return (0, $jdQxa.default).of();
    });
}
function from(links) {
    if (links.length === 0) return empty();
    return links.map(toLink).reduce(function(x, y) {
        return x.concat(y);
    });
}
function split(test, left, right) {
    var leftLink = toLink(left);
    var rightLink = toLink(right || new ApolloLink(passthrough));
    if (isTerminating(leftLink) && isTerminating(rightLink)) return new ApolloLink(function(operation) {
        return test(operation) ? leftLink.request(operation) || (0, $jdQxa.default).of() : rightLink.request(operation) || (0, $jdQxa.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return test(operation) ? leftLink.request(operation, forward) || (0, $jdQxa.default).of() : rightLink.request(operation, forward) || (0, $jdQxa.default).of();
    });
}
var concat = function(first, second) {
    var firstLink = toLink(first);
    if (isTerminating(firstLink)) return firstLink;
    var nextLink = toLink(second);
    if (isTerminating(nextLink)) return new ApolloLink(function(operation) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op) || (0, $jdQxa.default).of();
        }) || (0, $jdQxa.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op, forward) || (0, $jdQxa.default).of();
        }) || (0, $jdQxa.default).of();
    });
};
var ApolloLink = function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat(split(test, left, right || new ApolloLink(passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw new (0, $jptQV.InvariantError)(1);
    };
    ApolloLink.empty = empty;
    ApolloLink.from = from;
    ApolloLink.split = split;
    ApolloLink.execute = execute;
    return ApolloLink;
}();
function execute(link, operation) {
    return link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || (0, $jdQxa.default).of();
}

});
parcelRegister("jdQxa", function(module, exports) {
$parcel$export(module.exports, "default", () => $dfe7fb5822c44b62$export$2e2bcd8739ae039);

var $lzA31 = parcelRequire("lzA31");
var $dfe7fb5822c44b62$export$77cea355fa80b5f4 = (0, (/*@__PURE__*/$parcel$interopDefault($lzA31)));
var $dfe7fb5822c44b62$export$2e2bcd8739ae039 = $dfe7fb5822c44b62$export$77cea355fa80b5f4;

});
parcelRegister("lzA31", function(module, exports) {

module.exports = (parcelRequire("c5qkI")).Observable;

});
parcelRegister("c5qkI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Observable = void 0;
function $8cca60dd3e466a21$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8cca60dd3e466a21$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $8cca60dd3e466a21$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $8cca60dd3e466a21$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $8cca60dd3e466a21$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
// === Symbol Support ===
var $8cca60dd3e466a21$var$hasSymbols = function() {
    return typeof Symbol === 'function';
};
var $8cca60dd3e466a21$var$hasSymbol = function(name) {
    return $8cca60dd3e466a21$var$hasSymbols() && Boolean(Symbol[name]);
};
var $8cca60dd3e466a21$var$getSymbol = function(name) {
    return $8cca60dd3e466a21$var$hasSymbol(name) ? Symbol[name] : '@@' + name;
};
if ($8cca60dd3e466a21$var$hasSymbols() && !$8cca60dd3e466a21$var$hasSymbol('observable')) Symbol.observable = Symbol('observable');
var $8cca60dd3e466a21$var$SymbolIterator = $8cca60dd3e466a21$var$getSymbol('iterator');
var $8cca60dd3e466a21$var$SymbolObservable = $8cca60dd3e466a21$var$getSymbol('observable');
var $8cca60dd3e466a21$var$SymbolSpecies = $8cca60dd3e466a21$var$getSymbol('species'); // === Abstract Operations ===
function $8cca60dd3e466a21$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
    return value;
}
function $8cca60dd3e466a21$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$8cca60dd3e466a21$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $8cca60dd3e466a21$var$Observable;
}
function $8cca60dd3e466a21$var$isObservable(x) {
    return x instanceof $8cca60dd3e466a21$var$Observable; // SPEC: Brand check
}
function $8cca60dd3e466a21$var$hostReportError(e) {
    if ($8cca60dd3e466a21$var$hostReportError.log) $8cca60dd3e466a21$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $8cca60dd3e466a21$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $8cca60dd3e466a21$var$hostReportError(e);
        }
    });
}
function $8cca60dd3e466a21$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === 'function') cleanup();
        else {
            var unsubscribe = $8cca60dd3e466a21$var$getMethod(cleanup, 'unsubscribe');
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $8cca60dd3e466a21$var$hostReportError(e);
    }
}
function $8cca60dd3e466a21$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = 'closed';
}
function $8cca60dd3e466a21$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = 'ready';
    for(var i = 0; i < queue.length; ++i){
        $8cca60dd3e466a21$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === 'closed') break;
    }
}
function $8cca60dd3e466a21$var$notifySubscription(subscription, type, value) {
    subscription._state = 'running';
    var observer = subscription._observer;
    try {
        var m = $8cca60dd3e466a21$var$getMethod(observer, type);
        switch(type){
            case 'next':
                if (m) m.call(observer, value);
                break;
            case 'error':
                $8cca60dd3e466a21$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case 'complete':
                $8cca60dd3e466a21$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $8cca60dd3e466a21$var$hostReportError(e);
    }
    if (subscription._state === 'closed') $8cca60dd3e466a21$var$cleanupSubscription(subscription);
    else if (subscription._state === 'running') subscription._state = 'ready';
}
function $8cca60dd3e466a21$var$onNotify(subscription, type, value) {
    if (subscription._state === 'closed') return;
    if (subscription._state === 'buffering') {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== 'ready') {
        subscription._state = 'buffering';
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $8cca60dd3e466a21$var$enqueue(function() {
            return $8cca60dd3e466a21$var$flushSubscription(subscription);
        });
        return;
    }
    $8cca60dd3e466a21$var$notifySubscription(subscription, type, value);
}
var $8cca60dd3e466a21$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        $8cca60dd3e466a21$var$_classCallCheck(this, Subscription);
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = 'initializing';
        var subscriptionObserver = new $8cca60dd3e466a21$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === 'initializing') this._state = 'ready';
    }
    $8cca60dd3e466a21$var$_createClass(Subscription, [
        {
            key: "unsubscribe",
            value: function unsubscribe() {
                if (this._state !== 'closed') {
                    $8cca60dd3e466a21$var$closeSubscription(this);
                    $8cca60dd3e466a21$var$cleanupSubscription(this);
                }
            }
        },
        {
            key: "closed",
            get: function() {
                return this._state === 'closed';
            }
        }
    ]);
    return Subscription;
}();
var $8cca60dd3e466a21$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        $8cca60dd3e466a21$var$_classCallCheck(this, SubscriptionObserver);
        this._subscription = subscription;
    }
    $8cca60dd3e466a21$var$_createClass(SubscriptionObserver, [
        {
            key: "next",
            value: function next(value) {
                $8cca60dd3e466a21$var$onNotify(this._subscription, 'next', value);
            }
        },
        {
            key: "error",
            value: function error(value) {
                $8cca60dd3e466a21$var$onNotify(this._subscription, 'error', value);
            }
        },
        {
            key: "complete",
            value: function complete() {
                $8cca60dd3e466a21$var$onNotify(this._subscription, 'complete');
            }
        },
        {
            key: "closed",
            get: function() {
                return this._subscription._state === 'closed';
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $8cca60dd3e466a21$var$Observable = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        $8cca60dd3e466a21$var$_classCallCheck(this, Observable);
        if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
        if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
        this._subscriber = subscriber;
    }
    $8cca60dd3e466a21$var$_createClass(Observable, [
        {
            key: "subscribe",
            value: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) observer = {
                    next: observer,
                    error: arguments[1],
                    complete: arguments[2]
                };
                return new $8cca60dd3e466a21$var$Subscription(observer, this._subscriber);
            }
        },
        {
            key: "forEach",
            value: function forEach(fn) {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (typeof fn !== 'function') {
                        reject(new TypeError(fn + ' is not a function'));
                        return;
                    }
                    function done() {
                        subscription.unsubscribe();
                        resolve();
                    }
                    var subscription = _this.subscribe({
                        next: function(value) {
                            try {
                                fn(value, done);
                            } catch (e) {
                                reject(e);
                                subscription.unsubscribe();
                            }
                        },
                        error: reject,
                        complete: resolve
                    });
                });
            }
        },
        {
            key: "map",
            value: function map(fn) {
                var _this2 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $8cca60dd3e466a21$var$getSpecies(this);
                return new C(function(observer) {
                    return _this2.subscribe({
                        next: function(value) {
                            try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "filter",
            value: function filter(fn) {
                var _this3 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $8cca60dd3e466a21$var$getSpecies(this);
                return new C(function(observer) {
                    return _this3.subscribe({
                        next: function(value) {
                            try {
                                if (!fn(value)) return;
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "reduce",
            value: function reduce(fn) {
                var _this4 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $8cca60dd3e466a21$var$getSpecies(this);
                var hasSeed = arguments.length > 1;
                var hasValue = false;
                var seed = arguments[1];
                var acc = seed;
                return new C(function(observer) {
                    return _this4.subscribe({
                        next: function(value) {
                            var first = !hasValue;
                            hasValue = true;
                            if (!first || hasSeed) try {
                                acc = fn(acc, value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            else acc = value;
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                            observer.next(acc);
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "concat",
            value: function concat() {
                var _this5 = this;
                for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
                var C = $8cca60dd3e466a21$var$getSpecies(this);
                return new C(function(observer) {
                    var subscription;
                    var index = 0;
                    function startNext(next) {
                        subscription = next.subscribe({
                            next: function(v) {
                                observer.next(v);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                if (index === sources.length) {
                                    subscription = undefined;
                                    observer.complete();
                                } else startNext(C.from(sources[index++]));
                            }
                        });
                    }
                    startNext(_this5);
                    return function() {
                        if (subscription) {
                            subscription.unsubscribe();
                            subscription = undefined;
                        }
                    };
                });
            }
        },
        {
            key: "flatMap",
            value: function flatMap(fn) {
                var _this6 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $8cca60dd3e466a21$var$getSpecies(this);
                return new C(function(observer) {
                    var subscriptions = [];
                    var outer = _this6.subscribe({
                        next: function(value) {
                            if (fn) try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            var inner = C.from(value).subscribe({
                                next: function(value) {
                                    observer.next(value);
                                },
                                error: function(e) {
                                    observer.error(e);
                                },
                                complete: function() {
                                    var i = subscriptions.indexOf(inner);
                                    if (i >= 0) subscriptions.splice(i, 1);
                                    completeIfDone();
                                }
                            });
                            subscriptions.push(inner);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            completeIfDone();
                        }
                    });
                    function completeIfDone() {
                        if (outer.closed && subscriptions.length === 0) observer.complete();
                    }
                    return function() {
                        subscriptions.forEach(function(s) {
                            return s.unsubscribe();
                        });
                        outer.unsubscribe();
                    };
                });
            }
        },
        {
            key: $8cca60dd3e466a21$var$SymbolObservable,
            value: function() {
                return this;
            }
        }
    ], [
        {
            key: "from",
            value: function from(x) {
                var C = typeof this === 'function' ? this : Observable;
                if (x == null) throw new TypeError(x + ' is not an object');
                var method = $8cca60dd3e466a21$var$getMethod(x, $8cca60dd3e466a21$var$SymbolObservable);
                if (method) {
                    var observable = method.call(x);
                    if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
                    if ($8cca60dd3e466a21$var$isObservable(observable) && observable.constructor === C) return observable;
                    return new C(function(observer) {
                        return observable.subscribe(observer);
                    });
                }
                if ($8cca60dd3e466a21$var$hasSymbol('iterator')) {
                    method = $8cca60dd3e466a21$var$getMethod(x, $8cca60dd3e466a21$var$SymbolIterator);
                    if (method) return new C(function(observer) {
                        $8cca60dd3e466a21$var$enqueue(function() {
                            if (observer.closed) return;
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;
                            try {
                                for(var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _item = _step.value;
                                    observer.next(_item);
                                    if (observer.closed) return;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
                                } finally{
                                    if (_didIteratorError) throw _iteratorError;
                                }
                            }
                            observer.complete();
                        });
                    });
                }
                if (Array.isArray(x)) return new C(function(observer) {
                    $8cca60dd3e466a21$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < x.length; ++i){
                            observer.next(x[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
                throw new TypeError(x + ' is not observable');
            }
        },
        {
            key: "of",
            value: function of() {
                for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
                var C = typeof this === 'function' ? this : Observable;
                return new C(function(observer) {
                    $8cca60dd3e466a21$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < items.length; ++i){
                            observer.next(items[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
            }
        },
        {
            key: $8cca60dd3e466a21$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
module.exports.Observable = $8cca60dd3e466a21$var$Observable;
if ($8cca60dd3e466a21$var$hasSymbols()) Object.defineProperty($8cca60dd3e466a21$var$Observable, Symbol('extensions'), {
    value: {
        symbol: $8cca60dd3e466a21$var$SymbolObservable,
        hostReportError: $8cca60dd3e466a21$var$hostReportError
    },
    configurable: true
});

});



parcelRegister("jptQV", function(module, exports) {
$parcel$export(module.exports, "InvariantError", () => $e2178241d3abf639$export$cea12affaee22fe8);

var $3UfL2 = parcelRequire("3UfL2");

var $1CHRc = parcelRequire("1CHRc");
var $e2178241d3abf639$var$genericMessage = "Invariant Violation";
var $e2178241d3abf639$var$_a = Object.setPrototypeOf, $e2178241d3abf639$var$setPrototypeOf = $e2178241d3abf639$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $e2178241d3abf639$var$_a;
var $e2178241d3abf639$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $3UfL2.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $e2178241d3abf639$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $e2178241d3abf639$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $e2178241d3abf639$var$genericMessage;
        $e2178241d3abf639$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $e2178241d3abf639$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $e2178241d3abf639$export$cea12affaee22fe8(message);
}
function $e2178241d3abf639$var$wrapConsoleMethod(method) {
    return function() {
        return console[method].apply(console, arguments);
    };
}
(function(invariant) {
    invariant.warn = $e2178241d3abf639$var$wrapConsoleMethod("warn");
    invariant.error = $e2178241d3abf639$var$wrapConsoleMethod("error");
})($e2178241d3abf639$export$f5708dca728d7177 || ($e2178241d3abf639$export$f5708dca728d7177 = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var $e2178241d3abf639$export$e54fe5b0f43758f7 = {
    env: {}
};
if (typeof $1CHRc === "object") $e2178241d3abf639$export$e54fe5b0f43758f7 = $1CHRc;
else try {
    // Using Function to evaluate this assignment in global scope also escapes
    // the strict mode of the current module, thereby allowing the assignment.
    // Inspired by https://github.com/facebook/regenerator/pull/369.
    Function("stub", "process = stub")($e2178241d3abf639$export$e54fe5b0f43758f7);
} catch (atLeastWeTried) {
// The assignment can fail if a Content Security Policy heavy-handedly
// forbids Function usage. In those environments, developers should take
// extra care to replace process.env.NODE_ENV in their production builds,
// or define an appropriate global.process polyfill.
}
var $e2178241d3abf639$var$invariant$1 = $e2178241d3abf639$export$f5708dca728d7177;
var $e2178241d3abf639$export$2e2bcd8739ae039 = $e2178241d3abf639$var$invariant$1;

});

parcelRegister("gODea", function(module, exports) {
$parcel$export(module.exports, "argumentsObjectFromField", () => $c3dfbe9d28391fa8$export$3f5a60fb6a781b4f);
$parcel$export(module.exports, "resultKeyNameFromField", () => $c3dfbe9d28391fa8$export$7d1ad22471852218);
$parcel$export(module.exports, "isField", () => $c3dfbe9d28391fa8$export$fb56ad75dd311c12);
$parcel$export(module.exports, "isInlineFragment", () => $c3dfbe9d28391fa8$export$22a1cdafaf27bcff);
$parcel$export(module.exports, "shouldInclude", () => $c3dfbe9d28391fa8$export$3dc388a5f013b4a5);
$parcel$export(module.exports, "hasDirectives", () => $c3dfbe9d28391fa8$export$2dafb573e282fe8d);
$parcel$export(module.exports, "hasClientExports", () => $c3dfbe9d28391fa8$export$8d1e9e5bbfa5d09a);
$parcel$export(module.exports, "getOperationDefinition", () => $c3dfbe9d28391fa8$export$7a5b1fa979d2c158);
$parcel$export(module.exports, "getOperationName", () => $c3dfbe9d28391fa8$export$41bca9dc6871dd4e);
$parcel$export(module.exports, "getFragmentDefinitions", () => $c3dfbe9d28391fa8$export$5320a7ba9466a3df);
$parcel$export(module.exports, "getMainDefinition", () => $c3dfbe9d28391fa8$export$f431198736b7f96d);
$parcel$export(module.exports, "createFragmentMap", () => $c3dfbe9d28391fa8$export$193789b4c8246dd4);
$parcel$export(module.exports, "getDefaultValues", () => $c3dfbe9d28391fa8$export$84c19026e616569e);
$parcel$export(module.exports, "removeConnectionDirectiveFromDocument", () => $c3dfbe9d28391fa8$export$74985f3324559867);
$parcel$export(module.exports, "buildQueryFromSelectionSet", () => $c3dfbe9d28391fa8$export$57c368c23873f32b);
$parcel$export(module.exports, "removeClientSetsFromDocument", () => $c3dfbe9d28391fa8$export$8eae69e876ee321e);
$parcel$export(module.exports, "canUseWeakMap", () => $c3dfbe9d28391fa8$export$772fbc04a0ad4ce9);
$parcel$export(module.exports, "cloneDeep", () => $c3dfbe9d28391fa8$export$629a2bd3f5a49ecc);
$parcel$export(module.exports, "tryFunctionOrLogError", () => $c3dfbe9d28391fa8$export$50a91acae4904909);
$parcel$export(module.exports, "graphQLResultHasError", () => $c3dfbe9d28391fa8$export$b4df399e879e53ab);
$parcel$export(module.exports, "mergeDeep", () => $c3dfbe9d28391fa8$export$dd702b3c8240390c);
$parcel$export(module.exports, "mergeDeepArray", () => $c3dfbe9d28391fa8$export$160070228be94b08);

var $dUQHG = parcelRequire("dUQHG");

var $3GB3B = parcelRequire("3GB3B");

var $3UfL2 = parcelRequire("3UfL2");

var $inWvg = parcelRequire("inWvg");

var $99WkW = parcelRequire("99WkW");

var $1CHRc = parcelRequire("1CHRc");
function $c3dfbe9d28391fa8$export$dc071f102752d0eb(value) {
    return [
        'StringValue',
        'BooleanValue',
        'EnumValue'
    ].indexOf(value.kind) > -1;
}
function $c3dfbe9d28391fa8$export$3ff5e9927c3257c6(value) {
    return [
        'IntValue',
        'FloatValue'
    ].indexOf(value.kind) > -1;
}
function $c3dfbe9d28391fa8$var$isStringValue(value) {
    return value.kind === 'StringValue';
}
function $c3dfbe9d28391fa8$var$isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function $c3dfbe9d28391fa8$var$isIntValue(value) {
    return value.kind === 'IntValue';
}
function $c3dfbe9d28391fa8$var$isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function $c3dfbe9d28391fa8$var$isVariable(value) {
    return value.kind === 'Variable';
}
function $c3dfbe9d28391fa8$var$isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function $c3dfbe9d28391fa8$var$isListValue(value) {
    return value.kind === 'ListValue';
}
function $c3dfbe9d28391fa8$var$isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function $c3dfbe9d28391fa8$var$isNullValue(value) {
    return value.kind === 'NullValue';
}
function $c3dfbe9d28391fa8$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($c3dfbe9d28391fa8$var$isIntValue(value) || $c3dfbe9d28391fa8$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($c3dfbe9d28391fa8$var$isBooleanValue(value) || $c3dfbe9d28391fa8$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($c3dfbe9d28391fa8$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $c3dfbe9d28391fa8$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($c3dfbe9d28391fa8$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($c3dfbe9d28391fa8$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $c3dfbe9d28391fa8$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($c3dfbe9d28391fa8$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($c3dfbe9d28391fa8$var$isNullValue(value)) argObj[name.value] = null;
    else throw new (0, $3GB3B.InvariantError)(17);
}
function $c3dfbe9d28391fa8$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $c3dfbe9d28391fa8$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $c3dfbe9d28391fa8$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $c3dfbe9d28391fa8$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $c3dfbe9d28391fa8$var$KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export'
];
function $c3dfbe9d28391fa8$export$3cdb6c178b88cabe(fieldName, args, directives) {
    if (directives && directives['connection'] && directives['connection']['key']) {
        if (directives['connection']['filter'] && directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter'] ? directives['connection']['filter'] : [];
            filterKeys.sort();
            var queryArgs_1 = args;
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = queryArgs_1[key];
            });
            return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
        } else return directives['connection']['key'];
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = (0, (/*@__PURE__*/$parcel$interopDefault($inWvg)))(args);
        completeFieldName += "(" + stringifiedArgs + ")";
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($c3dfbe9d28391fa8$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
        else completeFieldName += "@" + key;
    });
    return completeFieldName;
}
function $c3dfbe9d28391fa8$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $c3dfbe9d28391fa8$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $c3dfbe9d28391fa8$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $c3dfbe9d28391fa8$export$fb56ad75dd311c12(selection) {
    return selection.kind === 'Field';
}
function $c3dfbe9d28391fa8$export$22a1cdafaf27bcff(selection) {
    return selection.kind === 'InlineFragment';
}
function $c3dfbe9d28391fa8$export$e33b89a9aa87695(idObject) {
    return idObject && idObject.type === 'id' && typeof idObject.generated === 'boolean';
}
function $c3dfbe9d28391fa8$export$b124f125e34d720a(idConfig, generated) {
    if (generated === void 0) generated = false;
    return (0, $3UfL2.__assign)({
        type: 'id',
        generated: generated
    }, typeof idConfig === 'string' ? {
        id: idConfig,
        typename: undefined
    } : idConfig);
}
function $c3dfbe9d28391fa8$export$226c1c6d1a5b660a(jsonObject) {
    return jsonObject != null && typeof jsonObject === 'object' && jsonObject.type === 'json';
}
function $c3dfbe9d28391fa8$var$defaultValueFromVariable(node) {
    throw new (0, $3GB3B.InvariantError)(18);
}
function $c3dfbe9d28391fa8$export$b3db129ed867b445(node, onVariable) {
    if (onVariable === void 0) onVariable = $c3dfbe9d28391fa8$var$defaultValueFromVariable;
    switch(node.kind){
        case 'Variable':
            return onVariable(node);
        case 'NullValue':
            return null;
        case 'IntValue':
            return parseInt(node.value, 10);
        case 'FloatValue':
            return parseFloat(node.value);
        case 'ListValue':
            return node.values.map(function(v) {
                return $c3dfbe9d28391fa8$export$b3db129ed867b445(v, onVariable);
            });
        case 'ObjectValue':
            var value = {};
            for(var _i = 0, _a = node.fields; _i < _a.length; _i++){
                var field = _a[_i];
                value[field.name.value] = $c3dfbe9d28391fa8$export$b3db129ed867b445(field.value, onVariable);
            }
            return value;
        default:
            return node.value;
    }
}
function $c3dfbe9d28391fa8$export$2a7f471142984a91(field, variables) {
    if (field.directives && field.directives.length) {
        var directiveObj_1 = {};
        field.directives.forEach(function(directive) {
            directiveObj_1[directive.name.value] = $c3dfbe9d28391fa8$export$3f5a60fb6a781b4f(directive, variables);
        });
        return directiveObj_1;
    }
    return null;
}
function $c3dfbe9d28391fa8$export$3dc388a5f013b4a5(selection, variables) {
    if (variables === void 0) variables = {};
    return $c3dfbe9d28391fa8$export$b7bdffb7e6f1ef53(selection.directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === 'Variable') {
            evaledValue = variables[ifArgument.value.name.value];
            (0, $3GB3B.invariant)(evaledValue !== void 0, 13);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === 'skip' ? !evaledValue : evaledValue;
    });
}
function $c3dfbe9d28391fa8$export$1b217de6ce18b9a(doc) {
    var names = [];
    (0, $dUQHG.visit)(doc, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
function $c3dfbe9d28391fa8$export$2dafb573e282fe8d(names, doc) {
    return $c3dfbe9d28391fa8$export$1b217de6ce18b9a(doc).some(function(name) {
        return names.indexOf(name) > -1;
    });
}
function $c3dfbe9d28391fa8$export$8d1e9e5bbfa5d09a(document) {
    return document && $c3dfbe9d28391fa8$export$2dafb573e282fe8d([
        'client'
    ], document) && $c3dfbe9d28391fa8$export$2dafb573e282fe8d([
        'export'
    ], document);
}
function $c3dfbe9d28391fa8$var$isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === 'skip' || value === 'include';
}
function $c3dfbe9d28391fa8$export$b7bdffb7e6f1ef53(directives) {
    return directives ? directives.filter($c3dfbe9d28391fa8$var$isInclusionDirective).map(function(directive) {
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        (0, $3GB3B.invariant)(directiveArguments && directiveArguments.length === 1, 14);
        var ifArgument = directiveArguments[0];
        (0, $3GB3B.invariant)(ifArgument.name && ifArgument.name.value === 'if', 15);
        var ifValue = ifArgument.value;
        (0, $3GB3B.invariant)(ifValue && (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 16);
        return {
            directive: directive,
            ifArgument: ifArgument
        };
    }) : [];
}
function $c3dfbe9d28391fa8$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function(definition) {
        if (definition.kind === 'OperationDefinition') throw new (0, $3GB3B.InvariantError)(11);
        if (definition.kind === 'FragmentDefinition') fragments.push(definition);
    });
    if (typeof actualFragmentName === 'undefined') {
        (0, $3GB3B.invariant)(fragments.length === 1, 12);
        actualFragmentName = fragments[0].name.value;
    }
    var query = (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, document), {
        definitions: (0, $3UfL2.__spreadArrays)([
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions)
    });
    return query;
}
function $c3dfbe9d28391fa8$export$e6e34fd1f2686227(target) {
    var sources = [];
    for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
    sources.forEach(function(source) {
        if (typeof source === 'undefined' || source === null) return;
        Object.keys(source).forEach(function(key) {
            target[key] = source[key];
        });
    });
    return target;
}
function $c3dfbe9d28391fa8$export$a92e7a440b22bdf0(doc) {
    $c3dfbe9d28391fa8$export$a7d0d8111d2386df(doc);
    var mutationDef = doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.operation === 'mutation';
    })[0];
    (0, $3GB3B.invariant)(mutationDef, 1);
    return mutationDef;
}
function $c3dfbe9d28391fa8$export$a7d0d8111d2386df(doc) {
    (0, $3GB3B.invariant)(doc && doc.kind === 'Document', 2);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== 'FragmentDefinition';
    }).map(function(definition) {
        if (definition.kind !== 'OperationDefinition') throw new (0, $3GB3B.InvariantError)(3);
        return definition;
    });
    (0, $3GB3B.invariant)(operations.length <= 1, 4);
    return doc;
}
function $c3dfbe9d28391fa8$export$7a5b1fa979d2c158(doc) {
    $c3dfbe9d28391fa8$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition';
    })[0];
}
function $c3dfbe9d28391fa8$export$78a8e95d8d43ad7f(document) {
    var def = $c3dfbe9d28391fa8$export$7a5b1fa979d2c158(document);
    (0, $3GB3B.invariant)(def, 5);
    return def;
}
function $c3dfbe9d28391fa8$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $c3dfbe9d28391fa8$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'FragmentDefinition';
    });
}
function $c3dfbe9d28391fa8$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $c3dfbe9d28391fa8$export$7a5b1fa979d2c158(doc);
    (0, $3GB3B.invariant)(queryDef && queryDef.operation === 'query', 6);
    return queryDef;
}
function $c3dfbe9d28391fa8$export$772111caef41b3f5(doc) {
    (0, $3GB3B.invariant)(doc.kind === 'Document', 7);
    (0, $3GB3B.invariant)(doc.definitions.length <= 1, 8);
    var fragmentDef = doc.definitions[0];
    (0, $3GB3B.invariant)(fragmentDef.kind === 'FragmentDefinition', 9);
    return fragmentDef;
}
function $c3dfbe9d28391fa8$export$f431198736b7f96d(queryDoc) {
    $c3dfbe9d28391fa8$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' || operation === 'mutation' || operation === 'subscription') return definition;
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw new (0, $3GB3B.InvariantError)(10);
}
function $c3dfbe9d28391fa8$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $c3dfbe9d28391fa8$export$84c19026e616569e(definition) {
    if (definition && definition.variableDefinitions && definition.variableDefinitions.length) {
        var defaultValues = definition.variableDefinitions.filter(function(_a) {
            var defaultValue = _a.defaultValue;
            return defaultValue;
        }).map(function(_a) {
            var variable = _a.variable, defaultValue = _a.defaultValue;
            var defaultValueObj = {};
            $c3dfbe9d28391fa8$export$a1dab82d368d6525(defaultValueObj, variable.name, defaultValue);
            return defaultValueObj;
        });
        return $c3dfbe9d28391fa8$export$e6e34fd1f2686227.apply(void 0, (0, $3UfL2.__spreadArrays)([
            {}
        ], defaultValues));
    }
    return {};
}
function $c3dfbe9d28391fa8$export$55ead6c9e4eac970(operation) {
    var names = new Set();
    if (operation.variableDefinitions) for(var _i = 0, _a = operation.variableDefinitions; _i < _a.length; _i++){
        var definition = _a[_i];
        names.add(definition.variable.name.value);
    }
    return names;
}
function $c3dfbe9d28391fa8$var$filterInPlace(array, test, context) {
    var target = 0;
    array.forEach(function(elem, i) {
        if (test.call(this, elem, i, array)) array[target++] = elem;
    }, context);
    array.length = target;
    return array;
}
var $c3dfbe9d28391fa8$var$TYPENAME_FIELD = {
    kind: 'Field',
    name: {
        kind: 'Name',
        value: '__typename'
    }
};
function $c3dfbe9d28391fa8$var$isEmpty(op, fragments) {
    return op.selectionSet.selections.every(function(selection) {
        return selection.kind === 'FragmentSpread' && $c3dfbe9d28391fa8$var$isEmpty(fragments[selection.name.value], fragments);
    });
}
function $c3dfbe9d28391fa8$var$nullIfDocIsEmpty(doc) {
    return $c3dfbe9d28391fa8$var$isEmpty($c3dfbe9d28391fa8$export$7a5b1fa979d2c158(doc) || $c3dfbe9d28391fa8$export$772111caef41b3f5(doc), $c3dfbe9d28391fa8$export$193789b4c8246dd4($c3dfbe9d28391fa8$export$5320a7ba9466a3df(doc))) ? null : doc;
}
function $c3dfbe9d28391fa8$var$getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function(dir) {
            return dir.name && dir.name === directive.name.value || dir.test && dir.test(directive);
        });
    };
}
function $c3dfbe9d28391fa8$export$e5ae0530da5fe96c(directives, doc) {
    var variablesInUse = Object.create(null);
    var variablesToRemove = [];
    var fragmentSpreadsInUse = Object.create(null);
    var fragmentSpreadsToRemove = [];
    var modifiedDoc = $c3dfbe9d28391fa8$var$nullIfDocIsEmpty((0, $dUQHG.visit)(doc, {
        Variable: {
            enter: function(node, _key, parent) {
                if (parent.kind !== 'VariableDefinition') variablesInUse[node.name.value] = true;
            }
        },
        Field: {
            enter: function(node) {
                if (directives && node.directives) {
                    var shouldRemoveField = directives.some(function(directive) {
                        return directive.remove;
                    });
                    if (shouldRemoveField && node.directives && node.directives.some($c3dfbe9d28391fa8$var$getDirectiveMatcher(directives))) {
                        if (node.arguments) node.arguments.forEach(function(arg) {
                            if (arg.value.kind === 'Variable') variablesToRemove.push({
                                name: arg.value.name.value
                            });
                        });
                        if (node.selectionSet) $c3dfbe9d28391fa8$var$getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function(frag) {
                            fragmentSpreadsToRemove.push({
                                name: frag.name.value
                            });
                        });
                        return null;
                    }
                }
            }
        },
        FragmentSpread: {
            enter: function(node) {
                fragmentSpreadsInUse[node.name.value] = true;
            }
        },
        Directive: {
            enter: function(node) {
                if ($c3dfbe9d28391fa8$var$getDirectiveMatcher(directives)(node)) return null;
            }
        }
    }));
    if (modifiedDoc && $c3dfbe9d28391fa8$var$filterInPlace(variablesToRemove, function(v) {
        return !variablesInUse[v.name];
    }).length) modifiedDoc = $c3dfbe9d28391fa8$export$ecd5bb739c4a8b38(variablesToRemove, modifiedDoc);
    if (modifiedDoc && $c3dfbe9d28391fa8$var$filterInPlace(fragmentSpreadsToRemove, function(fs) {
        return !fragmentSpreadsInUse[fs.name];
    }).length) modifiedDoc = $c3dfbe9d28391fa8$export$7c9d17c333033c13(fragmentSpreadsToRemove, modifiedDoc);
    return modifiedDoc;
}
function $c3dfbe9d28391fa8$export$43b332f87950a467(doc) {
    return (0, $dUQHG.visit)($c3dfbe9d28391fa8$export$a7d0d8111d2386df(doc), {
        SelectionSet: {
            enter: function(node, _key, parent) {
                if (parent && parent.kind === 'OperationDefinition') return;
                var selections = node.selections;
                if (!selections) return;
                var skip = selections.some(function(selection) {
                    return $c3dfbe9d28391fa8$export$fb56ad75dd311c12(selection) && (selection.name.value === '__typename' || selection.name.value.lastIndexOf('__', 0) === 0);
                });
                if (skip) return;
                var field = parent;
                if ($c3dfbe9d28391fa8$export$fb56ad75dd311c12(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === 'export';
                })) return;
                return (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, node), {
                    selections: (0, $3UfL2.__spreadArrays)(selections, [
                        $c3dfbe9d28391fa8$var$TYPENAME_FIELD
                    ])
                });
            }
        }
    });
}
var $c3dfbe9d28391fa8$var$connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) !directive.arguments || directive.arguments.some(function(arg) {
            return arg.name.value === 'key';
        });
        return willRemove;
    }
};
function $c3dfbe9d28391fa8$export$74985f3324559867(doc) {
    return $c3dfbe9d28391fa8$export$e5ae0530da5fe96c([
        $c3dfbe9d28391fa8$var$connectionRemoveConfig
    ], $c3dfbe9d28391fa8$export$a7d0d8111d2386df(doc));
}
function $c3dfbe9d28391fa8$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return $c3dfbe9d28391fa8$var$hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function $c3dfbe9d28391fa8$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!$c3dfbe9d28391fa8$export$fb56ad75dd311c12(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some($c3dfbe9d28391fa8$var$getDirectiveMatcher(directives)) || nestedCheck && $c3dfbe9d28391fa8$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function $c3dfbe9d28391fa8$export$deed3420cb5d2e1d(directives, doc) {
    $c3dfbe9d28391fa8$export$a7d0d8111d2386df(doc);
    var parentPath;
    return $c3dfbe9d28391fa8$var$nullIfDocIsEmpty((0, $dUQHG.visit)(doc, {
        SelectionSet: {
            enter: function(node, _key, _parent, path) {
                var currentPath = path.join('-');
                if (!parentPath || currentPath === parentPath || !currentPath.startsWith(parentPath)) {
                    if (node.selections) {
                        var selectionsWithDirectives = node.selections.filter(function(selection) {
                            return $c3dfbe9d28391fa8$var$hasDirectivesInSelection(directives, selection);
                        });
                        if ($c3dfbe9d28391fa8$var$hasDirectivesInSelectionSet(directives, node, false)) parentPath = currentPath;
                        return (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, node), {
                            selections: selectionsWithDirectives
                        });
                    } else return null;
                }
            }
        }
    }));
}
function $c3dfbe9d28391fa8$var$getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === 'Variable' && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function $c3dfbe9d28391fa8$export$ecd5bb739c4a8b38(config, doc) {
    var argMatcher = $c3dfbe9d28391fa8$var$getArgumentMatcher(config);
    return $c3dfbe9d28391fa8$var$nullIfDocIsEmpty((0, $dUQHG.visit)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, node), {
                    variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    })
                });
            }
        },
        Field: {
            enter: function(node) {
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function $c3dfbe9d28391fa8$export$7c9d17c333033c13(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return $c3dfbe9d28391fa8$var$nullIfDocIsEmpty((0, $dUQHG.visit)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function $c3dfbe9d28391fa8$var$getAllFragmentSpreadsFromSelectionSet(selectionSet) {
    var allFragments = [];
    selectionSet.selections.forEach(function(selection) {
        if (($c3dfbe9d28391fa8$export$fb56ad75dd311c12(selection) || $c3dfbe9d28391fa8$export$22a1cdafaf27bcff(selection)) && selection.selectionSet) $c3dfbe9d28391fa8$var$getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function(frag) {
            return allFragments.push(frag);
        });
        else if (selection.kind === 'FragmentSpread') allFragments.push(selection);
    });
    return allFragments;
}
function $c3dfbe9d28391fa8$export$57c368c23873f32b(document) {
    var definition = $c3dfbe9d28391fa8$export$f431198736b7f96d(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === 'query') return document;
    var modifiedDoc = (0, $dUQHG.visit)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, node), {
                    operation: 'query'
                });
            }
        }
    });
    return modifiedDoc;
}
function $c3dfbe9d28391fa8$export$8eae69e876ee321e(document) {
    $c3dfbe9d28391fa8$export$a7d0d8111d2386df(document);
    var modifiedDoc = $c3dfbe9d28391fa8$export$e5ae0530da5fe96c([
        {
            test: function(directive) {
                return directive.name.value === 'client';
            },
            remove: true
        }
    ], document);
    if (modifiedDoc) modifiedDoc = (0, $dUQHG.visit)(modifiedDoc, {
        FragmentDefinition: {
            enter: function(node) {
                if (node.selectionSet) {
                    var isTypenameOnly = node.selectionSet.selections.every(function(selection) {
                        return $c3dfbe9d28391fa8$export$fb56ad75dd311c12(selection) && selection.name.value === '__typename';
                    });
                    if (isTypenameOnly) return null;
                }
            }
        }
    });
    return modifiedDoc;
}
var $c3dfbe9d28391fa8$export$772fbc04a0ad4ce9 = typeof WeakMap === 'function' && !(typeof navigator === 'object' && navigator.product === 'ReactNative');
var $c3dfbe9d28391fa8$var$toString = Object.prototype.toString;
function $c3dfbe9d28391fa8$export$629a2bd3f5a49ecc(value) {
    return $c3dfbe9d28391fa8$var$cloneDeepHelper(value, new Map());
}
function $c3dfbe9d28391fa8$var$cloneDeepHelper(val, seen) {
    switch($c3dfbe9d28391fa8$var$toString.call(val)){
        case "[object Array]":
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = $c3dfbe9d28391fa8$var$cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            if (seen.has(val)) return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = $c3dfbe9d28391fa8$var$cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}
function $c3dfbe9d28391fa8$export$4bd44a2aa29d3d6e() {
    if (typeof $1CHRc !== 'undefined' && "production") return "production";
    return 'development';
}
function $c3dfbe9d28391fa8$export$f0cb0fda19c18b37(env) {
    return $c3dfbe9d28391fa8$export$4bd44a2aa29d3d6e() === env;
}
function $c3dfbe9d28391fa8$export$f15d00aa73aafac4() {
    return $c3dfbe9d28391fa8$export$f0cb0fda19c18b37('production') === true;
}
function $c3dfbe9d28391fa8$export$df77466336fe5355() {
    return $c3dfbe9d28391fa8$export$f0cb0fda19c18b37('development') === true;
}
function $c3dfbe9d28391fa8$export$410cbc2864fa25b5() {
    return $c3dfbe9d28391fa8$export$f0cb0fda19c18b37('test') === true;
}
function $c3dfbe9d28391fa8$export$50a91acae4904909(f) {
    try {
        return f();
    } catch (e) {
        if (console.error) console.error(e);
    }
}
function $c3dfbe9d28391fa8$export$b4df399e879e53ab(result) {
    return result.errors && result.errors.length;
}
function $c3dfbe9d28391fa8$var$deepFreeze(o) {
    Object.freeze(o);
    Object.getOwnPropertyNames(o).forEach(function(prop) {
        if (o[prop] !== null && (typeof o[prop] === 'object' || typeof o[prop] === 'function') && !Object.isFrozen(o[prop])) $c3dfbe9d28391fa8$var$deepFreeze(o[prop]);
    });
    return o;
}
function $c3dfbe9d28391fa8$export$7f9c177735b71f18(obj) {
    if ($c3dfbe9d28391fa8$export$df77466336fe5355() || $c3dfbe9d28391fa8$export$410cbc2864fa25b5()) {
        var symbolIsPolyfilled = typeof Symbol === 'function' && typeof Symbol('') === 'string';
        if (!symbolIsPolyfilled) return $c3dfbe9d28391fa8$var$deepFreeze(obj);
    }
    return obj;
}
var $c3dfbe9d28391fa8$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $c3dfbe9d28391fa8$export$dd702b3c8240390c() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $c3dfbe9d28391fa8$export$160070228be94b08(sources);
}
function $c3dfbe9d28391fa8$export$160070228be94b08(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var pastCopies = [];
        target = $c3dfbe9d28391fa8$var$shallowCopyForMerge(target, pastCopies);
        for(var i = 1; i < count; ++i)target = $c3dfbe9d28391fa8$var$mergeHelper(target, sources[i], pastCopies);
    }
    return target;
}
function $c3dfbe9d28391fa8$var$isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
function $c3dfbe9d28391fa8$var$mergeHelper(target, source, pastCopies) {
    if ($c3dfbe9d28391fa8$var$isObject(source) && $c3dfbe9d28391fa8$var$isObject(target)) {
        if (Object.isExtensible && !Object.isExtensible(target)) target = $c3dfbe9d28391fa8$var$shallowCopyForMerge(target, pastCopies);
        Object.keys(source).forEach(function(sourceKey) {
            var sourceValue = source[sourceKey];
            if ($c3dfbe9d28391fa8$var$hasOwnProperty.call(target, sourceKey)) {
                var targetValue = target[sourceKey];
                if (sourceValue !== targetValue) target[sourceKey] = $c3dfbe9d28391fa8$var$mergeHelper($c3dfbe9d28391fa8$var$shallowCopyForMerge(targetValue, pastCopies), sourceValue, pastCopies);
            } else target[sourceKey] = sourceValue;
        });
        return target;
    }
    return source;
}
function $c3dfbe9d28391fa8$var$shallowCopyForMerge(value, pastCopies) {
    if (value !== null && typeof value === 'object' && pastCopies.indexOf(value) < 0) {
        if (Array.isArray(value)) value = value.slice(0);
        else value = (0, $3UfL2.__assign)({
            __proto__: Object.getPrototypeOf(value)
        }, value);
        pastCopies.push(value);
    }
    return value;
}
var $c3dfbe9d28391fa8$var$haveWarned = Object.create({});
function $c3dfbe9d28391fa8$export$49d47c8e549bfaf9(msg, type) {
    if (type === void 0) type = 'warn';
    if (!$c3dfbe9d28391fa8$export$f15d00aa73aafac4() && !$c3dfbe9d28391fa8$var$haveWarned[msg]) {
        if (!$c3dfbe9d28391fa8$export$410cbc2864fa25b5()) $c3dfbe9d28391fa8$var$haveWarned[msg] = true;
        if (type === 'error') console.error(msg);
        else console.warn(msg);
    }
}
function $c3dfbe9d28391fa8$export$c54efeba029d4fe8(data) {
    return JSON.parse(JSON.stringify(data));
}

});
parcelRegister("dUQHG", function(module, exports) {
$parcel$export(module.exports, "BREAK", () => $a219632d0fae8d58$export$a89c95c098ac2a58);
$parcel$export(module.exports, "visit", () => $a219632d0fae8d58$export$bf638b60ea8b89b7);

var $hhVFx = parcelRequire("hhVFx");

var $he0fy = parcelRequire("he0fy");
var $a219632d0fae8d58$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        // or removed in the future.
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
var $a219632d0fae8d58$export$a89c95c098ac2a58 = Object.freeze({});
function $a219632d0fae8d58$export$bf638b60ea8b89b7(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $a219632d0fae8d58$export$4fcd777a40ccf407;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++){
                        var k = _Object$keys2[_i2];
                        clone[k] = node[k];
                    }
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!(0, $he0fy.isNode)(node)) throw new Error("Invalid AST Node: ".concat((0, $hhVFx.default)(node), "."));
            var visitFn = $a219632d0fae8d58$export$c9c25cca74db6e70(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === $a219632d0fae8d58$export$a89c95c098ac2a58) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if ((0, $he0fy.isNode)(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _visitorKeys$node$kin;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
function $a219632d0fae8d58$export$728beebeea393478(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (skipping[i] == null) {
                var fn = $a219632d0fae8d58$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === $a219632d0fae8d58$export$a89c95c098ac2a58) skipping[i] = $a219632d0fae8d58$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (skipping[i] == null) {
                    var fn = $a219632d0fae8d58$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === $a219632d0fae8d58$export$a89c95c098ac2a58) skipping[i] = $a219632d0fae8d58$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
function $a219632d0fae8d58$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === 'function') // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === 'function') // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === 'function') // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === 'function') // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}

});
parcelRegister("hhVFx", function(module, exports) {
$parcel$export(module.exports, "default", () => $c960c20dbdaebdf9$export$2e2bcd8739ae039);

var $dGtRh = parcelRequire("dGtRh");
function $c960c20dbdaebdf9$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $c960c20dbdaebdf9$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $c960c20dbdaebdf9$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $c960c20dbdaebdf9$var$_typeof(obj);
}
var $c960c20dbdaebdf9$var$MAX_ARRAY_LENGTH = 10;
var $c960c20dbdaebdf9$var$MAX_RECURSIVE_DEPTH = 2;
function $c960c20dbdaebdf9$export$2e2bcd8739ae039(value) {
    return $c960c20dbdaebdf9$var$formatValue(value, []);
}
function $c960c20dbdaebdf9$var$formatValue(value, seenValues) {
    switch($c960c20dbdaebdf9$var$_typeof(value)){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? "[function ".concat(value.name, "]") : '[function]';
        case 'object':
            if (value === null) return 'null';
            return $c960c20dbdaebdf9$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $c960c20dbdaebdf9$var$formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return '[Circular]';
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = $c960c20dbdaebdf9$var$getCustomFn(value);
    if (customInspectFn !== undefined) {
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === 'string' ? customValue : $c960c20dbdaebdf9$var$formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return $c960c20dbdaebdf9$var$formatArray(value, seenValues);
    return $c960c20dbdaebdf9$var$formatObject(value, seenValues);
}
function $c960c20dbdaebdf9$var$formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return '{}';
    if (seenValues.length > $c960c20dbdaebdf9$var$MAX_RECURSIVE_DEPTH) return '[' + $c960c20dbdaebdf9$var$getObjectTag(object) + ']';
    var properties = keys.map(function(key) {
        var value = $c960c20dbdaebdf9$var$formatValue(object[key], seenValues);
        return key + ': ' + value;
    });
    return '{ ' + properties.join(', ') + ' }';
}
function $c960c20dbdaebdf9$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $c960c20dbdaebdf9$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    var len = Math.min($c960c20dbdaebdf9$var$MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push($c960c20dbdaebdf9$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return '[' + items.join(', ') + ']';
}
function $c960c20dbdaebdf9$var$getCustomFn(object) {
    var customInspectFn = object[String((0, $dGtRh.default))];
    if (typeof customInspectFn === 'function') return customInspectFn;
    if (typeof object.inspect === 'function') return object.inspect;
}
function $c960c20dbdaebdf9$var$getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        var name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}

});
parcelRegister("dGtRh", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f665bdd2b8c73cb$export$2e2bcd8739ae039);
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $9f665bdd2b8c73cb$var$nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
var $9f665bdd2b8c73cb$export$2e2bcd8739ae039 = $9f665bdd2b8c73cb$var$nodejsCustomInspectSymbol;

});


parcelRegister("he0fy", function(module, exports) {
$parcel$export(module.exports, "Location", () => $c8a3f013d02df725$export$18a2be9195644f38);
$parcel$export(module.exports, "Token", () => $c8a3f013d02df725$export$50792b0e93539fde);
$parcel$export(module.exports, "isNode", () => $c8a3f013d02df725$export$8ee0fc9ee280b4ee);

var $lPRBK = parcelRequire("lPRBK");
var $c8a3f013d02df725$export$18a2be9195644f38 = /*#__PURE__*/ function() {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ function Location(startToken, endToken, source) {
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    var _proto = Location.prototype;
    _proto.toJSON = function toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    };
    return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $lPRBK.default)($c8a3f013d02df725$export$18a2be9195644f38);
var $c8a3f013d02df725$export$50792b0e93539fde = /*#__PURE__*/ function() {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ function Token(kind, start, end, line, column, prev, value) {
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column;
        this.value = value;
        this.prev = prev;
        this.next = null;
    }
    var _proto2 = Token.prototype;
    _proto2.toJSON = function toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    };
    return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $lPRBK.default)($c8a3f013d02df725$export$50792b0e93539fde);
function $c8a3f013d02df725$export$8ee0fc9ee280b4ee(maybeNode) {
    return maybeNode != null && typeof maybeNode.kind === 'string';
} /**
 * The list of all possible AST node types.
 */ 

});
parcelRegister("lPRBK", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe57f1c7533a292b$export$2e2bcd8739ae039);

var $glXRC = parcelRequire("glXRC");

var $dGtRh = parcelRequire("dGtRh");
function $fe57f1c7533a292b$export$2e2bcd8739ae039(classObject) {
    var fn = classObject.prototype.toJSON;
    typeof fn === 'function' || (0, $glXRC.default)(0);
    classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')
    if (0, $dGtRh.default) classObject.prototype[0, $dGtRh.default] = fn;
}

});
parcelRegister("glXRC", function(module, exports) {
$parcel$export(module.exports, "default", () => $031288704f5ae293$export$2e2bcd8739ae039);
function $031288704f5ae293$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message != null ? message : 'Unexpected invariant triggered.');
}

});




parcelRegister("3GB3B", function(module, exports) {
$parcel$export(module.exports, "InvariantError", () => $2af20a1dd4295ac2$export$cea12affaee22fe8);
$parcel$export(module.exports, "invariant", () => $2af20a1dd4295ac2$export$f5708dca728d7177);

var $3UfL2 = parcelRequire("3UfL2");

var $1CHRc = parcelRequire("1CHRc");
var $2af20a1dd4295ac2$var$genericMessage = "Invariant Violation";
var $2af20a1dd4295ac2$var$_a = Object.setPrototypeOf, $2af20a1dd4295ac2$var$setPrototypeOf = $2af20a1dd4295ac2$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $2af20a1dd4295ac2$var$_a;
var $2af20a1dd4295ac2$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $3UfL2.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $2af20a1dd4295ac2$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $2af20a1dd4295ac2$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $2af20a1dd4295ac2$var$genericMessage;
        $2af20a1dd4295ac2$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $2af20a1dd4295ac2$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $2af20a1dd4295ac2$export$cea12affaee22fe8(message);
}
function $2af20a1dd4295ac2$var$wrapConsoleMethod(method) {
    return function() {
        return console[method].apply(console, arguments);
    };
}
(function(invariant) {
    invariant.warn = $2af20a1dd4295ac2$var$wrapConsoleMethod("warn");
    invariant.error = $2af20a1dd4295ac2$var$wrapConsoleMethod("error");
})($2af20a1dd4295ac2$export$f5708dca728d7177 || ($2af20a1dd4295ac2$export$f5708dca728d7177 = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var $2af20a1dd4295ac2$export$e54fe5b0f43758f7 = {
    env: {}
};
if (typeof $1CHRc === "object") $2af20a1dd4295ac2$export$e54fe5b0f43758f7 = $1CHRc;
else try {
    // Using Function to evaluate this assignment in global scope also escapes
    // the strict mode of the current module, thereby allowing the assignment.
    // Inspired by https://github.com/facebook/regenerator/pull/369.
    Function("stub", "process = stub")($2af20a1dd4295ac2$export$e54fe5b0f43758f7);
} catch (atLeastWeTried) {
// The assignment can fail if a Content Security Policy heavy-handedly
// forbids Function usage. In those environments, developers should take
// extra care to replace process.env.NODE_ENV in their production builds,
// or define an appropriate global.process polyfill.
}
var $2af20a1dd4295ac2$var$invariant$1 = $2af20a1dd4295ac2$export$f5708dca728d7177;
var $2af20a1dd4295ac2$export$2e2bcd8739ae039 = $2af20a1dd4295ac2$var$invariant$1;

});

parcelRegister("inWvg", function(module, exports) {
'use strict';
module.exports = function(data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = {
        cmp: opts
    };
    var cycles = typeof opts.cycles === 'boolean' ? opts.cycles : false;
    var cmp = opts.cmp && function(f) {
        return function(node) {
            return function(a, b) {
                var aobj = {
                    key: a,
                    value: node[a]
                };
                var bobj = {
                    key: b,
                    value: node[b]
                };
                return f(aobj, bobj);
            };
        };
    }(opts.cmp);
    var seen = [];
    return function stringify(node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') node = node.toJSON();
        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);
        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for(i = 0; i < node.length; i++){
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }
        if (node === null) return 'null';
        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }
        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for(i = 0; i < keys.length; i++){
            var key = keys[i];
            var value = stringify(node[key]);
            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    }(data);
};

});

parcelRegister("99WkW", function(module, exports) {
$parcel$export(module.exports, "equal", () => $6ab234cfcb6ce03f$export$411ce8e5a71e3069);
var $6ab234cfcb6ce03f$var$_a = Object.prototype, $6ab234cfcb6ce03f$var$toString = $6ab234cfcb6ce03f$var$_a.toString, $6ab234cfcb6ce03f$var$hasOwnProperty = $6ab234cfcb6ce03f$var$_a.hasOwnProperty;
var $6ab234cfcb6ce03f$var$previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */ function $6ab234cfcb6ce03f$export$411ce8e5a71e3069(a, b) {
    try {
        return $6ab234cfcb6ce03f$var$check(a, b);
    } finally{
        $6ab234cfcb6ce03f$var$previousComparisons.clear();
    }
}
function $6ab234cfcb6ce03f$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = $6ab234cfcb6ce03f$var$toString.call(a);
    var bTag = $6ab234cfcb6ce03f$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case '[object Object]':
            if ($6ab234cfcb6ce03f$var$previouslyCompared(a, b)) return true;
            var aKeys = Object.keys(a);
            var bKeys = Object.keys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length) return false;
            // Now make sure they have the same keys.
            for(var k = 0; k < keyCount; ++k){
                if (!$6ab234cfcb6ce03f$var$hasOwnProperty.call(b, aKeys[k])) return false;
            }
            // Finally, check deep equality of all child properties.
            for(var k = 0; k < keyCount; ++k){
                var key = aKeys[k];
                if (!$6ab234cfcb6ce03f$var$check(a[key], b[key])) return false;
            }
            return true;
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == "" + b;
        case '[object Map]':
        case '[object Set]':
            if (a.size !== b.size) return false;
            if ($6ab234cfcb6ce03f$var$previouslyCompared(a, b)) return true;
            var aIterator = a.entries();
            var isMap = aTag === '[object Map]';
            while(true){
                var info = aIterator.next();
                if (info.done) break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) return false;
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !$6ab234cfcb6ce03f$var$check(aValue, b.get(aKey))) return false;
            }
            return true;
    }
    // Otherwise the values are not equal.
    return false;
}
function $6ab234cfcb6ce03f$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = $6ab234cfcb6ce03f$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $6ab234cfcb6ce03f$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}
var $6ab234cfcb6ce03f$export$2e2bcd8739ae039 = $6ab234cfcb6ce03f$export$411ce8e5a71e3069;

});



parcelRegister("9X8MB", function(module, exports) {
$parcel$export(module.exports, "default", () => $73f06fd9043f6870$export$2e2bcd8739ae039);
/* global window */ 
var $cnQ0K = parcelRequire("cnQ0K");
var root;
if (typeof self !== 'undefined') root = self;
else if (typeof window !== 'undefined') root = window;
else if (typeof $parcel$global !== 'undefined') root = $parcel$global;
else root = module;
var result = (0, $cnQ0K.default)(root);
var $73f06fd9043f6870$export$2e2bcd8739ae039 = result;

});
parcelRegister("cnQ0K", function(module, exports) {
$parcel$export(module.exports, "default", () => $02539ccfdeaa44ca$export$2e2bcd8739ae039);
function $02539ccfdeaa44ca$export$2e2bcd8739ae039(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) result = Symbol.observable;
        else {
            result = Symbol('observable');
            Symbol.observable = result;
        }
    } else result = '@@observable';
    return result;
}

});


parcelRegister("6vvG3", function(module, exports) {

let $4bce35c57e1c7f3a$var$load = (parcelRequire("6arlF"))(5);
module.exports = $4bce35c57e1c7f3a$var$load("eWNyL").then(()=>parcelRequire('cfn6I'));

});
parcelRegister("6arlF", function(module, exports) {
"use strict";


let $47d8e4140e65e221$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("ixlcF")).shardUrl((parcelRequire("4CP8J")).resolve(id), maxShards));
    };
module.exports = $47d8e4140e65e221$var$load;

});
parcelRegister("ixlcF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $d7ebc19ba3f34eb2$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $d7ebc19ba3f34eb2$var$getDomainShardIndex;
module.exports.shardUrl = $d7ebc19ba3f34eb2$var$shardUrl;
module.exports.shardUrlUnchecked = $d7ebc19ba3f34eb2$var$shardUrlUnchecked;
const $d7ebc19ba3f34eb2$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $d7ebc19ba3f34eb2$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $d7ebc19ba3f34eb2$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $d7ebc19ba3f34eb2$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $d7ebc19ba3f34eb2$var$removeTrailingShard(subdomain) {
    if (!$d7ebc19ba3f34eb2$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $d7ebc19ba3f34eb2$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$d7ebc19ba3f34eb2$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $d7ebc19ba3f34eb2$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $d7ebc19ba3f34eb2$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $d7ebc19ba3f34eb2$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $d7ebc19ba3f34eb2$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $d7ebc19ba3f34eb2$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $d7ebc19ba3f34eb2$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$d7ebc19ba3f34eb2$var$globalKeyName]) return url;
    return $d7ebc19ba3f34eb2$var$shardUrlUnchecked(url, maxShards);
}
const $d7ebc19ba3f34eb2$var$domainShardingKey = module.exports.domainShardingKey = $d7ebc19ba3f34eb2$var$globalKeyName;

});

parcelRegister("4CP8J", function(module, exports) {
$parcel$export(module.exports, "register", () => $35e26158a9b5e25a$export$6503ec6e8aabbaf, (v) => $35e26158a9b5e25a$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $35e26158a9b5e25a$export$f7ad0328861e2f03, (v) => $35e26158a9b5e25a$export$f7ad0328861e2f03 = v);
var $35e26158a9b5e25a$export$6503ec6e8aabbaf;
var $35e26158a9b5e25a$export$f7ad0328861e2f03;
"use strict";
var $35e26158a9b5e25a$var$mapping = new Map();
function $35e26158a9b5e25a$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$35e26158a9b5e25a$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $35e26158a9b5e25a$var$resolve(id) {
    var resolved = $35e26158a9b5e25a$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$35e26158a9b5e25a$export$6503ec6e8aabbaf = $35e26158a9b5e25a$var$register;
$35e26158a9b5e25a$export$f7ad0328861e2f03 = $35e26158a9b5e25a$var$resolve;

});



parcelRegister("kOCE7", function(module, exports) {

let $f2767472bcbf0ae4$var$load = (parcelRequire("6arlF"))(5);
module.exports = $f2767472bcbf0ae4$var$load("5W75u").then(()=>parcelRequire('fZKGJ'));

});

parcelRegister("kfarM", function(module, exports) {

let $ebcd4fec25d46bd7$var$load = (parcelRequire("6arlF"))(5);
module.exports = $ebcd4fec25d46bd7$var$load("bm5by").then(()=>parcelRequire('byKUj'));

});

parcelRegister("4DsE6", function(module, exports) {

let $36010665714d2675$var$load = (parcelRequire("6arlF"))(5);
module.exports = $36010665714d2675$var$load("knPTc").then(()=>parcelRequire('eqvx9'));

});

parcelRegister("8RNgu", function(module, exports) {
$parcel$export(module.exports, "Fragment", () => $67497cf31ee8ec0c$export$ffb0004e005737fa, (v) => $67497cf31ee8ec0c$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $67497cf31ee8ec0c$export$34b9dba7ce09269b, (v) => $67497cf31ee8ec0c$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $67497cf31ee8ec0c$export$25062201e9e25d76, (v) => $67497cf31ee8ec0c$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $67497cf31ee8ec0c$export$ffb0004e005737fa;
var $67497cf31ee8ec0c$export$34b9dba7ce09269b;
var $67497cf31ee8ec0c$export$25062201e9e25d76;
'use strict';

var $gqzfn = parcelRequire("gqzfn");
var $67497cf31ee8ec0c$var$k = Symbol.for("react.element"), $67497cf31ee8ec0c$var$l = Symbol.for("react.fragment"), $67497cf31ee8ec0c$var$m = Object.prototype.hasOwnProperty, $67497cf31ee8ec0c$var$n = $gqzfn.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $67497cf31ee8ec0c$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $67497cf31ee8ec0c$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$67497cf31ee8ec0c$var$m.call(a, b) && !$67497cf31ee8ec0c$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $67497cf31ee8ec0c$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $67497cf31ee8ec0c$var$n.current
    };
}
$67497cf31ee8ec0c$export$ffb0004e005737fa = $67497cf31ee8ec0c$var$l;
$67497cf31ee8ec0c$export$34b9dba7ce09269b = $67497cf31ee8ec0c$var$q;
$67497cf31ee8ec0c$export$25062201e9e25d76 = $67497cf31ee8ec0c$var$q;

});

parcelRegister("7YhLB", function(module, exports) {

let $5cdbeb21e401a7b0$var$load = (parcelRequire("6arlF"))(5);
module.exports = $5cdbeb21e401a7b0$var$load("c1QXH").then(()=>parcelRequire('ffseK'));

});

parcelRegister("b3ZhF", function(module, exports) {
$parcel$export(module.exports, "STARGATE_PROXY_PATH", () => $987cf748565a0d9c$export$5df9262e102d0c32);
$parcel$export(module.exports, "default", () => $987cf748565a0d9c$export$2e2bcd8739ae039);

var $2tp3i = parcelRequire("2tp3i");

var $bwpu1 = parcelRequire("bwpu1");

var $7Yhrz = parcelRequire("7Yhrz");

var $23Ap4 = parcelRequire("23Ap4");

var $886JK = parcelRequire("886JK");

var $7nd0Y = parcelRequire("7nd0Y");

var $3uSCi = parcelRequire("3uSCi");

var $2Kuwu = parcelRequire("2Kuwu");

var $4J7ab = parcelRequire("4J7ab");

var $hqzVj = parcelRequire("hqzVj");

var $56ZJB = parcelRequire("56ZJB");

var $9UKaB = parcelRequire("9UKaB");

var $7CePv = parcelRequire("7CePv");

var $b2MkN = parcelRequire("b2MkN");

var $fj9wA = parcelRequire("fj9wA");

var $1hMjq = parcelRequire("1hMjq");

var $4hL0X = parcelRequire("4hL0X");

var $1ecJa = parcelRequire("1ecJa");

var $fSWe2 = parcelRequire("fSWe2");

var $hn1K9 = parcelRequire("hn1K9");

var $eI6RR = parcelRequire("eI6RR");

var $1XWT7 = parcelRequire("1XWT7");

var $cwOIC = parcelRequire("cwOIC");
const $987cf748565a0d9c$export$5df9262e102d0c32 = '/gateway/api/gasv3/api/v1';
const $987cf748565a0d9c$var$LAST_SCREEN_EVENT_STORAGE_KEY = 'last.screen.event';
class $987cf748565a0d9c$export$48361b6ed38f1b0 {
    static getCallback(logger) {
        logger = logger || console;
        return (response)=>{
            $987cf748565a0d9c$export$48361b6ed38f1b0.callback(response, logger);
        };
    }
    static callback(response, logger) {
        const statusCode = response.getStatusCode();
        if (statusCode >= 200 && statusCode <= 299) response.getEventResponseList().forEach((eventResponse)=>{
            logger.warn('Validation report for event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
        });
        else if (statusCode === 400 || statusCode === 404) {
            logger.warn('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.getEventResponseList().forEach((eventResponse)=>{
                logger.warn('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        } else {
            logger.log('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.eventResponseList.forEach((eventResponse)=>{
                logger.debug('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        }
    }
}
class $987cf748565a0d9c$export$2e2bcd8739ae039 {
    metadataCallsEnabled(settings) {
        if (typeof settings.disableMetadataCalls === 'boolean') return !settings.disableMetadataCalls;
        return !(0, $eI6RR.TestSupport).isGeminiVREnvironment() && !(0, $eI6RR.TestSupport).areFetchCallsDisabled();
    }
    eventCallsEnabled(settings) {
        if (typeof settings.disableEventCalls === 'boolean') return !settings.disableEventCalls;
        return !(0, $eI6RR.TestSupport).isGeminiVREnvironment() && !(0, $eI6RR.TestSupport).areFetchCallsDisabled();
    }
    setEventValidationMode(eventValidationMode) {
        this._context.context.validationMode = eventValidationMode;
    }
    /**
   * @private
   * @deprecated
   * Please avoid using internal properties. They are not part of the public
   * API and may change without notice.
   *
   * This property has been exposed for backward compatibility with existing
   * tests in external code
   */ get task() {
        return this._task;
    }
    /**
   * @private
   * @deprecated
   * Please avoid using internal properties.
   * They are not part of the public API and may change without notice.
   *
   * This property has been exposed for backward compatibility with existing
   * tests in external code
   */ get _productInfo() {
        return this._internalProductInfo;
    }
    constructor(productInfo, settings = {}){
        this._apdexEvent = void 0;
        this._context = void 0;
        this._eventDelayQueue = void 0;
        this._historyReplaceFn = void 0;
        this._orgInfo = void 0;
        this._pageVisibility = void 0;
        this._internalProductInfo = void 0;
        this._safeSessionStorage = void 0;
        this._sessionTracking = void 0;
        this._tabTracking = void 0;
        this._tenantInfo = void 0;
        this._testingCache = void 0;
        this._uiViewedAttributes = void 0;
        this._uiViewedEvent = void 0;
        this._userInfo = void 0;
        this._originTracing = void 0;
        this._task = void 0;
        this._pageLoadId = void 0;
        this._workspaceInfo = void 0;
        this._aliases = void 0;
        this._groups = void 0;
        this._eventProcessor = void 0;
        this._logger = void 0;
        this._embeddedContext = void 0;
        this._crossProductInteractionTracking = void 0;
        this._useStargate = (useStargate)=>{
            if (useStargate == null) return true;
            return useStargate;
        };
        this._changeInternalUserId = (userId, anonymousId)=>{
            this._eventProcessor.getUser().setUserId(userId);
            if (anonymousId && anonymousId !== this._eventProcessor.getUser().getAnonymousId()) // Setting anonymous id can take a long time. Reading is a lot faster.
            // Only update if it has changed.
            this._eventProcessor.getUser().setAnonymousId(anonymousId);
        };
        this._createSubproductGetter = (subproduct)=>(0, $7Yhrz.default)(subproduct, 'Cannot get subproduct from the callback. Proceeding without it.');
        this._createEmbeddedProductGetter = (embeddedProduct)=>(0, $7Yhrz.default)(embeddedProduct, 'Cannot get embeddedProduct from the callback. Proceeding without it.');
        this._getLastScreenEvent = ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($987cf748565a0d9c$var$LAST_SCREEN_EVENT_STORAGE_KEY) || '');
            } catch (err) {
                this._safeSessionStorage.removeItem($987cf748565a0d9c$var$LAST_SCREEN_EVENT_STORAGE_KEY);
                return null;
            }
        };
        this._setLastScreenEvent = (event)=>{
            this._safeSessionStorage.setItem($987cf748565a0d9c$var$LAST_SCREEN_EVENT_STORAGE_KEY, JSON.stringify({
                name: event.name,
                attributes: event.attributes
            }));
        };
        this._shouldEventBeDelayed = (event)=>{
            // TODO: this is a temporary restriction for the purposes of the Track All Changes project
            // The delay mechanism has a chance of event loss, which we can only accept for our own data at this point.
            // Once the delay queue implementation has been improved and measured to confirm that it is reliable enough,
            // then we will be able to open it up for other products to use by removing this check.
            if (!event.tags || event.tags.indexOf('measurement') === -1) return false;
            const isEventHighPriority = event.highPriority !== false; // defaults to true if excluded
            return this._eventDelayQueue.isDelayingLowPriorityEvents() && !isEventHighPriority;
        };
        this._fireEvent = (identifier, builtEvent, context, callback)=>{
            switch(builtEvent.eventType){
                case (0, $2tp3i.eventType).UI:
                case (0, $2tp3i.eventType).OPERATIONAL:
                case (0, $2tp3i.eventType).TRACK:
                    return this._eventProcessor.track(identifier, builtEvent, context, callback);
                case (0, $2tp3i.eventType).SCREEN:
                    return this._eventProcessor.page(identifier, builtEvent, context, callback);
                case (0, $2tp3i.eventType).IDENTIFY:
                    return this._eventProcessor.identify(identifier, builtEvent, context, callback);
                default:
                    throw new Error(`No handler has been defined for events of type ${builtEvent.eventType}`);
            }
        };
        this._fireDelayedEvent = (identifier, builtEvent, context, userInfo)=>{
            try {
                // User information can change while the delay period is active, so we need to restore the values that
                // were active when the event was originally fired.
                this._changeInternalUserId(userInfo.userId, userInfo.anonymousId);
                builtEvent.tags = [
                    ...builtEvent.tags || [],
                    'sentWithDelay'
                ];
                // The callbacks for delayed events are fired immediately, so there is nothing to pass through for this argument.
                this._fireEvent(identifier, builtEvent, context, undefined);
            } finally{
                this._changeInternalUserId(this._userInfo.userId, this._userInfo.anonymousId);
            }
        };
        this._delayEvent = (identifier, builtEvent, context, userInfo, callback)=>{
            this._eventDelayQueue.push(identifier, builtEvent, context, userInfo);
            // Fire the callback immediately, as we can consider the event successfully processed at this point
            if (callback) callback();
        };
        this._processEvent = (identifier, builtEvent, context, callback)=>{
            this._testingCache.saveEvent(builtEvent);
            if (this._shouldEventBeDelayed(builtEvent)) {
                this._delayEvent(identifier, builtEvent, context, this._userInfo, callback);
                return Promise.resolve();
            } else return this._fireEvent(identifier, builtEvent, context, callback);
        };
        this.setEmbeddedProduct = (embeddedProduct)=>{
            this._internalProductInfo.embeddedProduct = this._createEmbeddedProductGetter(embeddedProduct);
            this.resetUIViewedTimers();
        };
        this.clearEmbeddedProduct = ()=>{
            this._internalProductInfo.embeddedProduct = this._createEmbeddedProductGetter(null);
        };
        this.setSubproduct = (subproduct)=>{
            this._internalProductInfo.subproduct = this._createSubproductGetter(subproduct);
            this.resetUIViewedTimers();
        };
        /**
      * Calling this function in the intialisation of the client in product
      * captures specified 'origin tracing' URL params and fires a single origin landed event
      * <p>
      * This function expects a mapping between the keys for any URL parameters
      *  that should be captured and removed for origin tracing
      * Multiple parameters may be captured simultaneously if multiple key: handler function pairs are provided
      * Each handler function should return an object with two items
      * a) 'originTracingAttributes' - an object that will be added to the 'origin landed' event's attributes under 'originTracing
      * b) 'taskSessionId' (optional) - an Id string that will be added to the tasksessions for any event that fires from the tab, with the key
      *    matching the URL parameter, for the purpose of attributing subsequent analytics event to the origin land.
      * </p>
      * The general use case for this feature is for allowing attributation of user behaviour to a out of product or cross product link,
      * e.g. from a share or email
      *
      * An example calling this function using an external decoding library, with taskSessionId specified to persist
      * analyticsWebClient.setOriginTracingHandlers({
           atlOrigin: encodedOrigin => {
               const { id, product } = OriginTracing.fromEncoded(encodedOrigin);
               return { originTracingAttributes: {'id': id, 'product': product}, taskSessionId: id };
           },
       });
      *
      * @param  {Object} originParamHandlerMapping a dictionary of mappings between origin url param keys and handler functions
      * @this {AnalyticsWebClient}
      */ this.setOriginTracingHandlers = (originParamHandlerMapping)=>{
            const capturedOriginTraces = this._originTracing.handleOriginParameters(originParamHandlerMapping, this._historyReplaceFn);
            Object.keys(capturedOriginTraces).forEach((x)=>{
                if (typeof capturedOriginTraces[x].taskSessionId !== 'undefined') this._task.createTaskSessionWithProvidedId(x, capturedOriginTraces[x].taskSessionId);
            });
            const originAttributes = {};
            Object.keys(capturedOriginTraces).forEach((x)=>{
                if (capturedOriginTraces[x].originTracingAttributes) originAttributes[x] = capturedOriginTraces[x].originTracingAttributes;
                else // eslint-disable-next-line no-console
                console.warn(`Handling method for origin parameter ${x} has not returned any attributes`);
            });
            if (Object.keys(capturedOriginTraces).length > 0) return this.sendOperationalEvent({
                action: 'landed',
                actionSubject: 'origin',
                source: 'webClient',
                attributes: {
                    originTracesLanded: originAttributes
                }
            }, // eslint-disable-next-line @typescript-eslint/no-empty-function
            ()=>{});
            return Promise.resolve();
        };
        this.setTenantInfo = (tenantIdType, tenantId)=>{
            if (!tenantIdType) throw new Error('Missing tenantIdType');
            if (tenantIdType !== (0, $2tp3i.tenantType).NONE && !tenantId) throw new Error('Missing tenantId');
            if (!(0, $2tp3i.isType)((0, $2tp3i.tenantType), tenantIdType)) throw new Error(`Invalid tenantIdType '${tenantIdType}', ` + `must be an tenantType: [${(0, $2tp3i.objectValues)((0, $2tp3i.tenantType))}]`);
            this._tenantInfo = {
                tenantIdType: tenantIdType,
                tenantId: tenantId
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.clearTenantInfo = ()=>{
            this._tenantInfo = {};
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.setOrgInfo = (orgId)=>{
            if (!orgId) throw new Error('Missing orgId');
            this._orgInfo = {
                orgId: orgId
            };
        };
        this.clearOrgInfo = ()=>{
            this._orgInfo = {};
        };
        this.setWorkspaceInfo = (workspaceId)=>{
            if (!workspaceId) throw new Error('Missing workspaceId');
            this._workspaceInfo = {
                workspaceId: workspaceId
            };
        };
        this.clearWorkspaceInfo = ()=>{
            this._workspaceInfo = {};
        };
        this.setUserInfo = (userIdType, userId)=>{
            (0, $2Kuwu.validateIdentifyEvent)(userIdType, userId);
            this._changeInternalUserId(userId);
            this._userInfo = {
                userIdType: userIdType,
                userId: userId,
                anonymousId: this._eventProcessor.getUser().getAnonymousId()
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.clearUserInfo = ()=>{
            this._changeInternalUserId(undefined);
            this._userInfo = {
                anonymousId: this._eventProcessor.getUser().getAnonymousId()
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.setAlias = (aliasKeyType, alias)=>{
            if (!aliasKeyType) throw new Error('Missing aliasType');
            if (!(0, $2tp3i.isType)((0, $2tp3i.aliasType), aliasKeyType)) throw new Error(`Invalid aliasType '${aliasKeyType}', ` + `must be an aliasType: [${(0, $2tp3i.objectValues)((0, $2tp3i.aliasType))}]`);
            this._aliases[aliasKeyType] = alias;
        };
        this.clearAlias = ()=>{
            this._aliases = {};
        };
        this.setGroup = (groupsKeyType, group)=>{
            if (!groupsKeyType) throw new Error('Missing groupType');
            if (!(0, $2tp3i.isType)((0, $2tp3i.groupType), groupsKeyType)) throw new Error(`Invalid groupType '${groupsKeyType}', ` + `must be an groupType: [${(0, $2tp3i.objectValues)((0, $2tp3i.groupType))}]`);
            this._groups[groupsKeyType] = group;
        };
        this.clearGroup = ()=>{
            this._groups = {};
        };
        this.getAnonymousId = ()=>this._userInfo.anonymousId;
        this.getCurrentSessionId = ()=>this._sessionTracking.getCurrentSessionId();
        this.setUIViewedAttributes = (uiViewedAttributes)=>{
            if (!uiViewedAttributes) throw new Error('Missing uiViewedAttributes');
            if (typeof uiViewedAttributes !== 'object' || Array.isArray(uiViewedAttributes)) throw new Error('Invalid uiViewedAttributes type, should be a non array object');
            this._uiViewedAttributes = {
                ...uiViewedAttributes
            };
        };
        this.getUIViewedAttributes = ()=>{
            return this._uiViewedAttributes;
        };
        this.clearUIViewedAttributes = ()=>{
            this._uiViewedAttributes = {};
        };
        this.appendUIViewedAttributes = (attributes)=>{
            if (!this._uiViewedAttributes) this._uiViewedAttributes = attributes;
            else this._uiViewedAttributes = {
                ...this._uiViewedAttributes,
                ...attributes
            };
        };
        this.sendIdentifyEvent = (userIdType, userId, callback)=>{
            this.setUserInfo(userIdType, userId);
            const builtEvent = {
                userIdType: userIdType,
                eventType: (0, $2tp3i.eventType).IDENTIFY
            };
            return this._processEvent(userId, builtEvent, this._context, callback);
        };
        /**
     * @deprecated
     * please use {@link sendScreenEvent instead)
     */ this.sendPageEvent = (name, callback)=>{
            return this.sendScreenEvent(name, callback);
        };
        /**
     * send screen event
     * @param event The event / For retrocompatibility event name is still supported here.
     * @param callback
     * @param attributes. Deprecated, will get ignored if using an event object as first param.
     */ this.sendScreenEvent = (event, callback, attributes)=>{
            let screenName;
            let screenAttributes;
            let screenContainers;
            let screenTags;
            if (typeof event === 'object') {
                /* This is for retrocompatibility */ screenName = event.name;
                screenAttributes = event.attributes;
                screenContainers = event.containers;
                screenTags = event.tags;
            } else {
                screenName = event;
                screenAttributes = attributes;
            }
            (0, $2Kuwu.validateScreenEvent)(screenName);
            (0, $2Kuwu.validateContainers)(screenContainers);
            const builtEvent = (0, $7nd0Y.buildScreenEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, screenAttributes, // TODO: Remove the as any and move into a place where we know event is an object
            event.nonPrivacySafeAttributes, screenTags, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, event, screenContainers, this._aliases, this._groups);
            const builtEventWithName = {
                name: screenName,
                ...builtEvent
            };
            this._setLastScreenEvent(builtEventWithName);
            return this._processEvent(screenName, builtEventWithName, this._context, (0, $1XWT7.default)(callback, builtEventWithName));
        };
        this.sendTrackEvent = (event, callback)=>{
            (0, $2Kuwu.validateTrackEvent)(event);
            const builtEvent = (0, $7nd0Y.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $2tp3i.eventType).TRACK, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $7nd0Y.buildActionName)(event), builtEvent, this._context, (0, $1XWT7.default)(callback, builtEvent));
        };
        this.sendUIEvent = (event, callback)=>{
            (0, $2Kuwu.validateUIEvent)(event);
            const builtEvent = (0, $7nd0Y.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $2tp3i.eventType).UI, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $7nd0Y.buildActionName)(event), builtEvent, this._context, (0, $1XWT7.default)(callback, builtEvent));
        };
        this.sendOperationalEvent = (event, callback)=>{
            (0, $2Kuwu.validateOperationalEvent)(event);
            const builtEvent = (0, $7nd0Y.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $2tp3i.eventType).OPERATIONAL, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $7nd0Y.buildActionName)(event), builtEvent, this._context, (0, $1XWT7.default)(callback, builtEvent));
        };
        this.startUIViewedEvent = (callback)=>{
            this.stopUIViewedEvent();
            this._uiViewedEvent = new (0, $fSWe2.default)(this._internalProductInfo, ()=>({
                    embeddedProduct: this._internalProductInfo.embeddedProduct(),
                    subproduct: this._internalProductInfo.subproduct(),
                    tenantIdType: this._tenantInfo.tenantIdType,
                    tenantId: this._tenantInfo.tenantId,
                    userId: this._userInfo.userId,
                    lastScreenEvent: this._getLastScreenEvent(),
                    attributes: this._uiViewedAttributes
                }), (event)=>this.sendUIEvent(event, callback));
            this._uiViewedEvent.start();
        };
        this.stopUIViewedEvent = ()=>{
            if (this._uiViewedEvent) {
                this._uiViewedEvent.stop();
                this._uiViewedEvent = null;
            }
        };
        this.resetUIViewedTimers = ()=>{
            if (this._uiViewedEvent) this._uiViewedEvent.resetTimers();
        };
        this.startApdexEvent = (apdexEvent)=>{
            this._apdexEvent.start(apdexEvent);
        };
        this.getApdexStart = (apdexEvent)=>this._apdexEvent.getStart(apdexEvent);
        this.stopApdexEvent = (apdexEvent, callback)=>{
            this._apdexEvent.stop(apdexEvent, callback);
        };
        // TODO If we ever make another breaking change, merge these two optional args into an `options` object arg.
        this.startLowPriorityEventDelay = (timeout, callback)=>{
            this._eventDelayQueue.startLowPriorityEventDelay(timeout, callback);
        };
        this.stopLowPriorityEventDelay = ()=>{
            this._eventDelayQueue.stopLowPriorityEventDelay();
        };
        this.onEvent = (_analyticsId, analyticsData)=>{
            if (!analyticsData) throw new Error('Missing analyticsData');
            if (!analyticsData.eventType) throw new Error('Missing analyticsData.eventType');
            if (analyticsData.eventType === (0, $2tp3i.eventType).TRACK) return this.sendTrackEvent(analyticsData);
            else if (analyticsData.eventType === (0, $2tp3i.eventType).UI) return this.sendUIEvent(analyticsData);
            else if (analyticsData.eventType === (0, $2tp3i.eventType).OPERATIONAL) return this.sendOperationalEvent(analyticsData);
            else if (analyticsData.eventType === (0, $2tp3i.eventType).SCREEN) return this.sendScreenEvent(analyticsData.name, null, analyticsData.attributes);
            else if (analyticsData.eventType === (0, $2tp3i.eventType).IDENTIFY) return this.sendIdentifyEvent(analyticsData.userIdType, analyticsData.userId);
            throw new Error(`Invalid analyticsData.eventType '${analyticsData.eventType}', ` + `must be an eventType: [${(0, $2tp3i.objectValues)((0, $2tp3i.eventType))}]`);
        };
        this.setResponseCallback = (responseCallback)=>{
            this._eventProcessor.setResponseCallback(responseCallback);
        };
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.env) throw new Error('Missing productInfo.env');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!(0, $2tp3i.isType)((0, $2tp3i.envType), productInfo.env)) throw new Error(`Invalid productInfo.env '${productInfo.env}', ` + `must be an envType: [${(0, $2tp3i.objectValues)((0, $2tp3i.envType))}]`);
        if (productInfo.perimeter && !(0, $2tp3i.isType)((0, $2tp3i.perimeterType), productInfo.perimeter)) throw new Error(`Invalid productInfo.perimeter '${productInfo.perimeter}', ` + `must be an perimeterType: [${(0, $2tp3i.objectValues)((0, $2tp3i.perimeterType))}]`);
        if (!productInfo.origin) productInfo.origin = (0, $2tp3i.originType).WEB;
        else if (!(0, $2tp3i.isType)((0, $2tp3i.originType), productInfo.origin)) throw new Error(`Invalid productInfo.origin '${productInfo.origin}', ` + `must be an originType: [${(0, $2tp3i.objectValues)((0, $2tp3i.originType))}]`);
        if (!productInfo.platform) productInfo.platform = productInfo.origin === (0, $2tp3i.originType).WEB ? (0, $2tp3i.platformType).WEB : (0, $2tp3i.platformType).DESKTOP;
        else (0, $2Kuwu.validatePlatform)(productInfo);
        this._logger = settings.logger || console;
        this._internalProductInfo = {
            ...productInfo,
            subproduct: this._createSubproductGetter(productInfo.subproduct),
            embeddedProduct: this._createEmbeddedProductGetter(productInfo.embeddedProduct)
        };
        this._tenantInfo = {};
        this._orgInfo = {};
        this._uiViewedAttributes = {};
        if (productInfo?.embeddedContext) {
            this._embeddedContext = productInfo.embeddedContext;
            if ((0, $886JK.isFirstParty)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext['embeddedType'],
                embeddedFromProduct: this._embeddedContext['embeddedFromProduct'],
                embeddedFromSubproduct: this._embeddedContext['embeddedFromSubproduct'],
                embeddedFromTopLevelDomain: this._embeddedContext['embeddedFromTopLevelDomain']
            });
            if ((0, $886JK.isThirdParty)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext['embeddedType'],
                embeddedFromTopLevelDomain: this._embeddedContext['embeddedFromTopLevelDomain']
            });
        }
        this._context = (0, $7nd0Y.buildContext)(this._internalProductInfo);
        this._safeSessionStorage = new (0, $fj9wA.default)();
        const _useStargate = this._useStargate(settings.useStargate);
        const apiHost = settings.apiHost || (0, $7CePv.selectHost)({
            useStargate: _useStargate,
            env: productInfo.env,
            useLegacyUrl: settings.useLegacyUrl,
            perimeter: productInfo.perimeter,
            ic: productInfo.ic,
            envOverride: productInfo.envOverride
        });
        const apiHostProtocol = settings.apiHostProtocol || 'https';
        const minRetryDelay = settings.minRetryDelay || 1000;
        const maxAttempts = settings.maxRetryAttempts !== undefined && Number.isInteger(settings.maxRetryAttempts) && settings.maxRetryAttempts >= 0 ? settings.maxRetryAttempts + 1 : undefined;
        const retryQueueOptions = {
            maxRetryDelay: 60000,
            minRetryDelay: minRetryDelay,
            backoffFactor: 2,
            flushWaitMs: settings.flushWaitInterval,
            flushBeforeUnload: settings.flushBeforeUnload,
            maxAttempts: maxAttempts
        };
        const retryQueuePrefix = `awc-${productInfo.env}`;
        const xidPromiseGetter = ()=>(0, $cwOIC.XIDPromise)(settings.xidConsent, settings.xidPromiseFn);
        const disableCookiePersistence = settings.disableCookiePersistence || false;
        const metadataClientFactory = settings.metadataClientFactory || (0, $hqzVj.MetadataClient).Factory;
        const metadataClient = metadataClientFactory(apiHostProtocol, apiHost, productInfo.product);
        this._eventProcessor = new (0, $4J7ab.default)({
            apiHost: apiHost,
            apiHostProtocol: apiHostProtocol,
            product: productInfo.product,
            retryQueuePrefix: retryQueuePrefix,
            retryQueueOptions: retryQueueOptions,
            xidPromiseGetter: xidPromiseGetter,
            logger: this._logger,
            metadataClient: metadataClient,
            disableCookiePersistence: disableCookiePersistence,
            responseCallback: $987cf748565a0d9c$export$48361b6ed38f1b0.getCallback(this._logger),
            env: productInfo.env,
            perimeter: productInfo.perimeter,
            enableMetadataCalls: this.metadataCallsEnabled(settings),
            enableEventCalls: this.eventCallsEnabled(settings)
        });
        this._userInfo = {
            anonymousId: this._eventProcessor.getUser().getAnonymousId(settings?.customAnonymousIdGenerator)
        };
        this._pageVisibility = new (0, $9UKaB.default)();
        this._tabTracking = new (0, $1hMjq.default)();
        this._sessionTracking = new (0, $b2MkN.default)({
            sessionExpiryTime: settings.sessionExpiryTime,
            onNewSessionStarted: settings.onNewSessionStarted
        });
        this._task = new (0, $4hL0X.default)();
        this._originTracing = new (0, $56ZJB.default)();
        // Init Apdex
        this._apdexEvent = new (0, $bwpu1.default)(this.sendOperationalEvent, this._pageVisibility);
        this._historyReplaceFn = typeof settings.historyReplaceFn === 'function' ? settings.historyReplaceFn : (0, $hn1K9.defaultHistoryReplaceFn);
        this._eventDelayQueue = new (0, $3uSCi.default)(this._fireDelayedEvent, settings.delayQueueCompressors || []);
        this._testingCache = new (0, $1ecJa.default)(settings.isSynthetic, settings.enableTestingCache);
        this._pageLoadId = crypto.randomUUID();
        this._workspaceInfo = {};
        this._aliases = {};
        this._groups = {};
        this._crossProductInteractionTracking = new (0, $23Ap4.default)({
            perimeter: productInfo.perimeter,
            product: productInfo.product,
            sendEventCallback: this.sendOperationalEvent,
            historyReplaceFn: this._historyReplaceFn
        });
        this._crossProductInteractionTracking.validateInteractionSession();
    }
}

});
parcelRegister("2tp3i", function(module, exports) {
$parcel$export(module.exports, "envType", () => $1795918190a051d7$export$56ac8ebc9870b1b9);
$parcel$export(module.exports, "eventType", () => $1795918190a051d7$export$4c045e605d532c98);
$parcel$export(module.exports, "platformType", () => $1795918190a051d7$export$6b4f396210e539f3);
$parcel$export(module.exports, "originType", () => $1795918190a051d7$export$f73e9fcd368bb695);
$parcel$export(module.exports, "tenantType", () => $1795918190a051d7$export$496f06ac2a964da2);
$parcel$export(module.exports, "productEmbedType", () => $1795918190a051d7$export$f49776dca27a2e7c);
$parcel$export(module.exports, "userType", () => $1795918190a051d7$export$1827adfd178b4870);
$parcel$export(module.exports, "apdexType", () => $1795918190a051d7$export$99b37380a464d794);
$parcel$export(module.exports, "desktopPlatforms", () => $1795918190a051d7$export$809831be6c4c6227);
$parcel$export(module.exports, "webPlatforms", () => $1795918190a051d7$export$19c579398ad213e7);
$parcel$export(module.exports, "originTracingType", () => $1795918190a051d7$export$62a500c02dc63ee);
$parcel$export(module.exports, "objectValues", () => $1795918190a051d7$export$ad1854f4a08c15f8);
$parcel$export(module.exports, "isType", () => $1795918190a051d7$export$26b9f946b448f23e);
$parcel$export(module.exports, "perimeterType", () => $1795918190a051d7$export$bdd41749d2096e4b);
$parcel$export(module.exports, "aliasType", () => $1795918190a051d7$export$a8c99e46b781d936);
$parcel$export(module.exports, "groupType", () => $1795918190a051d7$export$e73680b18d9b7c6e);
// These types have been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.
var $1795918190a051d7$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
var $1795918190a051d7$export$4c045e605d532c98 = /*#__PURE__*/ function(eventType) {
    eventType["TRACK"] = "track";
    eventType["UI"] = "ui";
    eventType["OPERATIONAL"] = "operational";
    eventType["SCREEN"] = "screen";
    eventType["IDENTIFY"] = "identify";
    return eventType;
}({});
var $1795918190a051d7$export$6b4f396210e539f3 = /*#__PURE__*/ function(platformType) {
    platformType["MAC"] = "mac";
    platformType["LINUX"] = "linux";
    platformType["WINDOWS"] = "windows";
    /**
	 *  @deprecated desktop is here for retrocompatibility, please select one of the above OS instead.
	 */ platformType["DESKTOP"] = "desktop";
    platformType["WEB"] = "web";
    platformType["MOBILE_WEB"] = "mobileWeb";
    return platformType;
}({});
var $1795918190a051d7$export$f73e9fcd368bb695 = /*#__PURE__*/ function(originType) {
    originType["DESKTOP"] = "desktop";
    originType["WEB"] = "web";
    return originType;
}({});
var $1795918190a051d7$export$496f06ac2a964da2 = /*#__PURE__*/ function(tenantType) {
    tenantType["CLOUD_ID"] = "cloudId";
    tenantType["ORG_ID"] = "orgId";
    tenantType["OPSGENIE_CUSTOMER_ID"] = "opsgenieCustomerId";
    tenantType["HALP_TEAM_ID"] = "halpTeamId";
    tenantType["LOOM_ORG_ID"] = "loomOrgId";
    tenantType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    tenantType["TRELLO_WORKSPACE_ID"] = "trelloWorkspaceId";
    tenantType["JA_WORKSPACE_ID"] = "jiraAlignWorkspaceId";
    tenantType["STUDIO_WORKSPACE_ID"] = "studioWorkspaceId";
    tenantType["NONE"] = "none";
    return tenantType;
}({});
var $1795918190a051d7$export$f49776dca27a2e7c = /*#__PURE__*/ function(productEmbedType) {
    productEmbedType["FIRST_PARTY"] = "FIRST_PARTY";
    productEmbedType["THIRD_PARTY"] = "THIRD_PARTY";
    return productEmbedType;
}({});
var $1795918190a051d7$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["LOOM"] = "loom";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["JA_USER_ID"] = "jiraAlign";
    userType["HALP"] = "halp";
    return userType;
}({});
var $1795918190a051d7$export$99b37380a464d794 = /*#__PURE__*/ function(apdexType) {
    apdexType["TRANSITION"] = "transition";
    apdexType["INITIAL_LOAD"] = "initialLoad";
    return apdexType;
}({});
const $1795918190a051d7$export$809831be6c4c6227 = Object.freeze([
    "desktop",
    "mac",
    "linux",
    "windows"
]);
const $1795918190a051d7$export$19c579398ad213e7 = Object.freeze([
    "web",
    "mobileWeb"
]);
var $1795918190a051d7$export$62a500c02dc63ee = /*#__PURE__*/ function(originTracingType) {
    originTracingType["ATL_ORIGIN"] = "atlOrigin";
    return originTracingType;
}({});
function $1795918190a051d7$export$ad1854f4a08c15f8(object) {
    return Object.values(object);
}
function $1795918190a051d7$export$26b9f946b448f23e(type, value) {
    return Object.values(type).indexOf(value) > -1;
}
var $1795918190a051d7$export$bdd41749d2096e4b = /*#__PURE__*/ function(perimeterType) {
    perimeterType["C5"] = "c5";
    perimeterType["COMMERCIAL"] = "commercial";
    perimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    perimeterType["FEDRAMP_HIGH"] = "fedramp-high";
    return perimeterType;
}({});
var $1795918190a051d7$export$a8c99e46b781d936 = /*#__PURE__*/ function(aliasType) {
    return aliasType;
}({});
var $1795918190a051d7$export$e73680b18d9b7c6e = /*#__PURE__*/ function(groupType) {
    groupType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    return groupType;
}({});
var $1795918190a051d7$export$12b75c708da5a04b = /*#__PURE__*/ function(envOverrides) {
    return envOverrides;
}({});

});

parcelRegister("bwpu1", function(module, exports) {
$parcel$export(module.exports, "default", () => $a74a63e8411fbf0f$export$2e2bcd8739ae039);

var $2tp3i = parcelRequire("2tp3i");

var $9UKaB = parcelRequire("9UKaB");

var $b6hzQ = parcelRequire("b6hzQ");
class $a74a63e8411fbf0f$export$2e2bcd8739ae039 {
    start(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        this._startedEvents.set(eventKey, true);
        this._isActiveEvents.set(eventKey, !this._pageVisibility.getIsHidden());
        this._performance.clearMarks(eventStartName);
        this._performance.mark(eventStartName);
    }
    getStart(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return undefined;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        return this._getEventTimingByName(eventStartName);
    }
    stop(event, callback) {
        this._validateStopEvent(event);
        if (!this._performance.isAvailable()) return;
        const apdexFields = this._getApdexFields(event);
        const visibilityFields = this._getVisibilityFields(event);
        this._sendEvent({
            ...event,
            ...apdexFields,
            ...visibilityFields
        }, callback);
    }
    onVisibilityChange(isActive) {
        if (!isActive) {
            this._wasPreviouslyHidden = true;
            Array.from(this._isActiveEvents.keys()).forEach((key)=>this._isActiveEvents.set(key, false));
        }
    }
    constructor(onEvent, pageVisibility){
        this._isActiveEvents = void 0;
        this._onEvent = void 0;
        this._pageVisibility = void 0;
        this._performance = void 0;
        this._startedEvents = void 0;
        this._threshold = void 0;
        this._wasPreviouslyHidden = void 0;
        this._getEventKey = ({ task: task, taskId: taskId })=>taskId ? `${task}.${taskId}` : task;
        this._getEventTimingByName = (name)=>{
            const eventTimings = this._performance.getEntriesByName(name);
            const eventTiming = eventTimings[eventTimings.length - 1];
            return eventTiming;
        };
        this._getApdexFields = (event)=>{
            const apdexTimings = this._getApdexTimings(event);
            const apdexScore = this._calculateApdex({
                duration: apdexTimings.duration,
                threshold: event.threshold
            });
            return {
                ...apdexTimings,
                apdex: apdexScore
            };
        };
        this._getApdexTimings = (event)=>{
            const eventKey = this._getEventKey(event);
            const eventStartName = `${eventKey}-start`;
            const startTime = event.startTime || this._getStartTime(event, eventStartName);
            const stopTime = event.stopTime || this._getStopTime();
            // We do some clean up of the marks and started events
            this._cleanApdexState(eventKey);
            return {
                startTime: startTime,
                stopTime: stopTime,
                duration: stopTime - startTime
            };
        };
        this._getStartTime = (event, eventName)=>{
            let startTime;
            const timeOrigin = this._performance.getTimeOrigin();
            if (event.type === (0, $2tp3i.apdexType).INITIAL_LOAD) startTime = timeOrigin;
            else {
                const eventTiming = this._getEventTimingByName(eventName);
                startTime = timeOrigin + eventTiming.startTime;
            }
            return startTime;
        };
        this._getStopTime = ()=>this._performance.getTimeOrigin() + this._performance.now();
        this._cleanApdexState = (eventKey)=>{
            this._performance.clearMarks(`${eventKey}-start`);
            this._performance.clearMarks(`${eventKey}-stop`);
            this._startedEvents.delete(eventKey);
        };
        this._getVisibilityFields = (event)=>{
            let isActiveTab;
            /**
       * For initialLoad type:
       * 1. if tab was not ever hidden (!_wasPreviouslyHidden)
       *
       * For transition type:
       * 1. active status is tracked in active events map (_isActiveEvents)
       *
       * For any type, if startTime or stopTime is specified:
       * 1. If currently active (!_isHidden)
       */ if (event.type === (0, $2tp3i.apdexType).INITIAL_LOAD) isActiveTab = !this._wasPreviouslyHidden;
            else if (event.type === (0, $2tp3i.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                isActiveTab = this._isActiveEvents.get(eventKey);
            }
            if (event.startTime || event.stopTime) isActiveTab = !this._pageVisibility.getIsHidden();
            return {
                isActiveTab: isActiveTab
            };
        };
        this._calculateApdex = ({ duration: duration, threshold: threshold = this._threshold })=>{
            let apdex;
            const satisfiedThreshold = threshold;
            const tolerableThreshold = threshold * 4;
            if (duration <= satisfiedThreshold) apdex = 1;
            else if (duration <= tolerableThreshold) apdex = 0.5;
            else apdex = 0;
            return apdex;
        };
        this._validateStartEvent = (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex start event');
            if (!event.task) throw new Error('Missing "task" in Apdex start event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex start event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex start event');
        };
        this._validateStopEvent = (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex stop event');
            if (!event.task) throw new Error('Missing "task" in Apdex stop event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex stop event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex stop event');
            if (!event.type) throw new Error('Missing "type" in Apdex stop event');
            if (event.type && !(0, $2tp3i.isType)((0, $2tp3i.apdexType), event.type)) throw new Error('Invalid "type" in Apdex stop event');
            if (event.threshold && typeof event.threshold !== 'number') throw new Error('Invalid "threshold" in Apdex stop event');
            /*
       * For a transition, if the startTime was not specified,
       * the start event should have been present.
       */ if (!event.startTime && event.type === (0, $2tp3i.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                if (!this._startedEvents.has(eventKey)) throw new Error(`Apdex event transition "${eventKey}" was not started`);
            }
            if (event.startTime && !(typeof event.startTime === 'number' && event.startTime >= 0)) throw new Error('Invalid "startTime" in Apdex stop event');
            if (event.stopTime && typeof event.stopTime !== 'number') throw new Error('Invalid "stopTime" in Apdex stop event');
            if (event.stopTime <= event.startTime) throw new Error('"stopTime" should be greater than "startTime" in Apdex stop event');
        };
        this._shouldSendEvent = (event)=>{
            if (!event) return false;
            if (typeof event.apdex !== 'number') return false;
            return true;
        };
        this._sendEvent = (event, callback)=>{
            if (this._shouldSendEvent(event)) this._onEvent({
                source: 'ui',
                action: 'readyForUser',
                actionSubject: 'ui',
                attributes: {
                    ...event.additionalAttributes,
                    task: event.task,
                    taskId: event.taskId,
                    type: event.type,
                    threshold: event.threshold || this._threshold,
                    apdex: event.apdex,
                    startTime: event.startTime,
                    stopTime: event.stopTime,
                    duration: event.duration,
                    isActiveTab: event.isActiveTab
                }
            }, callback);
        };
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        if (!(pageVisibility instanceof (0, $9UKaB.default))) throw new Error('Invalid pageVisibility, must be PageVisibility class');
        this._startedEvents = new Map();
        this._performance = new (0, $b6hzQ.default)();
        this._onEvent = onEvent;
        this._threshold = 1000;
        this._wasPreviouslyHidden = pageVisibility.getIsHidden();
        this._isActiveEvents = new Map();
        this._pageVisibility = pageVisibility;
        this._pageVisibility.addCallback('apdexEvent', (isHidden)=>{
            this.onVisibilityChange(!isHidden);
        });
    }
}

});
parcelRegister("9UKaB", function(module, exports) {
$parcel$export(module.exports, "default", () => $11f768062694ab7c$export$2e2bcd8739ae039);
class $11f768062694ab7c$export$2e2bcd8739ae039 {
    addCallback(name, fn) {
        if (typeof name !== 'string') throw new Error('Invalid name, must be string');
        if (typeof fn !== 'function') throw new Error('Invalid callback, must be function');
        this._callbacks.set(name, fn);
    }
    removeCallback(name) {
        if (this._callbacks.has(name)) this._callbacks.delete(name);
    }
    getIsHidden() {
        return this._isHidden;
    }
    constructor(){
        this._callbacks = void 0;
        this._hidden = void 0;
        this._isHidden = void 0;
        this._visibilityChange = void 0;
        this._bindEventListeners = ()=>{
            document.addEventListener(this._visibilityChange, this._handleVisibilityChange, false);
        };
        this._handleVisibilityChange = ()=>{
            const isHidden = document[this._hidden];
            this._isHidden = isHidden;
            this._callbacks.forEach((callbackFn)=>callbackFn(isHidden));
        };
        this._isHidden = false;
        this._callbacks = new Map();
        this._hidden = undefined;
        this._visibilityChange = undefined;
        if (typeof document !== 'undefined') {
            if (typeof document.hidden !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                this._isHidden = document.hidden;
                this._hidden = 'hidden';
                this._visibilityChange = 'visibilitychange';
            } else if (typeof document.msHidden !== 'undefined') {
                this._isHidden = document.msHidden;
                this._hidden = 'msHidden';
                this._visibilityChange = 'msvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                this._isHidden = document.webkitHidden;
                this._hidden = 'webkitHidden';
                this._visibilityChange = 'webkitvisibilitychange';
            }
            if (typeof document.addEventListener !== 'undefined' && this._hidden !== undefined) this._bindEventListeners();
        }
    }
}

});

parcelRegister("b6hzQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $03d7fd3b062cbce2$export$2e2bcd8739ae039);
class $03d7fd3b062cbce2$export$2e2bcd8739ae039 {
    clearMarks(...args) {
        if (!this._performance || !this._performance.clearMarks) return;
        this._performance.clearMarks(...args);
    }
    mark(...args) {
        if (!this._performance || !this._performance.mark) return;
        this._performance.mark(...args);
    }
    getEntriesByName(...args) {
        if (!this._performance || !this._performance.getEntriesByName) return [];
        return this._performance.getEntriesByName(...args);
    }
    getTimeOrigin() {
        if (!this._performance || !this._performance.timeOrigin && !this._performance.timing) return 0;
        return this._performance.timeOrigin || this._performance.timing.navigationStart;
    }
    now() {
        if (!this._performance || !this._performance.now) return Date.now ? Date.now() : +new Date();
        return this._performance.now();
    }
    isAvailable() {
        return !!this._performance && !!this._performance.clearMarks && !!this._performance.mark && !!this._performance.getEntriesByName && !!this._performance.timing;
    }
    constructor(){
        this._performance = void 0;
        this._performance = window.performance;
    }
}

});


parcelRegister("7Yhrz", function(module, exports) {
$parcel$export(module.exports, "default", () => $3aa28fe238b4c23c$export$2e2bcd8739ae039);
/**
 * Wraps {possibleFn} into a error-safe function and handles cases where {possibleFn}
 * is a function or object
 *
 * @param possibleFn - function that returns and object or the object itself
 * @param errorMessage - error message to log if {possibleFn} is a function and
 *                        throws an error when called
 * @returns {Function}
 */ const $3aa28fe238b4c23c$var$isFunction = (possibleFn)=>typeof possibleFn === 'function';
var $3aa28fe238b4c23c$export$2e2bcd8739ae039 = (possibleFn, errorMessage)=>{
    return ()=>{
        if ($3aa28fe238b4c23c$var$isFunction(possibleFn)) try {
            return possibleFn();
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`${errorMessage} - ${e instanceof Error ? e.message : String(e)}`);
            return undefined;
        }
        return possibleFn;
    };
};

});

parcelRegister("23Ap4", function(module, exports) {
$parcel$export(module.exports, "default", () => $e939455e1a181cdb$export$2e2bcd8739ae039);

var $7Oktg = parcelRequire("7Oktg");
var $gaky7 = parcelRequire("gaky7");
var $6dDWZ = parcelRequire("6dDWZ");

var $cnjKG = parcelRequire("cnjKG");

var $2tp3i = parcelRequire("2tp3i");

var $hn1K9 = parcelRequire("hn1K9");
const $e939455e1a181cdb$var$isCrossProductInteractionAttribute = (_, paramName)=>{
    return paramName === (0, $gaky7.URL_QUERY_PARAM_INTERACTION_SESSION);
};
class $e939455e1a181cdb$export$2e2bcd8739ae039 {
    getInteractionSession() {
        if (this.isEnabled && this.analyticsCrossProductInteractionClient) return {
            bridge: this.analyticsCrossProductInteractionClient.getBridge(),
            id: this.analyticsCrossProductInteractionClient.getCurrentInteractionSessionId(),
            prevId: this.analyticsCrossProductInteractionClient.getPreviousInteractionSessionId(),
            source: this.analyticsCrossProductInteractionClient.getInteractionSource()
        };
        else return {
            bridge: null,
            id: null,
            prevId: null,
            source: null
        };
    }
    /**
   * Validates the cross product interaction session parameters parsed from the URL (if present)
   * If the Base64-encoded URL does not decode into a valid JSON object
   *
   * This method must be called out of the constructor, as the sendEventCallback we expect here
   * depends on crossProductInteractionTracking.getInteractionSession() so the class must be initialised
   */ validateInteractionSession() {
        if (!this.urlValidation.result) this.sendEventCallback({
            action: 'corrupted',
            actionSubject: 'interactionSession',
            attributes: {
                url: this.urlValidation.url
            },
            source: 'interactionComponent',
            tags: [
                'navigationExperiences'
            ] // InteractionSession events will be registered under this platform product
        });
    }
    constructor(options){
        this.analyticsCrossProductInteractionClient = void 0;
        this.isEnabled = void 0;
        this.urlValidation = void 0;
        this.sendEventCallback = void 0;
        this.validProduct = false;
        this.isEnabled = (0, $cnjKG.fg)('analytics_cross_product_interaction_tracking') && options.perimeter !== (0, $2tp3i.perimeterType).FEDRAMP_MODERATE;
        this.urlValidation = {
            result: true,
            url: ''
        };
        this.sendEventCallback = options.sendEventCallback;
        if (this.isEnabled) {
            let bridge;
            let interactionSessionId;
            let interactionSource;
            let interactionSessionOptions;
            this.urlValidation.url = window.location.href;
            // Validate product
            //
            // Various UI components in the page might initialize their own AWC instances but some of those
            // instances might be associated with subordinate products that are of no interest to XPC tracking. We
            // want to avoid XPC meta analytics being fired against uninteresting products.
            //
            // Some products (e.g. Confluence) also have custom URL replace functions passed into AWC settings,
            // and we need to use those to ensure our query parameter is correctly processed.
            //
            // TODO - this is currently the best way we can try and guarantee that the most relevant product's AWC
            // is passing in the options. Down the line we ideally want the relevant products themselves to opt-in
            // to initialising cross product tracking via a flag in their AWC init options.
            this.validProduct = (0, $6dDWZ.validProducts).includes(options.product);
            if (this.validProduct) {
                // Only parse URL parameters if we are in a valid product
                const crossProductUrlPramater = (0, $hn1K9.default)($e939455e1a181cdb$var$isCrossProductInteractionAttribute, options.historyReplaceFn);
                const interactionSessionBlob = (0, $gaky7.URL_QUERY_PARAM_INTERACTION_SESSION) in crossProductUrlPramater ? crossProductUrlPramater[0, $gaky7.URL_QUERY_PARAM_INTERACTION_SESSION] : null;
                if (interactionSessionBlob) try {
                    const interactionSession = JSON.parse(atob(interactionSessionBlob));
                    if (interactionSession.bridge && interactionSession.id && interactionSession.source) {
                        // All 3 fields must be present from a valid query param
                        bridge = interactionSession.bridge;
                        interactionSessionId = interactionSession.id;
                        interactionSource = interactionSession.source;
                    } else this.urlValidation.result = false;
                } catch  {
                    // Gracefully fail through if parameter has been corrupted
                    this.urlValidation.result = false;
                }
                interactionSessionOptions = {
                    analyticsEventCallback: this.sendEventCallback,
                    persistedSessionId: interactionSessionId
                };
            }
            // Initialise interaction session client with parsed values if they exist
            this.analyticsCrossProductInteractionClient = new (0, $7Oktg.default)(interactionSessionOptions, bridge, interactionSource);
        }
    }
}

});
parcelRegister("7Oktg", function(module, exports) {
$parcel$export(module.exports, "default", () => $30e84d4fc0b15aa1$export$2e2bcd8739ae039);

var $eSXfa = parcelRequire("eSXfa");

var $cnjKG = parcelRequire("cnjKG");

var $cdh74 = parcelRequire("cdh74");

var $1eqix = parcelRequire("1eqix");
const $30e84d4fc0b15aa1$export$b9dd752fb13352ce = 'interactionSession.source';
const $30e84d4fc0b15aa1$export$e04e3c50573f9af7 = 'interactionSession.bridge';
class $30e84d4fc0b15aa1$export$2e2bcd8739ae039 {
    constructor(interactionSessionOptions, bridge, interactionSource){
        // TODO: Make these fields non-nullable once feature flag removed
        this.safeSessionStorage = void 0;
        this.interactionSessionTracking = void 0;
        this.isEnabled = void 0;
        this.getCurrentInteractionSessionId = ()=>this.isEnabled && this.interactionSessionTracking ? this.interactionSessionTracking.getCurrentInteractionSessionId() : null;
        this.getPreviousInteractionSessionId = ()=>this.isEnabled && this.interactionSessionTracking ? this.interactionSessionTracking.getPreviousInteractionSessionId() : null;
        this.getBridge = ()=>this.isEnabled && this.safeSessionStorage ? this.safeSessionStorage.getItem($30e84d4fc0b15aa1$export$e04e3c50573f9af7) : null;
        this.getInteractionSource = ()=>this.isEnabled && this.safeSessionStorage ? this.safeSessionStorage.getItem($30e84d4fc0b15aa1$export$b9dd752fb13352ce) : null;
        this.isEnabled = (0, $cnjKG.fg)('analytics_cross_product_interaction_tracking') && !(0, $eSXfa.isFedrampModerate)();
        if (this.isEnabled) {
            // Get singleton interaction session tracking instance
            this.interactionSessionTracking = (0, $cdh74.default).getInstance();
            let isValidPersistedId = false;
            if (this.interactionSessionTracking) {
                if (interactionSessionOptions) {
                    this.interactionSessionTracking.setAnalyticsCallback(interactionSessionOptions.analyticsEventCallback);
                    isValidPersistedId = this.interactionSessionTracking.setInteractionSessionId(interactionSessionOptions.persistedSessionId);
                }
            }
            this.safeSessionStorage = new (0, $1eqix.default)();
            // Store other interaction session parameters directly in session storage if ID has been validated
            if (isValidPersistedId) {
                bridge && this.safeSessionStorage.setItem($30e84d4fc0b15aa1$export$e04e3c50573f9af7, bridge);
                interactionSource && this.safeSessionStorage.setItem($30e84d4fc0b15aa1$export$b9dd752fb13352ce, interactionSource);
            }
        }
    }
}

});
parcelRegister("eSXfa", function(module, exports) {
$parcel$export(module.exports, "isIsolatedCloud", () => $5504f6d2d4d85944$export$9186ccba8effc5de);
$parcel$export(module.exports, "isFedrampModerate", () => $5504f6d2d4d85944$export$104cb891a6e90b3a);
$parcel$export(module.exports, "isolationContextId", () => $5504f6d2d4d85944$export$839b022803d38d4d);

var $ey7YH = parcelRequire("ey7YH");

var $kanwJ = parcelRequire("kanwJ");
function $5504f6d2d4d85944$export$9186ccba8effc5de() {
    if (typeof document === 'undefined') // @ts-ignore
    return globalThis.ssrContext.isInIC;
    const atlCtxCookieValues = (0, $kanwJ.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    // The icDomain check is needed for when federal perimeters are eventually added to Isolated Cloud as well
    return (0, $ey7YH.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
}
function $5504f6d2d4d85944$export$104cb891a6e90b3a() {
    if (typeof document === 'undefined') // @ts-ignore
    return globalThis.ssrContext.isInFedramp;
    const atlCtxCookieValues = (0, $kanwJ.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    return atlCtxCookieValues.perimeter === (0, $ey7YH.FEDRAMP_MODERATE);
}
function $5504f6d2d4d85944$export$80638ee198476daf() {
    if (typeof document === 'undefined') return globalThis.location.hostname;
    const atlCtxCookieValues = (0, $kanwJ.parseAtlCtxCookies)();
    return atlCtxCookieValues?.icDomain;
}
function $5504f6d2d4d85944$export$839b022803d38d4d() {
    if (typeof document === 'undefined') // @ts-ignore
    return $5504f6d2d4d85944$export$9186ccba8effc5de() ? globalThis.ssrContext.icName : undefined;
    const atlCtxCookieValues = (0, $kanwJ.parseAtlCtxCookies)();
    return atlCtxCookieValues?.icId;
}
function $5504f6d2d4d85944$export$9e04105551ffc5c4() {
    if (typeof document === 'undefined') return $5504f6d2d4d85944$var$cloudEnvironmentSsrLookup();
    return $5504f6d2d4d85944$var$cloudEnvironmentCookieLookup();
}
function $5504f6d2d4d85944$var$cloudEnvironmentSsrLookup() {
    // @ts-ignore
    if (globalThis.ssrContext.isInIC === true) return {
        type: 'isolated-cloud',
        perimeter: (0, $ey7YH.COMMERCIAL)
    };
    // @ts-ignore
    if (globalThis.ssrContext.isInFedramp === true) return {
        type: 'non-isolated-cloud',
        perimeter: (0, $ey7YH.FEDRAMP_MODERATE)
    };
    return {
        type: 'non-isolated-cloud',
        perimeter: (0, $ey7YH.COMMERCIAL)
    };
}
function $5504f6d2d4d85944$var$cloudEnvironmentCookieLookup() {
    // Avoid calling isFedrampModerate() and isIsolatedCloud() here to avoid repeated cookie parsing
    const atlCtxCookieValues = (0, $kanwJ.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return {
        type: 'non-isolated-cloud',
        perimeter: (0, $ey7YH.COMMERCIAL)
    };
    const isIc = (0, $ey7YH.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
    if (isIc) return {
        type: 'isolated-cloud',
        perimeter: (0, $ey7YH.COMMERCIAL)
    };
    if (atlCtxCookieValues.perimeter === (0, $ey7YH.FEDRAMP_MODERATE)) return {
        type: 'non-isolated-cloud',
        perimeter: (0, $ey7YH.FEDRAMP_MODERATE)
    };
    // If a new cloud environment has been created but not added to this library, return undefined
    return undefined;
}

});
parcelRegister("ey7YH", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $59fbc85f845c20d8$export$ce553301d55c2fd8);
$parcel$export(module.exports, "COMMERCIAL", () => $59fbc85f845c20d8$export$f005e2e9f707cb5f);
$parcel$export(module.exports, "ISOLATED_CLOUD_PERIMETERS", () => $59fbc85f845c20d8$export$d8347b4aae768c2d);
$parcel$export(module.exports, "ATL_CTX_PERIMETER", () => $59fbc85f845c20d8$export$87285944378c596);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_DOMAIN", () => $59fbc85f845c20d8$export$715603e81922c3ec);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_ID", () => $59fbc85f845c20d8$export$a0ffa0598c95dfb7);
const $59fbc85f845c20d8$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $59fbc85f845c20d8$export$f005e2e9f707cb5f = 'commercial';
const $59fbc85f845c20d8$export$a739cd5aac835909 = 'staging';
const $59fbc85f845c20d8$export$42dd0cdd351a4a9 = 'prod';
const $59fbc85f845c20d8$export$404582bc18fe4d9e = 'dev';
const $59fbc85f845c20d8$export$d8347b4aae768c2d = [
    $59fbc85f845c20d8$export$f005e2e9f707cb5f
];
const $59fbc85f845c20d8$export$b1b1ccc8f3e7f954 = [
    $59fbc85f845c20d8$export$f005e2e9f707cb5f,
    $59fbc85f845c20d8$export$ce553301d55c2fd8
];
const $59fbc85f845c20d8$export$87285944378c596 = 'Atl-Ctx-Perimeter';
const $59fbc85f845c20d8$export$715603e81922c3ec = 'Atl-Ctx-Isolation-Context-Domain';
const $59fbc85f845c20d8$export$a0ffa0598c95dfb7 = 'Atl-Ctx-Isolation-Context-Id';

});

parcelRegister("kanwJ", function(module, exports) {
$parcel$export(module.exports, "parseAtlCtxCookies", () => $26aa5cc02c2a2259$export$3fa7b7af96286cc9);

var $ey7YH = parcelRequire("ey7YH");
/**
 * Internal helper function used to parse cookie values and extract value of provided cookie name
 * @param {AtlCtxCookieName} cookieName - The name of the cookie to extract
 * @param {string} cookieString - The full cookie string
 * @returns {string | undefined} - The cookie value if present, undefined otherwise
 */ function $26aa5cc02c2a2259$var$getRawCookieValue(cookieName, cookieString) {
    if (!cookieString) return undefined;
    const cookies = cookieString.split(';');
    for (const cookie of cookies){
        const [name, value] = cookie.trim().split('=');
        if (name === cookieName) return value;
    }
    return undefined;
}
function $26aa5cc02c2a2259$export$3fa7b7af96286cc9() {
    const global = globalThis;
    try {
        // HOT-118791: the code below doesn't work on the server, and creates log spam in the catch block - "Cannot read properties of undefined (reading 'cookie')"
        if (typeof globalThis.document === 'undefined') return undefined;
        const cookies = global.document.cookie;
        const perimeter = $26aa5cc02c2a2259$var$getRawCookieValue((0, $ey7YH.ATL_CTX_PERIMETER), cookies);
        if (!perimeter) // Indicative of non-isolated commercial perimeter
        return undefined;
        const icDomain = $26aa5cc02c2a2259$var$getRawCookieValue((0, $ey7YH.ATL_CTX_ISOLATION_CONTEXT_DOMAIN), cookies);
        const icId = $26aa5cc02c2a2259$var$getRawCookieValue((0, $ey7YH.ATL_CTX_ISOLATION_CONTEXT_ID), cookies);
        // The IC Domain and IC Id cookie values are empty strings for non Isolated Cloud
        const emptyIcDomain = !icDomain || icDomain.length === 0;
        const emptyIcId = !icId || icId.length === 0;
        return {
            perimeter: perimeter,
            icDomain: emptyIcDomain ? undefined : icDomain,
            icId: emptyIcId ? undefined : icId
        };
    } catch (e) {
        console.warn('Failed to parse atl-ctx cookies:', e);
        return undefined;
    }
}

});


parcelRegister("cnjKG", function(module, exports) {
$parcel$export(module.exports, "setBooleanFeatureFlagResolver", () => $417fb459440de5b8$export$ba05d765b8392e5e);
$parcel$export(module.exports, "fg", () => $417fb459440de5b8$export$b40ec24ac8275656);

var $jzmMj = parcelRequire("jzmMj");
function $417fb459440de5b8$export$ba05d765b8392e5e(flagResolver) {
    (0, $jzmMj.setBooleanResolver)(flagResolver);
}
function $417fb459440de5b8$export$470e5c2be1411c89(name) {
    return (0, $jzmMj.resolveBooleanFlag)(name);
}
function $417fb459440de5b8$export$b40ec24ac8275656(name) {
    return (0, $jzmMj.resolveBooleanFlag)(name);
}

});
parcelRegister("jzmMj", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", () => $e2853bf795e0501e$export$f2b591175b3e424c);
$parcel$export(module.exports, "resolveBooleanFlag", () => $e2853bf795e0501e$export$6333b6aff9fc6275);

var $aE6gq = parcelRequire("aE6gq");

var $10fSH = parcelRequire("10fSH");

var $1CHRc = parcelRequire("1CHRc");
const $e2853bf795e0501e$var$pkgName = '@atlaskit/platform-feature-flags';
const $e2853bf795e0501e$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
const $e2853bf795e0501e$var$hasProcessEnv = typeof $1CHRc !== 'undefined' && typeof $1CHRc.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
const $e2853bf795e0501e$var$ENV_ENABLE_PLATFORM_FF = $e2853bf795e0501e$var$hasProcessEnv ? false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
const $e2853bf795e0501e$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $e2853bf795e0501e$var$hasProcessEnv ? false : false;
const $e2853bf795e0501e$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $e2853bf795e0501e$var$ENV_ENABLE_PLATFORM_FF || $e2853bf795e0501e$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
const $e2853bf795e0501e$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
const $e2853bf795e0501e$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$e2853bf795e0501e$var$globalVar[$e2853bf795e0501e$export$7e41b1b2bdee3f98] = $e2853bf795e0501e$var$globalVar[$e2853bf795e0501e$export$7e41b1b2bdee3f98] || $e2853bf795e0501e$var$DEFAULT_PFF_GLOBAL;
function $e2853bf795e0501e$export$f2b591175b3e424c(resolver) {
    $e2853bf795e0501e$var$globalVar[$e2853bf795e0501e$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $e2853bf795e0501e$export$6333b6aff9fc6275(flagKey) {
    if ($e2853bf795e0501e$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $10fSH.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $e2853bf795e0501e$var$pkgName, flagKey);
        return true;
    }
    try {
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if ($e2853bf795e0501e$var$globalVar[$e2853bf795e0501e$export$7e41b1b2bdee3f98]?.booleanResolver === undefined || $e2853bf795e0501e$var$globalVar[$e2853bf795e0501e$export$7e41b1b2bdee3f98]?.booleanResolver === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $aE6gq.default).checkGate(flagKey);
        const result = $e2853bf795e0501e$var$globalVar[$e2853bf795e0501e$export$7e41b1b2bdee3f98]?.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn(`${flagKey} resolved to a non-boolean value, returning false for safety`);
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("aE6gq", function(module, exports) {
$parcel$export(module.exports, "default", () => $de0dae9454f494c5$export$2e2bcd8739ae039);

var $ltYPx = parcelRequire("ltYPx");

var $hTRuQ = parcelRequire("hTRuQ");



var $de0dae9454f494c5$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ class $de0dae9454f494c5$var$FeatureGates {
    static isGateExists(gateName) {
        return this.client.isGateExist(gateName);
    }
    static isExperimentExists(experimentName) {
        return this.client.isExperimentExist(experimentName);
    }
}
$de0dae9454f494c5$var$_FeatureGates = $de0dae9454f494c5$var$FeatureGates;
$de0dae9454f494c5$var$FeatureGates.client = new (0, $ltYPx.Client)();
$de0dae9454f494c5$var$FeatureGates.hasCheckGateErrorOccurred = false;
$de0dae9454f494c5$var$FeatureGates.hasGetExperimentValueErrorOccurred = false;
$de0dae9454f494c5$var$FeatureGates.checkGate = (gateName, options)=>{
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            const overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$de0dae9454f494c5$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $de0dae9454f494c5$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $de0dae9454f494c5$var$_FeatureGates.client.checkGate(gateName, options);
};
$de0dae9454f494c5$var$FeatureGates.getExperimentValue = (experimentName, parameterName, defaultValue, options)=>{
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            const overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$de0dae9454f494c5$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $de0dae9454f494c5$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $de0dae9454f494c5$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
};
$de0dae9454f494c5$var$FeatureGates.initializeCalled = $de0dae9454f494c5$var$_FeatureGates.client.initializeCalled.bind($de0dae9454f494c5$var$_FeatureGates.client);
$de0dae9454f494c5$var$FeatureGates.initializeCompleted = $de0dae9454f494c5$var$_FeatureGates.client.initializeCompleted.bind($de0dae9454f494c5$var$_FeatureGates.client);
$de0dae9454f494c5$var$FeatureGates.waitUntilInitializeCompleted = $de0dae9454f494c5$var$_FeatureGates.client.waitUntilInitializeCompleted.bind($de0dae9454f494c5$var$_FeatureGates.client);
$de0dae9454f494c5$var$FeatureGates.initialize = $de0dae9454f494c5$var$_FeatureGates.client.initialize.bind($de0dae9454f494c5$var$_FeatureGates.client);
$de0dae9454f494c5$var$FeatureGates.initializeWithProvider = $de0dae9454f494c5$var$_FeatureGates.client.initializeWithProvider.bind($de0dae9454f494c5$var$_FeatureGates.client);
$de0dae9454f494c5$var$FeatureGates.initializeFromValues = $de0dae9454f494c5$var$_FeatureGates.client.initializeFromValues.bind($de0dae9454f494c5$var$_FeatureGates.client);
$de0dae9454f494c5$var$FeatureGates.manuallyLogGateExposure = $de0dae9454f494c5$var$_FeatureGates.client.manuallyLogGateExposure.bind($de0dae9454f494c5$var$_FeatureGates.client);
$de0dae9454f494c5$var$FeatureGates.getExperiment = $de0dae9454f494c5$var$_FeatureGates.client.getExperiment.bind($de0dae9454f494c5$var$_FeatureGates.client);
$de0dae9454f494c5$var$FeatureGates.manuallyLogExperimentExposure = $de0dae9454f494c5$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($de0dae9454f494c5$var$_FeatureGates.client);
$de0dae9454f494c5$var$FeatureGates.manuallyLogLayerExposure = $de0dae9454f494c5$var$_FeatureGates.client.manuallyLogLayerExposure.bind($de0dae9454f494c5$var$_FeatureGates.client);
$de0dae9454f494c5$var$FeatureGates.shutdownStatsig = $de0dae9454f494c5$var$_FeatureGates.client.shutdownStatsig.bind($de0dae9454f494c5$var$_FeatureGates.client);
$de0dae9454f494c5$var$FeatureGates.overrideGate = $de0dae9454f494c5$var$_FeatureGates.client.overrideGate.bind($de0dae9454f494c5$var$_FeatureGates.client);
$de0dae9454f494c5$var$FeatureGates.clearGateOverride = $de0dae9454f494c5$var$_FeatureGates.client.clearGateOverride.bind($de0dae9454f494c5$var$_FeatureGates.client);
$de0dae9454f494c5$var$FeatureGates.overrideConfig = $de0dae9454f494c5$var$_FeatureGates.client.overrideConfig.bind($de0dae9454f494c5$var$_FeatureGates.client);
$de0dae9454f494c5$var$FeatureGates.clearConfigOverride = $de0dae9454f494c5$var$_FeatureGates.client.clearConfigOverride.bind($de0dae9454f494c5$var$_FeatureGates.client);
$de0dae9454f494c5$var$FeatureGates.setOverrides = $de0dae9454f494c5$var$_FeatureGates.client.setOverrides.bind($de0dae9454f494c5$var$_FeatureGates.client);
$de0dae9454f494c5$var$FeatureGates.getOverrides = $de0dae9454f494c5$var$_FeatureGates.client.getOverrides.bind($de0dae9454f494c5$var$_FeatureGates.client);
$de0dae9454f494c5$var$FeatureGates.clearAllOverrides = $de0dae9454f494c5$var$_FeatureGates.client.clearAllOverrides.bind($de0dae9454f494c5$var$_FeatureGates.client);
$de0dae9454f494c5$var$FeatureGates.isCurrentUser = $de0dae9454f494c5$var$_FeatureGates.client.isCurrentUser.bind($de0dae9454f494c5$var$_FeatureGates.client);
$de0dae9454f494c5$var$FeatureGates.onGateUpdated = $de0dae9454f494c5$var$_FeatureGates.client.onGateUpdated.bind($de0dae9454f494c5$var$_FeatureGates.client);
$de0dae9454f494c5$var$FeatureGates.onExperimentValueUpdated = $de0dae9454f494c5$var$_FeatureGates.client.onExperimentValueUpdated.bind($de0dae9454f494c5$var$_FeatureGates.client);
$de0dae9454f494c5$var$FeatureGates.onAnyUpdated = $de0dae9454f494c5$var$_FeatureGates.client.onAnyUpdated.bind($de0dae9454f494c5$var$_FeatureGates.client);
$de0dae9454f494c5$var$FeatureGates.updateUser = $de0dae9454f494c5$var$_FeatureGates.client.updateUser.bind($de0dae9454f494c5$var$_FeatureGates.client);
$de0dae9454f494c5$var$FeatureGates.updateUserWithProvider = $de0dae9454f494c5$var$_FeatureGates.client.updateUserWithProvider.bind($de0dae9454f494c5$var$_FeatureGates.client);
$de0dae9454f494c5$var$FeatureGates.updateUserWithValues = $de0dae9454f494c5$var$_FeatureGates.client.updateUserWithValues.bind($de0dae9454f494c5$var$_FeatureGates.client);
$de0dae9454f494c5$var$FeatureGates.getPackageVersion = $de0dae9454f494c5$var$_FeatureGates.client.getPackageVersion.bind($de0dae9454f494c5$var$_FeatureGates.client);
$de0dae9454f494c5$var$FeatureGates.getLayer = $de0dae9454f494c5$var$_FeatureGates.client.getLayer.bind($de0dae9454f494c5$var$_FeatureGates.client);
$de0dae9454f494c5$var$FeatureGates.getLayerValue = $de0dae9454f494c5$var$_FeatureGates.client.getLayerValue.bind($de0dae9454f494c5$var$_FeatureGates.client);
let $de0dae9454f494c5$var$boundFGJS = $de0dae9454f494c5$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $de0dae9454f494c5$var$FeatureGates;
    else {
        $de0dae9454f494c5$var$boundFGJS = window.__FEATUREGATES_JS__;
        const boundVersion = $de0dae9454f494c5$var$boundFGJS?.getPackageVersion?.() || '4.10.0 or earlier';
        if (boundVersion !== (0, $hTRuQ.CLIENT_VERSION)) {
            const message = `Multiple versions of FeatureGateClients found on the current page.
      The currently bound version is ${boundVersion} when module version ${(0, $hTRuQ.CLIENT_VERSION)} was loading.`;
            // eslint-disable-next-line no-console
            console.warn(message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $de0dae9454f494c5$export$2e2bcd8739ae039 = $de0dae9454f494c5$var$boundFGJS;

});
parcelRegister("ltYPx", function(module, exports) {
$parcel$export(module.exports, "Client", () => $52111bcf561f75fb$export$1f2bb630327ac4b6);

var $8OdXD = parcelRequire("8OdXD");

var $1MvZt = parcelRequire("1MvZt");

var $cN9Jw = parcelRequire("cN9Jw");

var $6sdY6 = parcelRequire("6sdY6");

var $lbjMe = parcelRequire("lbjMe");

var $2zROK = parcelRequire("2zROK");

var $fP8Sl = parcelRequire("fP8Sl");

var $2A6OJ = parcelRequire("2A6OJ");

var $5g8Kq = parcelRequire("5g8Kq");

var $fOW7o = parcelRequire("fOW7o");

var $hTRuQ = parcelRequire("hTRuQ");
const $52111bcf561f75fb$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
const $52111bcf561f75fb$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
class $52111bcf561f75fb$export$1f2bb630327ac4b6 {
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ async initialize(clientOptions, identifiers, customAttributes) {
        const clientOptionsWithDefaults = (0, $fOW7o.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $fOW7o.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initialize', this.initCompleted, clientOptionsWithDefaults.apiKey);
        });
        return this.initPromise;
    }
    /**
   * @description
   * This method initializes the client using the provider given to call to fetch the bootstrap values.
   * If the client is initialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param provider {Provider}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ async initializeWithProvider(clientOptions, provider, identifiers, customAttributes) {
        const clientOptionsWithDefaults = (0, $fOW7o.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $fOW7o.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.provider = provider;
        this.provider.setClientVersion((0, $hTRuQ.CLIENT_VERSION));
        if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
        this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initializeWithProvider', this.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
        });
        return this.initPromise;
    }
    applyUpdateCallback(experimentsResult) {
        try {
            if (this.initCompleted || this.initWithDefaults) {
                this.assertInitialized(this.statsigClient);
                this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                this.statsigValuesUpdated();
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn('Error when attempting to apply update', error);
        }
    }
    fireClientEvent(startTime, totalTime, action, success, apiKey) {
        this.initOptions.analyticsWebClient?.then((analyticsWebClient)=>{
            const attributes = {
                targetApp: this.initOptions.targetApp,
                clientVersion: (0, $hTRuQ.CLIENT_VERSION),
                success: success,
                startTime: startTime,
                totalTime: totalTime,
                ...apiKey && {
                    apiKey: apiKey
                }
            };
            analyticsWebClient.sendOperationalEvent({
                action: action,
                actionSubject: 'featureGatesClient',
                attributes: attributes,
                tags: [
                    'measurement'
                ],
                source: '@atlaskit/feature-gate-js-client'
            });
        }).catch((err)=>{
            if (this.initOptions.environment !== (0, $5g8Kq.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
            console.error('Analytics web client promise did not resolve', err);
        });
    }
    async initializeFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}) {
        const clientOptionsWithDefaults = (0, $fOW7o.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $fOW7o.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        // This makes sure the new Statsig client behaves like the old when bootstrap data is
        // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
        if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initializeFromValues', this.initCompleted);
        });
        return this.initPromise;
    }
    assertInitialized(statsigClient) {
        if (!statsigClient) throw new Error('Client must be initialized before using this method');
    }
    /**
   * This method updates the user using a network call to fetch the new set of values.
   * @param fetchOptions {FetcherOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   */ async updateUser(fetchOptions, identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        const fetchOptionsWithDefaults = (0, $fOW7o.getOptionsWithDefaults)(fetchOptions);
        const initializeValuesProducer = ()=>(0, $2zROK.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(({ experimentValues: experimentValues, customAttributes: customAttributes })=>({
                    experimentValues: experimentValues,
                    customAttributesFromFetch: customAttributes
                }));
        await this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
    }
    /**
   * This method updates the user using the provider given on initialisation to get the new set of
   * values.
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   */ async updateUserWithProvider(identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        if (!this.provider) throw new Error('Cannot update user using provider as the client was not initialised with a provider');
        await this.provider.setProfile(this.initOptions, identifiers, customAttributes);
        await this.updateUserUsingInitializeValuesProducer(()=>this.provider.getExperimentValues(), identifiers, customAttributes);
    }
    /**
   * This method updates the user given a new set of bootstrap values obtained from one of the
   * server-side SDKs.
   *
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @param initializeValues {Record<string,unknown>}
   */ async updateUserWithValues(identifiers, customAttributes, initializeValues = {}) {
        this.assertInitialized(this.statsigClient);
        const initializeValuesProducer = ()=>Promise.resolve({
                experimentValues: initializeValues,
                customAttributesFromFetch: customAttributes
            });
        await this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
    }
    initializeCalled() {
        return this.initPromise != null;
    }
    initializeCompleted() {
        return this.initCompleted;
    }
    async waitUntilInitializeCompleted() {
        if (!this.initPromise) throw new Error('The client must be initialized before you can wait until initialized.');
        if (this.initCompleted) return;
        await this.initPromise;
    }
    /**
   * Returns the value for a feature gate. Returns false if there are errors.
   * @param {string} gateName - The name of the feature gate.
   * @param {Object} options
   * @param {boolean} options.fireGateExposure
   *        Whether or not to fire the exposure event for the gate. Defaults to true.
   *        To log an exposure event manually at a later time, use {@link Client.manuallyLogGateExposure}
   *        (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   */ checkGate(gateName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireGateExposure: fireGateExposure = true } = options;
            return this.statsigClient.checkGate(gateName, {
                disableExposureLog: !fireGateExposure
            });
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasCheckGateErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                    gateName: gateName,
                    error: error
                });
                this.hasCheckGateErrorOccurred = true;
            }
            return false;
        }
    }
    isGateExist(gateName) {
        try {
            this.assertInitialized(this.statsigClient);
            const gate = this.statsigClient.getFeatureGate(gateName, {
                disableExposureLog: true
            });
            return !gate.details.reason.includes('Unrecognized');
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to check FeatureGate: ${error}`);
            // in case of error report true to avoid false positives.
            return true;
        }
    }
    isExperimentExist(experimentName) {
        try {
            this.assertInitialized(this.statsigClient);
            const config = this.statsigClient.getExperiment(experimentName, {
                disableExposureLog: true
            });
            return !config.details.reason.includes('Unrecognized');
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to check Experiment: ${error}`);
            // in case of error report true to avoid false positives.
            return true;
        }
    }
    /**
   * Manually log a gate exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * This is useful if you have evaluated a gate earlier via {@link Client.checkGate} where
   * <code>options.fireGateExposure</code> is false.
   * @param gateName
   */ manuallyLogGateExposure(gateName) {
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        this.statsigClient.checkGate(gateName);
    }
    /**
   * Returns the entire config for a given experiment.
   *
   * @param {string} experimentName - The name of the experiment
   * @param {Object} options
   * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event
   * for the experiment. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * @returns The config for an experiment
   * @example
   * ```ts
   * const experimentConfig = client.getExperiment('example-experiment-name');
   * const backgroundColor: string = experimentConfig.get('backgroundColor', 'yellow');
   * ```
   */ getExperiment(experimentName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireExperimentExposure: fireExperimentExposure = true } = options;
            return (0, $cN9Jw.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                disableExposureLog: !fireExperimentExposure
            }));
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetExperimentErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                    experimentName: experimentName,
                    error: error
                });
                this.hasGetExperimentErrorOccurred = true;
            }
            // Return a default value
            return new (0, $cN9Jw.DynamicConfig)(experimentName, {}, '', {
                time: Date.now(),
                reason: (0, $lbjMe.EvaluationReason).Error
            });
        }
    }
    /**
   * Returns the value of a given parameter in an experiment config.
   *
   * @template T
   * @param {string} experimentName - The name of the experiment
   * @param {string} parameterName - The name of the parameter to fetch from the experiment config
   * @param {T} defaultValue - The value to serve if the experiment or parameter do not exist, or
   * if the returned value does not match the expected type.
   * @param {Object} options
   * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event
   * for the experiment. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-))
   * @param {function} options.typeGuard - A function that asserts that the return value has the
   * expected type. If this function returns false, then the default value will be returned
   * instead. This can be set to protect your code from unexpected values being set remotely. By
   * default, this will be done by asserting that the default value and value are the same primitive
   * type.
   * @returns The value of the parameter if the experiment and parameter both exist, otherwise the
   * default value.
   * @example
   ``` ts
   type ValidColor = 'blue' | 'red' | 'yellow';
   type ValidColorTypeCheck = (value: unknown) => value is ValidColor;
  	 const isValidColor: ValidColorTypeCheck =
  		(value: unknown) => typeof value === 'string' && ['blue', 'red', 'yellow'].includes(value);
  	 const buttonColor: ValidColor = client.getExperimentValue(
  		'example-experiment-name',
  		'backgroundColor',
  		'yellow',
  		{
  				typeGuard: isValidColor
  		}
   );
   ```
  */ getExperimentValue(experimentName, parameterName, defaultValue, options = {}) {
        const experiment = this.getExperiment(experimentName, options);
        try {
            const { typeGuard: typeGuard } = options;
            return experiment.get(parameterName, defaultValue, typeGuard);
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetExperimentValueErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                    experimentName: experimentName,
                    defaultValue: defaultValue,
                    options: options,
                    error: error
                });
                this.hasGetExperimentValueErrorOccurred = true;
            }
            return defaultValue;
        }
    }
    /**
   * Manually log an experiment exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * This is useful if you have evaluated an experiment earlier via {@link Client.getExperimentValue} or
   * {@link Client.getExperiment} where <code>options.fireExperimentExposure</code> is false.
   * @param experimentName
   */ manuallyLogExperimentExposure(experimentName) {
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        this.statsigClient.getExperiment(experimentName);
    }
    /**
   * Manually log a layer exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * This is useful if you have evaluated a layer earlier via {@link Client.getLayerValue} where <code>options.fireExperimentExposure</code> is false.
   * @param layerName
   * @param parameterName
   */ manuallyLogLayerExposure(layerName, parameterName) {
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        this.statsigClient.getLayer(layerName)?.get(parameterName);
    }
    shutdownStatsig() {
        this.assertInitialized(this.statsigClient);
        this.statsigClient.shutdown();
    }
    /**
   * Adds a new override for the given gate.
   *
   * This method is additive, meaning you can call it multiple times with different gate names to
   * build your full set of overrides.
   *
   * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
   * will continue to affect every client that is initialized on the same domain after this method
   * is called. If you are using this API for testing purposes, you should call
   * {@link Client.clearGateOverride} after your tests are completed to remove this
   * localStorage entry.
   *
   * @param {string} gateName
   * @param {boolean} value
   */ overrideGate(gateName, value) {
        this.overrideAdapter.overrideGate(gateName, value);
        // Trigger a reset of the memoized gate value
        if (this.user) this.statsigClient?.updateUserSync(this.user, {
            disableBackgroundCacheRefresh: true
        });
        this.statsigValuesUpdated();
    }
    /**
   * Removes any overrides that have been set for the given gate.
   */ clearGateOverride(gateName) {
        this.overrideAdapter.removeGateOverride(gateName);
        this.statsigValuesUpdated();
    }
    /**
   * Adds a new override for the given config (or experiment).
   *
   * This method is additive, meaning you can call it multiple times with different experiment
   * names to build your full set of overrides.
   *
   * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
   * will continue to affect every client that is initialized on the same domain after this method
   * is called. If you are using this API for testing purposes, you should call
   * {@link Client.clearConfigOverride} after your tests are completed to remove this
   * localStorage entry.
   *
   * @param {string} experimentName
   * @param {object} values
   */ overrideConfig(experimentName, values) {
        this.overrideAdapter.overrideDynamicConfig(experimentName, values);
        this.statsigValuesUpdated();
    }
    /**
   * Removes any overrides that have been set for the given experiment.
   * @param {string} experimentName
   */ clearConfigOverride(experimentName) {
        this.overrideAdapter.removeDynamicConfigOverride(experimentName);
        this.statsigValuesUpdated();
    }
    /**
   * Set overrides for gates, experiments and layers in batch.
   *
   * Note that these overrides are **not** additive and will completely replace any that have been
   * added via prior calls to {@link Client.overrideConfig} or
   * {@link Client.overrideGate}.
   *
   * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
   * will continue to affect every client that is initialized on the same domain after this method
   * is called. If you are using this API for testing purposes, you should call
   * {@link Client.clearAllOverrides} after your tests are completed to remove this
   * localStorage entry.
   */ setOverrides(overrides) {
        this.overrideAdapter.setOverrides(overrides);
        this.statsigValuesUpdated();
    }
    /**
   * @returns The current overrides for gates, configs (including experiments) and layers.
   */ getOverrides() {
        return this.overrideAdapter.getOverrides();
    }
    /**
   * Clears overrides for all gates, configs (including experiments) and layers.
   */ clearAllOverrides() {
        this.overrideAdapter.removeAllOverrides();
        this.statsigValuesUpdated();
    }
    /**
   * Returns whether the given identifiers and customAttributes align with the current
   * set that is being used by the client.
   *
   * If this method returns false, then the {@link Client.updateUser},
   * {@link Client.updateUserWithValues} or {@link Client.updateUserWithProvider}
   * methods can be used to re-align these values.
   *
   * @param identifiers
   * @param customAttributes
   * @returns a flag indicating whether the clients current configuration aligns with the given values
   */ isCurrentUser(identifiers, customAttributes) {
        return (0, $fOW7o.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $fOW7o.shallowEquals)(this.currentAttributes, customAttributes);
    }
    /**
   * Subscribe to updates where the given callback will be called with the current checkGate value
   * @param gateName
   * @param callback
   * @param options
   * @returns off function to unsubscribe from updates
   */ onGateUpdated(gateName, callback, options = {}) {
        const wrapCallback = (value)=>{
            const { fireGateExposure: fireGateExposure = true } = options;
            if (fireGateExposure) this.manuallyLogGateExposure(gateName);
            try {
                callback(value);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.warn(`Error calling callback for gate ${gateName} with value ${value}`, error);
            }
        };
        return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
    }
    /**
   * Subscribe to updates where the given callback will be called with the current experiment value
   * @param experimentName
   * @param parameterName
   * @param defaultValue
   * @param callback
   * @param options
   * @returns off function to unsubscribe from updates
   */ onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, options = {}) {
        const wrapCallback = (value)=>{
            const { fireExperimentExposure: fireExperimentExposure = true } = options;
            if (fireExperimentExposure) this.manuallyLogExperimentExposure(experimentName);
            try {
                callback(value);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.warn(`Error calling callback for experiment ${experimentName} with value ${value}`, error);
            }
        };
        return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
    }
    /**
   * Subscribe so on any update the callback will be called.
   * NOTE: The callback will be called whenever the values are updated even if the values have not
   * changed.
   * @param callback
   * @returns off function to unsubscribe from updates
   */ onAnyUpdated(callback) {
        return this.subscriptions.onAnyUpdated(callback);
    }
    /**
   * This method initializes the client using a network call to fetch the bootstrap values for the
   * given user.
   *
   * @param clientOptions
   * @param identifiers
   * @param customAttributes
   * @private
   */ async init(clientOptions, identifiers, customAttributes) {
        const fromValuesClientOptions = {
            ...clientOptions
        };
        let experimentValues;
        let customAttributesFromResult;
        try {
            // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
            // the experiment values request to be settled, and it will fall back to use default values.
            const clientSdkKeyPromise = (0, $2zROK.default).fetchClientSdk(clientOptions).then((value)=>fromValuesClientOptions.sdkKey = value.clientSdkKey);
            const experimentValuesPromise = (0, $2zROK.default).fetchExperimentValues(clientOptions, identifiers, customAttributes);
            // Only wait for the experiment values request to finish and try to initialise the client
            // with experiment values if both requests are successful. Else an error would be thrown and
            // handled by the catch
            const [, experimentValuesResult] = await Promise.all([
                clientSdkKeyPromise,
                experimentValuesPromise
            ]);
            experimentValues = experimentValuesResult.experimentValues;
            customAttributesFromResult = experimentValuesResult.customAttributes;
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to fetch the Feature Gates client values, error: ${error?.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client without values`);
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            throw error;
        }
        return this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
    }
    async initWithProvider(baseClientOptions, provider, identifiers, customAttributes) {
        const fromValuesClientOptions = {
            ...baseClientOptions,
            disableCurrentPageLogging: true
        };
        let experimentValues;
        let customAttributesFromResult;
        try {
            await provider.setProfile(baseClientOptions, identifiers, customAttributes);
            // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
            // the experiment values request to be settled, and it will fall back to use default values.
            const clientSdkKeyPromise = provider.getClientSdkKey().then((value)=>fromValuesClientOptions.sdkKey = value);
            const experimentValuesPromise = provider.getExperimentValues();
            // Only wait for the experiment values request to finish and try to initialise the client
            // with experiment values if both requests are successful. Else an error would be thrown and
            // handled by the catch
            const [, experimentValuesResult] = await Promise.all([
                clientSdkKeyPromise,
                experimentValuesPromise
            ]);
            experimentValues = experimentValuesResult.experimentValues;
            customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to fetch the Feature Gates client values, error: ${error?.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client without values`);
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            throw error;
        }
        return this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
    }
    /**
   * This method initializes the client using a set of boostrap values obtained from one of the
   * server-side SDKs.
   *
   * @param clientOptions
   * @param identifiers
   * @param customAttributes
   * @param initializeValues
   * @private
   */ async initFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}) {
        this.overrideAdapter.initFromStoredOverrides();
        this.currentIdentifiers = identifiers;
        this.currentAttributes = customAttributes;
        const newClientOptions = (0, $fOW7o.migrateInitializationOptions)(clientOptions);
        if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $52111bcf561f75fb$var$DEFAULT_CLIENT_KEY;
        if (!newClientOptions.networkConfig?.logEventUrl) newClientOptions.networkConfig = {
            ...newClientOptions.networkConfig,
            logEventUrl: $52111bcf561f75fb$var$DEFAULT_EVENT_LOGGING_API
        };
        if (newClientOptions.perimeter === (0, $5g8Kq.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
        newClientOptions.disableLogging = true;
        const { sdkKey: sdkKey, environment: environment, updateUserCompletionCallback: _updateUserCompletionCallback, perimeter: _perimeter, ...restClientOptions } = newClientOptions;
        this.user = (0, $fOW7o.toStatsigUser)(identifiers, customAttributes);
        const statsigOptions = {
            ...restClientOptions,
            environment: {
                tier: environment
            },
            includeCurrentPageUrlWithEvents: false,
            dataAdapter: this.dataAdapter,
            overrideAdapter: this.overrideAdapter,
            logEventCompressionMode: (0, $8OdXD.LogEventCompressionMode).Forced
        };
        // Statsig validates the provided stableId against their own cookie, so we either need
        // to update the cookie to match, or disable the validation completely.
        if (identifiers.stableId) (0, $8OdXD.StableID).setOverride(identifiers.stableId, sdkKey);
        else statsigOptions.disableStableID = true;
        try {
            this.statsigClient = new (0, $8OdXD.StatsigClient)(sdkKey, this.user, statsigOptions);
            this.dataAdapter.setBootstrapData(initializeValues);
            await this.statsigClient.initializeAsync();
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to initialise the Statsig client, error: ${error?.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client with default sdk key and without values`);
            this.statsigClient = new (0, $8OdXD.StatsigClient)($52111bcf561f75fb$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
            this.dataAdapter.setBootstrapData();
            await this.statsigClient.initializeAsync();
            this.initWithDefaults = true;
            throw error;
        }
    }
    /**
   * This method updates the user for this client with the bootstrap values returned from a given
   * Promise.
   * It uses the customAttributes from fetching experiment values to update the Statsig user but
   * uses the customAttributes from given input to check if the user has changed.
   *
   * @param {Identifiers} identifiers
   * @param {CustomAttributes} customAttributes
   * @param {Promise<InitializeValues>} getInitializeValues
   * @private
   */ async updateUserUsingInitializeValuesProducer(getInitializeValues, identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        if (!this.initPromise) throw new Error('The client must be initialized before you can update the user.');
        // If the user isn't changing at all, then exit immediately
        if (this.isCurrentUser(identifiers, customAttributes)) return this.initPromise;
        // Wait for the current initialize/update to finish
        const originalInitPromise = this.initPromise;
        try {
            await this.initPromise;
        } catch (err) {
        // Proceed with the user update even if the init failed, since this update
        // may put the client back into a valid state.
        }
        const initializeValuesPromise = getInitializeValues();
        const updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes);
        // We replace the init promise here since we are essentially re-initializing the client at this
        // point. Any subsequent calls to await client.initialize() or client.updateUser()
        // will now also await this user update.
        this.initPromise = updateUserPromise.catch(async ()=>{
            // If the update failed then it changed nothing, so revert back to the original promise.
            this.initPromise = originalInitPromise;
            // Set the user profile again to revert back to the current user
            if (this.provider) await this.provider.setProfile(this.initOptions, this.currentIdentifiers, this.currentAttributes);
        });
        return updateUserPromise;
    }
    /**
   * This method updates the user on the nested Statsig client
   *
   * @param identifiers
   * @param customAttributes
   * @param initializeValuesPromise
   * @private
   */ async updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        let initializeValues, user;
        try {
            initializeValues = await initializeValuesPromise;
            user = (0, $fOW7o.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
        } catch (err) {
            // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
            // This is not necessary for the updateUserWithValues call, because the Statsig client will
            // already invoke the callback itself.
            const errMsg = err instanceof Error ? err.message : JSON.stringify(err);
            this.initOptions.updateUserCompletionCallback?.(false, errMsg);
            throw err;
        }
        let success = true;
        let errorMessage = null;
        try {
            this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
            this.user = user;
            if (this.user) await this.statsigClient.updateUserAsync(this.user);
        } catch (err) {
            success = false;
            errorMessage = String(err);
        }
        this.initOptions?.updateUserCompletionCallback?.(success, errorMessage);
        if (success) {
            this.currentIdentifiers = identifiers;
            this.currentAttributes = customAttributes;
            this.subscriptions.anyUpdated();
        } else throw new Error('Failed to update user. An unexpected error occured.');
    }
    /**
   * @returns string version of the current package in semver style.
   */ getPackageVersion() {
        return 0, $hTRuQ.CLIENT_VERSION;
    }
    /**
   * Returns a specified layer otherwise returns an empty layer as a default value if the layer doesn't exist.
   *
   * @param {string} layerName - The name of the layer
   * @param {Object} options
   * @param {boolean} options.fireLayerExposure - Whether or not to fire the exposure event for the
   * layer. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogLayerExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * @returns A layer
   * @example
   * ```ts
   * const layer = client.getLayer('example-layer-name');
   * const exampletitle: string = layer.get("title", "Welcome to Statsig!");
   * ```
   */ getLayer(/** The name of the layer */ layerName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireLayerExposure: fireLayerExposure = true } = options;
            return (0, $6sdY6.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                disableExposureLog: !fireLayerExposure
            }));
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetLayerErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                    layerName: layerName,
                    error: error
                });
                this.hasGetLayerErrorOccurred = true;
            }
            // Return a default value
            return (0, $6sdY6.Layer).fromLayer((0, $8OdXD._makeLayer)(layerName, {
                reason: 'Error'
            }, null));
        }
    }
    /**
   * Returns the value of a given parameter in a layer config.
   *
   * @template T
   * @param {string} layerName - The name of the layer
   * @param {string} parameterName - The name of the parameter to fetch from the layer config
   * @param {T} defaultValue - The value to serve if the layer or parameter do not exist, or if the
   * returned value does not match the expected type.
   * @param {Object} options
   * @param {boolean} options.fireLayerExposure - Whether or not to fire the exposure event for the
   * layer. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogLayerExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-))
   * @param {function} options.typeGuard - A function that asserts that the return value has the expected type. If this function returns false, then the default value will be returned instead. This can be set to protect your code from unexpected values being set remotely. By default, this will be done by asserting that the default value and value are the same primitive type.
   * @returns The value of the parameter if the layer and parameter both exist, otherwise the default value.
   * @example
   * ``` ts
   * type ValidColor = 'blue' | 'red' | 'yellow';
   * type ValidColorTypeCheck = (value: unknown) => value is ValidColor;
   *
   * const isValidColor: ValidColorTypeCheck =
   *    (value: unknown) => typeof value === 'string' && ['blue', 'red', 'yellow'].includes(value);
   *
   * const buttonColor: ValidColor = client.getLayerValue(
   *    'example-layer-name',
   *    'backgroundColor',
   *    'yellow',
   *    {
   *        typeGuard: isValidColor
   *    }
   * );
   * ```
   */ getLayerValue(layerName, parameterName, defaultValue, options = {}) {
        const layer = this.getLayer(layerName, options);
        try {
            const { typeGuard: typeGuard } = options;
            return layer.get(parameterName, defaultValue, typeGuard);
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetLayerValueErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                    layerName: layerName,
                    defaultValue: defaultValue,
                    options: options,
                    error: error
                });
                this.hasGetLayerValueErrorOccurred = true;
            }
            return defaultValue;
        }
    }
    constructor({ localStorageKey: localStorageKey = (0, $2A6OJ.LOCAL_STORAGE_KEY), overrideAdapter: overrideAdapter } = {}){
        this.statsigClient = void 0;
        this.user = void 0;
        this.initOptions = void 0;
        this.initPromise = null;
        /** True if an initialize method was called and completed successfully. */ this.initCompleted = false;
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ this.initWithDefaults = false;
        this.currentIdentifiers = void 0;
        this.currentAttributes = void 0;
        this.hasCheckGateErrorOccurred = false;
        this.hasGetExperimentErrorOccurred = false;
        this.hasGetExperimentValueErrorOccurred = false;
        this.hasGetLayerErrorOccurred = false;
        this.hasGetLayerValueErrorOccurred = false;
        this.provider = void 0;
        this.subscriptions = new (0, $1MvZt.default)();
        this.dataAdapter = new (0, $fP8Sl.NoFetchDataAdapter)();
        this.overrideAdapter = void 0;
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ this.statsigValuesUpdated = ()=>{
            if (this.user) // Trigger a reset of the memoize cache
            this.statsigClient.updateUserSync(this.user, {
                disableBackgroundCacheRefresh: true
            });
            this.subscriptions.anyUpdated();
        };
        this.overrideAdapter = overrideAdapter || new (0, $2A6OJ.PersistentOverrideAdapter)(localStorageKey);
    }
}

});
parcelRegister("8OdXD", function(module, exports) {
"use strict";
var $669dd2970102cf7f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $669dd2970102cf7f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $669dd2970102cf7f$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClient = void 0;


var $6UlNw = parcelRequire("6UlNw");
module.exports.StatsigClient = $6UlNw.default;

$669dd2970102cf7f$var$__exportStar((parcelRequire("87DGy")), module.exports);
const $669dd2970102cf7f$var$__STATSIG__ = Object.assign((0, (parcelRequire("87DGy"))._getStatsigGlobal)(), {
    StatsigClient: $6UlNw.default
});
module.exports.default = $669dd2970102cf7f$var$__STATSIG__;

});
parcelRegister("6UlNw", function(module, exports) {
"use strict";
var $014c45b4192dd836$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $87DGy = parcelRequire("87DGy");

var $4UFDs = parcelRequire("4UFDs");

var $7pjD1 = parcelRequire("7pjD1");

var $cjRQ1 = parcelRequire("cjRQ1");

var $20CWr = parcelRequire("20CWr");
class $014c45b4192dd836$var$StatsigClient extends $87DGy.StatsigClientBase {
    /**
     * Retrieves an instance of the StatsigClient based on the provided SDK key.
     *  If no SDK key is provided, the method returns the most recently created instance of the StatsigClient.
     *  The method ensures that each unique SDK key corresponds to a single instance of StatsigClient, effectively implementing a singleton pattern for each key.
     *  If no instance exists for the given SDK key, a new StatsigClient instance will be created and returned.
     *
     * @param {string} [sdkKey] - Optional. The SDK key used to identify a specific instance of the StatsigClient. If omitted, the method returns the last created instance.
     * @returns {StatsigClient} Returns the StatsigClient instance associated with the given SDK key, creating a new one if needed.
     */ static instance(sdkKey) {
        const instance = (0, $87DGy._getStatsigGlobal)().instance(sdkKey);
        if (instance instanceof $014c45b4192dd836$var$StatsigClient) return instance;
        $87DGy.Log.warn((0, $87DGy._isServerEnv)() ? 'StatsigClient.instance is not supported in server environments' : 'Unable to find StatsigClient instance');
        return new $014c45b4192dd836$var$StatsigClient(sdkKey !== null && sdkKey !== void 0 ? sdkKey : '', {});
    }
    /**
     * Initializes the StatsigClient using cached values. This method sets up the client synchronously by utilizing previously cached values.
     * After initialization, cache values are updated in the background for future use, either in subsequent sessions or when `updateUser` is called.
     * This is useful for quickly starting with the last-known-good configurations while refreshing data to keep settings up-to-date.
     *
     * @see {@link initializeAsync} for the asynchronous version of this method.
     */ initializeSync(options) {
        var _a;
        if (this.loadingStatus !== 'Uninitialized') return (0, $87DGy.createUpdateDetails)(true, this._store.getSource(), -1, null, null, [
            'MultipleInitializations',
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
        this._logger.start();
        return this.updateUserSync(this._user, options);
    }
    /**
     * Initializes the StatsigClient asynchronously by first using cached values and then updating to the latest values from the network.
     * Once the network values are fetched, they replace the existing cached values. If this method's promise is not awaited,
     * there might be a transition from cached to network values during the session, which can affect consistency.
     * This method is useful when it's acceptable to begin with potentially stale data and switch to the latest configuration as it becomes available.
     *
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully initialized with the latest values from the network or a timeout (if set) is hit.
     * @see {@link initializeSync} for the synchronous version of this method.
     */ initializeAsync(options) {
        return $014c45b4192dd836$var$__awaiter(this, void 0, void 0, function*() {
            if (this._initializePromise) return this._initializePromise;
            this._initializePromise = this._initializeAsyncImpl(options);
            return this._initializePromise;
        });
    }
    /**
     * Synchronously updates the user in the Statsig client and switches the internal state to use cached values for the newly specified user.
     * After the initial switch to cached values, this method updates these values in the background, preparing them for future sessions or subsequent calls to updateUser.
     * This method ensures the client is quickly ready with available data.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @see {@link updateUserAsync} for the asynchronous version of this method.
     */ updateUserSync(user, options) {
        const startTime = performance.now();
        try {
            return this._updateUserSyncImpl(user, options, startTime);
        } catch (e) {
            const err = e instanceof Error ? e : new Error(String(e));
            return this._createErrorUpdateDetails(err, startTime);
        }
    }
    _updateUserSyncImpl(user, options, startTime) {
        var _a;
        const warnings = [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ];
        this._resetForUser(user);
        const result = this.dataAdapter.getDataSync(this._user);
        if (result == null) warnings.push('NoCachedValues');
        this._store.setValues(result, this._user);
        this._finalizeUpdate(result);
        const disable = options === null || options === void 0 ? void 0 : options.disableBackgroundCacheRefresh;
        if (disable === true || disable == null && (result === null || result === void 0 ? void 0 : result.source) === 'Bootstrap') return (0, $87DGy.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
        this._runPostUpdate(result !== null && result !== void 0 ? result : null, this._user);
        return (0, $87DGy.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
    }
    /**
     * Asynchronously updates the user in the Statsig client by initially using cached values and then fetching the latest values from the network.
     * When the latest values are fetched, they replace the cached values. If the promise returned by this method is not awaited,
     * the client's state may shift from cached to updated network values during the session, potentially affecting consistency.
     * This method is best used in scenarios where up-to-date configuration is critical and initial delays are acceptable.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully updated with the latest values from the network or a timeout (if set) is hit.
     * @see {@link updateUserSync} for the synchronous version of this method.
     */ updateUserAsync(user, options) {
        return $014c45b4192dd836$var$__awaiter(this, void 0, void 0, function*() {
            const startTime = performance.now();
            try {
                return yield this._updateUserAsyncImpl(user, options);
            } catch (e) {
                const err = e instanceof Error ? e : new Error(String(e));
                return this._createErrorUpdateDetails(err, startTime);
            }
        });
    }
    _updateUserAsyncImpl(user, options) {
        return $014c45b4192dd836$var$__awaiter(this, void 0, void 0, function*() {
            this._resetForUser(user);
            const initiator = this._user;
            $87DGy.Diagnostics._markInitOverallStart(this._sdkKey);
            let result = this.dataAdapter.getDataSync(initiator);
            this._store.setValues(result, this._user);
            this._setStatus('Loading', result);
            result = yield this.dataAdapter.getDataAsync(result, initiator, options);
            // ensure the user hasn't changed while we were waiting
            if (initiator !== this._user) return (0, $87DGy.createUpdateDetails)(false, this._store.getSource(), -1, new Error('User changed during update'), this._network.getLastUsedInitUrlAndReset());
            let isUsingNetworkValues = false;
            if (result != null) {
                $87DGy.Diagnostics._markInitProcessStart(this._sdkKey);
                isUsingNetworkValues = this._store.setValues(result, this._user);
                $87DGy.Diagnostics._markInitProcessEnd(this._sdkKey, {
                    success: isUsingNetworkValues
                });
            }
            this._finalizeUpdate(result);
            if (!isUsingNetworkValues) {
                this._errorBoundary.attachErrorIfNoneExists($87DGy.UPDATE_DETAIL_ERROR_MESSAGES.NO_NETWORK_DATA);
                this.$emt({
                    name: 'initialization_failure'
                });
            }
            $87DGy.Diagnostics._markInitOverallEnd(this._sdkKey, isUsingNetworkValues, this._store.getCurrentSourceDetails());
            const initDuration = $87DGy.Diagnostics._enqueueDiagnosticsEvent(this._user, this._logger, this._sdkKey, this._options);
            return (0, $87DGy.createUpdateDetails)(isUsingNetworkValues, this._store.getSource(), initDuration, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), this._store.getWarnings());
        });
    }
    /**
     * Retrieves a synchronous context containing data currently being used by the SDK. Represented as a {@link PrecomputedEvaluationsContext} object.
     *
     * @returns {PrecomputedEvaluationsContext} The current synchronous context for the this StatsigClient instance.
     */ getContext() {
        return {
            sdkKey: this._sdkKey,
            options: this._options,
            values: this._store.getValues(),
            user: JSON.parse(JSON.stringify(this._user)),
            errorBoundary: this._errorBoundary,
            session: $87DGy.StatsigSession.get(this._sdkKey),
            stableID: $87DGy.StableID.get(this._sdkKey),
            sdkInstanceID: this._sdkInstanceID
        };
    }
    /**
     * Retrieves the value of a feature gate for the current user, represented as a simple boolean.
     *
     * @param {string} name - The name of the feature gate to retrieve.
     * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {boolean} - The boolean value representing the gate's current evaluation results for the user.
     */ checkGate(name, options) {
        return this.getFeatureGate(name, options).value;
    }
    /**
     * Logs an event to the internal logging system. This function allows logging by either passing a fully formed event object or by specifying the event name with optional value and metadata.
     *
     * @param {StatsigEvent|string} eventOrName - The event object conforming to the StatsigEvent interface, or the name of the event as a string.
     * @param {string|number} value - Optional. The value associated with the event, which can be a string or a number. This parameter is ignored if the first parameter is a StatsigEvent object.
     * @param {Record<string, string>} metadata - Optional. A key-value record containing metadata about the event. This is also ignored if the first parameter is an event object.
     */ logEvent(eventOrName, value, metadata) {
        const event = typeof eventOrName === 'string' ? {
            eventName: eventOrName,
            value: value,
            metadata: metadata
        } : eventOrName;
        this.$emt({
            name: 'log_event_called',
            event: event
        });
        this._logger.enqueue(Object.assign(Object.assign({}, event), {
            user: this._user,
            time: Date.now()
        }));
    }
    /**
     * Updates the user with analytics only metadata. This will override any existing analytics only metadata.
     *
     * @param {Record<string, string | number | boolean>} metadata - The metadata to add to the user.
     */ updateUserWithAnalyticsOnlyMetadata(metadata) {
        this._user = this._configureUser(Object.assign(Object.assign({}, this._user), {
            analyticsOnlyMetadata: metadata
        }), this._options);
    }
    _primeReadyRipcord() {
        this.$on('error', ()=>{
            this.loadingStatus === 'Loading' && this._finalizeUpdate(null);
        });
    }
    _initializeAsyncImpl(options) {
        return $014c45b4192dd836$var$__awaiter(this, void 0, void 0, function*() {
            if (!$87DGy.Storage.isReady()) yield $87DGy.Storage.isReadyResolver();
            this._logger.start();
            return this.updateUserAsync(this._user, options);
        });
    }
    _createErrorUpdateDetails(error, startTime) {
        var _a;
        return (0, $87DGy.createUpdateDetails)(false, this._store.getSource(), performance.now() - startTime, error, null, [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
    }
    _finalizeUpdate(values) {
        this._store.finalize();
        this._setStatus('Ready', values);
    }
    _runPostUpdate(current, user) {
        this.dataAdapter.getDataAsync(current, user, {
            priority: 'low'
        }).catch((err)=>{
            $87DGy.Log.error('An error occurred after update.', err);
        });
    }
    _resetForUser(user) {
        this._logger.reset();
        this._store.reset();
        this._user = this._configureUser(user, this._options);
    }
    _configureUser(originalUser, options) {
        var _a;
        const user = (0, $87DGy._normalizeUser)(originalUser, options);
        const stableIdOverride = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (stableIdOverride) $87DGy.StableID.setOverride(stableIdOverride, this._sdkKey);
        user.analyticsOnlyMetadata = Object.assign(Object.assign({}, user.analyticsOnlyMetadata), this._possibleFirstTouchMetadata);
        return user;
    }
    _getFeatureGateImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getGate(name);
        const gate = (0, $87DGy._makeFeatureGate)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getGateOverride) === null || _b === void 0 ? void 0 : _b.call(_a, gate, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : gate;
        this._enqueueExposure(name, (0, $87DGy._createGateExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'gate_evaluation',
            gate: result
        });
        return result;
    }
    _getDynamicConfigImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const config = (0, $87DGy._makeDynamicConfig)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getDynamicConfigOverride) === null || _b === void 0 ? void 0 : _b.call(_a, config, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : config;
        this._enqueueExposure(name, (0, $87DGy._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'dynamic_config_evaluation',
            dynamicConfig: result
        });
        return result;
    }
    _getExperimentImpl(name, options) {
        var _a, _b, _c, _d;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const experiment = (0, $87DGy._makeExperiment)(name, details, evaluation);
        if (experiment.__evaluation != null) experiment.__evaluation.secondary_exposures = (0, $87DGy._mapExposures)((_b = (_a = experiment.__evaluation) === null || _a === void 0 ? void 0 : _a.secondary_exposures) !== null && _b !== void 0 ? _b : [], this._store.getExposureMapping());
        const overridden = (_d = (_c = this.overrideAdapter) === null || _c === void 0 ? void 0 : _c.getExperimentOverride) === null || _d === void 0 ? void 0 : _d.call(_c, experiment, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : experiment;
        this._enqueueExposure(name, (0, $87DGy._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'experiment_evaluation',
            experiment: result
        });
        return result;
    }
    _getConfigListImpl() {
        return this._store.getConfigList();
    }
    _getLayerImpl(name, options) {
        var _a, _b, _c;
        const { result: evaluation, details: details } = this._store.getLayer(name);
        const layer = (0, $87DGy._makeLayer)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getLayerOverride) === null || _b === void 0 ? void 0 : _b.call(_a, layer, this._user, options);
        if (options === null || options === void 0 ? void 0 : options.disableExposureLog) this._logger.incrementNonExposureCount(name);
        const result = (0, $87DGy._mergeOverride)(layer, overridden, (_c = overridden === null || overridden === void 0 ? void 0 : overridden.__value) !== null && _c !== void 0 ? _c : layer.__value, (param)=>{
            if (options === null || options === void 0 ? void 0 : options.disableExposureLog) return;
            this._enqueueExposure(name, (0, $87DGy._createLayerParameterExposure)(this._user, result, param, this._store.getExposureMapping()), options);
        });
        this.$emt({
            name: 'layer_evaluation',
            layer: result
        });
        return result;
    }
    _getParameterStoreImpl(name, options) {
        var _a, _b;
        const { result: configuration, details: details } = this._store.getParamStore(name);
        this._logger.incrementNonExposureCount(name);
        const paramStore = {
            name: name,
            details: details,
            __configuration: configuration,
            get: (0, $cjRQ1._makeParamStoreGetter)(this, configuration, options)
        };
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getParamStoreOverride) === null || _b === void 0 ? void 0 : _b.call(_a, paramStore, options);
        if (overridden != null) {
            paramStore.__configuration = overridden.config;
            paramStore.details = overridden.details;
            paramStore.get = (0, $cjRQ1._makeParamStoreGetter)(this, overridden.config, options);
        }
        return paramStore;
    }
    /**
     * StatsigClient constructor
     *
     * @param {string} sdkKey A Statsig client SDK key. eg "client-xyz123..."
     * @param {StatsigUser} user StatsigUser object containing various attributes related to a user.
     * @param {StatsigOptions | null} options StatsigOptions, used to customize the behavior of the SDK.
     */ constructor(sdkKey, user, options = null){
        var _a, _b;
        $87DGy.SDKType._setClientType(sdkKey, 'javascript-client');
        const network = new $7pjD1.default(options, (e)=>{
            this.$emt(e);
        });
        super(sdkKey, (_a = options === null || options === void 0 ? void 0 : options.dataAdapter) !== null && _a !== void 0 ? _a : new $20CWr.StatsigEvaluationsDataAdapter(), network, options);
        this._possibleFirstTouchMetadata = {};
        /**
         * Retrieves the value of a feature gate for the current user, represented as a {@link FeatureGate} object.
         *
         * @param {string} name - The name of the feature gate to retrieve.
         * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {FeatureGate} - The {@link FeatureGate} object representing the gate's current evaluation results for the user.
         */ this.getFeatureGate = this._memoize($87DGy.MemoPrefix._gate, this._getFeatureGateImpl.bind(this));
        /**
         * Retrieves the value of a dynamic config for the current user.
         *
         * @param {string} name The name of the dynamic config to get.
         * @param {DynamicConfigEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {DynamicConfig} - The {@link DynamicConfig} object representing the dynamic configs's current evaluation results for the user.
         */ this.getDynamicConfig = this._memoize($87DGy.MemoPrefix._dynamicConfig, this._getDynamicConfigImpl.bind(this));
        /**
         * Retrieves the value of a experiment for the current user.
         *
         * @param {string} name The name of the experiment to get.
         * @param {ExperimentEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Experiment} - The {@link Experiment} object representing the experiments's current evaluation results for the user.
         */ this.getExperiment = this._memoize($87DGy.MemoPrefix._experiment, this._getExperimentImpl.bind(this));
        /**
         * Retrieves the list of all Dynamic Configs and Experiments for the current user.
         *
         * @returns {string[]} The list of all Dynamic Config and Experiment names for the current user. Note - these will be hashed unless you've disabled hashing.
         * This is intended to be used for debugging.
         */ this.getConfigList = this._memoize($87DGy.MemoPrefix._configList, this._getConfigListImpl.bind(this));
        /**
         * Retrieves the value of a layer for the current user.
         *
         * @param {string} name The name of the layer to get.
         * @param {LayerEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Layer} - The {@link Layer} object representing the layers's current evaluation results for the user.
         */ this.getLayer = this._memoize($87DGy.MemoPrefix._layer, this._getLayerImpl.bind(this));
        /**
         * Retrieves the value of a parameter store for the current user.
         *
         * @param {string} name The name of the parameter store to get.
         * @param {ParameterStoreEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {ParameterStore} - The {@link ParameterStore} object representing the parameter store's current mappings for the user.
         */ this.getParameterStore = this._memoize($87DGy.MemoPrefix._paramStore, this._getParameterStoreImpl.bind(this));
        this._store = new $4UFDs.default(sdkKey);
        this._network = network;
        this._user = this._configureUser(user, options);
        this._sdkInstanceID = (0, $87DGy.getUUID)();
        const plugins = (_b = options === null || options === void 0 ? void 0 : options.plugins) !== null && _b !== void 0 ? _b : [];
        for (const plugin of plugins)plugin.bind(this);
    }
}
module.exports.default = $014c45b4192dd836$var$StatsigClient;

});
parcelRegister("4UFDs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $87DGy = parcelRequire("87DGy");
class $393cb05640019936$var$EvaluationStore {
    reset() {
        this._values = null;
        this._rawValues = null;
        this._source = 'Loading';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings.clear();
    }
    finalize() {
        if (this._values) return;
        this._source = 'NoValues';
    }
    getValues() {
        return this._rawValues ? (0, $87DGy._typedJsonParse)(this._rawValues, 'has_updates', 'EvaluationStoreValues') : null;
    }
    setValues(result, user) {
        var _a;
        if (!result) return false;
        const values = (0, $87DGy._typedJsonParse)(result.data, 'has_updates', 'EvaluationResponse');
        if (values == null) return false;
        this._source = result.source;
        if ((values === null || values === void 0 ? void 0 : values.has_updates) !== true) return true;
        this._rawValues = result.data;
        this._lcut = values.time;
        this._receivedAt = result.receivedAt;
        this._values = values;
        this._bootstrapMetadata = this._extractBootstrapMetadata(result.source, values);
        if (result.source && values.user) this._setWarningState(user, values);
        $87DGy.SDKFlags.setFlags(this._sdkKey, (_a = values.sdk_flags) !== null && _a !== void 0 ? _a : {});
        return true;
    }
    getWarnings() {
        if (this._warnings.size === 0) return undefined;
        return Array.from(this._warnings);
    }
    getGate(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.feature_gates, name);
    }
    getConfig(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.dynamic_configs, name);
    }
    getConfigList() {
        var _a;
        if (!((_a = this._values) === null || _a === void 0 ? void 0 : _a.dynamic_configs)) return [];
        return Object.values(this._values.dynamic_configs).map((config)=>config.name);
    }
    getLayer(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.layer_configs, name);
    }
    getParamStore(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.param_stores, name);
    }
    getSource() {
        return this._source;
    }
    getExposureMapping() {
        var _a;
        return (_a = this._values) === null || _a === void 0 ? void 0 : _a.exposures;
    }
    _extractBootstrapMetadata(source, values) {
        if (source !== 'Bootstrap') return null;
        const bootstrapMetadata = {};
        if (values.user) bootstrapMetadata.user = values.user;
        if (values.sdkInfo) bootstrapMetadata.generatorSDKInfo = values.sdkInfo;
        bootstrapMetadata.lcut = values.time;
        return bootstrapMetadata;
    }
    _getDetailedStoreResult(lookup, name) {
        let result = null;
        if (lookup) result = lookup[name] ? lookup[name] : lookup[(0, $87DGy._DJB2)(name)];
        return {
            result: result,
            details: this._getDetails(result == null)
        };
    }
    _setWarningState(user, values) {
        var _a, _b;
        const stableID = $87DGy.StableID.get(this._sdkKey);
        if (((_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID) !== stableID && // don't throw if they're both undefined
        (((_b = user.customIDs) === null || _b === void 0 ? void 0 : _b.stableID) || stableID)) {
            this._warnings.add('StableIDMismatch');
            return;
        }
        if ('user' in values) {
            const bootstrapUser = values['user'];
            const userForComparison = Object.assign(Object.assign({}, user), {
                analyticsOnlyMetadata: undefined,
                privateAttributes: undefined
            });
            if ((0, $87DGy._getFullUserHash)(userForComparison) !== (0, $87DGy._getFullUserHash)(bootstrapUser)) this._warnings.add('PartialUserMatch');
        }
    }
    getCurrentSourceDetails() {
        if (this._source === 'Uninitialized' || this._source === 'NoValues') return {
            reason: this._source
        };
        const sourceDetails = {
            reason: this._source,
            lcut: this._lcut,
            receivedAt: this._receivedAt
        };
        if (this._warnings.size > 0) sourceDetails.warnings = Array.from(this._warnings);
        return sourceDetails;
    }
    _getDetails(isUnrecognized) {
        var _a, _b;
        const sourceDetails = this.getCurrentSourceDetails();
        let reason = sourceDetails.reason;
        const warnings = (_a = sourceDetails.warnings) !== null && _a !== void 0 ? _a : [];
        if (this._source === 'Bootstrap' && warnings.length > 0) reason = reason + warnings[0];
        if (reason !== 'Uninitialized' && reason !== 'NoValues') {
            const subreason = isUnrecognized ? 'Unrecognized' : 'Recognized';
            reason = `${reason}:${subreason}`;
        }
        const bootstrapMetadata = this._source === 'Bootstrap' ? (_b = this._bootstrapMetadata) !== null && _b !== void 0 ? _b : undefined : undefined;
        if (bootstrapMetadata) sourceDetails.bootstrapMetadata = bootstrapMetadata;
        return Object.assign(Object.assign({}, sourceDetails), {
            reason: reason
        });
    }
    constructor(_sdkKey){
        this._sdkKey = _sdkKey;
        this._rawValues = null;
        this._values = null;
        this._source = 'Uninitialized';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings = new Set();
    }
}
module.exports.default = $393cb05640019936$var$EvaluationStore;

});

parcelRegister("7pjD1", function(module, exports) {
"use strict";
var $564a17f92481e2d9$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $87DGy = parcelRequire("87DGy");

var $4VWvy = parcelRequire("4VWvy");
class $564a17f92481e2d9$var$StatsigNetwork extends $87DGy.NetworkCore {
    fetchEvaluations(sdkKey, current, priority, user, isCacheValidFor204) {
        return $564a17f92481e2d9$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d, _e, _f;
            const cache = current ? (0, $87DGy._typedJsonParse)(current, 'has_updates', 'InitializeResponse') : null;
            let data = {
                user: user,
                hash: (_c = (_b = (_a = this._option) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.initializeHashAlgorithm) !== null && _c !== void 0 ? _c : 'djb2',
                deltasResponseRequested: false,
                full_checksum: null
            };
            if (cache === null || cache === void 0 ? void 0 : cache.has_updates) {
                const hasHashChanged = (cache === null || cache === void 0 ? void 0 : cache.hash_used) !== ((_f = (_e = (_d = this._option) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.initializeHashAlgorithm) !== null && _f !== void 0 ? _f : 'djb2');
                data = Object.assign(Object.assign({}, data), {
                    sinceTime: isCacheValidFor204 && !hasHashChanged ? cache.time : 0,
                    previousDerivedFields: 'derived_fields' in cache && isCacheValidFor204 ? cache.derived_fields : {},
                    deltasResponseRequested: true,
                    full_checksum: cache.full_checksum,
                    partialUserMatchSinceTime: !hasHashChanged ? cache.time : 0
                });
            }
            return this._fetchEvaluations(sdkKey, cache, data, priority);
        });
    }
    _fetchEvaluations(sdkKey, cache, data, priority) {
        return $564a17f92481e2d9$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            const response = yield this.post({
                sdkKey: sdkKey,
                urlConfig: this._initializeUrlConfig,
                data: data,
                retries: 2,
                isStatsigEncodable: true,
                priority: priority
            });
            if ((response === null || response === void 0 ? void 0 : response.code) === 204) return '{"has_updates": false}';
            if ((response === null || response === void 0 ? void 0 : response.code) !== 200) return (_a = response === null || response === void 0 ? void 0 : response.body) !== null && _a !== void 0 ? _a : null;
            if ((cache === null || cache === void 0 ? void 0 : cache.has_updates) !== true || ((_b = response.body) === null || _b === void 0 ? void 0 : _b.includes('"is_delta":true')) !== true || data.deltasResponseRequested !== true) return response.body;
            const result = (0, $4VWvy._resolveDeltasResponse)(cache, response.body);
            if (typeof result === 'string') return result;
            // retry without deltas
            return this._fetchEvaluations(sdkKey, cache, Object.assign(Object.assign(Object.assign({}, data), result), {
                deltasResponseRequested: false
            }), priority);
        });
    }
    constructor(options, emitter){
        super(options, emitter);
        const config = options === null || options === void 0 ? void 0 : options.networkConfig;
        this._option = options;
        this._initializeUrlConfig = new $87DGy.UrlConfiguration($87DGy.Endpoint._initialize, config === null || config === void 0 ? void 0 : config.initializeUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.initializeFallbackUrls);
    }
}
module.exports.default = $564a17f92481e2d9$var$StatsigNetwork;

});
parcelRegister("4VWvy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._resolveDeltasResponse = void 0;

var $87DGy = parcelRequire("87DGy");
const $3979debff1e89ef6$var$MAX_DELTAS_SORT_DEPTH = 2;
function $3979debff1e89ef6$var$_resolveDeltasResponse(cache, deltasString) {
    const deltas = (0, $87DGy._typedJsonParse)(deltasString, 'checksum', 'DeltasEvaluationResponse');
    if (!deltas) return {
        hadBadDeltaChecksum: true
    };
    const merged = $3979debff1e89ef6$var$_mergeDeltasIntoCache(cache, deltas);
    const resolved = $3979debff1e89ef6$var$_handleDeletedEntries(merged);
    const actualChecksum = (0, $87DGy._DJB2Object)({
        feature_gates: resolved.feature_gates,
        dynamic_configs: resolved.dynamic_configs,
        layer_configs: resolved.layer_configs
    }, $3979debff1e89ef6$var$MAX_DELTAS_SORT_DEPTH);
    const isMatch = actualChecksum === deltas.checksumV2;
    if (!isMatch) return {
        hadBadDeltaChecksum: true,
        badChecksum: actualChecksum,
        badMergedConfigs: resolved,
        badFullResponse: deltas.deltas_full_response
    };
    return JSON.stringify(resolved);
}
module.exports._resolveDeltasResponse = $3979debff1e89ef6$var$_resolveDeltasResponse;
function $3979debff1e89ef6$var$_mergeDeltasIntoCache(cache, deltas) {
    return Object.assign(Object.assign(Object.assign({}, cache), deltas), {
        feature_gates: Object.assign(Object.assign({}, cache.feature_gates), deltas.feature_gates),
        layer_configs: Object.assign(Object.assign({}, cache.layer_configs), deltas.layer_configs),
        dynamic_configs: Object.assign(Object.assign({}, cache.dynamic_configs), deltas.dynamic_configs)
    });
}
function $3979debff1e89ef6$var$_handleDeletedEntries(deltas) {
    const result = deltas;
    $3979debff1e89ef6$var$_deleteEntriesInRecord(deltas.deleted_gates, result.feature_gates);
    delete result.deleted_gates;
    $3979debff1e89ef6$var$_deleteEntriesInRecord(deltas.deleted_configs, result.dynamic_configs);
    delete result.deleted_configs;
    $3979debff1e89ef6$var$_deleteEntriesInRecord(deltas.deleted_layers, result.layer_configs);
    delete result.deleted_layers;
    return result;
}
function $3979debff1e89ef6$var$_deleteEntriesInRecord(keys, values) {
    keys === null || keys === void 0 || keys.forEach((key)=>{
        delete values[key];
    });
}

});


parcelRegister("cjRQ1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeParamStoreGetter = void 0;

var $87DGy = parcelRequire("87DGy");
const $8f81057d3b023723$var$NO_EXPOSURE_OPT = {
    disableExposureLog: true
};
function $8f81057d3b023723$var$_shouldLogExposure(options) {
    return options == null || options.disableExposureLog === false;
}
function $8f81057d3b023723$var$_shouldReturnFallback(value, fallback) {
    return fallback != null && !(0, $87DGy._isTypeMatch)(value, fallback);
}
function $8f81057d3b023723$var$_getMappedStaticValue(param, _options) {
    return param.value;
}
function $8f81057d3b023723$var$_getMappedGateValue(client, param, options) {
    const gate = client.getFeatureGate(param.gate_name, $8f81057d3b023723$var$_shouldLogExposure(options) ? undefined : $8f81057d3b023723$var$NO_EXPOSURE_OPT);
    if (gate.value) return param.pass_value;
    return param.fail_value;
}
function $8f81057d3b023723$var$_getMappedDynamicConfigValue(client, param, fallback, options) {
    const config = client.getDynamicConfig(param.config_name, $8f81057d3b023723$var$_shouldLogExposure(options) ? undefined : $8f81057d3b023723$var$NO_EXPOSURE_OPT);
    const value = config.get(param.param_name);
    if ($8f81057d3b023723$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $8f81057d3b023723$var$_getMappedExperimentValue(client, param, fallback, options) {
    const experiment = client.getExperiment(param.experiment_name, $8f81057d3b023723$var$_shouldLogExposure(options) ? undefined : $8f81057d3b023723$var$NO_EXPOSURE_OPT);
    const value = experiment.get(param.param_name);
    if ($8f81057d3b023723$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $8f81057d3b023723$var$_getMappedLayerValue(client, param, fallback, options) {
    const layer = client.getLayer(param.layer_name, $8f81057d3b023723$var$_shouldLogExposure(options) ? undefined : $8f81057d3b023723$var$NO_EXPOSURE_OPT);
    const value = layer.get(param.param_name);
    if ($8f81057d3b023723$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $8f81057d3b023723$var$_makeParamStoreGetter(client, config, options) {
    return (paramName, fallback)=>{
        if (config == null) return fallback;
        const param = config[paramName];
        if (param == null || fallback != null && (0, $87DGy._typeOf)(fallback) !== param.param_type) return fallback;
        switch(param.ref_type){
            case 'static':
                return $8f81057d3b023723$var$_getMappedStaticValue(param, options);
            case 'gate':
                return $8f81057d3b023723$var$_getMappedGateValue(client, param, options);
            case 'dynamic_config':
                return $8f81057d3b023723$var$_getMappedDynamicConfigValue(client, param, fallback, options);
            case 'experiment':
                return $8f81057d3b023723$var$_getMappedExperimentValue(client, param, fallback, options);
            case 'layer':
                return $8f81057d3b023723$var$_getMappedLayerValue(client, param, fallback, options);
            default:
                return fallback;
        }
    };
}
module.exports._makeParamStoreGetter = $8f81057d3b023723$var$_makeParamStoreGetter;

});

parcelRegister("20CWr", function(module, exports) {
"use strict";
var $1769c9db0b22dd7e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigEvaluationsDataAdapter = void 0;

var $87DGy = parcelRequire("87DGy");

var $7pjD1 = parcelRequire("7pjD1");
class $1769c9db0b22dd7e$var$StatsigEvaluationsDataAdapter extends $87DGy.DataAdapterCore {
    attach(sdkKey, options, network) {
        super.attach(sdkKey, options, network);
        if (network !== null && network instanceof $7pjD1.default) this._network = network;
        else this._network = new $7pjD1.default(options !== null && options !== void 0 ? options : {});
    }
    getDataAsync(current, user, options) {
        return this._getDataAsyncImpl(current, (0, $87DGy._normalizeUser)(user, this._options), options);
    }
    prefetchData(user, options) {
        return this._prefetchDataImpl(user, options);
    }
    setData(data) {
        const values = (0, $87DGy._typedJsonParse)(data, 'has_updates', 'data');
        if (values && 'user' in values) super.setData(data, values.user);
        else $87DGy.Log.error('StatsigUser not found. You may be using an older server SDK version. Please upgrade your SDK or use setDataLegacy.');
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    _fetchFromNetwork(current, user, options, isCacheValidFor204) {
        return $1769c9db0b22dd7e$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield (_a = this._network) === null || _a === void 0 ? void 0 : _a.fetchEvaluations(this._getSdkKey(), current, options === null || options === void 0 ? void 0 : options.priority, user, isCacheValidFor204);
            return result !== null && result !== void 0 ? result : null;
        });
    }
    _getCacheKey(user) {
        var _a;
        const key = (0, $87DGy._getStorageKey)(this._getSdkKey(), user, (_a = this._options) === null || _a === void 0 ? void 0 : _a.customUserCacheKeyFunc);
        return `${$87DGy.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(result, user) {
        return result.fullUserHash != null && result.fullUserHash === (0, $87DGy._getFullUserHash)(user);
    }
    constructor(){
        super('EvaluationsDataAdapter', 'evaluations');
        this._network = null;
        this._options = null;
    }
}
module.exports.StatsigEvaluationsDataAdapter = $1769c9db0b22dd7e$var$StatsigEvaluationsDataAdapter;

});



parcelRegister("1MvZt", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e7511be1a522d2f$export$2e2bcd8739ae039);

var $4Guso = parcelRequire("4Guso");
const $0e7511be1a522d2f$export$a66cbd9b2289cd78 = '@all-features';
class $0e7511be1a522d2f$export$2e2bcd8739ae039 {
    onGateUpdated(gateName, callback, checkGate, options) {
        const value = checkGate(gateName, {
            ...options,
            fireGateExposure: false
        });
        if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
        const wrapCallback = ()=>{
            const value = checkGate(gateName, {
                ...options,
                fireGateExposure: false
            });
            const existingValue = this.eventToValue.get(callback);
            if (existingValue !== value) {
                this.eventToValue.set(callback, value);
                callback(value);
            }
        };
        this.emitter.on(gateName, wrapCallback);
        return ()=>{
            this.emitter.off(gateName, wrapCallback);
        };
    }
    onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
        const experimentEventName = `${experimentName}.${parameterName}`;
        const value = getExperimentValue(experimentName, parameterName, defaultValue, {
            ...options,
            fireExperimentExposure: false
        });
        if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
        const wrapCallback = ()=>{
            const value = getExperimentValue(experimentName, parameterName, defaultValue, {
                ...options,
                fireExperimentExposure: false
            });
            const existingValue = this.eventToValue.get(callback);
            if (existingValue !== value) {
                this.eventToValue.set(callback, value);
                callback(value);
            }
        };
        this.emitter.on(experimentEventName, wrapCallback);
        return ()=>{
            this.emitter.off(experimentEventName, wrapCallback);
        };
    }
    onAnyUpdated(callback) {
        this.emitter.on($0e7511be1a522d2f$export$a66cbd9b2289cd78, callback);
        return ()=>{
            this.emitter.off($0e7511be1a522d2f$export$a66cbd9b2289cd78, callback);
        };
    }
    anyUpdated() {
        this.emitter.emit($0e7511be1a522d2f$export$a66cbd9b2289cd78);
        this.emitter.eventNames().filter((name)=>name !== $0e7511be1a522d2f$export$a66cbd9b2289cd78).forEach((event)=>{
            this.emitter.emit(event);
        });
    }
    constructor(){
        this.emitter = void 0;
        this.eventToValue = new Map();
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($4Guso)))();
    }
}

});
parcelRegister("4Guso", function(module, exports) {
'use strict';
var $3692b5cbf351a18c$var$has = Object.prototype.hasOwnProperty, $3692b5cbf351a18c$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $3692b5cbf351a18c$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $3692b5cbf351a18c$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $3692b5cbf351a18c$var$Events().__proto__) $3692b5cbf351a18c$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $3692b5cbf351a18c$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $3692b5cbf351a18c$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $3692b5cbf351a18c$var$EE(fn, context || emitter, once), evt = $3692b5cbf351a18c$var$prefix ? $3692b5cbf351a18c$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $3692b5cbf351a18c$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $3692b5cbf351a18c$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $3692b5cbf351a18c$var$EventEmitter() {
    this._events = new $3692b5cbf351a18c$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $3692b5cbf351a18c$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($3692b5cbf351a18c$var$has.call(events, name)) names.push($3692b5cbf351a18c$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $3692b5cbf351a18c$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $3692b5cbf351a18c$var$prefix ? $3692b5cbf351a18c$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $3692b5cbf351a18c$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $3692b5cbf351a18c$var$prefix ? $3692b5cbf351a18c$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $3692b5cbf351a18c$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $3692b5cbf351a18c$var$prefix ? $3692b5cbf351a18c$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $3692b5cbf351a18c$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $3692b5cbf351a18c$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $3692b5cbf351a18c$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $3692b5cbf351a18c$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $3692b5cbf351a18c$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $3692b5cbf351a18c$var$prefix ? $3692b5cbf351a18c$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $3692b5cbf351a18c$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $3692b5cbf351a18c$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $3692b5cbf351a18c$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $3692b5cbf351a18c$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $3692b5cbf351a18c$var$prefix ? $3692b5cbf351a18c$var$prefix + event : event;
        if (this._events[evt]) $3692b5cbf351a18c$var$clearEvent(this, evt);
    } else {
        this._events = new $3692b5cbf351a18c$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$3692b5cbf351a18c$var$EventEmitter.prototype.off = $3692b5cbf351a18c$var$EventEmitter.prototype.removeListener;
$3692b5cbf351a18c$var$EventEmitter.prototype.addListener = $3692b5cbf351a18c$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$3692b5cbf351a18c$var$EventEmitter.prefixed = $3692b5cbf351a18c$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$3692b5cbf351a18c$var$EventEmitter.EventEmitter = $3692b5cbf351a18c$var$EventEmitter;
module.exports = $3692b5cbf351a18c$var$EventEmitter;

});


parcelRegister("cN9Jw", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", () => $174c8eda8aa50db2$export$6dc24881a3d96325);

var $fOW7o = parcelRequire("fOW7o");
class $174c8eda8aa50db2$export$6dc24881a3d96325 {
    static fromExperiment(experiment) {
        const config = new $174c8eda8aa50db2$export$6dc24881a3d96325(experiment.name, experiment.value, experiment.ruleID, (0, $fOW7o.migrateEvaluationDetails)(experiment.details), (0, $fOW7o.migrateSecondaryExposures)(experiment.__evaluation?.secondary_exposures ?? []), experiment.groupName ?? undefined);
        config.experiment = experiment;
        return config;
    }
    get(key, defaultValue, typeGuard) {
        const val = this.getValue(key, defaultValue);
        if (val == null) return defaultValue;
        const expectedType = Array.isArray(defaultValue) ? 'array' : typeof defaultValue;
        const actualType = Array.isArray(val) ? 'array' : typeof val;
        if (typeGuard) {
            if (typeGuard(val)) {
                this.fireExposure(key);
                return val;
            }
            this._onDefaultValueFallback?.(this, key, expectedType, actualType);
            return defaultValue;
        }
        if (defaultValue == null || expectedType === actualType) {
            this.fireExposure(key);
            return val;
        }
        this._onDefaultValueFallback?.(this, key, expectedType, actualType);
        return defaultValue;
    }
    getValue(key, defaultValue) {
        if (key == null) return this.value;
        if (defaultValue == null) defaultValue = null;
        if (this.value[key] == null) return defaultValue;
        this.fireExposure(key);
        return this.value[key];
    }
    fireExposure(key) {
        // Call the wrapped experiment's get method to fire exposure
        if (this.experiment) this.experiment.get(key);
    }
    constructor(configName, configValue, ruleID, evaluationDetails, secondaryExposures = [], allocatedExperimentName = '', onDefaultValueFallback = null){
        this.value = void 0;
        this._name = void 0;
        this._ruleID = void 0;
        /** @deprecated - do not use, this is still exported for backwards compatibility but will be removed in the next major version  */ this._secondaryExposures = void 0;
        this._allocatedExperimentName = void 0;
        this._evaluationDetails = void 0;
        this._onDefaultValueFallback = void 0;
        this.experiment = void 0;
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
}

});
parcelRegister("fOW7o", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", () => $6c543369d399d814$export$d119b37e5f788b43);
$parcel$export(module.exports, "shallowEquals", () => $6c543369d399d814$export$fa1c2bbf4100b8bc);
$parcel$export(module.exports, "toStatsigUser", () => $6c543369d399d814$export$3dad1db244472f32);
$parcel$export(module.exports, "migrateInitializationOptions", () => $6c543369d399d814$export$202946b690d26d22);
$parcel$export(module.exports, "migrateEvaluationDetails", () => $6c543369d399d814$export$18ad168d3dbac899);
$parcel$export(module.exports, "migrateSecondaryExposures", () => $6c543369d399d814$export$55fd683752d01e67);

var $5GFWi = parcelRequire("5GFWi");

var $lbjMe = parcelRequire("lbjMe");

var $5g8Kq = parcelRequire("5g8Kq");
const $6c543369d399d814$export$d119b37e5f788b43 = (options)=>({
        /**
	 * If more federal PerimeterTypes are added in the future, this should be updated so
	 * that isFedRamp() === true always returns the strictest perimeter.
	 */ perimeter: (0, $5GFWi.isFedRamp)() ? (0, $5g8Kq.PerimeterType).FEDRAMP_MODERATE : (0, $5g8Kq.PerimeterType).COMMERCIAL,
        ...options
    });
const $6c543369d399d814$export$fa1c2bbf4100b8bc = (objectA, objectB)=>{
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    const aEntries = Object.entries(objectA);
    const bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    const ascendingKeyOrder = ([key1], [key2])=>key1.localeCompare(key2);
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(let i = 0; i < aEntries.length; i++){
        const [, aValue] = aEntries[i];
        const [, bValue] = bEntries[i];
        if (aValue !== bValue) return false;
    }
    return true;
};
const $6c543369d399d814$export$3dad1db244472f32 = (identifiers, customAttributes)=>{
    const user = {
        customIDs: identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
const $6c543369d399d814$export$202946b690d26d22 = (options)=>{
    const { api: api, disableCurrentPageLogging: disableCurrentPageLogging, loggingIntervalMillis: loggingIntervalMillis, loggingBufferMaxSize: loggingBufferMaxSize, localMode: localMode, eventLoggingApi: eventLoggingApi, eventLoggingApiForRetries: eventLoggingApiForRetries, disableLocalStorage: disableLocalStorage, ignoreWindowUndefined: ignoreWindowUndefined, disableAllLogging: disableAllLogging, // No equivalent but is pointless anyway since our Statsig init is synchronous
    initTimeoutMs: _initTimeoutMs, // No equivalent in new client but probably not important?
    disableNetworkKeepalive: _disableNetworkKeepalive, // Needs to be implemented manually but unused according to zoekt
    overrideStableID: _overrideStableID, // No equivalent for these but can't see them actually used anywhere in old client?
    disableErrorLogging: _disableErrorLogging, disableAutoMetricsLogging: _disableAutoMetricsLogging, ...rest } = options;
    return {
        ...rest,
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    };
};
const $6c543369d399d814$var$evaluationReasonMappings = Object.entries((0, $lbjMe.EvaluationReason)).map(([key, value])=>[
        key.toLowerCase(),
        value
    ]);
const $6c543369d399d814$export$18ad168d3dbac899 = (details)=>{
    const reasonLower = details.reason.toLowerCase();
    return {
        reason: $6c543369d399d814$var$evaluationReasonMappings.find(([key])=>reasonLower.includes(key))?.[1] ?? (0, $lbjMe.EvaluationReason).Unknown,
        time: details.receivedAt ?? Date.now()
    };
};
const $6c543369d399d814$export$55fd683752d01e67 = (secondaryExposures)=>{
    return secondaryExposures.map((exposure)=>{
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});
parcelRegister("5GFWi", function(module, exports) {
$parcel$export(module.exports, "isFedRamp", () => $a77b60b1e19194be$export$64d6499adf9b2e51);

var $7UIMN = parcelRequire("7UIMN");
function $a77b60b1e19194be$export$64d6499adf9b2e51() {
    const global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    const env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $7UIMN.FEDRAMP_MODERATE);
    const matches = global.location?.hostname?.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("7UIMN", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $febc309af318180c$export$ce553301d55c2fd8);
const $febc309af318180c$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $febc309af318180c$export$f005e2e9f707cb5f = 'commercial';
const $febc309af318180c$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $febc309af318180c$export$a739cd5aac835909 = 'stg';
const $febc309af318180c$export$42dd0cdd351a4a9 = 'prod';
const $febc309af318180c$export$404582bc18fe4d9e = 'dev';

});


parcelRegister("lbjMe", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", () => $d0b02944d4fba51e$export$c62558b199e46828);
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $d0b02944d4fba51e$export$c62558b199e46828 = /*#__PURE__*/ function(EvaluationReason) {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    EvaluationReason["Error"] = "Error";
    EvaluationReason["LocalOverride"] = "LocalOverride";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["Network"] = "Network";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["Cache"] = "Cache";
    // For when we could not migrate the reason from the new client
    EvaluationReason["Unknown"] = "Unknown";
    return EvaluationReason;
}({});

});

parcelRegister("5g8Kq", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", () => $f828b120fb87a2a4$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $f828b120fb87a2a4$export$c42b7bbc5e7ba555);
var $f828b120fb87a2a4$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $f828b120fb87a2a4$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
const $f828b120fb87a2a4$export$42f4885608027d0c = 'non_boolean';

});



parcelRegister("6sdY6", function(module, exports) {
$parcel$export(module.exports, "Layer", () => $4b16e9c6189000db$export$936d0764594b6eb3);

var $fOW7o = parcelRequire("fOW7o");
class $4b16e9c6189000db$export$936d0764594b6eb3 {
    static fromLayer(layer) {
        const value = new $4b16e9c6189000db$export$936d0764594b6eb3(layer.name, layer.__value, layer.ruleID, (0, $fOW7o.migrateEvaluationDetails)(layer.details), (_layer, parameterName)=>layer.get(parameterName), (0, $fOW7o.migrateSecondaryExposures)(layer.__evaluation?.secondary_exposures ?? []), (0, $fOW7o.migrateSecondaryExposures)(layer.__evaluation?.undelegated_secondary_exposures ?? []), layer.__evaluation?.allocated_experiment_name, layer.__evaluation?.explicit_parameters);
        return value;
    }
    get(key, defaultValue, typeGuard) {
        const val = this._value[key];
        if (val == null) return defaultValue;
        const logAndReturn = ()=>{
            this._logLayerParameterExposure(key);
            return val;
        };
        if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
        if (defaultValue == null) return logAndReturn();
        if (typeof val === typeof defaultValue && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
        return defaultValue;
    }
    getValue(key, defaultValue) {
        // eslint-disable-next-line eqeqeq
        if (defaultValue == undefined) defaultValue = null;
        const val = this._value[key];
        if (val != null) this._logLayerParameterExposure(key);
        return val ?? defaultValue;
    }
    _logLayerParameterExposure(parameterName) {
        this._logParameterFunction?.(this, parameterName);
    }
    constructor(name, layerValue, ruleID, evaluationDetails, logParameterFunction = null, secondaryExposures = [], undelegatedSecondaryExposures = [], allocatedExperimentName = '', explicitParameters = []){
        this._name = void 0;
        this._value = void 0;
        this._ruleID = void 0;
        /** @deprecated - do not use, this is still exported for backwards compatibility but will be removed in the next major version  */ this._secondaryExposures = void 0;
        /** @deprecated - do not use, this is still exported for backwards compatibility but will be removed in the next major version  */ this._undelegatedSecondaryExposures = void 0;
        this._allocatedExperimentName = void 0;
        this._explicitParameters = void 0;
        this._evaluationDetails = void 0;
        this._logParameterFunction = void 0;
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue ?? {}));
        this._ruleID = ruleID ?? '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
}

});

parcelRegister("2zROK", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d3b05bb00b138db$export$2e2bcd8739ae039);

var $5g8Kq = parcelRequire("5g8Kq");

var $hTRuQ = parcelRequire("hTRuQ");

var $7gGC5 = parcelRequire("7gGC5");
const $3d3b05bb00b138db$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
const $3d3b05bb00b138db$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
const $3d3b05bb00b138db$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
const $3d3b05bb00b138db$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
const $3d3b05bb00b138db$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
const $3d3b05bb00b138db$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
const $3d3b05bb00b138db$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
const $3d3b05bb00b138db$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
const $3d3b05bb00b138db$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
const $3d3b05bb00b138db$export$450bd8fb2a6d7ace = '/gateway/api/flags';
class $3d3b05bb00b138db$export$2e2bcd8739ae039 {
    static async fetchClientSdk(fetcherOptions) {
        const { targetApp: targetApp } = fetcherOptions;
        const url = `/api/v2/frontend/clientSdkKey/${targetApp}`;
        try {
            return await this.fetchRequest(url, 'GET', fetcherOptions);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve client sdk key');
        }
    }
    static async fetchExperimentValues(fetcherOptions, identifiers, customAttributes) {
        const requestBody = {
            identifiers: identifiers,
            customAttributes: customAttributes,
            targetApp: fetcherOptions.targetApp
        };
        try {
            return await this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve experiment values');
        }
    }
    static async handleResponseError(response) {
        if (!response.ok) {
            // Use text() instead of json() as the error body might not be json data
            const body = await response.text();
            throw new (0, $7gGC5.ResponseError)(`Non 2xx response status received, status: ${response.status}, body: ${JSON.stringify(body)}`);
        }
        if (response.status === 204) throw new (0, $7gGC5.ResponseError)('Unexpected 204 response');
    }
    static async extractResponseBody(response) {
        const value = await response.text();
        return JSON.parse(value);
    }
    static getBaseUrl(serviceEnv, useGatewayUrl = false, perimeter, isolationContextId = null) {
        if (useGatewayUrl) return $3d3b05bb00b138db$export$450bd8fb2a6d7ace;
        if (perimeter === (0, $5g8Kq.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
            case (0, $5g8Kq.FeatureGateEnvironment).Production:
                return $3d3b05bb00b138db$export$18c93900db9358a4;
            case (0, $5g8Kq.FeatureGateEnvironment).Staging:
                return $3d3b05bb00b138db$export$1a401a0da8da3565;
            default:
                throw new Error(`Invalid environment "${serviceEnv}" for "${perimeter}" perimeter`);
        }
        else if (perimeter === (0, $5g8Kq.PerimeterType).COMMERCIAL) switch(serviceEnv){
            case (0, $5g8Kq.FeatureGateEnvironment).Development:
                return $3d3b05bb00b138db$export$f058dbf75c3bc647;
            case (0, $5g8Kq.FeatureGateEnvironment).Staging:
                const apiUrl = this.getApiUrl(isolationContextId);
                if (apiUrl !== null) return apiUrl;
                return $3d3b05bb00b138db$export$942ba04389b0d5a2;
            default:
                const prodApiUrl = this.getApiUrl(isolationContextId);
                if (prodApiUrl !== null) return prodApiUrl;
                return $3d3b05bb00b138db$export$250a58ecde616daa;
        }
        else throw new Error(`Invalid perimeter "${perimeter}"`);
    }
    static async fetchRequest(path, method, fetcherOptions, body) {
        const baseUrl = $3d3b05bb00b138db$export$2e2bcd8739ae039.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
        const fetchTimeout = fetcherOptions.fetchTimeoutMs || $3d3b05bb00b138db$var$DEFAULT_REQUEST_TIMEOUT_MS;
        let abortSignal;
        if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
        else if (AbortController) {
            const abortController = new AbortController();
            abortSignal = abortController.signal;
            setTimeout(()=>abortController.abort(), fetchTimeout);
        }
        const response = await fetch(`${baseUrl}${path}`, {
            method: method,
            headers: {
                'Content-Type': 'application/json',
                'X-Client-Name': 'feature-gate-js-client',
                'X-Client-Version': (0, $hTRuQ.CLIENT_VERSION),
                'X-API-KEY': fetcherOptions.apiKey
            },
            signal: abortSignal,
            ...body && {
                body: JSON.stringify(body)
            }
        });
        await this.handleResponseError(response);
        return await this.extractResponseBody(response);
    }
    static getApiUrl(isolationContextId) {
        const window1 = this.getWindowLocation();
        if (window1 === undefined) {
            //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
            if (!isolationContextId) return null;
            return $3d3b05bb00b138db$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
        }
        const { protocol: protocol, hostname: hostname } = window1;
        // Match last subdomain fragment before oasis-stg.com
        const oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
        if (oasisMatch) return `${protocol}//api.${oasisMatch[1]}.${$3d3b05bb00b138db$export$cb3cd156f70d7e94}`;
        // Match last subdomain fragment before atlassian-isolated.net
        const isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
        if (isolatedMatch) return `${protocol}//api.${isolatedMatch[1]}.${$3d3b05bb00b138db$export$921fbc6cdfd4eee0}`;
        return null;
    }
    static getWindowLocation() {
        if (typeof window !== 'undefined' && window.location) return window.location;
        return undefined;
    }
}

});
parcelRegister("hTRuQ", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", () => $e1fb7caa3a014dc9$export$a59f8d67326bd1cb);
/// <reference types="node" />
const $e1fb7caa3a014dc9$export$a59f8d67326bd1cb = "0.0.0-use.local";

});

parcelRegister("7gGC5", function(module, exports) {
$parcel$export(module.exports, "ResponseError", () => $bcd141197e8151e2$export$286baf652d0b1206);
class $bcd141197e8151e2$export$286baf652d0b1206 extends Error {
    constructor(message){
        super(message);
    }
}

});


parcelRegister("fP8Sl", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", () => $9ee8b7ec7e59994a$export$55fffef3474104af);

var $8OdXD = parcelRequire("8OdXD");
class $9ee8b7ec7e59994a$export$55fffef3474104af extends (0, $8OdXD.DataAdapterCore) {
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ setBootstrapData(data) {
        this.bootstrapResult = data ? {
            source: 'Bootstrap',
            data: JSON.stringify(data),
            receivedAt: Date.now(),
            stableID: (0, $8OdXD.StableID).get(this._getSdkKey()),
            fullUserHash: null
        } : null;
    }
    async prefetchData(_user, _options) {}
    async getDataAsync(_current, user, _options) {
        return this.bootstrapResult && {
            ...this.bootstrapResult,
            fullUserHash: (0, $8OdXD._getFullUserHash)(user)
        };
    }
    getDataSync(user) {
        return this.bootstrapResult && {
            ...this.bootstrapResult,
            fullUserHash: (0, $8OdXD._getFullUserHash)(user)
        };
    }
    async _fetchFromNetwork(_current, _user, _options) {
        return null;
    }
    _getCacheKey(user) {
        // Same logic as default data adapter
        // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
        const key = (0, $8OdXD._getStorageKey)(this._getSdkKey(), user);
        return `${0, $8OdXD.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(_result, _user) {
        return false;
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    // Do not stringify options property since that includes this adapter and will
    // cause a circular reference when Statsig sends diagnostic events and including
    // values is not necessary and makes the result huge
    toJSON() {
        const result = {
            ...this
        };
        delete result._options;
        delete result._inMemoryCache;
        delete result.bootstrapResult;
        return result;
    }
    constructor(){
        super('NoFetchDataAdapter', 'nofetch');
        this.bootstrapResult = null;
    }
}

});

parcelRegister("2A6OJ", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", () => $675031cb436bf06d$export$d8474cff104280f3);
$parcel$export(module.exports, "PersistentOverrideAdapter", () => $675031cb436bf06d$export$bcb28fbac1def494);

var $2eiRU = parcelRequire("2eiRU");
const $675031cb436bf06d$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
const $675031cb436bf06d$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
const $675031cb436bf06d$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
const $675031cb436bf06d$var$makeEmptyStore = ()=>({
        gates: {},
        configs: {},
        layers: {}
    });
const $675031cb436bf06d$var$djb2MapKey = (hash, kind)=>kind + ':' + hash;
class $675031cb436bf06d$export$bcb28fbac1def494 {
    parseStoredOverrides(localStorageKey) {
        try {
            const json = window.localStorage.getItem(localStorageKey);
            if (!json) return $675031cb436bf06d$var$makeEmptyStore();
            return JSON.parse(json);
        } catch  {
            return $675031cb436bf06d$var$makeEmptyStore();
        }
    }
    mergeOverrides(...allOverrides) {
        const merged = $675031cb436bf06d$var$makeEmptyStore();
        for (const overrides of allOverrides){
            for (const [name, value] of Object.entries(overrides.gates ?? {}))merged.gates[name] = value;
            for (const [name, value] of Object.entries(overrides.configs ?? {}))merged.configs[name] = value;
            for (const [name, value] of Object.entries(overrides.layers ?? {}))merged.layers[name] = value;
        }
        return merged;
    }
    initFromStoredOverrides() {
        const storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($675031cb436bf06d$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
        // Clear data from legacy local storage key now we've read from it.
        // This prevents things being stuck in there that are always read but never written to.
        try {
            window.localStorage.removeItem($675031cb436bf06d$var$LEGACY_LOCAL_STORAGE_KEY);
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
        // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
        // multiple hashes to continue being created. This code here removes these hashes since we've moved
        // to using a more reliable and easier to maintain map in `_djb2Map`.
        for (const container of Object.values(storedOverrides)){
            const allKeys = new Set(Object.keys(container));
            for (const name of allKeys){
                const hash = (0, $2eiRU._DJB2)(name);
                if (allKeys.has(hash)) delete container[hash];
            }
        }
        this.applyOverrides(storedOverrides);
    }
    saveOverrides() {
        try {
            window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
    }
    getOverrides() {
        return this.mergeOverrides(this._overrides);
    }
    applyOverrides(overrides) {
        const newOverrides = {
            ...$675031cb436bf06d$var$makeEmptyStore(),
            ...overrides
        };
        this._djb2Map.clear();
        for (const [containerName, container] of Object.entries(newOverrides))for (const [name, value] of Object.entries(container))this._djb2Map.set($675031cb436bf06d$var$djb2MapKey((0, $2eiRU._DJB2)(name), containerName), value);
        this._overrides = newOverrides;
    }
    setOverrides(overrides) {
        this.applyOverrides(overrides);
        this.saveOverrides();
    }
    overrideGate(name, value) {
        this._overrides.gates[name] = value;
        this._djb2Map.set($675031cb436bf06d$var$djb2MapKey((0, $2eiRU._DJB2)(name), 'gates'), value);
        this.saveOverrides();
    }
    removeGateOverride(name) {
        delete this._overrides.gates[name];
        this._djb2Map.delete($675031cb436bf06d$var$djb2MapKey((0, $2eiRU._DJB2)(name), 'gates'));
        this.saveOverrides();
    }
    getGateOverride(current, _user) {
        const overridden = this._overrides.gates[current.name] ?? this._djb2Map.get($675031cb436bf06d$var$djb2MapKey(current.name, 'gates'));
        if (overridden == null) return null;
        return {
            ...current,
            value: overridden,
            details: {
                ...current.details,
                reason: $675031cb436bf06d$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
    overrideDynamicConfig(name, value) {
        this._overrides.configs[name] = value;
        this._djb2Map.set($675031cb436bf06d$var$djb2MapKey((0, $2eiRU._DJB2)(name), 'configs'), value);
        this.saveOverrides();
    }
    removeDynamicConfigOverride(name) {
        delete this._overrides.configs[name];
        this._djb2Map.delete($675031cb436bf06d$var$djb2MapKey((0, $2eiRU._DJB2)(name), 'configs'));
        this.saveOverrides();
    }
    getDynamicConfigOverride(current, _user) {
        return this._getConfigOverride(current, this._overrides.configs);
    }
    overrideExperiment(name, value) {
        this._overrides.configs[name] = value;
        this._djb2Map.set($675031cb436bf06d$var$djb2MapKey((0, $2eiRU._DJB2)(name), 'configs'), value);
        this.saveOverrides();
    }
    removeExperimentOverride(name) {
        delete this._overrides.configs[name];
        this._djb2Map.delete($675031cb436bf06d$var$djb2MapKey((0, $2eiRU._DJB2)(name), 'configs'));
        this.saveOverrides();
    }
    getExperimentOverride(current, _user) {
        return this._getConfigOverride(current, this._overrides.configs);
    }
    overrideLayer(name, value) {
        this._overrides.layers[name] = value;
        this._djb2Map.set($675031cb436bf06d$var$djb2MapKey((0, $2eiRU._DJB2)(name), 'layers'), value);
        this.saveOverrides();
    }
    removeLayerOverride(name) {
        delete this._overrides.layers[name];
        this._djb2Map.delete($675031cb436bf06d$var$djb2MapKey((0, $2eiRU._DJB2)(name), 'layers'));
        this.saveOverrides();
    }
    removeAllOverrides() {
        this._overrides = $675031cb436bf06d$var$makeEmptyStore();
        try {
            window.localStorage.removeItem(this._localStorageKey);
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
    }
    getLayerOverride(current, _user) {
        const overridden = this._overrides.layers[current.name] ?? this._djb2Map.get($675031cb436bf06d$var$djb2MapKey(current.name, 'layers'));
        if (overridden == null) return null;
        return {
            ...current,
            __value: overridden,
            get: (0, $2eiRU._makeTypedGet)(current.name, overridden),
            details: {
                ...current.details,
                reason: $675031cb436bf06d$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
    _getConfigOverride(current, lookup) {
        const overridden = lookup[current.name] ?? this._djb2Map.get($675031cb436bf06d$var$djb2MapKey(current.name, 'configs'));
        if (overridden == null) return null;
        return {
            ...current,
            value: overridden,
            get: (0, $2eiRU._makeTypedGet)(current.name, overridden),
            details: {
                ...current.details,
                reason: $675031cb436bf06d$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
    constructor(localStorageKey){
        this._overrides = void 0;
        this._localStorageKey = void 0;
        this._djb2Map = void 0;
        this._overrides = $675031cb436bf06d$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
}

});
parcelRegister("2eiRU", function(module, exports) {
"use strict";
var $19fb8672b168f837$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $19fb8672b168f837$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $19fb8672b168f837$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Storage = module.exports.Log = module.exports.EventLogger = module.exports.Diagnostics = void 0;



Object.defineProperty(module.exports, "Diagnostics", {
    enumerable: true,
    get: function() {
        return (parcelRequire("4k5J2")).Diagnostics;
    }
});

var $l7lyt = parcelRequire("l7lyt");
Object.defineProperty(module.exports, "EventLogger", {
    enumerable: true,
    get: function() {
        return $l7lyt.EventLogger;
    }
});

Object.defineProperty(module.exports, "Log", {
    enumerable: true,
    get: function() {
        return (parcelRequire("734ad")).Log;
    }
});


Object.defineProperty(module.exports, "Storage", {
    enumerable: true,
    get: function() {
        return (parcelRequire("c6J8p")).Storage;
    }
});

$19fb8672b168f837$var$__exportStar((parcelRequire("g2TNZ")), module.exports);

$19fb8672b168f837$var$__exportStar((parcelRequire("7dAGN")), module.exports);

$19fb8672b168f837$var$__exportStar((parcelRequire("fQeQM")), module.exports);

$19fb8672b168f837$var$__exportStar((parcelRequire("8DGg2")), module.exports);

$19fb8672b168f837$var$__exportStar((parcelRequire("4k5J2")), module.exports);

$19fb8672b168f837$var$__exportStar((parcelRequire("6ZBfS")), module.exports);

$19fb8672b168f837$var$__exportStar((parcelRequire("hLWFM")), module.exports);

$19fb8672b168f837$var$__exportStar((parcelRequire("ydZTp")), module.exports);

$19fb8672b168f837$var$__exportStar((parcelRequire("dNYVh")), module.exports);

$19fb8672b168f837$var$__exportStar((parcelRequire("5xWeB")), module.exports);

$19fb8672b168f837$var$__exportStar((parcelRequire("cqbQs")), module.exports);

$19fb8672b168f837$var$__exportStar((parcelRequire("734ad")), module.exports);

$19fb8672b168f837$var$__exportStar((parcelRequire("1i5Ye")), module.exports);

$19fb8672b168f837$var$__exportStar((parcelRequire("l3sJo")), module.exports);

$19fb8672b168f837$var$__exportStar((parcelRequire("7g9eY")), module.exports);

$19fb8672b168f837$var$__exportStar((parcelRequire("8CTpP")), module.exports);

$19fb8672b168f837$var$__exportStar((parcelRequire("iYN0W")), module.exports);

$19fb8672b168f837$var$__exportStar((parcelRequire("3h5v5")), module.exports);

$19fb8672b168f837$var$__exportStar((parcelRequire("561nR")), module.exports);

$19fb8672b168f837$var$__exportStar((parcelRequire("cSz3w")), module.exports);

$19fb8672b168f837$var$__exportStar((parcelRequire("6cHBa")), module.exports);

$19fb8672b168f837$var$__exportStar((parcelRequire("kZdmh")), module.exports);

$19fb8672b168f837$var$__exportStar((parcelRequire("4tnuA")), module.exports);

$19fb8672b168f837$var$__exportStar((parcelRequire("70Ond")), module.exports);

$19fb8672b168f837$var$__exportStar((parcelRequire("a5oTl")), module.exports);

$19fb8672b168f837$var$__exportStar((parcelRequire("kTyja")), module.exports);

$19fb8672b168f837$var$__exportStar((parcelRequire("jWxsz")), module.exports);

$19fb8672b168f837$var$__exportStar((parcelRequire("bZVno")), module.exports);

$19fb8672b168f837$var$__exportStar((parcelRequire("2RFmf")), module.exports);

$19fb8672b168f837$var$__exportStar((parcelRequire("85VP8")), module.exports);

$19fb8672b168f837$var$__exportStar((parcelRequire("1REJJ")), module.exports);

$19fb8672b168f837$var$__exportStar((parcelRequire("c0GK9")), module.exports);

$19fb8672b168f837$var$__exportStar((parcelRequire("c6J8p")), module.exports);

$19fb8672b168f837$var$__exportStar((parcelRequire("c9krb")), module.exports);

$19fb8672b168f837$var$__exportStar((parcelRequire("23ExQ")), module.exports);

$19fb8672b168f837$var$__exportStar((parcelRequire("h42ib")), module.exports);

$19fb8672b168f837$var$__exportStar((parcelRequire("2I8e3")), module.exports);

$19fb8672b168f837$var$__exportStar((parcelRequire("fOEO6")), module.exports);

$19fb8672b168f837$var$__exportStar((parcelRequire("9FhqT")), module.exports);

$19fb8672b168f837$var$__exportStar((parcelRequire("gVlw5")), module.exports);
Object.assign((0, (parcelRequire("g2TNZ"))._getStatsigGlobal)(), {
    Log: (parcelRequire("734ad")).Log,
    SDK_VERSION: (parcelRequire("jWxsz")).SDK_VERSION
});

});




parcelRegister("10fSH", function(module, exports) {
$parcel$export(module.exports, "debug", () => $853af983b13db930$export$1c9f709888824e05);
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
const $853af983b13db930$var$TESTS_MODE = globalThis?.process?.env?.JEST_WORKER_ID !== undefined;
const $853af983b13db930$var$DEBUG_MODE = !$853af983b13db930$var$TESTS_MODE && globalThis?.process?.env?.NODE_ENV !== 'production';
const $853af983b13db930$export$1c9f709888824e05 = (...args)=>{
    if (!$853af983b13db930$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    console.debug(...args);
};

});



parcelRegister("cdh74", function(module, exports) {
$parcel$export(module.exports, "default", () => $b1c471e7f68133dc$export$2e2bcd8739ae039);

var $dRdwa = parcelRequire("dRdwa");
const $b1c471e7f68133dc$export$7bc189309d2ad463 = 'analyticsInteractionSesssionTrackingClient';
class $b1c471e7f68133dc$export$2e2bcd8739ae039 {
    static getInstance() {
        let interactionSessionTracking;
        try {
            // Check if InteractionSessionTracking in global window object
            if ($b1c471e7f68133dc$export$7bc189309d2ad463 in window) interactionSessionTracking = window[$b1c471e7f68133dc$export$7bc189309d2ad463];
            else {
                // Initialise InteractionSessionTracking on global window object
                window[$b1c471e7f68133dc$export$7bc189309d2ad463] = new (0, $dRdwa.default)();
                interactionSessionTracking = window[$b1c471e7f68133dc$export$7bc189309d2ad463];
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Error initialising InteractionSessionTracking - ${error instanceof Error ? error.message : String(error)}`);
        }
        return interactionSessionTracking;
    }
}

});
parcelRegister("dRdwa", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf73dce9b004c0fd$export$2e2bcd8739ae039);

var $1eqix = parcelRequire("1eqix");
// WARNING: The value of INTERACTION_SESSION_ID_STORAGE_KEY will be used by Analytics Web Client to attach the session ID to events.
// If you change this, you will need to update the Analytics Web Client code as well.
const $cf73dce9b004c0fd$var$INTERACTION_SESSION_ID_STORAGE_KEY = 'interactionSession.id';
const $cf73dce9b004c0fd$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY = 'interactionSession.id.prev';
const $cf73dce9b004c0fd$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY = 'interactionSession.expiry';
const $cf73dce9b004c0fd$export$285f6bddd927a06d = 1800000; // 30 minutes
const $cf73dce9b004c0fd$export$d050a4cab1b9f734 = 86400000; // 24 hours
const $cf73dce9b004c0fd$export$a92e915d70316eb2 = 5000; // 5 seconds
const $cf73dce9b004c0fd$export$de43760b2dc10c19 = 0.9; // 90% of expiry
const $cf73dce9b004c0fd$var$INTEGER_REGEX = /^\d+$/;
const $cf73dce9b004c0fd$export$5d4c4eab0863aae3 = 'interactionSessionIdUpdated';
class $cf73dce9b004c0fd$export$2e2bcd8739ae039 {
    getCurrentInteractionSessionId() {
        const sessionId = this.safeSessionStorage.getItem($cf73dce9b004c0fd$var$INTERACTION_SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this.safeSessionStorage.getItem($cf73dce9b004c0fd$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
        // If we have an existing valid session ID within expiry, we can return it straight away
        if (sessionId && !Number.isNaN(sessionExpiry) && sessionExpiry > Date.now()) {
            this.debouncedUpdateSessionExpiry(sessionExpiry);
            return sessionId;
        }
        // To generate a new session ID we must ensure analytics is ready
        if (this.analyticsReady) {
            // Session expiry update must occur before generateNewSessionId. Otherwise we were running
            // into issues of calls attempting to read the session ID before a valid expiry had been set
            this.debouncedUpdateSessionExpiry(sessionExpiry);
            return this.generateNewSessionId();
        }
        return null;
    }
    getPreviousInteractionSessionId() {
        return this.safeSessionStorage.getItem($cf73dce9b004c0fd$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY);
    }
    setInteractionSessionId(persistedSessionId) {
        if (this.validateSessionId(persistedSessionId)) {
            const currentSessionId = this.safeSessionStorage.getItem($cf73dce9b004c0fd$var$INTERACTION_SESSION_ID_STORAGE_KEY);
            // If we are already on the required session ID, just return true and make no changes
            // This can happen if the persisted session ID in options is the same as the current session ID
            // We noticed this happening in some cases where Confluence's own URL redirect logic was causing
            // race conditions with our URL stripping, resulting in the same query parameter being processed multiple times
            if (currentSessionId === persistedSessionId) return false;
            // Session expiry update must occur before we fire off the dispatchEvent. Otherwise we were running
            // into issues of the event consumer attempting to read the session ID before a valid expiry had been set
            this.debouncedUpdateSessionExpiry(0);
            this.safeSessionStorage.setItem($cf73dce9b004c0fd$var$INTERACTION_SESSION_ID_STORAGE_KEY, persistedSessionId);
            this.safeSessionStorage.removeItem($cf73dce9b004c0fd$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY);
            document.dispatchEvent(new Event($cf73dce9b004c0fd$export$5d4c4eab0863aae3));
            return true;
        }
        return false;
    }
    // Must be called with a valid sendEvent function for other methods to work
    setAnalyticsCallback(sendEventCallback) {
        if (this.analyticsReady) // If we already have a valid callback, don't over-write it
        return;
        if (sendEventCallback && typeof sendEventCallback === 'function') {
            this.sendEventCallback = sendEventCallback;
            this.analyticsReady = true;
        } else this.analyticsReady = false;
    }
    validateSessionId(sessionId) {
        // Check if persisted session ID can parse as valid Unix timestamp
        if (sessionId && $cf73dce9b004c0fd$var$INTEGER_REGEX.test(sessionId)) {
            const sessionAge = Date.now() - parseInt(sessionId, 10);
            // Validate that timestamp is not a future time, and is also within the TTL
            if (sessionAge >= 0 && sessionAge <= $cf73dce9b004c0fd$export$d050a4cab1b9f734) return true;
        }
        return false;
    }
    sendInteractionSessionEvent(action) {
        this.sendEventCallback && this.sendEventCallback({
            action: action,
            actionSubject: 'interactionSession',
            source: 'interactionComponent',
            tags: [
                'navigationExperiences'
            ] // InteractionSession events will be registered under this platform product
        });
    }
    constructor(){
        this.safeSessionStorage = void 0;
        this.sessionExpiryTime = void 0;
        this.sessionExpiryDebounce = void 0;
        this.sessionExpiryDebounceThresholdPercentage = void 0;
        this.sessionExpiryDebounceTimer = void 0;
        this.analyticsReady = false;
        // This callback function will be called whenever a new session ID is generated
        // It expects a function that sends an operational analytics event, with
        // the first parameter being set to the action ('started' or 'renewed'), and the second parameter being
        // an InteractionSession object containing the new session ID and previous session ID.
        this.sendEventCallback = void 0;
        this.generateNewSessionId = ()=>{
            if (!this.analyticsReady) return null;
            const currentSessionId = this.safeSessionStorage.getItem($cf73dce9b004c0fd$var$INTERACTION_SESSION_ID_STORAGE_KEY);
            const newSessionId = Date.now().toString();
            this.safeSessionStorage.setItem($cf73dce9b004c0fd$var$INTERACTION_SESSION_ID_STORAGE_KEY, newSessionId);
            if (currentSessionId) {
                // Store a copy of the current session ID so we can link sessions if needed
                this.safeSessionStorage.setItem($cf73dce9b004c0fd$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY, currentSessionId);
                this.sendInteractionSessionEvent('renewed');
            } else this.sendInteractionSessionEvent('started');
            // Event listener is in useCrossProductUrl.tsx to update URL query params
            document.dispatchEvent(new Event($cf73dce9b004c0fd$export$5d4c4eab0863aae3));
            return newSessionId;
        };
        this.updateSessionExpiry = ()=>{
            const expiry = Date.now() + this.sessionExpiryTime;
            this.safeSessionStorage.setItem($cf73dce9b004c0fd$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        };
        this.debouncedUpdateSessionExpiry = (currentExpiry)=>{
            const { updateSessionExpiry: updateSessionExpiry } = this;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + this.sessionExpiryDebounceThresholdPercentage * this.sessionExpiryTime) updateSessionExpiry();
            else {
                if (this.sessionExpiryDebounceTimer) clearTimeout(this.sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                this.sessionExpiryDebounceTimer = setTimeout(()=>{
                    updateSessionExpiry();
                }, this.sessionExpiryDebounce);
            }
        };
        this.sessionExpiryTime = $cf73dce9b004c0fd$export$285f6bddd927a06d;
        this.sessionExpiryDebounce = $cf73dce9b004c0fd$export$a92e915d70316eb2;
        this.sessionExpiryDebounceThresholdPercentage = $cf73dce9b004c0fd$export$de43760b2dc10c19;
        this.safeSessionStorage = new (0, $1eqix.default)();
    }
}

});
parcelRegister("1eqix", function(module, exports) {
$parcel$export(module.exports, "default", () => $d939db76c325ca8c$export$2e2bcd8739ae039);

var $8tObm = parcelRequire("8tObm");

var $3kuwE = parcelRequire("3kuwE");
class $d939db76c325ca8c$export$2e2bcd8739ae039 extends (0, $3kuwE.default) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = window.sessionStorage || (0, $8tObm.default);
        } catch (err) {
            storageToUse = (0, $8tObm.default);
        }
        super(storageToUse, options);
    }
}

});
parcelRegister("8tObm", function(module, exports) {
$parcel$export(module.exports, "default", () => $f6a44dc0594ffb1c$export$2e2bcd8739ae039);
class $f6a44dc0594ffb1c$export$90e3e001bcac59c7 {
    constructor(){
        this.data = {};
        this.length = 0;
        this.setItem = (key, value)=>{
            this.data[key] = value;
            this.length = Object.keys(this.data).length;
            return value;
        };
        this.getItem = (key)=>{
            if (key in this.data) return this.data[key];
            return null;
        };
        this.removeItem = (key)=>{
            if (key in this.data) delete this.data[key];
            this.length = Object.keys(this.data).length;
            return null;
        };
        this.clear = ()=>{
            this.data = {};
            this.length = 0;
        };
        this.key = (index)=>Object.keys(this.data)[index];
    }
}
// eslint-disable-next-line import/no-anonymous-default-export
const $f6a44dc0594ffb1c$var$inmemorystorage = new $f6a44dc0594ffb1c$export$90e3e001bcac59c7();
var $f6a44dc0594ffb1c$export$2e2bcd8739ae039 = $f6a44dc0594ffb1c$var$inmemorystorage;

});

parcelRegister("3kuwE", function(module, exports) {
$parcel$export(module.exports, "default", () => $dcb91df4129de06a$export$2e2bcd8739ae039);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ 
var $8tObm = parcelRequire("8tObm");
const $dcb91df4129de06a$export$41c06fdd37b7e9a5 = 'awc';
const $dcb91df4129de06a$export$770aa8bc07b3de03 = 'awcInMemoryStorageFallback';
var $dcb91df4129de06a$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["DEV"] = "dev";
    envType["LOCAL"] = "local";
    envType["PROD"] = "prod";
    envType["STAGING"] = "staging";
    return envType;
}({});
function $dcb91df4129de06a$export$48c17662a6902497(store) {
    const TEST_VALUE = 'test_value';
    if (!store) return false;
    try {
        const key = 'awc.storage.support';
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}
function $dcb91df4129de06a$export$6325979d1c67607f(e) {
    let quotaExceeded = false;
    if (e.code) switch(e.code){
        case 22:
            quotaExceeded = true;
            break;
        case 1014:
            // Firefox
            if (e.name === 'NS_ERROR_DOM_QUOTA_REACHED') quotaExceeded = true;
            break;
        default:
            break;
    }
    else if (e.number === -2147024882) // Internet Explorer 8
    quotaExceeded = true;
    return quotaExceeded;
}
class $dcb91df4129de06a$export$2e2bcd8739ae039 {
    constructor(storageToUse, options = {}){
        this.prefix = void 0;
        this.store = void 0;
        this.options = void 0;
        this.getStore = ()=>this.store;
        this.getItem = (key)=>this.store.getItem(this.createKey(key));
        this.removeItem = (key)=>this.store.removeItem(this.createKey(key));
        this.setItem = (key, value)=>{
            try {
                this.store.setItem(this.createKey(key), value);
            } catch (err) {
                if ($dcb91df4129de06a$export$6325979d1c67607f(err)) {
                    this.swapToInMemory();
                    this.store.setItem(this.createKey(key), value);
                }
            }
        };
        this.swapToInMemory = ()=>{
            if (this.store === (0, $8tObm.default) || typeof window === 'undefined') return;
            const keys = Object.keys(this.store || {});
            let inMemoryStorage;
            if ($dcb91df4129de06a$export$48c17662a6902497(window[$dcb91df4129de06a$export$770aa8bc07b3de03])) inMemoryStorage = window[$dcb91df4129de06a$export$770aa8bc07b3de03];
            else {
                inMemoryStorage = (0, $8tObm.default);
                if (!window[$dcb91df4129de06a$export$770aa8bc07b3de03]) // If not already attached to window then attach our instance of InMemoryStorage
                // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
                // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
                window[$dcb91df4129de06a$export$770aa8bc07b3de03] = (0, $8tObm.default);
            }
            keys.forEach((key)=>{
                if (key.indexOf(this.getPrefix()) === 0) {
                    const value = this.store.getItem(key);
                    if (value) inMemoryStorage.setItem(key, value);
                }
            });
            this.store = inMemoryStorage;
        };
        this.clear = ()=>this.store.clear();
        this.key = (index)=>this.store.key(index);
        this.getPrefix = ()=>this.prefix;
        this.createKey = (key)=>{
            if (this.prefix) return `${this.getPrefix()}.${key}`;
            return key;
        };
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($dcb91df4129de06a$export$41c06fdd37b7e9a5);
        if (options.envPrefix && options.envPrefix !== "prod") prefixes.push(options.envPrefix);
        this.prefix = prefixes.join('-');
        if ($dcb91df4129de06a$export$48c17662a6902497(storageToUse)) this.store = storageToUse;
        else this.swapToInMemory();
    }
}

});





parcelRegister("gaky7", function(module, exports) {
$parcel$export(module.exports, "URL_QUERY_PARAM_INTERACTION_SESSION", () => $71005157aa68e86b$export$81d16f1428ce0486);
const $71005157aa68e86b$export$81d16f1428ce0486 = 'xpis';
const $71005157aa68e86b$export$2e3999ec51334ffe = (url, bridge, interactionSessionId, product, subProduct)=>{
    const interactionSource = subProduct ? `${product}-${subProduct}` : product;
    const interactionSession = {
        bridge: bridge,
        id: interactionSessionId,
        source: interactionSource
    };
    const paramValueEncoded = btoa(JSON.stringify(interactionSession));
    const urlObj = new URL(url);
    urlObj.searchParams.set($71005157aa68e86b$export$81d16f1428ce0486, paramValueEncoded);
    return urlObj.toString();
};

});

parcelRegister("6dDWZ", function(module, exports) {
$parcel$export(module.exports, "validProducts", () => $023b6ce9380425e5$export$b1e8b4360a046e61);
// Add products that will participate in cross-product interaction tracking here
// TODO: Down the line this should ideally be synced with ECS product list but that
// will take significant engineering effort
const $023b6ce9380425e5$export$b1e8b4360a046e61 = [
    'jira',
    'confluence',
    'townsquare',
    'loom'
];

});

parcelRegister("hn1K9", function(module, exports) {
$parcel$export(module.exports, "defaultHistoryReplaceFn", () => $ea747f7ad8ad99d9$export$600dd5bf1b049f11);
$parcel$export(module.exports, "default", () => $ea747f7ad8ad99d9$export$2e2bcd8739ae039);

var $5sXBG = parcelRequire("5sXBG");

var $5NC0R = parcelRequire("5NC0R");
const $ea747f7ad8ad99d9$export$600dd5bf1b049f11 = (newUrl)=>window.history.replaceState({}, '', newUrl);
const $ea747f7ad8ad99d9$var$urlParamExtractor = (isCaptureParam, historyReplaceFn = $ea747f7ad8ad99d9$export$600dd5bf1b049f11)=>{
    // Extract target parameters and values from URL if present
    const originalUrl = window.location.href;
    const fragmentHash = window.location.hash;
    const removedFragmentURL = fragmentHash !== '' ? originalUrl.replace(fragmentHash, '') : originalUrl;
    const { url: url, query: query } = (0, $5sXBG.parseUrl)(removedFragmentURL);
    const captureParams = (0, $5NC0R.pickBy)(query, isCaptureParam);
    // Do not modify URL if no matches
    if (Object.keys(captureParams).length > 0) {
        const queryWithoutCaptureParams = (0, $5NC0R.omitBy)(query, isCaptureParam);
        // Replace the URL minus captured parameters
        if (Object.keys(queryWithoutCaptureParams).length > 0) {
            const newUrl = `${url}?${(0, $5sXBG.stringify)(queryWithoutCaptureParams)}${fragmentHash}`;
            historyReplaceFn(newUrl);
        } else historyReplaceFn(`${url}${fragmentHash}`);
    }
    return captureParams;
};
var $ea747f7ad8ad99d9$export$2e2bcd8739ae039 = $ea747f7ad8ad99d9$var$urlParamExtractor;

});
parcelRegister("5sXBG", function(module, exports) {
$parcel$export(module.exports, "extract", () => $3fadcdf084323617$export$f9380c9a627682d3, (v) => $3fadcdf084323617$export$f9380c9a627682d3 = v);
$parcel$export(module.exports, "parse", () => $3fadcdf084323617$export$98e6a39c04603d36, (v) => $3fadcdf084323617$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $3fadcdf084323617$export$fac44ee5b035f737, (v) => $3fadcdf084323617$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parseUrl", () => $3fadcdf084323617$export$7a5253c0f62e0150, (v) => $3fadcdf084323617$export$7a5253c0f62e0150 = v);
$parcel$export(module.exports, "stringifyUrl", () => $3fadcdf084323617$export$a8c1621ea79325d3, (v) => $3fadcdf084323617$export$a8c1621ea79325d3 = v);
$parcel$export(module.exports, "pick", () => $3fadcdf084323617$export$357523c63a2253b9, (v) => $3fadcdf084323617$export$357523c63a2253b9 = v);
var $3fadcdf084323617$export$f9380c9a627682d3;
var $3fadcdf084323617$export$98e6a39c04603d36;
var $3fadcdf084323617$export$fac44ee5b035f737;
var $3fadcdf084323617$export$7a5253c0f62e0150;
var $3fadcdf084323617$export$a8c1621ea79325d3;
var $3fadcdf084323617$export$357523c63a2253b9;
var $3fadcdf084323617$export$44c361b8ec72ef7f;
'use strict';

var $4bnIJ = parcelRequire("4bnIJ");

var $etYf2 = parcelRequire("etYf2");

var $iNnEj = parcelRequire("iNnEj");

var $gAtWH = parcelRequire("gAtWH");
const $3fadcdf084323617$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $3fadcdf084323617$var$encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
function $3fadcdf084323617$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $3fadcdf084323617$var$encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $3fadcdf084323617$var$encode(key, options),
                            '[',
                            $3fadcdf084323617$var$encode(index, options),
                            ']=',
                            $3fadcdf084323617$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'bracket':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $3fadcdf084323617$var$encode(key, options),
                            '[]'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $3fadcdf084323617$var$encode(key, options),
                            '[]=',
                            $3fadcdf084323617$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'colon-list-separator':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $3fadcdf084323617$var$encode(key, options),
                            ':list='
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $3fadcdf084323617$var$encode(key, options),
                            ':list=',
                            $3fadcdf084323617$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'comma':
        case 'separator':
        case 'bracket-separator':
            {
                const keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? '' : value;
                        if (result.length === 0) return [
                            [
                                $3fadcdf084323617$var$encode(key, options),
                                keyValueSep,
                                $3fadcdf084323617$var$encode(value, options)
                            ].join('')
                        ];
                        return [
                            [
                                result,
                                $3fadcdf084323617$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        $3fadcdf084323617$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $3fadcdf084323617$var$encode(key, options),
                            '=',
                            $3fadcdf084323617$var$encode(value, options)
                        ].join('')
                    ];
                };
    }
}
function $3fadcdf084323617$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case 'index':
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'colon-list-separator':
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'comma':
        case 'separator':
            return (key, value, accumulator)=>{
                const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === 'string' && !isArray && $3fadcdf084323617$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $3fadcdf084323617$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$3fadcdf084323617$var$decode(item, options)) : value === null ? value : $3fadcdf084323617$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case 'bracket-separator':
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, '');
                if (!isArray) {
                    accumulator[key] = value ? $3fadcdf084323617$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$3fadcdf084323617$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $3fadcdf084323617$var$validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function $3fadcdf084323617$var$encode(value, options) {
    if (options.encode) return options.strict ? $4bnIJ(value) : encodeURIComponent(value);
    return value;
}
function $3fadcdf084323617$var$decode(value, options) {
    if (options.decode) return $etYf2(value);
    return value;
}
function $3fadcdf084323617$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === 'object') return $3fadcdf084323617$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $3fadcdf084323617$var$removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $3fadcdf084323617$var$getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $3fadcdf084323617$var$extract(input) {
    input = $3fadcdf084323617$var$removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function $3fadcdf084323617$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
    return value;
}
function $3fadcdf084323617$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $3fadcdf084323617$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $3fadcdf084323617$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== 'string') return ret;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return ret;
    for (const param of query.split('&')){
        if (param === '') continue;
        let [key, value] = $iNnEj(options.decode ? param.replace(/\+/g, ' ') : param, '=');
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            'comma',
            'separator',
            'bracket-separator'
        ].includes(options.arrayFormat) ? value : $3fadcdf084323617$var$decode(value, options);
        formatter($3fadcdf084323617$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === 'object' && value !== null) for (const k of Object.keys(value))value[k] = $3fadcdf084323617$var$parseValue(value[k], options);
        else ret[key] = $3fadcdf084323617$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $3fadcdf084323617$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$3fadcdf084323617$export$f9380c9a627682d3 = $3fadcdf084323617$var$extract;
$3fadcdf084323617$export$98e6a39c04603d36 = $3fadcdf084323617$var$parse;
$3fadcdf084323617$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return '';
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ','
    }, options);
    $3fadcdf084323617$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $3fadcdf084323617$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = $3fadcdf084323617$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return '';
        if (value === null) return $3fadcdf084323617$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === 'bracket-separator') return $3fadcdf084323617$var$encode(key, options) + '[]';
            return value.reduce(formatter(key), []).join('&');
        }
        return $3fadcdf084323617$var$encode(key, options) + '=' + $3fadcdf084323617$var$encode(value, options);
    }).filter((x)=>x.length > 0).join('&');
};
$3fadcdf084323617$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $iNnEj(url, '#');
    return Object.assign({
        url: url_.split('?')[0] || '',
        query: $3fadcdf084323617$var$parse($3fadcdf084323617$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $3fadcdf084323617$var$decode(hash, options)
    } : {});
};
$3fadcdf084323617$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$3fadcdf084323617$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $3fadcdf084323617$var$removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = $3fadcdf084323617$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $3fadcdf084323617$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $3fadcdf084323617$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $3fadcdf084323617$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$3fadcdf084323617$var$encodeFragmentIdentifier] ? $3fadcdf084323617$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$3fadcdf084323617$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$3fadcdf084323617$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $3fadcdf084323617$export$7a5253c0f62e0150(input, options);
    return $3fadcdf084323617$export$a8c1621ea79325d3({
        url: url,
        query: $gAtWH(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$3fadcdf084323617$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $3fadcdf084323617$export$357523c63a2253b9(input, exclusionFilter, options);
};

});
parcelRegister("4bnIJ", function(module, exports) {
'use strict';
module.exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);

});

parcelRegister("etYf2", function(module, exports) {
'use strict';
var $a8b280d93f2d87dc$var$token = '%[a-f0-9]{2}';
var $a8b280d93f2d87dc$var$singleMatcher = new RegExp('(' + $a8b280d93f2d87dc$var$token + ')|([^%]+?)', 'gi');
var $a8b280d93f2d87dc$var$multiMatcher = new RegExp('(' + $a8b280d93f2d87dc$var$token + ')+', 'gi');
function $a8b280d93f2d87dc$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(''))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $a8b280d93f2d87dc$var$decodeComponents(left), $a8b280d93f2d87dc$var$decodeComponents(right));
}
function $a8b280d93f2d87dc$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($a8b280d93f2d87dc$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $a8b280d93f2d87dc$var$decodeComponents(tokens, i).join('');
            tokens = input.match($a8b280d93f2d87dc$var$singleMatcher) || [];
        }
        return input;
    }
}
function $a8b280d93f2d87dc$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        '%FE%FF': '\uFFFD\uFFFD',
        '%FF%FE': '\uFFFD\uFFFD'
    };
    var match = $a8b280d93f2d87dc$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $a8b280d93f2d87dc$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $a8b280d93f2d87dc$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap['%C2'] = '\uFFFD';
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
    }
    return input;
}
module.exports = function(encodedURI) {
    if (typeof encodedURI !== 'string') throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
    try {
        encodedURI = encodedURI.replace(/\+/g, ' ');
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $a8b280d93f2d87dc$var$customDecodeURIComponent(encodedURI);
    }
};

});

parcelRegister("iNnEj", function(module, exports) {
'use strict';
module.exports = (string, separator)=>{
    if (!(typeof string === 'string' && typeof separator === 'string')) throw new TypeError('Expected the arguments to be of type `string`');
    if (separator === '') return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};

});

parcelRegister("gAtWH", function(module, exports) {
'use strict';
module.exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};

});


parcelRegister("5NC0R", function(module, exports) {
$parcel$export(module.exports, "mapKeys", () => $e150e1ccd240ef48$export$781522908e4e76a1);
$parcel$export(module.exports, "pick", () => $e150e1ccd240ef48$export$357523c63a2253b9);
$parcel$export(module.exports, "omitBy", () => $e150e1ccd240ef48$export$d7a617dda645b4e3);
$parcel$export(module.exports, "pickBy", () => $e150e1ccd240ef48$export$b460b275d6c6aa0);
$parcel$export(module.exports, "omit", () => $e150e1ccd240ef48$export$30a06c8d3562193f);
$parcel$export(module.exports, "equals", () => $e150e1ccd240ef48$export$e9bab7fafb253603);
$parcel$export(module.exports, "partition", () => $e150e1ccd240ef48$export$b29f828819edca8d);
/* eslint-disable no-return-assign, no-sequences */ // https://www.30secondsofcode.org/js/s/map-keys
const $e150e1ccd240ef48$export$781522908e4e76a1 = (obj, fn)=>Object.keys(obj).reduce((acc, k)=>{
        const key = fn(obj[k], k, obj);
        acc[key] = obj[k];
        return acc;
    }, {});
// https://www.30secondsofcode.org/js/s/pick
const $e150e1ccd240ef48$export$357523c63a2253b9 = (obj, arr)=>arr.reduce((acc, curr)=>(curr in obj && (acc[curr] = obj[curr]), acc), {});
// https://www.30secondsofcode.org/js/s/omit-by
const $e150e1ccd240ef48$export$d7a617dda645b4e3 = (obj, fn)=>Object.keys(obj).filter((k)=>!fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/pick-by
const $e150e1ccd240ef48$export$b460b275d6c6aa0 = (obj, fn)=>Object.keys(obj).filter((k)=>fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/omit
const $e150e1ccd240ef48$export$30a06c8d3562193f = (obj, arr)=>Object.keys(obj).filter((k)=>arr.indexOf(k) < 0).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/equals
const $e150e1ccd240ef48$export$e9bab7fafb253603 = (a, b)=>{
    if (a === b) return true;
    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
    if (!a || !b || typeof a !== 'object' && typeof b !== 'object') return a === b;
    if (a.prototype !== b.prototype) return false;
    const keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length) return false;
    return keys.every((k)=>$e150e1ccd240ef48$export$e9bab7fafb253603(a[k], b[k]));
};
// https://www.30secondsofcode.org/js/s/partition
const $e150e1ccd240ef48$export$b29f828819edca8d = (arr, fn)=>arr.reduce(// eslint-disable-next-line no-shadow
    (acc, val, i, arr)=>{
        acc[fn(val, i, arr) ? 0 : 1].push(val);
        return acc;
    }, [
        [],
        []
    ]);

});



parcelRegister("886JK", function(module, exports) {
$parcel$export(module.exports, "isFirstParty", () => $8b1157ce68b57039$export$f56713ced121eb91);
$parcel$export(module.exports, "isThirdParty", () => $8b1157ce68b57039$export$ab34f90cc32c8960);

var $2tp3i = parcelRequire("2tp3i");
const $8b1157ce68b57039$export$f56713ced121eb91 = (input)=>{
    return input.embeddedType === (0, $2tp3i.productEmbedType).FIRST_PARTY && input.embeddedFromProduct !== undefined;
};
const $8b1157ce68b57039$export$ab34f90cc32c8960 = (input)=>{
    return input.embeddedType === (0, $2tp3i.productEmbedType).THIRD_PARTY && input.embeddedFromTopLevelDomain !== undefined;
};

});

parcelRegister("7nd0Y", function(module, exports) {
$parcel$export(module.exports, "buildActionFields", () => $171cc0303d110a76$export$655ecf7241feac42);
$parcel$export(module.exports, "buildScreenEvent", () => $171cc0303d110a76$export$c7d9a5f56acc4b19);
$parcel$export(module.exports, "buildActionName", () => $171cc0303d110a76$export$9c5623a792efc9b0);
$parcel$export(module.exports, "buildContext", () => $171cc0303d110a76$export$3a7fe28f9bf4f3d9);
$parcel$export(module.exports, "buildActionEvent", () => $171cc0303d110a76$export$7bf451af4a8e3dd9);

var $cnjKG = parcelRequire("cnjKG");

var $2tp3i = parcelRequire("2tp3i");

var $dYbY5 = parcelRequire("dYbY5");
const $171cc0303d110a76$var$libraryVersion = "0.0.0-use.local";
function $171cc0303d110a76$var$buildTenantFields(tenantInfo) {
    return {
        tenantIdType: tenantInfo.tenantIdType,
        tenantId: tenantInfo.tenantId
    };
}
function $171cc0303d110a76$var$buildUserFields(userInfo) {
    return {
        userIdType: userInfo.userIdType
    };
}
function $171cc0303d110a76$var$buildOrgFields(orgInfo) {
    return {
        orgId: orgInfo.orgId
    };
}
function $171cc0303d110a76$var$buildWorkspaceFields(workspaceInfo) {
    return {
        workspaceId: workspaceInfo.workspaceId
    };
}
function $171cc0303d110a76$var$buildAliases(aliases) {
    if ($171cc0303d110a76$var$isNotEmptyObject(aliases)) return {
        aliases: aliases
    };
    return undefined;
}
function $171cc0303d110a76$var$buildGroups(groups) {
    if ($171cc0303d110a76$var$isNotEmptyObject(groups)) return {
        groups: groups
    };
    return undefined;
}
function $171cc0303d110a76$var$buildEventOverrides(event) {
    if (event.anonymousId) return {
        anonymousId: event.anonymousId
    };
    return {};
}
function $171cc0303d110a76$var$buildInteractionSession(properties) {
    // TODO: Once feature flag is removed this function can be removed and the property
    // directly added at the top level in the buildActionEvent and buildScreenEvent functions
    if ((0, $cnjKG.fg)('analytics_cross_product_interaction_tracking')) return {
        interactionSession: properties
    };
    return undefined;
}
function $171cc0303d110a76$var$getProductField(field, override) {
    return override === undefined ? field : override;
}
function $171cc0303d110a76$var$buildProductFields(productInfo, productOverrides) {
    const overrides = productOverrides || {};
    const env = $171cc0303d110a76$var$getProductField(productInfo.env, overrides.env);
    const product = $171cc0303d110a76$var$getProductField(productInfo.product, overrides.product);
    const subproduct = $171cc0303d110a76$var$getProductField(productInfo.subproduct(), overrides.subproduct);
    const version = $171cc0303d110a76$var$getProductField(productInfo.version, overrides.version);
    const origin = $171cc0303d110a76$var$getProductField(productInfo.origin, overrides.origin);
    const platform = $171cc0303d110a76$var$getProductField(productInfo.platform, overrides.platform);
    const ic = productInfo.ic; // ic should not be overriden once set
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform,
        ic: ic
    };
}
function $171cc0303d110a76$var$isNotEmptyObject(obj) {
    return (0, $dYbY5.isPlainObject)(obj) && Object.keys(obj).length > 0;
}
function $171cc0303d110a76$var$buildAttributesWithName(name, attrObject) {
    return $171cc0303d110a76$var$isNotEmptyObject(attrObject) ? {
        [name]: attrObject
    } : undefined;
}
function $171cc0303d110a76$var$buildAttributes(attributes) {
    return $171cc0303d110a76$var$buildAttributesWithName('attributes', attributes);
}
function $171cc0303d110a76$export$3f5115a568819c1a(containers) {
    const validContainers = {};
    Object.keys(containers).forEach((key)=>{
        const value = containers[key];
        validContainers[key] = {
            id: value.id,
            type: value.type
        };
    });
    return validContainers;
}
function $171cc0303d110a76$export$f045f238d77c002a(containers) {
    if ($171cc0303d110a76$var$isNotEmptyObject(containers)) {
        const validContainers = $171cc0303d110a76$export$3f5115a568819c1a(containers);
        return $171cc0303d110a76$var$buildAttributesWithName('containers', validContainers);
    }
    return undefined;
}
function $171cc0303d110a76$export$655ecf7241feac42(event, actionEventType) {
    return {
        containerType: event.containerType,
        containerId: event.containerId,
        source: event.source,
        objectType: event.objectType,
        objectId: event.objectId,
        actionSubject: event.actionSubject,
        action: event.action,
        actionSubjectId: event.actionSubjectId,
        attributes: event.attributes,
        nonPrivacySafeAttributes: event.nonPrivacySafeAttributes,
        tags: event.tags,
        highPriority: event.highPriority,
        eventType: actionEventType,
        ...$171cc0303d110a76$export$f045f238d77c002a(event.containers)
    };
}
function $171cc0303d110a76$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes) {
    return $171cc0303d110a76$var$buildAttributesWithName('nonPrivacySafeAttributes', nonPrivacySafeAttributes);
}
function $171cc0303d110a76$export$c7d9a5f56acc4b19(productInfo, tenantInfo, userInfo, attributes, nonPrivacySafeAttributes, tags, tabId, sessionId, taskSessions, interactionSession, orgInfo, pageLoadId, workspaceInfo, event, containers, aliases, groups) {
    const productFields = $171cc0303d110a76$var$buildProductFields(productInfo);
    const tenantFields = $171cc0303d110a76$var$buildTenantFields(tenantInfo);
    const userFields = $171cc0303d110a76$var$buildUserFields(userInfo);
    const orgFields = $171cc0303d110a76$var$buildOrgFields(orgInfo);
    const workspaceFields = $171cc0303d110a76$var$buildWorkspaceFields(workspaceInfo);
    const overrides = {
        title: '',
        path: '',
        url: '',
        referrer: '',
        search: '',
        eventType: (0, $2tp3i.eventType).SCREEN
    };
    return {
        ...productFields,
        ...tenantFields,
        ...userFields,
        ...orgFields,
        ...overrides,
        ...$171cc0303d110a76$var$buildAttributes(attributes),
        ...$171cc0303d110a76$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes),
        ...$171cc0303d110a76$export$f045f238d77c002a(containers),
        ...$171cc0303d110a76$var$buildEventOverrides(event),
        tags: tags,
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        ...$171cc0303d110a76$var$buildInteractionSession(interactionSession),
        pageLoadId: pageLoadId,
        ...workspaceFields,
        ...$171cc0303d110a76$var$buildAliases(aliases),
        ...$171cc0303d110a76$var$buildGroups(groups)
    };
}
function $171cc0303d110a76$export$9c5623a792efc9b0(event) {
    return `${event.actionSubject} ${event.action}`;
}
var $171cc0303d110a76$export$fbd92247fb4d6159 = /*#__PURE__*/ function(validationMode) {
    validationMode["QUIET"] = "quiet";
    validationMode["STANDARD"] = "standard";
    validationMode["COMPLETE"] = "complete";
    return validationMode;
}({});
function $171cc0303d110a76$var$getDefaultValidationMode(productInfo) {
    const environment = productInfo.env;
    if (environment === undefined) return "quiet";
    if (environment.includes('prod')) return "quiet";
    return "complete";
}
function $171cc0303d110a76$export$3a7fe28f9bf4f3d9(productInfo) {
    const screen = window.screen || {};
    return {
        context: {
            locale: productInfo.locale,
            screen: {
                width: screen.width,
                height: screen.height,
                density: window.devicePixelRatio
            },
            library: {
                name: 'analytics.js',
                version: $171cc0303d110a76$var$libraryVersion
            },
            validationMode: $171cc0303d110a76$var$getDefaultValidationMode(productInfo)
        }
    };
}
function $171cc0303d110a76$export$e3d99b4bfec06f6e(event) {
    const { env: env, product: product, subproduct: subproduct, version: version, origin: origin, platform: platform } = event;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}
function $171cc0303d110a76$export$7bf451af4a8e3dd9(productInfo, tenantInfo, userInfo, event, actionEventType, tabId, sessionId, taskSessions, interactionSession, orgInfo, pageLoadId, workspaceInfo, aliases, groups) {
    const productFields = $171cc0303d110a76$var$buildProductFields(productInfo, $171cc0303d110a76$export$e3d99b4bfec06f6e(event));
    const tenantFields = $171cc0303d110a76$var$buildTenantFields(tenantInfo);
    const orgFields = $171cc0303d110a76$var$buildOrgFields(orgInfo);
    const workspaceFields = $171cc0303d110a76$var$buildWorkspaceFields(workspaceInfo);
    const userFields = $171cc0303d110a76$var$buildUserFields(userInfo);
    const actionFields = $171cc0303d110a76$export$655ecf7241feac42(event, actionEventType);
    return {
        ...productFields,
        ...tenantFields,
        ...orgFields,
        ...userFields,
        ...actionFields,
        ...$171cc0303d110a76$var$buildEventOverrides(event),
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        ...$171cc0303d110a76$var$buildInteractionSession(interactionSession),
        pageLoadId: pageLoadId,
        ...workspaceFields,
        ...$171cc0303d110a76$var$buildAliases(aliases),
        ...$171cc0303d110a76$var$buildGroups(groups)
    };
}

});
parcelRegister("dYbY5", function(module, exports) {
$parcel$export(module.exports, "isPlainObject", () => $5fb6f06fd995b7c2$export$53b83ca8eaab0383);
// Modified from https://github.com/jonschlinkert/is-plain-object/blob/master/index.js
function $5fb6f06fd995b7c2$var$isObject(val) {
    return val !== null && typeof val === 'object' && Array.isArray(val) === false;
}
function $5fb6f06fd995b7c2$var$isObjectObject(o) {
    return $5fb6f06fd995b7c2$var$isObject(o) === true && Object.prototype.toString.call(o) === '[object Object]';
}
function $5fb6f06fd995b7c2$export$53b83ca8eaab0383(o) {
    if ($5fb6f06fd995b7c2$var$isObjectObject(o) === false) return false;
    // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor !== 'function') return false;
    // If has modified prototype
    const prot = ctor.prototype;
    if ($5fb6f06fd995b7c2$var$isObjectObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (!('isPrototypeOf' in prot)) return false;
    // Most likely a plain Object
    return true;
}

});


parcelRegister("3uSCi", function(module, exports) {
$parcel$export(module.exports, "default", () => $3926a4e2a957d664$export$2e2bcd8739ae039);

var $626yf = parcelRequire("626yf");

var $dNbez = parcelRequire("dNbez");

var $a9WOW = parcelRequire("a9WOW");
class $3926a4e2a957d664$export$2e2bcd8739ae039 {
    constructor(fireDelayedEvent, compressors){
        this.delayQueue = void 0;
        this.delayTimeout = void 0;
        this.delayCallback = void 0;
        this.isDelaying = void 0;
        this.push = (identifier, builtEvent, context, userInfo)=>{
            this.delayQueue.push(identifier, builtEvent, context, userInfo);
        };
        this.startLowPriorityEventDelay = (timeout = (0, $626yf.DEFAULT_DELAY_TIMEOUT), callback)=>{
            if (Number.isNaN(timeout) || timeout <= 0) throw new Error(`Invalid timeout period: ${timeout}, must be a number greater than 0`);
            if (this.delayTimeout) clearTimeout(this.delayTimeout);
            const delayTimeoutPeriod = timeout ? Math.min(timeout, (0, $626yf.MAX_DELAY_TIMEOUT)) : (0, $626yf.MAX_DELAY_TIMEOUT);
            this.delayCallback = callback;
            this.delayTimeout = setTimeout(()=>this.stopLowPriorityEventDelay((0, $a9WOW.StopLowPriorityEventDelayReason).TIMEOUT), delayTimeoutPeriod);
            // If the queue is still flushing from a previous delay period, then we should cancel that flush
            // to stop it from negatively impacting the performance of the new critical section
            this.delayQueue.cancelFlush();
            this.isDelaying = true;
        };
        this.stopLowPriorityEventDelay = (reason = (0, $a9WOW.StopLowPriorityEventDelayReason).MANUAL)=>{
            if (this.delayTimeout) {
                clearTimeout(this.delayTimeout);
                this.delayTimeout = undefined;
            }
            this.delayQueue.startFlush();
            this.isDelaying = false;
            this.delayCallback?.(reason);
            this.delayCallback = undefined;
        };
        this.isDelayingLowPriorityEvents = ()=>this.isDelaying;
        this.isDelaying = false;
        this.delayQueue = new (0, $dNbez.default)(fireDelayedEvent, compressors);
    }
}

});
parcelRegister("626yf", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_DELAY_TIMEOUT", () => $a9b98d8b275947f0$export$cf090d5281b5ae06);
$parcel$export(module.exports, "MAX_DELAY_TIMEOUT", () => $a9b98d8b275947f0$export$8575e30be0feb909);
const $a9b98d8b275947f0$export$cf090d5281b5ae06 = 10000;
const $a9b98d8b275947f0$export$8575e30be0feb909 = 30000;

});

parcelRegister("dNbez", function(module, exports) {
$parcel$export(module.exports, "default", () => $83cd92524c3ca8b3$export$2e2bcd8739ae039);

var $7nd0Y = parcelRequire("7nd0Y");

var $5NC0R = parcelRequire("5NC0R");

var $fLcSm = parcelRequire("fLcSm");
// We want to throttle the flush rate so that we don't have a huge upfront performance hit from starting the flush,
// and so that the underlying Segment client has some time to process some events in its queue before more are added.
const $83cd92524c3ca8b3$var$FLUSH_BATCH_SIZE = 7; // aligns with the default batch size of Segment's BatchableQueue
const $83cd92524c3ca8b3$var$FLUSH_BATCH_BACKOFF_PERIOD = 100;
class $83cd92524c3ca8b3$export$2e2bcd8739ae039 {
    constructor(processFn, compressionRules){
        this.compressor = void 0;
        this.eventArgs = void 0;
        this.flushBatchTimeout = void 0;
        this.processFn = void 0;
        this.push = (identifier, builtEvent, context, userInfo)=>{
            this.eventArgs.push({
                identifier: identifier,
                builtEvent: builtEvent,
                context: context,
                userInfo: userInfo
            });
        };
        this.size = ()=>this.eventArgs.length;
        this.startFlush = ()=>{
            try {
                this.eventArgs = this.compressEventArgs(this.eventArgs);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.warn('Failed to perform compression on the delayed analytics events. ' + `Error: ${e.message}. Sending ${this.eventArgs.length} uncompressed events instead`);
            }
            this.flushNextBatch();
        };
        this.cancelFlush = ()=>{
            if (this.flushBatchTimeout) {
                clearTimeout(this.flushBatchTimeout);
                this.flushBatchTimeout = null;
            }
        };
        this.flushNextBatch = ()=>{
            const batch = this.eventArgs.splice(0, $83cd92524c3ca8b3$var$FLUSH_BATCH_SIZE);
            batch.forEach((item)=>this.processFn(item.identifier, item.builtEvent, item.context, item.userInfo));
            if (this.eventArgs.length > 0) this.flushBatchTimeout = setTimeout(()=>this.flushNextBatch(), $83cd92524c3ca8b3$var$FLUSH_BATCH_BACKOFF_PERIOD);
            else this.flushBatchTimeout = null;
        };
        this.compressEventArgs = (eventArgs)=>{
            const [compressibleEventArgs, incompressibleEventArgs] = (0, $5NC0R.partition)(eventArgs, (args)=>this.compressor.canCompress(args.builtEvent));
            // Events can only be compressed together if they share the same context and user info, since these are top-level
            // fields that need to exist on the fired event and can only be set to a single value.
            // We can achieve this by grouping our events by context prior to passing them to the compressor.
            const contextGroups = compressibleEventArgs.reduce((groups, args)=>{
                const matchingGroup = groups.find((group)=>(0, $5NC0R.equals)(group.userInfo, args.userInfo) && (0, $5NC0R.equals)(group.context, args.context));
                if (matchingGroup) matchingGroup.eventArgs.push(args);
                else groups.push({
                    userInfo: args.userInfo,
                    context: args.context,
                    eventArgs: [
                        args
                    ]
                });
                return groups;
            }, []);
            // Run the compressor on each group
            const allCompressedEventArgs = contextGroups.reduce((acc, group)=>{
                try {
                    const events = group.eventArgs.map((args)=>args.builtEvent);
                    const compressedEvents = this.compressor.compress(events);
                    const compressedEventArgs = compressedEvents.map((compressedEvent)=>({
                            identifier: (0, $7nd0Y.buildActionName)(compressedEvent),
                            builtEvent: compressedEvent,
                            userInfo: group.userInfo,
                            context: group.context
                        }));
                    return acc.concat(compressedEventArgs);
                } catch (e) {
                    // If anything goes wrong while compressing this group, then just fall back on the
                    // uncompressed events instead. The event compressor already handles errors with invalid
                    // generator functions or results, but this is an extra layer of defense to prevent data
                    // loss in the event of an unexpected error.
                    // eslint-disable-next-line no-console
                    console.warn('Failed to compress some analytics events. ' + `Error: ${e.message}. Sending ${group.eventArgs.length} uncompressed events instead`);
                    return group.eventArgs;
                }
            }, []);
            incompressibleEventArgs.forEach((args)=>allCompressedEventArgs.push(args));
            return allCompressedEventArgs;
        };
        this.processFn = processFn;
        this.flushBatchTimeout = null;
        this.eventArgs = [];
        this.compressor = new (0, $fLcSm.default)(compressionRules);
    }
}

});
parcelRegister("fLcSm", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ea8df375f1e7839$export$2e2bcd8739ae039);
/* eslint-disable implicit-arrow-linebreak */ /* eslint-disable max-classes-per-file */ 
var $7nd0Y = parcelRequire("7nd0Y");

var $5NC0R = parcelRequire("5NC0R");

var $lLftv = parcelRequire("lLftv");
class $2ea8df375f1e7839$export$2e2bcd8739ae039 {
    constructor(compressionRules = []){
        this.compressionRules = void 0;
        this.canCompress = (event)=>this.compressionRules.some((compressionRule)=>compressionRule.canCompress(event));
        this.compress = (events)=>{
            const groups = this.createGroups(events);
            return groups.reduce((allCompressedEvents, group)=>{
                const groupCompressedEvents = this.compressGroup(group);
                return allCompressedEvents.concat(groupCompressedEvents);
            }, []);
        };
        this.createGroups = (events)=>// Group events based on contextual fields. These fields are anything that is added by the client itself,
            // rather than passed in by the caller (eg. product, org. and tenant info)
            events.reduce((groups, event)=>{
                const matchingCompressor = this.compressionRules.find((compressor)=>compressor.canCompress(event));
                let contextFields;
                if (matchingCompressor) {
                    const actionFields = (0, $7nd0Y.buildActionFields)(event, event.eventType);
                    contextFields = (0, $5NC0R.omit)(event, Object.keys(actionFields));
                }
                const matchingGroup = groups.find((group)=>matchingCompressor === group.compressor && (0, $5NC0R.equals)(contextFields, group.contextFields));
                if (matchingGroup) matchingGroup.events.push(event);
                else groups.push({
                    contextFields: contextFields,
                    compressor: matchingCompressor,
                    events: [
                        event
                    ]
                });
                return groups;
            }, []);
        this.compressGroup = (group)=>{
            // If this group doesn't have any compressor, then the event args are already in their final format
            if (!group.compressor) return group.events;
            try {
                // Run the compressor on the group to generate some new events.
                // The compression function is only expected to return the action fields for each
                // event that it generates, since all other fields are generated by the client.
                const compressedEventActionFields = group.compressor.compress(group.events);
                // Add the context fields to each of the resulting events to inflate them into a full action event
                return compressedEventActionFields.map((actionFields)=>({
                        ...actionFields,
                        ...group.contextFields
                    }));
            } catch (e) {
                // If we fail to compress the events, then just fall back the uncompressed events
                // so that no data is lost. This can happen if the compression function throws an error
                // or returns some invalid event payloads.
                // eslint-disable-next-line no-console
                // console.warn(
                // 	'Failed to compress some analytics events. ' +
                // 		`Error: ${(e as Error).message}. Sending ${
                // 			group.events.length
                // 		} uncompressed events instead`,
                // );
                return group.events;
            }
        };
        if (!Array.isArray(compressionRules)) throw new Error('Event compressors must be constructed with an array of CompressionRules');
        if (!compressionRules.every((rule)=>rule instanceof (0, $lLftv.CompressionRule))) throw new Error('Event compressors can only be constructed with instances of CompressionRule');
        this.compressionRules = compressionRules;
    }
}

});
parcelRegister("lLftv", function(module, exports) {
$parcel$export(module.exports, "CompressionRule", () => $4a5b8143ef4a2caa$export$89b3253ddfd2e6e8);

var $2Kuwu = parcelRequire("2Kuwu");

var $5NC0R = parcelRequire("5NC0R");
class $4a5b8143ef4a2caa$export$89b3253ddfd2e6e8 {
    /**
   * @callback EventPredicate
   * @param {object} event An analytics event
   * @returns {boolean} A flag indicating whether or not the event matches the conditions
   */ /**
   * @callback CompressionFunction
   * @param {Array.<Object>} events A collection of analytics events that match the predicate of this compression rule
   * @returns {Array.<Object>} compressedEvents The compressed analytics events to fire
   */ /**
   * This constructor defines a new rule for compressing analytics events.
   * @param {EventPredicate} predicate
   * @param {CompressionFunction} compressFn
   */ constructor(predicate, compressFn){
        this.compressFn = void 0;
        this.predicate = void 0;
        /**
     * This function returns a flag indicating whether or not this instance is capable of compressing the given event.
     * @param event
     * @returns {boolean}
     */ this.canCompress = (event)=>{
            try {
                return event && (0, $2Kuwu.isActionEventType)(event.eventType) && this.predicate(event);
            } catch (e) {
                return false;
            }
        };
        /**
     * This function compresses as many events in the given collection as possible.<p>
     * Any events in the given collection that do not match the conditions of {@link canCompress} will be left uncompressed and
     * appended to the end of the resulting array.
     *
     * @param events A collection of analytic events to compress
     * @returns {Array.<Object>} The action fields for the resulting compressed events
     */ this.compress = (events)=>{
            const [compatibleEvents, incompatibleEvents] = (0, $5NC0R.partition)(events, (event)=>this.canCompress(event));
            const compressedEvents = this.compressFn(compatibleEvents);
            if (!compressedEvents) throw new Error('No events were returned from the compression function');
            compressedEvents.forEach((event)=>{
                (0, $2Kuwu.validateActionEventType)(event.eventType);
                (0, $2Kuwu.validateActionEvent)(event);
            });
            return compressedEvents.concat(incompatibleEvents);
        };
        if (typeof predicate !== 'function') throw new Error('Invalid predicate, must be a function that accepts an event and returns a boolean');
        if (typeof compressFn !== 'function') throw new Error('Invalid compressFn, must be a function that both accepts and returns an array of events');
        this.predicate = predicate;
        this.compressFn = compressFn;
    }
}

});
parcelRegister("2Kuwu", function(module, exports) {
$parcel$export(module.exports, "validateContainers", () => $f0bdb0e88da5912a$export$e63ea5d8477971d3);
$parcel$export(module.exports, "isActionEventType", () => $f0bdb0e88da5912a$export$d19cebda16f7579a);
$parcel$export(module.exports, "validateActionEventType", () => $f0bdb0e88da5912a$export$4a8d7476662aebcc);
$parcel$export(module.exports, "validateActionEvent", () => $f0bdb0e88da5912a$export$e0c121325c66ed4c);
$parcel$export(module.exports, "validateScreenEvent", () => $f0bdb0e88da5912a$export$dc993432a592dc27);
$parcel$export(module.exports, "validateTrackEvent", () => $f0bdb0e88da5912a$export$8c014fd74b0c8b99);
$parcel$export(module.exports, "validateDwellBaseEvent", () => $f0bdb0e88da5912a$export$39d6334da9a44984);
$parcel$export(module.exports, "validateUIEvent", () => $f0bdb0e88da5912a$export$e5bac0930c812e90);
$parcel$export(module.exports, "validateOperationalEvent", () => $f0bdb0e88da5912a$export$1e561554275607ef);
$parcel$export(module.exports, "validateIdentifyEvent", () => $f0bdb0e88da5912a$export$c16a4e16aa4026c0);
$parcel$export(module.exports, "validatePlatform", () => $f0bdb0e88da5912a$export$801b46c35394d316);

var $2tp3i = parcelRequire("2tp3i");

var $dYbY5 = parcelRequire("dYbY5");
const $f0bdb0e88da5912a$var$actionEventTypes = Object.freeze([
    (0, $2tp3i.eventType).OPERATIONAL,
    (0, $2tp3i.eventType).TRACK,
    (0, $2tp3i.eventType).UI
]);
function $f0bdb0e88da5912a$export$df8ff30e3c960006(container) {
    if (!(0, $dYbY5.isPlainObject)(container)) throw new Error('properties.containers must be an Object');
    if (!('id' in container)) throw new Error("properties.containers is missing field 'id'");
    if (typeof container.id !== 'string') throw new Error('properties.containers.id must be of type String');
    if ('type' in container && typeof container.type !== 'string') throw new Error('properties.containers.type must be of type String');
}
function $f0bdb0e88da5912a$export$e63ea5d8477971d3(containers) {
    if (!containers) return;
    if (containers && containers.constructor !== Object) throw new Error('properties.containers must be an Object');
    Object.values(containers).forEach((container)=>$f0bdb0e88da5912a$export$df8ff30e3c960006(container));
}
function $f0bdb0e88da5912a$export$d19cebda16f7579a(type) {
    switch(type){
        case (0, $2tp3i.eventType).OPERATIONAL:
        case (0, $2tp3i.eventType).TRACK:
        case (0, $2tp3i.eventType).UI:
            return true;
        default:
            return false;
    }
}
function $f0bdb0e88da5912a$export$4a8d7476662aebcc(type) {
    if (!$f0bdb0e88da5912a$export$d19cebda16f7579a(type)) throw new Error(`Invalid action event type: ${type}, must be one of: [${$f0bdb0e88da5912a$var$actionEventTypes}]`);
    return true;
}
function $f0bdb0e88da5912a$export$e0c121325c66ed4c(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
    if (!event.action) throw new Error('Missing event.action');
    $f0bdb0e88da5912a$export$e63ea5d8477971d3(event.containers);
}
function $f0bdb0e88da5912a$export$dc993432a592dc27(name) {
    if (!name) throw new Error('Missing name');
}
function $f0bdb0e88da5912a$export$8c014fd74b0c8b99(event) {
    $f0bdb0e88da5912a$export$e0c121325c66ed4c(event);
}
function $f0bdb0e88da5912a$export$39d6334da9a44984(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
}
function $f0bdb0e88da5912a$export$e5bac0930c812e90(event) {
    $f0bdb0e88da5912a$export$e0c121325c66ed4c(event);
}
function $f0bdb0e88da5912a$export$1e561554275607ef(event) {
    $f0bdb0e88da5912a$export$e0c121325c66ed4c(event);
}
function $f0bdb0e88da5912a$export$c16a4e16aa4026c0(userIdType, userId) {
    if (!userIdType) throw new Error('Missing userIdType');
    if (!userId) throw new Error('Missing userId');
    if (!(0, $2tp3i.isType)((0, $2tp3i.userType), userIdType)) throw new Error(`Invalid userIdType '${userIdType}', ` + `must be an userType: [${(0, $2tp3i.objectValues)((0, $2tp3i.userType))}]`);
}
function $f0bdb0e88da5912a$export$801b46c35394d316(productInfo) {
    if (!(0, $2tp3i.isType)((0, $2tp3i.platformType), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + `must be a platformType: [${(0, $2tp3i.objectValues)((0, $2tp3i.platformType))}]`);
    if (productInfo.origin === (0, $2tp3i.originType).DESKTOP && !(0, $2tp3i.isType)((0, $2tp3i.desktopPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + 'must be one of [mac, linux, windows]');
    if (productInfo.origin === (0, $2tp3i.originType).WEB && !(0, $2tp3i.isType)((0, $2tp3i.webPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', must be one of [web, mobileWeb]`);
}

});




parcelRegister("a9WOW", function(module, exports) {
$parcel$export(module.exports, "StopLowPriorityEventDelayReason", () => $729028dd340fdd0d$export$fa6e3729c21cb8f);
var $729028dd340fdd0d$export$fa6e3729c21cb8f = /*#__PURE__*/ function(StopLowPriorityEventDelayReason) {
    StopLowPriorityEventDelayReason["TIMEOUT"] = "timeout";
    StopLowPriorityEventDelayReason["MANUAL"] = "manual";
    return StopLowPriorityEventDelayReason;
}({});

});


parcelRegister("4J7ab", function(module, exports) {
$parcel$export(module.exports, "default", () => $4f1c55afdc5629ee$export$2e2bcd8739ae039);

var $h68Rj = parcelRequire("h68Rj");

var $4BiDK = parcelRequire("4BiDK");

var $aO8Eq = parcelRequire("aO8Eq");

var $2AI7d = parcelRequire("2AI7d");

var $kHJVt = parcelRequire("kHJVt");

var $2srEX = parcelRequire("2srEX");

var $7SKVk = parcelRequire("7SKVk");

var $jP4qk = parcelRequire("jP4qk");

var $3aC6W = parcelRequire("3aC6W");
class $4f1c55afdc5629ee$var$AnalyticsAPIResponse {
    isSuccess() {
        return this.success;
    }
    getValidationErrors() {
        return this.validationErrors;
    }
    getMessage() {
        return this.message;
    }
    getCode() {
        return this.code;
    }
    getValidationReports() {
        return this.validationReports === undefined ? null : this.validationReports;
    }
    constructor(success, validationErrors, message, code, validationReports){
        this.success = void 0;
        this.validationErrors = void 0;
        this.message = void 0;
        this.code = void 0;
        this.validationReports = void 0;
        this.success = success;
        this.validationErrors = validationErrors;
        this.message = message;
        this.code = code;
        this.validationReports = validationReports;
    }
}
class $4f1c55afdc5629ee$var$Message {
    constructor(error){
        this.error = void 0;
        this.error = error;
    }
}
class $4f1c55afdc5629ee$var$EventValidationReport {
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
    constructor(messageId, results){
        this.messageId = void 0;
        this.results = void 0;
        this.messageId = messageId;
        this.results = results;
    }
}
class $4f1c55afdc5629ee$export$133650fcdde1b226 {
    isSuccess() {
        return this.success;
    }
    getStatusCode() {
        return this.statusCode;
    }
    getMessage() {
        return this.message;
    }
    getEventResponseList() {
        return this.eventResponseList;
    }
    constructor(success, statusCode, message, eventResponseList){
        this.success = void 0;
        this.statusCode = void 0;
        this.message = void 0;
        this.eventResponseList = void 0;
        this.success = success;
        this.statusCode = statusCode;
        this.message = message;
        this.eventResponseList = eventResponseList;
    }
}
class $4f1c55afdc5629ee$var$EventResponse {
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
    getSegmentEvent() {
        return this.segmentEvent;
    }
    constructor(messageId, results, segmentEvent){
        this.messageId = void 0;
        this.results = void 0;
        this.segmentEvent = void 0;
        this.messageId = messageId;
        this.results = results;
        this.segmentEvent = segmentEvent;
    }
}
class $4f1c55afdc5629ee$var$EventValidationResult {
    getType() {
        return this.type;
    }
    getSeverity() {
        return this.severity;
    }
    getPropertyPath() {
        return this.propertyPath;
    }
    getMessage() {
        return this.message;
    }
    constructor(type, severity, propertyPath, message){
        this.type = void 0;
        this.severity = void 0;
        this.propertyPath = void 0;
        this.message = void 0;
        this.type = type;
        this.severity = severity;
        this.propertyPath = propertyPath;
        this.message = message;
    }
}
class $4f1c55afdc5629ee$export$2e2bcd8739ae039 {
    getUser() {
        return this.user;
    }
    async track(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $7SKVk.SegmentEventTypes).TRACK, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $7SKVk.SegmentEventTypes).TRACK,
            properties: (0, $3aC6W.prepareEventProperties)(builtEvent),
            event: eventName
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    async page(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $7SKVk.SegmentEventTypes).PAGE, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $7SKVk.SegmentEventTypes).PAGE,
            properties: (0, $3aC6W.prepareEventProperties)(builtEvent),
            name: eventName
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    // Segment uses the identifier to update user id which we have already done in the analyticsWebClient.ts
    async identify(_identifier, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $7SKVk.SegmentEventTypes).IDENTIFY, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $7SKVk.SegmentEventTypes).IDENTIFY,
            traits: (0, $3aC6W.prepareEventProperties)(builtEvent)
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    async enqueueEvent(packagedEvent) {
        if (this.options.enableMetadataCalls) this.metadataClient.start(false); // Start the metadata client if needed
        await this.resilienceQueue.addItem(packagedEvent);
    }
    buildBaseEvent(context, type, overrides) {
        const clonedContext = (0, $3aC6W.prepareEventProperties)(context);
        const segmentContext = (0, $3aC6W.buildContext)(clonedContext);
        return {
            context: segmentContext,
            timestamp: new Date().toISOString(),
            type: type,
            userId: this.user.getUserId(),
            anonymousId: overrides.anonymousId || this.user.getAnonymousId()
        };
    }
    createMessageId() {
        return `ajs-${crypto.randomUUID()}`;
    }
    packageEvent(event) {
        const { apiHost: apiHost, apiHostProtocol: apiHostProtocol } = this.options;
        return {
            headers: {
                'Content-Type': 'text/plain'
            },
            msg: event,
            url: `${apiHostProtocol}://${apiHost}/${event.type.charAt(0)}`
        };
    }
    getEventUrl(metadataInfo) {
        const preferredBatchUrl = metadataInfo?.url ? metadataInfo.url : this.gasv3BatchUrl;
        const finalBatchUrl = this.useUrlFromMetadata ? preferredBatchUrl : this.gasv3BatchUrl;
        const isFallbackUrl = preferredBatchUrl === this.gasv3BatchUrl ? null : finalBatchUrl !== preferredBatchUrl;
        return [
            finalBatchUrl,
            isFallbackUrl
        ];
    }
    cleanLibraryMetadata(obj) {
        // skip if the parameter is not an object
        if (obj === null || typeof obj !== 'object') return;
        for(const key in obj){
            // Skip cleaning up props object and its keys
            // to avoid having to check the existence of the fields in props object
            // and manipulate them to calculate metadata signature in analytics service
            if (key === 'props') continue;
            let value = obj[key];
            // Remove null or undefined values
            if (value === null || value === undefined) delete obj[key];
            else if (typeof value === 'number' && value === 0) delete obj[key];
            else if (Array.isArray(value)) {
                if (value.length === 0) delete obj[key];
                else value.forEach((item)=>{
                    this.cleanLibraryMetadata(item);
                });
            } else if (typeof value === 'object') this.cleanLibraryMetadata(obj[key]);
        }
    }
    async invokeLocalResponseCallbackAsync(items, response, error) {
        const localResponseCallback = this.responseCallback;
        if (localResponseCallback) {
            // If we have a response, we'll parse it and create an AnalyticsAPIResponse from it.
            let analyticsAPIResponse = null;
            if (response) {
                let responseObject;
                try {
                    responseObject = await response.clone().json();
                } catch (error) {
                // Ignore errors parsing the response, we can't do anything about them
                }
                // Ensure we've got a valid object to work with, filling in any missing
                // properties as best we can.
                responseObject = responseObject || {};
                responseObject.code = Number.parseInt(responseObject.code) > 0 ? Number.parseInt(responseObject.code) : response.status;
                responseObject.success = responseObject.success || responseObject.code >= 200 && responseObject.code <= 299;
                analyticsAPIResponse = new $4f1c55afdc5629ee$var$AnalyticsAPIResponse(responseObject.success, responseObject.validationErrors || new Map(), new $4f1c55afdc5629ee$var$Message(responseObject.message?.error || ''), responseObject.code, responseObject.validationReports || null);
            }
            // If we have an error, but it's not an instance of Error (e.g. it's a string), we'll convert it to an Error object.
            if (error && !(error instanceof Error)) error = new Error(String(error));
            const analyticsResponse = $4f1c55afdc5629ee$var$BatchInterceptor.toAnalyticsResponse(items || [], error || null, // In case 'error' were to be undefined we'll convert it to null.
            analyticsAPIResponse);
            localResponseCallback(analyticsResponse);
        }
    }
    async attachXIDs(items) {
        if (this.xidPromiseCallback) return (0, $aO8Eq.attachXidToMultipleEvents)(items, this.xidPromiseCallback);
        return Promise.resolve(items);
    }
    setResponseCallback(responseCallback) {
        this.responseCallback = responseCallback;
    }
    refreshMetadata(userInfo, tenantInfo) {
        this.metadataClient.userInfo = userInfo;
        this.metadataClient.tenantInfo = tenantInfo;
    }
    constructor(options){
        this.user = void 0;
        this.options = void 0;
        this.resilienceQueue = void 0;
        this.gasv3BatchUrl = void 0;
        this.metrics = void 0;
        this.xidPromiseCallback = void 0;
        this.responseCallback = void 0;
        this.metadataClient = void 0;
        this.useUrlFromMetadata = void 0;
        this.lastSendEventsError = void 0;
        this.lastUrlFallbackError = void 0;
        // Using anonymous function so it can have the BatchFlushCallback type associated with it
        // And to allow it to not need bind when passing through to ResilieceQueue.
        this.sendEvents = async (items, callback)=>{
            if (this.options.enableEventCalls === false) return;
            const httpRetryCount = this.resilienceQueue.getGlobalRetryCount();
            const metricsPayload = this.metrics.getMetricsPayload();
            const eventsWithXID = await this.attachXIDs(items);
            // Calculating sentAt after the XID generation as this may take some time.
            const sentAt = new Date().toISOString();
            const metadataInfo = await this.metadataClient.getMetadataAsync();
            const [eventUrl, isFallbackUrl] = this.getEventUrl(metadataInfo);
            const metadata = {
                ...metricsPayload,
                httpRetryCount: httpRetryCount,
                lastSendEventsErrorReason: this.lastSendEventsError?.message || null,
                // Temporary back-compat
                lastSendEventsError: this.lastSendEventsError,
                lastUrlFallbackError: this.lastUrlFallbackError,
                isUsingFallbackUrl: isFallbackUrl,
                props: metadataInfo?.props || null,
                metadataClientMetrics: this.metadataClient?.metrics || null
            };
            // Remove default values from metadata to save space
            this.cleanLibraryMetadata(metadata);
            const unpackagedEvents = eventsWithXID.map((item)=>{
                item.msg.sentAt = sentAt;
                return item.msg;
            });
            const batchBody = {
                batch: unpackagedEvents,
                sentAt: sentAt,
                metadata: metadata
            };
            try {
                const response = await (0, $2srEX.sendEvents)({
                    url: eventUrl,
                    batch: batchBody,
                    timeout: this.options.requestTimeout
                });
                this.lastSendEventsError = null;
                this.lastUrlFallbackError = null;
                this.metrics.subtractFromMetrics(metricsPayload);
                callback(null, response);
                await this.invokeLocalResponseCallbackAsync(items, response, null);
            } catch (error) {
                // If there's an error, other than one which indicates a temporary problem with the service,
                // we'll stop using the URL from the metadata and fall back to the default URL. After a time
                // we'll fall forward again in case the problem has been resolved.
                if (error instanceof (0, $7SKVk.FetchError) && [
                    429,
                    503
                ].includes(error.statusCode)) // Ignore 429 and 503 errors since they're considered to indicate a temporary
                // issue with the service, rather than a network failure due to blocked requests.
                this.lastSendEventsError = new (0, $7SKVk.LastError)('ServerBusyError', error);
                else {
                    const errorName = error instanceof Error && (0, $7SKVk.ALLOW_LISTED_FETCH_ERROR_NAMES).includes(error.name) ? error.name : 'Unknown';
                    this.lastSendEventsError = new (0, $7SKVk.LastError)(errorName, error);
                    // Handle falling back to the default URL if we're using the metadata URL.
                    this.useUrlFromMetadata = false;
                    // If we're now using the fallback URL, and the last attempt wasn't,
                    // we'll record this as the error that triggered the fallback.
                    const [_, willUseFallbackUrl] = this.getEventUrl(metadataInfo);
                    if (willUseFallbackUrl && willUseFallbackUrl !== isFallbackUrl) this.lastUrlFallbackError = this.lastSendEventsError;
                }
                callback(error, null);
                await this.invokeLocalResponseCallbackAsync(items, null, error);
            }
        };
        this.options = {
            ...options,
            requestTimeout: options.requestTimeout || (0, $2AI7d.DEFAULT_REQUEST_TIMEOUT),
            retryQueueOptions: options.retryQueueOptions || {},
            logger: options.logger || console,
            disableCookiePersistence: options.disableCookiePersistence || false,
            env: options.env,
            perimeter: options.perimeter || '',
            enableMetadataCalls: typeof options.enableMetadataCalls === 'boolean' ? options.enableMetadataCalls : true,
            enableEventCalls: typeof options.enableEventCalls === 'boolean' ? options.enableEventCalls : true
        };
        this.user = new (0, $jP4qk.default)(this.options?.disableCookiePersistence);
        this.xidPromiseCallback = options.xidPromiseGetter();
        this.gasv3BatchUrl = `${options.apiHostProtocol}://${options.apiHost}/batch`;
        this.metrics = (0, $4BiDK.default)();
        this.responseCallback = options.responseCallback;
        this.resilienceQueue = (0, $h68Rj.default)(options.retryQueuePrefix, options.product, this.options.retryQueueOptions, this.options.logger);
        this.metadataClient = options.metadataClient;
        this.useUrlFromMetadata = true;
        this.lastSendEventsError = null;
        this.lastUrlFallbackError = null;
        setInterval(()=>{
            this.useUrlFromMetadata = true;
        }, 600000);
        this.resilienceQueue.start(this.sendEvents);
    }
}
class $4f1c55afdc5629ee$var$BatchInterceptor {
    static toAnalyticsResponse(items, error, analyticsAPIResponse) {
        const eventResponseList = [];
        if (analyticsAPIResponse !== null) {
            const [statusCode, success] = [
                analyticsAPIResponse.code,
                analyticsAPIResponse.success
            ];
            if (statusCode >= 200 && statusCode <= 299) {
                analyticsAPIResponse.validationReports?.forEach((report)=>{
                    const matchedEvent = items.find((item)=>item.msg.messageId === report.messageId);
                    if (matchedEvent) eventResponseList.push(new $4f1c55afdc5629ee$var$EventResponse(matchedEvent.msg.messageId, report.results, matchedEvent.msg));
                });
                return new $4f1c55afdc5629ee$export$133650fcdde1b226(success, statusCode, (0, $kHJVt.HTTP_STATUS_CODE_MAP).get(statusCode), eventResponseList);
            } else if (statusCode >= 400 && statusCode <= 499) {
                // not exluding "HTTP 429 Too Many Requests error" as it is thrown as an error and handled below
                const errorMessage = analyticsAPIResponse.message?.error !== null ? analyticsAPIResponse.message.error : (0, $kHJVt.HTTP_STATUS_CODE_MAP).has(statusCode) ? (0, $kHJVt.HTTP_STATUS_CODE_MAP).get(statusCode) : (0, $kHJVt.HTTP_STATUS_CODE_MAP).get(-1);
                items.forEach((item)=>{
                    eventResponseList.push(new $4f1c55afdc5629ee$var$EventResponse(item.msg.messageId, [], item.msg));
                });
                return new $4f1c55afdc5629ee$export$133650fcdde1b226(success, statusCode, errorMessage, eventResponseList);
            }
        } else if (error?.message) {
            const match = error.message.match($4f1c55afdc5629ee$var$BatchInterceptor.http_error_regex);
            if (match) {
                items.forEach((item)=>{
                    eventResponseList.push(new $4f1c55afdc5629ee$var$EventResponse(item.msg.messageId, [], item.msg));
                });
                return new $4f1c55afdc5629ee$export$133650fcdde1b226(false, Number(match[1]), match[2], eventResponseList);
            }
        }
        items.forEach((item)=>{
            eventResponseList.push(new $4f1c55afdc5629ee$var$EventResponse(item.msg.messageId, [], item.msg));
        });
        return new $4f1c55afdc5629ee$export$133650fcdde1b226(false, -1, (0, $kHJVt.HTTP_STATUS_CODE_MAP).get(-1), eventResponseList);
    }
}
$4f1c55afdc5629ee$var$BatchInterceptor.http_error_regex = /HTTP Error\s([0-9]{3})\s\((.+)\)/;

});
parcelRegister("h68Rj", function(module, exports) {
$parcel$export(module.exports, "default", () => $a9165b29dc0d3f85$export$2e2bcd8739ae039);

var $hApEI = parcelRequire("hApEI");

var $2E5bV = parcelRequire("2E5bV");
var $a9165b29dc0d3f85$export$2e2bcd8739ae039 = (retryQueuePrefix, product, options, logger)=>{
    return new (0, $hApEI.default)(retryQueuePrefix, product, options || {}, logger);
};

});
parcelRegister("hApEI", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_POLLING_OPTIONS", () => $345b96a9ec938c53$export$d219df4fe04c04a7);
$parcel$export(module.exports, "default", () => $345b96a9ec938c53$export$2e2bcd8739ae039);

var $iHn46 = parcelRequire("iHn46");
var $detUb = parcelRequire("detUb");

var $bdglF = parcelRequire("bdglF");
var $el3QZ = parcelRequire("el3QZ");
var $9ryIE = parcelRequire("9ryIE");

var $4BiDK = parcelRequire("4BiDK");

var $8viHC = parcelRequire("8viHC");

var $e9dzS = parcelRequire("e9dzS");
var $INLhk = parcelRequire("INLhk");

var $2E5bV = parcelRequire("2E5bV");
const $345b96a9ec938c53$var$ONE_MINUTE = 60000;
const $345b96a9ec938c53$var$LONG_POLLING_OPTIONS = {
    backoffFactor: 0,
    backoffJitterPercentage: 0,
    flushWaitMs: $345b96a9ec938c53$var$ONE_MINUTE,
    minRetryDelay: $345b96a9ec938c53$var$ONE_MINUTE,
    maxRetryDelay: $345b96a9ec938c53$var$ONE_MINUTE
};
const $345b96a9ec938c53$export$d219df4fe04c04a7 = {
    backoffFactor: 2,
    backoffJitterPercentage: 0.2,
    batchFlushSize: 7,
    flushBeforeUnload: false,
    flushWaitMs: 500,
    maxAttempts: 10,
    // TODO figure out this number. For indexeddb we are sharing the queue with all tabs
    maxItems: 1000,
    maxRetryDelay: 30000,
    minRetryDelay: 1000
};
class $345b96a9ec938c53$export$2e2bcd8739ae039 {
    start(flushCallback) {
        this.batchFlushCallback = flushCallback;
        this.longPollingScheduler.schedule();
    }
    stop() {
        this.scheduler.stop();
        this.longPollingScheduler.stop();
    }
    async addItem(item) {
        // Since Jira and Confluence use `.toJSON` on objects that should be strings
        // And expect us to use `JSON.stringify` on these objects,
        // And indexeddb strips these functions from the objects when adding them to the DB,
        // We must run this silly stringify and parse before passing the event to the resilience meechanism.
        // Planning on removing this in v4
        const jsonStringifiedAndParsedItem = JSON.parse(JSON.stringify(item));
        const { numberOfEvictedItems: numberOfEvictedItems } = await this.resilience.addItem(jsonStringifiedAndParsedItem, {}, (0, $9ryIE.GuardPolicy).EVICT);
        this.scheduler.schedule();
        this.metricsCollector.addToEventCount();
        if (numberOfEvictedItems > 0) this.metricsCollector.addToItemsDiscardedByOverflowCounter(numberOfEvictedItems);
    }
    getGlobalRetryCount() {
        return this.scheduler.getFailureCount();
    }
    async scheduleCallback(done) {
        // Even though we stopped the scheduler, it can be restarted with a call to schedule.
        // This could be triggered by a new event or the longPollingScheduler
        if (this.networkStatus.getNetworkStatus() === (0, $2E5bV.NetworkStatusEnum).OFFLINE) {
            done((0, $INLhk.DoneState).NOOP);
            return;
        }
        try {
            const result = await this.resilience.processItems(this.flush.bind(this), this.options.batchFlushSize);
            done(result);
        } catch (error) {
            if (error.name === (0, $bdglF.CallbackProcessingErrorName)) {
                done((0, $INLhk.DoneState).ERROR);
                return;
            }
        // TODO we can probably log here but throwing is useless as it will just be shallowed by the Scheduler
        // In theory something else should catch all other errors from indexeddb and this should never happen.
        } finally{
            await this.checkEventCountAndReschedule();
        }
    }
    async checkEventCountAndReschedule() {
        const eventWaitingCount = await this.resilience.getItemCount();
        if (eventWaitingCount > 0) this.scheduler.schedule({
            immediate: eventWaitingCount >= this.options.batchFlushSize
        });
    }
    async scheduleLongCallBack(done) {
        // Eventually we will want to send data about how many queues were purged
        const numberOfQueuesPurged = (0, $iHn46.default)(this.queuePrefix);
        this.metricsCollector.addToPurgedQueuesMetrics(numberOfQueuesPurged);
        // Eventually we will want to send data about how attempted reclaims and actual reclaims were made
        const reclaimMetrics = await (0, $detUb.default)(this.queuePrefix, async (localStorageItems)=>{
            const itemsToAdd = localStorageItems.map((localStorageItem)=>({
                    item: localStorageItem.item,
                    retryAttempts: localStorageItem.attemptNumber,
                    id: localStorageItem.id
                }));
            const { items: addedEvents } = await this.resilience.bulkAddItem(itemsToAdd, (0, $9ryIE.GuardPolicy).IGNORE);
            if (addedEvents.length === itemsToAdd.length) return {
                status: 'successful'
            };
            else return {
                status: 'partial',
                acceptedItemIds: addedEvents.map((event)=>event.id)
            };
        });
        this.metricsCollector.addToReclaimMetrics(reclaimMetrics);
        // We dont want to flush events from here as there maybe issues with analytics-service
        // Scheduler has all the context and can schedule the next batch accordingly
        await this.checkEventCountAndReschedule();
        done((0, $INLhk.DoneState).SUCCESS);
        this.longPollingScheduler.schedule();
    }
    flush(wrappedItems, otherMetadata) {
        this.metricsCollector.setResilienceMechanism(this.resilience.storeType());
        const { batchFlushCallback: batchFlushCallback } = this;
        if (!batchFlushCallback) throw new Error('batchFlushCallback has not been set. Call PullBatchableQueue#start first.');
        return new Promise((resolve, reject)=>{
            if (wrappedItems.length <= 0) {
                resolve((0, $INLhk.DoneState).NOOP);
                return;
            }
            const items = wrappedItems.map((wrappedItem)=>{
                const item = wrappedItem.item;
                if (wrappedItem.retryAttempts > 0 && item.msg) {
                    if (!item.msg._metadata) item.msg._metadata = {};
                    item.msg._metadata.failedAttempts = wrappedItem.retryAttempts;
                }
                return item;
            });
            batchFlushCallback(items, (error)=>{
                if (error) {
                    if (otherMetadata.numberOfDeletedItems > 0) this.metricsCollector.addToItemsDiscardedByRetryCounter(otherMetadata.numberOfDeletedItems);
                    reject(error);
                } else resolve((0, $INLhk.DoneState).SUCCESS);
            });
        });
    }
    buildOptions(options) {
        return {
            backoffFactor: options?.backoffFactor || $345b96a9ec938c53$export$d219df4fe04c04a7.backoffFactor,
            backoffJitterPercentage: options?.backoffJitterPercentage !== undefined ? options.backoffJitterPercentage : $345b96a9ec938c53$export$d219df4fe04c04a7.backoffJitterPercentage,
            batchFlushSize: options?.batchFlushSize || $345b96a9ec938c53$export$d219df4fe04c04a7.batchFlushSize,
            flushBeforeUnload: options?.flushBeforeUnload || $345b96a9ec938c53$export$d219df4fe04c04a7.flushBeforeUnload,
            flushWaitMs: options?.flushWaitMs || $345b96a9ec938c53$export$d219df4fe04c04a7.flushWaitMs,
            maxItems: options?.maxItems || $345b96a9ec938c53$export$d219df4fe04c04a7.maxItems,
            maxAttempts: options?.maxAttempts || $345b96a9ec938c53$export$d219df4fe04c04a7.maxAttempts,
            maxRetryDelay: options?.maxRetryDelay || $345b96a9ec938c53$export$d219df4fe04c04a7.maxRetryDelay,
            minRetryDelay: options?.minRetryDelay || $345b96a9ec938c53$export$d219df4fe04c04a7.minRetryDelay
        };
    }
    constructor(queuePrefix, product, options, logger){
        this.queuePrefix = void 0;
        this.resilience = void 0;
        this.batchFlushCallback = void 0;
        this.options = void 0;
        this.scheduler = void 0;
        this.longPollingScheduler = void 0;
        this.metricsCollector = void 0;
        this.networkStatus = void 0;
        this.queuePrefix = queuePrefix;
        // Avoiding using options in ResilienceDB at this stage as
        // the options are optimised for the PushBatchableQueue
        this.resilience = new (0, $el3QZ.default)(product, {
            logger: logger,
            maxAttempts: options?.maxAttempts,
            maxEventLimit: options?.maxItems
        });
        this.options = this.buildOptions(options);
        this.scheduler = new (0, $e9dzS.default)({
            ...this.options,
            waitInterval: options?.flushBeforeUnload ? 0 : this.options.flushWaitMs
        }, this.scheduleCallback.bind(this));
        this.longPollingScheduler = new (0, $e9dzS.default)({
            ...$345b96a9ec938c53$var$LONG_POLLING_OPTIONS,
            waitInterval: $345b96a9ec938c53$var$LONG_POLLING_OPTIONS.flushWaitMs
        }, this.scheduleLongCallBack.bind(this));
        this.metricsCollector = (0, $4BiDK.default)();
        this.networkStatus = new (0, $8viHC.default)((status)=>{
            if (status === (0, $2E5bV.NetworkStatusEnum).OFFLINE) this.scheduler.stop();
            else this.checkEventCountAndReschedule();
        });
    }
}

});
parcelRegister("iHn46", function(module, exports) {
$parcel$export(module.exports, "default", () => $c9d7008524549aea$export$2e2bcd8739ae039);

var $6Ux1c = parcelRequire("6Ux1c");

var $2oG9m = parcelRequire("2oG9m");
// For more details on this funciton, see https://hello.atlassian.net/wiki/spaces/MEASURE/pages/585086028/Investigation+Local+storage+full
// TL;DR
// If a queue looses its `ack` key in localstorage, it will never get claimed.
// There is a small chance that this can happen.
// This function is to run through queues and clean any that have been orphaned.
// Keys stolen from https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L55
const $c9d7008524549aea$var$validSuffixs = Object.values((0, $6Ux1c.LocalStorageKeySuffix));
var $c9d7008524549aea$export$2e2bcd8739ae039 = (prefix)=>{
    if (typeof prefix !== 'string' || prefix.length === 0) // We do not want to start deleting everything in localstorage
    return 0;
    try {
        const queueStates = Object.keys(localStorage).filter((key)=>key && key.startsWith(`${prefix}.`) || false).map((key)=>key.split('.')).filter((splitKeys)=>splitKeys.length === 3 && $c9d7008524549aea$var$validSuffixs.includes(splitKeys[2])).reduce((accumulator, currentKeys)=>{
            const [, id, suffix] = currentKeys;
            if (accumulator[id] === undefined) accumulator[id] = {};
            accumulator[id][suffix] = true;
            return accumulator;
        }, {});
        const queuesToPurge = Object.keys(queueStates).filter((id)=>queueStates[id][(0, $6Ux1c.LocalStorageKeySuffix).ACK] !== true);
        queuesToPurge.forEach((id)=>{
            const { queue: queue, inProgress: inProgress, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = (0, $2oG9m.createLocalStorageKeys)(prefix, id);
            localStorage.removeItem(inProgress);
            localStorage.removeItem(queue);
            localStorage.removeItem(reclaimStart);
            localStorage.removeItem(reclaimEnd);
        });
        return queuesToPurge.length;
    } catch (_error) {
    // Ignore errors from localStorage.
    }
    return 0;
};

});
parcelRegister("6Ux1c", function(module, exports) {
$parcel$export(module.exports, "LocalStorageKeySuffix", () => $8da602f2940e1b79$export$ecfa71cbc9b28241);
$parcel$export(module.exports, "Timers", () => $8da602f2940e1b79$export$8bb2c1fb2b1765a9);
var $8da602f2940e1b79$export$ecfa71cbc9b28241 = /*#__PURE__*/ function(LocalStorageKeySuffix) {
    LocalStorageKeySuffix["IN_PROGRESS"] = "inProgress";
    LocalStorageKeySuffix["QUEUE"] = "queue";
    LocalStorageKeySuffix["RECLAIM_START"] = "reclaimStart";
    LocalStorageKeySuffix["RECLAIM_END"] = "reclaimEnd";
    LocalStorageKeySuffix["ACK"] = "ack";
    return LocalStorageKeySuffix;
}({});
var $8da602f2940e1b79$export$8bb2c1fb2b1765a9 = /*#__PURE__*/ function(Timers) {
    Timers[Timers["RECLAIM_TIMEOUT"] = 10000] = "RECLAIM_TIMEOUT";
    Timers[Timers["RECLAIM_WAIT"] = 500] = "RECLAIM_WAIT";
    Timers[Timers["RECLAIM_WAIT_THRESHOLD"] = 2000] = "RECLAIM_WAIT_THRESHOLD";
    return Timers;
}({});

});

parcelRegister("2oG9m", function(module, exports) {
$parcel$export(module.exports, "createLocalStorageKeys", () => $0022cd52747a8725$export$8433d54f767cbec5);

var $6Ux1c = parcelRequire("6Ux1c");
const $0022cd52747a8725$export$8433d54f767cbec5 = (queuePrefix, queueId)=>({
        [(0, $6Ux1c.LocalStorageKeySuffix).ACK]: `${queuePrefix}.${queueId}.${(0, $6Ux1c.LocalStorageKeySuffix).ACK}`,
        [(0, $6Ux1c.LocalStorageKeySuffix).QUEUE]: `${queuePrefix}.${queueId}.${(0, $6Ux1c.LocalStorageKeySuffix).QUEUE}`,
        [(0, $6Ux1c.LocalStorageKeySuffix).IN_PROGRESS]: `${queuePrefix}.${queueId}.${(0, $6Ux1c.LocalStorageKeySuffix).IN_PROGRESS}`,
        [(0, $6Ux1c.LocalStorageKeySuffix).RECLAIM_START]: `${queuePrefix}.${queueId}.${(0, $6Ux1c.LocalStorageKeySuffix).RECLAIM_START}`,
        [(0, $6Ux1c.LocalStorageKeySuffix).RECLAIM_END]: `${queuePrefix}.${queueId}.${(0, $6Ux1c.LocalStorageKeySuffix).RECLAIM_END}`
    });

});


parcelRegister("detUb", function(module, exports) {
$parcel$export(module.exports, "default", () => $0838b4d663b9893f$export$2e2bcd8739ae039);

var $6Ux1c = parcelRequire("6Ux1c");

var $2oG9m = parcelRequire("2oG9m");
const $0838b4d663b9893f$var$promisedSetTimeout = (msToWait)=>new Promise((resolve)=>{
        setTimeout(resolve, msToWait);
    });
const $0838b4d663b9893f$var$findOtherQueues = (queuePrefix)=>{
    try {
        return Object.keys(localStorage).filter((key)=>key.startsWith(queuePrefix)).map((key)=>key.split('.')).filter((split)=>{
            if (split.length === 3 && split[0] === queuePrefix && split[2] === (0, $6Ux1c.LocalStorageKeySuffix).ACK) try {
                const ackTimestamp = localStorage.getItem(split.join('.'));
                if (ackTimestamp) {
                    const ackTimestampNumber = parseInt(ackTimestamp);
                    return (0, $6Ux1c.Timers).RECLAIM_TIMEOUT + ackTimestampNumber < Date.now();
                }
            } catch (error) {
            // ignore and drop value
            }
            return false;
        }).map((split)=>split[1]);
    } catch (_error) {
    // Ignore errors from accessing localStorage.
    }
    return [];
};
const $0838b4d663b9893f$var$tryReclaim = async (options, callback)=>{
    const { ack: ack, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = options.storageKeys;
    const start = Date.now();
    localStorage.setItem(reclaimStart, options.reclaimProcessId);
    localStorage.setItem(ack, start.toString());
    await $0838b4d663b9893f$var$promisedSetTimeout((0, $6Ux1c.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $6Ux1c.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimStart.');
    localStorage.setItem(reclaimEnd, options.reclaimProcessId);
    await $0838b4d663b9893f$var$promisedSetTimeout((0, $6Ux1c.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $6Ux1c.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId || localStorage.getItem(reclaimEnd) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimEnd.');
    return $0838b4d663b9893f$var$reclaim(options, callback);
};
const $0838b4d663b9893f$var$reclaim = async (options, callback)=>{
    const { queue: queue, inProgress: inProgress } = options.storageKeys;
    // Queue is an array of events while inProgress is an object with a uuid for key
    // Either of these queues may legitimately be missing.
    const eventsInQueue = JSON.parse(localStorage.getItem(queue) || '[]');
    const eventsInProgress = JSON.parse(localStorage.getItem(inProgress) || '{}');
    const arrayOfEventsInProgress = Object.entries(eventsInProgress).map(([key, item])=>{
        const itemWithId = {
            ...item,
            // LocalStorage-retry would add the attemptCounter after failure, rather than
            // as it was being processed
            attemptNumber: item.attemptNumber + 1,
            id: key
        };
        return itemWithId;
    });
    const eventsToProcess = [
        ...eventsInQueue,
        ...arrayOfEventsInProgress
    ];
    if (eventsToProcess.length > 0) {
        const result = await callback(eventsToProcess);
        if (result.status === 'successful') $0838b4d663b9893f$var$clearLocalStorageKeys(options.storageKeys);
        else if (result.status === 'partial') {
            // Dont delete all events if we are only able to take some of them.
            const leftover = eventsToProcess.filter((event)=>!result.acceptedItemIds.includes(event.id));
            // This way around, we can almost ensure that we wont hit memory quota exceeded errors.
            // However, there is a very small chance that we may lose events if the process exits between these two commands.
            localStorage.removeItem(inProgress);
            localStorage.setItem(queue, JSON.stringify(leftover));
            return {
                fullReclaim: false
            };
        }
    } else $0838b4d663b9893f$var$clearLocalStorageKeys(options.storageKeys);
    return {
        fullReclaim: true
    };
};
// Exterminate
const $0838b4d663b9893f$var$clearLocalStorageKeys = (keys)=>{
    // Always good to do queue and inprogress first to reduce duplications
    // and to free up more space in localstorage
    localStorage.removeItem(keys.queue);
    localStorage.removeItem(keys.inProgress);
    localStorage.removeItem(keys.reclaimEnd);
    localStorage.removeItem(keys.reclaimStart);
    // This has to be last or we risk leaving things in localStorage that have to be purged
    localStorage.removeItem(keys.ack);
};
var $0838b4d663b9893f$export$2e2bcd8739ae039 = async (queuePrefix, callback)=>{
    if (typeof queuePrefix !== 'string' || queuePrefix.length === 0) // We do not want to start deleting everything in localstorage
    return {
        fullReclaims: 0,
        partialReclaims: 0,
        failedReclaims: 0
    };
    const reclaimProcessId = crypto.randomUUID();
    const queuesToReclaim = $0838b4d663b9893f$var$findOtherQueues(queuePrefix);
    const claims = queuesToReclaim.map((id)=>$0838b4d663b9893f$var$tryReclaim({
            queuePrefix: queuePrefix,
            reclaimProcessId: reclaimProcessId,
            storageKeys: (0, $2oG9m.createLocalStorageKeys)(queuePrefix, id)
        }, callback));
    const settledClaims = await Promise.allSettled(claims);
    const failedReclaims = settledClaims.filter((claim)=>claim.status === 'rejected');
    const successfulClaims = settledClaims.filter((settledValue)=>settledValue.status === 'fulfilled').map((result)=>result.value);
    const fullReclaims = successfulClaims.filter((claim)=>claim.fullReclaim);
    const partialReclaims = successfulClaims.filter((claim)=>!claim.fullReclaim);
    return {
        failedReclaims: failedReclaims.length,
        partialReclaims: partialReclaims.length,
        fullReclaims: fullReclaims.length
    };
};

});

parcelRegister("bdglF", function(module, exports) {
$parcel$export(module.exports, "CallbackProcessingErrorName", () => $f2b960866d02a335$export$a409c8de90e11e14);
$parcel$export(module.exports, "default", () => $f2b960866d02a335$export$2e2bcd8739ae039);
const $f2b960866d02a335$export$a409c8de90e11e14 = 'CallbackProcessingError';
class $f2b960866d02a335$export$2e2bcd8739ae039 extends Error {
    constructor(error){
        const messageFromError = error && typeof error === 'object' && 'toString' in error && typeof error.toString === 'function' && error.toString();
        const messageFromString = typeof error === 'string' && error;
        const message = messageFromError || messageFromString || 'Argument passed to CallbackProcessingError was not an Error or string.';
        super(`Error thrown while processing events in callback: ${message}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $f2b960866d02a335$export$2e2bcd8739ae039.prototype);
        this.name = $f2b960866d02a335$export$a409c8de90e11e14;
    }
}

});

parcelRegister("el3QZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $acbe486be7342bdb$export$2e2bcd8739ae039);

var $d8sfT = parcelRequire("d8sfT");

var $9ryIE = parcelRequire("9ryIE");

var $bdglF = parcelRequire("bdglF");
var $acbe486be7342bdb$export$2e2bcd8739ae039 = (0, $d8sfT.default);

});
parcelRegister("d8sfT", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf50f19f65f0fc55$export$2e2bcd8739ae039);

var $9ryIE = parcelRequire("9ryIE");

var $9Q4W4 = parcelRequire("9Q4W4");
var $d09nW = parcelRequire("d09nW");

var $gxeqt = parcelRequire("gxeqt");

var $a85yd = parcelRequire("a85yd");

var $eyv43 = parcelRequire("eyv43");
class $cf50f19f65f0fc55$export$2e2bcd8739ae039 {
    getResilienceMechanism(namespace, options) {
        if (!options.useMemory) try {
            return new (0, $gxeqt.default)(namespace, options);
        } catch (error) {
            if (!(error instanceof (0, $9Q4W4.default))) options.logger?.warn('Attempted to create IndexedDbResilience but failed. Using memory instead.');
        }
        return new (0, $a85yd.default)(this.namespace, options);
    }
    addItem(item, options, policy = (0, $9ryIE.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.addItem(item, options, policy));
    }
    bulkAddItem(itemOptions, policy = (0, $9ryIE.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.bulkAddItem(itemOptions, policy));
    }
    getItems(count) {
        return this.runOrFailOver(()=>this.resilience.getItems(count));
    }
    deleteItems(itemIds) {
        return this.runOrFailOver(()=>this.resilience.deleteItems(itemIds));
    }
    getItemCount() {
        return this.runOrFailOver(()=>this.resilience.getItemCount());
    }
    processItems(processFn, count) {
        return this.runOrFailOver(()=>this.resilience.processItems(processFn, count));
    }
    storeType() {
        return this.resilience.storeType();
    }
    async runOrFailOver(runnable) {
        try {
            return await runnable();
        } catch (error) {
            if ((0, $d09nW.shouldIgnoreResilienceDbError)(error)) throw error;
            else if (this.resilience.storeType() === (0, $9ryIE.StoreType).INDEXEDDB) await this.failOver();
            return runnable();
        }
    }
    async failOver() {
        // Attempt to get any events we can and put them into memory
        const oldResilience = this.resilience;
        const newResilience = new (0, $a85yd.default)(this.namespace, this.options);
        this.resilience = newResilience;
        try {
            const { items: items } = await oldResilience.getItems(this.options.maxEventLimit);
            if (items.length > 0) {
                const bulkAddItemsResponse = await newResilience.bulkAddItemWrapperType(items, (0, $9ryIE.GuardPolicy).IGNORE);
                const addedItemIds = bulkAddItemsResponse.items.map((item)=>item.id);
                await oldResilience.deleteItems(addedItemIds);
            }
        } catch (error) {
            this.options.logger.warn('Unexpected error from ResilienceDb, switching to MemoryDb');
        // Dont need to catch. We are just getting events if we can
        }
    }
    constructor(namespace, options = {}){
        this.resilience = void 0;
        this.options = void 0;
        this.namespace = void 0;
        this.namespace = namespace;
        this.options = (0, $eyv43.createOptionsWithDefaults)(options);
        if (!namespace || namespace.length === 0 || typeof namespace !== 'string') throw new Error('Invalid namespace provided');
        this.resilience = this.getResilienceMechanism(namespace, options);
    }
}

});
parcelRegister("9ryIE", function(module, exports) {
$parcel$export(module.exports, "NAMESPACE_AND_TIME_ADDED_INDEX", () => $ad91946d3aa5a6f6$export$d21fbb25eb37b5bf);
$parcel$export(module.exports, "RESILIENCE_DB_NAME", () => $ad91946d3aa5a6f6$export$8cad224051643259);
$parcel$export(module.exports, "RESILIENCE_STORE_NAME", () => $ad91946d3aa5a6f6$export$3d8420be07b276ab);
$parcel$export(module.exports, "TIME_TO_PROCESS_AFTER_INDEX", () => $ad91946d3aa5a6f6$export$a512a65455fce2a6);
$parcel$export(module.exports, "TIME_ADDED_INDEX", () => $ad91946d3aa5a6f6$export$89d9c1ff8ac91862);
$parcel$export(module.exports, "RETRY_INDEX", () => $ad91946d3aa5a6f6$export$a37d385bcd713809);
$parcel$export(module.exports, "INDEXEDDB_TIMEOUT", () => $ad91946d3aa5a6f6$export$6d8635fed0e4b14d);
$parcel$export(module.exports, "StoreType", () => $ad91946d3aa5a6f6$export$39337ab5872e9457);
$parcel$export(module.exports, "GuardPolicy", () => $ad91946d3aa5a6f6$export$7710d69e6f450f20);
const $ad91946d3aa5a6f6$export$d21fbb25eb37b5bf = 'namespace-timeAdded';
const $ad91946d3aa5a6f6$export$8cad224051643259 = 'analytics-web-client';
const $ad91946d3aa5a6f6$export$3d8420be07b276ab = 'analytics-resilience';
const $ad91946d3aa5a6f6$export$a512a65455fce2a6 = 'timeToBeProcessedAfter';
const $ad91946d3aa5a6f6$export$89d9c1ff8ac91862 = 'timeAdded';
const $ad91946d3aa5a6f6$export$a37d385bcd713809 = 'retryAttempts';
const $ad91946d3aa5a6f6$export$6d8635fed0e4b14d = 15000;
var $ad91946d3aa5a6f6$export$39337ab5872e9457 = /*#__PURE__*/ function(StoreType) {
    StoreType["INDEXEDDB"] = "indexeddb";
    StoreType["MEMORY"] = "memory";
    return StoreType;
}({});
var $ad91946d3aa5a6f6$export$7710d69e6f450f20 = /*#__PURE__*/ function(GuardPolicy) {
    // Adds as many items as possible and IGONRES the rest.
    // Only to be used with BulkAdd
    GuardPolicy["IGNORE"] = "ignore";
    // ABANDON the request if not all items can be added.
    GuardPolicy["ABANDON"] = "abandon";
    // EVICT old items to make room for new items if space is tight.
    GuardPolicy["EVICT"] = "evict";
    return GuardPolicy;
}({});

});

parcelRegister("9Q4W4", function(module, exports) {
$parcel$export(module.exports, "default", () => $61dd4f6e01fe15c1$export$2e2bcd8739ae039);
const $61dd4f6e01fe15c1$export$fc14cf6dcea0f8ed = 'NoIndexedDbError';
class $61dd4f6e01fe15c1$export$2e2bcd8739ae039 extends Error {
    constructor(){
        super('window.indexeddb is undefined.');
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $61dd4f6e01fe15c1$export$2e2bcd8739ae039.prototype);
        this.name = $61dd4f6e01fe15c1$export$fc14cf6dcea0f8ed;
    }
}

});

parcelRegister("d09nW", function(module, exports) {
$parcel$export(module.exports, "shouldIgnoreResilienceDbError", () => $d32802ba1b2c99b7$export$74101021e0969375);

var $iCLWx = parcelRequire("iCLWx");

var $bdglF = parcelRequire("bdglF");

var $lmxyh = parcelRequire("lmxyh");
const $d32802ba1b2c99b7$export$74101021e0969375 = (error)=>{
    if (error && typeof error === 'object' && 'name' in error) {
        const errorWithName = error;
        return typeof errorWithName.name === 'string' && (errorWithName.name === (0, $iCLWx.AbandonWriteErrorName) || errorWithName.name === (0, $bdglF.CallbackProcessingErrorName) || errorWithName.name === (0, $lmxyh.InvalidPolicyErrorName));
    }
    return false;
};

});
parcelRegister("iCLWx", function(module, exports) {
$parcel$export(module.exports, "AbandonWriteErrorName", () => $f61e1848fbcf7fb3$export$ba95206613c96b28);
$parcel$export(module.exports, "default", () => $f61e1848fbcf7fb3$export$2e2bcd8739ae039);
const $f61e1848fbcf7fb3$export$ba95206613c96b28 = 'AbandonWriteError';
class $f61e1848fbcf7fb3$export$2e2bcd8739ae039 extends Error {
    constructor(source){
        super(`Event Limit reached. Abandoning write to: ${source}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $f61e1848fbcf7fb3$export$2e2bcd8739ae039.prototype);
        this.name = $f61e1848fbcf7fb3$export$ba95206613c96b28;
    }
}

});

parcelRegister("lmxyh", function(module, exports) {
$parcel$export(module.exports, "InvalidPolicyErrorName", () => $c4e0761e34bd9c05$export$7e7aee9a953465ec);
$parcel$export(module.exports, "default", () => $c4e0761e34bd9c05$export$2e2bcd8739ae039);
const $c4e0761e34bd9c05$export$7e7aee9a953465ec = 'InvalidPolicyError';
class $c4e0761e34bd9c05$export$2e2bcd8739ae039 extends Error {
    constructor(policy, method){
        super(`Method '${method}' cannot be called with policy '${policy}'.`);
        this.name = $c4e0761e34bd9c05$export$7e7aee9a953465ec;
    }
}

});


parcelRegister("gxeqt", function(module, exports) {
$parcel$export(module.exports, "default", () => $180b22b587f4422d$export$2e2bcd8739ae039);

var $9ryIE = parcelRequire("9ryIE");

var $1rS61 = parcelRequire("1rS61");

var $bdglF = parcelRequire("bdglF");
var $lmxyh = parcelRequire("lmxyh");
var $9Q4W4 = parcelRequire("9Q4W4");
var $d09nW = parcelRequire("d09nW");

var $a7luo = parcelRequire("a7luo");

var $eyv43 = parcelRequire("eyv43");
class $180b22b587f4422d$export$2e2bcd8739ae039 {
    storeType() {
        return (0, $9ryIE.StoreType).INDEXEDDB;
    }
    constructor(_namespace, _options = {}){
        this.db = void 0;
        this.logger = void 0;
        this.globalEventLimitGuard = void 0;
        this.options = void 0;
        this.namespace = void 0;
        this.startDB = async ()=>{
            return new Promise(async (resolve, reject)=>{
                if (typeof window !== 'undefined') {
                    const dbTimeout = window.setTimeout(()=>{
                        this.logger.warn('IndexedDB timed out.');
                        reject(new (0, $9Q4W4.default)());
                    }, (0, $9ryIE.INDEXEDDB_TIMEOUT));
                    /*
           * The database version number can never change.
           * An upgrade transaction is limited to only one connection to the database.
           * Once this is done, we cannot open any connections with older versions of the schema.
           * https://www.w3.org/TR/IndexedDB/#upgrade-transaction-construct
           *
           * Due to the nature of how AWC is used (multiple tabs that are very long lived),
           * we will not be able to run version upgrades via indexeddb.
           *
           * This does not mean we cant change what is stored in the tables,
           * this limitation just prevents us from:
           *   - Creating new ObjectStores in this database connection, and
           *   - Creating new indexes on our ObjectStores
           *
           * Any upgrades we wish to run in the future will have to create a new database,
           * and migrate all the data from older databases.
           *
           * This also means any migrations we make will have to be supported until we have evidence
           * that no events are coming from old versions of the database.
           * This may take a long time.
           */ const request = window.indexedDB.open((0, $9ryIE.RESILIENCE_DB_NAME), 1);
                    request.onupgradeneeded = (event)=>{
                        if (event.oldVersion !== 0) throw new Error('We cannot upgrade the database. Do not do this.');
                        const db = request.result;
                        const store = db.createObjectStore((0, $9ryIE.RESILIENCE_STORE_NAME), {
                            keyPath: 'id'
                        });
                        store.createIndex((0, $9ryIE.TIME_TO_PROCESS_AFTER_INDEX), (0, $9ryIE.TIME_TO_PROCESS_AFTER_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $9ryIE.RETRY_INDEX), (0, $9ryIE.RETRY_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $9ryIE.TIME_ADDED_INDEX), (0, $9ryIE.TIME_ADDED_INDEX), {
                            unique: false
                        });
                        // Compound key index of product - timeAdded.
                        store.createIndex((0, $9ryIE.NAMESPACE_AND_TIME_ADDED_INDEX), [
                            'namespace',
                            'timeAdded'
                        ], {
                            unique: false
                        });
                    };
                    request.onerror = function() {
                        reject(new (0, $9Q4W4.default)());
                    };
                    try {
                        await (0, $eyv43.requestToPromise)(request);
                        return resolve(request.result);
                    } catch (error) {
                        this.logger.warn('IndexedDB failed to initialise.', error);
                        reject(new (0, $9Q4W4.default)());
                    } finally{
                        window.clearTimeout(dbTimeout);
                    }
                } else {
                    this.logger.warn("IndexedDB failed to initialise. No 'window' object.");
                    reject(new (0, $9Q4W4.default)());
                }
            });
        };
        this.addItem = async (item, options = {}, policy = (0, $9ryIE.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const value = (0, $eyv43.convertToItemWrapper)(item, namespace, options);
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            if (policy === (0, $9ryIE.GuardPolicy).IGNORE) throw new (0, $lmxyh.default)(policy, 'IndexedDbConnector#addItem');
            try {
                if (!value.namespace || value.namespace.length === 0 || typeof value.namespace !== 'string') throw new Error('Namespace not specified');
                // Making space for 1 event, if required.
                const bulkAddResult = await this.globalEventLimitGuard.insertItems(objectStore, [
                    value
                ], policy);
                if (bulkAddResult.items.length === 1) return {
                    item: bulkAddResult.items[0],
                    numberOfEvictedItems: bulkAddResult.numberOfEvictedItems
                };
                // Should never happen as the Policy and EventCountGuard should cause another pathway
                throw new Error(`Incorrect number of items added. Expected: 1, got: ${bulkAddResult.items.length}`);
            } catch (error) {
                if ((0, $d09nW.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        };
        this.bulkAddItem = async (itemOptions, policy = (0, $9ryIE.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const items = itemOptions.map(({ item: item, ...options })=>(0, $eyv43.convertToItemWrapper)(item, namespace, options));
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                return await this.globalEventLimitGuard.insertItems(objectStore, items, policy);
            } catch (error) {
                if ((0, $d09nW.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        };
        this.getItems = async (count = (0, $1rS61.GET_ITEM_COUNT))=>{
            const fixedCount = count > 0 ? count : (0, $1rS61.GET_ITEM_COUNT);
            const { logger: logger } = this;
            const maxAttempts = this.options.maxAttempts;
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            const timeIndex = objectStore.index((0, $9ryIE.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.openCursor(upperBoundOpenKeyRange);
            const getResult = await new Promise(async (resolve, reject)=>{
                const items = [];
                let numberOfDeletedItems = 0;
                request.onerror = (error)=>{
                    logger.error('Failed to open cursor:', error);
                    reject('Failed to open cursor');
                };
                // Requests for Cursors call onsuccess multiple times and cannot be converted to promises
                request.onsuccess = (event)=>{
                    const cursor = event.target.result;
                    if (cursor) {
                        // Prevent mutation of the value we are returning
                        const value = {
                            ...cursor.value
                        };
                        items.push(value);
                        // Mutations seem to be required for testing indexeddb library
                        const updatedValue = cursor.value;
                        updatedValue.retryAttempts += 1;
                        updatedValue.timeToBeProcessedAfter = Date.now() + (0, $1rS61.VISIBILITY_TIMEOUT);
                        if (updatedValue.retryAttempts >= maxAttempts) {
                            ++numberOfDeletedItems;
                            const request = cursor.delete();
                            (0, $eyv43.monitorErrorsOnRequest)(request, logger);
                        } else {
                            const request = cursor.update(updatedValue);
                            (0, $eyv43.monitorErrorsOnRequest)(request, logger);
                        }
                        if (items.length < fixedCount) cursor.continue();
                        else resolve({
                            items: items,
                            numberOfDeletedItems: numberOfDeletedItems
                        });
                    } else resolve({
                        items: items,
                        numberOfDeletedItems: numberOfDeletedItems
                    });
                };
            });
            await (0, $eyv43.commitTransaction)(transaction, this.logger);
            return getResult;
        };
        this.deleteItems = async (itemIds)=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                const deletePromises = itemIds.map((id)=>this.deleteItem(objectStore, id));
                await (0, $eyv43.commitTransaction)(transaction, this.logger);
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        };
        this.getItemCount = async ()=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readonly');
            const timeIndex = objectStore.index((0, $9ryIE.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.count(upperBoundOpenKeyRange);
            const event = await (0, $eyv43.requestToPromise)(request);
            await (0, $eyv43.commitTransaction)(transaction, this.logger);
            return event.target.result;
        };
        this.processItems = async (processFn, count = (0, $1rS61.GET_ITEM_COUNT))=>{
            const { items: items, ...partialResult } = await this.getItems(count);
            try {
                const result = await processFn(items, partialResult);
                const itemIds = items.map((item)=>item.id);
                // We should not await this delete as a rejected promise would get caught by the catch statement
                await this.deleteItems(itemIds);
                return result;
            } catch (error) {
                // Eventually we will need a intermediate class to catch all errors but we should ignore this error
                // This allows libraries beneath to distinguish between a success or failure in processing to update schedulers or anything else
                // To provide back off or any other mechanism to allow what ever is cauing the errors to recover
                throw new (0, $bdglF.default)(error);
            }
        };
        this.deleteItem = async (objectStore, id)=>{
            const { logger: logger } = this;
            try {
                await (0, $eyv43.requestToPromise)(objectStore.delete(id));
            } catch (error) {
                logger.error('Failed to delete item:', id, error);
                throw error;
            }
        };
        this.getObjectStoreAndTransaction = async (mode)=>{
            const transaction = (await this.db).transaction((0, $9ryIE.RESILIENCE_STORE_NAME), mode);
            const objectStore = transaction.objectStore((0, $9ryIE.RESILIENCE_STORE_NAME));
            return {
                transaction: transaction,
                objectStore: objectStore
            };
        };
        this.options = (0, $eyv43.createOptionsWithDefaults)(_options);
        this.namespace = _namespace;
        this.logger = this.options.logger;
        if (!window.indexedDB) throw new (0, $9Q4W4.default)();
        this.db = this.startDB();
        // We just swallow any errors as we know that these are intermittent errors
        // when switching from indexeddb -> localStorage
        this.db.catch(()=>{});
        /**
     *
     * This class will enforce the number of analytics events we can store in our IndexedDB object store
     * if asked before adding items to the object store.
     */ this.globalEventLimitGuard = new (0, $a7luo.default)(this.options.maxEventLimit, this.namespace, this.logger, this.deleteItem);
    }
}

});
parcelRegister("1rS61", function(module, exports) {
$parcel$export(module.exports, "GET_ITEM_COUNT", () => $e4784e5de7cee7b6$export$b6df3d334cec060f);
$parcel$export(module.exports, "VISIBILITY_TIMEOUT", () => $e4784e5de7cee7b6$export$14ef152a03a4b6ee);
$parcel$export(module.exports, "MAX_ATTEMPTS", () => $e4784e5de7cee7b6$export$da9ab7b2fd5998e8);
$parcel$export(module.exports, "EVENT_COUNT_LIMIT", () => $e4784e5de7cee7b6$export$1188664dfff364c8);
const $e4784e5de7cee7b6$export$b6df3d334cec060f = 7;
const $e4784e5de7cee7b6$export$14ef152a03a4b6ee = 60000;
const $e4784e5de7cee7b6$export$da9ab7b2fd5998e8 = 10;
const $e4784e5de7cee7b6$export$1188664dfff364c8 = 5000;

});

parcelRegister("a7luo", function(module, exports) {
$parcel$export(module.exports, "default", () => $23d4e5dbae955b0b$export$2e2bcd8739ae039);

var $9ryIE = parcelRequire("9ryIE");

var $iCLWx = parcelRequire("iCLWx");

var $eyv43 = parcelRequire("eyv43");
class $23d4e5dbae955b0b$export$2e2bcd8739ae039 {
    /**
   * This function checks the number of events currently in AWC IndexedDB object store and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * The indexed is treated as effectively: partitioned by product and sorted by timeAdded.
   *
   * This function can be re-used when the bulk add functionality is added in IndexedDbConnector.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ async insertItems(objectStore, items, policy = (0, $9ryIE.GuardPolicy).ABANDON) {
        const itemsToAdd = [
            ...items
        ];
        let numberOfEvictedItems = 0;
        switch(policy){
            case (0, $9ryIE.GuardPolicy).ABANDON:
                await this.throwIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $9ryIE.GuardPolicy).EVICT:
                numberOfEvictedItems = await this.evictIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $9ryIE.GuardPolicy).IGNORE:
                // Removed items from `itemsToAdd` if there is insufficient space
                await this.calculateHowManyEventsWeCanAdd(objectStore, itemsToAdd);
                break;
        }
        const promises = itemsToAdd.map((item)=>(0, $eyv43.requestToPromise)(objectStore.add(item)));
        await Promise.all(promises);
        await (0, $eyv43.commitTransaction)(objectStore.transaction, this.logger);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async throwIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) throw new (0, $iCLWx.default)(`Not enough space in IndexedDb. Needed ${requiredSpace} but only had ${freeSpace}`);
    }
    async evictIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) {
            const extraSpace = requiredSpace - freeSpace;
            await this.deleteOldestNEvents(objectStore, extraSpace);
            return extraSpace;
        }
        return 0;
    }
    async calculateHowManyEventsWeCanAdd(objectStore, items) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < items.length) {
            const numberOfItemsToRemove = items.length - freeSpace;
            const start = items.length - numberOfItemsToRemove;
            items.splice(start, numberOfItemsToRemove);
        }
    }
    async calculateFreeSpace(objectStore) {
        const numberOfEventsInDb = await this.getCountofEventsInObjectStore(objectStore);
        return this.eventLimit - numberOfEventsInDb;
    }
    /**
   * This query returns the count of items held in AWC IndexedDB object store per product.
   */ async getCountofEventsInObjectStore(objectStore) {
        const productTimeAddedIndex = objectStore.index((0, $9ryIE.NAMESPACE_AND_TIME_ADDED_INDEX));
        const keyRangeValues = IDBKeyRange.bound([
            this.namespace,
            0
        ], [
            this.namespace,
            Date.now()
        ]);
        const request = productTimeAddedIndex.count(keyRangeValues);
        const event = await (0, $eyv43.requestToPromise)(request);
        return event.target.result;
    }
    constructor(eventLimit, namespace, logger, deleteItemHandler){
        this.eventLimit = void 0;
        this.namespace = void 0;
        this.logger = void 0;
        this.deleteItemHandler = void 0;
        /**
     * This query fetches the oldest events currently stored in AWC IndexedDb object store
     * and deletes them sequentially
     */ this.deleteOldestNEvents = async (objectStore, count)=>{
            const productTimeAddedIndex = objectStore.index((0, $9ryIE.NAMESPACE_AND_TIME_ADDED_INDEX));
            const keyRangeValues = IDBKeyRange.bound([
                this.namespace,
                0
            ], [
                this.namespace,
                Date.now()
            ]);
            const getAllRequest = productTimeAddedIndex.getAllKeys(keyRangeValues, count);
            const event = await (0, $eyv43.requestToPromise)(getAllRequest);
            const result = event?.target?.result;
            // Adding extra safety
            if (result && Array.isArray(result) && result.length > 0) try {
                const deletePromises = result.map((item)=>this.deleteItemHandler(objectStore, item));
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        };
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.namespace = namespace;
        this.logger = logger;
        this.deleteItemHandler = deleteItemHandler;
    }
}

});
parcelRegister("eyv43", function(module, exports) {
$parcel$export(module.exports, "convertToItemWrapper", () => $17a24aa07b35e3c0$export$aec476f33d77be11);
$parcel$export(module.exports, "createOptionsWithDefaults", () => $17a24aa07b35e3c0$export$ddc6718318090f71);
$parcel$export(module.exports, "requestToPromise", () => $17a24aa07b35e3c0$export$85ceed0783e42041);
$parcel$export(module.exports, "commitTransaction", () => $17a24aa07b35e3c0$export$feab8418f018df89);
$parcel$export(module.exports, "monitorErrorsOnRequest", () => $17a24aa07b35e3c0$export$342d941b6f724995);

var $1rS61 = parcelRequire("1rS61");
const $17a24aa07b35e3c0$export$aec476f33d77be11 = (item, namespace, { id: id, retryAttempts: retryAttempts, timeToProcessOffset: timeToProcessOffset })=>({
        item: item,
        id: id || crypto.randomUUID(),
        retryAttempts: retryAttempts || 0,
        timeToBeProcessedAfter: Date.now() + (timeToProcessOffset || 0),
        namespace: namespace,
        timeAdded: Date.now()
    });
const $17a24aa07b35e3c0$export$ddc6718318090f71 = (options)=>({
        logger: options.logger || console,
        useMemory: options.useMemory || false,
        maxAttempts: options.maxAttempts || (0, $1rS61.MAX_ATTEMPTS),
        // This is so that we can customise `maxEventLimit`, primarily for testing.
        maxEventLimit: options.maxEventLimit || (0, $1rS61.EVENT_COUNT_LIMIT)
    });
const $17a24aa07b35e3c0$export$85ceed0783e42041 = (request)=>{
    return new Promise((resolve, reject)=>{
        request.onsuccess = (event)=>{
            resolve(event);
        };
        request.onerror = (event)=>{
            reject(event);
        };
    });
};
const $17a24aa07b35e3c0$export$2a5213bce1720b42 = (transaction)=>{
    return new Promise((resolve, reject)=>{
        // We will have to see how much cost there is to waiting for the transaction to complete in the real world.
        // In theory in some cases we could return as soon as the request is complete and
        // just monitor errors on transactions with the logger.
        // This maybe more of an issue in Safari and other older browsers where commit isnt available
        // and we would have to wait for the transaction to complete itself.
        transaction.oncomplete = ()=>{
            resolve();
        };
        transaction.onerror = (event)=>{
            reject(event);
        };
        transaction.onabort = (event)=>{
            reject(event);
        };
    });
};
const $17a24aa07b35e3c0$export$feab8418f018df89 = (transaction, logger)=>{
    try {
        if (typeof transaction.commit === 'function') transaction.commit();
    } catch (error) {
        logger.error('Failed to force commit transaction:', error);
        throw error;
    }
    return $17a24aa07b35e3c0$export$2a5213bce1720b42(transaction);
};
const $17a24aa07b35e3c0$export$342d941b6f724995 = (request, logger)=>{
    request.onerror = (event)=>{
        logger.warn('Error thrown from request:', event);
    };
};

});



parcelRegister("a85yd", function(module, exports) {
$parcel$export(module.exports, "default", () => $70109517e38fc7e0$export$2e2bcd8739ae039);

var $9ryIE = parcelRequire("9ryIE");

var $1rS61 = parcelRequire("1rS61");

var $bdglF = parcelRequire("bdglF");
var $lmxyh = parcelRequire("lmxyh");

var $f5CUu = parcelRequire("f5CUu");

var $eyv43 = parcelRequire("eyv43");
class $70109517e38fc7e0$export$2e2bcd8739ae039 {
    /**
   * This method is used mainly to write new events to MemoryDB and uses the MEMORY_DB_GUARD_POLICY.EVICT_OLDEST_IF_LIMIT_EXECEEDED policy
   * to removes oldest events when limit is reached.
   */ async addItem(item, options = {}, policy = (0, $9ryIE.GuardPolicy).ABANDON) {
        if (policy === (0, $9ryIE.GuardPolicy).IGNORE) throw new (0, $lmxyh.default)(policy, 'IndexedDbConnector#addItem');
        const storedValue = (0, $eyv43.convertToItemWrapper)(item, this.namespace, options);
        // Delegated responsiblity to event limit guard to insert to memory stored
        const bulkAddItemsResult = await this.globalEventLimitGuard.insertItemsToMemoryStore([
            storedValue
        ], policy);
        return Promise.resolve({
            item: bulkAddItemsResult.items[0],
            numberOfEvictedItems: bulkAddItemsResult.numberOfEvictedItems
        });
    }
    bulkAddItem(itemOptions, policy = (0, $9ryIE.GuardPolicy).ABANDON) {
        const items = itemOptions.map(({ item: item, ...addOptions })=>(0, $eyv43.convertToItemWrapper)(item, this.namespace, addOptions));
        return this.bulkAddItemWrapperType(items, policy);
    }
    /**
   * This method is used mainly to write events to MemoryDB when unknown errors are thrown from IndexedDB.
   */ bulkAddItemWrapperType(items, policy = (0, $9ryIE.GuardPolicy).ABANDON) {
        return Promise.resolve(this.globalEventLimitGuard.insertItemsToMemoryStore(items, policy));
    }
    getItems(count = (0, $1rS61.GET_ITEM_COUNT)) {
        return Promise.resolve(this.synchronousGetItems(count));
    }
    synchronousGetItems(count = (0, $1rS61.GET_ITEM_COUNT)) {
        const fixedCount = count > 0 ? count : (0, $1rS61.GET_ITEM_COUNT);
        const now = Date.now();
        const wrappedItems = [];
        const itemsToRemove = [];
        for (let wrappedItem of this.memoryStore){
            if (wrappedItem.timeToBeProcessedAfter <= now) {
                wrappedItems.push({
                    ...wrappedItem
                });
                // Mutates the item in the memoryStore array, but not whats inside of wrappedItems
                wrappedItem.timeToBeProcessedAfter += (0, $1rS61.VISIBILITY_TIMEOUT);
                wrappedItem.retryAttempts += 1;
                if (wrappedItem.retryAttempts >= this.options.maxAttempts) itemsToRemove.push(wrappedItem);
            }
            if (wrappedItems.length >= fixedCount) break;
        }
        itemsToRemove.forEach((item)=>{
            const index = this.memoryStore.indexOf(item);
            this.memoryStore.splice(index, 1);
        });
        return {
            items: wrappedItems,
            numberOfDeletedItems: itemsToRemove.length
        };
    }
    deleteItems(itemIds) {
        this.memoryStore = this.memoryStore.filter((item)=>!itemIds.includes(item.id));
        return Promise.resolve(void 0);
    }
    getItemCount() {
        const now = Date.now();
        const count = this.memoryStore.filter((item)=>item.timeToBeProcessedAfter <= now).length;
        return Promise.resolve(count);
    }
    async processItems(processFn, count) {
        const { items: items, ...partialGetResult } = this.synchronousGetItems(count);
        const itemIds = items.map((i)=>i.id);
        try {
            const result = await processFn(items, partialGetResult);
            await this.deleteItems(itemIds);
            return result;
        } catch (error) {
            throw new (0, $bdglF.default)(error);
        }
    }
    storeType() {
        return (0, $9ryIE.StoreType).MEMORY;
    }
    /**
   * This function is adding items to the tail of the memoryStore and as it adds new items it keeps the
   * memory store sorted by timeAdded property. This makes evictions easier and adding elements to
   * memoryStore much faster.
   *
   * @param itemsToAdd
   */ addItems(itemsToAdd) {
        this.memoryStore.push(...itemsToAdd);
        // Sorting everytime, intentionally.
        this.memoryStore.sort(function(a, b) {
            return a.timeAdded - b.timeAdded;
        });
    }
    /**
   * This function checks the number of events currently in AWC MemoryDb and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ evictEventsIfNeeded(eventLimit) {
        const numberOfEventsInDb = this.memoryStore.length;
        // The number of analytics events currently in MemoryDb and
        // the Z events we are proposing to add will exceed our event count limit.
        if (numberOfEventsInDb > eventLimit) {
            const m = numberOfEventsInDb - eventLimit;
            // Removing oldest M events
            this.memoryStore.splice(0, m);
            return m;
        }
        return 0;
    }
    constructor(namespace, options = {}){
        this.memoryStore = void 0;
        this.options = void 0;
        this.globalEventLimitGuard = void 0;
        this.namespace = void 0;
        this.namespace = namespace;
        this.memoryStore = [];
        this.options = (0, $eyv43.createOptionsWithDefaults)(options);
        /**
     * This class will enforce the number of analytics events we can store in our MemoryDb
     */ this.globalEventLimitGuard = new (0, $f5CUu.default)(this.options.maxEventLimit, {
            addItems: this.addItems.bind(this),
            getItemCount: this.getItemCount.bind(this),
            evictEventsIfNeeded: this.evictEventsIfNeeded.bind(this)
        });
    }
}

});
parcelRegister("f5CUu", function(module, exports) {
$parcel$export(module.exports, "default", () => $7be8c5052ebd7f37$export$2e2bcd8739ae039);

var $9ryIE = parcelRequire("9ryIE");

var $iCLWx = parcelRequire("iCLWx");
class $7be8c5052ebd7f37$export$2e2bcd8739ae039 {
    async handleAbandonIfLimitWillExceedPolicy(itemsToAdd) {
        const itemCount = await this.memoryItemHandlers.getItemCount();
        if (itemCount + itemsToAdd.length > this.eventLimit) throw new (0, $iCLWx.default)((0, $9ryIE.StoreType).MEMORY);
        this.memoryItemHandlers.addItems(itemsToAdd);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: 0
        };
    }
    handleEvictOldestIfLimitExceededPolicy(itemsToAdd) {
        this.memoryItemHandlers.addItems(itemsToAdd);
        const numberOfEvictedItems = this.memoryItemHandlers.evictEventsIfNeeded(this.eventLimit);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async handleAddAsManyAsPossible(itemsToAdd) {
        const freeSpace = this.eventLimit - await this.memoryItemHandlers.getItemCount();
        const partialEventsToAdd = freeSpace > itemsToAdd.length ? itemsToAdd : itemsToAdd.slice(0, freeSpace);
        this.memoryItemHandlers.addItems(partialEventsToAdd);
        return {
            items: partialEventsToAdd,
            numberOfEvictedItems: 0
        };
    }
    constructor(eventLimit, memoryItemHandlers){
        this.eventLimit = void 0;
        this.memoryItemHandlers = void 0;
        /**
     * Unlike IndexedDb, we cannot take advantage of any index. So we are,
     * treating the memory store as a sorted set when adding items.
     */ this.insertItemsToMemoryStore = (itemsToAdd, policy)=>{
            switch(policy){
                case (0, $9ryIE.GuardPolicy).ABANDON:
                    return this.handleAbandonIfLimitWillExceedPolicy(itemsToAdd);
                case (0, $9ryIE.GuardPolicy).EVICT:
                    return Promise.resolve(this.handleEvictOldestIfLimitExceededPolicy(itemsToAdd));
                case (0, $9ryIE.GuardPolicy).IGNORE:
                    return this.handleAddAsManyAsPossible(itemsToAdd);
            }
        };
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.memoryItemHandlers = memoryItemHandlers;
    }
}

});




parcelRegister("4BiDK", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a17ccbca6ce9733$export$2e2bcd8739ae039);

var $2E5bV = parcelRequire("2E5bV");
class $2a17ccbca6ce9733$export$4b62ee5120ab50a8 {
    addToItemsDiscardedByRetryCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByRetry += numberOfDeletedEvents;
    }
    addToEventCount() {
        this.eventCount++;
    }
    addToItemsDiscardedByOverflowCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByOverflow += numberOfDeletedEvents;
    }
    setResilienceMechanism(mechanism) {
        this.resilienceMechanism = mechanism;
    }
    /* <Localstorage specific> */ addToReclaimMetrics(reclaimMetrics) {
        this.localstorageNumberOfFullReclaims += reclaimMetrics.fullReclaims;
        this.localstorageNumberOfPartialReclaims += reclaimMetrics.partialReclaims;
        this.localstorageNumberOfFailedReclaims += reclaimMetrics.failedReclaims;
    }
    addToPurgedQueuesMetrics(numberOfQueuesPurged) {
        this.localstorageNumberOfQueuesPurged += numberOfQueuesPurged;
    }
    /* </Localstorage specific> */ subtractFromMetrics(sentMetrics) {
        this.itemsDiscardedByRetry = this.subtractFromCount(this.itemsDiscardedByRetry, sentMetrics.itemsDiscardedByRetry);
        this.eventCount = this.subtractFromCount(this.eventCount, sentMetrics.eventCount);
        this.itemsDiscardedByOverflow = this.subtractFromCount(this.itemsDiscardedByOverflow, sentMetrics.itemsDiscardedByOverflow);
        // Localstorage specific
        this.localstorageNumberOfFullReclaims = this.subtractFromCount(this.localstorageNumberOfFullReclaims, sentMetrics.fullReclaims);
        this.localstorageNumberOfPartialReclaims = this.subtractFromCount(this.localstorageNumberOfPartialReclaims, sentMetrics.partialReclaims);
        this.localstorageNumberOfFailedReclaims = this.subtractFromCount(this.localstorageNumberOfFailedReclaims, sentMetrics.failedReclaims);
        this.localstorageNumberOfQueuesPurged = this.subtractFromCount(this.localstorageNumberOfQueuesPurged, sentMetrics.localstorageQueuesPurged);
    }
    subtractFromCount(count, subtract) {
        return Math.max(count - (subtract || 0), 0);
    }
    getMetricsPayload() {
        return {
            itemsDiscardedByRetry: this.itemsDiscardedByRetry,
            eventCount: this.eventCount,
            itemsDiscardedByOverflow: this.itemsDiscardedByOverflow,
            resilienceMechanism: this.resilienceMechanism,
            // Localstorage specific
            localstorageQueuesPurged: this.localstorageNumberOfQueuesPurged,
            fullReclaims: this.localstorageNumberOfFullReclaims,
            partialReclaims: this.localstorageNumberOfPartialReclaims,
            failedReclaims: this.localstorageNumberOfFailedReclaims
        };
    }
    constructor(){
        // Number of events discarded due to exceeding retry limits.
        this.itemsDiscardedByRetry = 0;
        // Number of events created by the product in current tab.
        this.eventCount = 0;
        // Number of events discarded due to reaching queue max size.
        this.itemsDiscardedByOverflow = 0;
        // Will be used in the future when we get more resilience mechanisms
        this.resilienceMechanism = (0, $2E5bV.ResilienceMechanism).INDEXEDDB;
        /* --- LocalStorage specific metrics --- */ // Emitted by purgeOrphanedQueues to tell us how many queues we have had to clean up due to
        // https://github.com/segmentio/localstorage-retry/pull/17
        this.localstorageNumberOfQueuesPurged = 0;
        // Emitted by reclaimEvents to tell us how many queues were seen in the process of reclaim.
        // We will only emit metrics for queues that are not currently being maintained (i.e. `ack` is not being updated).
        // Queue was found, all events removed and put into resilienceDb.
        this.localstorageNumberOfFullReclaims = 0;
        // Queue was found but not all events were able to be put into resilienceDb.
        this.localstorageNumberOfPartialReclaims = 0;
        // Reclaim failed for a queue and reclaim was abandonded.
        this.localstorageNumberOfFailedReclaims = 0;
    }
}
let $2a17ccbca6ce9733$var$cachedMetricsClient = null;
var $2a17ccbca6ce9733$export$2e2bcd8739ae039 = ()=>{
    if (!$2a17ccbca6ce9733$var$cachedMetricsClient) $2a17ccbca6ce9733$var$cachedMetricsClient = new $2a17ccbca6ce9733$export$4b62ee5120ab50a8();
    return $2a17ccbca6ce9733$var$cachedMetricsClient;
};

});
parcelRegister("2E5bV", function(module, exports) {
$parcel$export(module.exports, "ResilienceMechanism", () => $94adc46ebb53773c$export$c75161629e3ec34e);
$parcel$export(module.exports, "NetworkStatusEnum", () => $94adc46ebb53773c$export$ee138fa712d11b84);
var $94adc46ebb53773c$export$c75161629e3ec34e = /*#__PURE__*/ function(ResilienceMechanism) {
    ResilienceMechanism["INDEXEDDB"] = "indexeddb";
    ResilienceMechanism["MEMORY"] = "memory";
    return ResilienceMechanism;
}({});
var $94adc46ebb53773c$export$ee138fa712d11b84 = /*#__PURE__*/ function(NetworkStatusEnum) {
    NetworkStatusEnum[NetworkStatusEnum["ONLINE"] = 0] = "ONLINE";
    NetworkStatusEnum[NetworkStatusEnum["OFFLINE"] = 1] = "OFFLINE";
    return NetworkStatusEnum;
}({});

});


parcelRegister("8viHC", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e52ba5a0b5624b1$export$2e2bcd8739ae039);

var $2E5bV = parcelRequire("2E5bV");
class $2e52ba5a0b5624b1$export$2e2bcd8739ae039 {
    removeListeners() {
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', ()=>this._networkChangeCallback((0, $2E5bV.NetworkStatusEnum).OFFLINE));
            window.addEventListener('online', ()=>this._networkChangeCallback((0, $2E5bV.NetworkStatusEnum).ONLINE));
        }
    }
    getNetworkStatus() {
        if (window.navigator.onLine) return (0, $2E5bV.NetworkStatusEnum).ONLINE;
        return (0, $2E5bV.NetworkStatusEnum).OFFLINE;
    }
    constructor(networkChangeCallback){
        this._networkChangeCallback = void 0;
        this._networkChangeCallback = networkChangeCallback;
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', ()=>this._networkChangeCallback((0, $2E5bV.NetworkStatusEnum).OFFLINE));
            window.addEventListener('online', ()=>this._networkChangeCallback((0, $2E5bV.NetworkStatusEnum).ONLINE));
        }
    }
}

});

parcelRegister("e9dzS", function(module, exports) {
$parcel$export(module.exports, "default", () => $af4a35b966d6ddb0$export$2e2bcd8739ae039);

var $5XX5x = parcelRequire("5XX5x");

var $INLhk = parcelRequire("INLhk");
const $af4a35b966d6ddb0$var$SCHEDULER_OPTIONS_DEFAULT = {
    minRetryDelay: 1000,
    maxRetryDelay: 30000,
    backoffFactor: 2,
    backoffJitterPercentage: 0,
    waitInterval: 500,
    callbackTimeoutPeriod: 5000
};
var $af4a35b966d6ddb0$export$8bb92baee001fc60 = /*#__PURE__*/ function(QueuedScheduleTypes) {
    QueuedScheduleTypes[QueuedScheduleTypes["NONE"] = 0] = "NONE";
    QueuedScheduleTypes[QueuedScheduleTypes["IMMEDIATE"] = 1] = "IMMEDIATE";
    QueuedScheduleTypes[QueuedScheduleTypes["WAIT"] = 2] = "WAIT";
    return QueuedScheduleTypes;
}({});
class $af4a35b966d6ddb0$export$2e2bcd8739ae039 {
    constructor(retryOptions, callback){
        this.callback = void 0;
        this.failureCount = void 0;
        this.operationInFlight = void 0;
        this.options = void 0;
        this.queuedSchedule = void 0;
        this.scheduledTimeout = void 0;
        this.callbackTimer = void 0;
        this.schedule = ({ immediate: immediate } = {})=>{
            if (typeof window === 'undefined') return;
            if (this.operationInFlight) {
                if (immediate) this.queuedSchedule = 1;
                else if (this.queuedSchedule !== 1) this.queuedSchedule = 2;
            // Only run immediately if we have no failures
            } else if ((immediate || this.options.waitInterval <= 0) && this.failureCount === 0) {
                this.clearTimeout();
                this.run();
            // Calculate backoff for normal or failure scenario
            } else if (this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.calculateBackoff());
        };
        this.stop = ()=>{
            this.clearTimeout();
            this.queuedSchedule = 0;
        };
        this.getFailureCount = ()=>this.failureCount;
        this.getCallbackStatus = ()=>{
            return this.callbackTimer.getCallbackStatus();
        };
        this.clearTimeout = ()=>{
            if (typeof window !== 'undefined' && this.scheduledTimeout !== null) {
                window.clearTimeout(this.scheduledTimeout);
                this.scheduledTimeout = null;
            }
        };
        this.run = ()=>{
            this.operationInFlight = true;
            this.clearTimeout();
            try {
                this.callbackTimer.executeCallbackWithTimeout(// callback to execute
                this.callback, // when callback completes, call this function
                this.done, // on timeout, do this instead
                ()=>this.done((0, $INLhk.DoneState).ERROR));
            } catch (err) {
                this.done(err);
            }
        };
        this.done = (state)=>{
            this.operationInFlight = false;
            if (state === (0, $INLhk.DoneState).ERROR || this.callbackTimer.getCallbackStatus() === (0, $5XX5x.CallbackStatus).TIMED_OUT) {
                this.failureCount++;
                this.clearTimeout();
            } else if (state === (0, $INLhk.DoneState).SUCCESS) this.failureCount = 0;
            this.processQueuedSchedule();
        };
        this.processQueuedSchedule = ()=>{
            if (this.queuedSchedule !== 0) {
                const immediate = this.queuedSchedule === 1;
                this.queuedSchedule = 0;
                this.schedule({
                    immediate: immediate
                });
            } else if (this.failureCount > 0) // This will schedule tasks when this._done was called with a truthy value
            // For example, when this.callback(this._done) was not called within
            // this.callbackTimeoutPeriod
            this.schedule();
        };
        this.calculateBackoff = ()=>{
            const { minRetryDelay: minRetryDelay, maxRetryDelay: maxRetryDelay, backoffFactor: backoffFactor, backoffJitterPercentage: backoffJitterPercentage, waitInterval: waitInterval } = this.options;
            // Helper for deviation based on a single random sample
            const jitter = (base, symmetric)=>{
                if (!backoffJitterPercentage || base <= 0) return 0;
                const r = (Math.random() - 0.5) * 2;
                const frac = symmetric ? r : Math.abs(r);
                return Math.floor(frac * backoffJitterPercentage * base);
            };
            // No failures: wait interval with positive-only jitter
            if (this.failureCount === 0) return waitInterval + jitter(waitInterval, false);
            // Failures: exponential backoff with symmetric jitter
            const base = Math.min(minRetryDelay * backoffFactor ** this.failureCount, maxRetryDelay);
            const withJitter = base + jitter(base, true);
            return Math.max(minRetryDelay, Math.min(withJitter, maxRetryDelay));
        };
        this.options = {
            minRetryDelay: retryOptions.minRetryDelay || $af4a35b966d6ddb0$var$SCHEDULER_OPTIONS_DEFAULT.minRetryDelay,
            maxRetryDelay: retryOptions.maxRetryDelay || $af4a35b966d6ddb0$var$SCHEDULER_OPTIONS_DEFAULT.maxRetryDelay,
            backoffFactor: retryOptions.backoffFactor || $af4a35b966d6ddb0$var$SCHEDULER_OPTIONS_DEFAULT.backoffFactor,
            backoffJitterPercentage: retryOptions.backoffJitterPercentage || $af4a35b966d6ddb0$var$SCHEDULER_OPTIONS_DEFAULT.backoffJitterPercentage,
            waitInterval: retryOptions.waitInterval !== undefined ? retryOptions.waitInterval : $af4a35b966d6ddb0$var$SCHEDULER_OPTIONS_DEFAULT.waitInterval,
            callbackTimeoutPeriod: retryOptions.callbackTimeoutPeriod || $af4a35b966d6ddb0$var$SCHEDULER_OPTIONS_DEFAULT.callbackTimeoutPeriod
        };
        this.scheduledTimeout = null;
        this.failureCount = 0;
        this.callback = callback;
        this.operationInFlight = false;
        this.queuedSchedule = 0;
        this.callbackTimer = new (0, $5XX5x.CallbackWithTimeout)(this.options.callbackTimeoutPeriod);
    }
}

});
parcelRegister("5XX5x", function(module, exports) {
$parcel$export(module.exports, "CallbackStatus", () => $15b29367aa4f1f6b$export$ef3353088fca369c);
$parcel$export(module.exports, "CallbackWithTimeout", () => $15b29367aa4f1f6b$export$590a718599f8f8b3);
var $15b29367aa4f1f6b$export$ef3353088fca369c = /*#__PURE__*/ function(CallbackStatus) {
    CallbackStatus["IDLE"] = "idle";
    CallbackStatus["RUNNING"] = "running";
    CallbackStatus["COMPLETED"] = "completed";
    CallbackStatus["TIMED_OUT"] = "timedOut";
    return CallbackStatus;
}({});
var $15b29367aa4f1f6b$export$def7d978353eaa0 = /*#__PURE__*/ function(CallbackEvent) {
    CallbackEvent["EXECUTE"] = "execute";
    CallbackEvent["COMPLETE"] = "complete";
    CallbackEvent["TIMEOUT"] = "timeout";
    return CallbackEvent;
}({});
class $15b29367aa4f1f6b$export$590a718599f8f8b3 {
    // This is a state machine to control the flow of execution.
    // IDLE -> RUNNING -> COMPLETED
    // IDLE -> RUNNING -> TIMEDOUT
    transitionCallbackStatus(currentStatus, event) {
        switch(currentStatus){
            case "idle":
            case "timedOut":
            case "completed":
                if (event === "execute") this.callbackStatus = "running";
                break;
            case "running":
                switch(event){
                    case "complete":
                        this.callbackStatus = "completed";
                        break;
                    case "timeout":
                        this.callbackStatus = "timedOut";
                        break;
                }
                break;
            default:
                this.callbackStatus = currentStatus;
        }
    }
    // Start a timeout. If this.callback(this._done) does not finish
    // by this.options.callbackTimeoutPeriod time period,
    // we will call done with a true value.
    executeCallbackWithTimeout(callback, onDone, onTimeout) {
        if (typeof window === 'undefined') return;
        this.transitionCallbackStatus(this.callbackStatus, "execute");
        // Setting timeout
        this.timeoutHandle = window.setTimeout(()=>{
            this.transitionCallbackStatus(this.callbackStatus, "timeout");
            onTimeout();
        }, this.timeoutPeriod);
        // Executing callback
        callback((state)=>{
            this.cancelTimeout();
            if (this.getCallbackStatus() !== "timedOut") {
                this.transitionCallbackStatus(this.callbackStatus, "complete");
                onDone(state);
            }
        });
    }
    getCallbackStatus() {
        return this.callbackStatus;
    }
    // This allows us to cancel the timeout function, for example, if the callback finishes before the timeout period
    // or, if the user wants to manually cancel the timeout
    cancelTimeout() {
        if (typeof window !== 'undefined' && this.timeoutPeriod > 0 && this.timeoutHandle) {
            window.clearTimeout(this.timeoutHandle);
            this.timeoutHandle = undefined;
        }
    }
    constructor(timeoutPeriod){
        // Milliseconds to wait
        this.timeoutPeriod = void 0;
        // Tracks the settimeout; so that we can clear the timeout
        this.timeoutHandle = undefined;
        this.callbackStatus = "idle";
        if (timeoutPeriod > 0) {
            this.timeoutPeriod = timeoutPeriod;
            return;
        }
        throw new Error('CallbackWithTimeout requires timeout period higher than 0');
    }
}

});

parcelRegister("INLhk", function(module, exports) {
$parcel$export(module.exports, "DoneState", () => $29cea6be35b0265a$export$f93c40fda808dd0c);
// Clients can optionally provide the callbackTimeoutPeriod parameter
var $29cea6be35b0265a$export$f93c40fda808dd0c = /*#__PURE__*/ function(DoneState) {
    DoneState[DoneState["NOOP"] = 0] = "NOOP";
    DoneState[DoneState["SUCCESS"] = 1] = "SUCCESS";
    DoneState[DoneState["ERROR"] = 2] = "ERROR";
    return DoneState;
}({});

});




parcelRegister("aO8Eq", function(module, exports) {
$parcel$export(module.exports, "attachXidToMultipleEvents", () => $ae45b13c077961f8$export$c21270cab66ab290);

var $7SKVk = parcelRequire("7SKVk");
function $ae45b13c077961f8$export$c9c3aaf655d6f275(item, xidCallback) {
    if (!(xidCallback && xidCallback instanceof Function)) return item;
    if (item.msg.type === (0, $7SKVk.SegmentEventTypes).PAGE || item.msg.type === (0, $7SKVk.SegmentEventTypes).TRACK) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.properties = {
            ...item.msg.properties,
            xid: xid
        };
    } else if (item.msg.traits && item.msg.type === (0, $7SKVk.SegmentEventTypes).IDENTIFY) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.traits = {
            ...item.msg.traits,
            xid: xid
        };
    }
    return item;
}
async function $ae45b13c077961f8$export$c21270cab66ab290(items, xidItemPromiseCallback) {
    try {
        const xidCallback = await xidItemPromiseCallback;
        return items.map((item)=>$ae45b13c077961f8$export$c9c3aaf655d6f275(item, xidCallback));
    } catch (error) {
        return items;
    }
}

});
parcelRegister("7SKVk", function(module, exports) {
$parcel$export(module.exports, "LastError", () => $bf818347aaca0fe7$export$a63e16b3351b8c36);
$parcel$export(module.exports, "FetchError", () => $bf818347aaca0fe7$export$26e841bcf1aeb894);
$parcel$export(module.exports, "SegmentEventTypes", () => $bf818347aaca0fe7$export$ddf929981dc6feb3);
$parcel$export(module.exports, "MetadataResponse", () => $bf818347aaca0fe7$export$4b1a5e5486cc0d80);
$parcel$export(module.exports, "ALLOW_LISTED_FETCH_ERROR_NAMES", () => $bf818347aaca0fe7$export$96f086dcf574a9e2);
class $bf818347aaca0fe7$export$a63e16b3351b8c36 {
    constructor(reason, error){
        this.reason = void 0;
        this.message = void 0;
        this.statusCode = void 0;
        this.reason = reason;
        this.message = error instanceof Error ? error.message : null;
        this.statusCode = error instanceof $bf818347aaca0fe7$export$26e841bcf1aeb894 ? error.statusCode : null;
    }
}
var $bf818347aaca0fe7$export$ddf929981dc6feb3 = /*#__PURE__*/ function(SegmentEventTypes) {
    SegmentEventTypes["IDENTIFY"] = "identify";
    SegmentEventTypes["PAGE"] = "page";
    // Dont need Screen as page and screen are the same and we only use page
    SegmentEventTypes["TRACK"] = "track";
    return SegmentEventTypes;
}({});
var $bf818347aaca0fe7$export$8d8db47b9b0efb63 = /*#__PURE__*/ function(CrossDomainIdentifierType) {
    CrossDomainIdentifierType["XC"] = "xc";
    CrossDomainIdentifierType["UID"] = "uid";
    return CrossDomainIdentifierType;
}({});
var $bf818347aaca0fe7$export$2140495465f9e528 = /*#__PURE__*/ function(CrossDomainIdentifierState) {
    CrossDomainIdentifierState["NEW"] = "NEW";
    CrossDomainIdentifierState["CHANGED"] = "CHANGED";
    CrossDomainIdentifierState["EXISTING"] = "EXISTING";
    CrossDomainIdentifierState["TIMEOUT"] = "TIMEOUT";
    CrossDomainIdentifierState["ERROR"] = "ERROR";
    CrossDomainIdentifierState["UNAVAILABLE"] = "UNAVAILABLE";
    CrossDomainIdentifierState["MALFORMED"] = "MALFORMED";
    CrossDomainIdentifierState["UNKNOWN"] = "UNKNOWN";
    return CrossDomainIdentifierState;
}({});
class $bf818347aaca0fe7$export$4b1a5e5486cc0d80 {
    static fromJson(json) {
        let isString = (value)=>typeof value === 'string' || value instanceof String;
        const url = isString(json?.url) ? json.url.trim() : '';
        return new $bf818347aaca0fe7$export$4b1a5e5486cc0d80(json?.props || null, url.startsWith('http') ? url : null);
    }
    constructor(props, url){
        this.props = void 0;
        this.url = void 0;
        this.props = props;
        this.url = url;
    }
}
class $bf818347aaca0fe7$export$26e841bcf1aeb894 extends Error {
    constructor(message, statusCode, statusText){
        super(message);
        this.statusCode = void 0;
        this.statusText = void 0;
        this.statusCode = statusCode;
        this.statusText = statusText;
    }
}
const $bf818347aaca0fe7$export$96f086dcf574a9e2 = [
    'FetchError',
    'AbortError',
    'TypeError'
];

});


parcelRegister("2AI7d", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_REQUEST_TIMEOUT", () => $a0efed145e2e92a4$export$9175ce0e1c95daf2);
$parcel$export(module.exports, "DEFAULT_METADATA_REQUEST_TIMEOUT", () => $a0efed145e2e92a4$export$8fddcd1eff390364);
$parcel$export(module.exports, "DEFAULT_METADATA_REFRESH_INTERVAL", () => $a0efed145e2e92a4$export$92ed669a3d41dad3);
$parcel$export(module.exports, "DEFAULT_METADATA_MIN_RETRY_DELAY", () => $a0efed145e2e92a4$export$6649d5c857717efe);
$parcel$export(module.exports, "DEFAULT_METADATA_MAX_RETRY_DELAY", () => $a0efed145e2e92a4$export$33e7628d3b2c0e2);
$parcel$export(module.exports, "DEFAULT_METADATA_PROPERTY_CHANGE_REFRESH_INTERVAL", () => $a0efed145e2e92a4$export$6f1c008dd0c3b67e);
const $a0efed145e2e92a4$export$9175ce0e1c95daf2 = 10000; // 10 seconds
const $a0efed145e2e92a4$export$8fddcd1eff390364 = 60000; // 60 seconds
const $a0efed145e2e92a4$export$92ed669a3d41dad3 = 600000; // 10 minutes
const $a0efed145e2e92a4$export$6649d5c857717efe = 5000; // 5 seconds
const $a0efed145e2e92a4$export$33e7628d3b2c0e2 = 3600000; // 60 minutes
const $a0efed145e2e92a4$export$6f1c008dd0c3b67e = 10; // 10 milliseconds

});

parcelRegister("kHJVt", function(module, exports) {
$parcel$export(module.exports, "HTTP_STATUS_CODE_MAP", () => $a7281db0986f4e15$export$ba118f9de1e5ac63);
const $a7281db0986f4e15$export$ba118f9de1e5ac63 = new Map([
    [
        200,
        'OK'
    ],
    [
        400,
        'Bad Request'
    ],
    [
        401,
        'Unauthorized'
    ],
    [
        402,
        'Payment Required'
    ],
    [
        403,
        'Forbidden'
    ],
    [
        404,
        'Not Found'
    ],
    [
        405,
        'Method Not Allowed'
    ],
    [
        406,
        'Not Acceptable'
    ],
    [
        407,
        'Proxy Authentication Required'
    ],
    [
        408,
        'Request Timeout'
    ],
    [
        409,
        'Conflict'
    ],
    [
        410,
        'Gone'
    ],
    [
        411,
        'Length Required'
    ],
    [
        412,
        'Precondition Failed'
    ],
    [
        413,
        'Payload Too Large'
    ],
    [
        414,
        'URI Too Long'
    ],
    [
        415,
        'Unsupported Media Type'
    ],
    [
        416,
        'Requested range not satisfiable'
    ],
    [
        417,
        'Expectation Failed'
    ],
    [
        418,
        "I'm a teapot"
    ],
    [
        422,
        'Unprocessable Entity'
    ],
    [
        423,
        'Locked'
    ],
    [
        424,
        'Failed Dependency'
    ],
    [
        425,
        'Too Early'
    ],
    [
        426,
        'Upgrade Required'
    ],
    [
        428,
        'Precondition Required'
    ],
    [
        429,
        'Too Many Requests'
    ],
    [
        431,
        'Request Header Fields Too Large'
    ],
    [
        451,
        'Unavailable For Legal Reasons'
    ],
    [
        500,
        'Internal Server Error'
    ],
    [
        501,
        'Not Implemented'
    ],
    [
        502,
        'Bad Gateway'
    ],
    [
        503,
        'Service Unavailable'
    ],
    [
        504,
        'Gateway Timeout'
    ],
    [
        505,
        'HTTP Version not supported'
    ],
    [
        506,
        'Variant Also Negotiates'
    ],
    [
        507,
        'Insufficient Storage'
    ],
    [
        508,
        'Loop Detected'
    ],
    [
        509,
        'Bandwidth Limit Exceeded'
    ],
    [
        510,
        'Not Extended'
    ],
    [
        511,
        'Network Authentication Required'
    ],
    [
        -1,
        'Unknown Status'
    ]
]);

});

parcelRegister("2srEX", function(module, exports) {
$parcel$export(module.exports, "sendEvents", () => $54af19380ad1efc8$export$8e8f0180c1b41fad);

var $34Zxt = parcelRequire("34Zxt");

var $7SKVk = parcelRequire("7SKVk");
const $54af19380ad1efc8$export$8e8f0180c1b41fad = async (options)=>{
    const signal = $54af19380ad1efc8$var$createOrGetAbortController(options)?.signal;
    const corsOptions = $54af19380ad1efc8$var$getCorsForUrl(options.url);
    const response = await fetch(options.url, {
        method: 'POST',
        // Content-type has to be text/plain in order to prevent unnecessary `OPTIONS` requests.
        headers: {
            'Content-Type': 'text/plain'
        },
        body: JSON.stringify(options.batch),
        signal: signal,
        ...corsOptions
    });
    if (response.status === 429 || response.status >= 500 && response.status < 600) throw new (0, $7SKVk.FetchError)(`HTTP Error ${response.status} (${response.statusText})`, response.status, response.statusText);
    return response;
};
const $54af19380ad1efc8$var$createOrGetAbortController = (options)=>{
    if (options.abortController) return options.abortController;
    else if (options.timeout) {
        const abortController = new AbortController();
        // After a fetch has completed, calling abort is ignored.
        setTimeout(()=>{
            abortController.abort();
        }, options.timeout);
        return abortController;
    }
    return undefined;
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $54af19380ad1efc8$var$getCorsForUrl = (0, $34Zxt.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});

});
parcelRegister("34Zxt", function(module, exports) {
$parcel$export(module.exports, "default", () => $23e17b2dde02fd93$export$2e2bcd8739ae039);
var $23e17b2dde02fd93$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $23e17b2dde02fd93$var$isEqual(first, second) {
    if (first === second) return true;
    if ($23e17b2dde02fd93$var$safeIsNaN(first) && $23e17b2dde02fd93$var$safeIsNaN(second)) return true;
    return false;
}
function $23e17b2dde02fd93$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$23e17b2dde02fd93$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $23e17b2dde02fd93$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $23e17b2dde02fd93$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

});


parcelRegister("jP4qk", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ad6bb7e2b8e4158$export$2e2bcd8739ae039);

var $1HmWQ = parcelRequire("1HmWQ");

var $84Yyr = parcelRequire("84Yyr");
var $bg171 = parcelRequire("bg171");

var $5WZVs = parcelRequire("5WZVs");
// Cookie is stale, if anonymousId was generated 7 days ago.
const $7ad6bb7e2b8e4158$var$ANONYMOUS_ID_COOKIE_STALE_DAYS = 7;
const $7ad6bb7e2b8e4158$var$SAFE = 'SAFE';
const $7ad6bb7e2b8e4158$var$UNSAFE = 'UNSAFE';
const $7ad6bb7e2b8e4158$var$NOT_FOUND = 'NOT_FOUND';
const $7ad6bb7e2b8e4158$var$COOKIE = 'COOKIE';
const $7ad6bb7e2b8e4158$var$LOCAL_STORAGE = 'LOCAL_STORAGE';
class $7ad6bb7e2b8e4158$export$2e2bcd8739ae039 {
    getUserId() {
        return this.userId || null;
    }
    setUserId(userId) {
        this.userId = userId;
    }
    getAnonymousId(customAnonymousIdGenerator) {
        /**
     * Prefer localStorage as there cant be duplicate keys, and its faster. Also update cookie, if stale.
     * If not set in localStorage, check cookies. Also set localStorage for future attempts.
     * If not in cookies, generate a new one. Set both cookie and localStorage keys.
     */ return this.getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() || this.getAnonymousIdFromCookieAndUpdateLocalStorage() || this.generateNewAnonymousId(customAnonymousIdGenerator);
    }
    setAnonymousId(anonymousId) {
        const stringifyAnonymosId = JSON.stringify(anonymousId);
        this.cookie.set((0, $84Yyr.AWCCookiesKeys).AJS_ANONYMOUS_ID, stringifyAnonymosId);
        this.lastAnonymousIdCookieUpdate = Date.now();
        return this.store.setItem((0, $84Yyr.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), stringifyAnonymosId);
    }
    getAnonymousIdFromStorage(source) {
        const rawStorageAnonidValue = source === $7ad6bb7e2b8e4158$var$LOCAL_STORAGE ? this.store.getItem((0, $84Yyr.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey()) : this.cookie.get((0, $84Yyr.AWCCookiesKeys).AJS_ANONYMOUS_ID);
        if (rawStorageAnonidValue) {
            const unsafeValue = {
                type: $7ad6bb7e2b8e4158$var$UNSAFE,
                anonymousId: rawStorageAnonidValue
            };
            try {
                const parsedAnonId = JSON.parse(rawStorageAnonidValue);
                if (parsedAnonId && typeof parsedAnonId === 'string') return {
                    type: $7ad6bb7e2b8e4158$var$SAFE,
                    anonymousId: parsedAnonId
                };
                return unsafeValue;
            } catch (err) {
                /*
         * Segments new Analytics-next client will store strings as strings without stringifing.
         * The legacy Segment client and AWC always stringify and parse cookies and values.
         * If the new Segment analytics-client stores a cookie and local storage value first, it will
         * breaking old clients.
         *
         * Additionally, JSON.parse can cause exceptions to be thrown in some browsers; see AAP-324.
         *
         * Intentionally swalling errors here and returning the original value found in storage to avoid ping-pong.
         */ return unsafeValue;
            }
        }
        return {
            type: $7ad6bb7e2b8e4158$var$NOT_FOUND
        };
    }
    getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() {
        const localStorageValue = this.getAnonymousIdFromStorage($7ad6bb7e2b8e4158$var$LOCAL_STORAGE);
        let shouldUpdateCookie = false;
        if (!this.lastAnonymousIdCookieUpdate || (0, $1HmWQ.default)(new Date(), new Date(this.lastAnonymousIdCookieUpdate)) >= $7ad6bb7e2b8e4158$var$ANONYMOUS_ID_COOKIE_STALE_DAYS) shouldUpdateCookie = true;
        switch(localStorageValue.type){
            case $7ad6bb7e2b8e4158$var$SAFE:
                if (shouldUpdateCookie) this.setAnonymousId(localStorageValue.anonymousId);
                return localStorageValue.anonymousId;
            case $7ad6bb7e2b8e4158$var$UNSAFE:
                return localStorageValue.anonymousId;
            case $7ad6bb7e2b8e4158$var$NOT_FOUND:
            default:
                return null;
        }
    }
    getAnonymousIdFromCookieAndUpdateLocalStorage() {
        const cookieValue = this.getAnonymousIdFromStorage($7ad6bb7e2b8e4158$var$COOKIE);
        switch(cookieValue.type){
            case $7ad6bb7e2b8e4158$var$SAFE:
            case $7ad6bb7e2b8e4158$var$UNSAFE:
                this.store.setItem((0, $84Yyr.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), JSON.stringify(cookieValue.anonymousId));
                return cookieValue.anonymousId;
            case $7ad6bb7e2b8e4158$var$NOT_FOUND:
            default:
                return null;
        }
    }
    generateNewAnonymousId(customAnonymousIdGenerator) {
        const generator = typeof customAnonymousIdGenerator === 'function' ? customAnonymousIdGenerator : ()=>{
            return crypto.randomUUID();
        };
        const newAnonId = generator();
        this.setAnonymousId(newAnonId);
        return newAnonId;
    }
    constructor(disableCookiePersistence){
        this.store = void 0;
        this.cookie = void 0;
        this.userId = void 0;
        this.lastAnonymousIdCookieUpdate = void 0;
        this.store = new (0, $5WZVs.default)({
            useStoragePrefix: false
        });
        this.cookie = new (0, $bg171.default)(disableCookiePersistence);
    }
}

});
parcelRegister("1HmWQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $13cb9b965931e47a$export$2e2bcd8739ae039);

var $40arl = parcelRequire("40arl");

var $7gCsG = parcelRequire("7gCsG");

var $2Ioip = parcelRequire("2Ioip");
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $13cb9b965931e47a$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function $13cb9b965931e47a$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $2Ioip.default)(2, arguments);
    var dateLeft = (0, $40arl.default)(dirtyDateLeft);
    var dateRight = (0, $40arl.default)(dirtyDateRight);
    var sign = $13cb9b965931e47a$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $7gCsG.default)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($13cb9b965931e47a$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("40arl", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e9f42b62f739bb4$export$2e2bcd8739ae039);

var $75P5O = parcelRequire("75P5O");

var $2Ioip = parcelRequire("2Ioip");
function $2e9f42b62f739bb4$export$2e2bcd8739ae039(argument) {
    (0, $2Ioip.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $75P5O.default)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});
parcelRegister("75P5O", function(module, exports) {
$parcel$export(module.exports, "default", () => $52a0a1f950ec22c1$export$2e2bcd8739ae039);
function $52a0a1f950ec22c1$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $52a0a1f950ec22c1$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $52a0a1f950ec22c1$export$2e2bcd8739ae039(o);
}

});

parcelRegister("2Ioip", function(module, exports) {
$parcel$export(module.exports, "default", () => $1fa2897f6c4db51d$export$2e2bcd8739ae039);
function $1fa2897f6c4db51d$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}

});


parcelRegister("7gCsG", function(module, exports) {
$parcel$export(module.exports, "default", () => $54a7dcaef84a0875$export$2e2bcd8739ae039);

var $k36zP = parcelRequire("k36zP");

var $xnZxy = parcelRequire("xnZxy");

var $2Ioip = parcelRequire("2Ioip");
var $54a7dcaef84a0875$var$MILLISECONDS_IN_DAY = 86400000;
function $54a7dcaef84a0875$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $2Ioip.default)(2, arguments);
    var startOfDayLeft = (0, $xnZxy.default)(dirtyDateLeft);
    var startOfDayRight = (0, $xnZxy.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $k36zP.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $k36zP.default)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $54a7dcaef84a0875$var$MILLISECONDS_IN_DAY);
}

});
parcelRegister("k36zP", function(module, exports) {
$parcel$export(module.exports, "default", () => $e9893080da4d5abb$export$2e2bcd8739ae039);
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $e9893080da4d5abb$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

});

parcelRegister("xnZxy", function(module, exports) {
$parcel$export(module.exports, "default", () => $0645b16922c451c3$export$2e2bcd8739ae039);

var $40arl = parcelRequire("40arl");

var $2Ioip = parcelRequire("2Ioip");
function $0645b16922c451c3$export$2e2bcd8739ae039(dirtyDate) {
    (0, $2Ioip.default)(1, arguments);
    var date = (0, $40arl.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

});



parcelRegister("84Yyr", function(module, exports) {
$parcel$export(module.exports, "AWCCookiesKeys", () => $c967aef21b0efc39$export$202d555a5dbfd90c);
$parcel$export(module.exports, "AllAnalyticsCookies", () => $c967aef21b0efc39$export$d4cb17942ea57c95);
var $c967aef21b0efc39$export$202d555a5dbfd90c = /*#__PURE__*/ function(AWCCookiesKeys) {
    AWCCookiesKeys["AWC_TLD_TEST"] = "AWC_TLD_TEST";
    AWCCookiesKeys["AWC_ANALYTICS_DEBUG"] = "AWC_ANALYTICS_DEBUG";
    AWCCookiesKeys["AJS_ANONYMOUS_ID"] = "AJS_ANONYMOUS_ID";
    return AWCCookiesKeys;
}({});
class $c967aef21b0efc39$var$CookieSchema {
    getAttributes() {
        return this.options;
    }
    getKey() {
        return this.key;
    }
    constructor(key, options){
        this.key = void 0;
        this.options = void 0;
        this.key = key;
        this.options = options;
    }
}
const $c967aef21b0efc39$var$isSecure = ()=>{
    try {
        return window && window.location && window.location.protocol === 'https:';
    } catch (err) {
        return false;
    }
};
const $c967aef21b0efc39$export$d4cb17942ea57c95 = {
    ["AWC_TLD_TEST"]: new $c967aef21b0efc39$var$CookieSchema('__awc_tld_test__', {
        expires: 365,
        secure: $c967aef21b0efc39$var$isSecure(),
        path: '/'
    }),
    ["AWC_ANALYTICS_DEBUG"]: new $c967aef21b0efc39$var$CookieSchema('atlassian_analytics_debug', {
        expires: 365,
        secure: $c967aef21b0efc39$var$isSecure(),
        path: '/'
    }),
    ["AJS_ANONYMOUS_ID"]: new $c967aef21b0efc39$var$CookieSchema('ajs_anonymous_id', {
        expires: 365,
        secure: $c967aef21b0efc39$var$isSecure(),
        path: '/'
    })
};

});

parcelRegister("bg171", function(module, exports) {
$parcel$export(module.exports, "default", () => $9495416789bb9c9f$export$2e2bcd8739ae039);

var $ePB4t = parcelRequire("ePB4t");

var $84Yyr = parcelRequire("84Yyr");

var $cQtwD = parcelRequire("cQtwD");

var $e8e0r = parcelRequire("e8e0r");
class $9495416789bb9c9f$export$2e2bcd8739ae039 {
    set(name, value, options) {
        // no-op
        if (!(0, $84Yyr.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not set.`);
            return;
        }
        return this.cookieLike.set((0, $84Yyr.AllAnalyticsCookies)[name].getKey(), value, {
            ...(0, $84Yyr.AllAnalyticsCookies)[name].getAttributes(),
            // Function is memoized so we only calculate this once per page load
            domain: (0, $e8e0r.getTld)(),
            ...options
        });
    }
    get(name) {
        if (!(0, $84Yyr.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not fetched.`);
            return;
        }
        return this.cookieLike.get((0, $84Yyr.AllAnalyticsCookies)[name].getKey());
    }
    remove(name, options) {
        if (!(0, $84Yyr.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not removed.`);
            return;
        }
        this.cookieLike.remove((0, $84Yyr.AllAnalyticsCookies)[name].getKey(), {
            ...options
        });
    }
    constructor(disableCookiePersistence){
        this.cookieLike = void 0;
        this.cookieLike = (0, $e8e0r.canUseCookie)(disableCookiePersistence) ? (0, (/*@__PURE__*/$parcel$interopDefault($ePB4t))) : new (0, $cQtwD.default)();
    }
}

});
parcelRegister("ePB4t", function(module, exports) {
(function(factory) {
    var registeredInModuleLoader;
    if (typeof define === 'function' && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    module.exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = extend({
                path: '/'
            }, api.defaults, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = key + '=' + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === 'undefined') return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var cookie = parts.slice(1).join('=');
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, '', extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});

});

parcelRegister("cQtwD", function(module, exports) {
$parcel$export(module.exports, "default", () => $92e055fa5283e88b$export$2e2bcd8739ae039);

var $5WZVs = parcelRequire("5WZVs");
class $92e055fa5283e88b$export$2e2bcd8739ae039 {
    set(name, value) {
        this.safeStorage.setItem(name, value);
        return value;
    }
    get(name) {
        const value = this.safeStorage.getItem(name);
        return value || undefined;
    }
    remove(name) {
        this.safeStorage.removeItem(name);
    }
    constructor(){
        this.safeStorage = void 0;
        this.safeStorage = new (0, $5WZVs.default)({
            useStoragePrefix: false
        });
    }
}

});
parcelRegister("5WZVs", function(module, exports) {
$parcel$export(module.exports, "default", () => $3dd70d8c8ef51031$export$2e2bcd8739ae039);

var $4Evg9 = parcelRequire("4Evg9");

var $a5rIM = parcelRequire("a5rIM");
class $3dd70d8c8ef51031$export$2e2bcd8739ae039 extends (0, $a5rIM.default) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = window.localStorage || (0, $4Evg9.default);
        } catch (err) {
            storageToUse = (0, $4Evg9.default);
        }
        super(storageToUse, options);
    }
}

});
parcelRegister("4Evg9", function(module, exports) {
$parcel$export(module.exports, "default", () => $c2371e0faf6f886f$export$2e2bcd8739ae039);
class $c2371e0faf6f886f$export$90e3e001bcac59c7 {
    constructor(){
        this._data = {};
        this.length = 0;
        this.setItem = (key, value)=>{
            this._data[key] = value;
            this.length = Object.keys(this._data).length;
            return value;
        };
        this.getItem = (key)=>{
            if (key in this._data) return this._data[key];
            return null;
        };
        this.removeItem = (key)=>{
            if (key in this._data) delete this._data[key];
            this.length = Object.keys(this._data).length;
            return null;
        };
        this.clear = ()=>{
            this._data = {};
            this.length = 0;
        };
        this.key = (index)=>Object.keys(this._data)[index];
    }
}
// eslint-disable-next-line import/no-anonymous-default-export
const $c2371e0faf6f886f$var$inmemorystorage = new $c2371e0faf6f886f$export$90e3e001bcac59c7();
var $c2371e0faf6f886f$export$2e2bcd8739ae039 = $c2371e0faf6f886f$var$inmemorystorage;

});

parcelRegister("a5rIM", function(module, exports) {
$parcel$export(module.exports, "default", () => $c592139085d878a5$export$2e2bcd8739ae039);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ 
var $2tp3i = parcelRequire("2tp3i");

var $4Evg9 = parcelRequire("4Evg9");
const $c592139085d878a5$export$41c06fdd37b7e9a5 = 'awc';
const $c592139085d878a5$export$770aa8bc07b3de03 = 'awcInMemoryStorageFallback';
function $c592139085d878a5$export$48c17662a6902497(store) {
    const TEST_VALUE = 'test_value';
    if (!store) return false;
    try {
        const key = 'awc.storage.support';
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}
function $c592139085d878a5$export$6325979d1c67607f(e) {
    let quotaExceeded = false;
    if (e.code) switch(e.code){
        case 22:
            quotaExceeded = true;
            break;
        case 1014:
            // Firefox
            if (e.name === 'NS_ERROR_DOM_QUOTA_REACHED') quotaExceeded = true;
            break;
        default:
            break;
    }
    else if (e.number === -2147024882) // Internet Explorer 8
    quotaExceeded = true;
    return quotaExceeded;
}
class $c592139085d878a5$export$2e2bcd8739ae039 {
    constructor(storageToUse, options = {}){
        this._prefix = void 0;
        this._store = void 0;
        this.options = void 0;
        this.getStore = ()=>this._store;
        this.getItem = (key)=>this._store.getItem(this.createKey(key));
        this.removeItem = (key)=>this._store.removeItem(this.createKey(key));
        this.setItem = (key, value)=>{
            try {
                this._store.setItem(this.createKey(key), value);
            } catch (err) {
                if ($c592139085d878a5$export$6325979d1c67607f(err)) {
                    this.swapToInMemory();
                    this._store.setItem(this.createKey(key), value);
                }
            }
        };
        this.swapToInMemory = ()=>{
            if (this._store === (0, $4Evg9.default) || typeof window === 'undefined') return;
            const keys = Object.keys(this._store || {});
            let inMemoryStorage;
            if ($c592139085d878a5$export$48c17662a6902497(window[$c592139085d878a5$export$770aa8bc07b3de03])) inMemoryStorage = window[$c592139085d878a5$export$770aa8bc07b3de03];
            else {
                inMemoryStorage = (0, $4Evg9.default);
                if (!window[$c592139085d878a5$export$770aa8bc07b3de03]) // If not already attached to window then attach our instance of InMemoryStorage
                // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
                // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
                window[$c592139085d878a5$export$770aa8bc07b3de03] = (0, $4Evg9.default);
            }
            keys.forEach((key)=>{
                if (key.indexOf(this.getPrefix()) === 0) {
                    const value = this._store.getItem(key);
                    if (value) inMemoryStorage.setItem(key, value);
                }
            });
            this._store = inMemoryStorage;
        };
        this.clear = ()=>this._store.clear();
        this.key = (index)=>this._store.key(index);
        this.getPrefix = ()=>this._prefix;
        this.createKey = (key)=>{
            if (this._prefix) return `${this.getPrefix()}.${key}`;
            return key;
        };
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($c592139085d878a5$export$41c06fdd37b7e9a5);
        if (options.envPrefix && options.envPrefix !== (0, $2tp3i.envType).PROD) prefixes.push(options.envPrefix);
        this._prefix = prefixes.join('-');
        if ($c592139085d878a5$export$48c17662a6902497(storageToUse)) this._store = storageToUse;
        else this.swapToInMemory();
    }
}

});



parcelRegister("e8e0r", function(module, exports) {
$parcel$export(module.exports, "canUseCookie", () => $d66ffe0d74faae44$export$a9330601ee8f4d95);
$parcel$export(module.exports, "getTld", () => $d66ffe0d74faae44$export$de6821eed3d5f32d);

var $ePB4t = parcelRequire("ePB4t");

var $34Zxt = parcelRequire("34Zxt");

var $84Yyr = parcelRequire("84Yyr");
const $d66ffe0d74faae44$export$a9330601ee8f4d95 = (disableCookiePersistence = false)=>{
    if (disableCookiePersistence) return false;
    return !(location.protocol === 'file:' || location.protocol === 'chrome-extension:');
};
const $d66ffe0d74faae44$export$eb80e1beaa8dacf8 = (0, $84Yyr.AllAnalyticsCookies).AWC_TLD_TEST.getKey();
const $d66ffe0d74faae44$export$19164982d36535d8 = 'tld_test';
const $d66ffe0d74faae44$export$de6821eed3d5f32d = (0, $34Zxt.default)(()=>{
    if (typeof location === 'undefined') return '';
    const { hostname: hostname } = location;
    const splitHostname = hostname.split('.');
    for(let i = 1; i <= splitHostname.length; i++){
        const domainParts = splitHostname.slice(i * -1);
        const domain = `.${domainParts.join('.')}`;
        (0, (/*@__PURE__*/$parcel$interopDefault($ePB4t))).set($d66ffe0d74faae44$export$eb80e1beaa8dacf8, $d66ffe0d74faae44$export$19164982d36535d8, {
            domain: domain
        });
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ePB4t))).get($d66ffe0d74faae44$export$eb80e1beaa8dacf8) === $d66ffe0d74faae44$export$19164982d36535d8) {
            (0, (/*@__PURE__*/$parcel$interopDefault($ePB4t))).remove($d66ffe0d74faae44$export$eb80e1beaa8dacf8, {
                domain: domain
            });
            return domain;
        }
    }
    return hostname;
});

});



parcelRegister("3aC6W", function(module, exports) {
$parcel$export(module.exports, "buildContext", () => $06d418684083b597$export$3a7fe28f9bf4f3d9);
$parcel$export(module.exports, "prepareEventProperties", () => $06d418684083b597$export$44d22e5fb02cc68e);
// @ts-ignore

var $8POb2 = parcelRequire("8POb2");
const $06d418684083b597$export$3a7fe28f9bf4f3d9 = (context)=>{
    return {
        ...context.context,
        userAgent: navigator.userAgent
    };
};
const $06d418684083b597$export$44d22e5fb02cc68e = (properties)=>{
    const propertiesWithoutUndefined = $06d418684083b597$var$nestedRemoveUndefinedValues(properties, '$.properties');
    return (0, (/*@__PURE__*/$parcel$interopDefault($8POb2)))(propertiesWithoutUndefined);
};
// This function will essentially deepClone as well
const $06d418684083b597$var$nestedRemoveUndefinedValues = (obj, path)=>{
    const recursionDepthLimit = 512;
    const nestedRemoveUndefinedValuesImpl = (source, processedReferences, path, depth)=>{
        if (source === null || typeof source !== 'object') return source;
        // If the level of nesting is egregiously excessive we'll stop processing any further to
        // avoid crashing due to stack exhaustion, instead we return a note object.
        if (depth > recursionDepthLimit) return {
            _depthLimitExceeded: true,
            message: `Object nesting depth limit exceeded at path '${path}' with depth '${depth}'`
        };
        // If this object has already been seen then processing it would create a circular reference,
        // instead we return a note object.
        if (processedReferences.has(source)) {
            const originalPath = processedReferences.get(source);
            return {
                _circularReference: true,
                message: `Circular reference to object at original path '${originalPath}' detected at path '${path}'`,
                originalPath: originalPath
            };
        }
        processedReferences.set(source, path);
        const clone = {};
        Object.keys(source).forEach((key)=>{
            const value = source[key];
            if (value !== undefined) {
                if (Array.isArray(value)) {
                    const newArray = [];
                    value.forEach((v, i)=>{
                        const newValue = nestedRemoveUndefinedValuesImpl(v, processedReferences, `${path}.${key}[${i}]`, depth + 1);
                        if (newValue !== undefined) newArray.push(newValue);
                    });
                    clone[key] = newArray;
                } else {
                    const newValue = nestedRemoveUndefinedValuesImpl(value, processedReferences, `${path}.${key}`, depth + 1);
                    if (newValue !== undefined) clone[key] = newValue;
                }
            }
        });
        processedReferences.delete(source);
        return clone;
    };
    return nestedRemoveUndefinedValuesImpl(obj, new Map(), path, 0);
};

});
parcelRegister("8POb2", function(module, exports) {
'use strict';

var $aHVti = parcelRequire("aHVti");
/**
 * Expose `traverse`.
 */ module.exports = $66ea02466d94434b$var$traverse;
/**
 * Recursively traverse an object or array, and convert
 * all ISO date strings parse into Date objects.
 *
 * @param {Object} input - object, array, or string to convert
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $66ea02466d94434b$var$traverse(input, strict) {
    if (strict === undefined) strict = true;
    if (input && typeof input === 'object') return $66ea02466d94434b$var$traverseObject(input, strict);
    else if (Array.isArray(input)) return $66ea02466d94434b$var$traverseArray(input, strict);
    else if ($aHVti.is(input, strict)) return $aHVti.parse(input);
    return input;
}
/**
 * Object traverser helper function.
 *
 * @param {Object} obj - object to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $66ea02466d94434b$var$traverseObject(obj, strict) {
    Object.keys(obj).forEach(function(key) {
        obj[key] = $66ea02466d94434b$var$traverse(obj[key], strict);
    });
    return obj;
}
/**
 * Array traverser helper function
 *
 * @param {Array} arr - array to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Array}
 */ function $66ea02466d94434b$var$traverseArray(arr, strict) {
    arr.forEach(function(value, index) {
        arr[index] = $66ea02466d94434b$var$traverse(value, strict);
    });
    return arr;
}

});
parcelRegister("aHVti", function(module, exports) {
$parcel$export(module.exports, "parse", () => $0203021147cf10a9$export$98e6a39c04603d36, (v) => $0203021147cf10a9$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "is", () => $0203021147cf10a9$export$226b3eccf92c9ed9, (v) => $0203021147cf10a9$export$226b3eccf92c9ed9 = v);
/**
 * Convert an ISO date string to a date. Fallback to native `Date.parse`.
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 *
 * @param {String} iso
 * @return {Date}
 */ var $0203021147cf10a9$export$98e6a39c04603d36;
/**
 * Checks whether a `string` is an ISO date string. `strict` mode requires that
 * the date string at least have a year, month and date.
 *
 * @param {String} string
 * @param {Boolean} strict
 * @return {Boolean}
 */ var $0203021147cf10a9$export$226b3eccf92c9ed9;
'use strict';
/**
 * Matcher, slightly modified from:
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 */ var $0203021147cf10a9$var$matcher = /^(\d{4})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:([ T])(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
$0203021147cf10a9$export$98e6a39c04603d36 = function(iso) {
    var numericKeys = [
        1,
        5,
        6,
        7,
        11,
        12
    ];
    var arr = $0203021147cf10a9$var$matcher.exec(iso);
    var offset = 0;
    // fallback to native parsing
    if (!arr) return new Date(iso);
    /* eslint-disable no-cond-assign */ // remove undefined values
    for(var i = 0, val; val = numericKeys[i]; i++)arr[val] = parseInt(arr[val], 10) || 0;
    /* eslint-enable no-cond-assign */ // allow undefined days and months
    arr[2] = parseInt(arr[2], 10) || 1;
    arr[3] = parseInt(arr[3], 10) || 1;
    // month is 0-11
    arr[2]--;
    // allow abitrary sub-second precision
    arr[8] = arr[8] ? (arr[8] + '00').substring(0, 3) : 0;
    // apply timezone if one exists
    if (arr[4] === ' ') offset = new Date().getTimezoneOffset();
    else if (arr[9] !== 'Z' && arr[10]) {
        offset = arr[11] * 60 + arr[12];
        if (arr[10] === '+') offset = 0 - offset;
    }
    var millis = Date.UTC(arr[1], arr[2], arr[3], arr[5], arr[6] + offset, arr[7], arr[8]);
    return new Date(millis);
};
$0203021147cf10a9$export$226b3eccf92c9ed9 = function(string, strict) {
    if (typeof string !== 'string') return false;
    if (strict && /^\d{4}-\d{2}-\d{2}/.test(string) === false) return false;
    return $0203021147cf10a9$var$matcher.test(string);
};

});




parcelRegister("hqzVj", function(module, exports) {
$parcel$export(module.exports, "MetadataClient", () => $cc428dbbfea5896a$export$1ac223ae496131c9);

var $8viHC = parcelRequire("8viHC");

var $hApEI = parcelRequire("hApEI");

var $e9dzS = parcelRequire("e9dzS");
var $INLhk = parcelRequire("INLhk");

var $2E5bV = parcelRequire("2E5bV");

var $7CePv = parcelRequire("7CePv");

var $eI6RR = parcelRequire("eI6RR");

var $2AI7d = parcelRequire("2AI7d");

var $6KrpW = parcelRequire("6KrpW");

var $7SKVk = parcelRequire("7SKVk");
var $cc428dbbfea5896a$var$_MetadataClient;
class $cc428dbbfea5896a$export$1ac223ae496131c9 {
    /**
   * Starts the metadata client. This will start the scheduler and begin
   * fetching metadata.
   *
   * @param allowRestart - If false, the client will not be restarted if it has already been stopped
   *						 by a call to stop().
   */ start(allowRestart) {
        if (this._isEnabled || this._hasBeenStopped && !allowRestart) return;
        this._isEnabled = true;
        this.startNetworkStatusMonitor();
        setTimeout(()=>{
            this._scheduler.schedule({
                immediate: true
            });
        }, $cc428dbbfea5896a$export$1ac223ae496131c9.INITIAL_REFRESH_DELAY);
    }
    stop() {
        if (!this._isEnabled) return;
        this._hasBeenStopped = true;
        this._isEnabled = false;
        this.stopNetworkStatusMonitor();
        this._scheduler.stop();
        this._fetchAbortController?.abort();
        this.resetPropertyChangeRefresh();
    }
    startNetworkStatusMonitor() {
        if (this._networkStatus) return;
        this._networkStatus = new (0, $8viHC.default)((status)=>{
            if (status === (0, $2E5bV.NetworkStatusEnum).OFFLINE) this._scheduler.stop();
            else if (this._isEnabled) this._scheduler.schedule({
                immediate: this._metadataInfo === null
            });
        });
    }
    stopNetworkStatusMonitor() {
        if (this._networkStatus) {
            this._networkStatus.removeListeners();
            this._networkStatus = null;
        }
    }
    async refreshMetadataAsync() {
        if ((0, $eI6RR.TestSupport).areFetchCallsDisabled() || !this._isEnabled) return Promise.resolve();
        this._fetchAbortController?.abort();
        this._fetchAbortController = new AbortController();
        const fetchAbortSignal = this._fetchAbortController.signal;
        this._lastFetchRequestCount = this._scheduler.getFailureCount();
        await (0, $6KrpW.fetchMetadata)(this._url, {
            product: this._product,
            userInfo: this._userInfo,
            tenantInfo: this._tenantInfo
        }, (0, $2AI7d.DEFAULT_METADATA_REQUEST_TIMEOUT), fetchAbortSignal).then(async (response)=>{
            const metadata = await response.json();
            this._metadataInfo = (0, $7SKVk.MetadataResponse).fromJson(metadata);
            this._lastFetchRequestCount++;
            this._requestStatus = 'FETCHED';
            this._lastErrorReason = null;
        }).catch((error)=>{
            if (fetchAbortSignal.aborted) // This request was aborted, so we don't need to handle it.
            return;
            this._requestStatus = 'FAILED';
            if (error instanceof (0, $7SKVk.FetchError) && [
                429,
                503
            ].includes(error.statusCode)) this._lastErrorReason = 'ServerBusyError';
            else this._lastErrorReason = error instanceof Error && (0, $7SKVk.ALLOW_LISTED_FETCH_ERROR_NAMES).includes(error.name) ? error.name : 'Unknown';
            throw error;
        });
    }
    getMetadataAsync() {
        return Promise.resolve(this._metadataInfo);
    }
    get status() {
        return this._requestStatus;
    }
    get lastErrorReason() {
        return this._lastErrorReason;
    }
    get lastFetchRequestCount() {
        return this._lastFetchRequestCount;
    }
    get userInfo() {
        return this._userInfo;
    }
    set userInfo(userInfo) {
        if (this._userInfo?.userId === userInfo?.userId && this._userInfo?.userIdType === userInfo?.userIdType) return;
        this._userInfo = userInfo;
        this.schedulePropertyChangeRefresh();
    }
    get tenantInfo() {
        return this._tenantInfo;
    }
    set tenantInfo(tenantInfo) {
        if (this._tenantInfo?.tenantId === tenantInfo?.tenantId && this._tenantInfo?.tenantIdType === tenantInfo?.tenantIdType) return;
        this._tenantInfo = tenantInfo;
        this.schedulePropertyChangeRefresh();
    }
    get metrics() {
        return {
            host: this._metadataHost,
            status: this.status,
            lastErrorReason: this.lastErrorReason,
            lastRefreshRequestCount: this.lastFetchRequestCount
        };
    }
    async scheduleCallback(done) {
        if (this._networkStatus?.getNetworkStatus() === (0, $2E5bV.NetworkStatusEnum).OFFLINE) {
            done((0, $INLhk.DoneState).NOOP);
            return;
        }
        try {
            await this.refreshMetadataAsync();
            done((0, $INLhk.DoneState).SUCCESS);
            this._scheduler.schedule();
        } catch (error) {
            done((0, $INLhk.DoneState).ERROR);
        }
    }
    /**
   * Schedules a refresh of the metadata when the user or tenant info changes. There is
   * a short delay to allow for multiple changes to be batched together, such as when the
   * callers sets the user info and tenant info in quick succession.
   */ schedulePropertyChangeRefresh() {
        if (!this._isEnabled) return;
        this.resetPropertyChangeRefresh();
        this._propertyChangeRefreshTimeout = setTimeout(()=>{
            this.resetPropertyChangeRefresh();
            this._scheduler.schedule({
                immediate: true
            });
        }, (0, $2AI7d.DEFAULT_METADATA_PROPERTY_CHANGE_REFRESH_INTERVAL));
    }
    resetPropertyChangeRefresh() {
        if (this._propertyChangeRefreshTimeout) {
            clearTimeout(this._propertyChangeRefreshTimeout);
            this._propertyChangeRefreshTimeout = null;
        }
    }
    buildOptions(options) {
        return {
            backoffFactor: options?.backoffFactor || (0, $hApEI.DEFAULT_POLLING_OPTIONS).backoffFactor,
            backoffJitterPercentage: options?.backoffJitterPercentage !== undefined ? options.backoffJitterPercentage : (0, $hApEI.DEFAULT_POLLING_OPTIONS).backoffJitterPercentage,
            batchFlushSize: options?.batchFlushSize || (0, $hApEI.DEFAULT_POLLING_OPTIONS).batchFlushSize,
            flushBeforeUnload: options?.flushBeforeUnload || (0, $hApEI.DEFAULT_POLLING_OPTIONS).flushBeforeUnload,
            flushWaitMs: options?.flushWaitMs || (0, $hApEI.DEFAULT_POLLING_OPTIONS).flushWaitMs,
            maxItems: options?.maxItems || (0, $hApEI.DEFAULT_POLLING_OPTIONS).maxItems,
            maxAttempts: options?.maxAttempts || (0, $hApEI.DEFAULT_POLLING_OPTIONS).maxAttempts,
            maxRetryDelay: options?.maxRetryDelay || (0, $hApEI.DEFAULT_POLLING_OPTIONS).maxRetryDelay,
            minRetryDelay: options?.minRetryDelay || (0, $hApEI.DEFAULT_POLLING_OPTIONS).minRetryDelay
        };
    }
    constructor(apiHostProtocol, apiHost, product){
        this._userInfo = void 0;
        this._tenantInfo = void 0;
        this._url = void 0;
        this._metadataHost = void 0;
        this._product = void 0;
        this._metadataInfo = void 0;
        this._requestStatus = void 0;
        this._lastFetchRequestCount = void 0;
        this._options = void 0;
        this._scheduler = void 0;
        this._networkStatus = void 0;
        this._lastErrorReason = void 0;
        this._fetchAbortController = void 0;
        this._hasBeenStopped = void 0;
        this._isEnabled = void 0;
        this._propertyChangeRefreshTimeout = void 0;
        this._userInfo = {
            anonymousId: ''
        };
        this._tenantInfo = {};
        this._url = `${apiHostProtocol}://${apiHost}/metadata`;
        this._product = product;
        this._metadataInfo = null;
        this._requestStatus = 'PENDING';
        this._lastFetchRequestCount = 0;
        this._lastErrorReason = null;
        this._fetchAbortController = null;
        this._hasBeenStopped = false;
        this._isEnabled = false;
        this._propertyChangeRefreshTimeout = null;
        const isStargateProxy = (0, $7CePv.isStargateProxyPath)({
            apiHost: apiHost
        });
        this._metadataHost = isStargateProxy ? 'PRODUCT_HOST' : apiHost;
        this._options = this.buildOptions({
            backoffFactor: 2,
            backoffJitterPercentage: 0.8,
            batchFlushSize: 7,
            flushBeforeUnload: false,
            flushWaitMs: 500,
            maxAttempts: 10,
            maxItems: 1000,
            minRetryDelay: (0, $2AI7d.DEFAULT_METADATA_MIN_RETRY_DELAY),
            maxRetryDelay: (0, $2AI7d.DEFAULT_METADATA_MAX_RETRY_DELAY)
        });
        this._scheduler = new (0, $e9dzS.default)({
            ...this._options,
            waitInterval: (0, $2AI7d.DEFAULT_METADATA_REFRESH_INTERVAL)
        }, this.scheduleCallback.bind(this));
        this._networkStatus = null;
    }
}
$cc428dbbfea5896a$var$_MetadataClient = $cc428dbbfea5896a$export$1ac223ae496131c9;
$cc428dbbfea5896a$export$1ac223ae496131c9.INITIAL_REFRESH_DELAY = 1;
$cc428dbbfea5896a$export$1ac223ae496131c9.Factory = (apiHostProtocol, apiHost, product)=>{
    return new $cc428dbbfea5896a$var$_MetadataClient(apiHostProtocol, apiHost, product);
};

});
parcelRegister("7CePv", function(module, exports) {
$parcel$export(module.exports, "selectHost", () => $04d75f11689c0fa6$export$18c0b81944902eae);
$parcel$export(module.exports, "isStargateProxyPath", () => $04d75f11689c0fa6$export$83a9dd8d74be72c);

var $2tp3i = parcelRequire("2tp3i");
const $04d75f11689c0fa6$var$PROD_HOST = 'as.atlassian.com/api/v1';
const $04d75f11689c0fa6$var$STARGATE_PROD_HOST = 'api-private.atlassian.com/gasv3/api/v1';
const $04d75f11689c0fa6$var$STAGING_HOST = 'as.staging.atl-paas.net/api/v1';
const $04d75f11689c0fa6$var$STARGATE_STAGING_HOST = 'api-private.stg.atlassian.com/gasv3/api/v1';
const $04d75f11689c0fa6$var$FEDRAMP_STAGING_HOST = 'as.staging.atl-paas-us-gov-mod.net/api/v1';
const $04d75f11689c0fa6$var$FEDRAMP_PROD_HOST = 'as.atlassian-us-gov-mod.com/api/v1';
const $04d75f11689c0fa6$var$STARGATE_FEDRAMP_STAGING_HOST = 'api.stg.atlassian-us-gov-mod.com/gasv3/api/v1';
const $04d75f11689c0fa6$var$STARGATE_FEDRAMP_PROD_HOST = 'api.atlassian-us-gov-mod.com/gasv3/api/v1';
const $04d75f11689c0fa6$var$STARGATE_PROXY_PATH = '/gateway/api/gasv3/api/v1';
const $04d75f11689c0fa6$var$handleFedRampModerate = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, envOverride: envOverride })=>{
    if (env === (0, $2tp3i.envType).LOCAL || env === (0, $2tp3i.envType).DEV) throw Error('No LOCAL or DEV environments for FedRAMP.');
    if (env === (0, $2tp3i.envType).PROD && envOverride) throw Error('Cannot override to FedRAMP Sandbox for Prod.');
    if (!useStargate) return env === (0, $2tp3i.envType).PROD ? $04d75f11689c0fa6$var$FEDRAMP_PROD_HOST : $04d75f11689c0fa6$var$FEDRAMP_STAGING_HOST;
    if (useLegacyUrl) return env === (0, $2tp3i.envType).PROD ? $04d75f11689c0fa6$var$STARGATE_FEDRAMP_PROD_HOST : $04d75f11689c0fa6$var$STARGATE_FEDRAMP_STAGING_HOST;
    /**
	 * Stargate proxy path now needs to be the default to work around browser restrictions with cookies.
	 * For more details, see:
	 *  - https://experimentation-platform.atlassian.net/browse/MHD-326, and
	 *  - https://hello.atlassian.net/wiki/spaces/I/pages/1217206437/api-private+is+broken+is+your+product+impacted
	 */ return window.location.host + $04d75f11689c0fa6$var$STARGATE_PROXY_PATH;
};
const $04d75f11689c0fa6$var$handleCommercial = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl })=>{
    if (!useStargate) return env === (0, $2tp3i.envType).PROD ? $04d75f11689c0fa6$var$PROD_HOST : $04d75f11689c0fa6$var$STAGING_HOST;
    if (useLegacyUrl) return env === (0, $2tp3i.envType).PROD ? $04d75f11689c0fa6$var$STARGATE_PROD_HOST : $04d75f11689c0fa6$var$STARGATE_STAGING_HOST;
    /**
	 * Stargate proxy path now needs to be the default to work around browser restrictions with cookies.
	 * For more details, see:
	 *  - https://experimentation-platform.atlassian.net/browse/MHD-326, and
	 *  - https://hello.atlassian.net/wiki/spaces/I/pages/1217206437/api-private+is+broken+is+your+product+impacted
	 */ return window.location.host + $04d75f11689c0fa6$var$STARGATE_PROXY_PATH;
};
function $04d75f11689c0fa6$export$18c0b81944902eae({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, perimeter: perimeter, ic: ic, envOverride: envOverride }) {
    if (ic) {
        if (useLegacyUrl) throw Error('IC is set but useLegacyUrl is true.');
        throw Error('IC is set but no apiHost provided.');
    }
    if (perimeter === (0, $2tp3i.perimeterType).FEDRAMP_MODERATE) return $04d75f11689c0fa6$var$handleFedRampModerate({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl,
        envOverride: envOverride
    });
    return $04d75f11689c0fa6$var$handleCommercial({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl
    });
}
function $04d75f11689c0fa6$export$83a9dd8d74be72c({ apiHost: apiHost }) {
    return apiHost === window.location.host + $04d75f11689c0fa6$var$STARGATE_PROXY_PATH;
}

});

parcelRegister("eI6RR", function(module, exports) {
$parcel$export(module.exports, "TestSupport", () => $b2d150f02dbff2b4$export$44b578549c42d779);
class $b2d150f02dbff2b4$export$44b578549c42d779 {
    static isGeminiVREnvironment() {
        try {
            for(const k in $parcel$global){
                if (k.startsWith('__gemini_') && k.endsWith('__')) return true;
            }
        } catch (e) {
        // ignore
        }
        return false;
    }
    static areMetadataCallsDisabled() {
        return this.areFetchCallsDisabled() || this.getGlobalBooleanProperty($b2d150f02dbff2b4$export$44b578549c42d779.DISABLE_METADATA_CALLS_PROPERTY);
    }
    static areEventCallsDisabled() {
        return this.areFetchCallsDisabled() || this.getGlobalBooleanProperty($b2d150f02dbff2b4$export$44b578549c42d779.DISABLE_EVENT_CALLS_PROPERTY);
    }
    static areFetchCallsDisabled() {
        return this.getGlobalBooleanProperty($b2d150f02dbff2b4$export$44b578549c42d779.DISABLE_FETCH_CALLS_PROPERTY);
    }
    static getSyntheticFlagOverride() {
        return this.getGlobalTriStateProperty($b2d150f02dbff2b4$export$44b578549c42d779.SYNTHETIC_FLAG_OVERRIDE_PROPERTY);
    }
    static getGlobalBooleanProperty(propertyName) {
        if ($parcel$global && $parcel$global.hasOwnProperty(propertyName)) return $parcel$global[propertyName] === true;
        return false;
    }
    static getGlobalTriStateProperty(propertyName) {
        if ($parcel$global && $parcel$global.hasOwnProperty(propertyName)) {
            const value = $parcel$global[propertyName];
            if (typeof value === 'boolean') return value;
        }
        return undefined;
    }
}
$b2d150f02dbff2b4$export$44b578549c42d779.DISABLE_METADATA_CALLS_PROPERTY = '__awc_disable_metadata_calls__';
$b2d150f02dbff2b4$export$44b578549c42d779.DISABLE_EVENT_CALLS_PROPERTY = '__awc_disable_event_calls__';
$b2d150f02dbff2b4$export$44b578549c42d779.DISABLE_FETCH_CALLS_PROPERTY = '__awc_disable_fetch_calls__';
$b2d150f02dbff2b4$export$44b578549c42d779.SYNTHETIC_FLAG_OVERRIDE_PROPERTY = '__awc_synthetic_flag_override__';

});

parcelRegister("6KrpW", function(module, exports) {
$parcel$export(module.exports, "fetchMetadata", () => $c663c0e8b466769a$export$55b0d0261469055);

var $34Zxt = parcelRequire("34Zxt");

var $7SKVk = parcelRequire("7SKVk");
const $c663c0e8b466769a$export$55b0d0261469055 = async (url, params, timeout, signal)=>{
    const requestAbortController = $c663c0e8b466769a$var$createRequestAbortController(timeout, signal);
    const corsOptions = $c663c0e8b466769a$var$getCorsForUrl(url);
    const metadataUrl = url + '?' + new URLSearchParams({
        product: `${params.product}`,
        userId: `${params.userInfo?.userId || ''}`,
        userIdType: `${params.userInfo?.userIdType || ''}`,
        tenantId: `${params.tenantInfo?.tenantId || ''}`,
        tenantIdType: `${params.tenantInfo?.tenantIdType || ''}`
    }).toString();
    const response = await fetch(metadataUrl, {
        method: 'GET',
        signal: requestAbortController.signal,
        ...corsOptions
    });
    // Response must be a 200 (we expect a JSON response, so 204 is not valid for instance)
    if (response.status !== 200) throw new (0, $7SKVk.FetchError)(`Metadata: HTTP Error ${response.status} (${response.statusText})`, response.status, response.statusText);
    return response;
};
const $c663c0e8b466769a$var$createRequestAbortController = (timeout, signal)=>{
    const abortController = new AbortController();
    setTimeout(()=>{
        abortController.abort();
    }, timeout || 30000);
    signal?.addEventListener('abort', ()=>{
        abortController.abort();
    });
    return abortController;
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $c663c0e8b466769a$var$getCorsForUrl = (0, $34Zxt.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});

});


parcelRegister("56ZJB", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4c583091b404ead$export$2e2bcd8739ae039);

var $2tp3i = parcelRequire("2tp3i");

var $hn1K9 = parcelRequire("hn1K9");
class $a4c583091b404ead$export$2e2bcd8739ae039 {
    constructor(){
        this._originStore = void 0;
        this.handleOriginParameters = (originParamHandlerMapping, historyReplaceFn)=>{
            // Collect all the parameter labels to be handled
            const originParamLabelList = Object.keys(originParamHandlerMapping);
            if (!(originParamLabelList.length > 0)) throw new Error('Empty parameter mapping provided');
            // Check if the parameter labels are valid. If any invalid labels are found throw an exception.
            const invalidParams = originParamLabelList.filter((x)=>Object.values((0, $2tp3i.originTracingType)).indexOf(x) < 0);
            if (invalidParams.length > 0) throw new Error(`Invalid Origin Tracing Parameter(s) supplied: ${invalidParams.join()}!`);
            const isCaptureParam = (_, key)=>originParamLabelList.indexOf(key) >= 0;
            // Capture and remove params from URL
            const capturedURLParams = (0, $hn1K9.default)(isCaptureParam, historyReplaceFn);
            // Apply provided handler function to extract origin trace ID from each URL parameter
            const applyHandlerFunction = (key)=>{
                const x = originParamHandlerMapping[key](capturedURLParams[key]);
                return {
                    [key]: x
                };
            };
            const extractedOriginID = Object.keys(capturedURLParams).map(applyHandlerFunction).reduce((accumulator, currentValue)=>Object.assign(accumulator, currentValue), {});
            return extractedOriginID;
        };
        this._originStore = {};
    }
}

});

parcelRegister("b2MkN", function(module, exports) {
$parcel$export(module.exports, "default", () => $24fdd9ddcc5642cc$export$2e2bcd8739ae039);

var $5WZVs = parcelRequire("5WZVs");
// WARNING: The value of SESSION_ID_STORAGE_KEY is relied upon by other Platform packages
// (eg. search-page, product-search-dialog). If you need to change this key, you MUST
// notify the dependant Platform teams and update all dependent packages accordingly.
const $24fdd9ddcc5642cc$var$SESSION_ID_STORAGE_KEY = 'session.id';
const $24fdd9ddcc5642cc$var$SESSION_EXPIRY_STORAGE_KEY = 'session.expiry';
const $24fdd9ddcc5642cc$var$ONLY_NUMBERS_REGEX = /^\d+$/;
const $24fdd9ddcc5642cc$export$285f6bddd927a06d = 1800000; // 30 minutes
const $24fdd9ddcc5642cc$export$a92e915d70316eb2 = 5000; // 5 seconds
const $24fdd9ddcc5642cc$export$de43760b2dc10c19 = 0.9; // 90% of expiry
const $24fdd9ddcc5642cc$export$5702a91a6f42969f = ()=>{};
class $24fdd9ddcc5642cc$export$2e2bcd8739ae039 {
    getCurrentSessionId() {
        const sessionId = this._safeLocalStorage.getItem($24fdd9ddcc5642cc$var$SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this._safeLocalStorage.getItem($24fdd9ddcc5642cc$var$SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
        this._debouncedUpdateSessionExpiry(sessionExpiry);
        if (!sessionId || sessionExpiry <= Date.now() || Number.isNaN(sessionExpiry)) return this._generateNewSessionId();
        // Old versions of sessionId were UUIDs which caused issues for Amplitude which only accepts
        // integers for this field. In these scenarios we want to regenerate the sessionId as an integer
        if (!$24fdd9ddcc5642cc$var$ONLY_NUMBERS_REGEX.test(sessionId)) return this._generateNewSessionId();
        return sessionId;
    }
    constructor(options = {}){
        this._safeLocalStorage = void 0;
        this._sessionExpiryTime = void 0;
        this._sessionExpiryDebounce = void 0;
        this._sessionExpiryDebounceThresholdPercentage = void 0;
        this._sessionExpiryDebounceTimer = void 0;
        this._onNewSessionStarted = void 0;
        this._generateNewSessionId = ()=>{
            const newSessionId = Date.now().toString();
            this._safeLocalStorage.setItem($24fdd9ddcc5642cc$var$SESSION_ID_STORAGE_KEY, newSessionId);
            // COMMENTS-123 - When a new session starts, call the callback if it is given
            this._onNewSessionStarted && this._onNewSessionStarted();
            return newSessionId;
        };
        this._updateSessionExpiry = ()=>{
            const expiry = Date.now() + this._sessionExpiryTime;
            this._safeLocalStorage.setItem($24fdd9ddcc5642cc$var$SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        };
        this._debouncedUpdateSessionExpiry = (currentExpiry)=>{
            const { _updateSessionExpiry: _updateSessionExpiry } = this;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + this._sessionExpiryDebounceThresholdPercentage * this._sessionExpiryTime) _updateSessionExpiry();
            else {
                if (this._sessionExpiryDebounceTimer) clearTimeout(this._sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                this._sessionExpiryDebounceTimer = setTimeout(()=>{
                    _updateSessionExpiry();
                }, this._sessionExpiryDebounce);
            }
        };
        this._sessionExpiryTime = options.sessionExpiryTime || $24fdd9ddcc5642cc$export$285f6bddd927a06d;
        this._sessionExpiryDebounce = options.sessionExpiryDebounce || $24fdd9ddcc5642cc$export$a92e915d70316eb2;
        this._sessionExpiryDebounceThresholdPercentage = options.sessionExpiryDebounceThresholdPercentage || $24fdd9ddcc5642cc$export$de43760b2dc10c19;
        this._onNewSessionStarted = options.onNewSessionStarted ? options.onNewSessionStarted : $24fdd9ddcc5642cc$export$5702a91a6f42969f;
        this._safeLocalStorage = new (0, $5WZVs.default)();
    }
}

});

parcelRegister("fj9wA", function(module, exports) {
$parcel$export(module.exports, "default", () => $183284e7eee2b9df$export$2e2bcd8739ae039);

var $4Evg9 = parcelRequire("4Evg9");

var $a5rIM = parcelRequire("a5rIM");
class $183284e7eee2b9df$export$2e2bcd8739ae039 extends (0, $a5rIM.default) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = window.sessionStorage || (0, $4Evg9.default);
        } catch (err) {
            storageToUse = (0, $4Evg9.default);
        }
        super(storageToUse, options);
    }
}

});

parcelRegister("1hMjq", function(module, exports) {
$parcel$export(module.exports, "default", () => $d9ebc6cc0966af63$export$2e2bcd8739ae039);

var $fj9wA = parcelRequire("fj9wA");
const $d9ebc6cc0966af63$var$STORAGE_KEY = 'tab.id';
class $d9ebc6cc0966af63$export$2e2bcd8739ae039 {
    getCurrentTabId() {
        let tabId = this._safeSessionStorage.getItem($d9ebc6cc0966af63$var$STORAGE_KEY);
        if (!tabId) tabId = this._generateNewTabId();
        return tabId;
    }
    constructor(){
        this._safeSessionStorage = void 0;
        this._generateNewTabId = ()=>{
            const newTabId = crypto.randomUUID();
            this._safeSessionStorage.setItem($d9ebc6cc0966af63$var$STORAGE_KEY, newTabId);
            return newTabId;
        };
        this._safeSessionStorage = new (0, $fj9wA.default)();
    }
}

});

parcelRegister("4hL0X", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4643044f3c67d4f$export$2e2bcd8739ae039);

var $5sXBG = parcelRequire("5sXBG");

var $2tp3i = parcelRequire("2tp3i");

var $5NC0R = parcelRequire("5NC0R");

var $fj9wA = parcelRequire("fj9wA");

var $hn1K9 = parcelRequire("hn1K9");
const $e4643044f3c67d4f$var$STORAGE_KEY = 'taskSessions';
const $e4643044f3c67d4f$var$INIT_KEY = 'taskSessionsInit';
const $e4643044f3c67d4f$var$AWC_PARAM_PREFIX = 'awc.';
const $e4643044f3c67d4f$var$TASK_SESSION_RELOAD_TIME = 3000;
class $e4643044f3c67d4f$export$2e2bcd8739ae039 {
    constructor(){
        this._safeSessionStorage = void 0;
        this._taskSessionsNotRecentlyInitialised = (currentTimestamp)=>this._safeSessionStorage.getItem($e4643044f3c67d4f$var$STORAGE_KEY) === null || this._safeSessionStorage.getItem($e4643044f3c67d4f$var$INIT_KEY) === null || parseInt(this._safeSessionStorage.getItem($e4643044f3c67d4f$var$INIT_KEY) || '0', 10) < currentTimestamp - $e4643044f3c67d4f$var$TASK_SESSION_RELOAD_TIME;
        this._removeTaskSessionPrefix = (_, taskSessionName)=>taskSessionName.split($e4643044f3c67d4f$var$AWC_PARAM_PREFIX)[1];
        this._isTaskSessionQueryParam = (_, taskSessionName)=>taskSessionName.startsWith($e4643044f3c67d4f$var$AWC_PARAM_PREFIX);
        this.getAllTaskSessions = ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($e4643044f3c67d4f$var$STORAGE_KEY) || '');
            } catch (e) {
                return {};
            }
        };
        this._writeToSessionStorage = (taskSessions)=>{
            try {
                this._safeSessionStorage.setItem($e4643044f3c67d4f$var$STORAGE_KEY, JSON.stringify(taskSessions));
            // eslint-disable-next-line no-empty
            } catch (e) {}
        };
        this._appendTaskSessions = (newTaskSessions)=>{
            const currentState = this.getAllTaskSessions();
            const newState = currentState === null ? newTaskSessions : Object.assign(currentState, newTaskSessions);
            this._writeToSessionStorage(newState);
        };
        this._safelyRemoveKey = (currentState, taskSessionName)=>{
            if (currentState === null) return {};
            delete currentState[taskSessionName];
            return currentState;
        };
        this.createTaskSession = (taskSessionName)=>{
            const taskSessionId = crypto.randomUUID();
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
            return taskSessionId;
        };
        this.createTaskSessionWithProvidedId = (taskSessionName, taskSessionId)=>{
            if (typeof taskSessionId !== 'string') throw new TypeError('invalid taskSessionId, must be string');
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
        };
        this.completeTaskSession = (taskSessionName)=>{
            const currentState = this.getAllTaskSessions();
            const updatedState = this._safelyRemoveKey(currentState, taskSessionName);
            this._writeToSessionStorage(updatedState);
        };
        this.formatTaskSessionQueryString = ({ uri: uri, includedTaskSessions: includedTaskSessions })=>{
            const { url: url, query: query } = (0, $5sXBG.parseUrl)(uri);
            const currentState = this.getAllTaskSessions();
            // Use specified task sessions, otherwise all tasksessions excluding originTracing sessions
            const filteredTaskSessions = includedTaskSessions ? (0, $5NC0R.pick)(currentState, includedTaskSessions) : (0, $5NC0R.omit)(currentState, Object.values((0, $2tp3i.originTracingType)));
            if (Object.keys(filteredTaskSessions).length === 0) return uri;
            const queryWithTaskSessions = {
                ...(0, $5NC0R.mapKeys)(filteredTaskSessions, (_, taskSessionName)=>$e4643044f3c67d4f$var$AWC_PARAM_PREFIX + taskSessionName),
                ...query
            };
            return `${url}?${(0, $5sXBG.stringify)(queryWithTaskSessions)}`;
        };
        this.stripQueryParameters = ()=>{
            const extractedTaskSessions = (0, $5NC0R.mapKeys)((0, $hn1K9.default)(this._isTaskSessionQueryParam), this._removeTaskSessionPrefix);
            this._appendTaskSessions(extractedTaskSessions);
        };
        const _currentTimestamp = Date.now();
        this._safeSessionStorage = new (0, $fj9wA.default)();
        // Wrapping all sessionStorage calls in try catch to stop any error propogation, taskSessions should gracefully fail.
        try {
            if (this._taskSessionsNotRecentlyInitialised(_currentTimestamp)) {
                this._writeToSessionStorage({});
                this._safeSessionStorage.setItem($e4643044f3c67d4f$var$INIT_KEY, _currentTimestamp.toString());
            }
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}

});

parcelRegister("1ecJa", function(module, exports) {
$parcel$export(module.exports, "default", () => $b7a3f531477f3224$export$2e2bcd8739ae039);

var $ePB4t = parcelRequire("ePB4t");

var $84Yyr = parcelRequire("84Yyr");

var $eI6RR = parcelRequire("eI6RR");
const $b7a3f531477f3224$var$MAX_CACHE_SIZE = 100;
const $b7a3f531477f3224$var$COOKIE_NAME = (0, $84Yyr.AllAnalyticsCookies).AWC_ANALYTICS_DEBUG.getKey();
const $b7a3f531477f3224$var$DEBUG_TAG = 'synthetic';
class $b7a3f531477f3224$var$TestingCache {
    saveEvent(event) {
        try {
            if (!event) return;
            this.bind();
            this.addSyntheticTag(event);
            this.cache(event);
        } catch  {
        // Ignore errors from testing cache.
        }
    }
    bind() {
        if (!this.shouldCacheEvent() || typeof window === 'undefined' || window.testAnalytics) return;
        window.testAnalytics = {
            eventCache: [],
            events: ()=>window.testAnalytics.eventCache,
            clear: ()=>{
                window.testAnalytics.eventCache = [];
                try {
                    localStorage.removeItem('awc.ui.viewed.last.sent');
                    localStorage.removeItem('awc-staging.ui.viewed.last.sent');
                    localStorage.removeItem('awc-dev.ui.viewed.last.sent');
                    localStorage.removeItem('awc-local.ui.viewed.last.sent');
                } catch  {
                // Ignore errors from localStorage.
                }
            }
        };
    }
    cache(event) {
        if (!this.shouldCacheEvent() || typeof window === 'undefined' || !window.testAnalytics) return;
        if (window.testAnalytics.eventCache.length >= $b7a3f531477f3224$var$MAX_CACHE_SIZE) window.testAnalytics.eventCache = window.testAnalytics.eventCache.slice(1, window.testAnalytics.eventCache.length);
        window.testAnalytics.eventCache.push(event);
    }
    addSyntheticTag(event) {
        if (!this.shouldSetSyntheticFlag()) return;
        if (event.tags instanceof Array) {
            if (!event.tags.includes($b7a3f531477f3224$var$DEBUG_TAG)) event.tags.push($b7a3f531477f3224$var$DEBUG_TAG);
        } else event.tags = [
            $b7a3f531477f3224$var$DEBUG_TAG
        ];
    }
    shouldCacheEvent() {
        return this._enableTestingCache ? this._enableTestingCache : this._isDebugCookieEnabled;
    }
    shouldSetSyntheticFlag() {
        if (this._syntheticFlagOverride !== undefined) return this._syntheticFlagOverride;
        const globalSyntheticOverride = (0, $eI6RR.TestSupport).getSyntheticFlagOverride();
        if (globalSyntheticOverride !== undefined) return globalSyntheticOverride;
        return this.shouldCacheEvent();
    }
    static getDebugCookie() {
        try {
            return JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($ePB4t))).get($b7a3f531477f3224$var$COOKIE_NAME) || 'false') === true;
        } catch  {
            (0, (/*@__PURE__*/$parcel$interopDefault($ePB4t))).remove($b7a3f531477f3224$var$COOKIE_NAME);
        }
        return false;
    }
    constructor(syntheticFlagOverride, enableTestingCache){
        this._isDebugCookieEnabled = void 0;
        this._syntheticFlagOverride = void 0;
        this._enableTestingCache = void 0;
        this._syntheticFlagOverride = typeof syntheticFlagOverride === 'boolean' ? syntheticFlagOverride : undefined;
        this._enableTestingCache = typeof enableTestingCache === 'boolean' ? enableTestingCache : undefined;
        this._isDebugCookieEnabled = $b7a3f531477f3224$var$TestingCache.getDebugCookie();
        this.bind();
    }
}
var $b7a3f531477f3224$export$2e2bcd8739ae039 = $b7a3f531477f3224$var$TestingCache;

});

parcelRegister("fSWe2", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a41f57d4c415417$export$2e2bcd8739ae039);

var $2tp3i = parcelRequire("2tp3i");

var $8FhO2 = parcelRequire("8FhO2");

var $5WZVs = parcelRequire("5WZVs");
const $3a41f57d4c415417$var$DEFAULT_DELAY = 2000; // 2 seconds
const $3a41f57d4c415417$var$DEFAULT_THROTTLE = 3600000; // 1 hour
const $3a41f57d4c415417$var$DEFAULT_STORAGE_KEY = 'ui.viewed.last.sent';
const $3a41f57d4c415417$var$DEFAULT_MALFORMED_UIVIEWED_EVENT = 'malformed.uiviewed.last.sent';
class $3a41f57d4c415417$export$2e2bcd8739ae039 {
    constructor(productInfo, getContext, onEvent, settings = {}){
        this._blurListener = void 0;
        this._delay = void 0;
        this._focusListener = void 0;
        this._getContext = void 0;
        this._intervalId = void 0;
        this._onEvent = void 0;
        this._product = void 0;
        this._productInfo = void 0;
        this._safeLocalStorage = void 0;
        this._storageKey = void 0;
        this._malformedEventStorageKey = void 0;
        this._throttle = void 0;
        this.start = ()=>{
            this._startInterval();
            this._bindEventListeners();
        };
        this.stop = ()=>{
            this._stopInterval();
            this._unbindEventListeners();
        };
        this.resetTimers = ()=>{
            if (this._intervalId) {
                this.stop();
                this.start();
            }
        };
        this._bindEventListeners = ()=>{
            if (typeof window !== 'undefined') {
                window.addEventListener('focus', this._focusListener);
                window.addEventListener('blur', this._blurListener);
            }
        };
        this._unbindEventListeners = ()=>{
            if (typeof window !== 'undefined') {
                window.removeEventListener('focus', this._focusListener);
                window.removeEventListener('blur', this._blurListener);
            }
        };
        this._startInterval = ()=>{
            clearInterval(this._intervalId);
            this._intervalId = setInterval(this._handleInterval, this._delay);
        };
        this._stopInterval = ()=>{
            if (this._intervalId) {
                clearInterval(this._intervalId);
                this._intervalId = null;
            }
        };
        this._getProductKey = (product, subproduct)=>{
            let productKey = product;
            if (subproduct) productKey += `-${subproduct}`;
            return productKey;
        };
        this._getLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._storageKey) || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            const p = t[productKey] || null;
            return p;
        };
        this._parseLocalStorageData = (key)=>{
            const data = this._safeLocalStorage.getItem(key);
            try {
                return JSON.parse(data || '');
            } catch (error) {
                this._safeLocalStorage.removeItem(key);
                return null;
            }
        };
        this._getMalformedLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._malformedEventStorageKey) || {};
            const finalUserId = userId || 'NOT_SET';
            const finalTenantId = tenantId || 'NOT_SET';
            const u = json[finalUserId] || {};
            const t = u[finalTenantId] || {};
            const p = t[productKey] || null;
            return p;
        };
        this._setLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._storageKey) || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            t[productKey] = Date.now();
            u[tenantId] = t;
            json[userId] = u;
            this._safeLocalStorage.setItem(this._storageKey, JSON.stringify(json));
        };
        this._setMalformedLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._malformedEventStorageKey) || {};
            const finalUserId = userId || 'NOT_SET';
            const finalTenantId = tenantId || 'NOT_SET';
            const u = json[finalUserId] || {};
            const t = u[finalTenantId] || {};
            t[productKey] = Date.now();
            u[finalTenantId] = t;
            json[finalUserId] = u;
            this._safeLocalStorage.setItem(this._malformedEventStorageKey, JSON.stringify(json));
        };
        this._shouldSendEvent = (productKey, tenantIdType, tenantId, userId)=>{
            const document = (0, $8FhO2.getDocument)();
            if (document && !document.hasFocus()) return 'FocusLost';
            // TENANT OR USER ID NOT SET
            if (tenantIdType !== (0, $2tp3i.tenantType).NONE && !tenantId || !userId) {
                const sinceLastSent = Date.now() - this._getMalformedLastSentTimestamp(productKey, tenantId, userId);
                if (sinceLastSent === null || sinceLastSent > this._throttle) return 'UserOrTenantIncomplete';
                return 'MalformedUiViewedRateLimited';
            }
            const sinceLastSent = Date.now() - this._getLastSentTimestamp(productKey, tenantId, userId);
            if (sinceLastSent === null || sinceLastSent > this._throttle) return 'EligibleToSend';
            return 'UiViewedRateLimited';
        };
        this._handleInterval = ()=>{
            const { embeddedProduct: embeddedProduct, ...context } = this._getContext();
            this._sendEvent(this._product, context);
            if (embeddedProduct) this._sendEvent(embeddedProduct, context, true);
        };
        this._sendEvent = (product, context, isEmbeddedProduct = false)=>{
            const { subproduct: subproduct, tenantIdType: tenantIdType, tenantId: tenantId, userId: userId, lastScreenEvent: lastScreenEvent, attributes: attributes } = context;
            const productKey = this._getProductKey(product, subproduct);
            const shouldSendEventTriggerStatus = this._shouldSendEvent(productKey, tenantIdType, tenantId, userId);
            switch(shouldSendEventTriggerStatus){
                case 'EligibleToSend':
                    this._setLastSentTimestamp(productKey, tenantId, userId);
                    this._onEvent(this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes, 'ui', 'viewed'));
                    break;
                case 'UserOrTenantIncomplete':
                    this._setMalformedLastSentTimestamp(productKey, tenantId, userId);
                    this._onEvent(this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes, 'malformed', 'uiviewed'));
                    break;
                default:
                    break;
            }
        };
        this._createEvent = (product, subproduct, isEmbeddedProduct, lastScreenEvent, extraAttributes, actionSubject, action)=>{
            const event = {
                product: product,
                source: 'ui',
                action: action,
                actionSubject: actionSubject,
                attributes: extraAttributes
            };
            if (isEmbeddedProduct) {
                // Clear the subproduct and version as they don't relate to the embedded product
                event.subproduct = null;
                event.version = null;
                event.attributes = {
                    ...event.attributes,
                    embeddedInEnv: this._productInfo.env,
                    embeddedInProduct: this._productInfo.product,
                    embeddedInSubproduct: subproduct,
                    embeddedInVersion: this._productInfo.version,
                    embeddedInOrigin: this._productInfo.origin,
                    embeddedInPlatform: this._productInfo.platform
                };
            }
            if (lastScreenEvent) event.attributes = {
                ...event.attributes,
                lastScreenEvent: {
                    name: lastScreenEvent.name,
                    attributes: lastScreenEvent.attributes
                }
            };
            return event;
        };
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!getContext) throw new Error('Missing getContext callback');
        if (typeof getContext !== 'function') throw new Error('Invalid getContext, must be function');
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        this._productInfo = productInfo;
        this._product = productInfo.product;
        this._getContext = getContext;
        this._onEvent = onEvent;
        this._delay = settings.delay || $3a41f57d4c415417$var$DEFAULT_DELAY;
        this._throttle = settings.throttle || $3a41f57d4c415417$var$DEFAULT_THROTTLE;
        this._storageKey = settings.storageKey || $3a41f57d4c415417$var$DEFAULT_STORAGE_KEY;
        this._malformedEventStorageKey = settings.malformedStorageKey || $3a41f57d4c415417$var$DEFAULT_MALFORMED_UIVIEWED_EVENT;
        this._safeLocalStorage = new (0, $5WZVs.default)({
            envPrefix: this._productInfo.env
        });
        this._focusListener = ()=>{
            this._startInterval();
        };
        this._blurListener = ()=>{
            this._stopInterval();
        };
    }
}

});
parcelRegister("8FhO2", function(module, exports) {
$parcel$export(module.exports, "getDocument", () => $ead0940e7642e9b6$export$f65ca476c09acec0);
const $ead0940e7642e9b6$export$f65ca476c09acec0 = ()=>{
    if (typeof document !== 'undefined') return document;
    return null;
};

});


parcelRegister("1XWT7", function(module, exports) {
$parcel$export(module.exports, "default", () => $eec16277a09dcc47$export$2e2bcd8739ae039);
function $eec16277a09dcc47$export$2e2bcd8739ae039(callback, event) {
    if (!callback || typeof callback !== 'function') return null;
    return ()=>{
        callback(event);
    };
}

});

parcelRegister("cwOIC", function(module, exports) {
$parcel$export(module.exports, "XIDPromise", () => $1d8b9985caa2a9a7$export$fbe53bbbe682bcdd);

var $4TPsI = parcelRequire("4TPsI");
const $1d8b9985caa2a9a7$export$fbe53bbbe682bcdd = (xidConsent, xidPromiseFn)=>{
    if (xidConsent && xidPromiseFn && typeof xidPromiseFn === 'function') {
        const timeoutPromise = ()=>{
            return new Promise((resolve)=>{
                setTimeout(()=>resolve(()=>(0, $4TPsI.createTimeoutXid)()), (0, $4TPsI.XID_TIMEOUT));
            });
        };
        const xidPromise = ()=>{
            return xidPromiseFn().catch(()=>()=>(0, $4TPsI.createUnknownXid)());
        };
        return Promise.race([
            xidPromise(),
            timeoutPromise()
        ]);
    }
    return undefined;
};

});
parcelRegister("4TPsI", function(module, exports) {
$parcel$export(module.exports, "XID_TIMEOUT", () => $0e585963162336ed$export$545bcbd53afabfa3);
$parcel$export(module.exports, "createTimeoutXid", () => $0e585963162336ed$export$af4087e36d63846);
$parcel$export(module.exports, "createUnknownXid", () => $0e585963162336ed$export$fa341d0c750d705b);

var $6GDHE = parcelRequire("6GDHE");
const $0e585963162336ed$export$545bcbd53afabfa3 = 5000;
const $0e585963162336ed$export$af4087e36d63846 = ()=>[
        {
            type: (0, $6GDHE.XIDItemType).XC,
            state: 'TIMEOUT'
        },
        {
            type: (0, $6GDHE.XIDItemType).UID,
            state: 'TIMEOUT'
        }
    ];
const $0e585963162336ed$export$fa341d0c750d705b = ()=>[
        {
            type: (0, $6GDHE.XIDItemType).XC,
            state: 'UNKNOWN'
        },
        {
            type: (0, $6GDHE.XIDItemType).UID,
            state: 'UNKNOWN'
        }
    ];

});
parcelRegister("6GDHE", function(module, exports) {
$parcel$export(module.exports, "XIDItemType", () => $103859791cb1f479$export$92ca0438bcb0d396);
var $103859791cb1f479$export$92ca0438bcb0d396 = /*#__PURE__*/ function(XIDItemType) {
    XIDItemType["XC"] = "xc";
    XIDItemType["UID"] = "uid";
    return XIDItemType;
}({});
var $103859791cb1f479$export$c9079017d1f5aab9 = /*#__PURE__*/ function(XIDState) {
    XIDState["NEW"] = "NEW";
    XIDState["CHANGED"] = "CHANGED";
    XIDState["EXISTING"] = "EXISTING";
    XIDState["TIMEOUT"] = "TIMEOUT";
    XIDState["ERROR"] = "ERROR";
    XIDState["UNAVAILABLE"] = "UNAVAILABLE";
    XIDState["MALFORMED"] = "MALFORMED";
    XIDState["UNKNOWN"] = "UNKNOWN";
    return XIDState;
}({});

});




parcelRegister("9pfwj", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $jcj59 = parcelRequire("jcj59");

var $f5FWH = parcelRequire("f5FWH");
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, // RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
delims = [
    '<',
    '>',
    '"',
    '`',
    ' ',
    '\r',
    '\n',
    '\t'
], // RFC 2396: characters not allowed for various reasons.
unwise = [
    '{',
    '}',
    '|',
    '\\',
    '^',
    '`'
].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = [
    '\''
].concat(unwise), // Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
nonHostChars = [
    '%',
    '/',
    '?',
    ';',
    '#'
].concat(autoEscape), hostEndingChars = [
    '/',
    '?',
    '#'
], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
    'javascript': true,
    'javascript:': true
}, // protocols that never have a hostname.
hostlessProtocol = {
    'javascript': true,
    'javascript:': true
}, // protocols that always contain a // bit.
slashedProtocol = {
    'http': true,
    'https': true,
    'ftp': true,
    'gopher': true,
    'file': true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
};

var $hENQL = parcelRequire("hENQL");
function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && $f5FWH.isObject(url) && url instanceof Url) return url;
    var u = new Url;
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (!$f5FWH.isString(url)) throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    // Copy chrome, IE, opera backslash-handling behavior.
    // Back slashes before the query string get converted to forward slashes
    // See: https://code.google.com/p/chromium/issues/detail?id=25916
    var queryIndex = url.indexOf('?'), splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#', uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, '/');
    url = uSplit.join(splitter);
    var rest = url;
    // trim before proceeding.
    // This is to support parse stuff like "  http://foo.com  \n"
    rest = rest.trim();
    if (!slashesDenoteHost && url.split('#').length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = $hENQL.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = '';
                this.query = {};
            }
            return this;
        }
    }
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    // figure out if it's got a host
    // user@server is *always* interpreted as a hostname, and url
    // resolution will treat //foo/bar as host=foo,path=bar because that's
    // how the browser resolves relative URLs.
    if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        var slashes = rest.substr(0, 2) === '//';
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c
        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.
        // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < hostEndingChars.length; i++){
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf('@');
        else // atSign must be in auth portion.
        // http://a@b/c@d => host:b auth:a path:/c@d
        atSign = rest.lastIndexOf('@', hostEnd);
        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < nonHostChars.length; i++){
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        this.hostname = this.hostname || '';
        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = '';
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                    // we need this to make sure size of hostname is not
                    // broken by replacing non-ASCII by nothing
                    newpart += 'x';
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = '/' + notHost.join('.') + rest;
                        this.hostname = validParts.join('.');
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = '';
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) // IDNA Support: Returns a punycoded representation of "domain".
        // It only converts parts of the domain name that
        // have non-ASCII characters, i.e. it doesn't matter if
        // you call it with a domain that already is ASCII-only.
        this.hostname = $jcj59.toASCII(this.hostname);
        var p = this.port ? ':' + this.port : '';
        var h = this.hostname || '';
        this.host = h + p;
        this.href += this.host;
        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== '/') rest = '/' + rest;
        }
    }
    // now rest is set to the post-host stuff.
    // chop off any delim chars.
    if (!unsafeProtocol[lowerProto]) // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for(var i = 0, l = autoEscape.length; i < l; i++){
        var ae = autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf('#');
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf('?');
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = $hENQL.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = '';
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = '/';
    //to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || '';
        var s = this.search || '';
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    // ensure it's an object, and not a string url.
    // If it's an obj, this is a no-op.
    // this way, you can call url_format() on strings
    // to clean up potentially wonky urls.
    if ($f5FWH.isString(obj)) obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function() {
    var auth = this.auth || '';
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ':');
        auth += '@';
    }
    var protocol = this.protocol || '', pathname = this.pathname || '', hash = this.hash || '', host = false, query = '';
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
        if (this.port) host += ':' + this.port;
    }
    if (this.query && $f5FWH.isObject(this.query) && Object.keys(this.query).length) query = $hENQL.stringify(this.query);
    var search = this.search || query && '?' + query || '';
    if (protocol && protocol.substr(-1) !== ':') protocol += ':';
    // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
    // unless they had them to begin with.
    if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = '//' + (host || '');
        if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
    } else if (!host) host = '';
    if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
    if (search && search.charAt(0) !== '?') search = '?' + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace('#', '%23');
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function(relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function(relative) {
    if ($f5FWH.isString(relative)) {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    // hash is always overridden, no matter what.
    // even href="" will remove it.
    result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === '') {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== 'protocol') result[rkey] = relative[rkey];
        }
        //urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) result.path = result.pathname = '/';
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        // if it's a known url protocol, then changing
        // the protocol does weird things
        // first, if it's not file:, then we MUST have a host,
        // and if there was a path
        // to begin with, then we MUST have a path.
        // if it is file:, then the host is dropped,
        // because that's known to be hostless.
        // anything else is assumed to be absolute.
        if (!slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || '').split('/');
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = '';
            if (!relative.hostname) relative.hostname = '';
            if (relPath[0] !== '') relPath.unshift('');
            if (relPath.length < 2) relPath.unshift('');
            result.pathname = relPath.join('/');
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || '';
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || '';
            var s = result.search || '';
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/', isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/', mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split('/') || [], relPath = relative.pathname && relative.pathname.split('/') || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    // if the url is a non-slashed url, then relative
    // links like ../.. should be able
    // to crawl up to the hostname, as well.  This is strange.
    // result.protocol has already been set by now.
    // Later on, put the first path part into the host field.
    if (psychotic) {
        result.hostname = '';
        result.port = null;
        if (result.host) {
            if (srcPath[0] === '') srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = '';
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === '') relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === '' ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        // it's relative
        // throw away the existing file, and take the new path instead.
        if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (!$f5FWH.isNullOrUndefined(relative.search)) {
        // just pull out the search.
        // like href='?foo'.
        // Put this after the other two cases because it simplifies the booleans
        if (psychotic) {
            result.hostname = result.host = srcPath.shift();
            //occationaly the auth can get stuck only in host
            //this especially happens in cases like
            //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
            var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.host = result.hostname = authInHost.shift();
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        //to support http.request
        if (!$f5FWH.isNull(result.pathname) || !$f5FWH.isNull(result.search)) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        // no path at all.  easy.
        // we've already handled the other stuff above.
        result.pathname = null;
        //to support http.request
        if (result.search) result.path = '/' + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    // if a url ENDs in . or .., then it must get a trailing slash.
    // however, if it ends in anything else non-slashy,
    // then it must NOT get a trailing slash.
    var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';
    // strip single dots, resolve double dots to parent dir
    // if the path tries to go above the root, `up` ends up > 0
    var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === '.') srcPath.splice(i, 1);
        else if (last === '..') {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift('..');
    if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) srcPath.unshift('');
    if (hasTrailingSlash && srcPath.join('/').substr(-1) !== '/') srcPath.push('');
    var isAbsolute = srcPath[0] === '' || srcPath[0] && srcPath[0].charAt(0) === '/';
    // put the host back
    if (psychotic) {
        result.hostname = result.host = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
        //occationaly the auth can get stuck only in host
        //this especially happens in cases like
        //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
        var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.host = result.hostname = authInHost.shift();
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift('');
    if (!srcPath.length) {
        result.pathname = null;
        result.path = null;
    } else result.pathname = srcPath.join('/');
    //to support request.http
    if (!$f5FWH.isNull(result.pathname) || !$f5FWH.isNull(result.search)) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function() {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ':') this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};

});
parcelRegister("jcj59", function(module, exports) {
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == 'object' && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = '-', /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        'overflow': 'Overflow: input needs wider integers to process',
        'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
        'invalid-input': 'Invalid input'
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split('@');
        var result = '';
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + '@';
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, '\x2E');
        var labels = string.split('.');
        var encoded = map(labels, fn).join('.');
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = '';
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join('');
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * http://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error('not-basic');
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error('invalid-input');
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error('overflow');
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error('overflow');
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error('overflow');
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error('overflow');
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error('overflow');
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join('');
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ 'version': '1.3.2',
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ 'ucs2': {
            'decode': ucs2decode,
            'encode': ucs2encode
        },
        'decode': decode,
        'encode': encode,
        'toASCII': toASCII,
        'toUnicode': toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) define('punycode', function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) freeModule.exports = punycode;
        else for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else root.punycode = punycode;
})(this);

});

parcelRegister("f5FWH", function(module, exports) {
'use strict';
module.exports = {
    isString: function(arg) {
        return typeof arg === 'string';
    },
    isObject: function(arg) {
        return typeof arg === 'object' && arg !== null;
    },
    isNull: function(arg) {
        return arg === null;
    },
    isNullOrUndefined: function(arg) {
        return arg == null;
    }
};

});

parcelRegister("hENQL", function(module, exports) {
$parcel$export(module.exports, "parse", () => $cdacd740f0687005$export$98e6a39c04603d36, (v) => $cdacd740f0687005$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $cdacd740f0687005$export$fac44ee5b035f737, (v) => $cdacd740f0687005$export$fac44ee5b035f737 = v);
var $cdacd740f0687005$export$2f872c0f2117be69;
var $cdacd740f0687005$export$98e6a39c04603d36;
var $cdacd740f0687005$export$c564cdbbe6da493;
var $cdacd740f0687005$export$fac44ee5b035f737;
'use strict';

$cdacd740f0687005$export$2f872c0f2117be69 = $cdacd740f0687005$export$98e6a39c04603d36 = (parcelRequire("bRf97"));

$cdacd740f0687005$export$c564cdbbe6da493 = $cdacd740f0687005$export$fac44ee5b035f737 = (parcelRequire("9b15B"));

});
parcelRegister("bRf97", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function $8a2064a7b9e4b7bf$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
module.exports = function(qs, sep, eq, options) {
    sep = sep || '&';
    eq = eq || '=';
    var obj = {};
    if (typeof qs !== 'string' || qs.length === 0) return obj;
    var regexp = /\+/g;
    qs = qs.split(sep);
    var maxKeys = 1000;
    if (options && typeof options.maxKeys === 'number') maxKeys = options.maxKeys;
    var len = qs.length;
    // maxKeys <= 0 means that we should not limit keys count
    if (maxKeys > 0 && len > maxKeys) len = maxKeys;
    for(var i = 0; i < len; ++i){
        var x = qs[i].replace(regexp, '%20'), idx = x.indexOf(eq), kstr, vstr, k, v;
        if (idx >= 0) {
            kstr = x.substr(0, idx);
            vstr = x.substr(idx + 1);
        } else {
            kstr = x;
            vstr = '';
        }
        k = decodeURIComponent(kstr);
        v = decodeURIComponent(vstr);
        if (!$8a2064a7b9e4b7bf$var$hasOwnProperty(obj, k)) obj[k] = v;
        else if ($8a2064a7b9e4b7bf$var$isArray(obj[k])) obj[k].push(v);
        else obj[k] = [
            obj[k],
            v
        ];
    }
    return obj;
};
var $8a2064a7b9e4b7bf$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};

});

parcelRegister("9b15B", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $6ae5fc7142eb1d70$var$stringifyPrimitive = function(v) {
    switch(typeof v){
        case 'string':
            return v;
        case 'boolean':
            return v ? 'true' : 'false';
        case 'number':
            return isFinite(v) ? v : '';
        default:
            return '';
    }
};
module.exports = function(obj, sep, eq, name) {
    sep = sep || '&';
    eq = eq || '=';
    if (obj === null) obj = undefined;
    if (typeof obj === 'object') return $6ae5fc7142eb1d70$var$map($6ae5fc7142eb1d70$var$objectKeys(obj), function(k) {
        var ks = encodeURIComponent($6ae5fc7142eb1d70$var$stringifyPrimitive(k)) + eq;
        if ($6ae5fc7142eb1d70$var$isArray(obj[k])) return $6ae5fc7142eb1d70$var$map(obj[k], function(v) {
            return ks + encodeURIComponent($6ae5fc7142eb1d70$var$stringifyPrimitive(v));
        }).join(sep);
        else return ks + encodeURIComponent($6ae5fc7142eb1d70$var$stringifyPrimitive(obj[k]));
    }).join(sep);
    if (!name) return '';
    return encodeURIComponent($6ae5fc7142eb1d70$var$stringifyPrimitive(name)) + eq + encodeURIComponent($6ae5fc7142eb1d70$var$stringifyPrimitive(obj));
};
var $6ae5fc7142eb1d70$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};
function $6ae5fc7142eb1d70$var$map(xs, f) {
    if (xs.map) return xs.map(f);
    var res = [];
    for(var i = 0; i < xs.length; i++)res.push(f(xs[i], i));
    return res;
}
var $6ae5fc7142eb1d70$var$objectKeys = Object.keys || function(obj) {
    var res = [];
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
    return res;
};

});



parcelRegister("9A5g8", function(module, exports) {
$parcel$export(module.exports, "useSyncExternalStore", () => $6f9b8e3ec3635845$export$306c0aa65ff9ec16, (v) => $6f9b8e3ec3635845$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6f9b8e3ec3635845$export$306c0aa65ff9ec16;
"use strict";

var $gqzfn = parcelRequire("gqzfn");
function $6f9b8e3ec3635845$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $6f9b8e3ec3635845$var$objectIs = "function" === typeof Object.is ? Object.is : $6f9b8e3ec3635845$var$is, $6f9b8e3ec3635845$var$useState = $gqzfn.useState, $6f9b8e3ec3635845$var$useEffect = $gqzfn.useEffect, $6f9b8e3ec3635845$var$useLayoutEffect = $gqzfn.useLayoutEffect, $6f9b8e3ec3635845$var$useDebugValue = $gqzfn.useDebugValue;
function $6f9b8e3ec3635845$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $6f9b8e3ec3635845$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $6f9b8e3ec3635845$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $6f9b8e3ec3635845$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $6f9b8e3ec3635845$var$useEffect(function() {
        $6f9b8e3ec3635845$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $6f9b8e3ec3635845$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $6f9b8e3ec3635845$var$useDebugValue(value);
    return value;
}
function $6f9b8e3ec3635845$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$6f9b8e3ec3635845$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $6f9b8e3ec3635845$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $6f9b8e3ec3635845$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $6f9b8e3ec3635845$var$useSyncExternalStore$1 : $6f9b8e3ec3635845$var$useSyncExternalStore$2;
$6f9b8e3ec3635845$export$306c0aa65ff9ec16 = void 0 !== $gqzfn.useSyncExternalStore ? $gqzfn.useSyncExternalStore : $6f9b8e3ec3635845$var$shim;

});

parcelRegister("eWvdU", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $jXax9 = parcelRequire("jXax9");
function $ae0eb3c208372f9d$var$emptyFunction() {}
function $ae0eb3c208372f9d$var$emptyFunctionWithReset() {}
$ae0eb3c208372f9d$var$emptyFunctionWithReset.resetWarningCache = $ae0eb3c208372f9d$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $jXax9) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $ae0eb3c208372f9d$var$emptyFunctionWithReset,
        resetWarningCache: $ae0eb3c208372f9d$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("jXax9", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $e86bb2c856f92391$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $e86bb2c856f92391$var$ReactPropTypesSecret;

});


parcelRegister("bcu32", function(module, exports) {
$parcel$export(module.exports, "AsyncMode", () => $82781f99f4988560$export$2b8d127b894957b9, (v) => $82781f99f4988560$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $82781f99f4988560$export$cea3a54a6425200c, (v) => $82781f99f4988560$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $82781f99f4988560$export$a7c73072b1a182ae, (v) => $82781f99f4988560$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $82781f99f4988560$export$9f27bc3417b4524d, (v) => $82781f99f4988560$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $82781f99f4988560$export$db77ccec0bb4ccac, (v) => $82781f99f4988560$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $82781f99f4988560$export$8392c0c9d3dcbd35, (v) => $82781f99f4988560$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $82781f99f4988560$export$ffb0004e005737fa, (v) => $82781f99f4988560$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $82781f99f4988560$export$b624eff549462981, (v) => $82781f99f4988560$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $82781f99f4988560$export$7897aa7841a5380c, (v) => $82781f99f4988560$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $82781f99f4988560$export$602eac185826482c, (v) => $82781f99f4988560$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $82781f99f4988560$export$e2c29f18771995cb, (v) => $82781f99f4988560$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $82781f99f4988560$export$5f8d39834fd61797, (v) => $82781f99f4988560$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $82781f99f4988560$export$74bf444e3cd11ea5, (v) => $82781f99f4988560$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $82781f99f4988560$export$92387174baf9b227, (v) => $82781f99f4988560$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $82781f99f4988560$export$ec112efeb987d9c6, (v) => $82781f99f4988560$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $82781f99f4988560$export$b706b080d889d2c9, (v) => $82781f99f4988560$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $82781f99f4988560$export$5be5a87408f70ddc, (v) => $82781f99f4988560$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $82781f99f4988560$export$45a5e7f76e0caa8d, (v) => $82781f99f4988560$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $82781f99f4988560$export$455c2e768291efa6, (v) => $82781f99f4988560$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $82781f99f4988560$export$9522e17588c12572, (v) => $82781f99f4988560$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $82781f99f4988560$export$2110ac352bb060b9, (v) => $82781f99f4988560$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $82781f99f4988560$export$56885ab8b9c456ab, (v) => $82781f99f4988560$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $82781f99f4988560$export$d927fcb6adf8f9de, (v) => $82781f99f4988560$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $82781f99f4988560$export$b82d16f27459e05a, (v) => $82781f99f4988560$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $82781f99f4988560$export$522c17b4f5e123e8, (v) => $82781f99f4988560$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $82781f99f4988560$export$1aabd8a0274ecfd6, (v) => $82781f99f4988560$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $82781f99f4988560$export$9b621391a187a31a, (v) => $82781f99f4988560$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $82781f99f4988560$export$f5bbd400c2f4426f, (v) => $82781f99f4988560$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $82781f99f4988560$export$2b8d127b894957b9;
var $82781f99f4988560$export$cea3a54a6425200c;
var $82781f99f4988560$export$a7c73072b1a182ae;
var $82781f99f4988560$export$9f27bc3417b4524d;
var $82781f99f4988560$export$db77ccec0bb4ccac;
var $82781f99f4988560$export$8392c0c9d3dcbd35;
var $82781f99f4988560$export$ffb0004e005737fa;
var $82781f99f4988560$export$b624eff549462981;
var $82781f99f4988560$export$7897aa7841a5380c;
var $82781f99f4988560$export$602eac185826482c;
var $82781f99f4988560$export$e2c29f18771995cb;
var $82781f99f4988560$export$5f8d39834fd61797;
var $82781f99f4988560$export$74bf444e3cd11ea5;
var $82781f99f4988560$export$92387174baf9b227;
var $82781f99f4988560$export$ec112efeb987d9c6;
var $82781f99f4988560$export$b706b080d889d2c9;
var $82781f99f4988560$export$5be5a87408f70ddc;
var $82781f99f4988560$export$45a5e7f76e0caa8d;
var $82781f99f4988560$export$455c2e768291efa6;
var $82781f99f4988560$export$9522e17588c12572;
var $82781f99f4988560$export$2110ac352bb060b9;
var $82781f99f4988560$export$56885ab8b9c456ab;
var $82781f99f4988560$export$d927fcb6adf8f9de;
var $82781f99f4988560$export$b82d16f27459e05a;
var $82781f99f4988560$export$522c17b4f5e123e8;
var $82781f99f4988560$export$1aabd8a0274ecfd6;
var $82781f99f4988560$export$9b621391a187a31a;
var $82781f99f4988560$export$f5bbd400c2f4426f;
'use strict';
var $82781f99f4988560$var$b = "function" === typeof Symbol && Symbol.for, $82781f99f4988560$var$c = $82781f99f4988560$var$b ? Symbol.for("react.element") : 60103, $82781f99f4988560$var$d = $82781f99f4988560$var$b ? Symbol.for("react.portal") : 60106, $82781f99f4988560$var$e = $82781f99f4988560$var$b ? Symbol.for("react.fragment") : 60107, $82781f99f4988560$var$f = $82781f99f4988560$var$b ? Symbol.for("react.strict_mode") : 60108, $82781f99f4988560$var$g = $82781f99f4988560$var$b ? Symbol.for("react.profiler") : 60114, $82781f99f4988560$var$h = $82781f99f4988560$var$b ? Symbol.for("react.provider") : 60109, $82781f99f4988560$var$k = $82781f99f4988560$var$b ? Symbol.for("react.context") : 60110, $82781f99f4988560$var$l = $82781f99f4988560$var$b ? Symbol.for("react.async_mode") : 60111, $82781f99f4988560$var$m = $82781f99f4988560$var$b ? Symbol.for("react.concurrent_mode") : 60111, $82781f99f4988560$var$n = $82781f99f4988560$var$b ? Symbol.for("react.forward_ref") : 60112, $82781f99f4988560$var$p = $82781f99f4988560$var$b ? Symbol.for("react.suspense") : 60113, $82781f99f4988560$var$q = $82781f99f4988560$var$b ? Symbol.for("react.suspense_list") : 60120, $82781f99f4988560$var$r = $82781f99f4988560$var$b ? Symbol.for("react.memo") : 60115, $82781f99f4988560$var$t = $82781f99f4988560$var$b ? Symbol.for("react.lazy") : 60116, $82781f99f4988560$var$v = $82781f99f4988560$var$b ? Symbol.for("react.block") : 60121, $82781f99f4988560$var$w = $82781f99f4988560$var$b ? Symbol.for("react.fundamental") : 60117, $82781f99f4988560$var$x = $82781f99f4988560$var$b ? Symbol.for("react.responder") : 60118, $82781f99f4988560$var$y = $82781f99f4988560$var$b ? Symbol.for("react.scope") : 60119;
function $82781f99f4988560$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $82781f99f4988560$var$c:
                switch(a = a.type, a){
                    case $82781f99f4988560$var$l:
                    case $82781f99f4988560$var$m:
                    case $82781f99f4988560$var$e:
                    case $82781f99f4988560$var$g:
                    case $82781f99f4988560$var$f:
                    case $82781f99f4988560$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $82781f99f4988560$var$k:
                            case $82781f99f4988560$var$n:
                            case $82781f99f4988560$var$t:
                            case $82781f99f4988560$var$r:
                            case $82781f99f4988560$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $82781f99f4988560$var$d:
                return u;
        }
    }
}
function $82781f99f4988560$var$A(a) {
    return $82781f99f4988560$var$z(a) === $82781f99f4988560$var$m;
}
$82781f99f4988560$export$2b8d127b894957b9 = $82781f99f4988560$var$l;
$82781f99f4988560$export$cea3a54a6425200c = $82781f99f4988560$var$m;
$82781f99f4988560$export$a7c73072b1a182ae = $82781f99f4988560$var$k;
$82781f99f4988560$export$9f27bc3417b4524d = $82781f99f4988560$var$h;
$82781f99f4988560$export$db77ccec0bb4ccac = $82781f99f4988560$var$c;
$82781f99f4988560$export$8392c0c9d3dcbd35 = $82781f99f4988560$var$n;
$82781f99f4988560$export$ffb0004e005737fa = $82781f99f4988560$var$e;
$82781f99f4988560$export$b624eff549462981 = $82781f99f4988560$var$t;
$82781f99f4988560$export$7897aa7841a5380c = $82781f99f4988560$var$r;
$82781f99f4988560$export$602eac185826482c = $82781f99f4988560$var$d;
$82781f99f4988560$export$e2c29f18771995cb = $82781f99f4988560$var$g;
$82781f99f4988560$export$5f8d39834fd61797 = $82781f99f4988560$var$f;
$82781f99f4988560$export$74bf444e3cd11ea5 = $82781f99f4988560$var$p;
$82781f99f4988560$export$92387174baf9b227 = function(a) {
    return $82781f99f4988560$var$A(a) || $82781f99f4988560$var$z(a) === $82781f99f4988560$var$l;
};
$82781f99f4988560$export$ec112efeb987d9c6 = $82781f99f4988560$var$A;
$82781f99f4988560$export$b706b080d889d2c9 = function(a) {
    return $82781f99f4988560$var$z(a) === $82781f99f4988560$var$k;
};
$82781f99f4988560$export$5be5a87408f70ddc = function(a) {
    return $82781f99f4988560$var$z(a) === $82781f99f4988560$var$h;
};
$82781f99f4988560$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $82781f99f4988560$var$c;
};
$82781f99f4988560$export$455c2e768291efa6 = function(a) {
    return $82781f99f4988560$var$z(a) === $82781f99f4988560$var$n;
};
$82781f99f4988560$export$9522e17588c12572 = function(a) {
    return $82781f99f4988560$var$z(a) === $82781f99f4988560$var$e;
};
$82781f99f4988560$export$2110ac352bb060b9 = function(a) {
    return $82781f99f4988560$var$z(a) === $82781f99f4988560$var$t;
};
$82781f99f4988560$export$56885ab8b9c456ab = function(a) {
    return $82781f99f4988560$var$z(a) === $82781f99f4988560$var$r;
};
$82781f99f4988560$export$d927fcb6adf8f9de = function(a) {
    return $82781f99f4988560$var$z(a) === $82781f99f4988560$var$d;
};
$82781f99f4988560$export$b82d16f27459e05a = function(a) {
    return $82781f99f4988560$var$z(a) === $82781f99f4988560$var$g;
};
$82781f99f4988560$export$522c17b4f5e123e8 = function(a) {
    return $82781f99f4988560$var$z(a) === $82781f99f4988560$var$f;
};
$82781f99f4988560$export$1aabd8a0274ecfd6 = function(a) {
    return $82781f99f4988560$var$z(a) === $82781f99f4988560$var$p;
};
$82781f99f4988560$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $82781f99f4988560$var$e || a === $82781f99f4988560$var$m || a === $82781f99f4988560$var$g || a === $82781f99f4988560$var$f || a === $82781f99f4988560$var$p || a === $82781f99f4988560$var$q || "object" === typeof a && null !== a && (a.$$typeof === $82781f99f4988560$var$t || a.$$typeof === $82781f99f4988560$var$r || a.$$typeof === $82781f99f4988560$var$h || a.$$typeof === $82781f99f4988560$var$k || a.$$typeof === $82781f99f4988560$var$n || a.$$typeof === $82781f99f4988560$var$w || a.$$typeof === $82781f99f4988560$var$x || a.$$typeof === $82781f99f4988560$var$y || a.$$typeof === $82781f99f4988560$var$v);
};
$82781f99f4988560$export$f5bbd400c2f4426f = $82781f99f4988560$var$z;

});

parcelRegister("aOe7g", function(module, exports) {
$parcel$export(module.exports, "AsyncMode", () => $7de9860f48238fbe$export$2b8d127b894957b9, (v) => $7de9860f48238fbe$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $7de9860f48238fbe$export$cea3a54a6425200c, (v) => $7de9860f48238fbe$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $7de9860f48238fbe$export$a7c73072b1a182ae, (v) => $7de9860f48238fbe$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $7de9860f48238fbe$export$9f27bc3417b4524d, (v) => $7de9860f48238fbe$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $7de9860f48238fbe$export$db77ccec0bb4ccac, (v) => $7de9860f48238fbe$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $7de9860f48238fbe$export$8392c0c9d3dcbd35, (v) => $7de9860f48238fbe$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $7de9860f48238fbe$export$ffb0004e005737fa, (v) => $7de9860f48238fbe$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $7de9860f48238fbe$export$b624eff549462981, (v) => $7de9860f48238fbe$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $7de9860f48238fbe$export$7897aa7841a5380c, (v) => $7de9860f48238fbe$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $7de9860f48238fbe$export$602eac185826482c, (v) => $7de9860f48238fbe$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $7de9860f48238fbe$export$e2c29f18771995cb, (v) => $7de9860f48238fbe$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $7de9860f48238fbe$export$5f8d39834fd61797, (v) => $7de9860f48238fbe$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $7de9860f48238fbe$export$74bf444e3cd11ea5, (v) => $7de9860f48238fbe$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $7de9860f48238fbe$export$92387174baf9b227, (v) => $7de9860f48238fbe$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $7de9860f48238fbe$export$ec112efeb987d9c6, (v) => $7de9860f48238fbe$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $7de9860f48238fbe$export$b706b080d889d2c9, (v) => $7de9860f48238fbe$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $7de9860f48238fbe$export$5be5a87408f70ddc, (v) => $7de9860f48238fbe$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $7de9860f48238fbe$export$45a5e7f76e0caa8d, (v) => $7de9860f48238fbe$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $7de9860f48238fbe$export$455c2e768291efa6, (v) => $7de9860f48238fbe$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $7de9860f48238fbe$export$9522e17588c12572, (v) => $7de9860f48238fbe$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $7de9860f48238fbe$export$2110ac352bb060b9, (v) => $7de9860f48238fbe$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $7de9860f48238fbe$export$56885ab8b9c456ab, (v) => $7de9860f48238fbe$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $7de9860f48238fbe$export$d927fcb6adf8f9de, (v) => $7de9860f48238fbe$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $7de9860f48238fbe$export$b82d16f27459e05a, (v) => $7de9860f48238fbe$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $7de9860f48238fbe$export$522c17b4f5e123e8, (v) => $7de9860f48238fbe$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $7de9860f48238fbe$export$1aabd8a0274ecfd6, (v) => $7de9860f48238fbe$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $7de9860f48238fbe$export$9b621391a187a31a, (v) => $7de9860f48238fbe$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $7de9860f48238fbe$export$f5bbd400c2f4426f, (v) => $7de9860f48238fbe$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7de9860f48238fbe$export$2b8d127b894957b9;
var $7de9860f48238fbe$export$cea3a54a6425200c;
var $7de9860f48238fbe$export$a7c73072b1a182ae;
var $7de9860f48238fbe$export$9f27bc3417b4524d;
var $7de9860f48238fbe$export$db77ccec0bb4ccac;
var $7de9860f48238fbe$export$8392c0c9d3dcbd35;
var $7de9860f48238fbe$export$ffb0004e005737fa;
var $7de9860f48238fbe$export$b624eff549462981;
var $7de9860f48238fbe$export$7897aa7841a5380c;
var $7de9860f48238fbe$export$602eac185826482c;
var $7de9860f48238fbe$export$e2c29f18771995cb;
var $7de9860f48238fbe$export$5f8d39834fd61797;
var $7de9860f48238fbe$export$74bf444e3cd11ea5;
var $7de9860f48238fbe$export$92387174baf9b227;
var $7de9860f48238fbe$export$ec112efeb987d9c6;
var $7de9860f48238fbe$export$b706b080d889d2c9;
var $7de9860f48238fbe$export$5be5a87408f70ddc;
var $7de9860f48238fbe$export$45a5e7f76e0caa8d;
var $7de9860f48238fbe$export$455c2e768291efa6;
var $7de9860f48238fbe$export$9522e17588c12572;
var $7de9860f48238fbe$export$2110ac352bb060b9;
var $7de9860f48238fbe$export$56885ab8b9c456ab;
var $7de9860f48238fbe$export$d927fcb6adf8f9de;
var $7de9860f48238fbe$export$b82d16f27459e05a;
var $7de9860f48238fbe$export$522c17b4f5e123e8;
var $7de9860f48238fbe$export$1aabd8a0274ecfd6;
var $7de9860f48238fbe$export$9b621391a187a31a;
var $7de9860f48238fbe$export$f5bbd400c2f4426f;
'use strict';
var $7de9860f48238fbe$var$b = "function" === typeof Symbol && Symbol.for, $7de9860f48238fbe$var$c = $7de9860f48238fbe$var$b ? Symbol.for("react.element") : 60103, $7de9860f48238fbe$var$d = $7de9860f48238fbe$var$b ? Symbol.for("react.portal") : 60106, $7de9860f48238fbe$var$e = $7de9860f48238fbe$var$b ? Symbol.for("react.fragment") : 60107, $7de9860f48238fbe$var$f = $7de9860f48238fbe$var$b ? Symbol.for("react.strict_mode") : 60108, $7de9860f48238fbe$var$g = $7de9860f48238fbe$var$b ? Symbol.for("react.profiler") : 60114, $7de9860f48238fbe$var$h = $7de9860f48238fbe$var$b ? Symbol.for("react.provider") : 60109, $7de9860f48238fbe$var$k = $7de9860f48238fbe$var$b ? Symbol.for("react.context") : 60110, $7de9860f48238fbe$var$l = $7de9860f48238fbe$var$b ? Symbol.for("react.async_mode") : 60111, $7de9860f48238fbe$var$m = $7de9860f48238fbe$var$b ? Symbol.for("react.concurrent_mode") : 60111, $7de9860f48238fbe$var$n = $7de9860f48238fbe$var$b ? Symbol.for("react.forward_ref") : 60112, $7de9860f48238fbe$var$p = $7de9860f48238fbe$var$b ? Symbol.for("react.suspense") : 60113, $7de9860f48238fbe$var$q = $7de9860f48238fbe$var$b ? Symbol.for("react.suspense_list") : 60120, $7de9860f48238fbe$var$r = $7de9860f48238fbe$var$b ? Symbol.for("react.memo") : 60115, $7de9860f48238fbe$var$t = $7de9860f48238fbe$var$b ? Symbol.for("react.lazy") : 60116, $7de9860f48238fbe$var$v = $7de9860f48238fbe$var$b ? Symbol.for("react.block") : 60121, $7de9860f48238fbe$var$w = $7de9860f48238fbe$var$b ? Symbol.for("react.fundamental") : 60117, $7de9860f48238fbe$var$x = $7de9860f48238fbe$var$b ? Symbol.for("react.responder") : 60118, $7de9860f48238fbe$var$y = $7de9860f48238fbe$var$b ? Symbol.for("react.scope") : 60119;
function $7de9860f48238fbe$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $7de9860f48238fbe$var$c:
                switch(a = a.type, a){
                    case $7de9860f48238fbe$var$l:
                    case $7de9860f48238fbe$var$m:
                    case $7de9860f48238fbe$var$e:
                    case $7de9860f48238fbe$var$g:
                    case $7de9860f48238fbe$var$f:
                    case $7de9860f48238fbe$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $7de9860f48238fbe$var$k:
                            case $7de9860f48238fbe$var$n:
                            case $7de9860f48238fbe$var$t:
                            case $7de9860f48238fbe$var$r:
                            case $7de9860f48238fbe$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $7de9860f48238fbe$var$d:
                return u;
        }
    }
}
function $7de9860f48238fbe$var$A(a) {
    return $7de9860f48238fbe$var$z(a) === $7de9860f48238fbe$var$m;
}
$7de9860f48238fbe$export$2b8d127b894957b9 = $7de9860f48238fbe$var$l;
$7de9860f48238fbe$export$cea3a54a6425200c = $7de9860f48238fbe$var$m;
$7de9860f48238fbe$export$a7c73072b1a182ae = $7de9860f48238fbe$var$k;
$7de9860f48238fbe$export$9f27bc3417b4524d = $7de9860f48238fbe$var$h;
$7de9860f48238fbe$export$db77ccec0bb4ccac = $7de9860f48238fbe$var$c;
$7de9860f48238fbe$export$8392c0c9d3dcbd35 = $7de9860f48238fbe$var$n;
$7de9860f48238fbe$export$ffb0004e005737fa = $7de9860f48238fbe$var$e;
$7de9860f48238fbe$export$b624eff549462981 = $7de9860f48238fbe$var$t;
$7de9860f48238fbe$export$7897aa7841a5380c = $7de9860f48238fbe$var$r;
$7de9860f48238fbe$export$602eac185826482c = $7de9860f48238fbe$var$d;
$7de9860f48238fbe$export$e2c29f18771995cb = $7de9860f48238fbe$var$g;
$7de9860f48238fbe$export$5f8d39834fd61797 = $7de9860f48238fbe$var$f;
$7de9860f48238fbe$export$74bf444e3cd11ea5 = $7de9860f48238fbe$var$p;
$7de9860f48238fbe$export$92387174baf9b227 = function(a) {
    return $7de9860f48238fbe$var$A(a) || $7de9860f48238fbe$var$z(a) === $7de9860f48238fbe$var$l;
};
$7de9860f48238fbe$export$ec112efeb987d9c6 = $7de9860f48238fbe$var$A;
$7de9860f48238fbe$export$b706b080d889d2c9 = function(a) {
    return $7de9860f48238fbe$var$z(a) === $7de9860f48238fbe$var$k;
};
$7de9860f48238fbe$export$5be5a87408f70ddc = function(a) {
    return $7de9860f48238fbe$var$z(a) === $7de9860f48238fbe$var$h;
};
$7de9860f48238fbe$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $7de9860f48238fbe$var$c;
};
$7de9860f48238fbe$export$455c2e768291efa6 = function(a) {
    return $7de9860f48238fbe$var$z(a) === $7de9860f48238fbe$var$n;
};
$7de9860f48238fbe$export$9522e17588c12572 = function(a) {
    return $7de9860f48238fbe$var$z(a) === $7de9860f48238fbe$var$e;
};
$7de9860f48238fbe$export$2110ac352bb060b9 = function(a) {
    return $7de9860f48238fbe$var$z(a) === $7de9860f48238fbe$var$t;
};
$7de9860f48238fbe$export$56885ab8b9c456ab = function(a) {
    return $7de9860f48238fbe$var$z(a) === $7de9860f48238fbe$var$r;
};
$7de9860f48238fbe$export$d927fcb6adf8f9de = function(a) {
    return $7de9860f48238fbe$var$z(a) === $7de9860f48238fbe$var$d;
};
$7de9860f48238fbe$export$b82d16f27459e05a = function(a) {
    return $7de9860f48238fbe$var$z(a) === $7de9860f48238fbe$var$g;
};
$7de9860f48238fbe$export$522c17b4f5e123e8 = function(a) {
    return $7de9860f48238fbe$var$z(a) === $7de9860f48238fbe$var$f;
};
$7de9860f48238fbe$export$1aabd8a0274ecfd6 = function(a) {
    return $7de9860f48238fbe$var$z(a) === $7de9860f48238fbe$var$p;
};
$7de9860f48238fbe$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $7de9860f48238fbe$var$e || a === $7de9860f48238fbe$var$m || a === $7de9860f48238fbe$var$g || a === $7de9860f48238fbe$var$f || a === $7de9860f48238fbe$var$p || a === $7de9860f48238fbe$var$q || "object" === typeof a && null !== a && (a.$$typeof === $7de9860f48238fbe$var$t || a.$$typeof === $7de9860f48238fbe$var$r || a.$$typeof === $7de9860f48238fbe$var$h || a.$$typeof === $7de9860f48238fbe$var$k || a.$$typeof === $7de9860f48238fbe$var$n || a.$$typeof === $7de9860f48238fbe$var$w || a.$$typeof === $7de9860f48238fbe$var$x || a.$$typeof === $7de9860f48238fbe$var$y || a.$$typeof === $7de9860f48238fbe$var$v);
};
$7de9860f48238fbe$export$f5bbd400c2f4426f = $7de9860f48238fbe$var$z;

});

parcelRegister("1mK9W", function(module, exports) {

var $56kZ0 = parcelRequire("56kZ0");

var $6j9z2 = parcelRequire("6j9z2");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $56kZ0.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $6j9z2;
module.exports = isBuffer;

});
parcelRegister("56kZ0", function(module, exports) {

var $b2dRx = parcelRequire("b2dRx");
/** Detect free variable `self`. */ var $3b6dca0e649bc18c$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $3b6dca0e649bc18c$var$root = $b2dRx || $3b6dca0e649bc18c$var$freeSelf || Function('return this')();
module.exports = $3b6dca0e649bc18c$var$root;

});
parcelRegister("b2dRx", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $808aa2676b55f8cb$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $808aa2676b55f8cb$var$freeGlobal;

});


parcelRegister("6j9z2", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $497befafcfc31696$var$stubFalse() {
    return false;
}
module.exports = $497befafcfc31696$var$stubFalse;

});


parcelRegister("a246A", function(module, exports) {

var $b2dRx = parcelRequire("b2dRx");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $b2dRx.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("7vaT3", function(module, exports) {

var $gfqTY = parcelRequire("gfqTY");

var $5b0sL = parcelRequire("5b0sL");
/** Used to compose bitmasks for value comparisons. */ var $5763df9ad48a14f4$var$COMPARE_PARTIAL_FLAG = 1, $5763df9ad48a14f4$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $5763df9ad48a14f4$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $gfqTY;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $5b0sL(srcValue, objValue, $5763df9ad48a14f4$var$COMPARE_PARTIAL_FLAG | $5763df9ad48a14f4$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = $5763df9ad48a14f4$var$baseIsMatch;

});
parcelRegister("gfqTY", function(module, exports) {

var $akJ6a = parcelRequire("akJ6a");

var $hikcg = parcelRequire("hikcg");

var $bfutz = parcelRequire("bfutz");

var $2ZpIw = parcelRequire("2ZpIw");

var $ixt7p = parcelRequire("ixt7p");

var $diLGK = parcelRequire("diLGK");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $bd42ea3370832ed7$var$Stack(entries) {
    var data = this.__data__ = new $akJ6a(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$bd42ea3370832ed7$var$Stack.prototype.clear = $hikcg;
$bd42ea3370832ed7$var$Stack.prototype['delete'] = $bfutz;
$bd42ea3370832ed7$var$Stack.prototype.get = $2ZpIw;
$bd42ea3370832ed7$var$Stack.prototype.has = $ixt7p;
$bd42ea3370832ed7$var$Stack.prototype.set = $diLGK;
module.exports = $bd42ea3370832ed7$var$Stack;

});
parcelRegister("akJ6a", function(module, exports) {

var $kQ7ap = parcelRequire("kQ7ap");

var $bV2Mh = parcelRequire("bV2Mh");

var $f5d9f = parcelRequire("f5d9f");

var $91yVp = parcelRequire("91yVp");

var $guveB = parcelRequire("guveB");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $785ec14632bf3488$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$785ec14632bf3488$var$ListCache.prototype.clear = $kQ7ap;
$785ec14632bf3488$var$ListCache.prototype['delete'] = $bV2Mh;
$785ec14632bf3488$var$ListCache.prototype.get = $f5d9f;
$785ec14632bf3488$var$ListCache.prototype.has = $91yVp;
$785ec14632bf3488$var$ListCache.prototype.set = $guveB;
module.exports = $785ec14632bf3488$var$ListCache;

});
parcelRegister("kQ7ap", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $f2be39315f7d0f2d$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $f2be39315f7d0f2d$var$listCacheClear;

});

parcelRegister("bV2Mh", function(module, exports) {

var $btyw2 = parcelRequire("btyw2");
/** Used for built-in method references. */ var $8ad72c2d334763c6$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $8ad72c2d334763c6$var$splice = $8ad72c2d334763c6$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $8ad72c2d334763c6$var$listCacheDelete(key) {
    var data = this.__data__, index = $btyw2(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $8ad72c2d334763c6$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $8ad72c2d334763c6$var$listCacheDelete;

});
parcelRegister("btyw2", function(module, exports) {

var $akjE4 = parcelRequire("akjE4");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $85ad2d469f60a81e$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($akjE4(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $85ad2d469f60a81e$var$assocIndexOf;

});
parcelRegister("akjE4", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $01f0b197d992bd53$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $01f0b197d992bd53$var$eq;

});



parcelRegister("f5d9f", function(module, exports) {

var $btyw2 = parcelRequire("btyw2");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $afb18595ada8a9c5$var$listCacheGet(key) {
    var data = this.__data__, index = $btyw2(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $afb18595ada8a9c5$var$listCacheGet;

});

parcelRegister("91yVp", function(module, exports) {

var $btyw2 = parcelRequire("btyw2");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $691f4c66addec222$var$listCacheHas(key) {
    return $btyw2(this.__data__, key) > -1;
}
module.exports = $691f4c66addec222$var$listCacheHas;

});

parcelRegister("guveB", function(module, exports) {

var $btyw2 = parcelRequire("btyw2");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $c017ad354bcbdc90$var$listCacheSet(key, value) {
    var data = this.__data__, index = $btyw2(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $c017ad354bcbdc90$var$listCacheSet;

});


parcelRegister("hikcg", function(module, exports) {

var $akJ6a = parcelRequire("akJ6a");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $c973c8c0a6728010$var$stackClear() {
    this.__data__ = new $akJ6a;
    this.size = 0;
}
module.exports = $c973c8c0a6728010$var$stackClear;

});

parcelRegister("bfutz", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $8308bc491c732104$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = $8308bc491c732104$var$stackDelete;

});

parcelRegister("2ZpIw", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $22d53a229a886eee$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $22d53a229a886eee$var$stackGet;

});

parcelRegister("ixt7p", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d7f1e5667a1cee90$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $d7f1e5667a1cee90$var$stackHas;

});

parcelRegister("diLGK", function(module, exports) {

var $akJ6a = parcelRequire("akJ6a");

var $3Gg0y = parcelRequire("3Gg0y");

var $1W4Hx = parcelRequire("1W4Hx");
/** Used as the size to enable large array optimizations. */ var $9af1f2c14ba2206d$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $9af1f2c14ba2206d$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $akJ6a) {
        var pairs = data.__data__;
        if (!$3Gg0y || pairs.length < $9af1f2c14ba2206d$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $1W4Hx(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $9af1f2c14ba2206d$var$stackSet;

});
parcelRegister("3Gg0y", function(module, exports) {

var $8vcXv = parcelRequire("8vcXv");

var $56kZ0 = parcelRequire("56kZ0");
/* Built-in method references that are verified to be native. */ var $2ae1b62e61523c4b$var$Map = $8vcXv($56kZ0, 'Map');
module.exports = $2ae1b62e61523c4b$var$Map;

});
parcelRegister("8vcXv", function(module, exports) {

var $lnPeT = parcelRequire("lnPeT");

var $aGIoU = parcelRequire("aGIoU");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $630b4554c2b1f7e0$var$getNative(object, key) {
    var value = $aGIoU(object, key);
    return $lnPeT(value) ? value : undefined;
}
module.exports = $630b4554c2b1f7e0$var$getNative;

});
parcelRegister("lnPeT", function(module, exports) {

var $bcrSM = parcelRequire("bcrSM");

var $973yX = parcelRequire("973yX");

var $bFI6q = parcelRequire("bFI6q");

var $9qg9x = parcelRequire("9qg9x");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $f9137dfa73b2b19e$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $f9137dfa73b2b19e$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $f9137dfa73b2b19e$var$funcProto = Function.prototype, $f9137dfa73b2b19e$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $f9137dfa73b2b19e$var$funcToString = $f9137dfa73b2b19e$var$funcProto.toString;
/** Used to check objects for own properties. */ var $f9137dfa73b2b19e$var$hasOwnProperty = $f9137dfa73b2b19e$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $f9137dfa73b2b19e$var$reIsNative = RegExp('^' + $f9137dfa73b2b19e$var$funcToString.call($f9137dfa73b2b19e$var$hasOwnProperty).replace($f9137dfa73b2b19e$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $f9137dfa73b2b19e$var$baseIsNative(value) {
    if (!$bFI6q(value) || $973yX(value)) return false;
    var pattern = $bcrSM(value) ? $f9137dfa73b2b19e$var$reIsNative : $f9137dfa73b2b19e$var$reIsHostCtor;
    return pattern.test($9qg9x(value));
}
module.exports = $f9137dfa73b2b19e$var$baseIsNative;

});
parcelRegister("bcrSM", function(module, exports) {

var $aeQBO = parcelRequire("aeQBO");

var $bFI6q = parcelRequire("bFI6q");
/** `Object#toString` result references. */ var $827671919e201492$var$asyncTag = '[object AsyncFunction]', $827671919e201492$var$funcTag = '[object Function]', $827671919e201492$var$genTag = '[object GeneratorFunction]', $827671919e201492$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $827671919e201492$var$isFunction(value) {
    if (!$bFI6q(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $aeQBO(value);
    return tag == $827671919e201492$var$funcTag || tag == $827671919e201492$var$genTag || tag == $827671919e201492$var$asyncTag || tag == $827671919e201492$var$proxyTag;
}
module.exports = $827671919e201492$var$isFunction;

});
parcelRegister("aeQBO", function(module, exports) {

var $jf0iC = parcelRequire("jf0iC");

var $aArLb = parcelRequire("aArLb");

var $aLME7 = parcelRequire("aLME7");
/** `Object#toString` result references. */ var $77440538b1f78277$var$nullTag = '[object Null]', $77440538b1f78277$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $77440538b1f78277$var$symToStringTag = $jf0iC ? $jf0iC.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $77440538b1f78277$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $77440538b1f78277$var$undefinedTag : $77440538b1f78277$var$nullTag;
    return $77440538b1f78277$var$symToStringTag && $77440538b1f78277$var$symToStringTag in Object(value) ? $aArLb(value) : $aLME7(value);
}
module.exports = $77440538b1f78277$var$baseGetTag;

});
parcelRegister("jf0iC", function(module, exports) {

var $56kZ0 = parcelRequire("56kZ0");
/** Built-in value references. */ var $e01fa67499657e1a$var$Symbol = $56kZ0.Symbol;
module.exports = $e01fa67499657e1a$var$Symbol;

});

parcelRegister("aArLb", function(module, exports) {

var $jf0iC = parcelRequire("jf0iC");
/** Used for built-in method references. */ var $7b52ccb84679a7bf$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7b52ccb84679a7bf$var$hasOwnProperty = $7b52ccb84679a7bf$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $7b52ccb84679a7bf$var$nativeObjectToString = $7b52ccb84679a7bf$var$objectProto.toString;
/** Built-in value references. */ var $7b52ccb84679a7bf$var$symToStringTag = $jf0iC ? $jf0iC.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $7b52ccb84679a7bf$var$getRawTag(value) {
    var isOwn = $7b52ccb84679a7bf$var$hasOwnProperty.call(value, $7b52ccb84679a7bf$var$symToStringTag), tag = value[$7b52ccb84679a7bf$var$symToStringTag];
    try {
        value[$7b52ccb84679a7bf$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $7b52ccb84679a7bf$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$7b52ccb84679a7bf$var$symToStringTag] = tag;
        else delete value[$7b52ccb84679a7bf$var$symToStringTag];
    }
    return result;
}
module.exports = $7b52ccb84679a7bf$var$getRawTag;

});

parcelRegister("aLME7", function(module, exports) {
/** Used for built-in method references. */ var $7d740744ed053923$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $7d740744ed053923$var$nativeObjectToString = $7d740744ed053923$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $7d740744ed053923$var$objectToString(value) {
    return $7d740744ed053923$var$nativeObjectToString.call(value);
}
module.exports = $7d740744ed053923$var$objectToString;

});


parcelRegister("bFI6q", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $87f5bbe756440438$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = $87f5bbe756440438$var$isObject;

});


parcelRegister("973yX", function(module, exports) {

var $2BOBI = parcelRequire("2BOBI");
/** Used to detect methods masquerading as native. */ var $6a2787fd00f74939$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($2BOBI && $2BOBI.keys && $2BOBI.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $6a2787fd00f74939$var$isMasked(func) {
    return !!$6a2787fd00f74939$var$maskSrcKey && $6a2787fd00f74939$var$maskSrcKey in func;
}
module.exports = $6a2787fd00f74939$var$isMasked;

});
parcelRegister("2BOBI", function(module, exports) {

var $56kZ0 = parcelRequire("56kZ0");
/** Used to detect overreaching core-js shims. */ var $1e664b0deb7659ec$var$coreJsData = $56kZ0["__core-js_shared__"];
module.exports = $1e664b0deb7659ec$var$coreJsData;

});


parcelRegister("9qg9x", function(module, exports) {
/** Used for built-in method references. */ var $6dc3125ef2acbb0a$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $6dc3125ef2acbb0a$var$funcToString = $6dc3125ef2acbb0a$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $6dc3125ef2acbb0a$var$toSource(func) {
    if (func != null) {
        try {
            return $6dc3125ef2acbb0a$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = $6dc3125ef2acbb0a$var$toSource;

});


parcelRegister("aGIoU", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $7c8044b40c9f6d98$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $7c8044b40c9f6d98$var$getValue;

});



parcelRegister("1W4Hx", function(module, exports) {

var $9RAmM = parcelRequire("9RAmM");

var $dA2mj = parcelRequire("dA2mj");

var $bZz8V = parcelRequire("bZz8V");

var $1Qjav = parcelRequire("1Qjav");

var $eP28G = parcelRequire("eP28G");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $168edac7546d4822$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$168edac7546d4822$var$MapCache.prototype.clear = $9RAmM;
$168edac7546d4822$var$MapCache.prototype['delete'] = $dA2mj;
$168edac7546d4822$var$MapCache.prototype.get = $bZz8V;
$168edac7546d4822$var$MapCache.prototype.has = $1Qjav;
$168edac7546d4822$var$MapCache.prototype.set = $eP28G;
module.exports = $168edac7546d4822$var$MapCache;

});
parcelRegister("9RAmM", function(module, exports) {

var $8bBus = parcelRequire("8bBus");

var $akJ6a = parcelRequire("akJ6a");

var $3Gg0y = parcelRequire("3Gg0y");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $72e545ea91e56eae$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $8bBus,
        'map': new ($3Gg0y || $akJ6a),
        'string': new $8bBus
    };
}
module.exports = $72e545ea91e56eae$var$mapCacheClear;

});
parcelRegister("8bBus", function(module, exports) {

var $hGTcV = parcelRequire("hGTcV");

var $9TGcA = parcelRequire("9TGcA");

var $l55Sg = parcelRequire("l55Sg");

var $1Nxtp = parcelRequire("1Nxtp");

var $l7eaG = parcelRequire("l7eaG");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $5f5c6e9a847c7d5b$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$5f5c6e9a847c7d5b$var$Hash.prototype.clear = $hGTcV;
$5f5c6e9a847c7d5b$var$Hash.prototype['delete'] = $9TGcA;
$5f5c6e9a847c7d5b$var$Hash.prototype.get = $l55Sg;
$5f5c6e9a847c7d5b$var$Hash.prototype.has = $1Nxtp;
$5f5c6e9a847c7d5b$var$Hash.prototype.set = $l7eaG;
module.exports = $5f5c6e9a847c7d5b$var$Hash;

});
parcelRegister("hGTcV", function(module, exports) {

var $4bK2W = parcelRequire("4bK2W");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $ce112ef7dcc34180$var$hashClear() {
    this.__data__ = $4bK2W ? $4bK2W(null) : {};
    this.size = 0;
}
module.exports = $ce112ef7dcc34180$var$hashClear;

});
parcelRegister("4bK2W", function(module, exports) {

var $8vcXv = parcelRequire("8vcXv");
/* Built-in method references that are verified to be native. */ var $30cbe85d32b270b5$var$nativeCreate = $8vcXv(Object, 'create');
module.exports = $30cbe85d32b270b5$var$nativeCreate;

});


parcelRegister("9TGcA", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $7349fc8d3f546bf2$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $7349fc8d3f546bf2$var$hashDelete;

});

parcelRegister("l55Sg", function(module, exports) {

var $4bK2W = parcelRequire("4bK2W");
/** Used to stand-in for `undefined` hash values. */ var $f58e9f179078cc51$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $f58e9f179078cc51$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f58e9f179078cc51$var$hasOwnProperty = $f58e9f179078cc51$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $f58e9f179078cc51$var$hashGet(key) {
    var data = this.__data__;
    if ($4bK2W) {
        var result = data[key];
        return result === $f58e9f179078cc51$var$HASH_UNDEFINED ? undefined : result;
    }
    return $f58e9f179078cc51$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $f58e9f179078cc51$var$hashGet;

});

parcelRegister("1Nxtp", function(module, exports) {

var $4bK2W = parcelRequire("4bK2W");
/** Used for built-in method references. */ var $14f4552b814fba1c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $14f4552b814fba1c$var$hasOwnProperty = $14f4552b814fba1c$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $14f4552b814fba1c$var$hashHas(key) {
    var data = this.__data__;
    return $4bK2W ? data[key] !== undefined : $14f4552b814fba1c$var$hasOwnProperty.call(data, key);
}
module.exports = $14f4552b814fba1c$var$hashHas;

});

parcelRegister("l7eaG", function(module, exports) {

var $4bK2W = parcelRequire("4bK2W");
/** Used to stand-in for `undefined` hash values. */ var $03f7918656d2be63$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $03f7918656d2be63$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $4bK2W && value === undefined ? $03f7918656d2be63$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $03f7918656d2be63$var$hashSet;

});



parcelRegister("dA2mj", function(module, exports) {

var $jFKEl = parcelRequire("jFKEl");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $9e307791ad48eed6$var$mapCacheDelete(key) {
    var result = $jFKEl(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $9e307791ad48eed6$var$mapCacheDelete;

});
parcelRegister("jFKEl", function(module, exports) {

var $bwBaR = parcelRequire("bwBaR");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $e52608527fb1ef70$var$getMapData(map, key) {
    var data = map.__data__;
    return $bwBaR(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = $e52608527fb1ef70$var$getMapData;

});
parcelRegister("bwBaR", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $863f84e7f84d482f$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = $863f84e7f84d482f$var$isKeyable;

});



parcelRegister("bZz8V", function(module, exports) {

var $jFKEl = parcelRequire("jFKEl");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $8bb0a6e39063e43b$var$mapCacheGet(key) {
    return $jFKEl(this, key).get(key);
}
module.exports = $8bb0a6e39063e43b$var$mapCacheGet;

});

parcelRegister("1Qjav", function(module, exports) {

var $jFKEl = parcelRequire("jFKEl");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $15798440df7f6826$var$mapCacheHas(key) {
    return $jFKEl(this, key).has(key);
}
module.exports = $15798440df7f6826$var$mapCacheHas;

});

parcelRegister("eP28G", function(module, exports) {

var $jFKEl = parcelRequire("jFKEl");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $aca77ce74be1aa35$var$mapCacheSet(key, value) {
    var data = $jFKEl(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $aca77ce74be1aa35$var$mapCacheSet;

});




parcelRegister("5b0sL", function(module, exports) {

var $9DXjz = parcelRequire("9DXjz");

var $lqXWM = parcelRequire("lqXWM");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $3c4e56c49af995d7$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$lqXWM(value) && !$lqXWM(other)) return value !== value && other !== other;
    return $9DXjz(value, other, bitmask, customizer, $3c4e56c49af995d7$var$baseIsEqual, stack);
}
module.exports = $3c4e56c49af995d7$var$baseIsEqual;

});
parcelRegister("9DXjz", function(module, exports) {

var $gfqTY = parcelRequire("gfqTY");

var $dbhHM = parcelRequire("dbhHM");

var $l5KZn = parcelRequire("l5KZn");

var $9SxgQ = parcelRequire("9SxgQ");

var $jaE2r = parcelRequire("jaE2r");

var $9X1Pr = parcelRequire("9X1Pr");

var $1mK9W = parcelRequire("1mK9W");

var $lJdQZ = parcelRequire("lJdQZ");
/** Used to compose bitmasks for value comparisons. */ var $7055c4376e773e40$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $7055c4376e773e40$var$argsTag = '[object Arguments]', $7055c4376e773e40$var$arrayTag = '[object Array]', $7055c4376e773e40$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $7055c4376e773e40$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7055c4376e773e40$var$hasOwnProperty = $7055c4376e773e40$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $7055c4376e773e40$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $9X1Pr(object), othIsArr = $9X1Pr(other), objTag = objIsArr ? $7055c4376e773e40$var$arrayTag : $jaE2r(object), othTag = othIsArr ? $7055c4376e773e40$var$arrayTag : $jaE2r(other);
    objTag = objTag == $7055c4376e773e40$var$argsTag ? $7055c4376e773e40$var$objectTag : objTag;
    othTag = othTag == $7055c4376e773e40$var$argsTag ? $7055c4376e773e40$var$objectTag : othTag;
    var objIsObj = objTag == $7055c4376e773e40$var$objectTag, othIsObj = othTag == $7055c4376e773e40$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $1mK9W(object)) {
        if (!$1mK9W(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $gfqTY);
        return objIsArr || $lJdQZ(object) ? $dbhHM(object, other, bitmask, customizer, equalFunc, stack) : $l5KZn(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $7055c4376e773e40$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $7055c4376e773e40$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $7055c4376e773e40$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $gfqTY);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $gfqTY);
    return $9SxgQ(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $7055c4376e773e40$var$baseIsEqualDeep;

});
parcelRegister("dbhHM", function(module, exports) {

var $dNsvO = parcelRequire("dNsvO");

var $50gwa = parcelRequire("50gwa");

var $eAcRI = parcelRequire("eAcRI");
/** Used to compose bitmasks for value comparisons. */ var $998a0950ca73ee24$var$COMPARE_PARTIAL_FLAG = 1, $998a0950ca73ee24$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $998a0950ca73ee24$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $998a0950ca73ee24$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $998a0950ca73ee24$var$COMPARE_UNORDERED_FLAG ? new $dNsvO : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$50gwa(other, function(othValue, othIndex) {
                if (!$eAcRI(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
module.exports = $998a0950ca73ee24$var$equalArrays;

});
parcelRegister("dNsvO", function(module, exports) {

var $1W4Hx = parcelRequire("1W4Hx");

var $c7kt0 = parcelRequire("c7kt0");

var $3qBWC = parcelRequire("3qBWC");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $a0b5f7e1c99fefe1$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $1W4Hx;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$a0b5f7e1c99fefe1$var$SetCache.prototype.add = $a0b5f7e1c99fefe1$var$SetCache.prototype.push = $c7kt0;
$a0b5f7e1c99fefe1$var$SetCache.prototype.has = $3qBWC;
module.exports = $a0b5f7e1c99fefe1$var$SetCache;

});
parcelRegister("c7kt0", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $8d2603c49144155c$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $8d2603c49144155c$var$setCacheAdd(value) {
    this.__data__.set(value, $8d2603c49144155c$var$HASH_UNDEFINED);
    return this;
}
module.exports = $8d2603c49144155c$var$setCacheAdd;

});

parcelRegister("3qBWC", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $27f13bcb588d3d82$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $27f13bcb588d3d82$var$setCacheHas;

});


parcelRegister("50gwa", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $3a49c3f59ca64800$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $3a49c3f59ca64800$var$arraySome;

});

parcelRegister("eAcRI", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $a9de6849b3148fd0$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $a9de6849b3148fd0$var$cacheHas;

});


parcelRegister("l5KZn", function(module, exports) {

var $jf0iC = parcelRequire("jf0iC");

var $7XhNn = parcelRequire("7XhNn");

var $akjE4 = parcelRequire("akjE4");

var $dbhHM = parcelRequire("dbhHM");

var $9jiRU = parcelRequire("9jiRU");

var $36G11 = parcelRequire("36G11");
/** Used to compose bitmasks for value comparisons. */ var $f5ae83a64378044f$var$COMPARE_PARTIAL_FLAG = 1, $f5ae83a64378044f$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $f5ae83a64378044f$var$boolTag = '[object Boolean]', $f5ae83a64378044f$var$dateTag = '[object Date]', $f5ae83a64378044f$var$errorTag = '[object Error]', $f5ae83a64378044f$var$mapTag = '[object Map]', $f5ae83a64378044f$var$numberTag = '[object Number]', $f5ae83a64378044f$var$regexpTag = '[object RegExp]', $f5ae83a64378044f$var$setTag = '[object Set]', $f5ae83a64378044f$var$stringTag = '[object String]', $f5ae83a64378044f$var$symbolTag = '[object Symbol]';
var $f5ae83a64378044f$var$arrayBufferTag = '[object ArrayBuffer]', $f5ae83a64378044f$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $f5ae83a64378044f$var$symbolProto = $jf0iC ? $jf0iC.prototype : undefined, $f5ae83a64378044f$var$symbolValueOf = $f5ae83a64378044f$var$symbolProto ? $f5ae83a64378044f$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $f5ae83a64378044f$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $f5ae83a64378044f$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $f5ae83a64378044f$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $7XhNn(object), new $7XhNn(other))) return false;
            return true;
        case $f5ae83a64378044f$var$boolTag:
        case $f5ae83a64378044f$var$dateTag:
        case $f5ae83a64378044f$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $akjE4(+object, +other);
        case $f5ae83a64378044f$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $f5ae83a64378044f$var$regexpTag:
        case $f5ae83a64378044f$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $f5ae83a64378044f$var$mapTag:
            var convert = $9jiRU;
        case $f5ae83a64378044f$var$setTag:
            var isPartial = bitmask & $f5ae83a64378044f$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $36G11);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $f5ae83a64378044f$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $dbhHM(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $f5ae83a64378044f$var$symbolTag:
            if ($f5ae83a64378044f$var$symbolValueOf) return $f5ae83a64378044f$var$symbolValueOf.call(object) == $f5ae83a64378044f$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $f5ae83a64378044f$var$equalByTag;

});
parcelRegister("7XhNn", function(module, exports) {

var $56kZ0 = parcelRequire("56kZ0");
/** Built-in value references. */ var $5cabd8e741e9ee70$var$Uint8Array = $56kZ0.Uint8Array;
module.exports = $5cabd8e741e9ee70$var$Uint8Array;

});

parcelRegister("9jiRU", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $6c74864a2a985dfc$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $6c74864a2a985dfc$var$mapToArray;

});

parcelRegister("36G11", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $24328605d2aa6dfd$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $24328605d2aa6dfd$var$setToArray;

});


parcelRegister("9SxgQ", function(module, exports) {

var $eCkRO = parcelRequire("eCkRO");
/** Used to compose bitmasks for value comparisons. */ var $7312f714f8cd3682$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $7312f714f8cd3682$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7312f714f8cd3682$var$hasOwnProperty = $7312f714f8cd3682$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $7312f714f8cd3682$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $7312f714f8cd3682$var$COMPARE_PARTIAL_FLAG, objProps = $eCkRO(object), objLength = objProps.length, othProps = $eCkRO(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $7312f714f8cd3682$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
module.exports = $7312f714f8cd3682$var$equalObjects;

});
parcelRegister("eCkRO", function(module, exports) {

var $kfv1b = parcelRequire("kfv1b");

var $PmheH = parcelRequire("PmheH");

var $kOHWF = parcelRequire("kOHWF");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $aa44cd0e4764a91c$var$getAllKeys(object) {
    return $kfv1b(object, $kOHWF, $PmheH);
}
module.exports = $aa44cd0e4764a91c$var$getAllKeys;

});
parcelRegister("kfv1b", function(module, exports) {

var $2Wmte = parcelRequire("2Wmte");

var $9X1Pr = parcelRequire("9X1Pr");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $ebdd44ec062aba39$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $9X1Pr(object) ? result : $2Wmte(result, symbolsFunc(object));
}
module.exports = $ebdd44ec062aba39$var$baseGetAllKeys;

});
parcelRegister("2Wmte", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $22426db3e867077a$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $22426db3e867077a$var$arrayPush;

});

parcelRegister("9X1Pr", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $73eb0ae4a025f49a$var$isArray = Array.isArray;
module.exports = $73eb0ae4a025f49a$var$isArray;

});


parcelRegister("PmheH", function(module, exports) {

var $4bfZM = parcelRequire("4bfZM");

var $bXRS6 = parcelRequire("bXRS6");
/** Used for built-in method references. */ var $09a60b4880f8e037$var$objectProto = Object.prototype;
/** Built-in value references. */ var $09a60b4880f8e037$var$propertyIsEnumerable = $09a60b4880f8e037$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $09a60b4880f8e037$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $09a60b4880f8e037$var$getSymbols = !$09a60b4880f8e037$var$nativeGetSymbols ? $bXRS6 : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $4bfZM($09a60b4880f8e037$var$nativeGetSymbols(object), function(symbol) {
        return $09a60b4880f8e037$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $09a60b4880f8e037$var$getSymbols;

});
parcelRegister("4bfZM", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $30b498df53b22e31$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $30b498df53b22e31$var$arrayFilter;

});

parcelRegister("bXRS6", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $023f77b652dc0c36$var$stubArray() {
    return [];
}
module.exports = $023f77b652dc0c36$var$stubArray;

});


parcelRegister("kOHWF", function(module, exports) {

var $bNP5E = parcelRequire("bNP5E");

var $7GYGj = parcelRequire("7GYGj");

var $cOzi7 = parcelRequire("cOzi7");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $f27a90cb0fb58d23$var$keys(object) {
    return $cOzi7(object) ? $bNP5E(object) : $7GYGj(object);
}
module.exports = $f27a90cb0fb58d23$var$keys;

});
parcelRegister("bNP5E", function(module, exports) {

var $gKbAt = parcelRequire("gKbAt");

var $aPIym = parcelRequire("aPIym");

var $9X1Pr = parcelRequire("9X1Pr");

var $1mK9W = parcelRequire("1mK9W");

var $720Uz = parcelRequire("720Uz");

var $lJdQZ = parcelRequire("lJdQZ");
/** Used for built-in method references. */ var $897be6c221c4f36a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $897be6c221c4f36a$var$hasOwnProperty = $897be6c221c4f36a$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $897be6c221c4f36a$var$arrayLikeKeys(value, inherited) {
    var isArr = $9X1Pr(value), isArg = !isArr && $aPIym(value), isBuff = !isArr && !isArg && $1mK9W(value), isType = !isArr && !isArg && !isBuff && $lJdQZ(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $gKbAt(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $897be6c221c4f36a$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $720Uz(key, length)))) result.push(key);
    return result;
}
module.exports = $897be6c221c4f36a$var$arrayLikeKeys;

});
parcelRegister("gKbAt", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $c309ee3000412578$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $c309ee3000412578$var$baseTimes;

});

parcelRegister("aPIym", function(module, exports) {

var $783tX = parcelRequire("783tX");

var $lqXWM = parcelRequire("lqXWM");
/** Used for built-in method references. */ var $7e313a250e9e91d9$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7e313a250e9e91d9$var$hasOwnProperty = $7e313a250e9e91d9$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $7e313a250e9e91d9$var$propertyIsEnumerable = $7e313a250e9e91d9$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $7e313a250e9e91d9$var$isArguments = $783tX(function() {
    return arguments;
}()) ? $783tX : function(value) {
    return $lqXWM(value) && $7e313a250e9e91d9$var$hasOwnProperty.call(value, 'callee') && !$7e313a250e9e91d9$var$propertyIsEnumerable.call(value, 'callee');
};
module.exports = $7e313a250e9e91d9$var$isArguments;

});
parcelRegister("783tX", function(module, exports) {

var $aeQBO = parcelRequire("aeQBO");

var $lqXWM = parcelRequire("lqXWM");
/** `Object#toString` result references. */ var $530bfb3efb55b61a$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $530bfb3efb55b61a$var$baseIsArguments(value) {
    return $lqXWM(value) && $aeQBO(value) == $530bfb3efb55b61a$var$argsTag;
}
module.exports = $530bfb3efb55b61a$var$baseIsArguments;

});
parcelRegister("lqXWM", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $f9aa86f16045db02$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $f9aa86f16045db02$var$isObjectLike;

});



parcelRegister("720Uz", function(module, exports) {
/** Used as references for various `Number` constants. */ var $51e96d48c368665c$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $51e96d48c368665c$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $51e96d48c368665c$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $51e96d48c368665c$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $51e96d48c368665c$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $51e96d48c368665c$var$isIndex;

});

parcelRegister("lJdQZ", function(module, exports) {

var $hw0OB = parcelRequire("hw0OB");

var $X4ATL = parcelRequire("X4ATL");

var $a246A = parcelRequire("a246A");
/* Node.js helper references. */ var $fd188c019be69593$var$nodeIsTypedArray = $a246A && $a246A.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $fd188c019be69593$var$isTypedArray = $fd188c019be69593$var$nodeIsTypedArray ? $X4ATL($fd188c019be69593$var$nodeIsTypedArray) : $hw0OB;
module.exports = $fd188c019be69593$var$isTypedArray;

});
parcelRegister("hw0OB", function(module, exports) {

var $aeQBO = parcelRequire("aeQBO");

var $1zLxR = parcelRequire("1zLxR");

var $lqXWM = parcelRequire("lqXWM");
/** `Object#toString` result references. */ var $cc060eba6295e27c$var$argsTag = '[object Arguments]', $cc060eba6295e27c$var$arrayTag = '[object Array]', $cc060eba6295e27c$var$boolTag = '[object Boolean]', $cc060eba6295e27c$var$dateTag = '[object Date]', $cc060eba6295e27c$var$errorTag = '[object Error]', $cc060eba6295e27c$var$funcTag = '[object Function]', $cc060eba6295e27c$var$mapTag = '[object Map]', $cc060eba6295e27c$var$numberTag = '[object Number]', $cc060eba6295e27c$var$objectTag = '[object Object]', $cc060eba6295e27c$var$regexpTag = '[object RegExp]', $cc060eba6295e27c$var$setTag = '[object Set]', $cc060eba6295e27c$var$stringTag = '[object String]', $cc060eba6295e27c$var$weakMapTag = '[object WeakMap]';
var $cc060eba6295e27c$var$arrayBufferTag = '[object ArrayBuffer]', $cc060eba6295e27c$var$dataViewTag = '[object DataView]', $cc060eba6295e27c$var$float32Tag = '[object Float32Array]', $cc060eba6295e27c$var$float64Tag = '[object Float64Array]', $cc060eba6295e27c$var$int8Tag = '[object Int8Array]', $cc060eba6295e27c$var$int16Tag = '[object Int16Array]', $cc060eba6295e27c$var$int32Tag = '[object Int32Array]', $cc060eba6295e27c$var$uint8Tag = '[object Uint8Array]', $cc060eba6295e27c$var$uint8ClampedTag = '[object Uint8ClampedArray]', $cc060eba6295e27c$var$uint16Tag = '[object Uint16Array]', $cc060eba6295e27c$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $cc060eba6295e27c$var$typedArrayTags = {};
$cc060eba6295e27c$var$typedArrayTags[$cc060eba6295e27c$var$float32Tag] = $cc060eba6295e27c$var$typedArrayTags[$cc060eba6295e27c$var$float64Tag] = $cc060eba6295e27c$var$typedArrayTags[$cc060eba6295e27c$var$int8Tag] = $cc060eba6295e27c$var$typedArrayTags[$cc060eba6295e27c$var$int16Tag] = $cc060eba6295e27c$var$typedArrayTags[$cc060eba6295e27c$var$int32Tag] = $cc060eba6295e27c$var$typedArrayTags[$cc060eba6295e27c$var$uint8Tag] = $cc060eba6295e27c$var$typedArrayTags[$cc060eba6295e27c$var$uint8ClampedTag] = $cc060eba6295e27c$var$typedArrayTags[$cc060eba6295e27c$var$uint16Tag] = $cc060eba6295e27c$var$typedArrayTags[$cc060eba6295e27c$var$uint32Tag] = true;
$cc060eba6295e27c$var$typedArrayTags[$cc060eba6295e27c$var$argsTag] = $cc060eba6295e27c$var$typedArrayTags[$cc060eba6295e27c$var$arrayTag] = $cc060eba6295e27c$var$typedArrayTags[$cc060eba6295e27c$var$arrayBufferTag] = $cc060eba6295e27c$var$typedArrayTags[$cc060eba6295e27c$var$boolTag] = $cc060eba6295e27c$var$typedArrayTags[$cc060eba6295e27c$var$dataViewTag] = $cc060eba6295e27c$var$typedArrayTags[$cc060eba6295e27c$var$dateTag] = $cc060eba6295e27c$var$typedArrayTags[$cc060eba6295e27c$var$errorTag] = $cc060eba6295e27c$var$typedArrayTags[$cc060eba6295e27c$var$funcTag] = $cc060eba6295e27c$var$typedArrayTags[$cc060eba6295e27c$var$mapTag] = $cc060eba6295e27c$var$typedArrayTags[$cc060eba6295e27c$var$numberTag] = $cc060eba6295e27c$var$typedArrayTags[$cc060eba6295e27c$var$objectTag] = $cc060eba6295e27c$var$typedArrayTags[$cc060eba6295e27c$var$regexpTag] = $cc060eba6295e27c$var$typedArrayTags[$cc060eba6295e27c$var$setTag] = $cc060eba6295e27c$var$typedArrayTags[$cc060eba6295e27c$var$stringTag] = $cc060eba6295e27c$var$typedArrayTags[$cc060eba6295e27c$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $cc060eba6295e27c$var$baseIsTypedArray(value) {
    return $lqXWM(value) && $1zLxR(value.length) && !!$cc060eba6295e27c$var$typedArrayTags[$aeQBO(value)];
}
module.exports = $cc060eba6295e27c$var$baseIsTypedArray;

});
parcelRegister("1zLxR", function(module, exports) {
/** Used as references for various `Number` constants. */ var $125df0d302028536$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $125df0d302028536$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $125df0d302028536$var$MAX_SAFE_INTEGER;
}
module.exports = $125df0d302028536$var$isLength;

});


parcelRegister("X4ATL", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $0b19131a47b54358$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $0b19131a47b54358$var$baseUnary;

});



parcelRegister("7GYGj", function(module, exports) {

var $d0GOx = parcelRequire("d0GOx");

var $9IeAN = parcelRequire("9IeAN");
/** Used for built-in method references. */ var $599b86bbfecd10d1$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $599b86bbfecd10d1$var$hasOwnProperty = $599b86bbfecd10d1$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $599b86bbfecd10d1$var$baseKeys(object) {
    if (!$d0GOx(object)) return $9IeAN(object);
    var result = [];
    for(var key in Object(object))if ($599b86bbfecd10d1$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
module.exports = $599b86bbfecd10d1$var$baseKeys;

});
parcelRegister("d0GOx", function(module, exports) {
/** Used for built-in method references. */ var $978c7c7580432e24$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $978c7c7580432e24$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $978c7c7580432e24$var$objectProto;
    return value === proto;
}
module.exports = $978c7c7580432e24$var$isPrototype;

});

parcelRegister("9IeAN", function(module, exports) {

var $lebe5 = parcelRequire("lebe5");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $71238adda6b521ab$var$nativeKeys = $lebe5(Object.keys, Object);
module.exports = $71238adda6b521ab$var$nativeKeys;

});
parcelRegister("lebe5", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $f7439d0d03e4499c$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $f7439d0d03e4499c$var$overArg;

});



parcelRegister("cOzi7", function(module, exports) {

var $bcrSM = parcelRequire("bcrSM");

var $1zLxR = parcelRequire("1zLxR");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $954587a820e04f76$var$isArrayLike(value) {
    return value != null && $1zLxR(value.length) && !$bcrSM(value);
}
module.exports = $954587a820e04f76$var$isArrayLike;

});




parcelRegister("jaE2r", function(module, exports) {

var $2wF3n = parcelRequire("2wF3n");

var $3Gg0y = parcelRequire("3Gg0y");

var $7E9XE = parcelRequire("7E9XE");

var $kMi8Y = parcelRequire("kMi8Y");

var $tmwmG = parcelRequire("tmwmG");

var $aeQBO = parcelRequire("aeQBO");

var $9qg9x = parcelRequire("9qg9x");
/** `Object#toString` result references. */ var $df4e024223ff600d$var$mapTag = '[object Map]', $df4e024223ff600d$var$objectTag = '[object Object]', $df4e024223ff600d$var$promiseTag = '[object Promise]', $df4e024223ff600d$var$setTag = '[object Set]', $df4e024223ff600d$var$weakMapTag = '[object WeakMap]';
var $df4e024223ff600d$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $df4e024223ff600d$var$dataViewCtorString = $9qg9x($2wF3n), $df4e024223ff600d$var$mapCtorString = $9qg9x($3Gg0y), $df4e024223ff600d$var$promiseCtorString = $9qg9x($7E9XE), $df4e024223ff600d$var$setCtorString = $9qg9x($kMi8Y), $df4e024223ff600d$var$weakMapCtorString = $9qg9x($tmwmG);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $df4e024223ff600d$var$getTag = $aeQBO;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($2wF3n && $df4e024223ff600d$var$getTag(new $2wF3n(new ArrayBuffer(1))) != $df4e024223ff600d$var$dataViewTag || $3Gg0y && $df4e024223ff600d$var$getTag(new $3Gg0y) != $df4e024223ff600d$var$mapTag || $7E9XE && $df4e024223ff600d$var$getTag($7E9XE.resolve()) != $df4e024223ff600d$var$promiseTag || $kMi8Y && $df4e024223ff600d$var$getTag(new $kMi8Y) != $df4e024223ff600d$var$setTag || $tmwmG && $df4e024223ff600d$var$getTag(new $tmwmG) != $df4e024223ff600d$var$weakMapTag) $df4e024223ff600d$var$getTag = function(value) {
    var result = $aeQBO(value), Ctor = result == $df4e024223ff600d$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $9qg9x(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $df4e024223ff600d$var$dataViewCtorString:
            return $df4e024223ff600d$var$dataViewTag;
        case $df4e024223ff600d$var$mapCtorString:
            return $df4e024223ff600d$var$mapTag;
        case $df4e024223ff600d$var$promiseCtorString:
            return $df4e024223ff600d$var$promiseTag;
        case $df4e024223ff600d$var$setCtorString:
            return $df4e024223ff600d$var$setTag;
        case $df4e024223ff600d$var$weakMapCtorString:
            return $df4e024223ff600d$var$weakMapTag;
    }
    return result;
};
module.exports = $df4e024223ff600d$var$getTag;

});
parcelRegister("2wF3n", function(module, exports) {

var $8vcXv = parcelRequire("8vcXv");

var $56kZ0 = parcelRequire("56kZ0");
/* Built-in method references that are verified to be native. */ var $1d6e6a4ca8c42979$var$DataView = $8vcXv($56kZ0, 'DataView');
module.exports = $1d6e6a4ca8c42979$var$DataView;

});

parcelRegister("7E9XE", function(module, exports) {

var $8vcXv = parcelRequire("8vcXv");

var $56kZ0 = parcelRequire("56kZ0");
/* Built-in method references that are verified to be native. */ var $5913fee2ad78c741$var$Promise = $8vcXv($56kZ0, 'Promise');
module.exports = $5913fee2ad78c741$var$Promise;

});

parcelRegister("kMi8Y", function(module, exports) {

var $8vcXv = parcelRequire("8vcXv");

var $56kZ0 = parcelRequire("56kZ0");
/* Built-in method references that are verified to be native. */ var $f2065d4e7b5c19db$var$Set = $8vcXv($56kZ0, 'Set');
module.exports = $f2065d4e7b5c19db$var$Set;

});

parcelRegister("tmwmG", function(module, exports) {

var $8vcXv = parcelRequire("8vcXv");

var $56kZ0 = parcelRequire("56kZ0");
/* Built-in method references that are verified to be native. */ var $05842dc0a0cfa128$var$WeakMap = $8vcXv($56kZ0, 'WeakMap');
module.exports = $05842dc0a0cfa128$var$WeakMap;

});





parcelRegister("9EZcP", function(module, exports) {

var $yKC0q = parcelRequire("yKC0q");

var $kOHWF = parcelRequire("kOHWF");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $708753b14fcf74ec$var$getMatchData(object) {
    var result = $kOHWF(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $yKC0q(value)
        ];
    }
    return result;
}
module.exports = $708753b14fcf74ec$var$getMatchData;

});
parcelRegister("yKC0q", function(module, exports) {

var $bFI6q = parcelRequire("bFI6q");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $06875543250d288c$var$isStrictComparable(value) {
    return value === value && !$bFI6q(value);
}
module.exports = $06875543250d288c$var$isStrictComparable;

});


parcelRegister("cJDXf", function(module, exports) {

var $56kZ0 = parcelRequire("56kZ0");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $56kZ0.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("7kZ78", function(module, exports) {

var $1CHRc = parcelRequire("1CHRc");
'use strict';
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $5579cea4a4252eee$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $5579cea4a4252eee$var$MAX_UINT32 = 4294967295;

var $4EeOM = parcelRequire("4EeOM");
var $5579cea4a4252eee$require$Buffer = $4EeOM.Buffer;
var $5579cea4a4252eee$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
module.exports = function(size, cb) {
    if ($5579cea4a4252eee$var$crypto && $5579cea4a4252eee$var$crypto.getRandomValues) // browser
    return $5579cea4a4252eee$var$randomBytes(size, cb);
    else {
        if (globalThis.crypto && globalThis.crypto.randomBytes) // tesseract runtime
        return globalThis.crypto.randomBytes(size, cb);
        else // tesseract init time
        throw new Error('No randomBytes() support in current environment.');
    }
};
function $5579cea4a4252eee$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $5579cea4a4252eee$var$MAX_UINT32) throw new RangeError('requested too many random bytes');
    var bytes = $5579cea4a4252eee$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $5579cea4a4252eee$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $5579cea4a4252eee$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $5579cea4a4252eee$var$crypto.getRandomValues(bytes.slice(generated, generated + $5579cea4a4252eee$var$MAX_BYTES));
        else $5579cea4a4252eee$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === 'function') return $1CHRc.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});
parcelRegister("4EeOM", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $ekOVf = parcelRequire("ekOVf");
var $3626646b2902051d$var$Buffer = $ekOVf.Buffer;
// alternative to using Object.keys for old browsers
function $3626646b2902051d$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($3626646b2902051d$var$Buffer.from && $3626646b2902051d$var$Buffer.alloc && $3626646b2902051d$var$Buffer.allocUnsafe && $3626646b2902051d$var$Buffer.allocUnsafeSlow) module.exports = $ekOVf;
else {
    // Copy properties from require('buffer')
    $3626646b2902051d$var$copyProps($ekOVf, module.exports);
    module.exports.Buffer = $3626646b2902051d$var$SafeBuffer;
}
function $3626646b2902051d$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $3626646b2902051d$var$Buffer(arg, encodingOrOffset, length);
}
$3626646b2902051d$var$SafeBuffer.prototype = Object.create($3626646b2902051d$var$Buffer.prototype);
// Copy static methods from Buffer
$3626646b2902051d$var$copyProps($3626646b2902051d$var$Buffer, $3626646b2902051d$var$SafeBuffer);
$3626646b2902051d$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $3626646b2902051d$var$Buffer(arg, encodingOrOffset, length);
};
$3626646b2902051d$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $3626646b2902051d$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$3626646b2902051d$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $3626646b2902051d$var$Buffer(size);
};
$3626646b2902051d$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $ekOVf.SlowBuffer(size);
};

});


parcelRegister("lDOK8", function(module, exports) {
'use strict';

var $ktJSc = parcelRequire("ktJSc");

var $ioicd = parcelRequire("ioicd");

var $ixhPV = parcelRequire("ixhPV");

var $hajrJ = parcelRequire("hajrJ");

var $hCwwr = parcelRequire("hCwwr");
function $fc1499fe6436ee0d$var$Hash(hash) {
    $hCwwr.call(this, 'digest');
    this._hash = hash;
}
$ktJSc($fc1499fe6436ee0d$var$Hash, $hCwwr);
$fc1499fe6436ee0d$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$fc1499fe6436ee0d$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === 'md5') return new $ioicd();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $ixhPV();
    return new $fc1499fe6436ee0d$var$Hash($hajrJ(alg));
};

});
parcelRegister("ktJSc", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("ioicd", function(module, exports) {
'use strict';

var $ktJSc = parcelRequire("ktJSc");

var $fxuZ8 = parcelRequire("fxuZ8");

var $4EeOM = parcelRequire("4EeOM");
var $d6389539875493e7$require$Buffer = $4EeOM.Buffer;
var $d6389539875493e7$var$ARRAY16 = new Array(16);
function $d6389539875493e7$var$MD5() {
    $fxuZ8.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$ktJSc($d6389539875493e7$var$MD5, $fxuZ8);
$d6389539875493e7$var$MD5.prototype._update = function() {
    var M = $d6389539875493e7$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $d6389539875493e7$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $d6389539875493e7$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $d6389539875493e7$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $d6389539875493e7$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $d6389539875493e7$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $d6389539875493e7$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $d6389539875493e7$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $d6389539875493e7$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $d6389539875493e7$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $d6389539875493e7$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $d6389539875493e7$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $d6389539875493e7$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $d6389539875493e7$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $d6389539875493e7$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $d6389539875493e7$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $d6389539875493e7$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $d6389539875493e7$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $d6389539875493e7$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $d6389539875493e7$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $d6389539875493e7$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $d6389539875493e7$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $d6389539875493e7$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $d6389539875493e7$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $d6389539875493e7$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $d6389539875493e7$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $d6389539875493e7$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $d6389539875493e7$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $d6389539875493e7$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $d6389539875493e7$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $d6389539875493e7$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $d6389539875493e7$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $d6389539875493e7$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $d6389539875493e7$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $d6389539875493e7$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $d6389539875493e7$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $d6389539875493e7$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $d6389539875493e7$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $d6389539875493e7$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $d6389539875493e7$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $d6389539875493e7$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $d6389539875493e7$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $d6389539875493e7$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $d6389539875493e7$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $d6389539875493e7$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $d6389539875493e7$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $d6389539875493e7$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $d6389539875493e7$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $d6389539875493e7$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $d6389539875493e7$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $d6389539875493e7$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $d6389539875493e7$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $d6389539875493e7$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $d6389539875493e7$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $d6389539875493e7$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $d6389539875493e7$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $d6389539875493e7$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $d6389539875493e7$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $d6389539875493e7$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $d6389539875493e7$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $d6389539875493e7$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $d6389539875493e7$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $d6389539875493e7$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $d6389539875493e7$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $d6389539875493e7$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$d6389539875493e7$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $d6389539875493e7$require$Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $d6389539875493e7$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $d6389539875493e7$var$fnF(a, b, c, d, m, k, s) {
    return $d6389539875493e7$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $d6389539875493e7$var$fnG(a, b, c, d, m, k, s) {
    return $d6389539875493e7$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $d6389539875493e7$var$fnH(a, b, c, d, m, k, s) {
    return $d6389539875493e7$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $d6389539875493e7$var$fnI(a, b, c, d, m, k, s) {
    return $d6389539875493e7$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $d6389539875493e7$var$MD5;

});
parcelRegister("fxuZ8", function(module, exports) {
'use strict';

var $4EeOM = parcelRequire("4EeOM");
var $b501f90e542ed34a$require$Buffer = $4EeOM.Buffer;

var $cKOMr = parcelRequire("cKOMr");
var $b501f90e542ed34a$require$Transform = $cKOMr.Transform;

var $ktJSc = parcelRequire("ktJSc");
function $b501f90e542ed34a$var$HashBase(blockSize) {
    $b501f90e542ed34a$require$Transform.call(this);
    this._block = $b501f90e542ed34a$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$ktJSc($b501f90e542ed34a$var$HashBase, $b501f90e542ed34a$require$Transform);
$b501f90e542ed34a$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$b501f90e542ed34a$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
var $b501f90e542ed34a$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $b501f90e542ed34a$var$useArrayBuffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && ArrayBuffer.isView && ($b501f90e542ed34a$require$Buffer.prototype instanceof Uint8Array || $b501f90e542ed34a$require$Buffer.TYPED_ARRAY_SUPPORT);
function $b501f90e542ed34a$var$toBuffer(data, encoding) {
    // No need to do anything for exact instance
    // This is only valid when safe-buffer.Buffer === buffer.Buffer, i.e. when Buffer.from/Buffer.alloc existed
    if (data instanceof $b501f90e542ed34a$require$Buffer) return data;
    // Convert strings to Buffer
    if (typeof data === 'string') return $b501f90e542ed34a$require$Buffer.from(data, encoding);
    /*
   * Wrap any TypedArray instances and DataViews
   * Makes sense only on engines with full TypedArray support -- let Buffer detect that
   */ if ($b501f90e542ed34a$var$useArrayBuffer && ArrayBuffer.isView(data)) {
        if (data.byteLength === 0) return $b501f90e542ed34a$require$Buffer.alloc(0) // Bug in Node.js <6.3.1, which treats this as out-of-bounds
        ;
        var res = $b501f90e542ed34a$require$Buffer.from(data.buffer, data.byteOffset, data.byteLength);
        // Recheck result size, as offset/length doesn't work on Node.js <5.10
        // We just go to Uint8Array case if this fails
        if (res.byteLength === data.byteLength) return res;
    }
    /*
   * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
   * Doesn't make sense with other TypedArray instances
   */ if ($b501f90e542ed34a$var$useUint8Array && data instanceof Uint8Array) return $b501f90e542ed34a$require$Buffer.from(data);
    /*
   * Old Buffer polyfill on an engine that doesn't have TypedArray support
   * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
   * Convert to our current Buffer implementation
   */ if ($b501f90e542ed34a$require$Buffer.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer === 'function' && data.constructor.isBuffer(data)) return $b501f90e542ed34a$require$Buffer.from(data);
    throw new TypeError('The "data" argument must be of type string or an instance of Buffer, TypedArray, or DataView.');
}
$b501f90e542ed34a$var$HashBase.prototype.update = function(data, encoding) {
    if (this._finalized) throw new Error('Digest already called');
    data = $b501f90e542ed34a$var$toBuffer(data, encoding) // asserts correct input type
    ;
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$b501f90e542ed34a$var$HashBase.prototype._update = function() {
    throw new Error('_update is not implemented');
};
$b501f90e542ed34a$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$b501f90e542ed34a$var$HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
module.exports = $b501f90e542ed34a$var$HashBase;

});
parcelRegister("cKOMr", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $94912bcd9038ca42$var$Stream;

var $3V23I = parcelRequire("3V23I");
var $94912bcd9038ca42$require$EE = $3V23I.EventEmitter;

var $ktJSc = parcelRequire("ktJSc");
$ktJSc($94912bcd9038ca42$var$Stream, $94912bcd9038ca42$require$EE);

$94912bcd9038ca42$var$Stream.Readable = (parcelRequire("alFyf"));

$94912bcd9038ca42$var$Stream.Writable = (parcelRequire("fFwf0"));

$94912bcd9038ca42$var$Stream.Duplex = (parcelRequire("7n5mG"));

$94912bcd9038ca42$var$Stream.Transform = (parcelRequire("3RAPb"));

$94912bcd9038ca42$var$Stream.PassThrough = (parcelRequire("ermgP"));

$94912bcd9038ca42$var$Stream.finished = (parcelRequire("7Stfq"));

$94912bcd9038ca42$var$Stream.pipeline = (parcelRequire("fn4Y0"));
// Backwards-compat with node 0.4.x
$94912bcd9038ca42$var$Stream.Stream = $94912bcd9038ca42$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $94912bcd9038ca42$var$Stream() {
    $94912bcd9038ca42$require$EE.call(this);
}
$94912bcd9038ca42$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($94912bcd9038ca42$require$EE.listenerCount(this, 'error') === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on('error', onerror);
    dest.on('error', onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});
parcelRegister("3V23I", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $2da84ad46ea793b9$var$R = typeof Reflect === 'object' ? Reflect : null;
var $2da84ad46ea793b9$var$ReflectApply = $2da84ad46ea793b9$var$R && typeof $2da84ad46ea793b9$var$R.apply === 'function' ? $2da84ad46ea793b9$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $2da84ad46ea793b9$var$ReflectOwnKeys;
if ($2da84ad46ea793b9$var$R && typeof $2da84ad46ea793b9$var$R.ownKeys === 'function') $2da84ad46ea793b9$var$ReflectOwnKeys = $2da84ad46ea793b9$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $2da84ad46ea793b9$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $2da84ad46ea793b9$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $2da84ad46ea793b9$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $2da84ad46ea793b9$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $2da84ad46ea793b9$var$EventEmitter() {
    $2da84ad46ea793b9$var$EventEmitter.init.call(this);
}
module.exports = $2da84ad46ea793b9$var$EventEmitter;
module.exports.once = $2da84ad46ea793b9$var$once;
// Backwards-compat with node 0.10.x
$2da84ad46ea793b9$var$EventEmitter.EventEmitter = $2da84ad46ea793b9$var$EventEmitter;
$2da84ad46ea793b9$var$EventEmitter.prototype._events = undefined;
$2da84ad46ea793b9$var$EventEmitter.prototype._eventsCount = 0;
$2da84ad46ea793b9$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $2da84ad46ea793b9$var$defaultMaxListeners = 10;
function $2da84ad46ea793b9$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($2da84ad46ea793b9$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $2da84ad46ea793b9$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $2da84ad46ea793b9$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $2da84ad46ea793b9$var$defaultMaxListeners = arg;
    }
});
$2da84ad46ea793b9$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$2da84ad46ea793b9$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $2da84ad46ea793b9$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $2da84ad46ea793b9$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $2da84ad46ea793b9$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$2da84ad46ea793b9$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $2da84ad46ea793b9$var$_getMaxListeners(this);
};
$2da84ad46ea793b9$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $2da84ad46ea793b9$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $2da84ad46ea793b9$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$2da84ad46ea793b9$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $2da84ad46ea793b9$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $2da84ad46ea793b9$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $2da84ad46ea793b9$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $2da84ad46ea793b9$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$2da84ad46ea793b9$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $2da84ad46ea793b9$var$_addListener(this, type, listener, false);
};
$2da84ad46ea793b9$var$EventEmitter.prototype.on = $2da84ad46ea793b9$var$EventEmitter.prototype.addListener;
$2da84ad46ea793b9$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $2da84ad46ea793b9$var$_addListener(this, type, listener, true);
};
function $2da84ad46ea793b9$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $2da84ad46ea793b9$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $2da84ad46ea793b9$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$2da84ad46ea793b9$var$EventEmitter.prototype.once = function once(type, listener) {
    $2da84ad46ea793b9$var$checkListener(listener);
    this.on(type, $2da84ad46ea793b9$var$_onceWrap(this, type, listener));
    return this;
};
$2da84ad46ea793b9$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $2da84ad46ea793b9$var$checkListener(listener);
    this.prependListener(type, $2da84ad46ea793b9$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$2da84ad46ea793b9$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $2da84ad46ea793b9$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $2da84ad46ea793b9$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$2da84ad46ea793b9$var$EventEmitter.prototype.off = $2da84ad46ea793b9$var$EventEmitter.prototype.removeListener;
$2da84ad46ea793b9$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $2da84ad46ea793b9$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $2da84ad46ea793b9$var$unwrapListeners(evlistener) : $2da84ad46ea793b9$var$arrayClone(evlistener, evlistener.length);
}
$2da84ad46ea793b9$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $2da84ad46ea793b9$var$_listeners(this, type, true);
};
$2da84ad46ea793b9$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $2da84ad46ea793b9$var$_listeners(this, type, false);
};
$2da84ad46ea793b9$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $2da84ad46ea793b9$var$listenerCount.call(emitter, type);
};
$2da84ad46ea793b9$var$EventEmitter.prototype.listenerCount = $2da84ad46ea793b9$var$listenerCount;
function $2da84ad46ea793b9$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$2da84ad46ea793b9$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $2da84ad46ea793b9$var$ReflectOwnKeys(this._events) : [];
};
function $2da84ad46ea793b9$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $2da84ad46ea793b9$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $2da84ad46ea793b9$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $2da84ad46ea793b9$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $2da84ad46ea793b9$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $2da84ad46ea793b9$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $2da84ad46ea793b9$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $2da84ad46ea793b9$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $2da84ad46ea793b9$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("alFyf", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $1CHRc = parcelRequire("1CHRc");
'use strict';
module.exports = $01f1be55cb760751$var$Readable;
/*<replacement>*/ var $01f1be55cb760751$var$Duplex;
/*</replacement>*/ $01f1be55cb760751$var$Readable.ReadableState = $01f1be55cb760751$var$ReadableState;

var $3V23I = parcelRequire("3V23I");
var $01f1be55cb760751$require$EE = $3V23I.EventEmitter;
var $01f1be55cb760751$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $lR6aH = parcelRequire("lR6aH");

var $ekOVf = parcelRequire("ekOVf");
var $01f1be55cb760751$require$Buffer = $ekOVf.Buffer;
var $01f1be55cb760751$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $01f1be55cb760751$var$_uint8ArrayToBuffer(chunk) {
    return $01f1be55cb760751$require$Buffer.from(chunk);
}
function $01f1be55cb760751$var$_isUint8Array(obj) {
    return $01f1be55cb760751$require$Buffer.isBuffer(obj) || obj instanceof $01f1be55cb760751$var$OurUint8Array;
}

var $2DlfF = parcelRequire("2DlfF");
var $01f1be55cb760751$var$debug;
if ($2DlfF && $2DlfF.debuglog) $01f1be55cb760751$var$debug = $2DlfF.debuglog('stream');
else $01f1be55cb760751$var$debug = function debug() {};

var $hLr18 = parcelRequire("hLr18");

var $7uGJU = parcelRequire("7uGJU");

var $bStML = parcelRequire("bStML");
var $01f1be55cb760751$var$getHighWaterMark = $bStML.getHighWaterMark;

var $dTh3w = parcelRequire("dTh3w");
var $01f1be55cb760751$require$_require$codes = $dTh3w.codes;
var $01f1be55cb760751$var$ERR_INVALID_ARG_TYPE = $01f1be55cb760751$require$_require$codes.ERR_INVALID_ARG_TYPE, $01f1be55cb760751$var$ERR_STREAM_PUSH_AFTER_EOF = $01f1be55cb760751$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $01f1be55cb760751$var$ERR_METHOD_NOT_IMPLEMENTED = $01f1be55cb760751$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $01f1be55cb760751$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $01f1be55cb760751$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $01f1be55cb760751$var$StringDecoder;
var $01f1be55cb760751$var$createReadableStreamAsyncIterator;
var $01f1be55cb760751$var$from;

(parcelRequire("ktJSc"))($01f1be55cb760751$var$Readable, $lR6aH);
var $01f1be55cb760751$var$errorOrDestroy = $7uGJU.errorOrDestroy;
var $01f1be55cb760751$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $01f1be55cb760751$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $01f1be55cb760751$var$ReadableState(options, stream, isDuplex) {
    $01f1be55cb760751$var$Duplex = $01f1be55cb760751$var$Duplex || (parcelRequire("7n5mG"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $01f1be55cb760751$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $01f1be55cb760751$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $hLr18();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$01f1be55cb760751$var$StringDecoder) $01f1be55cb760751$var$StringDecoder = (parcelRequire("8PrxV")).StringDecoder;
        this.decoder = new $01f1be55cb760751$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $01f1be55cb760751$var$Readable(options) {
    $01f1be55cb760751$var$Duplex = $01f1be55cb760751$var$Duplex || (parcelRequire("7n5mG"));
    if (!(this instanceof $01f1be55cb760751$var$Readable)) return new $01f1be55cb760751$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $01f1be55cb760751$var$Duplex;
    this._readableState = new $01f1be55cb760751$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $lR6aH.call(this);
}
Object.defineProperty($01f1be55cb760751$var$Readable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$01f1be55cb760751$var$Readable.prototype.destroy = $7uGJU.destroy;
$01f1be55cb760751$var$Readable.prototype._undestroy = $7uGJU.undestroy;
$01f1be55cb760751$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$01f1be55cb760751$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $01f1be55cb760751$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $01f1be55cb760751$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$01f1be55cb760751$var$Readable.prototype.unshift = function(chunk) {
    return $01f1be55cb760751$var$readableAddChunk(this, chunk, null, true, false);
};
function $01f1be55cb760751$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $01f1be55cb760751$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $01f1be55cb760751$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $01f1be55cb760751$var$chunkInvalid(state, chunk);
        if (er) $01f1be55cb760751$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $01f1be55cb760751$require$Buffer.prototype) chunk = $01f1be55cb760751$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $01f1be55cb760751$var$errorOrDestroy(stream, new $01f1be55cb760751$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $01f1be55cb760751$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $01f1be55cb760751$var$errorOrDestroy(stream, new $01f1be55cb760751$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $01f1be55cb760751$var$addChunk(stream, state, chunk, false);
                    else $01f1be55cb760751$var$maybeReadMore(stream, state);
                } else $01f1be55cb760751$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $01f1be55cb760751$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $01f1be55cb760751$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit('data', chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $01f1be55cb760751$var$emitReadable(stream);
    }
    $01f1be55cb760751$var$maybeReadMore(stream, state);
}
function $01f1be55cb760751$var$chunkInvalid(state, chunk) {
    var er;
    if (!$01f1be55cb760751$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new $01f1be55cb760751$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer',
        'Uint8Array'
    ], chunk);
    return er;
}
$01f1be55cb760751$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$01f1be55cb760751$var$Readable.prototype.setEncoding = function(enc) {
    if (!$01f1be55cb760751$var$StringDecoder) $01f1be55cb760751$var$StringDecoder = (parcelRequire("8PrxV")).StringDecoder;
    var decoder = new $01f1be55cb760751$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = '';
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== '') this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $01f1be55cb760751$var$MAX_HWM = 0x40000000;
function $01f1be55cb760751$var$computeNewHighWaterMark(n) {
    if (n >= $01f1be55cb760751$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $01f1be55cb760751$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $01f1be55cb760751$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $01f1be55cb760751$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$01f1be55cb760751$var$Readable.prototype.read = function(n) {
    $01f1be55cb760751$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $01f1be55cb760751$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $01f1be55cb760751$var$endReadable(this);
        else $01f1be55cb760751$var$emitReadable(this);
        return null;
    }
    n = $01f1be55cb760751$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $01f1be55cb760751$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $01f1be55cb760751$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $01f1be55cb760751$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $01f1be55cb760751$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $01f1be55cb760751$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $01f1be55cb760751$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $01f1be55cb760751$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $01f1be55cb760751$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $01f1be55cb760751$var$onEofChunk(stream, state) {
    $01f1be55cb760751$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $01f1be55cb760751$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $01f1be55cb760751$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $01f1be55cb760751$var$emitReadable(stream) {
    var state = stream._readableState;
    $01f1be55cb760751$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $01f1be55cb760751$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $1CHRc.nextTick($01f1be55cb760751$var$emitReadable_, stream);
    }
}
function $01f1be55cb760751$var$emitReadable_(stream) {
    var state = stream._readableState;
    $01f1be55cb760751$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $01f1be55cb760751$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $01f1be55cb760751$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $1CHRc.nextTick($01f1be55cb760751$var$maybeReadMore_, stream, state);
    }
}
function $01f1be55cb760751$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $01f1be55cb760751$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$01f1be55cb760751$var$Readable.prototype._read = function(n) {
    $01f1be55cb760751$var$errorOrDestroy(this, new $01f1be55cb760751$var$ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
$01f1be55cb760751$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $01f1be55cb760751$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $1CHRc.stdout && dest !== $1CHRc.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $1CHRc.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $01f1be55cb760751$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $01f1be55cb760751$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $01f1be55cb760751$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $01f1be55cb760751$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $01f1be55cb760751$var$debug('ondata');
        var ret = dest.write(chunk);
        $01f1be55cb760751$var$debug('dest.write', ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $01f1be55cb760751$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $01f1be55cb760751$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $01f1be55cb760751$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($01f1be55cb760751$var$EElistenerCount(dest, 'error') === 0) $01f1be55cb760751$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $01f1be55cb760751$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $01f1be55cb760751$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $01f1be55cb760751$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $01f1be55cb760751$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $01f1be55cb760751$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $01f1be55cb760751$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $01f1be55cb760751$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $01f1be55cb760751$var$flow(src);
        }
    };
}
$01f1be55cb760751$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $01f1be55cb760751$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$01f1be55cb760751$var$Readable.prototype.on = function(ev, fn) {
    var res = $lR6aH.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $01f1be55cb760751$var$debug('on readable', state.length, state.reading);
            if (state.length) $01f1be55cb760751$var$emitReadable(this);
            else if (!state.reading) $1CHRc.nextTick($01f1be55cb760751$var$nReadingNextTick, this);
        }
    }
    return res;
};
$01f1be55cb760751$var$Readable.prototype.addListener = $01f1be55cb760751$var$Readable.prototype.on;
$01f1be55cb760751$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $lR6aH.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $1CHRc.nextTick($01f1be55cb760751$var$updateReadableListening, this);
    return res;
};
$01f1be55cb760751$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $lR6aH.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $1CHRc.nextTick($01f1be55cb760751$var$updateReadableListening, this);
    return res;
};
function $01f1be55cb760751$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount('readable') > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount('data') > 0) self1.resume();
}
function $01f1be55cb760751$var$nReadingNextTick(self1) {
    $01f1be55cb760751$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$01f1be55cb760751$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $01f1be55cb760751$var$debug('resume');
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $01f1be55cb760751$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $01f1be55cb760751$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $1CHRc.nextTick($01f1be55cb760751$var$resume_, stream, state);
    }
}
function $01f1be55cb760751$var$resume_(stream, state) {
    $01f1be55cb760751$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $01f1be55cb760751$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$01f1be55cb760751$var$Readable.prototype.pause = function() {
    $01f1be55cb760751$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $01f1be55cb760751$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState.paused = true;
    return this;
};
function $01f1be55cb760751$var$flow(stream) {
    var state = stream._readableState;
    $01f1be55cb760751$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$01f1be55cb760751$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $01f1be55cb760751$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $01f1be55cb760751$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $01f1be55cb760751$var$kProxyEvents.length; n++)stream.on($01f1be55cb760751$var$kProxyEvents[n], this.emit.bind(this, $01f1be55cb760751$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $01f1be55cb760751$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === 'function') $01f1be55cb760751$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($01f1be55cb760751$var$createReadableStreamAsyncIterator === undefined) $01f1be55cb760751$var$createReadableStreamAsyncIterator = (parcelRequire("cunJG"));
    return $01f1be55cb760751$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($01f1be55cb760751$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($01f1be55cb760751$var$Readable.prototype, 'readableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($01f1be55cb760751$var$Readable.prototype, 'readableFlowing', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$01f1be55cb760751$var$Readable._fromList = $01f1be55cb760751$var$fromList;
Object.defineProperty($01f1be55cb760751$var$Readable.prototype, 'readableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $01f1be55cb760751$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $01f1be55cb760751$var$endReadable(stream) {
    var state = stream._readableState;
    $01f1be55cb760751$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $1CHRc.nextTick($01f1be55cb760751$var$endReadableNT, state, stream);
    }
}
function $01f1be55cb760751$var$endReadableNT(state, stream) {
    $01f1be55cb760751$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === 'function') $01f1be55cb760751$var$Readable.from = function(iterable, opts) {
    if ($01f1be55cb760751$var$from === undefined) $01f1be55cb760751$var$from = (parcelRequire("liwP3"));
    return $01f1be55cb760751$var$from($01f1be55cb760751$var$Readable, iterable, opts);
};
function $01f1be55cb760751$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("lR6aH", function(module, exports) {

module.exports = (parcelRequire("3V23I")).EventEmitter;

});

parcelRegister("hLr18", function(module, exports) {
'use strict';
function $ceebc884a2a99ae4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ceebc884a2a99ae4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $ceebc884a2a99ae4$var$ownKeys(Object(source), !0).forEach(function(key) {
            $ceebc884a2a99ae4$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $ceebc884a2a99ae4$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ceebc884a2a99ae4$var$_defineProperty(obj, key, value) {
    key = $ceebc884a2a99ae4$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ceebc884a2a99ae4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ceebc884a2a99ae4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $ceebc884a2a99ae4$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $ceebc884a2a99ae4$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ceebc884a2a99ae4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ceebc884a2a99ae4$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $ceebc884a2a99ae4$var$_toPropertyKey(arg) {
    var key = $ceebc884a2a99ae4$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $ceebc884a2a99ae4$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $ekOVf = parcelRequire("ekOVf");
var $ceebc884a2a99ae4$var$Buffer = $ekOVf.Buffer;

var $2DlfF = parcelRequire("2DlfF");
var $ceebc884a2a99ae4$var$inspect = $2DlfF.inspect;
var $ceebc884a2a99ae4$var$custom = $ceebc884a2a99ae4$var$inspect && $ceebc884a2a99ae4$var$inspect.custom || 'inspect';
function $ceebc884a2a99ae4$var$copyBuffer(src, target, offset) {
    $ceebc884a2a99ae4$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $ceebc884a2a99ae4$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $ceebc884a2a99ae4$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $ceebc884a2a99ae4$var$Buffer.alloc(0);
                var ret = $ceebc884a2a99ae4$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $ceebc884a2a99ae4$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $ceebc884a2a99ae4$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $ceebc884a2a99ae4$var$custom,
            value: function value(_, options) {
                return $ceebc884a2a99ae4$var$inspect(this, $ceebc884a2a99ae4$var$_objectSpread($ceebc884a2a99ae4$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("7uGJU", function(module, exports) {

var $1CHRc = parcelRequire("1CHRc");
'use strict';
// undocumented cb() API, needed for core, not for public API
function $574c7ce600c62036$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $1CHRc.nextTick($574c7ce600c62036$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $1CHRc.nextTick($574c7ce600c62036$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $1CHRc.nextTick($574c7ce600c62036$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $1CHRc.nextTick($574c7ce600c62036$var$emitErrorAndCloseNT, _this, err);
            } else $1CHRc.nextTick($574c7ce600c62036$var$emitCloseNT, _this);
        } else if (cb) {
            $1CHRc.nextTick($574c7ce600c62036$var$emitCloseNT, _this);
            cb(err);
        } else $1CHRc.nextTick($574c7ce600c62036$var$emitCloseNT, _this);
    });
    return this;
}
function $574c7ce600c62036$var$emitErrorAndCloseNT(self, err) {
    $574c7ce600c62036$var$emitErrorNT(self, err);
    $574c7ce600c62036$var$emitCloseNT(self);
}
function $574c7ce600c62036$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit('close');
}
function $574c7ce600c62036$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $574c7ce600c62036$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
function $574c7ce600c62036$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit('error', err);
}
module.exports = {
    destroy: $574c7ce600c62036$var$destroy,
    undestroy: $574c7ce600c62036$var$undestroy,
    errorOrDestroy: $574c7ce600c62036$var$errorOrDestroy
};

});

parcelRegister("bStML", function(module, exports) {
'use strict';

var $8a5bd79feb84fba1$var$ERR_INVALID_OPT_VALUE = (parcelRequire("dTh3w")).codes.ERR_INVALID_OPT_VALUE;
function $8a5bd79feb84fba1$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $8a5bd79feb84fba1$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $8a5bd79feb84fba1$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : 'highWaterMark';
            throw new $8a5bd79feb84fba1$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $8a5bd79feb84fba1$var$getHighWaterMark
};

});
parcelRegister("dTh3w", function(module, exports) {
$parcel$export(module.exports, "codes", () => $a1cda4593cacb229$export$e45cb6485273080e, (v) => $a1cda4593cacb229$export$e45cb6485273080e = v);
var $a1cda4593cacb229$export$e45cb6485273080e;
'use strict';
function $a1cda4593cacb229$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $a1cda4593cacb229$var$codes = {};
function $a1cda4593cacb229$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $a1cda4593cacb229$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $a1cda4593cacb229$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $a1cda4593cacb229$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $a1cda4593cacb229$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $a1cda4593cacb229$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $a1cda4593cacb229$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$a1cda4593cacb229$var$createErrorType('ERR_INVALID_OPT_VALUE', function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$a1cda4593cacb229$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $a1cda4593cacb229$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($a1cda4593cacb229$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($a1cda4593cacb229$var$oneOf(expected, 'type'));
    else {
        var type = $a1cda4593cacb229$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($a1cda4593cacb229$var$oneOf(expected, 'type'));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$a1cda4593cacb229$var$createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
$a1cda4593cacb229$var$createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function(name) {
    return 'The ' + name + ' method is not implemented';
});
$a1cda4593cacb229$var$createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
$a1cda4593cacb229$var$createErrorType('ERR_STREAM_DESTROYED', function(name) {
    return 'Cannot call ' + name + ' after a stream was destroyed';
});
$a1cda4593cacb229$var$createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
$a1cda4593cacb229$var$createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
$a1cda4593cacb229$var$createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
$a1cda4593cacb229$var$createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$a1cda4593cacb229$var$createErrorType('ERR_UNKNOWN_ENCODING', function(arg) {
    return 'Unknown encoding: ' + arg;
}, TypeError);
$a1cda4593cacb229$var$createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
$a1cda4593cacb229$export$e45cb6485273080e = $a1cda4593cacb229$var$codes;

});


parcelRegister("7n5mG", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $1CHRc = parcelRequire("1CHRc");
'use strict';
/*<replacement>*/ var $55ded7c0ac1aa9c7$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $55ded7c0ac1aa9c7$var$Duplex;

var $alFyf = parcelRequire("alFyf");

var $fFwf0 = parcelRequire("fFwf0");

(parcelRequire("ktJSc"))($55ded7c0ac1aa9c7$var$Duplex, $alFyf);
// Allow the keys array to be GC'ed.
var $55ded7c0ac1aa9c7$var$keys = $55ded7c0ac1aa9c7$var$objectKeys($fFwf0.prototype);
for(var $55ded7c0ac1aa9c7$var$v = 0; $55ded7c0ac1aa9c7$var$v < $55ded7c0ac1aa9c7$var$keys.length; $55ded7c0ac1aa9c7$var$v++){
    var $55ded7c0ac1aa9c7$var$method = $55ded7c0ac1aa9c7$var$keys[$55ded7c0ac1aa9c7$var$v];
    if (!$55ded7c0ac1aa9c7$var$Duplex.prototype[$55ded7c0ac1aa9c7$var$method]) $55ded7c0ac1aa9c7$var$Duplex.prototype[$55ded7c0ac1aa9c7$var$method] = $fFwf0.prototype[$55ded7c0ac1aa9c7$var$method];
}
function $55ded7c0ac1aa9c7$var$Duplex(options) {
    if (!(this instanceof $55ded7c0ac1aa9c7$var$Duplex)) return new $55ded7c0ac1aa9c7$var$Duplex(options);
    $alFyf.call(this, options);
    $fFwf0.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once('end', $55ded7c0ac1aa9c7$var$onend);
        }
    }
}
Object.defineProperty($55ded7c0ac1aa9c7$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($55ded7c0ac1aa9c7$var$Duplex.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($55ded7c0ac1aa9c7$var$Duplex.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $55ded7c0ac1aa9c7$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $1CHRc.nextTick($55ded7c0ac1aa9c7$var$onEndNT, this);
}
function $55ded7c0ac1aa9c7$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($55ded7c0ac1aa9c7$var$Duplex.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("fFwf0", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $1CHRc = parcelRequire("1CHRc");
'use strict';
module.exports = $b683b1bae0671690$var$Writable;
/* <replacement> */ function $b683b1bae0671690$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $b683b1bae0671690$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $b683b1bae0671690$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $b683b1bae0671690$var$Duplex;
/*</replacement>*/ $b683b1bae0671690$var$Writable.WritableState = $b683b1bae0671690$var$WritableState;

/*<replacement>*/ var $b683b1bae0671690$var$internalUtil = {
    deprecate: (parcelRequire("9hK5W"))
};

var $lR6aH = parcelRequire("lR6aH");

var $ekOVf = parcelRequire("ekOVf");
var $b683b1bae0671690$require$Buffer = $ekOVf.Buffer;
var $b683b1bae0671690$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $b683b1bae0671690$var$_uint8ArrayToBuffer(chunk) {
    return $b683b1bae0671690$require$Buffer.from(chunk);
}
function $b683b1bae0671690$var$_isUint8Array(obj) {
    return $b683b1bae0671690$require$Buffer.isBuffer(obj) || obj instanceof $b683b1bae0671690$var$OurUint8Array;
}

var $7uGJU = parcelRequire("7uGJU");

var $bStML = parcelRequire("bStML");
var $b683b1bae0671690$var$getHighWaterMark = $bStML.getHighWaterMark;

var $dTh3w = parcelRequire("dTh3w");
var $b683b1bae0671690$require$_require$codes = $dTh3w.codes;
var $b683b1bae0671690$var$ERR_INVALID_ARG_TYPE = $b683b1bae0671690$require$_require$codes.ERR_INVALID_ARG_TYPE, $b683b1bae0671690$var$ERR_METHOD_NOT_IMPLEMENTED = $b683b1bae0671690$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $b683b1bae0671690$var$ERR_MULTIPLE_CALLBACK = $b683b1bae0671690$require$_require$codes.ERR_MULTIPLE_CALLBACK, $b683b1bae0671690$var$ERR_STREAM_CANNOT_PIPE = $b683b1bae0671690$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $b683b1bae0671690$var$ERR_STREAM_DESTROYED = $b683b1bae0671690$require$_require$codes.ERR_STREAM_DESTROYED, $b683b1bae0671690$var$ERR_STREAM_NULL_VALUES = $b683b1bae0671690$require$_require$codes.ERR_STREAM_NULL_VALUES, $b683b1bae0671690$var$ERR_STREAM_WRITE_AFTER_END = $b683b1bae0671690$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $b683b1bae0671690$var$ERR_UNKNOWN_ENCODING = $b683b1bae0671690$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $b683b1bae0671690$var$errorOrDestroy = $7uGJU.errorOrDestroy;

(parcelRequire("ktJSc"))($b683b1bae0671690$var$Writable, $lR6aH);
function $b683b1bae0671690$var$nop() {}

function $b683b1bae0671690$var$WritableState(options, stream, isDuplex) {
    $b683b1bae0671690$var$Duplex = $b683b1bae0671690$var$Duplex || (parcelRequire("7n5mG"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $b683b1bae0671690$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $b683b1bae0671690$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $b683b1bae0671690$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $b683b1bae0671690$var$CorkedRequest(this);
}
$b683b1bae0671690$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($b683b1bae0671690$var$WritableState.prototype, 'buffer', {
            get: $b683b1bae0671690$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $b683b1bae0671690$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $b683b1bae0671690$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($b683b1bae0671690$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($b683b1bae0671690$var$realHasInstance.call(this, object)) return true;
            if (this !== $b683b1bae0671690$var$Writable) return false;
            return object && object._writableState instanceof $b683b1bae0671690$var$WritableState;
        }
    });
} else $b683b1bae0671690$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $b683b1bae0671690$var$Writable(options) {
    $b683b1bae0671690$var$Duplex = $b683b1bae0671690$var$Duplex || (parcelRequire("7n5mG"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $b683b1bae0671690$var$Duplex;
    if (!isDuplex && !$b683b1bae0671690$var$realHasInstance.call($b683b1bae0671690$var$Writable, this)) return new $b683b1bae0671690$var$Writable(options);
    this._writableState = new $b683b1bae0671690$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $lR6aH.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$b683b1bae0671690$var$Writable.prototype.pipe = function() {
    $b683b1bae0671690$var$errorOrDestroy(this, new $b683b1bae0671690$var$ERR_STREAM_CANNOT_PIPE());
};
function $b683b1bae0671690$var$writeAfterEnd(stream, cb) {
    var er = new $b683b1bae0671690$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $b683b1bae0671690$var$errorOrDestroy(stream, er);
    $1CHRc.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $b683b1bae0671690$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $b683b1bae0671690$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== 'string' && !state.objectMode) er = new $b683b1bae0671690$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer'
    ], chunk);
    if (er) {
        $b683b1bae0671690$var$errorOrDestroy(stream, er);
        $1CHRc.nextTick(cb, er);
        return false;
    }
    return true;
}
$b683b1bae0671690$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $b683b1bae0671690$var$_isUint8Array(chunk);
    if (isBuf && !$b683b1bae0671690$require$Buffer.isBuffer(chunk)) chunk = $b683b1bae0671690$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $b683b1bae0671690$var$nop;
    if (state.ending) $b683b1bae0671690$var$writeAfterEnd(this, cb);
    else if (isBuf || $b683b1bae0671690$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $b683b1bae0671690$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$b683b1bae0671690$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$b683b1bae0671690$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $b683b1bae0671690$var$clearBuffer(this, state);
    }
};
$b683b1bae0671690$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new $b683b1bae0671690$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($b683b1bae0671690$var$Writable.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $b683b1bae0671690$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $b683b1bae0671690$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($b683b1bae0671690$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $b683b1bae0671690$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $b683b1bae0671690$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $b683b1bae0671690$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $b683b1bae0671690$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $b683b1bae0671690$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $b683b1bae0671690$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $1CHRc.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $1CHRc.nextTick($b683b1bae0671690$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $b683b1bae0671690$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $b683b1bae0671690$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $b683b1bae0671690$var$finishMaybe(stream, state);
    }
}
function $b683b1bae0671690$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $b683b1bae0671690$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') throw new $b683b1bae0671690$var$ERR_MULTIPLE_CALLBACK();
    $b683b1bae0671690$var$onwriteStateUpdate(state);
    if (er) $b683b1bae0671690$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $b683b1bae0671690$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $b683b1bae0671690$var$clearBuffer(stream, state);
        if (sync) $1CHRc.nextTick($b683b1bae0671690$var$afterWrite, stream, state, finished, cb);
        else $b683b1bae0671690$var$afterWrite(stream, state, finished, cb);
    }
}
function $b683b1bae0671690$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $b683b1bae0671690$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $b683b1bae0671690$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $b683b1bae0671690$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $b683b1bae0671690$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $b683b1bae0671690$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $b683b1bae0671690$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $b683b1bae0671690$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$b683b1bae0671690$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $b683b1bae0671690$var$ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
$b683b1bae0671690$var$Writable.prototype._writev = null;
$b683b1bae0671690$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $b683b1bae0671690$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($b683b1bae0671690$var$Writable.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $b683b1bae0671690$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $b683b1bae0671690$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $b683b1bae0671690$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit('prefinish');
        $b683b1bae0671690$var$finishMaybe(stream, state);
    });
}
function $b683b1bae0671690$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $1CHRc.nextTick($b683b1bae0671690$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $b683b1bae0671690$var$finishMaybe(stream, state) {
    var need = $b683b1bae0671690$var$needFinish(state);
    if (need) {
        $b683b1bae0671690$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $b683b1bae0671690$var$endWritable(stream, state, cb) {
    state.ending = true;
    $b683b1bae0671690$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $1CHRc.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $b683b1bae0671690$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($b683b1bae0671690$var$Writable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$b683b1bae0671690$var$Writable.prototype.destroy = $7uGJU.destroy;
$b683b1bae0671690$var$Writable.prototype._undestroy = $7uGJU.undestroy;
$b683b1bae0671690$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("9hK5W", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $6c29750c788258b5$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $6c29750c788258b5$var$deprecate(fn, msg) {
    if ($6c29750c788258b5$var$config('noDeprecation')) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($6c29750c788258b5$var$config('throwDeprecation')) throw new Error(msg);
            else if ($6c29750c788258b5$var$config('traceDeprecation')) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $6c29750c788258b5$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === 'true';
}

});



parcelRegister("8PrxV", function(module, exports) {
$parcel$export(module.exports, "StringDecoder", () => $66d87444173cd9d2$export$63a7aa211a91ed69, (v) => $66d87444173cd9d2$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $66d87444173cd9d2$export$63a7aa211a91ed69;
'use strict';

var $4EeOM = parcelRequire("4EeOM");
var $66d87444173cd9d2$require$Buffer = $4EeOM.Buffer;
/*</replacement>*/ var $66d87444173cd9d2$var$isEncoding = $66d87444173cd9d2$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $66d87444173cd9d2$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $66d87444173cd9d2$var$normalizeEncoding(enc) {
    var nenc = $66d87444173cd9d2$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($66d87444173cd9d2$require$Buffer.isEncoding === $66d87444173cd9d2$var$isEncoding || !$66d87444173cd9d2$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$66d87444173cd9d2$export$63a7aa211a91ed69 = $66d87444173cd9d2$var$StringDecoder;
function $66d87444173cd9d2$var$StringDecoder(encoding) {
    this.encoding = $66d87444173cd9d2$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $66d87444173cd9d2$var$utf16Text;
            this.end = $66d87444173cd9d2$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $66d87444173cd9d2$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $66d87444173cd9d2$var$base64Text;
            this.end = $66d87444173cd9d2$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $66d87444173cd9d2$var$simpleWrite;
            this.end = $66d87444173cd9d2$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $66d87444173cd9d2$require$Buffer.allocUnsafe(nb);
}
$66d87444173cd9d2$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$66d87444173cd9d2$var$StringDecoder.prototype.end = $66d87444173cd9d2$var$utf8End;
// Returns only complete characters in a Buffer
$66d87444173cd9d2$var$StringDecoder.prototype.text = $66d87444173cd9d2$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$66d87444173cd9d2$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $66d87444173cd9d2$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $66d87444173cd9d2$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $66d87444173cd9d2$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $66d87444173cd9d2$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $66d87444173cd9d2$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $66d87444173cd9d2$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $66d87444173cd9d2$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $66d87444173cd9d2$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $66d87444173cd9d2$var$utf8Text(buf, i) {
    var total = $66d87444173cd9d2$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $66d87444173cd9d2$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $66d87444173cd9d2$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $66d87444173cd9d2$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $66d87444173cd9d2$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $66d87444173cd9d2$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $66d87444173cd9d2$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $66d87444173cd9d2$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});

parcelRegister("cunJG", function(module, exports) {

var $1CHRc = parcelRequire("1CHRc");
'use strict';
var $917ab2d1b77b3215$var$_Object$setPrototypeO;
function $917ab2d1b77b3215$var$_defineProperty(obj, key, value) {
    key = $917ab2d1b77b3215$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $917ab2d1b77b3215$var$_toPropertyKey(arg) {
    var key = $917ab2d1b77b3215$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $917ab2d1b77b3215$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $7Stfq = parcelRequire("7Stfq");
var $917ab2d1b77b3215$var$kLastResolve = Symbol('lastResolve');
var $917ab2d1b77b3215$var$kLastReject = Symbol('lastReject');
var $917ab2d1b77b3215$var$kError = Symbol('error');
var $917ab2d1b77b3215$var$kEnded = Symbol('ended');
var $917ab2d1b77b3215$var$kLastPromise = Symbol('lastPromise');
var $917ab2d1b77b3215$var$kHandlePromise = Symbol('handlePromise');
var $917ab2d1b77b3215$var$kStream = Symbol('stream');
function $917ab2d1b77b3215$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $917ab2d1b77b3215$var$readAndResolve(iter) {
    var resolve = iter[$917ab2d1b77b3215$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$917ab2d1b77b3215$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$917ab2d1b77b3215$var$kLastPromise] = null;
            iter[$917ab2d1b77b3215$var$kLastResolve] = null;
            iter[$917ab2d1b77b3215$var$kLastReject] = null;
            resolve($917ab2d1b77b3215$var$createIterResult(data, false));
        }
    }
}
function $917ab2d1b77b3215$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $1CHRc.nextTick($917ab2d1b77b3215$var$readAndResolve, iter);
}
function $917ab2d1b77b3215$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$917ab2d1b77b3215$var$kEnded]) {
                resolve($917ab2d1b77b3215$var$createIterResult(undefined, true));
                return;
            }
            iter[$917ab2d1b77b3215$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $917ab2d1b77b3215$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $917ab2d1b77b3215$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($917ab2d1b77b3215$var$_Object$setPrototypeO = {
    get stream () {
        return this[$917ab2d1b77b3215$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$917ab2d1b77b3215$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$917ab2d1b77b3215$var$kEnded]) return Promise.resolve($917ab2d1b77b3215$var$createIterResult(undefined, true));
        if (this[$917ab2d1b77b3215$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $1CHRc.nextTick(function() {
                if (_this[$917ab2d1b77b3215$var$kError]) reject(_this[$917ab2d1b77b3215$var$kError]);
                else resolve($917ab2d1b77b3215$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$917ab2d1b77b3215$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($917ab2d1b77b3215$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$917ab2d1b77b3215$var$kStream].read();
            if (data !== null) return Promise.resolve($917ab2d1b77b3215$var$createIterResult(data, false));
            promise = new Promise(this[$917ab2d1b77b3215$var$kHandlePromise]);
        }
        this[$917ab2d1b77b3215$var$kLastPromise] = promise;
        return promise;
    }
}, $917ab2d1b77b3215$var$_defineProperty($917ab2d1b77b3215$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $917ab2d1b77b3215$var$_defineProperty($917ab2d1b77b3215$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$917ab2d1b77b3215$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($917ab2d1b77b3215$var$createIterResult(undefined, true));
        });
    });
}), $917ab2d1b77b3215$var$_Object$setPrototypeO), $917ab2d1b77b3215$var$AsyncIteratorPrototype);
var $917ab2d1b77b3215$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($917ab2d1b77b3215$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $917ab2d1b77b3215$var$_defineProperty(_Object$create, $917ab2d1b77b3215$var$kStream, {
        value: stream,
        writable: true
    }), $917ab2d1b77b3215$var$_defineProperty(_Object$create, $917ab2d1b77b3215$var$kLastResolve, {
        value: null,
        writable: true
    }), $917ab2d1b77b3215$var$_defineProperty(_Object$create, $917ab2d1b77b3215$var$kLastReject, {
        value: null,
        writable: true
    }), $917ab2d1b77b3215$var$_defineProperty(_Object$create, $917ab2d1b77b3215$var$kError, {
        value: null,
        writable: true
    }), $917ab2d1b77b3215$var$_defineProperty(_Object$create, $917ab2d1b77b3215$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $917ab2d1b77b3215$var$_defineProperty(_Object$create, $917ab2d1b77b3215$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$917ab2d1b77b3215$var$kStream].read();
            if (data) {
                iterator[$917ab2d1b77b3215$var$kLastPromise] = null;
                iterator[$917ab2d1b77b3215$var$kLastResolve] = null;
                iterator[$917ab2d1b77b3215$var$kLastReject] = null;
                resolve($917ab2d1b77b3215$var$createIterResult(data, false));
            } else {
                iterator[$917ab2d1b77b3215$var$kLastResolve] = resolve;
                iterator[$917ab2d1b77b3215$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$917ab2d1b77b3215$var$kLastPromise] = null;
    $7Stfq(stream, function(err) {
        if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
            var reject = iterator[$917ab2d1b77b3215$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$917ab2d1b77b3215$var$kLastPromise] = null;
                iterator[$917ab2d1b77b3215$var$kLastResolve] = null;
                iterator[$917ab2d1b77b3215$var$kLastReject] = null;
                reject(err);
            }
            iterator[$917ab2d1b77b3215$var$kError] = err;
            return;
        }
        var resolve = iterator[$917ab2d1b77b3215$var$kLastResolve];
        if (resolve !== null) {
            iterator[$917ab2d1b77b3215$var$kLastPromise] = null;
            iterator[$917ab2d1b77b3215$var$kLastResolve] = null;
            iterator[$917ab2d1b77b3215$var$kLastReject] = null;
            resolve($917ab2d1b77b3215$var$createIterResult(undefined, true));
        }
        iterator[$917ab2d1b77b3215$var$kEnded] = true;
    });
    stream.on('readable', $917ab2d1b77b3215$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $917ab2d1b77b3215$var$createReadableStreamAsyncIterator;

});
parcelRegister("7Stfq", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $5bc44392827af39a$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("dTh3w")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $5bc44392827af39a$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $5bc44392827af39a$var$noop() {}
function $5bc44392827af39a$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
function $5bc44392827af39a$var$eos(stream, opts, callback) {
    if (typeof opts === 'function') return $5bc44392827af39a$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $5bc44392827af39a$var$once(callback || $5bc44392827af39a$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $5bc44392827af39a$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $5bc44392827af39a$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on('finish', onfinish);
    };
    if ($5bc44392827af39a$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (opts.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    return function() {
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
}
module.exports = $5bc44392827af39a$var$eos;

});


parcelRegister("liwP3", function(module, exports) {
module.exports = function() {
    throw new Error('Readable.from is not available in the browser');
};

});


parcelRegister("3RAPb", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $2d02e2e57db0e99d$var$Transform;

var $dTh3w = parcelRequire("dTh3w");
var $2d02e2e57db0e99d$require$_require$codes = $dTh3w.codes;
var $2d02e2e57db0e99d$var$ERR_METHOD_NOT_IMPLEMENTED = $2d02e2e57db0e99d$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $2d02e2e57db0e99d$var$ERR_MULTIPLE_CALLBACK = $2d02e2e57db0e99d$require$_require$codes.ERR_MULTIPLE_CALLBACK, $2d02e2e57db0e99d$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $2d02e2e57db0e99d$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $2d02e2e57db0e99d$var$ERR_TRANSFORM_WITH_LENGTH_0 = $2d02e2e57db0e99d$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $7n5mG = parcelRequire("7n5mG");

(parcelRequire("ktJSc"))($2d02e2e57db0e99d$var$Transform, $7n5mG);
function $2d02e2e57db0e99d$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit('error', new $2d02e2e57db0e99d$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $2d02e2e57db0e99d$var$Transform(options) {
    if (!(this instanceof $2d02e2e57db0e99d$var$Transform)) return new $2d02e2e57db0e99d$var$Transform(options);
    $7n5mG.call(this, options);
    this._transformState = {
        afterTransform: $2d02e2e57db0e99d$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $2d02e2e57db0e99d$var$prefinish);
}
function $2d02e2e57db0e99d$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function' && !this._readableState.destroyed) this._flush(function(er, data) {
        $2d02e2e57db0e99d$var$done(_this, er, data);
    });
    else $2d02e2e57db0e99d$var$done(this, null, null);
}
$2d02e2e57db0e99d$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $7n5mG.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$2d02e2e57db0e99d$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $2d02e2e57db0e99d$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
$2d02e2e57db0e99d$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$2d02e2e57db0e99d$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$2d02e2e57db0e99d$var$Transform.prototype._destroy = function(err, cb) {
    $7n5mG.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $2d02e2e57db0e99d$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $2d02e2e57db0e99d$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $2d02e2e57db0e99d$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("ermgP", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $a834dcbbb060f0cd$var$PassThrough;

var $3RAPb = parcelRequire("3RAPb");

(parcelRequire("ktJSc"))($a834dcbbb060f0cd$var$PassThrough, $3RAPb);
function $a834dcbbb060f0cd$var$PassThrough(options) {
    if (!(this instanceof $a834dcbbb060f0cd$var$PassThrough)) return new $a834dcbbb060f0cd$var$PassThrough(options);
    $3RAPb.call(this, options);
}
$a834dcbbb060f0cd$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("fn4Y0", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';
var $b30cdb492a269e54$var$eos;
function $b30cdb492a269e54$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $dTh3w = parcelRequire("dTh3w");
var $b30cdb492a269e54$require$_require$codes = $dTh3w.codes;
var $b30cdb492a269e54$var$ERR_MISSING_ARGS = $b30cdb492a269e54$require$_require$codes.ERR_MISSING_ARGS, $b30cdb492a269e54$var$ERR_STREAM_DESTROYED = $b30cdb492a269e54$require$_require$codes.ERR_STREAM_DESTROYED;
function $b30cdb492a269e54$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $b30cdb492a269e54$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}

function $b30cdb492a269e54$var$destroyer(stream, reading, writing, callback) {
    callback = $b30cdb492a269e54$var$once(callback);
    var closed = false;
    stream.on('close', function() {
        closed = true;
    });
    if ($b30cdb492a269e54$var$eos === undefined) $b30cdb492a269e54$var$eos = (parcelRequire("7Stfq"));
    $b30cdb492a269e54$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($b30cdb492a269e54$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === 'function') return stream.destroy();
        callback(err || new $b30cdb492a269e54$var$ERR_STREAM_DESTROYED('pipe'));
    };
}
function $b30cdb492a269e54$var$call(fn) {
    fn();
}
function $b30cdb492a269e54$var$pipe(from, to) {
    return from.pipe(to);
}
function $b30cdb492a269e54$var$popCallback(streams) {
    if (!streams.length) return $b30cdb492a269e54$var$noop;
    if (typeof streams[streams.length - 1] !== 'function') return $b30cdb492a269e54$var$noop;
    return streams.pop();
}
function $b30cdb492a269e54$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $b30cdb492a269e54$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $b30cdb492a269e54$var$ERR_MISSING_ARGS('streams');
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $b30cdb492a269e54$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($b30cdb492a269e54$var$call);
            if (reading) return;
            destroys.forEach($b30cdb492a269e54$var$call);
            callback(error);
        });
    });
    return streams.reduce($b30cdb492a269e54$var$pipe);
}
module.exports = $b30cdb492a269e54$var$pipeline;

});




parcelRegister("ixhPV", function(module, exports) {
'use strict';

var $ekOVf = parcelRequire("ekOVf");
var $d7e9250aa7c1953a$require$Buffer = $ekOVf.Buffer;

var $ktJSc = parcelRequire("ktJSc");

var $fxuZ8 = parcelRequire("fxuZ8");
var $d7e9250aa7c1953a$var$ARRAY16 = new Array(16);
var $d7e9250aa7c1953a$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $d7e9250aa7c1953a$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $d7e9250aa7c1953a$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $d7e9250aa7c1953a$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $d7e9250aa7c1953a$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $d7e9250aa7c1953a$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $d7e9250aa7c1953a$var$RIPEMD160() {
    $fxuZ8.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$ktJSc($d7e9250aa7c1953a$var$RIPEMD160, $fxuZ8);
$d7e9250aa7c1953a$var$RIPEMD160.prototype._update = function() {
    var words = $d7e9250aa7c1953a$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $d7e9250aa7c1953a$var$fn1(al, bl, cl, dl, el, words[$d7e9250aa7c1953a$var$zl[i]], $d7e9250aa7c1953a$var$hl[0], $d7e9250aa7c1953a$var$sl[i]);
            tr = $d7e9250aa7c1953a$var$fn5(ar, br, cr, dr, er, words[$d7e9250aa7c1953a$var$zr[i]], $d7e9250aa7c1953a$var$hr[0], $d7e9250aa7c1953a$var$sr[i]);
        } else if (i < 32) {
            tl = $d7e9250aa7c1953a$var$fn2(al, bl, cl, dl, el, words[$d7e9250aa7c1953a$var$zl[i]], $d7e9250aa7c1953a$var$hl[1], $d7e9250aa7c1953a$var$sl[i]);
            tr = $d7e9250aa7c1953a$var$fn4(ar, br, cr, dr, er, words[$d7e9250aa7c1953a$var$zr[i]], $d7e9250aa7c1953a$var$hr[1], $d7e9250aa7c1953a$var$sr[i]);
        } else if (i < 48) {
            tl = $d7e9250aa7c1953a$var$fn3(al, bl, cl, dl, el, words[$d7e9250aa7c1953a$var$zl[i]], $d7e9250aa7c1953a$var$hl[2], $d7e9250aa7c1953a$var$sl[i]);
            tr = $d7e9250aa7c1953a$var$fn3(ar, br, cr, dr, er, words[$d7e9250aa7c1953a$var$zr[i]], $d7e9250aa7c1953a$var$hr[2], $d7e9250aa7c1953a$var$sr[i]);
        } else if (i < 64) {
            tl = $d7e9250aa7c1953a$var$fn4(al, bl, cl, dl, el, words[$d7e9250aa7c1953a$var$zl[i]], $d7e9250aa7c1953a$var$hl[3], $d7e9250aa7c1953a$var$sl[i]);
            tr = $d7e9250aa7c1953a$var$fn2(ar, br, cr, dr, er, words[$d7e9250aa7c1953a$var$zr[i]], $d7e9250aa7c1953a$var$hr[3], $d7e9250aa7c1953a$var$sr[i]);
        } else {
            tl = $d7e9250aa7c1953a$var$fn5(al, bl, cl, dl, el, words[$d7e9250aa7c1953a$var$zl[i]], $d7e9250aa7c1953a$var$hl[4], $d7e9250aa7c1953a$var$sl[i]);
            tr = $d7e9250aa7c1953a$var$fn1(ar, br, cr, dr, er, words[$d7e9250aa7c1953a$var$zr[i]], $d7e9250aa7c1953a$var$hr[4], $d7e9250aa7c1953a$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $d7e9250aa7c1953a$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $d7e9250aa7c1953a$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$d7e9250aa7c1953a$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $d7e9250aa7c1953a$require$Buffer.alloc ? $d7e9250aa7c1953a$require$Buffer.alloc(20) : new $d7e9250aa7c1953a$require$Buffer(20);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
function $d7e9250aa7c1953a$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $d7e9250aa7c1953a$var$fn1(a, b, c, d, e, m, k, s) {
    return $d7e9250aa7c1953a$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $d7e9250aa7c1953a$var$fn2(a, b, c, d, e, m, k, s) {
    return $d7e9250aa7c1953a$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $d7e9250aa7c1953a$var$fn3(a, b, c, d, e, m, k, s) {
    return $d7e9250aa7c1953a$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $d7e9250aa7c1953a$var$fn4(a, b, c, d, e, m, k, s) {
    return $d7e9250aa7c1953a$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $d7e9250aa7c1953a$var$fn5(a, b, c, d, e, m, k, s) {
    return $d7e9250aa7c1953a$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
module.exports = $d7e9250aa7c1953a$var$RIPEMD160;

});

parcelRegister("hajrJ", function(module, exports) {
var $c7f274788ebc4857$var$exports = module.exports = function SHA(algorithm) {
    algorithm = algorithm.toLowerCase();
    var Algorithm = $c7f274788ebc4857$var$exports[algorithm];
    if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)');
    return new Algorithm();
};

$c7f274788ebc4857$var$exports.sha = (parcelRequire("73Ua2"));

$c7f274788ebc4857$var$exports.sha1 = (parcelRequire("74iq0"));

$c7f274788ebc4857$var$exports.sha224 = (parcelRequire("jwk1i"));

$c7f274788ebc4857$var$exports.sha256 = (parcelRequire("cQZ2B"));

$c7f274788ebc4857$var$exports.sha384 = (parcelRequire("ikxj1"));

$c7f274788ebc4857$var$exports.sha512 = (parcelRequire("6dpQT"));

});
parcelRegister("73Ua2", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */ 
var $ktJSc = parcelRequire("ktJSc");

var $jDz2v = parcelRequire("jDz2v");

var $4EeOM = parcelRequire("4EeOM");
var $524460984d7f22d1$require$Buffer = $4EeOM.Buffer;
var $524460984d7f22d1$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $524460984d7f22d1$var$W = new Array(80);
function $524460984d7f22d1$var$Sha() {
    this.init();
    this._w = $524460984d7f22d1$var$W;
    $jDz2v.call(this, 64, 56);
}
$ktJSc($524460984d7f22d1$var$Sha, $jDz2v);
$524460984d7f22d1$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $524460984d7f22d1$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $524460984d7f22d1$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $524460984d7f22d1$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$524460984d7f22d1$var$Sha.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $524460984d7f22d1$var$rotl5(a) + $524460984d7f22d1$var$ft(s, b, c, d) + e + W[j] + $524460984d7f22d1$var$K[s] | 0;
        e = d;
        d = c;
        c = $524460984d7f22d1$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$524460984d7f22d1$var$Sha.prototype._hash = function() {
    var H = $524460984d7f22d1$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $524460984d7f22d1$var$Sha;

});
parcelRegister("jDz2v", function(module, exports) {

var $4EeOM = parcelRequire("4EeOM");
var $e4bcd6f5b32c8ff9$require$Buffer = $4EeOM.Buffer;
// prototype class for hash functions
function $e4bcd6f5b32c8ff9$var$Hash(blockSize, finalSize) {
    this._block = $e4bcd6f5b32c8ff9$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$e4bcd6f5b32c8ff9$var$Hash.prototype.update = function(data, enc) {
    if (typeof data === 'string') {
        enc = enc || 'utf8';
        data = $e4bcd6f5b32c8ff9$require$Buffer.from(data, enc);
    }
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$e4bcd6f5b32c8ff9$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
    // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
    this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$e4bcd6f5b32c8ff9$var$Hash.prototype._update = function() {
    throw new Error('_update must be implemented by subclass');
};
module.exports = $e4bcd6f5b32c8ff9$var$Hash;

});


parcelRegister("74iq0", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */ 
var $ktJSc = parcelRequire("ktJSc");

var $jDz2v = parcelRequire("jDz2v");

var $4EeOM = parcelRequire("4EeOM");
var $525731a929bfe8f0$require$Buffer = $4EeOM.Buffer;
var $525731a929bfe8f0$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $525731a929bfe8f0$var$W = new Array(80);
function $525731a929bfe8f0$var$Sha1() {
    this.init();
    this._w = $525731a929bfe8f0$var$W;
    $jDz2v.call(this, 64, 56);
}
$ktJSc($525731a929bfe8f0$var$Sha1, $jDz2v);
$525731a929bfe8f0$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $525731a929bfe8f0$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $525731a929bfe8f0$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $525731a929bfe8f0$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $525731a929bfe8f0$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$525731a929bfe8f0$var$Sha1.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = $525731a929bfe8f0$var$rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $525731a929bfe8f0$var$rotl5(a) + $525731a929bfe8f0$var$ft(s, b, c, d) + e + W[j] + $525731a929bfe8f0$var$K[s] | 0;
        e = d;
        d = c;
        c = $525731a929bfe8f0$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$525731a929bfe8f0$var$Sha1.prototype._hash = function() {
    var H = $525731a929bfe8f0$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $525731a929bfe8f0$var$Sha1;

});

parcelRegister("jwk1i", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $ktJSc = parcelRequire("ktJSc");

var $cQZ2B = parcelRequire("cQZ2B");

var $jDz2v = parcelRequire("jDz2v");

var $4EeOM = parcelRequire("4EeOM");
var $e3608909662b0be9$require$Buffer = $4EeOM.Buffer;
var $e3608909662b0be9$var$W = new Array(64);
function $e3608909662b0be9$var$Sha224() {
    this.init();
    this._w = $e3608909662b0be9$var$W // new Array(64)
    ;
    $jDz2v.call(this, 64, 56);
}
$ktJSc($e3608909662b0be9$var$Sha224, $cQZ2B);
$e3608909662b0be9$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$e3608909662b0be9$var$Sha224.prototype._hash = function() {
    var H = $e3608909662b0be9$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $e3608909662b0be9$var$Sha224;

});
parcelRegister("cQZ2B", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $ktJSc = parcelRequire("ktJSc");

var $jDz2v = parcelRequire("jDz2v");

var $4EeOM = parcelRequire("4EeOM");
var $95b9b0d238ccbb4b$require$Buffer = $4EeOM.Buffer;
var $95b9b0d238ccbb4b$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $95b9b0d238ccbb4b$var$W = new Array(64);
function $95b9b0d238ccbb4b$var$Sha256() {
    this.init();
    this._w = $95b9b0d238ccbb4b$var$W // new Array(64)
    ;
    $jDz2v.call(this, 64, 56);
}
$ktJSc($95b9b0d238ccbb4b$var$Sha256, $jDz2v);
$95b9b0d238ccbb4b$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $95b9b0d238ccbb4b$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $95b9b0d238ccbb4b$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $95b9b0d238ccbb4b$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $95b9b0d238ccbb4b$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $95b9b0d238ccbb4b$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $95b9b0d238ccbb4b$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$95b9b0d238ccbb4b$var$Sha256.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)W[i] = $95b9b0d238ccbb4b$var$gamma1(W[i - 2]) + W[i - 7] + $95b9b0d238ccbb4b$var$gamma0(W[i - 15]) + W[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $95b9b0d238ccbb4b$var$sigma1(e) + $95b9b0d238ccbb4b$var$ch(e, f, g) + $95b9b0d238ccbb4b$var$K[j] + W[j] | 0;
        var T2 = $95b9b0d238ccbb4b$var$sigma0(a) + $95b9b0d238ccbb4b$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$95b9b0d238ccbb4b$var$Sha256.prototype._hash = function() {
    var H = $95b9b0d238ccbb4b$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $95b9b0d238ccbb4b$var$Sha256;

});


parcelRegister("ikxj1", function(module, exports) {

var $ktJSc = parcelRequire("ktJSc");

var $6dpQT = parcelRequire("6dpQT");

var $jDz2v = parcelRequire("jDz2v");

var $4EeOM = parcelRequire("4EeOM");
var $d583ee1571a7651a$require$Buffer = $4EeOM.Buffer;
var $d583ee1571a7651a$var$W = new Array(160);
function $d583ee1571a7651a$var$Sha384() {
    this.init();
    this._w = $d583ee1571a7651a$var$W;
    $jDz2v.call(this, 128, 112);
}
$ktJSc($d583ee1571a7651a$var$Sha384, $6dpQT);
$d583ee1571a7651a$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$d583ee1571a7651a$var$Sha384.prototype._hash = function() {
    var H = $d583ee1571a7651a$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $d583ee1571a7651a$var$Sha384;

});
parcelRegister("6dpQT", function(module, exports) {

var $ktJSc = parcelRequire("ktJSc");

var $jDz2v = parcelRequire("jDz2v");

var $4EeOM = parcelRequire("4EeOM");
var $486802ade46ff43d$require$Buffer = $4EeOM.Buffer;
var $486802ade46ff43d$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $486802ade46ff43d$var$W = new Array(160);
function $486802ade46ff43d$var$Sha512() {
    this.init();
    this._w = $486802ade46ff43d$var$W;
    $jDz2v.call(this, 128, 112);
}
$ktJSc($486802ade46ff43d$var$Sha512, $jDz2v);
$486802ade46ff43d$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $486802ade46ff43d$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $486802ade46ff43d$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $486802ade46ff43d$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $486802ade46ff43d$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $486802ade46ff43d$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $486802ade46ff43d$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $486802ade46ff43d$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $486802ade46ff43d$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $486802ade46ff43d$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$486802ade46ff43d$var$Sha512.prototype._update = function(M) {
    var W = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        W[i] = M.readInt32BE(i * 4);
        W[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = W[i - 30];
        var xl = W[i - 30 + 1];
        var gamma0 = $486802ade46ff43d$var$Gamma0(xh, xl);
        var gamma0l = $486802ade46ff43d$var$Gamma0l(xl, xh);
        xh = W[i - 4];
        xl = W[i - 4 + 1];
        var gamma1 = $486802ade46ff43d$var$Gamma1(xh, xl);
        var gamma1l = $486802ade46ff43d$var$Gamma1l(xl, xh);
        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
        var Wi7h = W[i - 14];
        var Wi7l = W[i - 14 + 1];
        var Wi16h = W[i - 32];
        var Wi16l = W[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $486802ade46ff43d$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $486802ade46ff43d$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $486802ade46ff43d$var$getCarry(Wil, Wi16l) | 0;
        W[i] = Wih;
        W[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = W[j];
        Wil = W[j + 1];
        var majh = $486802ade46ff43d$var$maj(ah, bh, ch);
        var majl = $486802ade46ff43d$var$maj(al, bl, cl);
        var sigma0h = $486802ade46ff43d$var$sigma0(ah, al);
        var sigma0l = $486802ade46ff43d$var$sigma0(al, ah);
        var sigma1h = $486802ade46ff43d$var$sigma1(eh, el);
        var sigma1l = $486802ade46ff43d$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + W[j]
        var Kih = $486802ade46ff43d$var$K[j];
        var Kil = $486802ade46ff43d$var$K[j + 1];
        var chh = $486802ade46ff43d$var$Ch(eh, fh, gh);
        var chl = $486802ade46ff43d$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $486802ade46ff43d$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $486802ade46ff43d$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $486802ade46ff43d$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $486802ade46ff43d$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $486802ade46ff43d$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $486802ade46ff43d$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $486802ade46ff43d$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $486802ade46ff43d$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $486802ade46ff43d$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $486802ade46ff43d$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $486802ade46ff43d$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $486802ade46ff43d$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $486802ade46ff43d$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $486802ade46ff43d$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $486802ade46ff43d$var$getCarry(this._hl, hl) | 0;
};
$486802ade46ff43d$var$Sha512.prototype._hash = function() {
    var H = $486802ade46ff43d$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $486802ade46ff43d$var$Sha512;

});



parcelRegister("hCwwr", function(module, exports) {
'use strict';

var $4EeOM = parcelRequire("4EeOM");
var $cd3f36878a10ee2b$require$Buffer = $4EeOM.Buffer;

var $cKOMr = parcelRequire("cKOMr");
var $cd3f36878a10ee2b$require$Transform = $cKOMr.Transform;

var $8PrxV = parcelRequire("8PrxV");
var $cd3f36878a10ee2b$require$StringDecoder = $8PrxV.StringDecoder;

var $ktJSc = parcelRequire("ktJSc");
function $cd3f36878a10ee2b$var$CipherBase(hashMode) {
    $cd3f36878a10ee2b$require$Transform.call(this);
    this.hashMode = typeof hashMode === 'string';
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this['final'] = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$ktJSc($cd3f36878a10ee2b$var$CipherBase, $cd3f36878a10ee2b$require$Transform);
var $cd3f36878a10ee2b$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $cd3f36878a10ee2b$var$useArrayBuffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && ArrayBuffer.isView && ($cd3f36878a10ee2b$require$Buffer.prototype instanceof Uint8Array || $cd3f36878a10ee2b$require$Buffer.TYPED_ARRAY_SUPPORT);
function $cd3f36878a10ee2b$var$toBuffer(data, encoding) {
    /*
	 * No need to do anything for exact instance
	 * This is only valid when safe-buffer.Buffer === buffer.Buffer, i.e. when Buffer.from/Buffer.alloc existed
	 */ if (data instanceof $cd3f36878a10ee2b$require$Buffer) return data;
    // Convert strings to Buffer
    if (typeof data === 'string') return $cd3f36878a10ee2b$require$Buffer.from(data, encoding);
    /*
	 * Wrap any TypedArray instances and DataViews
	 * Makes sense only on engines with full TypedArray support -- let Buffer detect that
	 */ if ($cd3f36878a10ee2b$var$useArrayBuffer && ArrayBuffer.isView(data)) {
        // Bug in Node.js <6.3.1, which treats this as out-of-bounds
        if (data.byteLength === 0) return $cd3f36878a10ee2b$require$Buffer.alloc(0);
        var res = $cd3f36878a10ee2b$require$Buffer.from(data.buffer, data.byteOffset, data.byteLength);
        /*
		 * Recheck result size, as offset/length doesn't work on Node.js <5.10
		 * We just go to Uint8Array case if this fails
		 */ if (res.byteLength === data.byteLength) return res;
    }
    /*
	 * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
	 * Doesn't make sense with other TypedArray instances
	 */ if ($cd3f36878a10ee2b$var$useUint8Array && data instanceof Uint8Array) return $cd3f36878a10ee2b$require$Buffer.from(data);
    /*
	 * Old Buffer polyfill on an engine that doesn't have TypedArray support
	 * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
	 * Convert to our current Buffer implementation
	 */ if ($cd3f36878a10ee2b$require$Buffer.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer === 'function' && data.constructor.isBuffer(data)) return $cd3f36878a10ee2b$require$Buffer.from(data);
    throw new TypeError('The "data" argument must be of type string or an instance of Buffer, TypedArray, or DataView.');
}
$cd3f36878a10ee2b$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    var bufferData = $cd3f36878a10ee2b$var$toBuffer(data, inputEnc); // asserts correct input type
    var outData = this._update(bufferData);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$cd3f36878a10ee2b$var$CipherBase.prototype.setAutoPadding = function() {};
$cd3f36878a10ee2b$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error('trying to get auth tag in unsupported state');
};
$cd3f36878a10ee2b$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error('trying to set auth tag in unsupported state');
};
$cd3f36878a10ee2b$var$CipherBase.prototype.setAAD = function() {
    throw new Error('trying to set aad in unsupported state');
};
$cd3f36878a10ee2b$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$cd3f36878a10ee2b$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$cd3f36878a10ee2b$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $cd3f36878a10ee2b$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$cd3f36878a10ee2b$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $cd3f36878a10ee2b$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can\u2019t switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $cd3f36878a10ee2b$var$CipherBase;

});


parcelRegister("jMEDM", function(module, exports) {
'use strict';

var $ktJSc = parcelRequire("ktJSc");

var $eBS9J = parcelRequire("eBS9J");

var $hCwwr = parcelRequire("hCwwr");

var $4EeOM = parcelRequire("4EeOM");
var $e6720661fc4f01b6$require$Buffer = $4EeOM.Buffer;

var $a6DLt = parcelRequire("a6DLt");

var $ixhPV = parcelRequire("ixhPV");

var $hajrJ = parcelRequire("hajrJ");
var $e6720661fc4f01b6$var$ZEROS = $e6720661fc4f01b6$require$Buffer.alloc(128);
function $e6720661fc4f01b6$var$Hmac(alg, key) {
    $hCwwr.call(this, 'digest');
    if (typeof key === 'string') key = $e6720661fc4f01b6$require$Buffer.from(key);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === 'rmd160' ? new $ixhPV() : $hajrJ(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $e6720661fc4f01b6$require$Buffer.concat([
        key,
        $e6720661fc4f01b6$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $e6720661fc4f01b6$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $e6720661fc4f01b6$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === 'rmd160' ? new $ixhPV() : $hajrJ(alg);
    this._hash.update(ipad);
}
$ktJSc($e6720661fc4f01b6$var$Hmac, $hCwwr);
$e6720661fc4f01b6$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$e6720661fc4f01b6$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === 'rmd160' ? new $ixhPV() : $hajrJ(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $e6720661fc4f01b6$var$Hmac('rmd160', key);
    if (alg === 'md5') return new $eBS9J($a6DLt, key);
    return new $e6720661fc4f01b6$var$Hmac(alg, key);
};

});
parcelRegister("eBS9J", function(module, exports) {
'use strict';

var $ktJSc = parcelRequire("ktJSc");

var $4EeOM = parcelRequire("4EeOM");
var $aa2e87a900645e74$require$Buffer = $4EeOM.Buffer;

var $hCwwr = parcelRequire("hCwwr");
var $aa2e87a900645e74$var$ZEROS = $aa2e87a900645e74$require$Buffer.alloc(128);
var $aa2e87a900645e74$var$blocksize = 64;
function $aa2e87a900645e74$var$Hmac(alg, key) {
    $hCwwr.call(this, 'digest');
    if (typeof key === 'string') key = $aa2e87a900645e74$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $aa2e87a900645e74$var$blocksize) key = alg(key);
    else if (key.length < $aa2e87a900645e74$var$blocksize) key = $aa2e87a900645e74$require$Buffer.concat([
        key,
        $aa2e87a900645e74$var$ZEROS
    ], $aa2e87a900645e74$var$blocksize);
    var ipad = this._ipad = $aa2e87a900645e74$require$Buffer.allocUnsafe($aa2e87a900645e74$var$blocksize);
    var opad = this._opad = $aa2e87a900645e74$require$Buffer.allocUnsafe($aa2e87a900645e74$var$blocksize);
    for(var i = 0; i < $aa2e87a900645e74$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$ktJSc($aa2e87a900645e74$var$Hmac, $hCwwr);
$aa2e87a900645e74$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$aa2e87a900645e74$var$Hmac.prototype._final = function() {
    var h = this._alg($aa2e87a900645e74$require$Buffer.concat(this._hash));
    return this._alg($aa2e87a900645e74$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $aa2e87a900645e74$var$Hmac;

});

parcelRegister("a6DLt", function(module, exports) {

var $ioicd = parcelRequire("ioicd");
module.exports = function(buffer) {
    return new $ioicd().update(buffer).digest();
};

});


parcelRegister("rQEpC", function(module, exports) {
module.exports = JSON.parse("{\"sha224WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"RSA-SHA224\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"sha256WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"RSA-SHA256\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"sha384WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"RSA-SHA384\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"sha512WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA512\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA1\":{\"sign\":\"rsa\",\"hash\":\"sha1\",\"id\":\"3021300906052b0e03021a05000414\"},\"ecdsa-with-SHA1\":{\"sign\":\"ecdsa\",\"hash\":\"sha1\",\"id\":\"\"},\"sha256\":{\"sign\":\"ecdsa\",\"hash\":\"sha256\",\"id\":\"\"},\"sha224\":{\"sign\":\"ecdsa\",\"hash\":\"sha224\",\"id\":\"\"},\"sha384\":{\"sign\":\"ecdsa\",\"hash\":\"sha384\",\"id\":\"\"},\"sha512\":{\"sign\":\"ecdsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-SHA1\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-WITH-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-WITH-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-WITH-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-WITH-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-RIPEMD160\":{\"sign\":\"dsa\",\"hash\":\"rmd160\",\"id\":\"\"},\"ripemd160WithRSA\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"RSA-RIPEMD160\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"md5WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"},\"RSA-MD5\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"}}");

});

parcelRegister("2JcPJ", function(module, exports) {
'use strict';

var $4EeOM = parcelRequire("4EeOM");
var $1fc9bd30c4bf3e77$require$Buffer = $4EeOM.Buffer;

var $2LFqK = parcelRequire("2LFqK");

var $69V7h = parcelRequire("69V7h");

var $8RJn9 = parcelRequire("8RJn9");

var $hfZvC = parcelRequire("hfZvC");
var $1fc9bd30c4bf3e77$var$ZERO_BUF;
var $1fc9bd30c4bf3e77$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $1fc9bd30c4bf3e77$var$toBrowser = {
    sha: 'SHA-1',
    'sha-1': 'SHA-1',
    sha1: 'SHA-1',
    sha256: 'SHA-256',
    'sha-256': 'SHA-256',
    sha384: 'SHA-384',
    'sha-384': 'SHA-384',
    'sha-512': 'SHA-512',
    sha512: 'SHA-512'
};
var $1fc9bd30c4bf3e77$var$checks = [];
var $1fc9bd30c4bf3e77$var$nextTick;
function $1fc9bd30c4bf3e77$var$getNextTick() {
    if ($1fc9bd30c4bf3e77$var$nextTick) return $1fc9bd30c4bf3e77$var$nextTick;
    if ($parcel$global.process && $parcel$global.process.nextTick) $1fc9bd30c4bf3e77$var$nextTick = $parcel$global.process.nextTick;
    else if ($parcel$global.queueMicrotask) $1fc9bd30c4bf3e77$var$nextTick = $parcel$global.queueMicrotask;
    else if ($parcel$global.setImmediate) $1fc9bd30c4bf3e77$var$nextTick = $parcel$global.setImmediate;
    else $1fc9bd30c4bf3e77$var$nextTick = $parcel$global.setTimeout;
    return $1fc9bd30c4bf3e77$var$nextTick;
}
function $1fc9bd30c4bf3e77$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $1fc9bd30c4bf3e77$var$subtle.importKey('raw', password, {
        name: 'PBKDF2'
    }, false, [
        'deriveBits'
    ]).then(function(key) {
        return $1fc9bd30c4bf3e77$var$subtle.deriveBits({
            name: 'PBKDF2',
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $1fc9bd30c4bf3e77$require$Buffer.from(res);
    });
}
function $1fc9bd30c4bf3e77$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$1fc9bd30c4bf3e77$var$subtle || !$1fc9bd30c4bf3e77$var$subtle.importKey || !$1fc9bd30c4bf3e77$var$subtle.deriveBits) return Promise.resolve(false);
    if ($1fc9bd30c4bf3e77$var$checks[algo] !== undefined) return $1fc9bd30c4bf3e77$var$checks[algo];
    $1fc9bd30c4bf3e77$var$ZERO_BUF = $1fc9bd30c4bf3e77$var$ZERO_BUF || $1fc9bd30c4bf3e77$require$Buffer.alloc(8);
    var prom = $1fc9bd30c4bf3e77$var$browserPbkdf2($1fc9bd30c4bf3e77$var$ZERO_BUF, $1fc9bd30c4bf3e77$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }, function() {
        return false;
    });
    $1fc9bd30c4bf3e77$var$checks[algo] = prom;
    return prom;
}
function $1fc9bd30c4bf3e77$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $1fc9bd30c4bf3e77$var$getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        $1fc9bd30c4bf3e77$var$getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === 'function') {
        callback = digest;
        digest = undefined;
    }
    digest = digest || 'sha1';
    var algo = $1fc9bd30c4bf3e77$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== 'function') {
        $1fc9bd30c4bf3e77$var$getNextTick()(function() {
            var out;
            try {
                out = $8RJn9(password, salt, iterations, keylen, digest);
            } catch (e) {
                callback(e);
                return;
            }
            callback(null, out);
        });
        return;
    }
    $2LFqK(iterations, keylen);
    password = $hfZvC(password, $69V7h, 'Password');
    salt = $hfZvC(salt, $69V7h, 'Salt');
    if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2');
    $1fc9bd30c4bf3e77$var$resolvePromise($1fc9bd30c4bf3e77$var$checkNative(algo).then(function(resp) {
        if (resp) return $1fc9bd30c4bf3e77$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        return $8RJn9(password, salt, iterations, keylen, digest);
    }), callback);
};

});
parcelRegister("2LFqK", function(module, exports) {
'use strict';
var $20401bc135d3b689$var$MAX_ALLOC = Math.pow(2, 30) - 1; // default in iojs
module.exports = function(iterations, keylen) {
    if (typeof iterations !== 'number') throw new TypeError('Iterations not a number');
    if (iterations < 0) throw new TypeError('Bad iterations');
    if (typeof keylen !== 'number') throw new TypeError('Key length not a number');
    if (keylen < 0 || keylen > $20401bc135d3b689$var$MAX_ALLOC || keylen !== keylen) throw new TypeError('Bad key length');
};

});

parcelRegister("69V7h", function(module, exports) {

var $1CHRc = parcelRequire("1CHRc");
'use strict';
var $47bfe37977877868$var$defaultEncoding;
/* istanbul ignore next */ if ($parcel$global.process && $parcel$global.process.browser) $47bfe37977877868$var$defaultEncoding = 'utf-8';
else if ($parcel$global.process && $parcel$global.process.version) {
    var $47bfe37977877868$var$pVersionMajor = parseInt($1CHRc.version.split('.')[0].slice(1), 10);
    $47bfe37977877868$var$defaultEncoding = $47bfe37977877868$var$pVersionMajor >= 6 ? 'utf-8' : 'binary';
} else $47bfe37977877868$var$defaultEncoding = 'utf-8';
module.exports = $47bfe37977877868$var$defaultEncoding;

});

parcelRegister("8RJn9", function(module, exports) {
'use strict';

var $gbGt1 = parcelRequire("gbGt1");

var $9zNPH = parcelRequire("9zNPH");

var $hajrJ = parcelRequire("hajrJ");

var $4EeOM = parcelRequire("4EeOM");
var $67467800d7cd40d6$require$Buffer = $4EeOM.Buffer;

var $2LFqK = parcelRequire("2LFqK");

var $69V7h = parcelRequire("69V7h");

var $hfZvC = parcelRequire("hfZvC");
var $67467800d7cd40d6$var$ZEROS = $67467800d7cd40d6$require$Buffer.alloc(128);
var $67467800d7cd40d6$var$sizes = {
    __proto__: null,
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    'sha512-256': 32,
    ripemd160: 20,
    rmd160: 20
};
var $67467800d7cd40d6$var$mapping = {
    __proto__: null,
    'sha-1': 'sha1',
    'sha-224': 'sha224',
    'sha-256': 'sha256',
    'sha-384': 'sha384',
    'sha-512': 'sha512',
    'ripemd-160': 'ripemd160'
};
function $67467800d7cd40d6$var$rmd160Func(data) {
    return new $9zNPH().update(data).digest();
}
function $67467800d7cd40d6$var$getDigest(alg) {
    function shaFunc(data) {
        return $hajrJ(alg).update(data).digest();
    }
    if (alg === 'rmd160' || alg === 'ripemd160') return $67467800d7cd40d6$var$rmd160Func;
    if (alg === 'md5') return $gbGt1;
    return shaFunc;
}
function $67467800d7cd40d6$var$Hmac(alg, key, saltLen) {
    var hash = $67467800d7cd40d6$var$getDigest(alg);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $67467800d7cd40d6$require$Buffer.concat([
        key,
        $67467800d7cd40d6$var$ZEROS
    ], blocksize);
    var ipad = $67467800d7cd40d6$require$Buffer.allocUnsafe(blocksize + $67467800d7cd40d6$var$sizes[alg]);
    var opad = $67467800d7cd40d6$require$Buffer.allocUnsafe(blocksize + $67467800d7cd40d6$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $67467800d7cd40d6$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $67467800d7cd40d6$var$sizes[alg];
}
$67467800d7cd40d6$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $67467800d7cd40d6$var$pbkdf2(password, salt, iterations, keylen, digest) {
    $2LFqK(iterations, keylen);
    password = $hfZvC(password, $69V7h, 'Password');
    salt = $hfZvC(salt, $69V7h, 'Salt');
    var lowerDigest = (digest || 'sha1').toLowerCase();
    var mappedDigest = $67467800d7cd40d6$var$mapping[lowerDigest] || lowerDigest;
    var size = $67467800d7cd40d6$var$sizes[mappedDigest];
    if (typeof size !== 'number' || !size) throw new TypeError('Digest algorithm not supported: ' + digest);
    var hmac = new $67467800d7cd40d6$var$Hmac(mappedDigest, password, salt.length);
    var DK = $67467800d7cd40d6$require$Buffer.allocUnsafe(keylen);
    var block1 = $67467800d7cd40d6$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = size;
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $67467800d7cd40d6$var$pbkdf2;

});
parcelRegister("gbGt1", function(module, exports) {
'use strict';

var $9ajEJ = parcelRequire("9ajEJ");
/*
 * Calculate the MD5 of an array of little-endian words, and a bit length
 */ function $bc8e9d7d37d87e3f$var$core_md5(x, len) {
    /* append padding */ x[len >> 5] |= 0x80 << len % 32;
    x[(len + 64 >>> 9 << 4) + 14] = len;
    var a = 1732584193;
    var b = -271733879;
    var c = -1732584194;
    var d = 271733878;
    for(var i = 0; i < x.length; i += 16){
        var olda = a;
        var oldb = b;
        var oldc = c;
        var oldd = d;
        a = $bc8e9d7d37d87e3f$var$md5_ff(a, b, c, d, x[i + 0], 7, -680876936);
        d = $bc8e9d7d37d87e3f$var$md5_ff(d, a, b, c, x[i + 1], 12, -389564586);
        c = $bc8e9d7d37d87e3f$var$md5_ff(c, d, a, b, x[i + 2], 17, 606105819);
        b = $bc8e9d7d37d87e3f$var$md5_ff(b, c, d, a, x[i + 3], 22, -1044525330);
        a = $bc8e9d7d37d87e3f$var$md5_ff(a, b, c, d, x[i + 4], 7, -176418897);
        d = $bc8e9d7d37d87e3f$var$md5_ff(d, a, b, c, x[i + 5], 12, 1200080426);
        c = $bc8e9d7d37d87e3f$var$md5_ff(c, d, a, b, x[i + 6], 17, -1473231341);
        b = $bc8e9d7d37d87e3f$var$md5_ff(b, c, d, a, x[i + 7], 22, -45705983);
        a = $bc8e9d7d37d87e3f$var$md5_ff(a, b, c, d, x[i + 8], 7, 1770035416);
        d = $bc8e9d7d37d87e3f$var$md5_ff(d, a, b, c, x[i + 9], 12, -1958414417);
        c = $bc8e9d7d37d87e3f$var$md5_ff(c, d, a, b, x[i + 10], 17, -42063);
        b = $bc8e9d7d37d87e3f$var$md5_ff(b, c, d, a, x[i + 11], 22, -1990404162);
        a = $bc8e9d7d37d87e3f$var$md5_ff(a, b, c, d, x[i + 12], 7, 1804603682);
        d = $bc8e9d7d37d87e3f$var$md5_ff(d, a, b, c, x[i + 13], 12, -40341101);
        c = $bc8e9d7d37d87e3f$var$md5_ff(c, d, a, b, x[i + 14], 17, -1502002290);
        b = $bc8e9d7d37d87e3f$var$md5_ff(b, c, d, a, x[i + 15], 22, 1236535329);
        a = $bc8e9d7d37d87e3f$var$md5_gg(a, b, c, d, x[i + 1], 5, -165796510);
        d = $bc8e9d7d37d87e3f$var$md5_gg(d, a, b, c, x[i + 6], 9, -1069501632);
        c = $bc8e9d7d37d87e3f$var$md5_gg(c, d, a, b, x[i + 11], 14, 643717713);
        b = $bc8e9d7d37d87e3f$var$md5_gg(b, c, d, a, x[i + 0], 20, -373897302);
        a = $bc8e9d7d37d87e3f$var$md5_gg(a, b, c, d, x[i + 5], 5, -701558691);
        d = $bc8e9d7d37d87e3f$var$md5_gg(d, a, b, c, x[i + 10], 9, 38016083);
        c = $bc8e9d7d37d87e3f$var$md5_gg(c, d, a, b, x[i + 15], 14, -660478335);
        b = $bc8e9d7d37d87e3f$var$md5_gg(b, c, d, a, x[i + 4], 20, -405537848);
        a = $bc8e9d7d37d87e3f$var$md5_gg(a, b, c, d, x[i + 9], 5, 568446438);
        d = $bc8e9d7d37d87e3f$var$md5_gg(d, a, b, c, x[i + 14], 9, -1019803690);
        c = $bc8e9d7d37d87e3f$var$md5_gg(c, d, a, b, x[i + 3], 14, -187363961);
        b = $bc8e9d7d37d87e3f$var$md5_gg(b, c, d, a, x[i + 8], 20, 1163531501);
        a = $bc8e9d7d37d87e3f$var$md5_gg(a, b, c, d, x[i + 13], 5, -1444681467);
        d = $bc8e9d7d37d87e3f$var$md5_gg(d, a, b, c, x[i + 2], 9, -51403784);
        c = $bc8e9d7d37d87e3f$var$md5_gg(c, d, a, b, x[i + 7], 14, 1735328473);
        b = $bc8e9d7d37d87e3f$var$md5_gg(b, c, d, a, x[i + 12], 20, -1926607734);
        a = $bc8e9d7d37d87e3f$var$md5_hh(a, b, c, d, x[i + 5], 4, -378558);
        d = $bc8e9d7d37d87e3f$var$md5_hh(d, a, b, c, x[i + 8], 11, -2022574463);
        c = $bc8e9d7d37d87e3f$var$md5_hh(c, d, a, b, x[i + 11], 16, 1839030562);
        b = $bc8e9d7d37d87e3f$var$md5_hh(b, c, d, a, x[i + 14], 23, -35309556);
        a = $bc8e9d7d37d87e3f$var$md5_hh(a, b, c, d, x[i + 1], 4, -1530992060);
        d = $bc8e9d7d37d87e3f$var$md5_hh(d, a, b, c, x[i + 4], 11, 1272893353);
        c = $bc8e9d7d37d87e3f$var$md5_hh(c, d, a, b, x[i + 7], 16, -155497632);
        b = $bc8e9d7d37d87e3f$var$md5_hh(b, c, d, a, x[i + 10], 23, -1094730640);
        a = $bc8e9d7d37d87e3f$var$md5_hh(a, b, c, d, x[i + 13], 4, 681279174);
        d = $bc8e9d7d37d87e3f$var$md5_hh(d, a, b, c, x[i + 0], 11, -358537222);
        c = $bc8e9d7d37d87e3f$var$md5_hh(c, d, a, b, x[i + 3], 16, -722521979);
        b = $bc8e9d7d37d87e3f$var$md5_hh(b, c, d, a, x[i + 6], 23, 76029189);
        a = $bc8e9d7d37d87e3f$var$md5_hh(a, b, c, d, x[i + 9], 4, -640364487);
        d = $bc8e9d7d37d87e3f$var$md5_hh(d, a, b, c, x[i + 12], 11, -421815835);
        c = $bc8e9d7d37d87e3f$var$md5_hh(c, d, a, b, x[i + 15], 16, 530742520);
        b = $bc8e9d7d37d87e3f$var$md5_hh(b, c, d, a, x[i + 2], 23, -995338651);
        a = $bc8e9d7d37d87e3f$var$md5_ii(a, b, c, d, x[i + 0], 6, -198630844);
        d = $bc8e9d7d37d87e3f$var$md5_ii(d, a, b, c, x[i + 7], 10, 1126891415);
        c = $bc8e9d7d37d87e3f$var$md5_ii(c, d, a, b, x[i + 14], 15, -1416354905);
        b = $bc8e9d7d37d87e3f$var$md5_ii(b, c, d, a, x[i + 5], 21, -57434055);
        a = $bc8e9d7d37d87e3f$var$md5_ii(a, b, c, d, x[i + 12], 6, 1700485571);
        d = $bc8e9d7d37d87e3f$var$md5_ii(d, a, b, c, x[i + 3], 10, -1894986606);
        c = $bc8e9d7d37d87e3f$var$md5_ii(c, d, a, b, x[i + 10], 15, -1051523);
        b = $bc8e9d7d37d87e3f$var$md5_ii(b, c, d, a, x[i + 1], 21, -2054922799);
        a = $bc8e9d7d37d87e3f$var$md5_ii(a, b, c, d, x[i + 8], 6, 1873313359);
        d = $bc8e9d7d37d87e3f$var$md5_ii(d, a, b, c, x[i + 15], 10, -30611744);
        c = $bc8e9d7d37d87e3f$var$md5_ii(c, d, a, b, x[i + 6], 15, -1560198380);
        b = $bc8e9d7d37d87e3f$var$md5_ii(b, c, d, a, x[i + 13], 21, 1309151649);
        a = $bc8e9d7d37d87e3f$var$md5_ii(a, b, c, d, x[i + 4], 6, -145523070);
        d = $bc8e9d7d37d87e3f$var$md5_ii(d, a, b, c, x[i + 11], 10, -1120210379);
        c = $bc8e9d7d37d87e3f$var$md5_ii(c, d, a, b, x[i + 2], 15, 718787259);
        b = $bc8e9d7d37d87e3f$var$md5_ii(b, c, d, a, x[i + 9], 21, -343485551);
        a = $bc8e9d7d37d87e3f$var$safe_add(a, olda);
        b = $bc8e9d7d37d87e3f$var$safe_add(b, oldb);
        c = $bc8e9d7d37d87e3f$var$safe_add(c, oldc);
        d = $bc8e9d7d37d87e3f$var$safe_add(d, oldd);
    }
    return [
        a,
        b,
        c,
        d
    ];
}
/*
 * These functions implement the four basic operations the algorithm uses.
 */ function $bc8e9d7d37d87e3f$var$md5_cmn(q, a, b, x, s, t) {
    return $bc8e9d7d37d87e3f$var$safe_add($bc8e9d7d37d87e3f$var$bit_rol($bc8e9d7d37d87e3f$var$safe_add($bc8e9d7d37d87e3f$var$safe_add(a, q), $bc8e9d7d37d87e3f$var$safe_add(x, t)), s), b);
}
function $bc8e9d7d37d87e3f$var$md5_ff(a, b, c, d, x, s, t) {
    return $bc8e9d7d37d87e3f$var$md5_cmn(b & c | ~b & d, a, b, x, s, t);
}
function $bc8e9d7d37d87e3f$var$md5_gg(a, b, c, d, x, s, t) {
    return $bc8e9d7d37d87e3f$var$md5_cmn(b & d | c & ~d, a, b, x, s, t);
}
function $bc8e9d7d37d87e3f$var$md5_hh(a, b, c, d, x, s, t) {
    return $bc8e9d7d37d87e3f$var$md5_cmn(b ^ c ^ d, a, b, x, s, t);
}
function $bc8e9d7d37d87e3f$var$md5_ii(a, b, c, d, x, s, t) {
    return $bc8e9d7d37d87e3f$var$md5_cmn(c ^ (b | ~d), a, b, x, s, t);
}
/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */ function $bc8e9d7d37d87e3f$var$safe_add(x, y) {
    var lsw = (x & 0xFFFF) + (y & 0xFFFF);
    var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
    return msw << 16 | lsw & 0xFFFF;
}
/*
 * Bitwise rotate a 32-bit number to the left.
 */ function $bc8e9d7d37d87e3f$var$bit_rol(num, cnt) {
    return num << cnt | num >>> 32 - cnt;
}
module.exports = function md5(buf) {
    return $9ajEJ(buf, $bc8e9d7d37d87e3f$var$core_md5);
};

});
parcelRegister("9ajEJ", function(module, exports) {

var $ekOVf = parcelRequire("ekOVf");
var $6ac44b82fbf4eb01$require$Buffer = $ekOVf.Buffer;
'use strict';
var $6ac44b82fbf4eb01$var$intSize = 4;
var $6ac44b82fbf4eb01$var$zeroBuffer = new $6ac44b82fbf4eb01$require$Buffer($6ac44b82fbf4eb01$var$intSize);
$6ac44b82fbf4eb01$var$zeroBuffer.fill(0);
var $6ac44b82fbf4eb01$var$charSize = 8;
var $6ac44b82fbf4eb01$var$hashSize = 16;
function $6ac44b82fbf4eb01$var$toArray(buf) {
    if (buf.length % $6ac44b82fbf4eb01$var$intSize !== 0) {
        var len = buf.length + ($6ac44b82fbf4eb01$var$intSize - buf.length % $6ac44b82fbf4eb01$var$intSize);
        buf = $6ac44b82fbf4eb01$require$Buffer.concat([
            buf,
            $6ac44b82fbf4eb01$var$zeroBuffer
        ], len);
    }
    var arr = new Array(buf.length >>> 2);
    for(var i = 0, j = 0; i < buf.length; i += $6ac44b82fbf4eb01$var$intSize, j++)arr[j] = buf.readInt32LE(i);
    return arr;
}
module.exports = function hash(buf, fn) {
    var arr = fn($6ac44b82fbf4eb01$var$toArray(buf), buf.length * $6ac44b82fbf4eb01$var$charSize);
    buf = new $6ac44b82fbf4eb01$require$Buffer($6ac44b82fbf4eb01$var$hashSize);
    for(var i = 0; i < arr.length; i++)buf.writeInt32LE(arr[i], i << 2, true);
    return buf;
};

});


parcelRegister("9zNPH", function(module, exports) {

var $ekOVf = parcelRequire("ekOVf");
var $6f8e09b9493b4e8f$require$Buffer = $ekOVf.Buffer;
'use strict';

var $ktJSc = parcelRequire("ktJSc");

var $6Dj9o = parcelRequire("6Dj9o");
function $6f8e09b9493b4e8f$var$RIPEMD160() {
    $6Dj9o.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$ktJSc($6f8e09b9493b4e8f$var$RIPEMD160, $6Dj9o);
$6f8e09b9493b4e8f$var$RIPEMD160.prototype._update = function() {
    var m = new Array(16);
    for(var i = 0; i < 16; ++i)m[i] = this._block.readInt32LE(i * 4);
    var al = this._a;
    var bl = this._b;
    var cl = this._c;
    var dl = this._d;
    var el = this._e;
    // Mj = 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15
    // K = 0x00000000
    // Sj = 11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8
    al = $6f8e09b9493b4e8f$var$fn1(al, bl, cl, dl, el, m[0], 0x00000000, 11);
    cl = $6f8e09b9493b4e8f$var$rotl(cl, 10);
    el = $6f8e09b9493b4e8f$var$fn1(el, al, bl, cl, dl, m[1], 0x00000000, 14);
    bl = $6f8e09b9493b4e8f$var$rotl(bl, 10);
    dl = $6f8e09b9493b4e8f$var$fn1(dl, el, al, bl, cl, m[2], 0x00000000, 15);
    al = $6f8e09b9493b4e8f$var$rotl(al, 10);
    cl = $6f8e09b9493b4e8f$var$fn1(cl, dl, el, al, bl, m[3], 0x00000000, 12);
    el = $6f8e09b9493b4e8f$var$rotl(el, 10);
    bl = $6f8e09b9493b4e8f$var$fn1(bl, cl, dl, el, al, m[4], 0x00000000, 5);
    dl = $6f8e09b9493b4e8f$var$rotl(dl, 10);
    al = $6f8e09b9493b4e8f$var$fn1(al, bl, cl, dl, el, m[5], 0x00000000, 8);
    cl = $6f8e09b9493b4e8f$var$rotl(cl, 10);
    el = $6f8e09b9493b4e8f$var$fn1(el, al, bl, cl, dl, m[6], 0x00000000, 7);
    bl = $6f8e09b9493b4e8f$var$rotl(bl, 10);
    dl = $6f8e09b9493b4e8f$var$fn1(dl, el, al, bl, cl, m[7], 0x00000000, 9);
    al = $6f8e09b9493b4e8f$var$rotl(al, 10);
    cl = $6f8e09b9493b4e8f$var$fn1(cl, dl, el, al, bl, m[8], 0x00000000, 11);
    el = $6f8e09b9493b4e8f$var$rotl(el, 10);
    bl = $6f8e09b9493b4e8f$var$fn1(bl, cl, dl, el, al, m[9], 0x00000000, 13);
    dl = $6f8e09b9493b4e8f$var$rotl(dl, 10);
    al = $6f8e09b9493b4e8f$var$fn1(al, bl, cl, dl, el, m[10], 0x00000000, 14);
    cl = $6f8e09b9493b4e8f$var$rotl(cl, 10);
    el = $6f8e09b9493b4e8f$var$fn1(el, al, bl, cl, dl, m[11], 0x00000000, 15);
    bl = $6f8e09b9493b4e8f$var$rotl(bl, 10);
    dl = $6f8e09b9493b4e8f$var$fn1(dl, el, al, bl, cl, m[12], 0x00000000, 6);
    al = $6f8e09b9493b4e8f$var$rotl(al, 10);
    cl = $6f8e09b9493b4e8f$var$fn1(cl, dl, el, al, bl, m[13], 0x00000000, 7);
    el = $6f8e09b9493b4e8f$var$rotl(el, 10);
    bl = $6f8e09b9493b4e8f$var$fn1(bl, cl, dl, el, al, m[14], 0x00000000, 9);
    dl = $6f8e09b9493b4e8f$var$rotl(dl, 10);
    al = $6f8e09b9493b4e8f$var$fn1(al, bl, cl, dl, el, m[15], 0x00000000, 8);
    cl = $6f8e09b9493b4e8f$var$rotl(cl, 10);
    // Mj = 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8
    // K = 0x5a827999
    // Sj = 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12
    el = $6f8e09b9493b4e8f$var$fn2(el, al, bl, cl, dl, m[7], 0x5a827999, 7);
    bl = $6f8e09b9493b4e8f$var$rotl(bl, 10);
    dl = $6f8e09b9493b4e8f$var$fn2(dl, el, al, bl, cl, m[4], 0x5a827999, 6);
    al = $6f8e09b9493b4e8f$var$rotl(al, 10);
    cl = $6f8e09b9493b4e8f$var$fn2(cl, dl, el, al, bl, m[13], 0x5a827999, 8);
    el = $6f8e09b9493b4e8f$var$rotl(el, 10);
    bl = $6f8e09b9493b4e8f$var$fn2(bl, cl, dl, el, al, m[1], 0x5a827999, 13);
    dl = $6f8e09b9493b4e8f$var$rotl(dl, 10);
    al = $6f8e09b9493b4e8f$var$fn2(al, bl, cl, dl, el, m[10], 0x5a827999, 11);
    cl = $6f8e09b9493b4e8f$var$rotl(cl, 10);
    el = $6f8e09b9493b4e8f$var$fn2(el, al, bl, cl, dl, m[6], 0x5a827999, 9);
    bl = $6f8e09b9493b4e8f$var$rotl(bl, 10);
    dl = $6f8e09b9493b4e8f$var$fn2(dl, el, al, bl, cl, m[15], 0x5a827999, 7);
    al = $6f8e09b9493b4e8f$var$rotl(al, 10);
    cl = $6f8e09b9493b4e8f$var$fn2(cl, dl, el, al, bl, m[3], 0x5a827999, 15);
    el = $6f8e09b9493b4e8f$var$rotl(el, 10);
    bl = $6f8e09b9493b4e8f$var$fn2(bl, cl, dl, el, al, m[12], 0x5a827999, 7);
    dl = $6f8e09b9493b4e8f$var$rotl(dl, 10);
    al = $6f8e09b9493b4e8f$var$fn2(al, bl, cl, dl, el, m[0], 0x5a827999, 12);
    cl = $6f8e09b9493b4e8f$var$rotl(cl, 10);
    el = $6f8e09b9493b4e8f$var$fn2(el, al, bl, cl, dl, m[9], 0x5a827999, 15);
    bl = $6f8e09b9493b4e8f$var$rotl(bl, 10);
    dl = $6f8e09b9493b4e8f$var$fn2(dl, el, al, bl, cl, m[5], 0x5a827999, 9);
    al = $6f8e09b9493b4e8f$var$rotl(al, 10);
    cl = $6f8e09b9493b4e8f$var$fn2(cl, dl, el, al, bl, m[2], 0x5a827999, 11);
    el = $6f8e09b9493b4e8f$var$rotl(el, 10);
    bl = $6f8e09b9493b4e8f$var$fn2(bl, cl, dl, el, al, m[14], 0x5a827999, 7);
    dl = $6f8e09b9493b4e8f$var$rotl(dl, 10);
    al = $6f8e09b9493b4e8f$var$fn2(al, bl, cl, dl, el, m[11], 0x5a827999, 13);
    cl = $6f8e09b9493b4e8f$var$rotl(cl, 10);
    el = $6f8e09b9493b4e8f$var$fn2(el, al, bl, cl, dl, m[8], 0x5a827999, 12);
    bl = $6f8e09b9493b4e8f$var$rotl(bl, 10);
    // Mj = 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12
    // K = 0x6ed9eba1
    // Sj = 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5
    dl = $6f8e09b9493b4e8f$var$fn3(dl, el, al, bl, cl, m[3], 0x6ed9eba1, 11);
    al = $6f8e09b9493b4e8f$var$rotl(al, 10);
    cl = $6f8e09b9493b4e8f$var$fn3(cl, dl, el, al, bl, m[10], 0x6ed9eba1, 13);
    el = $6f8e09b9493b4e8f$var$rotl(el, 10);
    bl = $6f8e09b9493b4e8f$var$fn3(bl, cl, dl, el, al, m[14], 0x6ed9eba1, 6);
    dl = $6f8e09b9493b4e8f$var$rotl(dl, 10);
    al = $6f8e09b9493b4e8f$var$fn3(al, bl, cl, dl, el, m[4], 0x6ed9eba1, 7);
    cl = $6f8e09b9493b4e8f$var$rotl(cl, 10);
    el = $6f8e09b9493b4e8f$var$fn3(el, al, bl, cl, dl, m[9], 0x6ed9eba1, 14);
    bl = $6f8e09b9493b4e8f$var$rotl(bl, 10);
    dl = $6f8e09b9493b4e8f$var$fn3(dl, el, al, bl, cl, m[15], 0x6ed9eba1, 9);
    al = $6f8e09b9493b4e8f$var$rotl(al, 10);
    cl = $6f8e09b9493b4e8f$var$fn3(cl, dl, el, al, bl, m[8], 0x6ed9eba1, 13);
    el = $6f8e09b9493b4e8f$var$rotl(el, 10);
    bl = $6f8e09b9493b4e8f$var$fn3(bl, cl, dl, el, al, m[1], 0x6ed9eba1, 15);
    dl = $6f8e09b9493b4e8f$var$rotl(dl, 10);
    al = $6f8e09b9493b4e8f$var$fn3(al, bl, cl, dl, el, m[2], 0x6ed9eba1, 14);
    cl = $6f8e09b9493b4e8f$var$rotl(cl, 10);
    el = $6f8e09b9493b4e8f$var$fn3(el, al, bl, cl, dl, m[7], 0x6ed9eba1, 8);
    bl = $6f8e09b9493b4e8f$var$rotl(bl, 10);
    dl = $6f8e09b9493b4e8f$var$fn3(dl, el, al, bl, cl, m[0], 0x6ed9eba1, 13);
    al = $6f8e09b9493b4e8f$var$rotl(al, 10);
    cl = $6f8e09b9493b4e8f$var$fn3(cl, dl, el, al, bl, m[6], 0x6ed9eba1, 6);
    el = $6f8e09b9493b4e8f$var$rotl(el, 10);
    bl = $6f8e09b9493b4e8f$var$fn3(bl, cl, dl, el, al, m[13], 0x6ed9eba1, 5);
    dl = $6f8e09b9493b4e8f$var$rotl(dl, 10);
    al = $6f8e09b9493b4e8f$var$fn3(al, bl, cl, dl, el, m[11], 0x6ed9eba1, 12);
    cl = $6f8e09b9493b4e8f$var$rotl(cl, 10);
    el = $6f8e09b9493b4e8f$var$fn3(el, al, bl, cl, dl, m[5], 0x6ed9eba1, 7);
    bl = $6f8e09b9493b4e8f$var$rotl(bl, 10);
    dl = $6f8e09b9493b4e8f$var$fn3(dl, el, al, bl, cl, m[12], 0x6ed9eba1, 5);
    al = $6f8e09b9493b4e8f$var$rotl(al, 10);
    // Mj = 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2
    // K = 0x8f1bbcdc
    // Sj = 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12
    cl = $6f8e09b9493b4e8f$var$fn4(cl, dl, el, al, bl, m[1], 0x8f1bbcdc, 11);
    el = $6f8e09b9493b4e8f$var$rotl(el, 10);
    bl = $6f8e09b9493b4e8f$var$fn4(bl, cl, dl, el, al, m[9], 0x8f1bbcdc, 12);
    dl = $6f8e09b9493b4e8f$var$rotl(dl, 10);
    al = $6f8e09b9493b4e8f$var$fn4(al, bl, cl, dl, el, m[11], 0x8f1bbcdc, 14);
    cl = $6f8e09b9493b4e8f$var$rotl(cl, 10);
    el = $6f8e09b9493b4e8f$var$fn4(el, al, bl, cl, dl, m[10], 0x8f1bbcdc, 15);
    bl = $6f8e09b9493b4e8f$var$rotl(bl, 10);
    dl = $6f8e09b9493b4e8f$var$fn4(dl, el, al, bl, cl, m[0], 0x8f1bbcdc, 14);
    al = $6f8e09b9493b4e8f$var$rotl(al, 10);
    cl = $6f8e09b9493b4e8f$var$fn4(cl, dl, el, al, bl, m[8], 0x8f1bbcdc, 15);
    el = $6f8e09b9493b4e8f$var$rotl(el, 10);
    bl = $6f8e09b9493b4e8f$var$fn4(bl, cl, dl, el, al, m[12], 0x8f1bbcdc, 9);
    dl = $6f8e09b9493b4e8f$var$rotl(dl, 10);
    al = $6f8e09b9493b4e8f$var$fn4(al, bl, cl, dl, el, m[4], 0x8f1bbcdc, 8);
    cl = $6f8e09b9493b4e8f$var$rotl(cl, 10);
    el = $6f8e09b9493b4e8f$var$fn4(el, al, bl, cl, dl, m[13], 0x8f1bbcdc, 9);
    bl = $6f8e09b9493b4e8f$var$rotl(bl, 10);
    dl = $6f8e09b9493b4e8f$var$fn4(dl, el, al, bl, cl, m[3], 0x8f1bbcdc, 14);
    al = $6f8e09b9493b4e8f$var$rotl(al, 10);
    cl = $6f8e09b9493b4e8f$var$fn4(cl, dl, el, al, bl, m[7], 0x8f1bbcdc, 5);
    el = $6f8e09b9493b4e8f$var$rotl(el, 10);
    bl = $6f8e09b9493b4e8f$var$fn4(bl, cl, dl, el, al, m[15], 0x8f1bbcdc, 6);
    dl = $6f8e09b9493b4e8f$var$rotl(dl, 10);
    al = $6f8e09b9493b4e8f$var$fn4(al, bl, cl, dl, el, m[14], 0x8f1bbcdc, 8);
    cl = $6f8e09b9493b4e8f$var$rotl(cl, 10);
    el = $6f8e09b9493b4e8f$var$fn4(el, al, bl, cl, dl, m[5], 0x8f1bbcdc, 6);
    bl = $6f8e09b9493b4e8f$var$rotl(bl, 10);
    dl = $6f8e09b9493b4e8f$var$fn4(dl, el, al, bl, cl, m[6], 0x8f1bbcdc, 5);
    al = $6f8e09b9493b4e8f$var$rotl(al, 10);
    cl = $6f8e09b9493b4e8f$var$fn4(cl, dl, el, al, bl, m[2], 0x8f1bbcdc, 12);
    el = $6f8e09b9493b4e8f$var$rotl(el, 10);
    // Mj = 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
    // K = 0xa953fd4e
    // Sj = 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
    bl = $6f8e09b9493b4e8f$var$fn5(bl, cl, dl, el, al, m[4], 0xa953fd4e, 9);
    dl = $6f8e09b9493b4e8f$var$rotl(dl, 10);
    al = $6f8e09b9493b4e8f$var$fn5(al, bl, cl, dl, el, m[0], 0xa953fd4e, 15);
    cl = $6f8e09b9493b4e8f$var$rotl(cl, 10);
    el = $6f8e09b9493b4e8f$var$fn5(el, al, bl, cl, dl, m[5], 0xa953fd4e, 5);
    bl = $6f8e09b9493b4e8f$var$rotl(bl, 10);
    dl = $6f8e09b9493b4e8f$var$fn5(dl, el, al, bl, cl, m[9], 0xa953fd4e, 11);
    al = $6f8e09b9493b4e8f$var$rotl(al, 10);
    cl = $6f8e09b9493b4e8f$var$fn5(cl, dl, el, al, bl, m[7], 0xa953fd4e, 6);
    el = $6f8e09b9493b4e8f$var$rotl(el, 10);
    bl = $6f8e09b9493b4e8f$var$fn5(bl, cl, dl, el, al, m[12], 0xa953fd4e, 8);
    dl = $6f8e09b9493b4e8f$var$rotl(dl, 10);
    al = $6f8e09b9493b4e8f$var$fn5(al, bl, cl, dl, el, m[2], 0xa953fd4e, 13);
    cl = $6f8e09b9493b4e8f$var$rotl(cl, 10);
    el = $6f8e09b9493b4e8f$var$fn5(el, al, bl, cl, dl, m[10], 0xa953fd4e, 12);
    bl = $6f8e09b9493b4e8f$var$rotl(bl, 10);
    dl = $6f8e09b9493b4e8f$var$fn5(dl, el, al, bl, cl, m[14], 0xa953fd4e, 5);
    al = $6f8e09b9493b4e8f$var$rotl(al, 10);
    cl = $6f8e09b9493b4e8f$var$fn5(cl, dl, el, al, bl, m[1], 0xa953fd4e, 12);
    el = $6f8e09b9493b4e8f$var$rotl(el, 10);
    bl = $6f8e09b9493b4e8f$var$fn5(bl, cl, dl, el, al, m[3], 0xa953fd4e, 13);
    dl = $6f8e09b9493b4e8f$var$rotl(dl, 10);
    al = $6f8e09b9493b4e8f$var$fn5(al, bl, cl, dl, el, m[8], 0xa953fd4e, 14);
    cl = $6f8e09b9493b4e8f$var$rotl(cl, 10);
    el = $6f8e09b9493b4e8f$var$fn5(el, al, bl, cl, dl, m[11], 0xa953fd4e, 11);
    bl = $6f8e09b9493b4e8f$var$rotl(bl, 10);
    dl = $6f8e09b9493b4e8f$var$fn5(dl, el, al, bl, cl, m[6], 0xa953fd4e, 8);
    al = $6f8e09b9493b4e8f$var$rotl(al, 10);
    cl = $6f8e09b9493b4e8f$var$fn5(cl, dl, el, al, bl, m[15], 0xa953fd4e, 5);
    el = $6f8e09b9493b4e8f$var$rotl(el, 10);
    bl = $6f8e09b9493b4e8f$var$fn5(bl, cl, dl, el, al, m[13], 0xa953fd4e, 6);
    dl = $6f8e09b9493b4e8f$var$rotl(dl, 10);
    var ar = this._a;
    var br = this._b;
    var cr = this._c;
    var dr = this._d;
    var er = this._e;
    // M'j = 5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12
    // K' = 0x50a28be6
    // S'j = 8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6
    ar = $6f8e09b9493b4e8f$var$fn5(ar, br, cr, dr, er, m[5], 0x50a28be6, 8);
    cr = $6f8e09b9493b4e8f$var$rotl(cr, 10);
    er = $6f8e09b9493b4e8f$var$fn5(er, ar, br, cr, dr, m[14], 0x50a28be6, 9);
    br = $6f8e09b9493b4e8f$var$rotl(br, 10);
    dr = $6f8e09b9493b4e8f$var$fn5(dr, er, ar, br, cr, m[7], 0x50a28be6, 9);
    ar = $6f8e09b9493b4e8f$var$rotl(ar, 10);
    cr = $6f8e09b9493b4e8f$var$fn5(cr, dr, er, ar, br, m[0], 0x50a28be6, 11);
    er = $6f8e09b9493b4e8f$var$rotl(er, 10);
    br = $6f8e09b9493b4e8f$var$fn5(br, cr, dr, er, ar, m[9], 0x50a28be6, 13);
    dr = $6f8e09b9493b4e8f$var$rotl(dr, 10);
    ar = $6f8e09b9493b4e8f$var$fn5(ar, br, cr, dr, er, m[2], 0x50a28be6, 15);
    cr = $6f8e09b9493b4e8f$var$rotl(cr, 10);
    er = $6f8e09b9493b4e8f$var$fn5(er, ar, br, cr, dr, m[11], 0x50a28be6, 15);
    br = $6f8e09b9493b4e8f$var$rotl(br, 10);
    dr = $6f8e09b9493b4e8f$var$fn5(dr, er, ar, br, cr, m[4], 0x50a28be6, 5);
    ar = $6f8e09b9493b4e8f$var$rotl(ar, 10);
    cr = $6f8e09b9493b4e8f$var$fn5(cr, dr, er, ar, br, m[13], 0x50a28be6, 7);
    er = $6f8e09b9493b4e8f$var$rotl(er, 10);
    br = $6f8e09b9493b4e8f$var$fn5(br, cr, dr, er, ar, m[6], 0x50a28be6, 7);
    dr = $6f8e09b9493b4e8f$var$rotl(dr, 10);
    ar = $6f8e09b9493b4e8f$var$fn5(ar, br, cr, dr, er, m[15], 0x50a28be6, 8);
    cr = $6f8e09b9493b4e8f$var$rotl(cr, 10);
    er = $6f8e09b9493b4e8f$var$fn5(er, ar, br, cr, dr, m[8], 0x50a28be6, 11);
    br = $6f8e09b9493b4e8f$var$rotl(br, 10);
    dr = $6f8e09b9493b4e8f$var$fn5(dr, er, ar, br, cr, m[1], 0x50a28be6, 14);
    ar = $6f8e09b9493b4e8f$var$rotl(ar, 10);
    cr = $6f8e09b9493b4e8f$var$fn5(cr, dr, er, ar, br, m[10], 0x50a28be6, 14);
    er = $6f8e09b9493b4e8f$var$rotl(er, 10);
    br = $6f8e09b9493b4e8f$var$fn5(br, cr, dr, er, ar, m[3], 0x50a28be6, 12);
    dr = $6f8e09b9493b4e8f$var$rotl(dr, 10);
    ar = $6f8e09b9493b4e8f$var$fn5(ar, br, cr, dr, er, m[12], 0x50a28be6, 6);
    cr = $6f8e09b9493b4e8f$var$rotl(cr, 10);
    // M'j = 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2
    // K' = 0x5c4dd124
    // S'j = 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11
    er = $6f8e09b9493b4e8f$var$fn4(er, ar, br, cr, dr, m[6], 0x5c4dd124, 9);
    br = $6f8e09b9493b4e8f$var$rotl(br, 10);
    dr = $6f8e09b9493b4e8f$var$fn4(dr, er, ar, br, cr, m[11], 0x5c4dd124, 13);
    ar = $6f8e09b9493b4e8f$var$rotl(ar, 10);
    cr = $6f8e09b9493b4e8f$var$fn4(cr, dr, er, ar, br, m[3], 0x5c4dd124, 15);
    er = $6f8e09b9493b4e8f$var$rotl(er, 10);
    br = $6f8e09b9493b4e8f$var$fn4(br, cr, dr, er, ar, m[7], 0x5c4dd124, 7);
    dr = $6f8e09b9493b4e8f$var$rotl(dr, 10);
    ar = $6f8e09b9493b4e8f$var$fn4(ar, br, cr, dr, er, m[0], 0x5c4dd124, 12);
    cr = $6f8e09b9493b4e8f$var$rotl(cr, 10);
    er = $6f8e09b9493b4e8f$var$fn4(er, ar, br, cr, dr, m[13], 0x5c4dd124, 8);
    br = $6f8e09b9493b4e8f$var$rotl(br, 10);
    dr = $6f8e09b9493b4e8f$var$fn4(dr, er, ar, br, cr, m[5], 0x5c4dd124, 9);
    ar = $6f8e09b9493b4e8f$var$rotl(ar, 10);
    cr = $6f8e09b9493b4e8f$var$fn4(cr, dr, er, ar, br, m[10], 0x5c4dd124, 11);
    er = $6f8e09b9493b4e8f$var$rotl(er, 10);
    br = $6f8e09b9493b4e8f$var$fn4(br, cr, dr, er, ar, m[14], 0x5c4dd124, 7);
    dr = $6f8e09b9493b4e8f$var$rotl(dr, 10);
    ar = $6f8e09b9493b4e8f$var$fn4(ar, br, cr, dr, er, m[15], 0x5c4dd124, 7);
    cr = $6f8e09b9493b4e8f$var$rotl(cr, 10);
    er = $6f8e09b9493b4e8f$var$fn4(er, ar, br, cr, dr, m[8], 0x5c4dd124, 12);
    br = $6f8e09b9493b4e8f$var$rotl(br, 10);
    dr = $6f8e09b9493b4e8f$var$fn4(dr, er, ar, br, cr, m[12], 0x5c4dd124, 7);
    ar = $6f8e09b9493b4e8f$var$rotl(ar, 10);
    cr = $6f8e09b9493b4e8f$var$fn4(cr, dr, er, ar, br, m[4], 0x5c4dd124, 6);
    er = $6f8e09b9493b4e8f$var$rotl(er, 10);
    br = $6f8e09b9493b4e8f$var$fn4(br, cr, dr, er, ar, m[9], 0x5c4dd124, 15);
    dr = $6f8e09b9493b4e8f$var$rotl(dr, 10);
    ar = $6f8e09b9493b4e8f$var$fn4(ar, br, cr, dr, er, m[1], 0x5c4dd124, 13);
    cr = $6f8e09b9493b4e8f$var$rotl(cr, 10);
    er = $6f8e09b9493b4e8f$var$fn4(er, ar, br, cr, dr, m[2], 0x5c4dd124, 11);
    br = $6f8e09b9493b4e8f$var$rotl(br, 10);
    // M'j = 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13
    // K' = 0x6d703ef3
    // S'j = 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5
    dr = $6f8e09b9493b4e8f$var$fn3(dr, er, ar, br, cr, m[15], 0x6d703ef3, 9);
    ar = $6f8e09b9493b4e8f$var$rotl(ar, 10);
    cr = $6f8e09b9493b4e8f$var$fn3(cr, dr, er, ar, br, m[5], 0x6d703ef3, 7);
    er = $6f8e09b9493b4e8f$var$rotl(er, 10);
    br = $6f8e09b9493b4e8f$var$fn3(br, cr, dr, er, ar, m[1], 0x6d703ef3, 15);
    dr = $6f8e09b9493b4e8f$var$rotl(dr, 10);
    ar = $6f8e09b9493b4e8f$var$fn3(ar, br, cr, dr, er, m[3], 0x6d703ef3, 11);
    cr = $6f8e09b9493b4e8f$var$rotl(cr, 10);
    er = $6f8e09b9493b4e8f$var$fn3(er, ar, br, cr, dr, m[7], 0x6d703ef3, 8);
    br = $6f8e09b9493b4e8f$var$rotl(br, 10);
    dr = $6f8e09b9493b4e8f$var$fn3(dr, er, ar, br, cr, m[14], 0x6d703ef3, 6);
    ar = $6f8e09b9493b4e8f$var$rotl(ar, 10);
    cr = $6f8e09b9493b4e8f$var$fn3(cr, dr, er, ar, br, m[6], 0x6d703ef3, 6);
    er = $6f8e09b9493b4e8f$var$rotl(er, 10);
    br = $6f8e09b9493b4e8f$var$fn3(br, cr, dr, er, ar, m[9], 0x6d703ef3, 14);
    dr = $6f8e09b9493b4e8f$var$rotl(dr, 10);
    ar = $6f8e09b9493b4e8f$var$fn3(ar, br, cr, dr, er, m[11], 0x6d703ef3, 12);
    cr = $6f8e09b9493b4e8f$var$rotl(cr, 10);
    er = $6f8e09b9493b4e8f$var$fn3(er, ar, br, cr, dr, m[8], 0x6d703ef3, 13);
    br = $6f8e09b9493b4e8f$var$rotl(br, 10);
    dr = $6f8e09b9493b4e8f$var$fn3(dr, er, ar, br, cr, m[12], 0x6d703ef3, 5);
    ar = $6f8e09b9493b4e8f$var$rotl(ar, 10);
    cr = $6f8e09b9493b4e8f$var$fn3(cr, dr, er, ar, br, m[2], 0x6d703ef3, 14);
    er = $6f8e09b9493b4e8f$var$rotl(er, 10);
    br = $6f8e09b9493b4e8f$var$fn3(br, cr, dr, er, ar, m[10], 0x6d703ef3, 13);
    dr = $6f8e09b9493b4e8f$var$rotl(dr, 10);
    ar = $6f8e09b9493b4e8f$var$fn3(ar, br, cr, dr, er, m[0], 0x6d703ef3, 13);
    cr = $6f8e09b9493b4e8f$var$rotl(cr, 10);
    er = $6f8e09b9493b4e8f$var$fn3(er, ar, br, cr, dr, m[4], 0x6d703ef3, 7);
    br = $6f8e09b9493b4e8f$var$rotl(br, 10);
    dr = $6f8e09b9493b4e8f$var$fn3(dr, er, ar, br, cr, m[13], 0x6d703ef3, 5);
    ar = $6f8e09b9493b4e8f$var$rotl(ar, 10);
    // M'j = 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14
    // K' = 0x7a6d76e9
    // S'j = 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8
    cr = $6f8e09b9493b4e8f$var$fn2(cr, dr, er, ar, br, m[8], 0x7a6d76e9, 15);
    er = $6f8e09b9493b4e8f$var$rotl(er, 10);
    br = $6f8e09b9493b4e8f$var$fn2(br, cr, dr, er, ar, m[6], 0x7a6d76e9, 5);
    dr = $6f8e09b9493b4e8f$var$rotl(dr, 10);
    ar = $6f8e09b9493b4e8f$var$fn2(ar, br, cr, dr, er, m[4], 0x7a6d76e9, 8);
    cr = $6f8e09b9493b4e8f$var$rotl(cr, 10);
    er = $6f8e09b9493b4e8f$var$fn2(er, ar, br, cr, dr, m[1], 0x7a6d76e9, 11);
    br = $6f8e09b9493b4e8f$var$rotl(br, 10);
    dr = $6f8e09b9493b4e8f$var$fn2(dr, er, ar, br, cr, m[3], 0x7a6d76e9, 14);
    ar = $6f8e09b9493b4e8f$var$rotl(ar, 10);
    cr = $6f8e09b9493b4e8f$var$fn2(cr, dr, er, ar, br, m[11], 0x7a6d76e9, 14);
    er = $6f8e09b9493b4e8f$var$rotl(er, 10);
    br = $6f8e09b9493b4e8f$var$fn2(br, cr, dr, er, ar, m[15], 0x7a6d76e9, 6);
    dr = $6f8e09b9493b4e8f$var$rotl(dr, 10);
    ar = $6f8e09b9493b4e8f$var$fn2(ar, br, cr, dr, er, m[0], 0x7a6d76e9, 14);
    cr = $6f8e09b9493b4e8f$var$rotl(cr, 10);
    er = $6f8e09b9493b4e8f$var$fn2(er, ar, br, cr, dr, m[5], 0x7a6d76e9, 6);
    br = $6f8e09b9493b4e8f$var$rotl(br, 10);
    dr = $6f8e09b9493b4e8f$var$fn2(dr, er, ar, br, cr, m[12], 0x7a6d76e9, 9);
    ar = $6f8e09b9493b4e8f$var$rotl(ar, 10);
    cr = $6f8e09b9493b4e8f$var$fn2(cr, dr, er, ar, br, m[2], 0x7a6d76e9, 12);
    er = $6f8e09b9493b4e8f$var$rotl(er, 10);
    br = $6f8e09b9493b4e8f$var$fn2(br, cr, dr, er, ar, m[13], 0x7a6d76e9, 9);
    dr = $6f8e09b9493b4e8f$var$rotl(dr, 10);
    ar = $6f8e09b9493b4e8f$var$fn2(ar, br, cr, dr, er, m[9], 0x7a6d76e9, 12);
    cr = $6f8e09b9493b4e8f$var$rotl(cr, 10);
    er = $6f8e09b9493b4e8f$var$fn2(er, ar, br, cr, dr, m[7], 0x7a6d76e9, 5);
    br = $6f8e09b9493b4e8f$var$rotl(br, 10);
    dr = $6f8e09b9493b4e8f$var$fn2(dr, er, ar, br, cr, m[10], 0x7a6d76e9, 15);
    ar = $6f8e09b9493b4e8f$var$rotl(ar, 10);
    cr = $6f8e09b9493b4e8f$var$fn2(cr, dr, er, ar, br, m[14], 0x7a6d76e9, 8);
    er = $6f8e09b9493b4e8f$var$rotl(er, 10);
    // M'j = 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
    // K' = 0x00000000
    // S'j = 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
    br = $6f8e09b9493b4e8f$var$fn1(br, cr, dr, er, ar, m[12], 0x00000000, 8);
    dr = $6f8e09b9493b4e8f$var$rotl(dr, 10);
    ar = $6f8e09b9493b4e8f$var$fn1(ar, br, cr, dr, er, m[15], 0x00000000, 5);
    cr = $6f8e09b9493b4e8f$var$rotl(cr, 10);
    er = $6f8e09b9493b4e8f$var$fn1(er, ar, br, cr, dr, m[10], 0x00000000, 12);
    br = $6f8e09b9493b4e8f$var$rotl(br, 10);
    dr = $6f8e09b9493b4e8f$var$fn1(dr, er, ar, br, cr, m[4], 0x00000000, 9);
    ar = $6f8e09b9493b4e8f$var$rotl(ar, 10);
    cr = $6f8e09b9493b4e8f$var$fn1(cr, dr, er, ar, br, m[1], 0x00000000, 12);
    er = $6f8e09b9493b4e8f$var$rotl(er, 10);
    br = $6f8e09b9493b4e8f$var$fn1(br, cr, dr, er, ar, m[5], 0x00000000, 5);
    dr = $6f8e09b9493b4e8f$var$rotl(dr, 10);
    ar = $6f8e09b9493b4e8f$var$fn1(ar, br, cr, dr, er, m[8], 0x00000000, 14);
    cr = $6f8e09b9493b4e8f$var$rotl(cr, 10);
    er = $6f8e09b9493b4e8f$var$fn1(er, ar, br, cr, dr, m[7], 0x00000000, 6);
    br = $6f8e09b9493b4e8f$var$rotl(br, 10);
    dr = $6f8e09b9493b4e8f$var$fn1(dr, er, ar, br, cr, m[6], 0x00000000, 8);
    ar = $6f8e09b9493b4e8f$var$rotl(ar, 10);
    cr = $6f8e09b9493b4e8f$var$fn1(cr, dr, er, ar, br, m[2], 0x00000000, 13);
    er = $6f8e09b9493b4e8f$var$rotl(er, 10);
    br = $6f8e09b9493b4e8f$var$fn1(br, cr, dr, er, ar, m[13], 0x00000000, 6);
    dr = $6f8e09b9493b4e8f$var$rotl(dr, 10);
    ar = $6f8e09b9493b4e8f$var$fn1(ar, br, cr, dr, er, m[14], 0x00000000, 5);
    cr = $6f8e09b9493b4e8f$var$rotl(cr, 10);
    er = $6f8e09b9493b4e8f$var$fn1(er, ar, br, cr, dr, m[0], 0x00000000, 15);
    br = $6f8e09b9493b4e8f$var$rotl(br, 10);
    dr = $6f8e09b9493b4e8f$var$fn1(dr, er, ar, br, cr, m[3], 0x00000000, 13);
    ar = $6f8e09b9493b4e8f$var$rotl(ar, 10);
    cr = $6f8e09b9493b4e8f$var$fn1(cr, dr, er, ar, br, m[9], 0x00000000, 11);
    er = $6f8e09b9493b4e8f$var$rotl(er, 10);
    br = $6f8e09b9493b4e8f$var$fn1(br, cr, dr, er, ar, m[11], 0x00000000, 11);
    dr = $6f8e09b9493b4e8f$var$rotl(dr, 10);
    // change state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$6f8e09b9493b4e8f$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = new $6f8e09b9493b4e8f$require$Buffer(20);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
function $6f8e09b9493b4e8f$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $6f8e09b9493b4e8f$var$fn1(a, b, c, d, e, m, k, s) {
    return $6f8e09b9493b4e8f$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $6f8e09b9493b4e8f$var$fn2(a, b, c, d, e, m, k, s) {
    return $6f8e09b9493b4e8f$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $6f8e09b9493b4e8f$var$fn3(a, b, c, d, e, m, k, s) {
    return $6f8e09b9493b4e8f$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $6f8e09b9493b4e8f$var$fn4(a, b, c, d, e, m, k, s) {
    return $6f8e09b9493b4e8f$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $6f8e09b9493b4e8f$var$fn5(a, b, c, d, e, m, k, s) {
    return $6f8e09b9493b4e8f$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
module.exports = $6f8e09b9493b4e8f$var$RIPEMD160;

});
parcelRegister("6Dj9o", function(module, exports) {

var $ekOVf = parcelRequire("ekOVf");
var $4d453d7fbc00c422$require$Buffer = $ekOVf.Buffer;
'use strict';

var $cKOMr = parcelRequire("cKOMr");
var $4d453d7fbc00c422$require$Transform = $cKOMr.Transform;

var $ktJSc = parcelRequire("ktJSc");
function $4d453d7fbc00c422$var$HashBase(blockSize) {
    $4d453d7fbc00c422$require$Transform.call(this);
    this._block = new $4d453d7fbc00c422$require$Buffer(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$ktJSc($4d453d7fbc00c422$var$HashBase, $4d453d7fbc00c422$require$Transform);
$4d453d7fbc00c422$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        if (encoding !== 'buffer') chunk = new $4d453d7fbc00c422$require$Buffer(chunk, encoding);
        this.update(chunk);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$4d453d7fbc00c422$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this._digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$4d453d7fbc00c422$var$HashBase.prototype.update = function(data, encoding) {
    if (!$4d453d7fbc00c422$require$Buffer.isBuffer(data) && typeof data !== 'string') throw new TypeError('Data must be a string or a buffer');
    if (this._finalized) throw new Error('Digest already called');
    if (!$4d453d7fbc00c422$require$Buffer.isBuffer(data)) data = new $4d453d7fbc00c422$require$Buffer(data, encoding || 'binary');
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$4d453d7fbc00c422$var$HashBase.prototype._update = function(data) {
    throw new Error('_update is not implemented');
};
$4d453d7fbc00c422$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    return digest;
};
$4d453d7fbc00c422$var$HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
module.exports = $4d453d7fbc00c422$var$HashBase;

});


parcelRegister("hfZvC", function(module, exports) {
'use strict';

var $4EeOM = parcelRequire("4EeOM");
var $c9038cc8d56c7432$require$Buffer = $4EeOM.Buffer;

var $hCqa3 = parcelRequire("hCqa3");
var $c9038cc8d56c7432$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $c9038cc8d56c7432$var$useArrayBuffer = $c9038cc8d56c7432$var$useUint8Array && typeof ArrayBuffer !== 'undefined';
var $c9038cc8d56c7432$var$isView = $c9038cc8d56c7432$var$useArrayBuffer && ArrayBuffer.isView;
module.exports = function(thing, encoding, name) {
    if (typeof thing === 'string' || $c9038cc8d56c7432$require$Buffer.isBuffer(thing) || $c9038cc8d56c7432$var$useUint8Array && thing instanceof Uint8Array || $c9038cc8d56c7432$var$isView && $c9038cc8d56c7432$var$isView(thing)) return $hCqa3(thing, encoding);
    throw new TypeError(name + ' must be a string, a Buffer, a Uint8Array, or a DataView');
};

});
parcelRegister("hCqa3", function(module, exports) {
'use strict';

var $4EeOM = parcelRequire("4EeOM");
var $cd3a47597476d9ae$require$Buffer = $4EeOM.Buffer;

var $fwepD = parcelRequire("fwepD");

var $tmGuV = parcelRequire("tmGuV");
var $cd3a47597476d9ae$var$isView = ArrayBuffer.isView || function isView(obj) {
    try {
        $tmGuV(obj);
        return true;
    } catch (e) {
        return false;
    }
};
var $cd3a47597476d9ae$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $cd3a47597476d9ae$var$useArrayBuffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined';
var $cd3a47597476d9ae$var$useFromArrayBuffer = $cd3a47597476d9ae$var$useArrayBuffer && ($cd3a47597476d9ae$require$Buffer.prototype instanceof Uint8Array || $cd3a47597476d9ae$require$Buffer.TYPED_ARRAY_SUPPORT);
module.exports = function toBuffer(data, encoding) {
    /*
	 * No need to do anything for exact instance
	 * This is only valid when safe-buffer.Buffer === buffer.Buffer, i.e. when Buffer.from/Buffer.alloc existed
	 */ if (data instanceof $cd3a47597476d9ae$require$Buffer) return data;
    if (typeof data === 'string') return $cd3a47597476d9ae$require$Buffer.from(data, encoding);
    /*
	 * Wrap any TypedArray instances and DataViews
	 * Makes sense only on engines with full TypedArray support -- let Buffer detect that
	 */ if ($cd3a47597476d9ae$var$useArrayBuffer && $cd3a47597476d9ae$var$isView(data)) {
        // Bug in Node.js <6.3.1, which treats this as out-of-bounds
        if (data.byteLength === 0) return $cd3a47597476d9ae$require$Buffer.alloc(0);
        // When Buffer is based on Uint8Array, we can just construct it from ArrayBuffer
        if ($cd3a47597476d9ae$var$useFromArrayBuffer) {
            var res = $cd3a47597476d9ae$require$Buffer.from(data.buffer, data.byteOffset, data.byteLength);
            /*
			 * Recheck result size, as offset/length doesn't work on Node.js <5.10
			 * We just go to Uint8Array case if this fails
			 */ if (res.byteLength === data.byteLength) return res;
        }
        // Convert to Uint8Array bytes and then to Buffer
        var uint8 = data instanceof Uint8Array ? data : new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
        var result = $cd3a47597476d9ae$require$Buffer.from(uint8);
        /*
		 * Let's recheck that conversion succeeded
		 * We have .length but not .byteLength when useFromArrayBuffer is false
		 */ if (result.length === data.byteLength) return result;
    }
    /*
	 * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
	 * Doesn't make sense with other TypedArray instances
	 */ if ($cd3a47597476d9ae$var$useUint8Array && data instanceof Uint8Array) return $cd3a47597476d9ae$require$Buffer.from(data);
    var isArr = $fwepD(data);
    if (isArr) for(var i = 0; i < data.length; i += 1){
        var x = data[i];
        if (typeof x !== 'number' || x < 0 || x > 255 || ~~x !== x // NaN and integer check
        ) throw new RangeError('Array items must be numbers in the range 0-255.');
    }
    /*
	 * Old Buffer polyfill on an engine that doesn't have TypedArray support
	 * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
	 * Convert to our current Buffer implementation
	 */ if (isArr || $cd3a47597476d9ae$require$Buffer.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer === 'function' && data.constructor.isBuffer(data)) return $cd3a47597476d9ae$require$Buffer.from(data);
    throw new TypeError('The "data" argument must be a string, an Array, a Buffer, a Uint8Array, or a DataView.');
};

});
parcelRegister("fwepD", function(module, exports) {
var $b4c50634133af20e$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $b4c50634133af20e$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("tmGuV", function(module, exports) {
'use strict';

var $aqgEe = parcelRequire("aqgEe");

var $17AGv = parcelRequire("17AGv");
/** @type {undefined | ((thisArg: import('.').TypedArray) => Buffer<ArrayBufferLike>)} */ var $05844e34f05e730b$var$$typedArrayBuffer = $17AGv('TypedArray.prototype.buffer', true);

var $6xUJb = parcelRequire("6xUJb");
/** @type {import('.')} */ // node <= 0.10, < 0.11.4 has a nonconfigurable own property instead of a prototype getter
module.exports = $05844e34f05e730b$var$$typedArrayBuffer || function typedArrayBuffer(x) {
    if (!$6xUJb(x)) throw new $aqgEe('Not a Typed Array');
    return x.buffer;
};

});
parcelRegister("6xUJb", function(module, exports) {
'use strict';

var $hzv9d = parcelRequire("hzv9d");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$hzv9d(value);
};

});
parcelRegister("hzv9d", function(module, exports) {
'use strict';

var $gpo3P = parcelRequire("gpo3P");

var $01yMS = parcelRequire("01yMS");

var $2ejxZ = parcelRequire("2ejxZ");

var $17AGv = parcelRequire("17AGv");

var $hHEK3 = parcelRequire("hHEK3");

var $jafvZ = parcelRequire("jafvZ");
var $ccadddcd5c2fa213$var$$toString = $17AGv('Object.prototype.toString');

var $ccadddcd5c2fa213$var$hasToStringTag = (parcelRequire("fRINa"))();
var $ccadddcd5c2fa213$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $ccadddcd5c2fa213$var$typedArrays = $01yMS();
var $ccadddcd5c2fa213$var$$slice = $17AGv('String.prototype.slice');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $ccadddcd5c2fa213$var$$indexOf = $17AGv('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {import('./types').Getter} Getter */ /** @type {import('./types').Cache} */ var $ccadddcd5c2fa213$var$cache = {
    __proto__: null
};
if ($ccadddcd5c2fa213$var$hasToStringTag && $hHEK3 && $jafvZ) $gpo3P($ccadddcd5c2fa213$var$typedArrays, function(typedArray) {
    var arr = new $ccadddcd5c2fa213$var$g[typedArray]();
    if (Symbol.toStringTag in arr && $jafvZ) {
        var proto = $jafvZ(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $hHEK3(proto, Symbol.toStringTag);
        if (!descriptor && proto) {
            var superProto = $jafvZ(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $hHEK3(superProto, Symbol.toStringTag);
        }
        // @ts-expect-error TODO: fix
        $ccadddcd5c2fa213$var$cache['$' + typedArray] = $2ejxZ(descriptor.get);
    }
});
else $gpo3P($ccadddcd5c2fa213$var$typedArrays, function(typedArray) {
    var arr = new $ccadddcd5c2fa213$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) $ccadddcd5c2fa213$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */ // @ts-expect-error TODO FIXME
    $2ejxZ(fn);
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $ccadddcd5c2fa213$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $gpo3P(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $ccadddcd5c2fa213$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            if ('$' + getter(value) === typedArray) found = /** @type {import('.').TypedArrayName} */ $ccadddcd5c2fa213$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $ccadddcd5c2fa213$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $gpo3P(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $ccadddcd5c2fa213$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            getter(value);
            found = /** @type {import('.').TypedArrayName} */ $ccadddcd5c2fa213$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$ccadddcd5c2fa213$var$hasToStringTag) {
        /** @type {string} */ var tag = $ccadddcd5c2fa213$var$$slice($ccadddcd5c2fa213$var$$toString(value), 8, -1);
        if ($ccadddcd5c2fa213$var$$indexOf($ccadddcd5c2fa213$var$typedArrays, tag) > -1) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $ccadddcd5c2fa213$var$trySlices(value);
    }
    if (!$hHEK3) return null;
     // unknown engine
    return $ccadddcd5c2fa213$var$tryTypedArrays(value);
};

});
parcelRegister("gpo3P", function(module, exports) {
'use strict';

var $f61S9 = parcelRequire("f61S9");
var $bf21a5164f939d7a$var$toStr = Object.prototype.toString;
var $bf21a5164f939d7a$var$hasOwnProperty = Object.prototype.hasOwnProperty;
/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */ var $bf21a5164f939d7a$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($bf21a5164f939d7a$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */ var $bf21a5164f939d7a$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */ var $bf21a5164f939d7a$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($bf21a5164f939d7a$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
/** @type {(x: unknown) => x is readonly unknown[]} */ function $bf21a5164f939d7a$var$isArray(x) {
    return $bf21a5164f939d7a$var$toStr.call(x) === '[object Array]';
}
/** @type {import('.')._internal} */ module.exports = function forEach(list, iterator, thisArg) {
    if (!$f61S9(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($bf21a5164f939d7a$var$isArray(list)) $bf21a5164f939d7a$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $bf21a5164f939d7a$var$forEachString(list, iterator, receiver);
    else $bf21a5164f939d7a$var$forEachObject(list, iterator, receiver);
};

});
parcelRegister("f61S9", function(module, exports) {
'use strict';
var $afd8de59a078b09f$var$fnToStr = Function.prototype.toString;
var $afd8de59a078b09f$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $afd8de59a078b09f$var$badArrayLike;
var $afd8de59a078b09f$var$isCallableMarker;
if (typeof $afd8de59a078b09f$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $afd8de59a078b09f$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $afd8de59a078b09f$var$isCallableMarker;
        }
    });
    $afd8de59a078b09f$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $afd8de59a078b09f$var$reflectApply(function() {
        throw 42;
    }, null, $afd8de59a078b09f$var$badArrayLike);
} catch (_) {
    if (_ !== $afd8de59a078b09f$var$isCallableMarker) $afd8de59a078b09f$var$reflectApply = null;
}
else $afd8de59a078b09f$var$reflectApply = null;
var $afd8de59a078b09f$var$constructorRegex = /^\s*class\b/;
var $afd8de59a078b09f$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $afd8de59a078b09f$var$fnToStr.call(value);
        return $afd8de59a078b09f$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $afd8de59a078b09f$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($afd8de59a078b09f$var$isES6ClassFn(value)) return false;
        $afd8de59a078b09f$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $afd8de59a078b09f$var$toStr = Object.prototype.toString;
var $afd8de59a078b09f$var$objectClass = '[object Object]';
var $afd8de59a078b09f$var$fnClass = '[object Function]';
var $afd8de59a078b09f$var$genClass = '[object GeneratorFunction]';
var $afd8de59a078b09f$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $afd8de59a078b09f$var$ddaClass2 = '[object HTML document.all class]';
var $afd8de59a078b09f$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $afd8de59a078b09f$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $afd8de59a078b09f$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $afd8de59a078b09f$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $afd8de59a078b09f$var$all = document.all;
    if ($afd8de59a078b09f$var$toStr.call($afd8de59a078b09f$var$all) === $afd8de59a078b09f$var$toStr.call(document.all)) $afd8de59a078b09f$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($afd8de59a078b09f$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $afd8de59a078b09f$var$toStr.call(value);
            return (str === $afd8de59a078b09f$var$ddaClass || str === $afd8de59a078b09f$var$ddaClass2 || str === $afd8de59a078b09f$var$ddaClass3 // opera 12.16
             || str === $afd8de59a078b09f$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $afd8de59a078b09f$var$reflectApply ? function isCallable(value) {
    if ($afd8de59a078b09f$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $afd8de59a078b09f$var$reflectApply(value, null, $afd8de59a078b09f$var$badArrayLike);
    } catch (e) {
        if (e !== $afd8de59a078b09f$var$isCallableMarker) return false;
    }
    return !$afd8de59a078b09f$var$isES6ClassFn(value) && $afd8de59a078b09f$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($afd8de59a078b09f$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($afd8de59a078b09f$var$hasToStringTag) return $afd8de59a078b09f$var$tryFunctionObject(value);
    if ($afd8de59a078b09f$var$isES6ClassFn(value)) return false;
    var strClass = $afd8de59a078b09f$var$toStr.call(value);
    if (strClass !== $afd8de59a078b09f$var$fnClass && strClass !== $afd8de59a078b09f$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $afd8de59a078b09f$var$tryFunctionObject(value);
};

});


parcelRegister("01yMS", function(module, exports) {
'use strict';

var $5CQyv = parcelRequire("5CQyv");
var $004b1427fa935955$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $5CQyv.length; i++)if (typeof $004b1427fa935955$var$g[$5CQyv[i]] === 'function') // @ts-expect-error
    out[out.length] = $5CQyv[i];
    return out;
};

});
parcelRegister("5CQyv", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

});


parcelRegister("2ejxZ", function(module, exports) {
'use strict';

var $6TM00 = parcelRequire("6TM00");

var $hTrXq = parcelRequire("hTrXq");

var $8TVSL = parcelRequire("8TVSL");

var $k3wTH = parcelRequire("k3wTH");
module.exports = function callBind(originalFunction) {
    var func = $8TVSL(arguments);
    var adjustedLength = originalFunction.length - (arguments.length - 1);
    return $6TM00(func, 1 + (adjustedLength > 0 ? adjustedLength : 0), true);
};
if ($hTrXq) $hTrXq(module.exports, 'apply', {
    value: $k3wTH
});
else module.exports.apply = $k3wTH;

});
parcelRegister("6TM00", function(module, exports) {
'use strict';

var $1XDuP = parcelRequire("1XDuP");

var $2RLmT = parcelRequire("2RLmT");

var $505d1cc34bbecb94$var$hasDescriptors = (parcelRequire("acIXM"))();

var $hHEK3 = parcelRequire("hHEK3");

var $aqgEe = parcelRequire("aqgEe");
var $505d1cc34bbecb94$var$$floor = $1XDuP('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $aqgEe('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $505d1cc34bbecb94$var$$floor(length) !== length) throw new $aqgEe('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $hHEK3) {
        var desc = $hHEK3(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($505d1cc34bbecb94$var$hasDescriptors) $2RLmT(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $2RLmT(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("2RLmT", function(module, exports) {
'use strict';

var $hTrXq = parcelRequire("hTrXq");

var $lnoh5 = parcelRequire("lnoh5");

var $aqgEe = parcelRequire("aqgEe");

var $hHEK3 = parcelRequire("hHEK3");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $aqgEe('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $aqgEe('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $aqgEe('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $aqgEe('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $aqgEe('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $aqgEe('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$hHEK3 && $hHEK3(obj, property);
    if ($hTrXq) $hTrXq(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $lnoh5('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});
parcelRegister("hTrXq", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $d06d4284264ffbdc$var$$defineProperty = Object.defineProperty || false;
if ($d06d4284264ffbdc$var$$defineProperty) try {
    $d06d4284264ffbdc$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $d06d4284264ffbdc$var$$defineProperty = false;
}
module.exports = $d06d4284264ffbdc$var$$defineProperty;

});

parcelRegister("hHEK3", function(module, exports) {
'use strict';

var $dfaSL = parcelRequire("dfaSL");
var $ce360e5189a0171d$require$$gOPD = $dfaSL;
if ($ce360e5189a0171d$require$$gOPD) try {
    $ce360e5189a0171d$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $ce360e5189a0171d$require$$gOPD = null;
}
module.exports = $ce360e5189a0171d$require$$gOPD;

});
parcelRegister("dfaSL", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});



parcelRegister("acIXM", function(module, exports) {
'use strict';

var $hTrXq = parcelRequire("hTrXq");
var $76dde71dbd29973f$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$hTrXq;
};
$76dde71dbd29973f$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$hTrXq) return null;
    try {
        return $hTrXq([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $76dde71dbd29973f$var$hasPropertyDescriptors;

});


parcelRegister("k3wTH", function(module, exports) {
'use strict';

var $fa7Ft = parcelRequire("fa7Ft");

var $gtj11 = parcelRequire("gtj11");

var $jtJUh = parcelRequire("jtJUh");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return $jtJUh($fa7Ft, $gtj11, arguments);
};

});


parcelRegister("jafvZ", function(module, exports) {
'use strict';

var $hbOQQ = parcelRequire("hbOQQ");

var $gXUWy = parcelRequire("gXUWy");

var $kokKH = parcelRequire("kokKH");
/** @type {import('.')} */ module.exports = $hbOQQ ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $hbOQQ(O);
} : $gXUWy ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $gXUWy(O);
} : $kokKH ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $kokKH(O);
} : null;

});
parcelRegister("hbOQQ", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("gXUWy", function(module, exports) {
'use strict';

var $kTxUg = parcelRequire("kTxUg");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $kTxUg.getPrototypeOf || null;

});
parcelRegister("kTxUg", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});


parcelRegister("kokKH", function(module, exports) {
'use strict';

var $8TVSL = parcelRequire("8TVSL");

var $hHEK3 = parcelRequire("hHEK3");
var $ed86257bb3e5c931$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $ed86257bb3e5c931$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $ed86257bb3e5c931$var$desc = !!$ed86257bb3e5c931$var$hasProtoAccessor && $hHEK3 && $hHEK3(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $ed86257bb3e5c931$var$$Object = Object;
var $ed86257bb3e5c931$var$$getPrototypeOf = $ed86257bb3e5c931$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $ed86257bb3e5c931$var$desc && typeof $ed86257bb3e5c931$var$desc.get === 'function' ? $8TVSL([
    $ed86257bb3e5c931$var$desc.get
]) : typeof $ed86257bb3e5c931$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $ed86257bb3e5c931$var$$getPrototypeOf(value == null ? value : $ed86257bb3e5c931$var$$Object(value));
} : false;

});


parcelRegister("fRINa", function(module, exports) {
'use strict';

var $lPkww = parcelRequire("lPkww");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $lPkww() && !!Symbol.toStringTag;
};

});








parcelRegister("knogy", function(module, exports) {
$parcel$export(module.exports, "readUInt32BE", () => $ed58c7568bb2ef19$export$cfaef8ed399428b0, (v) => $ed58c7568bb2ef19$export$cfaef8ed399428b0 = v);
$parcel$export(module.exports, "writeUInt32BE", () => $ed58c7568bb2ef19$export$a80c7deaea7cbd80, (v) => $ed58c7568bb2ef19$export$a80c7deaea7cbd80 = v);
$parcel$export(module.exports, "ip", () => $ed58c7568bb2ef19$export$ed7577ae6e1cd0ef, (v) => $ed58c7568bb2ef19$export$ed7577ae6e1cd0ef = v);
$parcel$export(module.exports, "rip", () => $ed58c7568bb2ef19$export$5dcbef3aa594f567, (v) => $ed58c7568bb2ef19$export$5dcbef3aa594f567 = v);
$parcel$export(module.exports, "pc1", () => $ed58c7568bb2ef19$export$5bc8001ca71ed9c5, (v) => $ed58c7568bb2ef19$export$5bc8001ca71ed9c5 = v);
$parcel$export(module.exports, "r28shl", () => $ed58c7568bb2ef19$export$3e714e2c5d5d8cb2, (v) => $ed58c7568bb2ef19$export$3e714e2c5d5d8cb2 = v);
$parcel$export(module.exports, "pc2", () => $ed58c7568bb2ef19$export$94c3e544fd062b7f, (v) => $ed58c7568bb2ef19$export$94c3e544fd062b7f = v);
$parcel$export(module.exports, "expand", () => $ed58c7568bb2ef19$export$9f77e0932fb78f72, (v) => $ed58c7568bb2ef19$export$9f77e0932fb78f72 = v);
$parcel$export(module.exports, "substitute", () => $ed58c7568bb2ef19$export$d865ce2836f5927f, (v) => $ed58c7568bb2ef19$export$d865ce2836f5927f = v);
$parcel$export(module.exports, "permute", () => $ed58c7568bb2ef19$export$95e62ad65da8b7d2, (v) => $ed58c7568bb2ef19$export$95e62ad65da8b7d2 = v);
$parcel$export(module.exports, "padSplit", () => $ed58c7568bb2ef19$export$209139ff098c441a, (v) => $ed58c7568bb2ef19$export$209139ff098c441a = v);
var $ed58c7568bb2ef19$export$cfaef8ed399428b0;
var $ed58c7568bb2ef19$export$a80c7deaea7cbd80;
var $ed58c7568bb2ef19$export$ed7577ae6e1cd0ef;
var $ed58c7568bb2ef19$export$5dcbef3aa594f567;
var $ed58c7568bb2ef19$export$5bc8001ca71ed9c5;
var $ed58c7568bb2ef19$export$3e714e2c5d5d8cb2;
var $ed58c7568bb2ef19$export$94c3e544fd062b7f;
var $ed58c7568bb2ef19$export$9f77e0932fb78f72;
var $ed58c7568bb2ef19$export$d865ce2836f5927f;
var $ed58c7568bb2ef19$export$95e62ad65da8b7d2;
var $ed58c7568bb2ef19$export$209139ff098c441a;
'use strict';
$ed58c7568bb2ef19$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$ed58c7568bb2ef19$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$ed58c7568bb2ef19$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$ed58c7568bb2ef19$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$ed58c7568bb2ef19$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$ed58c7568bb2ef19$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $ed58c7568bb2ef19$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$ed58c7568bb2ef19$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $ed58c7568bb2ef19$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $ed58c7568bb2ef19$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $ed58c7568bb2ef19$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $ed58c7568bb2ef19$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$ed58c7568bb2ef19$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $ed58c7568bb2ef19$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$ed58c7568bb2ef19$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $ed58c7568bb2ef19$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $ed58c7568bb2ef19$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $ed58c7568bb2ef19$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$ed58c7568bb2ef19$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $ed58c7568bb2ef19$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $ed58c7568bb2ef19$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$ed58c7568bb2ef19$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = '0' + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(' ');
};

});

parcelRegister("28rE0", function(module, exports) {
'use strict';

var $38nc4 = parcelRequire("38nc4");
function $18e1c5b6128f4a8d$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
    this.padding = options.padding !== false;
}
module.exports = $18e1c5b6128f4a8d$var$Cipher;
$18e1c5b6128f4a8d$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$18e1c5b6128f4a8d$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === 'decrypt') return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$18e1c5b6128f4a8d$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$18e1c5b6128f4a8d$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$18e1c5b6128f4a8d$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$18e1c5b6128f4a8d$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$18e1c5b6128f4a8d$var$Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === 'encrypt') last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$18e1c5b6128f4a8d$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$18e1c5b6128f4a8d$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$18e1c5b6128f4a8d$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$18e1c5b6128f4a8d$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $38nc4.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});
parcelRegister("38nc4", function(module, exports) {
module.exports = $24841c3da1786e9f$var$assert;
function $24841c3da1786e9f$var$assert(val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
}
$24841c3da1786e9f$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || 'Assertion failed: ' + l + ' != ' + r);
};

});


parcelRegister("8e6aA", function(module, exports) {
'use strict';

var $38nc4 = parcelRequire("38nc4");

var $ktJSc = parcelRequire("ktJSc");

var $knogy = parcelRequire("knogy");

var $28rE0 = parcelRequire("28rE0");
function $5fd46abc33668be3$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $5fd46abc33668be3$var$DES(options) {
    $28rE0.call(this, options);
    var state = new $5fd46abc33668be3$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$ktJSc($5fd46abc33668be3$var$DES, $28rE0);
module.exports = $5fd46abc33668be3$var$DES;
$5fd46abc33668be3$var$DES.create = function create(options) {
    return new $5fd46abc33668be3$var$DES(options);
};
var $5fd46abc33668be3$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$5fd46abc33668be3$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $38nc4.equal(key.length, this.blockSize, 'Invalid key length');
    var kL = $knogy.readUInt32BE(key, 0);
    var kR = $knogy.readUInt32BE(key, 4);
    $knogy.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $5fd46abc33668be3$var$shiftTable[i >>> 1];
        kL = $knogy.r28shl(kL, shift);
        kR = $knogy.r28shl(kR, shift);
        $knogy.pc2(kL, kR, state.keys, i);
    }
};
$5fd46abc33668be3$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $knogy.readUInt32BE(inp, inOff);
    var r = $knogy.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $knogy.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === 'encrypt') this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $knogy.writeUInt32BE(out, l, outOff);
    $knogy.writeUInt32BE(out, r, outOff + 4);
};
$5fd46abc33668be3$var$DES.prototype._pad = function _pad(buffer, off) {
    if (this.padding === false) return false;
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$5fd46abc33668be3$var$DES.prototype._unpad = function _unpad(buffer) {
    if (this.padding === false) return buffer;
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$38nc4.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$5fd46abc33668be3$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $knogy.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $knogy.substitute(keyL, keyR);
        var f = $knogy.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $knogy.rip(r, l, out, off);
};
$5fd46abc33668be3$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $knogy.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $knogy.substitute(keyL, keyR);
        var f = $knogy.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $knogy.rip(l, r, out, off);
};

});

parcelRegister("9NKqH", function(module, exports) {
$parcel$export(module.exports, "instantiate", () => $722cb4990c14049e$export$f9bb8d20ccc7477a, (v) => $722cb4990c14049e$export$f9bb8d20ccc7477a = v);
var $722cb4990c14049e$export$f9bb8d20ccc7477a;
'use strict';

var $38nc4 = parcelRequire("38nc4");

var $ktJSc = parcelRequire("ktJSc");
var $722cb4990c14049e$var$proto = {};
function $722cb4990c14049e$var$CBCState(iv) {
    $38nc4.equal(iv.length, 8, 'Invalid IV length');
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $722cb4990c14049e$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $ktJSc(CBC, Base);
    var keys = Object.keys($722cb4990c14049e$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $722cb4990c14049e$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$722cb4990c14049e$export$f9bb8d20ccc7477a = $722cb4990c14049e$var$instantiate;
$722cb4990c14049e$var$proto._cbcInit = function _cbcInit() {
    var state = new $722cb4990c14049e$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$722cb4990c14049e$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === 'encrypt') {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRegister("84CVV", function(module, exports) {
'use strict';

var $38nc4 = parcelRequire("38nc4");

var $ktJSc = parcelRequire("ktJSc");

var $28rE0 = parcelRequire("28rE0");

var $8e6aA = parcelRequire("8e6aA");
function $5e0ce5cc006d825a$var$EDEState(type, key) {
    $38nc4.equal(key.length, 24, 'Invalid key length');
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === 'encrypt') this.ciphers = [
        $8e6aA.create({
            type: 'encrypt',
            key: k1
        }),
        $8e6aA.create({
            type: 'decrypt',
            key: k2
        }),
        $8e6aA.create({
            type: 'encrypt',
            key: k3
        })
    ];
    else this.ciphers = [
        $8e6aA.create({
            type: 'decrypt',
            key: k3
        }),
        $8e6aA.create({
            type: 'encrypt',
            key: k2
        }),
        $8e6aA.create({
            type: 'decrypt',
            key: k1
        })
    ];
}
function $5e0ce5cc006d825a$var$EDE(options) {
    $28rE0.call(this, options);
    var state = new $5e0ce5cc006d825a$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$ktJSc($5e0ce5cc006d825a$var$EDE, $28rE0);
module.exports = $5e0ce5cc006d825a$var$EDE;
$5e0ce5cc006d825a$var$EDE.create = function create(options) {
    return new $5e0ce5cc006d825a$var$EDE(options);
};
$5e0ce5cc006d825a$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$5e0ce5cc006d825a$var$EDE.prototype._pad = $8e6aA.prototype._pad;
$5e0ce5cc006d825a$var$EDE.prototype._unpad = $8e6aA.prototype._unpad;

});

parcelRegister("iK7Mn", function(module, exports) {
$parcel$export(module.exports, "encrypt", () => $da528eae9598f9ed$export$5b0f6292f11d1d18, (v) => $da528eae9598f9ed$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $da528eae9598f9ed$export$e85a0c9a1067c5d3, (v) => $da528eae9598f9ed$export$e85a0c9a1067c5d3 = v);
var $da528eae9598f9ed$export$5b0f6292f11d1d18;
var $da528eae9598f9ed$export$e85a0c9a1067c5d3;
$da528eae9598f9ed$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$da528eae9598f9ed$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRegister("eLY8q", function(module, exports) {
$parcel$export(module.exports, "encrypt", () => $ac1419ffa9d4d6f9$export$5b0f6292f11d1d18, (v) => $ac1419ffa9d4d6f9$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $ac1419ffa9d4d6f9$export$e85a0c9a1067c5d3, (v) => $ac1419ffa9d4d6f9$export$e85a0c9a1067c5d3 = v);
var $ac1419ffa9d4d6f9$export$5b0f6292f11d1d18;
var $ac1419ffa9d4d6f9$export$e85a0c9a1067c5d3;

var $ebojG = parcelRequire("ebojG");
$ac1419ffa9d4d6f9$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $ebojG(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$ac1419ffa9d4d6f9$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $ebojG(out, pad);
};

});
parcelRegister("ebojG", function(module, exports) {

var $ekOVf = parcelRequire("ekOVf");
var $a534f47e3e0b7336$require$Buffer = $ekOVf.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $a534f47e3e0b7336$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});


parcelRegister("heQsF", function(module, exports) {
$parcel$export(module.exports, "encrypt", () => $c8cc703ad1881810$export$5b0f6292f11d1d18, (v) => $c8cc703ad1881810$export$5b0f6292f11d1d18 = v);
var $c8cc703ad1881810$export$5b0f6292f11d1d18;

var $4EeOM = parcelRequire("4EeOM");
var $c8cc703ad1881810$require$Buffer = $4EeOM.Buffer;

var $ebojG = parcelRequire("ebojG");
function $c8cc703ad1881810$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $ebojG(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $c8cc703ad1881810$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$c8cc703ad1881810$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $c8cc703ad1881810$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $c8cc703ad1881810$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $c8cc703ad1881810$require$Buffer.concat([
                out,
                $c8cc703ad1881810$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $c8cc703ad1881810$require$Buffer.concat([
                out,
                $c8cc703ad1881810$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRegister("2kPDL", function(module, exports) {
$parcel$export(module.exports, "encrypt", () => $1b3581b7c2a7ac92$export$5b0f6292f11d1d18, (v) => $1b3581b7c2a7ac92$export$5b0f6292f11d1d18 = v);
var $1b3581b7c2a7ac92$export$5b0f6292f11d1d18;

var $4EeOM = parcelRequire("4EeOM");
var $1b3581b7c2a7ac92$require$Buffer = $4EeOM.Buffer;
function $1b3581b7c2a7ac92$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $1b3581b7c2a7ac92$require$Buffer.concat([
        self._prev.slice(1),
        $1b3581b7c2a7ac92$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$1b3581b7c2a7ac92$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $1b3581b7c2a7ac92$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $1b3581b7c2a7ac92$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("l2KYy", function(module, exports) {
$parcel$export(module.exports, "encrypt", () => $f51e394ab20e2ece$export$5b0f6292f11d1d18, (v) => $f51e394ab20e2ece$export$5b0f6292f11d1d18 = v);
var $f51e394ab20e2ece$export$5b0f6292f11d1d18;

var $4EeOM = parcelRequire("4EeOM");
var $f51e394ab20e2ece$require$Buffer = $4EeOM.Buffer;
function $f51e394ab20e2ece$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $f51e394ab20e2ece$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $f51e394ab20e2ece$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $f51e394ab20e2ece$require$Buffer.allocUnsafe(buffer.length);
    buffer = $f51e394ab20e2ece$require$Buffer.concat([
        buffer,
        $f51e394ab20e2ece$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$f51e394ab20e2ece$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $f51e394ab20e2ece$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $f51e394ab20e2ece$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("cYEid", function(module, exports) {
$parcel$export(module.exports, "encrypt", () => $972a57ef3cfb0851$export$5b0f6292f11d1d18, (v) => $972a57ef3cfb0851$export$5b0f6292f11d1d18 = v);
var $972a57ef3cfb0851$export$5b0f6292f11d1d18;

var $ekOVf = parcelRequire("ekOVf");
var $972a57ef3cfb0851$require$Buffer = $ekOVf.Buffer;

var $ebojG = parcelRequire("ebojG");
function $972a57ef3cfb0851$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$972a57ef3cfb0851$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $972a57ef3cfb0851$require$Buffer.concat([
        self._cache,
        $972a57ef3cfb0851$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $ebojG(chunk, pad);
};

});

parcelRegister("bJ4Ry", function(module, exports) {
$parcel$export(module.exports, "encrypt", () => $8897ab553d3b6b89$export$5b0f6292f11d1d18, (v) => $8897ab553d3b6b89$export$5b0f6292f11d1d18 = v);
var $8897ab553d3b6b89$export$5b0f6292f11d1d18;

var $ebojG = parcelRequire("ebojG");

var $4EeOM = parcelRequire("4EeOM");
var $8897ab553d3b6b89$require$Buffer = $4EeOM.Buffer;

var $fRGpR = parcelRequire("fRGpR");
function $8897ab553d3b6b89$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $fRGpR(self._prev);
    return out;
}
var $8897ab553d3b6b89$var$blockSize = 16;
$8897ab553d3b6b89$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $8897ab553d3b6b89$var$blockSize);
    var start = self._cache.length;
    self._cache = $8897ab553d3b6b89$require$Buffer.concat([
        self._cache,
        $8897ab553d3b6b89$require$Buffer.allocUnsafe(chunkNum * $8897ab553d3b6b89$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $8897ab553d3b6b89$var$getBlock(self);
        var offset = start + i * $8897ab553d3b6b89$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $ebojG(chunk, pad);
};

});
parcelRegister("fRGpR", function(module, exports) {
function $b8ccb534cf8738c3$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $b8ccb534cf8738c3$var$incr32;

});


parcelRegister("huXFj", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("2DlfF")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("5nNgF", function(module, exports) {
var $3eb5514a8d7dbc36$var$r;
module.exports = function rand(len) {
    if (!$3eb5514a8d7dbc36$var$r) $3eb5514a8d7dbc36$var$r = new $3eb5514a8d7dbc36$var$Rand(null);
    return $3eb5514a8d7dbc36$var$r.generate(len);
};
function $3eb5514a8d7dbc36$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $3eb5514a8d7dbc36$var$Rand;
$3eb5514a8d7dbc36$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$3eb5514a8d7dbc36$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === 'object') {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $3eb5514a8d7dbc36$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $3eb5514a8d7dbc36$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === 'object') // Old junk
    $3eb5514a8d7dbc36$var$Rand.prototype._rand = function() {
        throw new Error('Not implemented yet');
    };
} else // Node.js or Web worker with no crypto support
try {
    var $3eb5514a8d7dbc36$var$crypto = (parcelRequire("2DlfF"));
    if (typeof $3eb5514a8d7dbc36$var$crypto.randomBytes !== 'function') throw new Error('Not supported');
    $3eb5514a8d7dbc36$var$Rand.prototype._rand = function _rand(n) {
        return $3eb5514a8d7dbc36$var$crypto.randomBytes(n);
    };
} catch (e) {}

});

parcelRegister("gAb5Q", function(module, exports) {

exports = module.exports = (parcelRequire("g7Y7q"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("i7pQT"));

exports.Duplex = (parcelRequire("ebcTT"));

exports.Transform = (parcelRequire("1berE"));

exports.PassThrough = (parcelRequire("9XWzK"));

});
parcelRegister("g7Y7q", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $1CHRc = parcelRequire("1CHRc");
'use strict';

var $kvWCz = parcelRequire("kvWCz");
/*</replacement>*/ module.exports = $0307ad2591bc7b5f$var$Readable;

var $9xKyp = parcelRequire("9xKyp");
/*</replacement>*/ /*<replacement>*/ var $0307ad2591bc7b5f$var$Duplex;
/*</replacement>*/ $0307ad2591bc7b5f$var$Readable.ReadableState = $0307ad2591bc7b5f$var$ReadableState;

var $3V23I = parcelRequire("3V23I");
var $0307ad2591bc7b5f$require$EE = $3V23I.EventEmitter;
var $0307ad2591bc7b5f$var$EElistenerCount = function(emitter, type) {
    return emitter.listeners(type).length;
};

var $eO95d = parcelRequire("eO95d");

var $3BB0m = parcelRequire("3BB0m");
var $0307ad2591bc7b5f$require$Buffer = $3BB0m.Buffer;
var $0307ad2591bc7b5f$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $0307ad2591bc7b5f$var$_uint8ArrayToBuffer(chunk) {
    return $0307ad2591bc7b5f$require$Buffer.from(chunk);
}
function $0307ad2591bc7b5f$var$_isUint8Array(obj) {
    return $0307ad2591bc7b5f$require$Buffer.isBuffer(obj) || obj instanceof $0307ad2591bc7b5f$var$OurUint8Array;
}

/*</replacement>*/ /*<replacement>*/ var $0307ad2591bc7b5f$var$util = Object.create((parcelRequire("59Xcy")));

$0307ad2591bc7b5f$var$util.inherits = (parcelRequire("ktJSc"));

var $2DlfF = parcelRequire("2DlfF");
var $0307ad2591bc7b5f$var$debug = void 0;
if ($2DlfF && $2DlfF.debuglog) $0307ad2591bc7b5f$var$debug = $2DlfF.debuglog('stream');
else $0307ad2591bc7b5f$var$debug = function() {};

var $6BZiC = parcelRequire("6BZiC");

var $3mifv = parcelRequire("3mifv");
var $0307ad2591bc7b5f$var$StringDecoder;
$0307ad2591bc7b5f$var$util.inherits($0307ad2591bc7b5f$var$Readable, $eO95d);
var $0307ad2591bc7b5f$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $0307ad2591bc7b5f$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($9xKyp(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $0307ad2591bc7b5f$var$ReadableState(options, stream) {
    $0307ad2591bc7b5f$var$Duplex = $0307ad2591bc7b5f$var$Duplex || (parcelRequire("ebcTT"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $0307ad2591bc7b5f$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    var hwm = options.highWaterMark;
    var readableHwm = options.readableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $6BZiC();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$0307ad2591bc7b5f$var$StringDecoder) $0307ad2591bc7b5f$var$StringDecoder = (parcelRequire("ljb5R")).StringDecoder;
        this.decoder = new $0307ad2591bc7b5f$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $0307ad2591bc7b5f$var$Readable(options) {
    $0307ad2591bc7b5f$var$Duplex = $0307ad2591bc7b5f$var$Duplex || (parcelRequire("ebcTT"));
    if (!(this instanceof $0307ad2591bc7b5f$var$Readable)) return new $0307ad2591bc7b5f$var$Readable(options);
    this._readableState = new $0307ad2591bc7b5f$var$ReadableState(options, this);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $eO95d.call(this);
}
Object.defineProperty($0307ad2591bc7b5f$var$Readable.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$0307ad2591bc7b5f$var$Readable.prototype.destroy = $3mifv.destroy;
$0307ad2591bc7b5f$var$Readable.prototype._undestroy = $3mifv.undestroy;
$0307ad2591bc7b5f$var$Readable.prototype._destroy = function(err, cb) {
    this.push(null);
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$0307ad2591bc7b5f$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $0307ad2591bc7b5f$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $0307ad2591bc7b5f$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$0307ad2591bc7b5f$var$Readable.prototype.unshift = function(chunk) {
    return $0307ad2591bc7b5f$var$readableAddChunk(this, chunk, null, true, false);
};
function $0307ad2591bc7b5f$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $0307ad2591bc7b5f$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $0307ad2591bc7b5f$var$chunkInvalid(state, chunk);
        if (er) stream.emit('error', er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $0307ad2591bc7b5f$require$Buffer.prototype) chunk = $0307ad2591bc7b5f$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));
                else $0307ad2591bc7b5f$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) stream.emit('error', new Error('stream.push() after EOF'));
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $0307ad2591bc7b5f$var$addChunk(stream, state, chunk, false);
                    else $0307ad2591bc7b5f$var$maybeReadMore(stream, state);
                } else $0307ad2591bc7b5f$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) state.reading = false;
    }
    return $0307ad2591bc7b5f$var$needMoreData(state);
}
function $0307ad2591bc7b5f$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        stream.emit('data', chunk);
        stream.read(0);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $0307ad2591bc7b5f$var$emitReadable(stream);
    }
    $0307ad2591bc7b5f$var$maybeReadMore(stream, state);
}
function $0307ad2591bc7b5f$var$chunkInvalid(state, chunk) {
    var er;
    if (!$0307ad2591bc7b5f$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    return er;
}
// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function $0307ad2591bc7b5f$var$needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}
$0307ad2591bc7b5f$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$0307ad2591bc7b5f$var$Readable.prototype.setEncoding = function(enc) {
    if (!$0307ad2591bc7b5f$var$StringDecoder) $0307ad2591bc7b5f$var$StringDecoder = (parcelRequire("ljb5R")).StringDecoder;
    this._readableState.decoder = new $0307ad2591bc7b5f$var$StringDecoder(enc);
    this._readableState.encoding = enc;
    return this;
};
// Don't raise the hwm > 8MB
var $0307ad2591bc7b5f$var$MAX_HWM = 0x800000;
function $0307ad2591bc7b5f$var$computeNewHighWaterMark(n) {
    if (n >= $0307ad2591bc7b5f$var$MAX_HWM) n = $0307ad2591bc7b5f$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $0307ad2591bc7b5f$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $0307ad2591bc7b5f$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$0307ad2591bc7b5f$var$Readable.prototype.read = function(n) {
    $0307ad2591bc7b5f$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        $0307ad2591bc7b5f$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $0307ad2591bc7b5f$var$endReadable(this);
        else $0307ad2591bc7b5f$var$emitReadable(this);
        return null;
    }
    n = $0307ad2591bc7b5f$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $0307ad2591bc7b5f$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $0307ad2591bc7b5f$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $0307ad2591bc7b5f$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $0307ad2591bc7b5f$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $0307ad2591bc7b5f$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $0307ad2591bc7b5f$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $0307ad2591bc7b5f$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = true;
        n = 0;
    } else state.length -= n;
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $0307ad2591bc7b5f$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $0307ad2591bc7b5f$var$onEofChunk(stream, state) {
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    // emit 'readable' now to make sure it gets picked up.
    $0307ad2591bc7b5f$var$emitReadable(stream);
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $0307ad2591bc7b5f$var$emitReadable(stream) {
    var state = stream._readableState;
    state.needReadable = false;
    if (!state.emittedReadable) {
        $0307ad2591bc7b5f$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        if (state.sync) $kvWCz.nextTick($0307ad2591bc7b5f$var$emitReadable_, stream);
        else $0307ad2591bc7b5f$var$emitReadable_(stream);
    }
}
function $0307ad2591bc7b5f$var$emitReadable_(stream) {
    $0307ad2591bc7b5f$var$debug('emit readable');
    stream.emit('readable');
    $0307ad2591bc7b5f$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $0307ad2591bc7b5f$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $kvWCz.nextTick($0307ad2591bc7b5f$var$maybeReadMore_, stream, state);
    }
}
function $0307ad2591bc7b5f$var$maybeReadMore_(stream, state) {
    var len = state.length;
    while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
        $0307ad2591bc7b5f$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
        else len = state.length;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$0307ad2591bc7b5f$var$Readable.prototype._read = function(n) {
    this.emit('error', new Error('_read() is not implemented'));
};
$0307ad2591bc7b5f$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $0307ad2591bc7b5f$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $1CHRc.stdout && dest !== $1CHRc.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $kvWCz.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $0307ad2591bc7b5f$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $0307ad2591bc7b5f$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $0307ad2591bc7b5f$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $0307ad2591bc7b5f$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.
    var increasedAwaitDrain = false;
    src.on('data', ondata);
    function ondata(chunk) {
        $0307ad2591bc7b5f$var$debug('ondata');
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);
        if (false === ret && !increasedAwaitDrain) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $0307ad2591bc7b5f$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $0307ad2591bc7b5f$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
                increasedAwaitDrain = true;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $0307ad2591bc7b5f$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($0307ad2591bc7b5f$var$EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
    }
    // Make sure our error handler is attached before userland ones.
    $0307ad2591bc7b5f$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $0307ad2591bc7b5f$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $0307ad2591bc7b5f$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $0307ad2591bc7b5f$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $0307ad2591bc7b5f$var$pipeOnDrain(src) {
    return function() {
        var state = src._readableState;
        $0307ad2591bc7b5f$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $0307ad2591bc7b5f$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $0307ad2591bc7b5f$var$flow(src);
        }
    };
}
$0307ad2591bc7b5f$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $0307ad2591bc7b5f$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$0307ad2591bc7b5f$var$Readable.prototype.on = function(ev, fn) {
    var res = $eO95d.prototype.on.call(this, ev, fn);
    if (ev === 'data') // Start flowing on next tick if stream isn't explicitly paused
    {
        if (this._readableState.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        var state = this._readableState;
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.emittedReadable = false;
            if (!state.reading) $kvWCz.nextTick($0307ad2591bc7b5f$var$nReadingNextTick, this);
            else if (state.length) $0307ad2591bc7b5f$var$emitReadable(this);
        }
    }
    return res;
};
$0307ad2591bc7b5f$var$Readable.prototype.addListener = $0307ad2591bc7b5f$var$Readable.prototype.on;
function $0307ad2591bc7b5f$var$nReadingNextTick(self1) {
    $0307ad2591bc7b5f$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$0307ad2591bc7b5f$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $0307ad2591bc7b5f$var$debug('resume');
        state.flowing = true;
        $0307ad2591bc7b5f$var$resume(this, state);
    }
    return this;
};
function $0307ad2591bc7b5f$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $kvWCz.nextTick($0307ad2591bc7b5f$var$resume_, stream, state);
    }
}
function $0307ad2591bc7b5f$var$resume_(stream, state) {
    if (!state.reading) {
        $0307ad2591bc7b5f$var$debug('resume read 0');
        stream.read(0);
    }
    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit('resume');
    $0307ad2591bc7b5f$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$0307ad2591bc7b5f$var$Readable.prototype.pause = function() {
    $0307ad2591bc7b5f$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (false !== this._readableState.flowing) {
        $0307ad2591bc7b5f$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    return this;
};
function $0307ad2591bc7b5f$var$flow(stream) {
    var state = stream._readableState;
    $0307ad2591bc7b5f$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$0307ad2591bc7b5f$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $0307ad2591bc7b5f$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $0307ad2591bc7b5f$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function(method) {
        return function() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $0307ad2591bc7b5f$var$kProxyEvents.length; n++)stream.on($0307ad2591bc7b5f$var$kProxyEvents[n], this.emit.bind(this, $0307ad2591bc7b5f$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $0307ad2591bc7b5f$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
Object.defineProperty($0307ad2591bc7b5f$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._readableState.highWaterMark;
    }
});
// exposed for testing purposes only.
$0307ad2591bc7b5f$var$Readable._fromList = $0307ad2591bc7b5f$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $0307ad2591bc7b5f$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.head.data;
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = $0307ad2591bc7b5f$var$fromListPartial(n, state.buffer, state.decoder);
    return ret;
}
// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $0307ad2591bc7b5f$var$fromListPartial(n, list, hasStrings) {
    var ret;
    if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) // first chunk is a perfect match
    ret = list.shift();
    else // result spans more than one buffer
    ret = hasStrings ? $0307ad2591bc7b5f$var$copyFromBufferString(n, list) : $0307ad2591bc7b5f$var$copyFromBuffer(n, list);
    return ret;
}
// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $0307ad2591bc7b5f$var$copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;
    while(p = p.next){
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;
        else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
            if (nb === str.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = str.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $0307ad2591bc7b5f$var$copyFromBuffer(n, list) {
    var ret = $0307ad2591bc7b5f$require$Buffer.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;
    while(p = p.next){
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
            if (nb === buf.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = buf.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
function $0307ad2591bc7b5f$var$endReadable(stream) {
    var state = stream._readableState;
    // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.
    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    if (!state.endEmitted) {
        state.ended = true;
        $kvWCz.nextTick($0307ad2591bc7b5f$var$endReadableNT, state, stream);
    }
}
function $0307ad2591bc7b5f$var$endReadableNT(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
    }
}
function $0307ad2591bc7b5f$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("kvWCz", function(module, exports) {

var $1CHRc = parcelRequire("1CHRc");
'use strict';
if (typeof $1CHRc === 'undefined' || !$1CHRc.version || $1CHRc.version.indexOf('v0.') === 0 || $1CHRc.version.indexOf('v1.') === 0 && $1CHRc.version.indexOf('v1.8.') !== 0) module.exports = {
    nextTick: $eef42ccf605bdbdb$var$nextTick
};
else module.exports = $1CHRc;
function $eef42ccf605bdbdb$var$nextTick(fn, arg1, arg2, arg3) {
    if (typeof fn !== 'function') throw new TypeError('"callback" argument must be a function');
    var len = arguments.length;
    var args, i;
    switch(len){
        case 0:
        case 1:
            return $1CHRc.nextTick(fn);
        case 2:
            return $1CHRc.nextTick(function afterTickOne() {
                fn.call(null, arg1);
            });
        case 3:
            return $1CHRc.nextTick(function afterTickTwo() {
                fn.call(null, arg1, arg2);
            });
        case 4:
            return $1CHRc.nextTick(function afterTickThree() {
                fn.call(null, arg1, arg2, arg3);
            });
        default:
            args = new Array(len - 1);
            i = 0;
            while(i < args.length)args[i++] = arguments[i];
            return $1CHRc.nextTick(function afterTick() {
                fn.apply(null, args);
            });
    }
}

});

parcelRegister("9xKyp", function(module, exports) {
var $6f2b4ec2d553e186$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $6f2b4ec2d553e186$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("eO95d", function(module, exports) {

module.exports = (parcelRequire("3V23I")).EventEmitter;

});

parcelRegister("3BB0m", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $ekOVf = parcelRequire("ekOVf");
var $2a018833abb230ad$var$Buffer = $ekOVf.Buffer;
// alternative to using Object.keys for old browsers
function $2a018833abb230ad$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($2a018833abb230ad$var$Buffer.from && $2a018833abb230ad$var$Buffer.alloc && $2a018833abb230ad$var$Buffer.allocUnsafe && $2a018833abb230ad$var$Buffer.allocUnsafeSlow) module.exports = $ekOVf;
else {
    // Copy properties from require('buffer')
    $2a018833abb230ad$var$copyProps($ekOVf, module.exports);
    module.exports.Buffer = $2a018833abb230ad$var$SafeBuffer;
}
function $2a018833abb230ad$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $2a018833abb230ad$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$2a018833abb230ad$var$copyProps($2a018833abb230ad$var$Buffer, $2a018833abb230ad$var$SafeBuffer);
$2a018833abb230ad$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $2a018833abb230ad$var$Buffer(arg, encodingOrOffset, length);
};
$2a018833abb230ad$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $2a018833abb230ad$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$2a018833abb230ad$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $2a018833abb230ad$var$Buffer(size);
};
$2a018833abb230ad$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $ekOVf.SlowBuffer(size);
};

});

parcelRegister("59Xcy", function(module, exports) {
$parcel$export(module.exports, "isArray", () => $3c1bb730e87ae1a7$export$43bee75e5e14138e, (v) => $3c1bb730e87ae1a7$export$43bee75e5e14138e = v);
$parcel$export(module.exports, "isBoolean", () => $3c1bb730e87ae1a7$export$f9ce7b637dfbe238, (v) => $3c1bb730e87ae1a7$export$f9ce7b637dfbe238 = v);
$parcel$export(module.exports, "isNull", () => $3c1bb730e87ae1a7$export$630801d484da15df, (v) => $3c1bb730e87ae1a7$export$630801d484da15df = v);
$parcel$export(module.exports, "isNullOrUndefined", () => $3c1bb730e87ae1a7$export$bedb7023a7733221, (v) => $3c1bb730e87ae1a7$export$bedb7023a7733221 = v);
$parcel$export(module.exports, "isNumber", () => $3c1bb730e87ae1a7$export$7e4aa119212bc614, (v) => $3c1bb730e87ae1a7$export$7e4aa119212bc614 = v);
$parcel$export(module.exports, "isString", () => $3c1bb730e87ae1a7$export$844ec244b1367d54, (v) => $3c1bb730e87ae1a7$export$844ec244b1367d54 = v);
$parcel$export(module.exports, "isSymbol", () => $3c1bb730e87ae1a7$export$a244864fd9645c7f, (v) => $3c1bb730e87ae1a7$export$a244864fd9645c7f = v);
$parcel$export(module.exports, "isUndefined", () => $3c1bb730e87ae1a7$export$fce6876652108ab, (v) => $3c1bb730e87ae1a7$export$fce6876652108ab = v);
$parcel$export(module.exports, "isRegExp", () => $3c1bb730e87ae1a7$export$49841c62b9eff15, (v) => $3c1bb730e87ae1a7$export$49841c62b9eff15 = v);
$parcel$export(module.exports, "isObject", () => $3c1bb730e87ae1a7$export$a6cdc56e425d0d0a, (v) => $3c1bb730e87ae1a7$export$a6cdc56e425d0d0a = v);
$parcel$export(module.exports, "isDate", () => $3c1bb730e87ae1a7$export$871608497c498473, (v) => $3c1bb730e87ae1a7$export$871608497c498473 = v);
$parcel$export(module.exports, "isError", () => $3c1bb730e87ae1a7$export$e6127cc7fe7395c3, (v) => $3c1bb730e87ae1a7$export$e6127cc7fe7395c3 = v);
$parcel$export(module.exports, "isFunction", () => $3c1bb730e87ae1a7$export$f6e2535fb5126e54, (v) => $3c1bb730e87ae1a7$export$f6e2535fb5126e54 = v);
$parcel$export(module.exports, "isPrimitive", () => $3c1bb730e87ae1a7$export$c3825b437cbdea5c, (v) => $3c1bb730e87ae1a7$export$c3825b437cbdea5c = v);
$parcel$export(module.exports, "isBuffer", () => $3c1bb730e87ae1a7$export$a7884ebc965f8f54, (v) => $3c1bb730e87ae1a7$export$a7884ebc965f8f54 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
var $3c1bb730e87ae1a7$export$43bee75e5e14138e;
var $3c1bb730e87ae1a7$export$f9ce7b637dfbe238;
var $3c1bb730e87ae1a7$export$630801d484da15df;
var $3c1bb730e87ae1a7$export$bedb7023a7733221;
var $3c1bb730e87ae1a7$export$7e4aa119212bc614;
var $3c1bb730e87ae1a7$export$844ec244b1367d54;
var $3c1bb730e87ae1a7$export$a244864fd9645c7f;
var $3c1bb730e87ae1a7$export$fce6876652108ab;
var $3c1bb730e87ae1a7$export$49841c62b9eff15;
var $3c1bb730e87ae1a7$export$a6cdc56e425d0d0a;
var $3c1bb730e87ae1a7$export$871608497c498473;
var $3c1bb730e87ae1a7$export$e6127cc7fe7395c3;
var $3c1bb730e87ae1a7$export$f6e2535fb5126e54;
var $3c1bb730e87ae1a7$export$c3825b437cbdea5c;
var $3c1bb730e87ae1a7$export$a7884ebc965f8f54;
function $3c1bb730e87ae1a7$var$isArray(arg) {
    if (Array.isArray) return Array.isArray(arg);
    return $3c1bb730e87ae1a7$var$objectToString(arg) === '[object Array]';
}
$3c1bb730e87ae1a7$export$43bee75e5e14138e = $3c1bb730e87ae1a7$var$isArray;
function $3c1bb730e87ae1a7$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
$3c1bb730e87ae1a7$export$f9ce7b637dfbe238 = $3c1bb730e87ae1a7$var$isBoolean;
function $3c1bb730e87ae1a7$var$isNull(arg) {
    return arg === null;
}
$3c1bb730e87ae1a7$export$630801d484da15df = $3c1bb730e87ae1a7$var$isNull;
function $3c1bb730e87ae1a7$var$isNullOrUndefined(arg) {
    return arg == null;
}
$3c1bb730e87ae1a7$export$bedb7023a7733221 = $3c1bb730e87ae1a7$var$isNullOrUndefined;
function $3c1bb730e87ae1a7$var$isNumber(arg) {
    return typeof arg === 'number';
}
$3c1bb730e87ae1a7$export$7e4aa119212bc614 = $3c1bb730e87ae1a7$var$isNumber;
function $3c1bb730e87ae1a7$var$isString(arg) {
    return typeof arg === 'string';
}
$3c1bb730e87ae1a7$export$844ec244b1367d54 = $3c1bb730e87ae1a7$var$isString;
function $3c1bb730e87ae1a7$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
$3c1bb730e87ae1a7$export$a244864fd9645c7f = $3c1bb730e87ae1a7$var$isSymbol;
function $3c1bb730e87ae1a7$var$isUndefined(arg) {
    return arg === void 0;
}
$3c1bb730e87ae1a7$export$fce6876652108ab = $3c1bb730e87ae1a7$var$isUndefined;
function $3c1bb730e87ae1a7$var$isRegExp(re) {
    return $3c1bb730e87ae1a7$var$objectToString(re) === '[object RegExp]';
}
$3c1bb730e87ae1a7$export$49841c62b9eff15 = $3c1bb730e87ae1a7$var$isRegExp;
function $3c1bb730e87ae1a7$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
$3c1bb730e87ae1a7$export$a6cdc56e425d0d0a = $3c1bb730e87ae1a7$var$isObject;
function $3c1bb730e87ae1a7$var$isDate(d) {
    return $3c1bb730e87ae1a7$var$objectToString(d) === '[object Date]';
}
$3c1bb730e87ae1a7$export$871608497c498473 = $3c1bb730e87ae1a7$var$isDate;
function $3c1bb730e87ae1a7$var$isError(e) {
    return $3c1bb730e87ae1a7$var$objectToString(e) === '[object Error]' || e instanceof Error;
}
$3c1bb730e87ae1a7$export$e6127cc7fe7395c3 = $3c1bb730e87ae1a7$var$isError;
function $3c1bb730e87ae1a7$var$isFunction(arg) {
    return typeof arg === 'function';
}
$3c1bb730e87ae1a7$export$f6e2535fb5126e54 = $3c1bb730e87ae1a7$var$isFunction;
function $3c1bb730e87ae1a7$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
$3c1bb730e87ae1a7$export$c3825b437cbdea5c = $3c1bb730e87ae1a7$var$isPrimitive;

$3c1bb730e87ae1a7$export$a7884ebc965f8f54 = (parcelRequire("ekOVf")).Buffer.isBuffer;
function $3c1bb730e87ae1a7$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}

});

parcelRegister("6BZiC", function(module, exports) {
'use strict';
function $4d05bf86418249a1$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $3BB0m = parcelRequire("3BB0m");
var $4d05bf86418249a1$require$Buffer = $3BB0m.Buffer;

var $2DlfF = parcelRequire("2DlfF");
function $4d05bf86418249a1$var$copyBuffer(src, target, offset) {
    src.copy(target, offset);
}
module.exports = function() {
    function BufferList() {
        $4d05bf86418249a1$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    BufferList.prototype.push = function push(v) {
        var entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    };
    BufferList.prototype.unshift = function unshift(v) {
        var entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    };
    BufferList.prototype.shift = function shift() {
        if (this.length === 0) return;
        var ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    };
    BufferList.prototype.clear = function clear() {
        this.head = this.tail = null;
        this.length = 0;
    };
    BufferList.prototype.join = function join(s) {
        if (this.length === 0) return '';
        var p = this.head;
        var ret = '' + p.data;
        while(p = p.next)ret += s + p.data;
        return ret;
    };
    BufferList.prototype.concat = function concat(n) {
        if (this.length === 0) return $4d05bf86418249a1$require$Buffer.alloc(0);
        var ret = $4d05bf86418249a1$require$Buffer.allocUnsafe(n >>> 0);
        var p = this.head;
        var i = 0;
        while(p){
            $4d05bf86418249a1$var$copyBuffer(p.data, ret, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    };
    return BufferList;
}();
if ($2DlfF && $2DlfF.inspect && $2DlfF.inspect.custom) module.exports.prototype[$2DlfF.inspect.custom] = function() {
    var obj = $2DlfF.inspect({
        length: this.length
    });
    return this.constructor.name + ' ' + obj;
};

});

parcelRegister("3mifv", function(module, exports) {
'use strict';

var $kvWCz = parcelRequire("kvWCz");
/*</replacement>*/ // undocumented cb() API, needed for core, not for public API
function $2721950f62ffd5db$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $kvWCz.nextTick($2721950f62ffd5db$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $kvWCz.nextTick($2721950f62ffd5db$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $kvWCz.nextTick($2721950f62ffd5db$var$emitErrorNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $kvWCz.nextTick($2721950f62ffd5db$var$emitErrorNT, _this, err);
            }
        } else if (cb) cb(err);
    });
    return this;
}
function $2721950f62ffd5db$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $2721950f62ffd5db$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
module.exports = {
    destroy: $2721950f62ffd5db$var$destroy,
    undestroy: $2721950f62ffd5db$var$undestroy
};

});

parcelRegister("ebcTT", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
'use strict';

var $kvWCz = parcelRequire("kvWCz");
/*</replacement>*/ /*<replacement>*/ var $a52c198c7a1a0d7e$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $a52c198c7a1a0d7e$var$Duplex;

/*<replacement>*/ var $a52c198c7a1a0d7e$var$util = Object.create((parcelRequire("59Xcy")));

$a52c198c7a1a0d7e$var$util.inherits = (parcelRequire("ktJSc"));

var $g7Y7q = parcelRequire("g7Y7q");

var $i7pQT = parcelRequire("i7pQT");
$a52c198c7a1a0d7e$var$util.inherits($a52c198c7a1a0d7e$var$Duplex, $g7Y7q);
// avoid scope creep, the keys array can then be collected
var $a52c198c7a1a0d7e$var$keys = $a52c198c7a1a0d7e$var$objectKeys($i7pQT.prototype);
for(var $a52c198c7a1a0d7e$var$v = 0; $a52c198c7a1a0d7e$var$v < $a52c198c7a1a0d7e$var$keys.length; $a52c198c7a1a0d7e$var$v++){
    var $a52c198c7a1a0d7e$var$method = $a52c198c7a1a0d7e$var$keys[$a52c198c7a1a0d7e$var$v];
    if (!$a52c198c7a1a0d7e$var$Duplex.prototype[$a52c198c7a1a0d7e$var$method]) $a52c198c7a1a0d7e$var$Duplex.prototype[$a52c198c7a1a0d7e$var$method] = $i7pQT.prototype[$a52c198c7a1a0d7e$var$method];
}
function $a52c198c7a1a0d7e$var$Duplex(options) {
    if (!(this instanceof $a52c198c7a1a0d7e$var$Duplex)) return new $a52c198c7a1a0d7e$var$Duplex(options);
    $g7Y7q.call(this, options);
    $i7pQT.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once('end', $a52c198c7a1a0d7e$var$onend);
}
Object.defineProperty($a52c198c7a1a0d7e$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// the no-half-open enforcer
function $a52c198c7a1a0d7e$var$onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $kvWCz.nextTick($a52c198c7a1a0d7e$var$onEndNT, this);
}
function $a52c198c7a1a0d7e$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($a52c198c7a1a0d7e$var$Duplex.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});
$a52c198c7a1a0d7e$var$Duplex.prototype._destroy = function(err, cb) {
    this.push(null);
    this.end();
    $kvWCz.nextTick(cb, err);
};

});
parcelRegister("i7pQT", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $kvWCz = parcelRequire("kvWCz");
/*</replacement>*/ module.exports = $d30cef26cbb7bedd$var$Writable;
/* <replacement> */ function $d30cef26cbb7bedd$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $d30cef26cbb7bedd$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $d30cef26cbb7bedd$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $d30cef26cbb7bedd$var$asyncWrite = (0, $kvWCz.nextTick);
/*</replacement>*/ /*<replacement>*/ var $d30cef26cbb7bedd$var$Duplex;
/*</replacement>*/ $d30cef26cbb7bedd$var$Writable.WritableState = $d30cef26cbb7bedd$var$WritableState;

/*<replacement>*/ var $d30cef26cbb7bedd$var$util = Object.create((parcelRequire("59Xcy")));

$d30cef26cbb7bedd$var$util.inherits = (parcelRequire("ktJSc"));

/*</replacement>*/ /*<replacement>*/ var $d30cef26cbb7bedd$var$internalUtil = {
    deprecate: (parcelRequire("9hK5W"))
};

var $eO95d = parcelRequire("eO95d");

var $3BB0m = parcelRequire("3BB0m");
var $d30cef26cbb7bedd$require$Buffer = $3BB0m.Buffer;
var $d30cef26cbb7bedd$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $d30cef26cbb7bedd$var$_uint8ArrayToBuffer(chunk) {
    return $d30cef26cbb7bedd$require$Buffer.from(chunk);
}
function $d30cef26cbb7bedd$var$_isUint8Array(obj) {
    return $d30cef26cbb7bedd$require$Buffer.isBuffer(obj) || obj instanceof $d30cef26cbb7bedd$var$OurUint8Array;
}

var $3mifv = parcelRequire("3mifv");
$d30cef26cbb7bedd$var$util.inherits($d30cef26cbb7bedd$var$Writable, $eO95d);
function $d30cef26cbb7bedd$var$nop() {}

function $d30cef26cbb7bedd$var$WritableState(options, stream) {
    $d30cef26cbb7bedd$var$Duplex = $d30cef26cbb7bedd$var$Duplex || (parcelRequire("ebcTT"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $d30cef26cbb7bedd$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    var hwm = options.highWaterMark;
    var writableHwm = options.writableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $d30cef26cbb7bedd$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $d30cef26cbb7bedd$var$CorkedRequest(this);
}
$d30cef26cbb7bedd$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($d30cef26cbb7bedd$var$WritableState.prototype, 'buffer', {
            get: $d30cef26cbb7bedd$var$internalUtil.deprecate(function() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $d30cef26cbb7bedd$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $d30cef26cbb7bedd$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($d30cef26cbb7bedd$var$Writable, Symbol.hasInstance, {
        value: function(object) {
            if ($d30cef26cbb7bedd$var$realHasInstance.call(this, object)) return true;
            if (this !== $d30cef26cbb7bedd$var$Writable) return false;
            return object && object._writableState instanceof $d30cef26cbb7bedd$var$WritableState;
        }
    });
} else $d30cef26cbb7bedd$var$realHasInstance = function(object) {
    return object instanceof this;
};

function $d30cef26cbb7bedd$var$Writable(options) {
    $d30cef26cbb7bedd$var$Duplex = $d30cef26cbb7bedd$var$Duplex || (parcelRequire("ebcTT"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    if (!$d30cef26cbb7bedd$var$realHasInstance.call($d30cef26cbb7bedd$var$Writable, this) && !(this instanceof $d30cef26cbb7bedd$var$Duplex)) return new $d30cef26cbb7bedd$var$Writable(options);
    this._writableState = new $d30cef26cbb7bedd$var$WritableState(options, this);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $eO95d.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$d30cef26cbb7bedd$var$Writable.prototype.pipe = function() {
    this.emit('error', new Error('Cannot pipe, not readable'));
};
function $d30cef26cbb7bedd$var$writeAfterEnd(stream, cb) {
    var er = new Error('write after end');
    // TODO: defer error events consistently everywhere, not just the cb
    stream.emit('error', er);
    $kvWCz.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $d30cef26cbb7bedd$var$validChunk(stream, state, chunk, cb) {
    var valid = true;
    var er = false;
    if (chunk === null) er = new TypeError('May not write null values to stream');
    else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    if (er) {
        stream.emit('error', er);
        $kvWCz.nextTick(cb, er);
        valid = false;
    }
    return valid;
}
$d30cef26cbb7bedd$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $d30cef26cbb7bedd$var$_isUint8Array(chunk);
    if (isBuf && !$d30cef26cbb7bedd$require$Buffer.isBuffer(chunk)) chunk = $d30cef26cbb7bedd$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $d30cef26cbb7bedd$var$nop;
    if (state.ended) $d30cef26cbb7bedd$var$writeAfterEnd(this, cb);
    else if (isBuf || $d30cef26cbb7bedd$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $d30cef26cbb7bedd$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$d30cef26cbb7bedd$var$Writable.prototype.cork = function() {
    var state = this._writableState;
    state.corked++;
};
$d30cef26cbb7bedd$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $d30cef26cbb7bedd$var$clearBuffer(this, state);
    }
};
$d30cef26cbb7bedd$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
function $d30cef26cbb7bedd$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $d30cef26cbb7bedd$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($d30cef26cbb7bedd$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $d30cef26cbb7bedd$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $d30cef26cbb7bedd$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $d30cef26cbb7bedd$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $d30cef26cbb7bedd$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $d30cef26cbb7bedd$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $kvWCz.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $kvWCz.nextTick($d30cef26cbb7bedd$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
        // this can emit finish, but finish must
        // always follow error
        $d30cef26cbb7bedd$var$finishMaybe(stream, state);
    }
}
function $d30cef26cbb7bedd$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $d30cef26cbb7bedd$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    $d30cef26cbb7bedd$var$onwriteStateUpdate(state);
    if (er) $d30cef26cbb7bedd$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $d30cef26cbb7bedd$var$needFinish(state);
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $d30cef26cbb7bedd$var$clearBuffer(stream, state);
        if (sync) /*<replacement>*/ $d30cef26cbb7bedd$var$asyncWrite($d30cef26cbb7bedd$var$afterWrite, stream, state, finished, cb);
        else $d30cef26cbb7bedd$var$afterWrite(stream, state, finished, cb);
    }
}
function $d30cef26cbb7bedd$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $d30cef26cbb7bedd$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $d30cef26cbb7bedd$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $d30cef26cbb7bedd$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $d30cef26cbb7bedd$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $d30cef26cbb7bedd$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $d30cef26cbb7bedd$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $d30cef26cbb7bedd$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$d30cef26cbb7bedd$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new Error('_write() is not implemented'));
};
$d30cef26cbb7bedd$var$Writable.prototype._writev = null;
$d30cef26cbb7bedd$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $d30cef26cbb7bedd$var$endWritable(this, state, cb);
};
function $d30cef26cbb7bedd$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $d30cef26cbb7bedd$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) stream.emit('error', err);
        state.prefinished = true;
        stream.emit('prefinish');
        $d30cef26cbb7bedd$var$finishMaybe(stream, state);
    });
}
function $d30cef26cbb7bedd$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function') {
            state.pendingcb++;
            state.finalCalled = true;
            $kvWCz.nextTick($d30cef26cbb7bedd$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $d30cef26cbb7bedd$var$finishMaybe(stream, state) {
    var need = $d30cef26cbb7bedd$var$needFinish(state);
    if (need) {
        $d30cef26cbb7bedd$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
        }
    }
    return need;
}
function $d30cef26cbb7bedd$var$endWritable(stream, state, cb) {
    state.ending = true;
    $d30cef26cbb7bedd$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $kvWCz.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $d30cef26cbb7bedd$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($d30cef26cbb7bedd$var$Writable.prototype, 'destroyed', {
    get: function() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$d30cef26cbb7bedd$var$Writable.prototype.destroy = $3mifv.destroy;
$d30cef26cbb7bedd$var$Writable.prototype._undestroy = $3mifv.undestroy;
$d30cef26cbb7bedd$var$Writable.prototype._destroy = function(err, cb) {
    this.end();
    cb(err);
};

});


parcelRegister("ljb5R", function(module, exports) {
$parcel$export(module.exports, "StringDecoder", () => $f833fa47dcf2fe47$export$63a7aa211a91ed69, (v) => $f833fa47dcf2fe47$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $f833fa47dcf2fe47$export$63a7aa211a91ed69;
'use strict';

var $830oe = parcelRequire("830oe");
var $f833fa47dcf2fe47$require$Buffer = $830oe.Buffer;
/*</replacement>*/ var $f833fa47dcf2fe47$var$isEncoding = $f833fa47dcf2fe47$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $f833fa47dcf2fe47$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $f833fa47dcf2fe47$var$normalizeEncoding(enc) {
    var nenc = $f833fa47dcf2fe47$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($f833fa47dcf2fe47$require$Buffer.isEncoding === $f833fa47dcf2fe47$var$isEncoding || !$f833fa47dcf2fe47$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$f833fa47dcf2fe47$export$63a7aa211a91ed69 = $f833fa47dcf2fe47$var$StringDecoder;
function $f833fa47dcf2fe47$var$StringDecoder(encoding) {
    this.encoding = $f833fa47dcf2fe47$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $f833fa47dcf2fe47$var$utf16Text;
            this.end = $f833fa47dcf2fe47$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $f833fa47dcf2fe47$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $f833fa47dcf2fe47$var$base64Text;
            this.end = $f833fa47dcf2fe47$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $f833fa47dcf2fe47$var$simpleWrite;
            this.end = $f833fa47dcf2fe47$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $f833fa47dcf2fe47$require$Buffer.allocUnsafe(nb);
}
$f833fa47dcf2fe47$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$f833fa47dcf2fe47$var$StringDecoder.prototype.end = $f833fa47dcf2fe47$var$utf8End;
// Returns only complete characters in a Buffer
$f833fa47dcf2fe47$var$StringDecoder.prototype.text = $f833fa47dcf2fe47$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$f833fa47dcf2fe47$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $f833fa47dcf2fe47$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $f833fa47dcf2fe47$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $f833fa47dcf2fe47$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $f833fa47dcf2fe47$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $f833fa47dcf2fe47$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $f833fa47dcf2fe47$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $f833fa47dcf2fe47$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $f833fa47dcf2fe47$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $f833fa47dcf2fe47$var$utf8Text(buf, i) {
    var total = $f833fa47dcf2fe47$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $f833fa47dcf2fe47$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $f833fa47dcf2fe47$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $f833fa47dcf2fe47$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $f833fa47dcf2fe47$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $f833fa47dcf2fe47$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $f833fa47dcf2fe47$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $f833fa47dcf2fe47$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});
parcelRegister("830oe", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $ekOVf = parcelRequire("ekOVf");
var $5dbee7f1a3d1fbd0$var$Buffer = $ekOVf.Buffer;
// alternative to using Object.keys for old browsers
function $5dbee7f1a3d1fbd0$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($5dbee7f1a3d1fbd0$var$Buffer.from && $5dbee7f1a3d1fbd0$var$Buffer.alloc && $5dbee7f1a3d1fbd0$var$Buffer.allocUnsafe && $5dbee7f1a3d1fbd0$var$Buffer.allocUnsafeSlow) module.exports = $ekOVf;
else {
    // Copy properties from require('buffer')
    $5dbee7f1a3d1fbd0$var$copyProps($ekOVf, module.exports);
    module.exports.Buffer = $5dbee7f1a3d1fbd0$var$SafeBuffer;
}
function $5dbee7f1a3d1fbd0$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $5dbee7f1a3d1fbd0$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$5dbee7f1a3d1fbd0$var$copyProps($5dbee7f1a3d1fbd0$var$Buffer, $5dbee7f1a3d1fbd0$var$SafeBuffer);
$5dbee7f1a3d1fbd0$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $5dbee7f1a3d1fbd0$var$Buffer(arg, encodingOrOffset, length);
};
$5dbee7f1a3d1fbd0$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $5dbee7f1a3d1fbd0$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$5dbee7f1a3d1fbd0$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $5dbee7f1a3d1fbd0$var$Buffer(size);
};
$5dbee7f1a3d1fbd0$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $ekOVf.SlowBuffer(size);
};

});



parcelRegister("1berE", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $0dc205ffcc32fdc7$var$Transform;

var $ebcTT = parcelRequire("ebcTT");

/*<replacement>*/ var $0dc205ffcc32fdc7$var$util = Object.create((parcelRequire("59Xcy")));

$0dc205ffcc32fdc7$var$util.inherits = (parcelRequire("ktJSc"));
/*</replacement>*/ $0dc205ffcc32fdc7$var$util.inherits($0dc205ffcc32fdc7$var$Transform, $ebcTT);
function $0dc205ffcc32fdc7$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (!cb) return this.emit('error', new Error('write callback called multiple times'));
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $0dc205ffcc32fdc7$var$Transform(options) {
    if (!(this instanceof $0dc205ffcc32fdc7$var$Transform)) return new $0dc205ffcc32fdc7$var$Transform(options);
    $ebcTT.call(this, options);
    this._transformState = {
        afterTransform: $0dc205ffcc32fdc7$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $0dc205ffcc32fdc7$var$prefinish);
}
function $0dc205ffcc32fdc7$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function') this._flush(function(er, data) {
        $0dc205ffcc32fdc7$var$done(_this, er, data);
    });
    else $0dc205ffcc32fdc7$var$done(this, null, null);
}
$0dc205ffcc32fdc7$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $ebcTT.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$0dc205ffcc32fdc7$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    throw new Error('_transform() is not implemented');
};
$0dc205ffcc32fdc7$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$0dc205ffcc32fdc7$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$0dc205ffcc32fdc7$var$Transform.prototype._destroy = function(err, cb) {
    var _this2 = this;
    $ebcTT.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
        _this2.emit('close');
    });
};
function $0dc205ffcc32fdc7$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) stream.push(data);
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
    if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
    return stream.push(null);
}

});

parcelRegister("9XWzK", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $74170fa7c45c9174$var$PassThrough;

var $1berE = parcelRequire("1berE");

/*<replacement>*/ var $74170fa7c45c9174$var$util = Object.create((parcelRequire("59Xcy")));

$74170fa7c45c9174$var$util.inherits = (parcelRequire("ktJSc"));
/*</replacement>*/ $74170fa7c45c9174$var$util.inherits($74170fa7c45c9174$var$PassThrough, $1berE);
function $74170fa7c45c9174$var$PassThrough(options) {
    if (!(this instanceof $74170fa7c45c9174$var$PassThrough)) return new $74170fa7c45c9174$var$PassThrough(options);
    $1berE.call(this, options);
}
$74170fa7c45c9174$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});


parcelRegister("5w8q8", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("2DlfF")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, 'Invalid character in ' + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, 'Invalid character');
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') try {
        BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === 'le' ? 'LE' : 'BE';
        this['_toArrayLike' + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("3biSQ", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"elliptic\",\"version\":\"6.6.1\",\"description\":\"EC cryptography\",\"main\":\"lib/elliptic.js\",\"files\":[\"lib\"],\"scripts\":{\"lint\":\"eslint lib test\",\"lint:fix\":\"npm run lint -- --fix\",\"unit\":\"istanbul test _mocha --reporter=spec test/index.js\",\"test\":\"npm run lint && npm run unit\",\"version\":\"grunt dist && git add dist/\"},\"repository\":{\"type\":\"git\",\"url\":\"git@github.com:indutny/elliptic\"},\"keywords\":[\"EC\",\"Elliptic\",\"curve\",\"Cryptography\"],\"author\":\"Fedor Indutny <fedor@indutny.com>\",\"license\":\"MIT\",\"bugs\":{\"url\":\"https://github.com/indutny/elliptic/issues\"},\"homepage\":\"https://github.com/indutny/elliptic\",\"devDependencies\":{\"brfs\":\"^2.0.2\",\"coveralls\":\"^3.1.0\",\"eslint\":\"^7.6.0\",\"grunt\":\"^1.2.1\",\"grunt-browserify\":\"^5.3.0\",\"grunt-cli\":\"^1.3.2\",\"grunt-contrib-connect\":\"^3.0.0\",\"grunt-contrib-copy\":\"^1.0.0\",\"grunt-contrib-uglify\":\"^5.0.0\",\"grunt-mocha-istanbul\":\"^5.0.2\",\"grunt-saucelabs\":\"^9.0.1\",\"istanbul\":\"^0.4.5\",\"mocha\":\"^8.0.1\"},\"dependencies\":{\"bn.js\":\"^4.11.9\",\"brorand\":\"^1.1.0\",\"hash.js\":\"^1.0.0\",\"hmac-drbg\":\"^1.0.1\",\"inherits\":\"^2.0.4\",\"minimalistic-assert\":\"^1.0.1\",\"minimalistic-crypto-utils\":\"^1.0.1\"}}");

});

parcelRegister("iuAiA", function(module, exports) {
'use strict';
var $d7672f87c81b5a37$var$utils = module.exports;

var $huXFj = parcelRequire("huXFj");

var $38nc4 = parcelRequire("38nc4");

var $gFjXX = parcelRequire("gFjXX");
$d7672f87c81b5a37$var$utils.assert = $38nc4;
$d7672f87c81b5a37$var$utils.toArray = $gFjXX.toArray;
$d7672f87c81b5a37$var$utils.zero2 = $gFjXX.zero2;
$d7672f87c81b5a37$var$utils.toHex = $gFjXX.toHex;
$d7672f87c81b5a37$var$utils.encode = $gFjXX.encode;
// Represent num in a w-NAF form
function $d7672f87c81b5a37$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    var i;
    for(i = 0; i < naf.length; i += 1)naf[i] = 0;
    var ws = 1 << w + 1;
    var k = num.clone();
    for(i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$d7672f87c81b5a37$var$utils.getNAF = $d7672f87c81b5a37$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $d7672f87c81b5a37$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$d7672f87c81b5a37$var$utils.getJSF = $d7672f87c81b5a37$var$getJSF;
function $d7672f87c81b5a37$var$cachedProperty(obj, name, computer) {
    var key = '_' + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$d7672f87c81b5a37$var$utils.cachedProperty = $d7672f87c81b5a37$var$cachedProperty;
function $d7672f87c81b5a37$var$parseBytes(bytes) {
    return typeof bytes === 'string' ? $d7672f87c81b5a37$var$utils.toArray(bytes, 'hex') : bytes;
}
$d7672f87c81b5a37$var$utils.parseBytes = $d7672f87c81b5a37$var$parseBytes;
function $d7672f87c81b5a37$var$intFromLE(bytes) {
    return new $huXFj(bytes, 'hex', 'le');
}
$d7672f87c81b5a37$var$utils.intFromLE = $d7672f87c81b5a37$var$intFromLE;

});
parcelRegister("gFjXX", function(module, exports) {
'use strict';
var $c21ff687968e6059$var$utils = module.exports;
function $c21ff687968e6059$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== 'string') {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === 'hex') {
        msg = msg.replace(/[^a-z0-9]+/ig, '');
        if (msg.length % 2 !== 0) msg = '0' + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$c21ff687968e6059$var$utils.toArray = $c21ff687968e6059$var$toArray;
function $c21ff687968e6059$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$c21ff687968e6059$var$utils.zero2 = $c21ff687968e6059$var$zero2;
function $c21ff687968e6059$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $c21ff687968e6059$var$zero2(msg[i].toString(16));
    return res;
}
$c21ff687968e6059$var$utils.toHex = $c21ff687968e6059$var$toHex;
$c21ff687968e6059$var$utils.encode = function encode(arr, enc) {
    if (enc === 'hex') return $c21ff687968e6059$var$toHex(arr);
    else return arr;
};

});


parcelRegister("e8yQ1", function(module, exports) {
'use strict';
var $a4acd6243154de80$var$curve = module.exports;

$a4acd6243154de80$var$curve.base = (parcelRequire("46ypU"));

$a4acd6243154de80$var$curve.short = (parcelRequire("ltasE"));

$a4acd6243154de80$var$curve.mont = (parcelRequire("g9Hdm"));

$a4acd6243154de80$var$curve.edwards = (parcelRequire("4nR27"));

});
parcelRegister("46ypU", function(module, exports) {
'use strict';

var $huXFj = parcelRequire("huXFj");

var $iuAiA = parcelRequire("iuAiA");
var $2fd26b6a263c48ad$var$getNAF = $iuAiA.getNAF;
var $2fd26b6a263c48ad$var$getJSF = $iuAiA.getJSF;
var $2fd26b6a263c48ad$var$assert = $iuAiA.assert;
function $2fd26b6a263c48ad$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $huXFj(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $huXFj.red(conf.prime) : $huXFj.mont(this.p);
    // Useful for many curves
    this.zero = new $huXFj(0).toRed(this.red);
    this.one = new $huXFj(1).toRed(this.red);
    this.two = new $huXFj(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $huXFj(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $2fd26b6a263c48ad$var$BaseCurve;
$2fd26b6a263c48ad$var$BaseCurve.prototype.point = function point() {
    throw new Error('Not implemented');
};
$2fd26b6a263c48ad$var$BaseCurve.prototype.validate = function validate() {
    throw new Error('Not implemented');
};
$2fd26b6a263c48ad$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $2fd26b6a263c48ad$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $2fd26b6a263c48ad$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$2fd26b6a263c48ad$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $2fd26b6a263c48ad$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $2fd26b6a263c48ad$var$assert(z !== 0);
        if (p.type === 'affine') {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === 'affine' ? acc.toP() : acc;
};
$2fd26b6a263c48ad$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $2fd26b6a263c48ad$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $2fd26b6a263c48ad$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $2fd26b6a263c48ad$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === 'affine') acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $2fd26b6a263c48ad$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$2fd26b6a263c48ad$var$BaseCurve.BasePoint = $2fd26b6a263c48ad$var$BasePoint;
$2fd26b6a263c48ad$var$BasePoint.prototype.eq = function eq() {
    throw new Error('Not implemented');
};
$2fd26b6a263c48ad$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$2fd26b6a263c48ad$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $iuAiA.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $2fd26b6a263c48ad$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $2fd26b6a263c48ad$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error('Unknown point format');
};
$2fd26b6a263c48ad$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$2fd26b6a263c48ad$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray('be', len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray('be', len));
};
$2fd26b6a263c48ad$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $iuAiA.encode(this._encode(compact), enc);
};
$2fd26b6a263c48ad$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$2fd26b6a263c48ad$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$2fd26b6a263c48ad$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$2fd26b6a263c48ad$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$2fd26b6a263c48ad$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$2fd26b6a263c48ad$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRegister("ltasE", function(module, exports) {
'use strict';

var $iuAiA = parcelRequire("iuAiA");

var $huXFj = parcelRequire("huXFj");

var $ktJSc = parcelRequire("ktJSc");

var $46ypU = parcelRequire("46ypU");
var $fa146bc9695b9727$var$assert = $iuAiA.assert;
function $fa146bc9695b9727$var$ShortCurve(conf) {
    $46ypU.call(this, 'short', conf);
    this.a = new $huXFj(conf.a, 16).toRed(this.red);
    this.b = new $huXFj(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$ktJSc($fa146bc9695b9727$var$ShortCurve, $46ypU);
module.exports = $fa146bc9695b9727$var$ShortCurve;
$fa146bc9695b9727$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $huXFj(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $huXFj(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $fa146bc9695b9727$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $huXFj(vec.a, 16),
            b: new $huXFj(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$fa146bc9695b9727$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $huXFj.mont(num);
    var tinv = new $huXFj(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $huXFj(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$fa146bc9695b9727$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $huXFj(1);
    var y1 = new $huXFj(0);
    var x2 = new $huXFj(0);
    var y2 = new $huXFj(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$fa146bc9695b9727$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$fa146bc9695b9727$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $huXFj(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$fa146bc9695b9727$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$fa146bc9695b9727$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $fa146bc9695b9727$var$Point(curve, x, y, isRed) {
    $46ypU.BasePoint.call(this, curve, 'affine');
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $huXFj(x, 16);
        this.y = new $huXFj(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$ktJSc($fa146bc9695b9727$var$Point, $46ypU.BasePoint);
$fa146bc9695b9727$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $fa146bc9695b9727$var$Point(this, x, y, isRed);
};
$fa146bc9695b9727$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $fa146bc9695b9727$var$Point.fromJSON(this, obj, red);
};
$fa146bc9695b9727$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$fa146bc9695b9727$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$fa146bc9695b9727$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === 'string') obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$fa146bc9695b9727$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};
$fa146bc9695b9727$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$fa146bc9695b9727$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$fa146bc9695b9727$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$fa146bc9695b9727$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$fa146bc9695b9727$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$fa146bc9695b9727$var$Point.prototype.mul = function mul(k) {
    k = new $huXFj(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$fa146bc9695b9727$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$fa146bc9695b9727$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$fa146bc9695b9727$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$fa146bc9695b9727$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$fa146bc9695b9727$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $fa146bc9695b9727$var$JPoint(curve, x, y, z) {
    $46ypU.BasePoint.call(this, curve, 'jacobian');
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $huXFj(0);
    } else {
        this.x = new $huXFj(x, 16);
        this.y = new $huXFj(y, 16);
        this.z = new $huXFj(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$ktJSc($fa146bc9695b9727$var$JPoint, $46ypU.BasePoint);
$fa146bc9695b9727$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $fa146bc9695b9727$var$JPoint(this, x, y, z);
};
$fa146bc9695b9727$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$fa146bc9695b9727$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$fa146bc9695b9727$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$fa146bc9695b9727$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$fa146bc9695b9727$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$fa146bc9695b9727$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$fa146bc9695b9727$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$fa146bc9695b9727$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$fa146bc9695b9727$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$fa146bc9695b9727$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$fa146bc9695b9727$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $huXFj(k, kbase);
    return this.curve._wnafMul(this, k);
};
$fa146bc9695b9727$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === 'affine') return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$fa146bc9695b9727$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$fa146bc9695b9727$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC JPoint Infinity>';
    return '<EC JPoint x: ' + this.x.toString(16, 2) + ' y: ' + this.y.toString(16, 2) + ' z: ' + this.z.toString(16, 2) + '>';
};
$fa146bc9695b9727$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRegister("g9Hdm", function(module, exports) {
'use strict';

var $huXFj = parcelRequire("huXFj");

var $ktJSc = parcelRequire("ktJSc");

var $46ypU = parcelRequire("46ypU");

var $iuAiA = parcelRequire("iuAiA");
function $bc2f021f264298c6$var$MontCurve(conf) {
    $46ypU.call(this, 'mont', conf);
    this.a = new $huXFj(conf.a, 16).toRed(this.red);
    this.b = new $huXFj(conf.b, 16).toRed(this.red);
    this.i4 = new $huXFj(4).toRed(this.red).redInvm();
    this.two = new $huXFj(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$ktJSc($bc2f021f264298c6$var$MontCurve, $46ypU);
module.exports = $bc2f021f264298c6$var$MontCurve;
$bc2f021f264298c6$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $bc2f021f264298c6$var$Point(curve, x, z) {
    $46ypU.BasePoint.call(this, curve, 'projective');
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $huXFj(x, 16);
        this.z = new $huXFj(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$ktJSc($bc2f021f264298c6$var$Point, $46ypU.BasePoint);
$bc2f021f264298c6$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($iuAiA.toArray(bytes, enc), 1);
};
$bc2f021f264298c6$var$MontCurve.prototype.point = function point(x, z) {
    return new $bc2f021f264298c6$var$Point(this, x, z);
};
$bc2f021f264298c6$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $bc2f021f264298c6$var$Point.fromJSON(this, obj);
};
$bc2f021f264298c6$var$Point.prototype.precompute = function precompute() {
// No-op
};
$bc2f021f264298c6$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray('be', this.curve.p.byteLength());
};
$bc2f021f264298c6$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $bc2f021f264298c6$var$Point(curve, obj[0], obj[1] || curve.one);
};
$bc2f021f264298c6$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$bc2f021f264298c6$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$bc2f021f264298c6$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$bc2f021f264298c6$var$Point.prototype.add = function add() {
    throw new Error('Not supported on Montgomery curve');
};
$bc2f021f264298c6$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$bc2f021f264298c6$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$bc2f021f264298c6$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$bc2f021f264298c6$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$bc2f021f264298c6$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$bc2f021f264298c6$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$bc2f021f264298c6$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRegister("4nR27", function(module, exports) {
'use strict';

var $iuAiA = parcelRequire("iuAiA");

var $huXFj = parcelRequire("huXFj");

var $ktJSc = parcelRequire("ktJSc");

var $46ypU = parcelRequire("46ypU");
var $331272b5208d2a8f$var$assert = $iuAiA.assert;
function $331272b5208d2a8f$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $46ypU.call(this, 'edwards', conf);
    this.a = new $huXFj(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $huXFj(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $huXFj(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $331272b5208d2a8f$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$ktJSc($331272b5208d2a8f$var$EdwardsCurve, $46ypU);
module.exports = $331272b5208d2a8f$var$EdwardsCurve;
$331272b5208d2a8f$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$331272b5208d2a8f$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$331272b5208d2a8f$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$331272b5208d2a8f$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $huXFj(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$331272b5208d2a8f$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $huXFj(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error('invalid point');
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error('invalid point');
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$331272b5208d2a8f$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $331272b5208d2a8f$var$Point(curve, x, y, z, t) {
    $46ypU.BasePoint.call(this, curve, 'projective');
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $huXFj(x, 16);
        this.y = new $huXFj(y, 16);
        this.z = z ? new $huXFj(z, 16) : this.curve.one;
        this.t = t && new $huXFj(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$ktJSc($331272b5208d2a8f$var$Point, $46ypU.BasePoint);
$331272b5208d2a8f$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $331272b5208d2a8f$var$Point.fromJSON(this, obj);
};
$331272b5208d2a8f$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $331272b5208d2a8f$var$Point(this, x, y, z, t);
};
$331272b5208d2a8f$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $331272b5208d2a8f$var$Point(curve, obj[0], obj[1], obj[2]);
};
$331272b5208d2a8f$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$331272b5208d2a8f$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$331272b5208d2a8f$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$331272b5208d2a8f$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$331272b5208d2a8f$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$331272b5208d2a8f$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$331272b5208d2a8f$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$331272b5208d2a8f$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$331272b5208d2a8f$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$331272b5208d2a8f$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$331272b5208d2a8f$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$331272b5208d2a8f$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$331272b5208d2a8f$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$331272b5208d2a8f$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$331272b5208d2a8f$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$331272b5208d2a8f$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$331272b5208d2a8f$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$331272b5208d2a8f$var$Point.prototype.toP = $331272b5208d2a8f$var$Point.prototype.normalize;
$331272b5208d2a8f$var$Point.prototype.mixedAdd = $331272b5208d2a8f$var$Point.prototype.add;

});


parcelRegister("ecRVR", function(module, exports) {
'use strict';
var $a57c05819b091193$var$curves = module.exports;

var $1wWwG = parcelRequire("1wWwG");

var $e8yQ1 = parcelRequire("e8yQ1");

var $iuAiA = parcelRequire("iuAiA");
var $a57c05819b091193$var$assert = $iuAiA.assert;
function $a57c05819b091193$var$PresetCurve(options) {
    if (options.type === 'short') this.curve = new $e8yQ1.short(options);
    else if (options.type === 'edwards') this.curve = new $e8yQ1.edwards(options);
    else this.curve = new $e8yQ1.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $a57c05819b091193$var$assert(this.g.validate(), 'Invalid curve');
    $a57c05819b091193$var$assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
$a57c05819b091193$var$curves.PresetCurve = $a57c05819b091193$var$PresetCurve;
function $a57c05819b091193$var$defineCurve(name, options) {
    Object.defineProperty($a57c05819b091193$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $a57c05819b091193$var$PresetCurve(options);
            Object.defineProperty($a57c05819b091193$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$a57c05819b091193$var$defineCurve('p192', {
    type: 'short',
    prime: 'p192',
    p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
    b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
    n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
    hash: $1wWwG.sha256,
    gRed: false,
    g: [
        '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
        '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
    ]
});
$a57c05819b091193$var$defineCurve('p224', {
    type: 'short',
    prime: 'p224',
    p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
    b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
    n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
    hash: $1wWwG.sha256,
    gRed: false,
    g: [
        'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
        'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
    ]
});
$a57c05819b091193$var$defineCurve('p256', {
    type: 'short',
    prime: null,
    p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
    a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
    b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
    n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
    hash: $1wWwG.sha256,
    gRed: false,
    g: [
        '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
        '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
    ]
});
$a57c05819b091193$var$defineCurve('p384', {
    type: 'short',
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $1wWwG.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$a57c05819b091193$var$defineCurve('p521', {
    type: 'short',
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $1wWwG.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$a57c05819b091193$var$defineCurve('curve25519', {
    type: 'mont',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '76d06',
    b: '1',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $1wWwG.sha256,
    gRed: false,
    g: [
        '9'
    ]
});
$a57c05819b091193$var$defineCurve('ed25519', {
    type: 'edwards',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '-1',
    c: '1',
    // -121665 * (121666^(-1)) (mod P)
    d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $1wWwG.sha256,
    gRed: false,
    g: [
        '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',
        // 4/5
        '6666666666666666666666666666666666666666666666666666666666666658'
    ]
});
var $a57c05819b091193$var$pre;

try {
    $a57c05819b091193$var$pre = (parcelRequire("h19TE"));
} catch (e) {
    $a57c05819b091193$var$pre = undefined;
}
$a57c05819b091193$var$defineCurve('secp256k1', {
    type: 'short',
    prime: 'k256',
    p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
    a: '0',
    b: '7',
    n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
    h: '1',
    hash: $1wWwG.sha256,
    // Precomputed endomorphism
    beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
    lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
    basis: [
        {
            a: '3086d221a7d46bcde86c90e49284eb15',
            b: '-e4437ed6010e88286f547fa90abfe4c3'
        },
        {
            a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
            b: '3086d221a7d46bcde86c90e49284eb15'
        }
    ],
    gRed: false,
    g: [
        '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
        '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
        $a57c05819b091193$var$pre
    ]
});

});
parcelRegister("1wWwG", function(module, exports) {
var $11d62db08703e7a0$var$hash = module.exports;

$11d62db08703e7a0$var$hash.utils = (parcelRequire("sLl3Q"));

$11d62db08703e7a0$var$hash.common = (parcelRequire("4Vf4u"));

$11d62db08703e7a0$var$hash.sha = (parcelRequire("1G4m5"));

$11d62db08703e7a0$var$hash.ripemd = (parcelRequire("9pbsG"));

$11d62db08703e7a0$var$hash.hmac = (parcelRequire("ifxqm"));
// Proxy hash functions to the main object
$11d62db08703e7a0$var$hash.sha1 = $11d62db08703e7a0$var$hash.sha.sha1;
$11d62db08703e7a0$var$hash.sha256 = $11d62db08703e7a0$var$hash.sha.sha256;
$11d62db08703e7a0$var$hash.sha224 = $11d62db08703e7a0$var$hash.sha.sha224;
$11d62db08703e7a0$var$hash.sha384 = $11d62db08703e7a0$var$hash.sha.sha384;
$11d62db08703e7a0$var$hash.sha512 = $11d62db08703e7a0$var$hash.sha.sha512;
$11d62db08703e7a0$var$hash.ripemd160 = $11d62db08703e7a0$var$hash.ripemd.ripemd160;

});
parcelRegister("sLl3Q", function(module, exports) {
$parcel$export(module.exports, "inherits", () => $0567561e44392cbd$export$69f1b2dcda23c5f8, (v) => $0567561e44392cbd$export$69f1b2dcda23c5f8 = v);
$parcel$export(module.exports, "toArray", () => $0567561e44392cbd$export$45b10814cc054894, (v) => $0567561e44392cbd$export$45b10814cc054894 = v);
$parcel$export(module.exports, "toHex", () => $0567561e44392cbd$export$7ea66e3774a60b67, (v) => $0567561e44392cbd$export$7ea66e3774a60b67 = v);
$parcel$export(module.exports, "htonl", () => $0567561e44392cbd$export$34a52f00f601f6f1, (v) => $0567561e44392cbd$export$34a52f00f601f6f1 = v);
$parcel$export(module.exports, "toHex32", () => $0567561e44392cbd$export$812b0cbd5e8a72ab, (v) => $0567561e44392cbd$export$812b0cbd5e8a72ab = v);
$parcel$export(module.exports, "zero2", () => $0567561e44392cbd$export$f24f9e11d63bb314, (v) => $0567561e44392cbd$export$f24f9e11d63bb314 = v);
$parcel$export(module.exports, "zero8", () => $0567561e44392cbd$export$b71357c7e07ca1f1, (v) => $0567561e44392cbd$export$b71357c7e07ca1f1 = v);
$parcel$export(module.exports, "join32", () => $0567561e44392cbd$export$2e58a4b541fdcbe8, (v) => $0567561e44392cbd$export$2e58a4b541fdcbe8 = v);
$parcel$export(module.exports, "split32", () => $0567561e44392cbd$export$183b950bde9faab8, (v) => $0567561e44392cbd$export$183b950bde9faab8 = v);
$parcel$export(module.exports, "rotr32", () => $0567561e44392cbd$export$4785c77169fea59e, (v) => $0567561e44392cbd$export$4785c77169fea59e = v);
$parcel$export(module.exports, "rotl32", () => $0567561e44392cbd$export$242a185dfcffac5b, (v) => $0567561e44392cbd$export$242a185dfcffac5b = v);
$parcel$export(module.exports, "sum32", () => $0567561e44392cbd$export$58c04ae0ae31877d, (v) => $0567561e44392cbd$export$58c04ae0ae31877d = v);
$parcel$export(module.exports, "sum32_3", () => $0567561e44392cbd$export$d058ca695f8c6f11, (v) => $0567561e44392cbd$export$d058ca695f8c6f11 = v);
$parcel$export(module.exports, "sum32_4", () => $0567561e44392cbd$export$a1efd7fc3e986367, (v) => $0567561e44392cbd$export$a1efd7fc3e986367 = v);
$parcel$export(module.exports, "sum32_5", () => $0567561e44392cbd$export$bbfea4a2b5abaab4, (v) => $0567561e44392cbd$export$bbfea4a2b5abaab4 = v);
$parcel$export(module.exports, "sum64", () => $0567561e44392cbd$export$97ad4afc7de86152, (v) => $0567561e44392cbd$export$97ad4afc7de86152 = v);
$parcel$export(module.exports, "sum64_hi", () => $0567561e44392cbd$export$ce4673d9a79f6a4b, (v) => $0567561e44392cbd$export$ce4673d9a79f6a4b = v);
$parcel$export(module.exports, "sum64_lo", () => $0567561e44392cbd$export$786cc99fc6eedc0b, (v) => $0567561e44392cbd$export$786cc99fc6eedc0b = v);
$parcel$export(module.exports, "sum64_4_hi", () => $0567561e44392cbd$export$45c59b9a1848dd0, (v) => $0567561e44392cbd$export$45c59b9a1848dd0 = v);
$parcel$export(module.exports, "sum64_4_lo", () => $0567561e44392cbd$export$50d8f613e76d3034, (v) => $0567561e44392cbd$export$50d8f613e76d3034 = v);
$parcel$export(module.exports, "sum64_5_hi", () => $0567561e44392cbd$export$b8e83683c60ee162, (v) => $0567561e44392cbd$export$b8e83683c60ee162 = v);
$parcel$export(module.exports, "sum64_5_lo", () => $0567561e44392cbd$export$aeeb51790d1bcc4a, (v) => $0567561e44392cbd$export$aeeb51790d1bcc4a = v);
$parcel$export(module.exports, "rotr64_hi", () => $0567561e44392cbd$export$bb7c616f719ad9c, (v) => $0567561e44392cbd$export$bb7c616f719ad9c = v);
$parcel$export(module.exports, "rotr64_lo", () => $0567561e44392cbd$export$4d63290824f9d7df, (v) => $0567561e44392cbd$export$4d63290824f9d7df = v);
$parcel$export(module.exports, "shr64_hi", () => $0567561e44392cbd$export$2f64ceb90ef28ea1, (v) => $0567561e44392cbd$export$2f64ceb90ef28ea1 = v);
$parcel$export(module.exports, "shr64_lo", () => $0567561e44392cbd$export$8d2089d465f6d10d, (v) => $0567561e44392cbd$export$8d2089d465f6d10d = v);
var $0567561e44392cbd$export$69f1b2dcda23c5f8;
var $0567561e44392cbd$export$45b10814cc054894;
var $0567561e44392cbd$export$7ea66e3774a60b67;
var $0567561e44392cbd$export$34a52f00f601f6f1;
var $0567561e44392cbd$export$812b0cbd5e8a72ab;
var $0567561e44392cbd$export$f24f9e11d63bb314;
var $0567561e44392cbd$export$b71357c7e07ca1f1;
var $0567561e44392cbd$export$2e58a4b541fdcbe8;
var $0567561e44392cbd$export$183b950bde9faab8;
var $0567561e44392cbd$export$4785c77169fea59e;
var $0567561e44392cbd$export$242a185dfcffac5b;
var $0567561e44392cbd$export$58c04ae0ae31877d;
var $0567561e44392cbd$export$d058ca695f8c6f11;
var $0567561e44392cbd$export$a1efd7fc3e986367;
var $0567561e44392cbd$export$bbfea4a2b5abaab4;
var $0567561e44392cbd$export$97ad4afc7de86152;
var $0567561e44392cbd$export$ce4673d9a79f6a4b;
var $0567561e44392cbd$export$786cc99fc6eedc0b;
var $0567561e44392cbd$export$45c59b9a1848dd0;
var $0567561e44392cbd$export$50d8f613e76d3034;
var $0567561e44392cbd$export$b8e83683c60ee162;
var $0567561e44392cbd$export$aeeb51790d1bcc4a;
var $0567561e44392cbd$export$bb7c616f719ad9c;
var $0567561e44392cbd$export$4d63290824f9d7df;
var $0567561e44392cbd$export$2f64ceb90ef28ea1;
var $0567561e44392cbd$export$8d2089d465f6d10d;
'use strict';

var $38nc4 = parcelRequire("38nc4");

var $ktJSc = parcelRequire("ktJSc");
$0567561e44392cbd$export$69f1b2dcda23c5f8 = $ktJSc;
function $0567561e44392cbd$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $0567561e44392cbd$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === 'string') {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($0567561e44392cbd$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === 'hex') {
            msg = msg.replace(/[^a-z0-9]+/ig, '');
            if (msg.length % 2 !== 0) msg = '0' + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$0567561e44392cbd$export$45b10814cc054894 = $0567561e44392cbd$var$toArray;
function $0567561e44392cbd$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $0567561e44392cbd$var$zero2(msg[i].toString(16));
    return res;
}
$0567561e44392cbd$export$7ea66e3774a60b67 = $0567561e44392cbd$var$toHex;
function $0567561e44392cbd$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$0567561e44392cbd$export$34a52f00f601f6f1 = $0567561e44392cbd$var$htonl;
function $0567561e44392cbd$var$toHex32(msg, endian) {
    var res = '';
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === 'little') w = $0567561e44392cbd$var$htonl(w);
        res += $0567561e44392cbd$var$zero8(w.toString(16));
    }
    return res;
}
$0567561e44392cbd$export$812b0cbd5e8a72ab = $0567561e44392cbd$var$toHex32;
function $0567561e44392cbd$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$0567561e44392cbd$export$f24f9e11d63bb314 = $0567561e44392cbd$var$zero2;
function $0567561e44392cbd$var$zero8(word) {
    if (word.length === 7) return '0' + word;
    else if (word.length === 6) return '00' + word;
    else if (word.length === 5) return '000' + word;
    else if (word.length === 4) return '0000' + word;
    else if (word.length === 3) return '00000' + word;
    else if (word.length === 2) return '000000' + word;
    else if (word.length === 1) return '0000000' + word;
    else return word;
}
$0567561e44392cbd$export$b71357c7e07ca1f1 = $0567561e44392cbd$var$zero8;
function $0567561e44392cbd$var$join32(msg, start, end, endian) {
    var len = end - start;
    $38nc4(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === 'big') w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$0567561e44392cbd$export$2e58a4b541fdcbe8 = $0567561e44392cbd$var$join32;
function $0567561e44392cbd$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === 'big') {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$0567561e44392cbd$export$183b950bde9faab8 = $0567561e44392cbd$var$split32;
function $0567561e44392cbd$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$0567561e44392cbd$export$4785c77169fea59e = $0567561e44392cbd$var$rotr32;
function $0567561e44392cbd$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$0567561e44392cbd$export$242a185dfcffac5b = $0567561e44392cbd$var$rotl32;
function $0567561e44392cbd$var$sum32(a, b) {
    return a + b >>> 0;
}
$0567561e44392cbd$export$58c04ae0ae31877d = $0567561e44392cbd$var$sum32;
function $0567561e44392cbd$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$0567561e44392cbd$export$d058ca695f8c6f11 = $0567561e44392cbd$var$sum32_3;
function $0567561e44392cbd$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$0567561e44392cbd$export$a1efd7fc3e986367 = $0567561e44392cbd$var$sum32_4;
function $0567561e44392cbd$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$0567561e44392cbd$export$bbfea4a2b5abaab4 = $0567561e44392cbd$var$sum32_5;
function $0567561e44392cbd$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$0567561e44392cbd$export$97ad4afc7de86152 = $0567561e44392cbd$var$sum64;
function $0567561e44392cbd$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$0567561e44392cbd$export$ce4673d9a79f6a4b = $0567561e44392cbd$var$sum64_hi;
function $0567561e44392cbd$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$0567561e44392cbd$export$786cc99fc6eedc0b = $0567561e44392cbd$var$sum64_lo;
function $0567561e44392cbd$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$0567561e44392cbd$export$45c59b9a1848dd0 = $0567561e44392cbd$var$sum64_4_hi;
function $0567561e44392cbd$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$0567561e44392cbd$export$50d8f613e76d3034 = $0567561e44392cbd$var$sum64_4_lo;
function $0567561e44392cbd$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$0567561e44392cbd$export$b8e83683c60ee162 = $0567561e44392cbd$var$sum64_5_hi;
function $0567561e44392cbd$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$0567561e44392cbd$export$aeeb51790d1bcc4a = $0567561e44392cbd$var$sum64_5_lo;
function $0567561e44392cbd$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$0567561e44392cbd$export$bb7c616f719ad9c = $0567561e44392cbd$var$rotr64_hi;
function $0567561e44392cbd$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$0567561e44392cbd$export$4d63290824f9d7df = $0567561e44392cbd$var$rotr64_lo;
function $0567561e44392cbd$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$0567561e44392cbd$export$2f64ceb90ef28ea1 = $0567561e44392cbd$var$shr64_hi;
function $0567561e44392cbd$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$0567561e44392cbd$export$8d2089d465f6d10d = $0567561e44392cbd$var$shr64_lo;

});

parcelRegister("4Vf4u", function(module, exports) {
$parcel$export(module.exports, "BlockHash", () => $39582d2b7ee5dd7d$export$8687658379b577e6, (v) => $39582d2b7ee5dd7d$export$8687658379b577e6 = v);
var $39582d2b7ee5dd7d$export$8687658379b577e6;
'use strict';

var $sLl3Q = parcelRequire("sLl3Q");

var $38nc4 = parcelRequire("38nc4");
function $39582d2b7ee5dd7d$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = 'big';
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$39582d2b7ee5dd7d$export$8687658379b577e6 = $39582d2b7ee5dd7d$var$BlockHash;
$39582d2b7ee5dd7d$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $sLl3Q.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $sLl3Q.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$39582d2b7ee5dd7d$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $38nc4(this.pending === null);
    return this._digest(enc);
};
$39582d2b7ee5dd7d$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === 'big') {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("1G4m5", function(module, exports) {
$parcel$export(module.exports, "sha1", () => $138d178b0879dba8$export$5091bdda49ba90f5, (v) => $138d178b0879dba8$export$5091bdda49ba90f5 = v);
$parcel$export(module.exports, "sha224", () => $138d178b0879dba8$export$97b70509d4e397ea, (v) => $138d178b0879dba8$export$97b70509d4e397ea = v);
$parcel$export(module.exports, "sha256", () => $138d178b0879dba8$export$bced8d2aada2d1c9, (v) => $138d178b0879dba8$export$bced8d2aada2d1c9 = v);
$parcel$export(module.exports, "sha384", () => $138d178b0879dba8$export$612d47d55dedde45, (v) => $138d178b0879dba8$export$612d47d55dedde45 = v);
$parcel$export(module.exports, "sha512", () => $138d178b0879dba8$export$a888d2532e6dc7bb, (v) => $138d178b0879dba8$export$a888d2532e6dc7bb = v);
var $138d178b0879dba8$export$5091bdda49ba90f5;
var $138d178b0879dba8$export$97b70509d4e397ea;
var $138d178b0879dba8$export$bced8d2aada2d1c9;
var $138d178b0879dba8$export$612d47d55dedde45;
var $138d178b0879dba8$export$a888d2532e6dc7bb;
'use strict';

$138d178b0879dba8$export$5091bdda49ba90f5 = (parcelRequire("d5DQn"));

$138d178b0879dba8$export$97b70509d4e397ea = (parcelRequire("hbQlx"));

$138d178b0879dba8$export$bced8d2aada2d1c9 = (parcelRequire("aQUtN"));

$138d178b0879dba8$export$612d47d55dedde45 = (parcelRequire("2Um1Z"));

$138d178b0879dba8$export$a888d2532e6dc7bb = (parcelRequire("dA1Rs"));

});
parcelRegister("d5DQn", function(module, exports) {
'use strict';

var $sLl3Q = parcelRequire("sLl3Q");

var $4Vf4u = parcelRequire("4Vf4u");

var $l1kKt = parcelRequire("l1kKt");
var $987aa628d5c7f6f9$var$rotl32 = $sLl3Q.rotl32;
var $987aa628d5c7f6f9$var$sum32 = $sLl3Q.sum32;
var $987aa628d5c7f6f9$var$sum32_5 = $sLl3Q.sum32_5;
var $987aa628d5c7f6f9$var$ft_1 = $l1kKt.ft_1;
var $987aa628d5c7f6f9$var$BlockHash = $4Vf4u.BlockHash;
var $987aa628d5c7f6f9$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $987aa628d5c7f6f9$var$SHA1() {
    if (!(this instanceof $987aa628d5c7f6f9$var$SHA1)) return new $987aa628d5c7f6f9$var$SHA1();
    $987aa628d5c7f6f9$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$sLl3Q.inherits($987aa628d5c7f6f9$var$SHA1, $987aa628d5c7f6f9$var$BlockHash);
module.exports = $987aa628d5c7f6f9$var$SHA1;
$987aa628d5c7f6f9$var$SHA1.blockSize = 512;
$987aa628d5c7f6f9$var$SHA1.outSize = 160;
$987aa628d5c7f6f9$var$SHA1.hmacStrength = 80;
$987aa628d5c7f6f9$var$SHA1.padLength = 64;
$987aa628d5c7f6f9$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $987aa628d5c7f6f9$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $987aa628d5c7f6f9$var$sum32_5($987aa628d5c7f6f9$var$rotl32(a, 5), $987aa628d5c7f6f9$var$ft_1(s, b, c, d), e, W[i], $987aa628d5c7f6f9$var$sha1_K[s]);
        e = d;
        d = c;
        c = $987aa628d5c7f6f9$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $987aa628d5c7f6f9$var$sum32(this.h[0], a);
    this.h[1] = $987aa628d5c7f6f9$var$sum32(this.h[1], b);
    this.h[2] = $987aa628d5c7f6f9$var$sum32(this.h[2], c);
    this.h[3] = $987aa628d5c7f6f9$var$sum32(this.h[3], d);
    this.h[4] = $987aa628d5c7f6f9$var$sum32(this.h[4], e);
};
$987aa628d5c7f6f9$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $sLl3Q.toHex32(this.h, 'big');
    else return $sLl3Q.split32(this.h, 'big');
};

});
parcelRegister("l1kKt", function(module, exports) {
$parcel$export(module.exports, "ft_1", () => $f4d9c938f77563a7$export$5a92649d7ddb9f63, (v) => $f4d9c938f77563a7$export$5a92649d7ddb9f63 = v);
$parcel$export(module.exports, "ch32", () => $f4d9c938f77563a7$export$c6d0d020c3a6269, (v) => $f4d9c938f77563a7$export$c6d0d020c3a6269 = v);
$parcel$export(module.exports, "maj32", () => $f4d9c938f77563a7$export$eb90c27fca05f956, (v) => $f4d9c938f77563a7$export$eb90c27fca05f956 = v);
$parcel$export(module.exports, "s0_256", () => $f4d9c938f77563a7$export$14a4a98e063b1999, (v) => $f4d9c938f77563a7$export$14a4a98e063b1999 = v);
$parcel$export(module.exports, "s1_256", () => $f4d9c938f77563a7$export$d20cecfa1564c686, (v) => $f4d9c938f77563a7$export$d20cecfa1564c686 = v);
$parcel$export(module.exports, "g0_256", () => $f4d9c938f77563a7$export$44fd472a12fc6db, (v) => $f4d9c938f77563a7$export$44fd472a12fc6db = v);
$parcel$export(module.exports, "g1_256", () => $f4d9c938f77563a7$export$1ed238bb6ea1dd47, (v) => $f4d9c938f77563a7$export$1ed238bb6ea1dd47 = v);
var $f4d9c938f77563a7$export$5a92649d7ddb9f63;
var $f4d9c938f77563a7$export$c6d0d020c3a6269;
var $f4d9c938f77563a7$export$eb90c27fca05f956;
var $f4d9c938f77563a7$export$cc992891a14496a1;
var $f4d9c938f77563a7$export$14a4a98e063b1999;
var $f4d9c938f77563a7$export$d20cecfa1564c686;
var $f4d9c938f77563a7$export$44fd472a12fc6db;
var $f4d9c938f77563a7$export$1ed238bb6ea1dd47;
'use strict';

var $sLl3Q = parcelRequire("sLl3Q");
var $f4d9c938f77563a7$var$rotr32 = $sLl3Q.rotr32;
function $f4d9c938f77563a7$var$ft_1(s, x, y, z) {
    if (s === 0) return $f4d9c938f77563a7$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $f4d9c938f77563a7$var$p32(x, y, z);
    if (s === 2) return $f4d9c938f77563a7$var$maj32(x, y, z);
}
$f4d9c938f77563a7$export$5a92649d7ddb9f63 = $f4d9c938f77563a7$var$ft_1;
function $f4d9c938f77563a7$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$f4d9c938f77563a7$export$c6d0d020c3a6269 = $f4d9c938f77563a7$var$ch32;
function $f4d9c938f77563a7$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$f4d9c938f77563a7$export$eb90c27fca05f956 = $f4d9c938f77563a7$var$maj32;
function $f4d9c938f77563a7$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$f4d9c938f77563a7$export$cc992891a14496a1 = $f4d9c938f77563a7$var$p32;
function $f4d9c938f77563a7$var$s0_256(x) {
    return $f4d9c938f77563a7$var$rotr32(x, 2) ^ $f4d9c938f77563a7$var$rotr32(x, 13) ^ $f4d9c938f77563a7$var$rotr32(x, 22);
}
$f4d9c938f77563a7$export$14a4a98e063b1999 = $f4d9c938f77563a7$var$s0_256;
function $f4d9c938f77563a7$var$s1_256(x) {
    return $f4d9c938f77563a7$var$rotr32(x, 6) ^ $f4d9c938f77563a7$var$rotr32(x, 11) ^ $f4d9c938f77563a7$var$rotr32(x, 25);
}
$f4d9c938f77563a7$export$d20cecfa1564c686 = $f4d9c938f77563a7$var$s1_256;
function $f4d9c938f77563a7$var$g0_256(x) {
    return $f4d9c938f77563a7$var$rotr32(x, 7) ^ $f4d9c938f77563a7$var$rotr32(x, 18) ^ x >>> 3;
}
$f4d9c938f77563a7$export$44fd472a12fc6db = $f4d9c938f77563a7$var$g0_256;
function $f4d9c938f77563a7$var$g1_256(x) {
    return $f4d9c938f77563a7$var$rotr32(x, 17) ^ $f4d9c938f77563a7$var$rotr32(x, 19) ^ x >>> 10;
}
$f4d9c938f77563a7$export$1ed238bb6ea1dd47 = $f4d9c938f77563a7$var$g1_256;

});


parcelRegister("hbQlx", function(module, exports) {
'use strict';

var $sLl3Q = parcelRequire("sLl3Q");

var $aQUtN = parcelRequire("aQUtN");
function $c83c11a3467a48c7$var$SHA224() {
    if (!(this instanceof $c83c11a3467a48c7$var$SHA224)) return new $c83c11a3467a48c7$var$SHA224();
    $aQUtN.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$sLl3Q.inherits($c83c11a3467a48c7$var$SHA224, $aQUtN);
module.exports = $c83c11a3467a48c7$var$SHA224;
$c83c11a3467a48c7$var$SHA224.blockSize = 512;
$c83c11a3467a48c7$var$SHA224.outSize = 224;
$c83c11a3467a48c7$var$SHA224.hmacStrength = 192;
$c83c11a3467a48c7$var$SHA224.padLength = 64;
$c83c11a3467a48c7$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === 'hex') return $sLl3Q.toHex32(this.h.slice(0, 7), 'big');
    else return $sLl3Q.split32(this.h.slice(0, 7), 'big');
};

});
parcelRegister("aQUtN", function(module, exports) {
'use strict';

var $sLl3Q = parcelRequire("sLl3Q");

var $4Vf4u = parcelRequire("4Vf4u");

var $l1kKt = parcelRequire("l1kKt");

var $38nc4 = parcelRequire("38nc4");
var $7e6a9264295a50d2$var$sum32 = $sLl3Q.sum32;
var $7e6a9264295a50d2$var$sum32_4 = $sLl3Q.sum32_4;
var $7e6a9264295a50d2$var$sum32_5 = $sLl3Q.sum32_5;
var $7e6a9264295a50d2$var$ch32 = $l1kKt.ch32;
var $7e6a9264295a50d2$var$maj32 = $l1kKt.maj32;
var $7e6a9264295a50d2$var$s0_256 = $l1kKt.s0_256;
var $7e6a9264295a50d2$var$s1_256 = $l1kKt.s1_256;
var $7e6a9264295a50d2$var$g0_256 = $l1kKt.g0_256;
var $7e6a9264295a50d2$var$g1_256 = $l1kKt.g1_256;
var $7e6a9264295a50d2$var$BlockHash = $4Vf4u.BlockHash;
var $7e6a9264295a50d2$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $7e6a9264295a50d2$var$SHA256() {
    if (!(this instanceof $7e6a9264295a50d2$var$SHA256)) return new $7e6a9264295a50d2$var$SHA256();
    $7e6a9264295a50d2$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $7e6a9264295a50d2$var$sha256_K;
    this.W = new Array(64);
}
$sLl3Q.inherits($7e6a9264295a50d2$var$SHA256, $7e6a9264295a50d2$var$BlockHash);
module.exports = $7e6a9264295a50d2$var$SHA256;
$7e6a9264295a50d2$var$SHA256.blockSize = 512;
$7e6a9264295a50d2$var$SHA256.outSize = 256;
$7e6a9264295a50d2$var$SHA256.hmacStrength = 192;
$7e6a9264295a50d2$var$SHA256.padLength = 64;
$7e6a9264295a50d2$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $7e6a9264295a50d2$var$sum32_4($7e6a9264295a50d2$var$g1_256(W[i - 2]), W[i - 7], $7e6a9264295a50d2$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $38nc4(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $7e6a9264295a50d2$var$sum32_5(h, $7e6a9264295a50d2$var$s1_256(e), $7e6a9264295a50d2$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $7e6a9264295a50d2$var$sum32($7e6a9264295a50d2$var$s0_256(a), $7e6a9264295a50d2$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $7e6a9264295a50d2$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $7e6a9264295a50d2$var$sum32(T1, T2);
    }
    this.h[0] = $7e6a9264295a50d2$var$sum32(this.h[0], a);
    this.h[1] = $7e6a9264295a50d2$var$sum32(this.h[1], b);
    this.h[2] = $7e6a9264295a50d2$var$sum32(this.h[2], c);
    this.h[3] = $7e6a9264295a50d2$var$sum32(this.h[3], d);
    this.h[4] = $7e6a9264295a50d2$var$sum32(this.h[4], e);
    this.h[5] = $7e6a9264295a50d2$var$sum32(this.h[5], f);
    this.h[6] = $7e6a9264295a50d2$var$sum32(this.h[6], g);
    this.h[7] = $7e6a9264295a50d2$var$sum32(this.h[7], h);
};
$7e6a9264295a50d2$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $sLl3Q.toHex32(this.h, 'big');
    else return $sLl3Q.split32(this.h, 'big');
};

});


parcelRegister("2Um1Z", function(module, exports) {
'use strict';

var $sLl3Q = parcelRequire("sLl3Q");

var $dA1Rs = parcelRequire("dA1Rs");
function $21e1e6a595859bcf$var$SHA384() {
    if (!(this instanceof $21e1e6a595859bcf$var$SHA384)) return new $21e1e6a595859bcf$var$SHA384();
    $dA1Rs.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$sLl3Q.inherits($21e1e6a595859bcf$var$SHA384, $dA1Rs);
module.exports = $21e1e6a595859bcf$var$SHA384;
$21e1e6a595859bcf$var$SHA384.blockSize = 1024;
$21e1e6a595859bcf$var$SHA384.outSize = 384;
$21e1e6a595859bcf$var$SHA384.hmacStrength = 192;
$21e1e6a595859bcf$var$SHA384.padLength = 128;
$21e1e6a595859bcf$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $sLl3Q.toHex32(this.h.slice(0, 12), 'big');
    else return $sLl3Q.split32(this.h.slice(0, 12), 'big');
};

});
parcelRegister("dA1Rs", function(module, exports) {
'use strict';

var $sLl3Q = parcelRequire("sLl3Q");

var $4Vf4u = parcelRequire("4Vf4u");

var $38nc4 = parcelRequire("38nc4");
var $9e3014c7902f39b2$var$rotr64_hi = $sLl3Q.rotr64_hi;
var $9e3014c7902f39b2$var$rotr64_lo = $sLl3Q.rotr64_lo;
var $9e3014c7902f39b2$var$shr64_hi = $sLl3Q.shr64_hi;
var $9e3014c7902f39b2$var$shr64_lo = $sLl3Q.shr64_lo;
var $9e3014c7902f39b2$var$sum64 = $sLl3Q.sum64;
var $9e3014c7902f39b2$var$sum64_hi = $sLl3Q.sum64_hi;
var $9e3014c7902f39b2$var$sum64_lo = $sLl3Q.sum64_lo;
var $9e3014c7902f39b2$var$sum64_4_hi = $sLl3Q.sum64_4_hi;
var $9e3014c7902f39b2$var$sum64_4_lo = $sLl3Q.sum64_4_lo;
var $9e3014c7902f39b2$var$sum64_5_hi = $sLl3Q.sum64_5_hi;
var $9e3014c7902f39b2$var$sum64_5_lo = $sLl3Q.sum64_5_lo;
var $9e3014c7902f39b2$var$BlockHash = $4Vf4u.BlockHash;
var $9e3014c7902f39b2$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $9e3014c7902f39b2$var$SHA512() {
    if (!(this instanceof $9e3014c7902f39b2$var$SHA512)) return new $9e3014c7902f39b2$var$SHA512();
    $9e3014c7902f39b2$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $9e3014c7902f39b2$var$sha512_K;
    this.W = new Array(160);
}
$sLl3Q.inherits($9e3014c7902f39b2$var$SHA512, $9e3014c7902f39b2$var$BlockHash);
module.exports = $9e3014c7902f39b2$var$SHA512;
$9e3014c7902f39b2$var$SHA512.blockSize = 1024;
$9e3014c7902f39b2$var$SHA512.outSize = 512;
$9e3014c7902f39b2$var$SHA512.hmacStrength = 192;
$9e3014c7902f39b2$var$SHA512.padLength = 128;
$9e3014c7902f39b2$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $9e3014c7902f39b2$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $9e3014c7902f39b2$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $9e3014c7902f39b2$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $9e3014c7902f39b2$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $9e3014c7902f39b2$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $9e3014c7902f39b2$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$9e3014c7902f39b2$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $38nc4(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $9e3014c7902f39b2$var$s1_512_hi(eh, el);
        var c1_lo = $9e3014c7902f39b2$var$s1_512_lo(eh, el);
        var c2_hi = $9e3014c7902f39b2$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $9e3014c7902f39b2$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $9e3014c7902f39b2$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $9e3014c7902f39b2$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $9e3014c7902f39b2$var$s0_512_hi(ah, al);
        c0_lo = $9e3014c7902f39b2$var$s0_512_lo(ah, al);
        c1_hi = $9e3014c7902f39b2$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $9e3014c7902f39b2$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $9e3014c7902f39b2$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $9e3014c7902f39b2$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $9e3014c7902f39b2$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $9e3014c7902f39b2$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $9e3014c7902f39b2$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $9e3014c7902f39b2$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $9e3014c7902f39b2$var$sum64(this.h, 0, ah, al);
    $9e3014c7902f39b2$var$sum64(this.h, 2, bh, bl);
    $9e3014c7902f39b2$var$sum64(this.h, 4, ch, cl);
    $9e3014c7902f39b2$var$sum64(this.h, 6, dh, dl);
    $9e3014c7902f39b2$var$sum64(this.h, 8, eh, el);
    $9e3014c7902f39b2$var$sum64(this.h, 10, fh, fl);
    $9e3014c7902f39b2$var$sum64(this.h, 12, gh, gl);
    $9e3014c7902f39b2$var$sum64(this.h, 14, hh, hl);
};
$9e3014c7902f39b2$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $sLl3Q.toHex32(this.h, 'big');
    else return $sLl3Q.split32(this.h, 'big');
};
function $9e3014c7902f39b2$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $9e3014c7902f39b2$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $9e3014c7902f39b2$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $9e3014c7902f39b2$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $9e3014c7902f39b2$var$s0_512_hi(xh, xl) {
    var c0_hi = $9e3014c7902f39b2$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $9e3014c7902f39b2$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $9e3014c7902f39b2$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $9e3014c7902f39b2$var$s0_512_lo(xh, xl) {
    var c0_lo = $9e3014c7902f39b2$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $9e3014c7902f39b2$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $9e3014c7902f39b2$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $9e3014c7902f39b2$var$s1_512_hi(xh, xl) {
    var c0_hi = $9e3014c7902f39b2$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $9e3014c7902f39b2$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $9e3014c7902f39b2$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $9e3014c7902f39b2$var$s1_512_lo(xh, xl) {
    var c0_lo = $9e3014c7902f39b2$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $9e3014c7902f39b2$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $9e3014c7902f39b2$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $9e3014c7902f39b2$var$g0_512_hi(xh, xl) {
    var c0_hi = $9e3014c7902f39b2$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $9e3014c7902f39b2$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $9e3014c7902f39b2$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $9e3014c7902f39b2$var$g0_512_lo(xh, xl) {
    var c0_lo = $9e3014c7902f39b2$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $9e3014c7902f39b2$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $9e3014c7902f39b2$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $9e3014c7902f39b2$var$g1_512_hi(xh, xl) {
    var c0_hi = $9e3014c7902f39b2$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $9e3014c7902f39b2$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $9e3014c7902f39b2$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $9e3014c7902f39b2$var$g1_512_lo(xh, xl) {
    var c0_lo = $9e3014c7902f39b2$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $9e3014c7902f39b2$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $9e3014c7902f39b2$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("9pbsG", function(module, exports) {
$parcel$export(module.exports, "ripemd160", () => $6d8f56e0078bc97a$export$d1cea0ee4e3f0d3e, (v) => $6d8f56e0078bc97a$export$d1cea0ee4e3f0d3e = v);
var $6d8f56e0078bc97a$export$d1cea0ee4e3f0d3e;
'use strict';

var $sLl3Q = parcelRequire("sLl3Q");

var $4Vf4u = parcelRequire("4Vf4u");
var $6d8f56e0078bc97a$var$rotl32 = $sLl3Q.rotl32;
var $6d8f56e0078bc97a$var$sum32 = $sLl3Q.sum32;
var $6d8f56e0078bc97a$var$sum32_3 = $sLl3Q.sum32_3;
var $6d8f56e0078bc97a$var$sum32_4 = $sLl3Q.sum32_4;
var $6d8f56e0078bc97a$var$BlockHash = $4Vf4u.BlockHash;
function $6d8f56e0078bc97a$var$RIPEMD160() {
    if (!(this instanceof $6d8f56e0078bc97a$var$RIPEMD160)) return new $6d8f56e0078bc97a$var$RIPEMD160();
    $6d8f56e0078bc97a$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = 'little';
}
$sLl3Q.inherits($6d8f56e0078bc97a$var$RIPEMD160, $6d8f56e0078bc97a$var$BlockHash);
$6d8f56e0078bc97a$export$d1cea0ee4e3f0d3e = $6d8f56e0078bc97a$var$RIPEMD160;
$6d8f56e0078bc97a$var$RIPEMD160.blockSize = 512;
$6d8f56e0078bc97a$var$RIPEMD160.outSize = 160;
$6d8f56e0078bc97a$var$RIPEMD160.hmacStrength = 192;
$6d8f56e0078bc97a$var$RIPEMD160.padLength = 64;
$6d8f56e0078bc97a$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $6d8f56e0078bc97a$var$sum32($6d8f56e0078bc97a$var$rotl32($6d8f56e0078bc97a$var$sum32_4(A, $6d8f56e0078bc97a$var$f(j, B, C, D), msg[$6d8f56e0078bc97a$var$r[j] + start], $6d8f56e0078bc97a$var$K(j)), $6d8f56e0078bc97a$var$s[j]), E);
        A = E;
        E = D;
        D = $6d8f56e0078bc97a$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $6d8f56e0078bc97a$var$sum32($6d8f56e0078bc97a$var$rotl32($6d8f56e0078bc97a$var$sum32_4(Ah, $6d8f56e0078bc97a$var$f(79 - j, Bh, Ch, Dh), msg[$6d8f56e0078bc97a$var$rh[j] + start], $6d8f56e0078bc97a$var$Kh(j)), $6d8f56e0078bc97a$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $6d8f56e0078bc97a$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $6d8f56e0078bc97a$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $6d8f56e0078bc97a$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $6d8f56e0078bc97a$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $6d8f56e0078bc97a$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $6d8f56e0078bc97a$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$6d8f56e0078bc97a$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $sLl3Q.toHex32(this.h, 'little');
    else return $sLl3Q.split32(this.h, 'little');
};
function $6d8f56e0078bc97a$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $6d8f56e0078bc97a$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $6d8f56e0078bc97a$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $6d8f56e0078bc97a$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $6d8f56e0078bc97a$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $6d8f56e0078bc97a$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $6d8f56e0078bc97a$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("ifxqm", function(module, exports) {
'use strict';

var $sLl3Q = parcelRequire("sLl3Q");

var $38nc4 = parcelRequire("38nc4");
function $d4938e1215dea180$var$Hmac(hash, key, enc) {
    if (!(this instanceof $d4938e1215dea180$var$Hmac)) return new $d4938e1215dea180$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($sLl3Q.toArray(key, enc));
}
module.exports = $d4938e1215dea180$var$Hmac;
$d4938e1215dea180$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $38nc4(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$d4938e1215dea180$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$d4938e1215dea180$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRegister("h19TE", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
                'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
            ],
            [
                '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
                '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
            ],
            [
                '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
                'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
            ],
            [
                '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
                '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
            ],
            [
                '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
                '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
            ],
            [
                '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
                '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
            ],
            [
                'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
                '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
            ],
            [
                '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
                'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
            ],
            [
                'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
                '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
            ],
            [
                'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
                'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
            ],
            [
                'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
                '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
            ],
            [
                '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
                '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
            ],
            [
                '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
                '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
            ],
            [
                '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
                '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
            ],
            [
                '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
                '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
            ],
            [
                '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
                '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
            ],
            [
                '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
                '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
            ],
            [
                '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
                '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
            ],
            [
                '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
                'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
            ],
            [
                'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
                '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
            ],
            [
                'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
                '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
            ],
            [
                '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
                '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
            ],
            [
                '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
                '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
            ],
            [
                'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
                '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
            ],
            [
                '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
                'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
            ],
            [
                'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
                '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
            ],
            [
                'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
                'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
            ],
            [
                'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
                '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
            ],
            [
                'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
                'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
            ],
            [
                'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
                '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
            ],
            [
                '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
                'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
            ],
            [
                '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
                '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
            ],
            [
                'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
                '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
            ],
            [
                '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
                'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
            ],
            [
                'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
                '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
            ],
            [
                'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
                '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
            ],
            [
                'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
                'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
            ],
            [
                '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
                '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
            ],
            [
                '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
                '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
            ],
            [
                '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
                'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
            ],
            [
                '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
                '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
            ],
            [
                'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
                '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
            ],
            [
                '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
                '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
            ],
            [
                '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
                'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
            ],
            [
                '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
                '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
            ],
            [
                'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
                '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
            ],
            [
                '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
                'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
            ],
            [
                'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
                'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
            ],
            [
                'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
                '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
            ],
            [
                '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
                'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
            ],
            [
                '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
                'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
            ],
            [
                'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
                '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
            ],
            [
                'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
                '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
            ],
            [
                'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
                '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
            ],
            [
                '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
                'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
            ],
            [
                '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
                '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
            ],
            [
                'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
                'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
            ],
            [
                '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
                'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
            ],
            [
                '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
                '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
            ],
            [
                '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
                '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
            ],
            [
                'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
                'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
            ],
            [
                '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
                '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
            ],
            [
                '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
                '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
            ],
            [
                'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
                '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
            ],
            [
                'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
                'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
                '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
            ],
            [
                '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
                'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
            ],
            [
                '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
                '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
            ],
            [
                'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
                'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
            ],
            [
                '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
                'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
            ],
            [
                'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
                'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
            ],
            [
                'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
                '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
            ],
            [
                'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
                '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
            ],
            [
                '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
                '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
            ],
            [
                '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
                '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
            ],
            [
                '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
                '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
            ],
            [
                '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
                '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
            ],
            [
                'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
                'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
            ],
            [
                'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
                '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
            ],
            [
                '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
                'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
            ],
            [
                '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
                'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
            ],
            [
                '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
                '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
            ],
            [
                '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
                '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
            ],
            [
                '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
                '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
            ],
            [
                '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
                'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
            ],
            [
                'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
                'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
            ],
            [
                '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
                '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
            ],
            [
                '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
                '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
            ],
            [
                'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
                'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
            ],
            [
                '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
                '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
            ],
            [
                'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
                'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
            ],
            [
                'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
                'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
            ],
            [
                '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
                '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
            ],
            [
                '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
                '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
            ],
            [
                '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
                '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
            ],
            [
                'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
                '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
            ],
            [
                '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
                '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
            ],
            [
                'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
                '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
            ],
            [
                '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
                'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
            ],
            [
                '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
                'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
            ],
            [
                'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
                'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
            ],
            [
                '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
                '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
            ],
            [
                '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
                'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
            ],
            [
                'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
                'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
            ],
            [
                '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
                '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
            ],
            [
                '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
                'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
            ],
            [
                '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
                '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
            ],
            [
                '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
                'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
            ],
            [
                'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
                '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
            ],
            [
                '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
                '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
            ],
            [
                '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
                'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
            ],
            [
                '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
                'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
            ],
            [
                'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
                'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
            ],
            [
                'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
                'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
            ],
            [
                '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
                '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
            ],
            [
                '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
                '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
            ],
            [
                'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
                '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
            ],
            [
                'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
                'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
            ],
            [
                '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
                '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
            ],
            [
                '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
                '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
            ],
            [
                'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
                '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
            ],
            [
                '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
                '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
            ],
            [
                'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
                'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
            ],
            [
                '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
                'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
            ],
            [
                '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
                '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
            ],
            [
                'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
                '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
            ],
            [
                'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
                '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
            ],
            [
                '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
                '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
            ],
            [
                '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
                '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
            ],
            [
                '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
                'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
            ],
            [
                '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
                'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
            ],
            [
                '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
                '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
            ],
            [
                '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
                '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
            ],
            [
                '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
                '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
            ],
            [
                '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
                'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
            ],
            [
                'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
                'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
            ],
            [
                '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
                'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
            ],
            [
                'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
                '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
            ],
            [
                'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
                '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
            ],
            [
                'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
                '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
            ],
            [
                'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
                '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
            ],
            [
                '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
                'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
            ],
            [
                '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
                '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
            ],
            [
                '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
                'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
            ],
            [
                'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
                'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
            ],
            [
                'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
                '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
            ],
            [
                'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
                'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
            ],
            [
                'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
                '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
            ],
            [
                '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
                '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
            ],
            [
                'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
                '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
            ],
            [
                'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
                '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
            ],
            [
                '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
                '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
            ],
            [
                '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
                'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
            ],
            [
                'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
                '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
            ],
            [
                'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
                '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
            ],
            [
                'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
                '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
            ],
            [
                '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
                '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
            ],
            [
                'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
                'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
            ],
            [
                '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
                'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
            ],
            [
                'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
                'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
            ],
            [
                'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
                '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
            ],
            [
                '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
                'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
            ],
            [
                'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
                '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
            ],
            [
                'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
                '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
            ],
            [
                'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
                '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
            ],
            [
                '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
                'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
            ],
            [
                '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
                'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
            ],
            [
                'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
                '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
            ],
            [
                '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
                'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
            ],
            [
                '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
                '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
            ],
            [
                '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
                'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
            ],
            [
                'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
                'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
            ],
            [
                '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
                'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
            ],
            [
                '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
                '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
            ],
            [
                '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
                'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
            ],
            [
                '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
                '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
            ],
            [
                'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
                'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
            ],
            [
                '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
                '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
            ],
            [
                'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
                '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
            ],
            [
                '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
                '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
            ],
            [
                'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
                'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
            ],
            [
                'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
                '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
            ],
            [
                'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
                'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
            ],
            [
                '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
                'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
            ],
            [
                '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
                '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
            ],
            [
                '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
                'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
            ],
            [
                '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
                '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
            ],
            [
                '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
                '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
            ],
            [
                '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
                'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
            ],
            [
                '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
                '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
            ],
            [
                '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
                '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
            ],
            [
                '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
                '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
            ]
        ]
    }
};

});


parcelRegister("fStnO", function(module, exports) {
'use strict';

var $huXFj = parcelRequire("huXFj");

var $elzq0 = parcelRequire("elzq0");

var $iuAiA = parcelRequire("iuAiA");

var $ecRVR = parcelRequire("ecRVR");

var $5nNgF = parcelRequire("5nNgF");
var $b8f2b10c972f1cd9$var$assert = $iuAiA.assert;

var $i3Oid = parcelRequire("i3Oid");

var $8qxwW = parcelRequire("8qxwW");
function $b8f2b10c972f1cd9$var$EC(options) {
    if (!(this instanceof $b8f2b10c972f1cd9$var$EC)) return new $b8f2b10c972f1cd9$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === 'string') {
        $b8f2b10c972f1cd9$var$assert(Object.prototype.hasOwnProperty.call($ecRVR, options), 'Unknown curve ' + options);
        options = $ecRVR[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $ecRVR.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $b8f2b10c972f1cd9$var$EC;
$b8f2b10c972f1cd9$var$EC.prototype.keyPair = function keyPair(options) {
    return new $i3Oid(this, options);
};
$b8f2b10c972f1cd9$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $i3Oid.fromPrivate(this, priv, enc);
};
$b8f2b10c972f1cd9$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $i3Oid.fromPublic(this, pub, enc);
};
$b8f2b10c972f1cd9$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $elzq0({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8',
        entropy: options.entropy || $5nNgF(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || 'utf8',
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $huXFj(2));
    for(;;){
        var priv = new $huXFj(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$b8f2b10c972f1cd9$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly, bitLength) {
    var byteLength;
    if ($huXFj.isBN(msg) || typeof msg === 'number') {
        msg = new $huXFj(msg, 16);
        byteLength = msg.byteLength();
    } else if (typeof msg === 'object') {
        // BN assumes an array-like input and asserts length
        byteLength = msg.length;
        msg = new $huXFj(msg, 16);
    } else {
        // BN converts the value to string
        var str = msg.toString();
        // HEX encoding
        byteLength = str.length + 1 >>> 1;
        msg = new $huXFj(str, 16);
    }
    // Allow overriding
    if (typeof bitLength !== 'number') bitLength = byteLength * 8;
    var delta = bitLength - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$b8f2b10c972f1cd9$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === 'object') {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    if (typeof msg !== 'string' && typeof msg !== 'number' && !$huXFj.isBN(msg)) {
        $b8f2b10c972f1cd9$var$assert(typeof msg === 'object' && msg && typeof msg.length === 'number', 'Expected message to be an array-like, a hex string, or a BN instance');
        $b8f2b10c972f1cd9$var$assert(msg.length >>> 0 === msg.length); // non-negative 32-bit integer
        for(var i = 0; i < msg.length; i++)$b8f2b10c972f1cd9$var$assert((msg[i] & 255) === msg[i]);
    }
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(msg, false, options.msgBitLength);
    // Would fail further checks, but let's make the error message clear
    $b8f2b10c972f1cd9$var$assert(!msg.isNeg(), 'Can not sign a negative message');
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray('be', bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray('be', bytes);
    // Recheck nonce to be bijective to msg
    $b8f2b10c972f1cd9$var$assert(new $huXFj(nonce).eq(msg), 'Can not sign message');
    // Instantiate Hmac_DRBG
    var drbg = new $elzq0({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8'
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $huXFj(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $huXFj(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $8qxwW({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$b8f2b10c972f1cd9$var$EC.prototype.verify = function verify(msg, signature, key, enc, options) {
    if (!options) options = {};
    msg = this._truncateToN(msg, false, options.msgBitLength);
    key = this.keyFromPublic(key, enc);
    signature = new $8qxwW(signature, 'hex');
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$b8f2b10c972f1cd9$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $b8f2b10c972f1cd9$var$assert((3 & j) === j, 'The recovery param is more than two bits');
    signature = new $8qxwW(signature, enc);
    var n = this.n;
    var e = new $huXFj(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error('Unable to find sencond key candinate');
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$b8f2b10c972f1cd9$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $8qxwW(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error('Unable to find valid recovery factor');
};

});
parcelRegister("elzq0", function(module, exports) {
'use strict';

var $1wWwG = parcelRequire("1wWwG");

var $gFjXX = parcelRequire("gFjXX");

var $38nc4 = parcelRequire("38nc4");
function $a71e803612538135$var$HmacDRBG(options) {
    if (!(this instanceof $a71e803612538135$var$HmacDRBG)) return new $a71e803612538135$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $gFjXX.toArray(options.entropy, options.entropyEnc || 'hex');
    var nonce = $gFjXX.toArray(options.nonce, options.nonceEnc || 'hex');
    var pers = $gFjXX.toArray(options.pers, options.persEnc || 'hex');
    $38nc4(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._init(entropy, nonce, pers);
}
module.exports = $a71e803612538135$var$HmacDRBG;
$a71e803612538135$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$a71e803612538135$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $1wWwG.hmac(this.hash, this.K);
};
$a71e803612538135$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$a71e803612538135$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== 'string') {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $gFjXX.toArray(entropy, entropyEnc);
    add = $gFjXX.toArray(add, addEnc);
    $38nc4(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$a71e803612538135$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error('Reseed is required');
    // Optional encoding
    if (typeof enc !== 'string') {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $gFjXX.toArray(add, addEnc || 'hex');
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $gFjXX.encode(res, enc);
};

});

parcelRegister("i3Oid", function(module, exports) {
'use strict';

var $huXFj = parcelRequire("huXFj");

var $iuAiA = parcelRequire("iuAiA");
var $d25f84e7925bb3b6$var$assert = $iuAiA.assert;
function $d25f84e7925bb3b6$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $d25f84e7925bb3b6$var$KeyPair;
$d25f84e7925bb3b6$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $d25f84e7925bb3b6$var$KeyPair) return pub;
    return new $d25f84e7925bb3b6$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$d25f84e7925bb3b6$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $d25f84e7925bb3b6$var$KeyPair) return priv;
    return new $d25f84e7925bb3b6$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$d25f84e7925bb3b6$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: 'Invalid public key'
    };
    if (!pub.validate()) return {
        result: false,
        reason: 'Public key is not a point'
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: 'Public key * N != O'
    };
    return {
        result: true,
        reason: null
    };
};
$d25f84e7925bb3b6$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === 'string') {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$d25f84e7925bb3b6$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === 'hex') return this.priv.toString(16, 2);
    else return this.priv;
};
$d25f84e7925bb3b6$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $huXFj(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$d25f84e7925bb3b6$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === 'mont') $d25f84e7925bb3b6$var$assert(key.x, 'Need x coordinate');
        else if (this.ec.curve.type === 'short' || this.ec.curve.type === 'edwards') $d25f84e7925bb3b6$var$assert(key.x && key.y, 'Need both x and y coordinate');
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$d25f84e7925bb3b6$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $d25f84e7925bb3b6$var$assert(pub.validate(), 'public point not validated');
    return pub.mul(this.priv).getX();
};
// ECDSA
$d25f84e7925bb3b6$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$d25f84e7925bb3b6$var$KeyPair.prototype.verify = function verify(msg, signature, options) {
    return this.ec.verify(msg, signature, this, undefined, options);
};
$d25f84e7925bb3b6$var$KeyPair.prototype.inspect = function inspect() {
    return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) + ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};

});

parcelRegister("8qxwW", function(module, exports) {
'use strict';

var $huXFj = parcelRequire("huXFj");

var $iuAiA = parcelRequire("iuAiA");
var $622ac2e1368854a3$var$assert = $iuAiA.assert;
function $622ac2e1368854a3$var$Signature(options, enc) {
    if (options instanceof $622ac2e1368854a3$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $622ac2e1368854a3$var$assert(options.r && options.s, 'Signature without r or s');
    this.r = new $huXFj(options.r, 16);
    this.s = new $huXFj(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $622ac2e1368854a3$var$Signature;
function $622ac2e1368854a3$var$Position() {
    this.place = 0;
}
function $622ac2e1368854a3$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    if (buf[p.place] === 0x00) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $622ac2e1368854a3$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$622ac2e1368854a3$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $iuAiA.toArray(data, enc);
    var p = new $622ac2e1368854a3$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $622ac2e1368854a3$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $622ac2e1368854a3$var$getLength(data, p);
    if (rlen === false) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $622ac2e1368854a3$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $huXFj(r);
    this.s = new $huXFj(s);
    this.recoveryParam = null;
    return true;
};
function $622ac2e1368854a3$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$622ac2e1368854a3$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $622ac2e1368854a3$var$rmPadding(r);
    s = $622ac2e1368854a3$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $622ac2e1368854a3$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $622ac2e1368854a3$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $622ac2e1368854a3$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $iuAiA.encode(res, enc);
};

});


parcelRegister("kB2SE", function(module, exports) {
'use strict';

var $1wWwG = parcelRequire("1wWwG");

var $ecRVR = parcelRequire("ecRVR");

var $iuAiA = parcelRequire("iuAiA");
var $efe97f5e480a5503$var$assert = $iuAiA.assert;
var $efe97f5e480a5503$var$parseBytes = $iuAiA.parseBytes;

var $2Kecr = parcelRequire("2Kecr");

var $auxtg = parcelRequire("auxtg");
function $efe97f5e480a5503$var$EDDSA(curve) {
    $efe97f5e480a5503$var$assert(curve === 'ed25519', 'only tested with ed25519 so far');
    if (!(this instanceof $efe97f5e480a5503$var$EDDSA)) return new $efe97f5e480a5503$var$EDDSA(curve);
    curve = $ecRVR[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $1wWwG.sha512;
}
module.exports = $efe97f5e480a5503$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $efe97f5e480a5503$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $efe97f5e480a5503$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $efe97f5e480a5503$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $efe97f5e480a5503$var$parseBytes(message);
    sig = this.makeSignature(sig);
    if (sig.S().gte(sig.eddsa.curve.n) || sig.S().isNeg()) return false;
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$efe97f5e480a5503$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $iuAiA.intFromLE(hash.digest()).umod(this.curve.n);
};
$efe97f5e480a5503$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $2Kecr.fromPublic(this, pub);
};
$efe97f5e480a5503$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $2Kecr.fromSecret(this, secret);
};
$efe97f5e480a5503$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $auxtg) return sig;
    return new $auxtg(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $efe97f5e480a5503$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray('le', this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$efe97f5e480a5503$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $iuAiA.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $iuAiA.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$efe97f5e480a5503$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray('le', this.encodingLength);
};
$efe97f5e480a5503$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $iuAiA.intFromLE(bytes);
};
$efe97f5e480a5503$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRegister("2Kecr", function(module, exports) {
'use strict';

var $iuAiA = parcelRequire("iuAiA");
var $1ffae46e258c1390$var$assert = $iuAiA.assert;
var $1ffae46e258c1390$var$parseBytes = $iuAiA.parseBytes;
var $1ffae46e258c1390$var$cachedProperty = $iuAiA.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $1ffae46e258c1390$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $1ffae46e258c1390$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $1ffae46e258c1390$var$parseBytes(params.pub);
}
$1ffae46e258c1390$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $1ffae46e258c1390$var$KeyPair) return pub;
    return new $1ffae46e258c1390$var$KeyPair(eddsa, {
        pub: pub
    });
};
$1ffae46e258c1390$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $1ffae46e258c1390$var$KeyPair) return secret;
    return new $1ffae46e258c1390$var$KeyPair(eddsa, {
        secret: secret
    });
};
$1ffae46e258c1390$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$1ffae46e258c1390$var$cachedProperty($1ffae46e258c1390$var$KeyPair, 'pubBytes', function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$1ffae46e258c1390$var$cachedProperty($1ffae46e258c1390$var$KeyPair, 'pub', function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$1ffae46e258c1390$var$cachedProperty($1ffae46e258c1390$var$KeyPair, 'privBytes', function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$1ffae46e258c1390$var$cachedProperty($1ffae46e258c1390$var$KeyPair, 'priv', function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$1ffae46e258c1390$var$cachedProperty($1ffae46e258c1390$var$KeyPair, 'hash', function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$1ffae46e258c1390$var$cachedProperty($1ffae46e258c1390$var$KeyPair, 'messagePrefix', function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$1ffae46e258c1390$var$KeyPair.prototype.sign = function sign(message) {
    $1ffae46e258c1390$var$assert(this._secret, 'KeyPair can only verify');
    return this.eddsa.sign(message, this);
};
$1ffae46e258c1390$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$1ffae46e258c1390$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $1ffae46e258c1390$var$assert(this._secret, 'KeyPair is public only');
    return $iuAiA.encode(this.secret(), enc);
};
$1ffae46e258c1390$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $iuAiA.encode(this.pubBytes(), enc);
};
module.exports = $1ffae46e258c1390$var$KeyPair;

});

parcelRegister("auxtg", function(module, exports) {
'use strict';

var $huXFj = parcelRequire("huXFj");

var $iuAiA = parcelRequire("iuAiA");
var $7a36ab59e31f13f1$var$assert = $iuAiA.assert;
var $7a36ab59e31f13f1$var$cachedProperty = $iuAiA.cachedProperty;
var $7a36ab59e31f13f1$var$parseBytes = $iuAiA.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $7a36ab59e31f13f1$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== 'object') sig = $7a36ab59e31f13f1$var$parseBytes(sig);
    if (Array.isArray(sig)) {
        $7a36ab59e31f13f1$var$assert(sig.length === eddsa.encodingLength * 2, 'Signature has invalid size');
        sig = {
            R: sig.slice(0, eddsa.encodingLength),
            S: sig.slice(eddsa.encodingLength)
        };
    }
    $7a36ab59e31f13f1$var$assert(sig.R && sig.S, 'Signature without R or S');
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $huXFj) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$7a36ab59e31f13f1$var$cachedProperty($7a36ab59e31f13f1$var$Signature, 'S', function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$7a36ab59e31f13f1$var$cachedProperty($7a36ab59e31f13f1$var$Signature, 'R', function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$7a36ab59e31f13f1$var$cachedProperty($7a36ab59e31f13f1$var$Signature, 'Rencoded', function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$7a36ab59e31f13f1$var$cachedProperty($7a36ab59e31f13f1$var$Signature, 'Sencoded', function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$7a36ab59e31f13f1$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$7a36ab59e31f13f1$var$Signature.prototype.toHex = function toHex() {
    return $iuAiA.encode(this.toBytes(), 'hex').toUpperCase();
};
module.exports = $7a36ab59e31f13f1$var$Signature;

});


parcelRegister("aObYz", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("2DlfF")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, 'Invalid character in ' + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, 'Invalid character');
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') try {
        BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === 'le' ? 'LE' : 'BE';
        this['_toArrayLike' + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("acpZa", function(module, exports) {

var $g3TdU = parcelRequire("g3TdU");

var $ktJSc = parcelRequire("ktJSc");
var $76cf2e8fc34415fe$var$api = module.exports;
$76cf2e8fc34415fe$var$api.define = function define(name, body) {
    return new $76cf2e8fc34415fe$var$Entity(name, body);
};
function $76cf2e8fc34415fe$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}

$76cf2e8fc34415fe$var$Entity.prototype._createNamed = function createNamed(base) {
    var named;
    try {
        named = (parcelRequire("8MWiI")).runInThisContext('(function ' + this.name + '(entity) {\n' + '  this._initNamed(entity);\n' + '})');
    } catch (e) {
        named = function(entity) {
            this._initNamed(entity);
        };
    }
    $ktJSc(named, base);
    named.prototype._initNamed = function initnamed(entity) {
        base.call(this, entity);
    };
    return new named(this);
};
$76cf2e8fc34415fe$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || 'der';
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($g3TdU.decoders[enc]);
    return this.decoders[enc];
};
$76cf2e8fc34415fe$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$76cf2e8fc34415fe$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || 'der';
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($g3TdU.encoders[enc]);
    return this.encoders[enc];
};
$76cf2e8fc34415fe$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});
parcelRegister("g3TdU", function(module, exports) {
var $bb17c3600f194cb6$var$asn1 = module.exports;

$bb17c3600f194cb6$var$asn1.bignum = (parcelRequire("huXFj"));

$bb17c3600f194cb6$var$asn1.define = (parcelRequire("acpZa")).define;

$bb17c3600f194cb6$var$asn1.base = (parcelRequire("6G5hX"));

$bb17c3600f194cb6$var$asn1.constants = (parcelRequire("5txvE"));

$bb17c3600f194cb6$var$asn1.decoders = (parcelRequire("cgYun"));

$bb17c3600f194cb6$var$asn1.encoders = (parcelRequire("5gH8F"));

});
parcelRegister("6G5hX", function(module, exports) {
var $4dcac485f09a3e24$var$base = module.exports;

$4dcac485f09a3e24$var$base.Reporter = (parcelRequire("hwjUv")).Reporter;

$4dcac485f09a3e24$var$base.DecoderBuffer = (parcelRequire("a1T11")).DecoderBuffer;

$4dcac485f09a3e24$var$base.EncoderBuffer = (parcelRequire("a1T11")).EncoderBuffer;

$4dcac485f09a3e24$var$base.Node = (parcelRequire("8hba5"));

});
parcelRegister("hwjUv", function(module, exports) {
$parcel$export(module.exports, "Reporter", () => $cc14de9ecc8f0e75$export$957313a2f485e5ed, (v) => $cc14de9ecc8f0e75$export$957313a2f485e5ed = v);
var $cc14de9ecc8f0e75$export$957313a2f485e5ed;

var $ktJSc = parcelRequire("ktJSc");
function $cc14de9ecc8f0e75$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$cc14de9ecc8f0e75$export$957313a2f485e5ed = $cc14de9ecc8f0e75$var$Reporter;
$cc14de9ecc8f0e75$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $cc14de9ecc8f0e75$var$ReporterError;
};
$cc14de9ecc8f0e75$var$Reporter.prototype.save = function save() {
    var state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$cc14de9ecc8f0e75$var$Reporter.prototype.restore = function restore(data) {
    var state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$cc14de9ecc8f0e75$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$cc14de9ecc8f0e75$var$Reporter.prototype.exitKey = function exitKey(index) {
    var state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$cc14de9ecc8f0e75$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    var state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$cc14de9ecc8f0e75$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join('/');
};
$cc14de9ecc8f0e75$var$Reporter.prototype.enterObject = function enterObject() {
    var state = this._reporterState;
    var prev = state.obj;
    state.obj = {};
    return prev;
};
$cc14de9ecc8f0e75$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    var state = this._reporterState;
    var now = state.obj;
    state.obj = prev;
    return now;
};
$cc14de9ecc8f0e75$var$Reporter.prototype.error = function error(msg) {
    var err;
    var state = this._reporterState;
    var inherited = msg instanceof $cc14de9ecc8f0e75$var$ReporterError;
    if (inherited) err = msg;
    else err = new $cc14de9ecc8f0e75$var$ReporterError(state.path.map(function(elem) {
        return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$cc14de9ecc8f0e75$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    var state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $cc14de9ecc8f0e75$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$ktJSc($cc14de9ecc8f0e75$var$ReporterError, Error);
$cc14de9ecc8f0e75$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + ' at: ' + (this.path || '(shallow)');
    if (Error.captureStackTrace) Error.captureStackTrace(this, $cc14de9ecc8f0e75$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRegister("a1T11", function(module, exports) {
$parcel$export(module.exports, "DecoderBuffer", () => $74d4ac54a4513c71$export$bf9f79cdc4a49163, (v) => $74d4ac54a4513c71$export$bf9f79cdc4a49163 = v);
$parcel$export(module.exports, "EncoderBuffer", () => $74d4ac54a4513c71$export$8ff24f7760c7a78e, (v) => $74d4ac54a4513c71$export$8ff24f7760c7a78e = v);
var $74d4ac54a4513c71$export$bf9f79cdc4a49163;
var $74d4ac54a4513c71$export$8ff24f7760c7a78e;

var $ktJSc = parcelRequire("ktJSc");

var $6G5hX = parcelRequire("6G5hX");
var $74d4ac54a4513c71$require$Reporter = $6G5hX.Reporter;

var $ekOVf = parcelRequire("ekOVf");
var $74d4ac54a4513c71$require$Buffer = $ekOVf.Buffer;
function $74d4ac54a4513c71$var$DecoderBuffer(base, options) {
    $74d4ac54a4513c71$require$Reporter.call(this, options);
    if (!$74d4ac54a4513c71$require$Buffer.isBuffer(base)) {
        this.error('Input not Buffer');
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$ktJSc($74d4ac54a4513c71$var$DecoderBuffer, $74d4ac54a4513c71$require$Reporter);
$74d4ac54a4513c71$export$bf9f79cdc4a49163 = $74d4ac54a4513c71$var$DecoderBuffer;
$74d4ac54a4513c71$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $74d4ac54a4513c71$require$Reporter.prototype.save.call(this)
    };
};
$74d4ac54a4513c71$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    var res = new $74d4ac54a4513c71$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $74d4ac54a4513c71$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$74d4ac54a4513c71$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$74d4ac54a4513c71$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || 'DecoderBuffer overrun');
};
$74d4ac54a4513c71$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || 'DecoderBuffer overrun');
    var res = new $74d4ac54a4513c71$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$74d4ac54a4513c71$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $74d4ac54a4513c71$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!(item instanceof $74d4ac54a4513c71$var$EncoderBuffer)) item = new $74d4ac54a4513c71$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === 'number') {
        if (!(0 <= value && value <= 0xff)) return reporter.error('non-byte EncoderBuffer value');
        this.value = value;
        this.length = 1;
    } else if (typeof value === 'string') {
        this.value = value;
        this.length = $74d4ac54a4513c71$require$Buffer.byteLength(value);
    } else if ($74d4ac54a4513c71$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error('Unsupported type: ' + typeof value);
}
$74d4ac54a4513c71$export$8ff24f7760c7a78e = $74d4ac54a4513c71$var$EncoderBuffer;
$74d4ac54a4513c71$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = new $74d4ac54a4513c71$require$Buffer(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === 'number') out[offset] = this.value;
        else if (typeof this.value === 'string') out.write(this.value, offset);
        else if ($74d4ac54a4513c71$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});

parcelRegister("8hba5", function(module, exports) {

var $6G5hX = parcelRequire("6G5hX");
var $606891bca23a507d$require$Reporter = $6G5hX.Reporter;

var $6G5hX = parcelRequire("6G5hX");
var $606891bca23a507d$require$EncoderBuffer = $6G5hX.EncoderBuffer;

var $6G5hX = parcelRequire("6G5hX");
var $606891bca23a507d$require$DecoderBuffer = $6G5hX.DecoderBuffer;

var $38nc4 = parcelRequire("38nc4");
// Supported tags
var $606891bca23a507d$var$tags = [
    'seq',
    'seqof',
    'set',
    'setof',
    'objid',
    'bool',
    'gentime',
    'utctime',
    'null_',
    'enum',
    'int',
    'objDesc',
    'bitstr',
    'bmpstr',
    'charstr',
    'genstr',
    'graphstr',
    'ia5str',
    'iso646str',
    'numstr',
    'octstr',
    'printstr',
    't61str',
    'unistr',
    'utf8str',
    'videostr'
];
// Public methods list
var $606891bca23a507d$var$methods = [
    'key',
    'obj',
    'use',
    'optional',
    'explicit',
    'implicit',
    'def',
    'choice',
    'any',
    'contains'
].concat($606891bca23a507d$var$tags);
// Overrided methods list
var $606891bca23a507d$var$overrided = [
    '_peekTag',
    '_decodeTag',
    '_use',
    '_decodeStr',
    '_decodeObjid',
    '_decodeTime',
    '_decodeNull',
    '_decodeInt',
    '_decodeBool',
    '_decodeList',
    '_encodeComposite',
    '_encodeStr',
    '_encodeObjid',
    '_encodeTime',
    '_encodeNull',
    '_encodeInt',
    '_encodeBool'
];
function $606891bca23a507d$var$Node(enc, parent) {
    var state = {};
    this._baseState = state;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state['default'] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $606891bca23a507d$var$Node;
var $606891bca23a507d$var$stateProps = [
    'enc',
    'parent',
    'children',
    'tag',
    'args',
    'reverseArgs',
    'choice',
    'optional',
    'any',
    'obj',
    'use',
    'alteredUse',
    'key',
    'default',
    'explicit',
    'implicit',
    'contains'
];
$606891bca23a507d$var$Node.prototype.clone = function clone() {
    var state = this._baseState;
    var cstate = {};
    $606891bca23a507d$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    var res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$606891bca23a507d$var$Node.prototype._wrap = function wrap() {
    var state = this._baseState;
    $606891bca23a507d$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            var clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$606891bca23a507d$var$Node.prototype._init = function init(body) {
    var state = this._baseState;
    $38nc4(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $38nc4.equal(state.children.length, 1, 'Root node can have only one child');
};
$606891bca23a507d$var$Node.prototype._useArgs = function useArgs(args) {
    var state = this._baseState;
    // Filter children and args
    var children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $38nc4(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $38nc4(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== 'object' || arg.constructor !== Object) return arg;
            var res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                var value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$606891bca23a507d$var$overrided.forEach(function(method) {
    $606891bca23a507d$var$Node.prototype[method] = function _overrided() {
        var state = this._baseState;
        throw new Error(method + ' not implemented for encoding: ' + state.enc);
    };
});
//
// Public methods
//
$606891bca23a507d$var$tags.forEach(function(tag) {
    $606891bca23a507d$var$Node.prototype[tag] = function _tagMethod() {
        var state = this._baseState;
        var args = Array.prototype.slice.call(arguments);
        $38nc4(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$606891bca23a507d$var$Node.prototype.use = function use(item) {
    $38nc4(item);
    var state = this._baseState;
    $38nc4(state.use === null);
    state.use = item;
    return this;
};
$606891bca23a507d$var$Node.prototype.optional = function optional() {
    var state = this._baseState;
    state.optional = true;
    return this;
};
$606891bca23a507d$var$Node.prototype.def = function def(val) {
    var state = this._baseState;
    $38nc4(state['default'] === null);
    state['default'] = val;
    state.optional = true;
    return this;
};
$606891bca23a507d$var$Node.prototype.explicit = function explicit(num) {
    var state = this._baseState;
    $38nc4(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$606891bca23a507d$var$Node.prototype.implicit = function implicit(num) {
    var state = this._baseState;
    $38nc4(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$606891bca23a507d$var$Node.prototype.obj = function obj() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$606891bca23a507d$var$Node.prototype.key = function key(newKey) {
    var state = this._baseState;
    $38nc4(state.key === null);
    state.key = newKey;
    return this;
};
$606891bca23a507d$var$Node.prototype.any = function any() {
    var state = this._baseState;
    state.any = true;
    return this;
};
$606891bca23a507d$var$Node.prototype.choice = function choice(obj) {
    var state = this._baseState;
    $38nc4(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$606891bca23a507d$var$Node.prototype.contains = function contains(item) {
    var state = this._baseState;
    $38nc4(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$606891bca23a507d$var$Node.prototype._decode = function decode(input, options) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    var result = state['default'];
    var present = true;
    var prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        var tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            var save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    var prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            var explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        var start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            if (state.any) var save = input.save();
            var body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, 'tagged');
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, 'content');
        // Select proper method for tag
        if (state.any) result;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
            var data = new $606891bca23a507d$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$606891bca23a507d$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    var state = this._baseState;
    if (tag === 'seq' || tag === 'set') return null;
    if (tag === 'seqof' || tag === 'setof') return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === 'objid' && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === 'objid') return this._decodeObjid(input, null, null, options);
    else if (tag === 'gentime' || tag === 'utctime') return this._decodeTime(input, tag, options);
    else if (tag === 'null_') return this._decodeNull(input, options);
    else if (tag === 'bool') return this._decodeBool(input, options);
    else if (tag === 'objDesc') return this._decodeStr(input, tag, options);
    else if (tag === 'int' || tag === 'enum') return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error('unknown tag: ' + tag);
};
$606891bca23a507d$var$Node.prototype._getUse = function _getUse(entity, obj) {
    var state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $38nc4(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$606891bca23a507d$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    var state = this._baseState;
    var result = null;
    var match = false;
    Object.keys(state.choice).some(function(key) {
        var save = input.save();
        var node = state.choice[key];
        try {
            var value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error('Choice not matched');
    return result;
};
//
// Encoding
//
$606891bca23a507d$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $606891bca23a507d$require$EncoderBuffer(data, this.reporter);
};
$606891bca23a507d$var$Node.prototype._encode = function encode(data, reporter, parent) {
    var state = this._baseState;
    if (state['default'] !== null && state['default'] === data) return;
    var result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$606891bca23a507d$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $606891bca23a507d$require$Reporter());
    var result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state['default'] !== null) data = state['default'];
        else return;
    }
    // Encode children first
    var content = null;
    var primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === 'null_') return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error('Child should have a key');
            var prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== 'object') return reporter.error('Child expected, but input is not object');
            var res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === 'seqof' || state.tag === 'setof') {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error('Too many args for : ' + state.tag);
            if (!Array.isArray(data)) return reporter.error('seqof/setof, but data is not Array');
            var child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                var state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    var result;
    if (!state.any && state.choice === null) {
        var tag = state.implicit !== null ? state.implicit : state.tag;
        var cls = state.implicit === null ? 'universal' : 'context';
        if (tag === null) {
            if (state.use === null) reporter.error('Tag could be omitted only for .use()');
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, 'context', result);
    return result;
};
$606891bca23a507d$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    var state = this._baseState;
    var node = state.choice[data.type];
    if (!node) $38nc4(false, data.type + ' not found in ' + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$606891bca23a507d$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    var state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === 'objid' && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === 'objid') return this._encodeObjid(data, null, null);
    else if (tag === 'gentime' || tag === 'utctime') return this._encodeTime(data, tag);
    else if (tag === 'null_') return this._encodeNull();
    else if (tag === 'int' || tag === 'enum') return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === 'bool') return this._encodeBool(data);
    else if (tag === 'objDesc') return this._encodeStr(data, tag);
    else throw new Error('Unsupported tag: ' + tag);
};
$606891bca23a507d$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$606891bca23a507d$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};

});


parcelRegister("5txvE", function(module, exports) {
var $3fc9a77bfa6c5354$var$constants = module.exports;
// Helper
$3fc9a77bfa6c5354$var$constants._reverse = function reverse(map) {
    var res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        var value = map[key];
        res[value] = key;
    });
    return res;
};

$3fc9a77bfa6c5354$var$constants.der = (parcelRequire("1jBsN"));

});
parcelRegister("1jBsN", function(module, exports) {
$parcel$export(module.exports, "tagClass", () => $0f54a04705191f36$export$3584c46ed60baee8, (v) => $0f54a04705191f36$export$3584c46ed60baee8 = v);
$parcel$export(module.exports, "tagClassByName", () => $0f54a04705191f36$export$f18596ef8d632e49, (v) => $0f54a04705191f36$export$f18596ef8d632e49 = v);
$parcel$export(module.exports, "tag", () => $0f54a04705191f36$export$2b067c6666111485, (v) => $0f54a04705191f36$export$2b067c6666111485 = v);
$parcel$export(module.exports, "tagByName", () => $0f54a04705191f36$export$f17df38a421ab9e3, (v) => $0f54a04705191f36$export$f17df38a421ab9e3 = v);
var $0f54a04705191f36$export$3584c46ed60baee8;
var $0f54a04705191f36$export$f18596ef8d632e49;
var $0f54a04705191f36$export$2b067c6666111485;
var $0f54a04705191f36$export$f17df38a421ab9e3;

var $5txvE = parcelRequire("5txvE");
$0f54a04705191f36$export$3584c46ed60baee8 = {
    0: 'universal',
    1: 'application',
    2: 'context',
    3: 'private'
};
$0f54a04705191f36$export$f18596ef8d632e49 = $5txvE._reverse($0f54a04705191f36$export$3584c46ed60baee8);
$0f54a04705191f36$export$2b067c6666111485 = {
    0x00: 'end',
    0x01: 'bool',
    0x02: 'int',
    0x03: 'bitstr',
    0x04: 'octstr',
    0x05: 'null_',
    0x06: 'objid',
    0x07: 'objDesc',
    0x08: 'external',
    0x09: 'real',
    0x0a: 'enum',
    0x0b: 'embed',
    0x0c: 'utf8str',
    0x0d: 'relativeOid',
    0x10: 'seq',
    0x11: 'set',
    0x12: 'numstr',
    0x13: 'printstr',
    0x14: 't61str',
    0x15: 'videostr',
    0x16: 'ia5str',
    0x17: 'utctime',
    0x18: 'gentime',
    0x19: 'graphstr',
    0x1a: 'iso646str',
    0x1b: 'genstr',
    0x1c: 'unistr',
    0x1d: 'charstr',
    0x1e: 'bmpstr'
};
$0f54a04705191f36$export$f17df38a421ab9e3 = $5txvE._reverse($0f54a04705191f36$export$2b067c6666111485);

});


parcelRegister("cgYun", function(module, exports) {
var $8ef5e67f955e409b$var$decoders = module.exports;

$8ef5e67f955e409b$var$decoders.der = (parcelRequire("9aTd1"));

$8ef5e67f955e409b$var$decoders.pem = (parcelRequire("iMez9"));

});
parcelRegister("9aTd1", function(module, exports) {

var $ktJSc = parcelRequire("ktJSc");

var $g3TdU = parcelRequire("g3TdU");
var $6adfdf9e43aaf2b5$var$base = $g3TdU.base;
var $6adfdf9e43aaf2b5$var$bignum = $g3TdU.bignum;
// Import DER constants
var $6adfdf9e43aaf2b5$var$der = $g3TdU.constants.der;
function $6adfdf9e43aaf2b5$var$DERDecoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $6adfdf9e43aaf2b5$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $6adfdf9e43aaf2b5$var$DERDecoder;
$6adfdf9e43aaf2b5$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!(data instanceof $6adfdf9e43aaf2b5$var$base.DecoderBuffer)) data = new $6adfdf9e43aaf2b5$var$base.DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $6adfdf9e43aaf2b5$var$DERNode(parent) {
    $6adfdf9e43aaf2b5$var$base.Node.call(this, 'der', parent);
}
$ktJSc($6adfdf9e43aaf2b5$var$DERNode, $6adfdf9e43aaf2b5$var$base.Node);
$6adfdf9e43aaf2b5$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    var state = buffer.save();
    var decodedTag = $6adfdf9e43aaf2b5$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + 'of' === tag || any;
};
$6adfdf9e43aaf2b5$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    var decodedTag = $6adfdf9e43aaf2b5$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    var len = $6adfdf9e43aaf2b5$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + 'of' !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    var state = buffer.save();
    var res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$6adfdf9e43aaf2b5$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    while(true){
        var tag = $6adfdf9e43aaf2b5$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        var len = $6adfdf9e43aaf2b5$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        var res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === 'end') break;
    }
};
$6adfdf9e43aaf2b5$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    var result = [];
    while(!buffer.isEmpty()){
        var possibleEnd = this._peekTag(buffer, 'end');
        if (buffer.isError(possibleEnd)) return possibleEnd;
        var res = decoder.decode(buffer, 'der', options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$6adfdf9e43aaf2b5$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === 'bitstr') {
        var unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === 'bmpstr') {
        var raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error('Decoding of string type: bmpstr length mismatch');
        var str = '';
        for(var i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === 'numstr') {
        var numstr = buffer.raw().toString('ascii');
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === 'octstr') return buffer.raw();
    else if (tag === 'objDesc') return buffer.raw();
    else if (tag === 'printstr') {
        var printstr = buffer.raw().toString('ascii');
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error('Decoding of string type: ' + tag + ' unsupported');
};
$6adfdf9e43aaf2b5$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    var result;
    var identifiers = [];
    var ident = 0;
    while(!buffer.isEmpty()){
        var subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    var first = identifiers[0] / 40 | 0;
    var second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        var tmp = values[result.join(' ')];
        if (tmp === undefined) tmp = values[result.join('.')];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$6adfdf9e43aaf2b5$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    var str = buffer.raw().toString();
    if (tag === 'gentime') {
        var year = str.slice(0, 4) | 0;
        var mon = str.slice(4, 6) | 0;
        var day = str.slice(6, 8) | 0;
        var hour = str.slice(8, 10) | 0;
        var min = str.slice(10, 12) | 0;
        var sec = str.slice(12, 14) | 0;
    } else if (tag === 'utctime') {
        var year = str.slice(0, 2) | 0;
        var mon = str.slice(2, 4) | 0;
        var day = str.slice(4, 6) | 0;
        var hour = str.slice(6, 8) | 0;
        var min = str.slice(8, 10) | 0;
        var sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error('Decoding ' + tag + ' time is not supported yet');
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$6adfdf9e43aaf2b5$var$DERNode.prototype._decodeNull = function decodeNull(buffer) {
    return null;
};
$6adfdf9e43aaf2b5$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    var res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$6adfdf9e43aaf2b5$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    var raw = buffer.raw();
    var res = new $6adfdf9e43aaf2b5$var$bignum(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$6adfdf9e43aaf2b5$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getDecoder('der').tree;
};
// Utility methods
function $6adfdf9e43aaf2b5$var$derDecodeTag(buf, fail) {
    var tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    var cls = $6adfdf9e43aaf2b5$var$der.tagClass[tag >> 6];
    var primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        var oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    var tagStr = $6adfdf9e43aaf2b5$var$der.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $6adfdf9e43aaf2b5$var$derDecodeLen(buf, primitive, fail) {
    var len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    var num = len & 0x7f;
    if (num > 4) return buf.error('length octect is too long');
    len = 0;
    for(var i = 0; i < num; i++){
        len <<= 8;
        var j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRegister("iMez9", function(module, exports) {

var $ktJSc = parcelRequire("ktJSc");

var $ekOVf = parcelRequire("ekOVf");
var $dab8022abd42a517$require$Buffer = $ekOVf.Buffer;

var $9aTd1 = parcelRequire("9aTd1");
function $dab8022abd42a517$var$PEMDecoder(entity) {
    $9aTd1.call(this, entity);
    this.enc = 'pem';
}
$ktJSc($dab8022abd42a517$var$PEMDecoder, $9aTd1);
module.exports = $dab8022abd42a517$var$PEMDecoder;
$dab8022abd42a517$var$PEMDecoder.prototype.decode = function decode(data, options) {
    var lines = data.toString().split(/[\r\n]+/g);
    var label = options.label.toUpperCase();
    var re = /^-----(BEGIN|END) ([^-]+)-----$/;
    var start = -1;
    var end = -1;
    for(var i = 0; i < lines.length; i++){
        var match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== 'BEGIN') break;
            start = i;
        } else {
            if (match[1] !== 'END') break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error('PEM section not found for: ' + label);
    var base64 = lines.slice(start + 1, end).join('');
    // Remove excessive symbols
    base64.replace(/[^a-z0-9\+\/=]+/gi, '');
    var input = new $dab8022abd42a517$require$Buffer(base64, 'base64');
    return $9aTd1.prototype.decode.call(this, input, options);
};

});


parcelRegister("5gH8F", function(module, exports) {
var $3d5fe8d5f88c3b89$var$encoders = module.exports;

$3d5fe8d5f88c3b89$var$encoders.der = (parcelRequire("hEFp3"));

$3d5fe8d5f88c3b89$var$encoders.pem = (parcelRequire("l5M5l"));

});
parcelRegister("hEFp3", function(module, exports) {

var $ktJSc = parcelRequire("ktJSc");

var $ekOVf = parcelRequire("ekOVf");
var $cda649e80a1e8889$require$Buffer = $ekOVf.Buffer;

var $g3TdU = parcelRequire("g3TdU");
var $cda649e80a1e8889$var$base = $g3TdU.base;
// Import DER constants
var $cda649e80a1e8889$var$der = $g3TdU.constants.der;
function $cda649e80a1e8889$var$DEREncoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $cda649e80a1e8889$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $cda649e80a1e8889$var$DEREncoder;
$cda649e80a1e8889$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $cda649e80a1e8889$var$DERNode(parent) {
    $cda649e80a1e8889$var$base.Node.call(this, 'der', parent);
}
$ktJSc($cda649e80a1e8889$var$DERNode, $cda649e80a1e8889$var$base.Node);
$cda649e80a1e8889$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    var encodedTag = $cda649e80a1e8889$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        var header = new $cda649e80a1e8889$require$Buffer(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    var lenOctets = 1;
    for(var i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    var header = new $cda649e80a1e8889$require$Buffer(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
$cda649e80a1e8889$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === 'bitstr') return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === 'bmpstr') {
        var buf = new $cda649e80a1e8889$require$Buffer(str.length * 2);
        for(var i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === 'numstr') {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === 'printstr') {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === 'objDesc') return this._createEncoderBuffer(str);
    else return this.reporter.error('Encoding of string type: ' + tag + ' unsupported');
};
$cda649e80a1e8889$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === 'string') {
        if (!values) return this.reporter.error('string objid given, but no values map found');
        if (!values.hasOwnProperty(id)) return this.reporter.error('objid not found in values map');
        id = values[id].split(/[\s\.]+/g);
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error('Second objid identifier OOB');
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    var size = 0;
    for(var i = 0; i < id.length; i++){
        var ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    var objid = new $cda649e80a1e8889$require$Buffer(size);
    var offset = objid.length - 1;
    for(var i = id.length - 1; i >= 0; i--){
        var ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $cda649e80a1e8889$var$two(num) {
    if (num < 10) return '0' + num;
    else return num;
}
$cda649e80a1e8889$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    var str;
    var date = new Date(time);
    if (tag === 'gentime') str = [
        $cda649e80a1e8889$var$two(date.getFullYear()),
        $cda649e80a1e8889$var$two(date.getUTCMonth() + 1),
        $cda649e80a1e8889$var$two(date.getUTCDate()),
        $cda649e80a1e8889$var$two(date.getUTCHours()),
        $cda649e80a1e8889$var$two(date.getUTCMinutes()),
        $cda649e80a1e8889$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else if (tag === 'utctime') str = [
        $cda649e80a1e8889$var$two(date.getFullYear() % 100),
        $cda649e80a1e8889$var$two(date.getUTCMonth() + 1),
        $cda649e80a1e8889$var$two(date.getUTCDate()),
        $cda649e80a1e8889$var$two(date.getUTCHours()),
        $cda649e80a1e8889$var$two(date.getUTCMinutes()),
        $cda649e80a1e8889$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else this.reporter.error('Encoding ' + tag + ' time is not supported yet');
    return this._encodeStr(str, 'octstr');
};
$cda649e80a1e8889$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer('');
};
$cda649e80a1e8889$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === 'string') {
        if (!values) return this.reporter.error('String int or enum given, but no values map');
        if (!values.hasOwnProperty(num)) return this.reporter.error('Values map doesn\'t contain: ' + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== 'number' && !$cda649e80a1e8889$require$Buffer.isBuffer(num)) {
        var numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = new $cda649e80a1e8889$require$Buffer(numArray);
    }
    if ($cda649e80a1e8889$require$Buffer.isBuffer(num)) {
        var size = num.length;
        if (num.length === 0) size++;
        var out = new $cda649e80a1e8889$require$Buffer(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    var size = 1;
    for(var i = num; i >= 0x100; i >>= 8)size++;
    var out = new Array(size);
    for(var i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer(new $cda649e80a1e8889$require$Buffer(out));
};
$cda649e80a1e8889$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$cda649e80a1e8889$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getEncoder('der').tree;
};
$cda649e80a1e8889$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    var state = this._baseState;
    var i;
    if (state['default'] === null) return false;
    var data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $cda649e80a1e8889$var$encodeTag(tag, primitive, cls, reporter) {
    var res;
    if (tag === 'seqof') tag = 'seq';
    else if (tag === 'setof') tag = 'set';
    if ($cda649e80a1e8889$var$der.tagByName.hasOwnProperty(tag)) res = $cda649e80a1e8889$var$der.tagByName[tag];
    else if (typeof tag === 'number' && (tag | 0) === tag) res = tag;
    else return reporter.error('Unknown tag: ' + tag);
    if (res >= 0x1f) return reporter.error('Multi-octet tag encoding unsupported');
    if (!primitive) res |= 0x20;
    res |= $cda649e80a1e8889$var$der.tagClassByName[cls || 'universal'] << 6;
    return res;
}

});

parcelRegister("l5M5l", function(module, exports) {

var $ktJSc = parcelRequire("ktJSc");

var $hEFp3 = parcelRequire("hEFp3");
function $f5af5d4dddaf8e3b$var$PEMEncoder(entity) {
    $hEFp3.call(this, entity);
    this.enc = 'pem';
}
$ktJSc($f5af5d4dddaf8e3b$var$PEMEncoder, $hEFp3);
module.exports = $f5af5d4dddaf8e3b$var$PEMEncoder;
$f5af5d4dddaf8e3b$var$PEMEncoder.prototype.encode = function encode(data, options) {
    var buf = $hEFp3.prototype.encode.call(this, data);
    var p = buf.toString('base64');
    var out = [
        '-----BEGIN ' + options.label + '-----'
    ];
    for(var i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push('-----END ' + options.label + '-----');
    return out.join('\n');
};

});



parcelRegister("8MWiI", function(module, exports) {
var indexOf = function(xs, item) {
    if (xs.indexOf) return xs.indexOf(item);
    else for(var i = 0; i < xs.length; i++){
        if (xs[i] === item) return i;
    }
    return -1;
};
var Object_keys = function(obj) {
    if (Object.keys) return Object.keys(obj);
    else {
        var res = [];
        for(var key in obj)res.push(key);
        return res;
    }
};
var forEach = function(xs, fn) {
    if (xs.forEach) return xs.forEach(fn);
    else for(var i = 0; i < xs.length; i++)fn(xs[i], i, xs);
};
var defineProp = function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            });
        };
    } catch (e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}();
var globals = [
    'Array',
    'Boolean',
    'Date',
    'Error',
    'EvalError',
    'Function',
    'Infinity',
    'JSON',
    'Math',
    'NaN',
    'Number',
    'Object',
    'RangeError',
    'ReferenceError',
    'RegExp',
    'String',
    'SyntaxError',
    'TypeError',
    'URIError',
    'decodeURI',
    'decodeURIComponent',
    'encodeURI',
    'encodeURIComponent',
    'escape',
    'eval',
    'isFinite',
    'isNaN',
    'parseFloat',
    'parseInt',
    'undefined',
    'unescape'
];
function Context() {}
Context.prototype = {};
var Script = exports.Script = function NodeScript(code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};
Script.prototype.runInContext = function(context) {
    if (!(context instanceof Context)) throw new TypeError("needs a 'context' argument.");
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;
    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    forEach(Object_keys(context), function(key) {
        win[key] = context[key];
    });
    forEach(globals, function(key) {
        if (context[key]) win[key] = context[key];
    });
    var winKeys = Object_keys(win);
    var res = wEval.call(win, this.code);
    forEach(Object_keys(win), function(key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) context[key] = win[key];
    });
    forEach(globals, function(key) {
        if (!(key in context)) defineProp(context, key, win[key]);
    });
    document.body.removeChild(iframe);
    return res;
};
Script.prototype.runInThisContext = function() {
    return eval(this.code); // maybe...
};
Script.prototype.runInNewContext = function(context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);
    if (context) forEach(Object_keys(ctx), function(key) {
        context[key] = ctx[key];
    });
    return res;
};
forEach(Object_keys(Script.prototype), function(name) {
    exports[name] = Script[name] = function(code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});
exports.isContext = function(context) {
    return context instanceof Context;
};
exports.createScript = function(code) {
    return exports.Script(code);
};
exports.createContext = Script.createContext = function(context) {
    var copy = new Context();
    if (typeof context === 'object') forEach(Object_keys(context), function(key) {
        copy[key] = context[key];
    });
    return copy;
};

});


parcelRegister("bGzbE", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
'use strict';

var $g3TdU = parcelRequire("g3TdU");
var $881ee9573daa1825$var$Time = $g3TdU.define('Time', function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $881ee9573daa1825$var$AttributeTypeValue = $g3TdU.define('AttributeTypeValue', function() {
    this.seq().obj(this.key('type').objid(), this.key('value').any());
});
var $881ee9573daa1825$var$AlgorithmIdentifier = $g3TdU.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('parameters').optional(), this.key('curve').objid().optional());
});
var $881ee9573daa1825$var$SubjectPublicKeyInfo = $g3TdU.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($881ee9573daa1825$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
var $881ee9573daa1825$var$RelativeDistinguishedName = $g3TdU.define('RelativeDistinguishedName', function() {
    this.setof($881ee9573daa1825$var$AttributeTypeValue);
});
var $881ee9573daa1825$var$RDNSequence = $g3TdU.define('RDNSequence', function() {
    this.seqof($881ee9573daa1825$var$RelativeDistinguishedName);
});
var $881ee9573daa1825$var$Name = $g3TdU.define('Name', function() {
    this.choice({
        rdnSequence: this.use($881ee9573daa1825$var$RDNSequence)
    });
});
var $881ee9573daa1825$var$Validity = $g3TdU.define('Validity', function() {
    this.seq().obj(this.key('notBefore').use($881ee9573daa1825$var$Time), this.key('notAfter').use($881ee9573daa1825$var$Time));
});
var $881ee9573daa1825$var$Extension = $g3TdU.define('Extension', function() {
    this.seq().obj(this.key('extnID').objid(), this.key('critical').bool().def(false), this.key('extnValue').octstr());
});
var $881ee9573daa1825$var$TBSCertificate = $g3TdU.define('TBSCertificate', function() {
    this.seq().obj(this.key('version').explicit(0)['int']().optional(), this.key('serialNumber')['int'](), this.key('signature').use($881ee9573daa1825$var$AlgorithmIdentifier), this.key('issuer').use($881ee9573daa1825$var$Name), this.key('validity').use($881ee9573daa1825$var$Validity), this.key('subject').use($881ee9573daa1825$var$Name), this.key('subjectPublicKeyInfo').use($881ee9573daa1825$var$SubjectPublicKeyInfo), this.key('issuerUniqueID').implicit(1).bitstr().optional(), this.key('subjectUniqueID').implicit(2).bitstr().optional(), this.key('extensions').explicit(3).seqof($881ee9573daa1825$var$Extension).optional());
});
var $881ee9573daa1825$var$X509Certificate = $g3TdU.define('X509Certificate', function() {
    this.seq().obj(this.key('tbsCertificate').use($881ee9573daa1825$var$TBSCertificate), this.key('signatureAlgorithm').use($881ee9573daa1825$var$AlgorithmIdentifier), this.key('signatureValue').bitstr());
});
module.exports = $881ee9573daa1825$var$X509Certificate;

});

parcelRegister("3xUEM", function(module, exports) {

var $ekOVf = parcelRequire("ekOVf");
var $295067031abb1bb8$require$Buffer = $ekOVf.Buffer;

var $4maog = parcelRequire("4maog");

var $huXFj = parcelRequire("huXFj");
module.exports = function createECDH(curve) {
    return new $295067031abb1bb8$var$ECDH(curve);
};
var $295067031abb1bb8$var$aliases = {
    secp256k1: {
        name: 'secp256k1',
        byteLength: 32
    },
    secp224r1: {
        name: 'p224',
        byteLength: 28
    },
    prime256v1: {
        name: 'p256',
        byteLength: 32
    },
    prime192v1: {
        name: 'p192',
        byteLength: 24
    },
    ed25519: {
        name: 'ed25519',
        byteLength: 32
    },
    secp384r1: {
        name: 'p384',
        byteLength: 48
    },
    secp521r1: {
        name: 'p521',
        byteLength: 66
    }
};
$295067031abb1bb8$var$aliases.p224 = $295067031abb1bb8$var$aliases.secp224r1;
$295067031abb1bb8$var$aliases.p256 = $295067031abb1bb8$var$aliases.secp256r1 = $295067031abb1bb8$var$aliases.prime256v1;
$295067031abb1bb8$var$aliases.p192 = $295067031abb1bb8$var$aliases.secp192r1 = $295067031abb1bb8$var$aliases.prime192v1;
$295067031abb1bb8$var$aliases.p384 = $295067031abb1bb8$var$aliases.secp384r1;
$295067031abb1bb8$var$aliases.p521 = $295067031abb1bb8$var$aliases.secp521r1;
function $295067031abb1bb8$var$ECDH(curve) {
    this.curveType = $295067031abb1bb8$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $4maog.ec(this.curveType.name) // eslint-disable-line new-cap
    ;
    this.keys = void 0;
}
$295067031abb1bb8$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$295067031abb1bb8$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || 'utf8';
    if (!$295067031abb1bb8$require$Buffer.isBuffer(other)) other = new $295067031abb1bb8$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $295067031abb1bb8$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$295067031abb1bb8$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === 'compressed', true);
    if (format === 'hybrid') {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $295067031abb1bb8$var$formatReturnValue(key, enc);
};
$295067031abb1bb8$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $295067031abb1bb8$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$295067031abb1bb8$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || 'utf8';
    if (!$295067031abb1bb8$require$Buffer.isBuffer(pub)) pub = new $295067031abb1bb8$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$295067031abb1bb8$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || 'utf8';
    if (!$295067031abb1bb8$require$Buffer.isBuffer(priv)) priv = new $295067031abb1bb8$require$Buffer(priv, enc);
    var _priv = new $huXFj(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function $295067031abb1bb8$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $295067031abb1bb8$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $295067031abb1bb8$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $295067031abb1bb8$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});
parcelRegister("4maog", function(module, exports) {
'use strict';
var $32c146cac5be1d3e$var$elliptic = module.exports;

$32c146cac5be1d3e$var$elliptic.version = (parcelRequire("3biSQ")).version;

$32c146cac5be1d3e$var$elliptic.utils = (parcelRequire("iuAiA"));

$32c146cac5be1d3e$var$elliptic.rand = (parcelRequire("5nNgF"));

$32c146cac5be1d3e$var$elliptic.curve = (parcelRequire("e8yQ1"));

$32c146cac5be1d3e$var$elliptic.curves = (parcelRequire("ecRVR"));

// Protocols
$32c146cac5be1d3e$var$elliptic.ec = (parcelRequire("fStnO"));

$32c146cac5be1d3e$var$elliptic.eddsa = (parcelRequire("kB2SE"));

});


parcelRegister("lI3ev", function(module, exports) {

var $juAy9 = parcelRequire("juAy9");

var $7kZ78 = parcelRequire("7kZ78");

var $lDOK8 = parcelRequire("lDOK8");

var $gYDlp = parcelRequire("gYDlp");

var $JEKaf = parcelRequire("JEKaf");

var $huXFj = parcelRequire("huXFj");

var $dQBT1 = parcelRequire("dQBT1");

var $jZOuj = parcelRequire("jZOuj");

var $4EeOM = parcelRequire("4EeOM");
var $fce0370bd88b28bf$require$Buffer = $4EeOM.Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $juAy9(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = $fce0370bd88b28bf$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $fce0370bd88b28bf$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $huXFj(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error('data too long for modulus');
    } else throw new Error('unknown padding');
    if (reverse) return $jZOuj(paddedMsg, key);
    else return $dQBT1(paddedMsg, key);
};
function $fce0370bd88b28bf$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $lDOK8('sha1').update($fce0370bd88b28bf$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error('message too long');
    var ps = $fce0370bd88b28bf$require$Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = $7kZ78(hLen);
    var maskedDb = $JEKaf($fce0370bd88b28bf$require$Buffer.concat([
        iHash,
        ps,
        $fce0370bd88b28bf$require$Buffer.alloc(1, 1),
        msg
    ], dblen), $gYDlp(seed, dblen));
    var maskedSeed = $JEKaf(seed, $gYDlp(maskedDb, hLen));
    return new $huXFj($fce0370bd88b28bf$require$Buffer.concat([
        $fce0370bd88b28bf$require$Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function $fce0370bd88b28bf$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error('message too long');
    var ps;
    if (reverse) ps = $fce0370bd88b28bf$require$Buffer.alloc(k - mLen - 3, 0xff);
    else ps = $fce0370bd88b28bf$var$nonZero(k - mLen - 3);
    return new $huXFj($fce0370bd88b28bf$require$Buffer.concat([
        $fce0370bd88b28bf$require$Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        $fce0370bd88b28bf$require$Buffer.alloc(1),
        msg
    ], k));
}
function $fce0370bd88b28bf$var$nonZero(len) {
    var out = $fce0370bd88b28bf$require$Buffer.allocUnsafe(len);
    var i = 0;
    var cache = $7kZ78(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $7kZ78(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});
parcelRegister("juAy9", function(module, exports) {
'use strict';

var $ixueO = parcelRequire("ixueO");

var $exlMW = parcelRequire("exlMW");

var $3tr8l = parcelRequire("3tr8l");

var $7qWsf = parcelRequire("7qWsf");

var $Hnr6T = parcelRequire("Hnr6T");

var $4EeOM = parcelRequire("4EeOM");
var $e30d2bb8b683c3fd$require$Buffer = $4EeOM.Buffer;
function $e30d2bb8b683c3fd$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $exlMW[data.algorithm.decrypt.cipher.algo.join('.')];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split('-')[1], 10) / 8;
    var key = $Hnr6T.pbkdf2Sync(password, salt, iters, keylen, 'sha1');
    var cipher = $7qWsf.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher['final']());
    return $e30d2bb8b683c3fd$require$Buffer.concat(out);
}
function $e30d2bb8b683c3fd$var$parseKeys(buffer) {
    var password;
    if (typeof buffer === 'object' && !$e30d2bb8b683c3fd$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === 'string') buffer = $e30d2bb8b683c3fd$require$Buffer.from(buffer);
    var stripped = $3tr8l(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case 'CERTIFICATE':
            ndata = $ixueO.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case 'PUBLIC KEY':
            if (!ndata) ndata = $ixueO.PublicKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $ixueO.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der');
                case '1.2.840.10045.2.1':
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: 'ec',
                        data: ndata
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.pub_key = $ixueO.DSAparam.decode(ndata.subjectPublicKey.data, 'der');
                    return {
                        type: 'dsa',
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'ENCRYPTED PRIVATE KEY':
            data = $ixueO.EncryptedPrivateKey.decode(data, 'der');
            data = $e30d2bb8b683c3fd$var$decrypt(data, password);
        // falls through
        case 'PRIVATE KEY':
            ndata = $ixueO.PrivateKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $ixueO.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der');
                case '1.2.840.10045.2.1':
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $ixueO.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.priv_key = $ixueO.DSAparam.decode(ndata.subjectPrivateKey, 'der');
                    return {
                        type: 'dsa',
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'RSA PUBLIC KEY':
            return $ixueO.RSAPublicKey.decode(data, 'der');
        case 'RSA PRIVATE KEY':
            return $ixueO.RSAPrivateKey.decode(data, 'der');
        case 'DSA PRIVATE KEY':
            return {
                type: 'dsa',
                params: $ixueO.DSAPrivateKey.decode(data, 'der')
            };
        case 'EC PRIVATE KEY':
            data = $ixueO.ECPrivateKey.decode(data, 'der');
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error('unknown key type ' + type);
    }
}
$e30d2bb8b683c3fd$var$parseKeys.signature = $ixueO.signature;
module.exports = $e30d2bb8b683c3fd$var$parseKeys;

});
parcelRegister("ixueO", function(module, exports) {
$parcel$export(module.exports, "certificate", () => $d7f2c3b4d7ff40db$export$c98397a6eb8d0678, (v) => $d7f2c3b4d7ff40db$export$c98397a6eb8d0678 = v);
$parcel$export(module.exports, "RSAPrivateKey", () => $d7f2c3b4d7ff40db$export$f4aab6816f64fa6b, (v) => $d7f2c3b4d7ff40db$export$f4aab6816f64fa6b = v);
$parcel$export(module.exports, "RSAPublicKey", () => $d7f2c3b4d7ff40db$export$4471f5c65d097c11, (v) => $d7f2c3b4d7ff40db$export$4471f5c65d097c11 = v);
$parcel$export(module.exports, "PublicKey", () => $d7f2c3b4d7ff40db$export$ca8b6604d6ce14de, (v) => $d7f2c3b4d7ff40db$export$ca8b6604d6ce14de = v);
$parcel$export(module.exports, "PrivateKey", () => $d7f2c3b4d7ff40db$export$8f54525b330fd87b, (v) => $d7f2c3b4d7ff40db$export$8f54525b330fd87b = v);
$parcel$export(module.exports, "EncryptedPrivateKey", () => $d7f2c3b4d7ff40db$export$23cd2842b44ca3e7, (v) => $d7f2c3b4d7ff40db$export$23cd2842b44ca3e7 = v);
$parcel$export(module.exports, "DSAPrivateKey", () => $d7f2c3b4d7ff40db$export$245c9aaa9f5ce4ce, (v) => $d7f2c3b4d7ff40db$export$245c9aaa9f5ce4ce = v);
$parcel$export(module.exports, "DSAparam", () => $d7f2c3b4d7ff40db$export$8ad762e3e6399afe, (v) => $d7f2c3b4d7ff40db$export$8ad762e3e6399afe = v);
$parcel$export(module.exports, "ECPrivateKey", () => $d7f2c3b4d7ff40db$export$32ef6f92e22c6ab0, (v) => $d7f2c3b4d7ff40db$export$32ef6f92e22c6ab0 = v);
$parcel$export(module.exports, "signature", () => $d7f2c3b4d7ff40db$export$c9cd164b539ebb63, (v) => $d7f2c3b4d7ff40db$export$c9cd164b539ebb63 = v);
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $d7f2c3b4d7ff40db$export$c98397a6eb8d0678;
var $d7f2c3b4d7ff40db$export$f4aab6816f64fa6b;
var $d7f2c3b4d7ff40db$export$4471f5c65d097c11;
var $d7f2c3b4d7ff40db$export$ca8b6604d6ce14de;
var $d7f2c3b4d7ff40db$export$8f54525b330fd87b;
var $d7f2c3b4d7ff40db$export$23cd2842b44ca3e7;
var $d7f2c3b4d7ff40db$export$245c9aaa9f5ce4ce;
var $d7f2c3b4d7ff40db$export$8ad762e3e6399afe;
var $d7f2c3b4d7ff40db$export$32ef6f92e22c6ab0;
var $d7f2c3b4d7ff40db$export$c9cd164b539ebb63;
'use strict';

var $g3TdU = parcelRequire("g3TdU");

$d7f2c3b4d7ff40db$export$c98397a6eb8d0678 = (parcelRequire("bGzbE"));
var $d7f2c3b4d7ff40db$var$RSAPrivateKey = $g3TdU.define('RSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('modulus')['int'](), this.key('publicExponent')['int'](), this.key('privateExponent')['int'](), this.key('prime1')['int'](), this.key('prime2')['int'](), this.key('exponent1')['int'](), this.key('exponent2')['int'](), this.key('coefficient')['int']());
});
$d7f2c3b4d7ff40db$export$f4aab6816f64fa6b = $d7f2c3b4d7ff40db$var$RSAPrivateKey;
var $d7f2c3b4d7ff40db$var$RSAPublicKey = $g3TdU.define('RSAPublicKey', function() {
    this.seq().obj(this.key('modulus')['int'](), this.key('publicExponent')['int']());
});
$d7f2c3b4d7ff40db$export$4471f5c65d097c11 = $d7f2c3b4d7ff40db$var$RSAPublicKey;
var $d7f2c3b4d7ff40db$var$AlgorithmIdentifier = $g3TdU.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('none').null_().optional(), this.key('curve').objid().optional(), this.key('params').seq().obj(this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int']()).optional());
});
var $d7f2c3b4d7ff40db$var$PublicKey = $g3TdU.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($d7f2c3b4d7ff40db$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
$d7f2c3b4d7ff40db$export$ca8b6604d6ce14de = $d7f2c3b4d7ff40db$var$PublicKey;
var $d7f2c3b4d7ff40db$var$PrivateKeyInfo = $g3TdU.define('PrivateKeyInfo', function() {
    this.seq().obj(this.key('version')['int'](), this.key('algorithm').use($d7f2c3b4d7ff40db$var$AlgorithmIdentifier), this.key('subjectPrivateKey').octstr());
});
$d7f2c3b4d7ff40db$export$8f54525b330fd87b = $d7f2c3b4d7ff40db$var$PrivateKeyInfo;
var $d7f2c3b4d7ff40db$var$EncryptedPrivateKeyInfo = $g3TdU.define('EncryptedPrivateKeyInfo', function() {
    this.seq().obj(this.key('algorithm').seq().obj(this.key('id').objid(), this.key('decrypt').seq().obj(this.key('kde').seq().obj(this.key('id').objid(), this.key('kdeparams').seq().obj(this.key('salt').octstr(), this.key('iters')['int']())), this.key('cipher').seq().obj(this.key('algo').objid(), this.key('iv').octstr()))), this.key('subjectPrivateKey').octstr());
});
$d7f2c3b4d7ff40db$export$23cd2842b44ca3e7 = $d7f2c3b4d7ff40db$var$EncryptedPrivateKeyInfo;
var $d7f2c3b4d7ff40db$var$DSAPrivateKey = $g3TdU.define('DSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int'](), this.key('pub_key')['int'](), this.key('priv_key')['int']());
});
$d7f2c3b4d7ff40db$export$245c9aaa9f5ce4ce = $d7f2c3b4d7ff40db$var$DSAPrivateKey;
$d7f2c3b4d7ff40db$export$8ad762e3e6399afe = $g3TdU.define('DSAparam', function() {
    this['int']();
});
var $d7f2c3b4d7ff40db$var$ECParameters = $g3TdU.define('ECParameters', function() {
    this.choice({
        namedCurve: this.objid()
    });
});
var $d7f2c3b4d7ff40db$var$ECPrivateKey = $g3TdU.define('ECPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('privateKey').octstr(), this.key('parameters').optional().explicit(0).use($d7f2c3b4d7ff40db$var$ECParameters), this.key('publicKey').optional().explicit(1).bitstr());
});
$d7f2c3b4d7ff40db$export$32ef6f92e22c6ab0 = $d7f2c3b4d7ff40db$var$ECPrivateKey;
$d7f2c3b4d7ff40db$export$c9cd164b539ebb63 = $g3TdU.define('signature', function() {
    this.seq().obj(this.key('r')['int'](), this.key('s')['int']());
});

});

parcelRegister("exlMW", function(module, exports) {
module.exports = JSON.parse("{\"2.16.840.1.101.3.4.1.1\":\"aes-128-ecb\",\"2.16.840.1.101.3.4.1.2\":\"aes-128-cbc\",\"2.16.840.1.101.3.4.1.3\":\"aes-128-ofb\",\"2.16.840.1.101.3.4.1.4\":\"aes-128-cfb\",\"2.16.840.1.101.3.4.1.21\":\"aes-192-ecb\",\"2.16.840.1.101.3.4.1.22\":\"aes-192-cbc\",\"2.16.840.1.101.3.4.1.23\":\"aes-192-ofb\",\"2.16.840.1.101.3.4.1.24\":\"aes-192-cfb\",\"2.16.840.1.101.3.4.1.41\":\"aes-256-ecb\",\"2.16.840.1.101.3.4.1.42\":\"aes-256-cbc\",\"2.16.840.1.101.3.4.1.43\":\"aes-256-ofb\",\"2.16.840.1.101.3.4.1.44\":\"aes-256-cfb\"}");

});

parcelRegister("3tr8l", function(module, exports) {
'use strict';
// adapted from https://github.com/apatil/pemstrip
var $287920b83d2b9737$var$findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var $287920b83d2b9737$var$startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var $287920b83d2b9737$var$fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;

var $jCkZB = parcelRequire("jCkZB");

var $7qWsf = parcelRequire("7qWsf");

var $4EeOM = parcelRequire("4EeOM");
var $287920b83d2b9737$require$Buffer = $4EeOM.Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($287920b83d2b9737$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($287920b83d2b9737$var$fullRegex);
        decrypted = $287920b83d2b9737$require$Buffer.from(match2[2].replace(/[\r\n]/g, ''), 'base64');
    } else {
        var suite = 'aes' + match[1];
        var iv = $287920b83d2b9737$require$Buffer.from(match[2], 'hex');
        var cipherText = $287920b83d2b9737$require$Buffer.from(match[3].replace(/[\r\n]/g, ''), 'base64');
        var cipherKey = $jCkZB(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $7qWsf.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher['final']());
        decrypted = $287920b83d2b9737$require$Buffer.concat(out);
    }
    var tag = key.match($287920b83d2b9737$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});
parcelRegister("jCkZB", function(module, exports) {

var $4EeOM = parcelRequire("4EeOM");
var $e481d99e7cbc3c76$require$Buffer = $4EeOM.Buffer;

var $ioicd = parcelRequire("ioicd");
/* eslint-disable camelcase */ function $e481d99e7cbc3c76$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$e481d99e7cbc3c76$require$Buffer.isBuffer(password)) password = $e481d99e7cbc3c76$require$Buffer.from(password, 'binary');
    if (salt) {
        if (!$e481d99e7cbc3c76$require$Buffer.isBuffer(salt)) salt = $e481d99e7cbc3c76$require$Buffer.from(salt, 'binary');
        if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length');
    }
    var keyLen = keyBits / 8;
    var key = $e481d99e7cbc3c76$require$Buffer.alloc(keyLen);
    var iv = $e481d99e7cbc3c76$require$Buffer.alloc(ivLen || 0);
    var tmp = $e481d99e7cbc3c76$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $ioicd();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $e481d99e7cbc3c76$var$EVP_BytesToKey;

});

parcelRegister("7qWsf", function(module, exports) {
$parcel$export(module.exports, "createCipheriv", () => $56984dfbfdf2ef61$export$2f64596b8cbf08b4, (v) => $56984dfbfdf2ef61$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createDecipheriv", () => $56984dfbfdf2ef61$export$36b6d6ef312eab39, (v) => $56984dfbfdf2ef61$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "getCiphers", () => $56984dfbfdf2ef61$export$58a258485f1e49f6, (v) => $56984dfbfdf2ef61$export$58a258485f1e49f6 = v);
var $56984dfbfdf2ef61$export$bdd223f16383713e;
var $56984dfbfdf2ef61$export$26e5786e8ac8e530;
var $56984dfbfdf2ef61$export$2f64596b8cbf08b4;
var $56984dfbfdf2ef61$export$20533d26f07f1ee0;
var $56984dfbfdf2ef61$export$12ada9414fbc594c;
var $56984dfbfdf2ef61$export$2ce6d8d0e8b04e1a;
var $56984dfbfdf2ef61$export$36b6d6ef312eab39;
var $56984dfbfdf2ef61$export$f5e7e39d57cd9700;
var $56984dfbfdf2ef61$export$dedd8dc3dc62b370;
var $56984dfbfdf2ef61$export$58a258485f1e49f6;

var $aFtIy = parcelRequire("aFtIy");

var $bmVIT = parcelRequire("bmVIT");

var $hmRQI = parcelRequire("hmRQI");
function $56984dfbfdf2ef61$var$getCiphers() {
    return Object.keys($hmRQI);
}
$56984dfbfdf2ef61$export$bdd223f16383713e = $56984dfbfdf2ef61$export$26e5786e8ac8e530 = $aFtIy.createCipher;
$56984dfbfdf2ef61$export$2f64596b8cbf08b4 = $56984dfbfdf2ef61$export$20533d26f07f1ee0 = $aFtIy.createCipheriv;
$56984dfbfdf2ef61$export$12ada9414fbc594c = $56984dfbfdf2ef61$export$2ce6d8d0e8b04e1a = $bmVIT.createDecipher;
$56984dfbfdf2ef61$export$36b6d6ef312eab39 = $56984dfbfdf2ef61$export$f5e7e39d57cd9700 = $bmVIT.createDecipheriv;
$56984dfbfdf2ef61$export$dedd8dc3dc62b370 = $56984dfbfdf2ef61$export$58a258485f1e49f6 = $56984dfbfdf2ef61$var$getCiphers;

});
parcelRegister("aFtIy", function(module, exports) {
$parcel$export(module.exports, "createCipheriv", () => $7c44c90050178381$export$2f64596b8cbf08b4, (v) => $7c44c90050178381$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createCipher", () => $7c44c90050178381$export$bdd223f16383713e, (v) => $7c44c90050178381$export$bdd223f16383713e = v);
var $7c44c90050178381$export$2f64596b8cbf08b4;
var $7c44c90050178381$export$bdd223f16383713e;

var $dTcQB = parcelRequire("dTcQB");

var $86q28 = parcelRequire("86q28");

var $4EeOM = parcelRequire("4EeOM");
var $7c44c90050178381$require$Buffer = $4EeOM.Buffer;

var $kGHqj = parcelRequire("kGHqj");

var $hCwwr = parcelRequire("hCwwr");

var $6UikD = parcelRequire("6UikD");

var $jCkZB = parcelRequire("jCkZB");

var $ktJSc = parcelRequire("ktJSc");
function $7c44c90050178381$var$Cipher(mode, key, iv) {
    $hCwwr.call(this);
    this._cache = new $7c44c90050178381$var$Splitter();
    this._cipher = new $6UikD.AES(key);
    this._prev = $7c44c90050178381$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$ktJSc($7c44c90050178381$var$Cipher, $hCwwr);
$7c44c90050178381$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $7c44c90050178381$require$Buffer.concat(out);
};
var $7c44c90050178381$var$PADDING = $7c44c90050178381$require$Buffer.alloc(16, 0x10);
$7c44c90050178381$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($7c44c90050178381$var$PADDING)) {
        this._cipher.scrub();
        throw new Error('data not multiple of block length');
    }
};
$7c44c90050178381$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $7c44c90050178381$var$Splitter() {
    this.cache = $7c44c90050178381$require$Buffer.allocUnsafe(0);
}
$7c44c90050178381$var$Splitter.prototype.add = function(data) {
    this.cache = $7c44c90050178381$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$7c44c90050178381$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$7c44c90050178381$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $7c44c90050178381$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $7c44c90050178381$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $7c44c90050178381$var$createCipheriv(suite, password, iv) {
    var config = $dTcQB[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof password === 'string') password = $7c44c90050178381$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (typeof iv === 'string') iv = $7c44c90050178381$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (config.type === 'stream') return new $kGHqj(config.module, password, iv);
    else if (config.type === 'auth') return new $86q28(config.module, password, iv);
    return new $7c44c90050178381$var$Cipher(config.module, password, iv);
}
function $7c44c90050178381$var$createCipher(suite, password) {
    var config = $dTcQB[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $jCkZB(password, false, config.key, config.iv);
    return $7c44c90050178381$var$createCipheriv(suite, keys.key, keys.iv);
}
$7c44c90050178381$export$2f64596b8cbf08b4 = $7c44c90050178381$var$createCipheriv;
$7c44c90050178381$export$bdd223f16383713e = $7c44c90050178381$var$createCipher;

});
parcelRegister("dTcQB", function(module, exports) {








var $a1ca60ab3ef8e596$var$modeModules = {
    ECB: (parcelRequire("iK7Mn")),
    CBC: (parcelRequire("eLY8q")),
    CFB: (parcelRequire("heQsF")),
    CFB8: (parcelRequire("2kPDL")),
    CFB1: (parcelRequire("l2KYy")),
    OFB: (parcelRequire("cYEid")),
    CTR: (parcelRequire("bJ4Ry")),
    GCM: (parcelRequire("bJ4Ry"))
};

var $hmRQI = parcelRequire("hmRQI");
for(var $a1ca60ab3ef8e596$var$key in $hmRQI)$hmRQI[$a1ca60ab3ef8e596$var$key].module = $a1ca60ab3ef8e596$var$modeModules[$hmRQI[$a1ca60ab3ef8e596$var$key].mode];
module.exports = $hmRQI;

});
parcelRegister("hmRQI", function(module, exports) {
module.exports = JSON.parse("{\"aes-128-ecb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-192-ecb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-256-ecb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-128-cbc\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-192-cbc\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-256-cbc\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes128\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes192\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes256\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-128-cfb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-192-cfb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-256-cfb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-128-cfb8\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-192-cfb8\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-256-cfb8\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-128-cfb1\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-192-cfb1\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-256-cfb1\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-128-ofb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-192-ofb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-256-ofb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-128-ctr\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-192-ctr\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-256-ctr\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-128-gcm\":{\"cipher\":\"AES\",\"key\":128,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-192-gcm\":{\"cipher\":\"AES\",\"key\":192,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-256-gcm\":{\"cipher\":\"AES\",\"key\":256,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"}}");

});


parcelRegister("86q28", function(module, exports) {

var $6UikD = parcelRequire("6UikD");

var $4EeOM = parcelRequire("4EeOM");
var $5e6313fce136b01f$require$Buffer = $4EeOM.Buffer;

var $hCwwr = parcelRequire("hCwwr");

var $ktJSc = parcelRequire("ktJSc");

var $i7B4d = parcelRequire("i7B4d");

var $ebojG = parcelRequire("ebojG");

var $fRGpR = parcelRequire("fRGpR");
function $5e6313fce136b01f$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $5e6313fce136b01f$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $5e6313fce136b01f$require$Buffer.concat([
            iv,
            $5e6313fce136b01f$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $5e6313fce136b01f$require$Buffer.concat([
            iv,
            $5e6313fce136b01f$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $i7B4d(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($5e6313fce136b01f$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($5e6313fce136b01f$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $5e6313fce136b01f$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $5e6313fce136b01f$require$Buffer.from(self._finID);
    $fRGpR(out);
    return out;
}
function $5e6313fce136b01f$var$StreamCipher(mode, key, iv, decrypt) {
    $hCwwr.call(this);
    var h = $5e6313fce136b01f$require$Buffer.alloc(4, 0);
    this._cipher = new $6UikD.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $i7B4d(ck);
    iv = $5e6313fce136b01f$var$calcIv(this, iv, ck);
    this._prev = $5e6313fce136b01f$require$Buffer.from(iv);
    this._cache = $5e6313fce136b01f$require$Buffer.allocUnsafe(0);
    this._secCache = $5e6313fce136b01f$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$ktJSc($5e6313fce136b01f$var$StreamCipher, $hCwwr);
$5e6313fce136b01f$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $5e6313fce136b01f$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$5e6313fce136b01f$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data');
    var tag = $ebojG(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $5e6313fce136b01f$var$xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data');
    this._authTag = tag;
    this._cipher.scrub();
};
$5e6313fce136b01f$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$5e6313fce136b01f$require$Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state');
    return this._authTag;
};
$5e6313fce136b01f$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state');
    this._authTag = tag;
};
$5e6313fce136b01f$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error('Attempting to set AAD in unsupported state');
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $5e6313fce136b01f$var$StreamCipher;

});
parcelRegister("6UikD", function(module, exports) {
$parcel$export(module.exports, "AES", () => $50763160aea252cd$export$b80fbe1c3a2b92b5, (v) => $50763160aea252cd$export$b80fbe1c3a2b92b5 = v);
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $50763160aea252cd$export$b80fbe1c3a2b92b5;

var $4EeOM = parcelRequire("4EeOM");
var $50763160aea252cd$require$Buffer = $4EeOM.Buffer;
function $50763160aea252cd$var$asUInt32Array(buf) {
    if (!$50763160aea252cd$require$Buffer.isBuffer(buf)) buf = $50763160aea252cd$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $50763160aea252cd$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $50763160aea252cd$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $50763160aea252cd$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $50763160aea252cd$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $50763160aea252cd$var$AES(key) {
    this._key = $50763160aea252cd$var$asUInt32Array(key);
    this._reset();
}
$50763160aea252cd$var$AES.blockSize = 16;
$50763160aea252cd$var$AES.keySize = 32;
$50763160aea252cd$var$AES.prototype.blockSize = $50763160aea252cd$var$AES.blockSize;
$50763160aea252cd$var$AES.prototype.keySize = $50763160aea252cd$var$AES.keySize;
$50763160aea252cd$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $50763160aea252cd$var$G.SBOX[t >>> 24] << 24 | $50763160aea252cd$var$G.SBOX[t >>> 16 & 0xff] << 16 | $50763160aea252cd$var$G.SBOX[t >>> 8 & 0xff] << 8 | $50763160aea252cd$var$G.SBOX[t & 0xff];
            t ^= $50763160aea252cd$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $50763160aea252cd$var$G.SBOX[t >>> 24] << 24 | $50763160aea252cd$var$G.SBOX[t >>> 16 & 0xff] << 16 | $50763160aea252cd$var$G.SBOX[t >>> 8 & 0xff] << 8 | $50763160aea252cd$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $50763160aea252cd$var$G.INV_SUB_MIX[0][$50763160aea252cd$var$G.SBOX[tt >>> 24]] ^ $50763160aea252cd$var$G.INV_SUB_MIX[1][$50763160aea252cd$var$G.SBOX[tt >>> 16 & 0xff]] ^ $50763160aea252cd$var$G.INV_SUB_MIX[2][$50763160aea252cd$var$G.SBOX[tt >>> 8 & 0xff]] ^ $50763160aea252cd$var$G.INV_SUB_MIX[3][$50763160aea252cd$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$50763160aea252cd$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $50763160aea252cd$var$asUInt32Array(M);
    return $50763160aea252cd$var$cryptBlock(M, this._keySchedule, $50763160aea252cd$var$G.SUB_MIX, $50763160aea252cd$var$G.SBOX, this._nRounds);
};
$50763160aea252cd$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $50763160aea252cd$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$50763160aea252cd$var$AES.prototype.decryptBlock = function(M) {
    M = $50763160aea252cd$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $50763160aea252cd$var$cryptBlock(M, this._invKeySchedule, $50763160aea252cd$var$G.INV_SUB_MIX, $50763160aea252cd$var$G.INV_SBOX, this._nRounds);
    var buf = $50763160aea252cd$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$50763160aea252cd$var$AES.prototype.scrub = function() {
    $50763160aea252cd$var$scrubVec(this._keySchedule);
    $50763160aea252cd$var$scrubVec(this._invKeySchedule);
    $50763160aea252cd$var$scrubVec(this._key);
};
$50763160aea252cd$export$b80fbe1c3a2b92b5 = $50763160aea252cd$var$AES;

});

parcelRegister("i7B4d", function(module, exports) {

var $4EeOM = parcelRequire("4EeOM");
var $d315a22d11fc5f5c$require$Buffer = $4EeOM.Buffer;
var $d315a22d11fc5f5c$var$ZEROES = $d315a22d11fc5f5c$require$Buffer.alloc(16, 0);
function $d315a22d11fc5f5c$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $d315a22d11fc5f5c$var$fromArray(out) {
    var buf = $d315a22d11fc5f5c$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $d315a22d11fc5f5c$var$GHASH(key) {
    this.h = key;
    this.state = $d315a22d11fc5f5c$require$Buffer.alloc(16, 0);
    this.cache = $d315a22d11fc5f5c$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$d315a22d11fc5f5c$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$d315a22d11fc5f5c$var$GHASH.prototype._multiply = function() {
    var Vi = $d315a22d11fc5f5c$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $d315a22d11fc5f5c$var$fromArray(Zi);
};
$d315a22d11fc5f5c$var$GHASH.prototype.update = function(buf) {
    this.cache = $d315a22d11fc5f5c$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$d315a22d11fc5f5c$var$GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash($d315a22d11fc5f5c$require$Buffer.concat([
        this.cache,
        $d315a22d11fc5f5c$var$ZEROES
    ], 16));
    this.ghash($d315a22d11fc5f5c$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $d315a22d11fc5f5c$var$GHASH;

});


parcelRegister("kGHqj", function(module, exports) {

var $6UikD = parcelRequire("6UikD");

var $4EeOM = parcelRequire("4EeOM");
var $f0f969e0a412383e$require$Buffer = $4EeOM.Buffer;

var $hCwwr = parcelRequire("hCwwr");

var $ktJSc = parcelRequire("ktJSc");
function $f0f969e0a412383e$var$StreamCipher(mode, key, iv, decrypt) {
    $hCwwr.call(this);
    this._cipher = new $6UikD.AES(key);
    this._prev = $f0f969e0a412383e$require$Buffer.from(iv);
    this._cache = $f0f969e0a412383e$require$Buffer.allocUnsafe(0);
    this._secCache = $f0f969e0a412383e$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$ktJSc($f0f969e0a412383e$var$StreamCipher, $hCwwr);
$f0f969e0a412383e$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$f0f969e0a412383e$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $f0f969e0a412383e$var$StreamCipher;

});


parcelRegister("bmVIT", function(module, exports) {
$parcel$export(module.exports, "createDecipher", () => $846e86681f888243$export$12ada9414fbc594c, (v) => $846e86681f888243$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "createDecipheriv", () => $846e86681f888243$export$36b6d6ef312eab39, (v) => $846e86681f888243$export$36b6d6ef312eab39 = v);
var $846e86681f888243$export$12ada9414fbc594c;
var $846e86681f888243$export$36b6d6ef312eab39;

var $86q28 = parcelRequire("86q28");

var $4EeOM = parcelRequire("4EeOM");
var $846e86681f888243$require$Buffer = $4EeOM.Buffer;

var $dTcQB = parcelRequire("dTcQB");

var $kGHqj = parcelRequire("kGHqj");

var $hCwwr = parcelRequire("hCwwr");

var $6UikD = parcelRequire("6UikD");

var $jCkZB = parcelRequire("jCkZB");

var $ktJSc = parcelRequire("ktJSc");
function $846e86681f888243$var$Decipher(mode, key, iv) {
    $hCwwr.call(this);
    this._cache = new $846e86681f888243$var$Splitter();
    this._last = void 0;
    this._cipher = new $6UikD.AES(key);
    this._prev = $846e86681f888243$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$ktJSc($846e86681f888243$var$Decipher, $hCwwr);
$846e86681f888243$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $846e86681f888243$require$Buffer.concat(out);
};
$846e86681f888243$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $846e86681f888243$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error('data not multiple of block length');
};
$846e86681f888243$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $846e86681f888243$var$Splitter() {
    this.cache = $846e86681f888243$require$Buffer.allocUnsafe(0);
}
$846e86681f888243$var$Splitter.prototype.add = function(data) {
    this.cache = $846e86681f888243$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$846e86681f888243$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$846e86681f888243$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $846e86681f888243$var$unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error('unable to decrypt data');
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error('unable to decrypt data');
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $846e86681f888243$var$createDecipheriv(suite, password, iv) {
    var config = $dTcQB[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof iv === 'string') iv = $846e86681f888243$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (typeof password === 'string') password = $846e86681f888243$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (config.type === 'stream') return new $kGHqj(config.module, password, iv, true);
    else if (config.type === 'auth') return new $86q28(config.module, password, iv, true);
    return new $846e86681f888243$var$Decipher(config.module, password, iv);
}
function $846e86681f888243$var$createDecipher(suite, password) {
    var config = $dTcQB[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $jCkZB(password, false, config.key, config.iv);
    return $846e86681f888243$var$createDecipheriv(suite, keys.key, keys.iv);
}
$846e86681f888243$export$12ada9414fbc594c = $846e86681f888243$var$createDecipher;
$846e86681f888243$export$36b6d6ef312eab39 = $846e86681f888243$var$createDecipheriv;

});



parcelRegister("Hnr6T", function(module, exports) {
$parcel$export(module.exports, "pbkdf2", () => $082632384724f9d0$export$448fa22aedc9dbca, (v) => $082632384724f9d0$export$448fa22aedc9dbca = v);
$parcel$export(module.exports, "pbkdf2Sync", () => $082632384724f9d0$export$b80c7ba289c8fa56, (v) => $082632384724f9d0$export$b80c7ba289c8fa56 = v);
var $082632384724f9d0$export$448fa22aedc9dbca;
var $082632384724f9d0$export$b80c7ba289c8fa56;
'use strict';

$082632384724f9d0$export$448fa22aedc9dbca = (parcelRequire("2JcPJ"));

$082632384724f9d0$export$b80c7ba289c8fa56 = (parcelRequire("8RJn9"));

});


parcelRegister("gYDlp", function(module, exports) {

var $lDOK8 = parcelRequire("lDOK8");

var $4EeOM = parcelRequire("4EeOM");
var $c5c0c4e4ade8b5fa$require$Buffer = $4EeOM.Buffer;
module.exports = function(seed, len) {
    var t = $c5c0c4e4ade8b5fa$require$Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = $c5c0c4e4ade8b5fa$var$i2ops(i++);
        t = $c5c0c4e4ade8b5fa$require$Buffer.concat([
            t,
            $lDOK8('sha1').update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $c5c0c4e4ade8b5fa$var$i2ops(c) {
    var out = $c5c0c4e4ade8b5fa$require$Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRegister("JEKaf", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRegister("dQBT1", function(module, exports) {

var $huXFj = parcelRequire("huXFj");

var $4EeOM = parcelRequire("4EeOM");
var $a14d852af6f3c744$require$Buffer = $4EeOM.Buffer;
function $a14d852af6f3c744$var$withPublic(paddedMsg, key) {
    return $a14d852af6f3c744$require$Buffer.from(paddedMsg.toRed($huXFj.mont(key.modulus)).redPow(new $huXFj(key.publicExponent)).fromRed().toArray());
}
module.exports = $a14d852af6f3c744$var$withPublic;

});

parcelRegister("jZOuj", function(module, exports) {
'use strict';

var $5w8q8 = parcelRequire("5w8q8");

var $7kZ78 = parcelRequire("7kZ78");

var $4EeOM = parcelRequire("4EeOM");
var $e8eae0adc7f6df92$require$Buffer = $4EeOM.Buffer;
function $e8eae0adc7f6df92$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new $5w8q8($7kZ78(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function $e8eae0adc7f6df92$var$blind(priv) {
    var r = $e8eae0adc7f6df92$var$getr(priv);
    var blinder = r.toRed($5w8q8.mont(priv.modulus)).redPow(new $5w8q8(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $e8eae0adc7f6df92$var$crt(msg, priv) {
    var blinds = $e8eae0adc7f6df92$var$blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new $5w8q8(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($5w8q8.mont(priv.prime1));
    var c2 = blinded.toRed($5w8q8.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike($e8eae0adc7f6df92$require$Buffer, 'be', len);
}
$e8eae0adc7f6df92$var$crt.getr = $e8eae0adc7f6df92$var$getr;
module.exports = $e8eae0adc7f6df92$var$crt;

});


parcelRegister("46RSZ", function(module, exports) {

var $juAy9 = parcelRequire("juAy9");

var $gYDlp = parcelRequire("gYDlp");

var $JEKaf = parcelRequire("JEKaf");

var $huXFj = parcelRequire("huXFj");

var $jZOuj = parcelRequire("jZOuj");

var $lDOK8 = parcelRequire("lDOK8");

var $dQBT1 = parcelRequire("dQBT1");

var $4EeOM = parcelRequire("4EeOM");
var $2fe1859ac754c7b7$require$Buffer = $4EeOM.Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $juAy9(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $huXFj(enc).cmp(key.modulus) >= 0) throw new Error('decryption error');
    var msg;
    if (reverse) msg = $dQBT1(new $huXFj(enc), key);
    else msg = $jZOuj(enc, key);
    var zBuffer = $2fe1859ac754c7b7$require$Buffer.alloc(k - msg.length);
    msg = $2fe1859ac754c7b7$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $2fe1859ac754c7b7$var$oaep(key, msg);
    else if (padding === 1) return $2fe1859ac754c7b7$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error('unknown padding');
};
function $2fe1859ac754c7b7$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = $lDOK8('sha1').update($2fe1859ac754c7b7$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error('decryption error');
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $JEKaf(maskedSeed, $gYDlp(maskedDb, hLen));
    var db = $JEKaf(maskedDb, $gYDlp(seed, k - hLen - 1));
    if ($2fe1859ac754c7b7$var$compare(iHash, db.slice(0, hLen))) throw new Error('decryption error');
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error('decryption error');
    return db.slice(i);
}
function $2fe1859ac754c7b7$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString('hex') !== '0002' && !reverse || p1.toString('hex') !== '0001' && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error('decryption error');
    return msg.slice(i);
}
function $2fe1859ac754c7b7$var$compare(a, b) {
    a = $2fe1859ac754c7b7$require$Buffer.from(a);
    b = $2fe1859ac754c7b7$require$Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});

$parcel$global.rwr("kpJNO", () => { 
var $gqzfn = parcelRequire("gqzfn");
var $562ef484027f8b93$exports = {};
'use strict';
function $562ef484027f8b93$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($562ef484027f8b93$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$562ef484027f8b93$var$checkDCE();

$562ef484027f8b93$exports = (parcelRequire("lCoDQ"));



var $gqzfn = parcelRequire("gqzfn");

var $gqzfn = parcelRequire("gqzfn");
const $15f344f9545a569e$export$a7b0697657ed8bd0 = /*#__PURE__*/ (0, $gqzfn.createContext)({
    start () {},
    succeed () {},
    fail () {},
    abort () {},
    stopOnError () {},
    subscribe () {
        return ()=>{};
    },
    getExperienceState () {
        return null;
    },
    updateAttributes () {},
    attachDebugPoint () {}
});
function $15f344f9545a569e$export$f88dde183f4d31cb(WrappedComponent) {
    const withExperienceTracker = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement($15f344f9545a569e$export$a7b0697657ed8bd0.Consumer, null, (value)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement(WrappedComponent, {
                ...props,
                experienceTracker: value
            }));
    withExperienceTracker.displayName = `withExperienceTracker(${WrappedComponent.displayName || WrappedComponent.name})`;
    return withExperienceTracker;
}



var $34Zxt = parcelRequire("34Zxt");
var $c29b43bb0df96673$exports = {};
var $8620f91002fd03c7$exports = {};
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $8620f91002fd03c7$var$getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
if ($8620f91002fd03c7$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $8620f91002fd03c7$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    $8620f91002fd03c7$exports = function whatwgRNG() {
        $8620f91002fd03c7$var$getRandomValues($8620f91002fd03c7$var$rnds8);
        return $8620f91002fd03c7$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $8620f91002fd03c7$var$rnds = new Array(16);
    $8620f91002fd03c7$exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $8620f91002fd03c7$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $8620f91002fd03c7$var$rnds;
    };
}


var $0eb3fc9f8addfeea$exports = {};
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $0eb3fc9f8addfeea$var$byteToHex = [];
for(var $0eb3fc9f8addfeea$var$i = 0; $0eb3fc9f8addfeea$var$i < 256; ++$0eb3fc9f8addfeea$var$i)$0eb3fc9f8addfeea$var$byteToHex[$0eb3fc9f8addfeea$var$i] = ($0eb3fc9f8addfeea$var$i + 0x100).toString(16).substr(1);
function $0eb3fc9f8addfeea$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $0eb3fc9f8addfeea$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
$0eb3fc9f8addfeea$exports = $0eb3fc9f8addfeea$var$bytesToUuid;


function $c29b43bb0df96673$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $8620f91002fd03c7$exports)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $0eb3fc9f8addfeea$exports(rnds);
}
$c29b43bb0df96673$exports = $c29b43bb0df96673$var$v4;


const $613e0f6ab39bd308$export$9c05e7ef9f2c8895 = (event)=>({
        // Events should match the schema defined here:
        // https://hello.atlassian.net/wiki/spaces/BIZOPS/pages/387788554/Analytics+Event+Schema+for+SLA
        source: 'ui',
        actionSubject: 'ui',
        action: event.action,
        eventType: 'operational',
        attributes: $613e0f6ab39bd308$var$createExperienceTrackerAnalyticsAttributes(event)
    });
function $613e0f6ab39bd308$var$createExperienceTrackerAnalyticsAttributes(event) {
    const { action: action, name: name, id: id, attributes: experienceAttributes, ...rest } = event;
    const attributes = {
        ...experienceAttributes,
        ...rest,
        task: name,
        taskId: id
    };
    if (attributes.error) {
        let error;
        if (typeof attributes.error === 'string') error = new Error(attributes.error);
        else error = attributes.error;
        delete attributes.error;
        attributes.errorName = error.name;
        if (!attributes.traceId && error.traceId) attributes.traceId = error.traceId;
        attributes.errorMessage = error.message;
    }
    attributes.browserInfo = window.navigator.userAgent;
    // Matches the analytics-web-client's apdex event
    attributes.isActiveTab = document.visibilityState === 'visible';
    return attributes;
}


/**
 *  Data Services - Analytics Web Client for E-MAU
 *  url to the JIRA ticket (https://product-fabric.atlassian.net/browse/CFEA-16)
 *  source code (https://bitbucket.org/atlassian/analytics-web-client)
 */ // import uuid from 'uuid/v4';
var $466a4b1793cac1d8$exports = {};
var $146663b099b7c0bc$exports = {};
var $b1ff0dcf08c02bd4$exports = {};
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $b1ff0dcf08c02bd4$var$getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
if ($b1ff0dcf08c02bd4$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $b1ff0dcf08c02bd4$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    $b1ff0dcf08c02bd4$exports = function whatwgRNG() {
        $b1ff0dcf08c02bd4$var$getRandomValues($b1ff0dcf08c02bd4$var$rnds8);
        return $b1ff0dcf08c02bd4$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $b1ff0dcf08c02bd4$var$rnds = new Array(16);
    $b1ff0dcf08c02bd4$exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $b1ff0dcf08c02bd4$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $b1ff0dcf08c02bd4$var$rnds;
    };
}


var $98c87990cca01fa1$exports = {};
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $98c87990cca01fa1$var$byteToHex = [];
for(var $98c87990cca01fa1$var$i = 0; $98c87990cca01fa1$var$i < 256; ++$98c87990cca01fa1$var$i)$98c87990cca01fa1$var$byteToHex[$98c87990cca01fa1$var$i] = ($98c87990cca01fa1$var$i + 0x100).toString(16).substr(1);
function $98c87990cca01fa1$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $98c87990cca01fa1$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
$98c87990cca01fa1$exports = $98c87990cca01fa1$var$bytesToUuid;


// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $146663b099b7c0bc$var$_nodeId;
var $146663b099b7c0bc$var$_clockseq;
// Previous uuid creation time
var $146663b099b7c0bc$var$_lastMSecs = 0;
var $146663b099b7c0bc$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $146663b099b7c0bc$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $146663b099b7c0bc$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $146663b099b7c0bc$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $b1ff0dcf08c02bd4$exports();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $146663b099b7c0bc$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $146663b099b7c0bc$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $146663b099b7c0bc$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $146663b099b7c0bc$var$_lastMSecs + (nsecs - $146663b099b7c0bc$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $146663b099b7c0bc$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    $146663b099b7c0bc$var$_lastMSecs = msecs;
    $146663b099b7c0bc$var$_lastNSecs = nsecs;
    $146663b099b7c0bc$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $98c87990cca01fa1$exports(b);
}
$146663b099b7c0bc$exports = $146663b099b7c0bc$var$v1;


var $4a2ae143cdc90c61$exports = {};


function $4a2ae143cdc90c61$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $b1ff0dcf08c02bd4$exports)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $98c87990cca01fa1$exports(rnds);
}
$4a2ae143cdc90c61$exports = $4a2ae143cdc90c61$var$v4;


var $466a4b1793cac1d8$var$uuid = $4a2ae143cdc90c61$exports;
$466a4b1793cac1d8$var$uuid.v1 = $146663b099b7c0bc$exports;
$466a4b1793cac1d8$var$uuid.v4 = $4a2ae143cdc90c61$exports;
$466a4b1793cac1d8$exports = $466a4b1793cac1d8$var$uuid;


/**
 * This file converts between Base64 and Base 64 Encoding with URL and Filename Safe Alphabet,
 * the latter of which has URL-safe characters only (drops =, + and /).
 *
 * Why not use a library? The popular libs use Buffer to be able to
 * encode any data to base64. We don't need this capability, and it causes
 * Webpack to include 30KB of a Buffer polyfill.
 * Webpack's/UglifyJS's Tree Shaking seems to be unable to drop it.
 *
 * See: RFC 4648 section 5 (https://tools.ietf.org/html/rfc4648#section-5)
 */ function $a8c2f1a75f29f96f$export$3b91e21dac1023c6(base64) {
    if (base64 == null) return '';
    return String(base64).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}
function $a8c2f1a75f29f96f$export$47c5265a25535d02(base64url) {
    if (base64url == null) return '';
    const base64 = String(base64url).replace(/-/g, '+').replace(/_/g, '/');
    const padLength = (4 - base64url.length % 4) % 4;
    const pad = '==='.slice(0, padLength);
    return base64 + pad;
}



var $ekOVf = parcelRequire("ekOVf");

const $7483410b541cc4dd$export$d3cd91e0fdbfdbc0 = ()=>({
        atob: // atob/btoa need to be bound because they throw an illegal invocation error when called as a method (obj.atob())
        typeof atob === 'function' && atob.bind(undefined) || typeof (0, $ekOVf.Buffer) !== 'undefined' && ((encoded)=>(0, $ekOVf.Buffer).from(encoded, 'base64').toString()),
        btoa: typeof btoa === 'function' && btoa.bind(undefined) || typeof (0, $ekOVf.Buffer) !== 'undefined' && ((str)=>(0, $ekOVf.Buffer).from(str).toString('base64')),
        URLSearchParams: typeof URLSearchParams === 'function' && URLSearchParams || (0, (parcelRequire("cJmfa")).URLSearchParams)
    });
let $7483410b541cc4dd$var$env;
const $7483410b541cc4dd$export$4bd44a2aa29d3d6e = ()=>$7483410b541cc4dd$var$env || ($7483410b541cc4dd$var$env = $7483410b541cc4dd$var$validateEnv($7483410b541cc4dd$export$d3cd91e0fdbfdbc0()));
const $7483410b541cc4dd$var$validateEnv = (env)=>{
    if (!(env.atob && env.btoa && env.URLSearchParams)) throw new TypeError(`Origin-Tracing: missing environment APIs. Required: btoa(), atob(), URLSearchParams() (or in Node: Buffer, require('url').URLSearchParams).`);
    return env;
};


const $c87996fad4c597cf$var$productShorthands = {
    confluence: 'c',
    jira: 'j',
    stride: 's',
    bitbucket: 'b',
    trello: 't'
};
function $c87996fad4c597cf$export$c564cdbbe6da493(originData) {
    const json = JSON.stringify($c87996fad4c597cf$export$4bc4b533a565aabe(originData));
    const base64 = (0, $7483410b541cc4dd$export$4bd44a2aa29d3d6e)().btoa(json);
    return (0, $a8c2f1a75f29f96f$export$3b91e21dac1023c6)(base64);
}
function $c87996fad4c597cf$export$2f872c0f2117be69(encodedOriginString) {
    const base64 = (0, $a8c2f1a75f29f96f$export$47c5265a25535d02)(encodedOriginString);
    const json = (0, $7483410b541cc4dd$export$4bd44a2aa29d3d6e)().atob(base64);
    return $c87996fad4c597cf$export$46d5cda6b884b7ab(JSON.parse(json));
}
function $c87996fad4c597cf$export$4bc4b533a565aabe({ id: id, product: product }) {
    return {
        i: id,
        p: product && product in $c87996fad4c597cf$var$productShorthands ? $c87996fad4c597cf$var$productShorthands[product] : product
    };
}
function $c87996fad4c597cf$export$46d5cda6b884b7ab(originJSONObject) {
    const originData = {};
    if (originJSONObject.i) originData.id = originJSONObject.i;
    if (originJSONObject.p) originData.product = $c87996fad4c597cf$var$expandProductShorthand(originJSONObject.p);
    return originData;
}
function $c87996fad4c597cf$var$expandProductShorthand(maybeShorthand) {
    const products = Object.keys($c87996fad4c597cf$var$productShorthands);
    for(let i = 0; i < products.length; i++){
        const product = products[i];
        const shorthand = $c87996fad4c597cf$var$productShorthands[product];
        if (maybeShorthand === shorthand) return product;
    }
    return maybeShorthand;
}



const $d0d8d601ac789192$var$packageVersion = "0.0.0-use.local";
const $d0d8d601ac789192$var$originParamName = 'atlOrigin';
const $d0d8d601ac789192$var$originVersioningAttributes = {
    originLibrary: `origin-tracing.js@${$d0d8d601ac789192$var$packageVersion}`
};
class $d0d8d601ac789192$export$2e2bcd8739ae039 {
    static isValidId(value) {
        return typeof value === 'string' && /^[-_a-zA-Z0-9]{1,36}$/.test(value);
    }
    static isValidProduct(value) {
        return typeof value === 'string' && /^[-_a-zA-Z0-9]{1,20}$/.test(value);
    }
    static generateId() {
        const id = (0, $466a4b1793cac1d8$exports.v4)();
        // Dash positions are fixed so they don't add to uniqueness.
        // Remove them to save space in the encoded form.
        return id.replace(/-/g, '');
    }
    static createEmpty() {
        return new $d0d8d601ac789192$var$EmptyOriginTracer();
    }
    static createMalformed() {
        return new $d0d8d601ac789192$var$MalformedOriginTracer();
    }
    static fromUrl(url) {
        let params = new ((0, $7483410b541cc4dd$export$4bd44a2aa29d3d6e)()).URLSearchParams();
        $d0d8d601ac789192$var$replaceQuery(url, (queryString)=>{
            params = new ((0, $7483410b541cc4dd$export$4bd44a2aa29d3d6e)()).URLSearchParams(queryString);
        });
        return $d0d8d601ac789192$export$2e2bcd8739ae039.fromEncoded(params.get($d0d8d601ac789192$var$originParamName));
    }
    static fromEncoded(encoded) {
        if (!encoded) return $d0d8d601ac789192$export$2e2bcd8739ae039.createEmpty();
        try {
            return $d0d8d601ac789192$export$2e2bcd8739ae039.decode(encoded);
        } catch (e) {
            return $d0d8d601ac789192$export$2e2bcd8739ae039.createMalformed();
        }
    }
    static removeFromUrl(url) {
        return $d0d8d601ac789192$var$replaceQuery(url, (queryString)=>{
            const params = new ((0, $7483410b541cc4dd$export$4bd44a2aa29d3d6e)()).URLSearchParams(queryString);
            params.delete($d0d8d601ac789192$var$originParamName);
            return params.toString();
        });
    }
    static decode(encodedOrigin) {
        const originData = (0, $c87996fad4c597cf$export$2f872c0f2117be69)(encodedOrigin);
        return new $d0d8d601ac789192$export$2e2bcd8739ae039(originData);
    }
    encode() {
        return (0, $c87996fad4c597cf$export$c564cdbbe6da493)({
            id: this.id,
            product: this.product
        });
    }
    addToUrl(url) {
        return $d0d8d601ac789192$var$replaceQuery(url, (originalQueryString)=>{
            const params = new ((0, $7483410b541cc4dd$export$4bd44a2aa29d3d6e)()).URLSearchParams(originalQueryString);
            params.set($d0d8d601ac789192$var$originParamName, this.encode());
            return params.toString();
        });
    }
    isEmpty() {
        return false;
    }
    isMalformed() {
        return !this.isEmpty() && !this.isValid();
    }
    isValid() {
        return true;
    }
    toAnalyticsAttributes({ transformValue: transformValue = (v)=>v === null ? undefined : v, hasGeneratedId: hasGeneratedId = false } = {}) {
        // `originIdGenerated` should be used in analytic events that generated this originId.
        // Subsequent events should use `originId`.
        // No two events should have the same value of originIdGenerated.
        const originIdProp = hasGeneratedId ? 'originIdGenerated' : 'originId';
        return {
            [originIdProp]: transformValue(this.id),
            originProduct: transformValue(this.product),
            ...$d0d8d601ac789192$var$originVersioningAttributes
        };
    }
    validate() {
        if (!$d0d8d601ac789192$export$2e2bcd8739ae039.isValidId(this.id)) throw new TypeError('Invalid Origin id');
        if (!$d0d8d601ac789192$export$2e2bcd8739ae039.isValidProduct(this.product)) throw new TypeError('Missing/invalid Origin product');
    }
    constructor({ id: id = $d0d8d601ac789192$export$2e2bcd8739ae039.generateId(), product: product, dangerouslySkipValidation: dangerouslySkipValidation = false }){
        this.id = void 0;
        this.product = void 0;
        this.id = id;
        this.product = product;
        if (!dangerouslySkipValidation) this.validate();
    }
}
class $d0d8d601ac789192$var$EmptyOriginTracer extends $d0d8d601ac789192$export$2e2bcd8739ae039 {
    isValid() {
        return false;
    }
    isEmpty() {
        return true;
    }
    toAnalyticsAttributes() {
        return {
            ...$d0d8d601ac789192$var$originVersioningAttributes
        };
    }
    constructor(){
        super({
            id: null,
            product: null,
            dangerouslySkipValidation: true
        });
    }
}
class $d0d8d601ac789192$var$MalformedOriginTracer extends $d0d8d601ac789192$export$2e2bcd8739ae039 {
    isValid() {
        return false;
    }
    isEmpty() {
        return false;
    }
    toAnalyticsAttributes() {
        return {
            originMalformed: true,
            ...$d0d8d601ac789192$var$originVersioningAttributes
        };
    }
    constructor(){
        super({
            id: null,
            product: null,
            dangerouslySkipValidation: true
        });
    }
}
function $d0d8d601ac789192$var$replaceQuery(url, replacer) {
    const urlWithQueryStringRegex = /(^[^?#]*)(?:\?)?([^#]*?)(#.*|$)$/;
    // If we get passed window.location, we don't want to call window.location.replace()
    const urlString = String(url);
    return urlString.replace(urlWithQueryStringRegex, (_wholeMatch, beforeQuery, queryString, afterQuery)=>{
        let newQueryString = replacer(queryString);
        if (newQueryString) newQueryString = `?${newQueryString}`;
        return `${beforeQuery}${newQueryString}${afterQuery}`;
    });
}



var $eSXfa = parcelRequire("eSXfa");
let $c086cef45a2cc129$export$3dcce53a3755dc8c;
const $c086cef45a2cc129$export$57d3cdb500cb5402 = (agent)=>{
    if (agent) $c086cef45a2cc129$export$3dcce53a3755dc8c = agent;
    else if (typeof window !== 'undefined' && window.navigator) $c086cef45a2cc129$export$3dcce53a3755dc8c = window.navigator.userAgent;
};
const $c086cef45a2cc129$export$aad8462122ac592b = ()=>{
    $c086cef45a2cc129$export$3dcce53a3755dc8c = undefined;
};
const $c086cef45a2cc129$export$b7d78993b74f766d = ()=>{
    return $c086cef45a2cc129$export$3dcce53a3755dc8c?.indexOf('Firefox/') !== -1;
};
const $c086cef45a2cc129$export$c87f7e935aea4901 = ()=>{
    return !$c086cef45a2cc129$export$b7d78993b74f766d();
};
const $c086cef45a2cc129$export$552b0ed0b7a8f620 = ()=>{
    return $c086cef45a2cc129$export$3dcce53a3755dc8c?.indexOf('Edge/') !== -1;
};
const $c086cef45a2cc129$export$bf319670985f797f = ()=>{
    return !$c086cef45a2cc129$export$552b0ed0b7a8f620();
};
const $c086cef45a2cc129$export$7e7b1a9668aaed8 = ()=>{
    return $c086cef45a2cc129$export$3dcce53a3755dc8c?.indexOf('MSIE') !== -1 || $c086cef45a2cc129$export$3dcce53a3755dc8c?.indexOf('Trident/') !== -1 || $c086cef45a2cc129$export$552b0ed0b7a8f620();
};
const $c086cef45a2cc129$export$a9ab798d36ba46c = ()=>{
    return !$c086cef45a2cc129$export$7e7b1a9668aaed8();
};
const $c086cef45a2cc129$export$6446a186d09e379e = ()=>{
    return $c086cef45a2cc129$export$3dcce53a3755dc8c?.indexOf('Chrome/') !== -1;
};
const $c086cef45a2cc129$export$23ee57a84a15eab5 = ()=>{
    return !$c086cef45a2cc129$export$6446a186d09e379e();
};
const $c086cef45a2cc129$export$95df08bae54cb4df = ()=>{
    return $c086cef45a2cc129$export$3dcce53a3755dc8c?.indexOf('Safari/') !== -1 && $c086cef45a2cc129$export$3dcce53a3755dc8c?.indexOf('Chrome/') === -1;
};
const $c086cef45a2cc129$export$bc187e33086c8385 = ()=>{
    return !$c086cef45a2cc129$export$95df08bae54cb4df();
};
const $c086cef45a2cc129$export$7b405d3c2ef63516 = ()=>{
    return $c086cef45a2cc129$export$3dcce53a3755dc8c?.indexOf('PhantomJS') !== -1;
};
const $c086cef45a2cc129$export$f11fe2ca946efdb2 = ()=>{
    return !$c086cef45a2cc129$export$7b405d3c2ef63516();
};
const $c086cef45a2cc129$export$6d5620528cf86fa2 = ()=>{
    return !!$c086cef45a2cc129$export$3dcce53a3755dc8c && ($c086cef45a2cc129$export$3dcce53a3755dc8c?.indexOf('Confluence iOS/') !== -1 || $c086cef45a2cc129$export$3dcce53a3755dc8c?.indexOf('Confluence Android/') !== -1);
};
const $c086cef45a2cc129$export$83d89fbfd8236492 = ()=>{
    let versionMatch;
    if ($c086cef45a2cc129$export$7e7b1a9668aaed8()) versionMatch = $c086cef45a2cc129$export$3dcce53a3755dc8c?.match(/MSIE\s([\d.]+)/) || $c086cef45a2cc129$export$3dcce53a3755dc8c?.match(/rv:([\d.]+)/) || $c086cef45a2cc129$export$3dcce53a3755dc8c?.match(/Edge\/([\d.]+)/);
    else if ($c086cef45a2cc129$export$6446a186d09e379e()) versionMatch = $c086cef45a2cc129$export$3dcce53a3755dc8c?.match(/Chrome\/([\d.]+)/);
    else if ($c086cef45a2cc129$export$95df08bae54cb4df()) versionMatch = $c086cef45a2cc129$export$3dcce53a3755dc8c?.match(/Version\/([\d.]+)/);
    else if ($c086cef45a2cc129$export$b7d78993b74f766d()) versionMatch = $c086cef45a2cc129$export$3dcce53a3755dc8c?.match(/Firefox\/([\d.]+)/);
    return versionMatch && parseInt(versionMatch[1]);
};
const $c086cef45a2cc129$export$f52e1a142ed579d = ()=>{
    if ($c086cef45a2cc129$export$552b0ed0b7a8f620()) return 'MSEdge';
    if ($c086cef45a2cc129$export$7e7b1a9668aaed8()) return 'IE';
    if ($c086cef45a2cc129$export$6446a186d09e379e()) return 'Chrome';
    if ($c086cef45a2cc129$export$95df08bae54cb4df()) return 'Safari';
    if ($c086cef45a2cc129$export$b7d78993b74f766d()) return 'Firefox';
};


var $477e019f2b5e6422$export$1e511d4a378977f5;
var $477e019f2b5e6422$export$2e2bcd8739ae039;
'use strict';
$477e019f2b5e6422$export$1e511d4a378977f5 = true;
var $477e019f2b5e6422$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $477e019f2b5e6422$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $3ad7f8c8e251eaf8$exports = {};
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $3ad7f8c8e251eaf8$var$warning = function() {};
$3ad7f8c8e251eaf8$exports = $3ad7f8c8e251eaf8$var$warning;


var $477e019f2b5e6422$var$_warning2 = $477e019f2b5e6422$var$_interopRequireDefault($3ad7f8c8e251eaf8$exports);
var $50d93e068e301fc0$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $50d93e068e301fc0$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$50d93e068e301fc0$exports = $50d93e068e301fc0$var$invariant;


var $477e019f2b5e6422$var$_invariant2 = $477e019f2b5e6422$var$_interopRequireDefault($50d93e068e301fc0$exports);
var $8f47cb9e5c14e83a$export$1e511d4a378977f5;
var $8f47cb9e5c14e83a$export$c3e8bb440bd55b18;
var $8f47cb9e5c14e83a$export$90c043f1c57770b8;
'use strict';
$8f47cb9e5c14e83a$export$1e511d4a378977f5 = true;
$8f47cb9e5c14e83a$export$c3e8bb440bd55b18 = $8f47cb9e5c14e83a$export$90c043f1c57770b8 = undefined;
var $8f47cb9e5c14e83a$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $affb96385603b672$exports = {};

$parcel$defineInteropFlag($affb96385603b672$exports);
$parcel$export($affb96385603b672$exports, "default", () => $affb96385603b672$export$2e2bcd8739ae039);
function $affb96385603b672$var$isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function $affb96385603b672$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $affb96385603b672$var$resolvePathname(to) {
    var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && $affb96385603b672$var$isAbsolute(to);
    var isFromAbs = from && $affb96385603b672$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $affb96385603b672$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash = void 0;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') $affb96385603b672$var$spliceOne(fromParts, i);
        else if (part === '..') {
            $affb96385603b672$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $affb96385603b672$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !$affb96385603b672$var$isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
var $affb96385603b672$export$2e2bcd8739ae039 = $affb96385603b672$var$resolvePathname;


var $8f47cb9e5c14e83a$var$_resolvePathname2 = $8f47cb9e5c14e83a$var$_interopRequireDefault($affb96385603b672$exports);
var $1251071b4f9f7ce8$exports = {};

$parcel$defineInteropFlag($1251071b4f9f7ce8$exports);
$parcel$export($1251071b4f9f7ce8$exports, "default", () => $1251071b4f9f7ce8$export$2e2bcd8739ae039);
var $1251071b4f9f7ce8$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $1251071b4f9f7ce8$var$valueEqual(a, b) {
    if (a === b) return true;
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $1251071b4f9f7ce8$var$valueEqual(item, b[index]);
    });
    var aType = typeof a === 'undefined' ? 'undefined' : $1251071b4f9f7ce8$var$_typeof(a);
    var bType = typeof b === 'undefined' ? 'undefined' : $1251071b4f9f7ce8$var$_typeof(b);
    if (aType !== bType) return false;
    if (aType === 'object') {
        var aValue = a.valueOf();
        var bValue = b.valueOf();
        if (aValue !== a || bValue !== b) return $1251071b4f9f7ce8$var$valueEqual(aValue, bValue);
        var aKeys = Object.keys(a);
        var bKeys = Object.keys(b);
        if (aKeys.length !== bKeys.length) return false;
        return aKeys.every(function(key) {
            return $1251071b4f9f7ce8$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $1251071b4f9f7ce8$export$2e2bcd8739ae039 = $1251071b4f9f7ce8$var$valueEqual;


var $8f47cb9e5c14e83a$var$_valueEqual2 = $8f47cb9e5c14e83a$var$_interopRequireDefault($1251071b4f9f7ce8$exports);
var $71e1af5b080b12ca$export$1e511d4a378977f5;
var $71e1af5b080b12ca$export$5b4913142e03bca8;
var $71e1af5b080b12ca$export$79c5b1569e3be9e6;
var $71e1af5b080b12ca$export$10497c7ce66fcb84;
var $71e1af5b080b12ca$export$b69e3301ce081aa3;
var $71e1af5b080b12ca$export$d95b4586d238a081;
var $71e1af5b080b12ca$export$8ccf933b0513f8d0;
var $71e1af5b080b12ca$export$fe53371bee54353d;
'use strict';
$71e1af5b080b12ca$export$1e511d4a378977f5 = true;
var $71e1af5b080b12ca$var$addLeadingSlash = $71e1af5b080b12ca$export$5b4913142e03bca8 = function addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
};
var $71e1af5b080b12ca$var$stripLeadingSlash = $71e1af5b080b12ca$export$79c5b1569e3be9e6 = function stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
};
var $71e1af5b080b12ca$var$hasBasename = $71e1af5b080b12ca$export$10497c7ce66fcb84 = function hasBasename(path, prefix) {
    return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};
var $71e1af5b080b12ca$var$stripBasename = $71e1af5b080b12ca$export$b69e3301ce081aa3 = function stripBasename(path, prefix) {
    return $71e1af5b080b12ca$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};
var $71e1af5b080b12ca$var$stripTrailingSlash = $71e1af5b080b12ca$export$d95b4586d238a081 = function stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};
var $71e1af5b080b12ca$var$parsePath = $71e1af5b080b12ca$export$8ccf933b0513f8d0 = function parsePath(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
};
var $71e1af5b080b12ca$var$createPath = $71e1af5b080b12ca$export$fe53371bee54353d = function createPath(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;
    return path;
};


function $8f47cb9e5c14e83a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8f47cb9e5c14e83a$var$createLocation = $8f47cb9e5c14e83a$export$90c043f1c57770b8 = function createLocation(path, state, key, currentLocation) {
    var location = void 0;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = (0, $71e1af5b080b12ca$export$8ccf933b0513f8d0)(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = $8f47cb9e5c14e83a$var$_extends({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, $8f47cb9e5c14e83a$var$_resolvePathname2.default)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
};
var $8f47cb9e5c14e83a$var$locationsAreEqual = $8f47cb9e5c14e83a$export$c3e8bb440bd55b18 = function locationsAreEqual(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $8f47cb9e5c14e83a$var$_valueEqual2.default)(a.state, b.state);
};



var $b5b0f87adb64f216$exports = {};

$parcel$defineInteropFlag($b5b0f87adb64f216$exports);
$parcel$export($b5b0f87adb64f216$exports, "__esModule", () => $b5b0f87adb64f216$export$1e511d4a378977f5, (v) => $b5b0f87adb64f216$export$1e511d4a378977f5 = v);
$parcel$export($b5b0f87adb64f216$exports, "default", () => $b5b0f87adb64f216$export$2e2bcd8739ae039, (v) => $b5b0f87adb64f216$export$2e2bcd8739ae039 = v);
var $b5b0f87adb64f216$export$1e511d4a378977f5;
var $b5b0f87adb64f216$export$2e2bcd8739ae039;
'use strict';
$b5b0f87adb64f216$export$1e511d4a378977f5 = true;

var $b5b0f87adb64f216$var$_warning2 = $b5b0f87adb64f216$var$_interopRequireDefault($3ad7f8c8e251eaf8$exports);
function $b5b0f87adb64f216$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $b5b0f87adb64f216$var$createTransitionManager = function createTransitionManager() {
    var prompt = null;
    var setPrompt = function setPrompt(nextPrompt) {
        (0, $b5b0f87adb64f216$var$_warning2.default)(prompt == null, 'A history supports only one prompt at a time');
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    };
    var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else {
                    (0, $b5b0f87adb64f216$var$_warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');
                    callback(true);
                }
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    };
    var listeners = [];
    var appendListener = function appendListener(fn) {
        var isActive = true;
        var listener = function listener() {
            if (isActive) fn.apply(undefined, arguments);
        };
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    };
    var notifyListeners = function notifyListeners() {
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(undefined, args);
        });
    };
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
};
$b5b0f87adb64f216$export$2e2bcd8739ae039 = $b5b0f87adb64f216$var$createTransitionManager;


var $477e019f2b5e6422$var$_createTransitionManager2 = $477e019f2b5e6422$var$_interopRequireDefault($b5b0f87adb64f216$exports);
var $06fa104e4adbc166$export$1e511d4a378977f5;
var $06fa104e4adbc166$export$71594e8a50f746f4;
var $06fa104e4adbc166$export$3f65cefe8380dbea;
var $06fa104e4adbc166$export$8ff9f68337b520c0;
var $06fa104e4adbc166$export$ef38efb4b47d01db;
var $06fa104e4adbc166$export$67fc34576016d6ec;
var $06fa104e4adbc166$export$bd919e6f5f49fb48;
var $06fa104e4adbc166$export$9a5b29ff20eb48f9;
var $06fa104e4adbc166$export$aa3c5b1dd6fed00;
'use strict';
$06fa104e4adbc166$export$1e511d4a378977f5 = true;
var $06fa104e4adbc166$var$canUseDOM = $06fa104e4adbc166$export$71594e8a50f746f4 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $06fa104e4adbc166$var$addEventListener = $06fa104e4adbc166$export$3f65cefe8380dbea = function addEventListener(node, event, listener) {
    return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};
var $06fa104e4adbc166$var$removeEventListener = $06fa104e4adbc166$export$8ff9f68337b520c0 = function removeEventListener(node, event, listener) {
    return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};
var $06fa104e4adbc166$var$getConfirmation = $06fa104e4adbc166$export$ef38efb4b47d01db = function getConfirmation(message, callback) {
    return callback(window.confirm(message));
}; // eslint-disable-line no-alert
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ var $06fa104e4adbc166$var$supportsHistory = $06fa104e4adbc166$export$67fc34576016d6ec = function supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
};
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ var $06fa104e4adbc166$var$supportsPopStateOnHashChange = $06fa104e4adbc166$export$bd919e6f5f49fb48 = function supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
};
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ var $06fa104e4adbc166$var$supportsGoWithoutReloadUsingHash = $06fa104e4adbc166$export$9a5b29ff20eb48f9 = function supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
};
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ var $06fa104e4adbc166$var$isExtraneousPopstateEvent = $06fa104e4adbc166$export$aa3c5b1dd6fed00 = function isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};


function $477e019f2b5e6422$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $477e019f2b5e6422$var$PopStateEvent = 'popstate';
var $477e019f2b5e6422$var$HashChangeEvent = 'hashchange';
var $477e019f2b5e6422$var$getHistoryState = function getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
};
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ var $477e019f2b5e6422$var$createBrowserHistory = function createBrowserHistory() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, $477e019f2b5e6422$var$_invariant2.default)($06fa104e4adbc166$export$71594e8a50f746f4, 'Browser history needs a DOM');
    var globalHistory = window.history;
    var canUseHistory = (0, $06fa104e4adbc166$export$67fc34576016d6ec)();
    var needsHashChangeListener = !(0, $06fa104e4adbc166$export$bd919e6f5f49fb48)();
    var _props$forceRefresh = props.forceRefresh, forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh, _props$getUserConfirm = props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === undefined ? $06fa104e4adbc166$export$ef38efb4b47d01db : _props$getUserConfirm, _props$keyLength = props.keyLength, keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
    var basename = props.basename ? (0, $71e1af5b080b12ca$export$d95b4586d238a081)((0, $71e1af5b080b12ca$export$5b4913142e03bca8)(props.basename)) : '';
    var getDOMLocation = function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        (0, $477e019f2b5e6422$var$_warning2.default)(!basename || (0, $71e1af5b080b12ca$export$10497c7ce66fcb84)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
        if (basename) path = (0, $71e1af5b080b12ca$export$b69e3301ce081aa3)(path, basename);
        return (0, $8f47cb9e5c14e83a$export$90c043f1c57770b8)(path, state, key);
    };
    var createKey = function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    };
    var transitionManager = (0, $477e019f2b5e6422$var$_createTransitionManager2.default)();
    var setState = function setState(nextState) {
        $477e019f2b5e6422$var$_extends(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    };
    var handlePopState = function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ((0, $06fa104e4adbc166$export$aa3c5b1dd6fed00)(event)) return;
        handlePop(getDOMLocation(event.state));
    };
    var handleHashChange = function handleHashChange() {
        handlePop(getDOMLocation($477e019f2b5e6422$var$getHistoryState()));
    };
    var forceNextPop = false;
    var handlePop = function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    };
    var revertPop = function revertPop(fromLocation) {
        var toLocation = history.location;
        // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    };
    var initialLocation = getDOMLocation($477e019f2b5e6422$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ];
    // Public interface
    var createHref = function createHref(location) {
        return basename + (0, $71e1af5b080b12ca$export$fe53371bee54353d)(location);
    };
    var push = function push(path, state) {
        (0, $477e019f2b5e6422$var$_warning2.default)(!((typeof path === 'undefined' ? 'undefined' : $477e019f2b5e6422$var$_typeof(path)) === 'object' && path.state !== undefined && state !== undefined), "You should avoid providing a 2nd state argument to push when the 1st argument is a location-like object that already has state; it is ignored");
        var action = 'PUSH';
        var location = (0, $8f47cb9e5c14e83a$export$90c043f1c57770b8)(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else {
                (0, $477e019f2b5e6422$var$_warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');
                window.location.href = href;
            }
        });
    };
    var replace = function replace(path, state) {
        (0, $477e019f2b5e6422$var$_warning2.default)(!((typeof path === 'undefined' ? 'undefined' : $477e019f2b5e6422$var$_typeof(path)) === 'object' && path.state !== undefined && state !== undefined), "You should avoid providing a 2nd state argument to replace when the 1st argument is a location-like object that already has state; it is ignored");
        var action = 'REPLACE';
        var location = (0, $8f47cb9e5c14e83a$export$90c043f1c57770b8)(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else {
                (0, $477e019f2b5e6422$var$_warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');
                window.location.replace(href);
            }
        });
    };
    var go = function go(n) {
        globalHistory.go(n);
    };
    var goBack = function goBack() {
        return go(-1);
    };
    var goForward = function goForward() {
        return go(1);
    };
    var listenerCount = 0;
    var checkDOMListeners = function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1) {
            (0, $06fa104e4adbc166$export$3f65cefe8380dbea)(window, $477e019f2b5e6422$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) (0, $06fa104e4adbc166$export$3f65cefe8380dbea)(window, $477e019f2b5e6422$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            (0, $06fa104e4adbc166$export$8ff9f68337b520c0)(window, $477e019f2b5e6422$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) (0, $06fa104e4adbc166$export$8ff9f68337b520c0)(window, $477e019f2b5e6422$var$HashChangeEvent, handleHashChange);
        }
    };
    var isBlocked = false;
    var block = function block() {
        var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    };
    var listen = function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    };
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
};
$477e019f2b5e6422$export$2e2bcd8739ae039 = $477e019f2b5e6422$var$createBrowserHistory;



var $34Zxt = parcelRequire("34Zxt");
let $efe75065bf034d65$var$browserHistoryListener = null;
const $efe75065bf034d65$export$39f750fd76b05ae3 = (newBrowserHistoryListener)=>{
    $efe75065bf034d65$var$browserHistoryListener = newBrowserHistoryListener;
    return ()=>{
        $efe75065bf034d65$var$browserHistoryListener = null;
    };
};
const $efe75065bf034d65$export$1ddb08151d15bc78 = (0, $34Zxt.default)(()=>{
    const browserHistory = (0, $477e019f2b5e6422$export$2e2bcd8739ae039)();
    browserHistory.listen((location, action)=>{
        $efe75065bf034d65$var$browserHistoryListener?.(location, action);
    });
    return browserHistory;
});


// The build information here are populated by the code inlined in the bootstrapping HTML
// They can be found in:
// - packages/confluence-frontend-server/templates/*
function $f3f8c1a227f13835$var$getReleaseTrack() {
    try {
        // This value overrides the track as "dev". Helpful for when
        // end-to-end tests are run from dev machine against a production instance.
        // eslint-disable-next-line check-set-storage-usage/no-unimported-storage-set
        if (sessionStorage.getItem('confluence.telemetry-dev-track-override')) return 'dev';
    } catch  {
    // no-op
    }
    return 'prod';
}
function $f3f8c1a227f13835$export$4ea39b9726d98a51() {
    const injectedBuildInfo = window.__buildInfo || {};
    let { FRONTEND_VERSION: FRONTEND_VERSION } = injectedBuildInfo;
    if (!FRONTEND_VERSION) FRONTEND_VERSION = '';
    const FRONTEND_VERSION_PATTERN = /^([^-]+)-(.+)-(\d+)$/;
    const match = FRONTEND_VERSION_PATTERN.exec(FRONTEND_VERSION);
    return {
        FRONTEND_VERSION: match ? FRONTEND_VERSION : 'UNKNOWN-unknown-0',
        BRANCH_NAME: match ? match[2] : 'unknown',
        BUILD_NUMBER: match ? parseInt(match[3], 10) : 0,
        BUILD_DATE: injectedBuildInfo.BUILD_DATE || 0,
        PUBLIC_PATH: injectedBuildInfo.PUBLIC_PATH || 'unknown',
        RELEASE_TRACK: $f3f8c1a227f13835$var$getReleaseTrack(),
        IS_BIFROST: window.__IS_BIFROST__ || false
    };
}


const $cd3135dd152096aa$var$PromiseStatus = Symbol.for('PromiseStatus');
const $cd3135dd152096aa$var$PromiseValue = Symbol.for('PromiseValue');
const $cd3135dd152096aa$export$cc373701aed148fc = (promise)=>{
    const newPromise = promise.then((value)=>{
        newPromise[$cd3135dd152096aa$var$PromiseStatus] = 'resolved';
        newPromise[$cd3135dd152096aa$var$PromiseValue] = value;
        return value;
    }, (error)=>{
        newPromise[$cd3135dd152096aa$var$PromiseStatus] = 'rejected';
        newPromise[$cd3135dd152096aa$var$PromiseValue] = error;
        throw error;
    });
    newPromise[$cd3135dd152096aa$var$PromiseStatus] = 'pending';
    return newPromise;
};
const $cd3135dd152096aa$export$b1a2a6bd0c6f9666 = (liftedPromise)=>liftedPromise[$cd3135dd152096aa$var$PromiseStatus] === 'resolved';
const $cd3135dd152096aa$export$bf7199a9ebcb84a9 = (liftedPromise)=>liftedPromise[$cd3135dd152096aa$var$PromiseValue];



/* eslint-disable no-console */ function $a6897acd40ed68b1$var$getLoggerName(logSource) {
    return typeof logSource === 'string' ? logSource : logSource.displayName || logSource.name || 'Unknown';
}
class $a6897acd40ed68b1$var$Logger {
    log(strings, ...values) {
        this.logAnyLevel(1, console.log, strings, values);
    }
    debug(strings, ...values) {
        this.logAnyLevel(2, console.debug, strings, values);
    }
    info(strings, ...values) {
        this.logAnyLevel(3, console.info, strings, values);
    }
    warn(strings, ...values) {
        this.logAnyLevel(4, console.warn, strings, values);
    }
    error(strings, ...values) {
        this.logAnyLevel(5, console.error, strings, values);
    }
    logAnyLevel(logLevel, consoleFunction, strings, values) {
        try {
            if (// There's no sessionStorage in service workers.
            // We'll just enable logging from service workers for simplicity.
            typeof sessionStorage === 'undefined' || sessionStorage.getItem('confluence.enable-logging') === 'true') {
                const logLevelSetting = typeof sessionStorage !== 'undefined' && sessionStorage.getItem('confluence.log-level');
                const configuredLogLevel = parseInt(logLevelSetting || '', 10) || 1;
                if (configuredLogLevel > logLevel) return;
                const prefix = [
                    `[@${Math.round(performance.now())} ${this.name}]`
                ];
                const messages = strings.reduce((processed, str, index)=>{
                    const value = values[index];
                    const trimmedStr = str.trim()// Allow multiline strings to be indented in code but printed without indenting
                    .replace(/\n\s+/g, '\n');
                    if (trimmedStr) processed.push(trimmedStr);
                    if (index !== strings.length - 1) processed.push(typeof value === 'string' ? JSON.stringify(value) : value);
                    return processed;
                }, prefix);
                consoleFunction(...messages);
            }
        } catch (e) {
            // Catch and log.
            // We don't want to stop execution due to a logging error.
            console.error(e);
        }
    }
    constructor(logSource){
        this.name = void 0;
        this.name = $a6897acd40ed68b1$var$getLoggerName(logSource);
    }
}
const $a6897acd40ed68b1$export$2b1d391cd05230fd = (logSource)=>new $a6897acd40ed68b1$var$Logger(logSource);


// Must call this before any browser-helper functions, to ensure user agent has been set first
(0, $c086cef45a2cc129$export$57d3cdb500cb5402)();
const $3793e1e9d193543a$var$logger = (0, $a6897acd40ed68b1$export$2b1d391cd05230fd)('mobile-detection');
// Copied from com.atlassian.confluence.mobile.MobileUtils
const $3793e1e9d193543a$var$NATIVE_IOS_REGEX_STRING = 'iPhone;|iPad;|iPhone Simulator;|iPod;|iPod touch;';
const $3793e1e9d193543a$var$NATIVE_ANDROID_REGEX_STRING = 'Linux; U; Android|Android';
const $3793e1e9d193543a$var$MOBILE_USER_AGENT_REGEX = new RegExp(`(${$3793e1e9d193543a$var$NATIVE_IOS_REGEX_STRING}|${$3793e1e9d193543a$var$NATIVE_ANDROID_REGEX_STRING})`, 'i');
const $3793e1e9d193543a$var$ANDROID_CHROME = /Chrome\/[.\d]* Mobile/i;
const $3793e1e9d193543a$var$OLD_ANDROID = /Linux; U; Android (?:[23]\.\d|4\.0\.[12])/i;
const $3793e1e9d193543a$var$NATIVE_IOS = new RegExp(`(${$3793e1e9d193543a$var$NATIVE_IOS_REGEX_STRING})`, 'i');
const $3793e1e9d193543a$var$NATIVE_ANDROID = new RegExp(`(${$3793e1e9d193543a$var$NATIVE_ANDROID_REGEX_STRING})`, 'i');
const $3793e1e9d193543a$export$bb3c728251279d4a = 'mobileWebTestingMode=testing';
const $3793e1e9d193543a$export$2275282fb5681637 = 'mobile.web.desktop.override.active';
const $3793e1e9d193543a$export$abee7d877fc322c9 = ()=>{
    // Port from com.atlassian.confluence.mobile.MobileUtils#isMobileViewRequest
    const ua = window.navigator.userAgent;
    return !!ua && !$3793e1e9d193543a$var$OLD_ANDROID.test(ua) && ($3793e1e9d193543a$var$MOBILE_USER_AGENT_REGEX.test(ua) || $3793e1e9d193543a$var$ANDROID_CHROME.test(ua) || (0, $c086cef45a2cc129$export$6d5620528cf86fa2)());
};
const $3793e1e9d193543a$export$cc63546398e0df2 = ()=>window.localStorage.getItem($3793e1e9d193543a$export$2275282fb5681637) === 'true';
const $3793e1e9d193543a$export$47a2095e97aaa3d3 = ()=>{
    try {
        // TODO: Remove lint rule once storage is updated to use atlassian/browser-storage-controls or confluence/storage-manager
        // eslint-disable-next-line check-set-storage-usage/no-unimported-storage-set
        window.localStorage.setItem($3793e1e9d193543a$export$2275282fb5681637, 'true');
    } catch (err) {
        $3793e1e9d193543a$var$logger.error`Unable to set local storage. key = "${$3793e1e9d193543a$export$2275282fb5681637}", value = "true"`;
    }
};
const $3793e1e9d193543a$export$77ee453f21ed22ca = ()=>window.localStorage.removeItem($3793e1e9d193543a$export$2275282fb5681637);
function $3793e1e9d193543a$export$1adf40e7373cdd98() {
    // for testing purposes, query param forces mobile web
    if (window.location.search.includes($3793e1e9d193543a$export$bb3c728251279d4a)) return true;
    return $3793e1e9d193543a$export$abee7d877fc322c9() && !$3793e1e9d193543a$export$cc63546398e0df2();
}
const $3793e1e9d193543a$export$4483f9f8ce987764 = ()=>{
    const ua = window.navigator.userAgent;
    return !!ua && $3793e1e9d193543a$var$NATIVE_ANDROID.test(ua);
};
const $3793e1e9d193543a$export$63c82ea425a2bb3d = ()=>{
    const ua = window.navigator.userAgent;
    return !!ua && $3793e1e9d193543a$var$NATIVE_IOS.test(ua);
};



var $aE6gq = parcelRequire("aE6gq");
const $1ba1f4be15891c95$export$42f4885608027d0c = 'non_boolean';


function $d512fd1167083ee2$var$startsAsObject(value) {
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
}
function $d512fd1167083ee2$var$isObject(value) {
    return value && typeof value === 'object' && value.constructor === Object;
}
function $d512fd1167083ee2$var$isString(input) {
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
}
function $d512fd1167083ee2$export$7b4abba432e57989(value) {
    return $d512fd1167083ee2$var$isString(value) && $d512fd1167083ee2$var$startsAsObject(value) || $d512fd1167083ee2$var$isObject(value);
}
function $d512fd1167083ee2$export$fcc03ee4c944962f(featureFlagValue) {
    return $d512fd1167083ee2$export$7b4abba432e57989(featureFlagValue) ? (0, $1ba1f4be15891c95$export$42f4885608027d0c) : featureFlagValue;
}


const $bad1dfcb36c5adde$export$5b78c989c8db2561 = new Map();
const $bad1dfcb36c5adde$export$2a5c8df26bb89760 = new Map();
function $bad1dfcb36c5adde$export$47fade9662f71000(featureFlagName, featureFlagValue) {
    try {
        // Inform Criterion about FF being accessed
        if (globalThis.__CRITERION__ && typeof globalThis.__CRITERION__.addFeatureFlagAccessed === 'function') globalThis.__CRITERION__.addFeatureFlagAccessed(featureFlagName, featureFlagValue);
    } catch (_e) {
    // ignore the criterion error
    }
    const value = (0, $d512fd1167083ee2$export$fcc03ee4c944962f)(featureFlagValue);
    $bad1dfcb36c5adde$export$5b78c989c8db2561.set(featureFlagName, value);
    $bad1dfcb36c5adde$export$2a5c8df26bb89760.set(featureFlagName, value);
}


const $3df4286e75ff1ab6$export$b40ec24ac8275656 = (gateName)=>{
    // eslint-disable-next-line confluence-feature-gating/use-recommended-utils
    const value = (0, $aE6gq.default).checkGate(gateName);
    (0, $bad1dfcb36c5adde$export$47fade9662f71000)(gateName, value);
    return value;
};







var $aE6gq = parcelRequire("aE6gq");

const $ef003bca5ae3d837$var$DEFAULT_ENABLED_PARAM = 'isEnabled';
function $ef003bca5ae3d837$export$9db1624a8af791a4(experimentName, param, defaultValue) {
    // eslint-disable-next-line confluence-feature-gating/use-recommended-utils
    const value = (0, $aE6gq.default).getExperimentValue(experimentName, param, defaultValue);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $bad1dfcb36c5adde$export$47fade9662f71000)(`${experimentName}:${param}`, value);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return value;
}
function $ef003bca5ae3d837$export$da472ee01c19d92e(experimentName, param, defaultValue) {
    // eslint-disable-next-line confluence-feature-gating/use-recommended-utils
    const value = (0, $aE6gq.default).getExperimentValue(experimentName, param, defaultValue, {
        fireExperimentExposure: false
    });
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $bad1dfcb36c5adde$export$47fade9662f71000)(`${experimentName}:${param}`, value);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return value;
}
const $ef003bca5ae3d837$export$94f132839aec533f = $ef003bca5ae3d837$export$da472ee01c19d92e;
function $ef003bca5ae3d837$export$45abdb3f977b5b14(experimentName, param, comparatorValue) {
    // eslint-disable-next-line confluence-feature-gating/inline-expVal-params
    return $ef003bca5ae3d837$export$9db1624a8af791a4(experimentName, param, null) === comparatorValue;
}
function $ef003bca5ae3d837$export$d9ae946a42fe8ba9(experimentName, param, comparatorValue) {
    // eslint-disable-next-line confluence-feature-gating/inline-expVal-params
    return $ef003bca5ae3d837$export$da472ee01c19d92e(experimentName, param, null) === comparatorValue;
}
const $ef003bca5ae3d837$export$63eebf86443a0a61 = $ef003bca5ae3d837$export$d9ae946a42fe8ba9;
function $ef003bca5ae3d837$export$d14de861476c5d7c(experimentName) {
    (0, $aE6gq.default).manuallyLogExperimentExposure(experimentName);
}
function $ef003bca5ae3d837$export$336b018592dc9972(experimentName) {
    // eslint-disable-next-line confluence-feature-gating/inline-expVal-params
    return $ef003bca5ae3d837$export$45abdb3f977b5b14(experimentName, $ef003bca5ae3d837$var$DEFAULT_ENABLED_PARAM, true);
}
function $ef003bca5ae3d837$export$9a4bf900b9ee892d(experimentName) {
    // eslint-disable-next-line confluence-feature-gating/inline-expVal-params
    return $ef003bca5ae3d837$export$d9ae946a42fe8ba9(experimentName, $ef003bca5ae3d837$var$DEFAULT_ENABLED_PARAM, true);
}
class $ef003bca5ae3d837$var$ExperimentConfig {
    get(key, defaultValue, typeGuard) {
        // Check if the CRITERION override mechanism is available
        if (window && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            const overrideValue = window.__CRITERION__.getExperimentValueOverride(this._experimentName, key);
            if (overrideValue !== undefined && overrideValue !== null) {
                (0, $bad1dfcb36c5adde$export$47fade9662f71000)(`${this._experimentName}:${key}`, overrideValue);
                return overrideValue;
            }
        }
        const value = this._config.get(key, defaultValue, typeGuard);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $bad1dfcb36c5adde$export$47fade9662f71000)(`${this._experimentName}:${key}`, value);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return value;
    }
    constructor(experimentName, config){
        this._experimentName = void 0;
        this._config = void 0;
        this._experimentName = experimentName;
        this._config = config;
    }
}
const $ef003bca5ae3d837$var$cache = new Map();
function $ef003bca5ae3d837$export$677f9fa2e1ae6fec(experimentName) {
    let instance = $ef003bca5ae3d837$var$cache.get(experimentName);
    if (instance == null) {
        const config = (0, $aE6gq.default).getExperiment(experimentName, {
            fireExperimentExposure: false
        });
        const fireExposure = ()=>(0, $aE6gq.default).manuallyLogExperimentExposure(experimentName);
        instance = [
            new $ef003bca5ae3d837$var$ExperimentConfig(experimentName, config),
            fireExposure
        ];
        $ef003bca5ae3d837$var$cache.set(experimentName, instance);
    }
    return instance;
}



function $d4a7caa009eb781c$export$eca64eb737a4c2bc(requestInit) {
    // referrerPolicy is not supported by Edge pre Chromium:
    if (requestInit && 'referrerPolicy' in requestInit) {
        const { referrerPolicy: referrerPolicy, ...requestInitWithoutReferrerPolicy } = requestInit;
        try {
            new Request('/', {
                referrerPolicy: referrerPolicy
            });
        // The referrerPolicy seems to be supported. Leave it in requestInit.
        } catch (_) {
            // The referrerPolicy does not seem to be supported. Drop it from
            // requestInit; otherwise, the Request constructor and fetch will throw:
            requestInit = requestInitWithoutReferrerPolicy;
        }
    }
    return requestInit;
}


const $32b74afc9e827b44$export$9f229e40eb65abfc = (response)=>response?.headers?.get('x-b3-traceid') || response?.headers?.get('atl-traceid') || null;



var $3UfL2 = parcelRequire("3UfL2");

var $gODea = parcelRequire("gODea");
var $99WkW = parcelRequire("99WkW");

var $7kiUr = parcelRequire("7kiUr");
var $jdQxa = parcelRequire("jdQxa");

var $9X8MB = parcelRequire("9X8MB");

var $3UfL2 = parcelRequire("3UfL2");

var $1CHRc = parcelRequire("1CHRc");
var $6bc7ad95682943c0$var$genericMessage = "Invariant Violation";
var $6bc7ad95682943c0$var$_a = Object.setPrototypeOf, $6bc7ad95682943c0$var$setPrototypeOf = $6bc7ad95682943c0$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $6bc7ad95682943c0$var$_a;
var $6bc7ad95682943c0$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $3UfL2.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $6bc7ad95682943c0$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $6bc7ad95682943c0$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $6bc7ad95682943c0$var$genericMessage;
        $6bc7ad95682943c0$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $6bc7ad95682943c0$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $6bc7ad95682943c0$export$cea12affaee22fe8(message);
}
function $6bc7ad95682943c0$var$wrapConsoleMethod(method) {
    return function() {
        return console[method].apply(console, arguments);
    };
}
(function(invariant) {
    invariant.warn = $6bc7ad95682943c0$var$wrapConsoleMethod("warn");
    invariant.error = $6bc7ad95682943c0$var$wrapConsoleMethod("error");
})($6bc7ad95682943c0$export$f5708dca728d7177 || ($6bc7ad95682943c0$export$f5708dca728d7177 = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var $6bc7ad95682943c0$export$e54fe5b0f43758f7 = {
    env: {}
};
if (typeof $1CHRc === "object") $6bc7ad95682943c0$export$e54fe5b0f43758f7 = $1CHRc;
else try {
    // Using Function to evaluate this assignment in global scope also escapes
    // the strict mode of the current module, thereby allowing the assignment.
    // Inspired by https://github.com/facebook/regenerator/pull/369.
    Function("stub", "process = stub")($6bc7ad95682943c0$export$e54fe5b0f43758f7);
} catch (atLeastWeTried) {
// The assignment can fail if a Content Security Policy heavy-handedly
// forbids Function usage. In those environments, developers should take
// extra care to replace process.env.NODE_ENV in their production builds,
// or define an appropriate global.process polyfill.
}
var $6bc7ad95682943c0$var$invariant$1 = $6bc7ad95682943c0$export$f5708dca728d7177;
var $6bc7ad95682943c0$export$2e2bcd8739ae039 = $6bc7ad95682943c0$var$invariant$1;



var $dUQHG = parcelRequire("dUQHG");
var $cb292de0bef73a33$export$bd096ddbd246c79c;
(function(NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})($cb292de0bef73a33$export$bd096ddbd246c79c || ($cb292de0bef73a33$export$bd096ddbd246c79c = {}));
function $cb292de0bef73a33$var$isNetworkRequestInFlight(networkStatus) {
    return networkStatus < 7;
}
var $cb292de0bef73a33$var$Observable = function(_super) {
    (0, $3UfL2.__extends)(Observable, _super);
    function Observable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Observable.prototype[0, $9X8MB.default] = function() {
        return this;
    };
    Observable.prototype['@@observable'] = function() {
        return this;
    };
    return Observable;
}((0, $jdQxa.default));
function $cb292de0bef73a33$var$isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}
function $cb292de0bef73a33$export$17f5e6bd290bb15d(err) {
    return err.hasOwnProperty('graphQLErrors');
}
var $cb292de0bef73a33$var$generateErrorMessage = function(err) {
    var message = '';
    if ($cb292de0bef73a33$var$isNonEmptyArray(err.graphQLErrors)) err.graphQLErrors.forEach(function(graphQLError) {
        var errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += "GraphQL error: " + errorMessage + "\n";
    });
    if (err.networkError) message += 'Network error: ' + err.networkError.message + '\n';
    message = message.replace(/\n$/, '');
    return message;
};
var $cb292de0bef73a33$export$26a337512320b8c6 = function(_super) {
    (0, $3UfL2.__extends)(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.graphQLErrors = graphQLErrors || [];
        _this.networkError = networkError || null;
        if (!errorMessage) _this.message = $cb292de0bef73a33$var$generateErrorMessage(_this);
        else _this.message = errorMessage;
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);
var $cb292de0bef73a33$export$160bafb6ac1e0641;
(function(FetchType) {
    FetchType[FetchType["normal"] = 1] = "normal";
    FetchType[FetchType["refetch"] = 2] = "refetch";
    FetchType[FetchType["poll"] = 3] = "poll";
})($cb292de0bef73a33$export$160bafb6ac1e0641 || ($cb292de0bef73a33$export$160bafb6ac1e0641 = {}));
var $cb292de0bef73a33$var$hasError = function(storeValue, policy) {
    if (policy === void 0) policy = 'none';
    return storeValue && (storeValue.networkError || policy === 'none' && $cb292de0bef73a33$var$isNonEmptyArray(storeValue.graphQLErrors));
};
var $cb292de0bef73a33$export$6c1b56eac59c9584 = function(_super) {
    (0, $3UfL2.__extends)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, options = _a.options, _b = _a.shouldSubscribe, shouldSubscribe = _b === void 0 ? true : _b;
        var _this = _super.call(this, function(observer) {
            return _this.onSubscribe(observer);
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.isTornDown = false;
        _this.options = options;
        _this.variables = options.variables || {};
        _this.queryId = queryManager.generateQueryId();
        _this.shouldSubscribe = shouldSubscribe;
        var opDef = (0, $gODea.getOperationDefinition)(options.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        _this.queryManager = queryManager;
        return _this;
    }
    ObservableQuery.prototype.result = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var observer = {
                next: function(result) {
                    resolve(result);
                    _this.observers.delete(observer);
                    if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                    setTimeout(function() {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject
            };
            var subscription = _this.subscribe(observer);
        });
    };
    ObservableQuery.prototype.currentResult = function() {
        var result = this.getCurrentResult();
        if (result.data === undefined) result.data = {};
        return result;
    };
    ObservableQuery.prototype.getCurrentResult = function() {
        if (this.isTornDown) {
            var lastResult = this.lastResult;
            return {
                data: !this.lastError && lastResult && lastResult.data || void 0,
                error: this.lastError,
                loading: false,
                networkStatus: $cb292de0bef73a33$export$bd096ddbd246c79c.error
            };
        }
        var _a = this.queryManager.getCurrentQueryResult(this), data = _a.data, partial = _a.partial;
        var queryStoreValue = this.queryManager.queryStore.get(this.queryId);
        var result;
        var fetchPolicy = this.options.fetchPolicy;
        var isNetworkFetchPolicy = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
        if (queryStoreValue) {
            var networkStatus = queryStoreValue.networkStatus;
            if ($cb292de0bef73a33$var$hasError(queryStoreValue, this.options.errorPolicy)) return {
                data: void 0,
                loading: false,
                networkStatus: networkStatus,
                error: new $cb292de0bef73a33$export$26a337512320b8c6({
                    graphQLErrors: queryStoreValue.graphQLErrors,
                    networkError: queryStoreValue.networkError
                })
            };
            if (queryStoreValue.variables) {
                this.options.variables = (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, this.options.variables), queryStoreValue.variables);
                this.variables = this.options.variables;
            }
            result = {
                data: data,
                loading: $cb292de0bef73a33$var$isNetworkRequestInFlight(networkStatus),
                networkStatus: networkStatus
            };
            if (queryStoreValue.graphQLErrors && this.options.errorPolicy === 'all') result.errors = queryStoreValue.graphQLErrors;
        } else {
            var loading = isNetworkFetchPolicy || partial && fetchPolicy !== 'cache-only';
            result = {
                data: data,
                loading: loading,
                networkStatus: loading ? $cb292de0bef73a33$export$bd096ddbd246c79c.loading : $cb292de0bef73a33$export$bd096ddbd246c79c.ready
            };
        }
        if (!partial) this.updateLastResult((0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, result), {
            stale: false
        }));
        return (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, result), {
            partial: partial
        });
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function(newResult) {
        var snapshot = this.lastResultSnapshot;
        return !(snapshot && newResult && snapshot.networkStatus === newResult.networkStatus && snapshot.stale === newResult.stale && (0, $99WkW.equal)(snapshot.data, newResult.data));
    };
    ObservableQuery.prototype.getLastResult = function() {
        return this.lastResult;
    };
    ObservableQuery.prototype.getLastError = function() {
        return this.lastError;
    };
    ObservableQuery.prototype.resetLastResults = function() {
        delete this.lastResult;
        delete this.lastResultSnapshot;
        delete this.lastError;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function() {
        var queryStore = this.queryManager.queryStore.get(this.queryId);
        if (queryStore) {
            queryStore.networkError = null;
            queryStore.graphQLErrors = [];
        }
    };
    ObservableQuery.prototype.refetch = function(variables) {
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === 'cache-only') return Promise.reject(new (0, $6bc7ad95682943c0$export$cea12affaee22fe8)(1));
        if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'cache-and-network') fetchPolicy = 'network-only';
        if (!(0, $99WkW.equal)(this.variables, variables)) this.variables = (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, this.variables), variables);
        if (!(0, $99WkW.equal)(this.options.variables, this.variables)) this.options.variables = (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, this.options.variables), this.variables);
        return this.queryManager.fetchQuery(this.queryId, (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, this.options), {
            fetchPolicy: fetchPolicy
        }), $cb292de0bef73a33$export$160bafb6ac1e0641.refetch);
    };
    ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
        var _this = this;
        (0, $6bc7ad95682943c0$export$f5708dca728d7177)(fetchMoreOptions.updateQuery, 2);
        var combinedOptions = (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, $3UfL2.__assign)((0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, this.options), fetchMoreOptions), {
            variables: (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, this.variables), fetchMoreOptions.variables)
        })), {
            fetchPolicy: 'network-only'
        });
        var qid = this.queryManager.generateQueryId();
        return this.queryManager.fetchQuery(qid, combinedOptions, $cb292de0bef73a33$export$160bafb6ac1e0641.normal, this.queryId).then(function(fetchMoreResult) {
            _this.updateQuery(function(previousResult) {
                return fetchMoreOptions.updateQuery(previousResult, {
                    fetchMoreResult: fetchMoreResult.data,
                    variables: combinedOptions.variables
                });
            });
            _this.queryManager.stopQuery(qid);
            return fetchMoreResult;
        }, function(error) {
            _this.queryManager.stopQuery(qid);
            throw error;
        });
    };
    ObservableQuery.prototype.subscribeToMore = function(options) {
        var _this = this;
        var subscription = this.queryManager.startGraphQLSubscription({
            query: options.document,
            variables: options.variables
        }).subscribe({
            next: function(subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) _this.updateQuery(function(previous, _a) {
                    var variables = _a.variables;
                    return updateQuery(previous, {
                        subscriptionData: subscriptionData,
                        variables: variables
                    });
                });
            },
            error: function(err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
            }
        });
        this.subscriptions.add(subscription);
        return function() {
            if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
        };
    };
    ObservableQuery.prototype.setOptions = function(opts) {
        var oldFetchPolicy = this.options.fetchPolicy;
        this.options = (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, this.options), opts);
        if (opts.pollInterval) this.startPolling(opts.pollInterval);
        else if (opts.pollInterval === 0) this.stopPolling();
        var fetchPolicy = opts.fetchPolicy;
        return this.setVariables(this.options.variables, oldFetchPolicy !== fetchPolicy && (oldFetchPolicy === 'cache-only' || oldFetchPolicy === 'standby' || fetchPolicy === 'network-only'), opts.fetchResults);
    };
    ObservableQuery.prototype.setVariables = function(variables, tryFetch, fetchResults) {
        if (tryFetch === void 0) tryFetch = false;
        if (fetchResults === void 0) fetchResults = true;
        this.isTornDown = false;
        variables = variables || this.variables;
        if (!tryFetch && (0, $99WkW.equal)(variables, this.variables)) return this.observers.size && fetchResults ? this.result() : Promise.resolve();
        this.variables = this.options.variables = variables;
        if (!this.observers.size) return Promise.resolve();
        return this.queryManager.fetchQuery(this.queryId, this.options);
    };
    ObservableQuery.prototype.updateQuery = function(mapFn) {
        var queryManager = this.queryManager;
        var _a = queryManager.getQueryWithPreviousResult(this.queryId), previousResult = _a.previousResult, variables = _a.variables, document = _a.document;
        var newResult = (0, $gODea.tryFunctionOrLogError)(function() {
            return mapFn(previousResult, {
                variables: variables
            });
        });
        if (newResult) {
            queryManager.dataStore.markUpdateQueryResult(document, variables, newResult);
            queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.stopPolling = function() {
        this.queryManager.stopPollingQuery(this.queryId);
        this.options.pollInterval = undefined;
    };
    ObservableQuery.prototype.startPolling = function(pollInterval) {
        $cb292de0bef73a33$var$assertNotCacheFirstOrOnly(this);
        this.options.pollInterval = pollInterval;
        this.queryManager.startPollingQuery(this.options, this.queryId);
    };
    ObservableQuery.prototype.updateLastResult = function(newResult) {
        var previousResult = this.lastResult;
        this.lastResult = newResult;
        this.lastResultSnapshot = this.queryManager.assumeImmutableResults ? newResult : (0, $gODea.cloneDeep)(newResult);
        return previousResult;
    };
    ObservableQuery.prototype.onSubscribe = function(observer) {
        var _this = this;
        try {
            var subObserver = observer._subscription._observer;
            if (subObserver && !subObserver.error) subObserver.error = $cb292de0bef73a33$var$defaultSubscriptionObserverErrorCallback;
        } catch (_a) {}
        var first = !this.observers.size;
        this.observers.add(observer);
        if (observer.next && this.lastResult) observer.next(this.lastResult);
        if (observer.error && this.lastError) observer.error(this.lastError);
        if (first) this.setUpQuery();
        return function() {
            if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
        };
    };
    ObservableQuery.prototype.setUpQuery = function() {
        var _this = this;
        var _a = this, queryManager = _a.queryManager, queryId = _a.queryId;
        if (this.shouldSubscribe) queryManager.addObservableQuery(queryId, this);
        if (this.options.pollInterval) {
            $cb292de0bef73a33$var$assertNotCacheFirstOrOnly(this);
            queryManager.startPollingQuery(this.options, queryId);
        }
        var onError = function(error) {
            _this.updateLastResult((0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, _this.lastResult), {
                errors: error.graphQLErrors,
                networkStatus: $cb292de0bef73a33$export$bd096ddbd246c79c.error,
                loading: false
            }));
            $cb292de0bef73a33$var$iterateObserversSafely(_this.observers, 'error', _this.lastError = error);
        };
        queryManager.observeQuery(queryId, this.options, {
            next: function(result) {
                if (_this.lastError || _this.isDifferentFromLastResult(result)) {
                    var previousResult_1 = _this.updateLastResult(result);
                    var _a = _this.options, query_1 = _a.query, variables = _a.variables, fetchPolicy_1 = _a.fetchPolicy;
                    if (queryManager.transform(query_1).hasClientExports) queryManager.getLocalState().addExportedVariables(query_1, variables).then(function(variables) {
                        var previousVariables = _this.variables;
                        _this.variables = _this.options.variables = variables;
                        if (!result.loading && previousResult_1 && fetchPolicy_1 !== 'cache-only' && queryManager.transform(query_1).serverQuery && !(0, $99WkW.equal)(previousVariables, variables)) _this.refetch();
                        else $cb292de0bef73a33$var$iterateObserversSafely(_this.observers, 'next', result);
                    });
                    else $cb292de0bef73a33$var$iterateObserversSafely(_this.observers, 'next', result);
                }
            },
            error: onError
        }).catch(onError);
    };
    ObservableQuery.prototype.tearDownQuery = function() {
        var queryManager = this.queryManager;
        this.isTornDown = true;
        queryManager.stopPollingQuery(this.queryId);
        this.subscriptions.forEach(function(sub) {
            return sub.unsubscribe();
        });
        this.subscriptions.clear();
        queryManager.removeObservableQuery(this.queryId);
        queryManager.stopQuery(this.queryId);
        this.observers.clear();
    };
    return ObservableQuery;
}($cb292de0bef73a33$var$Observable);
function $cb292de0bef73a33$var$defaultSubscriptionObserverErrorCallback(error) {}
function $cb292de0bef73a33$var$iterateObserversSafely(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function(obs) {
        return obs[method] && observersWithMethod.push(obs);
    });
    observersWithMethod.forEach(function(obs) {
        return obs[method](argument);
    });
}
function $cb292de0bef73a33$var$assertNotCacheFirstOrOnly(obsQuery) {
    var fetchPolicy = obsQuery.options.fetchPolicy;
    (0, $6bc7ad95682943c0$export$f5708dca728d7177)(fetchPolicy !== 'cache-first' && fetchPolicy !== 'cache-only', 3);
}
var $cb292de0bef73a33$var$MutationStore = function() {
    function MutationStore() {
        this.store = {};
    }
    MutationStore.prototype.getStore = function() {
        return this.store;
    };
    MutationStore.prototype.get = function(mutationId) {
        return this.store[mutationId];
    };
    MutationStore.prototype.initMutation = function(mutationId, mutation, variables) {
        this.store[mutationId] = {
            mutation: mutation,
            variables: variables || {},
            loading: true,
            error: null
        };
    };
    MutationStore.prototype.markMutationError = function(mutationId, error) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = error;
        }
    };
    MutationStore.prototype.markMutationResult = function(mutationId) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = null;
        }
    };
    MutationStore.prototype.reset = function() {
        this.store = {};
    };
    return MutationStore;
}();
var $cb292de0bef73a33$var$QueryStore = function() {
    function QueryStore() {
        this.store = {};
    }
    QueryStore.prototype.getStore = function() {
        return this.store;
    };
    QueryStore.prototype.get = function(queryId) {
        return this.store[queryId];
    };
    QueryStore.prototype.initQuery = function(query) {
        var previousQuery = this.store[query.queryId];
        (0, $6bc7ad95682943c0$export$f5708dca728d7177)(!previousQuery || previousQuery.document === query.document || (0, $99WkW.equal)(previousQuery.document, query.document), 19);
        var isSetVariables = false;
        var previousVariables = null;
        if (query.storePreviousVariables && previousQuery && previousQuery.networkStatus !== $cb292de0bef73a33$export$bd096ddbd246c79c.loading) {
            if (!(0, $99WkW.equal)(previousQuery.variables, query.variables)) {
                isSetVariables = true;
                previousVariables = previousQuery.variables;
            }
        }
        var networkStatus;
        if (isSetVariables) networkStatus = $cb292de0bef73a33$export$bd096ddbd246c79c.setVariables;
        else if (query.isPoll) networkStatus = $cb292de0bef73a33$export$bd096ddbd246c79c.poll;
        else if (query.isRefetch) networkStatus = $cb292de0bef73a33$export$bd096ddbd246c79c.refetch;
        else networkStatus = $cb292de0bef73a33$export$bd096ddbd246c79c.loading;
        var graphQLErrors = [];
        if (previousQuery && previousQuery.graphQLErrors) graphQLErrors = previousQuery.graphQLErrors;
        this.store[query.queryId] = {
            document: query.document,
            variables: query.variables,
            previousVariables: previousVariables,
            networkError: null,
            graphQLErrors: graphQLErrors,
            networkStatus: networkStatus,
            metadata: query.metadata
        };
        if (typeof query.fetchMoreForQueryId === 'string' && this.store[query.fetchMoreForQueryId]) this.store[query.fetchMoreForQueryId].networkStatus = $cb292de0bef73a33$export$bd096ddbd246c79c.fetchMore;
    };
    QueryStore.prototype.markQueryResult = function(queryId, result, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = null;
        this.store[queryId].graphQLErrors = $cb292de0bef73a33$var$isNonEmptyArray(result.errors) ? result.errors : [];
        this.store[queryId].previousVariables = null;
        this.store[queryId].networkStatus = $cb292de0bef73a33$export$bd096ddbd246c79c.ready;
        if (typeof fetchMoreForQueryId === 'string' && this.store[fetchMoreForQueryId]) this.store[fetchMoreForQueryId].networkStatus = $cb292de0bef73a33$export$bd096ddbd246c79c.ready;
    };
    QueryStore.prototype.markQueryError = function(queryId, error, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = error;
        this.store[queryId].networkStatus = $cb292de0bef73a33$export$bd096ddbd246c79c.error;
        if (typeof fetchMoreForQueryId === 'string') this.markQueryResultClient(fetchMoreForQueryId, true);
    };
    QueryStore.prototype.markQueryResultClient = function(queryId, complete) {
        var storeValue = this.store && this.store[queryId];
        if (storeValue) {
            storeValue.networkError = null;
            storeValue.previousVariables = null;
            if (complete) storeValue.networkStatus = $cb292de0bef73a33$export$bd096ddbd246c79c.ready;
        }
    };
    QueryStore.prototype.stopQuery = function(queryId) {
        delete this.store[queryId];
    };
    QueryStore.prototype.reset = function(observableQueryIds) {
        var _this = this;
        Object.keys(this.store).forEach(function(queryId) {
            if (observableQueryIds.indexOf(queryId) < 0) _this.stopQuery(queryId);
            else _this.store[queryId].networkStatus = $cb292de0bef73a33$export$bd096ddbd246c79c.loading;
        });
    };
    return QueryStore;
}();
function $cb292de0bef73a33$var$capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
var $cb292de0bef73a33$var$LocalState = function() {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.cache = cache;
        if (client) this.client = client;
        if (resolvers) this.addResolvers(resolvers);
        if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
    }
    LocalState.prototype.addResolvers = function(resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
            _this.resolvers = (0, $gODea.mergeDeep)(_this.resolvers, resolverGroup);
        });
        else this.resolvers = (0, $gODea.mergeDeep)(this.resolvers, resolvers);
    };
    LocalState.prototype.setResolvers = function(resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function() {
        return this.resolvers || {};
    };
    LocalState.prototype.runResolvers = function(_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return (0, $3UfL2.__awaiter)(this, void 0, void 0, function() {
            return (0, $3UfL2.__generator)(this, function(_c) {
                if (document) return [
                    2,
                    this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                        return (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, remoteResult), {
                            data: localResult.result
                        });
                    })
                ];
                return [
                    2,
                    remoteResult
                ];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function() {
        return this.fragmentMatcher;
    };
    LocalState.prototype.clientQuery = function(document) {
        if ((0, $gODea.hasDirectives)([
            'client'
        ], document)) {
            if (this.resolvers) return document;
        }
        return null;
    };
    LocalState.prototype.serverQuery = function(document) {
        return this.resolvers ? (0, $gODea.removeClientSetsFromDocument)(document) : document;
    };
    LocalState.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var cache = this.cache;
        var newContext = (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, context), {
            cache: cache,
            getCacheKey: function(obj) {
                if (cache.config) return cache.config.dataIdFromObject(obj);
                else (0, $6bc7ad95682943c0$export$f5708dca728d7177)(false, 6);
            }
        });
        return newContext;
    };
    LocalState.prototype.addExportedVariables = function(document, variables, context) {
        if (variables === void 0) variables = {};
        if (context === void 0) context = {};
        return (0, $3UfL2.__awaiter)(this, void 0, void 0, function() {
            return (0, $3UfL2.__generator)(this, function(_a) {
                if (document) return [
                    2,
                    this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                        return (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, variables), data.exportedVariables);
                    })
                ];
                return [
                    2,
                    (0, $3UfL2.__assign)({}, variables)
                ];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function(document) {
        var forceResolvers = false;
        (0, $dUQHG.visit)(document, {
            Directive: {
                enter: function(node) {
                    if (node.name.value === 'client' && node.arguments) {
                        forceResolvers = node.arguments.some(function(arg) {
                            return arg.name.value === 'always' && arg.value.kind === 'BooleanValue' && arg.value.value === true;
                        });
                        if (forceResolvers) return 0, $dUQHG.BREAK;
                    }
                }
            }
        });
        return forceResolvers;
    };
    LocalState.prototype.buildRootValueFromCache = function(document, variables) {
        return this.cache.diff({
            query: (0, $gODea.buildQueryFromSelectionSet)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false
        }).result;
    };
    LocalState.prototype.resolveDocument = function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) context = {};
        if (variables === void 0) variables = {};
        if (fragmentMatcher === void 0) fragmentMatcher = function() {
            return true;
        };
        if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
        return (0, $3UfL2.__awaiter)(this, void 0, void 0, function() {
            var mainDefinition, fragments, fragmentMap, definitionOperation, defaultOperationType, _a, cache, client, execContext;
            return (0, $3UfL2.__generator)(this, function(_b) {
                mainDefinition = (0, $gODea.getMainDefinition)(document);
                fragments = (0, $gODea.getFragmentDefinitions)(document);
                fragmentMap = (0, $gODea.createFragmentMap)(fragments);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ? $cb292de0bef73a33$var$capitalizeFirstLetter(definitionOperation) : 'Query';
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, context), {
                        cache: cache,
                        client: client
                    }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    onlyRunForcedResolvers: onlyRunForcedResolvers
                };
                return [
                    2,
                    this.resolveSelectionSet(mainDefinition.selectionSet, rootValue, execContext).then(function(result) {
                        return {
                            result: result,
                            exportedVariables: execContext.exportedVariables
                        };
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function(selectionSet, rootValue, execContext) {
        return (0, $3UfL2.__awaiter)(this, void 0, void 0, function() {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0, $3UfL2.__generator)(this, function(_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [
                    rootValue
                ];
                execute = function(selection) {
                    return (0, $3UfL2.__awaiter)(_this, void 0, void 0, function() {
                        var fragment, typeCondition;
                        return (0, $3UfL2.__generator)(this, function(_a) {
                            if (!(0, $gODea.shouldInclude)(selection, variables)) return [
                                2
                            ];
                            if ((0, $gODea.isField)(selection)) return [
                                2,
                                this.resolveField(selection, rootValue, execContext).then(function(fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== 'undefined') resultsToMerge.push((_a = {}, _a[(0, $gODea.resultKeyNameFromField)(selection)] = fieldResult, _a));
                                })
                            ];
                            if ((0, $gODea.isInlineFragment)(selection)) fragment = selection;
                            else {
                                fragment = fragmentMap[selection.name.value];
                                (0, $6bc7ad95682943c0$export$f5708dca728d7177)(fragment, 7);
                            }
                            if (fragment && fragment.typeCondition) {
                                typeCondition = fragment.typeCondition.name.value;
                                if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                    2,
                                    this.resolveSelectionSet(fragment.selectionSet, rootValue, execContext).then(function(fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })
                                ];
                            }
                            return [
                                2
                            ];
                        });
                    });
                };
                return [
                    2,
                    Promise.all(selectionSet.selections.map(execute)).then(function() {
                        return (0, $gODea.mergeDeepArray)(resultsToMerge);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveField = function(field, rootValue, execContext) {
        return (0, $3UfL2.__awaiter)(this, void 0, void 0, function() {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0, $3UfL2.__generator)(this, function(_a) {
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0, $gODea.resultKeyNameFromField)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) resultPromise = Promise.resolve(resolve(rootValue, (0, $gODea.argumentsObjectFromField)(field, variables), execContext.context, {
                            field: field,
                            fragmentMap: execContext.fragmentMap
                        }));
                    }
                }
                return [
                    2,
                    resultPromise.then(function(result) {
                        if (result === void 0) result = defaultResult;
                        if (field.directives) field.directives.forEach(function(directive) {
                            if (directive.name.value === 'export' && directive.arguments) directive.arguments.forEach(function(arg) {
                                if (arg.name.value === 'as' && arg.value.kind === 'StringValue') execContext.exportedVariables[arg.value.value] = result;
                            });
                        });
                        if (!field.selectionSet) return result;
                        if (result == null) return result;
                        if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, result, execContext);
                        if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, result, execContext);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function(field, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, item, execContext);
            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, item, execContext);
        }));
    };
    return LocalState;
}();
function $cb292de0bef73a33$var$multiplex(inner) {
    var observers = new Set();
    var sub = null;
    return new $cb292de0bef73a33$var$Observable(function(observer) {
        observers.add(observer);
        sub = sub || inner.subscribe({
            next: function(value) {
                observers.forEach(function(obs) {
                    return obs.next && obs.next(value);
                });
            },
            error: function(error) {
                observers.forEach(function(obs) {
                    return obs.error && obs.error(error);
                });
            },
            complete: function() {
                observers.forEach(function(obs) {
                    return obs.complete && obs.complete();
                });
            }
        });
        return function() {
            if (observers.delete(observer) && !observers.size && sub) {
                sub.unsubscribe();
                sub = null;
            }
        };
    });
}
function $cb292de0bef73a33$var$asyncMap(observable, mapFn) {
    return new $cb292de0bef73a33$var$Observable(function(observer) {
        var next = observer.next, error = observer.error, complete = observer.complete;
        var activeNextCount = 0;
        var completed = false;
        var handler = {
            next: function(value) {
                ++activeNextCount;
                new Promise(function(resolve) {
                    resolve(mapFn(value));
                }).then(function(result) {
                    --activeNextCount;
                    next && next.call(observer, result);
                    completed && handler.complete();
                }, function(e) {
                    --activeNextCount;
                    error && error.call(observer, e);
                });
            },
            error: function(e) {
                error && error.call(observer, e);
            },
            complete: function() {
                completed = true;
                if (!activeNextCount) complete && complete.call(observer);
            }
        };
        var sub = observable.subscribe(handler);
        return function() {
            return sub.unsubscribe();
        };
    });
}
var $cb292de0bef73a33$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $cb292de0bef73a33$var$QueryManager = function() {
    function QueryManager(_a) {
        var link = _a.link, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, store = _a.store, _c = _a.onBroadcast, onBroadcast = _c === void 0 ? function() {
            return undefined;
        } : _c, _d = _a.ssrMode, ssrMode = _d === void 0 ? false : _d, _e = _a.clientAwareness, clientAwareness = _e === void 0 ? {} : _e, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
        this.mutationStore = new $cb292de0bef73a33$var$MutationStore();
        this.queryStore = new $cb292de0bef73a33$var$QueryStore();
        this.clientAwareness = {};
        this.idCounter = 1;
        this.queries = new Map();
        this.fetchQueryRejectFns = new Map();
        this.transformCache = new ((0, $gODea.canUseWeakMap) ? WeakMap : Map)();
        this.inFlightLinkObservables = new Map();
        this.pollingInfoByQueryId = new Map();
        this.link = link;
        this.queryDeduplication = queryDeduplication;
        this.dataStore = store;
        this.onBroadcast = onBroadcast;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new $cb292de0bef73a33$var$LocalState({
            cache: store.getCache()
        });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = !!assumeImmutableResults;
    }
    QueryManager.prototype.stop = function() {
        var _this = this;
        this.queries.forEach(function(_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $6bc7ad95682943c0$export$cea12affaee22fe8)(8));
        });
    };
    QueryManager.prototype.mutate = function(_a) {
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueriesByName = _a.updateQueries, _b = _a.refetchQueries, refetchQueries = _b === void 0 ? [] : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, updateWithProxyFn = _a.update, _d = _a.errorPolicy, errorPolicy = _d === void 0 ? 'none' : _d, fetchPolicy = _a.fetchPolicy, _e = _a.context, context = _e === void 0 ? {} : _e;
        return (0, $3UfL2.__awaiter)(this, void 0, void 0, function() {
            var mutationId, generateUpdateQueriesInfo, self;
            var _this = this;
            return (0, $3UfL2.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        (0, $6bc7ad95682943c0$export$f5708dca728d7177)(mutation, 9);
                        (0, $6bc7ad95682943c0$export$f5708dca728d7177)(!fetchPolicy || fetchPolicy === 'no-cache', 10);
                        mutationId = this.generateQueryId();
                        mutation = this.transform(mutation).document;
                        this.setQuery(mutationId, function() {
                            return {
                                document: mutation
                            };
                        });
                        variables = this.getVariables(mutation, variables);
                        if (!this.transform(mutation).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(mutation, variables, context)
                        ];
                    case 1:
                        variables = _f.sent();
                        _f.label = 2;
                    case 2:
                        generateUpdateQueriesInfo = function() {
                            var ret = {};
                            if (updateQueriesByName) _this.queries.forEach(function(_a, queryId) {
                                var observableQuery = _a.observableQuery;
                                if (observableQuery) {
                                    var queryName = observableQuery.queryName;
                                    if (queryName && $cb292de0bef73a33$var$hasOwnProperty.call(updateQueriesByName, queryName)) ret[queryId] = {
                                        updater: updateQueriesByName[queryName],
                                        query: _this.queryStore.get(queryId)
                                    };
                                }
                            });
                            return ret;
                        };
                        this.mutationStore.initMutation(mutationId, mutation, variables);
                        this.dataStore.markMutationInit({
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            updateQueries: generateUpdateQueriesInfo(),
                            update: updateWithProxyFn,
                            optimisticResponse: optimisticResponse
                        });
                        this.broadcastQueries();
                        self = this;
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                var storeResult;
                                var error;
                                self.getObservableFromLink(mutation, (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, context), {
                                    optimisticResponse: optimisticResponse
                                }), variables, false).subscribe({
                                    next: function(result) {
                                        if ((0, $gODea.graphQLResultHasError)(result) && errorPolicy === 'none') {
                                            error = new $cb292de0bef73a33$export$26a337512320b8c6({
                                                graphQLErrors: result.errors
                                            });
                                            return;
                                        }
                                        self.mutationStore.markMutationResult(mutationId);
                                        if (fetchPolicy !== 'no-cache') self.dataStore.markMutationResult({
                                            mutationId: mutationId,
                                            result: result,
                                            document: mutation,
                                            variables: variables,
                                            updateQueries: generateUpdateQueriesInfo(),
                                            update: updateWithProxyFn
                                        });
                                        storeResult = result;
                                    },
                                    error: function(err) {
                                        self.mutationStore.markMutationError(mutationId, err);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        self.setQuery(mutationId, function() {
                                            return {
                                                document: null
                                            };
                                        });
                                        reject(new $cb292de0bef73a33$export$26a337512320b8c6({
                                            networkError: err
                                        }));
                                    },
                                    complete: function() {
                                        if (error) self.mutationStore.markMutationError(mutationId, error);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        if (error) {
                                            reject(error);
                                            return;
                                        }
                                        if (typeof refetchQueries === 'function') refetchQueries = refetchQueries(storeResult);
                                        var refetchQueryPromises = [];
                                        if ($cb292de0bef73a33$var$isNonEmptyArray(refetchQueries)) refetchQueries.forEach(function(refetchQuery) {
                                            if (typeof refetchQuery === 'string') self.queries.forEach(function(_a) {
                                                var observableQuery = _a.observableQuery;
                                                if (observableQuery && observableQuery.queryName === refetchQuery) refetchQueryPromises.push(observableQuery.refetch());
                                            });
                                            else {
                                                var queryOptions = {
                                                    query: refetchQuery.query,
                                                    variables: refetchQuery.variables,
                                                    fetchPolicy: 'network-only'
                                                };
                                                if (refetchQuery.context) queryOptions.context = refetchQuery.context;
                                                refetchQueryPromises.push(self.query(queryOptions));
                                            }
                                        });
                                        Promise.all(awaitRefetchQueries ? refetchQueryPromises : []).then(function() {
                                            self.setQuery(mutationId, function() {
                                                return {
                                                    document: null
                                                };
                                            });
                                            if (errorPolicy === 'ignore' && storeResult && (0, $gODea.graphQLResultHasError)(storeResult)) delete storeResult.errors;
                                            resolve(storeResult);
                                        });
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    QueryManager.prototype.fetchQuery = function(queryId, options, fetchType, fetchMoreForQueryId) {
        return (0, $3UfL2.__awaiter)(this, void 0, void 0, function() {
            var _a, metadata, _b, fetchPolicy, _c, context, query, variables, storeResult, isNetworkOnly, needToFetch, _d, complete, result, shouldFetch, requestId, cancel, networkResult;
            var _this = this;
            return (0, $3UfL2.__generator)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _a = options.metadata, metadata = _a === void 0 ? null : _a, _b = options.fetchPolicy, fetchPolicy = _b === void 0 ? 'cache-first' : _b, _c = options.context, context = _c === void 0 ? {} : _c;
                        query = this.transform(options.query).document;
                        variables = this.getVariables(query, options.variables);
                        if (!this.transform(query).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(query, variables, context)
                        ];
                    case 1:
                        variables = _e.sent();
                        _e.label = 2;
                    case 2:
                        options = (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, options), {
                            variables: variables
                        });
                        isNetworkOnly = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
                        needToFetch = isNetworkOnly;
                        if (!isNetworkOnly) {
                            _d = this.dataStore.getCache().diff({
                                query: query,
                                variables: variables,
                                returnPartialData: true,
                                optimistic: false
                            }), complete = _d.complete, result = _d.result;
                            needToFetch = !complete || fetchPolicy === 'cache-and-network';
                            storeResult = result;
                        }
                        shouldFetch = needToFetch && fetchPolicy !== 'cache-only' && fetchPolicy !== 'standby';
                        if ((0, $gODea.hasDirectives)([
                            'live'
                        ], query)) shouldFetch = true;
                        requestId = this.idCounter++;
                        cancel = fetchPolicy !== 'no-cache' ? this.updateQueryWatch(queryId, query, options) : undefined;
                        this.setQuery(queryId, function() {
                            return {
                                document: query,
                                lastRequestId: requestId,
                                invalidated: true,
                                cancel: cancel
                            };
                        });
                        this.invalidate(fetchMoreForQueryId);
                        this.queryStore.initQuery({
                            queryId: queryId,
                            document: query,
                            storePreviousVariables: shouldFetch,
                            variables: variables,
                            isPoll: fetchType === $cb292de0bef73a33$export$160bafb6ac1e0641.poll,
                            isRefetch: fetchType === $cb292de0bef73a33$export$160bafb6ac1e0641.refetch,
                            metadata: metadata,
                            fetchMoreForQueryId: fetchMoreForQueryId
                        });
                        this.broadcastQueries();
                        if (shouldFetch) {
                            networkResult = this.fetchRequest({
                                requestId: requestId,
                                queryId: queryId,
                                document: query,
                                options: options,
                                fetchMoreForQueryId: fetchMoreForQueryId
                            }).catch(function(error) {
                                if ($cb292de0bef73a33$export$17f5e6bd290bb15d(error)) throw error;
                                else {
                                    if (requestId >= _this.getQuery(queryId).lastRequestId) {
                                        _this.queryStore.markQueryError(queryId, error, fetchMoreForQueryId);
                                        _this.invalidate(queryId);
                                        _this.invalidate(fetchMoreForQueryId);
                                        _this.broadcastQueries();
                                    }
                                    throw new $cb292de0bef73a33$export$26a337512320b8c6({
                                        networkError: error
                                    });
                                }
                            });
                            if (fetchPolicy !== 'cache-and-network') return [
                                2,
                                networkResult
                            ];
                            networkResult.catch(function() {});
                        }
                        this.queryStore.markQueryResultClient(queryId, !shouldFetch);
                        this.invalidate(queryId);
                        this.invalidate(fetchMoreForQueryId);
                        if (this.transform(query).hasForcedResolvers) return [
                            2,
                            this.localState.runResolvers({
                                document: query,
                                remoteResult: {
                                    data: storeResult
                                },
                                context: context,
                                variables: variables,
                                onlyRunForcedResolvers: true
                            }).then(function(result) {
                                _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                                _this.broadcastQueries();
                                return result;
                            })
                        ];
                        this.broadcastQueries();
                        return [
                            2,
                            {
                                data: storeResult
                            }
                        ];
                }
            });
        });
    };
    QueryManager.prototype.markQueryResult = function(queryId, result, _a, fetchMoreForQueryId) {
        var fetchPolicy = _a.fetchPolicy, variables = _a.variables, errorPolicy = _a.errorPolicy;
        if (fetchPolicy === 'no-cache') this.setQuery(queryId, function() {
            return {
                newData: {
                    result: result.data,
                    complete: true
                }
            };
        });
        else this.dataStore.markQueryResult(result, this.getQuery(queryId).document, variables, fetchMoreForQueryId, errorPolicy === 'ignore' || errorPolicy === 'all');
    };
    QueryManager.prototype.queryListenerForObserver = function(queryId, options, observer) {
        var _this = this;
        function invoke(method, argument) {
            if (observer[method]) try {
                observer[method](argument);
            } catch (e) {}
            else method;
        }
        return function(queryStoreValue, newData) {
            _this.invalidate(queryId, false);
            if (!queryStoreValue) return;
            var _a = _this.getQuery(queryId), observableQuery = _a.observableQuery, document = _a.document;
            var fetchPolicy = observableQuery ? observableQuery.options.fetchPolicy : options.fetchPolicy;
            if (fetchPolicy === 'standby') return;
            var loading = $cb292de0bef73a33$var$isNetworkRequestInFlight(queryStoreValue.networkStatus);
            var lastResult = observableQuery && observableQuery.getLastResult();
            var networkStatusChanged = !!(lastResult && lastResult.networkStatus !== queryStoreValue.networkStatus);
            var shouldNotifyIfLoading = options.returnPartialData || !newData && queryStoreValue.previousVariables || networkStatusChanged && options.notifyOnNetworkStatusChange || fetchPolicy === 'cache-only' || fetchPolicy === 'cache-and-network';
            if (loading && !shouldNotifyIfLoading) return;
            var hasGraphQLErrors = $cb292de0bef73a33$var$isNonEmptyArray(queryStoreValue.graphQLErrors);
            var errorPolicy = observableQuery && observableQuery.options.errorPolicy || options.errorPolicy || 'none';
            if (errorPolicy === 'none' && hasGraphQLErrors || queryStoreValue.networkError) return invoke('error', new $cb292de0bef73a33$export$26a337512320b8c6({
                graphQLErrors: queryStoreValue.graphQLErrors,
                networkError: queryStoreValue.networkError
            }));
            try {
                var data = void 0;
                var isMissing = void 0;
                if (newData) {
                    if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'network-only') _this.setQuery(queryId, function() {
                        return {
                            newData: null
                        };
                    });
                    data = newData.result;
                    isMissing = !newData.complete;
                } else {
                    var lastError = observableQuery && observableQuery.getLastError();
                    var errorStatusChanged = errorPolicy !== 'none' && (lastError && lastError.graphQLErrors) !== queryStoreValue.graphQLErrors;
                    if (lastResult && lastResult.data && !errorStatusChanged) {
                        data = lastResult.data;
                        isMissing = false;
                    } else {
                        var diffResult = _this.dataStore.getCache().diff({
                            query: document,
                            variables: queryStoreValue.previousVariables || queryStoreValue.variables,
                            returnPartialData: true,
                            optimistic: true
                        });
                        data = diffResult.result;
                        isMissing = !diffResult.complete;
                    }
                }
                var stale = isMissing && !(options.returnPartialData || fetchPolicy === 'cache-only');
                var resultFromStore = {
                    data: stale ? lastResult && lastResult.data : data,
                    loading: loading,
                    networkStatus: queryStoreValue.networkStatus,
                    stale: stale
                };
                if (errorPolicy === 'all' && hasGraphQLErrors) resultFromStore.errors = queryStoreValue.graphQLErrors;
                invoke('next', resultFromStore);
            } catch (networkError) {
                invoke('error', new $cb292de0bef73a33$export$26a337512320b8c6({
                    networkError: networkError
                }));
            }
        };
    };
    QueryManager.prototype.transform = function(document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var cache = this.dataStore.getCache();
            var transformed = cache.transformDocument(document);
            var forLink = (0, $gODea.removeConnectionDirectiveFromDocument)(cache.transformForLink(transformed));
            var clientQuery = this.localState.clientQuery(transformed);
            var serverQuery = this.localState.serverQuery(forLink);
            var cacheEntry_1 = {
                document: transformed,
                hasClientExports: (0, $gODea.hasClientExports)(transformed),
                hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                clientQuery: clientQuery,
                serverQuery: serverQuery,
                defaultVars: (0, $gODea.getDefaultValues)((0, $gODea.getOperationDefinition)(transformed))
            };
            var add = function(doc) {
                if (doc && !transformCache.has(doc)) transformCache.set(doc, cacheEntry_1);
            };
            add(document);
            add(transformed);
            add(clientQuery);
            add(serverQuery);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function(document, variables) {
        return (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, this.transform(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function(options, shouldSubscribe) {
        if (shouldSubscribe === void 0) shouldSubscribe = true;
        (0, $6bc7ad95682943c0$export$f5708dca728d7177)(options.fetchPolicy !== 'standby', 11);
        options.variables = this.getVariables(options.query, options.variables);
        if (typeof options.notifyOnNetworkStatusChange === 'undefined') options.notifyOnNetworkStatusChange = false;
        var transformedOptions = (0, $3UfL2.__assign)({}, options);
        return new $cb292de0bef73a33$export$6c1b56eac59c9584({
            queryManager: this,
            options: transformedOptions,
            shouldSubscribe: shouldSubscribe
        });
    };
    QueryManager.prototype.query = function(options) {
        var _this = this;
        (0, $6bc7ad95682943c0$export$f5708dca728d7177)(options.query, 12);
        (0, $6bc7ad95682943c0$export$f5708dca728d7177)(options.query.kind === 'Document', 13);
        (0, $6bc7ad95682943c0$export$f5708dca728d7177)(!options.returnPartialData, 14);
        (0, $6bc7ad95682943c0$export$f5708dca728d7177)(!options.pollInterval, 15);
        return new Promise(function(resolve, reject) {
            var watchedQuery = _this.watchQuery(options, false);
            _this.fetchQueryRejectFns.set("query:" + watchedQuery.queryId, reject);
            watchedQuery.result().then(resolve, reject).then(function() {
                return _this.fetchQueryRejectFns.delete("query:" + watchedQuery.queryId);
            });
        });
    };
    QueryManager.prototype.generateQueryId = function() {
        return String(this.idCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
        this.stopPollingQuery(queryId);
        this.queryStore.stopQuery(queryId);
        this.invalidate(queryId);
    };
    QueryManager.prototype.addQueryListener = function(queryId, listener) {
        this.setQuery(queryId, function(_a) {
            var listeners = _a.listeners;
            listeners.add(listener);
            return {
                invalidated: false
            };
        });
    };
    QueryManager.prototype.updateQueryWatch = function(queryId, document, options) {
        var _this = this;
        var cancel = this.getQuery(queryId).cancel;
        if (cancel) cancel();
        var previousResult = function() {
            var previousResult = null;
            var observableQuery = _this.getQuery(queryId).observableQuery;
            if (observableQuery) {
                var lastResult = observableQuery.getLastResult();
                if (lastResult) previousResult = lastResult.data;
            }
            return previousResult;
        };
        return this.dataStore.getCache().watch({
            query: document,
            variables: options.variables,
            optimistic: true,
            previousResult: previousResult,
            callback: function(newData) {
                if (!$cb292de0bef73a33$export$13f5a5f0f1dbab88.__watchPerformanceImprovementsEnabled || newData.result !== previousResult()) _this.setQuery(queryId, function() {
                    return {
                        invalidated: true,
                        newData: newData
                    };
                });
            }
        });
    };
    QueryManager.prototype.addObservableQuery = function(queryId, observableQuery) {
        this.setQuery(queryId, function() {
            return {
                observableQuery: observableQuery
            };
        });
    };
    QueryManager.prototype.removeObservableQuery = function(queryId) {
        var cancel = this.getQuery(queryId).cancel;
        this.setQuery(queryId, function() {
            return {
                observableQuery: null
            };
        });
        if (cancel) cancel();
    };
    QueryManager.prototype.clearStore = function() {
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $6bc7ad95682943c0$export$cea12affaee22fe8)(16));
        });
        var resetIds = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) resetIds.push(queryId);
        });
        this.queryStore.reset(resetIds);
        this.mutationStore.reset();
        return this.dataStore.reset();
    };
    QueryManager.prototype.resetStore = function() {
        var _this = this;
        return this.clearStore().then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
        var _this = this;
        if (includeStandby === void 0) includeStandby = false;
        var observableQueryPromises = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) {
                var fetchPolicy = observableQuery.options.fetchPolicy;
                observableQuery.resetLastResults();
                if (fetchPolicy !== 'cache-only' && (includeStandby || fetchPolicy !== 'standby')) observableQueryPromises.push(observableQuery.refetch());
                _this.setQuery(queryId, function() {
                    return {
                        newData: null
                    };
                });
                _this.invalidate(queryId);
            }
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.observeQuery = function(queryId, options, observer) {
        this.addQueryListener(queryId, this.queryListenerForObserver(queryId, options, observer));
        return this.fetchQuery(queryId, options);
    };
    QueryManager.prototype.startQuery = function(queryId, options, listener) {
        this.addQueryListener(queryId, listener);
        this.fetchQuery(queryId, options).catch(function() {
            return undefined;
        });
        return queryId;
    };
    QueryManager.prototype.startGraphQLSubscription = function(_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, variables = _a.variables;
        query = this.transform(query).document;
        variables = this.getVariables(query, variables);
        var makeObservable = function(variables) {
            return _this.getObservableFromLink(query, {}, variables, false).map(function(result) {
                if (!fetchPolicy || fetchPolicy !== 'no-cache') {
                    _this.dataStore.markSubscriptionResult(result, query, variables);
                    _this.broadcastQueries();
                }
                if ((0, $gODea.graphQLResultHasError)(result)) throw new $cb292de0bef73a33$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                });
                return result;
            });
        };
        if (this.transform(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables).then(makeObservable);
            return new $cb292de0bef73a33$var$Observable(function(observer) {
                var sub = null;
                observablePromise_1.then(function(observable) {
                    return sub = observable.subscribe(observer);
                }, observer.error);
                return function() {
                    return sub && sub.unsubscribe();
                };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function(queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function(queryId) {
        this.fetchQueryRejectFns.delete("query:" + queryId);
        this.fetchQueryRejectFns.delete("fetchRequest:" + queryId);
        this.getQuery(queryId).subscriptions.forEach(function(x) {
            return x.unsubscribe();
        });
        this.queries.delete(queryId);
    };
    QueryManager.prototype.getCurrentQueryResult = function(observableQuery, optimistic) {
        if (optimistic === void 0) optimistic = true;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query, fetchPolicy = _a.fetchPolicy, returnPartialData = _a.returnPartialData;
        var lastResult = observableQuery.getLastResult();
        var newData = this.getQuery(observableQuery.queryId).newData;
        if (newData && newData.complete) return {
            data: newData.result,
            partial: false
        };
        if (fetchPolicy === 'no-cache' || fetchPolicy === 'network-only') return {
            data: undefined,
            partial: false
        };
        var _b = this.dataStore.getCache().diff({
            query: query,
            variables: variables,
            previousResult: lastResult ? lastResult.data : undefined,
            returnPartialData: true,
            optimistic: optimistic
        }), result = _b.result, complete = _b.complete;
        return {
            data: complete || returnPartialData ? result : void 0,
            partial: !complete
        };
    };
    QueryManager.prototype.getQueryWithPreviousResult = function(queryIdOrObservable) {
        var observableQuery;
        if (typeof queryIdOrObservable === 'string') {
            var foundObserveableQuery = this.getQuery(queryIdOrObservable).observableQuery;
            (0, $6bc7ad95682943c0$export$f5708dca728d7177)(foundObserveableQuery, 17);
            observableQuery = foundObserveableQuery;
        } else observableQuery = queryIdOrObservable;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query;
        return {
            previousResult: this.getCurrentQueryResult(observableQuery, false).data,
            variables: variables,
            document: query
        };
    };
    QueryManager.prototype.broadcastQueries = function() {
        var _this = this;
        this.onBroadcast();
        this.queries.forEach(function(info, id) {
            if (info.invalidated) {
                const name = info && info.document && info.document.definitions && info.document.definitions[0] && info.document.definitions[0].name && info.document.definitions[0].name.value;
                const stats = typeof window !== 'undefined' && window && window.__APOLLO_STATS__ && window.__APOLLO_STATS__.broadcast;
                let start;
                if (name && stats) {
                    start = performance.now();
                    if (!(name in stats)) stats[name] = {
                        count: 0,
                        duration: 0
                    };
                    stats[name].count++;
                }
                info.listeners.forEach(function(listener) {
                    if (listener) listener(_this.queryStore.get(id), info.newData);
                });
                if (name && stats) stats[name].duration += performance.now() - start; // how long it took to broadcast
            }
        });
    };
    QueryManager.prototype.getLocalState = function() {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function(query, context, variables, deduplication) {
        var _this = this;
        if (deduplication === void 0) deduplication = this.queryDeduplication;
        var observable;
        var serverQuery = this.transform(query).serverQuery;
        if (serverQuery) {
            var _a = this, inFlightLinkObservables_1 = _a.inFlightLinkObservables, link = _a.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0, $gODea.getOperationName)(serverQuery) || void 0,
                context: this.prepareContext((0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, context), {
                    forceFetch: !deduplication
                }))
            };
            context = operation.context;
            if (deduplication) {
                var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                var varJson_1 = JSON.stringify(variables);
                observable = byVariables_1.get(varJson_1);
                if (!observable) {
                    byVariables_1.set(varJson_1, observable = $cb292de0bef73a33$var$multiplex((0, $7kiUr.execute)(link, operation)));
                    var cleanup = function() {
                        byVariables_1.delete(varJson_1);
                        if (!byVariables_1.size) inFlightLinkObservables_1.delete(serverQuery);
                        cleanupSub_1.unsubscribe();
                    };
                    var cleanupSub_1 = observable.subscribe({
                        next: cleanup,
                        error: cleanup,
                        complete: cleanup
                    });
                }
            } else observable = $cb292de0bef73a33$var$multiplex((0, $7kiUr.execute)(link, operation));
        } else {
            observable = $cb292de0bef73a33$var$Observable.of({
                data: {}
            });
            context = this.prepareContext(context);
        }
        var clientQuery = this.transform(query).clientQuery;
        if (clientQuery) observable = $cb292de0bef73a33$var$asyncMap(observable, function(result) {
            return _this.localState.runResolvers({
                document: clientQuery,
                remoteResult: result,
                context: context,
                variables: variables
            });
        });
        return observable;
    };
    QueryManager.prototype.fetchRequest = function(_a) {
        var _this = this;
        var requestId = _a.requestId, queryId = _a.queryId, document = _a.document, options = _a.options, fetchMoreForQueryId = _a.fetchMoreForQueryId;
        var variables = options.variables, _b = options.errorPolicy, errorPolicy = _b === void 0 ? 'none' : _b, fetchPolicy = options.fetchPolicy;
        var resultFromStore;
        var errorsFromStore;
        return new Promise(function(resolve, reject) {
            var observable = _this.getObservableFromLink(document, options.context, variables);
            var fqrfId = "fetchRequest:" + queryId;
            _this.fetchQueryRejectFns.set(fqrfId, reject);
            var cleanup = function() {
                _this.fetchQueryRejectFns.delete(fqrfId);
                _this.setQuery(queryId, function(_a) {
                    var subscriptions = _a.subscriptions;
                    subscriptions.delete(subscription);
                });
            };
            var subscription = observable.map(function(result) {
                if (requestId >= _this.getQuery(queryId).lastRequestId) {
                    _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                    _this.queryStore.markQueryResult(queryId, result, fetchMoreForQueryId);
                    _this.invalidate(queryId);
                    _this.invalidate(fetchMoreForQueryId);
                    _this.broadcastQueries();
                }
                if (errorPolicy === 'none' && $cb292de0bef73a33$var$isNonEmptyArray(result.errors)) return reject(new $cb292de0bef73a33$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                }));
                if (errorPolicy === 'all') errorsFromStore = result.errors;
                if (fetchMoreForQueryId || fetchPolicy === 'no-cache') resultFromStore = result.data;
                else {
                    var _a = _this.dataStore.getCache().diff({
                        variables: variables,
                        query: document,
                        optimistic: false,
                        returnPartialData: true
                    }), result_1 = _a.result, complete = _a.complete;
                    if (complete || options.returnPartialData) resultFromStore = result_1;
                }
            }).subscribe({
                error: function(error) {
                    cleanup();
                    reject(error);
                },
                complete: function() {
                    cleanup();
                    resolve({
                        data: resultFromStore,
                        errors: errorsFromStore,
                        loading: false,
                        networkStatus: $cb292de0bef73a33$export$bd096ddbd246c79c.ready,
                        stale: false
                    });
                }
            });
            _this.setQuery(queryId, function(_a) {
                var subscriptions = _a.subscriptions;
                subscriptions.add(subscription);
            });
        });
    };
    QueryManager.prototype.getQuery = function(queryId) {
        return this.queries.get(queryId) || {
            listeners: new Set(),
            invalidated: false,
            document: null,
            newData: null,
            lastRequestId: 1,
            observableQuery: null,
            subscriptions: new Set()
        };
    };
    QueryManager.prototype.setQuery = function(queryId, updater) {
        var prev = this.getQuery(queryId);
        var newInfo = (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, prev), updater(prev));
        this.queries.set(queryId, newInfo);
    };
    QueryManager.prototype.invalidate = function(queryId, invalidated) {
        if (invalidated === void 0) invalidated = true;
        if (queryId) this.setQuery(queryId, function() {
            return {
                invalidated: invalidated
            };
        });
    };
    QueryManager.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var newContext = this.localState.prepareContext(context);
        return (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, newContext), {
            clientAwareness: this.clientAwareness
        });
    };
    QueryManager.prototype.checkInFlight = function(queryId) {
        var query = this.queryStore.get(queryId);
        return query && query.networkStatus !== $cb292de0bef73a33$export$bd096ddbd246c79c.ready && query.networkStatus !== $cb292de0bef73a33$export$bd096ddbd246c79c.error;
    };
    QueryManager.prototype.startPollingQuery = function(options, queryId, listener) {
        var _this = this;
        var pollInterval = options.pollInterval;
        (0, $6bc7ad95682943c0$export$f5708dca728d7177)(pollInterval, 18);
        if (!this.ssrMode) {
            var info = this.pollingInfoByQueryId.get(queryId);
            if (!info) this.pollingInfoByQueryId.set(queryId, info = {});
            info.interval = pollInterval;
            info.options = (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, options), {
                fetchPolicy: 'network-only'
            });
            var maybeFetch_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    if (_this.checkInFlight(queryId)) poll_1();
                    else _this.fetchQuery(queryId, info.options, $cb292de0bef73a33$export$160bafb6ac1e0641.poll).then(poll_1, poll_1);
                }
            };
            var poll_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    clearTimeout(info.timeout);
                    info.timeout = setTimeout(maybeFetch_1, info.interval);
                }
            };
            if (listener) this.addQueryListener(queryId, listener);
            poll_1();
        }
        return queryId;
    };
    QueryManager.prototype.stopPollingQuery = function(queryId) {
        this.pollingInfoByQueryId.delete(queryId);
    };
    return QueryManager;
}();
var $cb292de0bef73a33$var$DataStore = function() {
    function DataStore(initialCache) {
        this.cache = initialCache;
    }
    DataStore.prototype.getCache = function() {
        return this.cache;
    };
    DataStore.prototype.markQueryResult = function(result, document, variables, fetchMoreForQueryId, ignoreErrors) {
        if (ignoreErrors === void 0) ignoreErrors = false;
        var writeWithErrors = !(0, $gODea.graphQLResultHasError)(result);
        if (ignoreErrors && (0, $gODea.graphQLResultHasError)(result) && result.data) writeWithErrors = true;
        if (!fetchMoreForQueryId && writeWithErrors) this.cache.write({
            result: result.data,
            dataId: 'ROOT_QUERY',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markSubscriptionResult = function(result, document, variables) {
        if (!(0, $gODea.graphQLResultHasError)(result)) this.cache.write({
            result: result.data,
            dataId: 'ROOT_SUBSCRIPTION',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markMutationInit = function(mutation) {
        var _this = this;
        if (mutation.optimisticResponse) {
            var optimistic_1;
            if (typeof mutation.optimisticResponse === 'function') optimistic_1 = mutation.optimisticResponse(mutation.variables);
            else optimistic_1 = mutation.optimisticResponse;
            this.cache.recordOptimisticTransaction(function(c) {
                var orig = _this.cache;
                _this.cache = c;
                try {
                    _this.markMutationResult({
                        mutationId: mutation.mutationId,
                        result: {
                            data: optimistic_1
                        },
                        document: mutation.document,
                        variables: mutation.variables,
                        updateQueries: mutation.updateQueries,
                        update: mutation.update
                    });
                } finally{
                    _this.cache = orig;
                }
            }, mutation.mutationId);
        }
    };
    DataStore.prototype.markMutationResult = function(mutation) {
        var _this = this;
        if (!(0, $gODea.graphQLResultHasError)(mutation.result)) {
            var cacheWrites_1 = [
                {
                    result: mutation.result.data,
                    dataId: 'ROOT_MUTATION',
                    query: mutation.document,
                    variables: mutation.variables
                }
            ];
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) Object.keys(updateQueries_1).forEach(function(id) {
                var _a = updateQueries_1[id], query = _a.query, updater = _a.updater;
                var _b = _this.cache.diff({
                    query: query.document,
                    variables: query.variables,
                    returnPartialData: true,
                    optimistic: false
                }), currentQueryResult = _b.result, complete = _b.complete;
                if (complete) {
                    var nextQueryResult = (0, $gODea.tryFunctionOrLogError)(function() {
                        return updater(currentQueryResult, {
                            mutationResult: mutation.result,
                            queryName: (0, $gODea.getOperationName)(query.document) || undefined,
                            queryVariables: query.variables
                        });
                    });
                    if (nextQueryResult) cacheWrites_1.push({
                        result: nextQueryResult,
                        dataId: 'ROOT_QUERY',
                        query: query.document,
                        variables: query.variables
                    });
                }
            });
            this.cache.performTransaction(function(c) {
                cacheWrites_1.forEach(function(write) {
                    return c.write(write);
                });
                var update = mutation.update;
                if (update) (0, $gODea.tryFunctionOrLogError)(function() {
                    return update(c, mutation.result);
                });
            });
        }
    };
    DataStore.prototype.markMutationComplete = function(_a) {
        var mutationId = _a.mutationId, optimisticResponse = _a.optimisticResponse;
        if (optimisticResponse) this.cache.removeOptimistic(mutationId);
    };
    DataStore.prototype.markUpdateQueryResult = function(document, variables, newResult) {
        this.cache.write({
            result: newResult,
            dataId: 'ROOT_QUERY',
            variables: variables,
            query: document
        });
    };
    DataStore.prototype.reset = function() {
        return this.cache.reset();
    };
    return DataStore;
}();
var $cb292de0bef73a33$var$version = "2.6.10";
var $cb292de0bef73a33$var$hasSuggestedDevtools = false;
var $cb292de0bef73a33$export$13f5a5f0f1dbab88 = function() {
    function ApolloClient(options) {
        var _this = this;
        this.defaultOptions = {};
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        var cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, connectToDevTools = options.connectToDevTools, _c = options.queryDeduplication, queryDeduplication = _c === void 0 ? true : _c, defaultOptions = options.defaultOptions, _d = options.assumeImmutableResults, assumeImmutableResults = _d === void 0 ? false : _d, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link && resolvers) link = (0, $7kiUr.ApolloLink).empty();
        if (!link || !cache) throw new (0, $6bc7ad95682943c0$export$cea12affaee22fe8)(4);
        this.link = link;
        this.cache = cache;
        this.store = new $cb292de0bef73a33$var$DataStore(cache);
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || {};
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) setTimeout(function() {
            return _this.disableNetworkFetches = false;
        }, ssrForceFetchDelay);
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        var defaultConnectToDevTools = false;
        if (typeof connectToDevTools === 'undefined' ? defaultConnectToDevTools : connectToDevTools && typeof window !== 'undefined') window.__APOLLO_CLIENT__ = this;
        this.version = $cb292de0bef73a33$var$version;
        this.localState = new $cb292de0bef73a33$var$LocalState({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher
        });
        this.queryManager = new $cb292de0bef73a33$var$QueryManager({
            link: this.link,
            store: this.store,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: function() {
                if (_this.devToolsHookCb) _this.devToolsHookCb({
                    action: {},
                    state: {
                        queries: _this.queryManager.queryStore.getStore(),
                        mutations: _this.queryManager.mutationStore.getStore()
                    },
                    dataWithOptimisticResults: _this.cache.extract(true)
                });
            }
        });
    }
    ApolloClient.prototype.stop = function() {
        this.queryManager.stop();
    };
    ApolloClient.prototype.watchQuery = function(options) {
        if (this.defaultOptions.watchQuery) options = (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, this.defaultOptions.watchQuery), options);
        if (this.disableNetworkFetches && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options = (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.watchQuery(options);
    };
    ApolloClient.prototype.query = function(options) {
        if (this.defaultOptions.query) options = (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, this.defaultOptions.query), options);
        (0, $6bc7ad95682943c0$export$f5708dca728d7177)(options.fetchPolicy !== 'cache-and-network', 5);
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') options = (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.query(options);
    };
    ApolloClient.prototype.mutate = function(options) {
        if (this.defaultOptions.mutate) options = (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, this.defaultOptions.mutate), options);
        return this.queryManager.mutate(options);
    };
    ApolloClient.prototype.subscribe = function(options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function(options) {
        var result = this.cache.writeQuery(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeFragment = function(options) {
        var result = this.cache.writeFragment(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeData = function(options) {
        var result = this.cache.writeData(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.__actionHookForDevTools = function(cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function(payload) {
        return (0, $7kiUr.execute)(this.link, payload);
    };
    ApolloClient.prototype.initQueryManager = function() {
        return this.queryManager;
    };
    ApolloClient.prototype.resetStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                return fn();
            }));
        }).then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    ApolloClient.prototype.clearStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                return fn();
            }));
        });
    };
    ApolloClient.prototype.onResetStore = function(cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function() {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.onClearStore = function(cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function() {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    ApolloClient.prototype.extract = function(optimistic) {
        return this.cache.extract(optimistic);
    };
    ApolloClient.prototype.restore = function(serializedState) {
        return this.cache.restore(serializedState);
    };
    ApolloClient.prototype.addResolvers = function(resolvers) {
        this.localState.addResolvers(resolvers);
    };
    ApolloClient.prototype.setResolvers = function(resolvers) {
        this.localState.setResolvers(resolvers);
    };
    ApolloClient.prototype.getResolvers = function() {
        return this.localState.getResolvers();
    };
    ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    return ApolloClient;
}();
var $cb292de0bef73a33$export$2e2bcd8739ae039 = $cb292de0bef73a33$export$13f5a5f0f1dbab88;


function $2ac49c6c2d445dcb$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message);
}


function $116f7d35ce8e0538$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $116f7d35ce8e0538$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $116f7d35ce8e0538$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $116f7d35ce8e0538$var$_typeof(obj);
}
function $116f7d35ce8e0538$export$2e2bcd8739ae039(value) {
    return $116f7d35ce8e0538$var$_typeof(value) == 'object' && value !== null;
}


// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $008c791512bded7b$export$f6cdee3c26d6da57 = typeof Symbol === 'function' && Symbol.iterator != null ? Symbol.iterator : '@@iterator'; // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
var $008c791512bded7b$export$8d0083df0471478e = typeof Symbol === 'function' && Symbol.asyncIterator != null ? Symbol.asyncIterator : '@@asyncIterator'; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $008c791512bded7b$export$5deadc579ccc7c9c = typeof Symbol === 'function' && Symbol.toStringTag != null ? Symbol.toStringTag : '@@toStringTag';


/**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ function $0879e3bc2f3223bb$export$e7fd20fad3cf4b5f(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}



function $eafbd19ee13d0fa5$export$96a9681e539deed(location) {
    return $eafbd19ee13d0fa5$export$867940333fd9f869(location.source, (0, $0879e3bc2f3223bb$export$e7fd20fad3cf4b5f)(location.source, location.start));
}
function $eafbd19ee13d0fa5$export$867940333fd9f869(source, sourceLocation) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = $eafbd19ee13d0fa5$var$whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = sourceLocation.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = sourceLocation.line + lineOffset;
    var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = sourceLocation.column + columnOffset;
    var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
    var lines = body.split(/\r\n|[\n\r]/g);
    var locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        var subLineIndex = Math.floor(columnNum / 80);
        var subLineColumnNum = columnNum % 80;
        var subLines = [];
        for(var i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $eafbd19ee13d0fa5$var$printPrefixedLines([
            [
                "".concat(lineNum),
                subLines[0]
            ]
        ].concat(subLines.slice(1, subLineIndex + 1).map(function(subLine) {
            return [
                '',
                subLine
            ];
        }), [
            [
                ' ',
                $eafbd19ee13d0fa5$var$whitespace(subLineColumnNum - 1) + '^'
            ],
            [
                '',
                subLines[subLineIndex + 1]
            ]
        ]));
    }
    return locationStr + $eafbd19ee13d0fa5$var$printPrefixedLines([
        [
            "".concat(lineNum - 1),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum),
            locationLine
        ],
        [
            '',
            $eafbd19ee13d0fa5$var$whitespace(columnNum - 1) + '^'
        ],
        [
            "".concat(lineNum + 1),
            lines[lineIndex + 1]
        ]
    ]);
}
function $eafbd19ee13d0fa5$var$printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = Math.max.apply(Math, existingLines.map(function(_ref2) {
        var prefix = _ref2[0];
        return prefix.length;
    }));
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return $eafbd19ee13d0fa5$var$leftPad(padLen, prefix) + (line ? ' | ' + line : ' |');
    }).join('\n');
}
function $eafbd19ee13d0fa5$var$whitespace(len) {
    return Array(len + 1).join(' ');
}
function $eafbd19ee13d0fa5$var$leftPad(len, str) {
    return $eafbd19ee13d0fa5$var$whitespace(len - str.length) + str;
}


function $82b332e4f5a9572d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $82b332e4f5a9572d$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $82b332e4f5a9572d$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $82b332e4f5a9572d$var$_typeof(obj);
}
function $82b332e4f5a9572d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $82b332e4f5a9572d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $82b332e4f5a9572d$var$ownKeys(Object(source), true).forEach(function(key) {
            $82b332e4f5a9572d$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $82b332e4f5a9572d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $82b332e4f5a9572d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $82b332e4f5a9572d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $82b332e4f5a9572d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $82b332e4f5a9572d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $82b332e4f5a9572d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $82b332e4f5a9572d$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $82b332e4f5a9572d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $82b332e4f5a9572d$var$_setPrototypeOf(subClass, superClass);
}
function $82b332e4f5a9572d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $82b332e4f5a9572d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $82b332e4f5a9572d$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $82b332e4f5a9572d$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $82b332e4f5a9572d$var$_possibleConstructorReturn(this, result);
    };
}
function $82b332e4f5a9572d$var$_possibleConstructorReturn(self, call) {
    if (call && ($82b332e4f5a9572d$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $82b332e4f5a9572d$var$_assertThisInitialized(self);
}
function $82b332e4f5a9572d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $82b332e4f5a9572d$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $82b332e4f5a9572d$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$82b332e4f5a9572d$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $82b332e4f5a9572d$var$_construct(Class, arguments, $82b332e4f5a9572d$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $82b332e4f5a9572d$var$_setPrototypeOf(Wrapper, Class);
    };
    return $82b332e4f5a9572d$var$_wrapNativeSuper(Class);
}
function $82b332e4f5a9572d$var$_construct(Parent, args, Class) {
    if ($82b332e4f5a9572d$var$_isNativeReflectConstruct()) $82b332e4f5a9572d$var$_construct = Reflect.construct;
    else $82b332e4f5a9572d$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $82b332e4f5a9572d$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $82b332e4f5a9572d$var$_construct.apply(null, arguments);
}
function $82b332e4f5a9572d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $82b332e4f5a9572d$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $82b332e4f5a9572d$var$_setPrototypeOf(o, p) {
    $82b332e4f5a9572d$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $82b332e4f5a9572d$var$_setPrototypeOf(o, p);
}
function $82b332e4f5a9572d$var$_getPrototypeOf(o) {
    $82b332e4f5a9572d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $82b332e4f5a9572d$var$_getPrototypeOf(o);
}
var $82b332e4f5a9572d$export$92d6ed0888e7cb7f = /*#__PURE__*/ function(_Error) {
    $82b332e4f5a9572d$var$_inherits(GraphQLError, _Error);
    var _super = $82b332e4f5a9572d$var$_createSuper(GraphQLError);
    /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
        var _nodeLocations, _nodeLocations2, _nodeLocations3;
        var _this;
        $82b332e4f5a9572d$var$_classCallCheck(this, GraphQLError);
        _this = _super.call(this, message);
        _this.name = 'GraphQLError';
        _this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        _this.nodes = $82b332e4f5a9572d$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        var nodeLocations = [];
        for(var _i2 = 0, _ref3 = (_this$nodes = _this.nodes) !== null && _this$nodes !== void 0 ? _this$nodes : []; _i2 < _ref3.length; _i2++){
            var _this$nodes;
            var _ref4 = _ref3[_i2];
            var loc = _ref4.loc;
            if (loc != null) nodeLocations.push(loc);
        }
        nodeLocations = $82b332e4f5a9572d$var$undefinedIfEmpty(nodeLocations); // Compute locations in the source for the given nodes/positions.
        _this.source = source !== null && source !== void 0 ? source : (_nodeLocations = nodeLocations) === null || _nodeLocations === void 0 ? void 0 : _nodeLocations[0].source;
        _this.positions = positions !== null && positions !== void 0 ? positions : (_nodeLocations2 = nodeLocations) === null || _nodeLocations2 === void 0 ? void 0 : _nodeLocations2.map(function(loc) {
            return loc.start;
        });
        _this.locations = positions && source ? positions.map(function(pos) {
            return (0, $0879e3bc2f3223bb$export$e7fd20fad3cf4b5f)(source, pos);
        }) : (_nodeLocations3 = nodeLocations) === null || _nodeLocations3 === void 0 ? void 0 : _nodeLocations3.map(function(loc) {
            return (0, $0879e3bc2f3223bb$export$e7fd20fad3cf4b5f)(loc.source, loc.start);
        });
        _this.path = path !== null && path !== void 0 ? path : undefined;
        var originalExtensions = originalError === null || originalError === void 0 ? void 0 : originalError.extensions;
        if (extensions == null && (0, $116f7d35ce8e0538$export$2e2bcd8739ae039)(originalExtensions)) _this.extensions = $82b332e4f5a9572d$var$_objectSpread({}, originalExtensions);
        else _this.extensions = extensions !== null && extensions !== void 0 ? extensions : {};
         // By being enumerable, JSON.stringify will include bellow properties in the resulting output.
        // This ensures that the simplest possible GraphQL service adheres to the spec.
        Object.defineProperties($82b332e4f5a9572d$var$_assertThisInitialized(_this), {
            message: {
                enumerable: true
            },
            locations: {
                enumerable: _this.locations != null
            },
            path: {
                enumerable: _this.path != null
            },
            extensions: {
                enumerable: _this.extensions != null && Object.keys(_this.extensions).length > 0
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        if (originalError !== null && originalError !== void 0 && originalError.stack) {
            Object.defineProperty($82b332e4f5a9572d$var$_assertThisInitialized(_this), 'stack', {
                value: originalError.stack,
                writable: true,
                configurable: true
            });
            return $82b332e4f5a9572d$var$_possibleConstructorReturn(_this);
        } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
        if (Error.captureStackTrace) Error.captureStackTrace($82b332e4f5a9572d$var$_assertThisInitialized(_this), GraphQLError);
        else Object.defineProperty($82b332e4f5a9572d$var$_assertThisInitialized(_this), 'stack', {
            value: Error().stack,
            writable: true,
            configurable: true
        });
        return _this;
    }
    $82b332e4f5a9572d$var$_createClass(GraphQLError, [
        {
            key: "toString",
            value: function toString() {
                return $82b332e4f5a9572d$export$55ee1551a3f962e6(this);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return $82b332e4f5a9572d$export$7b5b869ee98c16ab(this);
            } // FIXME: workaround to not break chai comparisons, should be remove in v16
        },
        {
            key: (0, $008c791512bded7b$export$5deadc579ccc7c9c),
            get: function get() {
                return 'Object';
            }
        }
    ]);
    return GraphQLError;
}(/*#__PURE__*/ $82b332e4f5a9572d$var$_wrapNativeSuper(Error));
function $82b332e4f5a9572d$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $82b332e4f5a9572d$export$55ee1551a3f962e6(error) {
    var output = error.message;
    if (error.nodes) for(var _i4 = 0, _error$nodes2 = error.nodes; _i4 < _error$nodes2.length; _i4++){
        var node = _error$nodes2[_i4];
        if (node.loc) output += '\n\n' + (0, $eafbd19ee13d0fa5$export$96a9681e539deed)(node.loc);
    }
    else if (error.source && error.locations) for(var _i6 = 0, _error$locations2 = error.locations; _i6 < _error$locations2.length; _i6++){
        var location = _error$locations2[_i6];
        output += '\n\n' + (0, $eafbd19ee13d0fa5$export$867940333fd9f869)(error.source, location);
    }
    return output;
}
function $82b332e4f5a9572d$export$7b5b869ee98c16ab(error) {
    var _error$message;
    error || (0, $2ac49c6c2d445dcb$export$2e2bcd8739ae039)(0, 'Received null or undefined error.');
    var message = (_error$message = error.message) !== null && _error$message !== void 0 ? _error$message : 'An unknown error occurred.';
    var locations = error.locations;
    var path = error.path;
    var extensions = error.extensions;
    return extensions && Object.keys(extensions).length > 0 ? {
        message: message,
        locations: locations,
        path: path,
        extensions: extensions
    } : {
        message: message,
        locations: locations,
        path: path
    };
} /**
 * @see https://github.com/graphql/graphql-spec/blob/master/spec/Section%207%20--%20Response.md#errors
 */ 


function $eb7022fe2ef8793b$export$d54488e5d0ecaef7(value) {
    return value instanceof (0, $82b332e4f5a9572d$export$92d6ed0888e7cb7f);
}


class $65398bb1ddc9160a$export$bae979e68e4dc802 extends Error {
}
function $65398bb1ddc9160a$export$bda33884db3cf75b(error) {
    if (error instanceof $65398bb1ddc9160a$export$bae979e68e4dc802) return true;
    if ((0, $cb292de0bef73a33$export$17f5e6bd290bb15d)(error)) {
        const { graphQLErrors: graphQLErrors, networkError: networkError } = error;
        if (networkError) // ApolloError describes a network-related error if its networkError
        // property value is truthy. These are errors that have occurred within a
        // NetworkLink of ApolloClient. Think non-experimental queries (and
        // mutations).
        return true;
        return graphQLErrors.some($65398bb1ddc9160a$export$bda33884db3cf75b);
    }
    if ((0, $eb7022fe2ef8793b$export$d54488e5d0ecaef7)(error)) {
        const { originalError: originalError } = error;
        if (originalError) return $65398bb1ddc9160a$export$bda33884db3cf75b(originalError);
    }
    return false;
}
function $65398bb1ddc9160a$export$762bd3eeab681428(error) {
    return error.cause instanceof Error && error.cause?.name === 'AbortError';
}


class $165abb9eb28d58da$export$12c8b3d0a1a46f87 extends (0, $65398bb1ddc9160a$export$bae979e68e4dc802) {
    get traceId() {
        return (0, $32b74afc9e827b44$export$9f229e40eb65abfc)(this.response);
    }
    static isBadStatusError(value) {
        return value instanceof $165abb9eb28d58da$export$12c8b3d0a1a46f87;
    }
    constructor(message, response){
        super(message);
        this.response = void 0;
        this.name = 'BadStatusError';
        this.response = response;
    }
}



class $ea3ad52d3b05fdce$export$79f50640f30c1c0e extends (0, $65398bb1ddc9160a$export$bae979e68e4dc802) {
    constructor(...args){
        super(...args);
        /**
     * If the call site of `cfetch` has indicated that `NoNetworkError`s are to be
     * ignored by handlers, then `true`; otherwise, `false` or `undefined`.
     */ this.ignore = void 0;
        /**
     * Indicates whether the error was exposed to the feature gate `platform_editor_bubble_cfe_gql_network_errors`
     * and subsequently bubbled up to the client. This property is used to track errors originating from this
     * feature gate in analytics events.
     *
     * Note: This property is temporary and may be removed during the cleanup of the feature gate.
     */ this.wasBubbledUp = void 0;
    }
}



const $47f40898ee722892$var$RATE_LIMIT_TEXT_MARK = 'rate limit exceeded';
class $47f40898ee722892$export$b5f929f4d77c16a9 extends (0, $165abb9eb28d58da$export$12c8b3d0a1a46f87) {
    constructor(message, response){
        super(`${message} ${$47f40898ee722892$var$RATE_LIMIT_TEXT_MARK}`, response);
    }
}


function $57a53db822db3688$export$bee20cbc27fea50(headers, headerName, headerValue) {
    if (Array.isArray(headers)) {
        headers.push([
            headerName,
            headerValue
        ]);
        return;
    }
    if (headers instanceof Headers) {
        headers.append(headerName, headerValue);
        return;
    }
    headers[headerName] = headerValue;
}


function $1c343939761f9a65$export$149b1181d497cd(headers, headerName) {
    if (Array.isArray(headers)) {
        const header = headers.find(([name])=>name === headerName);
        return header ? header[1] : null;
    }
    if (headers instanceof Headers) return headers.get(headerName);
    return headers[headerName] ?? null;
}


const $e8815de0e5744b4a$export$1fccf6c6ebec28fe = 'X-Atl-Experience';
const $e8815de0e5744b4a$export$ecc9e1785213e182 = 'X-Atl-Experience-Id';


class $53b31fbcee8a9542$var$FrontendNetworkTracker {
    // Called from createWrappedFetch for each individual operation
    trackGraphQLOperations(operationNames) {
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        if (typeof window === 'undefined') return;
        operationNames.forEach(()=>{
            this.stats.totalOperations++;
        });
    }
    // Called from cfetch for REST calls
    trackRestCall(_url) {
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        if (typeof window === 'undefined') return;
        this.stats.totalOperations++;
    }
    getStats() {
        return {
            ...this.stats
        };
    }
    reset() {
        this.stats = {
            totalOperations: 0
        };
    }
    constructor(){
        this.stats = {
            totalOperations: 0
        };
    }
}
const $53b31fbcee8a9542$export$9a57a9973e788640 = new $53b31fbcee8a9542$var$FrontendNetworkTracker();


const $b9f93b053c525d82$export$7fd82c6bb3f5e7d5 = async (resource, init = {})=>{
    const urlPrefix = (0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('cc-agg-migration-use-agg-endpoint') ? '/gateway/api/graphql/slow' : '/cgraphql';
    if (typeof window !== 'undefined' && window['GLOBAL_FALLBACK_ATL_EXP']) {
        if (resource instanceof Request && resource.url.startsWith(urlPrefix)) resource.headers.append((0, $e8815de0e5744b4a$export$1fccf6c6ebec28fe), resource.headers.get((0, $e8815de0e5744b4a$export$1fccf6c6ebec28fe)) || window['GLOBAL_FALLBACK_ATL_EXP']);
        else if (String(resource).startsWith(urlPrefix)) {
            init.headers = init?.headers || {};
            // For requests sending outside of exp tracker scope fallback to URL based exp name
            (0, $57a53db822db3688$export$bee20cbc27fea50)(init.headers, (0, $e8815de0e5744b4a$export$1fccf6c6ebec28fe), (0, $1c343939761f9a65$export$149b1181d497cd)(init.headers, (0, $e8815de0e5744b4a$export$1fccf6c6ebec28fe)) || window['GLOBAL_FALLBACK_ATL_EXP']);
        }
    }
    // eslint-disable-next-line prefer-const
    let { ignoreNoNetworkError: ignoreNoNetworkError, requestInit: requestInit } = $b9f93b053c525d82$var$decomposeInit(init);
    // XXX Default RequestInit's credentials to "include" but not always: if the
    // caller provided a Request as resource and no init, then us adding a
    // RequestInit can break the caller.
    if (!resource || typeof resource === 'string' || !resource.credentials) requestInit = {
        credentials: 'include',
        ...requestInit
    };
    let response;
    const { url: url } = $b9f93b053c525d82$var$getRequestInfo(resource);
    let finalUrl = url;
    let authHeaders = {};
    try {
        // Track REST calls for frontend (GraphQL is tracked separately)
        // Only track in browser environment
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        if (typeof window !== 'undefined') (0, $53b31fbcee8a9542$export$9a57a9973e788640).trackRestCall(url);
        var value, name;
        // eslint-disable-next-line check-credentials-option/has-credentials-option, no-restricted-syntax
        response = await fetch(resource, requestInit);
    } catch (e) {
        // According to the fetch spec, a network failure results in a Promise
        // rejected with a TypeError. Any Response at all will resolve the Promise,
        // with the status property revealing the HTTP status code.
        const cause = (0, $ef003bca5ae3d837$export$9db1624a8af791a4)('confluence_use_fetch_base', 'isEnabled', false) ? e.cause : e;
        const error = new (0, $ea3ad52d3b05fdce$export$79f50640f30c1c0e)(`Network failure: ${cause}`, {
            cause: cause
        });
        error.ignore = ignoreNoNetworkError;
        error.ignore || $b9f93b053c525d82$var$emit(/* response */ undefined, error);
        throw error;
    }
    // If we don't get a 2xx Response, we'll consider that an error, and we'll
    // throw an exception. If we don't, we risk developers not checking the
    // Response status, running parsing logic such as parsing JSON, and failing
    // on non-2xx HTTP status code with weird errors like:
    // * Unexpected end of JSON input
    // * Unexpected token < in JSON at position 0
    // * JSON.parse: unexpected end of data at line 1 column 1 of the JSON data
    // * etc.
    //
    // By using our own Error subclass, we can prevent such unintended running of
    // parsing logic and we allow the product easily recognize the error and apply
    // product-wide processing.
    if (!response.ok) {
        let error;
        if (response.status === 429) error = new (0, $47f40898ee722892$export$b5f929f4d77c16a9)(resource.toString(), response);
        else error = new (0, $165abb9eb28d58da$export$12c8b3d0a1a46f87)(`Received status ${response.status}`, response);
        $b9f93b053c525d82$var$emit(response, error);
        throw error;
    }
    $b9f93b053c525d82$var$emit(response, /* error */ undefined);
    return response;
};
function $b9f93b053c525d82$var$decomposeInit(init = {}) {
    const { ignoreNoNetworkError: ignoreNoNetworkError, ...requestInit } = init;
    return {
        ignoreNoNetworkError: ignoreNoNetworkError,
        requestInit: Object.getOwnPropertyNames(requestInit).length ? (0, $d4a7caa009eb781c$export$eca64eb737a4c2bc)(requestInit) : undefined
    };
}
const $b9f93b053c525d82$var$logger = (0, $a6897acd40ed68b1$export$2b1d391cd05230fd)($b9f93b053c525d82$export$7fd82c6bb3f5e7d5);
let $b9f93b053c525d82$var$subscribers = [];
/**
 * Adds a specific `subscriber` to be notified whenever any `cfetch` call
 * resolves with a `Response` and/or an `Error`. If you're calling `cfetch` and
 * are interested in the outcome of that particular call only, please await the
 * resolution of the `Promise` returned by `cfetch`.
 */ $b9f93b053c525d82$export$7fd82c6bb3f5e7d5.subscribe = (subscriber)=>{
    if (typeof subscriber !== 'function') throw new Error('Subscriber must be a function');
    $b9f93b053c525d82$var$subscribers.push(subscriber);
    return ()=>{
        $b9f93b053c525d82$var$subscribers = $b9f93b053c525d82$var$subscribers.filter((x)=>x !== subscriber);
    };
};
function $b9f93b053c525d82$var$emit(response, error) {
    $b9f93b053c525d82$var$subscribers.forEach((subscriber)=>{
        try {
            subscriber(response, error);
        } catch (e) {
            $b9f93b053c525d82$var$logger.error`Error occurred in a cfetch subscriber: ${e}`;
        }
    });
}
/**
 * Helper function to extract URL and determine if request is GraphQL
 */ function $b9f93b053c525d82$var$getRequestInfo(resource) {
    const url = typeof resource === 'string' ? resource : resource instanceof Request ? resource.url : resource.toString();
    const isGraphQL = url.includes('/gateway/api/graphql/slow') || url.includes('?q=') || url.includes('&q=');
    return {
        url: url,
        isGraphQL: isGraphQL
    };
}



const $ce97530b5e3fb851$export$54fe7bbc3a8667b6 = `
  query isNewUserQuery {
    isNewUser
  }
`;


const $5ffd74b04d73fde2$export$53cb6decc268273b = (attributes)=>{
    const URI = (0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('cc-agg-migration-use-agg-endpoint') ? '/gateway/api/graphql/slow' : window['GLOBAL_APOLLO_CLIENT_URI'] || '/cgraphql';
    (0, $b9f93b053c525d82$export$7fd82c6bb3f5e7d5)(`${URI}?q=isNewUserQuery`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'X-APOLLO-OPERATION-NAME': 'isNewUserQuery',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            operationName: 'isNewUserQuery',
            query: (0, $ce97530b5e3fb851$export$54fe7bbc3a8667b6)
        })
    }).then(async (res)=>{
        if (res.ok) {
            const data = await res.json();
            const isNewUser = data?.data?.isNewUser || false;
            if (!!isNewUser) {
                (0, $b9f93b053c525d82$export$7fd82c6bb3f5e7d5)('/wiki/rest/onboarding/1/store', {
                    method: 'PUT',
                    body: JSON.stringify({
                        key: 'onboarding-origin-state:attributes',
                        value: JSON.stringify(attributes)
                    }),
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
                window.dispatchEvent(new Event('onboardingAttributesUpdated'));
            }
        }
    });
};


// Must call this before any browser-helper functions, to ensure user agent has been set first
(0, $c086cef45a2cc129$export$57d3cdb500cb5402)();
let $b76dfd1db5681318$var$provideClient;
const $b76dfd1db5681318$var$analyticsWebClientPromise = (0, $cd3135dd152096aa$export$cc373701aed148fc)(new Promise((resolve)=>{
    $b76dfd1db5681318$var$provideClient = resolve;
}));
let $b76dfd1db5681318$var$provideDwellTimeHelper;
const $b76dfd1db5681318$var$dwellTimeHelperPromise = (0, $cd3135dd152096aa$export$cc373701aed148fc)(new Promise((resolve)=>{
    $b76dfd1db5681318$var$provideDwellTimeHelper = resolve;
}));
const $b76dfd1db5681318$var$GAS_V3_ROUTE = 'gateway/api/gasv3/api/v1';
const $b76dfd1db5681318$export$45a69314cf48a3eb = ({ envType: envType, originType: originType, environment: environment, platformType: platformType, locale: locale, product: product, subproduct: subproduct })=>{
    const env = // In dev, proxying to a site will give that site's environment,
    // which is not what we want
    window.location.hostname === 'localhost' ? envType.DEV : environment === 'STAGING' ? envType.STAGING : environment === 'PRODUCTION' ? envType.PROD : envType.DEV;
    return {
        env: env,
        product: product || 'confluence',
        ...subproduct ? {
            subproduct: subproduct
        } : undefined,
        version: (0, $f3f8c1a227f13835$export$4ea39b9726d98a51)().FRONTEND_VERSION,
        origin: originType.WEB,
        platform: (0, $3793e1e9d193543a$export$1adf40e7373cdd98)() ? platformType.MOBILE_WEB : platformType.WEB,
        locale: locale,
        ...(0, $eSXfa.isIsolatedCloud)() && {
            ic: (0, $eSXfa.isolationContextId)()
        }
    };
};
const $b76dfd1db5681318$export$cac1fa7ce63519ac = (cloudId, activationId)=>`ari:cloud:confluence:${cloudId}:workspace/${activationId}`;
let $b76dfd1db5681318$var$updateAmplitudeSRSession;
let $b76dfd1db5681318$var$amplitudeAttributesInjector;
const $b76dfd1db5681318$var$wrapSendMethod = (originalMethod)=>{
    return function(payload, ...args) {
        // Inject amplitude attributes if injector exists
        if ($b76dfd1db5681318$var$amplitudeAttributesInjector && payload) $b76dfd1db5681318$var$amplitudeAttributesInjector(payload);
        // Call original method
        return originalMethod.call(this, payload, ...args);
    };
};




const $b76dfd1db5681318$export$7d842b959fcdcd03 = ({ cloudId: cloudId, userId: userId, environment: environment, product: product, subproduct: subproduct, locale: locale, activationId: activationId, eventFilterOptions: eventFilterOptions = {
    shouldFilterEvents: false,
    eventMatchers: []
}, callback: callback })=>{
    let config;
    Promise.all([
        (parcelRequire("6vvG3")),
        (parcelRequire("kOCE7")),
        // This is needed for @atlassiansox/origin-tracing to work in old versions of Edge (<=16).
        // Origin Tracing needs URLSearchParams, but the API is missing from old Edge,
        // and old Edge is not served the ES5/polyfills bundle.
        typeof URLSearchParams === 'undefined' ? (parcelRequire("kfarM")) : Promise.resolve()
    ]).then(async ([analyticsWebClientModule, { buildCompressionFunction: buildCompressionFunction, canCompress: canCompress }])=>{
        const { default: AnalyticsWebClient, originType: originType, tenantType: tenantType, userType: userType, envType: envType, platformType: platformType, DwellTimeHelper: DwellTimeHelper, CompressionRule: CompressionRule } = analyticsWebClientModule;
        config = $b76dfd1db5681318$export$45a69314cf48a3eb({
            envType: envType,
            originType: originType,
            environment: environment,
            platformType: platformType,
            locale: locale,
            product: product,
            subproduct: subproduct
        });
        let analyticsWebClient;
        // COMMENTS-195 - Send an operational event when a session starts
        const handleSessionStarted = ()=>{
            analyticsWebClient && analyticsWebClient.sendOperationalEvent({
                action: 'started',
                actionSubject: 'session',
                source: 'webClient'
            });
            if ((0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('cc_engagement_amplitude_session_replay')) $b76dfd1db5681318$var$updateAmplitudeSRSession && $b76dfd1db5681318$var$updateAmplitudeSRSession(analyticsWebClient);
        };
        $b76dfd1db5681318$var$provideDwellTimeHelper(DwellTimeHelper);
        const browserHistory = (0, $efe75065bf034d65$export$1ddb08151d15bc78)();
        const settings = {
            historyReplaceFn: (url)=>{
                const { pathname: pathname, search: search, hash: hash } = new URL(url);
                // Warning: can't pass an instance of URL here as it will erase query params and hash
                // Caused: https://product-fabric.atlassian.net/browse/WS-2317
                browserHistory.replace({
                    pathname: pathname,
                    search: search,
                    hash: hash
                });
            },
            delayQueueCompressors: [
                new CompressionRule(canCompress, buildCompressionFunction())
            ],
            onNewSessionStarted: handleSessionStarted,
            apiHostProtocol: window.location.hostname === 'localhost' ? 'http' : 'https',
            ...(0, $eSXfa.isIsolatedCloud)() && {
                apiHost: `${window.location.hostname}/${$b76dfd1db5681318$var$GAS_V3_ROUTE}`
            },
            disableCookiePersistence: true
        };
        const { shouldFilterEvents: shouldFilterEvents, eventMatchers: eventMatchers } = eventFilterOptions;
        // We suppress analytics events if we're within the mobile app so that we don't
        // end up firing overlapping events from the native and web code
        if (shouldFilterEvents || (0, $c086cef45a2cc129$export$6d5620528cf86fa2)()) {
            /**
       * Don't use Stargate if we're filtering events.
       * According to the analytics-web-client package source code at https://bitbucket.org/atlassian/analytics-web-client/src/bf3bd861ee8d08759e0e79830fcb1d69156db1a5/src/analyticsWebClient.js?at=master#lines-208
       * By default, useStargate is true. On a production instance, even if we set the env to "staging" or "dev", this event will land to the huge production Redash Socrates table, such as cloud.event_operational.
       * For the purpose of preproduction performance detection, we need the analytics event to send to staging table, such as raw_dlf_stg.event_operational.
       * The staging table has much less data, so we can run data transformation job hourly, and query more real-time data. Production table is huge, so we can only run data transformation job daily.
       */ const useStargate = !shouldFilterEvents;
            const { createFilteredAWC: createFilteredAWC } = await (parcelRequire("4DsE6"));
            analyticsWebClient = createFilteredAWC(analyticsWebClientModule, config, {
                ...settings,
                useStargate: useStargate
            }, eventMatchers);
        } else analyticsWebClient = new AnalyticsWebClient(config, settings);
        analyticsWebClient.setTenantInfo(tenantType.CLOUD_ID, cloudId);
        if ((0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('cc_engagement_amplitude_session_replay')) {
            analyticsWebClient.setUpdateAmplitudeSRSession = (callback)=>{
                $b76dfd1db5681318$var$updateAmplitudeSRSession = callback || undefined;
            };
            analyticsWebClient.setAmplitudeAttributesInjector = (injector)=>{
                $b76dfd1db5681318$var$amplitudeAttributesInjector = injector || undefined;
            };
            analyticsWebClient.sendScreenEvent = $b76dfd1db5681318$var$wrapSendMethod(analyticsWebClient.sendScreenEvent);
            analyticsWebClient.sendUIEvent = $b76dfd1db5681318$var$wrapSendMethod(analyticsWebClient.sendUIEvent);
        }
        if (activationId) {
            const workspaceId = $b76dfd1db5681318$export$cac1fa7ce63519ac(cloudId, activationId);
            analyticsWebClient.setWorkspaceInfo(workspaceId);
        }
        // userId is null when the user is anonymous. In that scenario we don't
        // want to set any account ID on the analytics client.
        if (userId) analyticsWebClient.setUserInfo(userType.ATLASSIAN_ACCOUNT, userId);
        analyticsWebClient.setOriginTracingHandlers({
            atlOrigin: (encodedOrigin)=>{
                const origin = (0, $d0d8d601ac789192$export$2e2bcd8739ae039).fromEncoded(encodedOrigin);
                const attributes = origin.toAnalyticsAttributes();
                if (userId) (0, $5ffd74b04d73fde2$export$53cb6decc268273b)(attributes);
                return {
                    originTracingAttributes: {
                        id: attributes.originId,
                        product: attributes.originProduct,
                        library: attributes.originLibrary
                    },
                    taskSessionId: origin.id
                };
            }
        });
        if (product === 'embeddedConfluence') {
            const href = window?.location?.href;
            if (href) {
                const url = new URL(href);
                const embeddedConfluenceSource = url.searchParams.get('embeddedConfluenceSource');
                analyticsWebClient.setUIViewedAttributes({
                    embeddedConfluenceSource: embeddedConfluenceSource || 'unknown'
                });
            }
        }
        analyticsWebClient.startUIViewedEvent();
        $b76dfd1db5681318$var$provideClient(analyticsWebClient);
        callback && callback();
    }).catch((error)=>{
        throw new Error(`Analytics Web Client ${error}, ${JSON.stringify({
            ...config
        })}`);
    });
};
const $b76dfd1db5681318$export$e9ba7ef9458d1a4a = ()=>$b76dfd1db5681318$var$analyticsWebClientPromise;
const $b76dfd1db5681318$export$68106415736c5577 = ()=>$b76dfd1db5681318$var$dwellTimeHelperPromise;


/**
 * confluence/meta is used to access dynamic metadata passed from the
 * server to JavaScript via the page HTML.
 */ /**
 *  A backing map to use if the user sets data.
 */ const $b9d7d5d25d527513$export$1591b5b8c61dbb9c = {};
const $b9d7d5d25d527513$export$357972e1dc28ee9f = (key, value)=>{
    $b9d7d5d25d527513$export$1591b5b8c61dbb9c[key] = value;
};
const $b9d7d5d25d527513$export$70f24959ef00553b = (value)=>{
    const evaluatedValue = typeof value === 'string' ? value.toLowerCase() : '';
    const booleanEnum = {
        true: true,
        false: false
    };
    return evaluatedValue in booleanEnum ? booleanEnum[evaluatedValue] : value;
};
const $b9d7d5d25d527513$export$72427a1521dd0069 = (key)=>{
    // Check if we're server-side or client-side
    if ($b9d7d5d25d527513$export$9542afab8c2a5f48()) {
        const metaEl = document.querySelector(`meta[name='ajs-${key}']`);
        if (metaEl) return $b9d7d5d25d527513$export$70f24959ef00553b(metaEl.content);
        return $b9d7d5d25d527513$export$1591b5b8c61dbb9c[key];
    }
    // Always return undefined on the server-side
    return undefined;
};
const $b9d7d5d25d527513$export$49258654c956d9af = ()=>{
    const map = {};
    if (!document?.querySelectorAll?.length) return map;
    const metas = document.querySelectorAll('meta[name^=ajs-]');
    if (metas) for(let i = 0; i < metas.length; i++){
        const { name: name, content: content } = metas[i];
        map[name.substring(4)] = content;
    }
    return Object.assign(map, $b9d7d5d25d527513$export$1591b5b8c61dbb9c);
};
const $b9d7d5d25d527513$export$594c6655c9709eda = ()=>{
    const metaData = {};
    if ($b9d7d5d25d527513$export$9542afab8c2a5f48()) {
        const metaTags = document.querySelectorAll('meta[name^=ajs-]');
        for(let i = 0; i < metaTags.length; i++){
            const { name: name, content: content } = metaTags[i];
            metaData[name.replace(/^ajs-/, '')] = content;
        }
    }
    return metaData;
};
const $b9d7d5d25d527513$export$9542afab8c2a5f48 = ()=>{
    return typeof document !== 'undefined';
};
const $b9d7d5d25d527513$export$578af21a462ae10b = ()=>{
    Object.keys($b9d7d5d25d527513$export$1591b5b8c61dbb9c).forEach((key)=>{
        delete $b9d7d5d25d527513$export$1591b5b8c61dbb9c[key];
    });
};


// Please only keep this import as a *type import* to avoid bringing in the entire lib
/**
 * The error returned if an error occurs while calling a REST API.
 */ class $b1c79be305194522$export$e704fce35c66bf42 extends Error {
    constructor({ message: message, method: method, url: url, 'status-code': statusCode }, { route: route, traceId: traceId } = {}){
        const formattedMessage = message.length ? message : `Failed to ${method} ${route || url}`;
        super(formattedMessage);
        /**
     * The URL of the failed request.
     */ this.url = void 0;
        /**
     * The attempted http request method.
     */ this.method = void 0;
        /**
     * The status code returned in the response
     */ this.statusCode = void 0;
        /**
     * The name of the requested route (without UGC/PII)
     */ this.route = void 0;
        /**
     * The traceId of the request
     */ this.traceId = void 0;
        this.url = url;
        this.route = route;
        this.method = method;
        this.statusCode = statusCode;
        this.traceId = traceId;
    }
}


function $8a3a8685062675cc$var$isApolloError(error) {
    // theoretically this could be an `instanceof ApolloError` check, but bringing another
    // dependency to this package for the sake of this single check seems like an overkill
    return typeof error === 'object' && error !== null && ('graphQLErrors' in error || 'networkError' in error);
}
const $8a3a8685062675cc$var$REACT_ERROR_CONTEXT_SYMBOL = Symbol('React error context');
function $8a3a8685062675cc$export$df1c6d0ba3db287e(error, context) {
    if (typeof error === 'object' && error !== null) error[$8a3a8685062675cc$var$REACT_ERROR_CONTEXT_SYMBOL] = context;
}
function $8a3a8685062675cc$export$8b5fa6128aa81e5e(error) {
    if (typeof error === 'object' && error !== null) return error[$8a3a8685062675cc$var$REACT_ERROR_CONTEXT_SYMBOL];
    return undefined;
}
const $8a3a8685062675cc$var$GRAPHQL_ERROR_CONTEXT_SYMBOL = Symbol('Graphql error context');
function $8a3a8685062675cc$export$6f0dbe4e2bbe0509(error, context) {
    if (typeof error === 'object' && error !== null) error[$8a3a8685062675cc$var$GRAPHQL_ERROR_CONTEXT_SYMBOL] = context;
}
function $8a3a8685062675cc$export$b19e649eafc62480(error) {
    if (typeof error !== 'object' || error === null) return undefined;
    if (error[$8a3a8685062675cc$var$GRAPHQL_ERROR_CONTEXT_SYMBOL]) return error[$8a3a8685062675cc$var$GRAPHQL_ERROR_CONTEXT_SYMBOL];
    // Currently the graphql error context is set on the first entry of the `graphqlErrors`
    // property of `ApolloError`. That way, `ApolloError` itself does not have the context
    // set properly. This method is a measure to overcome this and make sure that
    // we are able to retrieve the context correctly.
    return $8a3a8685062675cc$var$getGraphqlErrorAttributesFromApolloError(error);
}
function $8a3a8685062675cc$var$getGraphqlErrorAttributesFromApolloError(error) {
    if (!$8a3a8685062675cc$var$isApolloError(error)) return undefined;
    const graphqlErrors = error.graphQLErrors;
    // the context is populated by next/packages/graphql/src/links/OnErrorLink.ts
    if (graphqlErrors && graphqlErrors.length > 0 && graphqlErrors[0][$8a3a8685062675cc$var$GRAPHQL_ERROR_CONTEXT_SYMBOL]) return graphqlErrors[0][$8a3a8685062675cc$var$GRAPHQL_ERROR_CONTEXT_SYMBOL];
    if (error.networkError) return error.networkError[$8a3a8685062675cc$var$GRAPHQL_ERROR_CONTEXT_SYMBOL];
    return undefined;
}
const $8a3a8685062675cc$var$SLA_ERROR_CONTEXT_SYMBOL = Symbol('SLA error context');
function $8a3a8685062675cc$export$d4fe004fb0aaaf4f(error) {
    if (typeof error === 'object' && error !== null) return error[$8a3a8685062675cc$var$SLA_ERROR_CONTEXT_SYMBOL];
    return undefined;
}
function $8a3a8685062675cc$export$a986f274521b30d7(error, context) {
    if (typeof error === 'object' && error !== null) error[$8a3a8685062675cc$var$SLA_ERROR_CONTEXT_SYMBOL] = context;
}
function $8a3a8685062675cc$var$getBadStatusErrorAttributes(error) {
    if (!(error instanceof (0, $165abb9eb28d58da$export$12c8b3d0a1a46f87))) return undefined;
    return {
        statusCode: error.response.status,
        traceId: (0, $32b74afc9e827b44$export$9f229e40eb65abfc)(error.response)
    };
}
function $8a3a8685062675cc$var$getConfluenceRestApiErrorAttributes(error) {
    if (!(error instanceof (0, $b1c79be305194522$export$e704fce35c66bf42))) return undefined;
    return {
        statusCode: error.statusCode,
        restMethod: error.method,
        restRoute: error.route,
        traceId: error.traceId
    };
}
const $8a3a8685062675cc$var$CONTENT_ERROR_CONTEXT_SYMBOL = Symbol('Content error context');
function $8a3a8685062675cc$export$c37ca7d37ab54fcc(error, context) {
    if (typeof error === 'object' && error !== null) error[$8a3a8685062675cc$var$CONTENT_ERROR_CONTEXT_SYMBOL] = context;
}
function $8a3a8685062675cc$export$bc010311f017b17c(error) {
    if (typeof error === 'object' && error !== null) return error[$8a3a8685062675cc$var$CONTENT_ERROR_CONTEXT_SYMBOL];
    return undefined;
}
const $8a3a8685062675cc$var$LOADABLE_ERROR_CONTEXT_SYMBOL = Symbol('Loadable error context');
function $8a3a8685062675cc$export$6f86bd8e510ff607(error, context) {
    if (typeof error === 'object' && error !== null) error[$8a3a8685062675cc$var$LOADABLE_ERROR_CONTEXT_SYMBOL] = context;
}
function $8a3a8685062675cc$export$b8f8f1e62c6397ed(error) {
    if (typeof error === 'object' && error !== null) return error[$8a3a8685062675cc$var$LOADABLE_ERROR_CONTEXT_SYMBOL];
    return undefined;
}
function $8a3a8685062675cc$export$69408b85ed2a0e77(error) {
    const traceId = $8a3a8685062675cc$export$b19e649eafc62480(error)?.traceId || $8a3a8685062675cc$export$b19e649eafc62480(error?.graphQLErrors?.[0])?.traceId;
    if (traceId) return traceId;
    // handle experimental query error
    if (error.graphQLErrors?.[0].originalError instanceof (0, $165abb9eb28d58da$export$12c8b3d0a1a46f87)) return error.graphQLErrors[0].originalError?.traceId;
    return null;
}
function $8a3a8685062675cc$export$d08bac32cb78075f(error) {
    if (!error || typeof error !== 'object') return {};
    return {
        ...$8a3a8685062675cc$export$8b5fa6128aa81e5e(error),
        ...$8a3a8685062675cc$export$b19e649eafc62480(error),
        ...$8a3a8685062675cc$export$d4fe004fb0aaaf4f(error),
        ...$8a3a8685062675cc$export$bc010311f017b17c(error),
        ...$8a3a8685062675cc$export$b8f8f1e62c6397ed(error),
        ...$8a3a8685062675cc$var$getConfluenceRestApiErrorAttributes(error),
        ...$8a3a8685062675cc$var$getBadStatusErrorAttributes(error)
    };
}


function $c2e01af11e74e6ce$export$1115c5277eb10d5e(traceId, spanId) {
    return {
        'X-B3-TraceId': traceId,
        'X-B3-SpanId': spanId
    };
}


const $aae51952f0016112$var$state = {
    context: null
};
function $aae51952f0016112$export$295213bc4d0c54ad() {
    return Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}
function $aae51952f0016112$export$f2e521e495a88544(interactionId, experienceType) {
    $aae51952f0016112$export$a1002be327997103(interactionId.replace(/-/g, ''), $aae51952f0016112$export$295213bc4d0c54ad(), experienceType);
}
function $aae51952f0016112$export$a1002be327997103(traceId, spanId, type) {
    $aae51952f0016112$var$state.context = {
        traceId: traceId,
        spanId: spanId,
        type: type
    };
}
function $aae51952f0016112$export$b6ac780db3a3cc77() {
    return $aae51952f0016112$var$state.context || undefined;
}
function $aae51952f0016112$export$17ab21d7be720b() {
    $aae51952f0016112$var$state.context = null;
}
function $aae51952f0016112$export$6e17cce6446848f9(_url) {
    if ($aae51952f0016112$var$state.context === null) return null;
    const { traceId: traceId, spanId: spanId } = $aae51952f0016112$var$state.context;
    return (0, $c2e01af11e74e6ce$export$1115c5277eb10d5e)(traceId, spanId);
}
function $aae51952f0016112$export$a1e7396778592551(_url) {
    const traceHeaders = $aae51952f0016112$export$6e17cce6446848f9();
    return traceHeaders ? new URLSearchParams(traceHeaders).toString().toLowerCase() : null;
}




var $cnjKG = parcelRequire("cnjKG");
/**
 * A random function that passes one in rate times.
 * E.g. coinflip(2) is the same as if you flipped a coin.
 * It will pass 50% of the time
 * @param rate The change that it will pass (1 in <rate> times)
 * @returns bool, if it passes or not
 */ function $4659fee6fbb6d2af$var$coinflip(rate) {
    if (rate === 0) return false;
    else if (rate === 1) return true;
    else return Math.random() * rate <= 1;
}
var $4659fee6fbb6d2af$export$2e2bcd8739ae039 = $4659fee6fbb6d2af$var$coinflip;



var $cnjKG = parcelRequire("cnjKG");
let $0d141f9c9c05f1cf$var$config;
const $0d141f9c9c05f1cf$export$f9bb3bb330fb9609 = 'fy25.03';
const $0d141f9c9c05f1cf$export$d50dacda7fe6392b = 1000;
function $0d141f9c9c05f1cf$export$10d6139a8fb42158(newConfig) {
    // Handle edge cases with `enabledVCRevisions`
    const { enabledVCRevisions: enabledVCRevisions } = newConfig?.vc ?? {};
    if (typeof enabledVCRevisions?.byExperience === 'object') $0d141f9c9c05f1cf$var$config = {
        ...newConfig,
        vc: {
            ...newConfig.vc,
            enabledVCRevisions: {
                // enforce axiom about `enabledVCRevisions.all` config
                all: Array.from(new Set([
                    $0d141f9c9c05f1cf$export$f9bb3bb330fb9609,
                    ...enabledVCRevisions?.all,
                    ...Object.values(enabledVCRevisions?.byExperience).flat()
                ])),
                byExperience: {
                    ...enabledVCRevisions?.byExperience
                }
            }
        }
    };
    else $0d141f9c9c05f1cf$var$config = newConfig;
}
function $0d141f9c9c05f1cf$export$44487a86467333c3() {
    return $0d141f9c9c05f1cf$var$config;
}
const $0d141f9c9c05f1cf$var$isValidConfigArray = (array)=>{
    return Array.isArray(array) && array.length > 0;
};
function $0d141f9c9c05f1cf$export$87fbc8e01b137811(experienceKey = '') {
    try {
        if (!$0d141f9c9c05f1cf$var$config) return [];
        if ($0d141f9c9c05f1cf$var$config.vc?.enabled) {
            const { enabledVCRevisions: enabledVCRevisions } = $0d141f9c9c05f1cf$var$config.vc ?? {};
            if ($0d141f9c9c05f1cf$var$isValidConfigArray(enabledVCRevisions?.byExperience?.[experienceKey])) return enabledVCRevisions.byExperience?.[experienceKey];
            if ($0d141f9c9c05f1cf$var$isValidConfigArray(enabledVCRevisions?.all)) return enabledVCRevisions.all;
            return [
                $0d141f9c9c05f1cf$export$f9bb3bb330fb9609
            ];
        }
        return [];
    } catch  {
        return [];
    }
}
function $0d141f9c9c05f1cf$export$4babcefc81a3ef0b(revision, experienceKey) {
    return $0d141f9c9c05f1cf$export$87fbc8e01b137811(experienceKey).includes(revision);
}
function $0d141f9c9c05f1cf$export$70184d6e2c753893(experienceKey = '') {
    const enabledVCRevisions = $0d141f9c9c05f1cf$export$87fbc8e01b137811(experienceKey);
    return enabledVCRevisions[enabledVCRevisions.length - 1];
}
function $0d141f9c9c05f1cf$export$2d8f8d64dc343d7b() {
    if (!$0d141f9c9c05f1cf$var$config) return undefined;
    try {
        const stats = $0d141f9c9c05f1cf$var$config?.getReactHydrationStats?.();
        return stats ?? undefined;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('getReactHydrationStats threw an error: ', e);
        return undefined;
    }
}
function $0d141f9c9c05f1cf$export$9466a8f085fa7d4e(name, interactionKind) {
    try {
        if (!$0d141f9c9c05f1cf$var$config) return 0;
        const { killswitch: killswitch, rates: rates, rules: rules, kind: kind, autoGeneratedRate: autoGeneratedRate } = $0d141f9c9c05f1cf$var$config;
        if (killswitch != null) {
            // Specifically kill certain events
            if (killswitch.includes(name)) return 0;
        }
        const isUnknown = name === 'unknown';
        if (isUnknown) {
            if (rates?.[name] != null) return rates[name];
            // Return default rate for unknown events when no explicit rate is configured
            return $0d141f9c9c05f1cf$export$d50dacda7fe6392b;
        }
        if (rates != null) {
            // Decide the rate explicitly
            if (rates[name] != null) return rates[name];
        }
        if (rules != null) for(let i = 0; i < rules.length; i++){
            const rule = rules[i];
            const { test: test, rate: rate } = rule;
            if (test != null && rate != null) {
                const regexp = new RegExp(test, 'ig');
                if (regexp.test(name)) return rate;
            }
        }
        const isAutogenerated = name?.startsWith('auto-generated');
        if (isAutogenerated) {
            const rate = autoGeneratedRate;
            if (rate != null) return rate;
        }
        if (kind != null) {
            const rate = kind[interactionKind];
            if (rate != null) return rate;
        }
        return 0;
    } catch (e) {
        // Fallback
        return 0;
    }
}
function $0d141f9c9c05f1cf$export$563f73272328c0d(name, interactionType) {
    try {
        if (!$0d141f9c9c05f1cf$var$config) return 0;
        const { experimentalInteractionMetrics: experimentalInteractionMetrics } = $0d141f9c9c05f1cf$var$config;
        if (!experimentalInteractionMetrics?.enabled) return 0;
        if (experimentalInteractionMetrics.rates && typeof experimentalInteractionMetrics.rates[name] === 'number') return experimentalInteractionMetrics.rates[name];
        if (experimentalInteractionMetrics.kind && typeof experimentalInteractionMetrics.kind[interactionType] === 'number') return experimentalInteractionMetrics.kind[interactionType];
        return 0;
    } catch (e) {
        return 0;
    }
}
function $0d141f9c9c05f1cf$export$1d459f020c06ae34(name, interactionType) {
    return $0d141f9c9c05f1cf$var$getConfigRate(name, interactionType, 'postInteractionLog');
}
function $0d141f9c9c05f1cf$export$29b9ffb14861a1d(capability) {
    if ((0, $cnjKG.fg)('platform_ufo_remove_deprecated_config_fields')) return 1;
    try {
        if (!$0d141f9c9c05f1cf$var$config) return 0;
        const { capability: capabilityRate } = $0d141f9c9c05f1cf$var$config;
        if (capabilityRate != null) {
            const rate = capabilityRate[capability];
            if (rate != null) return rate;
        }
        return 0;
    } catch  {
        return 0;
    }
}
function $0d141f9c9c05f1cf$var$getConfigRate(name, interactionType, configName) {
    try {
        if (!$0d141f9c9c05f1cf$var$config) return 0;
        const gotConfig = $0d141f9c9c05f1cf$var$config[configName];
        if (!gotConfig?.enabled) return 0;
        if (interactionType !== 'page_load' && interactionType !== 'transition') return 0;
        if (gotConfig.rates && typeof gotConfig.rates[name] === 'number') return gotConfig.rates[name];
        if ('kind' in gotConfig && gotConfig.kind && typeof gotConfig.kind[interactionType] === 'number') return gotConfig.kind[interactionType];
        return 0;
    } catch (e) {
        return 0;
    }
}
function $0d141f9c9c05f1cf$export$203bd06a99c66a0d(name, interactionType) {
    return $0d141f9c9c05f1cf$var$getConfigRate(name, interactionType, 'extraInteractionMetrics');
}
const $0d141f9c9c05f1cf$var$validTypingMethods = [
    'timeout',
    'timeoutNoAlloc',
    'mutationObserver'
];
function $0d141f9c9c05f1cf$export$7e32aae12bf9b50f() {
    const defaultMethod = 'timeout';
    try {
        if (!$0d141f9c9c05f1cf$var$config) return defaultMethod;
        const { typingMethod: typingMethod } = $0d141f9c9c05f1cf$var$config;
        if (typingMethod != null && $0d141f9c9c05f1cf$var$validTypingMethods.find((m)=>m === typingMethod)) return typingMethod;
        else return defaultMethod;
    } catch (e) {
        return defaultMethod;
    }
}
function $0d141f9c9c05f1cf$export$2d311b3fd18dcab1() {
    try {
        if (!$0d141f9c9c05f1cf$var$config) return [];
        const { awaitBM3TTI: awaitBM3TTI } = $0d141f9c9c05f1cf$var$config;
        if (awaitBM3TTI != null) return awaitBM3TTI;
        else return [];
    } catch (e) {
        return [];
    }
}
function $0d141f9c9c05f1cf$export$4f4649ef27b6f5d6() {
    try {
        if (!$0d141f9c9c05f1cf$var$config) return undefined;
        const { ufoNameOverrides: ufoNameOverrides } = $0d141f9c9c05f1cf$var$config;
        if (ufoNameOverrides != null) return ufoNameOverrides;
        return undefined;
    } catch (e) {
        return undefined;
    }
}
function $0d141f9c9c05f1cf$export$b150ddad71c80d77() {
    try {
        if (!$0d141f9c9c05f1cf$var$config) return undefined;
        const { minorInteractions: minorInteractions } = $0d141f9c9c05f1cf$var$config;
        return minorInteractions;
    } catch (e) {
        return undefined;
    }
}
function $0d141f9c9c05f1cf$export$3c170167645a0eff() {
    try {
        if (!$0d141f9c9c05f1cf$var$config) return undefined;
        const { doNotAbortActivePressInteraction: doNotAbortActivePressInteraction } = $0d141f9c9c05f1cf$var$config;
        return doNotAbortActivePressInteraction;
    } catch (e) {
        return undefined;
    }
}
function $0d141f9c9c05f1cf$export$d6dc9444bd15f70f() {
    try {
        if (!$0d141f9c9c05f1cf$var$config) return undefined;
        const { doNotAbortActivePressInteractionOnTransition: doNotAbortActivePressInteractionOnTransition } = $0d141f9c9c05f1cf$var$config;
        return doNotAbortActivePressInteractionOnTransition;
    } catch (e) {
        return undefined;
    }
}
function $0d141f9c9c05f1cf$export$20e8108b8ccdd0bd() {
    try {
        if (!$0d141f9c9c05f1cf$var$config) return undefined;
        const { finishInteractionOnTransition: finishInteractionOnTransition } = $0d141f9c9c05f1cf$var$config;
        return finishInteractionOnTransition;
    } catch (e) {
        return undefined;
    }
}
const $0d141f9c9c05f1cf$export$2a8604960d7d23d9 = 60000;
function $0d141f9c9c05f1cf$export$c681731847989445(ufoName) {
    try {
        if (!$0d141f9c9c05f1cf$var$config) return $0d141f9c9c05f1cf$export$2a8604960d7d23d9;
        const { interactionTimeout: interactionTimeout } = $0d141f9c9c05f1cf$var$config;
        if (interactionTimeout != null && interactionTimeout[ufoName] != null) return interactionTimeout[ufoName];
        if (interactionTimeout != null && interactionTimeout.__globalInteractionTimeout != null) return interactionTimeout.__globalInteractionTimeout;
        else return $0d141f9c9c05f1cf$export$2a8604960d7d23d9;
    } catch (e) {
        return $0d141f9c9c05f1cf$export$2a8604960d7d23d9;
    }
}


var $46ab2715b72c0996$exports = {};
"use strict";
Object.defineProperty($46ab2715b72c0996$exports, "__esModule", {
    value: true
});
$46ab2715b72c0996$exports.bindAll = $46ab2715b72c0996$exports.bind = void 0;
var $76b4a33c26f603f2$exports = {};
"use strict";
Object.defineProperty($76b4a33c26f603f2$exports, "__esModule", {
    value: true
});
$76b4a33c26f603f2$exports.bind = void 0;
function $76b4a33c26f603f2$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
$76b4a33c26f603f2$exports.bind = $76b4a33c26f603f2$var$bind;


Object.defineProperty($46ab2715b72c0996$exports, "bind", {
    enumerable: true,
    get: function() {
        return $76b4a33c26f603f2$exports.bind;
    }
});
var $ae5f81489a9fc42c$exports = {};
"use strict";
var $ae5f81489a9fc42c$var$__assign = $ae5f81489a9fc42c$exports && $ae5f81489a9fc42c$exports.__assign || function() {
    $ae5f81489a9fc42c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ae5f81489a9fc42c$var$__assign.apply(this, arguments);
};
Object.defineProperty($ae5f81489a9fc42c$exports, "__esModule", {
    value: true
});
$ae5f81489a9fc42c$exports.bindAll = void 0;

function $ae5f81489a9fc42c$var$toOptions(value) {
    if (typeof value === 'undefined') return undefined;
    if (typeof value === 'boolean') return {
        capture: value
    };
    return value;
}
function $ae5f81489a9fc42c$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $ae5f81489a9fc42c$var$__assign($ae5f81489a9fc42c$var$__assign({}, original), {
        options: $ae5f81489a9fc42c$var$__assign($ae5f81489a9fc42c$var$__assign({}, $ae5f81489a9fc42c$var$toOptions(sharedOptions)), $ae5f81489a9fc42c$var$toOptions(original.options))
    });
    return binding;
}
function $ae5f81489a9fc42c$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $ae5f81489a9fc42c$var$getBinding(original, sharedOptions);
        return (0, $76b4a33c26f603f2$exports.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
$ae5f81489a9fc42c$exports.bindAll = $ae5f81489a9fc42c$var$bindAll;


Object.defineProperty($46ab2715b72c0996$exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $ae5f81489a9fc42c$exports.bindAll;
    }
});


const $9b310dd053d891ac$var$timings = [];
let $9b310dd053d891ac$var$wasHiddenFlag;
let $9b310dd053d891ac$var$setupFlag = false;
function $9b310dd053d891ac$var$isPageHidden() {
    if ('visibilityState' in document) return document.visibilityState === 'hidden';
    else // @ts-expect-error - Property 'hidden' does not exist on type 'never'.
    return document.hidden;
}
const $9b310dd053d891ac$var$SIZE = 50;
let $9b310dd053d891ac$var$insertIndex = 0;
function $9b310dd053d891ac$var$pushHidden(isPageHiddenFlag, time) {
    $9b310dd053d891ac$var$timings[$9b310dd053d891ac$var$insertIndex] = {
        time: time ?? performance.now(),
        hidden: isPageHiddenFlag
    };
    $9b310dd053d891ac$var$insertIndex = ($9b310dd053d891ac$var$insertIndex + 1) % $9b310dd053d891ac$var$SIZE;
    $9b310dd053d891ac$var$wasHiddenFlag = isPageHiddenFlag;
}
function $9b310dd053d891ac$var$handleChange() {
    const isPageHiddenFlag = $9b310dd053d891ac$var$isPageHidden();
    if (isPageHiddenFlag) {
        if (!$9b310dd053d891ac$var$wasHiddenFlag) $9b310dd053d891ac$var$pushHidden(isPageHiddenFlag);
        $9b310dd053d891ac$var$wasHiddenFlag = true;
    } else {
        if ($9b310dd053d891ac$var$wasHiddenFlag) $9b310dd053d891ac$var$pushHidden(isPageHiddenFlag);
        $9b310dd053d891ac$var$wasHiddenFlag = false;
    }
}
function $9b310dd053d891ac$var$setup() {
    (0, $46ab2715b72c0996$exports.bind)(window, {
        type: 'pageshow',
        listener: $9b310dd053d891ac$var$handleChange
    });
    (0, $46ab2715b72c0996$exports.bind)(window, {
        type: 'pagehide',
        listener: $9b310dd053d891ac$var$handleChange
    });
    (0, $46ab2715b72c0996$exports.bind)(document, {
        type: 'visibilitychange',
        listener: $9b310dd053d891ac$var$handleChange
    });
}
function $9b310dd053d891ac$export$554cefe0f0373da4() {
    if (!$9b310dd053d891ac$var$setupFlag) {
        const isPageHiddenFlag = $9b310dd053d891ac$var$isPageHidden();
        $9b310dd053d891ac$var$pushHidden(isPageHiddenFlag, 0);
        $9b310dd053d891ac$var$setup();
        $9b310dd053d891ac$var$setupFlag = true;
    }
}
function $9b310dd053d891ac$export$768b2008623433e1(start, end) {
    // Input validation - return default for invalid inputs
    if (!Number.isFinite(start) || !Number.isFinite(end)) return 'visible';
    // Desirable default value is visible
    if ($9b310dd053d891ac$var$timings.length === 0) return 'visible';
    const currentSize = $9b310dd053d891ac$var$timings.length;
    let hiddenState = 'mixed';
    let startIdx = $9b310dd053d891ac$var$insertIndex;
    let endIdx = $9b310dd053d891ac$var$insertIndex;
    // currentSize is capped at SIZE.
    for(let i = 0; i < currentSize; i++){
        const tmpIdx = ($9b310dd053d891ac$var$insertIndex + i) % currentSize;
        // Add bounds checking before accessing array element
        if ($9b310dd053d891ac$var$timings[tmpIdx] && $9b310dd053d891ac$var$timings[tmpIdx].time <= end) {
            endIdx = tmpIdx;
            if ($9b310dd053d891ac$var$timings[tmpIdx].time <= start) startIdx = tmpIdx;
        }
    }
    // Add bounds checking before accessing timings array
    if (endIdx - startIdx === 0 && $9b310dd053d891ac$var$timings[startIdx]) hiddenState = $9b310dd053d891ac$var$timings[startIdx].hidden ? 'hidden' : 'visible';
    return hiddenState;
}





const $be63b08d44343780$export$199edc0307b5587f = {
    wheel: 'wheel',
    keydown: 'keydown',
    resize: 'resize'
};


function $94137264f8855f28$export$a497a1dcb4408212(document = window.document) {
    let documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch (e) {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
function $94137264f8855f28$export$4f01c15d21ef9cc6(document = window.document) {
    let documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch (e) {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}


function $26287bc5d3857881$export$9010aa71841a6887(window, initialViewPort, callback) {
    const unbindWheel = (0, $46ab2715b72c0996$exports.bind)(window, {
        type: (0, $be63b08d44343780$export$199edc0307b5587f).wheel,
        listener: (e)=>{
            callback((0, $be63b08d44343780$export$199edc0307b5587f).wheel, e.timeStamp);
        },
        options: {
            passive: true,
            once: true
        }
    });
    const unbindKeydown = (0, $46ab2715b72c0996$exports.bind)(window, {
        type: (0, $be63b08d44343780$export$199edc0307b5587f).keydown,
        listener: (e)=>{
            callback((0, $be63b08d44343780$export$199edc0307b5587f).keydown, e.timeStamp);
        },
        options: {
            once: true
        }
    });
    const unbindResize = (0, $46ab2715b72c0996$exports.bind)(window, {
        type: (0, $be63b08d44343780$export$199edc0307b5587f).resize,
        listener: (e)=>{
            if ((0, $94137264f8855f28$export$a497a1dcb4408212)() !== initialViewPort.w || (0, $94137264f8855f28$export$4f01c15d21ef9cc6)() !== initialViewPort.h) {
                callback((0, $be63b08d44343780$export$199edc0307b5587f).resize, e.timeStamp);
                unbindResize();
            }
        }
    });
    return [
        unbindWheel,
        unbindKeydown,
        unbindResize
    ];
}


function $e35ce536f0d590a0$export$72e6dda9d5859230({ revision: revision, isClean: isClean, abortReason: abortReason, VCEntries: VCEntries, componentsLog: componentsLog, interactionId: interactionId }) {
    // Pre-sort VCEntries by time for efficient lookups
    const sortedVCEntries = [
        ...VCEntries
    ].sort((a, b)=>a.time - b.time);
    // Pre-calculate max viewport percentage up to each time for efficient lookups
    const maxViewportPercentageAtTime = new Map();
    let maxSoFar = 0;
    for (const entry of sortedVCEntries){
        maxSoFar = Math.max(maxSoFar, entry.vc);
        maxViewportPercentageAtTime.set(entry.time, maxSoFar);
    }
    // Helper function to find the biggest previous viewport percentage
    const getBiggestPreviousViewportPercentage = (targetTime)=>{
        // Binary search for the largest time <= targetTime
        let left = 0;
        let right = sortedVCEntries.length - 1;
        let result = -1;
        while(left <= right){
            const mid = Math.floor((left + right) / 2);
            if (sortedVCEntries[mid].time <= targetTime) {
                result = mid;
                left = mid + 1;
            } else right = mid - 1;
        }
        return result >= 0 ? maxViewportPercentageAtTime.get(sortedVCEntries[result].time) || null : null;
    };
    const allVcLogs = [];
    // Add regular VC entries
    for (const entry of VCEntries){
        const timeLogEntries = componentsLog[entry.time];
        allVcLogs.push({
            time: entry.time,
            viewportPercentage: entry.vc,
            entries: entry.elements.map((element)=>{
                const logEntry = timeLogEntries?.find((log)=>log.targetName === element);
                return {
                    elementName: element,
                    type: logEntry?.type,
                    rect: logEntry?.intersectionRect,
                    visible: true,
                    attributeName: logEntry?.attributeName,
                    oldValue: logEntry?.oldValue,
                    newValue: logEntry?.newValue,
                    ignoreReason: logEntry?.ignoreReason
                };
            })
        });
    }
    // Add ignored elements - only process timestamps that have ignored elements
    for (const [timestamp, timeLogEntries] of Object.entries(componentsLog)){
        const ignoredElements = timeLogEntries.filter((log)=>log.ignoreReason);
        if (ignoredElements.length === 0) continue;
        const time = Number(timestamp);
        const viewportPercentage = getBiggestPreviousViewportPercentage(time);
        allVcLogs.push({
            time: time,
            viewportPercentage: viewportPercentage,
            entries: ignoredElements.map((logEntry)=>({
                    elementName: logEntry.targetName,
                    type: logEntry.type,
                    rect: logEntry.intersectionRect,
                    visible: false,
                    attributeName: logEntry.attributeName,
                    oldValue: logEntry.oldValue,
                    newValue: logEntry.newValue,
                    ignoreReason: logEntry.ignoreReason
                }))
        });
    }
    // Sort once at the end
    allVcLogs.sort((a, b)=>a.time - b.time);
    return {
        revision: revision,
        isClean: isClean,
        abortReason: abortReason,
        vcLogs: allVcLogs,
        interactionId: interactionId
    };
}




const $785e457733bf6f61$var$VCParts = [
    '25',
    '50',
    '75',
    '80',
    '85',
    '90',
    '95',
    '98',
    '99'
];
const $785e457733bf6f61$var$READONLY_EMPTY_ARRAY = Array.from({
    length: 0
});
// Helper function to create vcDetails object to avoid code duplication
function $785e457733bf6f61$var$createVCDetails(calculatedVC, shouldHaveVCmetric) {
    if (!shouldHaveVCmetric || !calculatedVC || !calculatedVC.VC || !calculatedVC.VCBox) return {};
    const details = {};
    const { VC: VC, VCBox: VCBox } = calculatedVC; // Destructure once to avoid repeated property access
    for (const key of $785e457733bf6f61$var$VCParts)details[key] = {
        t: VC[key] || -1,
        e: VCBox[key] || $785e457733bf6f61$var$READONLY_EMPTY_ARRAY
    };
    return details;
}
function $785e457733bf6f61$export$5c86a34c9becd6d0({ fullPrefix: fullPrefix, interaction: interaction, isVCClean: isVCClean, isEventAborted: isEventAborted, calculatedVC: calculatedVC, calculatedVCNext: calculatedVCNext, experienceKey: experienceKey, ratios: ratios }) {
    const pageVisibilityUpToTTAI = (0, $9b310dd053d891ac$export$768b2008623433e1)(interaction.start, interaction.end);
    const isVisiblePageVisibleUpToTTAI = pageVisibilityUpToTTAI === 'visible';
    const shouldHaveVCmetric = isVCClean && !isEventAborted && isVisiblePageVisibleUpToTTAI;
    const availableVCRevisionPayloads = [];
    if ((0, $0d141f9c9c05f1cf$export$4babcefc81a3ef0b)('fy25.01', experienceKey)) {
        const revision = {
            revision: 'fy25.01',
            clean: isVCClean,
            'metric:vc90': shouldHaveVCmetric ? calculatedVC.VC['90'] : null,
            vcDetails: $785e457733bf6f61$var$createVCDetails(calculatedVC, shouldHaveVCmetric)
        };
        if (shouldHaveVCmetric) revision.ratios = ratios;
        availableVCRevisionPayloads.push(revision);
    }
    if ((0, $0d141f9c9c05f1cf$export$4babcefc81a3ef0b)('fy25.02', experienceKey)) {
        const revision = {
            revision: 'fy25.02',
            clean: isVCClean,
            'metric:vc90': shouldHaveVCmetric ? calculatedVCNext.VC['90'] : null,
            vcDetails: $785e457733bf6f61$var$createVCDetails(calculatedVCNext, shouldHaveVCmetric)
        };
        if (shouldHaveVCmetric) revision.ratios = ratios;
        availableVCRevisionPayloads.push(revision);
    }
    return {
        [`${fullPrefix}vc:rev`]: availableVCRevisionPayloads
    };
}



var $84ae032d365e55f3$exports = {};
'use strict';

$84ae032d365e55f3$exports = (parcelRequire("8RNgu"));


parcelRequire("gqzfn");
const $5f09aa0131a11996$export$7674290405cc25b0 = 'data-media-vc-wrapper';
const $5f09aa0131a11996$export$7028e9efe569888c = {
    [$5f09aa0131a11996$export$7674290405cc25b0]: true
};
function $5f09aa0131a11996$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $84ae032d365e55f3$exports.jsx)("div", {
        ...$5f09aa0131a11996$export$7028e9efe569888c,
        children: children
    });
}


function $86a48bade3b91e5a$export$f61fbc3b9c4a9019(node) {
    while(node){
        if (node instanceof Element && node.hasAttribute((0, $5f09aa0131a11996$export$7674290405cc25b0))) return true;
        node = node.parentNode;
    }
    return false;
}


/**
 * Checks if a mutation record represents a non-visual style change
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is a non-visual style mutation
 *
 * A mutation is considered non-visual if:
 * - The target has data-	vc-nvs="true" attribute
 * - The changed attribute is either 'class' or 'style'
 */ function $18027e2848e11db0$var$isNonVisualStyleMutation({ target: target, attributeName: attributeName }) {
    if (!(target instanceof Element)) return false;
    if (attributeName !== 'class' && attributeName !== 'style') return false;
    if (target.getAttribute('data-vc-nvs') !== 'true') return false;
    return true;
}
var $18027e2848e11db0$export$2e2bcd8739ae039 = $18027e2848e11db0$var$isNonVisualStyleMutation;


const $c8503ffbffbc0ab6$var$GLOBAL_RLL_HANDLERS_KEY = '__REACT_UFO_RLL_PLACEHOLDER_HANDLERS__';
class $c8503ffbffbc0ab6$export$166779fc0f49d4df {
    /**
   * Gets the global singleton instance of RLLPlaceholderHandlers.
   * Creates the instance if it doesn't exist and stores it in globalThis.
   * @returns The singleton instance of RLLPlaceholderHandlers
   */ static getInstance() {
        if (typeof globalThis !== 'undefined') {
            if (!globalThis[$c8503ffbffbc0ab6$var$GLOBAL_RLL_HANDLERS_KEY]) globalThis[$c8503ffbffbc0ab6$var$GLOBAL_RLL_HANDLERS_KEY] = new $c8503ffbffbc0ab6$export$166779fc0f49d4df();
            return globalThis[$c8503ffbffbc0ab6$var$GLOBAL_RLL_HANDLERS_KEY];
        }
        // Fallback for environments without globalThis (should be rare)
        return new $c8503ffbffbc0ab6$export$166779fc0f49d4df();
    }
    reset() {
        this.placeholders = [];
    }
    /**
   * Collects all React Loosely Lazy (RLL) placeholders from the DOM and caches their viewport intersecting rectangles.
   * RLL placeholders are marked with data-lazy-begin and data-lazy-end attributes on hidden input elements.
   * Performance optimized to batch getBoundingClientRect calls and minimize layout thrashing.
   * Only stores the intersecting portions of rectangles that are currently visible in the viewport.
   */ collectRLLPlaceholders() {
        if (typeof window === 'undefined' || typeof document === 'undefined' || typeof window.document === 'undefined') return;
        const beginElements = document.querySelectorAll('input[data-lazy-begin]');
        const beginCount = beginElements.length;
        if (beginCount === 0) return;
        // Performance optimization: pre-allocate array with estimated size
        const allElements = [];
        // Performance optimization: use traditional for loop instead of forEach
        for(let i = 0; i < beginCount; i++){
            const beginEl = beginElements[i];
            const id = beginEl.getAttribute('data-lazy-begin');
            if (!id) continue;
            const elements = this.refElements(beginEl, id);
            if (elements.length > 0) allElements.push(...elements);
        }
        // Second pass: batch all getBoundingClientRect calls to minimize reflow cycles
        const allElementsLength = allElements.length;
        if (allElementsLength > 0) {
            // Performance optimization: pre-allocate array with exact size
            const intersectingRects = [];
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            for(let i = 0; i < allElementsLength; i++){
                const rect = allElements[i].getBoundingClientRect();
                // Performance optimization: inline intersection calculation to avoid function call overhead
                const left = Math.max(rect.left, 0);
                const top = Math.max(rect.top, 0);
                const right = Math.min(rect.right, windowWidth);
                const bottom = Math.min(rect.bottom, windowHeight);
                // Check if there's a valid intersection with non-zero width and height
                if (left < right && top < bottom) intersectingRects.push(new DOMRect(left, top, right - left, bottom - top));
            }
            this.placeholders = intersectingRects;
        }
    }
    /**
   * Traverses DOM siblings to find all elements between RLL begin and end markers.
   * Based on the refElements pattern from react-loosely-lazy's platform/packages/async/react-loosely-lazy/src/collect/hydrate.ts
   * Performance optimized to minimize iterations and early exit conditions.
   *
   * @param fromEl - The input element with data-lazy-begin attribute
   * @param id - The placeholder ID to match against data-lazy-end
   * @returns Array of DOM elements between the begin/end markers
   */ refElements(fromEl, id) {
        const result = [];
        let el = fromEl.nextSibling;
        // Performance optimization: use while loop instead of recursive calls
        while(el){
            if (el.dataset?.lazyEnd === id) break;
            if (el.nodeType === Node.ELEMENT_NODE) result.push(el);
            el = el.nextSibling;
        }
        return result;
    }
    /**
   * Returns the cached intersecting viewport rectangles for all RLL placeholder elements.
   * @returns Array of DOMRect objects representing the intersecting portions of placeholders within the viewport
   */ getPlaceholders() {
        return this.placeholders;
    }
    /**
   * Checks if the given intersecting rectangle matches any of the cached RLL placeholder intersecting rectangles.
   * This is designed to be called from IntersectionObserver with the intersectionRect.
   * Performance optimized with early exits and minimal calculations.
   * @param intersectingRect - The intersecting rectangle from IntersectionObserver
   * @returns true if the intersecting rectangle matches a cached placeholder rectangle and hasn't exceeded match limit, false otherwise
   */ isRLLPlaceholderHydration(intersectingRect) {
        const placeholdersLength = this.placeholders.length;
        if (placeholdersLength === 0) return false;
        // Performance optimization: cache array length and use traditional for loop
        for(let i = 0; i < placeholdersLength; i++){
            const placeholderRect = this.placeholders[i];
            if (this.areRectsEqual(intersectingRect, placeholderRect)) return true;
        }
        return false;
    }
    /**
   * Compares two DOMRect objects for equality with ±1 pixel tolerance.
   * Performance optimized to minimize calculations and early exit on major differences.
   * @param rect1 - First rectangle to compare
   * @param rect2 - Second rectangle to compare
   * @returns true if rectangles are within 1 pixel tolerance for all properties
   */ areRectsEqual(rect1, rect2) {
        // Early exit for exact matches (most common case)
        if (rect1.left === rect2.left && rect1.top === rect2.top && rect1.right === rect2.right && rect1.bottom === rect2.bottom) return true;
        // Performance optimization: check largest differences first for early exit
        const leftDiff = rect1.left - rect2.left;
        if (leftDiff > 1 || leftDiff < -1) return false;
        const rightDiff = rect1.right - rect2.right;
        if (rightDiff > 1 || rightDiff < -1) return false;
        const topDiff = rect1.top - rect2.top;
        if (topDiff > 1 || topDiff < -1) return false;
        const bottomDiff = rect1.bottom - rect2.bottom;
        if (bottomDiff > 1 || bottomDiff < -1) return false;
        return true;
    }
    constructor(){
        this.placeholders = [];
        if (typeof window !== 'undefined' && typeof document !== 'undefined' && typeof window.document !== 'undefined') this.collectRLLPlaceholders();
    }
}


const $fb991c433aa54a3e$var$ANCESTOR_LOOKUP_LIMIT = 10;
const $fb991c433aa54a3e$var$PAGE_LAYOUT_ID = 'page-layout.root';
class $fb991c433aa54a3e$export$c0102f1a1198d10f {
    clear() {
        this.staticPlaceholders = new Map();
        this.callbacks = new Map();
        this.getSizeCallbacks = new Map();
        this.reactValidateCallbacks = new Map();
    }
    collectPlaceholdersInternal() {
        const selector = this.enablePageLayoutPlaceholder ? '[data-ssr-placeholder],[data-testid="page-layout.root"]' : '[data-ssr-placeholder]';
        const existingElements = document.querySelectorAll(selector);
        existingElements.forEach((el)=>{
            const placeholderId = el instanceof HTMLElement && this.getPlaceholderId(el);
            if (placeholderId && !this.staticPlaceholders.has(placeholderId)) {
                let width = -1;
                let height = -1;
                let x = -1;
                let y = -1;
                // Use SSR dimensions from window global if available
                const boundingClientRect = window.__SSR_PLACEHOLDERS_DIMENSIONS__?.[placeholderId];
                if (boundingClientRect) {
                    width = boundingClientRect.width;
                    height = boundingClientRect.height;
                    x = boundingClientRect.x;
                    y = boundingClientRect.y;
                } else {
                    // Fallback to current bounding rect if SSR dimensions not available
                    const rect = el.getBoundingClientRect();
                    width = rect.width;
                    height = rect.height;
                    x = rect.x;
                    y = rect.y;
                }
                this.staticPlaceholders.set(placeholderId, {
                    width: width,
                    height: height,
                    x: x,
                    y: y
                });
                this.intersectionObserver?.observe(el);
            }
        });
    }
    /**
   * Added this method to be utilised for testing purposes.
   * In production it collection placeholder should only happens on constructor
   */ collectExistingPlaceholders() {
        if (!window.document) return;
        try {
            // Collect placeholders using SSR dimensions or fallback to live dimensions
            this.collectPlaceholdersInternal();
        } catch (e) {
        // Silently fail if there are any issues
        } finally{
            delete window.__SSR_PLACEHOLDERS_DIMENSIONS__;
        }
    }
    isPlaceholder(element) {
        return Boolean(this.getPlaceholderId(element));
    }
    isPlaceholderReplacement(element) {
        return Boolean(this.getPlaceholderReplacementId(element));
    }
    isPlaceholderIgnored(element) {
        // data-ssr-placeholder-ignored doesn't have a value.
        return 'ssrPlaceholderIgnored' in element.dataset;
    }
    findNearestPlaceholderContainerIfIgnored(element) {
        if (!this.isPlaceholderIgnored(element)) return element;
        let ancestor = element.parentElement;
        let i = 0;
        while(ancestor && i < $fb991c433aa54a3e$var$ANCESTOR_LOOKUP_LIMIT){
            if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
            ancestor = ancestor.parentElement;
            i++;
        }
        return element;
    }
    // Validates placeholder match using asynchronous observation and resolves with the result
    checkIfExistedAndSizeMatching(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderId(el);
        return new Promise((resolve)=>{
            if (!this.staticPlaceholders.has(id)) {
                resolve(false);
                return;
            } else {
                this.callbacks.set(id, resolve);
                this.intersectionObserver?.observe(el);
            }
        });
    }
    // Validates placeholder match synchronously using stored SSR dimensions and current bounds
    checkIfExistedAndSizeMatchingV3(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderId(el);
        const placeholderRects = this.staticPlaceholders.get(id);
        if (!placeholderRects) return false;
        return this.hasSameSizePosition(placeholderRects, this.getEffectiveBoundingRect(el));
    }
    getSize(el) {
        return new Promise((resolve)=>{
            this.getSizeCallbacks.set(this.getPlaceholderId(el), resolve);
            this.intersectionObserver?.observe(el);
        });
    }
    validateReactComponentMatchToPlaceholder(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderReplacementId(el);
        return new Promise((resolve)=>{
            if (!this.staticPlaceholders.has(id)) {
                resolve(false);
                return;
            } else {
                this.reactValidateCallbacks.set(id, resolve);
                this.intersectionObserver?.observe(el);
            }
        });
    }
    hasSameSizePosition(rect, boundingClientRect) {
        if (!rect) return false;
        const horizontalCheck = Math.abs(rect.x - boundingClientRect.x) < this.EQUALITY_THRESHOLD && Math.abs(rect.width - boundingClientRect.width) < this.EQUALITY_THRESHOLD;
        const verticalCheck = Math.abs(rect.y - boundingClientRect.y) < this.EQUALITY_THRESHOLD && Math.abs(rect.height - boundingClientRect.height) < this.EQUALITY_THRESHOLD;
        return horizontalCheck && verticalCheck || false;
    }
    /**
   * Gets the effective bounding rectangle for an element, handling display: contents elements
   * by collecting dimensions from their children instead
   */ getEffectiveBoundingRect(el) {
        const computedStyle = window.getComputedStyle(el);
        // If element has display: contents, collect bounding rect from children
        if (computedStyle.display === 'contents') {
            const children = Array.from(el.children);
            if (children.length === 0) // No children, return zero rect
            return new DOMRect(0, 0, 0, 0);
            // Calculate union of all children's bounding rects
            let minX = Infinity;
            let minY = Infinity;
            let maxX = -Infinity;
            let maxY = -Infinity;
            children.forEach((child)=>{
                const childRect = child.getBoundingClientRect();
                // Skip children with zero dimensions (likely also display: contents)
                if (childRect.width > 0 || childRect.height > 0) {
                    minX = Math.min(minX, childRect.left);
                    minY = Math.min(minY, childRect.top);
                    maxX = Math.max(maxX, childRect.right);
                    maxY = Math.max(maxY, childRect.bottom);
                }
            });
            // If no children with dimensions found, return zero rect
            if (minX === Infinity) return new DOMRect(0, 0, 0, 0);
            return new DOMRect(minX, minY, maxX - minX, maxY - minY);
        }
        // Normal element, return its bounding rect
        return el.getBoundingClientRect();
    }
    isDummyRect(rect) {
        return rect && rect.width < 0 && rect.height < 0 || false;
    }
    constructor({ enablePageLayoutPlaceholder: enablePageLayoutPlaceholder = false }){
        this.staticPlaceholders = new Map();
        this.callbacks = new Map();
        this.getSizeCallbacks = new Map();
        this.reactValidateCallbacks = new Map();
        this.intersectionObserver = void 0;
        this.EQUALITY_THRESHOLD = 1;
        this.enablePageLayoutPlaceholder = void 0;
        this.getPlaceholderId = (el)=>{
            const ssrPlaceholderId = el?.dataset?.ssrPlaceholder;
            if (!!ssrPlaceholderId) return ssrPlaceholderId;
            if (this.enablePageLayoutPlaceholder && el?.dataset.testid === $fb991c433aa54a3e$var$PAGE_LAYOUT_ID) return $fb991c433aa54a3e$var$PAGE_LAYOUT_ID;
            return '';
        };
        this.getPlaceholderReplacementId = (el)=>{
            const ssrPlaceholderReplaceId = el?.dataset?.ssrPlaceholderReplace;
            if (!!ssrPlaceholderReplaceId) return ssrPlaceholderReplaceId;
            if (this.enablePageLayoutPlaceholder && el?.dataset.testid === $fb991c433aa54a3e$var$PAGE_LAYOUT_ID) return $fb991c433aa54a3e$var$PAGE_LAYOUT_ID;
            return '';
        };
        this.intersectionObserverCallback = ({ target: target, boundingClientRect: boundingClientRect })=>{
            this.intersectionObserver?.unobserve(target);
            if (!(target instanceof HTMLElement)) // impossible case - keep typescript healthy
            return;
            const staticKey = this.getPlaceholderId(target);
            if (staticKey) {
                if (this.staticPlaceholders.has(staticKey) && this.callbacks.has(staticKey)) {
                    // validation
                    const resolve = this.callbacks.get(staticKey);
                    if (!resolve) return;
                    const rect = this.staticPlaceholders.get(staticKey);
                    const hasSameSizePosition = this.hasSameSizePosition(rect, boundingClientRect);
                    if (hasSameSizePosition || this.isDummyRect(rect)) resolve(hasSameSizePosition);
                    else requestAnimationFrame(()=>{
                        const targetRect = this.getEffectiveBoundingRect(target);
                        const hasSameSizePosition = this.hasSameSizePosition(rect, targetRect);
                        resolve(hasSameSizePosition);
                    });
                    this.callbacks.delete(staticKey);
                }
            } else {
                const key = this.getPlaceholderReplacementId(target);
                const resolve = this.reactValidateCallbacks.get(key);
                if (!resolve) return;
                const rect = this.staticPlaceholders.get(key);
                const hasSameSizePosition = this.hasSameSizePosition(rect, boundingClientRect);
                if (hasSameSizePosition || this.isDummyRect(rect)) resolve(hasSameSizePosition);
                else requestAnimationFrame(()=>{
                    const targetRect = this.getEffectiveBoundingRect(target);
                    const hasSameSizePosition = this.hasSameSizePosition(rect, targetRect);
                    resolve(hasSameSizePosition);
                });
                this.staticPlaceholders.delete(staticKey);
                this.reactValidateCallbacks.delete(staticKey);
            }
        };
        if (typeof IntersectionObserver === 'function') // Only instantiate the IntersectionObserver if it's supported
        this.intersectionObserver = new IntersectionObserver((entries)=>entries.filter((entry)=>entry.intersectionRatio > 0).forEach(this.intersectionObserverCallback));
        this.enablePageLayoutPlaceholder = enablePageLayoutPlaceholder;
        if (window.document) try {
            // Collect initial placeholders using SSR dimensions
            this.collectPlaceholdersInternal();
        } catch (e) {} finally{
            delete window.__SSR_PLACEHOLDERS_DIMENSIONS__;
        }
    }
}


const $9eac344254cae2d4$var$state = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
function $9eac344254cae2d4$var$isElementVisible(target) {
    if (!target || typeof target.checkVisibility !== 'function') return true;
    const isVisible = target.checkVisibility({
        contentVisibilityAuto: true,
        opacityProperty: true,
        visibilityProperty: true
    });
    return isVisible;
}
class $9eac344254cae2d4$export$b65d046240060e78 {
    isBrowserSupported() {
        return typeof window.IntersectionObserver === 'function' && typeof window.MutationObserver === 'function';
    }
    observe() {
        this.totalTime = 0;
        this.ssr = {
            state: $9eac344254cae2d4$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.mutationObserver?.observe(document.body, {
            attributeFilter: [
                'hidden',
                'style',
                'src',
                'class'
            ],
            attributeOldValue: true,
            attributes: true,
            childList: true,
            subtree: true
        });
    }
    disconnect() {
        this.mutationObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.observedMutations = new WeakMap();
        this.elementsInView.clear();
        this.callbacks.clear();
        this.ssr.reactRootElement = null;
        this.ssrPlaceholderHandler.clear();
    }
    getTotalTime() {
        return this.totalTime;
    }
    setReactRootElement(element) {
        this.ssr.reactRootElement = element;
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.ssr.renderStart = startTime;
        this.ssr.state = $9eac344254cae2d4$var$state.waitingForFirstRender;
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.ssr.renderStop = stopTime;
    }
    getMutationObserver() {
        if (!this.isBrowserSupported()) return null;
        return new MutationObserver((mutations)=>{
            this.measureStart();
            mutations.forEach((mutation)=>{
                // patching element if timestamp not automatically added
                // eslint-disable-next-line no-param-reassign
                mutation.timestamp = mutation.timestamp === undefined ? performance.now() : mutation.timestamp;
                let ignoreReason = '';
                if (this.ssr.state === $9eac344254cae2d4$var$state.waitingForFirstRender && mutation.timestamp > this.ssr.renderStart && mutation.target === this.ssr.reactRootElement) {
                    this.ssr.state = $9eac344254cae2d4$var$state.ignoring;
                    if (this.ssr.renderStop === -1) // arbitrary 500ms DOM update window
                    this.ssr.renderStop = mutation.timestamp + 500;
                    ignoreReason = 'ssr-hydration';
                }
                if (this.ssr.state === $9eac344254cae2d4$var$state.ignoring && mutation.timestamp > this.ssr.renderStart && mutation.target === this.ssr.reactRootElement) {
                    if (mutation.timestamp <= this.ssr.renderStop) ignoreReason = 'ssr-hydration';
                    else this.ssr.state = $9eac344254cae2d4$var$state.normal;
                }
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach((node)=>{
                        if ((0, $86a48bade3b91e5a$export$f61fbc3b9c4a9019)(node)) ignoreReason = 'image';
                        if (node instanceof HTMLElement) {
                            if (this.ssrPlaceholderHandler.isPlaceholder(node) || this.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                this.ssrPlaceholderHandler.checkIfExistedAndSizeMatching(node).then((result)=>{
                                    if (result === false) this.observeElement(node, mutation, 'html', ignoreReason);
                                });
                                return;
                            }
                            if (this.ssrPlaceholderHandler.isPlaceholderReplacement(node) || this.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                this.ssrPlaceholderHandler.validateReactComponentMatchToPlaceholder(node).then((result)=>{
                                    if (result === false) this.observeElement(node, mutation, 'html', ignoreReason);
                                });
                                return;
                            }
                            this.observeElement(node, mutation, 'html', ignoreReason);
                        }
                        if (node instanceof Text && node.parentElement != null) this.observeElement(node.parentElement, mutation, 'text', ignoreReason);
                    });
                    mutation.removedNodes.forEach((node)=>{
                        if (node instanceof Element) {
                            this.elementsInView.delete(node);
                            this.intersectionObserver?.unobserve(node);
                        }
                    });
                } else if (mutation.type === 'attributes') {
                    if (mutation.target instanceof HTMLElement) {
                        const attributeName = mutation.attributeName;
                        /*
            	"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
            	I think it might have been something along the lines that for consistency every setAttribute call should create a record.
            	Conceptually there is after all a mutation: there is an old value replaced with a new one,
            	and whether or not they are the same doesn't really matter.
            	And Custom elements should work the same way as MutationObserver."
            	https://github.com/whatwg/dom/issues/520#issuecomment-336574796
            */ const oldValue = mutation.oldValue ?? undefined;
                        const newValue = attributeName ? mutation.target.getAttribute(attributeName) : undefined;
                        if (oldValue !== newValue) {
                            if ((0, $18027e2848e11db0$export$2e2bcd8739ae039)(mutation)) ignoreReason = 'non-visual-style';
                            if ((0, $86a48bade3b91e5a$export$f61fbc3b9c4a9019)(mutation.target)) ignoreReason = 'image';
                            this.observeElement(mutation.target, mutation, 'attr', ignoreReason, attributeName, oldValue, newValue);
                        }
                    }
                }
            });
        });
    }
    getElementName(element) {
        try {
            const tagName = element.localName;
            const dataVCAttr = element.getAttribute('data-vc');
            const dataVC = this.selectorConfig.dataVC && dataVCAttr ? `[data-vc="${dataVCAttr}"]` : '';
            const id = this.selectorConfig.id && element.id ? `#${element.id}` : '';
            let testId = this.selectorConfig.testId ? element.getAttribute('data-testid') || element.getAttribute('data-test-id') : '';
            testId = testId ? `[testid=${testId}]` : '';
            let role = this.selectorConfig.role ? element.getAttribute('role') : '';
            role = role ? `[role=${role}]` : '';
            let classList = this.selectorConfig.className ? Array.from(element.classList).join('.') : '';
            classList = classList === '' ? '' : `.${classList}`;
            const attrs = dataVC ? dataVC : [
                id,
                testId,
                role
            ].join('');
            let idString = '';
            if (attrs === '' && classList === '') {
                const parent = element.parentElement ? this.getElementName(element.parentElement) : 'unknown';
                idString = `${parent} > ${tagName}`;
            } else idString = [
                tagName,
                attrs || classList
            ].join('');
            return idString;
        } catch (e) {
            return 'error';
        }
    }
    getIntersectionObserver() {
        if (!this.isBrowserSupported()) return null;
        return new IntersectionObserver((entries)=>{
            this.measureStart();
            entries.forEach(({ isIntersecting: isIntersecting, intersectionRect: ir, target: target })=>{
                const data = this.observedMutations.get(target);
                this.observedMutations.delete(target);
                if (isIntersecting && ir.width > 0 && ir.height > 0) {
                    if (!(target instanceof HTMLElement)) return;
                    if (!data?.mutation) // ignore intersection report without recent mutation
                    return;
                    if (!$9eac344254cae2d4$var$isElementVisible(target)) data.ignoreReason = 'not-visible';
                    if ((0, $c8503ffbffbc0ab6$export$166779fc0f49d4df).getInstance().isRLLPlaceholderHydration(ir)) data.ignoreReason = 'rll-placeholder';
                    this.callbacks.forEach((callback)=>{
                        let elementName;
                        try {
                            elementName = this.getElementName(target);
                        } catch (e) {
                            elementName = 'error';
                        }
                        callback(data.mutation.timestamp || performance.now(), ir, elementName, target, data.type, data.ignoreReason, data.attributeName, data.oldValue, data.newValue);
                    });
                    this.elementsInView.add(target);
                } else this.elementsInView.delete(target);
            });
            this.measureStop();
        });
    }
    measureStart() {
        this._startMeasureTimestamp = performance.now();
    }
    measureStop() {
        if (this._startMeasureTimestamp === -1) return;
        this.totalTime += performance.now() - this._startMeasureTimestamp;
        this._startMeasureTimestamp = -1;
    }
    constructor(opts){
        this.intersectionObserver = void 0;
        this.mutationObserver = void 0;
        this.observedMutations = new WeakMap();
        this.elementsInView = new Set();
        this.callbacks = new Set();
        this.totalTime = 0;
        this._startMeasureTimestamp = -1;
        this.ssrPlaceholderHandler = void 0;
        this.ssr = {
            state: $9eac344254cae2d4$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.selectorConfig = {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        };
        this.subscribeResults = (cb)=>{
            this.callbacks.add(cb);
        };
        this.observeElement = (node, mutation, type, ignoreReason, attributeName, oldValue = null, newValue = null)=>{
            this.intersectionObserver?.observe(node);
            this.observedMutations.set(node, {
                mutation: mutation,
                ignoreReason: ignoreReason,
                type: type,
                attributeName: attributeName,
                oldValue: oldValue,
                newValue: newValue
            });
        };
        this.selectorConfig = {
            ...this.selectorConfig,
            ...opts.selectorConfig
        };
        this.intersectionObserver = this.getIntersectionObserver();
        this.mutationObserver = this.getMutationObserver();
        // Use shared SSR placeholder handler if provided, otherwise create new one
        if (opts.ssrPlaceholderHandler) this.ssrPlaceholderHandler = opts.ssrPlaceholderHandler;
        else this.ssrPlaceholderHandler = new (0, $fb991c433aa54a3e$export$c0102f1a1198d10f)({
            enablePageLayoutPlaceholder: opts.SSRConfig?.enablePageLayoutPlaceholder
        });
    }
}


const $18ea8dbf711a6ef1$var$abortReason = {
    scroll: 'scroll',
    keypress: 'keypress',
    resize: 'resize',
    error: 'error'
};
const $18ea8dbf711a6ef1$var$UNUSED_SECTOR = 0;
function $18ea8dbf711a6ef1$var$filterComponentsLog(log) {
    return Object.fromEntries(Object.entries(log).map(([timestamp, entries])=>[
            Number(timestamp),
            entries.map((entry)=>{
                const { __debug__element: __debug__element, ...rest } = entry;
                return rest;
            })
        ]));
}
class $18ea8dbf711a6ef1$export$1f70d263701b1d01 {
    start({ startTime: startTime }) {
        this.active = true;
        if (this.observers.isBrowserSupported()) {
            this.setViewportSize();
            this.resetState();
            this.startTime = startTime;
            this.attachAbortListeners();
            this.observers.subscribeResults(this.handleUpdate);
            this.observers.observe();
        } else this.setAbortReason('not-supported', startTime);
    }
    stop() {
        this.observers.disconnect();
        this.detachAbortListeners();
    }
    getIgnoredElements(componentsLog) {
        return Object.values(componentsLog).flat().filter(({ ignoreReason: ignoreReason })=>Boolean(ignoreReason)).map(({ targetName: targetName, ignoreReason: ignoreReason })=>({
                targetName: targetName,
                ignoreReason: ignoreReason
            }));
    }
    static getSSRRatio(entries, ssr) {
        if (ssr === undefined || entries.length === 0) return undefined;
        const maybeSSR = entries[0];
        if (maybeSSR.elements[0] === 'SSR') return maybeSSR.vc;
        return 0;
    }
    static calculateVC({ heatmap: heatmap, ssr: ssr = $18ea8dbf711a6ef1$var$UNUSED_SECTOR, componentsLog: componentsLog, viewport: viewport, fixSSRAttribution: fixSSRAttribution }) {
        const lastUpdate = {};
        let totalPainted = 0;
        const ssrTime = fixSSRAttribution ? Math.floor(ssr) : ssr;
        if (ssrTime !== $18ea8dbf711a6ef1$var$UNUSED_SECTOR) {
            const element = {
                __debug__element: new WeakRef(window.document?.body),
                intersectionRect: {
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    x: 0,
                    y: 0,
                    width: viewport.w,
                    height: viewport.h,
                    toJSON () {
                        return {};
                    }
                },
                targetName: 'SSR'
            };
            if (!componentsLog[ssrTime]) componentsLog[ssrTime] = [];
            componentsLog[ssrTime].push(element);
        }
        heatmap.forEach((line)=>{
            line.forEach((entry)=>{
                const rounded = Math.floor(entry === $18ea8dbf711a6ef1$var$UNUSED_SECTOR && ssrTime !== $18ea8dbf711a6ef1$var$UNUSED_SECTOR ? ssrTime : entry);
                totalPainted += rounded !== $18ea8dbf711a6ef1$var$UNUSED_SECTOR ? 1 : 0;
                if (rounded !== $18ea8dbf711a6ef1$var$UNUSED_SECTOR) lastUpdate[rounded] = lastUpdate[rounded] ? lastUpdate[rounded] + 1 : 1;
            });
        });
        const entries = Object.entries(lastUpdate).map((a)=>[
                parseInt(a[0], 10),
                a[1]
            ]).sort((a, b)=>a[0] > b[0] ? 1 : -1);
        const VC = $18ea8dbf711a6ef1$export$1f70d263701b1d01.makeVCReturnObj();
        const VCBox = $18ea8dbf711a6ef1$export$1f70d263701b1d01.makeVCReturnObj();
        entries.reduce((acc = 0, v)=>{
            const currRatio = v[1] / totalPainted;
            let VCRatio = currRatio + acc;
            const preciseCurrRatio = Math.round(100 * (v[1] / totalPainted));
            const preciseAccRatio = Math.round(acc * 100);
            VCRatio = (preciseCurrRatio + preciseAccRatio) / 100;
            const time = v[0];
            $18ea8dbf711a6ef1$export$1f70d263701b1d01.VCParts.forEach((key)=>{
                const value = parseInt(key, 10);
                if ((VC[key] === null || VC[key] === undefined) && VCRatio >= value / 100) {
                    VC[key] = time;
                    VCBox[key] = [
                        ...new Set(componentsLog[time]?.filter((v)=>!v.ignoreReason).map((v)=>v.targetName))
                    ];
                }
            });
            return VCRatio;
        }, 0);
        const VCEntries = entries.reduce((acc, [timestamp, entryPainted], i)=>{
            const currentlyPainted = entryPainted + (acc.abs[i - 1]?.[1] || 0);
            const currentlyPaintedRatio = Math.round(currentlyPainted / totalPainted * 1000) / 10;
            const logEntry = [
                ...new Set(componentsLog[timestamp]?.filter((v)=>!v.ignoreReason).map((v)=>v.targetName))
            ];
            const ratioDelta = (currentlyPaintedRatio - (acc.rel[i - 1]?.vc ?? 0)) / 100;
            const speedIndex = timestamp * ratioDelta;
            acc.speedIndex += speedIndex;
            acc.abs.push([
                timestamp,
                currentlyPainted
            ]);
            acc.rel.push({
                time: timestamp,
                vc: currentlyPaintedRatio,
                elements: logEntry
            });
            return acc;
        }, {
            abs: [],
            rel: [],
            speedIndex: 0
        });
        VCEntries.speedIndex = Math.round(VCEntries.speedIndex);
        return {
            VC: VC,
            VCBox: VCBox,
            VCEntries: VCEntries,
            totalPainted: totalPainted
        };
    }
    setSSRElement(element) {
        this.observers.setReactRootElement(element);
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.observers.setReactRootRenderStart(startTime);
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.observers.setReactRootRenderStop(stopTime);
    }
    collectSSRPlaceholders() {
    // This is handled by the shared SSRPlaceholderHandlers in VCObserverWrapper
    // Individual observers don't need to implement this
    }
    setAbortReason(abort, timestamp, info = '') {
        if (this.abortReason.reason === null || this.abortReason.blocking === false) {
            this.abortReason.reason = abort;
            this.abortReason.info = info;
            this.abortReason.timestamp = timestamp;
            this.abortReason.blocking = abort !== $18ea8dbf711a6ef1$var$abortReason.scroll;
            if (this.abortReason.blocking) this.detachAbortListeners();
        }
    }
    resetState() {
        this.abortReason = {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        };
        this.detachAbortListeners();
        this.heatmap = !(0, $0d141f9c9c05f1cf$export$4babcefc81a3ef0b)('fy25.01') ? [] : this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.totalTime = 0;
        this.componentsLog = {};
        this.vcRatios = {};
    }
    getCleanHeatmap() {
        return Array(this.arraySize).fill('').map(()=>Array(this.arraySize).fill($18ea8dbf711a6ef1$var$UNUSED_SECTOR));
    }
    setViewportSize() {
        this.viewport.w = (0, $94137264f8855f28$export$a497a1dcb4408212)();
        this.viewport.h = (0, $94137264f8855f28$export$4f01c15d21ef9cc6)();
    }
    applyChangesToHeatMap(a, time, heatmap) {
        const { l: l, t: t, r: r, b: b } = a;
        const localHeatmap = heatmap;
        for(let row = t; row < b; row++){
            for(let col = l; col < r; col++)if (localHeatmap[row] === undefined) {
                try {
                    this.setAbortReason($18ea8dbf711a6ef1$var$abortReason.error, time, `index - ${row}`);
                } catch (e) {
                    this.setAbortReason($18ea8dbf711a6ef1$var$abortReason.error, time, 'row error');
                }
                return;
            } else localHeatmap[row][col] = time;
        }
    }
    static makeVCReturnObj() {
        const vc = {};
        $18ea8dbf711a6ef1$export$1f70d263701b1d01.VCParts.forEach((v)=>{
            vc[v] = null;
        });
        return vc;
    }
    detachAbortListeners() {
        if (this.unbind) {
            const { unbind: unbind } = this;
            for(let i = 0; i < unbind.length; i++)unbind[i]();
            this.unbind.length = 0;
        }
    }
    measureStart() {
        this._startMeasureTimestamp = performance.now();
    }
    measureStop() {
        if (this._startMeasureTimestamp === -1) return;
        this.totalTime += performance.now() - this._startMeasureTimestamp;
        this._startMeasureTimestamp = -1;
    }
    constructor(options){
        /* abort logic */ this.abortReason = {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        };
        this.outOfBoundaryInfo = '';
        this.viewport = {
            w: 0,
            h: 0
        };
        /* heatmap */ this.arraySize = 0;
        this.heatmap = void 0;
        this.heatmapNext = void 0;
        this.componentsLog = {};
        this.vcRatios = {};
        this.active = false;
        this.totalTime = 0;
        this.startTime = 0;
        this.observers = void 0;
        this._startMeasureTimestamp = -1;
        this.ssr = {
            reactRendered: -1
        };
        this.devToolsEnabled = void 0;
        this.oldDomUpdatesEnabled = void 0;
        this.unbind = [];
        this.isPostInteraction = void 0;
        this.getAbortReasonInfo = ()=>{
            if (this.abortReason.reason === null) return null;
            const info = this.abortReason.info !== '' ? ` ${this.abortReason.info}` : '';
            return `${this.abortReason.reason}${info}`;
        };
        this.getVCRawData = ()=>{
            this.measureStart();
            if (!this.active) {
                this.measureStop();
                return null;
            }
            this.stop();
            const abortReasonInfo = this.getAbortReasonInfo();
            this.measureStop();
            return {
                abortReasonInfo: abortReasonInfo,
                abortReason: {
                    ...this.abortReason
                },
                heatmap: this.heatmap,
                heatmapNext: this.heatmapNext,
                outOfBoundaryInfo: this.outOfBoundaryInfo,
                totalTime: Math.round(this.totalTime + this.observers.getTotalTime()),
                componentsLog: {
                    ...this.componentsLog
                },
                viewport: {
                    ...this.viewport
                },
                oldDomUpdatesEnabled: this.oldDomUpdatesEnabled,
                devToolsEnabled: this.devToolsEnabled,
                ratios: this.vcRatios
            };
        };
        this.getVCResult = async ({ start: start, stop: stop, tti: tti, prefix: prefix, ssr: ssr, vc: vc, isEventAborted: isEventAborted, experienceKey: experienceKey, interactionId: interactionId, includeSSRRatio: includeSSRRatio })=>{
            const startTime = performance.now();
            // add local measurement
            const fullPrefix = prefix !== undefined && prefix !== '' ? `${prefix}:` : '';
            const rawData = vc !== undefined ? vc : this.getVCRawData();
            if (rawData === null) return {};
            const { abortReason: abortReason, abortReasonInfo: abortReasonInfo, heatmap: heatmap, heatmapNext: heatmapNext, outOfBoundaryInfo: outOfBoundaryInfo, totalTime: totalTime, componentsLog: componentsLog, viewport: viewport, devToolsEnabled: devToolsEnabled, ratios: ratios } = rawData;
            const isTTVCv1Disabled = !(0, $0d141f9c9c05f1cf$export$4babcefc81a3ef0b)('fy25.01', experienceKey);
            if (abortReasonInfo !== null) {
                // exposing data to devtools
                try {
                    if (devToolsEnabled && !this.isPostInteraction) window.__vcNotAvailableReason = abortReasonInfo;
                } catch (e) {}
                const vcAbortedResultWithRevisions = {
                    [`${fullPrefix}vc:rev`]: [
                        {
                            revision: 'fy25.02',
                            clean: false,
                            'metric:vc90': null,
                            abortReason: abortReason.reason,
                            abortTimestamp: Math.round(abortReason.timestamp)
                        }
                    ]
                };
                if (!isTTVCv1Disabled) vcAbortedResultWithRevisions[`${fullPrefix}vc:rev`].push({
                    revision: 'fy25.01',
                    clean: false,
                    'metric:vc90': null,
                    abortReason: abortReason.reason,
                    abortTimestamp: Math.round(abortReason.timestamp)
                });
                return vcAbortedResultWithRevisions;
            }
            const ttvcV1Result = isTTVCv1Disabled ? {
                VC: {},
                VCBox: {},
                VCEntries: {
                    abs: [],
                    rel: [],
                    speedIndex: -1
                },
                totalPainted: -1
            } : $18ea8dbf711a6ef1$export$1f70d263701b1d01.calculateVC({
                heatmap: heatmap,
                ssr: ssr,
                componentsLog: {
                    ...componentsLog
                },
                viewport: viewport,
                fixSSRAttribution: includeSSRRatio
            });
            const { VC: VC, VCBox: VCBox, VCEntries: VCEntries, totalPainted: totalPainted } = ttvcV1Result;
            const _componentsLog = {};
            Object.entries(this.componentsLog).forEach(([_timestamp, value])=>{
                const timestamp = Number(_timestamp);
                if (stop > timestamp) _componentsLog[timestamp] = value;
            });
            const vcNext = $18ea8dbf711a6ef1$export$1f70d263701b1d01.calculateVC({
                heatmap: heatmapNext,
                ssr: ssr,
                componentsLog: _componentsLog,
                viewport: viewport,
                fixSSRAttribution: includeSSRRatio
            });
            const outOfBoundary = outOfBoundaryInfo ? {
                [`${fullPrefix}vc:oob`]: outOfBoundaryInfo
            } : {};
            //const oldDomUpdates = oldDomUpdatesEnabled ? { [`${fullPrefix}vc:old:dom`]: vcNext.VCBox } : {};
            const stopTime = performance.now();
            // exposing data to devtools
            try {
                if (!this.isPostInteraction && devToolsEnabled) {
                    const ttvcV1DevToolInfo = isTTVCv1Disabled ? undefined : {
                        entries: VCEntries.rel,
                        log: componentsLog,
                        metrics: {
                            '75': VC['75'],
                            '80': VC['80'],
                            '85': VC['85'],
                            '90': VC['90'],
                            '95': VC['95'],
                            '98': VC['98'],
                            '99': VC['99'],
                            tti: tti,
                            ttai: stop - start
                        },
                        start: start,
                        stop: stop,
                        heatmap: heatmap,
                        ratios: ratios
                    };
                    const ttvcV2DevToolInfo = {
                        entries: vcNext.VCEntries.rel,
                        log: componentsLog,
                        metrics: {
                            '75': vcNext.VC['75'],
                            '80': vcNext.VC['80'],
                            '85': vcNext.VC['85'],
                            '90': vcNext.VC['90'],
                            '95': vcNext.VC['95'],
                            '98': vcNext.VC['98'],
                            '99': vcNext.VC['99'],
                            tti: tti,
                            ttai: stop - start
                        },
                        start: start,
                        stop: stop,
                        heatmap: heatmapNext,
                        ratios: ratios
                    };
                    if (isTTVCv1Disabled) {
                        window.__vc = ttvcV2DevToolInfo;
                        window.__vcNext = ttvcV2DevToolInfo;
                    } else {
                        window.__vc = ttvcV1DevToolInfo;
                        window.__vcNext = ttvcV2DevToolInfo;
                    }
                    // Emitting a custom event to make it available in the Chrome extension
                    window.dispatchEvent(new CustomEvent('vcReady', {
                        detail: {
                            log: $18ea8dbf711a6ef1$var$filterComponentsLog(componentsLog),
                            entries: isTTVCv1Disabled ? vcNext.VCEntries.rel : VCEntries.rel
                        }
                    }));
                }
                if (!this.isPostInteraction) {
                    // Only create revision debug details if callbacks exist
                    const shouldCreateDebugDetails = typeof window.__ufo_devtool_onVCRevisionReady__ === 'function' || typeof window.__on_ufo_vc_debug_data_ready === 'function';
                    if (shouldCreateDebugDetails) {
                        const v1RevisionDebugDetails = (0, $e35ce536f0d590a0$export$72e6dda9d5859230)({
                            revision: 'fy25.01',
                            isClean: !abortReasonInfo,
                            abortReason: abortReason.reason,
                            VCEntries: VCEntries.rel,
                            componentsLog: componentsLog,
                            interactionId: interactionId
                        });
                        const v2RevisionDebugDetails = (0, $e35ce536f0d590a0$export$72e6dda9d5859230)({
                            revision: 'fy25.02',
                            isClean: !abortReasonInfo,
                            abortReason: abortReason.reason,
                            VCEntries: vcNext.VCEntries.rel,
                            componentsLog: componentsLog,
                            interactionId: interactionId
                        });
                        // Add devtool callback for both v1 and v2
                        if (typeof window.__ufo_devtool_onVCRevisionReady__ === 'function') {
                            // Handle v1 if not disabled
                            if (!isTTVCv1Disabled) window.__ufo_devtool_onVCRevisionReady__?.(v1RevisionDebugDetails);
                            // Handle v2
                            window.__ufo_devtool_onVCRevisionReady__?.(v2RevisionDebugDetails);
                        }
                        if (typeof window.__on_ufo_vc_debug_data_ready === 'function') {
                            if (!isTTVCv1Disabled) window.__on_ufo_vc_debug_data_ready?.(v1RevisionDebugDetails);
                            window.__on_ufo_vc_debug_data_ready?.(v2RevisionDebugDetails);
                        }
                    }
                }
            } catch (e) {
            /*  do nothing */ }
            const isVCClean = !abortReasonInfo;
            const revisionsData = (0, $785e457733bf6f61$export$5c86a34c9becd6d0)({
                fullPrefix: fullPrefix,
                interaction: {
                    start: start,
                    end: stop
                },
                isVCClean: isVCClean,
                calculatedVC: {
                    VC: VC,
                    VCBox: VCBox
                },
                calculatedVCNext: {
                    VC: vcNext.VC,
                    VCBox: vcNext.VCBox
                },
                isEventAborted: isEventAborted,
                experienceKey: experienceKey,
                ratios: ratios
            });
            const speedIndex = {
                [`ufo:speedIndex`]: isTTVCv1Disabled ? vcNext.VCEntries.speedIndex : VCEntries.speedIndex,
                [`ufo:next:speedIndex`]: vcNext.VCEntries.speedIndex
            };
            const SSRRatio = $18ea8dbf711a6ef1$export$1f70d263701b1d01.getSSRRatio(VCEntries.rel, ssr);
            const SSRRatioNext = $18ea8dbf711a6ef1$export$1f70d263701b1d01.getSSRRatio(vcNext.VCEntries.rel, ssr);
            const SSRRatioPayload = includeSSRRatio ? {
                [`${fullPrefix}vc:ssrRatio`]: isTTVCv1Disabled ? SSRRatioNext : SSRRatio,
                [`${fullPrefix}vc:next:ssrRatio`]: SSRRatioNext
            } : {};
            if (isTTVCv1Disabled) return {
                [`${fullPrefix}vc:size`]: viewport,
                [`${fullPrefix}vc:time`]: Math.round(totalTime + (stopTime - startTime)),
                [`${fullPrefix}vc:ratios`]: ratios,
                ...outOfBoundary,
                [`${fullPrefix}vc:ignored`]: this.getIgnoredElements(componentsLog),
                ...SSRRatioPayload,
                [`${fullPrefix}vc:ssrRatio`]: SSRRatioNext,
                ...revisionsData,
                ...speedIndex
            };
            const isTTVCv3Enabled = (0, $0d141f9c9c05f1cf$export$4babcefc81a3ef0b)('fy25.03', experienceKey);
            return {
                'metrics:vc': VC,
                [`${fullPrefix}vc:state`]: true,
                [`${fullPrefix}vc:clean`]: isVCClean,
                [`${fullPrefix}vc:dom`]: VCBox,
                [`${fullPrefix}vc:updates`]: isTTVCv3Enabled ? undefined : VCEntries.rel.slice(0, 50),
                // max 50
                [`${fullPrefix}vc:size`]: viewport,
                [`${fullPrefix}vc:time`]: Math.round(totalTime + (stopTime - startTime)),
                [`${fullPrefix}vc:total`]: totalPainted,
                [`${fullPrefix}vc:ratios`]: ratios,
                [`${fullPrefix}vc:ssrRatio`]: SSRRatio,
                ...outOfBoundary,
                [`${fullPrefix}vc:next`]: vcNext.VC,
                [`${fullPrefix}vc:next:updates`]: isTTVCv3Enabled ? undefined : vcNext.VCEntries.rel.slice(0, 50),
                // max 50
                [`${fullPrefix}vc:next:dom`]: vcNext.VCBox,
                ...SSRRatioPayload,
                [`${fullPrefix}vc:ignored`]: this.getIgnoredElements(componentsLog),
                ...revisionsData,
                ...speedIndex
            };
        };
        this.handleUpdate = (rawTime, intersectionRect, targetName, element, type, ignoreReason, attributeName, oldValue, newValue)=>{
            if (this.abortReason.reason === null || this.abortReason.blocking === false) {
                const time = Math.round(rawTime - this.startTime);
                const mappedValues = this.mapPixelsToHeatmap(intersectionRect.left, intersectionRect.top, intersectionRect.width, intersectionRect.height);
                this.vcRatios[targetName] = this.getElementRatio(mappedValues);
                if (!ignoreReason) this.applyChangesToHeatMap(mappedValues, time, this.heatmapNext);
                const interaction = (0, $d9b1f70c159fe18d$export$2b3954d2e8509985)();
                const isTTVCv1Disabled = !(0, $0d141f9c9c05f1cf$export$4babcefc81a3ef0b)('fy25.01', interaction?.ufoName);
                if (!isTTVCv1Disabled && (!ignoreReason || ignoreReason === 'not-visible') && type !== 'attr') this.applyChangesToHeatMap(mappedValues, time, this.heatmap);
                if (!this.componentsLog[time]) this.componentsLog[time] = [];
                this.componentsLog[time].push({
                    __debug__element: this.devToolsEnabled ? new WeakRef(element) : null,
                    type: type,
                    intersectionRect: intersectionRect,
                    targetName: targetName,
                    ignoreReason: ignoreReason,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                });
            }
        };
        this.mapPixelsToHeatmap = (left, top, width, height)=>{
            const { w: w, h: h } = this.viewport;
            const l = Math.floor(left / w * this.arraySize);
            const t = Math.floor(top / h * this.arraySize);
            const r = Math.ceil((left + width) / w * this.arraySize);
            const b = Math.ceil((top + height) / h * this.arraySize);
            // that info is temporary to get info why it goes over boundary
            if (this.outOfBoundaryInfo === '') {
                let outOfBoundaryInfo = '';
                if (r > this.arraySize) outOfBoundaryInfo += ` r ${r} ! ${left} ${width}`;
                if (b > this.arraySize) outOfBoundaryInfo += ` r ${r} ! ${top} ${height}`;
                this.outOfBoundaryInfo = outOfBoundaryInfo;
            }
            // correct values to min - 0, max - arraySize
            const result = {
                l: Math.max(0, l),
                t: Math.max(0, t),
                r: Math.min(this.arraySize, r),
                b: Math.min(this.arraySize, b)
            };
            return result;
        };
        this.getElementRatio = (mappedValues)=>{
            const { r: r, l: l, b: b, t: t } = mappedValues;
            return (r - l) * (b - t) / (this.arraySize * this.arraySize);
        };
        this.abortReasonCallback = (key, time)=>{
            switch(key){
                case 'wheel':
                    this.setAbortReason($18ea8dbf711a6ef1$var$abortReason.scroll, time);
                    break;
                case 'keydown':
                    this.setAbortReason($18ea8dbf711a6ef1$var$abortReason.keypress, time);
                    break;
                case 'resize':
                    this.setAbortReason($18ea8dbf711a6ef1$var$abortReason.resize, time);
                    break;
            }
        };
        this.attachAbortListeners = ()=>{
            this.detachAbortListeners();
            let unbinds = (0, $26287bc5d3857881$export$9010aa71841a6887)(window, this.viewport, this.abortReasonCallback);
            if (window?.__SSR_ABORT_LISTENERS__) Object.entries(window.__SSR_ABORT_LISTENERS__.aborts).forEach(([key, time])=>{
                if (time) this.abortReasonCallback(key, time);
            });
            this.unbind = unbinds;
        };
        this.arraySize = options.heatmapSize || 200;
        this.devToolsEnabled = options.devToolsEnabled || false;
        this.oldDomUpdatesEnabled = options.oldDomUpdates || false;
        const { ssrEnablePageLayoutPlaceholder: ssrEnablePageLayoutPlaceholder, ssrPlaceholderHandler: ssrPlaceholderHandler } = options;
        this.observers = new (0, $9eac344254cae2d4$export$b65d046240060e78)({
            selectorConfig: options.selectorConfig || {
                id: false,
                testId: false,
                role: false,
                className: true,
                dataVC: true
            },
            SSRConfig: {
                enablePageLayoutPlaceholder: ssrEnablePageLayoutPlaceholder || false
            },
            ssrPlaceholderHandler: ssrPlaceholderHandler
        });
        this.heatmap = !(0, $0d141f9c9c05f1cf$export$4babcefc81a3ef0b)('fy25.01') ? [] : this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.isPostInteraction = options.isPostInteraction || false;
    }
}
/** config * */ $18ea8dbf711a6ef1$export$1f70d263701b1d01.VCParts = [
    '25',
    '50',
    '75',
    '80',
    '85',
    '90',
    '95',
    '98',
    '99'
];


const $7f7abea31cb0de11$var$interactionBuffer = [];
let $7f7abea31cb0de11$var$bufferInteractionData = (interactionId, data)=>{
    $7f7abea31cb0de11$var$interactionBuffer.push({
        interactionId: interactionId,
        data: data
    });
};
function $7f7abea31cb0de11$var$clearInteractionBuffer() {
    $7f7abea31cb0de11$var$interactionBuffer.length = 0;
}
function $7f7abea31cb0de11$var$appendInteractionData(interactionId, data) {
    $7f7abea31cb0de11$var$bufferInteractionData(interactionId, data);
}
function $7f7abea31cb0de11$export$c8a9e17ae62a073d(handler) {
    for (const { interactionId: interactionId, data: data } of $7f7abea31cb0de11$var$interactionBuffer)handler(interactionId, data);
    $7f7abea31cb0de11$var$clearInteractionBuffer();
    $7f7abea31cb0de11$var$bufferInteractionData = handler;
}
function $7f7abea31cb0de11$export$7aa99c40634ac65f(sinkFn) {
    $7f7abea31cb0de11$export$c8a9e17ae62a073d(sinkFn);
}
function $7f7abea31cb0de11$export$1aed449484dedf63(interactionId, data, endTime = performance.now()) {
    if (data.ufoName) {
        data.end = endTime;
        $7f7abea31cb0de11$var$appendInteractionData(interactionId, data);
        $7f7abea31cb0de11$var$clearInteractionBuffer();
    }
}
class $7f7abea31cb0de11$export$f9a59f57e0282541 {
    initialize(options) {
        if (this.vcObserver === null) this.vcObserver = new (0, $18ea8dbf711a6ef1$export$1f70d263701b1d01)({
            ...options,
            isPostInteraction: true
        });
        return this;
    }
    start({ startTime: startTime }) {
        this.vcObserver?.start({
            startTime: startTime
        });
    }
    constructor(){
        this.vcObserver = null;
    }
}
const $7f7abea31cb0de11$export$81b28dca2587ec47 = new $7f7abea31cb0de11$export$f9a59f57e0282541();
async function $7f7abea31cb0de11$export$d17d2b5c5e8d732e(interaction) {
    // Use per-interaction VC observer if available, otherwise fall back to global experimentalVC
    const vcObserver = interaction.experimentalVCObserver || $7f7abea31cb0de11$export$81b28dca2587ec47.vcObserver;
    const pageVisibilityUpToTTAI = (0, $9b310dd053d891ac$export$768b2008623433e1)(interaction.start, interaction.end);
    if (vcObserver) {
        const prefix = 'ufo-experimental';
        const result = await vcObserver.getVCResult({
            start: interaction.start,
            stop: interaction.end,
            tti: interaction.apdex?.[0]?.stopTime,
            isEventAborted: !!interaction.abortReason,
            prefix: prefix,
            vc: interaction.vc,
            experienceKey: interaction.ufoName,
            interactionId: interaction.id,
            interactionType: interaction.type,
            isPageVisible: pageVisibilityUpToTTAI === 'visible',
            interactionAbortReason: interaction.abortReason
        });
        const VC = result?.['metrics:vc'];
        if (!VC || !result?.[`${prefix}:vc:clean`]) return result;
        if (interaction.abortReason || pageVisibilityUpToTTAI !== 'visible') return result;
        return {
            ...result,
            'metric:experimental:vc90': VC['90']
        };
    }
    return null;
}


const $7e9e3b3390858f11$var$interactionBuffer = [];
let $7e9e3b3390858f11$var$bufferInteractionData = (interactionId, data)=>{
    $7e9e3b3390858f11$var$interactionBuffer.push({
        interactionId: interactionId,
        data: data
    });
};
function $7e9e3b3390858f11$var$clearInteractionBuffer() {
    $7e9e3b3390858f11$var$interactionBuffer.length = 0;
}
function $7e9e3b3390858f11$var$appendInteractionData(interactionId, data) {
    $7e9e3b3390858f11$var$bufferInteractionData(interactionId, data);
}
function $7e9e3b3390858f11$var$installInteractionSink(handler) {
    for (const { interactionId: interactionId, data: data } of $7e9e3b3390858f11$var$interactionBuffer)handler(interactionId, data);
    $7e9e3b3390858f11$var$clearInteractionBuffer();
    $7e9e3b3390858f11$var$bufferInteractionData = handler;
}
function $7e9e3b3390858f11$export$e6a07a94f3e112d4(sinkFn) {
    $7e9e3b3390858f11$var$installInteractionSink(sinkFn);
}
function $7e9e3b3390858f11$export$74b9ce7e9d206a8(interactionId, data) {
    if (data.ufoName) {
        $7e9e3b3390858f11$var$appendInteractionData(interactionId, data);
        $7e9e3b3390858f11$var$clearInteractionBuffer();
    }
}



var $cnjKG = parcelRequire("cnjKG");

const $b8f4de455fc17800$export$e919e900fc2d7fe8 = '2.0.0';
function $b8f4de455fc17800$export$159168550e7449b8(interactionType, isPostInteractionLog) {
    if (isPostInteractionLog) return '1.0.1';
    if (interactionType !== 'page_load' && interactionType !== 'transition') return '1.0.1';
    return $b8f4de455fc17800$export$e919e900fc2d7fe8;
}


function $558d2462b9279893$export$e08487ea3ae92adb(name) {
    return name.replace(/_/g, '-');
}
function $558d2462b9279893$export$1adbaf5c2363e4ae(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}
function $558d2462b9279893$export$1569bc0edeecbcd8(labelStacks) {
    const r = {
        n: 'segment-tree-root',
        c: {}
    };
    const config = (0, $0d141f9c9c05f1cf$export$44487a86467333c3)();
    const segmentThreshold = config?.segmentsThreshold;
    const addSegmentsMap = new Map();
    if ((0, $cnjKG.fg)('platform_ufo_add_segments_count_threshold')) labelStacks.forEach((labelStack)=>{
        const stringifiedLabelStack = $558d2462b9279893$export$88f21baa687271f4(labelStack);
        let currentNode = r;
        for (const label of labelStack){
            const isSegment = $558d2462b9279893$export$1adbaf5c2363e4ae(label);
            const name = label.name;
            if (isSegment && segmentThreshold && segmentThreshold[name]) {
                const threshold = segmentThreshold[name];
                const count = addSegmentsMap.get(stringifiedLabelStack) || 0;
                if (count < threshold) addSegmentsMap.set(stringifiedLabelStack, count + 1);
                else break;
            }
            const id = isSegment ? label.segmentId : undefined;
            const key = id !== undefined ? id : name;
            const type = isSegment ? label.type : undefined;
            if (!currentNode.c) currentNode.c = {};
            if (!currentNode.c[key]) currentNode.c[key] = {
                n: name,
                ...type ? {
                    t: type
                } : {}
            };
            currentNode = currentNode.c[key];
        }
    });
    else labelStacks.forEach((labelStack)=>{
        let currentNode = r;
        labelStack.forEach((label)=>{
            const name = label.name;
            const id = $558d2462b9279893$export$1adbaf5c2363e4ae(label) ? label.segmentId : undefined;
            const key = id !== undefined ? id : name;
            const type = $558d2462b9279893$export$1adbaf5c2363e4ae(label) ? label.type : undefined;
            if (!currentNode.c) currentNode.c = {};
            if (!currentNode.c[key]) currentNode.c[key] = {
                n: name,
                ...type ? {
                    t: type
                } : {}
            };
            currentNode = currentNode.c[key];
        });
    });
    return {
        r: r
    };
}
function $558d2462b9279893$export$caeee352b541de1f(labelStack) {
    return labelStack.map((l)=>{
        if ($558d2462b9279893$export$1adbaf5c2363e4ae(l)) return `${l.name}:${l.segmentId}`;
        return l.name;
    }).join('/');
}
function $558d2462b9279893$export$88f21baa687271f4(labelStack) {
    return labelStack.map((l)=>{
        if ($558d2462b9279893$export$1adbaf5c2363e4ae(l)) return `${l.name}:segment`;
        return l.name;
    }).join('/');
}
function $558d2462b9279893$var$getLabelStackReference(labelStack) {
    return labelStack.map((l)=>$558d2462b9279893$export$1adbaf5c2363e4ae(l) ? l.segmentId : l.name).join('/');
}
function $558d2462b9279893$export$1787b1cd413c7e2(labelStack, startWith) {
    return $558d2462b9279893$export$caeee352b541de1f(labelStack).startsWith($558d2462b9279893$export$caeee352b541de1f(startWith));
}
function $558d2462b9279893$export$a0cd72da07c76b4c(labelStack, reactUFOVersion) {
    return reactUFOVersion === '2.0.0' ? $558d2462b9279893$var$getLabelStackReference(labelStack) : labelStack.map((ls)=>({
            n: ls.name,
            ...ls.segmentId ? {
                s: ls.segmentId
            } : {},
            ...ls.type ? {
                t: ls.type
            } : {}
        }));
}
function $558d2462b9279893$export$b70bcfd92c93435e(segments, interactionType) {
    if ((0, $cnjKG.fg)('platform_ufo_add_segments_count_threshold')) {
        const config = (0, $0d141f9c9c05f1cf$export$44487a86467333c3)();
        const addSegmentsMap = new Map();
        const segmentThreshold = config?.segmentsThreshold;
        return segments.map(({ labelStack: labelStack, ...others })=>{
            const stringifiedLabelStack = $558d2462b9279893$export$88f21baa687271f4(labelStack);
            const segmentsInfo = [];
            for (const ls of labelStack){
                const isSegment = $558d2462b9279893$export$1adbaf5c2363e4ae(ls);
                if (isSegment && segmentThreshold && segmentThreshold[ls.name]) {
                    const threshold = segmentThreshold[ls.name];
                    const count = addSegmentsMap.get(stringifiedLabelStack) || 0;
                    if (count < threshold) addSegmentsMap.set(stringifiedLabelStack, count + 1);
                    else break;
                }
                segmentsInfo.push({
                    n: ls.name,
                    ...ls.segmentId ? {
                        s: ls.segmentId
                    } : {},
                    ...ls.type ? {
                        t: ls.type
                    } : {}
                });
            }
            return {
                ...others,
                labelStack: segmentsInfo
            };
        });
    }
    return segments.map(({ labelStack: labelStack, ...others })=>({
            ...others,
            labelStack: $558d2462b9279893$export$a0cd72da07c76b4c(labelStack, (0, $b8f4de455fc17800$export$159168550e7449b8)(interactionType))
        }));
}





var $gqzfn = parcelRequire("gqzfn");
const $9a27762368c0f25d$var$listeners = new Set();
// Observable interaction ID implementation
class $9a27762368c0f25d$var$ObservableInteractionID {
    get current() {
        return this._current;
    }
    set current(newId) {
        const oldId = this._current;
        this._current = newId;
        // Notify all listeners if the ID actually changed
        if (oldId !== newId) $9a27762368c0f25d$var$listeners.forEach((listener)=>listener(newId));
    }
    constructor(){
        this._current = null;
    }
}
// Ensures a single DefaultInteractionID instance exists across the entire application,
// even when the module is loaded multiple times in different contexts
const $9a27762368c0f25d$var$initializeGlobalDefaultInteractionID = ()=>{
    // Return existing instance if already initialized
    if (globalThis.__UFO_DEFAULT_INTERACTION_ID__) return globalThis.__UFO_DEFAULT_INTERACTION_ID__;
    // Create and store new instance globally
    const instance = new $9a27762368c0f25d$var$ObservableInteractionID();
    globalThis.__UFO_DEFAULT_INTERACTION_ID__ = instance;
    return instance;
};
const $9a27762368c0f25d$export$3109542b68df9ba1 = $9a27762368c0f25d$var$initializeGlobalDefaultInteractionID();
const $9a27762368c0f25d$export$3e0c3023952f6774 = (listener)=>{
    $9a27762368c0f25d$var$listeners.add(listener);
    return ()=>{
        $9a27762368c0f25d$var$listeners.delete(listener);
    };
};
var // We use a context to allow modals to have their own lifecycle
$9a27762368c0f25d$export$2e2bcd8739ae039 = (0, $gqzfn.createContext)($9a27762368c0f25d$export$3109542b68df9ba1);
const $9a27762368c0f25d$export$37bca3107733ac1e = ()=>$9a27762368c0f25d$export$3109542b68df9ba1;
const $9a27762368c0f25d$export$9f6000531b78127e = ()=>$9a27762368c0f25d$export$3109542b68df9ba1;



class $0752e50fe9955142$export$24d07287b49da906 {
    start(_) {}
    stop() {}
    getVCRawData() {
        return null;
    }
    getVCResult(_) {
        return Promise.resolve({
            'ufo:vc:noop': true
        });
    }
    setSSRElement(_) {}
    setReactRootRenderStart(_) {}
    setReactRootRenderStop(_) {}
}




var $cnjKG = parcelRequire("cnjKG");

class $cf7971336bf19b1a$export$2e2bcd8739ae039 {
    push(entry) {
        this.unorderedEntries.push(entry);
        this.sortedEntriesCache.clear();
    }
    getCacheKey(start, stop) {
        return `${start ?? 'null'}_${stop ?? 'null'}`;
    }
    getOrderedEntries({ start: start, stop: stop }) {
        const cacheKey = this.getCacheKey(start, stop);
        const cachedSortedEntries = this.sortedEntriesCache.get(cacheKey)?.deref();
        if (cachedSortedEntries) return cachedSortedEntries;
        const filteredEntries = this.unorderedEntries.filter((e)=>e.time >= (start ?? 0) && e.time <= (stop ?? performance.now()));
        const sortedEntries = filteredEntries.sort((a, b)=>a.time - b.time);
        this.sortedEntriesCache.set(cacheKey, new WeakRef(sortedEntries));
        return sortedEntries;
    }
    clear() {
        this.unorderedEntries = [];
        this.sortedEntriesCache.clear();
    }
    constructor(){
        this.unorderedEntries = void 0;
        this.sortedEntriesCache = void 0;
        this.unorderedEntries = [];
        this.sortedEntriesCache = new Map();
    }
}


const $44cdd7d7c021d005$var$nameCache = new WeakMap();
function $44cdd7d7c021d005$var$getElementName(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) {
        let elementInstance = 'Unknown';
        // Types of elements according to LLM
        if (element instanceof Text) elementInstance = 'Text';
        else if (element instanceof DocumentFragment) elementInstance = 'DocumentFragment';
        else if (element instanceof Document) elementInstance = 'Document';
        else if (element instanceof Comment) elementInstance = 'Comment';
        else if (element instanceof ProcessingInstruction) elementInstance = 'ProcessingInstruction';
        else if (element instanceof Attr) elementInstance = 'Attr';
        else if (element instanceof CDATASection) elementInstance = 'CDATASection';
        if (element.parentElement && element.parentElement instanceof HTMLElement) {
            const parentElementSelector = $44cdd7d7c021d005$var$getElementName(selectorConfig, element.parentElement);
            return `${parentElementSelector} > ${elementInstance}`;
        } else return elementInstance;
    }
    const cachedName = $44cdd7d7c021d005$var$nameCache.get(element);
    if (cachedName) return cachedName;
    // Get the tag name of the element.
    const tagName = element.localName;
    const encodeValue = (s)=>{
        if (typeof encodeURIComponent !== 'function') return '';
        try {
            return encodeURIComponent(s);
        } catch (e) {
            return 'malformed_value';
        }
    };
    // Helper function to construct attribute selectors.
    const getAttributeSelector = (attributeName, prefix = '')=>{
        if (element && typeof element.getAttribute !== 'function') return '';
        const attrValue = element.getAttribute(attributeName);
        if (!attrValue) return '';
        const encondedAttrValue = encodeValue(attrValue);
        return `${prefix}[${attributeName}="${encondedAttrValue}"]`;
    };
    // Construct the data-vc attribute selector if specified in the config.
    const dataVC = selectorConfig.dataVC !== false ? getAttributeSelector('data-vc') : '';
    // Construct the ID selector if specified in the config and the element has an ID.
    const id = selectorConfig.id && element.id ? `#${encodeValue(element.id)}` : '';
    // Construct the test ID selector if specified in the config.
    const testId = selectorConfig.testId ? getAttributeSelector('data-testid') || getAttributeSelector('data-test-id') : '';
    // Construct the role selector if specified in the config.
    const role = selectorConfig.role ? getAttributeSelector('role') : '';
    const classNames = Array.from(element.classList).map(encodeValue).join('.');
    // Construct the class list selector if specified in the config.
    const classList = selectorConfig.className && classNames ? `.${classNames}` : '';
    // Combine primary attribute selectors (id, testId, role) into a single string.
    const primaryAttributes = [
        id,
        testId,
        role
    ].filter(Boolean).join('');
    // Use dataVC if available, otherwise use the primary attributes.
    const attributes = dataVC || primaryAttributes;
    // If no attributes or class list, recursively get the parent's name.
    if (!attributes && !classList) {
        const parentName = element.parentElement ? $44cdd7d7c021d005$var$getElementName(selectorConfig, element.parentElement) : 'unknown';
        return `${parentName} > ${tagName}`;
    }
    // Return the final constructed name: tagName + attributes or classList.
    const name = `${tagName}${attributes || classList}`;
    $44cdd7d7c021d005$var$nameCache.set(element, name);
    return name;
}
var $44cdd7d7c021d005$export$2e2bcd8739ae039 = $44cdd7d7c021d005$var$getElementName;



var $cnjKG = parcelRequire("cnjKG");

var $cnjKG = parcelRequire("cnjKG");

var $cnjKG = parcelRequire("cnjKG");
// See https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
async function $71866496442cf9bf$var$taskYield() {
    // This is using globalThis to allow the yield task to be used outside of a browser env
    if ('scheduler' in globalThis && // @ts-ignore
    'yield' in globalThis.scheduler) {
        // @ts-ignore
        await scheduler.yield();
        return;
    }
    let resolve = ()=>{};
    const p = new Promise((a)=>{
        resolve = a;
    });
    setTimeout(resolve, 0);
    await p;
}
var $71866496442cf9bf$export$2e2bcd8739ae039 = $71866496442cf9bf$var$taskYield;


class $087fe7f02287b62d$export$3e59ac9de7402fb1 {
    /**
   * Creates a canvas instance, falling back to HTMLCanvasElement if OffscreenCanvas is not available
   */ createCanvas(width, height) {
        if (typeof OffscreenCanvas !== 'undefined') return new OffscreenCanvas(width, height);
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        return canvas;
    }
    getScaledDimensions() {
        return {
            width: this.scaledWidth,
            height: this.scaledHeight
        };
    }
    /**
   * Clears the entire canvas by removing all drawn content.
   * @private
   */ clear() {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    }
    /**
   * Generates a unique RGB color from an incrementing counter.
   * Uses a 24-bit color space (16,777,216 possible colors).
   *
   * @private
   * @returns A unique RGB color string
   *
   * @example
   * // Example bit operations for color 0x00FF8040:
   * // Red:   (0x00FF8040 >> 16) & 0xFF = 0xFF = 255
   * // Green: (0x00FF8040 >> 8) & 0xFF  = 0x80 = 128
   * // Blue:   0x00FF8040 & 0xFF        = 0x40 = 64
   */ generateColor() {
        // Wrap around at 16,777,215 (0x00FFFFFF) to stay within 24-bit color space
        const rgbColor = this.colorCounter++ % 0x00ffffff;
        return $087fe7f02287b62d$export$54591583ed0b20ce(rgbColor);
    }
    /**
   * Draws a rectangle on the canvas with a unique color and associates it with a timestamp.
   * Each drawn rectangle gets a unique color which is mapped to the provided timestamp.
   *
   * @param rect - The rectangle dimensions to draw
   * @param timestamp - The timestamp to associate with this drawing operation
   */ drawRect(rect, timestamp) {
        const color = this.generateColor();
        this.colorTimeMap.set(color, timestamp);
        this.ctx.fillStyle = color;
        if (this.scaleFactor === 1) return this.ctx.fillRect(rect.x, rect.y, rect.width, rect.height);
        const scaledX = rect.x * this.scaleX;
        const scaledY = rect.y * this.scaleY;
        const scaledWidth = rect.width * this.scaleX;
        const scaledHeight = rect.height * this.scaleY;
        this.ctx.fillRect(Math.floor(scaledX), Math.ceil(scaledY), Math.max(scaledWidth, 1), Math.max(scaledHeight, 1));
    }
    /**
   * Calculates the number of pixels drawn for each timestamp.
   * This method:
   * 1. Reads the pixel data from the canvas
   * 2. Counts pixels of each unique color
   * 3. Maps colors back to their timestamps
   * 4. Adjusts counts based on the scale factor
   *
   * @returns A Map containing timestamp to pixel count mappings
   */ async getPixelCounts() {
        const imageData = this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height);
        const timestampsAmount = this.colorTimeMap.size;
        const pixelCounts = await $087fe7f02287b62d$export$fafc9be44839f9c8(imageData, this.scaleFactor, timestampsAmount);
        // Convert color counts to timestamp counts
        const timePixelCounts = new Map();
        for(let i = 0; i < pixelCounts.length; i++){
            const count = pixelCounts[i];
            if (typeof count !== 'number') continue;
            const color = i + 1;
            const rgbColor = $087fe7f02287b62d$export$54591583ed0b20ce(color);
            const timestamp = this.colorTimeMap.get(rgbColor);
            if (timestamp !== undefined) timePixelCounts.set(timestamp, (timePixelCounts.get(timestamp) || 0) + count);
        }
        return timePixelCounts;
    }
    /**
   * Creates a new ViewportCanvas instance.
   * @param viewport - The dimensions of the viewport
   * @param scaleFactor - Scale factor to apply to the canvas (default: 0.5)
   * @throws {Error} If canvas context cannot be obtained
   */ constructor(viewport, scaleFactor = 1){
        /** The underlying Canvas instance (either OffscreenCanvas or HTMLCanvasElement) */ this.canvas = void 0;
        /** The 2D rendering context of the canvas */ this.ctx = void 0;
        /** Scale factor applied to the canvas (affects final pixel counts) */ this.scaleFactor = void 0;
        /** Maps unique colors to their corresponding timestamps */ this.colorTimeMap = void 0;
        /** Counter used to generate unique colors */ this.colorCounter = void 0;
        this.scaledWidth = void 0;
        this.scaledHeight = void 0;
        this.scaleX = void 0;
        this.scaleY = void 0;
        this.scaleFactor = scaleFactor;
        this.colorCounter = 1;
        this.colorTimeMap = new Map();
        const safeViewportWidth = Math.max(viewport.width, 1);
        const safeViewportHeight = Math.max(viewport.height, 1);
        // Calculate scaled dimensions
        this.scaledWidth = Math.max(Math.ceil(safeViewportWidth * scaleFactor), 1);
        this.scaledHeight = Math.max(Math.ceil(safeViewportHeight * scaleFactor), 1);
        this.scaleX = this.scaledWidth / safeViewportWidth;
        this.scaleY = this.scaledHeight / safeViewportHeight;
        // Initialize canvas with scaled dimensions
        this.canvas = this.createCanvas(this.scaledWidth, this.scaledHeight);
        const ctx = this.canvas.getContext('2d', {
            alpha: false,
            // Disable alpha channel for better performance
            willReadFrequently: true,
            // Optimize for frequent pixel reading
            colorSpace: 'srgb' // Use standard RGB color space
        });
        if (!ctx) throw new Error('Could not get canvas context');
        this.ctx = ctx;
        this.ctx.globalCompositeOperation = 'source-over';
        this.ctx.imageSmoothingEnabled = false; // Disable image smoothing for better performance
        this.clear();
    }
}
function $087fe7f02287b62d$export$54591583ed0b20ce(n) {
    // Ensure the input is within the valid range for a 24-bit color
    if (n < 0 || n > 0xffffff) throw new Error('Input number must be between 0 and 16777215 (inclusive).');
    // Extract blue component (bits 0-7)
    const blue = n & 0xff;
    // Extract green component (bits 8-15)
    const green = n >> 8 & 0xff;
    // Extract red component (bits 16-23)
    const red = n >> 16 & 0xff;
    return `rgb(${red}, ${green}, ${blue})`;
}
async function $087fe7f02287b62d$export$fafc9be44839f9c8(imageData, _, arraySize) {
    const data = imageData.data;
    const arr = new Uint32Array(arraySize);
    for(let i = 0; i < data.length; i += 4){
        // Check alpha
        if (data[i + 3] !== 0) {
            // Combine RGB components into a single 24-bit color value:
            // (data[i] << 16)   - Shift red component left 16 bits   (bits 16-23)
            // (data[i + 1] << 8) - Shift green component left 8 bits (bits 8-15)
            // data[i + 2]       - Blue component stays as is         (bits 0-7)
            // The | operator combines all bits together
            const color = data[i] << 16 | data[i + 1] << 8 | data[i + 2];
            const colorIndex = color - 1;
            arr[colorIndex] = (arr[colorIndex] || 0) + 1;
        }
        if (i % 10000 === 0) await (0, $71866496442cf9bf$export$2e2bcd8739ae039)();
    }
    return arr;
}


async function $eb71a5b23030139a$var$calculateTTVCPercentiles({ viewport: viewport, orderedEntries: orderedEntries, percentiles: percentiles, startTime: startTime }) {
    const canvas = new (0, $087fe7f02287b62d$export$3e59ac9de7402fb1)(viewport, (0, $cnjKG.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
    const elementMap = new Map();
    for (const entry of orderedEntries){
        if (!('rect' in entry.data)) continue;
        const rect = entry.data.rect;
        const elementName = entry.data.elementName;
        canvas.drawRect(rect, entry.time);
        if (!elementMap.has(entry.time)) elementMap.set(entry.time, new Set());
        elementMap.get(entry.time).add(elementName);
    }
    // Get pixel counts
    const timePixelCounts = await canvas.getPixelCounts();
    const canvasDimenstions = canvas.getScaledDimensions();
    const totalPixels = canvasDimenstions.width * canvasDimenstions.height;
    return $eb71a5b23030139a$export$89c8da9b65eff678(timePixelCounts, elementMap, percentiles, totalPixels, startTime);
}
async function $eb71a5b23030139a$export$96ea73435089b05a({ viewport: viewport, orderedEntries: orderedEntries, startTime: startTime }) {
    const canvas = new (0, $087fe7f02287b62d$export$3e59ac9de7402fb1)(viewport, (0, $cnjKG.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
    const elementMap = new Map();
    for (const entry of orderedEntries){
        if (!('rect' in entry.data)) continue;
        const rect = entry.data.rect;
        canvas.drawRect(rect, entry.time);
        if (!elementMap.has(entry.time)) elementMap.set(entry.time, []);
        elementMap.get(entry.time).push(entry.data);
    }
    // Get pixel counts
    const timePixelCounts = await canvas.getPixelCounts();
    const canvasDimensions = canvas.getScaledDimensions();
    const totalPixels = canvasDimensions.width * canvasDimensions.height;
    return $eb71a5b23030139a$export$a532ce01ea38d882(timePixelCounts, elementMap, totalPixels, startTime);
}
var $eb71a5b23030139a$export$2e2bcd8739ae039 = $eb71a5b23030139a$var$calculateTTVCPercentiles;
function $eb71a5b23030139a$export$89c8da9b65eff678(timePixelCounts, elementMap, unorderedPercentiles, totalPixels, startTime) {
    const results = {};
    let cumulativePixels = 0;
    const percentiles = unorderedPercentiles.sort((a, b)=>a - b);
    // Sort entries by timestamp for consistent processing
    const sortedEntries = Array.from(timePixelCounts.entries()).sort(([timeA], [timeB])=>Number(timeA) - Number(timeB));
    let percentileIndex = 0;
    let domElementsBuffer = new Set();
    for (const [time, pixelCount] of sortedEntries){
        cumulativePixels += pixelCount;
        const percentCovered = cumulativePixels / totalPixels * 100;
        const elementNames = elementMap.get(time) || new Set();
        elementNames.forEach((elName)=>domElementsBuffer.add(elName));
        let matchesAnyCheckpoints = false;
        while(percentileIndex < percentiles.length && percentCovered >= percentiles[percentileIndex]){
            results[`${percentiles[percentileIndex]}`] = {
                t: Math.round(Number(time - startTime)),
                e: Array.from(domElementsBuffer)
            };
            percentileIndex++;
            matchesAnyCheckpoints = true;
        }
        if (matchesAnyCheckpoints) domElementsBuffer.clear();
        if (percentileIndex >= percentiles.length) break;
    }
    let previousResult = {
        t: 0,
        e: []
    };
    for(let i = 0; i < percentiles.length; i++){
        const percentile = percentiles[i];
        if (!(percentile in results)) results[`${percentile}`] = previousResult;
        previousResult = results[`${percentile}`];
    }
    return results;
}
function $eb71a5b23030139a$export$a532ce01ea38d882(timePixelCounts, elementMap, totalPixels, startTime) {
    const results = new Array(elementMap.size);
    let cumulativePixels = 0;
    const sortedEntries = Array.from(timePixelCounts.entries()).sort(([timeA], [timeB])=>Number(timeA) - Number(timeB));
    for(let i = 0; i < sortedEntries.length; i++){
        const [time, pixelCount] = sortedEntries[i];
        cumulativePixels += pixelCount;
        const percentCovered = cumulativePixels / totalPixels * 100;
        const entryDatas = elementMap.get(time) || [];
        results[i] = {
            time: Math.round(Number(time - startTime)),
            viewportPercentage: percentCovered,
            entries: Array.from(entryDatas)
        };
    }
    return results;
}


function $4ff47188228910cc$var$getViewportHeight(document = window.document) {
    let documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch (e) {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}
var $4ff47188228910cc$export$2e2bcd8739ae039 = $4ff47188228910cc$var$getViewportHeight;


function $af3823a1c15573dc$var$getViewportWidth(document = window.document) {
    let documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch (e) {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
var $af3823a1c15573dc$export$2e2bcd8739ae039 = $af3823a1c15573dc$var$getViewportWidth;


class $258a0155bf4f6bbc$export$2e2bcd8739ae039 {
    filterViewportEntries(entries) {
        return entries.filter((entry)=>{
            return 'rect' in entry.data;
        });
    }
    /**
   * Calculate ratios for each element based on their viewport coverage.
   */ calculateRatios(filteredEntries) {
        const ratios = {};
        const viewportWidth = (0, $af3823a1c15573dc$export$2e2bcd8739ae039)();
        const viewportHeight = (0, $4ff47188228910cc$export$2e2bcd8739ae039)();
        const totalViewportArea = viewportWidth * viewportHeight;
        if (totalViewportArea === 0) return ratios;
        const elementRects = new Map();
        for (const entry of filteredEntries)if ('rect' in entry.data) {
            const viewportEntry = entry.data;
            elementRects.set(viewportEntry.elementName, viewportEntry.rect);
        }
        for (const [elementName, rect] of elementRects){
            const elementArea = rect.width * rect.height;
            ratios[elementName] = elementArea / totalViewportArea;
        }
        return ratios;
    }
    getLabelStacks(filteredEntries) {
        const labelStacks = {};
        for (const entry of filteredEntries)if ('elementName' in entry.data && entry.data.labelStacks) labelStacks[entry.data.elementName] = {
            segment: entry.data.labelStacks.segment,
            labelStack: entry.data.labelStacks.labelStack
        };
        return labelStacks;
    }
    async calculateWithDebugInfo(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionType, isPageVisible, interactionId, dirtyReason, allEntries, include3p, excludeSmartAnswersInSearch, interactionAbortReason, includeSSRRatio) {
        const percentiles = [
            25,
            50,
            75,
            80,
            85,
            90,
            95,
            98,
            99,
            100
        ];
        const viewportEntries = this.filterViewportEntries(filteredEntries);
        const vcLogs = await (0, $eb71a5b23030139a$export$96ea73435089b05a)({
            viewport: {
                width: (0, $af3823a1c15573dc$export$2e2bcd8739ae039)(),
                height: (0, $4ff47188228910cc$export$2e2bcd8739ae039)()
            },
            startTime: startTime,
            stopTime: stopTime,
            orderedEntries: viewportEntries
        });
        const vcDetails = {};
        let percentileIndex = 0;
        const entryDataBuffer = new Set();
        let ssrRatio = -1;
        if (vcLogs) for (const entry of vcLogs){
            const { time: time, viewportPercentage: viewportPercentage, entries: entries } = entry;
            if (includeSSRRatio && ssrRatio === -1 && entries.some((e)=>e.elementName === 'SSR') && (0, $cnjKG.fg)('vc_v3_ssr_ratio_fixed_range')) ssrRatio = viewportPercentage;
            // Only process entries if we haven't reached all percentiles
            if (percentileIndex >= percentiles.length) break;
            // Check if this entry matches any checkpoint percentiles
            if (viewportPercentage >= percentiles[percentileIndex]) {
                const elementNames = entries.map((e)=>e.elementName);
                // Process all matching percentiles in one go
                while(percentileIndex < percentiles.length && viewportPercentage >= percentiles[percentileIndex]){
                    vcDetails[`${percentiles[percentileIndex]}`] = {
                        t: Math.round(time),
                        e: elementNames
                    };
                    percentileIndex++;
                }
                // Clear buffer after processing all matching percentiles
                entryDataBuffer.clear();
            } else // Only add to buffer if we haven't reached all percentiles
            entries.forEach((e)=>entryDataBuffer.add(e));
        }
        // Fill in any missing percentiles with the last known values
        let previousResult = {
            t: 0,
            e: []
        };
        for(let i = 0; i < percentiles.length; i++){
            const percentile = percentiles[i];
            if (!(percentile in vcDetails)) vcDetails[`${percentile}`] = previousResult;
            else previousResult = vcDetails[`${percentile}`];
        }
        let enhancedVcLogs = vcLogs ? vcLogs.map((log)=>({
                ...log,
                entries: log.entries.map((entry)=>({
                        ...entry,
                        rect: entry.rect?.toJSON(),
                        previousRect: entry.previousRect?.toJSON()
                    })),
                viewportPercentage: log.viewportPercentage
            })) : [];
        // If 3p metric enabled - calculate the debug details
        const shouldCalculate3p = include3p && (0, $cnjKG.fg)('platform_ufo_enable_ttai_with_3p');
        // Only calculate enhanced debug details if devtool callbacks exist
        let shouldCalculateDebugDetails = (!isPostInteraction || shouldCalculate3p) && (typeof window?.__ufo_devtool_onVCRevisionReady__ === 'function' || typeof window?.__on_ufo_vc_debug_data_ready === 'function');
        if ((0, $cnjKG.fg)('platform_ufo_fix_post_interaction_check_vc_debug')) shouldCalculateDebugDetails = !isPostInteraction && (typeof window?.__ufo_devtool_onVCRevisionReady__ === 'function' || typeof window?.__on_ufo_vc_debug_data_ready === 'function' || typeof window?.__ufo_devtool_vc_3p_debug_data === 'function');
        if (shouldCalculateDebugDetails && allEntries && vcLogs) {
            // Pre-sort vcLogs by time for efficient lookups
            const sortedVcLogs = [
                ...vcLogs
            ].sort((a, b)=>a.time - b.time);
            // Pre-calculate max viewport percentage up to each time for efficient lookups
            const maxViewportPercentageAtTime = new Map();
            let maxSoFar = 0;
            for (const log of sortedVcLogs)if (log.viewportPercentage !== null) {
                maxSoFar = Math.max(maxSoFar, log.viewportPercentage);
                maxViewportPercentageAtTime.set(log.time, maxSoFar);
            }
            // Helper function to find the biggest previous viewport percentage
            const getBiggestPreviousViewportPercentage = (targetTime)=>{
                // Binary search for the largest time <= targetTime
                let left = 0;
                let right = sortedVcLogs.length - 1;
                let result = -1;
                while(left <= right){
                    const mid = Math.floor((left + right) / 2);
                    if (sortedVcLogs[mid].time <= targetTime) {
                        result = mid;
                        left = mid + 1;
                    } else right = mid - 1;
                }
                return result >= 0 ? maxViewportPercentageAtTime.get(sortedVcLogs[result].time) || null : null;
            };
            // Group ignored entries by timestamp
            const ignoredEntriesByTime = new Map();
            for (const entry of allEntries)if ('rect' in entry.data && !this.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch)) {
                const viewportData = entry.data;
                const timestamp = Math.round(entry.time);
                if (!ignoredEntriesByTime.has(timestamp)) ignoredEntriesByTime.set(timestamp, []);
                ignoredEntriesByTime.get(timestamp)?.push({
                    ...viewportData,
                    rect: viewportData.rect?.toJSON(),
                    previousRect: viewportData.previousRect?.toJSON(),
                    ignoreReason: viewportData.visible ? viewportData.type : 'not-visible'
                });
            }
            // Add ignored entries to vcLogs
            const additionalVcLogs = [];
            for (const [timestamp, ignoredEntries] of ignoredEntriesByTime)if (ignoredEntries.length > 0) {
                const viewportPercentage = getBiggestPreviousViewportPercentage(timestamp);
                additionalVcLogs.push({
                    time: timestamp,
                    viewportPercentage: viewportPercentage,
                    entries: ignoredEntries
                });
            }
            // Combine and sort all vcLogs
            enhancedVcLogs = [
                ...enhancedVcLogs,
                ...additionalVcLogs
            ].sort((a, b)=>a.time - b.time);
        }
        // Only create debug details if callbacks exist
        let v3RevisionDebugDetails = null;
        if (shouldCalculateDebugDetails) v3RevisionDebugDetails = {
            revision: this.revisionNo,
            isClean: isVCClean && !interactionAbortReason && isPageVisible,
            abortReason: !isPageVisible ? 'browser_backgrounded' : dirtyReason ?? interactionAbortReason,
            vcLogs: enhancedVcLogs,
            interactionId: interactionId,
            interactionType: interactionType
        };
        // Handle devtool callback
        if (v3RevisionDebugDetails && typeof window?.__ufo_devtool_onVCRevisionReady__ === 'function' && !include3p) try {
            window?.__ufo_devtool_onVCRevisionReady__?.(v3RevisionDebugDetails);
        } catch (e) {
            // if any error communicating with devtool, we don't want to break the app
            // eslint-disable-next-line no-console
            console.error('Error in onVCRevisionReady', e);
        }
        if (v3RevisionDebugDetails && typeof window?.__on_ufo_vc_debug_data_ready === 'function' && !include3p) try {
            window?.__on_ufo_vc_debug_data_ready?.(v3RevisionDebugDetails);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('Error in onVCRevisionReady', e);
        }
        if (v3RevisionDebugDetails && shouldCalculate3p) try {
            // Log vc details with 3p for debugging
            window.__ufo_devtool_vc_3p_debug_data = v3RevisionDebugDetails;
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('Error in 3pDebugData', e);
        }
        return {
            vcDetails: vcDetails,
            ssrRatio: ssrRatio
        };
    }
    async calculate({ startTime: startTime, stopTime: stopTime, orderedEntries: orderedEntries, interactionId: interactionId, isPostInteraction: isPostInteraction, include3p: include3p, excludeSmartAnswersInSearch: excludeSmartAnswersInSearch, includeSSRRatio: includeSSRRatio, interactionType: interactionType, isPageVisible: isPageVisible, interactionAbortReason: interactionAbortReason }) {
        const filteredEntries = orderedEntries.filter((entry)=>{
            return this.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch);
        });
        let isVCClean;
        let dirtyReason;
        const getVCCleanStatusResult = this.getVCCleanStatus(filteredEntries);
        isVCClean = getVCCleanStatusResult.isVCClean;
        dirtyReason = getVCCleanStatusResult.dirtyReason;
        if (!isVCClean) return {
            revision: this.revisionNo,
            'metric:vc90': null,
            clean: false,
            abortReason: dirtyReason,
            abortTimestamp: getVCCleanStatusResult.abortTimestamp
        };
        const { vcDetails: vcDetails, ssrRatio: ssrRatio } = await this.calculateWithDebugInfo(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionType, isPageVisible, interactionId, dirtyReason, orderedEntries, include3p, excludeSmartAnswersInSearch, interactionAbortReason, includeSSRRatio);
        const result = {
            revision: this.revisionNo,
            clean: true,
            'metric:vc90': vcDetails?.['90']?.t ?? null,
            vcDetails: vcDetails ?? undefined
        };
        result.ratios = this.calculateRatios(filteredEntries);
        if (ssrRatio !== -1) result.ssrRatio = ssrRatio;
        if (isPostInteraction) result.labelStacks = this.getLabelStacks(filteredEntries);
        return result;
    }
    constructor(revisionNo){
        this.revisionNo = void 0;
        this.revisionNo = revisionNo;
    }
}


const $493f7cea88c98340$export$f65ca476c09acec0 = ()=>{
    if (typeof document !== 'undefined') return document;
    return null;
};


function $6b94aa1eafef7e6a$export$8be86f3caab7d679(entry) {
    const { elementName: elementName } = entry.data;
    if (!elementName || elementName === 'START') return false;
    const doc = (0, $493f7cea88c98340$export$f65ca476c09acec0)();
    if (!doc) return false;
    const smartAnswersElement = doc.getElementById('search-page-smart-answers');
    if (!smartAnswersElement) return false;
    const entryDOMElement = doc.querySelector(elementName);
    if (!entryDOMElement) return false;
    return smartAnswersElement.contains(entryDOMElement);
}


function $382d2dd4977d9655$var$isViewportEntryData(data) {
    if (data) {
        const hasElementName = typeof data.elementName === 'string';
        const hasRect = typeof data.rect !== 'undefined';
        if (hasRect && hasElementName) return true;
    }
    return false;
}
var $382d2dd4977d9655$export$2e2bcd8739ae039 = $382d2dd4977d9655$var$isViewportEntryData;


const $5216c9b4fe44f180$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize'
];
const $5216c9b4fe44f180$var$REVISION_NO = 'fy25.03';
const $5216c9b4fe44f180$var$getConsideredEntryTypes = (include3p)=>{
    const entryTypes = [
        'mutation:child-element',
        'mutation:element',
        'mutation:attribute',
        'layout-shift',
        'layout-shift:same-rect',
        'window:event'
    ];
    // If not exclude 3p elements from ttvc,
    // including the tags into the ConsideredEntryTypes so that it won't be ignored for TTVC calculation
    if (!(0, $cnjKG.fg)('platform_ufo_exclude_3p_elements_from_ttvc') || include3p) {
        entryTypes.push('mutation:third-party-element');
        entryTypes.push('mutation:third-party-attribute');
    }
    if ((0, $cnjKG.fg)('platform_ufo_enable_media_for_ttvc_v3')) entryTypes.push('mutation:media');
    return entryTypes;
};
const $5216c9b4fe44f180$export$98812f4e79596e2b = [
    'data-drop-target-for-element',
    'data-drop-target-for-external',
    'draggable',
    'data-is-observed'
];
const $5216c9b4fe44f180$export$44331555a87fcd9e = [
    'aria-label',
    'aria-labelledby',
    'aria-describedby',
    'aria-hidden',
    'aria-expanded',
    'aria-controls',
    'aria-selected',
    'aria-checked',
    'aria-disabled',
    'aria-required',
    'aria-current',
    'aria-haspopup',
    'aria-pressed',
    'aria-atomic',
    'aria-live'
];
const $5216c9b4fe44f180$export$c4351da6279bef53 = [
    'bis_skin_checked',
    'cz-shortcut-listen',
    'monica-version',
    'data-gr-ext-installed',
    'data-dashlane-rid',
    'sapling-installed',
    'data-gptw',
    // grammarly extensions
    'data-new-gr-c-s-loaded',
    'data-gr-aaa-notch-connection-id',
    'data-gr-aaa-loaded'
];
class $5216c9b4fe44f180$export$2e2bcd8739ae039 extends (0, $258a0155bf4f6bbc$export$2e2bcd8739ae039) {
    isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
        if (!$5216c9b4fe44f180$var$getConsideredEntryTypes(include3p).includes(entry.data.type)) return false;
        if (excludeSmartAnswersInSearch && (0, $6b94aa1eafef7e6a$export$8be86f3caab7d679)(entry)) return false;
        if (entry.data.type === 'mutation:media' && (0, $cnjKG.fg)('media-perf-uplift-mutation-fix')) {
            const entryData = entry.data;
            const attributeName = entryData.attributeName;
            if (attributeName && (/data-(test|file|context)-\S+/g.test(attributeName) || attributeName === 'alt')) return false;
        }
        if (entry.data.type === 'mutation:attribute') {
            const entryData = entry.data;
            const attributeName = entryData.attributeName;
            if (!attributeName || $5216c9b4fe44f180$export$98812f4e79596e2b.includes(attributeName)) return false;
            if (attributeName.startsWith('data-test') || attributeName === 'data-aui-version' || attributeName === 'data-testid' || attributeName === 'data-vc' || attributeName === 'data-ssr-placeholder' || attributeName === 'data-ssr-placeholder-replace' || attributeName === 'data-vc-nvs' || attributeName === 'data-media-vc-wrapper' || attributeName === 'data-renderer-start-pos' || attributeName === 'data-table-local-id' || attributeName === 'spellcheck' || attributeName === 'data-auto-scrollable' || attributeName === 'id' || attributeName === 'tabindex' || attributeName === 'data-is-ttvc-ready' || attributeName === 'contenteditable' || attributeName === 'data-has-collab-initialised' || attributeName === 'translate' || $5216c9b4fe44f180$export$44331555a87fcd9e.includes(attributeName) || $5216c9b4fe44f180$export$c4351da6279bef53.includes(attributeName) && (0, $cnjKG.fg)('platform_ufo_exclude_3p_extensions_from_ttvc')) return false;
            return true;
        }
        if ((0, $382d2dd4977d9655$export$2e2bcd8739ae039)(entry.data) && !entry.data.visible) return false;
        return true;
    }
    getVCCleanStatus(filteredEntries) {
        let dirtyReason = '';
        let abortTimestamp = -1;
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.data.type === 'window:event') {
                const data = entry.data;
                if ($5216c9b4fe44f180$var$ABORTING_WINDOW_EVENT.includes(data.eventType)) {
                    dirtyReason = data.eventType === 'keydown' ? 'keypress' : data.eventType;
                    abortTimestamp = Math.round(entry.time);
                    return true;
                }
            }
            return false;
        });
        if (hasAbortEvent && dirtyReason) return {
            isVCClean: false,
            dirtyReason: dirtyReason,
            abortTimestamp: abortTimestamp
        };
        return {
            isVCClean: true
        };
    }
    constructor(revisionNo){
        super(revisionNo ?? $5216c9b4fe44f180$var$REVISION_NO);
    }
}





// NOTE: `next` to be renamed `fy26.04` once stable
const $3dcfe7ed41739b4f$var$REVISION_NO = 'next';
const $3dcfe7ed41739b4f$var$getConsideredEntryTypes = ()=>{
    return [
        'mutation:display-contents-children-element'
    ];
};
const $3dcfe7ed41739b4f$var$getExcludedEntryTypes = ()=>{
    return [
        'layout-shift:same-rect'
    ];
};
class $3dcfe7ed41739b4f$export$2e2bcd8739ae039 extends (0, $5216c9b4fe44f180$export$2e2bcd8739ae039) {
    isEntryIncluded(entry, include3p) {
        const isEntryIncludedInV3 = super.isEntryIncluded(entry, include3p);
        if (isEntryIncludedInV3 && !$3dcfe7ed41739b4f$var$getExcludedEntryTypes().includes(entry.data.type)) return true;
        return $3dcfe7ed41739b4f$var$getConsideredEntryTypes().includes(entry.data.type);
    }
    constructor(){
        super($3dcfe7ed41739b4f$var$REVISION_NO);
    }
}



var $cnjKG = parcelRequire("cnjKG");



function $f16b2a0eebdc73e5$var$isValidEntry(entry) {
    return entry.isIntersecting && entry.intersectionRect.width > 0 && entry.intersectionRect.height > 0;
}
function $f16b2a0eebdc73e5$export$c3799d33e0ae80a5({ onEntry: onEntry, onObserved: onObserved }) {
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    const callbacksPerElement = new WeakMap();
    const intersectionObserverCallback = (entries)=>{
        const validEntries = [];
        const startTime = performance.now();
        entries.forEach((entry)=>{
            if (!(entry.target instanceof HTMLElement) || !$f16b2a0eebdc73e5$var$isValidEntry(entry)) return;
            let mutationTag = null;
            let mutationData = null;
            const tagOrCallback = callbacksPerElement.get(entry.target);
            if (typeof tagOrCallback === 'function') {
                const tagOrCallbackResult = tagOrCallback({
                    target: entry.target,
                    rect: entry.intersectionRect
                });
                if (!tagOrCallbackResult) mutationTag = 'unknown';
                else if (typeof tagOrCallbackResult === 'string') mutationTag = tagOrCallbackResult;
                else {
                    mutationTag = tagOrCallbackResult.type;
                    mutationData = tagOrCallbackResult.mutationData;
                }
            } else if (typeof tagOrCallback === 'string') mutationTag = tagOrCallback;
            onEntry({
                target: entry.target,
                rect: entry.intersectionRect,
                time: entry.time,
                type: mutationTag ?? 'unknown',
                mutationData: mutationData
            });
            validEntries.push(new WeakRef(entry.target));
            callbacksPerElement.delete(entry.target);
            observer.unobserve(entry.target);
        });
        onObserved?.({
            time: startTime,
            elements: validEntries
        });
    };
    const observer = new IntersectionObserver(intersectionObserverCallback);
    return {
        disconnect: ()=>{
            observer.disconnect();
        },
        unobserve: (target)=>{
            observer.unobserve(target);
        },
        watchAndTag: (target, tagOrCallback)=>{
            callbacksPerElement.set(target, tagOrCallback);
            observer.observe(target);
        }
    };
}



var $aE6gq = parcelRequire("aE6gq");

const $4e3a02ee1ebd6c82$export$9db1624a8af791a4 = (experimentName, experimentParam, defaultValue)=>{
    // If client is not initialized, we return the default value
    if (!(0, $aE6gq.default).initializeCompleted()) return defaultValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $aE6gq.default).getExperimentValue(experimentName, experimentParam, defaultValue);
    (0, $bad1dfcb36c5adde$export$47fade9662f71000)(`${experimentName}:${experimentParam}`, experimentValue);
    return experimentValue;
};


function $07888a5dab0a3239$var$createMutationObserver({ onAttributeMutation: onAttributeMutation, onChildListMutation: onChildListMutation, onMutationFinished: onMutationFinished }) {
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    const mutationObserverCallback = (mutations)=>{
        const targets = [];
        // Use nested Maps for O(1) batching performance
        // Short-lived Maps are safe since they're discarded after each callback
        const batchedMutations = new Map();
        for (const mut of mutations){
            if (!(mut.target instanceof HTMLElement)) continue;
            if ((0, $4e3a02ee1ebd6c82$export$9db1624a8af791a4)('cc_editor_vc_exclude_flags', 'isEnabled', false)) {
                // Intended for excluding out of band mutations such as tooltips on hover, and page flags
                // Currently being tested in Confluence
                // Skip elements with data-vc-oob attribute
                if (mut.target.dataset.vcOob) return;
            }
            if (mut.type === 'attributes') {
                /*
							"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
							I think it might have been something along the lines that for consistency every setAttribute call should create a record.
							Conceptually there is after all a mutation: there is an old value replaced with a new one,
							and whether or not they are the same doesn't really matter.
							And Custom elements should work the same way as MutationObserver."
							https://github.com/whatwg/dom/issues/520#issuecomment-336574796
						*/ const oldValue = mut.oldValue ?? undefined;
                const newValue = mut.attributeName ? mut.target.getAttribute(mut.attributeName) : undefined;
                if (oldValue !== newValue) onAttributeMutation({
                    target: mut.target,
                    attributeName: mut.attributeName ?? 'unknown',
                    oldValue: oldValue,
                    newValue: newValue
                });
                continue;
            } else if (mut.type === 'childList') {
                // In chromium browser MutationRecord has timestamp field, which we should use.
                const timestamp = Math.round(mut.timestamp || performance.now());
                // Get or create timestamp bucket
                let timestampBucket = batchedMutations.get(timestamp);
                if (!timestampBucket) {
                    timestampBucket = new Map();
                    batchedMutations.set(timestamp, timestampBucket);
                }
                // Get or create target batch within timestamp bucket
                let batch = timestampBucket.get(mut.target);
                if (!batch) {
                    batch = {
                        target: new WeakRef(mut.target),
                        addedNodes: [],
                        removedNodes: [],
                        timestamp: timestamp
                    };
                    timestampBucket.set(mut.target, batch);
                }
                // Accumulate added nodes
                (mut.addedNodes ?? []).forEach((node)=>{
                    if (node instanceof HTMLElement) batch.addedNodes.push(new WeakRef(node));
                });
                // Accumulate removed nodes
                (mut.removedNodes ?? []).forEach((node)=>{
                    if (node instanceof HTMLElement) batch.removedNodes.push(new WeakRef(node));
                });
            }
            targets.push(mut.target);
        }
        // Process all batched childList mutations
        for (const timestampBucket of batchedMutations.values())for (const batch of timestampBucket.values())onChildListMutation({
            target: batch.target,
            addedNodes: batch.addedNodes,
            removedNodes: batch.removedNodes,
            timestamp: batch.timestamp
        });
        onMutationFinished?.({
            targets: targets
        });
    };
    const observer = new MutationObserver(mutationObserverCallback);
    return observer;
}
var $07888a5dab0a3239$export$2e2bcd8739ae039 = $07888a5dab0a3239$var$createMutationObserver;


// The LayoutShiftAttribution API is returning the numbers on physical dimension
function $9de8155a758ba46c$export$5e3f54cad8cb65e2(rect) {
    if (typeof window.devicePixelRatio !== 'number') return rect;
    if (window.devicePixelRatio === 1) return rect;
    // eslint-disable-next-line compat/compat
    return new DOMRect(rect.x / window.devicePixelRatio, rect.y / window.devicePixelRatio, rect.width / window.devicePixelRatio, rect.height / window.devicePixelRatio);
}
function $9de8155a758ba46c$var$createPerformanceObserver({ onLayoutShift: onLayoutShift }) {
    if (!window || typeof window.PerformanceObserver !== 'function') return null;
    const performanceObserverCallback = (entries)=>{
        for (const entry of entries.getEntries())if (entry.entryType === 'layout-shift' && 'sources' in entry) {
            // see https://developer.mozilla.org/en-US/docs/Web/API/LayoutShiftAttribution for more info
            const changedRects = entry.sources.reduceRight((acc, attr)=>{
                acc.push({
                    rect: $9de8155a758ba46c$export$5e3f54cad8cb65e2(attr.currentRect),
                    previousRect: $9de8155a758ba46c$export$5e3f54cad8cb65e2(attr.previousRect),
                    node: attr.node
                });
                return acc;
            }, []);
            onLayoutShift({
                time: entry.startTime,
                changedRects: changedRects
            });
        }
    };
    const observer = new PerformanceObserver(performanceObserverCallback);
    return observer;
}
var $9de8155a758ba46c$export$2e2bcd8739ae039 = $9de8155a758ba46c$var$createPerformanceObserver;



// Helper function to extract component name from fiber
function $fc255221be729b2b$export$2e2bcd8739ae039(fiber) {
    const type = fiber?.type;
    if (!type) return undefined;
    if (typeof type === 'function' || typeof type === 'object') return type.displayName || type.name;
    return undefined;
}


function $3d6ddc011d3a68b4$export$2e2bcd8739ae039(fiber, targetComponentName, maxLevel) {
    // Stop when no more levels to traverse
    if (maxLevel <= 0) return false;
    if (!fiber) return false;
    const componentName = (0, $fc255221be729b2b$export$2e2bcd8739ae039)(fiber);
    if (componentName === targetComponentName) return true;
    // Recursively traverse up the fiber tree
    return $3d6ddc011d3a68b4$export$2e2bcd8739ae039(fiber.return, targetComponentName, maxLevel - 1);
}


// Helper function to find React fiber on an element
function $69b1982048e3d465$export$2e2bcd8739ae039(element) {
    // Use for...in loop instead of Object.keys().find() to avoid creating an array
    for(const key in element){
        if (key.startsWith('__reactFiber$') || key.startsWith('__reactInternalInstance$')) return element[key];
    }
    return null;
}


function $331e2955b12a30b6$export$2e2bcd8739ae039(element, maxLevel, checkedNodes) {
    // Stop when no more levels to traverse
    if (maxLevel <= 0) return null;
    checkedNodes.push(element);
    const fiber = (0, $69b1982048e3d465$export$2e2bcd8739ae039)(element);
    if (fiber) return fiber;
    // Walk up the DOM tree to find the fiber
    const parent = element.parentElement;
    if (!parent) return null;
    // Recursively check parent
    return $331e2955b12a30b6$export$2e2bcd8739ae039(parent, maxLevel - 1, checkedNodes);
}


const $8f40ba37c4954a0d$var$DEFAULT_MAX_LEVEL = 20;
// Cache cleanup
let $8f40ba37c4954a0d$var$callCount = 0;
const $8f40ba37c4954a0d$var$CLEANUP_THRESHOLD = 50;
function $8f40ba37c4954a0d$var$maybeCleanup(resultCache) {
    $8f40ba37c4954a0d$var$callCount++;
    if ($8f40ba37c4954a0d$var$callCount >= $8f40ba37c4954a0d$var$CLEANUP_THRESHOLD && (0, $4659fee6fbb6d2af$export$2e2bcd8739ae039)(0.3)) $8f40ba37c4954a0d$export$6a35c3789c327630(resultCache);
}
function $8f40ba37c4954a0d$export$6a35c3789c327630(resultCache) {
    resultCache = new WeakMap();
    $8f40ba37c4954a0d$var$callCount = 0;
    return resultCache;
}
function $8f40ba37c4954a0d$export$2e2bcd8739ae039(node, targetComponentName, resultCache) {
    $8f40ba37c4954a0d$var$maybeCleanup(resultCache);
    if (resultCache.has(node)) return {
        isWithin: resultCache.get(node) ?? false
    };
    let fiber = null;
    let checkedNodes = [];
    // Always use cached fiber strategy to handle non-React elements reliably
    fiber = (0, $331e2955b12a30b6$export$2e2bcd8739ae039)(node, $8f40ba37c4954a0d$var$DEFAULT_MAX_LEVEL, checkedNodes);
    if (!fiber) {
        checkedNodes.forEach((checkedNode)=>{
            resultCache.set(checkedNode, false);
        });
        return {
            isWithin: false
        };
    }
    const isWithin = (0, $3d6ddc011d3a68b4$export$2e2bcd8739ae039)(fiber, targetComponentName, $8f40ba37c4954a0d$var$DEFAULT_MAX_LEVEL);
    checkedNodes.forEach((checkedNode)=>{
        resultCache.set(checkedNode, isWithin);
    });
    return {
        isWithin: isWithin
    };
}


const $454f1e58447c0186$var$MAX_NESTED_LEVELS_OF_DISPLAY_CONTENT_ELEMENTS_HANDLED = 3;
function $454f1e58447c0186$export$c9ea137b0af90c5e(element, depthLevel = 0) {
    if (window?.getComputedStyle(element)?.display === 'contents') {
        const mutatedElements = [];
        const nestedDisplayContentsElementChildren = [];
        for (const child of element.children){
            if (window?.getComputedStyle(child)?.display === 'contents') nestedDisplayContentsElementChildren.push(child);
            mutatedElements.push({
                element: child,
                isDisplayContentsElementChildren: true
            });
        }
        if (depthLevel < $454f1e58447c0186$var$MAX_NESTED_LEVELS_OF_DISPLAY_CONTENT_ELEMENTS_HANDLED && nestedDisplayContentsElementChildren.length > 0) return [
            ...mutatedElements,
            ...nestedDisplayContentsElementChildren.map((element)=>$454f1e58447c0186$export$c9ea137b0af90c5e(element, depthLevel + 1)).flat()
        ];
        return mutatedElements;
    } else return [
        {
            element: element,
            isDisplayContentsElementChildren: false
        }
    ];
}


function $d3eed8af844f3e91$export$e989c0fffaa6b27a(element) {
    if (!(element instanceof HTMLElement)) return true;
    try {
        const visible = element.checkVisibility({
            // @ts-ignore - visibilityProperty may not exist in all TS environments
            visibilityProperty: true,
            contentVisibilityAuto: true,
            opacityProperty: true
        });
        return visible;
    } catch (e) {
        // there is no support for checkVisibility
        return true;
    }
}


/**
 * Check if the element is in the VC ignore if no layout shift marker.
 * @param element - The element to check.
 * @returns True if the element has the data-vc-ignore-if-no-layout-shift attribute == 'true or its parent has it, false otherwise.
 */ function $f64c41fac552ffe4$export$2e2bcd8739ae039(element) {
    if (!element) return false;
    return element.getAttribute('data-vc-ignore-if-no-layout-shift') === 'true' || $f64c41fac552ffe4$export$2e2bcd8739ae039(element.parentElement);
}


const $075a8265dd084aa5$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX = 1;
function $075a8265dd084aa5$export$fde63bc968551821(a, b) {
    if (!a || !b) return false;
    return Math.abs(a.width - b.width) <= $075a8265dd084aa5$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.height - b.height) <= $075a8265dd084aa5$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.x - b.x) <= $075a8265dd084aa5$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.y - b.y) <= $075a8265dd084aa5$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX;
}


const $4b892b277c94f57b$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX = 1;
function $4b892b277c94f57b$export$597b41700f7dcd36(a, b) {
    if (!a || !b) return false;
    return Math.abs(a.width - b.width) <= $4b892b277c94f57b$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.height - b.height) <= $4b892b277c94f57b$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX;
}


const $cdf320ce09f2d570$var$createElementMutationsWatcher = (removedNodeRects)=>({ target: target, rect: rect })=>{
        const isInIgnoreLsMarker = (0, $f64c41fac552ffe4$export$2e2bcd8739ae039)(target);
        if (!isInIgnoreLsMarker) return 'mutation:element';
        const isRLLPlaceholder = (0, $c8503ffbffbc0ab6$export$166779fc0f49d4df).getInstance().isRLLPlaceholderHydration(rect);
        if (isRLLPlaceholder && isInIgnoreLsMarker) return 'mutation:rll-placeholder';
        const wasDeleted = removedNodeRects.some((nr)=>(0, $075a8265dd084aa5$export$fde63bc968551821)(nr, rect));
        if (wasDeleted && isInIgnoreLsMarker) return 'mutation:element-replacement';
        return 'mutation:element';
    };
class $cdf320ce09f2d570$export$2e2bcd8739ae039 {
    initializeObservers() {
        if (this.isStarted) return;
        this.intersectionObserver = (0, $f16b2a0eebdc73e5$export$c3799d33e0ae80a5)({
            onEntry: this.handleIntersectionEntry
        });
        this.mutationObserver = (0, $07888a5dab0a3239$export$2e2bcd8739ae039)({
            onChildListMutation: this.handleChildListMutation,
            onAttributeMutation: this.handleAttributeMutation
        });
        this.performanceObserver = (0, $9de8155a758ba46c$export$2e2bcd8739ae039)({
            onLayoutShift: this.handleLayoutShift
        });
    }
    start() {
        if (this.isStarted) return;
        this.initializeObservers();
        this.mutationObserver?.observe(document.body, {
            attributeOldValue: true,
            attributes: true,
            childList: true,
            subtree: true
        });
        this.performanceObserver?.observe({
            type: 'layout-shift',
            buffered: true,
            // @ts-ignore -error
            durationThreshold: 30
        });
        this.isStarted = true;
    }
    stop() {
        if (!this.isStarted) return;
        this.mutationObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.performanceObserver?.disconnect();
        this.isStarted = false;
        // Clean up caches when stopping
        (0, $8f40ba37c4954a0d$export$6a35c3789c327630)(this.mapIs3pResult);
    }
    constructor({ onChange: onChange, getSSRState: getSSRState, getSSRPlaceholderHandler: getSSRPlaceholderHandler }){
        this.intersectionObserver = void 0;
        this.mutationObserver = void 0;
        this.performanceObserver = void 0;
        this.mapVisibleNodeRects = void 0;
        this.mapIs3pResult = void 0;
        this.onChange = void 0;
        this.isStarted = void 0;
        // SSR context functions
        this.getSSRState = void 0;
        this.getSSRPlaceholderHandler = void 0;
        this.handleIntersectionEntry = ({ target: target, rect: rect, time: time, type: type, mutationData: mutationData })=>{
            if (!target) return;
            const visible = (0, $d3eed8af844f3e91$export$e989c0fffaa6b27a)(target);
            const lastElementRect = this.mapVisibleNodeRects.get(target);
            this.mapVisibleNodeRects.set(target, rect);
            this.onChange({
                time: time,
                type: type,
                elementRef: new WeakRef(target),
                visible: visible,
                rect: rect,
                previousRect: lastElementRect,
                mutationData: mutationData
            });
        };
        this.handleChildListMutation = async ({ target: target, addedNodes: addedNodes, removedNodes: removedNodes, timestamp: timestamp })=>{
            const removedNodeRects = removedNodes.map((ref)=>{
                const n = ref.deref();
                if (!n) return;
                return this.mapVisibleNodeRects.get(n);
            });
            const targetNode = target.deref();
            for (const addedNodeRef of addedNodes){
                const addedNode = addedNodeRef.deref();
                if (!addedNode) continue;
                for (const { isDisplayContentsElementChildren: isDisplayContentsElementChildren, element: element } of (0, $454f1e58447c0186$export$c9ea137b0af90c5e)(addedNode)){
                    // SSR hydration logic
                    if (this.getSSRState) {
                        const ssrState = this.getSSRState();
                        const SSRStateEnum = {
                            normal: 1,
                            waitingForFirstRender: 2,
                            ignoring: 3
                        };
                        if (ssrState.state === SSRStateEnum.waitingForFirstRender && timestamp > ssrState.renderStart && targetNode === ssrState.reactRootElement) {
                            ssrState.state = SSRStateEnum.ignoring;
                            if (ssrState.renderStop === -1) // arbitrary 500ms DOM update window
                            ssrState.renderStop = timestamp + 500;
                            this.intersectionObserver?.watchAndTag(element, 'ssr-hydration');
                            continue;
                        }
                        if (ssrState.state === SSRStateEnum.ignoring && timestamp > ssrState.renderStart && targetNode === ssrState.reactRootElement) {
                            if (timestamp <= ssrState.renderStop) {
                                this.intersectionObserver?.watchAndTag(element, 'ssr-hydration');
                                continue;
                            } else ssrState.state = SSRStateEnum.normal;
                        }
                    }
                    // SSR placeholder logic - check and handle with await
                    if (this.getSSRPlaceholderHandler) {
                        const ssrPlaceholderHandler = this.getSSRPlaceholderHandler();
                        if (ssrPlaceholderHandler) {
                            if (ssrPlaceholderHandler.isPlaceholder(element) || ssrPlaceholderHandler.isPlaceholderIgnored(element)) {
                                if (ssrPlaceholderHandler.checkIfExistedAndSizeMatchingV3(element)) {
                                    this.intersectionObserver?.watchAndTag(element, 'mutation:ssr-placeholder');
                                    continue;
                                }
                            }
                            if (ssrPlaceholderHandler.isPlaceholderReplacement(element) || ssrPlaceholderHandler.isPlaceholderIgnored(element)) {
                                const result = await ssrPlaceholderHandler.validateReactComponentMatchToPlaceholder(element);
                                if (result !== false) {
                                    this.intersectionObserver?.watchAndTag(element, 'mutation:ssr-placeholder');
                                    continue;
                                }
                            // If result is false, continue to normal mutation logic below
                            }
                        }
                    }
                    const sameDeletedNode = removedNodes.find((ref)=>{
                        const n = ref.deref();
                        if (!n || !element) return false;
                        return n.isEqualNode(element);
                    });
                    const isInIgnoreLsMarker = element instanceof HTMLElement ? (0, $f64c41fac552ffe4$export$2e2bcd8739ae039)(element) : false;
                    if (sameDeletedNode && isInIgnoreLsMarker) {
                        this.intersectionObserver?.watchAndTag(element, 'mutation:remount');
                        continue;
                    }
                    if ((0, $86a48bade3b91e5a$export$f61fbc3b9c4a9019)(element)) {
                        this.intersectionObserver?.watchAndTag(element, 'mutation:media');
                        continue;
                    }
                    const { isWithin: isWithinThirdPartySegment } = element instanceof HTMLElement ? (0, $8f40ba37c4954a0d$export$2e2bcd8739ae039)(element, 'UFOThirdPartySegment', this.mapIs3pResult) : {
                        isWithin: false
                    };
                    if (isWithinThirdPartySegment) {
                        this.intersectionObserver?.watchAndTag(element, 'mutation:third-party-element');
                        continue;
                    }
                    if (isDisplayContentsElementChildren) this.intersectionObserver?.watchAndTag(element, 'mutation:display-contents-children-element');
                    else this.intersectionObserver?.watchAndTag(element, $cdf320ce09f2d570$var$createElementMutationsWatcher(removedNodeRects));
                }
            }
        };
        this.handleAttributeMutation = ({ target: target, attributeName: attributeName, oldValue: oldValue, newValue: newValue })=>{
            this.intersectionObserver?.watchAndTag(target, ({ target: target, rect: rect })=>{
                if ((0, $86a48bade3b91e5a$export$f61fbc3b9c4a9019)(target)) return {
                    type: 'mutation:media',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
                if ((0, $cnjKG.fg)('platform_ufo_exclude_3p_attribute_changes')) {
                    const { isWithin: isWithinThirdPartySegment } = (0, $8f40ba37c4954a0d$export$2e2bcd8739ae039)(target, 'UFOThirdPartySegment', this.mapIs3pResult);
                    if (isWithinThirdPartySegment) return {
                        type: 'mutation:third-party-attribute',
                        mutationData: {
                            attributeName: attributeName,
                            oldValue: oldValue,
                            newValue: newValue
                        }
                    };
                }
                if ((0, $18027e2848e11db0$export$2e2bcd8739ae039)({
                    target: target,
                    attributeName: attributeName,
                    type: 'attributes'
                })) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
                const isRLLPlaceholder = (0, $c8503ffbffbc0ab6$export$166779fc0f49d4df).getInstance().isRLLPlaceholderHydration(rect);
                if (isRLLPlaceholder) return {
                    type: 'mutation:rll-placeholder',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
                const lastElementRect = this.mapVisibleNodeRects.get(target);
                if (lastElementRect && (0, $4b892b277c94f57b$export$597b41700f7dcd36)(rect, lastElementRect)) return {
                    type: 'mutation:attribute:no-layout-shift',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
                return {
                    type: 'mutation:attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
            });
        };
        this.handleLayoutShift = ({ time: time, changedRects: changedRects })=>{
            for (const changedRect of changedRects){
                const target = changedRect.node;
                if (target) {
                    const isSameCurrentAndPreviousRects = (0, $075a8265dd084aa5$export$fde63bc968551821)(changedRect.rect, changedRect.previousRect);
                    this.onChange({
                        time: time,
                        elementRef: new WeakRef(target),
                        visible: true,
                        rect: changedRect.rect,
                        previousRect: changedRect.previousRect,
                        type: isSameCurrentAndPreviousRects ? 'layout-shift:same-rect' : 'layout-shift'
                    });
                }
            }
        };
        this.mapVisibleNodeRects = new WeakMap();
        this.mapIs3pResult = new WeakMap();
        this.onChange = onChange;
        this.isStarted = false;
        this.intersectionObserver = null;
        this.mutationObserver = null;
        this.performanceObserver = null;
        // Initialize SSR context functions
        this.getSSRState = getSSRState;
        this.getSSRPlaceholderHandler = getSSRPlaceholderHandler;
    }
}



class $3bc33983ff718785$export$2e2bcd8739ae039 {
    bindEvent(type) {
        const unbindCallback = (0, $46ab2715b72c0996$exports.bind)(window, {
            type: type,
            listener: (event)=>{
                if (!event.isTrusted) return;
                this.onEvent({
                    time: event.timeStamp,
                    type: type,
                    event: event
                });
            },
            options: {
                passive: true,
                once: true
            }
        });
        this.unbindFns.push(unbindCallback);
    }
    start() {
        this.bindEvent('wheel');
        this.bindEvent('scroll');
        this.bindEvent('keydown');
        this.bindEvent('resize');
    }
    stop() {
        this.unbindFns.forEach((cb)=>{
            cb();
        });
        this.unbindFns = [];
    }
    constructor(opts){
        this.unbindFns = [];
        this.onEvent = void 0;
        this.onEvent = opts.onEvent;
    }
}


const $8f72356c075818ad$var$SSRState = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
const $8f72356c075818ad$var$DEFAULT_SELECTOR_CONFIG = {
    id: false,
    testId: true,
    role: false,
    className: false,
    dataVC: true
};
class $8f72356c075818ad$export$2e2bcd8739ae039 {
    start(_) {
        // Reset SSR state on start (matches old VCObserver behavior)
        this.ssr = {
            state: $8f72356c075818ad$var$SSRState.normal,
            reactRootElement: null,
            // Reset to null (matches old VCObserver)
            renderStart: -1,
            renderStop: -1
        };
        this.viewportObserver?.start();
        if (window?.__SSR_ABORT_LISTENERS__) {
            const abortListeners = window.__SSR_ABORT_LISTENERS__;
            const aborts = abortListeners.aborts;
            if (aborts && typeof aborts === 'object') Object.entries(aborts).forEach(([key, time])=>{
                if (typeof time === 'number') this.entriesTimeline.push({
                    time: time,
                    data: {
                        type: 'window:event',
                        eventType: key
                    }
                });
            });
        }
        this.windowEventObserver?.start();
        this.entriesTimeline.clear();
    }
    stop() {
        this.viewportObserver?.stop();
        this.windowEventObserver?.stop();
        // Clear SSR state on stop (matches old VCObserver behavior)
        this.ssr.reactRootElement = null;
    }
    // SSR related methods
    setReactRootElement(element) {
        this.ssr.reactRootElement = element;
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.ssr.renderStart = startTime;
        this.ssr.state = $8f72356c075818ad$var$SSRState.waitingForFirstRender;
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.ssr.renderStop = stopTime;
    }
    collectSSRPlaceholders() {
    // This is handled by the shared SSRPlaceholderHandlers in VCObserverWrapper
    // Individual observers don't need to implement this
    }
    // Internal methods for ViewportObserver to access SSR state
    getSSRState() {
        return this.ssr;
    }
    getSSRPlaceholderHandler() {
        return this.ssrPlaceholderHandler;
    }
    addSSR(ssr) {
        this.entriesTimeline.push({
            time: ssr,
            data: {
                elementName: 'SSR',
                type: 'mutation:element',
                rect: {
                    height: (0, $4ff47188228910cc$export$2e2bcd8739ae039)(),
                    width: (0, $af3823a1c15573dc$export$2e2bcd8739ae039)(),
                    left: 0,
                    top: 0,
                    x: 0,
                    y: 0,
                    bottom: (0, $4ff47188228910cc$export$2e2bcd8739ae039)(),
                    right: (0, $af3823a1c15573dc$export$2e2bcd8739ae039)(),
                    toJSON () {
                        return null;
                    }
                },
                visible: true
            }
        });
    }
    async getVCResult(param) {
        const { start: start, stop: stop, interactionId: interactionId, interactionType: interactionType, interactionAbortReason: interactionAbortReason, isPageVisible: isPageVisible, include3p: include3p, includeSSRRatio: includeSSRRatio, excludeSmartAnswersInSearch: excludeSmartAnswersInSearch } = param;
        const results = [];
        this.addStartEntry(start);
        const calculator_fy25_03 = new (0, $5216c9b4fe44f180$export$2e2bcd8739ae039)();
        if (param.ssr) this.addSSR(param.ssr);
        const orderedEntries = this.entriesTimeline.getOrderedEntries({
            start: start,
            stop: stop
        });
        const fy25_03 = await calculator_fy25_03.calculate({
            orderedEntries: orderedEntries,
            startTime: start,
            stopTime: stop,
            interactionId: interactionId,
            interactionType: interactionType,
            isPostInteraction: this.isPostInteraction,
            include3p: include3p,
            excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
            includeSSRRatio: includeSSRRatio,
            isPageVisible: isPageVisible,
            interactionAbortReason: interactionAbortReason
        });
        if (fy25_03) results.push(fy25_03);
        // TODO on cleanup: put behind `enabledVCRevisions` config
        const calculator_next = new (0, $3dcfe7ed41739b4f$export$2e2bcd8739ae039)();
        const vcNext = await calculator_next.calculate({
            orderedEntries: orderedEntries,
            startTime: start,
            stopTime: stop,
            interactionId: interactionId,
            interactionType: interactionType,
            isPostInteraction: this.isPostInteraction,
            include3p: include3p,
            includeSSRRatio: includeSSRRatio,
            isPageVisible: isPageVisible,
            interactionAbortReason: interactionAbortReason
        });
        if (vcNext) results.push(vcNext);
        return results;
    }
    addStartEntry(startTime) {
        this.entriesTimeline.push({
            time: startTime,
            data: {
                type: 'mutation:element',
                elementName: 'START',
                visible: true,
                rect: {
                    x: 0,
                    y: 0,
                    width: window.innerWidth,
                    height: window.innerHeight,
                    top: 0,
                    left: 0,
                    bottom: window.innerHeight,
                    right: window.innerWidth,
                    toJSON: function() {
                        return {
                            x: this.x,
                            y: this.y,
                            width: this.width,
                            height: this.height,
                            top: this.top,
                            left: this.left,
                            bottom: this.bottom,
                            right: this.right
                        };
                    }
                }
            }
        });
    }
    getElementName(element) {
        return (0, $44cdd7d7c021d005$export$2e2bcd8739ae039)(this.selectorConfig, element);
    }
    constructor(config){
        this.selectorConfig = void 0;
        this.viewportObserver = null;
        this.windowEventObserver = null;
        this.entriesTimeline = void 0;
        this.isPostInteraction = void 0;
        // SSR related properties
        this.ssrPlaceholderHandler = null;
        this.ssr = {
            state: $8f72356c075818ad$var$SSRState.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.entriesTimeline = new (0, $cf7971336bf19b1a$export$2e2bcd8739ae039)();
        this.isPostInteraction = config.isPostInteraction ?? false;
        this.selectorConfig = config.selectorConfig ?? $8f72356c075818ad$var$DEFAULT_SELECTOR_CONFIG;
        // Use shared SSR placeholder handler if provided, otherwise create new one if feature flag is enabled
        if (config.ssrPlaceholderHandler) this.ssrPlaceholderHandler = config.ssrPlaceholderHandler;
        else this.ssrPlaceholderHandler = new (0, $fb991c433aa54a3e$export$c0102f1a1198d10f)({
            enablePageLayoutPlaceholder: config.SSRConfig?.enablePageLayoutPlaceholder ?? false
        });
        this.viewportObserver = new (0, $cdf320ce09f2d570$export$2e2bcd8739ae039)({
            onChange: (onChangeArg)=>{
                const { time: time, type: type, elementRef: elementRef, visible: visible, rect: rect, previousRect: previousRect, mutationData: mutationData } = onChangeArg;
                let elementName = 'unknown';
                const element = elementRef.deref();
                if (element) elementName = this.getElementName(element);
                const data = {
                    type: type,
                    elementName: elementName,
                    rect: rect,
                    previousRect: previousRect,
                    visible: visible,
                    attributeName: mutationData?.attributeName,
                    oldValue: mutationData?.oldValue,
                    newValue: mutationData?.newValue
                };
                if (element && this.isPostInteraction && (0, $cnjKG.fg)('platform_ufo_enable_late_mutation_label_stacks')) {
                    const labelStacks = $8f72356c075818ad$var$getLabelStacks(element);
                    if (labelStacks) Object.assign(data, {
                        labelStacks: labelStacks
                    });
                }
                this.entriesTimeline.push({
                    time: time,
                    data: data
                });
            },
            // Pass SSR context to ViewportObserver
            getSSRState: ()=>this.getSSRState(),
            getSSRPlaceholderHandler: ()=>this.getSSRPlaceholderHandler()
        });
        this.windowEventObserver = new (0, $3bc33983ff718785$export$2e2bcd8739ae039)({
            onEvent: ({ time: time, type: type })=>{
                this.entriesTimeline.push({
                    time: time,
                    data: {
                        type: 'window:event',
                        eventType: type
                    }
                });
            }
        });
    }
}
function $8f72356c075818ad$var$labelStackFromFiber(fiber) {
    const value = fiber?.child?.memoizedProps?.value;
    return Array.isArray(value?.labelStack) ? value.labelStack : [];
}
function $8f72356c075818ad$var$labelStackToString(labelStack) {
    return labelStack.map((label)=>label.name).join('/');
}
function $8f72356c075818ad$var$labelStackToSegment(labelStack) {
    let segmentIndex = -1;
    for(let i = labelStack.length - 1; i >= 0; i--)if (labelStack[i].segmentId) {
        segmentIndex = i;
        break;
    }
    return labelStack.slice(0, segmentIndex + 1).map((label)=>label.name).join('/');
}
function $8f72356c075818ad$var$traverseFiber(fiber) {
    let segment = 'unknown';
    let labelStackString = 'unknown';
    let currentFiber = fiber;
    while(currentFiber){
        if (currentFiber.type) {
            const componentName = currentFiber.type.displayName || currentFiber.type.name;
            if (componentName === 'UFOSegment' || componentName === 'UFOLabel') {
                const labelStack = $8f72356c075818ad$var$labelStackFromFiber(currentFiber);
                labelStackString = $8f72356c075818ad$var$labelStackToString(labelStack) || 'unknown';
                segment = $8f72356c075818ad$var$labelStackToSegment(labelStack) || 'unknown';
                break;
            }
        }
        currentFiber = currentFiber.return;
    }
    return {
        segment: segment,
        labelStack: labelStackString
    };
}
function $8f72356c075818ad$var$getLabelStacks(element) {
    const reactFiberKey = Object.keys(element).find((key)=>key.startsWith('__reactFiber$'));
    if (!reactFiberKey) return null;
    const fiber = element[reactFiberKey];
    return fiber ? $8f72356c075818ad$var$traverseFiber(fiber) : null;
}





var $1CHRc = parcelRequire("1CHRc");
class $c64cf67065768157$export$4a1fe1ab3c13bbf5 {
    // Helper method to process SSR abort listeners
    processSsrAbortListeners() {
        // Process any SSR abort listeners that remain
        if (window?.__SSR_ABORT_LISTENERS__) {
            // Clean up any event listeners that may have been registered during SSR
            // This is centralized here so only the wrapper handles unbinding, not individual observers
            if (window.__SSR_ABORT_LISTENERS__.unbinds && Array.isArray(window.__SSR_ABORT_LISTENERS__.unbinds)) window.__SSR_ABORT_LISTENERS__.unbinds.forEach((unbind)=>{
                if (typeof unbind === 'function') unbind();
            });
            // After all observers had a chance to process abort events,
            // we can safely delete the SSR_ABORT_LISTENERS object
            delete window.__SSR_ABORT_LISTENERS__;
        }
    }
    start({ startTime: startTime, experienceKey: experienceKey }) {
        if ((0, $0d141f9c9c05f1cf$export$4babcefc81a3ef0b)('fy25.01', experienceKey) || (0, $0d141f9c9c05f1cf$export$4babcefc81a3ef0b)('fy25.02', experienceKey)) this.oldVCObserver?.start({
            startTime: startTime
        });
        if ((0, $0d141f9c9c05f1cf$export$4babcefc81a3ef0b)('fy25.03', experienceKey)) this.newVCObserver?.start({
            startTime: startTime
        });
        // Clean up any remaining SSR abort listeners after all observers have been started
        this.processSsrAbortListeners();
    }
    stop(experienceKey) {
        if ((0, $0d141f9c9c05f1cf$export$4babcefc81a3ef0b)('fy25.01', experienceKey) || (0, $0d141f9c9c05f1cf$export$4babcefc81a3ef0b)('fy25.02', experienceKey)) this.oldVCObserver?.stop();
        if ((0, $0d141f9c9c05f1cf$export$4babcefc81a3ef0b)('fy25.03', experienceKey)) this.newVCObserver?.stop();
        (0, $c8503ffbffbc0ab6$export$166779fc0f49d4df).getInstance().reset();
        // Clear shared SSR placeholder handler
        this.ssrPlaceholderHandler.clear();
    }
    getVCRawData() {
        return this.oldVCObserver?.getVCRawData() ?? null;
    }
    async getVCResult(param) {
        const { experienceKey: experienceKey, include3p: include3p, excludeSmartAnswersInSearch: excludeSmartAnswersInSearch, includeSSRRatio: includeSSRRatio } = param;
        const v1v2Result = (0, $0d141f9c9c05f1cf$export$4babcefc81a3ef0b)('fy25.01', experienceKey) || (0, $0d141f9c9c05f1cf$export$4babcefc81a3ef0b)('fy25.02', experienceKey) ? await this.oldVCObserver?.getVCResult(param) : {};
        const v3Result = (0, $0d141f9c9c05f1cf$export$4babcefc81a3ef0b)('fy25.03', experienceKey) ? await this.newVCObserver?.getVCResult({
            start: param.start,
            stop: param.stop,
            interactionId: param.interactionId,
            ssr: param.includeSSRInV3 ? param.ssr : undefined,
            include3p: include3p,
            excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
            includeSSRRatio: includeSSRRatio,
            interactionType: param.interactionType,
            isPageVisible: param.isPageVisible,
            interactionAbortReason: param.interactionAbortReason
        }) : [];
        if (!v3Result) return v1v2Result ?? {};
        const ssrRatio = v3Result[0].ssrRatio;
        return {
            ...includeSSRRatio && ssrRatio !== undefined ? {
                'ufo:vc:ssrRatio': ssrRatio
            } : {},
            ...v1v2Result,
            'ufo:vc:rev': [
                ...v1v2Result?.['ufo:vc:rev'] ?? [],
                ...v3Result ?? []
            ]
        };
    }
    setSSRElement(element) {
        this.oldVCObserver?.setSSRElement(element);
        this.newVCObserver?.setReactRootElement(element);
    }
    setReactRootRenderStart(startTime) {
        this.oldVCObserver?.setReactRootRenderStart(startTime || performance.now());
        this.newVCObserver?.setReactRootRenderStart(startTime || performance.now());
    }
    setReactRootRenderStop(stopTime) {
        this.oldVCObserver?.setReactRootRenderStop(stopTime || performance.now());
        this.newVCObserver?.setReactRootRenderStop(stopTime || performance.now());
    }
    collectSSRPlaceholders() {
        this.ssrPlaceholderHandler.collectExistingPlaceholders();
    }
    constructor(opts = {}){
        this.oldVCObserver = void 0;
        this.newVCObserver = void 0;
        this.ssrPlaceholderHandler = void 0;
        this.newVCObserver = null;
        this.oldVCObserver = null;
        // Initialize SSR placeholder handler once
        this.ssrPlaceholderHandler = new (0, $fb991c433aa54a3e$export$c0102f1a1198d10f)({
            enablePageLayoutPlaceholder: opts.ssrEnablePageLayoutPlaceholder ?? false
        });
        if ((0, $0d141f9c9c05f1cf$export$4babcefc81a3ef0b)('fy25.03') || (0, $0d141f9c9c05f1cf$export$4babcefc81a3ef0b)('next')) this.newVCObserver = new (0, $8f72356c075818ad$export$2e2bcd8739ae039)({
            selectorConfig: opts.selectorConfig,
            isPostInteraction: opts.isPostInteraction,
            SSRConfig: {
                enablePageLayoutPlaceholder: opts.ssrEnablePageLayoutPlaceholder ?? false
            },
            ssrPlaceholderHandler: this.ssrPlaceholderHandler
        });
        if ((0, $0d141f9c9c05f1cf$export$4babcefc81a3ef0b)('fy25.01') || (0, $0d141f9c9c05f1cf$export$4babcefc81a3ef0b)('fy25.02')) this.oldVCObserver = new (0, $18ea8dbf711a6ef1$export$1f70d263701b1d01)({
            ...opts,
            ssrPlaceholderHandler: this.ssrPlaceholderHandler
        });
    }
}
// Some products set this variable to indicate it is running in SSR
let $c64cf67065768157$var$isServer = Boolean(globalThis?.__SERVER__);
// Other products set this other variable to indicate it is running in SSR
let $c64cf67065768157$var$isReactSSR = typeof $1CHRc !== 'undefined' && Boolean($1CHRc?.env?.REACT_SSR || false);
function $c64cf67065768157$export$68d57b133e88584d() {
    // SSR environment aren't supported
    if ($c64cf67065768157$var$isReactSSR || $c64cf67065768157$var$isServer) return false;
    // Legacy browsers that doesn't support WeakRef
    // aren't valid
    if (typeof globalThis?.WeakRef !== 'function') return false;
    if (typeof globalThis?.MutationObserver !== 'function' || typeof globalThis?.IntersectionObserver !== 'function' || typeof globalThis?.PerformanceObserver !== 'function') return false;
    return true;
}
function $c64cf67065768157$export$b3bc47985717b49e(opts = {}) {
    if (!globalThis.__vcObserver) {
        const shouldMockVCObserver = !$c64cf67065768157$export$68d57b133e88584d();
        globalThis.__vcObserver = shouldMockVCObserver ? new (0, $0752e50fe9955142$export$24d07287b49da906)() : new $c64cf67065768157$export$4a1fe1ab3c13bbf5(opts);
    }
    return globalThis.__vcObserver;
}
function $c64cf67065768157$export$c69731bddfc24d85(opts = {}) {
    const shouldMockVCObserver = !$c64cf67065768157$export$68d57b133e88584d();
    const observer = shouldMockVCObserver ? new (0, $0752e50fe9955142$export$24d07287b49da906)() : new $c64cf67065768157$export$4a1fe1ab3c13bbf5(opts);
    return observer;
}


const $91a965b249f4808e$export$cc97b17ef9aeb088 = new Map();





class $58eebd64b2e586fa$export$2e2bcd8739ae039 {
    initializeVCObserver(options) {
        this.vcObserver = new (0, $c64cf67065768157$export$4a1fe1ab3c13bbf5)({
            ...options,
            isPostInteraction: true
        });
    }
    startVCObserver({ startTime: startTime }, interactionId) {
        if (this.eligibleToMeasure(interactionId)) this.vcObserver?.start({
            startTime: startTime
        });
    }
    stopVCObserver() {
        this.vcObserver?.stop();
    }
    // Check if the current interaction is eligible for measurement
    eligibleToMeasure(interactionId) {
        const interaction = (0, $91a965b249f4808e$export$cc97b17ef9aeb088).get(interactionId);
        return interaction?.type === 'page_load' || interaction?.type === 'transition';
    }
    updateFinishedInteraction(interaction) {
        if (interaction?.type === 'page_load' || interaction?.type === 'transition') this.finishedInteraction = interaction;
    }
    setLastInteractionFinishVCResult(result) {
        this.lastInteractionFinishVCResult = result;
    }
    sinkHandler(fn) {
        this.sinkHandlerFn = fn;
    }
    onInteractionComplete(id, data) {
        if (data.ufoName) {
            const updatedData = {
                ...data,
                vcObserver: this.vcObserver ?? undefined
            };
            this.sinkHandlerFn(id, updatedData, this.finishedInteraction, this.lastInteractionFinishVCResult);
        }
        this.stopVCObserver();
        (0, $d9b1f70c159fe18d$export$cd7f480d6b8286c3)(id);
        this.reset();
    }
    reset() {
        this.stopVCObserver();
        if (this.finishedInteraction?.id) (0, $d9b1f70c159fe18d$export$cd7f480d6b8286c3)(this.finishedInteraction.id);
        this.finishedInteraction = null;
        this.lastInteractionFinishVCResult = undefined;
    }
    stopAll(id) {
        (0, $d9b1f70c159fe18d$export$cd7f480d6b8286c3)(id);
        this.reset();
    }
    constructor(){
        // Store the finished interaction (as non-3p interaction)
        this.finishedInteraction = null;
        // independent VC observer, that observes until `custom.post-interaction-logs` event is sent
        this.vcObserver = null;
        // Store the finished interaction's VC result
        this.lastInteractionFinishVCResult = void 0;
        this.sinkHandlerFn = ()=>{};
    }
}



var $cnjKG = parcelRequire("cnjKG");



const $4088fde4f4a7a3fb$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT = 3000;
class $4088fde4f4a7a3fb$export$2e2bcd8739ae039 {
    initializeVCObserver(options) {
        this.vcObserver = new (0, $c64cf67065768157$export$4a1fe1ab3c13bbf5)({
            ...options,
            isPostInteraction: true
        });
    }
    startVCObserver({ startTime: startTime }) {
        this.vcObserver?.start({
            startTime: startTime
        });
    }
    stopVCObserver() {
        this.vcObserver?.stop();
    }
    setVCObserverSSRConfig(vcObserverSSRConfig) {
        this.vcObserverSSRConfig = vcObserverSSRConfig;
    }
    /**
   * Set the VC result as per the last interaction
   * Used to compare diffs of VC updates vs post interaction VC observer
   * @param result - VC result as calculated by UFO create payload
   */ setLastInteractionFinishVCResult(result) {
        this.lastInteractionFinishVCResult = result;
    }
    /**
   * Set the fn that would be invoked to process / send the observation data
   */ sinkHandler(sinkHandlerFn) {
        this.sinkHandlerFn = sinkHandlerFn;
    }
    /**
   * Reset state of the log
   */ reset() {
        this.lastInteractionFinish = null;
        this.reactProfilerTimings = [];
        this.holdInfo = [];
        if (this.sinkTimeoutId != null) {
            clearTimeout(this.sinkTimeoutId);
            this.sinkTimeoutId = null;
        }
        this.setVCObserverSSRConfig(null);
    }
    /**
   * Check if there is data in the log
   */ hasData() {
        return this.reactProfilerTimings?.length > 0;
    }
    /**
   * Send the log if there is data
   */ async sendPostInteractionLog() {
        if (!this.lastInteractionFinish || !this.sinkHandlerFn || !this.hasData() && !(0, $cnjKG.fg)('platform_ufo_always_send_post_interaction_log')) {
            this.reset();
            this.vcObserver?.stop();
            return;
        }
        const pageVisibilityState = (0, $9b310dd053d891ac$export$768b2008623433e1)(this.lastInteractionFinish.start, this.lastInteractionFinish.end);
        const isPageVisible = pageVisibilityState === 'visible';
        const config = (0, $0d141f9c9c05f1cf$export$44487a86467333c3)();
        const postInteractionFinishVCResult = await this.vcObserver?.getVCResult({
            start: this.lastInteractionFinish.start,
            stop: performance.now(),
            tti: -1,
            // no need for TTI value here
            isEventAborted: !!this.lastInteractionFinish.abortReason,
            prefix: 'ufo',
            experienceKey: this.lastInteractionFinish.ufoName,
            interactionId: this.lastInteractionFinish.id,
            includeSSRInV3: config?.vc?.includeSSRInV3,
            includeSSRRatio: config?.vc?.includeSSRRatio,
            ...this.vcObserverSSRConfig,
            interactionType: this.lastInteractionFinish.type,
            isPageVisible: isPageVisible,
            interactionAbortReason: this.lastInteractionFinish.abortReason
        });
        this.vcObserver?.stop();
        this.sinkHandlerFn({
            lastInteractionFinish: this.lastInteractionFinish,
            reactProfilerTimings: this.reactProfilerTimings,
            postInteractionFinishVCResult: postInteractionFinishVCResult,
            lastInteractionFinishVCResult: this.lastInteractionFinishVCResult,
            postInteractionHoldInfo: this.holdInfo
        });
        this.reset();
    }
    /**
   * This fn should be invoked when an interaction has finished
   * Basic details about the finished interaction will be recorded
   * A timeout will be setup to send the post interaction observation after some time.
   */ onInteractionComplete({ ufoName: ufoName, start: start, end: end, id: id, abortReason: abortReason, abortedByInteractionName: abortedByInteractionName, routeName: routeName, type: type, experimentalTTAI: experimentalTTAI, experimentalVC90: experimentalVC90, errors: errors }) {
        this.lastInteractionFinish = {
            ufoName: ufoName,
            start: start,
            end: end,
            id: id,
            abortReason: abortReason,
            abortedByInteractionName: abortedByInteractionName,
            routeName: routeName,
            type: type,
            experimentalTTAI: experimentalTTAI,
            experimentalVC90: experimentalVC90,
            errors: errors
        };
        const timeout = (0, $0d141f9c9c05f1cf$export$44487a86467333c3)()?.timeWindowForLateMutationsInMilliseconds || $4088fde4f4a7a3fb$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT;
        this.sinkTimeoutId = window.setTimeout(async ()=>{
            await this.sendPostInteractionLog();
        }, timeout);
    }
    /**
   * This fn should be invoked when a React render happens after interaction has finished
   */ addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
        if (this.lastInteractionFinish != null) this.reactProfilerTimings.push({
            type: type,
            actualDuration: actualDuration,
            baseDuration: baseDuration,
            startTime: startTime,
            commitTime: commitTime,
            labelStack: labelStack
        });
    }
    addHoldInfo(labelStack, name, start) {
        this.holdInfo.push({
            name: name,
            labelStack: labelStack,
            start: start
        });
    }
    constructor(){
        /**
     * Basic info about interaction that has just finished
     */ this.lastInteractionFinish = null;
        /**
     * Array of observed react render timings
     */ this.reactProfilerTimings = [];
        /**
     * Store the scheduled sink timeout Id so that it can be cancelled when needed
     */ this.sinkTimeoutId = null;
        this.holdInfo = [];
        /**
     * independent VC observer, that observes until `custom.post-interaction-logs` event is sent
     */ this.vcObserver = null;
        this.vcObserverSSRConfig = null;
        this.lastInteractionFinishVCResult = void 0;
        /**
     * Handler function to process / send the observation data
     */ this.sinkHandlerFn = ()=>{};
    }
}


const $d9b1f70c159fe18d$var$PreviousInteractionLog = {
    name: undefined,
    isAborted: undefined
};
const $d9b1f70c159fe18d$export$d8f52e8f804021e8 = new (0, $4088fde4f4a7a3fb$export$2e2bcd8739ae039)();
const $d9b1f70c159fe18d$export$481f88116dc8b7ad = new (0, $58eebd64b2e586fa$export$2e2bcd8739ae039)();
const $d9b1f70c159fe18d$var$interactionQueue = [];
const $d9b1f70c159fe18d$var$segmentCache = new Map();
const $d9b1f70c159fe18d$export$a2b14406ded37d60 = new Map(); // Temporarily store segment unmount counts
const $d9b1f70c159fe18d$var$segmentObservers = [];
function $d9b1f70c159fe18d$export$2b3954d2e8509985() {
    const interactionId = (0, $9a27762368c0f25d$export$37bca3107733ac1e)();
    if (!interactionId.current) return;
    return (0, $91a965b249f4808e$export$cc97b17ef9aeb088).get(interactionId.current);
}
function $d9b1f70c159fe18d$var$isPerformanceTracingEnabled() {
    return (0, $0d141f9c9c05f1cf$export$44487a86467333c3)()?.enableAdditionalPerformanceMarks || window.__REACT_UFO_ENABLE_PERF_TRACING || false;
}
let $d9b1f70c159fe18d$var$performanceEventObserver;
const $d9b1f70c159fe18d$export$17afbba0f16b4b19 = ()=>{
    $d9b1f70c159fe18d$var$performanceEventObserver = $d9b1f70c159fe18d$var$performanceEventObserver || new PerformanceObserver((entries)=>{
        const list = entries.getEntries();
        for (let entry of list)if (entry.name === 'click') $d9b1f70c159fe18d$export$e6be05b411ce21a6(entry);
    });
    return $d9b1f70c159fe18d$var$performanceEventObserver;
};
const $d9b1f70c159fe18d$export$e6be05b411ce21a6 = (entry)=>{
    const interaction = $d9b1f70c159fe18d$export$2b3954d2e8509985();
    if (interaction?.type === 'press') {
        const responsiveness = interaction.responsiveness || {};
        // if happens there is another event interaction that has started after
        // the initial one, we don't want to replace the values if they have already
        // been set up
        responsiveness.experimentalInputToNextPaint = responsiveness.experimentalInputToNextPaint || entry.duration;
        responsiveness.inputDelay = responsiveness.experimentalInputToNextPaint || entry.processingStart - entry.startTime;
        interaction.responsiveness = responsiveness;
        // if the entry start time is lower than the one in the interaction
        // it means the interaction start time is not accurate, we assign
        // this value which will match the timestamp in the event
        if (entry.startTime < interaction.start) interaction.start = entry.startTime;
    }
};
function $d9b1f70c159fe18d$var$labelStackToString(labelStack, name) {
    const stack = [
        ...labelStack ?? []
    ];
    if (name) stack.push({
        name: name
    });
    return stack.map((l)=>l.name)?.join('/');
}
function $d9b1f70c159fe18d$var$labelStackToIdString(labelStack) {
    return labelStack?.map((l)=>'segmentId' in l ? `${l.name}:${l.segmentId}` : `${l.name}`)?.join('/');
}
function $d9b1f70c159fe18d$var$addSegmentObserver(observer) {
    $d9b1f70c159fe18d$var$segmentObservers.push(observer);
    for (const segmentInfo of $d9b1f70c159fe18d$var$segmentCache.values())observer.onAdd(segmentInfo);
}
function $d9b1f70c159fe18d$var$removeSegmentObserver(observer) {
    const index = $d9b1f70c159fe18d$var$segmentObservers.findIndex((obs)=>obs === observer);
    if (index !== -1) $d9b1f70c159fe18d$var$segmentObservers.splice(index, 1);
}
function $d9b1f70c159fe18d$export$cd7f480d6b8286c3(interactionId) {
    (0, $91a965b249f4808e$export$cc97b17ef9aeb088).delete(interactionId);
}
function $d9b1f70c159fe18d$export$f6f1cf5bedf83c71(ufoName, routeName = ufoName) {
    const interaction = $d9b1f70c159fe18d$export$2b3954d2e8509985();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    interaction.ufoName = ufoName;
    interaction.routeName = routeName;
}
function $d9b1f70c159fe18d$export$12f2b6cb85d59904(interactionId, data) {
    const interaction = (0, $91a965b249f4808e$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) Object.keys(data).forEach((key)=>{
        interaction.metaData[key] = data[key];
    });
}
function $d9b1f70c159fe18d$export$e4380431c2bdabee(interactionId, labelStack, data) {
    const interaction = (0, $91a965b249f4808e$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) Object.keys(data).forEach((i)=>{
        interaction.customData.push({
            labelStack: labelStack,
            data: {
                [i]: data[i]
            }
        });
    });
}
function $d9b1f70c159fe18d$export$20265b12c6625451(interactionId, key, value) {
    const interaction = (0, $91a965b249f4808e$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction == null) return;
    // Allow null and undefined values
    if (value === null || value === undefined) {
        interaction.cohortingCustomData.set(key, value);
        return;
    }
    // Validate that the value is a primitive (number, boolean, or string)
    if (typeof value !== 'number' && typeof value !== 'boolean' && typeof value !== 'string') return;
    // Validate string length (max 50 characters)
    if (typeof value === 'string' && value.length > 50) return;
    interaction.cohortingCustomData.set(key, value);
}
function $d9b1f70c159fe18d$export$27cacb7d7f3fe20a(interactionId, labelStack, data) {
    const interaction = (0, $91a965b249f4808e$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        interaction.customTimings.push({
            labelStack: labelStack,
            data: data
        });
        if ($d9b1f70c159fe18d$var$isPerformanceTracingEnabled()) for (const [key, timingData] of Object.entries(data)){
            const { startTime: startTime, endTime: endTime } = timingData;
            try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${$d9b1f70c159fe18d$var$labelStackToString(labelStack, key)} [custom_timing]`, {
                    start: startTime,
                    end: endTime,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'tertiary-light'
                        }
                    }
                });
            } catch (e) {
            // do nothing
            }
        }
    }
}
function $d9b1f70c159fe18d$export$728e28c22a0fba4(interactionId, type, name, labelStack, time = performance.now()) {
    const interaction = (0, $91a965b249f4808e$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) interaction.marks.push({
        type: type,
        name: name,
        labelStack: labelStack,
        time: time
    });
    if ($d9b1f70c159fe18d$var$isPerformanceTracingEnabled()) performance.mark(`\u{1F6F8} ${$d9b1f70c159fe18d$var$labelStackToString(labelStack, name)} [${type}]`, {
        startTime: time
    });
}
function $d9b1f70c159fe18d$export$c4b23cc624bd2fb(type, name, labelStack, time = performance.now()) {
    (0, $91a965b249f4808e$export$cc97b17ef9aeb088).forEach((interaction)=>{
        interaction.marks.push({
            type: type,
            name: name,
            labelStack: labelStack,
            time: time
        });
    });
    if ($d9b1f70c159fe18d$var$isPerformanceTracingEnabled()) performance.mark(`\u{1F6F8} ${$d9b1f70c159fe18d$var$labelStackToString(labelStack, name)} [${type}]`, {
        startTime: time
    });
}
function $d9b1f70c159fe18d$export$2c1d6e17cfa9bbc7(interactionId, type, name, labelStack, start, end = performance.now(), size) {
    const interaction = (0, $91a965b249f4808e$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
        if ($d9b1f70c159fe18d$var$isPerformanceTracingEnabled()) try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${$d9b1f70c159fe18d$var$labelStackToString(labelStack, name)} [${type}]`, {
                start: start,
                end: end,
                detail: {
                    devtools: {
                        track: "\uD83D\uDEF8 reactUFO detailed timings",
                        color: 'secondary'
                    }
                }
            });
        } catch (e) {
        // do nothing
        }
    }
}
function $d9b1f70c159fe18d$export$943a8b2b5d6b1809(type, name, labelStack, start, end = performance.now(), size = 0) {
    (0, $91a965b249f4808e$export$cc97b17ef9aeb088).forEach((interaction)=>{
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
    });
    if ($d9b1f70c159fe18d$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} ${$d9b1f70c159fe18d$var$labelStackToString(labelStack, name)} [${type}]`, {
            start: start,
            end: end,
            detail: {
                devtools: {
                    track: "\uD83D\uDEF8 reactUFO detailed timings",
                    color: 'secondary'
                }
            }
        });
    } catch (e) {
    // do nothing
    }
}
function $d9b1f70c159fe18d$export$9e04fe1a58571ec(moduleId, timestamp) {
    $d9b1f70c159fe18d$export$c4b23cc624bd2fb('bundle_preload', moduleId, null, timestamp);
}
function $d9b1f70c159fe18d$export$6f228d1fdc911d7(identifier, start, end) {
    $d9b1f70c159fe18d$export$943a8b2b5d6b1809('bundle_load', identifier, null, start, end - start);
}
const $d9b1f70c159fe18d$var$moduleLoadingRequests = {};
function $d9b1f70c159fe18d$export$f5a8f10de74904da(input) {
    let result = input ?? '';
    result = result.replace(/^\.\/src\/packages\//, '');
    result = result.replace(/^\.\/node_modules\//, '');
    result = result.replace(/(\/src)?\/(index|main)\.(tsx|ts|js|jsx)$/, '');
    return result;
}
function $d9b1f70c159fe18d$var$addHoldCriterion(id, labelStack, name, startTime) {
    if (!window.__CRITERION__?.addUFOHold) return;
    window.__CRITERION__.addUFOHold(id, $d9b1f70c159fe18d$var$labelStackToString(labelStack), name, startTime);
}
function $d9b1f70c159fe18d$var$removeHoldCriterion(id) {
    if (!window.__CRITERION__?.removeUFOHold) return;
    window.__CRITERION__.removeUFOHold(id);
}
function $d9b1f70c159fe18d$export$7606887303596f82(interactionId, labelStack, name, experimental) {
    const interaction = (0, $91a965b249f4808e$export$cc97b17ef9aeb088).get(interactionId);
    const id = (0, $466a4b1793cac1d8$exports.v4)();
    if (!interaction && (0, $cnjKG.fg)('platform_ufo_enable_late_holds_post_interaction')) // add hold timestamp to post interaction log if interaction is complete
    $d9b1f70c159fe18d$export$d8f52e8f804021e8.addHoldInfo(labelStack, name, performance.now());
    if (interaction != null) {
        const start = performance.now();
        const holdActive = {
            labelStack: labelStack,
            name: name,
            start: start
        };
        if ((0, $cnjKG.fg)('platform_ufo_enable_ttai_with_3p')) {
            const is3pHold = labelStack.some((l)=>'type' in l && l.type === 'third-party');
            if (is3pHold) {
                if (!interaction.hold3pActive) interaction.hold3pActive = new Map();
                interaction.hold3pActive.set(id, {
                    ...holdActive,
                    start: start
                });
            } else {
                interaction.holdActive.set(id, {
                    ...holdActive,
                    start: start
                });
                $d9b1f70c159fe18d$var$addHoldCriterion(id, labelStack, name, start);
            }
        } else {
            if ((0, $0d141f9c9c05f1cf$export$44487a86467333c3)()?.experimentalInteractionMetrics?.enabled && experimental) interaction.holdExpActive.set(id, {
                ...holdActive,
                start: start
            });
            if (!experimental) interaction.holdActive.set(id, {
                ...holdActive,
                start: start
            });
            $d9b1f70c159fe18d$var$addHoldCriterion(id, labelStack, name, start);
        }
        return ()=>{
            const end = performance.now();
            if ($d9b1f70c159fe18d$var$isPerformanceTracingEnabled()) try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${$d9b1f70c159fe18d$var$labelStackToString(labelStack, name)} [hold]`, {
                    start: start,
                    end: end,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'secondary-light'
                        }
                    }
                });
            } catch (e) {
            // do nothing
            }
            $d9b1f70c159fe18d$var$removeHoldCriterion(id);
            const currentInteraction = (0, $91a965b249f4808e$export$cc97b17ef9aeb088).get(interactionId);
            const currentHold = interaction.holdActive.get(id);
            const expHold = interaction.holdExpActive.get(id);
            if (currentInteraction != null) {
                if (currentHold != null) {
                    currentInteraction.holdInfo.push({
                        ...currentHold,
                        end: end
                    });
                    interaction.holdActive.delete(id);
                }
                if (expHold != null) {
                    currentInteraction.holdExpInfo.push({
                        ...expHold,
                        end: end
                    });
                    interaction.holdExpActive.delete(id);
                }
                if ((0, $cnjKG.fg)('platform_ufo_enable_ttai_with_3p')) {
                    if (interaction.hold3pActive) {
                        const current3pHold = interaction.hold3pActive.get(id);
                        if (current3pHold != null) {
                            if (!currentInteraction.hold3pInfo) currentInteraction.hold3pInfo = [];
                            currentInteraction.hold3pInfo.push({
                                ...current3pHold,
                                end: end
                            });
                            interaction.hold3pActive.delete(id);
                        }
                    }
                }
            }
        };
    }
    return ()=>{};
}
function $d9b1f70c159fe18d$export$10582acd678c213(interactionId, labelStack, name, id, ignoreOnSubmit) {
    const interaction = (0, $91a965b249f4808e$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        const start = performance.now();
        if ((0, $cnjKG.fg)('platform_ufo_enable_ttai_with_3p')) {
            const is3pHold = labelStack.some((l)=>'type' in l && l.type === 'third-party');
            if (is3pHold) {
                if (!interaction.hold3pActive) interaction.hold3pActive = new Map();
                interaction.hold3pActive.set(id, {
                    labelStack: labelStack,
                    name: name,
                    start: start,
                    ignoreOnSubmit: ignoreOnSubmit
                });
            } else {
                interaction.holdActive.set(id, {
                    labelStack: labelStack,
                    name: name,
                    start: start,
                    ignoreOnSubmit: ignoreOnSubmit
                });
                $d9b1f70c159fe18d$var$addHoldCriterion(id, labelStack, name, start);
            }
        } else {
            interaction.holdActive.set(id, {
                labelStack: labelStack,
                name: name,
                start: start,
                ignoreOnSubmit: ignoreOnSubmit
            });
            $d9b1f70c159fe18d$var$addHoldCriterion(id, labelStack, name, start);
        }
    }
    return ()=>{};
}
function $d9b1f70c159fe18d$export$4983dfbbb996f7ae(interactionId, id) {
    const interaction = (0, $91a965b249f4808e$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        const end = performance.now();
        const currentInteraction = (0, $91a965b249f4808e$export$cc97b17ef9aeb088).get(interactionId);
        const currentHold = interaction.holdActive.get(id);
        if (currentInteraction != null && currentHold != null) {
            currentInteraction.holdInfo.push({
                ...currentHold,
                end: end
            });
            interaction.holdActive.delete(id);
            $d9b1f70c159fe18d$var$removeHoldCriterion(id);
        }
        if ((0, $cnjKG.fg)('platform_ufo_enable_ttai_with_3p')) {
            if (interaction.hold3pActive) {
                const current3pHold = interaction.hold3pActive.get(id);
                if (currentInteraction != null && current3pHold != null) {
                    if (!currentInteraction.hold3pInfo) currentInteraction.hold3pInfo = [];
                    currentInteraction.hold3pInfo.push({
                        ...current3pHold,
                        end: end
                    });
                    interaction.hold3pActive.delete(id);
                }
            }
        }
    }
}
function $d9b1f70c159fe18d$export$2df109852219d16e(interactionId) {
    const interaction = (0, $91a965b249f4808e$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction) return interaction.type;
    return null;
}
const $d9b1f70c159fe18d$export$9591b52b33ccc510 = {
    onPreload (moduleId, _priority) {
        $d9b1f70c159fe18d$export$9e04fe1a58571ec($d9b1f70c159fe18d$export$f5a8f10de74904da(moduleId), performance.now());
    },
    onLoadStart (info) {
        const timeoutId = setTimeout(()=>{
            delete $d9b1f70c159fe18d$var$moduleLoadingRequests[info.identifier];
        }, 30000);
        const request = {
            start: performance.now(),
            timeoutId: timeoutId
        };
        $d9b1f70c159fe18d$var$moduleLoadingRequests[info.identifier] = request;
    },
    onLoadComplete (info) {
        const request = $d9b1f70c159fe18d$var$moduleLoadingRequests[info.identifier];
        if (request) {
            clearTimeout(request.timeoutId);
            delete $d9b1f70c159fe18d$var$moduleLoadingRequests[info.identifier];
            $d9b1f70c159fe18d$export$6f228d1fdc911d7($d9b1f70c159fe18d$export$f5a8f10de74904da(info.identifier), request.start, performance.now());
        }
    },
    placeholderFallBackMounted (id, moduleId) {
        const interactionId = (0, $9a27762368c0f25d$export$37bca3107733ac1e)();
        const currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $d9b1f70c159fe18d$export$10582acd678c213(currentInteractionId, [], moduleId, id);
    },
    placeholderFallBackUnmounted (id) {
        const interactionId = (0, $9a27762368c0f25d$export$37bca3107733ac1e)();
        const currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $d9b1f70c159fe18d$export$4983dfbbb996f7ae(currentInteractionId, id);
    }
};
function $d9b1f70c159fe18d$export$239c33984d9b1367(interactionId, name, labelStack, errorType, errorMessage, errorStack, forcedError, errorHash, errorStatusCode) {
    const interaction = (0, $91a965b249f4808e$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) interaction.errors.push({
        name: name,
        labelStack: labelStack,
        errorType: errorType,
        errorMessage: errorMessage,
        errorStack: errorStack,
        forcedError: forcedError,
        errorHash: errorHash,
        errorStatusCode: errorStatusCode
    });
}
function $d9b1f70c159fe18d$export$7379c15afd3840fa(name, labelStack, errorType, errorMessage, errorStack, errorHash, errorStatusCode) {
    (0, $91a965b249f4808e$export$cc97b17ef9aeb088).forEach((interaction)=>{
        interaction.errors.push({
            name: name,
            labelStack: labelStack,
            errorType: errorType,
            errorMessage: errorMessage,
            errorStack: errorStack,
            errorHash: errorHash,
            errorStatusCode: errorStatusCode
        });
    });
}
function $d9b1f70c159fe18d$export$53d6f611de951a13(interactionId, labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
    if ($d9b1f70c159fe18d$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} ${$d9b1f70c159fe18d$var$labelStackToString(labelStack)} [react-profiler] ${type}`, {
            start: startTime,
            duration: actualDuration,
            detail: {
                devtools: {
                    track: "\uD83D\uDEF8 reactUFO detailed timings",
                    color: 'secondary-dark'
                }
            }
        });
    } catch (e) {
    // do nothing
    }
    const interaction = (0, $91a965b249f4808e$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) interaction.reactProfilerTimings.push({
        labelStack: labelStack,
        type: type,
        actualDuration: actualDuration,
        baseDuration: baseDuration,
        startTime: startTime,
        commitTime: commitTime
    });
    else if ((0, $0d141f9c9c05f1cf$export$44487a86467333c3)()?.postInteractionLog?.enabled) $d9b1f70c159fe18d$export$d8f52e8f804021e8.addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime);
}
function $d9b1f70c159fe18d$var$pushToQueue(id, data) {
    $d9b1f70c159fe18d$var$interactionQueue.push({
        id: id,
        data: data
    });
}
let $d9b1f70c159fe18d$var$handleInteraction = $d9b1f70c159fe18d$var$pushToQueue;
function $d9b1f70c159fe18d$var$callCleanUpCallbacks(interaction) {
    interaction.cleanupCallbacks.reverse().forEach((cleanUpCallback)=>{
        cleanUpCallback();
    });
}
function $d9b1f70c159fe18d$var$finishInteraction(id, data, endTime = performance.now()) {
    data.end = endTime;
    try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} [${data.type}] ${data.ufoName} [ttai]`, {
            start: data.start,
            end: data.end,
            detail: {
                devtools: {
                    track: 'main metrics',
                    trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                    color: 'tertiary'
                }
            }
        });
        performance.mark(`TTAI`, {
            startTime: data.end,
            detail: {
                devtools: {
                    dataType: 'marker'
                }
            }
        });
    } catch (e) {
    // do nothing
    }
    if (data.featureFlags) data.featureFlags.during = Object.fromEntries((0, $bad1dfcb36c5adde$export$2a5c8df26bb89760));
    (0, $aae51952f0016112$export$17ab21d7be720b)();
    $d9b1f70c159fe18d$var$callCleanUpCallbacks(data);
    if ((0, $0d141f9c9c05f1cf$export$44487a86467333c3)()?.vc?.stopVCAtInteractionFinish) {
        // Use per-interaction VC observer if available, otherwise fall back to global
        const observer = data.vcObserver;
        if (observer) data.vc = observer.getVCRawData();
    }
    if (data.type === 'page_load') data.hydration = (0, $0d141f9c9c05f1cf$export$2d8f8d64dc343d7b)();
    // By this time, stop the post interaction log observer if coinflip rate is 0
    const sanitisedUfoName = (0, $558d2462b9279893$export$e08487ea3ae92adb)(data.ufoName);
    if (!(0, $4659fee6fbb6d2af$export$2e2bcd8739ae039)((0, $0d141f9c9c05f1cf$export$1d459f020c06ae34)(sanitisedUfoName, data.type))) $d9b1f70c159fe18d$export$d8f52e8f804021e8.stopVCObserver();
    if ((0, $cnjKG.fg)('platform_ufo_enable_ttai_with_3p')) {
        const sanitisedUfoName = (0, $558d2462b9279893$export$e08487ea3ae92adb)(data.ufoName);
        if (!(0, $4659fee6fbb6d2af$export$2e2bcd8739ae039)((0, $0d141f9c9c05f1cf$export$203bd06a99c66a0d)(sanitisedUfoName, data.type))) $d9b1f70c159fe18d$export$481f88116dc8b7ad.stopAll(id);
        else if (!data.hold3pActive || data.hold3pActive.size === 0) {
            if (!(0, $0d141f9c9c05f1cf$export$44487a86467333c3)()?.experimentalInteractionMetrics?.enabled) $d9b1f70c159fe18d$export$cd7f480d6b8286c3(id);
        }
    } else if (!(0, $0d141f9c9c05f1cf$export$44487a86467333c3)()?.experimentalInteractionMetrics?.enabled) $d9b1f70c159fe18d$export$cd7f480d6b8286c3(id);
    $d9b1f70c159fe18d$var$PreviousInteractionLog.name = data.ufoName || 'unknown';
    $d9b1f70c159fe18d$var$PreviousInteractionLog.isAborted = data.abortReason != null;
    if (data.ufoName) {
        if ((0, $cnjKG.fg)('platform_ufo_enable_ttai_with_3p')) {
            if ($d9b1f70c159fe18d$export$481f88116dc8b7ad.finishedInteraction?.id !== id) // If this same interaction was not already handled, handle it
            $d9b1f70c159fe18d$var$handleInteraction(id, data);
        } else $d9b1f70c159fe18d$var$handleInteraction(id, data);
    }
    if ($d9b1f70c159fe18d$var$isPerformanceTracingEnabled()) {
        const profilerTimingMap = new Map();
        data.reactProfilerTimings.forEach((profilerTiming)=>{
            const labelStackId = $d9b1f70c159fe18d$var$labelStackToIdString(profilerTiming.labelStack);
            if (labelStackId) {
                const timing = profilerTimingMap.get(labelStackId) ?? {
                    labelStack: profilerTiming.labelStack
                };
                timing.start = profilerTiming.startTime < (timing.start ?? Number.MAX_SAFE_INTEGER) ? profilerTiming.startTime : timing.start;
                timing.end = profilerTiming.commitTime > (timing.end ?? Number.MIN_SAFE_INTEGER) ? profilerTiming.commitTime : timing.end;
                profilerTimingMap.set(labelStackId, timing);
            }
        });
        try {
            // for Firefox 102 and older
            for (const [, { labelStack: labelStack, start: start, end: end }] of profilerTimingMap.entries())performance.measure(`\u{1F6F8} ${$d9b1f70c159fe18d$var$labelStackToString(labelStack)} [segment_ttai]`, {
                start: start,
                end: end,
                detail: {
                    devtools: {
                        track: "\uD83D\uDEF8 reactUFO detailed timings",
                        color: 'secondary-dark'
                    }
                }
            });
        } catch (e) {
        // do nothing
        }
    }
    try {
        // dispatch a global window event to notify the measure is completed
        window.dispatchEvent(new CustomEvent('UFO_FINISH_INTERACTION', {
            detail: data
        }));
    } catch (error) {
    // do nothing
    }
}
function $d9b1f70c159fe18d$export$9e614a29a1ac213e(sinkFn) {
    if ($d9b1f70c159fe18d$var$handleInteraction === $d9b1f70c159fe18d$var$pushToQueue) {
        $d9b1f70c159fe18d$var$handleInteraction = sinkFn;
        $d9b1f70c159fe18d$var$interactionQueue.forEach((interaction)=>{
            sinkFn(interaction.id, interaction.data);
        });
        $d9b1f70c159fe18d$var$interactionQueue.length = 0;
    }
}
function $d9b1f70c159fe18d$export$8a1ba7bef607358a(sinkFn) {
    $d9b1f70c159fe18d$export$d8f52e8f804021e8.sinkHandler(sinkFn);
}
// a flag to prevent multiple submitting
let $d9b1f70c159fe18d$var$activeSubmitted = false;
function $d9b1f70c159fe18d$export$673be905888f8839(interactionId, endTime) {
    const interaction = (0, $91a965b249f4808e$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const noMoreExpHolds = interaction.holdExpActive.size === 0;
        const postInteraction = async ()=>{
            if ((0, $0d141f9c9c05f1cf$export$44487a86467333c3)()?.postInteractionLog?.enabled) {
                let experimentalVC90;
                let experimentalTTAI;
                if ((0, $0d141f9c9c05f1cf$export$44487a86467333c3)()?.experimentalInteractionMetrics?.enabled) {
                    experimentalVC90 = (await (0, $7f7abea31cb0de11$export$d17d2b5c5e8d732e)(interaction))?.['metric:experimental:vc90'];
                    const { start: start, end: end } = interaction;
                    experimentalTTAI = !interaction.abortReason ? Math.round(end - start) : undefined;
                }
                $d9b1f70c159fe18d$export$d8f52e8f804021e8.onInteractionComplete({
                    ...interaction,
                    experimentalTTAI: experimentalTTAI,
                    experimentalVC90: experimentalVC90
                });
            }
            if ((0, $cnjKG.fg)('platform_ufo_enable_ttai_with_3p')) {
                if ($d9b1f70c159fe18d$export$481f88116dc8b7ad.finishedInteraction?.id !== interactionId) // If interactionExtraMetrics is not waiting for measuring this interaction
                {
                    if ((0, $0d141f9c9c05f1cf$export$44487a86467333c3)()?.experimentalInteractionMetrics?.enabled) $d9b1f70c159fe18d$export$cd7f480d6b8286c3(interactionId);
                }
            } else if ((0, $0d141f9c9c05f1cf$export$44487a86467333c3)()?.experimentalInteractionMetrics?.enabled) $d9b1f70c159fe18d$export$cd7f480d6b8286c3(interactionId);
            $d9b1f70c159fe18d$var$activeSubmitted = false;
        };
        if ((0, $cnjKG.fg)('platform_ufo_enable_ttai_with_3p')) {
            const noMoreActive3pHolds = interaction.hold3pActive?.size === 0 || interaction.hold3pActive === undefined;
            if (noMoreActiveHolds && $d9b1f70c159fe18d$export$481f88116dc8b7ad.finishedInteraction?.id !== interactionId) {
                // If it's not waiting for extra metrics to complete, finish the interaction as normal
                if (!$d9b1f70c159fe18d$var$activeSubmitted) {
                    $d9b1f70c159fe18d$var$finishInteraction(interactionId, interaction, endTime);
                    if ((0, $0d141f9c9c05f1cf$export$44487a86467333c3)()?.extraInteractionMetrics?.enabled) $d9b1f70c159fe18d$export$481f88116dc8b7ad.updateFinishedInteraction(interaction);
                    if ((0, $0d141f9c9c05f1cf$export$44487a86467333c3)()?.extraSearchPageInteraction?.enabled && interaction.ufoName === (0, $0d141f9c9c05f1cf$export$44487a86467333c3)()?.extraSearchPageInteraction?.searchPageMetricName) (0, $7e9e3b3390858f11$export$74b9ce7e9d206a8)(interactionId, interaction);
                    $d9b1f70c159fe18d$var$activeSubmitted = true;
                }
                if (noMoreExpHolds) {
                    if ((0, $0d141f9c9c05f1cf$export$44487a86467333c3)()?.experimentalInteractionMetrics?.enabled) (0, $7f7abea31cb0de11$export$1aed449484dedf63)(interactionId, interaction, endTime);
                    postInteraction();
                }
            }
            if (noMoreActiveHolds && noMoreActive3pHolds) {
                const data = {
                    ...interaction,
                    end: endTime
                };
                $d9b1f70c159fe18d$export$481f88116dc8b7ad.onInteractionComplete(interactionId, data);
            }
        } else if (noMoreActiveHolds) {
            if (!$d9b1f70c159fe18d$var$activeSubmitted) {
                $d9b1f70c159fe18d$var$finishInteraction(interactionId, interaction, endTime);
                if ((0, $0d141f9c9c05f1cf$export$44487a86467333c3)()?.extraSearchPageInteraction?.enabled && interaction.ufoName === (0, $0d141f9c9c05f1cf$export$44487a86467333c3)()?.extraSearchPageInteraction?.searchPageMetricName) (0, $7e9e3b3390858f11$export$74b9ce7e9d206a8)(interactionId, interaction);
                $d9b1f70c159fe18d$var$activeSubmitted = true;
            }
            if (noMoreExpHolds) {
                if ((0, $0d141f9c9c05f1cf$export$44487a86467333c3)()?.experimentalInteractionMetrics?.enabled) (0, $7f7abea31cb0de11$export$1aed449484dedf63)(interactionId, interaction, endTime);
                postInteraction();
            }
        }
    }
}
function $d9b1f70c159fe18d$var$callCancelCallbacks(interaction) {
    interaction.cancelCallbacks.reverse().forEach((cancelCallback)=>{
        cancelCallback();
    });
}
function $d9b1f70c159fe18d$export$5def58af4fd46132(interactionId, abortReason) {
    const interaction = (0, $91a965b249f4808e$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        $d9b1f70c159fe18d$var$callCancelCallbacks(interaction);
        interaction.abortReason = abortReason;
        $d9b1f70c159fe18d$var$finishInteraction(interactionId, interaction);
        $d9b1f70c159fe18d$export$d8f52e8f804021e8.reset();
        $d9b1f70c159fe18d$export$d8f52e8f804021e8.stopVCObserver();
        if ((0, $cnjKG.fg)('platform_ufo_enable_ttai_with_3p')) $d9b1f70c159fe18d$export$481f88116dc8b7ad.stopAll(interactionId);
        if ((0, $4659fee6fbb6d2af$export$2e2bcd8739ae039)((0, $0d141f9c9c05f1cf$export$563f73272328c0d)(interaction.ufoName, interaction.type))) {
            (0, $7f7abea31cb0de11$export$1aed449484dedf63)(interactionId, interaction);
            $d9b1f70c159fe18d$export$cd7f480d6b8286c3(interactionId);
        }
    }
}
function $d9b1f70c159fe18d$export$c4a545284f55edf2(interactionId, interactionName) {
    const interaction = (0, $91a965b249f4808e$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        $d9b1f70c159fe18d$var$callCancelCallbacks(interaction);
        interaction.abortReason = 'new_interaction';
        interaction.abortedByInteractionName = interactionName;
        $d9b1f70c159fe18d$var$finishInteraction(interactionId, interaction);
        $d9b1f70c159fe18d$export$d8f52e8f804021e8.reset();
        $d9b1f70c159fe18d$export$d8f52e8f804021e8.stopVCObserver();
        if ((0, $cnjKG.fg)('platform_ufo_enable_ttai_with_3p')) $d9b1f70c159fe18d$export$481f88116dc8b7ad.stopAll(interactionId);
        if ((0, $4659fee6fbb6d2af$export$2e2bcd8739ae039)((0, $0d141f9c9c05f1cf$export$563f73272328c0d)(interaction.ufoName, interaction.type))) {
            (0, $7f7abea31cb0de11$export$1aed449484dedf63)(interactionId, interaction);
            $d9b1f70c159fe18d$export$cd7f480d6b8286c3(interactionId);
        }
    }
}
function $d9b1f70c159fe18d$export$614a7af2affc5dff(abortReason, abortedByInteractionName) {
    const activeInteraction = $d9b1f70c159fe18d$export$2b3954d2e8509985();
    const finishInteractions = (0, $0d141f9c9c05f1cf$export$20e8108b8ccdd0bd)();
    (0, $91a965b249f4808e$export$cc97b17ef9aeb088).forEach((interaction, interactionId)=>{
        const isActiveInteraction = activeInteraction === interaction;
        let hasFinished = interaction.holdActive.size === 0;
        if (isActiveInteraction && abortReason === 'transition' && interaction.type === 'press' && finishInteractions?.includes(interaction.ufoName) && (0, $cnjKG.fg)('platform_ufo_enable_finish_interaction_transition')) hasFinished = true;
        if (!hasFinished) {
            $d9b1f70c159fe18d$var$callCancelCallbacks(interaction);
            interaction.abortReason = abortReason;
            if (abortedByInteractionName != null) interaction.abortedByInteractionName = abortedByInteractionName;
        }
        $d9b1f70c159fe18d$var$finishInteraction(interactionId, interaction);
        $d9b1f70c159fe18d$export$d8f52e8f804021e8.reset();
        $d9b1f70c159fe18d$export$d8f52e8f804021e8.stopVCObserver();
        if ((0, $cnjKG.fg)('platform_ufo_enable_ttai_with_3p')) $d9b1f70c159fe18d$export$481f88116dc8b7ad.stopAll(interactionId);
        if ((0, $4659fee6fbb6d2af$export$2e2bcd8739ae039)((0, $0d141f9c9c05f1cf$export$563f73272328c0d)(interaction.ufoName, interaction.type))) {
            (0, $7f7abea31cb0de11$export$1aed449484dedf63)(interactionId, interaction);
            $d9b1f70c159fe18d$export$cd7f480d6b8286c3(interactionId);
        }
    });
}
function $d9b1f70c159fe18d$export$7b9261a96cfe427b(id, cancelCallback) {
    const interaction = (0, $91a965b249f4808e$export$cc97b17ef9aeb088).get(id);
    interaction?.cancelCallbacks.push(cancelCallback);
}
function $d9b1f70c159fe18d$export$1a1ed1e1fdb2006b(interactionId, ufoName, type, startTime, rate, labelStack, routeName, trace = null) {
    $d9b1f70c159fe18d$export$481f88116dc8b7ad.reset();
    $d9b1f70c159fe18d$export$d8f52e8f804021e8.reset();
    let vcObserver;
    let previousTime = startTime;
    let timeoutTime = (0, $0d141f9c9c05f1cf$export$c681731847989445)(ufoName);
    const timerID = setTimeout(()=>{
        $d9b1f70c159fe18d$export$5def58af4fd46132(interactionId, 'timeout');
    }, timeoutTime);
    function changeTimeout(newTime) {
        // we compare if the time left is lower than the new time to no
        // extend the timeout beyond the initial waiting time
        const currentTime = performance.now();
        const timeLeft = timeoutTime - (currentTime - previousTime);
        if (timeLeft < newTime) return;
        clearTimeout(this.timerID);
        const newTimerID = setTimeout(()=>{
            $d9b1f70c159fe18d$export$5def58af4fd46132(interactionId, 'timeout');
        }, newTime);
        timeoutTime = newTime;
        previousTime = currentTime;
        this.timerID = newTimerID;
    }
    const addFeatureFlagsToInteraction = (0, $4659fee6fbb6d2af$export$2e2bcd8739ae039)((0, $0d141f9c9c05f1cf$export$29b9ffb14861a1d)('feature_flag_access'));
    const config = (0, $0d141f9c9c05f1cf$export$44487a86467333c3)();
    if (config && config.vc) {
        const vcOptions = {
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            selectorConfig: config.vc.selectorConfig,
            ssrEnablePageLayoutPlaceholder: config.vc.ssrEnablePageLayoutPlaceholder
        };
        vcObserver = (0, $c64cf67065768157$export$c69731bddfc24d85)(vcOptions);
    }
    const priorAccessedFg = type === 'press' && (0, $cnjKG.fg)('platform_ufo_drop_prior_fg_interactions') ? {} : Object.fromEntries((0, $bad1dfcb36c5adde$export$5b78c989c8db2561));
    const metrics = {
        id: interactionId,
        start: startTime,
        end: 0,
        ufoName: ufoName,
        type: type,
        previousInteractionName: $d9b1f70c159fe18d$var$PreviousInteractionLog.name,
        isPreviousInteractionAborted: $d9b1f70c159fe18d$var$PreviousInteractionLog.isAborted === true,
        marks: [],
        customData: [],
        cohortingCustomData: new Map(),
        customTimings: [],
        spans: [],
        requestInfo: [],
        reactProfilerTimings: [],
        holdInfo: [],
        holdExpInfo: [],
        holdActive: new Map(),
        holdExpActive: new Map(),
        // measure when we execute this code
        // from this, we can measure the input delay -
        // how long the browser took to hand execution back to JS)
        measureStart: performance.now(),
        rate: rate,
        cancelCallbacks: [],
        metaData: {},
        errors: [],
        apdex: [],
        labelStack: labelStack,
        routeName: routeName ?? ufoName,
        featureFlags: addFeatureFlagsToInteraction ? {
            prior: priorAccessedFg,
            during: {}
        } : undefined,
        knownSegments: [],
        cleanupCallbacks: [],
        awaitReactProfilerCount: 0,
        redirects: [],
        timerID: timerID,
        changeTimeout: changeTimeout,
        trace: trace,
        vcObserver: vcObserver,
        hold3pActive: new Map(),
        hold3pInfo: [],
        minorInteractions: []
    };
    if (addFeatureFlagsToInteraction) (0, $bad1dfcb36c5adde$export$2a5c8df26bb89760).clear();
    (0, $91a965b249f4808e$export$cc97b17ef9aeb088).set(interactionId, metrics);
    const segmentObserver = {
        onAdd (segment) {
            metrics.knownSegments.push(segment);
        },
        onRemove () {}
    };
    $d9b1f70c159fe18d$var$addSegmentObserver(segmentObserver);
    metrics.cleanupCallbacks.push(()=>{
        $d9b1f70c159fe18d$var$removeSegmentObserver(segmentObserver);
    });
    metrics.cleanupCallbacks.push(()=>{
        clearTimeout(metrics.timerID);
    });
    // Add cleanup for per-interaction VC observer
    if (vcObserver) metrics.cleanupCallbacks.push(()=>{
        vcObserver.stop(ufoName);
    });
    const awaitBM3TTIList = (0, $0d141f9c9c05f1cf$export$2d311b3fd18dcab1)();
    if (awaitBM3TTIList.includes(ufoName)) $d9b1f70c159fe18d$export$10582acd678c213(interactionId, [], ufoName, ufoName, true);
    if (type === 'transition' || type === 'page_load') {
        // Use per-interaction VC observer if available, otherwise fall back to global
        const observer = vcObserver;
        if (observer) observer.start({
            startTime: startTime,
            experienceKey: ufoName
        });
        // Start post interaction observer for all if config is enabled
        // in case ufoName is updated at later time
        if ((0, $0d141f9c9c05f1cf$export$44487a86467333c3)()?.postInteractionLog?.enabled) $d9b1f70c159fe18d$export$d8f52e8f804021e8.startVCObserver({
            startTime: startTime
        });
        if ((0, $4659fee6fbb6d2af$export$2e2bcd8739ae039)((0, $0d141f9c9c05f1cf$export$563f73272328c0d)(ufoName, type))) (0, $7f7abea31cb0de11$export$81b28dca2587ec47).start({
            startTime: startTime
        });
        if (config?.extraInteractionMetrics?.enabled && (0, $cnjKG.fg)('platform_ufo_enable_ttai_with_3p')) $d9b1f70c159fe18d$export$481f88116dc8b7ad.startVCObserver({
            startTime: startTime
        }, interactionId);
    }
    if (type === 'press') {
        // Use per-interaction VC observer if available, otherwise fall back to global
        const observer = vcObserver;
        if (observer) observer.start({
            startTime: startTime,
            experienceKey: ufoName
        });
    }
}
function $d9b1f70c159fe18d$export$4a759336b50e86e3(event) {
    const interaction = $d9b1f70c159fe18d$export$2b3954d2e8509985();
    if (interaction) {
        interaction.legacyMetrics = interaction.legacyMetrics || [];
        interaction.legacyMetrics.push(event);
        if ((interaction.type === 'page_load' || interaction.type === 'transition') && event.config?.type === 'PAGE_LOAD') $d9b1f70c159fe18d$export$4983dfbbb996f7ae(interaction.id, interaction.ufoName);
    }
}
function $d9b1f70c159fe18d$export$ad216cc25852d44b(apdex) {
    (0, $91a965b249f4808e$export$cc97b17ef9aeb088).forEach((interaction, key)=>{
        interaction.apdex.push(apdex);
        try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${apdex.key} [bm3_tti]`, {
                start: apdex.startTime ?? interaction.start,
                end: apdex.stopTime,
                detail: {
                    devtools: {
                        track: 'main metrics',
                        trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                        color: 'primary-dark'
                    }
                }
            });
            performance.mark(`[bm3] TTI`, {
                startTime: apdex.stopTime,
                detail: {
                    devtools: {
                        dataType: 'marker'
                    }
                }
            });
        } catch (e) {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') $d9b1f70c159fe18d$export$4983dfbbb996f7ae(key, interaction.ufoName);
    });
}
function $d9b1f70c159fe18d$export$35220fd6cdd1b731(interactionId, apdexInfo) {
    const interaction = (0, $91a965b249f4808e$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        interaction.apdex.push(apdexInfo);
        try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${apdexInfo.key} [bm3_tti]`, {
                start: apdexInfo.startTime ?? interaction.start,
                end: apdexInfo.stopTime,
                detail: {
                    devtools: {
                        track: 'main metrics',
                        trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                        color: 'primary-dark'
                    }
                }
            });
            performance.mark(`[bm3] TTI`, {
                startTime: apdexInfo.stopTime,
                detail: {
                    devtools: {
                        dataType: 'marker'
                    }
                }
            });
        } catch (e) {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') $d9b1f70c159fe18d$export$4983dfbbb996f7ae(interactionId, interaction.ufoName);
    }
}
function $d9b1f70c159fe18d$export$57d55b4569823d8f(interactionId, labelStack, requestInfo) {
    const interaction = (0, $91a965b249f4808e$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) interaction.requestInfo.push({
        labelStack: labelStack,
        ...requestInfo
    });
}
function $d9b1f70c159fe18d$var$isSegmentLabel(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}
function $d9b1f70c159fe18d$var$getSegmentCacheKey(labelStack) {
    return labelStack.map((l)=>{
        if ($d9b1f70c159fe18d$var$isSegmentLabel(l)) return `${l.name}_${l.segmentId}`;
        return l.name;
    }).join('|');
}
function $d9b1f70c159fe18d$export$1c43f9ac826b6462(labelStack) {
    const key = $d9b1f70c159fe18d$var$getSegmentCacheKey(labelStack);
    const existingSegment = $d9b1f70c159fe18d$var$segmentCache.get(key);
    if (!existingSegment) {
        const segmentInfo = {
            labelStack: labelStack
        };
        $d9b1f70c159fe18d$var$segmentCache.set(key, segmentInfo);
        $d9b1f70c159fe18d$var$segmentObservers.forEach((observer)=>{
            observer.onAdd(segmentInfo);
        });
    }
}
function $d9b1f70c159fe18d$export$d0365e48b58231c3(labelStack) {
    const key = $d9b1f70c159fe18d$var$getSegmentCacheKey(labelStack);
    const segmentInfo = $d9b1f70c159fe18d$var$segmentCache.get(key);
    if (segmentInfo) {
        $d9b1f70c159fe18d$var$segmentCache.delete(JSON.stringify(labelStack));
        if ((0, $cnjKG.fg)('platform_ufo_segment_unmount_count')) {
            const cacheKey = (0, $558d2462b9279893$export$caeee352b541de1f)(labelStack);
            $d9b1f70c159fe18d$export$a2b14406ded37d60.set(cacheKey, ($d9b1f70c159fe18d$export$a2b14406ded37d60.get(cacheKey) || 0) + 1);
        }
        $d9b1f70c159fe18d$var$segmentObservers.forEach((observer)=>{
            observer.onRemove(segmentInfo);
        });
    }
}
function $d9b1f70c159fe18d$export$bbf14d79614d9818(interactionId, fromUfoName, nextUfoName, nextRouteName, time) {
    const interaction = (0, $91a965b249f4808e$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        interaction.ufoName = nextUfoName;
        interaction.routeName = nextRouteName;
        interaction.redirects.push({
            fromInteractionName: fromUfoName,
            time: time
        });
        if ($d9b1f70c159fe18d$var$isPerformanceTracingEnabled()) {
            const prevRedirect = interaction.redirects.at(-2);
            try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${nextUfoName} [redirect]`, {
                    start: prevRedirect?.time ?? interaction.start,
                    end: time,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'tertiary'
                        }
                    }
                });
            } catch (e) {
            // do nothing
            }
        }
    }
}
const $d9b1f70c159fe18d$export$6ce04c7ca6810a7e = [];
const $d9b1f70c159fe18d$var$defaultLabelStack = [
    {
        name: 'custom'
    }
];
function $d9b1f70c159fe18d$export$5342dcad19138a1c(name, start, end = performance.now(), size = 0, labelStack = $d9b1f70c159fe18d$var$defaultLabelStack) {
    const customSpan = {
        type: 'custom',
        name: name,
        start: start,
        end: end,
        labelStack: labelStack,
        size: size
    };
    $d9b1f70c159fe18d$export$6ce04c7ca6810a7e.push(customSpan);
}









var $34Zxt = parcelRequire("34Zxt");




const $bafd16c1172e5624$var$cloudFrontRegex = /(https?):\/\/[a-z0-9]+\.cloudfront\.net\//g;
const $bafd16c1172e5624$var$cloudFrontS3Regex = /(https?):\/\/[a-z0-9]+\.cloudfront\.net\/download\//g;
// Used to match web resource URLs like this:
//   .../wiki/s/99914b932bd37a50b983c5e7c90ae93b-CDN/-1510873586/6452/236c4aa50522e3b557db968ff45d01d44604ffe1/1000.0.53/_/download/...
//   .../wiki/s/d41d8cd98f00b204e9800998ecf8427e-CDN/-783152381/h/2ddebfb80ae902fe7ab6e15441fe94e2/_/download/batch/...
//   .../wiki/s/d065fee603fdcf75115204ec65310e1c-CDN/-1510873586/6452/236c4aa50522e3b557db968ff45d01d44604ffe1/11d5083bb8bb9dac4c3a5987eeac4b5b/_/download/contextbatch/...
//   .../wiki/s/1283600969/6452/571d5459a4fbf60c255c41bb4e0d3ef3b8022627/_/download/resources/...
const $bafd16c1172e5624$var$wrmResourceRegex = /s\/[^_]+_\/download\//g;
/**
 * For values which represent a stringified JSON, tries to extract the `"message"`
 * property and returns it if found. Returned result defaults to input value.
 */ function $bafd16c1172e5624$var$tryExtractMessage(value) {
    try {
        const parsedValue = JSON.parse(value);
        return parsedValue.message || value;
    } catch (_) {
        return value;
    }
}
// Turns the culprit URL into .../wiki/download/... to remove the hash information.
function $bafd16c1172e5624$var$stripHashAndCDNHost(url) {
    return url.match($bafd16c1172e5624$var$wrmResourceRegex) ? url.replace($bafd16c1172e5624$var$wrmResourceRegex, 'download/').replace($bafd16c1172e5624$var$cloudFrontRegex, '$1://') : url;
}
function $bafd16c1172e5624$var$getErrorFingerprint(error) {
    // See docs at https://docs.sentry.io/platforms/javascript/data-management/event-grouping/sdk-fingerprinting/
    const DEFAULT_FINGERPRINT = '{{ default }}';
    if (error.message.startsWith('Quota exceeded on key') || error.message.startsWith('QuotaExceededError')) return [
        'storage-quota-error'
    ];
    if (error.message.startsWith('Maximum call stack size exceeded') || error.message.startsWith('too much recursion')) // Most (if not all) of these errors originate from editor/prosemirror, and they
    // are hard to troubleshoot. So, although they all might represent a
    // different error, we're bundling them together
    return [
        'maximum-call-stack'
    ];
    if (error.message.startsWith('Invalid position')) // These errors originate from editor/prosemirror. The rest of the message
    // is the position number itself, and Sentry seldom groups those together.
    // By giving them all the same fingerprint, we're forcing Sentry to treat all
    // of those as the occurrence of one and the same error.
    return [
        'invalid-position'
    ];
    if (error.message.match(/Loading chunk .+? failed/)) // These are webpack chunk load errors, which often have very different stack traces.
    // We're grouping them together.
    return [
        'chunk-load-error'
    ];
    if (error.message.startsWith('Error creating blueprint content:')) // Grouping those by message should work better than looking at the stack trace
    return [
        'blueprint-creation-error',
        error.message.substr(0, 100)
    ];
    if (error.message.startsWith('Error from synchrony plugin')) // These are hard to troubleshoot, so to reduce noise we group them together
    return [
        'error-from-synchrony-plugin'
    ];
    if (error.message.includes('Error fetching data from identity - Error has been logged with execution ID:')) // The "execution ID" part in these errors is always different.
    return [
        'identity-fetching-error'
    ];
    if (error.message.includes('java.net.SocketTimeoutException')) return [
        'socket-timeout'
    ];
    if (error instanceof URIError) // This will group all URI errors together, as they often have different stack traces
    return [
        'malformed-uri-error'
    ];
    if (error instanceof (0, $b1c79be305194522$export$e704fce35c66bf42) && error.route) // These errors tend to produce unpredictable messages which are hard to group.
    // So, instead of grouping by message, we'll group them by `route` and status code (which should be more predictable)
    return [
        `rest-api-${error.route}-${error.statusCode}`
    ];
    const logSafeAttributes = (0, $8a3a8685062675cc$export$d08bac32cb78075f)(error);
    if (logSafeAttributes.failedSlaExperience) {
        if (logSafeAttributes.operationName || logSafeAttributes.statusCode) // This code branch is for GraphQL/REST failures which result in experience failures.
        // Since the same backend errors can be thrown for different operations/endpoints,
        // we're applying a per-message grouping.
        // Also, we're **not** including default fingerprint here.
        return [
            `experience-${logSafeAttributes.failedSlaExperience}`,
            $bafd16c1172e5624$var$tryExtractMessage(error.message).substr(0, 100)
        ];
        else // this way SLA-affecting errors shouldn't be bundled with other types of errors
        return [
            DEFAULT_FINGERPRINT,
            `experience-${logSafeAttributes.failedSlaExperience}`
        ];
    }
    return undefined;
}
const $bafd16c1172e5624$var$dataTransformer = function(data, hint) {
    let fromWRM = false;
    let fromS3 = false;
    if (data.exception?.values) // Go through the stack trace and sanitize all the exception URLs.
    data.exception.values = data.exception.values.map((exception)=>{
        if (exception.stacktrace && exception.stacktrace.frames) exception.stacktrace.frames = exception.stacktrace.frames.map((frame)=>{
            if (frame.filename) {
                fromWRM = Boolean(frame.filename.match($bafd16c1172e5624$var$wrmResourceRegex));
                fromS3 = Boolean(frame.filename.match($bafd16c1172e5624$var$cloudFrontS3Regex));
                frame.filename = $bafd16c1172e5624$var$stripHashAndCDNHost(frame.filename);
            }
            return frame;
        });
        return exception;
    });
    if (typeof hint?.originalException === 'object' && hint?.originalException !== null) {
        data.fingerprint = $bafd16c1172e5624$var$getErrorFingerprint(hint.originalException);
        const { componentStack: _1, // this field is very big
        failedSlaExperience: _2, // this one is included as tag
        ...rest } = (0, $8a3a8685062675cc$export$d08bac32cb78075f)(hint.originalException);
        data.extra = {
            ...data.extra,
            ...rest
        };
    }
    if (fromWRM) data.logger = 'wrm';
    else if (fromS3) data.logger = 'react';
    else data.logger = 'javascript';
    // strip out url and breadcrumbs which include customer sensitive data
    if (data.request) delete data.request.url;
    delete data.breadcrumbs;
    data.transaction = ''; // transactions can have URLs in them, too
    return data;
};
// Structure: https://<PUBLIC_KEY>@o55978.ingest.sentry.io/<PROJECT_ID>
// See: https://hello.atlassian.net/wiki/spaces/OBSERVABILITY/pages/1436386358/Sentry+Cloud+-+Getting+Started#Setting-up-the-Sentry-SDK-for-your-project
function $bafd16c1172e5624$var$getSentryDsn() {
    // https://sentry.io/settings/atlassian-2y/projects/confluence/keys/
    const SENTRY_DSN_PROD = 'https://1f56d81aaaae4b1ea5ca08bca6633223@o55978.ingest.sentry.io/5988811';
    // https://sentry.io/settings/atlassian-2y/projects/confluence-staging/keys/
    const SENTRY_DSN_STAGING = 'https://ce2ea70bbd2a439793b772cc1d59e2fe@o55978.ingest.sentry.io/5988871';
    return SENTRY_DSN_PROD;
}
function $bafd16c1172e5624$var$getSentryEnvironment() {
    const SENTRY_ENV_PROD = 'CONFLUENCE';
    const SENTRY_ENV_STAGING = 'CONFLUENCE-STAGING';
    const SENTRY_ENV_HELLO = 'HELLO';
    return SENTRY_ENV_PROD;
}
function $bafd16c1172e5624$var$getSentryOptions(dsn) {
    const additionalOptions = {};
    return {
        release: (0, $f3f8c1a227f13835$export$4ea39b9726d98a51)().FRONTEND_VERSION,
        dsn: dsn,
        environment: $bafd16c1172e5624$var$getSentryEnvironment(),
        beforeSend (event, hint) {
            return $bafd16c1172e5624$var$dataTransformer(event, hint);
        },
        ignoreErrors: [
            'Transport destroyed',
            // Error being thrown by media that won't be resolved any time soon.
            'Worker was destroyed',
            // Error being thrown by media that won't be resolved any time soon.
            'Failed to connect on any of the ADC ports',
            // Error being thrown by media that won't be resolved any time soon.
            "Cannot read property 'postMessage' of undefined",
            // Error being thrown by Connect that won't be resolved any time soon.
            "Cannot read property 'postMessage' of null",
            // Error being thrown by Connect that won't be resolved any time soon.
            'd.hide is not a function',
            // From com.atlassian.auiplugin:aui-date-picker,
            /^network error/i,
            // We can't do anything about network issues
            /^network failure/i,
            // We can't do anything about network issues
            'TypeError: Failed to fetch',
            // We can't do anything about network issues
            'ResizeObserver loop limit exceeded',
            // A benign error, see https://stackoverflow.com/a/50387233/2645305
            /ResizeObserver loop completed with undelivered notifications/
        ],
        autoSessionTracking: false,
        ...additionalOptions
    };
}

const $bafd16c1172e5624$export$c2e2a07dfafd1ea2 = (0, $34Zxt.default)(async ()=>{
    // https://sentry.io/settings/atlassian-2y/projects/confluence-sla/keys/
    const SENTRY_DSN_SLA = 'https://2d329ea4a8a04cf0b19117b4675b336f@o55978.ingest.sentry.io/5988900';
    return (0, $cd3135dd152096aa$export$cc373701aed148fc)((parcelRequire("7YhLB")).then(({ BrowserClient: BrowserClient, Hub: Hub })=>{
        const client = new BrowserClient($bafd16c1172e5624$var$getSentryOptions(SENTRY_DSN_SLA));
        return new Hub(client);
    }).catch(()=>{
        // noop, there's nowhere to report this error
        return null;
    }));
});

function $bafd16c1172e5624$export$1f7656c617418e15() {
    (parcelRequire("7YhLB")).then(({ init: init })=>{
        init($bafd16c1172e5624$var$getSentryOptions($bafd16c1172e5624$var$getSentryDsn()));
    }).catch(()=>{
    // noop, there's nowhere to report this error
    });
}


/* eslint-disable no-useless-constructor */ class $bf7ff670cf416156$export$704b12ddc1dacdd2 {
    add(item) {
        this.scheduleFlush();
        this.currentBatch.push(item);
        if (this.currentBatch.length >= this.batchMaxSize) this.flush();
    }
    onFlush(callback) {
        if (!(callback instanceof Function)) throw new Error(`"onFlush" callback is supposed to be a function; saw ${typeof callback} instead`);
        this.onFlushCallbacks.add(callback);
        return {
            unsubscribe: ()=>{
                this.onFlushCallbacks.delete(callback);
            }
        };
    }
    /**
   * Forcefully flushes the batcher. Noop if current batch is empty.
   */ forceFlush() {
        // Currently force-flush is synchronous. Make sure the call sites are updated if
        // this is changed to a promise-based approach
        this.flush();
    }
    renewBatch() {
        const oldBatch = this.currentBatch;
        this.currentBatch = [];
        return oldBatch;
    }
    scheduleFlush() {
        if (!this.flushIntervalId) this.flushIntervalId = window.setInterval(this.flush, this.flushIntervalMs);
    }
    unscheduleFlush() {
        if (this.flushIntervalId) {
            window.clearInterval(this.flushIntervalId);
            this.flushIntervalId = undefined;
        }
    }
    constructor(flushIntervalMs, batchMaxSize){
        this.flushIntervalMs = flushIntervalMs;
        this.batchMaxSize = batchMaxSize;
        this.flushIntervalId = void 0;
        this.onFlushCallbacks = new Set();
        this.currentBatch = [];
        this.flush = ()=>{
            const batch = this.renewBatch();
            this.unscheduleFlush();
            if (batch.length === 0) return;
            this.onFlushCallbacks.forEach((cb)=>{
                try {
                    cb(batch);
                } catch (e) {
                    // rethrow error asynchronously to allow other callbacks to execute
                    setTimeout(()=>{
                        /* eslint-disable-next-line no-console */ console.error(`"onFlush" callback threw the below error. Please make sure your callbacks have proper error handling`);
                        throw e;
                    }, 0);
                }
            });
        };
    }
}



const $20a7f4cbd1623994$var$logger = (0, $a6897acd40ed68b1$export$2b1d391cd05230fd)('CustomMonitoringClient');

class $20a7f4cbd1623994$export$a54226afd3e3cacc {
    enableNewSentry() {
        this.newSentryEnabled = true;
    }
    enableSendErrorsToTelemetryService() {
        this.sendErrorsToTelemetryService = true;
    }
    submitError(error, errorData) {
        if (!error) return;
        if (this.errorsPerCurrentTransition === this.errorsPerTransitionLimit) // limit reached; do not submit the errors
        return;
        this.errorsPerCurrentTransition++;
        const logSafeErrorAttributes = (0, $8a3a8685062675cc$export$d08bac32cb78075f)(error);
        const { attribution: attribution } = errorData;
        let isFirstInSession = this.firstErrorInSession;
        const errorWithStackTrace = error && error.stack && error.message ? error : new Error(error && error.message || String(error));
        if ($20a7f4cbd1623994$var$isErrorIgnorableByOnCall(errorWithStackTrace, attribution, logSafeErrorAttributes)) isFirstInSession = false;
        else this.firstErrorInSession = false;
        this.incrementCounter('jsErrors', [
            `attribution:${attribution}`,
            `firstInSession:${isFirstInSession}`,
            ...logSafeErrorAttributes.operationName ? [
                `queryName:${logSafeErrorAttributes.operationName}`
            ] : []
        ]);
        const sentryTags = {
            attribution: attribution
        };
        if (this.context.slaExperience) sentryTags.slaExperience = this.context.slaExperience;
        if (this.context.pageName) sentryTags.pageName = this.context.pageName;
        if (logSafeErrorAttributes.failedSlaExperience) sentryTags.failedSlaExperience = logSafeErrorAttributes.failedSlaExperience;
        if (logSafeErrorAttributes.operationName) sentryTags.operationName = logSafeErrorAttributes.operationName;
        sentryTags.ssrRendered = Boolean(window.__SSR_RENDERED__).toString();
        if (logSafeErrorAttributes.failedSlaExperience) this.logSlaErrorToSentry(errorWithStackTrace, sentryTags).catch((sentryError)=>{
            this.logError(sentryError, {
                attribution: 'backbone'
            });
        });
        else if (this.newSentryEnabled) this.logErrorToSentry(errorWithStackTrace, sentryTags);
        this.logError(errorWithStackTrace, {
            ...errorData,
            ...logSafeErrorAttributes,
            firstInSession: isFirstInSession
        });
    }
    updateContext(update) {
        if (update.transitionId !== undefined && (update.transitionId === 0 || this.context.transitionId !== update.transitionId)) {
            this.incrementCounter('session', [
                `type:${update.transitionId === 0 ? 'initial' : 'transition'}`
            ]);
            // Next error will be first in the session when there is a initial load (transition id = 0) or a SPA transition.
            this.firstErrorInSession = true;
            this.errorsPerCurrentTransition = 0;
        }
        if (update.pageName && this.context.pageName !== update.pageName) // since the page name changed, all the events in the current batch were done
        // under an old page name. Hence we force-flush the batch, and only then set the new context.
        {
            if (this.context.pageName !== undefined) // skip force-flush if that's the first time we set pageName (i.e. initial navigation)
            this.batcher.forceFlush();
        }
        Object.assign(this.context, update);
    }
    incrementCounter(counterName, tags) {
        this.batcher.add(this.createMetric({
            type: 'increment',
            name: counterName,
            value: 1,
            tags: tags
        }));
    }
    logErrorToSentry(error, tags) {
        (parcelRequire("7YhLB")).then(({ withScope: withScope, captureException: captureException })=>{
            withScope((scope)=>{
                scope.setTags(tags);
                captureException(error);
            });
        }).catch((sentryError)=>{
            this.logError(sentryError, {
                attribution: 'backbone'
            });
        });
    }
    async logSlaErrorToSentry(error, tags) {
        let sentryHub = null;
        const standaloneSentryPromise = (0, $bafd16c1172e5624$export$c2e2a07dfafd1ea2)();
        if ((0, $cd3135dd152096aa$export$b1a2a6bd0c6f9666)(standaloneSentryPromise)) sentryHub = (0, $cd3135dd152096aa$export$bf7199a9ebcb84a9)(standaloneSentryPromise);
        else sentryHub = await standaloneSentryPromise;
        if (sentryHub) sentryHub.withScope((scope)=>{
            scope.setTags(tags);
            sentryHub.captureException(error);
        });
    }
    /**
   * There is a 64kb payload limit for navigator.sendBeacon requests
   * 10 events sent max.
   * 3 fields that are being trimmed
   * That allows for 65536/10/3 = 2184.5 per field
   * we add a bit of buffer for the rest of the payload by reducing that number further to 1000
   * @param errorAttributes
   * @returns a new object with trimmed attributes if they exceed the limit determined by
   * errorBatchMsgTrimLength` which is calculated based on the following details
   */ trimAttributes(errorAttributes) {
        const attributesToTrim = [
            'error',
            'stack',
            'componentStack'
        ];
        const newErrorAttributes = {
            ...errorAttributes
        };
        if (errorAttributes.error?.startsWith?.('Minified React error #130') && (0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_frontend_untrimmed_react_errors')) {
            // Oct 2025: Log the (hopefully entire) stack for minified react error 130, to aid investigations into increased occurrences. Still trims to <64kb limit.
            newErrorAttributes.error = this.trimTextLength(newErrorAttributes.error, 2000);
            newErrorAttributes.stack = this.trimTextLength(newErrorAttributes.stack, 25000);
            newErrorAttributes.componentStack = this.trimTextLength(newErrorAttributes.componentStack, 25000);
        } else attributesToTrim.forEach((attribute)=>{
            if (newErrorAttributes[attribute]) newErrorAttributes[attribute] = this.trimTextLength(newErrorAttributes[attribute], this.errorBatchMsgTrimLength);
        });
        return newErrorAttributes;
    }
    async logError(error, additionalData) {
        try {
            const analyticsWebClientPromise = (0, $b76dfd1db5681318$export$e9ba7ef9458d1a4a)();
            let client;
            if ((0, $cd3135dd152096aa$export$b1a2a6bd0c6f9666)(analyticsWebClientPromise)) client = (0, $cd3135dd152096aa$export$bf7199a9ebcb84a9)(analyticsWebClientPromise);
            else client = await analyticsWebClientPromise;
            const errorAttributes = {
                error: error.message || String(error),
                stack: error.stack,
                browserInfo: window.navigator.userAgent,
                ssrRendered: Boolean(window.__SSR_RENDERED__),
                releaseId: (0, $f3f8c1a227f13835$export$4ea39b9726d98a51)().FRONTEND_VERSION,
                track: (0, $f3f8c1a227f13835$export$4ea39b9726d98a51)().RELEASE_TRACK,
                pageName: this.context.pageName,
                shard: this.context.shard,
                edition: this.context.edition,
                jqVer: window.jQuery?.fn?.jquery,
                activeExperiences: this.context.activeExperiences ? Array.from(this.context.activeExperiences) : undefined,
                slaExperience: this.context.slaExperience,
                ufoTraceId: (0, $aae51952f0016112$export$b6ac780db3a3cc77)()?.traceId,
                ufoTraceType: (0, $aae51952f0016112$export$b6ac780db3a3cc77)()?.type,
                ...additionalData
            };
            const trimmedErrorAttributes = this.trimAttributes(errorAttributes);
            const hydrationFailed = window && window.__HYDRATION_FAILED__ && (0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_prevent_hydration_ufo_abort');
            if (!hydrationFailed) (0, $d9b1f70c159fe18d$export$7379c15afd3840fa)('confluence-frontend-monitoring-client', null, 'interaction unhandled error', errorAttributes.error);
            client.sendOperationalEvent({
                source: 'ui',
                action: 'unhandledError',
                actionSubject: 'ui',
                attributes: trimmedErrorAttributes
            });
            if (this.sendErrorsToTelemetryService) this.errorBatcher.add({
                event: trimmedErrorAttributes
            });
        } catch  {
        // no-op, if an error occurs here, there's really nowhere to submit it
        }
    }
    /**
   * Defines an allow-list of context attributes that will be sent as "global" tags to FE Telemetry and SignalFX with every event.
   * Tags additionally have to be allow-listed in the FE Telemetry repository. We PURPOSELY exclude certain tags (that are allowed by FE Telemetry)
   * such as "edition", as we do not want to be sending that tag for every experience event (thereby increasing metric cardinality). Instead, those tags
   * are included with specific experience events.
   * @private
   */ formatContextAsTags() {
        const tags = [];
        if (this.context.pageName) tags.push(`page:${this.context.pageName}`);
        if (this.context.tenantId) tags.push(`cloudId:${this.context.tenantId}`);
        if (this.context.shard) tags.push(`shard:${this.context.shard}`);
        if (this.context.product) tags.push(`product:${this.context.product}`);
        const { FRONTEND_VERSION: frontendVersion, RELEASE_TRACK: releaseTrack } = (0, $f3f8c1a227f13835$export$4ea39b9726d98a51)();
        if (frontendVersion) tags.push(`version:${frontendVersion}`);
        if (releaseTrack) tags.push(`track:${releaseTrack}`);
        return tags;
    }
    onBatch(batch) {
        const payload = {
            type: 'metric',
            meta: {
                globalTags: this.formatContextAsTags()
            },
            data: batch
        };
        this.send(payload);
    }
    onErrorBatch(batch) {
        const payload = {
            type: 'error',
            meta: {
                globalTags: this.formatContextAsTags()
            },
            data: batch
        };
        this.send(payload);
    }
    send(telemetryPayload) {
        try {
            $20a7f4cbd1623994$var$logger.info`Sending monitoring events: ${telemetryPayload}`;
            const reportingUrl = '/gateway/api/telemetry';
            const data = JSON.stringify(telemetryPayload);
            let isSentViaBeacon = false;
            if (navigator.sendBeacon) isSentViaBeacon = navigator.sendBeacon(reportingUrl, data);
            if (!isSentViaBeacon) {
                // resorting to XMLHttpRequest instead of fetch here so that we can submit these events *synchronously* when
                // the page unloads (`fetch` can't do that)
                const client = new XMLHttpRequest();
                const shouldBeSync = this.isWindowUnloading;
                client.open('POST', reportingUrl, !shouldBeSync);
                // we're setting the "Content-Type" header to "text/plain" to behave as closely to `sendBeacon` as possible
                client.setRequestHeader('Content-Type', 'text/plain;charset=UTF-8');
                client.send(data);
            }
        } catch (e) {
            // ignore - there's nothing we can do when monitoring is down
            $20a7f4cbd1623994$var$logger.error`Sending monitoring data failed: ${e}`;
        }
    }
    createMetric({ type: type, name: name, value: value, tags: tags = [] }) {
        return {
            type: type,
            name: name,
            value: value,
            sampleRate: 1,
            tags: tags,
            timestamp: new Date().toISOString()
        };
    }
    trimTextLength(text, trimmedLength) {
        if (!text || !trimmedLength) return text;
        if (text.length > trimmedLength) return `${text.substring(0, trimmedLength)}...`;
        return text;
    }
    constructor({ errorsPerTransitionLimit: errorsPerTransitionLimit = 1000, metricBatchMaxSize: metricBatchMaxSize = 50, metricBatchFlushIntervalMs: metricBatchFlushIntervalMs = 10000, errorBatchFlushIntervalMs: errorBatchFlushIntervalMs = 10000, errorBatchMaxSize: errorBatchMaxSize = 10, errorBatchMsgTrimLength: errorBatchMsgTrimLength = 1000 } = {}){
        this.batcher = void 0;
        this.errorBatcher = void 0;
        this.isWindowUnloading = false;
        this.context = {};
        // First error occurred in initial load or transition
        this.firstErrorInSession = true;
        this.newSentryEnabled = false;
        this.sendErrorsToTelemetryService = false;
        this.errorsPerTransitionLimit = void 0;
        this.errorsPerCurrentTransition = 0;
        this.errorBatchMsgTrimLength = void 0;
        this.errorsPerTransitionLimit = errorsPerTransitionLimit;
        this.errorBatchMsgTrimLength = errorBatchMsgTrimLength;
        this.batcher = new (0, $bf7ff670cf416156$export$704b12ddc1dacdd2)(metricBatchFlushIntervalMs, metricBatchMaxSize);
        this.errorBatcher = new (0, $bf7ff670cf416156$export$704b12ddc1dacdd2)(errorBatchFlushIntervalMs, errorBatchMaxSize);
        this.batcher.onFlush((batch)=>{
            this.onBatch(batch);
        });
        this.errorBatcher.onFlush((batch)=>{
            this.onErrorBatch(batch);
        });
        const unloadListener = ()=>{
            this.isWindowUnloading = true;
            this.batcher.forceFlush();
            this.errorBatcher.forceFlush();
        };
        window.addEventListener('pagehide', unloadListener);
    }
}
function $20a7f4cbd1623994$var$isErrorIgnorableByOnCall(error, attribution, attrs) {
    // make sure that this condition remains first, as it should override everything else
    if (Boolean(attrs.failedSlaExperience)) // non-ignorable, because it resulted in a failure of an SLA-bound experience
    return false;
    if ((0, $65398bb1ddc9160a$export$bda33884db3cf75b)(error)) // ignorable, because on-call can't do much about user-side network connectivity
    return true;
    if (attribution === 'backbone-loadable') // while we do want to report those, we don't want to overwhelm our error rate detector
    return true;
    if (error.message.includes('com.atlassian.confluence.api.service.exceptions.PermissionException') || error.message.includes('Authorization failed: Principal has insufficient permissions') || error.message.includes('com.atlassian.confluence.api.service.exceptions.NotFoundException') || attrs.statusCode === 401 || attrs.statusCode === 403) // on-call engineers can't do much about those errors, because they indicate a client-side issue
    return true;
    return false;
}


class $e83139af63a401f5$export$97cc0a779e2b1c0d {
    submitError() {}
    updateContext() {}
    incrementCounter() {}
}



let $d1c1e8e192b1a688$var$monitoringClient;
const $d1c1e8e192b1a688$export$39a3b7739331403b = ()=>{
    if (!$d1c1e8e192b1a688$var$monitoringClient) {
        if (/bot/i.test(window.navigator.userAgent)) // Do nothing for search engine crawlers
        $d1c1e8e192b1a688$var$monitoringClient = new (0, $e83139af63a401f5$export$97cc0a779e2b1c0d)();
        else $d1c1e8e192b1a688$var$monitoringClient = new (0, $20a7f4cbd1623994$export$a54226afd3e3cacc)();
    }
    return $d1c1e8e192b1a688$var$monitoringClient;
};
const $d1c1e8e192b1a688$export$b97a02aaddc4fced = ()=>{
    if ($d1c1e8e192b1a688$var$monitoringClient instanceof (0, $20a7f4cbd1623994$export$a54226afd3e3cacc)) $d1c1e8e192b1a688$var$monitoringClient.enableSendErrorsToTelemetryService();
};



var $gqzfn = parcelRequire("gqzfn");


var $34Zxt = parcelRequire("34Zxt");

var $cnjKG = parcelRequire("cnjKG");
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
function $f034bd26346a891e$export$f9ce7b637dfbe238(value) {
    return typeof value === 'boolean';
}
function $f034bd26346a891e$export$a9a18ae5ba42aeab(values) {
    function typeGuard(value) {
        return values.includes(value);
    }
    /**
	 * This is used by test utils to get the variants when running describe.each
	 */ if ($f034bd26346a891e$var$IS_TESTING_ENV) typeGuard.values = values;
    return typeGuard;
}
const $f034bd26346a891e$var$IS_TESTING_ENV = false;


function $596a47b26c45c5c8$export$456f1587c9c92021(config) {
    return {
        ...config,
        typeGuard: (0, $f034bd26346a891e$export$f9ce7b637dfbe238),
        defaultValue: config.defaultValue
    };
}
function $596a47b26c45c5c8$export$fb89e8a786694d1(config) {
    const { values: values } = config;
    return {
        ...config,
        values: [
            ...values
        ],
        typeGuard: (0, $f034bd26346a891e$export$a9a18ae5ba42aeab)(config.values),
        defaultValue: config.defaultValue
    };
}


const $0d6aba039f4bc9a8$export$6cbb856f286b07ef = {
    // new format to avoid collisions with other users when updating the file
    // Editor Platform experiments
    // lwoollard experiments
    // Added 03-09-2025
    cc_editor_limited_mode_include_lcm: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_editor_limited_mode_include_lcm'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 03-09-2025
    cc_editor_interactivity_monitoring: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_editor_interactivity_monitoring'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    cc_editor_insm_doc_size_stats: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_editor_insm_doc_size_stats'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-30
    cc_editor_insm_outlier_events: (0, $596a47b26c45c5c8$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'cc_editor_insm_outlier_events'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-09-30
    // variant 1: remove table overflow shadows completely, no table border shown when scrolling.
    // variant 2: remove table overflow shadows, show table border when scrolling.
    // variant 3: replace table overflow shadows with CSS-only solution.
    platform_editor_disable_table_overflow_shadows: (0, $596a47b26c45c5c8$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_editor_disable_table_overflow_shadows'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1',
            'variant2',
            'variant3'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-05-27
    platform_editor_reduce_noisy_steps_ncs: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_reduce_noisy_steps_ncs'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-24
    editor_prevent_numbered_column_too_big_jira_1: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            jira: 'editor_prevent_numbered_column_too_big_jira_1'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-02
    platform_editor_block_control_optimise_render: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_block_control_optimise_render'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-boolean': (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_boolean'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-multivariate': (0, $596a47b26c45c5c8$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_multivariate'
        },
        param: 'variant',
        values: [
            'one',
            'two',
            'three'
        ],
        defaultValue: 'one'
    }),
    // Added 2024-08-08
    'test-new-experiments-package': (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package',
            jira: 'jira_editor_experiment_test_new_package'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_table_drag_handle_hover: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_table_drag_handle_hover',
            jira: 'platform_editor_table_drag_handle_hover'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-05
    support_table_in_comment: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_support_table_in_comment_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-07
    platform_editor_exp_lazy_node_views: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_exp_lazy_node_views'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-18
    platform_renderer_table_sticky_scrollbar: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_renderer_table_sticky_scrollbar'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-10
    platform_editor_experience_tracking: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_experience_tracking'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-26
    platform_editor_prevent_toolbar_layout_shifts: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_prevent_toolbar_layout_shifts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-01
    comment_on_bodied_extensions: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_comment_on_bodied_extensions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-14
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_advanced_layouts/setup
    advanced_layouts: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_advanced_layouts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-3-15
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_single_column_layout/setup
    single_column_layouts: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_single_column_layout'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-08
    support_table_in_comment_jira: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            jira: 'platform_editor_support_table_in_comment_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    'platform_editor_ai-prompts-placeholder': (0, $596a47b26c45c5c8$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_editor_ai-prompts-placeholder'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // added 2024-11-06
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_nested_tables/setup
    'nested-tables-in-tables': (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_nested_tables'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-11-26
    platform_editor_ai_unsplash_page_header: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_ai_unsplash_page_header'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-12-05
    platform_editor_blockquote_in_text_formatting_menu: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_blockquote_in_text_formatting_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-13
    platform_editor_element_drag_and_drop_multiselect: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_element_drag_and_drop_multiselect'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-19
    platform_editor_ai_edit_response_in_preview: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_ai_edit_response_in_preview'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-02-10
    platform_editor_controls: (0, $596a47b26c45c5c8$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_editor_controls'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-08-01
    platform_editor_controls_block_controls_state_fix: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_controls_block_controls_state_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 28-02-2025
    platform_editor_insertion: (0, $596a47b26c45c5c8$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_editor_insertion'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-09-03
    platform_editor_hydratable_ui: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_hydratable_ui'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-14
    platform_editor_resizer_cls_fix: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_resizer_cls_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-03-28
    platform_editor_ai_proactive_ai_nudge_parameters: (0, $596a47b26c45c5c8$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_editor_ai_proactive_ai_nudge_parameters'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-04-14
    // https://switcheroo.atlassian.com/ui/gates/b159b45a-86d9-4f4b-b482-f9aca5b615d6/key/platform_editor_offline_editing_web
    platform_editor_offline_editing_web: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_offline_editing_web'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-14
    editor_ai_inline_suggestion_date_v2: (0, $596a47b26c45c5c8$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'editor_ai_inline_suggestion_date_v2'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-31
    platform_editor_lovability_suppress_toolbar_event: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_lovability_suppress_toolbar_event',
            jira: 'platform_editor_lovability_suppress_toolbar_event'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-17
    platform_editor_tables_drag_and_drop: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_tables_drag_and_drop'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-17
    platform_editor_tables_table_selector: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_tables_table_selector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_editor_usesharedpluginstateselector: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_usesharedpluginstateselector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_renderer_fix_analytics_memo_callback: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_renderer_fix_analytics_memo_callback'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-26
    platform_editor_stop_width_reflows: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_stop_width_reflows'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-10
    platform_editor_no_cursor_on_edit_page_init: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_no_cursor_on_edit_page_init'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-14
    platform_editor_debounce_portal_provider: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_debounce_portal_provider'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-15
    platform_editor_no_ssr: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_no_ssr'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-14
    platform_editor_jira_advanced_code_blocks: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            jira: 'platform_editor_jira_advanced_code_blocks'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-08 - Jira work sync description comment summary
    'jira-work-sync-desc-comment-summary': (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            jira: 'jira-work-sync-desc-comment-summary'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-15
    platform_editor_breakout_resizing: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_breakout_resizing'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-07
    platform_editor_ai_quickstart_command: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_ai_quickstart_command'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-05
    platform_editor_block_controls_perf_optimization: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_block_controls_perf_optimization'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-16
    platform_editor_enable_single_player_step_merging: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_enable_single_player_step_merging'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-02
    platform_editor_code_block_fold_gutter: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_code_block_fold_gutter'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-18
    platform_editor_ai_iw_adf_streaming: (0, $596a47b26c45c5c8$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_editor_ai_iw_adf_streaming'
        },
        param: 'cohort',
        values: [
            'control',
            'adf_gemini25flash',
            'adf_gpt41mini'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-06-18
    platform_editor_ai_ct_sg_adf_streaming: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_ai_ct_sg_adf_streaming'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-20
    platform_editor_ai_non_iw_adf_streaming: (0, $596a47b26c45c5c8$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_editor_ai_non_iw_adf_streaming'
        },
        param: 'cohort',
        values: [
            'control',
            'adf_gemini25flash',
            'adf_gpt41mini'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-07-07
    platform_editor_ai_remove_trivial_prompts_cc: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_ai_remove_trivial_prompts_cc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    //Added 2025-07-25
    platform_editor_extension_styles: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_extension_styles'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-20
    confluence_whiteboards_quick_insert_aa: (0, $596a47b26c45c5c8$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'confluence_whiteboards_quick_insert_aa'
        },
        param: 'cohort',
        values: [
            'control',
            'test_blank',
            'test_diagram'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-06-24
    platform_editor_find_and_replace_improvements: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_find_and_replace_improvements'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-24
    confluence_whiteboards_quick_insert: (0, $596a47b26c45c5c8$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'confluence_whiteboards_quick_insert'
        },
        param: 'cohort',
        values: [
            'control',
            'test_blank',
            'test_diagram'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-06-26
    platform_editor_feedback_mandatory_rating: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_feedback_mandatory_rating'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_drag_handle_aria_label: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_drag_handle_aria_label'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-07
    platform_editor_toggle_expand_on_match_found: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_toggle_expand_on_match_found'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_smart_card_otp: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_smart_card_otp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-15
    platform_editor_preview_panel_responsiveness: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'confluence_preview_panels_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_preview_panel_linking_exp: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_preview_panel_linking_exp_conf',
            jira: 'platform_editor_preview_panel_linking_exp_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-10
    platform_editor_hoverlink_ui_fixes_exp: (0, $596a47b26c45c5c8$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_editor_hoverlink_ui_fixes_exp'
        },
        param: 'cohort',
        values: [
            'control',
            'css_changes_only',
            'css_js_changes'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-08-17
    platform_hover_card_preview_panel: (0, $596a47b26c45c5c8$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_hover_card_preview_panel',
            jira: 'platform_hover_card_preview_panel'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-09-17
    platform_hover_card_preview_panel_modal: (0, $596a47b26c45c5c8$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_hover_card_preview_panel_modal',
            jira: 'platform_hover_card_preview_panel_modal'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025--8-05
    platform_editor_block_menu: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_block_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025--9-17
    platform_editor_block_menu_empty_line: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_block_menu_empty_line'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-16
    platform_editor_emoji_otp: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_emoji_otp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-23
    platform_editor_renderer_breakout_fix: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_renderer_breakout_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-24
    editor_enghealth_hyperlink_toolbar_aria_values: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'editor_enghealth_hyperlink_toolbar_aria_values'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-14
    platform_editor_add_orange_highlight_color: (0, $596a47b26c45c5c8$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_editor_add_orange_highlight_color'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    //Added 2025-07-16
    platform_editor_toolbar_aifc: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            jira: 'platform_editor_toolbar_aifc_jira',
            confluence: 'platform_editor_toolbar_aifc_confluence'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-04
    editor_refactor_backspace_task_and_decisions: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'editor_refactor_backspace_task_and_decisions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    //Added 2025-07-16
    platform_editor_toolbar_aifc_patch_3: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            jira: 'platform_editor_toolbar_aifc_patch_3',
            confluence: 'platform_editor_toolbar_aifc_patch_3'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    //Added 2025-09-09
    platform_editor_toolbar_aifc_patch_4: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            jira: 'platform_editor_toolbar_aifc_patch_4',
            confluence: 'platform_editor_toolbar_aifc_patch_4'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-29
    platform_editor_toolbar_aifc_selection_extension: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_selection_extension',
            jira: 'platform_editor_toolbar_aifc_selection_extension'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-04
    platform_editor_floating_toolbar_button_aria_label: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_floating_toolbar_button_aria_label'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-24
    platform_editor_enghealth_table_plugin_lable_rule: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_enghealth_table_plugin_lable_rule'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-31
    platform_editor_breakout_interaction_rerender: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_breakout_interaction_rerender'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-27
    platform_editor_toolbar_aifc_responsive: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_responsive',
            jira: 'platform_editor_toolbar_aifc_responsive'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_pasting_nested_table_fix: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_pasting_nested_table_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 20205-07-28
    platform_editor_fix_quick_insert_consistency_exp: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_fix_quick_insert_consistency_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-31
    platform_editor_fix_a11y_aria_posinset_0: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_fix_a11y_aria_posinset_0'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_blocktaskitem_node_tenantid: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_blocktaskitem_node_tenantid'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-08
    platform_editor_blocktaskitem_patch_1: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_blocktaskitem_patch_1'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-06
    cc_editor_limited_mode: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_editor_limited_mode'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_native_anchor_support: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_native_anchor_support'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-28
    editor_enable_image_alignment_in_expand: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'editor_enable_image_alignment_in_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_august_a11y: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_august_a11y'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-10
    platform_synced_block: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_synced_block'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-16
    cc_improve_writing_on_paste_v2: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_improve_writing_on_paste_v2'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_locale_datepicker: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_locale_datepicker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_find_replace_a11y_fixes: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_find_replace_a11y_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-19
    platform_editor_breakout_resizing_vc90_fix: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_breakout_resizing_vc90_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-27
    platform_editor_toolbar_support_custom_components: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_toolbar_support_custom_components'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-21
    platform_editor_paste_rich_text_bugfix: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_paste_rich_text_bugfix',
            jira: 'platform_editor_paste_rich_text_bugfix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-25
    platform_editor_toolbar_aifc_template_editor: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_template_editor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-26
    platform_editor_toolbar_migrate_loom: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_toolbar_migrate_loom',
            jira: 'platform_editor_toolbar_migrate_loom'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-16
    platform_editor_prevent_taskitem_remount: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_prevent_taskitem_remount'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-01
    cc_editor_ai_content_mode: (0, $596a47b26c45c5c8$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'cc_editor_ai_content_mode'
        },
        param: 'variant',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-09-08
    platform_editor_editor_width_analytics: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_editor_width_analytics',
            jira: 'platform_editor_editor_width_analytics'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-10
    platform_editor_fix_button_name_violation_in_table: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_fix_button_name_violation_in_table'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-11
    platform_editor_quick_insert_image_wrap_right_fix: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_quick_insert_image_wrap_right_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-11
    platform_editor_block_menu_layout_format: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_block_menu_layout_format'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-11
    platform_editor_block_menu_expand_format: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_block_menu_expand_format'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-17
    platform_editor_block_menu_keyboard_navigation: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_block_menu_keyboard_navigation'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-11
    platform_editor_add_aria_checked_to_inline_img_btn: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_add_aria_checked_to_inline_image_btn'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-16
    platform_editor_nested_table_refresh_width_fix: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_nested_table_refresh_width_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-15
    platform_editor_toolbar_aifc_patch_5: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_patch_5'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-18
    platform_editor_toolbar_aifc_renderer_selection: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_renderer_selection'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-10
    platform_use_llm_space_recommendations: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_use_llm_space_recommendations'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-15
    platform_editor_text_highlight_padding: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_text_highlight_padding'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-24
    platform_editor_lovability_user_intent: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_lovability_user_intent'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-17
    cc_complexit_fe_emoji_stability: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_complexit_fe_emoji_stability'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-23
    cc_editor_ttvc_release_bundle_one: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_editor_ttvc_release_bundle_one'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-07
    platform_editor_plain_text_support: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            jira: 'platform_editor_plain_text_support',
            confluence: 'platform_editor_plain_text_support'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-26
    platform_editor_toolbar_aifc_patch_6: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_patch_6'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-17
    confluence_content_mode_replace_dense_with_compact: (0, $596a47b26c45c5c8$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'confluence_content_mode_replace_dense_with_compact'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-01
    platform_inline_smartcard_connect_button_exp: (0, $596a47b26c45c5c8$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_inline_smartcard_connect_button_exp',
            jira: 'platform_inline_smartcard_connect_button_exp'
        },
        param: 'cohort',
        values: [
            'control',
            'test1',
            'test2'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-10
    platform_editor_new_list_decorations_logic: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_new_list_decorations_logic'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-13
    platform_editor_media_error_analytics: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_media_error_analytics'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-15
    platform_editor_new_mentions_detection_logic: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_new_mentions_detection_logic'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-20
    confluence_whiteboards_quick_insert_localised: (0, $596a47b26c45c5c8$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'confluence_whiteboards_quick_insert_localised'
        },
        param: 'cohort',
        values: [
            'control',
            'test_blank',
            'test_diagram'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-28
    confluence_whiteboards_quick_insert_localised_aa: (0, $596a47b26c45c5c8$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'confluence_whiteboards_quick_insert_localised_aa'
        },
        param: 'cohort',
        values: [
            'control',
            'test_diagram'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-22
    platform_editor_remove_bidi_char_warning: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_remove_bidi_char_warning'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-24
    platform_editor_fix_clone_nesting_exp: (0, $596a47b26c45c5c8$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_fix_clone_nesting_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-27
    platform_editor_table_sticky_header_improvements: (0, $596a47b26c45c5c8$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_editor_table_sticky_header_improvements'
        },
        param: 'cohort',
        values: [
            'control',
            'test_with_overflow',
            'test_without_overflow'
        ],
        defaultValue: 'control'
    })
};


const $0a3dc0435f94572c$export$7e849a84a00ffd1c = {
    'example-multivariate': 'one',
    'platform_editor_ai-prompts-placeholder': 'control',
    platform_editor_ai_proactive_ai_nudge_parameters: 'control',
    platform_editor_controls: 'control',
    confluence_whiteboards_quick_insert_aa: 'control',
    confluence_whiteboards_quick_insert: 'control',
    confluence_whiteboards_quick_insert_localised: 'control',
    confluence_whiteboards_quick_insert_localised_aa: 'control',
    platform_editor_insertion: 'control',
    editor_ai_inline_suggestion_date_v2: 'control',
    cc_editor_ai_content_mode: 'control',
    platform_editor_add_orange_highlight_color: 'control',
    platform_editor_ai_iw_adf_streaming: 'control',
    platform_editor_ai_non_iw_adf_streaming: 'control',
    platform_hover_card_preview_panel: 'control',
    platform_hover_card_preview_panel_modal: 'control',
    platform_inline_smartcard_connect_button_exp: 'control',
    confluence_content_mode_replace_dense_with_compact: 'control',
    cc_editor_insm_outlier_events: 'test',
    platform_editor_disable_table_overflow_shadows: 'control',
    platform_editor_hoverlink_ui_fixes_exp: 'control',
    platform_editor_table_sticky_header_improvements: 'control'
};
const $0a3dc0435f94572c$export$54960937bb713f97 = {
    platform_editor_feedback_mandatory_rating: false,
    platform_editor_preview_panel_responsiveness: false,
    platform_editor_renderer_breakout_fix: false,
    platform_editor_toolbar_aifc: false,
    platform_editor_block_control_optimise_render: false,
    'test-new-experiments-package': false,
    support_table_in_comment: false,
    platform_editor_exp_lazy_node_views: false,
    platform_renderer_table_sticky_scrollbar: false,
    platform_editor_prevent_toolbar_layout_shifts: false,
    comment_on_bodied_extensions: false,
    advanced_layouts: false,
    single_column_layouts: false,
    support_table_in_comment_jira: false,
    'nested-tables-in-tables': false,
    platform_editor_ai_unsplash_page_header: false,
    platform_editor_blockquote_in_text_formatting_menu: false,
    platform_editor_element_drag_and_drop_multiselect: false,
    platform_editor_ai_edit_response_in_preview: false,
    platform_editor_offline_editing_web: false,
    platform_editor_tables_drag_and_drop: false,
    platform_editor_tables_table_selector: false,
    platform_renderer_fix_analytics_memo_callback: false,
    platform_editor_stop_width_reflows: false,
    platform_editor_no_cursor_on_edit_page_init: false,
    'jira-work-sync-desc-comment-summary': false,
    platform_editor_breakout_resizing: false,
    platform_editor_ai_quickstart_command: false,
    platform_editor_block_controls_perf_optimization: false,
    platform_editor_enable_single_player_step_merging: false,
    platform_editor_ai_remove_trivial_prompts_cc: false,
    platform_editor_find_and_replace_improvements: false,
    platform_editor_toggle_expand_on_match_found: false,
    platform_editor_reduce_noisy_steps_ncs: false,
    cc_improve_writing_on_paste_v2: false,
    platform_editor_text_highlight_padding: false
};


let $3309bcde17ef7513$export$e5d73bf4f8e2ae96 = {};
let $3309bcde17ef7513$export$4e849416bb5c5b52 = {};
let $3309bcde17ef7513$export$cf7305fc65acbf0d;
function $3309bcde17ef7513$export$1c2b6dbf79eb3560(product, /**
	 * Overrides are used to set the group of an experiment for testing purposes.
	 * This is useful when you want to test a specific experiment group.
	 */ groupOverrides, /**
	 * Param overrides are used to set the experiment parameters for testing purposes.
	 * This is useful when you want to tweak the experiment parameters for testing.
	 */ paramOverrides, options) {
    if (groupOverrides) {
        // When setting up overrides, we want to ensure that experiments don't end up with invalid
        // values.
        // For production usage -- this is done via the feature flag client which takes the type
        // and performs equivalent logic.
        // @ts-ignore
        groupOverrides = Object.entries(groupOverrides).reduce((acc, [key, value])=>{
            const config = (0, $0d6aba039f4bc9a8$export$6cbb856f286b07ef)[key];
            if (config) acc = {
                ...acc,
                [key]: config.typeGuard(value) ? value : config.defaultValue
            };
            return acc;
        }, {});
        $3309bcde17ef7513$export$e5d73bf4f8e2ae96 = groupOverrides;
    }
    if (product === 'test' && !options?.disableTestOverrides) {
        // Enforce expectation - file overrides, then global overrides, then default to true for boolean
        // experiments, then last result use the default value
        const testOverrides = Object.fromEntries(Object.entries((0, $0d6aba039f4bc9a8$export$6cbb856f286b07ef)).map(([key, value])=>{
            const defaultValue = typeof value.defaultValue === 'boolean' ? true : value.defaultValue;
            return [
                key,
                groupOverrides?.[key] ?? (0, $0a3dc0435f94572c$export$7e849a84a00ffd1c)[key] ?? (0, $0a3dc0435f94572c$export$54960937bb713f97)[key] ?? defaultValue
            ];
        }));
        $3309bcde17ef7513$export$e5d73bf4f8e2ae96 = testOverrides;
    }
    $3309bcde17ef7513$export$cf7305fc65acbf0d = product;
    $3309bcde17ef7513$export$4e849416bb5c5b52 = paramOverrides || {};
}


var $7d86fc4abc7b6fc9$export$2c20ffeba7dbc068 = /*#__PURE__*/ function(ExposureTriggerReason) {
    ExposureTriggerReason["OptIn"] = "optInExposure";
    ExposureTriggerReason["Manual"] = "manualExposure";
    ExposureTriggerReason["Default"] = "defaultExposure";
    ExposureTriggerReason["AutoExposure"] = "autoExposure";
    ExposureTriggerReason["hasCustomAttributes"] = "hasCustomAttributes";
    return ExposureTriggerReason;
}({});


const $4e7d1641cc2384a1$export$a6cdc56e425d0d0a = (value)=>typeof value === 'object';
const $4e7d1641cc2384a1$export$8ed1df9dbe2e9a7d = (obj)=>{
    return obj ? Object.keys(obj).length === 0 : true;
};
const $4e7d1641cc2384a1$export$c7d37910dd25ecbf = (obj, attributes, identifier)=>{
    attributes.forEach((attribute)=>{
        if (!(attribute in obj)) {
            const title = identifier ? `${identifier}: ` : '';
            throw new Error(`${title}Missing ${attribute}`);
        }
    });
};
const $4e7d1641cc2384a1$export$891630e169ca14a4 = (customAttributes)=>{
    const reservedAttributes = [
        'flagKey',
        'ruleId',
        'reason',
        'value',
        'errorKind'
    ];
    const keys = customAttributes ? Object.keys(customAttributes) : [];
    if (reservedAttributes.some((attribute)=>keys.includes(attribute))) throw new TypeError(`exposureData contains a reserved attribute. Reserved attributes are: ${reservedAttributes.join(', ')}`);
};
const $4e7d1641cc2384a1$var$validateFlag = (flagKey, flag)=>{
    if ($4e7d1641cc2384a1$export$a6cdc56e425d0d0a(flag) && 'value' in flag) return true;
};
const $4e7d1641cc2384a1$export$410eec87ab950965 = (flags)=>{
    Object.keys(flags).forEach((key)=>$4e7d1641cc2384a1$var$validateFlag(key, flags[key]));
};


const $b82c39383c4a082c$export$933245d8afcc8872 = {
    kind: 'ERROR',
    errorKind: 'FLAG_NOT_FOUND'
};
class $b82c39383c4a082c$export$2e2bcd8739ae039 {
    evaluate(defaultValue) {
        return defaultValue;
    }
    getBooleanValue(options) {
        return this.evaluate(options.default);
    }
    getVariantValue(options) {
        return this.evaluate(options.default);
    }
    getJSONValue() {
        return this.evaluate({});
    }
    getRawValue(options) {
        return this.evaluate(options.default);
    }
    getFlagEvaluation(options) {
        const value = this.evaluate(options.default);
        return {
            value: value,
            explanation: $b82c39383c4a082c$export$933245d8afcc8872
        };
    }
    constructor(){
        // Unused but required for type
        this.evaluationCount = -1;
    }
}



class $47f1996d1bff486e$export$2e2bcd8739ae039 {
    getCachedResultOrCompute(defaultValue, { shouldTrackExposureEvent: shouldTrackExposureEvent, exposureData: exposureData, oneOf: oneOf, ignoreTypes: ignoreTypes }) {
        let exposureTriggerReason = (0, $7d86fc4abc7b6fc9$export$2c20ffeba7dbc068).OptIn;
        if (shouldTrackExposureEvent === undefined) {
            shouldTrackExposureEvent = true;
            exposureTriggerReason = (0, $7d86fc4abc7b6fc9$export$2c20ffeba7dbc068).Default;
        }
        // It is very common for products to call this method many times for the same flag key,
        // as flag evaluations are often done inside action callbacks and/or inside components with many instances.
        // We can cache the result of the first evaluation to avoid doing the same validation checks on every call.
        if (this.evaluationResult === undefined) this.evaluationResult = this.computeWithValidation(defaultValue, {
            oneOf: oneOf,
            ignoreTypes: ignoreTypes
        });
        let value = this.evaluationResult.value;
        if (this.evaluationResult.didFallbackToDefaultValue) // Use the default that was passed in, just in case it's different to what it was in the initial evaluation
        value = defaultValue;
        else if (shouldTrackExposureEvent) // For backwards compability, only fire the opt-in exposure event in valid evaluations.
        this.trackExposure(this.flagKey, this.flag, exposureTriggerReason, exposureData);
        this.sendAutomaticExposure(this.flagKey, value, this.evaluationResult.explanation);
        this.evaluationCount++;
        return {
            value: value,
            explanation: this.evaluationResult.explanation
        };
    }
    computeWithValidation(defaultValue, { oneOf: oneOf, ignoreTypes: ignoreTypes }) {
        let result = {
            value: this.flag.value,
            explanation: this.flag.explanation,
            didFallbackToDefaultValue: false
        };
        if (!ignoreTypes && typeof this.flag.value !== typeof defaultValue) {
            result.value = defaultValue;
            result.didFallbackToDefaultValue = true;
            result.explanation = {
                ...result.explanation || {},
                kind: 'ERROR',
                errorKind: 'WRONG_TYPE'
            };
        } else if (oneOf !== undefined && !oneOf.includes(this.flag.value)) {
            result.value = defaultValue;
            result.didFallbackToDefaultValue = true;
            result.explanation = {
                ...result.explanation || {},
                kind: 'ERROR',
                errorKind: 'VALIDATION_ERROR'
            };
        }
        return result;
    }
    getBooleanValue(options) {
        const flag = this.getCachedResultOrCompute(options.default, {
            exposureData: options.exposureData,
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            oneOf: undefined,
            ignoreTypes: this.ignoreTypes || false
        });
        return flag.value;
    }
    getVariantValue(options) {
        const flag = this.getCachedResultOrCompute(options.default, {
            exposureData: options.exposureData,
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            oneOf: options.oneOf,
            ignoreTypes: this.ignoreTypes || false
        });
        return flag.value;
    }
    getJSONValue() {
        return this.getCachedResultOrCompute({}, {
            shouldTrackExposureEvent: false,
            ignoreTypes: this.ignoreTypes
        }).value;
    }
    getRawValue(options) {
        return this.getCachedResultOrCompute(options.default, {
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            exposureData: options.exposureData,
            oneOf: undefined,
            ignoreTypes: true
        }).value;
    }
    getFlagEvaluation(options) {
        return this.getCachedResultOrCompute(options.default, {
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            exposureData: options.exposureData,
            ignoreTypes: this.ignoreTypes || false
        });
    }
    constructor(flagKey, flag, trackExposure, sendAutomaticExposure, ignoreTypes){
        this.evaluationCount = void 0;
        this.flagKey = void 0;
        this.flag = void 0;
        this.trackExposure = void 0;
        this.sendAutomaticExposure = void 0;
        this.ignoreTypes = void 0;
        // Makes the casting easier later on. The APIs should not leak any.
        // Should only be used in private functions.
        this.evaluationResult = void 0;
        this.flagKey = flagKey;
        this.flag = flag;
        this.evaluationCount = 0;
        this.trackExposure = trackExposure;
        this.sendAutomaticExposure = sendAutomaticExposure;
        this.ignoreTypes = ignoreTypes;
    }
}


class $eb0cfcd94dabfc57$export$2e2bcd8739ae039 {
    setFlags(flags) {
        if (!(0, $4e7d1641cc2384a1$export$a6cdc56e425d0d0a)(flags)) return;
        Object.entries(flags).forEach(([flagKey, flag])=>{
            this.flags.set(flagKey, flag);
        });
        // Clear any cached data for flags that have been passed in again,
        // in case they have different values or explanations
        for (const flagKey of this.flagWrapperCache.keys())if (flags.hasOwnProperty(flagKey)) this.flagWrapperCache.delete(flagKey);
    }
    setAnalyticsHandler(analyticsHandler) {
        this.analyticsHandler = analyticsHandler;
    }
    setIsAutomaticExposuresEnabled(isEnabled) {
        this.isAutomaticExposuresEnabled = isEnabled;
    }
    /**
   * This method returns the wrapper object for the given flag key.
   * If the flag does not exist, this will return a stubbed flag following the null-object pattern,
   * so it is always guaranteed to return an object.
   */ getFlagWrapper(flagKey) {
        let wrapper = this.flagWrapperCache.get(flagKey);
        if (wrapper !== undefined) return wrapper;
        const flag = this.flags.get(flagKey);
        if (flag) wrapper = new (0, $47f1996d1bff486e$export$2e2bcd8739ae039)(flagKey, flag, this._trackExposure.bind(this), this.sendAutomaticExposure.bind(this), this.ignoreTypes);
        else wrapper = new (0, $b82c39383c4a082c$export$2e2bcd8739ae039)();
        this.flagWrapperCache.set(flagKey, wrapper);
        return wrapper;
    }
    clear() {
        this.flags.clear();
        this.flagWrapperCache.clear();
        this.trackedFlags.clear();
    }
    getBooleanValue(flagKey, options) {
        (0, $4e7d1641cc2384a1$export$c7d37910dd25ecbf)(options, [
            'default'
        ], 'getBooleanValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getBooleanValue(options);
    }
    getVariantValue(flagKey, options) {
        (0, $4e7d1641cc2384a1$export$c7d37910dd25ecbf)(options, [
            'default',
            'oneOf'
        ], 'getVariantValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getVariantValue(options);
    }
    getJSONValue(flagKey) {
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getJSONValue();
    }
    getRawValue(flagKey, options) {
        (0, $4e7d1641cc2384a1$export$c7d37910dd25ecbf)(options, [
            'default'
        ], 'getRawValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getRawValue(options);
    }
    getFlagEvaluation(flagKey, options) {
        (0, $4e7d1641cc2384a1$export$c7d37910dd25ecbf)(options, [
            'default'
        ], 'getRawValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getFlagEvaluation(options);
    }
    /**
   * This method combines both the trackExposure and sendAutomaticExposure flows into
   * one endpoint. Depending on the passed in trigger reason a manual or automatic exposure
   * is sent.
   **/ trackFeatureFlag(flagKey, options = {}) {
        const triggerReason = options?.triggerReason ? options.triggerReason : (0, $7d86fc4abc7b6fc9$export$2c20ffeba7dbc068).Manual;
        const isValueSet = this.flags.has(flagKey) || 'value' in options;
        if (!isValueSet) {
            // eslint-disable-next-line no-console
            console.warn(`No value associated with the flagKey: ${flagKey} with an exposure trigger reason of: ${triggerReason}`);
            return;
        }
        // if no values for flagValue and explanation supplied then retrieve them from the flags map
        const flagValue = 'value' in options ? options.value : this.flags.get(flagKey)?.value;
        const flagExplanation = options?.explanation ? options.explanation : this.flags.get(flagKey)?.explanation;
        if (triggerReason === (0, $7d86fc4abc7b6fc9$export$2c20ffeba7dbc068).AutoExposure) this.sendAutomaticExposure(flagKey, flagValue, flagExplanation);
        else // default to fire a manual track exposure
        this._trackExposure(flagKey, {
            value: flagValue,
            explanation: flagExplanation
        }, triggerReason);
    }
    trackExposure(flagKey, flag, exposureData = {}) {
        return this._trackExposure(flagKey, flag, (0, $7d86fc4abc7b6fc9$export$2c20ffeba7dbc068).Manual, exposureData);
    }
    _trackExposure(flagKey, flag, exposureTriggerReason, exposureData) {
        if (!(flag && flag.explanation && this.shouldSendEvent(flagKey, exposureData))) return;
        (0, $4e7d1641cc2384a1$export$891630e169ca14a4)(exposureData);
        const flagAttributes = {
            flagKey: flagKey,
            reason: flag.explanation.kind,
            ruleId: flag.explanation.ruleId,
            value: flag.value
        };
        this.sendExposureEvent(flagAttributes, exposureTriggerReason, exposureData);
    }
    shouldSendEvent(flagKey, customAttributes) {
        return this.analyticsHandler !== undefined && (!this.trackedFlags.has(flagKey) || !(0, $4e7d1641cc2384a1$export$8ed1df9dbe2e9a7d)(customAttributes) && !this.customAttributesExposuresCache.has(flagKey));
    }
    sendAutomaticExposure(flagKey, value, flagExplanation) {
        if (!(flagExplanation && this.isAutomaticExposuresEnabled && this.shouldSendEvent(flagKey))) return;
        const flagAttributes = {
            flagKey: flagKey,
            value: value,
            reason: flagExplanation.kind || 'SIMPLE_EVAL',
            // In theory this shouldnt be necessary
            ruleId: flagExplanation.ruleId,
            errorKind: flagExplanation.errorKind
        };
        this.sendExposureEvent(flagAttributes, (0, $7d86fc4abc7b6fc9$export$2c20ffeba7dbc068).AutoExposure);
    }
    sendExposureEvent(attributes, exposureTriggerReason, customAttributes) {
        if (!this.trackedFlags.has(attributes.flagKey)) {
            const exposureEvent = {
                action: 'exposed',
                actionSubject: 'feature',
                attributes: attributes,
                tags: [
                    'measurement',
                    exposureTriggerReason
                ],
                highPriority: false,
                source: '@atlaskit/feature-flag-client'
            };
            this.analyticsHandler?.sendOperationalEvent(exposureEvent);
            this.trackedFlags.add(attributes.flagKey);
        }
        // Due to the way we've simplified our pipeline, custom attributes are dropped from exposure
        // events. In order not to break existing users of this feature immediately, we're sending an
        // extra event that won't be consumed by our pipeline, but will end up in the `cloud.*` tables.
        // See: https://hello.atlassian.net/wiki/spaces/MEASURE/pages/1838596497/AtlasKit+TAC
        if (!(0, $4e7d1641cc2384a1$export$8ed1df9dbe2e9a7d)(customAttributes)) {
            const customeAttributesExposureEvent = {
                action: 'exposed',
                actionSubject: 'feature',
                attributes: Object.assign({}, attributes, customAttributes),
                tags: [
                    'measurement',
                    (0, $7d86fc4abc7b6fc9$export$2c20ffeba7dbc068).hasCustomAttributes,
                    exposureTriggerReason
                ],
                highPriority: true,
                source: '@atlaskit/feature-flag-client'
            };
            this.analyticsHandler?.sendOperationalEvent(customeAttributesExposureEvent);
            this.customAttributesExposuresCache.add(attributes.flagKey);
        }
    }
    getFlagStats() {
        const flagStats = {};
        for (const [flagKey, wrapper] of this.flagWrapperCache){
            const { evaluationCount: evaluationCount } = wrapper;
            flagStats[flagKey] = {
                evaluationCount: evaluationCount
            };
        }
        return flagStats;
    }
    constructor(options){
        this.flags = void 0;
        this.flagWrapperCache = void 0;
        this.analyticsHandler = void 0;
        this.isAutomaticExposuresEnabled = void 0;
        this.trackedFlags = void 0;
        this.customAttributesExposuresCache = void 0;
        this.ignoreTypes = void 0;
        (0, $4e7d1641cc2384a1$export$c7d37910dd25ecbf)(options, [
            'analyticsHandler'
        ], 'Feature Flag Client');
        const { flags: flags, analyticsHandler: analyticsHandler, isAutomaticExposuresEnabled: isAutomaticExposuresEnabled, ignoreTypes: ignoreTypes } = options;
        this.flags = new Map();
        this.flagWrapperCache = new Map();
        this.customAttributesExposuresCache = new Set();
        this.trackedFlags = new Set();
        this.isAutomaticExposuresEnabled = isAutomaticExposuresEnabled || false;
        this.ignoreTypes = ignoreTypes || false;
        this.setFlags(flags || {});
        this.setAnalyticsHandler(analyticsHandler);
    }
}






function $7a55ff9c881e37e5$export$30a0bf30ea993fb(value) {
    if (value === 'true') return true;
    else if (value === 'false') return false;
    else if (typeof value === 'object') return JSON.stringify(value);
    return value;
}
function $7a55ff9c881e37e5$export$254798ec7ef71406(objectList, valueGetter) {
    return objectList.reduce((keyedObject, item)=>{
        keyedObject[item.id] = valueGetter(item);
        return keyedObject;
    }, {});
}
const $7a55ff9c881e37e5$export$b474714fac955e7c = (flags)=>{
    return $7a55ff9c881e37e5$export$254798ec7ef71406(flags, (item)=>$7a55ff9c881e37e5$export$30a0bf30ea993fb(item.value));
};


function $f1239c91f558df40$var$normalizeValue(rawValue) {
    if (typeof rawValue === 'object' && 'value' in rawValue) return {
        ...rawValue.explanation ? {
            explanation: {
                ...rawValue.explanation
            }
        } : {},
        value: (0, $7a55ff9c881e37e5$export$30a0bf30ea993fb)(rawValue.value)
    };
    else return {
        value: (0, $7a55ff9c881e37e5$export$30a0bf30ea993fb)(rawValue),
        explanation: undefined
    };
}
const $f1239c91f558df40$var$noopAnalyticsHandler = {
    sendOperationalEvent: (_event)=>Promise.resolve()
};
const $f1239c91f558df40$export$8c9b5e98a87ea54c = (0, $34Zxt.default)((flags, platformFlags)=>{
    const normalizedFeatureFlags = flags ? (0, $7a55ff9c881e37e5$export$254798ec7ef71406)(flags, $f1239c91f558df40$var$normalizeValue) : {};
    const normalizedPlatformFeatureFlags = platformFlags != null ? (0, $7a55ff9c881e37e5$export$254798ec7ef71406)(platformFlags, $f1239c91f558df40$var$normalizeValue) : {};
    Object.assign(normalizedFeatureFlags, normalizedPlatformFeatureFlags);
    const featureFlagClient = new (0, $eb0cfcd94dabfc57$export$2e2bcd8739ae039)({
        flags: normalizedFeatureFlags,
        analyticsHandler: $f1239c91f558df40$var$noopAnalyticsHandler
    });
    // This sets up tooling for the editor experiments
    (0, $3309bcde17ef7513$export$1c2b6dbf79eb3560)('confluence');
    // This sets up the platform feature flags
    (0, $cnjKG.setBooleanFeatureFlagResolver)((flagKey)=>{
        // eslint-disable-next-line confluence-feature-gating/static-feature-gates
        if ((0, $3df4286e75ff1ab6$export$b40ec24ac8275656)(flagKey)) return true;
        return false;
    });
    const allFlags = flags.concat(platformFlags);
    const original = (0, $7a55ff9c881e37e5$export$b474714fac955e7c)(allFlags);
    return {
        originalFeatureFlags: original,
        featureFlagsWithOverrides: original,
        featureFlagClient: featureFlagClient
    };
});


const $2800afeb4fc22c91$export$3aa1d70b86d65666 = ()=>$2800afeb4fc22c91$export$48ea97dcec207a60(null);
function $2800afeb4fc22c91$export$48ea97dcec207a60(data) {
    const { originalFeatureFlags: originalFeatureFlags, featureFlagsWithOverrides: featureFlagsWithOverrides, featureFlagClient: featureFlagClient } = (0, $f1239c91f558df40$export$8c9b5e98a87ea54c)([], []);
    // nullability of `tenant` is probably a schema issue
    // `userForAnalytics.id` would probably never be null, follow up with Xiao
    const confluenceLocale = data?.user?.confluence?.locale?.replace('_', '-');
    return {
        shard: data?.tenant?.shard || '',
        cloudId: data?.tenant?.cloudId || '',
        activationId: data?.tenant?.activationId || '',
        orgId: data?.organization?.orgId || undefined,
        environment: data?.tenant?.environment || 'PRODUCTION',
        edition: data?.confluence_tenantContext?.editions?.confluence || null,
        userId: data?.user?.id || null,
        displayName: data?.user?.displayName || null,
        isLoggedIn: Boolean(data?.user?.id),
        // CCP-472: This is for JSD users who are unlicensed for
        // Confluence usage. In that case, we need to skip
        // `WatchDialogQuery` as they are causing NullPointerExceptions
        // in the BE.
        isLicensed: Boolean(data?.user?.confluence?.accountId && data?.user?.confluence?.userKey),
        accessStatus: data?.user?.confluence?.accessStatus || null,
        userIdForAnalytics: data?.userForAnalytics?.id || null,
        featureFlags: featureFlagsWithOverrides,
        featureFlagClient: featureFlagClient,
        _originalFeatureFlags: originalFeatureFlags,
        locale: confluenceLocale || 'en-US',
        timeZone: data?.user?.timeZone || null,
        tenantTimeZone: data?.confluence_tenantContext?.timeZone || null,
        isAdminHubAIEnabled: Boolean(data?.getAIConfig?.isEnabled),
        isRovoEnabled: Boolean(data?.getAIConfig?.isRovoEnabled),
        isRovoLLMEnabled: Boolean(data?.getAIConfig?.isRovoLLMEnabled),
        monolithRegion: data?.confluence_tenantContext?.monolithRegion || null
    };
}


/* eslint-disable no-dupe-class-members */ class $e2dc1797b8fbbb8b$export$31c6869b8bca23f6 {
    run(name, fn) {
        const names = Array.isArray(name) ? name : [
            name
        ];
        names.forEach((name)=>this.markMeasureStart(name));
        const result = fn();
        if (typeof result?.then === 'function') // eslint-disable-next-line @typescript-eslint/no-floating-promises
        result.finally(()=>{
            names.forEach((name)=>this.markMeasureEnd(name));
        });
        else names.forEach((name)=>this.markMeasureEnd(name));
        return result;
    }
    markMeasureStart(name, timestamp) {
        //if startTime already marked, don't mark again.
        if (this.measures[name]?.startTime) return;
        this.measures[name] = {
            startTime: Math.floor(timestamp ?? performance.now()),
            duration: 0
        };
    }
    markMeasureEnd(name, timestamp, allowEndOnly = false) {
        const entry = this.measures[name];
        if (!entry?.duration && entry?.startTime) entry.duration = Math.floor((timestamp ?? performance.now()) - entry.startTime);
        else if (!entry && allowEndOnly) // In allowEndOnly mode we take FIRST end time as duration
        this.measures[name] = {
            startTime: 0,
            duration: timestamp ?? performance.now()
        };
    }
    getMeasures() {
        return this.measures;
    }
    clearMeasures() {
        this.measures = {};
    }
    constructor(){
        this.measures = {};
    }
}


class $47c7a260b3a5dfb3$var$SSRMeasure extends (0, $e2dc1797b8fbbb8b$export$31c6869b8bca23f6) {
    fetchCountIncr() {
        this.fetchCount++;
    }
    getFetchCount() {
        return this.fetchCount;
    }
    errorCountIncr() {
        this.errorCount++;
    }
    getErrorCount() {
        return this.errorCount;
    }
    operationsCountIncr() {
        this.operationsCount++;
    }
    getOperationsCount() {
        return this.operationsCount;
    }
    setStartTime(startTimeOffset = 0) {
        this.startTimeOffset = startTimeOffset;
        if (!this.startTime) this.startTime = Math.floor(performance.now());
    }
    getStartTime() {
        return this.startTime;
    }
    nowFromStartTime() {
        return Math.floor(performance.now()) - this.startTime;
    }
    now() {
        return this.nowFromStartTime() + this.startTimeOffset;
    }
    setMeasureDuration(name, duration) {
        const entry = this.measures[name];
        if (entry) entry.duration = duration;
    }
    addMeasure(name, duration, offsetStartByDuration = false) {
        if (this.measures[name]) return;
        this.measures[name] = {
            startTime: offsetStartByDuration ? this.now() - duration : this.now(),
            duration: duration
        };
    }
    markMeasureStart(name) {
        if (!this.measures[name]) this.measures[name] = {
            startTime: this.now(),
            duration: 0
        };
    }
    markMeasureEnd(name) {
        const entry = this.measures[name];
        if (entry) entry.duration = this.now() - entry.startTime;
    }
    clearMeasures() {
        this.startTimeOffset = 0;
        this.startTime = 0;
        this.fetchCount = 0;
        this.errorCount = 0;
        this.operationsCount = 0;
        this.measures = {};
    }
    constructor(...args){
        super(...args);
        this.startTimeOffset = 0;
        this.startTime = 0;
        // fetch count (counts batched operations as one fetch)
        this.fetchCount = 0;
        // total operations (counts individual operations even in batched operations)
        this.operationsCount = 0;
        this.errorCount = 0;
    }
}
const $47c7a260b3a5dfb3$export$5467c8c7fa0f4d06 = new $47c7a260b3a5dfb3$var$SSRMeasure();




var $gqzfn = parcelRequire("gqzfn");

function $8001e21998d25cdc$export$93aea9a3d680252e(error, statusCode, statusCodeAlternative) {
    if (error) {
        if ((0, $cb292de0bef73a33$export$17f5e6bd290bb15d)(error)) return error.graphQLErrors?.some((graphQLError)=>$8001e21998d25cdc$var$isStatusCodeNonApolloError(graphQLError, statusCode, statusCodeAlternative)) || $8001e21998d25cdc$var$isStatusCodeNonApolloError(error?.networkError, statusCode, statusCodeAlternative);
        return $8001e21998d25cdc$var$isStatusCodeNonApolloError(error, statusCode, statusCodeAlternative);
    }
    return false;
}
function $8001e21998d25cdc$export$4b7f1fcb987c29b8(error) {
    if (error) {
        if ((0, $cb292de0bef73a33$export$17f5e6bd290bb15d)(error)) {
            for (const graphQLError of error?.graphQLErrors || []){
                const result = $8001e21998d25cdc$var$getStatusCodeNonApolloError(graphQLError);
                if (result) return result;
            }
            const networkErrorStatusCode = $8001e21998d25cdc$var$getStatusCodeNonApolloError(error?.networkError);
            if (networkErrorStatusCode) return networkErrorStatusCode;
        }
        return $8001e21998d25cdc$var$getStatusCodeNonApolloError(error);
    }
    return undefined;
}
function $8001e21998d25cdc$var$isStatusCodeNonApolloError(error, statusCode, statusCodeAlternative) {
    if (error) {
        if ($8001e21998d25cdc$export$68868794c9b58e55(error) === statusCode || statusCodeAlternative?.(error)) return true;
        const { originalError: originalError } = error;
        if (originalError) return $8001e21998d25cdc$export$93aea9a3d680252e(originalError, statusCode, statusCodeAlternative);
    }
    return false;
}
function $8001e21998d25cdc$var$getStatusCodeNonApolloError(error) {
    if (error) {
        const result = $8001e21998d25cdc$export$68868794c9b58e55(error);
        if (result) return result;
        const { originalError: originalError } = error;
        if (originalError) return $8001e21998d25cdc$export$68868794c9b58e55(originalError);
    }
    return undefined;
}
function $8001e21998d25cdc$export$68868794c9b58e55(error) {
    if (error) {
        let status = error?.response?.status;
        if (status == null) {
            const { extensions: extensions } = error;
            if (extensions) status = extensions.statusCode || extensions.http?.status;
        }
        // Coercing to string because backend is inconsistent in the response type,
        // both string and number have been seen in practice:
        return status?.toString();
    }
    return undefined;
}



var $gqzfn = parcelRequire("gqzfn");

var $gqzfn = parcelRequire("gqzfn");
const $4aa6efa966e6f6e4$export$6ae4df695e19c5 = (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createContext(()=>false);
$4aa6efa966e6f6e4$export$6ae4df695e19c5.displayName = 'KnownErrorBoundaryContext';


class $13120d3a5460a891$export$a6c66dc6b08c87fe extends (0, $gqzfn.Component) {
    componentDidCatch(error) {
        if (this.props.isKnownError(error)) {
            this.props.onError?.(error);
            this.setState({
                error: error
            });
        } else throw error;
    }
    render() {
        const { error: error } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement((0, $4aa6efa966e6f6e4$export$6ae4df695e19c5).Consumer, null, (willCatch)=>{
            this.willParentCatch = willCatch;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement((0, $4aa6efa966e6f6e4$export$6ae4df695e19c5).Provider, {
                value: this.willCatch
            }, error ? this.props.renderOnError(error) : this.props.children);
        });
    }
    constructor(...args){
        super(...args);
        this.willParentCatch = void 0;
        this.state = {
            error: null
        };
        this.willCatch = (error)=>Boolean(this.props.isKnownError(error) || this.willParentCatch?.(error));
    }
}


const $6e2aeba1bc095709$export$616870549cbd985 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement((0, $13120d3a5460a891$export$a6c66dc6b08c87fe), {
        isKnownError: $6e2aeba1bc095709$export$55152de1f925fd05,
        ...props
    });
/**
 * https://pug.jira-dev.com/wiki/spaces/CCB/pages/4709260932/GraphQL+Errors+Contract+for+Status+Code+401+and+403
 */ const $6e2aeba1bc095709$var$isLegacyUnauthorizedGraphQLError = (error)=>error?.extensions?.data?.authorized === false;
const $6e2aeba1bc095709$export$55152de1f925fd05 = (error)=>(0, $8001e21998d25cdc$export$93aea9a3d680252e)(error, '403', $6e2aeba1bc095709$var$isLegacyUnauthorizedGraphQLError);





function $4b7988ce40c8fd3c$var$onGraphqlError(error) {
    (0, $d1c1e8e192b1a688$export$39a3b7739331403b)().submitError(error, {
        attribution: 'graphql'
    });
}
// NOTE: use `Symbol.for(...)` here because this module is bundled into two separate
// chunks - preloader and main app. Creating it via `Symbol(...)` will result in two
// different symbols, so errors that are handled in the preloader won't be identified
// as handled in the main app.
const $4b7988ce40c8fd3c$var$HANDLED_ERROR_MARK_SYMBOL = Symbol.for('error marked as handled');
class $4b7988ce40c8fd3c$export$bba8f5318e9cae27 {
    scheduleErrorReporting(error) {
        const timeoutId = window.setTimeout(()=>{
            // NOTE: This is an extra measure to prevent over-reporting of an otherwise handled error.
            // When query is preloaded and errors out, the reporting is scheduled by onErrorLink from
            // both preloader and from the place where query data is processed, but `errorsToHandle`
            // would only contain the entry of the error mapped to the latest timeoutId.
            if (this.isErrorMarkedAsHandled(error)) return;
            this.errorHandler(error);
            $4b7988ce40c8fd3c$export$702f853386561b84(error);
        }, this.gracefulHandlingPeriodMs);
        this.errorsToHandle.set(error, timeoutId);
    }
    // eslint-disable-next-line no-useless-constructor
    constructor(gracefulHandlingPeriodMs, errorHandler){
        this.gracefulHandlingPeriodMs = gracefulHandlingPeriodMs;
        this.errorHandler = errorHandler;
        // map of Error to timeoutId of when the generic error handling will kick-off
        this.errorsToHandle = new Map();
        this.processError = (error)=>{
            if (error) this.scheduleErrorReporting(error);
        };
        this.isErrorMarkedAsHandled = (error)=>{
            if (!error) return false;
            if (typeof error !== 'object') return false;
            return Boolean(error[$4b7988ce40c8fd3c$var$HANDLED_ERROR_MARK_SYMBOL]);
        };
        this.markErrorAsHandled = (error)=>{
            if (!error) return;
            if ((0, $cb292de0bef73a33$export$17f5e6bd290bb15d)(error)) {
                (error.graphQLErrors || []).forEach((e)=>this.markErrorAsHandled(e));
                this.markErrorAsHandled(error.networkError);
            }
            const timeoutId = this.errorsToHandle.get(error);
            if (typeof error === 'object') error[$4b7988ce40c8fd3c$var$HANDLED_ERROR_MARK_SYMBOL] = true;
            window.clearTimeout(timeoutId);
            this.errorsToHandle.delete(error);
        };
    }
}
const $4b7988ce40c8fd3c$var$GRACEFUL_ERROR_HANDLING_PERIOD_MS = 100;
// GraphqlErrorProcessor is stateful and should be a singleton. Given that this module
// is bundled into two separate chunks - preloader and main app, we need to make sure
// that the same instance is used in both places.
const $4b7988ce40c8fd3c$var$graphqlErrorProcessor = new $4b7988ce40c8fd3c$export$bba8f5318e9cae27($4b7988ce40c8fd3c$var$GRACEFUL_ERROR_HANDLING_PERIOD_MS, $4b7988ce40c8fd3c$var$onGraphqlError);
const $4b7988ce40c8fd3c$export$db43d00048f0afe4 = $4b7988ce40c8fd3c$var$GRACEFUL_ERROR_HANDLING_PERIOD_MS;
const $4b7988ce40c8fd3c$export$702f853386561b84 = $4b7988ce40c8fd3c$var$graphqlErrorProcessor.markErrorAsHandled;
const $4b7988ce40c8fd3c$export$792efb60958ecf86 = $4b7988ce40c8fd3c$var$graphqlErrorProcessor.isErrorMarkedAsHandled;
const $4b7988ce40c8fd3c$export$83457a6c00af4df7 = $4b7988ce40c8fd3c$var$graphqlErrorProcessor.processError;


/** @graphql cc **/ 
var $3UfL2 = parcelRequire("3UfL2");

function $439af9fbfc6ab5b0$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $82b332e4f5a9572d$export$92d6ed0888e7cb7f)("Syntax Error: ".concat(description), undefined, source, [
        position
    ]);
}


/**
 * The set of allowed kind values for AST nodes.
 */ var $3b2c3a9842dd7a21$export$a84bdc57c5122798 = Object.freeze({
    // Name
    NAME: 'Name',
    // Document
    DOCUMENT: 'Document',
    OPERATION_DEFINITION: 'OperationDefinition',
    VARIABLE_DEFINITION: 'VariableDefinition',
    SELECTION_SET: 'SelectionSet',
    FIELD: 'Field',
    ARGUMENT: 'Argument',
    // Fragments
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_FRAGMENT: 'InlineFragment',
    FRAGMENT_DEFINITION: 'FragmentDefinition',
    // Values
    VARIABLE: 'Variable',
    INT: 'IntValue',
    FLOAT: 'FloatValue',
    STRING: 'StringValue',
    BOOLEAN: 'BooleanValue',
    NULL: 'NullValue',
    ENUM: 'EnumValue',
    LIST: 'ListValue',
    OBJECT: 'ObjectValue',
    OBJECT_FIELD: 'ObjectField',
    // Directives
    DIRECTIVE: 'Directive',
    // Types
    NAMED_TYPE: 'NamedType',
    LIST_TYPE: 'ListType',
    NON_NULL_TYPE: 'NonNullType',
    // Type System Definitions
    SCHEMA_DEFINITION: 'SchemaDefinition',
    OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
    // Type Definitions
    SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
    OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
    FIELD_DEFINITION: 'FieldDefinition',
    INPUT_VALUE_DEFINITION: 'InputValueDefinition',
    INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
    UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
    ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
    ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
    INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
    // Directive Definitions
    DIRECTIVE_DEFINITION: 'DirectiveDefinition',
    // Type System Extensions
    SCHEMA_EXTENSION: 'SchemaExtension',
    // Type Extensions
    SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
    OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
    INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
    UNION_TYPE_EXTENSION: 'UnionTypeExtension',
    ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
    INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
}); /**
 * The enum type representing the possible kind values of AST nodes.
 */ 



var $he0fy = parcelRequire("he0fy");
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $95835c63c923c213$export$8b9d26ab11394711 = Object.freeze({
    SOF: '<SOF>',
    EOF: '<EOF>',
    BANG: '!',
    DOLLAR: '$',
    AMP: '&',
    PAREN_L: '(',
    PAREN_R: ')',
    SPREAD: '...',
    COLON: ':',
    EQUALS: '=',
    AT: '@',
    BRACKET_L: '[',
    BRACKET_R: ']',
    BRACE_L: '{',
    PIPE: '|',
    BRACE_R: '}',
    NAME: 'Name',
    INT: 'Int',
    FLOAT: 'Float',
    STRING: 'String',
    BLOCK_STRING: 'BlockString',
    COMMENT: 'Comment'
}); /**
 * The enum type representing the token kinds values.
 */ 




var $hhVFx = parcelRequire("hhVFx");


function $d8c5dfdf174d875b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $d8c5dfdf174d875b$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $d8c5dfdf174d875b$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $d8c5dfdf174d875b$var$_typeof(obj);
}
var /**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 */ // See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
// See: https://webpack.js.org/guides/production/
$d8c5dfdf174d875b$export$2e2bcd8739ae039 = // eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
    return value instanceof constructor;
};


function $c135937af474ab09$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $c135937af474ab09$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c135937af474ab09$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c135937af474ab09$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $c135937af474ab09$export$1d2df86270c81ecb = /*#__PURE__*/ function() {
    function Source(body) {
        var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GraphQL request';
        var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            line: 1,
            column: 1
        };
        typeof body === 'string' || (0, $2ac49c6c2d445dcb$export$2e2bcd8739ae039)(0, "Body must be a string. Received: ".concat((0, $hhVFx.default)(body), "."));
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $2ac49c6c2d445dcb$export$2e2bcd8739ae039)(0, 'line in locationOffset is 1-indexed and must be positive.');
        this.locationOffset.column > 0 || (0, $2ac49c6c2d445dcb$export$2e2bcd8739ae039)(0, 'column in locationOffset is 1-indexed and must be positive.');
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    $c135937af474ab09$var$_createClass(Source, [
        {
            key: (0, $008c791512bded7b$export$5deadc579ccc7c9c),
            get: function get() {
                return 'Source';
            }
        }
    ]);
    return Source;
}();
function $c135937af474ab09$export$75135ee9ed6e435b(source) {
    return (0, $d8c5dfdf174d875b$export$2e2bcd8739ae039)(source, $c135937af474ab09$export$1d2df86270c81ecb);
}


/**
 * The set of allowed directive location values.
 */ var $870ee74bc34bd65f$export$b45ffd2948484c41 = Object.freeze({
    // Request Definitions
    QUERY: 'QUERY',
    MUTATION: 'MUTATION',
    SUBSCRIPTION: 'SUBSCRIPTION',
    FIELD: 'FIELD',
    FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
    FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
    INLINE_FRAGMENT: 'INLINE_FRAGMENT',
    VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
    // Type System Definitions
    SCHEMA: 'SCHEMA',
    SCALAR: 'SCALAR',
    OBJECT: 'OBJECT',
    FIELD_DEFINITION: 'FIELD_DEFINITION',
    ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
    INTERFACE: 'INTERFACE',
    UNION: 'UNION',
    ENUM: 'ENUM',
    ENUM_VALUE: 'ENUM_VALUE',
    INPUT_OBJECT: 'INPUT_OBJECT',
    INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
}); /**
 * The enum type representing the directive location values.
 */ 




var $he0fy = parcelRequire("he0fy");

/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */ function $21d0717fb5905509$export$fd88c0b652c46ccc(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = $21d0717fb5905509$export$3c95bfdc680af0c(rawString);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    var startLine = 0;
    while(startLine < lines.length && $21d0717fb5905509$var$isBlank(lines[startLine]))++startLine;
    var endLine = lines.length;
    while(endLine > startLine && $21d0717fb5905509$var$isBlank(lines[endLine - 1]))--endLine;
     // Return a string of the lines joined with U+000A.
    return lines.slice(startLine, endLine).join('\n');
}
function $21d0717fb5905509$var$isBlank(str) {
    for(var i = 0; i < str.length; ++i){
        if (str[i] !== ' ' && str[i] !== '\t') return false;
    }
    return true;
}
function $21d0717fb5905509$export$3c95bfdc680af0c(value) {
    var _commonIndent;
    var isFirstLine = true;
    var isEmptyLine = true;
    var indent = 0;
    var commonIndent = null;
    for(var i = 0; i < value.length; ++i)switch(value.charCodeAt(i)){
        case 13:
            //  \r
            if (value.charCodeAt(i + 1) === 10) ++i; // skip \r\n as one symbol
        // falls through
        case 10:
            //  \n
            isFirstLine = false;
            isEmptyLine = true;
            indent = 0;
            break;
        case 9:
        case 32:
            //  <space>
            ++indent;
            break;
        default:
            if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) commonIndent = indent;
            isEmptyLine = false;
    }
    return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
function $21d0717fb5905509$export$adb6ca997eeb1f45(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf('\n') === -1;
    var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
    var hasTrailingQuote = value[value.length - 1] === '"';
    var hasTrailingSlash = value[value.length - 1] === '\\';
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
    var result = ''; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += '\n' + indentation;
    result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;
    if (printAsMultipleLines) result += '\n';
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}


var $5a597531e6ab370d$export$6168dc8908a6c652 = /*#__PURE__*/ function() {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ function Lexer(source) {
        var startOfFileToken = new (0, $he0fy.Token)((0, $95835c63c923c213$export$8b9d26ab11394711).SOF, 0, 0, 0, 0, null);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ var _proto = Lexer.prototype;
    _proto.advance = function advance() {
        this.lastToken = this.token;
        var token = this.token = this.lookahead();
        return token;
    } /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ ;
    _proto.lookahead = function lookahead() {
        var token = this.token;
        if (token.kind !== (0, $95835c63c923c213$export$8b9d26ab11394711).EOF) do {
            var _token$next;
            // Note: next is only mutable during parsing, so we cast to allow this.
            token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = $5a597531e6ab370d$var$readToken(this, token);
        }while (token.kind === (0, $95835c63c923c213$export$8b9d26ab11394711).COMMENT);
        return token;
    };
    return Lexer;
}();
function $5a597531e6ab370d$export$59ac0f4da287406a(kind) {
    return kind === (0, $95835c63c923c213$export$8b9d26ab11394711).BANG || kind === (0, $95835c63c923c213$export$8b9d26ab11394711).DOLLAR || kind === (0, $95835c63c923c213$export$8b9d26ab11394711).AMP || kind === (0, $95835c63c923c213$export$8b9d26ab11394711).PAREN_L || kind === (0, $95835c63c923c213$export$8b9d26ab11394711).PAREN_R || kind === (0, $95835c63c923c213$export$8b9d26ab11394711).SPREAD || kind === (0, $95835c63c923c213$export$8b9d26ab11394711).COLON || kind === (0, $95835c63c923c213$export$8b9d26ab11394711).EQUALS || kind === (0, $95835c63c923c213$export$8b9d26ab11394711).AT || kind === (0, $95835c63c923c213$export$8b9d26ab11394711).BRACKET_L || kind === (0, $95835c63c923c213$export$8b9d26ab11394711).BRACKET_R || kind === (0, $95835c63c923c213$export$8b9d26ab11394711).BRACE_L || kind === (0, $95835c63c923c213$export$8b9d26ab11394711).PIPE || kind === (0, $95835c63c923c213$export$8b9d26ab11394711).BRACE_R;
}
function $5a597531e6ab370d$var$printCharCode(code) {
    return isNaN(code) ? (0, $95835c63c923c213$export$8b9d26ab11394711).EOF : code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"");
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $5a597531e6ab370d$var$readToken(lexer, prev) {
    var source = lexer.source;
    var body = source.body;
    var bodyLength = body.length;
    var pos = prev.end;
    while(pos < bodyLength){
        var code = body.charCodeAt(pos);
        var _line = lexer.line;
        var _col = 1 + pos - lexer.lineStart; // SourceCharacter
        switch(code){
            case 0xfeff:
            case 9:
            case 32:
            case 44:
                //  ,
                ++pos;
                continue;
            case 10:
                //  \n
                ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 13:
                //  \r
                if (body.charCodeAt(pos + 1) === 10) pos += 2;
                else ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 33:
                //  !
                return new (0, $he0fy.Token)((0, $95835c63c923c213$export$8b9d26ab11394711).BANG, pos, pos + 1, _line, _col, prev);
            case 35:
                //  #
                return $5a597531e6ab370d$var$readComment(source, pos, _line, _col, prev);
            case 36:
                //  $
                return new (0, $he0fy.Token)((0, $95835c63c923c213$export$8b9d26ab11394711).DOLLAR, pos, pos + 1, _line, _col, prev);
            case 38:
                //  &
                return new (0, $he0fy.Token)((0, $95835c63c923c213$export$8b9d26ab11394711).AMP, pos, pos + 1, _line, _col, prev);
            case 40:
                //  (
                return new (0, $he0fy.Token)((0, $95835c63c923c213$export$8b9d26ab11394711).PAREN_L, pos, pos + 1, _line, _col, prev);
            case 41:
                //  )
                return new (0, $he0fy.Token)((0, $95835c63c923c213$export$8b9d26ab11394711).PAREN_R, pos, pos + 1, _line, _col, prev);
            case 46:
                //  .
                if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) return new (0, $he0fy.Token)((0, $95835c63c923c213$export$8b9d26ab11394711).SPREAD, pos, pos + 3, _line, _col, prev);
                break;
            case 58:
                //  :
                return new (0, $he0fy.Token)((0, $95835c63c923c213$export$8b9d26ab11394711).COLON, pos, pos + 1, _line, _col, prev);
            case 61:
                //  =
                return new (0, $he0fy.Token)((0, $95835c63c923c213$export$8b9d26ab11394711).EQUALS, pos, pos + 1, _line, _col, prev);
            case 64:
                //  @
                return new (0, $he0fy.Token)((0, $95835c63c923c213$export$8b9d26ab11394711).AT, pos, pos + 1, _line, _col, prev);
            case 91:
                //  [
                return new (0, $he0fy.Token)((0, $95835c63c923c213$export$8b9d26ab11394711).BRACKET_L, pos, pos + 1, _line, _col, prev);
            case 93:
                //  ]
                return new (0, $he0fy.Token)((0, $95835c63c923c213$export$8b9d26ab11394711).BRACKET_R, pos, pos + 1, _line, _col, prev);
            case 123:
                // {
                return new (0, $he0fy.Token)((0, $95835c63c923c213$export$8b9d26ab11394711).BRACE_L, pos, pos + 1, _line, _col, prev);
            case 124:
                // |
                return new (0, $he0fy.Token)((0, $95835c63c923c213$export$8b9d26ab11394711).PIPE, pos, pos + 1, _line, _col, prev);
            case 125:
                // }
                return new (0, $he0fy.Token)((0, $95835c63c923c213$export$8b9d26ab11394711).BRACE_R, pos, pos + 1, _line, _col, prev);
            case 34:
                //  "
                if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) return $5a597531e6ab370d$var$readBlockString(source, pos, _line, _col, prev, lexer);
                return $5a597531e6ab370d$var$readString(source, pos, _line, _col, prev);
            case 45:
            case 48:
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
                //  9
                return $5a597531e6ab370d$var$readNumber(source, pos, code, _line, _col, prev);
            case 65:
            case 66:
            case 67:
            case 68:
            case 69:
            case 70:
            case 71:
            case 72:
            case 73:
            case 74:
            case 75:
            case 76:
            case 77:
            case 78:
            case 79:
            case 80:
            case 81:
            case 82:
            case 83:
            case 84:
            case 85:
            case 86:
            case 87:
            case 88:
            case 89:
            case 90:
            case 95:
            case 97:
            case 98:
            case 99:
            case 100:
            case 101:
            case 102:
            case 103:
            case 104:
            case 105:
            case 106:
            case 107:
            case 108:
            case 109:
            case 110:
            case 111:
            case 112:
            case 113:
            case 114:
            case 115:
            case 116:
            case 117:
            case 118:
            case 119:
            case 120:
            case 121:
            case 122:
                // z
                return $5a597531e6ab370d$var$readName(source, pos, _line, _col, prev);
        }
        throw (0, $439af9fbfc6ab5b0$export$bbee0c6176c019d4)(source, pos, $5a597531e6ab370d$var$unexpectedCharacterMessage(code));
    }
    var line = lexer.line;
    var col = 1 + pos - lexer.lineStart;
    return new (0, $he0fy.Token)((0, $95835c63c923c213$export$8b9d26ab11394711).EOF, bodyLength, bodyLength, line, col, prev);
}
/**
 * Report a message that an unexpected character was encountered.
 */ function $5a597531e6ab370d$var$unexpectedCharacterMessage(code) {
    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) return "Cannot contain the invalid character ".concat($5a597531e6ab370d$var$printCharCode(code), ".");
    if (code === 39) // '
    return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
    return "Cannot parse the unexpected character ".concat($5a597531e6ab370d$var$printCharCode(code), ".");
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */ function $5a597531e6ab370d$var$readComment(source, start, line, col, prev) {
    var body = source.body;
    var code;
    var position = start;
    do code = body.charCodeAt(++position);
    while (!isNaN(code) && (code > 0x001f || code === 0x0009));
    return new (0, $he0fy.Token)((0, $95835c63c923c213$export$8b9d26ab11394711).COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */ function $5a597531e6ab370d$var$readNumber(source, start, firstCode, line, col, prev) {
    var body = source.body;
    var code = firstCode;
    var position = start;
    var isFloat = false;
    if (code === 45) // -
    code = body.charCodeAt(++position);
    if (code === 48) {
        // 0
        code = body.charCodeAt(++position);
        if (code >= 48 && code <= 57) throw (0, $439af9fbfc6ab5b0$export$bbee0c6176c019d4)(source, position, "Invalid number, unexpected digit after 0: ".concat($5a597531e6ab370d$var$printCharCode(code), "."));
    } else {
        position = $5a597531e6ab370d$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 46) {
        // .
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $5a597531e6ab370d$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 69 || code === 101) {
        // E e
        isFloat = true;
        code = body.charCodeAt(++position);
        if (code === 43 || code === 45) // + -
        code = body.charCodeAt(++position);
        position = $5a597531e6ab370d$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 46 || $5a597531e6ab370d$var$isNameStart(code)) throw (0, $439af9fbfc6ab5b0$export$bbee0c6176c019d4)(source, position, "Invalid number, expected digit but got: ".concat($5a597531e6ab370d$var$printCharCode(code), "."));
    return new (0, $he0fy.Token)(isFloat ? (0, $95835c63c923c213$export$8b9d26ab11394711).FLOAT : (0, $95835c63c923c213$export$8b9d26ab11394711).INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */ function $5a597531e6ab370d$var$readDigits(source, start, firstCode) {
    var body = source.body;
    var position = start;
    var code = firstCode;
    if (code >= 48 && code <= 57) {
        // 0 - 9
        do code = body.charCodeAt(++position);
        while (code >= 48 && code <= 57); // 0 - 9
        return position;
    }
    throw (0, $439af9fbfc6ab5b0$export$bbee0c6176c019d4)(source, position, "Invalid number, expected digit but got: ".concat($5a597531e6ab370d$var$printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */ function $5a597531e6ab370d$var$readString(source, start, line, col, prev) {
    var body = source.body;
    var position = start + 1;
    var chunkStart = position;
    var code = 0;
    var value = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
    code !== 0x000a && code !== 0x000d){
        // Closing Quote (")
        if (code === 34) {
            value += body.slice(chunkStart, position);
            return new (0, $he0fy.Token)((0, $95835c63c923c213$export$8b9d26ab11394711).STRING, start, position + 1, line, col, prev, value);
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009) throw (0, $439af9fbfc6ab5b0$export$bbee0c6176c019d4)(source, position, "Invalid character within String: ".concat($5a597531e6ab370d$var$printCharCode(code), "."));
        ++position;
        if (code === 92) {
            // \
            value += body.slice(chunkStart, position - 1);
            code = body.charCodeAt(position);
            switch(code){
                case 34:
                    value += '"';
                    break;
                case 47:
                    value += '/';
                    break;
                case 92:
                    value += '\\';
                    break;
                case 98:
                    value += '\b';
                    break;
                case 102:
                    value += '\f';
                    break;
                case 110:
                    value += '\n';
                    break;
                case 114:
                    value += '\r';
                    break;
                case 116:
                    value += '\t';
                    break;
                case 117:
                    // uXXXX
                    var charCode = $5a597531e6ab370d$var$uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));
                    if (charCode < 0) {
                        var invalidSequence = body.slice(position + 1, position + 5);
                        throw (0, $439af9fbfc6ab5b0$export$bbee0c6176c019d4)(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
                    }
                    value += String.fromCharCode(charCode);
                    position += 4;
                    break;
                default:
                    throw (0, $439af9fbfc6ab5b0$export$bbee0c6176c019d4)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
            }
            ++position;
            chunkStart = position;
        }
    }
    throw (0, $439af9fbfc6ab5b0$export$bbee0c6176c019d4)(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */ function $5a597531e6ab370d$var$readBlockString(source, start, line, col, prev, lexer) {
    var body = source.body;
    var position = start + 3;
    var chunkStart = position;
    var code = 0;
    var rawValue = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position))){
        // Closing Triple-Quote (""")
        if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
            rawValue += body.slice(chunkStart, position);
            return new (0, $he0fy.Token)((0, $95835c63c923c213$export$8b9d26ab11394711).BLOCK_STRING, start, position + 3, line, col, prev, (0, $21d0717fb5905509$export$fd88c0b652c46ccc)(rawValue));
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) throw (0, $439af9fbfc6ab5b0$export$bbee0c6176c019d4)(source, position, "Invalid character within String: ".concat($5a597531e6ab370d$var$printCharCode(code), "."));
        if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if (body.charCodeAt(position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
            rawValue += body.slice(chunkStart, position) + '"""';
            position += 4;
            chunkStart = position;
        } else ++position;
    }
    throw (0, $439af9fbfc6ab5b0$export$bbee0c6176c019d4)(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */ function $5a597531e6ab370d$var$uniCharCode(a, b, c, d) {
    return $5a597531e6ab370d$var$char2hex(a) << 12 | $5a597531e6ab370d$var$char2hex(b) << 8 | $5a597531e6ab370d$var$char2hex(c) << 4 | $5a597531e6ab370d$var$char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */ function $5a597531e6ab370d$var$char2hex(a) {
    return a >= 48 && a <= 57 ? a - 48 // 0-9
     : a >= 65 && a <= 70 ? a - 55 // A-F
     : a >= 97 && a <= 102 ? a - 87 // a-f
     : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */ function $5a597531e6ab370d$var$readName(source, start, line, col, prev) {
    var body = source.body;
    var bodyLength = body.length;
    var position = start + 1;
    var code = 0;
    while(position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
    code >= 48 && code <= 57 || // 0-9
    code >= 65 && code <= 90 || // A-Z
    code >= 97 && code <= 122 // a-z
    ))++position;
    return new (0, $he0fy.Token)((0, $95835c63c923c213$export$8b9d26ab11394711).NAME, start, position, line, col, prev, body.slice(start, position));
} // _ A-Z a-z
function $5a597531e6ab370d$var$isNameStart(code) {
    return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}


function $6c1b0252a3200a99$export$98e6a39c04603d36(source, options) {
    var parser = new $6c1b0252a3200a99$export$7acfa6ed01010e37(source, options);
    return parser.parseDocument();
}
function $6c1b0252a3200a99$export$5303528d1070ff6f(source, options) {
    var parser = new $6c1b0252a3200a99$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $95835c63c923c213$export$8b9d26ab11394711).SOF);
    var value = parser.parseValueLiteral(false);
    parser.expectToken((0, $95835c63c923c213$export$8b9d26ab11394711).EOF);
    return value;
}
function $6c1b0252a3200a99$export$28b8f402ccc88182(source, options) {
    var parser = new $6c1b0252a3200a99$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $95835c63c923c213$export$8b9d26ab11394711).SOF);
    var type = parser.parseTypeReference();
    parser.expectToken((0, $95835c63c923c213$export$8b9d26ab11394711).EOF);
    return type;
}
var $6c1b0252a3200a99$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser(source, options) {
        var sourceObj = (0, $c135937af474ab09$export$75135ee9ed6e435b)(source) ? source : new (0, $c135937af474ab09$export$1d2df86270c81ecb)(source);
        this._lexer = new (0, $5a597531e6ab370d$export$6168dc8908a6c652)(sourceObj);
        this._options = options;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ var _proto = Parser.prototype;
    _proto.parseName = function parseName() {
        var token = this.expectToken((0, $95835c63c923c213$export$8b9d26ab11394711).NAME);
        return {
            kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).NAME,
            value: token.value,
            loc: this.loc(token)
        };
    } // Implements the parsing rules in the Document section.
     /**
   * Document : Definition+
   */ ;
    _proto.parseDocument = function parseDocument() {
        var start = this._lexer.token;
        return {
            kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).DOCUMENT,
            definitions: this.many((0, $95835c63c923c213$export$8b9d26ab11394711).SOF, this.parseDefinition, (0, $95835c63c923c213$export$8b9d26ab11394711).EOF),
            loc: this.loc(start)
        };
    } /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   */ ;
    _proto.parseDefinition = function parseDefinition() {
        if (this.peek((0, $95835c63c923c213$export$8b9d26ab11394711).NAME)) switch(this._lexer.token.value){
            case 'query':
            case 'mutation':
            case 'subscription':
                return this.parseOperationDefinition();
            case 'fragment':
                return this.parseFragmentDefinition();
            case 'schema':
            case 'scalar':
            case 'type':
            case 'interface':
            case 'union':
            case 'enum':
            case 'input':
            case 'directive':
                return this.parseTypeSystemDefinition();
            case 'extend':
                return this.parseTypeSystemExtension();
        }
        else if (this.peek((0, $95835c63c923c213$export$8b9d26ab11394711).BRACE_L)) return this.parseOperationDefinition();
        else if (this.peekDescription()) return this.parseTypeSystemDefinition();
        throw this.unexpected();
    } // Implements the parsing rules in the Operations section.
     /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ ;
    _proto.parseOperationDefinition = function parseOperationDefinition() {
        var start = this._lexer.token;
        if (this.peek((0, $95835c63c923c213$export$8b9d26ab11394711).BRACE_L)) return {
            kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).OPERATION_DEFINITION,
            operation: 'query',
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        var operation = this.parseOperationType();
        var name;
        if (this.peek((0, $95835c63c923c213$export$8b9d26ab11394711).NAME)) name = this.parseName();
        return {
            kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * OperationType : one of query mutation subscription
   */ ;
    _proto.parseOperationType = function parseOperationType() {
        var operationToken = this.expectToken((0, $95835c63c923c213$export$8b9d26ab11394711).NAME);
        switch(operationToken.value){
            case 'query':
                return 'query';
            case 'mutation':
                return 'mutation';
            case 'subscription':
                return 'subscription';
        }
        throw this.unexpected(operationToken);
    } /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ ;
    _proto.parseVariableDefinitions = function parseVariableDefinitions() {
        return this.optionalMany((0, $95835c63c923c213$export$8b9d26ab11394711).PAREN_L, this.parseVariableDefinition, (0, $95835c63c923c213$export$8b9d26ab11394711).PAREN_R);
    } /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseVariableDefinition = function parseVariableDefinition() {
        var start = this._lexer.token;
        return {
            kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $95835c63c923c213$export$8b9d26ab11394711).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $95835c63c923c213$export$8b9d26ab11394711).EQUALS) ? this.parseValueLiteral(true) : undefined,
            directives: this.parseDirectives(true),
            loc: this.loc(start)
        };
    } /**
   * Variable : $ Name
   */ ;
    _proto.parseVariable = function parseVariable() {
        var start = this._lexer.token;
        this.expectToken((0, $95835c63c923c213$export$8b9d26ab11394711).DOLLAR);
        return {
            kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).VARIABLE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } /**
   * SelectionSet : { Selection+ }
   */ ;
    _proto.parseSelectionSet = function parseSelectionSet() {
        var start = this._lexer.token;
        return {
            kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).SELECTION_SET,
            selections: this.many((0, $95835c63c923c213$export$8b9d26ab11394711).BRACE_L, this.parseSelection, (0, $95835c63c923c213$export$8b9d26ab11394711).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ ;
    _proto.parseSelection = function parseSelection() {
        return this.peek((0, $95835c63c923c213$export$8b9d26ab11394711).SPREAD) ? this.parseFragment() : this.parseField();
    } /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ ;
    _proto.parseField = function parseField() {
        var start = this._lexer.token;
        var nameOrAlias = this.parseName();
        var alias;
        var name;
        if (this.expectOptionalToken((0, $95835c63c923c213$export$8b9d26ab11394711).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return {
            kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $95835c63c923c213$export$8b9d26ab11394711).BRACE_L) ? this.parseSelectionSet() : undefined,
            loc: this.loc(start)
        };
    } /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ ;
    _proto.parseArguments = function parseArguments(isConst) {
        var item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $95835c63c923c213$export$8b9d26ab11394711).PAREN_L, item, (0, $95835c63c923c213$export$8b9d26ab11394711).PAREN_R);
    } /**
   * Argument[Const] : Name : Value[?Const]
   */ ;
    _proto.parseArgument = function parseArgument() {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $95835c63c923c213$export$8b9d26ab11394711).COLON);
        return {
            kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(false),
            loc: this.loc(start)
        };
    };
    _proto.parseConstArgument = function parseConstArgument() {
        var start = this._lexer.token;
        return {
            kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).ARGUMENT,
            name: this.parseName(),
            value: (this.expectToken((0, $95835c63c923c213$export$8b9d26ab11394711).COLON), this.parseValueLiteral(true)),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Fragments section.
     /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ ;
    _proto.parseFragment = function parseFragment() {
        var start = this._lexer.token;
        this.expectToken((0, $95835c63c923c213$export$8b9d26ab11394711).SPREAD);
        var hasTypeCondition = this.expectOptionalKeyword('on');
        if (!hasTypeCondition && this.peek((0, $95835c63c923c213$export$8b9d26ab11394711).NAME)) return {
            kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false),
            loc: this.loc(start)
        };
        return {
            kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ ;
    _proto.parseFragmentDefinition = function parseFragmentDefinition() {
        var _this$_options;
        var start = this._lexer.token;
        this.expectKeyword('fragment'); // Experimental support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) return {
            kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        return {
            kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentName : Name but not `on`
   */ ;
    _proto.parseFragmentName = function parseFragmentName() {
        if (this._lexer.token.value === 'on') throw this.unexpected();
        return this.parseName();
    } // Implements the parsing rules in the Values section.
     /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ ;
    _proto.parseValueLiteral = function parseValueLiteral(isConst) {
        var token = this._lexer.token;
        switch(token.kind){
            case (0, $95835c63c923c213$export$8b9d26ab11394711).BRACKET_L:
                return this.parseList(isConst);
            case (0, $95835c63c923c213$export$8b9d26ab11394711).BRACE_L:
                return this.parseObject(isConst);
            case (0, $95835c63c923c213$export$8b9d26ab11394711).INT:
                this._lexer.advance();
                return {
                    kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).INT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $95835c63c923c213$export$8b9d26ab11394711).FLOAT:
                this._lexer.advance();
                return {
                    kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).FLOAT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $95835c63c923c213$export$8b9d26ab11394711).STRING:
            case (0, $95835c63c923c213$export$8b9d26ab11394711).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $95835c63c923c213$export$8b9d26ab11394711).NAME:
                this._lexer.advance();
                switch(token.value){
                    case 'true':
                        return {
                            kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).BOOLEAN,
                            value: true,
                            loc: this.loc(token)
                        };
                    case 'false':
                        return {
                            kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).BOOLEAN,
                            value: false,
                            loc: this.loc(token)
                        };
                    case 'null':
                        return {
                            kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).NULL,
                            loc: this.loc(token)
                        };
                    default:
                        return {
                            kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).ENUM,
                            value: token.value,
                            loc: this.loc(token)
                        };
                }
            case (0, $95835c63c923c213$export$8b9d26ab11394711).DOLLAR:
                if (!isConst) return this.parseVariable();
                break;
        }
        throw this.unexpected();
    };
    _proto.parseStringLiteral = function parseStringLiteral() {
        var token = this._lexer.token;
        this._lexer.advance();
        return {
            kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).STRING,
            value: token.value,
            block: token.kind === (0, $95835c63c923c213$export$8b9d26ab11394711).BLOCK_STRING,
            loc: this.loc(token)
        };
    } /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ ;
    _proto.parseList = function parseList(isConst) {
        var _this = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this.parseValueLiteral(isConst);
        };
        return {
            kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).LIST,
            values: this.any((0, $95835c63c923c213$export$8b9d26ab11394711).BRACKET_L, item, (0, $95835c63c923c213$export$8b9d26ab11394711).BRACKET_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   */ ;
    _proto.parseObject = function parseObject(isConst) {
        var _this2 = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this2.parseObjectField(isConst);
        };
        return {
            kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).OBJECT,
            fields: this.any((0, $95835c63c923c213$export$8b9d26ab11394711).BRACE_L, item, (0, $95835c63c923c213$export$8b9d26ab11394711).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectField[Const] : Name : Value[?Const]
   */ ;
    _proto.parseObjectField = function parseObjectField(isConst) {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $95835c63c923c213$export$8b9d26ab11394711).COLON);
        return {
            kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Directives section.
     /**
   * Directives[Const] : Directive[?Const]+
   */ ;
    _proto.parseDirectives = function parseDirectives(isConst) {
        var directives = [];
        while(this.peek((0, $95835c63c923c213$export$8b9d26ab11394711).AT))directives.push(this.parseDirective(isConst));
        return directives;
    } /**
   * Directive[Const] : @ Name Arguments[?Const]?
   */ ;
    _proto.parseDirective = function parseDirective(isConst) {
        var start = this._lexer.token;
        this.expectToken((0, $95835c63c923c213$export$8b9d26ab11394711).AT);
        return {
            kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Types section.
     /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ ;
    _proto.parseTypeReference = function parseTypeReference() {
        var start = this._lexer.token;
        var type;
        if (this.expectOptionalToken((0, $95835c63c923c213$export$8b9d26ab11394711).BRACKET_L)) {
            type = this.parseTypeReference();
            this.expectToken((0, $95835c63c923c213$export$8b9d26ab11394711).BRACKET_R);
            type = {
                kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).LIST_TYPE,
                type: type,
                loc: this.loc(start)
            };
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $95835c63c923c213$export$8b9d26ab11394711).BANG)) return {
            kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).NON_NULL_TYPE,
            type: type,
            loc: this.loc(start)
        };
        return type;
    } /**
   * NamedType : Name
   */ ;
    _proto.parseNamedType = function parseNamedType() {
        var start = this._lexer.token;
        return {
            kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).NAMED_TYPE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Type Definition section.
     /**
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
        // Many definitions begin with a description and require a lookahead.
        var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $95835c63c923c213$export$8b9d26ab11394711).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaDefinition();
            case 'scalar':
                return this.parseScalarTypeDefinition();
            case 'type':
                return this.parseObjectTypeDefinition();
            case 'interface':
                return this.parseInterfaceTypeDefinition();
            case 'union':
                return this.parseUnionTypeDefinition();
            case 'enum':
                return this.parseEnumTypeDefinition();
            case 'input':
                return this.parseInputObjectTypeDefinition();
            case 'directive':
                return this.parseDirectiveDefinition();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.peekDescription = function peekDescription() {
        return this.peek((0, $95835c63c923c213$export$8b9d26ab11394711).STRING) || this.peek((0, $95835c63c923c213$export$8b9d26ab11394711).BLOCK_STRING);
    } /**
   * Description : StringValue
   */ ;
    _proto.parseDescription = function parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    } /**
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   */ ;
    _proto.parseSchemaDefinition = function parseSchemaDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.many((0, $95835c63c923c213$export$8b9d26ab11394711).BRACE_L, this.parseOperationTypeDefinition, (0, $95835c63c923c213$export$8b9d26ab11394711).BRACE_R);
        return {
            kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * OperationTypeDefinition : OperationType : NamedType
   */ ;
    _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
        var start = this._lexer.token;
        var operation = this.parseOperationType();
        this.expectToken((0, $95835c63c923c213$export$8b9d26ab11394711).COLON);
        var type = this.parseNamedType();
        return {
            kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ ;
    _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ ;
    _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
        var _this$_options2;
        if (!this.expectOptionalKeyword('implements')) return [];
        if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
            var types = []; // Optional leading ampersand
            this.expectOptionalToken((0, $95835c63c923c213$export$8b9d26ab11394711).AMP);
            do types.push(this.parseNamedType());
            while (this.expectOptionalToken((0, $95835c63c923c213$export$8b9d26ab11394711).AMP) || this.peek((0, $95835c63c923c213$export$8b9d26ab11394711).NAME));
            return types;
        }
        return this.delimitedMany((0, $95835c63c923c213$export$8b9d26ab11394711).AMP, this.parseNamedType);
    } /**
   * FieldsDefinition : { FieldDefinition+ }
   */ ;
    _proto.parseFieldsDefinition = function parseFieldsDefinition() {
        var _this$_options3;
        // Legacy support for the SDL?
        if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek((0, $95835c63c923c213$export$8b9d26ab11394711).BRACE_L) && this._lexer.lookahead().kind === (0, $95835c63c923c213$export$8b9d26ab11394711).BRACE_R) {
            this._lexer.advance();
            this._lexer.advance();
            return [];
        }
        return this.optionalMany((0, $95835c63c923c213$export$8b9d26ab11394711).BRACE_L, this.parseFieldDefinition, (0, $95835c63c923c213$export$8b9d26ab11394711).BRACE_R);
    } /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ ;
    _proto.parseFieldDefinition = function parseFieldDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        this.expectToken((0, $95835c63c923c213$export$8b9d26ab11394711).COLON);
        var type = this.parseTypeReference();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ ;
    _proto.parseArgumentDefs = function parseArgumentDefs() {
        return this.optionalMany((0, $95835c63c923c213$export$8b9d26ab11394711).PAREN_L, this.parseInputValueDef, (0, $95835c63c923c213$export$8b9d26ab11394711).PAREN_R);
    } /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseInputValueDef = function parseInputValueDef() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        this.expectToken((0, $95835c63c923c213$export$8b9d26ab11394711).COLON);
        var type = this.parseTypeReference();
        var defaultValue;
        if (this.expectOptionalToken((0, $95835c63c923c213$export$8b9d26ab11394711).EQUALS)) defaultValue = this.parseValueLiteral(true);
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ ;
    _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        return {
            kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ ;
    _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $95835c63c923c213$export$8b9d26ab11394711).EQUALS) ? this.delimitedMany((0, $95835c63c923c213$export$8b9d26ab11394711).PIPE, this.parseNamedType) : [];
    } /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ ;
    _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        return {
            kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * EnumValuesDefinition : { EnumValueDefinition+ }
   */ ;
    _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
        return this.optionalMany((0, $95835c63c923c213$export$8b9d26ab11394711).BRACE_L, this.parseEnumValueDefinition, (0, $95835c63c923c213$export$8b9d26ab11394711).BRACE_R);
    } /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   *
   * EnumValue : Name
   */ ;
    _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ ;
    _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        return {
            kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InputFieldsDefinition : { InputValueDefinition+ }
   */ ;
    _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
        return this.optionalMany((0, $95835c63c923c213$export$8b9d26ab11394711).BRACE_L, this.parseInputValueDef, (0, $95835c63c923c213$export$8b9d26ab11394711).BRACE_R);
    } /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
        var keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $95835c63c923c213$export$8b9d26ab11394711).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaExtension();
            case 'scalar':
                return this.parseScalarTypeExtension();
            case 'type':
                return this.parseObjectTypeExtension();
            case 'interface':
                return this.parseInterfaceTypeExtension();
            case 'union':
                return this.parseUnionTypeExtension();
            case 'enum':
                return this.parseEnumTypeExtension();
            case 'input':
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    } /**
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   */ ;
    _proto.parseSchemaExtension = function parseSchemaExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.optionalMany((0, $95835c63c923c213$export$8b9d26ab11394711).BRACE_L, this.parseOperationTypeDefinition, (0, $95835c63c923c213$export$8b9d26ab11394711).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return {
            kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ ;
    _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        if (directives.length === 0) throw this.unexpected();
        return {
            kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ ;
    _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ ;
    _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ ;
    _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return {
            kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ ;
    _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return {
            kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ ;
    _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   */ ;
    _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('directive');
        this.expectToken((0, $95835c63c923c213$export$8b9d26ab11394711).AT);
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        var repeatable = this.expectOptionalKeyword('repeatable');
        this.expectKeyword('on');
        var locations = this.parseDirectiveLocations();
        return {
            kind: (0, $3b2c3a9842dd7a21$export$a84bdc57c5122798).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations,
            loc: this.loc(start)
        };
    } /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ ;
    _proto.parseDirectiveLocations = function parseDirectiveLocations() {
        return this.delimitedMany((0, $95835c63c923c213$export$8b9d26ab11394711).PIPE, this.parseDirectiveLocation);
    } /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ ;
    _proto.parseDirectiveLocation = function parseDirectiveLocation() {
        var start = this._lexer.token;
        var name = this.parseName();
        if ((0, $870ee74bc34bd65f$export$b45ffd2948484c41)[name.value] !== undefined) return name;
        throw this.unexpected(start);
    } // Core parsing utility functions
     /**
   * Returns a location object, used to identify the place in the source that created a given parsed object.
   */ ;
    _proto.loc = function loc(startToken) {
        var _this$_options4;
        if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) return new (0, $he0fy.Location)(startToken, this._lexer.lastToken, this._lexer.source);
    } /**
   * Determines if the next token is of a given kind
   */ ;
    _proto.peek = function peek(kind) {
        return this._lexer.token.kind === kind;
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectToken = function expectToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        throw (0, $439af9fbfc6ab5b0$export$bbee0c6176c019d4)(this._lexer.source, token.start, "Expected ".concat($6c1b0252a3200a99$var$getTokenKindDesc(kind), ", found ").concat($6c1b0252a3200a99$var$getTokenDesc(token), "."));
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and return undefined.
   */ ;
    _proto.expectOptionalToken = function expectOptionalToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        return undefined;
    } /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectKeyword = function expectKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $95835c63c923c213$export$8b9d26ab11394711).NAME && token.value === value) this._lexer.advance();
        else throw (0, $439af9fbfc6ab5b0$export$bbee0c6176c019d4)(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat($6c1b0252a3200a99$var$getTokenDesc(token), "."));
    } /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ ;
    _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $95835c63c923c213$export$8b9d26ab11394711).NAME && token.value === value) {
            this._lexer.advance();
            return true;
        }
        return false;
    } /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ ;
    _proto.unexpected = function unexpected(atToken) {
        var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $439af9fbfc6ab5b0$export$bbee0c6176c019d4)(this._lexer.source, token.start, "Unexpected ".concat($6c1b0252a3200a99$var$getTokenDesc(token), "."));
    } /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.any = function any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    } /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            var nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.many = function many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ ;
    _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    };
    return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging.
 */ function $6c1b0252a3200a99$var$getTokenDesc(token) {
    var value = token.value;
    return $6c1b0252a3200a99$var$getTokenKindDesc(token.kind) + (value != null ? " \"".concat(value, "\"") : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $6c1b0252a3200a99$var$getTokenKindDesc(kind) {
    return (0, $5a597531e6ab370d$export$59ac0f4da287406a)(kind) ? "\"".concat(kind, "\"") : kind;
}


var $d7f2d52a706ecc0f$var$docCache = new Map();
var $d7f2d52a706ecc0f$var$fragmentSourceMap = new Map();
var $d7f2d52a706ecc0f$var$printFragmentWarnings = true;
var $d7f2d52a706ecc0f$var$experimentalFragmentVariables = false;
function $d7f2d52a706ecc0f$var$normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function $d7f2d52a706ecc0f$var$cacheKeyFromLoc(loc) {
    return $d7f2d52a706ecc0f$var$normalize(loc.source.body.substring(loc.start, loc.end));
}
function $d7f2d52a706ecc0f$var$processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function(fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = $d7f2d52a706ecc0f$var$cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = $d7f2d52a706ecc0f$var$fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if ($d7f2d52a706ecc0f$var$printFragmentWarnings) console.warn("Warning: fragment with name " + fragmentName + " already exists.\n" + "graphql-tag enforces all fragment names across your application to be unique; read more about\n" + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
            } else if (!sourceKeySet) $d7f2d52a706ecc0f$var$fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        } else definitions.push(fragmentDefinition);
    });
    return (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, ast), {
        definitions: definitions
    });
}
function $d7f2d52a706ecc0f$var$stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function(node) {
        if (node.loc) delete node.loc;
        Object.keys(node).forEach(function(key) {
            var value = node[key];
            if (value && typeof value === 'object') workSet.add(value);
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function $d7f2d52a706ecc0f$var$parseDocument(source) {
    var cacheKey = $d7f2d52a706ecc0f$var$normalize(source);
    if (!$d7f2d52a706ecc0f$var$docCache.has(cacheKey)) {
        var parsed = (0, $6c1b0252a3200a99$export$98e6a39c04603d36)(source, {
            experimentalFragmentVariables: $d7f2d52a706ecc0f$var$experimentalFragmentVariables,
            allowLegacyFragmentVariables: $d7f2d52a706ecc0f$var$experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') throw new Error('Not a valid GraphQL document.');
        $d7f2d52a706ecc0f$var$docCache.set(cacheKey, $d7f2d52a706ecc0f$var$stripLoc($d7f2d52a706ecc0f$var$processFragments(parsed)));
    }
    return $d7f2d52a706ecc0f$var$docCache.get(cacheKey);
}
function $d7f2d52a706ecc0f$export$72e4926bf8358653(literals) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (typeof literals === 'string') literals = [
        literals
    ];
    var result = literals[0];
    args.forEach(function(arg, i) {
        if (arg && arg.kind === 'Document') result += arg.loc.source.body;
        else result += arg;
        result += literals[i + 1];
    });
    return $d7f2d52a706ecc0f$var$parseDocument(result);
}
function $d7f2d52a706ecc0f$export$657554ef4dc7ac2d() {
    $d7f2d52a706ecc0f$var$docCache.clear();
    $d7f2d52a706ecc0f$var$fragmentSourceMap.clear();
}
function $d7f2d52a706ecc0f$export$e4294e638636c6ab() {
    $d7f2d52a706ecc0f$var$printFragmentWarnings = false;
}
function $d7f2d52a706ecc0f$export$78cf889af350c840() {
    $d7f2d52a706ecc0f$var$experimentalFragmentVariables = true;
}
function $d7f2d52a706ecc0f$export$5290df9bbbd3cfa() {
    $d7f2d52a706ecc0f$var$experimentalFragmentVariables = false;
}
var $d7f2d52a706ecc0f$var$extras = {
    gql: $d7f2d52a706ecc0f$export$72e4926bf8358653,
    resetCaches: $d7f2d52a706ecc0f$export$657554ef4dc7ac2d,
    disableFragmentWarnings: $d7f2d52a706ecc0f$export$e4294e638636c6ab,
    enableExperimentalFragmentVariables: $d7f2d52a706ecc0f$export$78cf889af350c840,
    disableExperimentalFragmentVariables: $d7f2d52a706ecc0f$export$5290df9bbbd3cfa
};
(function(gql_1) {
    gql_1.gql = $d7f2d52a706ecc0f$var$extras.gql, gql_1.resetCaches = $d7f2d52a706ecc0f$var$extras.resetCaches, gql_1.disableFragmentWarnings = $d7f2d52a706ecc0f$var$extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = $d7f2d52a706ecc0f$var$extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = $d7f2d52a706ecc0f$var$extras.disableExperimentalFragmentVariables;
})($d7f2d52a706ecc0f$export$72e4926bf8358653 || ($d7f2d52a706ecc0f$export$72e4926bf8358653 = {}));
$d7f2d52a706ecc0f$export$72e4926bf8358653["default"] = $d7f2d52a706ecc0f$export$72e4926bf8358653;
var $d7f2d52a706ecc0f$export$2e2bcd8739ae039 = $d7f2d52a706ecc0f$export$72e4926bf8358653;


const $61c0b2c7a276da71$export$e344c3770925712a = (0, $d7f2d52a706ecc0f$export$2e2bcd8739ae039)`query SiteInformationQuery{tenant{shard cloudId environment activationId}organization{orgId}userForAnalytics:confluence_atlassianUser{id}user:confluence_atlassianUser(current:true){id displayName confluence{accessStatus accountId userKey locale}timeZone}getAIConfig(product:CONFLUENCE){isEnabled isRovoEnabled isRovoLLMEnabled}confluence_tenantContext{licenseStates{confluence{ccpEntitlementId}}timeZone editions{confluence}monolithRegion}isSiteAdmin abTestCohorts experimentFeatures userCanCreateContent isNewUser siteSettings{homepage{uri title}siteTitle showApplicationTitle frontCover{frontCoverState}companyHubName}siteDescription{logoUrl}currentConfluenceUser{isAnonymous}}`;


function $b409c2781320251f$var$apolloQuery({ query: query, queryName: queryName, client: client = window.GLOBAL_APOLLO_CLIENT }) {
    if (!client) return Promise.reject(new Error(`ApolloClient not available, cannot load query ${queryName}`));
    return (0, $47c7a260b3a5dfb3$export$5467c8c7fa0f4d06).run(`ssr-app/prepare/preloadQuery/fetch:${queryName}`, async ()=>client.query({
            query: query,
            errorPolicy: 'all',
            fetchPolicy: 'cache-first',
            context: {
                single: false,
                allowOnExternalPage: true
            }
        }));
}
async function $b409c2781320251f$export$5ae208508f6870b() {
    // __SITEINFORMATION__ is either actual session data
    // or the promise that is resolving the session data
    // In the case when page is rendered by SSR, the __SITEINFORMATION__ will be populated with JSON data.
    if (window['__SITEINFORMATION__']) return window['__SITEINFORMATION__'];
    window['__SITEINFORMATION__'] = $b409c2781320251f$var$apolloQuery({
        query: (0, $61c0b2c7a276da71$export$e344c3770925712a),
        queryName: 'SiteInformationQuery'
    }).then((result)=>{
        const errors = result.errors ?? [];
        if (errors.length > 0) errors.forEach((e)=>{
            if ((0, $6e2aeba1bc095709$export$55152de1f925fd05)(e) && !!result?.data?.tenant?.cloudId) (0, $4b7988ce40c8fd3c$export$702f853386561b84)(e);
            else (0, $d1c1e8e192b1a688$export$39a3b7739331403b)().submitError(e, {
                isSiteInformationError: true,
                partialFailure: true,
                attribution: 'FATAL'
            });
        });
        return result.data;
    }).catch((error)=>{
        if (Array.isArray(error)) error.forEach((e)=>(0, $d1c1e8e192b1a688$export$39a3b7739331403b)().submitError(e, {
                isSiteInformationError: true,
                partialFailure: false,
                attribution: 'FATAL'
            }));
        else (0, $d1c1e8e192b1a688$export$39a3b7739331403b)().submitError(error, {
            isSiteInformationError: true,
            partialFailure: false,
            attribution: 'FATAL'
        });
        return null;
    });
    return window['__SITEINFORMATION__'];
}


const $b5780f5a758d6771$export$4163744babc94103 = ()=>{
    // Not using memorize here because we want to reset promise in test
    if (window['__SITEINFORMATION_PROMISE__']) return window['__SITEINFORMATION_PROMISE__'];
    return window['__SITEINFORMATION_PROMISE__'] = (0, $cd3135dd152096aa$export$cc373701aed148fc)((0, $b409c2781320251f$export$5ae208508f6870b)().then((0, $2800afeb4fc22c91$export$48ea97dcec207a60)));
};
const $b5780f5a758d6771$export$fdd2c0ba94025c3c = ()=>{
    const sessionDataPromise = $b5780f5a758d6771$export$4163744babc94103();
    if ((0, $cd3135dd152096aa$export$b1a2a6bd0c6f9666)(sessionDataPromise)) return (0, $cd3135dd152096aa$export$bf7199a9ebcb84a9)(sessionDataPromise)?.cloudId;
    else // Session data is not loaded yet, return null
    return null;
};
class $b5780f5a758d6771$export$14dde3d2ec7dfd8f extends (0, $gqzfn.Component) {
    componentWillUnmount() {
        this._mount = false;
    }
    render() {
        const { sessionData: sessionData } = this.state;
        if (sessionData) return this.props.children(sessionData);
        if (this.props.renderChildrenWhenLoading === true) return this.props.children({
            loading: true
        });
        return null;
    }
    constructor(props){
        super(props);
        this._mount = void 0;
        this.state = {};
        const promise = $b5780f5a758d6771$export$4163744babc94103();
        this._mount = true;
        if ((0, $cd3135dd152096aa$export$b1a2a6bd0c6f9666)(promise)) this.state = {
            sessionData: (0, $cd3135dd152096aa$export$bf7199a9ebcb84a9)(promise)
        };
        else promise.then((sessionData)=>{
            if (this._mount) this.setState({
                sessionData: sessionData
            });
        });
    }
}



const $a4b9a8903fd62c69$var$COMPANY_HUB_SPACE_KEY_PREFIX = '~HUB';
const $a4b9a8903fd62c69$export$5ab9c400208ad907 = (spaceKey)=>!!(spaceKey?.startsWith($a4b9a8903fd62c69$var$COMPANY_HUB_SPACE_KEY_PREFIX) && spaceKey?.endsWith('~'));
const $a4b9a8903fd62c69$export$6193f65d76fa4c00 = (sessionData)=>{
    if (!sessionData?.activationId || !sessionData?.cloudId) sessionData = (0, $cd3135dd152096aa$export$bf7199a9ebcb84a9)((0, $b5780f5a758d6771$export$4163744babc94103)());
    if (sessionData) {
        const { activationId: activationId, cloudId: cloudId } = sessionData;
        if (activationId && cloudId) return `${$a4b9a8903fd62c69$var$COMPANY_HUB_SPACE_KEY_PREFIX}-${cloudId}-${activationId}~`;
    }
    // We used to return undefined, but pretty much always we fell back to the empty string with code like `?? ''` or `|| ''`.
    // Instead of sprinkling noise like that all over, it's less complex to do the de facto fallback here.
    return '';
};
var $a4b9a8903fd62c69$export$8b92a390c1734cf9 = /*#__PURE__*/ function(FrontCoverStateEnum) {
    FrontCoverStateEnum["UNSET"] = "unset";
    FrontCoverStateEnum["HIDDEN"] = "hidden";
    FrontCoverStateEnum["EDITORS_ONLY"] = "editors_only";
    FrontCoverStateEnum["SHOWN"] = "shown";
    return FrontCoverStateEnum;
}({});
var $a4b9a8903fd62c69$export$ec1312b61cf60ef3 = /*#__PURE__*/ function(FrontCoverStateInputEnum) {
    FrontCoverStateInputEnum["UNSET"] = "UNSET";
    FrontCoverStateInputEnum["HIDDEN"] = "HIDDEN";
    FrontCoverStateInputEnum["SHOWN"] = "SHOWN";
    return FrontCoverStateInputEnum;
}({});


// Deep link visiting
const $d4b865e8cc459c1f$export$61f782d99db03c49 = 'follow-deep-link';
const $d4b865e8cc459c1f$export$ed2197e4948fef6c = 'view-macro-renderer';
const $d4b865e8cc459c1f$export$136d4e1bb3adaa98 = 'view-macro-editor';
const $d4b865e8cc459c1f$export$54747aca26cee3f8 = 'view-all-macro';
const $d4b865e8cc459c1f$export$f8afba90a5a815ad = 'view-jira-macro';
const $d4b865e8cc459c1f$export$87daa9a1b1dd910d = 'migrate-page';
const $d4b865e8cc459c1f$export$6c0a7d453b9ba427 = 'migrate-page/publish';
const $d4b865e8cc459c1f$export$b39a77dbc03575b1 = 'migrate-template';
const $d4b865e8cc459c1f$export$f94e85276e6d639f = 'add-page-comment';
const $d4b865e8cc459c1f$export$31bd7de6ca230764 = 'add-page-comment/load';
const $d4b865e8cc459c1f$export$4cb6cf73aff93e7d = 'add-page-comment/publish';
const $d4b865e8cc459c1f$export$2a99a63e28df64fd = 'edit-page-comment';
const $d4b865e8cc459c1f$export$515913089a77cb7c = 'edit-page-comment/load';
const $d4b865e8cc459c1f$export$c0906b23fa1e3b63 = 'edit-page-comment/publish';
const $d4b865e8cc459c1f$export$e9a5501ca0d5d256 = 'reply-to-page-comment';
const $d4b865e8cc459c1f$export$3fdffa656412b99a = 'reply-to-page-comment/load';
const $d4b865e8cc459c1f$export$bfebfbab40727cd6 = 'reply-to-page-comment/publish';
const $d4b865e8cc459c1f$export$91d50c2b267d0461 = 'delete-page-comment';
const $d4b865e8cc459c1f$export$24ef8c79de5598b9 = 'resolve-page-comment';
const $d4b865e8cc459c1f$export$8c6422f793f7efae = 'mark-comments-as-read';
const $d4b865e8cc459c1f$export$98dbdebd041da61c = 'mark-all-comments-as-read';
const $d4b865e8cc459c1f$export$6f58645a9a5f7936 = 'create-inline-comment';
const $d4b865e8cc459c1f$export$8180a49fb6c681b1 = 'create-inline-comment/init';
const $d4b865e8cc459c1f$export$ed5e210bce3a41a9 = 'create-inline-comment/draft-to-publish';
const $d4b865e8cc459c1f$export$db23cb60632b0aa0 = 'create-inline-comment/attach-comment';
const $d4b865e8cc459c1f$export$f8e0e16825f0d222 = 'select-inline-comment';
const $d4b865e8cc459c1f$export$2003fd9c8f509d96 = 'add-inline-comment';
const $d4b865e8cc459c1f$export$a69ecd33d83d56ce = 'add-inline-comment/load';
const $d4b865e8cc459c1f$export$eb89dbd7422d8194 = 'add-inline-comment/publish';
const $d4b865e8cc459c1f$export$29c433981d13c955 = 'edit-inline-comment';
const $d4b865e8cc459c1f$export$a557d8a611f835b = 'edit-inline-comment/load';
const $d4b865e8cc459c1f$export$e9dafdd46fb3d4ed = 'edit-inline-comment/publish';
const $d4b865e8cc459c1f$export$20fbac00cba3c8a = 'view-inline-comment';
const $d4b865e8cc459c1f$export$533f2a7cfe4f757e = 'view-inline-comment/toplevel';
const $d4b865e8cc459c1f$export$fb1f28583d577755 = 'view-inline-comment/reply';
const $d4b865e8cc459c1f$export$9d157677f817543f = 'reply-to-inline-comment';
const $d4b865e8cc459c1f$export$b4f2ad99abb89883 = 'reply-to-inline-comment/load';
const $d4b865e8cc459c1f$export$32059abd767a1104 = 'reply-to-inline-comment/publish';
const $d4b865e8cc459c1f$export$bcfccb61f33e9641 = 'delete-inline-comment';
const $d4b865e8cc459c1f$export$819fbef15068ac1d = 'resolve-inline-comment';
const $d4b865e8cc459c1f$export$996a096215f40255 = 'unresolve-inline-comment';
const $d4b865e8cc459c1f$export$c64ae72fd2ff5bed = 'resolved-inline-comments-dialog-sort';
const $d4b865e8cc459c1f$export$a32711b0e13e94b7 = 'reattach-inline-comment';
const $d4b865e8cc459c1f$export$d6f52083721d3342 = 'view-reactions';
const $d4b865e8cc459c1f$export$e6f0efe9d461092e = 'view-reaction-user-list';
const $d4b865e8cc459c1f$export$ba45b443cf775f1b = 'add-reaction';
const $d4b865e8cc459c1f$export$63f7987e2f1f8f3 = 'delete-reaction';
const $d4b865e8cc459c1f$export$aa1b3aa6132c5165 = 'add-quick-reaction';
const $d4b865e8cc459c1f$export$7321222ee6dc4c8a = 'copy-space-permissions';
const $d4b865e8cc459c1f$export$227ea80a7d6d8ef2 = 'create-page';
const $d4b865e8cc459c1f$export$1773354263fb7a1f = 'create-page/load-dialog';
const $d4b865e8cc459c1f$export$5f80ef7b2915bb38 = 'create-page/template-variable-input';
const $d4b865e8cc459c1f$export$f27db95814bbdf0 = 'create-whiteboard';
const $d4b865e8cc459c1f$export$13566a78bbba7568 = 'create-database';
const $d4b865e8cc459c1f$export$c6222c9fbf47e43b = 'create-embed';
const $d4b865e8cc459c1f$export$63a2c018dc189e0 = 'create-folder';
const $d4b865e8cc459c1f$export$9c40f417713b17ea = 'edit-page-smart-create/load';
const $d4b865e8cc459c1f$export$dd70d6707192298e = 'edit-page';
const $d4b865e8cc459c1f$export$cd96dc6a09f60949 = 'edit-legacy-page';
const $d4b865e8cc459c1f$export$b6f302e969b56ed5 = 'edit-page-embed';
const $d4b865e8cc459c1f$export$cfe717283b384dee = 'edit-page/loader'; // loader to determine editor routing (next vs. classic)
const $d4b865e8cc459c1f$export$54650b8dd9597591 = 'edit-page/load';
const $d4b865e8cc459c1f$export$9cfef550e5af515d = 'edit-legacy-page/load';
const $d4b865e8cc459c1f$export$4aed0cf42acf9c68 = 'edit-page/publish';
const $d4b865e8cc459c1f$export$770ea955fed26e20 = 'edit-legacy-page/publish';
const $d4b865e8cc459c1f$export$4abcdf78bb75330c = 'edit-page/publish-as-blog';
const $d4b865e8cc459c1f$export$92edebd76eb1ad1 = 'edit-page/close';
const $d4b865e8cc459c1f$export$1339ae8dc80b092c = 'edit-legacy-page/close';
const $d4b865e8cc459c1f$export$42ce143b9452f768 = 'edit-page/revert-draft';
const $d4b865e8cc459c1f$export$d3dcb341de2e384f = 'live-page';
const $d4b865e8cc459c1f$export$f8e950d04ce466ff = 'live-page/edit';
const $d4b865e8cc459c1f$export$3814d28dd3802a02 = 'live-page-session';
const $d4b865e8cc459c1f$export$40fb2b7b657bf7d = 'live-page/publish';
const $d4b865e8cc459c1f$export$9e0dcc9389703292 = 'create-and-edit-page';
const $d4b865e8cc459c1f$export$b9892a850189b3e9 = 'template-edit-page';
const $d4b865e8cc459c1f$export$3604f7decc6e0567 = 'template-edit-page/load';
const $d4b865e8cc459c1f$export$1a3cf6b911b3771 = 'template-edit-page/close';
const $d4b865e8cc459c1f$export$a7f90c693668eabe = 'template-edit-page/publish';
const $d4b865e8cc459c1f$export$3c5dcebba4317c7e = 'template-edit-page/publish/template-body';
const $d4b865e8cc459c1f$export$3a8f568ddb8f3189 = 'template-edit-page/publish/template-properties';
const $d4b865e8cc459c1f$export$583391c24e8a1735 = 'in-editor-templates-load-panel';
const $d4b865e8cc459c1f$export$6afe1d2e05c85172 = 'in-editor-templates-load-panel/template-list';
const $d4b865e8cc459c1f$export$6085a8760b035f6 = 'in-editor-templates-load-panel/categories';
const $d4b865e8cc459c1f$export$cbd9dfa0a050a0e0 = 'in-editor-templates-load-panel/space-selector';
const $d4b865e8cc459c1f$export$8fcf8395eb106389 = 'in-editor-templates-update-content';
const $d4b865e8cc459c1f$export$eac277758b783558 = 'in-editor-templates-update-content/refresh-editor';
const $d4b865e8cc459c1f$export$d3b70eeb61a68ef1 = 'template-suggestions';
const $d4b865e8cc459c1f$export$89e30156af35c723 = 'view-in-product-help';
const $d4b865e8cc459c1f$export$1072a5750cf51c7e = 'search-in-product-help';
const $d4b865e8cc459c1f$export$85f8b3853315a126 = 'search-in-product-help/load';
const $d4b865e8cc459c1f$export$49e4c787a6cc62e = 'view-article-in-product-help';
const $d4b865e8cc459c1f$export$3d1292b099f0e166 = 'view-article-in-product-help/load';
const $d4b865e8cc459c1f$export$54615853abc6859 = 'template-gallery';
const $d4b865e8cc459c1f$export$82c983e2a60f2e28 = 'template-gallery/space-selector';
const $d4b865e8cc459c1f$export$61439b391c5a3aca = 'template-gallery/categories';
const $d4b865e8cc459c1f$export$81cd8bf6923e1bf1 = 'template-gallery/cards';
const $d4b865e8cc459c1f$export$b6af3a64b182b9d0 = 'template-gallery/template-detail';
const $d4b865e8cc459c1f$export$588acf29fbd8637d = 'template-gallery/template-detail-update';
const $d4b865e8cc459c1f$export$a1cf4f28febc3bee = 'template-gallery/template-detail/header';
const $d4b865e8cc459c1f$export$b802716fd0c5b93f = 'template-preview';
const $d4b865e8cc459c1f$export$e0195c05e32ed777 = 'refresh-editor-content';
const $d4b865e8cc459c1f$export$9194ae178043ade6 = 'create-content-from-template';
const $d4b865e8cc459c1f$export$1545639c80579c53 = 'blueprint-wizard-load-dialog';
const $d4b865e8cc459c1f$export$fc0c176abc30d17b = 'connect-addon';
const $d4b865e8cc459c1f$export$97b170c4be77228 = 'quick-reload';
const $d4b865e8cc459c1f$export$9625ccab45afe35a = 'quick-reload-v3';
const $d4b865e8cc459c1f$export$dbbd27df623b094f = 'restricted-page';
const $d4b865e8cc459c1f$export$8f404e4bd2a13aa = 'restricted-space-for-guest';
const $d4b865e8cc459c1f$export$727b779ceeca0a78 = 'restricted-space';
const $d4b865e8cc459c1f$export$b9ee7465c962e842 = 'restrictions-dialog';
const $d4b865e8cc459c1f$export$2e96e7e6b8da0317 = 'restrictions-dialog/load';
const $d4b865e8cc459c1f$export$6b54d78a736a983b = 'restrictions-dialog/apply';
const $d4b865e8cc459c1f$export$a66250c876dd8838 = 'publish-modal/load-restrictions';
const $d4b865e8cc459c1f$export$e64caae0c75dd921 = 'impersonation-flag';
const $d4b865e8cc459c1f$export$7ebe8ae2b3f231cb = 'inspect-permissions';
const $d4b865e8cc459c1f$export$b659623b19114e87 = 'user-access';
const $d4b865e8cc459c1f$export$9d715fddec195756 = 'upsell-edition';
const $d4b865e8cc459c1f$export$a7ffbea51ff646ee = 'upsell-edition-upflow';
const $d4b865e8cc459c1f$export$bd5028ea224c4de1 = 'archiving/archive-pages';
const $d4b865e8cc459c1f$export$e63a17e805ed8387 = 'archiving/restore-pages';
const $d4b865e8cc459c1f$export$d74c17e82f5dbc27 = 'archiving/view-space-archived-pages';
const $d4b865e8cc459c1f$export$b7a40ae431fd676d = 'archiving/view-space-archived-pages/paginate';
const $d4b865e8cc459c1f$export$b84de3b67d7aa4be = 'archiving/edit-notes-archive-pages';
const $d4b865e8cc459c1f$export$9efd42121cbefbff = 'archiving/bulk-edit-notes-archive-pages';
const $d4b865e8cc459c1f$export$c30b739e25dc756b = 'archiving/archived-page-banner';
const $d4b865e8cc459c1f$export$fc9036c892e05ff9 = 'automation-discovery/add-label';
const $d4b865e8cc459c1f$export$abe2705723fc11ac = 'automation-discovery/publish-meeting-notes';
const $d4b865e8cc459c1f$export$90d9afd417e81733 = 'automation-discovery/archive-page';
const $d4b865e8cc459c1f$export$bcf33c3d2ec343df = 'automation-discovery/hover-over-page-title';
const $d4b865e8cc459c1f$export$8b43be9232ec143f = 'automation-discovery/jira-link';
const $d4b865e8cc459c1f$export$adc097acaa5bd53a = 'automation-discovery/manual-trigger';
const $d4b865e8cc459c1f$export$184da8822d56484c = 'automation-discovery/bulk-archive';
const $d4b865e8cc459c1f$export$65a0bbd38d8f5b63 = 'automation-discovery/page-public-link';
const $d4b865e8cc459c1f$export$c7dca20d997e95ed = 'automation-manual-triggers';
const $d4b865e8cc459c1f$export$2504afae65d57ffb = 'automation-discovery/whiteboards';
const $d4b865e8cc459c1f$export$cf23f74117283d17 = 'automation-discovery/bulk-change-page-owner';
const $d4b865e8cc459c1f$export$78bf51c34f43d049 = 'automation-smart-button-run-rule';
const $d4b865e8cc459c1f$export$d0afbe071e52a5cf = 'automation-smart-button-create-rule';
const $d4b865e8cc459c1f$export$b30eb768fa4c3967 = 'automation-smart-button-edit-rule';
const $d4b865e8cc459c1f$export$2cc8139334567c4f = 'automation-smart-button-preview-rule';
const $d4b865e8cc459c1f$export$cab2a1e3c7ddbb06 = 'automation-side-nav-bar';
const $d4b865e8cc459c1f$export$a03bf7627f412dc4 = 'automation-upsell';
const $d4b865e8cc459c1f$export$a26e99521ea3a9f4 = 'delete-page';
const $d4b865e8cc459c1f$export$57cc53c6e3b9be1b = 'bulk-delete-pages';
const $d4b865e8cc459c1f$export$91d3a54b5d7e1b7f = 'bulk-change-owner';
const $d4b865e8cc459c1f$export$ba8b23dd795f5f9e = 'bulk-change-status';
const $d4b865e8cc459c1f$export$7bea875d555696ca = 'bulk-convert-page-to-live-doc';
const $d4b865e8cc459c1f$export$a837ee39f68fa2dd = 'edit-sidebar';
const $d4b865e8cc459c1f$export$e69ba0c4a7667861 = 'edit-sidebar/update';
const $d4b865e8cc459c1f$export$c6fd99844ee488c5 = 'manage-pages';
const $d4b865e8cc459c1f$export$8fc86f50c7402da0 = 'manage-pages/paginate';
const $d4b865e8cc459c1f$export$d4b4a08489e4dfe2 = 'content-manager';
const $d4b865e8cc459c1f$export$c03f98139dd9719e = 'move-page-dialog-load';
const $d4b865e8cc459c1f$export$1167cf561a6df618 = 'move-published-page';
const $d4b865e8cc459c1f$export$95c6dda6cbbf364 = 'move-blog';
const $d4b865e8cc459c1f$export$fbbc408e16c59382 = 'not-found';
const $d4b865e8cc459c1f$export$cf73dfff88c1f700 = 'view-content';
const $d4b865e8cc459c1f$export$d4712ac27cc4e72f = 'view-page';
const $d4b865e8cc459c1f$export$5e30e9d7ea54dcd2 = 'view-page-session';
const $d4b865e8cc459c1f$export$2a57468d23984a9d = 'space-overview';
const $d4b865e8cc459c1f$export$54504a2cc31519bf = 'breadcrumbs';
const $d4b865e8cc459c1f$export$68af05e1cf40b8e6 = 'breadcrumbs/dropdown';
const $d4b865e8cc459c1f$export$863ebd92a50403cf = 'view-page/title';
const $d4b865e8cc459c1f$export$df0793573ff7d63c = 'view-page/reactions';
const $d4b865e8cc459c1f$export$bdd2d0f331a38827 = 'view-page/labels'; //After confluence_frontend_labels_in_footer is rolled out, this will only beused for tiny pages which show the old view page labels experience
const $d4b865e8cc459c1f$export$def55fa9fa47c777 = 'view-page/labels/footer';
const $d4b865e8cc459c1f$export$49fde5724a27b431 = 'view-page/byline';
const $d4b865e8cc459c1f$export$7a119c18309263c = 'view-page/byline/forge';
const $d4b865e8cc459c1f$export$45c9f537ef090ccd = 'view-page/comments';
const $d4b865e8cc459c1f$export$d7d1b2bdd9bd08f4 = 'view-page/direct-comment-data-flow';
const $d4b865e8cc459c1f$export$dc03e514628af5e9 = 'view-page/edit';
const $d4b865e8cc459c1f$export$38478feb41239856 = 'view-page/content-tools';
const $d4b865e8cc459c1f$export$ef641459105e6b1a = 'view-page/content-tools/forge';
const $d4b865e8cc459c1f$export$255077470163d493 = 'view-page/context-menu';
const $d4b865e8cc459c1f$export$43081e88ffac9568 = 'view-page/context-menu/forge';
const $d4b865e8cc459c1f$export$14a39beec323232a = 'view-page/content-header'; // for old view page header
const $d4b865e8cc459c1f$export$5870dabed6d7b7fc = 'view-page/favorite';
const $d4b865e8cc459c1f$export$857306718a36d667 = 'view-page/share-button';
const $d4b865e8cc459c1f$export$b7907767002e32d = 'view-page/restrictions-button';
const $d4b865e8cc459c1f$export$aa15347df133b367 = 'view-page/comment-button';
const $d4b865e8cc459c1f$export$18cb1bed3afb8173 = 'view-page/discover-inline-comments-feature';
const $d4b865e8cc459c1f$export$b500820ed8b3aee5 = 'view-page/publish-as-blog';
const $d4b865e8cc459c1f$export$a83700d85c7e0745 = 'whiteboard-page';
const $d4b865e8cc459c1f$export$bdaf5db6d84a5581 = 'whiteboard-page/content';
const $d4b865e8cc459c1f$export$4252e8d96c415d57 = 'whiteboard-version-history-side-panel';
const $d4b865e8cc459c1f$export$b8cdecdc06b6252 = 'whiteboard-restore-version';
const $d4b865e8cc459c1f$export$90f5a89f66458e77 = 'whiteboard-version-history-restore-modal';
const $d4b865e8cc459c1f$export$f02aef641190ead6 = 'database-page';
const $d4b865e8cc459c1f$export$7140ccdb0c7b2b37 = 'database-page/content';
const $d4b865e8cc459c1f$export$857587c3b96ae00c = 'database-version-history-side-panel';
const $d4b865e8cc459c1f$export$bdbfe4dafa70ffab = 'database-restore-version';
const $d4b865e8cc459c1f$export$7cc7b880d5b3f324 = 'database-version-history-restore-modal';
const $d4b865e8cc459c1f$export$ba3b240cb9a3ffd0 = 'database-load-historical-version';
const $d4b865e8cc459c1f$export$c85a8dac7f241add = 'embed-page';
const $d4b865e8cc459c1f$export$927658f514adba70 = 'embed-page/content';
const $d4b865e8cc459c1f$export$c1092431c58e1571 = 'edit-embed';
const $d4b865e8cc459c1f$export$3485e62ad9c27d0b = 'folder-page';
const $d4b865e8cc459c1f$export$6237c6dbe5a63f05 = 'folder-page/content';
const $d4b865e8cc459c1f$export$7fd0425089f6d999 = 'content-types-header';
const $d4b865e8cc459c1f$export$47f14e5e827cfff3 = 'content-types-header/watch';
const $d4b865e8cc459c1f$export$748b7f600814978a = 'content-creation-paywall';
const $d4b865e8cc459c1f$export$5e1aeeb6f31be57a = 'record-loom-entry-point';
const $d4b865e8cc459c1f$export$c427a8b1052a6522 = 'loom-page-header-content-insertion';
const $d4b865e8cc459c1f$export$6ca90e5df7047c10 = 'loom-cross-sell';
const $d4b865e8cc459c1f$export$96f8e8997d2c8722 = 'edit-page/labels';
const $d4b865e8cc459c1f$export$e9e0897b7cf2ab3f = 'labels/add-label';
const $d4b865e8cc459c1f$export$5a4fc6855f9c48e = 'labels/create-label';
const $d4b865e8cc459c1f$export$3f19e9a9a0d72413 = 'labels/delete-label';
const $d4b865e8cc459c1f$export$39d403abc2174e5e = 'labels/search-label';
const $d4b865e8cc459c1f$export$4d573c9dfbc9337c = 'labels/recommended';
const $d4b865e8cc459c1f$export$8af5d568de2d4e43 = 'template-edit-page/labels';
const $d4b865e8cc459c1f$export$c5ef6dea1c804893 = 'template-edit-page/labels/add-label';
const $d4b865e8cc459c1f$export$fa82b911a68fea4d = 'template-edit-page/labels/create-label';
const $d4b865e8cc459c1f$export$20b2f79b83628af0 = 'template-edit-page/labels/delete-label';
const $d4b865e8cc459c1f$export$479dc90f08ae49d = 'template-edit-page/labels/search-label';
const $d4b865e8cc459c1f$export$d8e5793fc3893dd0 = 'header-items/group-load';
const $d4b865e8cc459c1f$export$66f0a82e06e92ea = 'home';
const $d4b865e8cc459c1f$export$8856e11bfa69959d = 'home/spaces';
const $d4b865e8cc459c1f$export$8ef0e6a462dfc555 = 'home/recent-pages';
const $d4b865e8cc459c1f$export$d931b261468db3be = 'home/right-panel';
const $d4b865e8cc459c1f$export$cd6478684fc4b278 = 'home/right-panel/activity';
const $d4b865e8cc459c1f$export$45cf379c9ef28a2d = 'home/right-panel/welcome-message';
const $d4b865e8cc459c1f$export$ceb391a6374fc2 = 'home/right-panel/calendars';
const $d4b865e8cc459c1f$export$799c1b543715aab4 = 'home/right-panel/apps';
const $d4b865e8cc459c1f$export$519eb6f457873738 = 'home/right-panel/forge';
const $d4b865e8cc459c1f$export$b57c8eba324f4ab1 = 'home/right-panel/recommendations';
const $d4b865e8cc459c1f$export$cf6a4f3279a69e87 = 'confluence';
const $d4b865e8cc459c1f$export$680e462c4f71cea1 = 'feed';
const $d4b865e8cc459c1f$export$d660d67b42309542 = 'home/overview';
const $d4b865e8cc459c1f$export$f987075f870b167d = 'home/overview/recent';
const $d4b865e8cc459c1f$export$6c96437f170477a4 = 'home/overview/recent/paginate';
const $d4b865e8cc459c1f$export$94f2ecf008a81b99 = 'home/recent';
const $d4b865e8cc459c1f$export$45d7f7ed7a82bcd = 'home/starred';
const $d4b865e8cc459c1f$export$ecf5fd41d4da9bf8 = 'home/watching';
const $d4b865e8cc459c1f$export$9b242f2ddcd908fc = 'home/drafts';
const $d4b865e8cc459c1f$export$5393f7f46c9e5055 = 'advanced-search';
const $d4b865e8cc459c1f$export$91a00c702eb82c2c = 'advanced-search/space-filter';
const $d4b865e8cc459c1f$export$3f0c1a8eb5419bb4 = 'advanced-search/contributor-filter';
const $d4b865e8cc459c1f$export$bda2c35d9a84e22c = 'advanced-search/smart-contributor-filter';
const $d4b865e8cc459c1f$export$ec545137ad6ac054 = 'quick-search/pre-query';
const $d4b865e8cc459c1f$export$e64dfa2771353f5c = 'recent-dropdown/visited';
const $d4b865e8cc459c1f$export$53f4f21972586e42 = 'recent-dropdown/created-by-me';
const $d4b865e8cc459c1f$export$985013c384c228e1 = 'recent-dropdown/worked-on';
const $d4b865e8cc459c1f$export$605220fac97de = 'recent-dropdown/drafts';
const $d4b865e8cc459c1f$export$7c6d9e11a2120c1b = 'recent-dropdown/starred';
const $d4b865e8cc459c1f$export$59a9c2c7ae337de7 = 'page-tree';
const $d4b865e8cc459c1f$export$bbc326cd1f124322 = 'page-tree/dnd';
const $d4b865e8cc459c1f$export$f9d04e98575a0216 = 'page-tree/quick-actions';
const $d4b865e8cc459c1f$export$cd3eec90d152a8ea = 'page-tree/rename';
const $d4b865e8cc459c1f$export$9d1f80f618a6627b = 'blog-tree';
const $d4b865e8cc459c1f$export$899513ff8720fa55 = 'blog-tree/pagination';
const $d4b865e8cc459c1f$export$d200becb25c80dc0 = 'activity/tailored';
const $d4b865e8cc459c1f$export$8729a78bfed79808 = 'activity/create-space-button';
const $d4b865e8cc459c1f$export$b0be9d71080b7c81 = 'activity/right-sidebar';
const $d4b865e8cc459c1f$export$2783f61e72caafb5 = 'feed-migration/activity/popular';
const $d4b865e8cc459c1f$export$fcff442a18d04a5d = 'feed-migration/activity/all-updates';
const $d4b865e8cc459c1f$export$357a2b9b5fb0f4e4 = 'navigation/nav-2-admin-navigation/forge';
const $d4b865e8cc459c1f$export$9b5915bb3a4fbcae = 'navigation/app-nav-global-navigation';
const $d4b865e8cc459c1f$export$e3e183dd97af67fd = 'navigation/app-nav-container-navigation';
const $d4b865e8cc459c1f$export$14b67f3e8f5e6f95 = 'navigation/app-nav-admin-navigation';
const $d4b865e8cc459c1f$export$f089f204ab93864e = 'navigation/app-nav-spaces-dropdown';
const $d4b865e8cc459c1f$export$5c3671291c82150b = 'navigation/app-nav-pages-dropdown';
const $d4b865e8cc459c1f$export$63d03b6879925116 = 'navigation/app-nav-apps-dropdown';
const $d4b865e8cc459c1f$export$fa160b39d3766fc0 = 'navigation/app-nav-notifications-dropdown';
const $d4b865e8cc459c1f$export$986139018de1521a = 'navigation/app-nav-profile-dropdown';
const $d4b865e8cc459c1f$export$6cebb7e0b005cd28 = 'space-directory';
const $d4b865e8cc459c1f$export$aeda23f4b92ccc3b = 'space-directory/your-spaces';
const $d4b865e8cc459c1f$export$4a890f75d0a61967 = 'space-directory/filter';
const $d4b865e8cc459c1f$export$39e9ebfcfd8e8bad = 'space-directory/paginate';
const $d4b865e8cc459c1f$export$de6098630f95035a = 'create-space/submit';
const $d4b865e8cc459c1f$export$9b47bc79e174bc93 = 'create-space/validate';
const $d4b865e8cc459c1f$export$1d45fd96fcd751f5 = 'onboarding/start';
const $d4b865e8cc459c1f$export$c33c0eca528dad5c = 'onboarding/invite-users';
const $d4b865e8cc459c1f$export$6d895b52727161d4 = 'onboarding/remove-invite-users';
const $d4b865e8cc459c1f$export$be07109624e8a07e = 'onboarding/create-a-space';
const $d4b865e8cc459c1f$export$d5e6e79f726e8007 = 'onboarding/choose-a-space';
const $d4b865e8cc459c1f$export$87a646b39eb224a = 'onboarding/end';
const $d4b865e8cc459c1f$export$a453322b492264d1 = 'onboarding/choose-a-space-card';
const $d4b865e8cc459c1f$export$4ead33eb5b37dee5 = 'onboarding/follow-spaces';
const $d4b865e8cc459c1f$export$59c55b717acdcf15 = 'onboarding/auto-follow-spaces';
const $d4b865e8cc459c1f$export$a09834a747086083 = 'onboarding/shared-link-spotlight';
const $d4b865e8cc459c1f$export$749c4d9c23381805 = 'onboarding/nudge';
const $d4b865e8cc459c1f$export$1aaba3dd5fd71b43 = 'onboarding-account-setup-modal';
const $d4b865e8cc459c1f$export$7989a920a6248647 = 'onboarding-jsw-xflow/admin-switcher-tour';
const $d4b865e8cc459c1f$export$55172161173a2d6e = 'onboarding-jsw-xflow/nth-switcher-tour';
const $d4b865e8cc459c1f$export$aaf55a29d2f12a6e = 'onboarding-jsw-xflow/invite-teammate-task';
const $d4b865e8cc459c1f$export$e40755126e0d0b54 = 'onboarding-editor/draft-banner';
const $d4b865e8cc459c1f$export$32b7ff7de164c7ad = 'onboarding-editor/land-in-editor-banner';
const $d4b865e8cc459c1f$export$b154482ef737e03a = 'onboarding-editor/quickstart-tutorial-task';
const $d4b865e8cc459c1f$export$d04515c6314fec11 = 'onboarding-editor/publish-modal-prompt';
const $d4b865e8cc459c1f$export$8425321c06a7c373 = 'onboarding-editor/publish-success-flag';
const $d4b865e8cc459c1f$export$f3de65caafc09b21 = 'onboarding-editor/recent-draft-spotlight';
const $d4b865e8cc459c1f$export$25e1b00b32cd992d = 'onboarding/query/labels';
const $d4b865e8cc459c1f$export$8ef86f4d4da92fa5 = 'onboarding/grace-period-banner';
const $d4b865e8cc459c1f$export$8125e64b190d01e2 = 'onboarding/storage-enforcement-banner';
const $d4b865e8cc459c1f$export$343afc350dc963df = 'onboarding/storage-enforcement-banner/dismiss';
const $d4b865e8cc459c1f$export$9491541521237449 = 'onboarding/storage-enforcement-flags';
const $d4b865e8cc459c1f$export$616864953f0d339 = 'onboarding/storage-enforcement/block-create-modal';
const $d4b865e8cc459c1f$export$61418bee30087820 = 'onboarding/home/templates-collection';
const $d4b865e8cc459c1f$export$70cb2a8c47e6afd8 = 'onboarding/home/templates-collection/create-template';
const $d4b865e8cc459c1f$export$e61bc67cff9e0f2 = 'onboarding/ibo/new-home/recent-page';
const $d4b865e8cc459c1f$export$c1f744d5e0181dd = 'onboarding/ibo/new-home/spaces';
const $d4b865e8cc459c1f$export$5ddea2545ba37329 = 'onboarding/ibo/new-home';
const $d4b865e8cc459c1f$export$c03570fb82968b7e = 'onboarding/nth-user-setup-modal';
const $d4b865e8cc459c1f$export$59679d849f29c62b = 'onboarding/onboarding-tracker';
const $d4b865e8cc459c1f$export$7893ecd5dfd2c478 = 'onboarding/onboarding-tracker/organize-space/spotlight';
const $d4b865e8cc459c1f$export$f63cf886d6298a0d = 'onboarding/onboarding-tracker/add-content/spotlight';
const $d4b865e8cc459c1f$export$7b13a63caff7cb41 = 'onboarding/onboarding-tracker/invite-people/spotlight';
const $d4b865e8cc459c1f$export$3971f3f0bdcc083 = 'onboarding/onboarding-surface-import/global-import/create-page';
const $d4b865e8cc459c1f$export$7e62e90cd8969fd8 = 'onboarding/confluence-recap-modal';
const $d4b865e8cc459c1f$export$5612c7c22aba3ae8 = 'onboarding/confluence-home-onboarding-takeover-v2';
const $d4b865e8cc459c1f$export$3edd3fbbb3bde42a = 'onboarding/nth-user-confluence-home-onboarding-takeover';
const $d4b865e8cc459c1f$export$e97003dd72490d60 = 'onboarding/confluence-home-onboarding-takeover-v2/home-nudge';
const $d4b865e8cc459c1f$export$be5f66bc85ac48a2 = 'onboarding/confluence-personalized-templates-v2';
const $d4b865e8cc459c1f$export$4ef813fe853a14e1 = 'onboarding/nth-user-home-onboarding-revamp';
const $d4b865e8cc459c1f$export$241c40e7f0f7d7b2 = 'content-action-apps/forge';
const $d4b865e8cc459c1f$export$404655cfa9ecfbc3 = 'byline-apps/forge';
const $d4b865e8cc459c1f$export$224bdd20537c043c = 'context-menu-apps/forge';
const $d4b865e8cc459c1f$export$fe9e3a7216162400 = 'settings-page-apps/forge';
const $d4b865e8cc459c1f$export$16a139fd3cad706d = 'custom-content-apps/forge';
const $d4b865e8cc459c1f$export$a333c0535291436a = 'space-page-apps/forge';
const $d4b865e8cc459c1f$export$4e660f0eec1b7b63 = 'space-settings/integrations/forge';
const $d4b865e8cc459c1f$export$42fe8757b12b9abb = 'space-settings-v2/integrations/forge';
const $d4b865e8cc459c1f$export$e4e961f07f20b1e9 = 'space-settings-v2/landing-page';
const $d4b865e8cc459c1f$export$30670c5b5576bc9d = 'global-page-apps/forge';
const $d4b865e8cc459c1f$export$de2b763dff9c90e = 'full-page-apps/forge';
const $d4b865e8cc459c1f$export$7fee035e8993093b = 'background-script-apps/forge';
const $d4b865e8cc459c1f$export$d773e3323beb4d91 = 'site-permission/space-access';
const $d4b865e8cc459c1f$export$1fdf87b44bf66203 = 'space-pages';
const $d4b865e8cc459c1f$export$eab5c9963f80520c = 'space-pages/filter';
const $d4b865e8cc459c1f$export$6af7d14b23c7ed20 = 'space-pages/paginate';
const $d4b865e8cc459c1f$export$1ae7d5b32e27dd1b = 'space-views/initial';
const $d4b865e8cc459c1f$export$92e7a42b4d134675 = 'space-views/change';
const $d4b865e8cc459c1f$export$cd0c9383cd80d210 = 'space-views/paginate';
const $d4b865e8cc459c1f$export$90dff6c3d9facebb = 'space-views/hover-page-card';
const $d4b865e8cc459c1f$export$8a00f2824cff2c5e = 'site-permissions/space-access/remove';
const $d4b865e8cc459c1f$export$30e6c2e5c854e3d7 = 'site-permissions/space-access/add';
const $d4b865e8cc459c1f$export$b07723d1eb2313ad = 'site-permissions/space-access/guest/change';
const $d4b865e8cc459c1f$export$94d2e4338cb54b2c = 'insights/page-byline';
const $d4b865e8cc459c1f$export$27bffcf643f6c238 = 'insights/page-dialog';
const $d4b865e8cc459c1f$export$460c09ff51f88f24 = 'insights/page-dialog-upsell';
const $d4b865e8cc459c1f$export$371cd738ccd37b38 = 'insights/page-analytics';
const $d4b865e8cc459c1f$export$3861bdd55a91a4a0 = 'insights/page-analytics/view-chart';
const $d4b865e8cc459c1f$export$968182ed9835d21a = 'insights/page-analytics/total-views-card';
const $d4b865e8cc459c1f$export$24ed3cf43f154734 = 'insights/page-analytics/unique-viewers-card';
const $d4b865e8cc459c1f$export$a531b5e2ff0b9747 = 'insights/page-analytics/mentioned-users-card';
const $d4b865e8cc459c1f$export$27ccd506e08e0e = 'insights/page-analytics/viewers-table';
const $d4b865e8cc459c1f$export$ec84fc419c424bb5 = 'insights/page-analytics/mentioned-users-reminder';
const $d4b865e8cc459c1f$export$8ddcb6f0d9ebf30e = 'insights/page-analytics/mentioned-users-table';
const $d4b865e8cc459c1f$export$f8f3f70f34becef9 = 'insights/page-analytics/links-inbound-total-clicks-card';
const $d4b865e8cc459c1f$export$3d388f0f7fc44c3f = 'insights/page-analytics/links-inbound-ctr-card';
const $d4b865e8cc459c1f$export$310d1207c2b3ca7d = 'insights/page-analytics/links-inbound-table';
const $d4b865e8cc459c1f$export$ab6abc47e6a1b436 = 'insights/page-analytics/links-outbound-total-clicks-card';
const $d4b865e8cc459c1f$export$a1934b3cd762057c = 'insights/page-analytics/links-outbound-ctr-card';
const $d4b865e8cc459c1f$export$11b4f841e984d2a8 = 'insights/page-analytics/links-outbound-table';
const $d4b865e8cc459c1f$export$5478a6cbf2100291 = 'insights/space-analytics';
const $d4b865e8cc459c1f$export$12f42654844570d0 = 'insights/space-analytics/overview-chart';
const $d4b865e8cc459c1f$export$40a98279383e549e = 'insights/space-analytics/popular-content-card';
const $d4b865e8cc459c1f$export$340eeaf9226a3e00 = 'insights/space-analytics/active-readers-card';
const $d4b865e8cc459c1f$export$327f825878dc4802 = 'insights/space-analytics/active-contributors-card';
const $d4b865e8cc459c1f$export$9595ac2edfb0edec = 'insights/space-analytics/content-activity-table';
const $d4b865e8cc459c1f$export$bfbd1b5517d327f6 = 'insights/space-analytics/user-activity-table';
const $d4b865e8cc459c1f$export$ae73006a481ab5bc = 'insights/space-analytics/async-export';
const $d4b865e8cc459c1f$export$e27cd103e9670e33 = 'insights/space-analytics/permissions/load';
const $d4b865e8cc459c1f$export$5a507008b468c991 = 'insights/space-analytics/permissions/update';
const $d4b865e8cc459c1f$export$8ed4273d919d1070 = 'insights/site-analytics';
const $d4b865e8cc459c1f$export$f2d660eb8a9ba56e = 'insights/site-analytics/overview-chart';
const $d4b865e8cc459c1f$export$8e5ed6a75264c549 = 'insights/site-analytics/popular-spaces-card';
const $d4b865e8cc459c1f$export$7cc392d1f03d59f9 = 'insights/site-analytics/active-readers-card';
const $d4b865e8cc459c1f$export$e5b5e8161ac66e90 = 'insights/site-analytics/popular-searches-card';
const $d4b865e8cc459c1f$export$221bc81bca00257 = 'insights/site-analytics/spaces-table';
const $d4b865e8cc459c1f$export$31b3362136d95230 = 'insights/site-analytics/users-table';
const $d4b865e8cc459c1f$export$86dcda8aa2b50b8a = 'insights/site-analytics/search-table';
const $d4b865e8cc459c1f$export$91ffba1860245927 = 'insights/site-analytics/search-panel';
const $d4b865e8cc459c1f$export$1b7a393d48199f1c = 'insights/site-analytics/search-panel/graph';
const $d4b865e8cc459c1f$export$4020b74c723b4607 = 'insights/site-analytics/search-panel/content-list';
const $d4b865e8cc459c1f$export$343c48c7798baab8 = 'insights/site-analytics/search-panel/spaces-list';
const $d4b865e8cc459c1f$export$58ad08103bb62c4b = 'insights/site-analytics/permissions/load';
const $d4b865e8cc459c1f$export$f73b370055c8cbef = 'insights/site-analytics/permissions/update';
const $d4b865e8cc459c1f$export$5d12872cd9595692 = 'bulk-space-permissions';
const $d4b865e8cc459c1f$export$ee395498ea9fc566 = 'global-perms';
const $d4b865e8cc459c1f$export$bbc6348b8482e5b1 = 'expand-group';
const $d4b865e8cc459c1f$export$f96f0a60f840676c = 'group-members-load-more';
const $d4b865e8cc459c1f$export$7b06f43e66d37bd9 = 'view-space-guest-list';
const $d4b865e8cc459c1f$export$b3639316349424 = 'team-calendar';
const $d4b865e8cc459c1f$export$b731d5eab77f5ae2 = 'team-calendar-upsell';
const $d4b865e8cc459c1f$export$6e2e950545a96fb5 = 'team-calendars/calendar/add';
const $d4b865e8cc459c1f$export$e60dce5b561d6551 = 'team-calendars/calendar/add-existing';
const $d4b865e8cc459c1f$export$25067b28cdd34cc6 = 'team-calendars/calendar/delete';
const $d4b865e8cc459c1f$export$19d86a52695ae312 = 'team-calendars/calendar/remove';
const $d4b865e8cc459c1f$export$120ce8feec0488aa = 'team-calendars/calendar/subscribe';
const $d4b865e8cc459c1f$export$dc96bc0456e09d60 = 'team-calendars/calendar/update';
const $d4b865e8cc459c1f$export$d23cc4800e46d1e6 = 'team-calendars/calendar/import';
const $d4b865e8cc459c1f$export$13b2254026213b46 = 'team-calendars/event-type/add';
const $d4b865e8cc459c1f$export$c348a46d97587ee4 = 'team-calendars/event-type/delete';
const $d4b865e8cc459c1f$export$bfd3172de881908e = 'team-calendars/event-type/update';
const $d4b865e8cc459c1f$export$e1a32de918001908 = 'team-calendars/event/add';
const $d4b865e8cc459c1f$export$36abe825d06f7b68 = 'team-calendars/event/jira-calendar';
const $d4b865e8cc459c1f$export$1be22ae521e809a9 = 'team-calendars/event/update';
const $d4b865e8cc459c1f$export$eb40d48a494923c8 = 'team-calendars/event/delete';
const $d4b865e8cc459c1f$export$66104f246f979de9 = 'team-calendars/restrictions/update';
const $d4b865e8cc459c1f$export$a245b5e8e50aca4e = 'edit-space-logo/restore';
const $d4b865e8cc459c1f$export$38c64d0e786460e8 = 'edit-space-logo/save';
const $d4b865e8cc459c1f$export$53b6eab7c794efdf = 'edit-space-logo/details-load';
const $d4b865e8cc459c1f$export$d4e50447c54e832a = 'cover-picture/unsplash-upload';
const $d4b865e8cc459c1f$export$3b296e5e8d4fbd72 = 'cover-picture/media-upload';
const $d4b865e8cc459c1f$export$75c73b1e1363abb2 = 'cover-picture/remove';
const $d4b865e8cc459c1f$export$56b59e3252d65c77 = 'view-app-suggestions';
const $d4b865e8cc459c1f$export$61ad3866e7413864 = 'conditional_publish_dialog';
const $d4b865e8cc459c1f$export$5685c80727d12c34 = 'extension_point_byline';
const $d4b865e8cc459c1f$export$4b9cf95d297cf82f = 'extension_point_space_buttons';
const $d4b865e8cc459c1f$export$811ef7c3a5f94996 = 'extension_point_home_footer';
const $d4b865e8cc459c1f$export$dfab08323861cbc1 = 'extension_point_home_header';
const $d4b865e8cc459c1f$export$aa9a33eaf0b3cefa = 'extension_point_editor_savebar';
const $d4b865e8cc459c1f$export$4933a09c775176cb = 'extension_point_page_metadata_banner';
const $d4b865e8cc459c1f$export$645909341bfebc9b = 'extension_point_page_banner';
const $d4b865e8cc459c1f$export$facf18b53398c3d7 = 'extension_point_space_settings_tabs';
const $d4b865e8cc459c1f$export$23be08d2ca73ecf = 'core-invites';
const $d4b865e8cc459c1f$export$b1dd9d960d4ea959 = 'custom-content-page-all';
const $d4b865e8cc459c1f$export$38660dec2eb2a695 = 'custom-content-space-list-view';
const $d4b865e8cc459c1f$export$7b1fe4d076a9542a = 'custom-content-page-list-view';
const $d4b865e8cc459c1f$export$ad06e79f63068f5e = 'custom-content-view';
const $d4b865e8cc459c1f$export$eef674482902ef6d = 'connections-panel-view';
const $d4b865e8cc459c1f$export$c5bcbbcb1df627e5 = 'end-of-page-recommendations';
const $d4b865e8cc459c1f$export$3b683344868f9f0a = 'notify-on-first-view';
const $d4b865e8cc459c1f$export$4fdd9934209dba0e = 'presenter-mode/view';
const $d4b865e8cc459c1f$export$40638d9b45e8ceca = 'presenter-mode/full-screen-api';
const $d4b865e8cc459c1f$export$b1f7a84b45eb9afb = 'view-public-link-site-settings';
const $d4b865e8cc459c1f$export$8294c237289049c4 = 'view-public-link-spaces-table';
const $d4b865e8cc459c1f$export$ec6e09c5fd9fa221 = 'view-public-links-page-table';
const $d4b865e8cc459c1f$export$5cc7e9470bfae723 = 'public-links-spaces-table-action';
const $d4b865e8cc459c1f$export$c102a9d514fc95ac = 'public-link-site-toggle-change';
const $d4b865e8cc459c1f$export$ff2fb656c8231637 = 'view-public-links-space-settings';
const $d4b865e8cc459c1f$export$ba803d464f49a265 = 'public-links-space-toggle-change';
const $d4b865e8cc459c1f$export$d95bcf023bd8993 = 'view-public-links-default-space-settings';
const $d4b865e8cc459c1f$export$7362876707c57af9 = 'public-links-default-space-toggle-change';
const $d4b865e8cc459c1f$export$c7ff49e7eaa45ff1 = 'view-public-link-shared-page';
const $d4b865e8cc459c1f$export$24cbec84f278c600 = 'public-link-rendered';
const $d4b865e8cc459c1f$export$5b89a66b04cea206 = 'public-link-toggle-change';
const $d4b865e8cc459c1f$export$44b7602dc9689e08 = 'public-link-disable-from-restrictions';
const $d4b865e8cc459c1f$export$eed7907041fecd69 = 'public-link-page-table-action';
const $d4b865e8cc459c1f$export$49a01ffc1a18656b = 'external-share';
const $d4b865e8cc459c1f$export$e25df1f458506fcd = 'copy-content-link';
const $d4b865e8cc459c1f$export$7c34e8285a2b9238 = 'content-history';
const $d4b865e8cc459c1f$export$b9b41dfe39f06772 = 'view-tasks';
const $d4b865e8cc459c1f$export$6be3453279e7dd85 = 'set-task-complete';
const $d4b865e8cc459c1f$export$80a3b142ba868b57 = 'change-page-owner';
const $d4b865e8cc459c1f$export$19875313f499fad9 = 'content-ownership/dialog';
const $d4b865e8cc459c1f$export$e94c6163c32592ce = 'admin-announcement-banner';
const $d4b865e8cc459c1f$export$7653dfd9fd5557b = 'admin-announcement-banner-dismissed';
const $d4b865e8cc459c1f$export$394294e59b36efb9 = 'admin-announcement-banner-settings';
const $d4b865e8cc459c1f$export$8f017785cc4bb995 = 'admin-announcement-banner-publish';
const $d4b865e8cc459c1f$export$a4d890726485d79a = 'admin-announcement-banner-turn-off';
const $d4b865e8cc459c1f$export$47d510c88b13ea8d = 'admin-announcement-banner-table';
const $d4b865e8cc459c1f$export$548adb1a2fe6e6b1 = 'space-manager';
const $d4b865e8cc459c1f$export$35f739fc0b127205 = 'space-manager-quick-action-item';
const $d4b865e8cc459c1f$export$bfe6ff6cddeed6e3 = 'importer-dashboard';
const $d4b865e8cc459c1f$export$2decaadcf840e6b3 = 'company-hub-general-settings';
const $d4b865e8cc459c1f$export$23b4a008c670d304 = 'company-hub-general-settings-your-hub';
const $d4b865e8cc459c1f$export$c6198e9d6ab9e417 = 'company-hub-general-settings-your-hub-actions';
const $d4b865e8cc459c1f$export$e1b506612f6e9657 = 'company-hub-general-settings-recent-activity';
const $d4b865e8cc459c1f$export$dfdc3f1142f40689 = 'company-hub-general-settings-hub-views';
const $d4b865e8cc459c1f$export$e9845af7b7fd8501 = 'company-hub-general-settings-most-clicks';
const $d4b865e8cc459c1f$export$237a7d3a8e219dbb = 'admin-center';
const $d4b865e8cc459c1f$export$b7b3a9d4d05ffd12 = 'admin-center-confluence-admins';
const $d4b865e8cc459c1f$export$367f60a3ad6918c1 = 'admin-center-search-count';
const $d4b865e8cc459c1f$export$9a8113803e6447cf = 'admin-center-search-ctr';
const $d4b865e8cc459c1f$export$8f37d7eb1e6f681d = 'admin-center-top-searches';
const $d4b865e8cc459c1f$export$2ad5d40786f81da0 = 'admin-center-top-unsuccessful-searches';
const $d4b865e8cc459c1f$export$e68566fb281dbb33 = 'admin-center-external-access';
const $d4b865e8cc459c1f$export$a7f1ee469fd8596c = 'admin-center-beta-features';
const $d4b865e8cc459c1f$export$8a3b06f53918d80e = 'admin-center-total-spaces';
const $d4b865e8cc459c1f$export$d4f2672a4a997be2 = 'admin-center-total-content';
const $d4b865e8cc459c1f$export$61440d1f5d765856 = 'admin-center-grouped-summary-section';
const $d4b865e8cc459c1f$export$a122d82c3b13ba99 = 'admin-center-inactive-pages';
const $d4b865e8cc459c1f$export$bf035e1987052c42 = 'admin-center-top-inactive-pages';
const $d4b865e8cc459c1f$export$1613edca53571ea3 = 'admin-center-deactivated-owner-pages';
const $d4b865e8cc459c1f$export$4ba2b40dc30760f9 = 'admin-center-top-deactivated-owner-pages';
const $d4b865e8cc459c1f$export$5d6b6234c4e9f70d = 'admin-center-content-created';
const $d4b865e8cc459c1f$export$39552d32ae5efc36 = 'admin-center-content-updated';
const $d4b865e8cc459c1f$export$a4934c826482e207 = 'admin-center-content-views';
const $d4b865e8cc459c1f$export$4c0549ea0cf0f43d = 'admin-center-top-content-views';
const $d4b865e8cc459c1f$export$6b8c8a94a6fb0b10 = 'admin-center-grouped-summary-section-v2-update';
const $d4b865e8cc459c1f$export$a4855248cbcdc638 = 'admin-center-grouped-summary-section-v2';
const $d4b865e8cc459c1f$export$f1c6b44ad858e24f = 'admin-center-search-count-summary';
const $d4b865e8cc459c1f$export$aaba8c517b5b0014 = 'admin-center-search-ctr-summary';
const $d4b865e8cc459c1f$export$3463471aa64d2a20 = 'admin-center-total-spaces-summary';
const $d4b865e8cc459c1f$export$aed49d47c6d277d2 = 'admin-center-total-content-summary';
const $d4b865e8cc459c1f$export$c89944dc251c7694 = 'admin-center-inactive-pages-num-summary';
const $d4b865e8cc459c1f$export$45d06e7b1bc06ed4 = 'admin-center-inactive-pages-percent-summary';
const $d4b865e8cc459c1f$export$50744fb70a2982a2 = 'admin-center-deactivated-owner-pages-num-summary';
const $d4b865e8cc459c1f$export$35f523c785c60e15 = 'admin-center-deactivated-owner-pages-percent-summary';
const $d4b865e8cc459c1f$export$d4f40a3c80d7fa00 = 'admin-center-content-created-summary';
const $d4b865e8cc459c1f$export$3e98f2df16d1f652 = 'admin-center-content-updated-summary';
const $d4b865e8cc459c1f$export$512d403dd28c8f13 = 'admin-center-content-views-summary';
const $d4b865e8cc459c1f$export$b5db801ede6fe9e5 = 'admin-center-public-link-views-summary';
const $d4b865e8cc459c1f$export$2df6bcfd56d7c9e8 = 'admin-center-public-links-summary';
const $d4b865e8cc459c1f$export$6c98543cf0a07a9f = 'admin-center-suggestions';
const $d4b865e8cc459c1f$export$9f5be3c30e870f46 = 'admin-center-suggestions-unassigned-guest';
const $d4b865e8cc459c1f$export$56c7132579558fc8 = 'admin-center-suggestions-inactive-pages';
const $d4b865e8cc459c1f$export$4bc17e6067981b1f = 'admin-center-suggestions-deactivated-owner-pages';
const $d4b865e8cc459c1f$export$2f62829f51afa45a = 'admin-center-suggestions-space-manager';
const $d4b865e8cc459c1f$export$19020e617b152304 = 'admin-center-suggestions-user-access';
const $d4b865e8cc459c1f$export$12a435102ccb624a = 'admin-center-suggestions-quick-action-item';
const $d4b865e8cc459c1f$export$dec2cee4628ab9c4 = 'admin-center-suggestions-metric-cta';
const $d4b865e8cc459c1f$export$88a8c07833ef47b1 = 'space-admin-center';
const $d4b865e8cc459c1f$export$fb0bb005ed2de56c = 'space-admin-center-grouped-summary-section';
const $d4b865e8cc459c1f$export$73c5a862f5073e46 = 'space-admin-center-external-access';
const $d4b865e8cc459c1f$export$4d72041a86e9e003 = 'space-admin-center-space-admins';
const $d4b865e8cc459c1f$export$724928cbf61f8819 = 'space-admin-center-content-views';
const $d4b865e8cc459c1f$export$eee5f90734589227 = 'space-admin-center-top-content-views';
const $d4b865e8cc459c1f$export$a5e95165e3a702d1 = 'space-admin-center-content-created';
const $d4b865e8cc459c1f$export$32dde1d12c499528 = 'space-admin-center-content-updated';
const $d4b865e8cc459c1f$export$147226654b32f956 = 'space-admin-center-total-content';
const $d4b865e8cc459c1f$export$648d00fafa66ae14 = 'space-admin-center-inactive-pages';
const $d4b865e8cc459c1f$export$a3fdce9bb003f0b8 = 'space-admin-center-top-inactive-pages';
const $d4b865e8cc459c1f$export$71daddda71b57298 = 'space-admin-center-deactivated-owner-pages';
const $d4b865e8cc459c1f$export$62d9e5dacf2e073d = 'space-admin-center-top-deactivated-owner-pages';
const $d4b865e8cc459c1f$export$8c3b600f7a5dce0f = 'dwell-time/start';
const $d4b865e8cc459c1f$export$b0fe8424f6f27f51 = 'trial-components/lozenge-view';
const $d4b865e8cc459c1f$export$40c0cee2cad141c5 = 'trial-components/flag-view';
const $d4b865e8cc459c1f$export$d6bad6d87d8c028f = 'trial-components/premium-insights-action-menu-item-view';
const $d4b865e8cc459c1f$export$d0e7688ec900110c = 'team-presence/avatar-group-view';
const $d4b865e8cc459c1f$export$655feba7d95d5b26 = 'team-presence/click-to-find';
const $d4b865e8cc459c1f$export$a3748c7e642ec857 = 'flywheel-feature-discovery';
const $d4b865e8cc459c1f$export$f8372d329c2aeea0 = 'quick-summary';
const $d4b865e8cc459c1f$export$31e4e6e2658a6cae = 'quick-summary-whiteboards';
const $d4b865e8cc459c1f$export$4a493e4dc06e57e7 = 'quick-summary-to-page';
const $d4b865e8cc459c1f$export$5565b0bba4d72eee = 'comments-summary';
const $d4b865e8cc459c1f$export$8d9dfd2f17501337 = 'ai-content-catchup';
const $d4b865e8cc459c1f$export$eb38477d5de37f36 = 'ai-presentation-generation-view';
const $d4b865e8cc459c1f$export$ed3e815374d54f04 = 'ai-presentation-generation-create';
const $d4b865e8cc459c1f$export$bb8fdee2f545676e = 'ai-snippet';
const $d4b865e8cc459c1f$export$c114a6d7848b93cb = 'ai-bulk-issue-create';
const $d4b865e8cc459c1f$export$a48ee5f2c131dea3 = 'ai-audio';
const $d4b865e8cc459c1f$export$f9a8f9ac1a851fe7 = 'ai-audio-briefing';
const $d4b865e8cc459c1f$export$6086ea87dfcad89d = 'ai-audio-narration';
const $d4b865e8cc459c1f$export$daafa0ab79e187e5 = 'ai-title-generation';
const $d4b865e8cc459c1f$export$8091bb21bb2521cb = 'ai-header-image-generation';
const $d4b865e8cc459c1f$export$530e334566c01c65 = 'plan-comparison-modal';
const $d4b865e8cc459c1f$export$af3f8586c2e30e0 = 'pendo-installation';
const $d4b865e8cc459c1f$export$7f32d11b06ee25ff = 'reading-aids';
const $d4b865e8cc459c1f$export$38e6a52d8f0a641f = 'ai-definitions-autohighlight';
const $d4b865e8cc459c1f$export$9bd965a890617f5b = 'view-guest-request-to-upgrade';
const $d4b865e8cc459c1f$export$85b1366ed05e7209 = 'submit-guest-request-to-upgrade';
const $d4b865e8cc459c1f$export$7ca653e6d1fa2509 = 'view-guest-request-to-upgrade-side-nav';
const $d4b865e8cc459c1f$export$30addda68c1793d0 = 'submit-guest-request-to-upgrade-side-nav';
const $d4b865e8cc459c1f$export$aace851408b6de3e = 'submit-guest-mentions-upgrade-flow';
const $d4b865e8cc459c1f$export$611140537004e76c = 'view-guest-spaces-menu-request-to-upgrade';
const $d4b865e8cc459c1f$export$e73147035caab2f2 = 'submit-guest-spaces-menu-request-to-upgrade';
const $d4b865e8cc459c1f$export$11311af26ac8cb8b = 'restore-space';
const $d4b865e8cc459c1f$export$dec29f1de3a4a5ce = 'hard-delete-space';
const $d4b865e8cc459c1f$export$e69556d68987dda1 = 'view-space-permissions';
const $d4b865e8cc459c1f$export$a5bcda9ae1f6839a = 'edit-space-permissions';
const $d4b865e8cc459c1f$export$22c9153bc8c871f3 = 'view-app-custom-content-permissions';
const $d4b865e8cc459c1f$export$32f7f39f260e234c = 'edit-app-custom-content-permissions';
const $d4b865e8cc459c1f$export$c39bf2cb4e8cc70c = 'view-jsm-banner';
const $d4b865e8cc459c1f$export$4e373788dac39943 = 'disable-jsm-permissions';
const $d4b865e8cc459c1f$export$f7308c84ae7be9c8 = 'view-default-space-permissions';
const $d4b865e8cc459c1f$export$85cd19170159a085 = 'edit-default-space-permissions';
const $d4b865e8cc459c1f$export$3cfa8e4552e9e6ce = 'view-all-spaces-tab';
const $d4b865e8cc459c1f$export$c9f8ebbba8f73eeb = 'company-home-builder-load';
const $d4b865e8cc459c1f$export$d4d3fc5b22a2a5d2 = 'company-home-builder-edit';
const $d4b865e8cc459c1f$export$cc438f9a49eb57aa = 'company-home-builder-edit/upload';
const $d4b865e8cc459c1f$export$90e15cc4582adffa = 'company-hub-creation';
const $d4b865e8cc459c1f$export$9458ecd4beb6dc6b = 'company-hub-change-hub-name';
const $d4b865e8cc459c1f$export$7f2689ec25c432a4 = 'front-cover-load'; // TODO: rename this to COMPANY_HUB_LOAD_EXPERIENCE
const $d4b865e8cc459c1f$export$c8ff6311a26d2c8c = 'company-hub-unpublish-hub';
const $d4b865e8cc459c1f$export$f5a5045f5872d850 = 'company-hub-analytics';
const $d4b865e8cc459c1f$export$2c2b8afe13693d2b = 'company-hub-analytics-box-row';
const $d4b865e8cc459c1f$export$db8c2f7bf58fe015 = 'company-hub-analytics-chart';
const $d4b865e8cc459c1f$export$b0852f88603c392f = 'company-hub-analytics-table';
const $d4b865e8cc459c1f$export$c5e974e322d233b1 = 'company-hub-card-ai-description';
const $d4b865e8cc459c1f$export$c6d05c48b9430e3c = 'company-hub-editor';
const $d4b865e8cc459c1f$export$35975591aeab4dd6 = 'company-hub-editor/load';
const $d4b865e8cc459c1f$export$7a3dfdccebea9c7b = 'company-hub-editor/close';
const $d4b865e8cc459c1f$export$eef6122c9774ba1c = 'front-cover-publish'; // TODO: rename this to COMPANY_HUB_PUBLISH_EXPERIENCE
const $d4b865e8cc459c1f$export$b414a79d615eda80 = 'end-of-trial-modal';
const $d4b865e8cc459c1f$export$393f60effc43223a = 'end-of-trial-modal/number-of-users';
const $d4b865e8cc459c1f$export$85f2b0ac7d403e39 = 'end-of-trial-modal/guest-access';
const $d4b865e8cc459c1f$export$d28aabd131a0c82d = 'end-of-trial-modal/page-insights';
const $d4b865e8cc459c1f$export$a3809cd1b0c7c1f9 = 'end-of-trial-modal/page-restrictions';
const $d4b865e8cc459c1f$export$82fbc9c9caa0525b = 'end-of-trial-modal/osb-link';
const $d4b865e8cc459c1f$export$651b4e780cbf5647 = 'cards-image-upload';
const $d4b865e8cc459c1f$export$3e70adb2ef2d5f7a = 'admin-team-calendars-load';
const $d4b865e8cc459c1f$export$18051474a34eda87 = 'admin-team-calendars-update';
const $d4b865e8cc459c1f$export$7e4c7c98306e835d = 'standard-differentiators-onboarding';
const $d4b865e8cc459c1f$export$1230cc550a8fe90f = 'standard-differentiators-help';
const $d4b865e8cc459c1f$export$dc2f45d36e47ca3a = 'admin-general-configuration-load';
const $d4b865e8cc459c1f$export$b27bac0c0dea2a55 = 'admin-general-configuration-update';
const $d4b865e8cc459c1f$export$a3c4dc4a199ee1b8 = 'admin-general-configuration-update/favicon-upload';
const $d4b865e8cc459c1f$export$d32cd699d9dbf985 = 'notifications-site-settings-load';
const $d4b865e8cc459c1f$export$6fd7ab2f1e137193 = 'notifications-site-settings-update';
const $d4b865e8cc459c1f$export$7875e1f75aa15306 = 'admin-configure-code-macro-load';
const $d4b865e8cc459c1f$export$164e825247db8d43 = 'admin-configure-code-macro-update';
const $d4b865e8cc459c1f$export$c390f9e07c545581 = 'admin-default-space-logo-config-load';
const $d4b865e8cc459c1f$export$4090d6a71e5b3ead = 'admin-default-space-logo-config-media-service-load';
const $d4b865e8cc459c1f$export$a1986920605a1163 = 'admin-default-space-logo-config-update';
const $d4b865e8cc459c1f$export$313ad6157a5a0ea9 = 'admin-header-and-footer-load';
const $d4b865e8cc459c1f$export$dd6c028654f91f02 = 'admin-header-and-footer-update';
const $d4b865e8cc459c1f$export$bb009baa1a9cbcf0 = 'space-settings-admin-page-layout-load';
const $d4b865e8cc459c1f$export$6d0fbdff5b6fa174 = 'space-settings-admin-page-layout-update';
const $d4b865e8cc459c1f$export$8abd8604ca7982c7 = 'admin-security-configuration-load';
const $d4b865e8cc459c1f$export$21855cac8c6f3d91 = 'admin-security-configuration-update';
const $d4b865e8cc459c1f$export$faa6a1cbc50fd4a5 = 'admin-templates-and-blueprints-load';
const $d4b865e8cc459c1f$export$9cfd44509d36312b = 'admin-templates-and-blueprints-load/page-templates';
const $d4b865e8cc459c1f$export$fb29220c46f6993 = 'admin-templates-and-blueprints-load/page-blueprints';
const $d4b865e8cc459c1f$export$90402aae1ab35229 = 'admin-templates-and-blueprints-load/system-templates';
const $d4b865e8cc459c1f$export$8e008c4796774e26 = 'space-settings-admin-templates-and-blueprints-load';
const $d4b865e8cc459c1f$export$bc61a3e94ba2560e = 'admin-import-spaces-configuration-load';
const $d4b865e8cc459c1f$export$936492407dd3e3ab = 'admin-import-spaces-import';
const $d4b865e8cc459c1f$export$99f32e90f59041e7 = 'admin-trashed-spaces-load';
const $d4b865e8cc459c1f$export$1057adadb9206825 = 'admin-trashed-spaces-restore';
const $d4b865e8cc459c1f$export$9f610d573468ea4 = 'admin-trashed-spaces-hard-delete';
const $d4b865e8cc459c1f$export$86fdc512ee3200db = 'admin-color-scheme-load';
const $d4b865e8cc459c1f$export$db764d23341437ca = 'admin-color-scheme-update';
const $d4b865e8cc459c1f$export$4447822883006e0 = 'admin-application-navigator-load';
const $d4b865e8cc459c1f$export$93194ca916026abe = 'admin-application-navigator-update';
const $d4b865e8cc459c1f$export$c226034eea0cb4de = 'admin-application-navigator-add';
const $d4b865e8cc459c1f$export$22f1f1a21c7d0c50 = 'admin-themes-load';
const $d4b865e8cc459c1f$export$12093307e4f8fd56 = 'admin-themes-update';
const $d4b865e8cc459c1f$export$a48b049eb2fcbe71 = 'space-settings-admin-themes-load';
const $d4b865e8cc459c1f$export$5b92dfbf1efa2144 = 'space-settings-admin-themes-update';
const $d4b865e8cc459c1f$export$565897f0a51f5efd = 'admin-jira-macro-repair-load';
const $d4b865e8cc459c1f$export$2292c61864873ec0 = 'admin-jira-macro-repair-update';
const $d4b865e8cc459c1f$export$d8f5df97692e60be = 'admin-pdf-export-load-experience';
const $d4b865e8cc459c1f$export$e2eb28f9e03e0850 = 'admin-pdf-export-update-experience';
const $d4b865e8cc459c1f$export$ab0128b7a160aaed = 'space-settings-admin-pdf-export-load-experience';
const $d4b865e8cc459c1f$export$e65a54ac514355c1 = 'space-settings-admin-pdf-export-update-experience';
const $d4b865e8cc459c1f$export$9fb76bc73314ca1e = 'space-settings-csv-export-experience';
const $d4b865e8cc459c1f$export$fde5d45e43ea2ca4 = 'export-page-tree-load';
const $d4b865e8cc459c1f$export$b9b428ecdf423548 = 'export-page-export-completed-export-and-download';
const $d4b865e8cc459c1f$export$5fa322173b52c417 = 'pdf-export-page';
const $d4b865e8cc459c1f$export$bda7d7fc953c118f = 'space-settings-legacy-content-report-experience';
const $d4b865e8cc459c1f$export$c08c7422d3e7a141 = 'admin-macro-usage-load';
const $d4b865e8cc459c1f$export$d6369a194e24ad7f = 'watch-dialog-watch';
const $d4b865e8cc459c1f$export$8012a45d3107312e = 'watch-dialog-watch-children';
const $d4b865e8cc459c1f$export$84a690fd513af1de = 'manage-watchers-dialog-unfiltered';
const $d4b865e8cc459c1f$export$7c7b27adbfa0b2a1 = 'auto-upgrade-awareness-modal';
const $d4b865e8cc459c1f$export$6d5416d96215c2a6 = 'space-settings-admin-look-and-feel-experience';
const $d4b865e8cc459c1f$export$ce75b3763db649b5 = 'user-access-update';
const $d4b865e8cc459c1f$export$ae036afd16ed2b49 = 'user-access-space-permissions-report';
const $d4b865e8cc459c1f$export$2361c2310cf691ea = 'convert-page-to-folder';
const $d4b865e8cc459c1f$export$e85b045b69985ed1 = 'share-and-restrict-button-load';
const $d4b865e8cc459c1f$export$4717394ee1c94acc = 'share-and-restrict-dialog-load';
const $d4b865e8cc459c1f$export$15b0dc8b7eaf2460 = 'share-and-restrict-dialog-save-action';
const $d4b865e8cc459c1f$export$d7fbaabd51b7e8aa = 'share-and-restrict-dialog-share-action';
const $d4b865e8cc459c1f$export$62f393504fed6ed = 'flyout-messaging';
const $d4b865e8cc459c1f$export$5409fe2736a41b4e = 'confluence-eot-premium-recommend-standard-buy';
const $d4b865e8cc459c1f$export$b3185617ebec44c9 = 'view-space-role-assignments';
const $d4b865e8cc459c1f$export$2bf4fa4e191abad2 = 'edit-space-role-assignments';
const $d4b865e8cc459c1f$export$a2e8aa26b8f23b29 = 'view-default-space-role-assignments';
const $d4b865e8cc459c1f$export$f615f6649fe944d3 = 'edit-default-space-role-assignments';
const $d4b865e8cc459c1f$export$c355f58335217bcc = 'view-site-roles';
const $d4b865e8cc459c1f$export$ea342babb9acb6bc = 'edit-site-roles';
const $d4b865e8cc459c1f$export$f6c4ac51d51b4d11 = 'space-details-load';
const $d4b865e8cc459c1f$export$e6949233f3fd16fa = 'space-details-update';
const $d4b865e8cc459c1f$export$ac4798c67f4aca63 = 'space-details-space-label-search';
const $d4b865e8cc459c1f$export$13c8bebb873a5fd2 = 'object-header';
const $d4b865e8cc459c1f$export$717078a23de7ce41 = 'sidebar-details-panel-load';
const $d4b865e8cc459c1f$export$8bb2fdea912e6360 = 'sidebar-comments-panel-load';
const $d4b865e8cc459c1f$export$785ec834db7448db = 'sidebar-comments-panel-load-open';
const $d4b865e8cc459c1f$export$9455f903a440f62b = 'sidebar-comments-panel-load-unread';
const $d4b865e8cc459c1f$export$9eb18c236ac889d2 = 'sidebar-comments-panel-load-resolved';
const $d4b865e8cc459c1f$export$e6d0321727a888ba = 'sidebar-comments-panel-load-deleted-content';
const $d4b865e8cc459c1f$export$89c31c18d20e326d = 'comments-data-background-load';
const $d4b865e8cc459c1f$export$1f5ef81ae9b1b308 = 'import-content';
const $d4b865e8cc459c1f$export$8e0f9138cc943183 = 'import-miro-users';
const $d4b865e8cc459c1f$export$c81d8b61dfed18d = 'mpucup-free-to-standard-fg-modal';
const $d4b865e8cc459c1f$export$bf23e3ec80d510d = 'content-overflow-menu';
const $d4b865e8cc459c1f$export$5167cfad2b30339a = 'mobile-macro-renderer-query';
const $d4b865e8cc459c1f$export$db5f7458e232d5f3 = 'mobile-macro-renderer';
const $d4b865e8cc459c1f$export$d4235a0083f21618 = 'permissions-audit-generation';
const $d4b865e8cc459c1f$export$a992b43898fc066a = 'permissions-audit-generation-view';


class $4b50c1dadb433c8a$export$d27a2b6293f7631c extends Error {
    constructor(message){
        super(message);
        this.name = 'ExperienceTimeoutError';
    }
}






const $ebb54c1f7b9c33e4$var$CAUGHT_SESSION_ERROR_TEXT = 'Session expired';
class $ebb54c1f7b9c33e4$export$8220cdf0bd206e05 extends (0, $165abb9eb28d58da$export$12c8b3d0a1a46f87) {
    constructor(message, response){
        super(`${message} ${$ebb54c1f7b9c33e4$var$CAUGHT_SESSION_ERROR_TEXT}`, response);
    }
}
function $ebb54c1f7b9c33e4$export$1bd7f0128d65baef(error) {
    if (!error) return false;
    if (error instanceof $ebb54c1f7b9c33e4$export$8220cdf0bd206e05) return true;
    const errorMessage = error?.message || '';
    if (errorMessage.indexOf($ebb54c1f7b9c33e4$var$CAUGHT_SESSION_ERROR_TEXT) != -1) return true;
    const errorStatusCode = error?.extensions?.statusCode;
    if (errorStatusCode == 401) return true;
    return false;
}
function $ebb54c1f7b9c33e4$export$b8c2308c7b82c3a9(error) {
    if (!error) return false;
    if ($ebb54c1f7b9c33e4$export$1bd7f0128d65baef(error)) return true;
    if ((0, $cb292de0bef73a33$export$17f5e6bd290bb15d)(error)) {
        const { graphQLErrors: graphQLErrors, networkError: networkError } = error;
        if ($ebb54c1f7b9c33e4$export$1bd7f0128d65baef(networkError)) return true;
        if ((graphQLErrors || []).some($ebb54c1f7b9c33e4$export$1bd7f0128d65baef)) return true;
    }
    return false;
}



var $34Zxt = parcelRequire("34Zxt");

const $0f301ee8607b3904$export$1e9642d012cc75d6 = {
    uuid: null,
    pageId: '',
    routeName: '',
    transitionId: 0,
    routingTimestamp: 0,
    currentSavedTimestamp: 0,
    isLivePage: null
};


const $0b946e8b990b9608$export$3dc3660453120ccc = ()=>{
    (0, $0f301ee8607b3904$export$1e9642d012cc75d6).currentSavedTimestamp = performance.now();
    const activeTrace = (0, $aae51952f0016112$export$b6ac780db3a3cc77)();
    const activeTraceId = activeTrace?.traceId;
    return {
        uuid: (0, $0f301ee8607b3904$export$1e9642d012cc75d6).uuid,
        contentId: (0, $0f301ee8607b3904$export$1e9642d012cc75d6).pageId,
        isInitial: (0, $0f301ee8607b3904$export$1e9642d012cc75d6).transitionId === 0,
        isSSR: Boolean(window['__SSR_RENDERED__']),
        routingDuration: (0, $0f301ee8607b3904$export$1e9642d012cc75d6).currentSavedTimestamp - (0, $0f301ee8607b3904$export$1e9642d012cc75d6).routingTimestamp,
        ...activeTraceId ? {
            ufoTraceId: activeTraceId,
            ufoTraceType: activeTrace.type
        } : {},
        ...(0, $0f301ee8607b3904$export$1e9642d012cc75d6).isLivePage !== null ? {
            isLivePage: (0, $0f301ee8607b3904$export$1e9642d012cc75d6).isLivePage
        } : {}
    };
};
const $0b946e8b990b9608$export$eef458cd11f4b6e7 = ()=>{
    return (0, $0f301ee8607b3904$export$1e9642d012cc75d6).currentSavedTimestamp;
};
const $0b946e8b990b9608$export$8c17c676096b7909 = (routeName = '', match, transitionId, userInfo)=>{
    const contentId = match?.params?.contentId;
    const useUserInfo = userInfo.userId;
    if ((0, $0f301ee8607b3904$export$1e9642d012cc75d6).pageId !== contentId || (0, $0f301ee8607b3904$export$1e9642d012cc75d6).routeName !== routeName) {
        let savedUniqueId;
        if (useUserInfo) savedUniqueId = $0b946e8b990b9608$var$createPageLoadId(routeName, contentId, userInfo);
        else savedUniqueId = $0b946e8b990b9608$var$createUniqueId();
        (0, $0f301ee8607b3904$export$1e9642d012cc75d6).uuid = savedUniqueId;
        (0, $0f301ee8607b3904$export$1e9642d012cc75d6).routeName = routeName;
        (0, $0f301ee8607b3904$export$1e9642d012cc75d6).pageId = contentId;
        (0, $0f301ee8607b3904$export$1e9642d012cc75d6).transitionId = transitionId;
        (0, $0f301ee8607b3904$export$1e9642d012cc75d6).routingTimestamp = performance.now();
    }
};
const $0b946e8b990b9608$export$2cb0d16c23c1cda0 = (isLivePage)=>{
    (0, $0f301ee8607b3904$export$1e9642d012cc75d6).isLivePage = isLivePage;
};
// refer to https://gist.github.com/jed/982883 for uuid generation
// For Anonymous users
const $0b946e8b990b9608$var$createUniqueId = ()=>{
    return `${1e7}${-1000}${-4000}${-8000}${-100000000000}`.replace(/1|0/g, function() {
        // This is a LEGACY disable statement after rule addition. Use `Math.floor()` next time
        // eslint-disable-next-line no-bitwise
        return (0 | Math.random() * 16).toString(16);
    });
};
// For Atlassian users
const $0b946e8b990b9608$var$createPageLoadId = (routeName, contentId, userInfo)=>{
    const { userId: userId, cloudId: cloudId } = userInfo;
    routeName = routeName || 'route';
    contentId = contentId || 'page';
    // TO-DO ask Dennis if he wants to take any of these out
    return `${routeName}-${contentId}-${userId}-${cloudId}-${Date.now()}`;
};






var $gqzfn = parcelRequire("gqzfn");

var $gqzfn = parcelRequire("gqzfn");

var $3UfL2 = parcelRequire("3UfL2");

var $1CHRc = parcelRequire("1CHRc");
var $f3d34949c63e9876$var$genericMessage = "Invariant Violation";
var $f3d34949c63e9876$var$_a = Object.setPrototypeOf, $f3d34949c63e9876$var$setPrototypeOf = $f3d34949c63e9876$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $f3d34949c63e9876$var$_a;
var $f3d34949c63e9876$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $3UfL2.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $f3d34949c63e9876$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $f3d34949c63e9876$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $f3d34949c63e9876$var$genericMessage;
        $f3d34949c63e9876$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $f3d34949c63e9876$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $f3d34949c63e9876$export$cea12affaee22fe8(message);
}
function $f3d34949c63e9876$var$wrapConsoleMethod(method) {
    return function() {
        return console[method].apply(console, arguments);
    };
}
(function(invariant) {
    invariant.warn = $f3d34949c63e9876$var$wrapConsoleMethod("warn");
    invariant.error = $f3d34949c63e9876$var$wrapConsoleMethod("error");
})($f3d34949c63e9876$export$f5708dca728d7177 || ($f3d34949c63e9876$export$f5708dca728d7177 = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var $f3d34949c63e9876$export$e54fe5b0f43758f7 = {
    env: {}
};
if (typeof $1CHRc === "object") $f3d34949c63e9876$export$e54fe5b0f43758f7 = $1CHRc;
else try {
    // Using Function to evaluate this assignment in global scope also escapes
    // the strict mode of the current module, thereby allowing the assignment.
    // Inspired by https://github.com/facebook/regenerator/pull/369.
    Function("stub", "process = stub")($f3d34949c63e9876$export$e54fe5b0f43758f7);
} catch (atLeastWeTried) {
// The assignment can fail if a Content Security Policy heavy-handedly
// forbids Function usage. In those environments, developers should take
// extra care to replace process.env.NODE_ENV in their production builds,
// or define an appropriate global.process polyfill.
}
var $f3d34949c63e9876$var$invariant$1 = $f3d34949c63e9876$export$f5708dca728d7177;
var $f3d34949c63e9876$export$2e2bcd8739ae039 = $f3d34949c63e9876$var$invariant$1;


var $0a7f56b0d02823e9$var$apolloContext;
function $0a7f56b0d02823e9$export$a47505d961ee3a1() {
    if (!$0a7f56b0d02823e9$var$apolloContext) $0a7f56b0d02823e9$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createContext({});
    return $0a7f56b0d02823e9$var$apolloContext;
}
function $0a7f56b0d02823e9$export$c2ee824bcc89ca6a() {
    $0a7f56b0d02823e9$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createContext({});
}
var $0a7f56b0d02823e9$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = $0a7f56b0d02823e9$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement(ApolloContext.Consumer, null, function(context) {
        if (context === void 0) context = {};
        if (client && context.client !== client) context = Object.assign({}, context, {
            client: client
        });
        (0, $f3d34949c63e9876$export$f5708dca728d7177)(context.client, 5);
        return (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement(ApolloContext.Provider, {
            value: context
        }, children);
    });
};
var $0a7f56b0d02823e9$export$ed5ceab8c2bb5ce4 = function(props) {
    var ApolloContext = $0a7f56b0d02823e9$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement(ApolloContext.Consumer, null, function(context) {
        (0, $f3d34949c63e9876$export$f5708dca728d7177)(context && context.client, 6);
        return props.children(context.client);
    });
};
var $0a7f56b0d02823e9$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($0a7f56b0d02823e9$export$d1d99cf900472499 || ($0a7f56b0d02823e9$export$d1d99cf900472499 = {}));
var $0a7f56b0d02823e9$var$cache = new Map();
function $0a7f56b0d02823e9$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $0a7f56b0d02823e9$export$d1d99cf900472499.Query:
            name = 'Query';
            break;
        case $0a7f56b0d02823e9$export$d1d99cf900472499.Mutation:
            name = 'Mutation';
            break;
        case $0a7f56b0d02823e9$export$d1d99cf900472499.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function $0a7f56b0d02823e9$export$8f49e4af10703ce3(document) {
    var cached = $0a7f56b0d02823e9$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $f3d34949c63e9876$export$f5708dca728d7177)(!!document && !!document.kind, 1);
    var fragments = document.definitions.filter(function(x) {
        return x.kind === 'FragmentDefinition';
    });
    var queries = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'query';
    });
    var mutations = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'mutation';
    });
    var subscriptions = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'subscription';
    });
    (0, $f3d34949c63e9876$export$f5708dca728d7177)(!fragments.length || queries.length || mutations.length || subscriptions.length, 2);
    (0, $f3d34949c63e9876$export$f5708dca728d7177)(queries.length + mutations.length + subscriptions.length <= 1, 3);
    type = queries.length ? $0a7f56b0d02823e9$export$d1d99cf900472499.Query : $0a7f56b0d02823e9$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $0a7f56b0d02823e9$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $f3d34949c63e9876$export$f5708dca728d7177)(definitions.length === 1, 4);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') name = definition.name.value;
    else name = 'data';
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $0a7f56b0d02823e9$var$cache.set(document, payload);
    return payload;
}



var $3UfL2 = parcelRequire("3UfL2");

var $gqzfn = parcelRequire("gqzfn");

var $700a6971356da061$var$_a = Object.prototype, $700a6971356da061$var$toString = $700a6971356da061$var$_a.toString, $700a6971356da061$var$hasOwnProperty = $700a6971356da061$var$_a.hasOwnProperty;
var $700a6971356da061$var$previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */ function $700a6971356da061$export$411ce8e5a71e3069(a, b) {
    try {
        return $700a6971356da061$var$check(a, b);
    } finally{
        $700a6971356da061$var$previousComparisons.clear();
    }
}
function $700a6971356da061$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = $700a6971356da061$var$toString.call(a);
    var bTag = $700a6971356da061$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case '[object Object]':
            if ($700a6971356da061$var$previouslyCompared(a, b)) return true;
            var aKeys = Object.keys(a);
            var bKeys = Object.keys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length) return false;
            // Now make sure they have the same keys.
            for(var k = 0; k < keyCount; ++k){
                if (!$700a6971356da061$var$hasOwnProperty.call(b, aKeys[k])) return false;
            }
            // Finally, check deep equality of all child properties.
            for(var k = 0; k < keyCount; ++k){
                var key = aKeys[k];
                if (!$700a6971356da061$var$check(a[key], b[key])) return false;
            }
            return true;
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == "" + b;
        case '[object Map]':
        case '[object Set]':
            if (a.size !== b.size) return false;
            if ($700a6971356da061$var$previouslyCompared(a, b)) return true;
            var aIterator = a.entries();
            var isMap = aTag === '[object Map]';
            while(true){
                var info = aIterator.next();
                if (info.done) break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) return false;
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !$700a6971356da061$var$check(aValue, b.get(aKey))) return false;
            }
            return true;
    }
    // Otherwise the values are not equal.
    return false;
}
function $700a6971356da061$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = $700a6971356da061$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $700a6971356da061$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}
var $700a6971356da061$export$2e2bcd8739ae039 = $700a6971356da061$export$411ce8e5a71e3069;



var $3UfL2 = parcelRequire("3UfL2");

var $1CHRc = parcelRequire("1CHRc");
var $2d0ca7b6bb291cf2$var$genericMessage = "Invariant Violation";
var $2d0ca7b6bb291cf2$var$_a = Object.setPrototypeOf, $2d0ca7b6bb291cf2$var$setPrototypeOf = $2d0ca7b6bb291cf2$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $2d0ca7b6bb291cf2$var$_a;
var $2d0ca7b6bb291cf2$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $3UfL2.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $2d0ca7b6bb291cf2$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $2d0ca7b6bb291cf2$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $2d0ca7b6bb291cf2$var$genericMessage;
        $2d0ca7b6bb291cf2$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $2d0ca7b6bb291cf2$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $2d0ca7b6bb291cf2$export$cea12affaee22fe8(message);
}
function $2d0ca7b6bb291cf2$var$wrapConsoleMethod(method) {
    return function() {
        return console[method].apply(console, arguments);
    };
}
(function(invariant) {
    invariant.warn = $2d0ca7b6bb291cf2$var$wrapConsoleMethod("warn");
    invariant.error = $2d0ca7b6bb291cf2$var$wrapConsoleMethod("error");
})($2d0ca7b6bb291cf2$export$f5708dca728d7177 || ($2d0ca7b6bb291cf2$export$f5708dca728d7177 = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var $2d0ca7b6bb291cf2$export$e54fe5b0f43758f7 = {
    env: {}
};
if (typeof $1CHRc === "object") $2d0ca7b6bb291cf2$export$e54fe5b0f43758f7 = $1CHRc;
else try {
    // Using Function to evaluate this assignment in global scope also escapes
    // the strict mode of the current module, thereby allowing the assignment.
    // Inspired by https://github.com/facebook/regenerator/pull/369.
    Function("stub", "process = stub")($2d0ca7b6bb291cf2$export$e54fe5b0f43758f7);
} catch (atLeastWeTried) {
// The assignment can fail if a Content Security Policy heavy-handedly
// forbids Function usage. In those environments, developers should take
// extra care to replace process.env.NODE_ENV in their production builds,
// or define an appropriate global.process polyfill.
}
var $2d0ca7b6bb291cf2$var$invariant$1 = $2d0ca7b6bb291cf2$export$f5708dca728d7177;
var $2d0ca7b6bb291cf2$export$2e2bcd8739ae039 = $2d0ca7b6bb291cf2$var$invariant$1;


var $706be9e0db767cf6$var$OperationData = function() {
    function OperationData(options, context) {
        this.isMounted = false;
        this.previousOptions = {};
        this.context = {};
        this.options = {};
        this.options = options || {};
        this.context = context || {};
    }
    OperationData.prototype.getOptions = function() {
        return this.options;
    };
    OperationData.prototype.setOptions = function(newOptions, storePrevious) {
        if (storePrevious === void 0) storePrevious = false;
        if (storePrevious && !(0, $700a6971356da061$export$411ce8e5a71e3069)(this.options, newOptions)) this.previousOptions = this.options;
        this.options = newOptions;
    };
    OperationData.prototype.unmount = function() {
        this.isMounted = false;
    };
    OperationData.prototype.refreshClient = function() {
        var client = this.options && this.options.client || this.context && this.context.client;
        (0, $2d0ca7b6bb291cf2$export$f5708dca728d7177)(!!client, 2);
        var isNew = false;
        if (client !== this.client) {
            isNew = true;
            this.client = client;
            this.cleanup();
        }
        return {
            client: this.client,
            isNew: isNew
        };
    };
    OperationData.prototype.verifyDocumentType = function(document, type) {
        var operation = (0, $0a7f56b0d02823e9$export$8f49e4af10703ce3)(document);
        var requiredOperationName = (0, $0a7f56b0d02823e9$export$5db520940cf00715)(type);
        var usedOperationName = (0, $0a7f56b0d02823e9$export$5db520940cf00715)(operation.type);
        (0, $2d0ca7b6bb291cf2$export$f5708dca728d7177)(operation.type === type, 3);
    };
    return OperationData;
}();
var $706be9e0db767cf6$var$QueryData = function(_super) {
    (0, $3UfL2.__extends)(QueryData, _super);
    function QueryData(_a) {
        var options = _a.options, context = _a.context, forceUpdate = _a.forceUpdate;
        var _this = _super.call(this, options, context) || this;
        _this.previousData = {};
        _this.currentObservable = {};
        _this.runLazy = false;
        _this.runLazyQuery = function(options) {
            _this.cleanup();
            _this.runLazy = true;
            _this.lazyOptions = options;
            _this.forceUpdate();
        };
        _this.getExecuteResult = function() {
            var result = _this.getQueryResult();
            _this.startQuerySubscription();
            return result;
        };
        _this.obsRefetch = function(variables) {
            return _this.currentObservable.query.refetch(variables);
        };
        _this.obsFetchMore = function(fetchMoreOptions) {
            return _this.currentObservable.query.fetchMore(fetchMoreOptions);
        };
        _this.obsUpdateQuery = function(mapFn) {
            return _this.currentObservable.query.updateQuery(mapFn);
        };
        _this.obsStartPolling = function(pollInterval) {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.startPolling(pollInterval);
        };
        _this.obsStopPolling = function() {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.stopPolling();
        };
        _this.obsSubscribeToMore = function(options) {
            return _this.currentObservable.query.subscribeToMore(options);
        };
        _this.forceUpdate = forceUpdate;
        return _this;
    }
    QueryData.prototype.execute = function() {
        this.refreshClient();
        var _a = this.getOptions(), skip = _a.skip, query = _a.query;
        if (skip || query !== this.previousData.query) {
            this.removeQuerySubscription();
            this.previousData.query = query;
        }
        this.updateObservableQuery();
        if (this.isMounted) this.startQuerySubscription();
        return this.getExecuteSsrResult() || this.getExecuteResult();
    };
    QueryData.prototype.executeLazy = function() {
        return !this.runLazy ? [
            this.runLazyQuery,
            {
                loading: false,
                networkStatus: (0, $cb292de0bef73a33$export$bd096ddbd246c79c).ready,
                called: false,
                data: undefined
            }
        ] : [
            this.runLazyQuery,
            this.execute()
        ];
    };
    QueryData.prototype.fetchData = function() {
        var options = this.getOptions();
        if (options.skip || options.ssr === false) return false;
        var obs = this.currentObservable.query;
        var currentResult = obs.getCurrentResult();
        return currentResult.loading ? obs.result() : false;
    };
    QueryData.prototype.afterExecute = function(_a) {
        var _this = this;
        var _b = (_a === void 0 ? {} : _a).lazy, lazy = _b === void 0 ? false : _b;
        this.isMounted = true;
        if (!lazy || this.runLazy) {
            this.handleErrorOrCompleted();
            setTimeout(function() {
                _this.currentObservable.query && _this.currentObservable.query.resetQueryStoreErrors();
            });
        }
        this.previousOptions = this.getOptions();
        return this.unmount.bind(this);
    };
    QueryData.prototype.cleanup = function() {
        this.removeQuerySubscription();
        delete this.currentObservable.query;
        delete this.previousData.result;
    };
    QueryData.prototype.getOptions = function() {
        var options = _super.prototype.getOptions.call(this);
        if (this.lazyOptions) {
            options.variables = (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, options.variables), this.lazyOptions.variables);
            options.context = (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, options.context), this.lazyOptions.context);
        }
        if (this.runLazy) delete options.skip;
        return options;
    };
    QueryData.prototype.getExecuteSsrResult = function() {
        var treeRenderingInitiated = this.context && this.context.renderPromises;
        var ssrDisabled = this.getOptions().ssr === false;
        var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
        var ssrLoading = {
            loading: true,
            networkStatus: (0, $cb292de0bef73a33$export$bd096ddbd246c79c).loading,
            called: true,
            data: undefined
        };
        if (ssrDisabled && (treeRenderingInitiated || fetchDisabled)) return ssrLoading;
        var result;
        if (treeRenderingInitiated) result = this.context.renderPromises.addQueryPromise(this, this.getExecuteResult) || ssrLoading;
        return result;
    };
    QueryData.prototype.prepareObservableQueryOptions = function() {
        var options = this.getOptions();
        this.verifyDocumentType(options.query, (0, $0a7f56b0d02823e9$export$d1d99cf900472499).Query);
        var displayName = options.displayName || 'Query';
        if (this.context && this.context.renderPromises && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options.fetchPolicy = 'cache-first';
        return (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, options), {
            displayName: displayName,
            context: options.context,
            metadata: {
                reactComponent: {
                    displayName: displayName
                }
            }
        });
    };
    QueryData.prototype.initializeObservableQuery = function() {
        if (this.context && this.context.renderPromises) this.currentObservable.query = this.context.renderPromises.getSSRObservable(this.getOptions());
        if (!this.currentObservable.query) {
            var observableQueryOptions = this.prepareObservableQueryOptions();
            this.previousData.observableQueryOptions = (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, observableQueryOptions), {
                children: null
            });
            this.currentObservable.query = this.refreshClient().client.watchQuery((0, $3UfL2.__assign)({}, observableQueryOptions));
            if (this.context && this.context.renderPromises) this.context.renderPromises.registerSSRObservable(this.currentObservable.query, observableQueryOptions);
        }
    };
    QueryData.prototype.updateObservableQuery = function() {
        if (!this.currentObservable.query) {
            this.initializeObservableQuery();
            return;
        }
        var newObservableQueryOptions = (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, this.prepareObservableQueryOptions()), {
            children: null
        });
        if (!(0, $700a6971356da061$export$411ce8e5a71e3069)(newObservableQueryOptions, this.previousData.observableQueryOptions)) {
            this.previousData.observableQueryOptions = newObservableQueryOptions;
            this.currentObservable.query.setOptions(newObservableQueryOptions).catch(function() {});
        }
    };
    QueryData.prototype.startQuerySubscription = function() {
        var _this = this;
        if (this.currentObservable.subscription || this.getOptions().skip) return;
        var obsQuery = this.currentObservable.query;
        this.currentObservable.subscription = obsQuery.subscribe({
            next: function(_a) {
                var loading = _a.loading, networkStatus = _a.networkStatus, data = _a.data;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading === loading && previousResult.networkStatus === networkStatus && (0, $700a6971356da061$export$411ce8e5a71e3069)(previousResult.data, data)) return;
                _this.forceUpdate();
            },
            error: function(error) {
                _this.resubscribeToQuery();
                if (!error.hasOwnProperty('graphQLErrors')) throw error;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading || !(0, $700a6971356da061$export$411ce8e5a71e3069)(error, _this.previousData.error)) {
                    _this.previousData.error = error;
                    _this.forceUpdate();
                }
            }
        });
    };
    QueryData.prototype.resubscribeToQuery = function() {
        this.removeQuerySubscription();
        var lastError = this.currentObservable.query.getLastError();
        var lastResult = this.currentObservable.query.getLastResult();
        this.currentObservable.query.resetLastResults();
        this.startQuerySubscription();
        Object.assign(this.currentObservable.query, {
            lastError: lastError,
            lastResult: lastResult
        });
    };
    QueryData.prototype.getQueryResult = function() {
        var result = this.observableQueryFields();
        var options = this.getOptions();
        if (options.skip) result = (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, result), {
            data: undefined,
            error: undefined,
            loading: false,
            called: true
        });
        else {
            var currentResult = this.currentObservable.query.getCurrentResult();
            var loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
            var error = currentResult.error, data = currentResult.data;
            if (errors && errors.length > 0) error = new (0, $cb292de0bef73a33$export$26a337512320b8c6)({
                graphQLErrors: errors
            });
            result = (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, result), {
                loading: loading,
                networkStatus: networkStatus,
                error: error,
                called: true
            });
            if (loading) {
                var previousData = this.previousData.result && this.previousData.result.data;
                result.data = previousData && data ? (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, previousData), data) : previousData || data;
            } else if (error) Object.assign(result, {
                data: (this.currentObservable.query.getLastResult() || {}).data
            });
            else {
                var fetchPolicy = this.currentObservable.query.options.fetchPolicy;
                var partialRefetch = options.partialRefetch;
                if (partialRefetch && !data && partial && fetchPolicy !== 'cache-only') {
                    Object.assign(result, {
                        loading: true,
                        networkStatus: (0, $cb292de0bef73a33$export$bd096ddbd246c79c).loading
                    });
                    result.refetch();
                    return result;
                }
                result.data = data;
            }
        }
        result.client = this.client;
        this.previousData.loading = this.previousData.result && this.previousData.result.loading || false;
        this.previousData.result = result;
        return result;
    };
    QueryData.prototype.handleErrorOrCompleted = function() {
        var obsQuery = this.currentObservable.query;
        if (!obsQuery) return;
        var _a = obsQuery.getCurrentResult(), data = _a.data, loading = _a.loading, error = _a.error;
        if (!loading) {
            var _b = this.getOptions(), query = _b.query, variables = _b.variables, onCompleted = _b.onCompleted, onError = _b.onError;
            if (this.previousOptions && !this.previousData.loading && (0, $700a6971356da061$export$411ce8e5a71e3069)(this.previousOptions.query, query) && (0, $700a6971356da061$export$411ce8e5a71e3069)(this.previousOptions.variables, variables)) return;
            if (onCompleted && !error) onCompleted(data);
            else if (onError && error) onError(error);
        }
    };
    QueryData.prototype.removeQuerySubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    QueryData.prototype.observableQueryFields = function() {
        var observable = this.currentObservable.query;
        return {
            variables: observable.variables,
            refetch: this.obsRefetch,
            fetchMore: this.obsFetchMore,
            updateQuery: this.obsUpdateQuery,
            startPolling: this.obsStartPolling,
            stopPolling: this.obsStopPolling,
            subscribeToMore: this.obsSubscribeToMore
        };
    };
    return QueryData;
}($706be9e0db767cf6$var$OperationData);
function $706be9e0db767cf6$var$useDeepMemo(memoFn, key) {
    var ref = (0, $gqzfn.useRef)();
    if (!ref.current || !(0, $700a6971356da061$export$411ce8e5a71e3069)(key, ref.current.key)) ref.current = {
        key: key,
        value: memoFn()
    };
    return ref.current.value;
}
function $706be9e0db767cf6$var$useBaseQuery(query, options, lazy) {
    if (lazy === void 0) lazy = false;
    var context = (0, $gqzfn.useContext)((0, $0a7f56b0d02823e9$export$a47505d961ee3a1)());
    var _a = (0, $gqzfn.useReducer)(function(x) {
        return x + 1;
    }, 0), tick = _a[0], forceUpdate = _a[1];
    var updatedOptions = options ? (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, options), {
        query: query
    }) : {
        query: query
    };
    var queryDataRef = (0, $gqzfn.useRef)();
    if (!queryDataRef.current) queryDataRef.current = new $706be9e0db767cf6$var$QueryData({
        options: updatedOptions,
        context: context,
        forceUpdate: forceUpdate
    });
    var queryData = queryDataRef.current;
    queryData.setOptions(updatedOptions);
    queryData.context = context;
    var memo = {
        options: (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, updatedOptions), {
            onError: undefined,
            onCompleted: undefined
        }),
        context: context,
        tick: tick
    };
    var result = $706be9e0db767cf6$var$useDeepMemo(function() {
        return lazy ? queryData.executeLazy() : queryData.execute();
    }, memo);
    var queryResult = lazy ? result[1] : result;
    (0, $gqzfn.useEffect)(function() {
        return queryData.afterExecute({
            lazy: lazy
        });
    }, [
        queryResult.loading,
        queryResult.networkStatus,
        queryResult.error,
        queryResult.data
    ]);
    (0, $gqzfn.useEffect)(function() {
        return function() {
            return queryData.cleanup();
        };
    }, []);
    return result;
}
function $706be9e0db767cf6$export$dd0a697e1782aedd(query, options) {
    return $706be9e0db767cf6$var$useBaseQuery(query, options, false);
}
function $706be9e0db767cf6$export$fd83eea6ecd2d8fa(query, options) {
    return $706be9e0db767cf6$var$useBaseQuery(query, options, true);
}
var $706be9e0db767cf6$var$MutationData = function(_super) {
    (0, $3UfL2.__extends)(MutationData, _super);
    function MutationData(_a) {
        var options = _a.options, context = _a.context, result = _a.result, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.runMutation = function(mutationFunctionOptions) {
            if (mutationFunctionOptions === void 0) mutationFunctionOptions = {};
            _this.onMutationStart();
            var mutationId = _this.generateNewMutationId();
            return _this.mutate(mutationFunctionOptions).then(function(response) {
                _this.onMutationCompleted(response, mutationId);
                return response;
            }).catch(function(error) {
                _this.onMutationError(error, mutationId);
                if (!_this.getOptions().onError) throw error;
            });
        };
        _this.verifyDocumentType(options.mutation, (0, $0a7f56b0d02823e9$export$d1d99cf900472499).Mutation);
        _this.result = result;
        _this.setResult = setResult;
        _this.mostRecentMutationId = 0;
        return _this;
    }
    MutationData.prototype.execute = function(result) {
        this.isMounted = true;
        this.verifyDocumentType(this.getOptions().mutation, (0, $0a7f56b0d02823e9$export$d1d99cf900472499).Mutation);
        result.client = this.refreshClient().client;
        return [
            this.runMutation,
            result
        ];
    };
    MutationData.prototype.afterExecute = function() {
        this.isMounted = true;
        return this.unmount.bind(this);
    };
    MutationData.prototype.cleanup = function() {};
    MutationData.prototype.mutate = function(mutationFunctionOptions) {
        var _a = this.getOptions(), mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, mutationContext = _b === void 0 ? {} : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, fetchPolicy = _a.fetchPolicy;
        var mutateOptions = (0, $3UfL2.__assign)({}, mutationFunctionOptions);
        var mutateVariables = Object.assign({}, variables, mutateOptions.variables);
        delete mutateOptions.variables;
        return this.refreshClient().client.mutate((0, $3UfL2.__assign)({
            mutation: mutation,
            optimisticResponse: optimisticResponse,
            refetchQueries: mutateOptions.refetchQueries || this.getOptions().refetchQueries,
            awaitRefetchQueries: awaitRefetchQueries,
            update: update,
            context: mutationContext,
            fetchPolicy: fetchPolicy,
            variables: mutateVariables
        }, mutateOptions));
    };
    MutationData.prototype.onMutationStart = function() {
        if (!this.result.loading && !this.getOptions().ignoreResults) this.updateResult({
            loading: true,
            error: undefined,
            data: undefined,
            called: true
        });
    };
    MutationData.prototype.onMutationCompleted = function(response, mutationId) {
        var _a = this.getOptions(), onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
        var data = response.data, errors = response.errors;
        var error = errors && errors.length > 0 ? new (0, $cb292de0bef73a33$export$26a337512320b8c6)({
            graphQLErrors: errors
        }) : undefined;
        var callOncomplete = function() {
            return onCompleted ? onCompleted(data) : null;
        };
        if (this.isMostRecentMutation(mutationId) && !ignoreResults) this.updateResult({
            called: true,
            loading: false,
            data: data,
            error: error
        });
        callOncomplete();
    };
    MutationData.prototype.onMutationError = function(error, mutationId) {
        var onError = this.getOptions().onError;
        if (this.isMostRecentMutation(mutationId)) this.updateResult({
            loading: false,
            error: error,
            data: undefined,
            called: true
        });
        if (onError) onError(error);
    };
    MutationData.prototype.generateNewMutationId = function() {
        return ++this.mostRecentMutationId;
    };
    MutationData.prototype.isMostRecentMutation = function(mutationId) {
        return this.mostRecentMutationId === mutationId;
    };
    MutationData.prototype.updateResult = function(result) {
        if (this.isMounted && (!this.previousResult || !(0, $700a6971356da061$export$411ce8e5a71e3069)(this.previousResult, result))) {
            this.setResult(result);
            this.previousResult = result;
        }
    };
    return MutationData;
}($706be9e0db767cf6$var$OperationData);
function $706be9e0db767cf6$export$609860bf8b0084c(mutation, options) {
    var context = (0, $gqzfn.useContext)((0, $0a7f56b0d02823e9$export$a47505d961ee3a1)());
    var _a = (0, $gqzfn.useState)({
        called: false,
        loading: false
    }), result = _a[0], setResult = _a[1];
    var updatedOptions = options ? (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, options), {
        mutation: mutation
    }) : {
        mutation: mutation
    };
    var mutationDataRef = (0, $gqzfn.useRef)();
    function getMutationDataRef() {
        if (!mutationDataRef.current) mutationDataRef.current = new $706be9e0db767cf6$var$MutationData({
            options: updatedOptions,
            context: context,
            result: result,
            setResult: setResult
        });
        return mutationDataRef.current;
    }
    var mutationData = getMutationDataRef();
    mutationData.setOptions(updatedOptions);
    mutationData.context = context;
    (0, $gqzfn.useEffect)(function() {
        return mutationData.afterExecute();
    });
    return mutationData.execute(result);
}
var $706be9e0db767cf6$var$SubscriptionData = function(_super) {
    (0, $3UfL2.__extends)(SubscriptionData, _super);
    function SubscriptionData(_a) {
        var options = _a.options, context = _a.context, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.currentObservable = {};
        _this.setResult = setResult;
        _this.initialize(options);
        return _this;
    }
    SubscriptionData.prototype.execute = function(result) {
        if (this.getOptions().skip === true) {
            this.cleanup();
            return {
                loading: false,
                error: undefined,
                data: undefined,
                variables: this.getOptions().variables
            };
        }
        var currentResult = result;
        if (this.refreshClient().isNew) currentResult = this.getLoadingResult();
        var shouldResubscribe = this.getOptions().shouldResubscribe;
        if (typeof shouldResubscribe === 'function') shouldResubscribe = !!shouldResubscribe(this.getOptions());
        if (shouldResubscribe !== false && this.previousOptions && Object.keys(this.previousOptions).length > 0 && (this.previousOptions.subscription !== this.getOptions().subscription || !(0, $700a6971356da061$export$411ce8e5a71e3069)(this.previousOptions.variables, this.getOptions().variables) || this.previousOptions.skip !== this.getOptions().skip)) {
            this.cleanup();
            currentResult = this.getLoadingResult();
        }
        this.initialize(this.getOptions());
        this.startSubscription();
        this.previousOptions = this.getOptions();
        return (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, currentResult), {
            variables: this.getOptions().variables
        });
    };
    SubscriptionData.prototype.afterExecute = function() {
        this.isMounted = true;
    };
    SubscriptionData.prototype.cleanup = function() {
        this.endSubscription();
        delete this.currentObservable.query;
    };
    SubscriptionData.prototype.initialize = function(options) {
        if (this.currentObservable.query || this.getOptions().skip === true) return;
        this.currentObservable.query = this.refreshClient().client.subscribe({
            query: options.subscription,
            variables: options.variables,
            fetchPolicy: options.fetchPolicy
        });
    };
    SubscriptionData.prototype.startSubscription = function() {
        if (this.currentObservable.subscription) return;
        this.currentObservable.subscription = this.currentObservable.query.subscribe({
            next: this.updateCurrentData.bind(this),
            error: this.updateError.bind(this),
            complete: this.completeSubscription.bind(this)
        });
    };
    SubscriptionData.prototype.getLoadingResult = function() {
        return {
            loading: true,
            error: undefined,
            data: undefined
        };
    };
    SubscriptionData.prototype.updateResult = function(result) {
        if (this.isMounted) this.setResult(result);
    };
    SubscriptionData.prototype.updateCurrentData = function(result) {
        var onSubscriptionData = this.getOptions().onSubscriptionData;
        this.updateResult({
            data: result.data,
            loading: false,
            error: undefined
        });
        if (onSubscriptionData) onSubscriptionData({
            client: this.refreshClient().client,
            subscriptionData: result
        });
    };
    SubscriptionData.prototype.updateError = function(error) {
        this.updateResult({
            error: error,
            loading: false
        });
    };
    SubscriptionData.prototype.completeSubscription = function() {
        var onSubscriptionComplete = this.getOptions().onSubscriptionComplete;
        if (onSubscriptionComplete) onSubscriptionComplete();
        this.endSubscription();
    };
    SubscriptionData.prototype.endSubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    return SubscriptionData;
}($706be9e0db767cf6$var$OperationData);
function $706be9e0db767cf6$export$368b4214baeb914c(subscription, options) {
    var context = (0, $gqzfn.useContext)((0, $0a7f56b0d02823e9$export$a47505d961ee3a1)());
    var updatedOptions = options ? (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, options), {
        subscription: subscription
    }) : {
        subscription: subscription
    };
    var _a = (0, $gqzfn.useState)({
        loading: !updatedOptions.skip,
        error: undefined,
        data: undefined
    }), result = _a[0], setResult = _a[1];
    var subscriptionDataRef = (0, $gqzfn.useRef)();
    function getSubscriptionDataRef() {
        if (!subscriptionDataRef.current) subscriptionDataRef.current = new $706be9e0db767cf6$var$SubscriptionData({
            options: updatedOptions,
            context: context,
            setResult: setResult
        });
        return subscriptionDataRef.current;
    }
    var subscriptionData = getSubscriptionDataRef();
    subscriptionData.setOptions(updatedOptions, true);
    subscriptionData.context = context;
    (0, $gqzfn.useEffect)(function() {
        return subscriptionData.afterExecute();
    });
    (0, $gqzfn.useEffect)(function() {
        return subscriptionData.cleanup.bind(subscriptionData);
    }, []);
    return subscriptionData.execute(result);
}
function $706be9e0db767cf6$export$eb9a56e7a29e494() {
    var client = (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).useContext((0, $0a7f56b0d02823e9$export$a47505d961ee3a1)()).client;
    (0, $2d0ca7b6bb291cf2$export$f5708dca728d7177)(client, 1);
    return client;
}
function $706be9e0db767cf6$var$makeDefaultQueryInfo() {
    return {
        seen: false,
        observable: null
    };
}
var $706be9e0db767cf6$export$260e90e395a79974 = function() {
    function RenderPromises() {
        this.queryPromises = new Map();
        this.queryInfoTrie = new Map();
    }
    RenderPromises.prototype.registerSSRObservable = function(observable, props) {
        this.lookupQueryInfo(props).observable = observable;
    };
    RenderPromises.prototype.getSSRObservable = function(props) {
        return this.lookupQueryInfo(props).observable;
    };
    RenderPromises.prototype.addQueryPromise = function(queryInstance, finish) {
        var info = this.lookupQueryInfo(queryInstance.getOptions());
        if (!info.seen) {
            this.queryPromises.set(queryInstance.getOptions(), new Promise(function(resolve) {
                resolve(queryInstance.fetchData());
            }));
            return null;
        }
        return finish();
    };
    RenderPromises.prototype.hasPromises = function() {
        return this.queryPromises.size > 0;
    };
    RenderPromises.prototype.consumeAndAwaitPromises = function() {
        var _this = this;
        var promises = [];
        this.queryPromises.forEach(function(promise, queryInstance) {
            _this.lookupQueryInfo(queryInstance).seen = true;
            promises.push(promise);
        });
        this.queryPromises.clear();
        return Promise.all(promises);
    };
    RenderPromises.prototype.lookupQueryInfo = function(props) {
        var queryInfoTrie = this.queryInfoTrie;
        var query = props.query, variables = props.variables;
        var varMap = queryInfoTrie.get(query) || new Map();
        if (!queryInfoTrie.has(query)) queryInfoTrie.set(query, varMap);
        var variablesString = JSON.stringify(variables);
        var info = varMap.get(variablesString) || $706be9e0db767cf6$var$makeDefaultQueryInfo();
        if (!varMap.has(variablesString)) varMap.set(variablesString, info);
        return info;
    };
    return RenderPromises;
}();




var $gqzfn = parcelRequire("gqzfn");
function $14b303d47097dd86$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $14b303d47097dd86$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $gqzfn.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, $gqzfn.useRef)(true);
    var committed = (0, $gqzfn.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && $14b303d47097dd86$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $gqzfn.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $14b303d47097dd86$export$33752cf3ee811995(callback, inputs) {
    return $14b303d47097dd86$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $14b303d47097dd86$export$1538c33de8887b59 = $14b303d47097dd86$export$b6feb8998cd9b342;
var $14b303d47097dd86$export$35808ee640e87ca7 = $14b303d47097dd86$export$33752cf3ee811995;


/// <reference types="node" />
const $9796e0f397735ad4$export$ad4be5c2ec28cecf = (obj)=>obj instanceof $9796e0f397735ad4$export$2e2bcd8739ae039 || !!obj?._isAnalyticsEvent || // Backwards compatibility with older analytics-next packages
    obj?.constructor?.name === 'AnalyticsEvent';
class $9796e0f397735ad4$export$2e2bcd8739ae039 {
    update(updater) {
        if (typeof updater === 'function') this.payload = updater(this.payload);
        if (typeof updater === 'object') this.payload = {
            ...this.payload,
            ...updater
        };
        return this;
    }
    constructor(props){
        this.payload = void 0;
        this._isAnalyticsEvent = true;
        this.clone = ()=>{
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            const payload = {
                ...this.payload
            };
            return new $9796e0f397735ad4$export$2e2bcd8739ae039({
                payload: payload
            });
        };
        this.payload = props.payload;
    }
}


const $b743fd01767d00ac$export$35f8383928ba8d7 = (obj)=>obj instanceof $b743fd01767d00ac$export$2e2bcd8739ae039 || !!obj?._isUIAnalyticsEvent || // Backwards compatibility with older analytics-next packages
    obj?.constructor?.name === 'UIAnalyticsEvent';
class $b743fd01767d00ac$export$2e2bcd8739ae039 extends (0, $9796e0f397735ad4$export$2e2bcd8739ae039) {
    update(updater) {
        if (this.hasFired) return this;
        return super.update(updater);
    }
    constructor(props){
        super(props);
        this.context = void 0;
        this.handlers = void 0;
        this.hasFired = void 0;
        this._isUIAnalyticsEvent = true;
        this.clone = ()=>{
            if (this.hasFired) return null;
            const context = [
                ...this.context
            ];
            const handlers = [
                ...this.handlers
            ];
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ const payload = JSON.parse(JSON.stringify(this.payload));
            return new $b743fd01767d00ac$export$2e2bcd8739ae039({
                context: context,
                handlers: handlers,
                payload: payload
            });
        };
        this.fire = (channel)=>{
            if (this.hasFired) return;
            this.handlers.forEach((handler)=>handler(this, channel));
            this.hasFired = true;
        };
        this.context = props.context || [];
        this.handlers = props.handlers || [];
        this.hasFired = false;
    }
}



var $gqzfn = parcelRequire("gqzfn");

var $gqzfn = parcelRequire("gqzfn");
const $bf2857b19a0a0db4$var$AnalyticsNextContext = (0, $gqzfn.createContext)({
    getAtlaskitAnalyticsContext: ()=>[],
    getAtlaskitAnalyticsEventHandlers: ()=>[]
});
var $bf2857b19a0a0db4$export$2e2bcd8739ae039 = $bf2857b19a0a0db4$var$AnalyticsNextContext;


var $caa1af2947dbe592$export$2e2bcd8739ae039 = (0, $bf2857b19a0a0db4$export$2e2bcd8739ae039);


const $4565d92b4a1f5f08$export$d1f587f82ad51c4 = ()=>{
    return (0, $gqzfn.useContext)((0, $caa1af2947dbe592$export$2e2bcd8739ae039));
};


function $7fea6b6f7f18a70b$export$5bf35293e545f20c() {
    const analyticsContext = (0, $4565d92b4a1f5f08$export$d1f587f82ad51c4)();
    const createAnalyticsEvent = (0, $14b303d47097dd86$export$33752cf3ee811995)((payload)=>{
        return new (0, $b743fd01767d00ac$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $gqzfn = parcelRequire("gqzfn");


function $0f48a177c099c909$export$7c1c2f97801b533e(graphqlTaggedNode) {
    if (typeof graphqlTaggedNode === 'string') // For backwards-compatibility only; that's why `string` is not specified as an accepted argument type
    return (0, $d7f2d52a706ecc0f$export$2e2bcd8739ae039)(graphqlTaggedNode);
    if ('kind' in graphqlTaggedNode && 'definitions' in graphqlTaggedNode) return graphqlTaggedNode;
    if (!('params' in graphqlTaggedNode)) throw new Error('[Relay Migration] unsupported tagged node provided. Please make sure you generated Relay artifacts for your operation');
    const operationText = graphqlTaggedNode.params.text;
    if (!operationText) throw new Error('[Relay Migration] The provided `ConcreteRequest` did not specify `params.text` properties that is required for Apollo deprecation. Make sure you keep the `persiste: { includeQueryText: true }` Relay compiler configuration option ');
    return (0, $d7f2d52a706ecc0f$export$2e2bcd8739ae039)(graphqlTaggedNode.params.text);
}


const $f54dbbdd58dc6856$var$queryResults = new WeakMap();
function $f54dbbdd58dc6856$export$33c3a40e92be94b0(query, options) {
    query = (0, $0f48a177c099c909$export$7c1c2f97801b533e)(query);
    const client = options?.client ?? window['GLOBAL_APOLLO_CLIENT'];
    let dataFromCache = null;
    try {
        if (!options?.skip) dataFromCache = client.readQuery({
            query: query,
            ...options
        });
    } catch  {}
    const [result, setResult] = (0, $gqzfn.useState)(()=>{
        return dataFromCache ? {
            data: dataFromCache,
            loading: false,
            networkStatus: (0, $cb292de0bef73a33$export$bd096ddbd246c79c).ready
        } : {
            data: null,
            loading: true,
            networkStatus: (0, $cb292de0bef73a33$export$bd096ddbd246c79c).loading
        };
    });
    (0, $gqzfn.useEffect)(()=>{
        if (result.loading && !options?.skip) {
            // technically not a hash but it's good enough since variable is an plain object.
            const variablesHash = JSON.stringify(options?.variables || {});
            // Same query + variable should reuse the same promise to avoid going through expensive Apollo client.
            let queryResultPromise;
            if ($f54dbbdd58dc6856$var$queryResults.has(query) && $f54dbbdd58dc6856$var$queryResults.get(query).has(variablesHash)) queryResultPromise = $f54dbbdd58dc6856$var$queryResults.get(query)?.get(variablesHash);
            else {
                queryResultPromise = client.query({
                    query: query,
                    ...options
                });
                if (!$f54dbbdd58dc6856$var$queryResults.has(query)) $f54dbbdd58dc6856$var$queryResults.set(query, new Map());
                $f54dbbdd58dc6856$var$queryResults.get(query).set(variablesHash, queryResultPromise);
            }
            queryResultPromise.then((result)=>setResult(result)).catch((e)=>{
                setResult({
                    ...result,
                    loading: false,
                    networkStatus: (0, $cb292de0bef73a33$export$bd096ddbd246c79c).ready,
                    error: e
                });
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return result;
}



var $ePB4t = parcelRequire("ePB4t");

var $cnjKG = parcelRequire("cnjKG");
var $6f6c23291291fb56$export$ba064dbfe4bb66d7 = /*#__PURE__*/ function(PreferenceCategory) {
    PreferenceCategory["StrictlyNecessary"] = "STRICTLY_NECESSARY";
    PreferenceCategory["Functional"] = "FUNCTIONAL";
    PreferenceCategory["Marketing"] = "MARKETING";
    PreferenceCategory["Analytics"] = "ANALYTICS";
    PreferenceCategory["Unknown"] = "UNKNOWN";
    return PreferenceCategory;
}({});
var $6f6c23291291fb56$export$cdef20bac194f235 = /*#__PURE__*/ function(ConsentPreferenceV2) {
    ConsentPreferenceV2["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    ConsentPreferenceV2["ConsentedUnderGDPR"] = "CONSENTS_SAVED_IN_GDPR_LOCALE";
    ConsentPreferenceV2["ConsentedUnderCPRA"] = "CONSENTS_SAVED_IN_CPRA_LOCALE";
    ConsentPreferenceV2["ConsentedUnderLGPD"] = "CONSENTS_SAVED_IN_LGPD_LOCALE";
    ConsentPreferenceV2["ConsentedUnderFADP"] = "CONSENTS_SAVED_IN_FADP_LOCALE";
    return ConsentPreferenceV2;
}({});
var $6f6c23291291fb56$export$fac80ad19b60e313 = /*#__PURE__*/ function(ContextualConsentProperty) {
    ContextualConsentProperty["ConsentsAreDefault"] = "DEFAULT_CONSENTS";
    ContextualConsentProperty["UserIsAuthenticated"] = "USER_AUTHENTICATED";
    ContextualConsentProperty["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    return ContextualConsentProperty;
}({});
var $6f6c23291291fb56$export$4fda8eb914d6791c = /*#__PURE__*/ function(CachedKeysDataPropertyLegacy) {
    CachedKeysDataPropertyLegacy["LocalStorage"] = "localStorageKeys";
    CachedKeysDataPropertyLegacy["SessionStorage"] = "sessionStorageKeys";
    CachedKeysDataPropertyLegacy["Cookies"] = "keys";
    CachedKeysDataPropertyLegacy["ThirdParty"] = "thirdPartyKeys";
    return CachedKeysDataPropertyLegacy;
}({});
var $6f6c23291291fb56$export$5d6594a0bba4ab8a = /*#__PURE__*/ function(PrefetchedPreferenceState) {
    PrefetchedPreferenceState[PrefetchedPreferenceState["INTERNAL"] = 0] = "INTERNAL";
    return PrefetchedPreferenceState;
}({});
var $6f6c23291291fb56$export$2506b012eb637f61 = /*#__PURE__*/ function(CategoryStorageType) {
    CategoryStorageType["Cookies"] = "Cookies";
    CategoryStorageType["LocalStorage"] = "LocalStorage";
    CategoryStorageType["SessionStorage"] = "SessionStorage";
    return CategoryStorageType;
}({});
var $6f6c23291291fb56$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["SUCCESS"] = "SUCCESS";
    Status["BLOCKED"] = "BLOCKED";
    Status["FAILED"] = "FAILED";
    return Status;
}({});
var $6f6c23291291fb56$export$eefdbcf75990494a = /*#__PURE__*/ function(BSC_PACKAGE_KILLSWITCHES) {
    BSC_PACKAGE_KILLSWITCHES["MASTER_KILLSWITCH"] = "platform_moonjelly_bsc_master_killswitch";
    BSC_PACKAGE_KILLSWITCHES["UI_KILLSWITCH"] = "platform_moonjelly_bsc_ui_killswitch";
    BSC_PACKAGE_KILLSWITCHES["SSR_KILLSWITCH"] = "platform_moonjelly_bsc_ssr_killswitch";
    BSC_PACKAGE_KILLSWITCHES["WEB_STORAGE_KILLSWITCH"] = "platform_moonjelly_bsc_web_storage_killswitch";
    return BSC_PACKAGE_KILLSWITCHES;
}({});



var $cnjKG = parcelRequire("cnjKG");

/* eslint-disable no-console */ 
var $cnjKG = parcelRequire("cnjKG");

var $b3ZhF = parcelRequire("b3ZhF");
var $2tp3i = parcelRequire("2tp3i");


const $bba9ef4fb78348f4$export$9345d7360ffe0722 = "platform-pkg" ?? '';
const $bba9ef4fb78348f4$export$91546b032799aa40 = "0.0.0-use.local" ?? '';




class $03c4a3fdf91a59e2$export$b886edaf6623554a {
    get cachedSamplingConfig() {
        return this.cache;
    }
    set cachedSamplingConfig(value) {
        this.cache = value;
    }
    constructor(){
        this.cache = void 0;
    }
}


const $beef1ec499f3b6a7$export$69a3209f1a06c04d = new (0, $03c4a3fdf91a59e2$export$b886edaf6623554a)();



var $b3ZhF = parcelRequire("b3ZhF");

var $cnjKG = parcelRequire("cnjKG");
const $133d964c5b1c8928$export$48d7c418edadb60c = ()=>{
    const isMissingNecessaryBrowserUtils = typeof document === 'undefined' || typeof window === 'undefined' || !Document || !Document.prototype || !Object || !Object.defineProperty;
    const isMissingBooleanFF = !(0, $cnjKG.fg);
    const isMissingAnalyticsWebClient = !Boolean((0, $b3ZhF.default));
    if (isMissingNecessaryBrowserUtils || isMissingBooleanFF || isMissingAnalyticsWebClient) return true;
    else return false;
};


const $0fdccae9eae5b69b$export$1138592b3c099377 = {
    usedGetCookie: 100000,
    usedGetCookieError: 1,
    usedSetCookie: 1000,
    usedSetCookieError: 1,
    usedSetStrictlyNecessaryCookie: 10000,
    usedSetStrictlyNecessaryCookieError: 1,
    usedDeleteCookie: 10,
    usedDeleteCookieError: 1,
    usedCheckThirdParty: 100000,
    checkThirdPartyError: 1,
    usedDocumentCookie: 100,
    usedDocumentCookieError: 1,
    initializeControlsError: 1,
    loadStorageControlsError: 1,
    updatePreferencesError: 1,
    fetchConsentPreferencesError: 1,
    saveConsentPreferencesError: 1,
    usedAtlBrowserStorageGetItem: 100,
    usedAtlBrowserStorageGetItemError: 1,
    usedAtlBrowserStorageSetItem: 100,
    usedAtlBrowserStorageSetItemError: 1,
    usedAtlBrowserStorageSetStrictlyNecessaryItem: 100,
    usedAtlBrowserStorageSetStrictlyNecessaryItemError: 1,
    usedCheckIfSetByPackageError: 1,
    renderConsentBannerError: 1,
    bannerAppearanceAfterDismissal: 1
};
// This short-circuits finding a sampling ratio from the remote config. Useful for things like
// `loadStorageControlsError` which itself tries to log an event on error, causing an infinite
// recursion as each lookup fails, logging another event, etc.
const $0fdccae9eae5b69b$var$localOnlySamplingKeys = [
    'loadStorageControlsError'
];
async function $0fdccae9eae5b69b$var$loadSamplingConfig() {
    if ((0, $beef1ec499f3b6a7$export$69a3209f1a06c04d).cachedSamplingConfig) return (0, $beef1ec499f3b6a7$export$69a3209f1a06c04d).cachedSamplingConfig;
    if ((0, $133d964c5b1c8928$export$48d7c418edadb60c)()) return undefined;
    const { loadCache: loadCache } = (0, $f2d96fa10745de8c$export$3b78a1ea01f5ec28)();
    const controlsData = await loadCache((0, $6f6c23291291fb56$export$2506b012eb637f61).Cookies);
    const analyticsSamplingRatioConfigs = controlsData?.analyticsSamplingRatio;
    (0, $beef1ec499f3b6a7$export$69a3209f1a06c04d).cachedSamplingConfig = analyticsSamplingRatioConfigs;
    return analyticsSamplingRatioConfigs;
}
async function $0fdccae9eae5b69b$export$b286f5e8716d11ad(analyticsEventKey) {
    if ($0fdccae9eae5b69b$var$localOnlySamplingKeys.includes(analyticsEventKey)) return $0fdccae9eae5b69b$export$1138592b3c099377[analyticsEventKey];
    const remoteSamplingConfig = await $0fdccae9eae5b69b$var$loadSamplingConfig();
    const samplingConfig = remoteSamplingConfig ?? $0fdccae9eae5b69b$export$1138592b3c099377;
    const samplingRatio = samplingConfig?.[analyticsEventKey] !== undefined ? samplingConfig[analyticsEventKey] : $0fdccae9eae5b69b$export$1138592b3c099377[analyticsEventKey];
    return samplingRatio;
}
function $0fdccae9eae5b69b$export$dc2f0946255b3f89(samplingRatio, cb) {
    /* Only run if rolling the samplingRatio-sized die lands on a 0
       ________
      /\       \
     /()\   ()  \
    /    \_______\
    \    /()     /
     \()/   ()  /
      \/_____()/
  */ const shouldRun = !Math.floor(Math.random() * samplingRatio);
    shouldRun && cb();
}
async function $0fdccae9eae5b69b$export$67b6e87f323cb6ad(analyticsEventKey, cb) {
    const ratio = await $0fdccae9eae5b69b$export$b286f5e8716d11ad(analyticsEventKey);
    $0fdccae9eae5b69b$export$dc2f0946255b3f89(ratio, cb);
}


const $3489483a13ea178e$var$getEnvironment = ()=>{
    const { hostname: hostname } = window.location;
    if (hostname.includes('.dev.') || hostname.includes('.stg.') || hostname.includes('.jira-dev.') || hostname.includes('.jira-stg.')) return (0, $2tp3i.envType).STAGING;
    if (hostname.includes('localhost') || hostname.includes('ngrok') || hostname.includes('atlastunnel')) return (0, $2tp3i.envType).DEV;
    return (0, $2tp3i.envType).PROD;
};
const $3489483a13ea178e$export$78d7c0236b4fece9 = (path)=>{
    let subPath = '';
    if (!path) return subPath;
    const checkPath = (match)=>{
        return new RegExp(`^${match}(/|$)`).test(String(path));
    };
    if (checkPath('/wiki')) subPath = '/wiki';
    if (checkPath('/jira')) subPath = '/jira';
    if (checkPath('/compass')) subPath = '/compass';
    if (checkPath('/canvas')) subPath = '/canvas';
    if (checkPath('/servicedesk') || checkPath('/jira/servicedesk')) subPath = '/servicedesk';
    return subPath;
};
const $3489483a13ea178e$var$getProductFromDomain = (domain)=>{
    if (domain === 'https://trello.com') return 'trello';
    return null;
};
const $3489483a13ea178e$export$fce3dd735e04d566 = ()=>{
    const { origin: origin, pathname: pathname } = window.location;
    const productPath = $3489483a13ea178e$export$78d7c0236b4fece9(pathname);
    const domain = `${origin}${productPath}`;
    const product = $3489483a13ea178e$var$getProductFromDomain(domain) || productPath.slice(1);
    return {
        domain: domain,
        product: product
    };
};
const $3489483a13ea178e$var$decorateEventAttributes = (attributes)=>{
    const { domain: domain, product: product } = $3489483a13ea178e$export$fce3dd735e04d566();
    return {
        packageName: $bba9ef4fb78348f4$export$9345d7360ffe0722,
        packageVersion: $bba9ef4fb78348f4$export$91546b032799aa40,
        domain: domain,
        product: (0, $f2d96fa10745de8c$export$3b78a1ea01f5ec28)().product?.toLowerCase() ?? product,
        ...attributes && attributes
    };
};
const $3489483a13ea178e$export$fde53e78fd93a54d = (()=>{
    let instance;
    return ()=>{
        try {
            if (!instance && (0, $f2d96fa10745de8c$export$3b78a1ea01f5ec28)().analyticsEnabled) instance = new (0, $b3ZhF.default)({
                env: $3489483a13ea178e$var$getEnvironment(),
                product: 'atlassianCookies'
            }, {
                // useLegacyUrl tells the analytics client to make calls directly to Global Analytics Service.
                // When set to false, the client will use a stargate proxy for the current URL to send events
                // to GAS. Said another way:
                // true => events are sent to https://api-private.stg.atlassian.com/gasv3/api/v1/batch
                // false => events are sent to <the current domain>/gasv3/api/v1/batch
                //
                // By default, this should be set to false.  If you need to validate that analytics events
                // are being transmitted correctly in local dev, you can temporarily enable it since localhost
                // won't be able to proxy to GAS via stargate.
                useLegacyUrl: false,
                disableCookiePersistence: true
            });
        } catch (e) {
            // Log  errors thrown in constructor initialization for the AnalyticsWebClient
            (0, $dfd3c3c473d0c6a3$export$efa9a398d6368992).error(`Failed to initialize AnalyticsWebClient. ${e}`);
        }
        if (!(0, $f2d96fa10745de8c$export$3b78a1ea01f5ec28)().analyticsEnabled) return undefined;
        // Return the instance, even if it is undefined
        return instance;
    };
})();
function $3489483a13ea178e$export$5bfe55348e7aebc1(properties) {
    (0, $0fdccae9eae5b69b$export$67b6e87f323cb6ad)(properties.action, ()=>$3489483a13ea178e$export$fde53e78fd93a54d()?.sendOperationalEvent({
            source: 'package',
            actionSubject: 'package',
            action: properties.action,
            attributes: $3489483a13ea178e$var$decorateEventAttributes(properties.attributes)
        }));
}
function $3489483a13ea178e$export$1aecf263098db667(properties) {
    $3489483a13ea178e$export$fde53e78fd93a54d()?.sendUIEvent({
        ...properties,
        attributes: $3489483a13ea178e$var$decorateEventAttributes(properties.attributes)
    });
}
function $3489483a13ea178e$export$22a3b1671f38a193(properties) {
    $3489483a13ea178e$export$fde53e78fd93a54d()?.sendScreenEvent({
        ...properties,
        attributes: $3489483a13ea178e$var$decorateEventAttributes(properties.attributes)
    });
}
function $3489483a13ea178e$export$1ba525b8a711eaac(properties) {
    $3489483a13ea178e$export$fde53e78fd93a54d()?.sendTrackEvent({
        ...properties,
        attributes: $3489483a13ea178e$var$decorateEventAttributes(properties.attributes)
    });
}



const $dfd3c3c473d0c6a3$var$LOG_PREFIX = '[browser-storage-controls]';
class $dfd3c3c473d0c6a3$export$efa9a398d6368992 {
    static info(message, metadata) {
        console.log(`${$dfd3c3c473d0c6a3$var$LOG_PREFIX}: ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
    static error(message, metadata) {
        console.error(`${$dfd3c3c473d0c6a3$var$LOG_PREFIX}: ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
    static errorWithOperationalEvent({ action: action, attributes: attributes = {}, message: message, metadata: metadata }) {
        try {
            (0, $3489483a13ea178e$export$5bfe55348e7aebc1)({
                action: action,
                attributes: {
                    error: message,
                    ...attributes
                }
            });
        } catch (e) {
            this.error(`Failed to send operational event on error: ${action}. ${e.message || ''}`);
        }
        this.error(message, metadata ? JSON.stringify(metadata) : '');
    }
    static warn(message, metadata) {
        console.warn(`${$dfd3c3c473d0c6a3$var$LOG_PREFIX}: ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
    /**
   * Logger for additional debugging of the package. Debug logs are only sent when the
   * atl-bsc-debug-mode cookie is set on the browser. This is evaluated via global state
   */ static debug(message, metadata) {
        if ((0, $f2d96fa10745de8c$export$3b78a1ea01f5ec28)().packageDebugMode && (0, $cnjKG.fg)('platform_moonjelly_bsc_debug_mode')) console.debug(`${$dfd3c3c473d0c6a3$var$LOG_PREFIX}: DEBUG ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
}



const $c02125aa863afb53$export$194c34963e6f0bc6 = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories.json';
const $c02125aa863afb53$export$b44048c6704cb5cb = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories_COOKIE.json';
const $c02125aa863afb53$export$c55beaf8e17d7be2 = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories_LOCAL_STORAGE.json';
const $c02125aa863afb53$export$e1db91db5e7e324f = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories_SESSION_STORAGE.json';
const $c02125aa863afb53$export$abf8d23e319d4d71 = 'https://atlassian-cookies--categories.us-east-1.prod.cdn.atlassian-us-gov-mod.com/categories_COOKIE.json';
const $c02125aa863afb53$export$de367b95fcc6730f = 'https://atlassian-cookies--categories.us-east-1.prod.cdn.atlassian-us-gov-mod.com/categories_LOCAL_STORAGE.json';
const $c02125aa863afb53$export$d5e6ad74bf291eaf = 'https://atlassian-cookies--categories.us-east-1.prod.cdn.atlassian-us-gov-mod.com/categories_SESSION_STORAGE.json';
const $c02125aa863afb53$export$218c59d0d43946aa = {
    [(0, $6f6c23291291fb56$export$2506b012eb637f61).Cookies]: $c02125aa863afb53$export$b44048c6704cb5cb,
    [(0, $6f6c23291291fb56$export$2506b012eb637f61).LocalStorage]: $c02125aa863afb53$export$c55beaf8e17d7be2,
    [(0, $6f6c23291291fb56$export$2506b012eb637f61).SessionStorage]: $c02125aa863afb53$export$e1db91db5e7e324f
};
const $c02125aa863afb53$export$df45fb0af5b720ce = {
    commercial: $c02125aa863afb53$export$218c59d0d43946aa,
    'fedramp-moderate': {
        [(0, $6f6c23291291fb56$export$2506b012eb637f61).Cookies]: $c02125aa863afb53$export$abf8d23e319d4d71,
        [(0, $6f6c23291291fb56$export$2506b012eb637f61).LocalStorage]: $c02125aa863afb53$export$de367b95fcc6730f,
        [(0, $6f6c23291291fb56$export$2506b012eb637f61).SessionStorage]: $c02125aa863afb53$export$d5e6ad74bf291eaf
    }
};


class $4f2fbfe1038fd354$export$e479342c697b82a9 {
    clearStorageControlsDataCache() {
        this.localResponseCache = undefined;
        this.localResponsePromiseCache = undefined;
        this.localResponseJsonPromiseCache = undefined;
    }
    /**
   * Unpacks the response promise from the categories CDN
   *
   * errors if that request was unsuccessful, returns the categories data otherwise
   *
   */ async handleCategoriesResponse(responsePromise) {
        if (!responsePromise) throw new Error(`Failed to fetch Cookies Cache! Cached promise was undefined`);
        const response = await responsePromise;
        if (!response.ok) throw new Error(`Failed to fetch Cookies Cache! status: ${response.status}`);
        // Checks if we've already fired the response.json() promise
        this.localResponseJsonPromiseCache = this.localResponseJsonPromiseCache || response?.json();
        return this.localResponseJsonPromiseCache;
    }
    async loadStorageControlsData() {
        if (this.localResponseCache) return this.localResponseCache;
        else // Always use Prod CDN for prod/local/dev/staging environments, but stub the route for automation tests
        try {
            if (!this.localResponsePromiseCache) {
                (0, $dfd3c3c473d0c6a3$export$efa9a398d6368992).debug(`Loading cache ${this.cacheUrl}`);
                // invoke CDN and cache the promise
                this.localResponsePromiseCache = fetch(this.cacheUrl);
            }
            // unpack response
            this.localResponseCache = await this.handleCategoriesResponse(this.localResponsePromiseCache);
            return this.localResponseCache;
        } catch (e) {
            (0, $dfd3c3c473d0c6a3$export$efa9a398d6368992).errorWithOperationalEvent({
                action: 'loadStorageControlsError',
                message: e.message || ''
            });
            this.clearStorageControlsDataCache();
        }
    }
    constructor(storageType, perimeter = 'commercial'){
        this.cacheUrl = void 0;
        /**
     * Cache variable for storing categorized cookies cache
     */ this.localResponseCache = void 0;
        /**
     * Cache variable for storing a promise that's been fired by a different invocation of loadStorageControls
     *
     * Allows for many invocations to happen simultaneously, and for only one fetch to go out
     */ this.localResponsePromiseCache = void 0;
        /**
     * Cache variable for storing the promise returned from the response object's json method
     *
     * Ensures we don't invoke response.json multiple times
     */ this.localResponseJsonPromiseCache = void 0;
        if (!(0, $cnjKG.fg)('fedramp-cookies-controls')) switch(storageType){
            case (0, $6f6c23291291fb56$export$2506b012eb637f61).Cookies:
                this.cacheUrl = (0, $c02125aa863afb53$export$b44048c6704cb5cb);
                break;
            case (0, $6f6c23291291fb56$export$2506b012eb637f61).LocalStorage:
                this.cacheUrl = (0, $c02125aa863afb53$export$c55beaf8e17d7be2);
                break;
            case (0, $6f6c23291291fb56$export$2506b012eb637f61).SessionStorage:
                this.cacheUrl = (0, $c02125aa863afb53$export$e1db91db5e7e324f);
                break;
            default:
                this.cacheUrl = (0, $c02125aa863afb53$export$194c34963e6f0bc6);
        }
        else {
            // If a new perimeter type is added, but not supported by us yet, default to commercial URLs
            const cacheUrlLookup = (0, $c02125aa863afb53$export$df45fb0af5b720ce)[perimeter] || (0, $c02125aa863afb53$export$218c59d0d43946aa);
            this.cacheUrl = cacheUrlLookup[storageType];
        }
    }
}



let $f2d96fa10745de8c$var$analyticsEnabledGlobalState;
let $f2d96fa10745de8c$var$productGlobalState;
let $f2d96fa10745de8c$var$perimeterGlobalState;
let $f2d96fa10745de8c$var$webStorageControlsEnabledGlobalState;
let $f2d96fa10745de8c$var$localConsentModeGlobalState;
let $f2d96fa10745de8c$var$packageDebugModeEnabledGlobalState;
let $f2d96fa10745de8c$var$allowUncategorizedCookiesInOverridesGlobalState;
let $f2d96fa10745de8c$var$hasInitialized = false;
let $f2d96fa10745de8c$var$cookiesCacheLoader;
let $f2d96fa10745de8c$var$localStorageCacheLoader;
let $f2d96fa10745de8c$var$sessionStorageCacheLoader;
let $f2d96fa10745de8c$var$loadCache = async (storageType)=>{
    switch(storageType){
        case (0, $6f6c23291291fb56$export$2506b012eb637f61).Cookies:
            return await $f2d96fa10745de8c$var$cookiesCacheLoader?.loadStorageControlsData();
        case (0, $6f6c23291291fb56$export$2506b012eb637f61).LocalStorage:
            return await $f2d96fa10745de8c$var$localStorageCacheLoader?.loadStorageControlsData();
        case (0, $6f6c23291291fb56$export$2506b012eb637f61).SessionStorage:
            return await $f2d96fa10745de8c$var$sessionStorageCacheLoader?.loadStorageControlsData();
        default:
            return undefined;
    }
};
const $f2d96fa10745de8c$export$3b78a1ea01f5ec28 = ()=>{
    return {
        analyticsEnabled: $f2d96fa10745de8c$var$analyticsEnabledGlobalState ?? true,
        product: $f2d96fa10745de8c$var$productGlobalState,
        perimeter: $f2d96fa10745de8c$var$perimeterGlobalState,
        webStorageEnabled: $f2d96fa10745de8c$var$webStorageControlsEnabledGlobalState ?? false,
        localConsentMode: $f2d96fa10745de8c$var$localConsentModeGlobalState ?? false,
        packageDebugMode: $f2d96fa10745de8c$var$packageDebugModeEnabledGlobalState,
        allowUncategorizedCookiesInOverrides: $f2d96fa10745de8c$var$allowUncategorizedCookiesInOverridesGlobalState ?? false,
        cookiesCacheLoader: $f2d96fa10745de8c$var$cookiesCacheLoader,
        localStorageCacheLoader: $f2d96fa10745de8c$var$localStorageCacheLoader,
        sessionStorageCacheLoader: $f2d96fa10745de8c$var$sessionStorageCacheLoader,
        loadCache: $f2d96fa10745de8c$var$loadCache,
        hasInitialized: $f2d96fa10745de8c$var$hasInitialized
    };
};
const $f2d96fa10745de8c$export$882c4530c58781d8 = ({ webStorageEnabled: webStorageEnabled, allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides, localConsentMode: localConsentMode = false, product: product = 'all', perimeter: perimeter = 'commercial', analyticsEnabled: analyticsEnabled = true } = {})=>{
    (0, $dfd3c3c473d0c6a3$export$efa9a398d6368992).debug('Initialize global state invoked');
    // If the app provides a value for product only in one place,
    // we want that value to be sticky and to override the default if necessary
    if ((!$f2d96fa10745de8c$var$productGlobalState || $f2d96fa10745de8c$var$productGlobalState == null || $f2d96fa10745de8c$var$productGlobalState === 'all') && product) $f2d96fa10745de8c$var$productGlobalState = product;
    // Treating webStorageEnabled and allowUncategorizedCookiesInOverrides differently
    // because they are only passed through initializeControls and
    // we don't want it to be defaulted to false via a call from the ConsentBanner
    if (webStorageEnabled !== undefined && $f2d96fa10745de8c$var$webStorageControlsEnabledGlobalState === undefined) $f2d96fa10745de8c$var$webStorageControlsEnabledGlobalState = webStorageEnabled && !(0, $cnjKG.fg)('platform_moonjelly_bsc_master_killswitch') && !(0, $cnjKG.fg)('platform_moonjelly_bsc_web_storage_killswitch');
    if (allowUncategorizedCookiesInOverrides !== undefined && $f2d96fa10745de8c$var$allowUncategorizedCookiesInOverridesGlobalState === undefined) $f2d96fa10745de8c$var$allowUncategorizedCookiesInOverridesGlobalState = allowUncategorizedCookiesInOverrides;
    // All other state can only be initialized once and is defaulted if not passed on the first initialization
    if ($f2d96fa10745de8c$var$hasInitialized) return;
    if (!(0, $cnjKG.fg)('fedramp-cookies-controls')) $f2d96fa10745de8c$var$localConsentModeGlobalState = localConsentMode;
    else // Force local consent mode when in the FedRAMP Moderate perimeter because ConsentHub is
    // not hydrated in the perimeter as of this comment
    $f2d96fa10745de8c$var$localConsentModeGlobalState = localConsentMode || perimeter === 'fedramp-moderate';
    $f2d96fa10745de8c$var$analyticsEnabledGlobalState = analyticsEnabled;
    $f2d96fa10745de8c$var$perimeterGlobalState = perimeter;
    $f2d96fa10745de8c$var$cookiesCacheLoader = new (0, $4f2fbfe1038fd354$export$e479342c697b82a9)((0, $6f6c23291291fb56$export$2506b012eb637f61).Cookies, perimeter);
    $f2d96fa10745de8c$var$localStorageCacheLoader = new (0, $4f2fbfe1038fd354$export$e479342c697b82a9)((0, $6f6c23291291fb56$export$2506b012eb637f61).LocalStorage, perimeter);
    $f2d96fa10745de8c$var$sessionStorageCacheLoader = new (0, $4f2fbfe1038fd354$export$e479342c697b82a9)((0, $6f6c23291291fb56$export$2506b012eb637f61).SessionStorage, perimeter);
    if ((0, $cnjKG.fg)('platform_moonjelly_bsc_debug_mode')) $f2d96fa10745de8c$var$packageDebugModeEnabledGlobalState = Boolean((0, (/*@__PURE__*/$parcel$interopDefault($ePB4t))).get('atl-bsc-debug-mode'));
    $f2d96fa10745de8c$var$hasInitialized = true;
};
const $f2d96fa10745de8c$export$f86e17381f699baf = ({ loadCache: overrideLoadCache, product: overrideProduct })=>{
    if (overrideLoadCache) $f2d96fa10745de8c$var$loadCache = overrideLoadCache;
    if (overrideProduct) $f2d96fa10745de8c$var$productGlobalState = overrideProduct;
};
const $f2d96fa10745de8c$export$ac7c2edd09656c05 = ()=>{
    $f2d96fa10745de8c$var$analyticsEnabledGlobalState = undefined;
    $f2d96fa10745de8c$var$productGlobalState = undefined;
    $f2d96fa10745de8c$var$webStorageControlsEnabledGlobalState = undefined;
    $f2d96fa10745de8c$var$localConsentModeGlobalState = undefined;
    $f2d96fa10745de8c$var$packageDebugModeEnabledGlobalState = undefined;
    $f2d96fa10745de8c$var$allowUncategorizedCookiesInOverridesGlobalState = undefined;
    $f2d96fa10745de8c$var$cookiesCacheLoader = undefined;
    $f2d96fa10745de8c$var$localStorageCacheLoader = undefined;
    $f2d96fa10745de8c$var$sessionStorageCacheLoader = undefined;
    $f2d96fa10745de8c$var$hasInitialized = false;
};






class $8b0596a5b77a45bc$export$fde2a4e0e57f47e {
    async boot() {
        if (!this.isAvailable) {
            (0, $dfd3c3c473d0c6a3$export$efa9a398d6368992).warn('IndexedDB is not available');
            return;
        }
        if (this.isBooted) // Short circuit if we've already booted once
        return;
        // Only boot once, even if we've been called numerous times sequentially
        if (!this.bootUpPromiseCache) {
            this.bootUpPromiseCache = this.openDB();
            try {
                await this.bootUpPromiseCache;
                this.isBooted = true;
            } catch (e) {
                this.isBooted = false;
                (0, $dfd3c3c473d0c6a3$export$efa9a398d6368992).warn('Error booting up IndexedDB.');
                throw e;
            }
        }
    }
    getIsDBAvailable() {
        return !(0, $133d964c5b1c8928$export$48d7c418edadb60c)() && !!window.indexedDB;
    }
    async openDB() {
        return new Promise((resolve, reject)=>{
            let request = indexedDB.open(this.dbName, 2);
            request.onerror = this.onConnectionErrorHandler(reject);
            request.onsuccess = this.onConnectionSuccessHandler(request, resolve);
            request.onupgradeneeded = this.onConnectionUpgradeNeededHandler(request);
        });
    }
    async getRecord(recordKey) {
        try {
            if (!this.isBooted) await this.boot();
            if (!this.db) throw new Error('Database is not opened');
            let fetchTransaction = this.db.transaction([
                this.storeName
            ]);
            let recordStore = fetchTransaction.objectStore(this.storeName);
            const fetchedRecord = new Promise((resolve, reject)=>{
                let request = recordStore.get(recordKey);
                request.onerror = this.onGetRecordErrorHandler(reject);
                request.onsuccess = this.onGetRecordSuccessHandler(request, resolve);
            });
            return fetchedRecord;
        } catch (e) {
            (0, $dfd3c3c473d0c6a3$export$efa9a398d6368992).error(`Error fetching record from database. ${e.message || ''}`);
            throw e;
        }
    }
    async setRecord(recordKey) {
        try {
            if (!this.isBooted) await this.boot();
            if (!this.db) throw new Error('Database is not opened');
            const setRecord = new Promise((resolve, reject)=>{
                let setTransaction = this.db.transaction([
                    this.storeName
                ], 'readwrite');
                let objectStore = setTransaction.objectStore(this.storeName);
                const newAtlRecord = {
                    atlSetItem: 'SET-BY-PACKAGE',
                    id: recordKey
                };
                let request = objectStore.put(newAtlRecord);
                request.onerror = this.onSetRecordErrorHandler(reject);
                request.onsuccess = this.onSetRecordSuccessHandler(resolve);
            });
            return setRecord;
        } catch (e) {
            (0, $dfd3c3c473d0c6a3$export$efa9a398d6368992).warn(`Error setting record in database. ${e.message || ''}`);
            throw e;
        }
    }
    constructor(dbName, storeName){
        this.dbName = void 0;
        this.storeName = void 0;
        this.bootUpPromiseCache = void 0;
        this.db = null;
        this.isBooted = false;
        this.isAvailable = false;
        this.onConnectionErrorHandler = (reject)=>(event)=>{
                (0, $dfd3c3c473d0c6a3$export$efa9a398d6368992).warn('Error opening database.');
                reject(event);
            };
        this.onConnectionSuccessHandler = (connection, resolve)=>()=>{
                this.db = connection.result;
                resolve();
            };
        this.onConnectionUpgradeNeededHandler = (request)=>()=>{
                this.db = request.result;
                this.db.createObjectStore(this.storeName, {
                    keyPath: 'id'
                });
            };
        this.onGetRecordErrorHandler = (reject)=>()=>{
                const getErrorMessage = `Failed to perform a get transaction on IndexedDB: ${this.dbName} + ${this.storeName}`;
                (0, $dfd3c3c473d0c6a3$export$efa9a398d6368992).warn(getErrorMessage);
                reject(getErrorMessage);
            };
        this.onGetRecordSuccessHandler = (getRequest, resolve)=>()=>{
                resolve(getRequest.result);
            };
        this.onSetRecordErrorHandler = (reject)=>()=>{
                const errorMessage = `Failed to perform a set transaction on IndexedDB: ${this.dbName} + ${this.storeName}`;
                (0, $dfd3c3c473d0c6a3$export$efa9a398d6368992).warn(errorMessage);
                reject(errorMessage);
            };
        this.onSetRecordSuccessHandler = (resolve)=>()=>{
                resolve();
            };
        this.dbName = dbName;
        this.storeName = storeName;
        this.isAvailable = this.getIsDBAvailable();
        this.isBooted = false;
        this.bootUpPromiseCache = null;
    }
}
const $8b0596a5b77a45bc$export$36328b3bcbe4623a = new $8b0596a5b77a45bc$export$fde2a4e0e57f47e('BSCIndexedDB', 'InternalStorageKeys');


var $a1e698f910fc5577$export$259e3a861f28589b = /*#__PURE__*/ function(WebStorageType) {
    WebStorageType["LocalStorage"] = "LocalStorage";
    WebStorageType["SessionStorage"] = "SessionStorage";
    return WebStorageType;
}({});




const $1a55a94ef9c4e696$export$e612bb1301d659de = (itemKey, storageType, browserStorage)=>{
    const eventAttributes = {
        itemKey: itemKey,
        storageType: storageType
    };
    try {
        (0, $3489483a13ea178e$export$5bfe55348e7aebc1)({
            action: 'usedAtlBrowserStorageGetItem',
            attributes: eventAttributes
        });
        return browserStorage.getItem(itemKey);
    } catch (e) {
        (0, $dfd3c3c473d0c6a3$export$efa9a398d6368992).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageGetItemError',
            attributes: eventAttributes,
            message: `Failed to get ${storageType} item. ${e.message || ''}`
        });
        return null;
    }
};


// eslint-disable-next-line @atlassian/tangerine/import/no-restricted-paths


const $41b24bf45fab4f15$export$10d7db8e1a856fd8 = 'atl-gdpr-consent';
const $41b24bf45fab4f15$export$435de28e5b000487 = 'atl-bsc-consent-token';
const $41b24bf45fab4f15$export$4b17acc0e875ba2a = 'atl-bsc-show-banner';
const $41b24bf45fab4f15$export$f57af01b64fc97b8 = 'atl-bsc-current-locale';
const $41b24bf45fab4f15$export$23a1e02c3c0b0d08 = 'atl-bsc-consent-token-fallback';
const $41b24bf45fab4f15$export$37073d560ecebada = 'atl-testing-consents';
const $41b24bf45fab4f15$export$5dc0026db06844f3 = 'atl-bsc-banner-dismissed-time';
const $41b24bf45fab4f15$export$b28b5d760fe14a21 = {
    [(0, $6f6c23291291fb56$export$ba064dbfe4bb66d7).StrictlyNecessary]: true,
    [(0, $6f6c23291291fb56$export$ba064dbfe4bb66d7).Functional]: true,
    [(0, $6f6c23291291fb56$export$ba064dbfe4bb66d7).Marketing]: true,
    [(0, $6f6c23291291fb56$export$ba064dbfe4bb66d7).Analytics]: true,
    [(0, $6f6c23291291fb56$export$ba064dbfe4bb66d7).Unknown]: true // Includes uncategorized cookies
};
const $41b24bf45fab4f15$export$4a12f9e99971760a = {
    [(0, $6f6c23291291fb56$export$ba064dbfe4bb66d7).StrictlyNecessary]: true,
    [(0, $6f6c23291291fb56$export$ba064dbfe4bb66d7).Functional]: false,
    [(0, $6f6c23291291fb56$export$ba064dbfe4bb66d7).Marketing]: false,
    [(0, $6f6c23291291fb56$export$ba064dbfe4bb66d7).Analytics]: false,
    [(0, $6f6c23291291fb56$export$ba064dbfe4bb66d7).Unknown]: false
};
const $41b24bf45fab4f15$export$f0fd1d13ec1d48f2 = {
    ...$41b24bf45fab4f15$export$4a12f9e99971760a,
    [(0, $6f6c23291291fb56$export$fac80ad19b60e313).ConsentsAreDefault]: true,
    [(0, $6f6c23291291fb56$export$fac80ad19b60e313).UserIsAuthenticated]: false,
    [(0, $6f6c23291291fb56$export$fac80ad19b60e313).ConsentDataUnavailable]: true
};
const $41b24bf45fab4f15$export$f95182b7aa141c57 = '001';
const $41b24bf45fab4f15$export$1f25427b34f9c405 = '002';
const $41b24bf45fab4f15$export$31deaeaebce525bb = '003';




var $ePB4t = parcelRequire("ePB4t");

var $cnjKG = parcelRequire("cnjKG");


function $e9fbd27e9159f5c4$export$4be65e66cfa2648a(key) {
    if ((0, $cnjKG.fg)('platform_moonjelly_bsc_master_killswitch')) // Get the cookie without package operational events
    // when master killswitch is enabled
    return key ? (0, (/*@__PURE__*/$parcel$interopDefault($ePB4t))).get(key) : (0, (/*@__PURE__*/$parcel$interopDefault($ePB4t))).get();
    try {
        (0, $3489483a13ea178e$export$5bfe55348e7aebc1)({
            action: 'usedGetCookie',
            attributes: {
                cookieKey: key
            }
        });
        return key ? (0, (/*@__PURE__*/$parcel$interopDefault($ePB4t))).get(key) : (0, (/*@__PURE__*/$parcel$interopDefault($ePB4t))).get();
    } catch (e) {
        (0, $dfd3c3c473d0c6a3$export$efa9a398d6368992).errorWithOperationalEvent({
            action: 'usedGetCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use get cookie. ${e.message || ''}`
        });
    }
}




const $a7061e76287f0fcd$export$b5282052fc15e1ae = (genuineConsentToken)=>{
    // The existence of this cookie will make it look like fetched ConsentHub data is missing
    // You can set it to undefined yourself/empty string, or an actual default value.
    const tokenOverride = (0, $e9fbd27e9159f5c4$export$4be65e66cfa2648a)((0, $41b24bf45fab4f15$export$37073d560ecebada));
    // Note: Clear this cookie out of your browser when you're done testing empty data sets
    // Or you'll be stuck seeing the banner and never actually consenting on the UI
    return tokenOverride || genuineConsentToken;
};


const $e820f1ab3644076d$export$929f1500428a1fc8 = (value)=>{
    return Number(value).toString();
};
const $e820f1ab3644076d$export$27647458f3cf29d2 = (bitValue)=>{
    if (bitValue) return !!Number(bitValue);
};




var $ePB4t = parcelRequire("ePB4t");

var $aE6gq = parcelRequire("aE6gq");







var $a4ef702d915c6fc2$export$31140359b1e505cf = /*#__PURE__*/ function(ConsentHubKey) {
    ConsentHubKey["StrictlyNecessary"] = "strictlyNecessaryCookies";
    ConsentHubKey["Functional"] = "functionalCookies";
    ConsentHubKey["Analytics"] = "performanceCookies";
    ConsentHubKey["Marketing"] = "targetingCookies";
    ConsentHubKey["Unknown"] = "unknownCookies";
    return ConsentHubKey;
}({});


const $1b22306267891258$var$isLegacyGeoTargetingV2Token = (consentToken)=>{
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV2Schema = version === (0, $41b24bf45fab4f15$export$1f25427b34f9c405);
    return isV2Schema;
};
const $1b22306267891258$var$isLegacyV1Token = (consentToken)=>{
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV1Schema = version === (0, $41b24bf45fab4f15$export$f95182b7aa141c57);
    return isV1Schema;
};
const $1b22306267891258$export$42b0ca8aba2631e4 = (consentToken)=>{
    if ($1b22306267891258$var$isLegacyGeoTargetingV2Token(consentToken)) {
        // If we're looking at a V2 token and they have ANY saved 'consentedUnderXX' bits,
        // we know it must be a set of valid consents instead of defaults
        const consentedUnderGDPR = consentToken[8] === '1';
        const consentedUnderCPRA = consentToken[9] === '1';
        const consentedUnderLGPD = consentToken[10] === '1';
        const consentedUnderFADP = consentToken[11] === '1';
        const hasConsentedPreviously = consentedUnderGDPR || consentedUnderCPRA || consentedUnderLGPD || consentedUnderFADP;
        return hasConsentedPreviously;
    }
    return false;
};
const $1b22306267891258$export$497a647f0eb30ef4 = (consentToken)=>{
    const isLegacyV1ConsentToken = $1b22306267891258$var$isLegacyV1Token(consentToken);
    const isLegacyV2ConsentToken = $1b22306267891258$var$isLegacyGeoTargetingV2Token(consentToken);
    if (isLegacyV1ConsentToken) // We only add a legacy `atl-gdpr-consents` cookie if a user has consented,
    // so if we see a V1 token, we know it must be a set of valid consents
    // instead of default consents
    return false;
    if (isLegacyV2ConsentToken) {
        const legacyTokenHasConsents = $1b22306267891258$export$42b0ca8aba2631e4(consentToken);
        return !legacyTokenHasConsents;
    }
    // Check 'isDefaultConsentBit' bit for V003 Schema tokens
    const isDefaultTokenV3 = (0, $e820f1ab3644076d$export$27647458f3cf29d2)(consentToken[7]);
    return isDefaultTokenV3;
};
const $1b22306267891258$export$c42e1a74e60f4d73 = (consentsUnavailable)=>{
    const version = (0, $41b24bf45fab4f15$export$31deaeaebce525bb);
    // DEFAULT_PREFERENCES now has the default boolean baked into it, so we don't need to set it here
    const serializedBits = Object.entries((0, $41b24bf45fab4f15$export$f0fd1d13ec1d48f2)).reduce((acc, [key, val])=>{
        // Skip the STRICTLY_NECESSARY as it's always allowed
        if (key === (0, $6f6c23291291fb56$export$ba064dbfe4bb66d7).StrictlyNecessary) return acc;
        if (key === (0, $6f6c23291291fb56$export$fac80ad19b60e313).UserIsAuthenticated) {
            // If consents are missing when setting these defaults, the user will be logged out,
            // so pack this info into the consent token bits
            const userIsAuthed = !consentsUnavailable;
            return acc + (0, $e820f1ab3644076d$export$929f1500428a1fc8)(userIsAuthed);
        }
        if (key === (0, $6f6c23291291fb56$export$fac80ad19b60e313).ConsentDataUnavailable) // If consents are missing when setting these defaults, the user will be logged out,
        // so pack this info into the consent token bits
        return acc + (0, $e820f1ab3644076d$export$929f1500428a1fc8)(!!consentsUnavailable);
        return acc + (0, $e820f1ab3644076d$export$929f1500428a1fc8)(val);
    }, '');
    return `${version}${serializedBits}`;
};
const $1b22306267891258$export$42a0b3fb1e53e7b9 = (consents)=>{
    const version = (0, $41b24bf45fab4f15$export$31deaeaebce525bb);
    // As 'strictlyNecessaryConsent' would always be allowed, we don't store it in the cookie or use ConsentHub
    const functionalConsent = (0, $e820f1ab3644076d$export$929f1500428a1fc8)(!!consents.find((key)=>key.key === (0, $a4ef702d915c6fc2$export$31140359b1e505cf).Functional)?.granted);
    const analyticsConsent = (0, $e820f1ab3644076d$export$929f1500428a1fc8)(!!consents.find((key)=>key.key === (0, $a4ef702d915c6fc2$export$31140359b1e505cf).Analytics)?.granted);
    const marketingConsent = (0, $e820f1ab3644076d$export$929f1500428a1fc8)(!!consents.find((key)=>key.key === (0, $a4ef702d915c6fc2$export$31140359b1e505cf).Marketing)?.granted);
    const unknownConsent = (0, $e820f1ab3644076d$export$929f1500428a1fc8)(!!consents.find((key)=>key.key === (0, $a4ef702d915c6fc2$export$31140359b1e505cf).Unknown)?.granted);
    // As these consents were returned from the server, ConsentHub is obviously available, they're logged in, and aren't defaults
    const isDefaultToken = 0;
    const userIsAuthenticated = 1;
    const consentHubDataUnavailable = 0;
    return [
        version,
        functionalConsent,
        analyticsConsent,
        marketingConsent,
        unknownConsent,
        isDefaultToken,
        userIsAuthenticated,
        consentHubDataUnavailable
    ].join('');
};
const $1b22306267891258$export$92ba0b2fe50f90df = ({ consents: consents })=>{
    if (!consents) {
        // When generating consents for an unauthenticated user, use the fallback token if it exists
        // This circumvents us setting defaults for them if their token has expired, but they have consented previously
        const existingFallbackToken = (0, $e9fbd27e9159f5c4$export$4be65e66cfa2648a)((0, $41b24bf45fab4f15$export$23a1e02c3c0b0d08));
        if (existingFallbackToken) return existingFallbackToken;
        // User is unauthed, will only use local consenting, consent data will also be unavailable
        return $1b22306267891258$export$c42e1a74e60f4d73(true); // e.g. 0030000101
    } else if (consents.length === 0) // User is authed but has no consents in the system, so use defaults in the interim, consentData must be available
    return $1b22306267891258$export$c42e1a74e60f4d73(); // e.g. 0030000110
    else // User is authed and has consents in the system
    return $1b22306267891258$export$42a0b3fb1e53e7b9(consents); // e.g. 0030110110
};
const $1b22306267891258$export$bfa0c91662787fb0 = (unpackedUserPreferences, displayedTextMap)=>{
    const validConsentHubCookieConsents = [
        (0, $6f6c23291291fb56$export$ba064dbfe4bb66d7).StrictlyNecessary,
        (0, $6f6c23291291fb56$export$ba064dbfe4bb66d7).Functional,
        (0, $6f6c23291291fb56$export$ba064dbfe4bb66d7).Analytics,
        (0, $6f6c23291291fb56$export$ba064dbfe4bb66d7).Marketing,
        (0, $6f6c23291291fb56$export$ba064dbfe4bb66d7).Unknown
    ];
    const consentKeyMap = {
        [(0, $6f6c23291291fb56$export$ba064dbfe4bb66d7).StrictlyNecessary]: (0, $a4ef702d915c6fc2$export$31140359b1e505cf).StrictlyNecessary,
        [(0, $6f6c23291291fb56$export$ba064dbfe4bb66d7).Functional]: (0, $a4ef702d915c6fc2$export$31140359b1e505cf).Functional,
        [(0, $6f6c23291291fb56$export$ba064dbfe4bb66d7).Analytics]: (0, $a4ef702d915c6fc2$export$31140359b1e505cf).Analytics,
        [(0, $6f6c23291291fb56$export$ba064dbfe4bb66d7).Marketing]: (0, $a4ef702d915c6fc2$export$31140359b1e505cf).Marketing,
        [(0, $6f6c23291291fb56$export$ba064dbfe4bb66d7).Unknown]: (0, $a4ef702d915c6fc2$export$31140359b1e505cf).Unknown
    };
    const consentRecords = validConsentHubCookieConsents.map((consentKey)=>{
        const key = consentKeyMap[consentKey];
        return {
            key: key,
            granted: !!unpackedUserPreferences[consentKey],
            gatheredTs: new Date().toISOString(),
            displayedText: displayedTextMap[consentKey]
        };
    });
    return consentRecords;
};
const $1b22306267891258$export$13e4cff933f26b03 = ({ consents: consents })=>{
    if (consents && consents.length) {
        // As consents can be updated individually, we need to find the most recent timestamp to use as "most recent consent"
        const timestamps = consents.map((consent)=>{
            return new Date(consent.updatedTs).getTime();
        });
        const maxTimestamp = Math.max(...timestamps);
        const mostRecentConsentTimestamp = new Date(maxTimestamp).toISOString();
        return mostRecentConsentTimestamp;
    }
};
const $1b22306267891258$export$3387347b75450ae1 = (consentTimestamp)=>{
    // Privacy has determined that we should re-prompt users for consent if they haven't
    // consented in over a year regardless, because they're legally stale/expired
    let consentedOverAYearAgo = false;
    if (consentTimestamp) {
        const oneYearAgo = new Date();
        oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
        consentedOverAYearAgo = new Date(consentTimestamp) < oneYearAgo;
    }
    return consentedOverAYearAgo;
};
class $1b22306267891258$export$a79c0ea3d7c2444a extends Error {
    constructor(message, status){
        super(message);
        this.status = void 0;
        this.status = status;
        Object.setPrototypeOf(this, $1b22306267891258$export$a79c0ea3d7c2444a.prototype);
        // Captures the stack trace (for environments that support it)
        if (Error.captureStackTrace) Error.captureStackTrace(this, $1b22306267891258$export$a79c0ea3d7c2444a);
        this.name = 'StatusCodeError';
    }
}








const $1cc4749b2bc9d6f2$export$64b31470e8522819 = (consentToken)=>{
    // A token can technically be bad data (alphanumeric instead of binary) but we should fail gracefully if so
    if (consentToken.length < 3) // Wrong format, no version
    return {
        isValid: false,
        isV001: false,
        isV002: false,
        isV003: false
    };
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV001 = version === (0, $41b24bf45fab4f15$export$f95182b7aa141c57) && consentToken.length === 7;
    const isV002 = version === (0, $41b24bf45fab4f15$export$1f25427b34f9c405) && consentToken.length === 12;
    const isV003 = version === (0, $41b24bf45fab4f15$export$31deaeaebce525bb) && consentToken.length === 10;
    // We support version 001, 002, 003 only
    const isSupportedVersion = [
        (0, $41b24bf45fab4f15$export$f95182b7aa141c57),
        (0, $41b24bf45fab4f15$export$1f25427b34f9c405),
        (0, $41b24bf45fab4f15$export$31deaeaebce525bb)
    ].includes(version);
    const isValid = isSupportedVersion && (isV001 || isV002 || isV003);
    return {
        isValid: isValid,
        isV001: isV001,
        isV002: isV002,
        isV003: isV003
    };
};
/* Schema Version 001:
---------------------------------------------------
  - Format 0000000
  - 001 (schema version 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies disabled/enabled)
*/ const $1cc4749b2bc9d6f2$var$packPrefsVersion001 = (userPreferences)=>{
    const version = (0, $41b24bf45fab4f15$export$f95182b7aa141c57);
    return [
        version,
        (0, $e820f1ab3644076d$export$929f1500428a1fc8)(userPreferences.FUNCTIONAL),
        (0, $e820f1ab3644076d$export$929f1500428a1fc8)(userPreferences.ANALYTICS),
        (0, $e820f1ab3644076d$export$929f1500428a1fc8)(userPreferences.MARKETING),
        (0, $e820f1ab3644076d$export$929f1500428a1fc8)(userPreferences.UNKNOWN)
    ].join('');
};
const $1cc4749b2bc9d6f2$var$unpackPrefsVersion001 = (userPreferencesCookie)=>{
    if (userPreferencesCookie.length !== 7) // Wrong length for version 001
    return;
    return {
        [(0, $6f6c23291291fb56$export$ba064dbfe4bb66d7).StrictlyNecessary]: true,
        [(0, $6f6c23291291fb56$export$ba064dbfe4bb66d7).Functional]: userPreferencesCookie[3] === '1',
        [(0, $6f6c23291291fb56$export$ba064dbfe4bb66d7).Analytics]: userPreferencesCookie[4] === '1',
        [(0, $6f6c23291291fb56$export$ba064dbfe4bb66d7).Marketing]: userPreferencesCookie[5] === '1',
        [(0, $6f6c23291291fb56$export$ba064dbfe4bb66d7).Unknown]: userPreferencesCookie[6] === '1'
    };
};
/* Schema Version 002 ***** DEPRECATED *****
---------------------------------------------------
  - Format 000000000000
  - 002 (schema version, 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies - disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies - disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies - disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies - disabled/enabled)
  - 0/1 (1 digit, consent records are unavailable from ConsentHub (logged out) - yes/no)
  - 0/1 (1 digit, consents saved while in GDPR locale (Europe) - yes/no)
  - 0/1 (1 digit, consents saved while in CPRA locale (CPRA will act as 'all USA' bucket) - yes/no)
  - 0/1 (1 digit, consents saved while in LGPD locale (Brazil) - yes/no)
  - 0/1 (1 digit, consents saved while in FADP locale (Switzerland) - yes/no)
*/ const $1cc4749b2bc9d6f2$var$packPrefsVersion002 = (userPreferences)=>{
    // As we want to slowly kill off any V002 preferences, if we're provided one for some reason
    // internally convert it to a V003 preference to drop contextual GeoIP details
    const version = (0, $41b24bf45fab4f15$export$31deaeaebce525bb);
    const hasConsentedPreviously = userPreferences[(0, $6f6c23291291fb56$export$cdef20bac194f235).ConsentedUnderGDPR] || userPreferences[(0, $6f6c23291291fb56$export$cdef20bac194f235).ConsentedUnderCPRA] || userPreferences[(0, $6f6c23291291fb56$export$cdef20bac194f235).ConsentedUnderLGPD] || userPreferences[(0, $6f6c23291291fb56$export$cdef20bac194f235).ConsentedUnderFADP];
    const isDefaultConsentBit = !hasConsentedPreviously;
    // As we've broken out authentication insights/context from "ConsentDataUnavailable" bit in V3,
    // and it does not exist, we will backfill the value based on the previous bit state
    const existingConsentDataUnavailableBit = userPreferences[(0, $6f6c23291291fb56$export$fac80ad19b60e313).ConsentDataUnavailable];
    const userIsAuthenticatedBit = !existingConsentDataUnavailableBit;
    return [
        version,
        (0, $e820f1ab3644076d$export$929f1500428a1fc8)(userPreferences[(0, $6f6c23291291fb56$export$ba064dbfe4bb66d7).Functional]),
        (0, $e820f1ab3644076d$export$929f1500428a1fc8)(userPreferences[(0, $6f6c23291291fb56$export$ba064dbfe4bb66d7).Analytics]),
        (0, $e820f1ab3644076d$export$929f1500428a1fc8)(userPreferences[(0, $6f6c23291291fb56$export$ba064dbfe4bb66d7).Marketing]),
        (0, $e820f1ab3644076d$export$929f1500428a1fc8)(userPreferences[(0, $6f6c23291291fb56$export$ba064dbfe4bb66d7).Unknown]),
        (0, $e820f1ab3644076d$export$929f1500428a1fc8)(isDefaultConsentBit),
        (0, $e820f1ab3644076d$export$929f1500428a1fc8)(userIsAuthenticatedBit),
        (0, $e820f1ab3644076d$export$929f1500428a1fc8)(existingConsentDataUnavailableBit)
    ].join('');
};
const $1cc4749b2bc9d6f2$var$unpackPrefsVersion002 = (userPreferencesCookie)=>{
    // If the provided V002 token has consented anywhere, we'll drop the contextual GeoIP bits and
    // convert it to a V003 schema
    const isADefaultConsentToken = (0, $1b22306267891258$export$497a647f0eb30ef4)(userPreferencesCookie);
    // Backfill the value based on the previous "ConsentDataUnavailable" bit state as we've broken this contextual info out
    const consentDataUnavailable = userPreferencesCookie[7] === '1';
    const userIsDeemedAuthenticated = !consentDataUnavailable;
    return {
        ...$1cc4749b2bc9d6f2$var$unpackPrefsVersion003(userPreferencesCookie),
        [(0, $6f6c23291291fb56$export$fac80ad19b60e313).ConsentsAreDefault]: !!isADefaultConsentToken,
        [(0, $6f6c23291291fb56$export$fac80ad19b60e313).UserIsAuthenticated]: userIsDeemedAuthenticated,
        [(0, $6f6c23291291fb56$export$fac80ad19b60e313).ConsentDataUnavailable]: consentDataUnavailable
    };
};
/* Schema Version 003
---------------------------------------------------
  - Format 0000000000
  - 003 (schema version, 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies - disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies - disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies - disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies - disabled/enabled)
  - 0/1 (1 digit, Consent token in a default state, user has yet to consent) - no/yes)
  - 0/1 (1 digit, User is authenticated, did not 401 during save) - no/yes)
  - 0/1 (1 digit, ConsentHub records are unavailable (CH is down, errored while saving, etc) - no/yes)
*/ const $1cc4749b2bc9d6f2$var$packPrefsVersion003 = (userPreferences)=>{
    const version = (0, $41b24bf45fab4f15$export$31deaeaebce525bb);
    return [
        version,
        (0, $e820f1ab3644076d$export$929f1500428a1fc8)(userPreferences[(0, $6f6c23291291fb56$export$ba064dbfe4bb66d7).Functional]),
        (0, $e820f1ab3644076d$export$929f1500428a1fc8)(userPreferences[(0, $6f6c23291291fb56$export$ba064dbfe4bb66d7).Analytics]),
        (0, $e820f1ab3644076d$export$929f1500428a1fc8)(userPreferences[(0, $6f6c23291291fb56$export$ba064dbfe4bb66d7).Marketing]),
        (0, $e820f1ab3644076d$export$929f1500428a1fc8)(userPreferences[(0, $6f6c23291291fb56$export$ba064dbfe4bb66d7).Unknown]),
        (0, $e820f1ab3644076d$export$929f1500428a1fc8)(userPreferences[(0, $6f6c23291291fb56$export$fac80ad19b60e313).ConsentsAreDefault]),
        (0, $e820f1ab3644076d$export$929f1500428a1fc8)(userPreferences[(0, $6f6c23291291fb56$export$fac80ad19b60e313).UserIsAuthenticated]),
        (0, $e820f1ab3644076d$export$929f1500428a1fc8)(userPreferences[(0, $6f6c23291291fb56$export$fac80ad19b60e313).ConsentDataUnavailable])
    ].join('');
};
const $1cc4749b2bc9d6f2$var$unpackPrefsVersion003 = (userPreferencesCookie)=>{
    return {
        [(0, $6f6c23291291fb56$export$ba064dbfe4bb66d7).StrictlyNecessary]: true,
        [(0, $6f6c23291291fb56$export$ba064dbfe4bb66d7).Functional]: userPreferencesCookie[3] === '1',
        [(0, $6f6c23291291fb56$export$ba064dbfe4bb66d7).Analytics]: userPreferencesCookie[4] === '1',
        [(0, $6f6c23291291fb56$export$ba064dbfe4bb66d7).Marketing]: userPreferencesCookie[5] === '1',
        [(0, $6f6c23291291fb56$export$ba064dbfe4bb66d7).Unknown]: userPreferencesCookie[6] === '1',
        [(0, $6f6c23291291fb56$export$fac80ad19b60e313).ConsentsAreDefault]: userPreferencesCookie[7] === '1',
        [(0, $6f6c23291291fb56$export$fac80ad19b60e313).UserIsAuthenticated]: userPreferencesCookie[8] === '1',
        [(0, $6f6c23291291fb56$export$fac80ad19b60e313).ConsentDataUnavailable]: userPreferencesCookie[9] === '1'
    };
};
const $1cc4749b2bc9d6f2$var$V002SpecificBitKeys = [
    (0, $6f6c23291291fb56$export$fac80ad19b60e313).ConsentDataUnavailable,
    (0, $6f6c23291291fb56$export$cdef20bac194f235).ConsentedUnderGDPR,
    (0, $6f6c23291291fb56$export$cdef20bac194f235).ConsentedUnderCPRA,
    (0, $6f6c23291291fb56$export$cdef20bac194f235).ConsentedUnderLGPD,
    (0, $6f6c23291291fb56$export$cdef20bac194f235).ConsentedUnderFADP
];
const $1cc4749b2bc9d6f2$var$V003SpecificBitKeys = [
    (0, $6f6c23291291fb56$export$fac80ad19b60e313).ConsentsAreDefault,
    (0, $6f6c23291291fb56$export$fac80ad19b60e313).UserIsAuthenticated,
    (0, $6f6c23291291fb56$export$fac80ad19b60e313).ConsentDataUnavailable
];
function $1cc4749b2bc9d6f2$export$3199823fec979bd1(userPreferences) {
    if ((0, $f2d96fa10745de8c$export$3b78a1ea01f5ec28)().localConsentMode) return $1cc4749b2bc9d6f2$var$packPrefsVersion001(userPreferences);
    const isV002 = $1cc4749b2bc9d6f2$var$V002SpecificBitKeys.every((key)=>key in userPreferences);
    if (isV002) // As V002 is deprecated, if we've been provided V002 set of "legacy" prefs, internally
    // convert them to V003 to drop the unnecessary contextual details
    return $1cc4749b2bc9d6f2$var$packPrefsVersion002(userPreferences);
    const isV003 = $1cc4749b2bc9d6f2$var$V003SpecificBitKeys.every((key)=>key in userPreferences);
    if (isV003) return $1cc4749b2bc9d6f2$var$packPrefsVersion003(userPreferences);
    // Fallback to V001
    return $1cc4749b2bc9d6f2$var$packPrefsVersion001(userPreferences);
}
function $1cc4749b2bc9d6f2$export$8d213cb390bab4fa(userPreferencesCookie) {
    if ((0, $f2d96fa10745de8c$export$3b78a1ea01f5ec28)().localConsentMode) {
        if (userPreferencesCookie.length < 3) // Wrong format, no version
        return;
        const version = userPreferencesCookie[0] + userPreferencesCookie[1] + userPreferencesCookie[2];
        if (version === (0, $41b24bf45fab4f15$export$f95182b7aa141c57)) return $1cc4749b2bc9d6f2$var$unpackPrefsVersion001(userPreferencesCookie);
        return;
    }
    const { isValid: isValid, isV001: isV001, isV002: isV002, isV003: isV003 } = $1cc4749b2bc9d6f2$export$64b31470e8522819(userPreferencesCookie);
    if (!isValid) // We support version 001, 002, 003 only
    return;
    if (isV001) return $1cc4749b2bc9d6f2$var$unpackPrefsVersion001(userPreferencesCookie);
    if (isV002) // Deprecated, so this will unpack to 003 to drop the contextual GeoIP bits
    return $1cc4749b2bc9d6f2$var$unpackPrefsVersion002(userPreferencesCookie);
    if (isV003) return $1cc4749b2bc9d6f2$var$unpackPrefsVersion003(userPreferencesCookie);
}
const $1cc4749b2bc9d6f2$export$67f70eb55341bd29 = (initialPreferences)=>{
    if (!initialPreferences) return true;
    const prefExistButAreEmpty = Object.keys(initialPreferences).length === 0;
    return prefExistButAreEmpty;
};
const $1cc4749b2bc9d6f2$export$7962405c3ca274b1 = (initialPreferences)=>{
    if (initialPreferences !== (0, $6f6c23291291fb56$export$5d6594a0bba4ab8a).INTERNAL) {
        if ($1cc4749b2bc9d6f2$export$67f70eb55341bd29(initialPreferences)) // Failsafe handling: Consumer failed to provide data even though they have prefetched, so we need to fetch again
        // This may occur if a consumer's prefetch requests fails, or if they fail to implement the system correctly
        return {
            prefs: undefined,
            isPrefetchedPrefsInternalState: true
        };
        // If initialPreferences is not INTERNAL on first render, we have been provided a pre-fetched
        // value, which means we don't need to make a fetch to storage or ConsentHub to get it.
        // If that preference is defined, we persist it to our local cookie set
        // If the data is a ConsentHubResponse/PrefetchedConsentCookieData, we'll need to transform it properly before consumption
        const consentToken = initialPreferences && 'consentToken' in initialPreferences && initialPreferences.consentToken;
        if (consentToken) {
            // We already have a consent cookie that was passed in, let's not override it by setting it again
            const unpackedExistingPrefs = $1cc4749b2bc9d6f2$export$8d213cb390bab4fa(consentToken);
            return {
                prefs: unpackedExistingPrefs,
                isPrefetchedPrefsInternalState: !Boolean(unpackedExistingPrefs)
            };
        }
        // This type guard protects the below casting of ConsentHubResponse ensuring we have the correct shape
        if (initialPreferences && 'consents' in initialPreferences) {
            const serializedPrefetchedConsentToken = (0, $1b22306267891258$export$92ba0b2fe50f90df)(initialPreferences);
            const unpackedPrefetchedPrefs = $1cc4749b2bc9d6f2$export$8d213cb390bab4fa(serializedPrefetchedConsentToken);
            return {
                prefs: unpackedPrefetchedPrefs,
                isPrefetchedPrefsInternalState: !Boolean(unpackedPrefetchedPrefs)
            };
        }
    }
    // If we've fallen into this, EMPTY implies we have no data at all
    // INTERNAL implies we still need to fetch new data, so trigger a refetch
    if (initialPreferences === (0, $6f6c23291291fb56$export$5d6594a0bba4ab8a).INTERNAL) return {
        prefs: undefined,
        isPrefetchedPrefsInternalState: true
    };
    return {
        prefs: undefined,
        isPrefetchedPrefsInternalState: false
    };
};


const $b2d8e94101ac2e01$var$getUserIsAuthenticatedBit = (consentToken)=>{
    const { isV002: isV002 } = (0, $1cc4749b2bc9d6f2$export$64b31470e8522819)(consentToken);
    let userIsAuthenticatedBit = consentToken[8]; // V3 position
    if (isV002) {
        // Schema has changed in V3, V2 had this bit in a different position. Logged out users will have this bit set to 1
        const legacyV2ConsentDataUnavailableBit = consentToken[7];
        // We can backfill the UserIsAuthenticated bit by flipping the bit value. If ConsentHub was unavailable, that means they were logged out.
        userIsAuthenticatedBit = legacyV2ConsentDataUnavailableBit === '1' ? '0' : '1';
    }
    return userIsAuthenticatedBit;
};
const $b2d8e94101ac2e01$var$shouldShowBannerForLoggedOutDefaultToken = (fallbackConsentToken)=>{
    // Logged out + default consents + fallback: we have a discrepancy where ConsentHub is down/unavailable, or they're just logged out,
    // but the user has actually consented previously (which essentially the only way to save to the fallback to begin with)
    if (fallbackConsentToken) {
        const fallbackUserIsAuthenticatedBit = $b2d8e94101ac2e01$var$getUserIsAuthenticatedBit(fallbackConsentToken);
        const isLoggedOutFallbackConsents = !(0, $e820f1ab3644076d$export$27647458f3cf29d2)(fallbackUserIsAuthenticatedBit);
        const fallbackTokenHasGenuineConsents = !(0, $1b22306267891258$export$497a647f0eb30ef4)(fallbackConsentToken);
        const localOnlyUsersHasGenuineConsents = isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
        // If the fallback is from a logged out consent (localOnlyConsent), they're currently
        // logged out and also saved while logged out, so don't show the banner
        if (localOnlyUsersHasGenuineConsents) return !fallbackTokenHasGenuineConsents;
        const loggedOutUserPreviouslyConsentedWhileLoggedIn = !isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
        if (loggedOutUserPreviouslyConsentedWhileLoggedIn) // Or if it is from a logged in consent, and they've consented somewhere (they must have)
        // then we should not show the banner, as their consents aren't "stale", we're just in a situation
        // where the original token has expired so they get a default set, but we should hide the banner
        return false;
    }
    // Defaults consents + unauthed + missing a fallback, show the banner, as they haven't consented in the past year
    return true;
};
const $b2d8e94101ac2e01$var$shouldShowBannerForLoggedOutUser = ({ consentToken: consentToken, fallbackConsentToken: fallbackConsentToken })=>{
    const tokenIsADefaultConsent = !!(0, $1b22306267891258$export$497a647f0eb30ef4)(consentToken);
    // Handle default token flow
    if (tokenIsADefaultConsent) return $b2d8e94101ac2e01$var$shouldShowBannerForLoggedOutDefaultToken(fallbackConsentToken);
    // Handle genuine token flow
    // If they're a legacy/V2 user who hasn't consented, this will have checked the V3 "is default" bit to note they've consented or not
    const localOnlyUserHasConsented = (0, $1b22306267891258$export$42b0ca8aba2631e4)(consentToken) || !tokenIsADefaultConsent;
    if (localOnlyUserHasConsented) // LocalOnly users will never have a timestamp to validate against since they can't talk to ConsentHub
    // Existence of fallback consents means they've consented in the past year and do not have stale consents, do not show banner
    return fallbackConsentToken ? false : true;
    // This case should never be hit: if it's not a default, but they haven't consented... what is it? Add a catch-all "show banner"
    return true;
};
const $b2d8e94101ac2e01$var$shouldShowBannerForLoggedInDefaultToken = (fallbackConsentToken)=>{
    // Defaults + fallback + logged in, but they consented while they were previously logged out:
    if (fallbackConsentToken) {
        const fallbackUserIsAuthenticatedBit = $b2d8e94101ac2e01$var$getUserIsAuthenticatedBit(fallbackConsentToken);
        const isLoggedOutFallbackConsents = !(0, $e820f1ab3644076d$export$27647458f3cf29d2)(fallbackUserIsAuthenticatedBit);
        const fallbackTokenHasGenuineConsents = !(0, $1b22306267891258$export$497a647f0eb30ef4)(fallbackConsentToken);
        if (fallbackTokenHasGenuineConsents) {
            // Defaults + logged in user + consented <1yr ago, but while logged out
            if (isLoggedOutFallbackConsents) /*
        They've consented, and thus stored a fallback while logged out (fallback's CH bit is 1),
        then fetched from CH but get empty data (since they couldn't save to CH on their initial "save"), which sets authed consent defaults (bit 0)

        UX Problem:
        Since they have genuinely consented within the past year, the ideal UX would be to not show the banner...
        But if we do not re-prompt here in an effort to recapture their consents, the opportunity for them/us to actually get consents in the DB
        is infrequent (either via Account Privacy Page or once this fallback expires in a year).

        Example:
        While logged out, they consent in Trello, so we store the unauthed fallback token, then log in on Trello. If we hide the banner when the
        fallback exists, if that user later goes to Confluence's cookie domain (where they have no fallback), it would show the banner
        because they have no stored consents on CH, and no fallback in that domain, but are logged in. Repeat for every new domain...

        We could be fancy and save under the hood for them if they have a fallback, but to ensure we don't copy stale/different consents saved in a fallback
        to ConsentHub on their behalf, we should just re-prompt them for consents now that they're logged in. This way, they will actually
        persist their choices, and when loading other domains/products, there will be a Source of Truth to reference and not show the banner.

        Ultimately, this feels like the more "correct" way to handle this situation, as the cost of showing the banner again to officially capture
        consents feels lower than the potential cost of relying on fallbacks in all situations/across all domains for this user for the next whole year

        Result: Show the banner again and hope we officially recapture consents this time around
      */ return true;
            // Defaults + logged in user + consented <1yr ago, but while logged in
            // This scenario shouldn't happen, or if it does, it's in a phase where we haven't fetched preferences
            // yet, so hide the banner for now
            return false;
        }
        // Default token + default fallback (authed or unauthed) mean we've likely stored this
        // fallback from SSR's initialPreferences flow in. Fallbacks should not be saved with defaults intentionally
        // But sometimes we copy an existing token to the fallback via SSR flow, so let's treat this
        // as an bunk fallback, and show the banner as they haven't consented
        return true;
    }
    // Default consent token + logged in user + no fallback = they haven't consented in the past year, show banner
    return true;
};
const $b2d8e94101ac2e01$var$shouldShowBannerForLoggedInUser = ({ consentToken: consentToken, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsentToken })=>{
    // Handle default token flow
    const tokenIsADefaultConsent = !!(0, $1b22306267891258$export$497a647f0eb30ef4)(consentToken);
    if (tokenIsADefaultConsent) return $b2d8e94101ac2e01$var$shouldShowBannerForLoggedInDefaultToken(fallbackConsentToken);
    // Handle genuine token flow
    if (consentTimestamp) {
        // If the user has genuine consents, and a timestamp, check if they're stale (> 1yr old), show the banner if they're stale
        const showBannerIfStale = (0, $1b22306267891258$export$3387347b75450ae1)(consentTimestamp);
        return showBannerIfStale;
    }
    // Genuine consents + no timestamp— we're in a situation where we've been passed cached cookie data instead of CH response data,
    // so the only way to determine staleness is through the absence of the fallback.
    // Technically, we could assume since they've consented recently, we don't have to show the banner here but... to be safe we should
    return fallbackConsentToken ? false : true;
};
const $b2d8e94101ac2e01$export$bfdb9f82a9194c1e = ({ consentToken: consentToken, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsents })=>{
    // Consent tokens are either a set of defaults, or genuine (persisted to the remote, or saved in an entire local-only flow via fallbacks).
    // the deciding factor is whether or not your consents are stale/fresh, either via the existence/absence of a fallback (a.k.a consented within a year or not)
    // or if the ConsentHub response data of a user's consent has a timestamp that is older than a year
    // Detect if js-cookie has been replaced with SSR-safe version (Confluence only)
    const isJsCookieSSRSafe = typeof (0, (/*@__PURE__*/$parcel$interopDefault($ePB4t))).__SSR_INITIALIZE_COOKIES__ === 'function' && (0, $aE6gq.default).getExperimentValue('confluence_ssr_use_fallback_token', 'isEnabled', false);
    const fallbackConsentToken = (0, $133d964c5b1c8928$export$48d7c418edadb60c)() ? fallbackConsents || (isJsCookieSSRSafe ? (0, $e9fbd27e9159f5c4$export$4be65e66cfa2648a)((0, $41b24bf45fab4f15$export$23a1e02c3c0b0d08)) : undefined) : fallbackConsents || (0, $e9fbd27e9159f5c4$export$4be65e66cfa2648a)((0, $41b24bf45fab4f15$export$23a1e02c3c0b0d08));
    let userIsAuthenticatedBit = $b2d8e94101ac2e01$var$getUserIsAuthenticatedBit(consentToken);
    const isLoggedOutConsentToken = !(0, $e820f1ab3644076d$export$27647458f3cf29d2)(userIsAuthenticatedBit);
    let isBannerVisible = true; // By default, show the banner to every user
    // Unauthed/logged out user flow, should never receive a timestamp because logged out users can't communicate to ConsentHub
    if (isLoggedOutConsentToken) isBannerVisible = $b2d8e94101ac2e01$var$shouldShowBannerForLoggedOutUser({
        consentToken: consentToken,
        fallbackConsentToken: fallbackConsentToken
    });
    else // Authed/logged in user flow
    isBannerVisible = $b2d8e94101ac2e01$var$shouldShowBannerForLoggedInUser({
        consentToken: consentToken,
        fallbackConsentToken: fallbackConsentToken,
        consentTimestamp: consentTimestamp
    });
    return isBannerVisible;
};



var $ePB4t = parcelRequire("ePB4t");

var $cnjKG = parcelRequire("cnjKG");


const $993e3e2747da3cf6$export$93509ff9a62ee022 = (key, value, attributes)=>{
    if ((0, $cnjKG.fg)('platform_moonjelly_bsc_master_killswitch')) // Set the cookie without package operational events
    // when master killswitch is enabled
    (0, (/*@__PURE__*/$parcel$interopDefault($ePB4t))).set(key, value, {
        ...attributes,
        'atl-set-cookie': true
    });
    else try {
        (0, $3489483a13ea178e$export$5bfe55348e7aebc1)({
            action: 'usedSetStrictlyNecessaryCookie',
            attributes: {
                cookieKey: key
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ePB4t))).set(key, value, {
            ...attributes,
            'atl-set-cookie': true
        });
    } catch (e) {
        (0, $dfd3c3c473d0c6a3$export$efa9a398d6368992).errorWithOperationalEvent({
            action: 'usedSetStrictlyNecessaryCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use set strictly necessary cookie. ${e.message || ''}`
        });
    }
};


const $722e5bdfcd5ad050$export$8e560d0760f733a2 = (consentToken)=>{
    const inTenMinutes = new Date();
    inTenMinutes.setTime(inTenMinutes.getTime() + 600000);
    (0, $993e3e2747da3cf6$export$93509ff9a62ee022)((0, $41b24bf45fab4f15$export$435de28e5b000487), consentToken, {
        expires: inTenMinutes,
        path: '/'
    });
    (0, $dfd3c3c473d0c6a3$export$efa9a398d6368992).debug(`Set Consent Token ${(0, $41b24bf45fab4f15$export$435de28e5b000487)} ${consentToken}`);
};
const $722e5bdfcd5ad050$export$133cd762b0f705a2 = (consentToken)=>{
    const inOneYear = new Date();
    inOneYear.setFullYear(inOneYear.getFullYear() + 1);
    (0, $993e3e2747da3cf6$export$93509ff9a62ee022)((0, $41b24bf45fab4f15$export$23a1e02c3c0b0d08), consentToken, {
        expires: inOneYear,
        path: '/'
    });
    (0, $dfd3c3c473d0c6a3$export$efa9a398d6368992).debug(`set fallback consent token: ${(0, $41b24bf45fab4f15$export$23a1e02c3c0b0d08)} ${consentToken}`);
};
const $722e5bdfcd5ad050$export$99ecece88c58d938 = (consentToken, consentTimestamp)=>{
    // Since we have no good way to reference this as a global state object, we want to precompute and store the
    // banner visibility in a temporary, session-scope cookie (same expiry as the other cookies), which we can
    // lookup in the UI as needed
    const bannerVisibility = (0, $b2d8e94101ac2e01$export$bfdb9f82a9194c1e)({
        consentToken: consentToken,
        consentTimestamp: consentTimestamp
    });
    const shouldShowBanner = (0, $e820f1ab3644076d$export$929f1500428a1fc8)(!!bannerVisibility);
    const inTenMinutes = new Date();
    inTenMinutes.setTime(inTenMinutes.getTime() + 600000);
    (0, $993e3e2747da3cf6$export$93509ff9a62ee022)((0, $41b24bf45fab4f15$export$4b17acc0e875ba2a), shouldShowBanner, {
        expires: inTenMinutes,
        path: '/'
    });
    (0, $dfd3c3c473d0c6a3$export$efa9a398d6368992).debug(`set shouldShowBannerCookie: ${(0, $41b24bf45fab4f15$export$4b17acc0e875ba2a)} ${shouldShowBanner}`);
};
const $722e5bdfcd5ad050$export$b3365240280cb3c3 = (consentToken, consentTimestamps)=>{
    $722e5bdfcd5ad050$export$8e560d0760f733a2(consentToken);
    $722e5bdfcd5ad050$export$99ecece88c58d938(consentToken, consentTimestamps);
};



var $cnjKG = parcelRequire("cnjKG");



const $a7193eec3f36a65e$var$BASE_CONSENTS_URL = '/gateway/api/consenthub/session';
const $a7193eec3f36a65e$var$POST_CONSENTS_URL = `${$a7193eec3f36a65e$var$BASE_CONSENTS_URL}/user`;
const $a7193eec3f36a65e$var$GET_CONSENTS_URL = `${$a7193eec3f36a65e$var$POST_CONSENTS_URL}/consents/cookies`;
const $a7193eec3f36a65e$export$bd9f5bcbf9cd947c = (consentData)=>{
    if (consentData) {
        const serializedConsents = (0, $1b22306267891258$export$92ba0b2fe50f90df)(consentData);
        const consentTimestamp = (0, $1b22306267891258$export$13e4cff933f26b03)(consentData);
        return {
            consentToken: serializedConsents,
            consentTimestamp: consentTimestamp
        };
    }
    // Without consent data (due to server failure or unauthenticated user), set defaults illustrating that absence
    return {
        consentToken: (0, $1b22306267891258$export$92ba0b2fe50f90df)({}),
        consentHubInaccessible: true
    };
};
const $a7193eec3f36a65e$export$86467566615ab85e = async ()=>{
    const { origin: origin } = window.location;
    const getFromConsentHubURL = `${origin}${$a7193eec3f36a65e$var$GET_CONSENTS_URL}`;
    try {
        const response = await fetch(getFromConsentHubURL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (!response.ok) throw new Error(`Failed to fetch preferences from ConsentHub with status: ${response.status}`);
        const consentData = await response.json();
        return $a7193eec3f36a65e$export$bd9f5bcbf9cd947c(consentData);
    } catch (err) {
        (0, $dfd3c3c473d0c6a3$export$efa9a398d6368992).errorWithOperationalEvent({
            action: 'fetchConsentPreferencesError',
            message: err.message || ''
        });
        return $a7193eec3f36a65e$export$bd9f5bcbf9cd947c();
    }
};
const $a7193eec3f36a65e$var$buildConsentRequestBody = (unpackedUserPreferences, displayedTextMap)=>{
    const { origin: origin, pathname: pathname } = window.location;
    const deserializedConsents = (0, $1b22306267891258$export$bfa0c91662787fb0)(unpackedUserPreferences, displayedTextMap);
    // Type guard here so TS knows we're working with ConsentPreferenceV003
    const action = 'CONSENT_DATA_UNAVAILABLE' in unpackedUserPreferences && unpackedUserPreferences.CONSENT_DATA_UNAVAILABLE ? 'FORM_FILL' : 'UPDATE_PREFERENCES';
    const consentRequestBody = {
        action: action,
        consents: deserializedConsents,
        formUrl: `${origin}${pathname}`,
        locale: 'UNKNOWN',
        site: 'atlassian',
        source: 'COOKIE_PREFERENCES'
    };
    return JSON.stringify(consentRequestBody);
};
const $a7193eec3f36a65e$export$f8422650c3dec8b2 = async (unpackedUserPreferences, displayedTextMap)=>{
    const saveToConsentHubURL = `${window.location.origin}${$a7193eec3f36a65e$var$POST_CONSENTS_URL}`;
    try {
        const response = await fetch(saveToConsentHubURL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: $a7193eec3f36a65e$var$buildConsentRequestBody(unpackedUserPreferences, displayedTextMap)
        });
        // Saving is an async API (we don't know if the save succeeds) so returns 202 Accepted.
        // 401 = User is unauthenticated
        // 5xx = ConsentHub is unavailable
        if (!response.ok || response.status !== 202 && response.status !== 200) {
            const errMsg = `Failed to save preferences to ConsentHub with status: ${response.status}`;
            const errWithStatusCode = new (0, $1b22306267891258$export$a79c0ea3d7c2444a)(errMsg, response.status);
            throw errWithStatusCode;
        }
    } catch (err) {
        (0, $dfd3c3c473d0c6a3$export$efa9a398d6368992).errorWithOperationalEvent({
            action: 'saveConsentPreferencesError',
            message: err.message || ''
        });
        // Re-throw to any encapsulating logic, a la `setConsentToken()`
        throw err;
    }
};



const $4d8a13e427af162c$export$c515de1cc9cebc71 = async (fallbackConsentToken)=>{
    // Fetches preferences from ConsentHub and returns serialized token data if possible
    const consentData = await (0, $a7193eec3f36a65e$export$86467566615ab85e)();
    let { consentToken: consentToken, consentTimestamp: consentTimestamp, consentHubInaccessible: consentHubInaccessible } = consentData;
    let { isValid: isValid } = (0, $1cc4749b2bc9d6f2$export$64b31470e8522819)(consentToken);
    if (isValid && consentHubInaccessible) {
        if (fallbackConsentToken) // `consentHubInaccessible`: ConsentHub request failed (e.g. service is down/bad request/etc). Attempt to use
        // any previously set consents in the interim if we have them.
        consentToken = fallbackConsentToken;
        else if ((0, $cnjKG.fg)('platform_moonjelly_bsc_fallback_token_audit')) {
            const version = (0, $41b24bf45fab4f15$export$31deaeaebce525bb);
            const consents = consentToken.slice(3, 7);
            // V003 BSC bits set to reflect default consent token status, authenticated user status,
            // and unavailable consentHub records status)
            const serviceBits = '111';
            // Temporary: Sets a default token with V003 properties
            // when ConsentHub is inaccessible and there is not fallback token. This
            // will ensure the banner isn't shown when ConsentHub is down.
            consentToken = `${version}${consents}${serviceBits}`;
        } else // Temporary: Sets the default token to have true consentedUnderXXXX bits
        // when ConsentHub is inaccessible and there is not fallback token. This
        // will ensure the banner isn't shown when ConsentHub is down.
        consentToken = `${consentToken.slice(0, 8)}1111`;
    }
    return isValid ? {
        consentToken: consentToken,
        consentTimestamp: consentTimestamp
    } : undefined;
};


const $2aab2efb0b08522f$export$f1b8f2ca713fca08 = async ()=>{
    const fallbackConsentToken = (0, $e9fbd27e9159f5c4$export$4be65e66cfa2648a)((0, $41b24bf45fab4f15$export$23a1e02c3c0b0d08));
    const consentData = await (0, $4d8a13e427af162c$export$c515de1cc9cebc71)(fallbackConsentToken);
    if (consentData) {
        const { consentToken: consentToken, consentTimestamp: consentTimestamp } = consentData;
        /*** TESTING OVERRIDES ***/ const potentiallyOverriddenConsentToken = (0, $a7061e76287f0fcd$export$b5282052fc15e1ae)(consentToken);
        const testingConsentOverride = (0, $e9fbd27e9159f5c4$export$4be65e66cfa2648a)((0, $41b24bf45fab4f15$export$37073d560ecebada));
        const hasTestingConsents = !!(testingConsentOverride || testingConsentOverride === '');
        if (hasTestingConsents) {
            // If testing, set the cookies accordingly so we can test with any overridden token data.
            (0, $722e5bdfcd5ad050$export$99ecece88c58d938)(potentiallyOverriddenConsentToken);
            (0, $722e5bdfcd5ad050$export$8e560d0760f733a2)(potentiallyOverriddenConsentToken);
            // Unfortunately, if you've previously saved to ConsentHub, that data will always resolve, so to simulate ConsentHub
            // being down, or the token data being bunk/invalid, we must set the testing token to an empty string. This will
            // return undefined here and skip any unpacking of the token. Otherwise, it will use the overridden token value.
            return potentiallyOverriddenConsentToken === '' ? undefined : potentiallyOverriddenConsentToken;
        }
        // At this point, all data should be valid and overridden for testing as needed, so set those cookies!
        (0, $722e5bdfcd5ad050$export$b3365240280cb3c3)(potentiallyOverriddenConsentToken, consentTimestamp);
        return consentToken;
    }
    return undefined;
};




async function $da99ddf655a2db22$export$1de6a888ae076ff8() {
    // when localConsentMode is on, don't make calls to ConsentHub
    if ((0, $f2d96fa10745de8c$export$3b78a1ea01f5ec28)().localConsentMode) {
        const packedPrefs = (0, $e9fbd27e9159f5c4$export$4be65e66cfa2648a)((0, $41b24bf45fab4f15$export$10d7db8e1a856fd8));
        if (!packedPrefs) return undefined;
        return (0, $1cc4749b2bc9d6f2$export$8d213cb390bab4fa)(packedPrefs);
    } else {
        let packedLocalPrefs = (0, $e9fbd27e9159f5c4$export$4be65e66cfa2648a)((0, $41b24bf45fab4f15$export$435de28e5b000487));
        if (!packedLocalPrefs) {
            const consentToken = await (0, $2aab2efb0b08522f$export$f1b8f2ca713fca08)();
            if ((0, $133d964c5b1c8928$export$48d7c418edadb60c)() && consentToken) window.__COOKIE_CONSENT_PREFERENCES__ = Object.assign(window.__COOKIE_CONSENT_PREFERENCES__ || {}, {
                consentToken: consentToken
            });
            return consentToken ? (0, $1cc4749b2bc9d6f2$export$8d213cb390bab4fa)(consentToken) : undefined;
        }
        return (0, $1cc4749b2bc9d6f2$export$8d213cb390bab4fa)(packedLocalPrefs);
    }
}




const $d573c783195a5d03$export$2c141b1c00f3e482 = (itemKey, startsWith)=>{
    // Setup initial pattern step and position
    let currentStep = startsWith;
    let position = 0;
    // Iterate through item key symbol by symbol
    while(position < itemKey.length){
        // The value of item character at the position
        const currentStepValue = currentStep[itemKey[position]];
        // If there is no match for item symbol in cache, this means there is no
        // pattern match for the item key
        if (currentStepValue === undefined) return null;
        // If current step value is a number, this means we reached the end of the pattern
        // and should return category number
        if (typeof currentStepValue === 'number') return currentStepValue;
        // Continue to going through pattern
        currentStep = currentStepValue;
        position++;
    }
    // No pattern match - all patterns longer or shorter than item key
    return null;
};
const $d573c783195a5d03$export$c4a1dd71bbd8954c = (itemKey, endsWith)=>{
    // Return category number if str is found in the trie, otherwise return undefined
    const trieSearch = (str)=>{
        let currentStep = endsWith;
        let foundString = '';
        let terminalNumber;
        for(let i = 0; i < str.length; i++){
            const char = str[i];
            currentStep = currentStep[char];
            if (currentStep === undefined) break;
            foundString += char;
            if (typeof currentStep === 'number') {
                terminalNumber = currentStep;
                break;
            }
        }
        if (foundString === str) // Trie contained the complete string
        return terminalNumber;
        else // Trie did not contain the complete string
        return undefined;
    };
    let position = 0;
    // Iterate through item key symbol by symbol
    while(position < itemKey.length){
        const remainderMatch = trieSearch(itemKey.slice(position));
        if (remainderMatch !== undefined) return remainderMatch;
        position++;
    }
    return null;
};
const $d573c783195a5d03$export$69d5b68d01f4a366 = (itemKey, storageControlsData, productName)=>{
    const downcasedProduct = productName?.toLowerCase();
    let itemCategoryNumber = null;
    const { categories: categories, patterns: patterns } = storageControlsData;
    let productKeys = {
        ...storageControlsData['keys']['all'],
        ...downcasedProduct ? storageControlsData['keys'][downcasedProduct] : {}
    };
    const productStartsWithPatterns = {
        ...patterns.startsWith['all'],
        ...downcasedProduct ? patterns.startsWith[downcasedProduct] : {}
    };
    const productEndsWithPatterns = {
        ...patterns.endsWith['all'],
        ...downcasedProduct ? patterns.endsWith[downcasedProduct] : {}
    };
    // Find direct match in keys
    if (Object.keys(productKeys).includes(itemKey)) itemCategoryNumber = productKeys[itemKey];
    else {
        // Find pattern match or null
        itemCategoryNumber = $d573c783195a5d03$export$2c141b1c00f3e482(itemKey, productStartsWithPatterns);
        if (itemCategoryNumber === null) itemCategoryNumber = $d573c783195a5d03$export$c4a1dd71bbd8954c(itemKey, productEndsWithPatterns);
    }
    const numToCategoryMap = {
        [categories.STRICTLY_NECESSARY]: (0, $6f6c23291291fb56$export$ba064dbfe4bb66d7).StrictlyNecessary,
        [categories.FUNCTIONAL]: (0, $6f6c23291291fb56$export$ba064dbfe4bb66d7).Functional,
        [categories.ANALYTICS]: (0, $6f6c23291291fb56$export$ba064dbfe4bb66d7).Analytics,
        [categories.MARKETING]: (0, $6f6c23291291fb56$export$ba064dbfe4bb66d7).Marketing,
        [categories.UNKNOWN]: (0, $6f6c23291291fb56$export$ba064dbfe4bb66d7).Unknown
    };
    return itemCategoryNumber !== null ? numToCategoryMap[itemCategoryNumber] : null;
};
const $d573c783195a5d03$export$ec8ce5237293e4a4 = async (itemKey, storageType, productName)=>{
    const storageControlsData = await (0, $f2d96fa10745de8c$export$3b78a1ea01f5ec28)().loadCache(storageType);
    if (!storageControlsData) return null;
    else return $d573c783195a5d03$export$69d5b68d01f4a366(itemKey, storageControlsData, productName);
};
const $d573c783195a5d03$export$e7a3dca206fec6e2 = async ({ itemKey: itemKey, allowedCallback: allowedCallback = ()=>{}, blockedCallback: blockedCallback = ()=>{}, storageType: storageType, productName: productName })=>{
    let shouldProcessItem;
    const itemCategory = await $d573c783195a5d03$export$ec8ce5237293e4a4(itemKey, storageType, productName);
    if (itemCategory === (0, $6f6c23291291fb56$export$ba064dbfe4bb66d7).StrictlyNecessary) shouldProcessItem = true;
    else {
        const preferences = await (0, $da99ddf655a2db22$export$1de6a888ae076ff8)();
        let hasPreferencesForCategory = false;
        if (!!preferences) {
            if (!!itemCategory) hasPreferencesForCategory = preferences[itemCategory];
        }
        shouldProcessItem = hasPreferencesForCategory;
    }
    if (shouldProcessItem) allowedCallback?.();
    else blockedCallback?.({
        itemHasCategory: itemCategory != null
    });
    return shouldProcessItem;
};






const $70a9893fa82f9dcf$export$5ee8760f703d9d62 = async (itemKey, value, storageType, productName, browserStorage)=>{
    // user belongs to an org that opted into cookies management and we should respect their preferences
    // Flag enabled, user belongs to an org that opted into cookies management and we should respect their preferences
    const shouldSetItem = await (0, $d573c783195a5d03$export$e7a3dca206fec6e2)({
        itemKey: itemKey,
        storageType: storageType === (0, $a1e698f910fc5577$export$259e3a861f28589b).LocalStorage ? (0, $6f6c23291291fb56$export$2506b012eb637f61).LocalStorage : (0, $6f6c23291291fb56$export$2506b012eb637f61).SessionStorage,
        productName: productName
    });
    const eventAttributes = {
        wasRejected: !shouldSetItem,
        itemKey: itemKey,
        storageType: storageType
    };
    try {
        (0, $3489483a13ea178e$export$5bfe55348e7aebc1)({
            action: 'usedAtlBrowserStorageSetItem',
            attributes: eventAttributes
        });
        if (shouldSetItem) {
            // Store the item as a record in our IDB service to track that we've seen it before.
            // That way, when we can confirm/deny that this has been set by our service when we check again.
            // If it fails for some reason, it will be caught before actually setting the item
            await (0, $8b0596a5b77a45bc$export$36328b3bcbe4623a).setRecord(itemKey);
            browserStorage.setItem(itemKey, value);
            return (0, $6f6c23291291fb56$export$96e9906d6d93a972).SUCCESS;
        } else return (0, $6f6c23291291fb56$export$96e9906d6d93a972).BLOCKED;
    } catch (e) {
        (0, $dfd3c3c473d0c6a3$export$efa9a398d6368992).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageSetItemError',
            attributes: eventAttributes,
            message: `Failed to set ${storageType} item. ${e.message || ''}`
        });
        return (0, $6f6c23291291fb56$export$96e9906d6d93a972).BLOCKED;
    }
};





const $b4714a5aacb832ca$export$f1b0c189562aa9fd = (itemKey, value, storageType, browserStorage)=>{
    // Flag disabled, allow all items.
    const eventAttributes = {
        itemKey: itemKey,
        storageType: storageType
    };
    try {
        (0, $3489483a13ea178e$export$5bfe55348e7aebc1)({
            action: 'usedAtlBrowserStorageSetStrictlyNecessaryItem',
            attributes: eventAttributes
        });
        // Store the item as a record in our IDB service to track that we've seen it before.
        // That way, when we can confirm/deny that this has been set by our service when we check again.
        // If it fails for some reason, it will be caught before actually setting the item
        // As setting Strictly Necessary requires synchronous operation, wait on the promise in an OG fashion
        (0, $8b0596a5b77a45bc$export$36328b3bcbe4623a).setRecord(itemKey).then(()=>{
        // NOTE: Should this just no-op/be removed? It already set and returned the item theoretically since this main func is sync
        }).catch((e)=>{
            // Rethrow to the above catch clause since this is async within a sync func
            throw new Error(e.message || '');
        });
        browserStorage.setItem(itemKey, value);
        return (0, $6f6c23291291fb56$export$96e9906d6d93a972).SUCCESS;
    } catch (e) {
        (0, $dfd3c3c473d0c6a3$export$efa9a398d6368992).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageSetStrictlyNecessaryItemError',
            attributes: eventAttributes,
            message: `Failed to set strictly necessary ${storageType} item. ${e.message || ''}`
        });
        return (0, $6f6c23291291fb56$export$96e9906d6d93a972).FAILED;
    }
};


class $e13ac002387b6964$export$8e4a3cf07a10930b {
    get isWebStorageEnabled() {
        // Note: outside of user configuration, webStoragedEnabled is also feature gated by
        // 1. platform_moonjelly_bsc_master_killswitch
        // 2. platform_moonjelly_bsc_web_storage_killswitch
        if ((0, $f2d96fa10745de8c$export$3b78a1ea01f5ec28)().webStorageEnabled) return true;
        (0, $dfd3c3c473d0c6a3$export$efa9a398d6368992).debug('WebStorage config is disabled, cannot proceed.');
        return false;
    }
    // Core API
    getItem(key) {
        if (!this.isWebStorageEnabled) return this.storage.getItem(key);
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $dfd3c3c473d0c6a3$export$efa9a398d6368992).warn(`${this.storageType} is unavailable. Failed to get item ${key}`);
            return null;
        }
        const retrievedItem = (0, $1a55a94ef9c4e696$export$e612bb1301d659de)(key, this.storageType, this.storage);
        return retrievedItem;
    }
    async setItem(key, value) {
        if (!this.isWebStorageEnabled) {
            this.storage.setItem(key, value);
            return;
        }
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $dfd3c3c473d0c6a3$export$efa9a398d6368992).warn(`${this.storageType} is unavailable. Failed to set item ${key}`);
            return;
        }
        const globalStateProduct = (0, $f2d96fa10745de8c$export$3b78a1ea01f5ec28)().product;
        const itemSetStatus = await (0, $70a9893fa82f9dcf$export$5ee8760f703d9d62)(key, value, this.storageType, globalStateProduct, this.storage);
        (0, $dfd3c3c473d0c6a3$export$efa9a398d6368992).debug(`${itemSetStatus === (0, $6f6c23291291fb56$export$96e9906d6d93a972).SUCCESS ? 'Successfully' : 'Failed to'} set item ${key} with value ${value}`);
    }
    setStrictlyNecessaryItem(key, value) {
        if (!this.isWebStorageEnabled) {
            this.storage.setItem(key, value);
            return;
        }
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $dfd3c3c473d0c6a3$export$efa9a398d6368992).warn(`${this.storageType} is unavailable. Failed to set strictly necessary item ${key}`);
            return;
        }
        const itemSetStatus = (0, $b4714a5aacb832ca$export$f1b0c189562aa9fd)(key, value, this.storageType, this.storage);
        (0, $dfd3c3c473d0c6a3$export$efa9a398d6368992).debug(`${itemSetStatus === (0, $6f6c23291291fb56$export$96e9906d6d93a972).SUCCESS ? 'Successfully' : 'Failed to'} set strictly necessary item ${key} with value ${value}`);
    }
    // Native Utilities
    removeItem(key) {
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $dfd3c3c473d0c6a3$export$efa9a398d6368992).warn(`${this.storageType} is unavailable. Failed to remove item ${key}`);
            return;
        }
        this.storage.removeItem(key);
    }
    key(index) {
        if (!this.isAvailable) return null;
        return this.storage.key(index);
    }
    length() {
        if (!this.isAvailable) return 0;
        return this.storage.length;
    }
    clear() {
        if (!this.isAvailable) return;
        this.storage.clear();
    }
    // Utilities
    isStorageAvailable() {
        if ((0, $133d964c5b1c8928$export$48d7c418edadb60c)()) return false;
        try {
            const x = '__storage_test__';
            this.storage.setItem(x, x);
            this.storage.removeItem(x);
            return true;
        } catch (e) {
            return e instanceof DOMException && // everything except Firefox
            (e.code === 22 || // Firefox
            e.code === 1014 || // test name field too, because code might not be present
            // everything except Firefox
            e.name === 'QuotaExceededError' || // Firefox
            e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && // acknowledge QuotaExceededError only if there's something already stored
            this.storage && this.storage.length !== 0;
        }
    }
    constructor(storage, storageType){
        this.storage = void 0;
        this.storageType = void 0;
        this.isAvailable = false;
        this.checkIfSetByPackage = async ({ itemKey: itemKey, isSetCallback: isSetCallback = ()=>{}, isNotSetCallback: isNotSetCallback = ()=>{} })=>{
            // As IDB is asynchronous in nature, when this in invoked, we need to rely on the callbacks
            // to actually do something with the result.
            try {
                const record = await (0, $8b0596a5b77a45bc$export$36328b3bcbe4623a).getRecord(itemKey);
                if (record) {
                    isSetCallback();
                    return true;
                } else {
                    isNotSetCallback();
                    return false;
                }
            } catch (e) {
                // If it fails to pull from IDB, we can't validate that it's been set by our package or not, so log the error
                // and assume it hasn't been set by our package. This will only impact our analytics correctness.
                (0, $dfd3c3c473d0c6a3$export$efa9a398d6368992).errorWithOperationalEvent({
                    action: 'usedCheckIfSetByPackageError',
                    message: `IDB lookup failed to check if item was set by package. ${e.message || ''}`,
                    attributes: {
                        itemKey: itemKey
                    }
                });
                isNotSetCallback();
                return false;
            }
        };
        this.storage = storage;
        this.storageType = storageType;
        this.isAvailable = this.isStorageAvailable();
    }
}
const $e13ac002387b6964$export$c8cc3ffd3f2c1d2f = new $e13ac002387b6964$export$8e4a3cf07a10930b(window?.localStorage, (0, $a1e698f910fc5577$export$259e3a861f28589b).LocalStorage);
const $e13ac002387b6964$export$edbae459bdf957a5 = new $e13ac002387b6964$export$8e4a3cf07a10930b(window?.sessionStorage, (0, $a1e698f910fc5577$export$259e3a861f28589b).SessionStorage);
const $e13ac002387b6964$export$14921bfc334334c0 = (type)=>{
    return ({
        [(0, $a1e698f910fc5577$export$259e3a861f28589b).LocalStorage]: $e13ac002387b6964$export$c8cc3ffd3f2c1d2f,
        [(0, $a1e698f910fc5577$export$259e3a861f28589b).SessionStorage]: $e13ac002387b6964$export$edbae459bdf957a5
    })[type];
};



/* eslint-disable check-set-storage-usage/no-unimported-storage-set */ 



const $0a711c922c37c686$export$359ef83116415c8a = (0, $d7f2d52a706ecc0f$export$2e2bcd8739ae039)`mutation UpdateLocalStorageMutation($storageinput:LocalStorageInput!$stringKeys:[String]!){updateLocalStorage(localStorage:$storageinput){stringValues(keys:$stringKeys){key value}}}`;


const $55aebbd7cffee8f3$export$ed97f33186d4b816 = {
    DISCOVER_ROUTE: 'discover.route.last',
    GLOBAL_SIDEBAR_PANEL: 'sidebar.global.panel',
    EDITOR_SURVEY_LAST_SUBMITTED: 'editor.survey.last.submitted',
    SUPERADMIN_SURVEY_REQUESTED: 'superadmin.survey.requested',
    SUPERADMIN_SURVEY_SUBMITTED: 'superadmin.survey.submitted',
    SUPERADMIN_SESSION_EXPIRED: 'superadmin.session.expired',
    RESTRICTED_PAGE_CONFIRMED: 'restricted.page.confirmed',
    HOME_ONBOARDING: 'home.onboarding',
    PAGE_JUST_CONVERTED: 'migration.page.just.converted',
    NAVIGATION_CLASSIC_OPT_OUT: 'navigation.classic.opt.out',
    NAVIGATION_HOME_OPT_OUT: 'navigation.home.opt.out',
    NAVIGATION_DEFAULT_OPTED_OUT: 'navigation.default.opted.out',
    NAVIGATION_OPT_IN_SEEN_SPOTLIGHT: 'navigation.opt.in.seen.spotlight',
    NAVIGATION_CLICKED_LOUD_OPT_IN_OR_VIEWED_FLAG: 'navigation.clicked.loud.opt.in.or.viewed.flag',
    NOTIFICATION_SPOTLIGHT_VIEWED: 'notification.spotlight.viewed',
    HOME_SECTION_COLLAPSED: 'home.section.collapsed',
    RECENTLY_WATCHED_SPACE: 'recentlyWatchedSpace',
    GROWTH_EXPERIMENT_REQUEST_UPGRADE_SENT: 'growth.experiment.request.upgrade.sent',
    GROWTH_EXPERIMENT_UPGRADE_DISMISSED_COUNT: 'growth.experiment.engagedUpgrade.dismissed.count',
    GROWTH_EXPERIMENT_UPGRADE_LAST_DISMISSED_DATE: 'growth.experiment.engagedUpgrade.last.dismissed.date',
    LOCAL_STORAGE_DISPLAYS_NEXT_AT_KEY: 'growth.experiment.engagedBilling.displays.next.at',
    LOCAL_STORAGE_HAS_BILLING_DETAILS: 'growth.experiment.engagedBilling.has.billing.details',
    LOCAL_STORAGE_BILLING_API_NEXT_CALLED_AT_KEY: 'growth.experiment.engagedBilling.billing.api.next.called.at',
    LOCAL_STORAGE_CONTENT_VIEW_CLOSEST_ELEMENT_SCROLL_POSITION: 'ce.content.view.best.element.scroll.position',
    CONFLUENCE_SLACK_APP_IS_ENABLED: 'growth.experiment.confluence.slack-is-enabled',
    INVITE_ON_LINK_INSERT_DISMISSAL_COUNT: 'growth.experiment.confluence.invite-on-link-insert-dismissal-count',
    INVITE_ON_LINK_INSERT_OPT_OUT: 'growth.experiment.confluence.invite-on-link-insert-opt-out',
    CROSS_JOIN_NUDGES_V3_VISITED_KEY: 'growth.experiment.confluence.cross-join-nudges-v3-visited',
    CROSS_JOIN_NUDGES_JPD_VISITED_KEY: 'growth.experiment.confluence.cross-join-nudges-jpd-visited',
    CROSS_JOIN_NUDGES_MSR_VISITED_KEY: 'growth.experiment.confluence.cross-join-nudges-msr-visited',
    CROSS_JOIN_NUDGES_MSR_USER_OPT_OUT: 'growth.experiment.confluence.cross-join-nudges-msr-opt-out',
    CROSS_JOIN_NUDGES_MSR_VISITED_COUNT: 'growth.experiment.confluence.cross-join-nudges-msr-visited-count',
    CROSS_JOIN_NUDGES_V3_VISITED_COUNT: 'growth.experiment.confluence.cross-join-nudges-v3-visited-count',
    CROSS_JOIN_NUDGES_JPD_VISITED_COUNT: 'growth.experiment.confluence.cross-join-nudges-jpd-visited-count',
    CROSS_JOIN_NUDGES_V3_USER_OPT_OUT: 'growth.experiment.confluence.cross-join-nudges-v3-opt-out',
    CROSS_JOIN_NUDGES_JPD_USER_OPT_OUT: 'growth.experiment.confluence.cross-join-nudges-jpd-opt-out',
    CROSS_JOIN_NUDGES_ELIGIBILITY_KEY: 'growth.experiment.confluence.cross-join-nudges-eligibility',
    CROSS_JOIN_NUDGES_EVENT_CACHE_KEY: 'growth.experiment.confluence.cross-join-nudges-event-cache',
    CROSS_JOIN_NUDGES_LOOM_EVENT_CACHE_KEY: 'growth.experiment.confluence.cross-join-nudges-loom-event-cache',
    CROSS_JOIN_THIRD_PARTY_NUDGES_VISITED_KEY: 'growth.experiment.confluence.cross-join-third-party-nudges-v2-visited',
    CROSS_JOIN_THIRD_PARTY_NUDGES_VISITED_COUNT: 'growth.experiment.confluence.cross-join-third-party-nudges-v2-visited-count',
    CROSS_JOIN_NUDGES_LOOM_VISITED_KEY: 'growth.experiment.confluence.cross-join-nudges-loom-visited',
    CROSS_JOIN_NUDGES_LOOM_VISITED_COUNT: 'growth.experiment.confluence.cross-join-nudges-loom-visited-count',
    CROSS_JOIN_NUDGES_LOOM_OPT_OUT: 'growth.experiment.confluence.cross-join-nudges-loom-opt-out',
    /**
   * The width of the right panel on Home
   */ HOME_SIDEBAR_WIDTH: 'home.sidebar.width',
    /**
   * Used to store starred/favorited feature flags for the dev tools panel
   */ STARRED_FEATURE_FLAGS: 'confluence-frontend-next.starredFeatureFlags',
    /**
   * Indicates that "Copy space permissions" (implemented by
   * @confluence/copy-space-permissions) has completed i.e. space permissions
   * have been copied.
   */ COPIED_SPACE_PERMISSIONS: 'copied.space.permissions',
    PERSIST_SCROLL_POSITION_IN_VIEW_PAGE: 'editor-persit-scroll-position',
    ID_START_CONTENT_IN_VIEW_PAGE: 'main-content',
    FABRIC_PAGE_OPTIN_MIGRATION_BANNER: 'fabric.page.optin.migration.banner.discovery.feature',
    FABRIC_TEMPLATE_MIGRATION_SUCCESS_FLAG: 'fabric-template-migration.success.flag',
    FABRIC_TEMPLATE_MIGRATION_ERROR_FLAG: 'fabric-template-migration.error.flag',
    BYLINE_APPS_SHOW_ALL: 'byline.apps.show-all',
    SPACENAV_APPS_SHOW_ALL: 'spacenav.apps.show-all',
    HIDE_BULK_CONFIRMATION_DIALOG_LOCAL_STORAGE_KEY: 'archive-pages.bulk-archive.confirmation-dialog.opt-out',
    ONBOARDING_STEP_INDEX: 'onboarding.account.setup.step.index',
    ONBOARDING_STEP_HAS_TEAM_NAME: 'onboarding.account.setup.step.hasTeamName',
    ONBOARDING_FORM_VALUES: 'onboarding.account.setup.form.values',
    RIGHT_SIDEBAR: 'right.sidebar',
    CONNECT_APP_ANALYTICS: 'ecosystem.confluence.connect.analytics',
    /**
   * Auto Convert TinyMCE pages
   */ EDITOR_REVERTED: 'autoconverted.pages.reverted',
    BLOGPOST_PERMISSIONS_NOTICE: 'blogpost.permissions.notice.error',
    QUERY_OVERRIDES: 'query.overrides',
    CANVAS_SERVER: 'canvas-server',
    CANVAS_RELAY: 'canvas-relay',
    CANVAS_FRONTEND_VERSION: 'canvas-frontend-version',
    // Below are cc-automation keys for in-context discoverability messages
    AUTOMATION_DISCOVER_ARCHIVE_FROM_OVERFLOW_MENU: 'automation.discover.archive-from-overflow-menu',
    AUTOMATION_DISCOVER_ARCHIVE_FROM_HOVER_OVER_PAGE_TITLE: 'automation.discover.archive-from-hover-over-page-title',
    AUTOMATION_DISCOVER_BULK_ARCHIVE: 'automation.discover.bulk-archive',
    AUTOMATION_DISCOVER_BULK_CHANGE_PAGE_OWNER: 'automation.discover.bulk-change-page-owner',
    AUTOMATION_DISCOVER_ADD_LABEL_TO_PAGE: 'automation.discover.add-label-to-page',
    AUTOMATION_DISCOVER_MEETING_NOTES_TEMPLATE: 'automation.discover.meeting-notes-template',
    AUTOMATION_DISCOVER_JIRA_LINK: 'automation.discover.jira-link',
    AUTOMATION_DISCOVER_MANUAL_TRIGGER: 'automation.discover.manual.trigger',
    AUTOMATION_DISCOVER_MANUAL_RULE_COUNT: 'automation.discover.manual.rule.count',
    AUTOMTION_DISCOVER_MANUAL_RULE_SMART_BUTTON: 'automation.discover.manual.rule.smart.button',
    AUTOMATION_DISCOVER_PAGE_PUBLIC_LINK: 'automation.discover.page-public-link',
    AUTOMATION_DISCOVER_GLOBAL_PUBLIC_LINK: 'automation.discover.global-public-link',
    AUTOMATION_DISCOVER_SPACE_ASSIGNED_BULK: 'automation.discover.space-assigned-bulk',
    AUTOMATION_DISCOVER_SPACE_ASSIGNED_INDIVIDUAL: 'automation.discover.space-assigned-individual',
    AUTOMATION_DISCOVER_GLOBAL_DEFAULT_SPACE: 'automation.discover.global-default-space',
    AUTOMATION_DISCOVER_VERIFIED_CONTENT: 'automation.discover.verified.content',
    AUTOMATION_DISCOVER_WHITE_BOARDS: 'automation.discover.publish.white.boards',
    AUTOMATION_DISCOVER_SHARE_SLACK: 'automation.discover.share.slack',
    AUTOMATION_DISCOVER_SET_CONTENT_STATE: 'automation.discover.set-content-state',
    AUTOMATION_DISCOVER_PRODUCT_REQUIREMENTS: 'automation.discover.product-requirements',
    AUTOMATION_DISCOVER_FEEDBACK_ANALYSIS: 'automation.discover.feedback-analysis',
    AUTOMATION_DISCOVER_RELEASE_NOTES: 'automation.discover.release-notes',
    AUTOMATION_ONBOARDING: 'automation.onboarding',
    AUTOMATION_EXECUTION_LIMIT: 'automation.execution.limit',
    SPACE_SETTINGS_NAV_SECTIONS_EXPANDED_STATES: 'space-settings-nav.sections.expand-states',
    SITE_SETTINGS_NAV_SECTIONS_EXPANDED_STATES: 'site-settings-nav.sections.expand-states',
    /**
   * Comment Drafts
   */ COMMENT_DRAFTS_PAGE_CREATE: 'comments.drafts.page.create',
    COMMENT_DRAFTS_PAGE_EDIT: 'comments.drafts.page.edit',
    COMMENT_DRAFTS_PAGE_REPLY: 'comments.drafts.page.reply',
    COMMENT_DRAFTS_INLINE_CREATE: 'comments.drafts.inline.comments.create',
    COMMENT_DRAFTS_INLINE_EDIT: 'comments.drafts.inline.comments.edit',
    COMMENT_DRAFTS_INLINE_REPLY: 'comments.drafts.inline.reply',
    COMMENT_DRAFTS_EDITOR_INLINE_CREATE: 'comments.drafts.editor.inline.create',
    COMMENT_DRAFTS_EDITOR_INLINE_EDIT: 'comments.drafts.editor.inline.edit',
    COMMENT_DRAFTS_EDITOR_INLINE_REPLY: 'comments.drafts.editor.inline.reply',
    LOOM_BETA_ENABLED: 'loom.beta.enabled',
    BROWSER_BANNER_CLOSED_BY_USER: 'devloop.browser-support-warning.closed',
    /**
   * Home Feeds
   */ HOME_FOLLOWING_FEED_SESSION_ID: 'home.follow-feed.sessionId',
    HOME_POPULAR_FEED_SESSION_ID: 'home.popular-feed.sessionId',
    HOME_FOLLOWING_FEED_SORTING: 'home.follow-feed.sorting',
    HOME_POPULAR_FEED_TIME_GRANULARITY: 'home.popular-feed.time-granularity',
    /**
   * Live Pages
   */ LIVE_PAGES_IN_PRODUCT_PROMPT_MODAL_LAST_DISMISSED: 'live-pages.in-product-prompt.modal.last-dismissed',
    LIVE_PAGES_IN_PRODUCT_PROMPT_BANNER_SPACE_SETTINGS_LAST_DISMISSED: 'live-pages.in-product-prompt.banner.space-settings.last-dismissed',
    LIVE_PAGES_IN_PRODUCT_PROMPT_BANNER_MISSION_CONTROL_LAST_DISMISSED: 'live-pages.in-product-prompt.banner.mission-control.last-dismissed',
    LIVE_PAGES_MODE_SWITCHING_FLAG_SHOWN: 'live-pages.mode-switcher.flag.shown',
    LIVE_PAGES_OPEN_BETA_PROMPT_MODAL_FIRST_SEEN: 'live-pages.open-beta-prompt-modal.first-seen',
    LIVE_PAGES_OPEN_BETA_PROMPT_GLOBAL_BANNER_FIRST_DISMISSED: 'live-pages.open-beta-prompt-global-banner.first-dismissed',
    LIVE_DOCS_HAS_INIT_MODERNIZE: 'live-docs.has-init-modernize',
    LIVE_DOCS_HAS_INIT_MODERNIZE_POST_EXP: 'live-docs.has-init-modernize-post-exp',
    LIVE_DOCS_NEW_LOZENGE_SHOWN_TRACKER: 'live-docs.new-lozenge-shown-tracker',
    /**
   * AI First Creation
   */ HAS_INIT_AIFC_EXP: 'ai-first-creation.has-init-aifc-exp',
    CREATE_WITH_ROVO_MODAL_CLOSE_FEEDBACK_FLAG_LAST_SHOWN: 'create-with-rovo-modal-close-feedback-flag.last-shown',
    /**
   * Confluence Notes
   */ NOTES_FLOATING_POSITION: 'confluence-notes.floating-position',
    UNIVERSAL_SHORTCUTS_HIDE_PROMPT_UNTIL: 'universal-shortcuts.deprecated-shortcut-flag.hide-until',
    // Bold new pages experiment
    UNREAD_PAGES_VISITED: 'bold-new-pages.experiment.unread-pages.visited',
    // Mention Reminders experiment
    MENTION_REMINDERS_SENT: 'mention-reminders.experiment.sent',
    // Nav 4 Site/Space settings back button URL
    NAV4_SETTINGS_BACK_BUTTON_URL: 'navigation.settings.back-button.url',
    // Nav 4 opt out cache
    NAV4_OPT_OUT_CACHE: 'navigation.opt-out',
    // Nav 4 admin opt in cache
    NAV4_ADMIN_OPT_IN_CACHE: 'navigation.admin.opt-in',
    // Nav 4 misaligned nav versions flag
    NAV4_MISALIGNED_NAV_VERSIONS_FLAG: 'navigation.misaligned.nav.versions.flag',
    // EOT Banner experiment
    EOT_BANNER_DISMISS_UNTIL: 'eot-banner.dismiss-until',
    // Issue Create
    ISSUE_CREATE_WITH_AI: 'issue-create.with-ai',
    // AI Unsplash Header Experiment
    AI_UNSPLASH_HEADER_ACCEPTED: 'ai-unsplash.header.accepted',
    //Notify User On 1st View expeirment
    NOTIFY_USERS_ON_FIRST_VIEW_MUTATION_FIRED: 'notify-users-on-first-view.mutation.fired',
    NAVDEX_STORAGE_KEY: 'navigationSession',
    // Super Admin Timeout
    SUPER_ADMIN_TIMEOUT: 'confluence.super.admin.timeout',
    // Premium Onboarding
    PTO_PHASE_TWO_SPOTLIGHT_TARGET: 'pto-phase-two-spotlight',
    // Have I Seen It prefix
    HAVE_I_SEEN_IT_PREFIX: 'cf_hisi_',
    // Migrations
    IMPORT_CONTENT_TIMESTAMP: 'importContentTimestamp',
    // Page Experience
    AE_TABLE_COPIED: 'copied',
    AE_TABLE_COPIED_COLS: 'copiedCols',
    LAST_TAB_SUFFIX: 'last-tab',
    // AI Audio Playback Speed
    AI_AUDIO_PLAYBACK_SPEED: 'ai.audio.playback-speed',
    AI_AUDIO_BRIEFING_CUSTOMIZATION: 'ai.audio.briefing.customization',
    // EditorTeamCreatedFlag
    RETROSPECTIVE_BLUEPRINT_TEAM_CREATED: 'retrospective-blueprint.team.created',
    RETROSPECTIVE_BLUEPRINT_TEAM_USED: 'retrospective-blueprint.team.used',
    // Confluence Custom Origins
    CONFLUENCE_CUSTOM_ORIGINS: 'confluenceCustomOrigins',
    // Dev and Testing
    HIDE_FEATURE_FLAG_ICON: 'confluence-frontend-next.hideFeatureFlagIcon',
    FE_FIXTURE_PARAMS: '__confluence-frontend-fixture-params',
    TEST_FAILURES_LINK_MODE: 'testFailuresLink.mode',
    TEST_FAILURES_LINK_OPERATIONS_PREFIX: 'testFailuresLink.operations.',
    // Disable Engagement for tests
    DISABLE_ENGAGEMENT_FOR_TESTS: 'confluence.disable-engagement-for-tests',
    // Jira Crossflow Experiment
    JIRA_ACCESS_REQUESTED: 'jira_access_requested',
    JIRA_TRIAL_REQUESTED: 'jira_trial_requested',
    // Feature Discovery Override
    FEATURE_DISCOVERY_OVERRIDE_PREFIX: 'featureDiscoveryOverride-',
    // Chrome Extension
    CONFLUENCE_SSR_OUTLINE_PRIORITY: 'confluence.ssr-outline-priority',
    CONFLUENCE_SSR_OUTLINE_ENABLED: 'confluence.ssr-outline-enabled',
    CONFLUENCE_LOADABLE_STEP_OVER_ENABLED: 'confluence.loadable-step-over-enabled'
};
const $55aebbd7cffee8f3$export$84dce893719feb44 = {
    //keys stored on backend start with persisted
    PERSISTED_LEFT_SIDEBAR_WIDTH: 'persisted.left.sidebar.width',
    PERSISTED_LEFT_SIDEBAR_COLLAPSED: 'persisted.left.sidebar.collapsed',
    PERSISTED_GROWTH_PERSISTENT_UPGRADE_PRETRIAL_BANNER: 'persisted.growth.persistent.upgrade.preTrial.banner',
    PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES: 'persisted.space-nav.sections.expand-states',
    // The next time to show the External Collaboration Guest Satisfaction Survey to this guest user
    PERSISTED_GUEST_SURVEY_NEXT_TIME_TO_SHOW: 'persisted.guest.survey.next.time.to.show',
    // Overrided feature flags. These are persisted to the server so they can be
    // used when rendering in SSR
    PERSISTED_OVERRIDE_FEATURE_FLAGS: 'persisted.enterprise-experience.override.feature.flags',
    PERSISTED_OVERRIDES_STATSIG: 'persisted.enterprise-experience.override.statsig',
    PERSISTED_ADMIN_ANNOUNCEMENT_BANNER: 'persisted.admin.announcement.banner',
    PERSISTED_ADMIN_ANNOUNCEMENT_BANNER_MIGRATOR_PROMPT: 'persisted.admin.announcement.banner.migrator.prompt',
    PERSISTED_STORAGE_ENFORCEMENT_BANNER: 'persisted.storage.enforcement.banner',
    // Public Links Modals
    PERSISTED_RESTRICTIONS_DIALOG_PUBLIC_LINKS_MODAL: 'persisted.restrictions.dialog.public.links.modal',
    PERSISTED_SHARE_DIALOG_PUBLIC_LINKS_TOGGLE_ON_MODAL: 'persisted.share.dialog.public.links.toggle.on.modal',
    PERSISTED_SHARE_DIALOG_PUBLIC_LINKS_TOGGLE_ON_MODAL_SMART_SECTIONS: 'persisted.share.dialog.public.links.toggle.on.modal.smart.sections',
    PERSISTED_SHARE_DIALOG_PUBLIC_LINKS_TOGGLE_OFF_MODAL: 'persisted.share.dialog.public.links.toggle.off.modal',
    // Public Links Edit Whiteboard Banner
    PERSISTED_PUBLIC_LINKS_EDIT_WHITEBOARD_BANNER: 'persisted.public.links.edit.whiteboard.banner',
    // Theming
    PERSISTED_USER_THEME_PREFERENCE: 'persisted.ecosystem.user.theme.preference',
    // Premium feature highlight
    PERSISTED_PREMIUM_FEATURE_HIGHLIGHT: 'persisted.premium.feature.highlight',
    // Reading Aids
    PERSISTED_READING_AIDS_AUTO_HIGHLIGHT: 'persisted.reading.aids.auto.highlight',
    // Bold new pages experiment
    PERSISTED_BOLD_NEW_PAGES_SATISFACTION_SURVEY_HAS_SEEN: 'persisted.bold-new-pages.experiment.satisfaction-survey.has-seen',
    // Previously trialed premium users experiment
    PERSISTED_PREVIOUSLY_TRIALED_PREMIUM_USERS_DISMISSED: 'persisted.previously.trialed.premium.users.banner.dismissed',
    // Quick Summary Experiment
    PERSISTED_QUICK_SUMMARY_REQUEST_SENT: 'persisted.growth.quick-summary-request-sent',
    // AIFC Banner Persistence
    PERSISTED_SMART_CREATE_FEEDBACK_BANNER_LAST_DISMISSED: 'persisted.smart-create.feedback-banner.last-dismissed',
    // Editor Controls
    PERSISTED_EDITOR_CONTROLS_ONBOARDING_BANNER_NEW_PINNING_DISMISSED: 'persisted.editor-controls.onboarding-banner-new-pinning.dismissed',
    //Bite Sized Generic Premium Messages
    PERSISTED_BITE_SIZED_PREMIUM_MESSAGES_GENERIC_CADENCE: 'persisted.bite-sized.premium-messages.generic.cadence',
    //Bite Sized Automation Premium Messages
    PERSISTED_BITE_SIZED_PREMIUM_MESSAGES_AUTOMATION_CADENCE: 'persisted.bite-sized.premium-messages.automation.cadence',
    //Role Based Access Control
    PERSISTED_RBAC_TRACKING: 'persisted.rbac.tracking',
    // Loom cross_flow ad-control not interested preference
    PERSISTED_LOOM_CROSS_FLOW_AD_CONTROL_NOT_INTERESTED: 'persisted.loom-cross-flow.ad-control.not-interested',
    // Status of exposure to a series of spotlight pulse outlines
    // highlighting Loom entrypoints to cross-sell-eligible customers
    PERSISTED_LOOM_CROSS_SELL_DISCOVERABILITY_PULSES_HAVE_ENDED: 'persisted.loom-cross-sell.discoverability-pulses.have-ended',
    // Jira Cloud ID preference for site picker on Jira Issue Create
    PERSISTED_JIRA_CLOUD_ID_PREFERENCE: 'persisted.jira-cloud-id.preference',
    // Selected site, project and issue type from the configure view on bulk AI Jira Issue Create
    PERSISTED_BULK_CREATE_JIRA_CONFIG_FOR_USER: 'persisted.bulk-create.jira.config.for.user',
    // Selected site, project and issue type from the single work create form
    PERSISTED_SINGLE_CREATE_JIRA_CONFIG_FOR_USER: 'persisted.single-create.jira.config.for.user',
    PERSISTED_SHOULD_USE_GIC_EMBED: 'persisted.should-use-gic-embed',
    // Importers
    PERSISTED_IMPORT_FEEDBACK_DISABLED: 'persisted.imports.import-feedback-disabled',
    PERSISTED_RT_PAID_FEATURE_EDUCATION_SPOTLIGHT_SEEN: 'persisted.rt-paid-feature-education.spotlight.seen'
};



const $abd639c20d964dca$export$94c92810ef76851 = 'atlassian';
const $abd639c20d964dca$export$cae0fbb99c422e2 = 'frontend';
const $abd639c20d964dca$export$1b311d1dfe8a9349 = 'localStorage';
const $abd639c20d964dca$export$16f5e866917d6fd1 = 'sessionStorage';


const $505af0297173c4d6$var$serverCacheKeyRegex = /[^A-Za-z0-9\-._\/]/g;
const $505af0297173c4d6$export$7c5eda5500a5f08d = (userId)=>{
    const keys = [];
    let prefix = `${(0, $abd639c20d964dca$export$1b311d1dfe8a9349)}/${(0, $abd639c20d964dca$export$94c92810ef76851)}.${userId}.${(0, $abd639c20d964dca$export$cae0fbb99c422e2)}`;
    prefix = prefix.replace($505af0297173c4d6$var$serverCacheKeyRegex, '_');
    Object.keys((0, $55aebbd7cffee8f3$export$84dce893719feb44)).forEach((key)=>keys.push(`${prefix}.${(0, $55aebbd7cffee8f3$export$84dce893719feb44)[key]}`));
    return keys;
};
const $505af0297173c4d6$export$902ba6ec74c93f9d = (key, cacheKey)=>{
    if (Object.values((0, $55aebbd7cffee8f3$export$84dce893719feb44)).indexOf(key) > -1) cacheKey = cacheKey.replace($505af0297173c4d6$var$serverCacheKeyRegex, '_');
    return cacheKey;
};


const $a0a079aa648eb079$var$logger = (0, $a6897acd40ed68b1$export$2b1d391cd05230fd)('storage-manager');
const $a0a079aa648eb079$var$localStorageMigrationEntriesKey = 'localstorage-migration-entries';
function $a0a079aa648eb079$export$4fc2001188ec893d(error) {
    if (error && 'code' in error) switch(error.code){
        case 22:
            return true;
        case 1014:
            // Firefox
            if (error.name === 'NS_ERROR_DOM_QUOTA_REACHED') return true;
            break;
        default:
            return false;
    }
    return false;
}
function $a0a079aa648eb079$export$b4ff986ecbd5f7f2(value) {
    if (!value) return value;
    try {
        return JSON.parse(value);
    } catch (_) {
        return value;
    }
}
class $a0a079aa648eb079$export$93525d6e221593cb {
    /**
   * PRIVATE Does not trigger Init
   * creates a prefix for a value
   */ _getPrefix(seconds) {
        const milliseconds = (seconds || 0) * 1000;
        if (!milliseconds) return '';
        return Date.now() + milliseconds + this._delimiter;
    }
    constructor(storageManager, prefix, id, storagePrefix, { userId: userId, isLicensed: isLicensed }){
        this._storageManager = void 0;
        this._delimiter = '#';
        this._namespace = void 0;
        this._userId = void 0;
        this._isLicensedUser = void 0;
        this._hasQuotaErrorBeenSubmitted = false;
        this._persistSetValue = (originalKey, value, persistKey)=>{
            // there is a cyclic dependency with @confluence/graphql
            // communicate local/session storage update to cc-bandana
            if (Object.values((0, $55aebbd7cffee8f3$export$84dce893719feb44)).indexOf(originalKey) > -1 && !sessionStorage.getItem('confluence.disable-persisted-storage-for-tests') && window['GLOBAL_APOLLO_CLIENT'] && this._userId && this._isLicensedUser) {
                const mutationVariables = {
                    storageinput: {
                        stringValues: [
                            {
                                key: persistKey,
                                value: value
                            }
                        ]
                    },
                    stringKeys: [
                        persistKey
                    ]
                };
                window['GLOBAL_APOLLO_CLIENT'].mutate({
                    mutation: (0, $0a711c922c37c686$export$359ef83116415c8a),
                    variables: mutationVariables
                }).catch((e)=>{
                    this._submitError(e, `Error updating user preferences with key ${originalKey} and value ${value}: ${e}`);
                });
            }
        };
        /**
     * Gets the item stored in local storage for the given key. null is returned if it doesn't exist.
     * Note that this method will always return a string representation of what is stored.
     */ this.getItem = (key)=>{
            if (!this._storageManager) {
                $a0a079aa648eb079$var$logger.warn`Local/session storage not supported on browser`;
                return null;
            }
            try {
                const cacheKey = (0, $505af0297173c4d6$export$902ba6ec74c93f9d)(key, `${this._namespace}.${key}`);
                let item;
                if ((0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_browser_storage_controls')) item = this._storageManager.getItem(key);
                else {
                    item = this._storageManager.getItem(cacheKey);
                    /**
           * Currently some keys from independent usages of native local/session storage
          	 were adding keys without namespace. This helps cleanup those keys and return the
          	values for those keys if they exist
          * Once we stop seeing increments in counter in metrics for localStorageMigrationEntriesKey
          		we can remove this logic*/ if (!item) {
                        item = this._storageManager.getItem(key);
                        if (item) {
                            this._incrementLocalStorageMigrationEntries();
                            this.setItem(key, item);
                            this._storageManager.removeItem(`${key}`);
                        }
                    }
                }
                if (item) {
                    item = $a0a079aa648eb079$export$b4ff986ecbd5f7f2(item);
                    let match;
                    const prefixMatch = /(\d+)#/;
                    if (typeof item === 'string' && (match = prefixMatch.exec(item))) {
                        const itemWithStrippedExpirationPrefix = item.replace(match[0], '');
                        const expirationTimestamp = parseInt(match[1], 10);
                        const isExpired = !isNaN(expirationTimestamp) && Date.now() > expirationTimestamp;
                        if (isExpired) {
                            this.removeItem(key);
                            return null;
                        }
                        return itemWithStrippedExpirationPrefix;
                    }
                    return item;
                }
                return null;
            } catch (e) {
                this._submitError(e, `Error getting value from storage manager for key:${key} : ${e}`);
                return null;
            }
        };
        this.getAndRemoveItem = (key)=>{
            if (!this._storageManager) {
                $a0a079aa648eb079$var$logger.warn`Local/session storage not supported on browser`;
                return null;
            }
            try {
                const item = this.getItem(key);
                if (item) {
                    this.removeItem(key);
                    return item;
                }
                return null;
            } catch (e) {
                this._submitError(e, `Error getting and removing value from storage manager for key:${key} : ${e}`);
                return null;
            }
        };
        /**
     * Get all the items in local storage that are bound to the given context.
     */ this.getAllItems = ()=>{
            const items = {};
            if (!this._storageManager) {
                $a0a079aa648eb079$var$logger.warn`Local/session storage not supported on browser`;
                return items;
            }
            const length = this._storageManager.length;
            // Currently getAllItems is unsupported if _storageManager is AtlBrowserStorage,
            // which retrieves length differently
            if (typeof length !== 'number') return items;
            try {
                for(let i = 0; i < length; i++){
                    const itemKey = this._storageManager.key(i);
                    if (itemKey && itemKey.includes(`${this._namespace}.`)) {
                        const keyWithoutNamespace = itemKey.split(`${this._namespace}.`)[1];
                        const rawItemValue = this._storageManager.getItem(itemKey);
                        items[keyWithoutNamespace] = $a0a079aa648eb079$export$b4ff986ecbd5f7f2(rawItemValue);
                    }
                }
                return items;
            } catch (e) {
                this._submitError(e, `Error getting all items from storage manager : ${e}`);
                return items;
            }
        };
        /**
     * Returns a boolean to let you know if we contain a key that matches, and has not expired.
     */ this.doesContain = (key)=>{
            if (!this._storageManager) {
                $a0a079aa648eb079$var$logger.warn`Local/session storage not supported on browser`;
                return false;
            }
            try {
                const value = this.getItem(key);
                return typeof value === 'boolean' ? !value : !!value;
            } catch (e) {
                this._submitError(e, `Error getting value from storage manager for key ${key}: ${e}`);
                return false;
            }
        };
        /**
     * Gets the item stored in local storage for the given key and returns the boolean value of it.
     * It correctly convert the "true" and "false" strings to return true/false booleans.
     */ this.getItemAsBoolean = (key)=>{
            if (!this._storageManager) {
                $a0a079aa648eb079$var$logger.warn`Local/session storage not supported on browser`;
                return false;
            }
            try {
                const value = this.getItem(key);
                if (value && typeof value === 'string' && value.indexOf('false') >= 0) return false;
                if (value && typeof value === 'string' && value.indexOf('true') >= 0) return true;
                return !!value;
            } catch (e) {
                this._submitError(e, `Error getting value as boolean from storage manager for key ${key}: ${e}`);
                return false;
            }
        };
        /**
     * synchronously sets a value
     * @param expire expiration time in seconds
     * @returns {string}
     */ this.setItem = (key, value, expire)=>{
            if (!this._storageManager) {
                $a0a079aa648eb079$var$logger.warn`Local/session storage not supported on browser`;
                return null;
            }
            try {
                const cacheKey = (0, $505af0297173c4d6$export$902ba6ec74c93f9d)(key, `${this._namespace}.${key}`);
                // If it's not an object then append prefix.
                if (typeof value !== 'object') value = `${this._getPrefix(expire)}${value}`;
                value = JSON.stringify(value);
                // Use original key to call AtlBrowserStorage setItem, because only the original key is registered
                if ((0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_browser_storage_controls')) {
                    const processSetItem = this._storageManager.setItem(key, value);
                    processSetItem?.then(()=>{
                        // Currently AtlBrowserStorage setItem does not return SUCCESS or BLOCKED,
                        // so we check the successful status by calling getItem
                        // only persist the value if the setItem was successful
                        const isSuccessful = this._storageManager && this._storageManager.getItem(key);
                        if (isSuccessful) this._persistSetValue(key, value, cacheKey);
                    });
                } else {
                    this._storageManager.setItem(cacheKey, value);
                    this._persistSetValue(key, value, cacheKey);
                }
                return JSON.parse(value);
            } catch (e) {
                if ($a0a079aa648eb079$export$4fc2001188ec893d(e)) {
                    // for "quota exceeded" errors we're re-massaging the error message to exclude `this._namespace`
                    // DOMException properties are read-only, so we can't just modify them inline, see https://developer.mozilla.org/en-US/docs/Web/API/DOMException
                    if (!this._hasQuotaErrorBeenSubmitted) {
                        // we'll only submit "quota exceeded" error to the monitoring systems once per user session -- there isn't really a need to submit all such errors.
                        this._submitError(new Error(`Quota exceeded on key "${key}"`));
                        this._hasQuotaErrorBeenSubmitted = true;
                    }
                    $a0a079aa648eb079$var$logger.error`Storage quota exceeded when for key ${key} and value ${value}; original error: ${e}`;
                } else this._submitError(e, `Error setting value from storage manager with key ${key} and value ${value}: ${e}`);
                return null;
            }
        };
        /**
     * Removes a Key from the Store
     */ this.removeItem = (key)=>{
            if (!this._storageManager) {
                $a0a079aa648eb079$var$logger.warn`Local/session storage not supported on browser`;
                return;
            }
            try {
                const cacheKey = (0, $505af0297173c4d6$export$902ba6ec74c93f9d)(key, `${this._namespace}.${key}`);
                if ((0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_browser_storage_controls')) this._storageManager.removeItem(`${key}`);
                else this._storageManager.removeItem(`${cacheKey}`);
                return;
            } catch (e) {
                this._submitError(e, `Error removing value from storage manager for key ${key}: ${e}`);
                return;
            }
        };
        this.initializeFromServer = (results)=>{
            if (!Array.isArray(results)) return;
            if (sessionStorage.getItem('confluence.disable-persisted-storage-for-tests')) return;
            try {
                if ((0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_browser_storage_controls')) results.forEach((val)=>{
                    const originalKey = val?.key?.replace(`${this._namespace}.`, '');
                    if (this._storageManager && originalKey) this._storageManager.setItem(originalKey, val.value);
                });
                else results.forEach((val)=>this._storageManager && this._storageManager.setItem(val.key, val.value));
            } catch (e) {
                if ($a0a079aa648eb079$export$4fc2001188ec893d(e)) this._submitError(new Error('Quota exceeded on intializing persisted values from server'));
                else this._submitError(e, `Error setting value from storage manager while initializing persisted values from server: ${e}`);
            }
        };
        this._submitError = (e, message)=>{
            if (message) $a0a079aa648eb079$var$logger.error`${message}`;
            (0, $d1c1e8e192b1a688$export$39a3b7739331403b)().submitError(e, {
                attribution: 'unknown'
            });
        };
        this._incrementLocalStorageMigrationEntries = ()=>{
            (0, $d1c1e8e192b1a688$export$39a3b7739331403b)().incrementCounter($a0a079aa648eb079$var$localStorageMigrationEntriesKey);
        };
        this._storageManager = storageManager;
        this._namespace = userId ? `${storagePrefix}/${prefix}.${userId}.${id}` : `${storagePrefix}/null`;
        this._userId = userId;
        this._isLicensedUser = isLicensed ?? false;
    }
}







var $b4b9136780ae841d$export$c32b36f46293e67b = /*#__PURE__*/ function(MicrosEnvironmentType) {
    MicrosEnvironmentType["local"] = "local";
    MicrosEnvironmentType["dev"] = "dev";
    MicrosEnvironmentType["staging"] = "staging";
    MicrosEnvironmentType["prod"] = "prod";
    return MicrosEnvironmentType;
}({});
const $b4b9136780ae841d$export$6dd1bbd39f571125 = ()=>false;
const $b4b9136780ae841d$export$23da1d24a38b0bde = ()=>globalThis.ssrContext.environmentType === "staging";
const $b4b9136780ae841d$export$64471597a28217e6 = ()=>$b4b9136780ae841d$export$6dd1bbd39f571125() || $b4b9136780ae841d$export$23da1d24a38b0bde() || globalThis.ssrContext.environmentType === "dev";
const $b4b9136780ae841d$export$4bd44a2aa29d3d6e = ()=>globalThis.ssrContext.environment;
const $b4b9136780ae841d$export$1038046b28a1d92e = ()=>globalThis.ssrContext.environmentType;
const $b4b9136780ae841d$export$94e128262c4fa6c3 = ()=>globalThis.ssrContext.entryScriptVersionId;


const $4ecd5830b37ff119$export$72dc662ac05b1fbb = `
  query LocalStorageQuery($stringKeys: [String]!) {
    localStorage {
      stringValues(keys: $stringKeys) {
        key
        value
      }
    }
  }
`;



async function $2123323c5a3599df$export$efc60d6604f5fc7a({ userId: userId, isLicensed: isLicensed }) {
    if (window['__REMOTE_LOCAL_STORAGE__']) return window['__REMOTE_LOCAL_STORAGE__'];
    const URI = (0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('cc-agg-migration-use-agg-endpoint') ? '/gateway/api/graphql/slow' : window['GLOBAL_APOLLO_CLIENT_URI'] || '/cgraphql';
    return window['__REMOTE_LOCAL_STORAGE__'] = (0, $47c7a260b3a5dfb3$export$5467c8c7fa0f4d06).run('ssr-app/prepare/preloadQuery/fetch:LocalStorageQuery', async ()=>{
        let result = null;
        try {
            if (isLicensed && userId) {
                const variables = {
                    stringKeys: (0, $505af0297173c4d6$export$7c5eda5500a5f08d)(userId)
                };
                const res = await (0, $b9f93b053c525d82$export$7fd82c6bb3f5e7d5)(`${URI}?q=LocalStorageQuery`, {
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                        'X-APOLLO-OPERATION-NAME': 'LocalStorageQuery',
                        'Content-Type': 'application/json',
                        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
                        ...Boolean(undefined) && Boolean(undefined) && !(0, $b4b9136780ae841d$export$6dd1bbd39f571125)() ? {
                            'x-ssr-asap-audience': 'cc-graphql'
                        } : {}
                    },
                    body: JSON.stringify({
                        operationName: 'LocalStorageQuery',
                        query: (0, $4ecd5830b37ff119$export$72dc662ac05b1fbb),
                        variables: variables
                    })
                });
                if (res.ok) {
                    const { data: data } = await res.json();
                    result = data?.localStorage?.stringValues;
                }
            }
        } catch (e) {}
        return window['__REMOTE_LOCAL_STORAGE__'] = result;
    });
}


// check if local and session storage are valid
const $8b7debc8685a2ab6$var$isStorageValid = (storage)=>{
    try {
        return typeof storage !== 'undefined' && 'setItem' in storage && // in IE8 typeof localStorage.setItem === 'object'
        !!storage.setItem;
    } catch (e) {
        return false;
    }
};
const $8b7debc8685a2ab6$var$getStorage = (type)=>{
    if (typeof window === 'object' && $8b7debc8685a2ab6$var$isStorageValid(window[type])) return window[type];
    return null;
};
let $8b7debc8685a2ab6$export$7691d7c35a352a10;
let $8b7debc8685a2ab6$export$fb051bd2501e65b3;
const $8b7debc8685a2ab6$export$68017d60ff81319c = async (initializationData)=>{
    let confluenceLocalStorage = null;
    let confluenceSessionStorage = null;
    if ((0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_browser_storage_controls')) {
        confluenceLocalStorage = (0, $e13ac002387b6964$export$c8cc3ffd3f2c1d2f);
        confluenceSessionStorage = (0, $e13ac002387b6964$export$edbae459bdf957a5);
    } else {
        confluenceLocalStorage = $8b7debc8685a2ab6$var$getStorage('localStorage');
        confluenceSessionStorage = $8b7debc8685a2ab6$var$getStorage('sessionStorage');
    }
    $8b7debc8685a2ab6$export$7691d7c35a352a10 = new (0, $a0a079aa648eb079$export$93525d6e221593cb)(confluenceLocalStorage, (0, $abd639c20d964dca$export$94c92810ef76851), (0, $abd639c20d964dca$export$cae0fbb99c422e2), (0, $abd639c20d964dca$export$1b311d1dfe8a9349), initializationData);
    $8b7debc8685a2ab6$export$fb051bd2501e65b3 = new (0, $a0a079aa648eb079$export$93525d6e221593cb)(confluenceSessionStorage, (0, $abd639c20d964dca$export$94c92810ef76851), (0, $abd639c20d964dca$export$cae0fbb99c422e2), (0, $abd639c20d964dca$export$16f5e866917d6fd1), initializationData);
    const result = await (0, $2123323c5a3599df$export$efc60d6604f5fc7a)(initializationData);
    if (result) $8b7debc8685a2ab6$export$7691d7c35a352a10.initializeFromServer(result);
};





var $9pfwj = parcelRequire("9pfwj");

var $gqzfn = parcelRequire("gqzfn");

var $gqzfn = parcelRequire("gqzfn");
var $3e920ee9fcaea77e$exports = {};
'use strict';

$3e920ee9fcaea77e$exports = (parcelRequire("9A5g8"));



var $gqzfn = parcelRequire("gqzfn");
const $75113849f21621b4$var$supports = {
    scheduling () {
        return typeof window !== 'undefined' && typeof MessageChannel === 'function';
    }
};
var $75113849f21621b4$export$2e2bcd8739ae039 = $75113849f21621b4$var$supports;



var $gqzfn = parcelRequire("gqzfn");
const $e595115efb4a0024$var$defaultMutator = (prevState, partialState)=>{
    // Merge the partial state and the previous state.
    return Object.assign({}, prevState, partialState);
};
const $e595115efb4a0024$var$defaults = {
    batchUpdates: 'useSyncExternalStore' in (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))),
    devtools: false,
    middlewares: new Set(),
    mutator: $e595115efb4a0024$var$defaultMutator
};
var $e595115efb4a0024$export$2e2bcd8739ae039 = $e595115efb4a0024$var$defaults;


const $f72f6918da3aa085$var$namedMutator = (storeState, actionName)=>function() {
        storeState.mutator.actionName = actionName;
        return storeState.mutator(...arguments);
    };
const $f72f6918da3aa085$var$warnings = new WeakMap();
const $f72f6918da3aa085$export$5f944353e69b9bf3 = (storeState, actionFn, actionKey, config, actions)=>{
    const callThunk = (instance, thunkFn, actionName)=>thunkFn({
            setState: (0, $e595115efb4a0024$export$2e2bcd8739ae039).devtools ? $f72f6918da3aa085$var$namedMutator(instance.storeState, actionName) : instance.storeState.mutator,
            getState: instance.storeState.getState,
            get actions () {
                if (!$f72f6918da3aa085$var$warnings.has(actionFn)) $f72f6918da3aa085$var$warnings.set(actionFn, console.warn(`react-sweet-state 'actions' property has been deprecated and will be removed in the next mayor. ` + `Please check action '${actionName}' of Store '${instance.storeState.key}' and use 'dispatch' instead`));
                return actions;
            },
            dispatch: (tFn)=>callThunk(instance, tFn, `${actionName}.dispatch`)
        }, config.props());
    return function() {
        return callThunk({
            storeState: storeState,
            actions: actions
        }, actionFn(...arguments), actionKey);
    };
};
const $f72f6918da3aa085$export$5ee1d46cd0883a22 = function bindActions(actions, storeState, config, boundActions) {
    if (boundActions === void 0) boundActions = null;
    return Object.keys(actions).reduce((acc, k)=>{
        acc[k] = $f72f6918da3aa085$export$5f944353e69b9bf3(storeState, actions[k], k, config, boundActions || acc);
        return acc;
    }, {});
};



// Mostly copied from fbjs/packages/fbjs/src/core/shallowEqual.js
// enhanced with keys cache as might get called multiple times with same args
const $573c0acb3e909987$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $573c0acb3e909987$var$CACHE = new WeakMap();
function $573c0acb3e909987$export$2e2bcd8739ae039(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    if (Array.isArray(objA) && Array.isArray(objB)) {
        // do array comparison
        if (objA.length !== objB.length) return false;
        for(let i = 0; i < objA.length; i++){
            if (objA[i] !== objB[i]) return false;
        }
        return true;
    } else {
        // Handle Date, RegExp, String, Number, ... and complex objects
        const strA = '' + objA;
        const strB = '' + objB;
        if (strA !== strB || strA[0] === '[' && strA !== '[object Object]') return false;
         // do object comparison
        let keysA;
        if ($573c0acb3e909987$var$CACHE.has(objA)) keysA = $573c0acb3e909987$var$CACHE.get(objA);
        else {
            keysA = Object.keys(objA);
            $573c0acb3e909987$var$CACHE.set(objA, keysA);
        }
        let keysB;
        if ($573c0acb3e909987$var$CACHE.has(objB)) keysB = $573c0acb3e909987$var$CACHE.get(objB);
        else {
            keysB = Object.keys(objB);
            $573c0acb3e909987$var$CACHE.set(objB, keysB);
        }
        if (keysA.length !== keysB.length) return false;
         // Test for A's keys different from B.
        for(let i = 0; i < keysA.length; i++){
            if (!$573c0acb3e909987$var$hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
        }
        return true;
    }
}


const $418b1fe470f8b30f$var$updateMiddleware = (storeState)=>(next)=>(arg)=>{
            let output;
            const state = storeState.getState();
            const nextState = next(state, arg, (out)=>{
                output = out;
            });
            if (!(0, $573c0acb3e909987$export$2e2bcd8739ae039)(nextState, state)) storeState.setState(nextState);
            return output;
        };
var $418b1fe470f8b30f$export$2e2bcd8739ae039 = $418b1fe470f8b30f$var$updateMiddleware;


const $02722b627ca5114b$var$applyMiddleware = (storeState, middlewares)=>Array.from(middlewares).concat((0, $418b1fe470f8b30f$export$2e2bcd8739ae039)).reduceRight((next, mw)=>mw(storeState)(next), (0, $e595115efb4a0024$export$2e2bcd8739ae039).mutator);
var $02722b627ca5114b$export$2e2bcd8739ae039 = $02722b627ca5114b$var$applyMiddleware;



const $8bcea4936b3b8f31$var$connectDevTools = (storeState, config)=>{
    const devTools = window.__REDUX_DEVTOOLS_EXTENSION__.connect(Object.assign({
        name: `Store ${storeState.key}`,
        serialize: true,
        trace: true
    }, config));
    devTools.init(storeState.getState());
    devTools.subscribe((message)=>{
        if (message.type === 'DISPATCH') switch(message.payload.type){
            case 'RESET':
                storeState.resetState();
                devTools.init(storeState.getState());
                return;
            case 'COMMIT':
                devTools.init(storeState.getState());
                return;
            case 'ROLLBACK':
                storeState.setState(JSON.parse(message.state));
                devTools.init(storeState.getState());
                return;
            case 'JUMP_TO_STATE':
            case 'JUMP_TO_ACTION':
                storeState.setState(JSON.parse(message.state));
                return;
        }
        else if (message.type === 'ACTION') {
            let action = JSON.parse(message.payload);
            storeState.setState(action.payload);
        }
    });
    return devTools;
};
const $8bcea4936b3b8f31$var$withDevtools = (createStoreState)=>function() {
        const storeState = createStoreState(...arguments);
        if ((0, $e595115efb4a0024$export$2e2bcd8739ae039).devtools && window && window.__REDUX_DEVTOOLS_EXTENSION__) {
            const origMutator = storeState.mutator;
            let devTools;
            const devtoolMutator = (arg)=>{
                const result = origMutator(arg);
                try {
                    if (!devTools) {
                        const config = typeof (0, $e595115efb4a0024$export$2e2bcd8739ae039).devtools === 'function' ? (0, $e595115efb4a0024$export$2e2bcd8739ae039).devtools(storeState) : {};
                        devTools = $8bcea4936b3b8f31$var$connectDevTools(storeState, config);
                    }
                    devTools.send({
                        type: storeState.mutator.actionName,
                        payload: arg
                    }, storeState.getState(), {}, storeState.key);
                } catch (err) {
                /* ignore devtools errors */ }
                return result;
            };
            storeState.mutator = devtoolMutator;
        }
        return storeState;
    };
var $8bcea4936b3b8f31$export$2e2bcd8739ae039 = $8bcea4936b3b8f31$var$withDevtools;




/* eslint-disable import/no-unresolved */ 

var $9phqb = parcelRequire("9phqb");


let $8047962571b826ee$var$isInsideBatchedSchedule = false;
function $8047962571b826ee$export$712ea50be43a7858(fn) {
    // if we are in node/tests or nested schedule
    if (!(0, $e595115efb4a0024$export$2e2bcd8739ae039).batchUpdates || !(0, $75113849f21621b4$export$2e2bcd8739ae039).scheduling() || $8047962571b826ee$var$isInsideBatchedSchedule) return (0, $562ef484027f8b93$exports.unstable_batchedUpdates)(fn);
    $8047962571b826ee$var$isInsideBatchedSchedule = true; // Use ImmediatePriority as it has -1ms timeout
    // https://github.com/facebook/react/blob/main/packages/scheduler/src/forks/Scheduler.js#L65
    return (0, $9phqb.unstable_scheduleCallback)((0, $9phqb.unstable_ImmediatePriority), function scheduleBatchedUpdates() {
        (0, $562ef484027f8b93$exports.unstable_batchedUpdates)(fn);
        $8047962571b826ee$var$isInsideBatchedSchedule = false;
    });
}



const $e7a2956519205703$var$QUEUE = [];
let $e7a2956519205703$var$scheduled;
function $e7a2956519205703$export$2e2bcd8739ae039(fn) {
    // if we are in node/tests or feature disabled, make updates sync batched
    if (!(0, $e595115efb4a0024$export$2e2bcd8739ae039).batchUpdates || !(0, $75113849f21621b4$export$2e2bcd8739ae039).scheduling()) return (0, $8047962571b826ee$export$712ea50be43a7858)(()=>fn()); // Add to queue if not already there
    // so we avoid multiple notifications to same store listeners
    if (!$e7a2956519205703$var$QUEUE.includes(fn)) $e7a2956519205703$var$QUEUE.push(fn); // if something already started schedule, skip
    if ($e7a2956519205703$var$scheduled) return;
    $e7a2956519205703$var$scheduled = (0, $8047962571b826ee$export$712ea50be43a7858)(()=>{
        let queueFn;
        while(queueFn = $e7a2956519205703$var$QUEUE.shift())queueFn();
        $e7a2956519205703$var$scheduled = null;
    });
}


function $895d121650654358$var$createStoreState(key, initialState) {
    let listeners = new Set();
    let currentState = initialState;
    const storeState = {
        key: key,
        getState () {
            return currentState;
        },
        setState (nextState) {
            currentState = nextState; // Instead of notifying all handlers immediately, we wait next tick
            // so multiple actions affecting the same store gets combined
            (0, $e7a2956519205703$export$2e2bcd8739ae039)(storeState.notify);
        },
        resetState () {
            storeState.setState(initialState);
        },
        notify () {
            for (const listener of listeners)listener(storeState.getState());
        },
        subscribe (listener) {
            listeners.add(listener);
            return function unsubscribe() {
                listeners.delete(listener);
            };
        },
        listeners () {
            return listeners;
        }
    };
    storeState.mutator = (0, $02722b627ca5114b$export$2e2bcd8739ae039)(storeState, (0, $e595115efb4a0024$export$2e2bcd8739ae039).middlewares);
    return storeState;
}
var $895d121650654358$export$2e2bcd8739ae039 = (0, $8bcea4936b3b8f31$export$2e2bcd8739ae039)($895d121650654358$var$createStoreState);


const $d150e058e3987100$export$e4d628ba0054221b = '__global__';
class $d150e058e3987100$export$acb47f32da33501e {
    constructor(defaultScope){
        var _this = this;
        if (defaultScope === void 0) defaultScope = $d150e058e3987100$export$e4d628ba0054221b;
        this.stores = new Map();
        this.initStore = (key, Store, config)=>{
            const { initialState: initialState, actions: actions } = Store;
            if (Store.containedBy && !config.contained(Store)) {
                const err = new Error(`Store ${Store.key} should be contained by a container but it is used globally. ` + `While it might still work, it will likely cause unexpected behaviours.`);
                if ((0, $75113849f21621b4$export$2e2bcd8739ae039).scheduling()) Promise.reject(err);
                else throw err;
            }
            const storeState = (0, $895d121650654358$export$2e2bcd8739ae039)(key, initialState);
            let boundActions;
            const store = {
                storeState: storeState,
                // these are used only when container-less, so we generate them on-demand
                get actions () {
                    if (!boundActions) boundActions = (0, $f72f6918da3aa085$export$5ee1d46cd0883a22)(actions, storeState, config);
                    return boundActions;
                }
            };
            this.stores.set(key, store);
            return store;
        };
        this.hasStore = function(Store, scopeId) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            const key = _this.generateKey(Store, scopeId);
            return _this.stores.has(key);
        };
        this.getStore = function(Store, scopeId, config) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            if (config === void 0) config = {
                props: ()=>({}),
                contained: ()=>false
            };
            const key = _this.generateKey(Store, scopeId);
            return _this.stores.get(key) || config && _this.initStore(key, Store, config);
        };
        this.deleteStore = function(Store, scopeId) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            const key = _this.generateKey(Store, scopeId);
            _this.stores.delete(key);
        };
        this.generateKey = (Store, scopeId)=>`${Store.key}@${scopeId}`;
        this.defaultScope = defaultScope;
    }
}
const $d150e058e3987100$export$9d726ae4880b1060 = new $d150e058e3987100$export$acb47f32da33501e();


const $8498e50fdf3dc860$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createContext({
    globalRegistry: (0, $d150e058e3987100$export$9d726ae4880b1060),
    retrieveStore: (Store)=>(0, $d150e058e3987100$export$9d726ae4880b1060).getStore(Store)
}, ()=>0);



function $0252f3f1021adaa6$var$exactEqual(objA, objB) {
    return objA === objB;
}
function $0252f3f1021adaa6$var$areArgumentsEqual(propsMode, prev, next) {
    if (prev === null || next === null || prev.length !== next.length) return false; // If propsMode and 2 arguments, means it is an input selector
    // and we check for shallow equality on 2nd one to optimise props
    if (propsMode && prev.length === 2) return prev[0] === next[0] && (0, $573c0acb3e909987$export$2e2bcd8739ae039)(prev[1], next[1]);
    for(let i = 0; i < prev.length; i++){
        if (!$0252f3f1021adaa6$var$exactEqual(prev[i], next[i])) return false;
    }
    return true;
}
function $0252f3f1021adaa6$export$2e2bcd8739ae039(resultFn, propsMode) {
    if (propsMode === void 0) propsMode = false;
    let lastArgs = [];
    let lastResult;
    let calledOnce = false;
    const result = function result() {
        if (calledOnce && $0252f3f1021adaa6$var$areArgumentsEqual(propsMode, arguments, lastArgs)) return lastResult;
        const nextResult = resultFn.apply(this, arguments);
        if (!propsMode && (0, $573c0acb3e909987$export$2e2bcd8739ae039)(nextResult, lastResult)) return lastResult;
        lastResult = nextResult;
        calledOnce = true;
        lastArgs = arguments;
        return lastResult;
    };
    return result;
}


function $267a3ee87adee9d1$export$595d22ed68ca2841() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    const resultFunc = funcs.pop();
    const dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    const memoizedResultFunc = (0, $0252f3f1021adaa6$export$2e2bcd8739ae039)(function() {
        return resultFunc.apply(null, arguments);
    }); // this memoisation is optimised for 2 arguments (state, props)
    const selector = (0, $0252f3f1021adaa6$export$2e2bcd8739ae039)(function() {
        // calculate all dependencies results
        const params = [];
        for(let i = 0; i < dependencies.length; i++)params.push(dependencies[i].apply(null, arguments));
         // then call the final func with all them as arguments
        return memoizedResultFunc.apply(null, params);
    }, true); // expose so we can create per scope selectors
    // API compatible with reselect@^4
    selector.resultFunc = resultFunc;
    selector.dependencies = dependencies;
    return selector;
}
function $267a3ee87adee9d1$export$d2c200d79fc82f8c(selector) {
    const isReselector = typeof selector.resultFunc === 'function' && Array.isArray(selector.dependencies);
    const dependencies = isReselector ? selector.dependencies : [
        (s)=>s,
        (_, p)=>p
    ];
    const resultFunc = isReselector ? selector.resultFunc : selector;
    return $267a3ee87adee9d1$export$595d22ed68ca2841(dependencies, resultFunc);
}
const $267a3ee87adee9d1$var$cache = new WeakMap();
function $267a3ee87adee9d1$export$38d24f3c60944dd5(selector, storeState, hasProps) {
    if (!hasProps) {
        if (!$267a3ee87adee9d1$var$cache.has(storeState)) $267a3ee87adee9d1$var$cache.set(storeState, new WeakMap());
        const scopeSelectors = $267a3ee87adee9d1$var$cache.get(storeState);
        if (!scopeSelectors.has(selector)) scopeSelectors.set(selector, $267a3ee87adee9d1$export$d2c200d79fc82f8c(selector));
        return scopeSelectors.get(selector);
    }
    return $267a3ee87adee9d1$export$d2c200d79fc82f8c(selector);
}


const $bb481050db28f5d2$var$EMPTY_SELECTOR = ()=>undefined;
const $bb481050db28f5d2$var$DEFAULT_SELECTOR = (state)=>state;
function $bb481050db28f5d2$export$e7f733c8fc2b8a24(Store, _temp) {
    let { selector: selector } = _temp === void 0 ? {} : _temp;
    return function useSweetState(propsArg) {
        const { retrieveStore: retrieveStore } = (0, $gqzfn.useContext)((0, $8498e50fdf3dc860$export$841858b892ce1f4c));
        const { storeState: storeState, actions: actions } = retrieveStore(Store);
        const hasPropsArg = propsArg !== undefined;
        const propsArgRef = (0, $gqzfn.useRef)(propsArg);
        propsArgRef.current = propsArg;
        const stateSelector = (0, $gqzfn.useMemo)(()=>selector ? (0, $267a3ee87adee9d1$export$38d24f3c60944dd5)(selector, storeState, hasPropsArg) : selector === null ? $bb481050db28f5d2$var$EMPTY_SELECTOR : $bb481050db28f5d2$var$DEFAULT_SELECTOR, [
            hasPropsArg,
            storeState
        ]);
        const forceUpdate = (0, $gqzfn.useState)({})[1];
        const getSnapshot = (0, $gqzfn.useCallback)(()=>{
            // parent scope has changed and notify was explicitly triggered by the container
            // we need to force the hook to re-render to listen new storeState
            if (retrieveStore(Store).storeState !== storeState) forceUpdate({});
            const state = storeState.getState();
            return stateSelector(state, propsArgRef.current);
        }, [
            retrieveStore,
            storeState,
            stateSelector,
            forceUpdate
        ]);
        const currentState = (0, $3e920ee9fcaea77e$exports.useSyncExternalStore)(storeState.subscribe, getSnapshot, getSnapshot);
        return [
            currentState,
            actions
        ];
    };
}
function $bb481050db28f5d2$export$7c643e1d6648e418(Store) {
    const useHook = $bb481050db28f5d2$export$e7f733c8fc2b8a24(Store, {
        selector: null
    });
    return function useSweetStateActions() {
        return useHook()[1];
    };
}
function $bb481050db28f5d2$export$6e4e5611de132e85(Store, _temp2) {
    let { selector: selector } = _temp2 === void 0 ? {} : _temp2;
    const useHook = $bb481050db28f5d2$export$e7f733c8fc2b8a24(Store, {
        selector: selector
    });
    return function useSweetStateState(propsArg) {
        return useHook(propsArg)[0];
    };
}


var $gqzfn = parcelRequire("gqzfn");
var $37198ed473bd55f3$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $37198ed473bd55f3$var$ReactIs, $37198ed473bd55f3$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$37198ed473bd55f3$exports = (parcelRequire("eWvdU"))();





const $55be7fc7d57ae297$var$_excluded = [
    "children"
], $55be7fc7d57ae297$var$_excluded2 = [
    "scope",
    "isGlobal"
];
function $55be7fc7d57ae297$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $55be7fc7d57ae297$var$noop = ()=>()=>{};
function $55be7fc7d57ae297$export$26ae5ca175b4ec5a(StoreOrOptions, _temp) {
    if (StoreOrOptions === void 0) StoreOrOptions = {};
    let { onInit: _onInit = $55be7fc7d57ae297$var$noop, onUpdate: onUpdate = $55be7fc7d57ae297$var$noop, onCleanup: onCleanup = $55be7fc7d57ae297$var$noop, displayName: displayName = '' } = _temp === void 0 ? {} : _temp;
    if ('key' in StoreOrOptions) {
        const Store = StoreOrOptions;
        const dn = displayName || `Container(${Store.key.split('__')[0]})`;
        return $55be7fc7d57ae297$var$createFunctionContainer({
            displayName: dn,
            // compat fields
            override: {
                Store: Store,
                handlers: Object.assign({}, _onInit !== $55be7fc7d57ae297$var$noop && {
                    onInit: ()=>_onInit()
                }, onCleanup !== $55be7fc7d57ae297$var$noop && {
                    onDestroy: ()=>onCleanup()
                }, onUpdate !== $55be7fc7d57ae297$var$noop && {
                    onContainerUpdate: ()=>onUpdate()
                })
            }
        });
    }
    return $55be7fc7d57ae297$var$createFunctionContainer(StoreOrOptions);
}
function $55be7fc7d57ae297$var$useRegistry(scope, isGlobal, _ref) {
    let { globalRegistry: globalRegistry } = _ref;
    return (0, $gqzfn.useMemo)(()=>{
        const isLocal = !scope && !isGlobal;
        return isLocal ? new (0, $d150e058e3987100$export$acb47f32da33501e)('__local__') : globalRegistry;
    }, [
        scope,
        isGlobal,
        globalRegistry
    ]);
}
function $55be7fc7d57ae297$var$useContainedStore(scope, registry, propsRef, check, override) {
    // Store contained scopes in a map, but throwing it away on scope change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const containedStores = (0, $gqzfn.useMemo)(()=>new Map(), [
        scope
    ]);
    const getContainedStore = (0, $gqzfn.useCallback)((Store)=>{
        let containedStore = containedStores.get(Store); // first time it gets called we add store to contained map bound
        // so we can provide props to actions (only triggered by children)
        if (!containedStore) {
            const isExisting = registry.hasStore(Store, scope);
            const config = {
                props: ()=>propsRef.current.sub,
                contained: check
            };
            const { storeState: storeState } = registry.getStore(Store, scope, config);
            const actions = (0, $f72f6918da3aa085$export$5ee1d46cd0883a22)(Store.actions, storeState, config);
            const handlers = (0, $f72f6918da3aa085$export$5ee1d46cd0883a22)(Object.assign({}, Store.handlers, override == null ? void 0 : override.handlers), storeState, config, actions);
            containedStore = {
                storeState: storeState,
                actions: actions,
                handlers: handlers,
                unsubscribe: undefined
            };
            containedStores.set(Store, containedStore); // Signal store is contained and ready now, so by the time
            // consumers subscribe we already have updated the store (if needed).
            // Also if override maintain legacy behaviour, triggered on every mount
            if (!isExisting || override) handlers.onInit == null || handlers.onInit();
        }
        return containedStore;
    }, [
        containedStores,
        scope,
        registry,
        propsRef,
        check,
        override
    ]);
    return [
        containedStores,
        getContainedStore
    ];
}
function $55be7fc7d57ae297$var$useApi(check, getContainedStore, _ref2) {
    let { globalRegistry: globalRegistry, retrieveStore: retrieveStore } = _ref2;
    const retrieveRef = (0, $gqzfn.useRef)();
    retrieveRef.current = (Store)=>check(Store) ? getContainedStore(Store) : retrieveStore(Store); // This api is "frozen", as changing it will trigger re-render across all consumers
    // so we link retrieveStore dynamically and manually call notify() on scope change
    return (0, $gqzfn.useMemo)(()=>({
            globalRegistry: globalRegistry,
            retrieveStore: (s)=>retrieveRef.current(s)
        }), [
        globalRegistry
    ]);
}
function $55be7fc7d57ae297$var$createFunctionContainer(_temp2) {
    let { displayName: displayName, override: override } = _temp2 === void 0 ? {} : _temp2;
    const check = (store)=>override ? store === override.Store : store.containedBy === FunctionContainer;
    function FunctionContainer(props) {
        const { children: children } = props, restProps = $55be7fc7d57ae297$var$_objectWithoutPropertiesLoose(props, $55be7fc7d57ae297$var$_excluded);
        const { scope: scope, isGlobal: isGlobal } = restProps, subProps = $55be7fc7d57ae297$var$_objectWithoutPropertiesLoose(restProps, $55be7fc7d57ae297$var$_excluded2);
        const ctx = (0, $gqzfn.useContext)((0, $8498e50fdf3dc860$export$841858b892ce1f4c));
        const registry = $55be7fc7d57ae297$var$useRegistry(scope, isGlobal, ctx); // Store props in a ref to avoid re-binding actions when they change and re-rendering all
        // consumers unnecessarily. The update is handled by an effect on the component instead
        const propsRef = (0, $gqzfn.useRef)({
            prev: null,
            next: restProps,
            sub: subProps
        });
        propsRef.current = {
            prev: propsRef.current.next,
            next: restProps,
            sub: subProps // TODO remove on next major
        };
        const [containedStores, getContainedStore] = $55be7fc7d57ae297$var$useContainedStore(scope, registry, propsRef, check, override); // Use a stable object as is passed as value to context Provider
        const api = $55be7fc7d57ae297$var$useApi(check, getContainedStore, ctx); // This listens for custom props change, and so we trigger container update actions
        // before the re-render gets to consumers (hence why side effect on render).
        // We do not use React hooks because num of restProps might change and react will throws
        if (!(0, $573c0acb3e909987$export$2e2bcd8739ae039)(propsRef.current.next, propsRef.current.prev)) containedStores.forEach((_ref3)=>{
            let { handlers: handlers } = _ref3;
            handlers.onContainerUpdate == null || handlers.onContainerUpdate(propsRef.current.next, propsRef.current.prev);
        });
         // Every time we add/remove a contained store, we ensure we are subscribed to the updates
        // as an effect to properly handle strict mode
        (0, $gqzfn.useEffect)(()=>{
            containedStores.forEach((containedStore)=>{
                if (!containedStore.unsubscribe) {
                    const unsub = containedStore.storeState.subscribe(()=>containedStore.handlers.onUpdate == null ? void 0 : containedStore.handlers.onUpdate());
                    containedStore.unsubscribe = ()=>{
                        unsub();
                        containedStore.unsubscribe = undefined;
                    };
                }
            });
        }, [
            containedStores,
            containedStores.size
        ]); // We support renderding "bootstrap" containers without children with override API
        // so in this case we call getCS to initialize the store globally asap
        if (override && !containedStores.size && (scope || isGlobal)) getContainedStore(override.Store);
         // This listens for scope change or component unmount, to notify all consumers
        // so all work is done on cleanup
        (0, $gqzfn.useEffect)(()=>{
            return ()=>{
                containedStores.forEach((_ref4, Store)=>{
                    let { storeState: storeState, handlers: handlers, unsubscribe: unsubscribe } = _ref4;
                    // Detatch container from subscription
                    unsubscribe == null || unsubscribe(); // Trigger a forced update on all subscribers as we opted out from context
                    // Some might have already re-rendered naturally, but we "force update" all anyway.
                    // This is sub-optimal as if there are other containers with the same
                    // old scope id we will re-render those too, but still better than context
                    storeState.notify(); // Given unsubscription is handled by useSyncExternalStore, we have no control on when
                    // React decides to do it. So we schedule on next tick to run last
                    Promise.resolve().then(()=>{
                        var _registry$getStore;
                        if (!storeState.listeners().size && // ensure registry has not already created a new store with same scope
                        storeState === ((_registry$getStore = registry.getStore(Store, scope, null)) == null ? void 0 : _registry$getStore.storeState)) {
                            handlers.onDestroy == null || handlers.onDestroy(); // We only delete scoped stores, as global shall persist and local are auto-deleted
                            if (!isGlobal) registry.deleteStore(Store, scope);
                        }
                    });
                }); // no need to reset containedStores as the map is already bound to scope
            };
        }, [
            registry,
            scope,
            isGlobal,
            containedStores
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement((0, $8498e50fdf3dc860$export$841858b892ce1f4c).Provider, {
            value: api
        }, children);
    }
    FunctionContainer.displayName = displayName || `Container`;
    FunctionContainer.propTypes = {
        children: (0, (/*@__PURE__*/$parcel$interopDefault($37198ed473bd55f3$exports))).node,
        scope: (0, (/*@__PURE__*/$parcel$interopDefault($37198ed473bd55f3$exports))).string,
        isGlobal: (0, (/*@__PURE__*/$parcel$interopDefault($37198ed473bd55f3$exports))).bool
    };
    return FunctionContainer;
}

/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $7f7f066061a7db1c$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}


function $7ece04f888d5f8ff$var$createKey(initialState, actions, name) {
    const src = !name ? Object.keys(actions).reduce((acc, k)=>acc + actions[k].toString(), '') : '';
    return [
        name,
        (0, $7f7f066061a7db1c$export$2e2bcd8739ae039)(src + JSON.stringify(initialState))
    ].filter(Boolean).join('__');
}
function $7ece04f888d5f8ff$export$f51a9068ac82ea43(_ref) {
    let { name: name = '', initialState: initialState, actions: actions, containedBy: containedBy, handlers: handlers = {} } = _ref;
    let key;
    return {
        get key () {
            // lazy evaluate key on first access
            return key || (key = $7ece04f888d5f8ff$var$createKey(initialState, actions, name));
        },
        initialState: initialState,
        actions: actions,
        containedBy: containedBy,
        handlers: handlers
    };
}


const $ac24f32175344833$var$_excluded = [
    "children"
];
function $ac24f32175344833$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $ac24f32175344833$var$hasAdditionalProps(props) {
    for(let i in props)return true;
    return false;
}
function $ac24f32175344833$export$48f338a7e080595c(Store, _temp) {
    let { selector: selector, displayName: displayName = '' } = _temp === void 0 ? {} : _temp;
    const useStore = (0, $bb481050db28f5d2$export$e7f733c8fc2b8a24)(Store, {
        selector: selector
    });
    const Subscriber = function Subscriber(_ref) {
        let { children: children } = _ref, rest = $ac24f32175344833$var$_objectWithoutPropertiesLoose(_ref, $ac24f32175344833$var$_excluded);
        const api = useStore($ac24f32175344833$var$hasAdditionalProps(rest) ? rest : undefined);
        return children(...api);
    };
    Subscriber.displayName = displayName || `Subscriber(${Store.key.split('__')[0]})`;
    return Subscriber;
}








// The UFORouteName object is a global singleton
const $141d3ae8f27fd99b$var$UFORouteName = {
    current: null
};
var $141d3ae8f27fd99b$export$2e2bcd8739ae039 = $141d3ae8f27fd99b$var$UFORouteName;


const $adfdebcbce973ecf$var$AWAITING_PAGELOAD_NAME = 'awaiting_pageload_name';
function $adfdebcbce973ecf$var$traceUFOPageLoad(ufoName, routeName = ufoName) {
    const activeInteraction = (0, $d9b1f70c159fe18d$export$2b3954d2e8509985)();
    if (activeInteraction && !ufoName) return;
    (0, $141d3ae8f27fd99b$export$2e2bcd8739ae039).current = routeName || null;
    const rate = ufoName ? (0, $0d141f9c9c05f1cf$export$9466a8f085fa7d4e)(ufoName, 'page_load') : 1;
    const enabledBySamplingRate = (0, $4659fee6fbb6d2af$export$2e2bcd8739ae039)(rate);
    if (enabledBySamplingRate && !activeInteraction) {
        const newId = (0, $466a4b1793cac1d8$exports.v4)();
        (0, $9a27762368c0f25d$export$3109542b68df9ba1).current = newId;
        (0, $d9b1f70c159fe18d$export$1a1ed1e1fdb2006b)(newId, ufoName || '', 'page_load', 0, rate, null, routeName, (0, $aae51952f0016112$export$b6ac780db3a3cc77)());
        if (!ufoName) // if no name is provided we add a hold to the interaction, it is removed if the name is provided while the interaction is holding
        (0, $d9b1f70c159fe18d$export$10582acd678c213)(newId, [], $adfdebcbce973ecf$var$AWAITING_PAGELOAD_NAME, $adfdebcbce973ecf$var$AWAITING_PAGELOAD_NAME, true);
    } else if (!enabledBySamplingRate && activeInteraction && activeInteraction.type === 'page_load') // if there is an active interaction it will be aborted without initialising a new one because the coinflip returned false
    (0, $d9b1f70c159fe18d$export$5def58af4fd46132)(activeInteraction.id, 'excluded_by_sampling');
    else if (ufoName && activeInteraction && !activeInteraction.ufoName && activeInteraction.type === 'page_load') {
        (0, $d9b1f70c159fe18d$export$f6f1cf5bedf83c71)(ufoName, routeName);
        (0, $d9b1f70c159fe18d$export$4983dfbbb996f7ae)(activeInteraction.id, $adfdebcbce973ecf$var$AWAITING_PAGELOAD_NAME);
    }
}
var $adfdebcbce973ecf$export$2e2bcd8739ae039 = $adfdebcbce973ecf$var$traceUFOPageLoad;
function $adfdebcbce973ecf$export$d0f99433cd4f4028(ufoName, routeName = ufoName) {
    const interaction = (0, $d9b1f70c159fe18d$export$2b3954d2e8509985)();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    if (ufoName) {
        const rate = (0, $0d141f9c9c05f1cf$export$9466a8f085fa7d4e)(ufoName, 'page_load');
        (0, $d9b1f70c159fe18d$export$f6f1cf5bedf83c71)(ufoName, routeName);
        if ((0, $4659fee6fbb6d2af$export$2e2bcd8739ae039)(rate)) (0, $141d3ae8f27fd99b$export$2e2bcd8739ae039).current = ufoName;
        else (0, $d9b1f70c159fe18d$export$5def58af4fd46132)(interaction.id, 'excluded_by_sampling');
    }
    (0, $d9b1f70c159fe18d$export$4983dfbbb996f7ae)(interaction.id, $adfdebcbce973ecf$var$AWAITING_PAGELOAD_NAME);
}


const $a55430c99df8268f$var$nullNoop = ()=>null;
const $a55430c99df8268f$var$objNoop = ()=>({});
const $a55430c99df8268f$var$stringNoop = ()=>'';
const $a55430c99df8268f$var$voidNoop = ()=>{};
const $a55430c99df8268f$var$RouteStore = (0, $7ece04f888d5f8ff$export$f51a9068ac82ea43)({
    initialState: {
        getHref: $a55430c99df8268f$var$stringNoop,
        history: null,
        location: null,
        match: null,
        transitionId: null,
        toUrl: $a55430c99df8268f$var$stringNoop,
        matchRoute: $a55430c99df8268f$var$nullNoop,
        matchSupportedRoute: $a55430c99df8268f$var$nullNoop,
        getQueryParams: $a55430c99df8268f$var$objNoop,
        setQueryParams: $a55430c99df8268f$var$voidNoop,
        getHash: $a55430c99df8268f$var$stringNoop,
        setHash: $a55430c99df8268f$var$voidNoop,
        replace: $a55430c99df8268f$var$voidNoop,
        routes: [],
        push: $a55430c99df8268f$var$voidNoop,
        open: $a55430c99df8268f$var$nullNoop,
        onPageReload: $a55430c99df8268f$var$voidNoop,
        preloadRoute: $a55430c99df8268f$var$voidNoop
    },
    actions: {
        push (...args) {
            return ({ getState: getState })=>getState().push(...args);
        },
        replace (...args) {
            return ({ getState: getState })=>getState().replace(...args);
        },
        setQueryParams: (query, replace)=>({ getState: getState })=>getState().setQueryParams(query, replace),
        setHash: (hash)=>({ getState: getState })=>getState().setHash(hash),
        getLatestRouteData: ()=>({ getState: getState })=>{
                const match = getState().match;
                return {
                    routeName: match?.name,
                    routeParams: match?.params ?? {},
                    hash: getState().location?.hash?.substring(1) ?? '',
                    href: getState().getHref(),
                    queryParams: (0, $9pfwj.parse)(getState().location?.search ?? '', true)?.query,
                    toUrl: match?.toUrl?.bind(match) ?? function() {
                        return '';
                    }
                };
            },
        overrideUFORouteName: (newName)=>({ getState: getState })=>{
                (0, $adfdebcbce973ecf$export$d0f99433cd4f4028)(newName, getState().match?.name);
            },
        preloadRoute: (matchOrUrl, options)=>({ getState: getState })=>getState().preloadRoute(matchOrUrl, options)
    },
    name: 'RouteState'
});
const $a55430c99df8268f$export$52c04f66b1983f2a = (0, $55be7fc7d57ae297$export$26ae5ca175b4ec5a)($a55430c99df8268f$var$RouteStore, {
    onInit: ()=>({ setState: setState }, routeState)=>{
            setState(routeState);
        },
    onUpdate: ()=>({ setState: setState }, routeState)=>{
            setState(routeState);
        }
});
const $a55430c99df8268f$export$d4f74eb8532c85b4 = (0, $ac24f32175344833$export$48f338a7e080595c)($a55430c99df8268f$var$RouteStore);
/**
 * `useAllRouteActions` exposes all RouteState actions for internal use.
 * This is used to limit which route actions are publicly exposed.
 */ const $a55430c99df8268f$var$useAllRouteActions = (0, $bb481050db28f5d2$export$7c643e1d6648e418)($a55430c99df8268f$var$RouteStore);
const $a55430c99df8268f$export$2467ee40aa778f80 = ()=>{
    const { push: push, replace: replace, setQueryParams: setQueryParams, setHash: setHash, overrideUFORouteName: overrideUFORouteName, preloadRoute: preloadRoute } = $a55430c99df8268f$var$useAllRouteActions();
    return {
        push: /** See {@link RouteActionsType.push} for documentation */ push,
        replace: /** See {@link RouteActionsType.replace} for documentation */ replace,
        setQueryParams: /** See {@link RouteActionsType.setQueryParams} for documentation */ setQueryParams,
        setHash: /** See {@link RouteActionsType.setHash} for documentation */ setHash,
        overrideUFORouteName: /** See {@link RouteActionsType.overrideUFORouteName} for documentation */ overrideUFORouteName,
        preloadRoute: /** See {@link RouteActionsType.preloadRoute} for documentation */ preloadRoute
    };
};
const $a55430c99df8268f$export$a434162a7524cfb3 = (routeParam)=>(0, $bb481050db28f5d2$export$6e4e5611de132e85)($a55430c99df8268f$var$RouteStore, {
        selector: (state)=>state?.match?.params?.[routeParam]
    });
const $a55430c99df8268f$export$a3421b85303fa9de = (queryParam)=>$a55430c99df8268f$export$a7bf969075a175d2(queryParam, (parseResult)=>$a55430c99df8268f$var$singleQueryParamParser(parseResult));
const $a55430c99df8268f$export$2c2c4e775b5e6393 = (queryParam)=>$a55430c99df8268f$export$a7bf969075a175d2(queryParam, (parseResult)=>{
        if (parseResult === '') return [];
        else if (typeof parseResult === 'string') return [
            parseResult
        ];
        return parseResult;
    });
const $a55430c99df8268f$export$a7bf969075a175d2 = (queryParam, customParser)=>(0, $bb481050db28f5d2$export$6e4e5611de132e85)($a55430c99df8268f$var$RouteStore, {
        selector: (state)=>{
            const parseResult = (0, $9pfwj.parse)(state.location?.search ?? '', true)?.query?.[queryParam];
            return customParser(parseResult);
        }
    });
const $a55430c99df8268f$export$b1482fdc3ffb1b4a = (0, $bb481050db28f5d2$export$6e4e5611de132e85)($a55430c99df8268f$var$RouteStore, {
    selector: (state)=>{
        const hash = state.location?.hash;
        return hash ? hash.substring(1) : '';
    }
});
const $a55430c99df8268f$export$244d8f2aa1ab504f = (0, $bb481050db28f5d2$export$6e4e5611de132e85)($a55430c99df8268f$var$RouteStore, {
    selector: (state, { selector: selector })=>{
        return selector(state.match?.url);
    }
});
const $a55430c99df8268f$export$30aadaab39fae199 = (0, $bb481050db28f5d2$export$6e4e5611de132e85)($a55430c99df8268f$var$RouteStore, {
    selector: (state, { selector: selector })=>{
        return selector(state.match?.name);
    }
});
function $a55430c99df8268f$var$singleQueryParamParser(parseResult) {
    return Array.isArray(parseResult) ? parseResult?.[0] : parseResult;
}
function $a55430c99df8268f$export$85e000103cdf6a77(route) {
    return $a55430c99df8268f$export$30aadaab39fae199({
        selector: (matchName)=>matchName === route.name
    });
}
const $a55430c99df8268f$export$c9f0d094e50e1bbc = ()=>{
    const { getLatestRouteData: getLatestRouteData } = $a55430c99df8268f$var$useAllRouteActions();
    return (0, $gqzfn.useMemo)(()=>({
            get current () {
                return getLatestRouteData();
            }
        }), [
        getLatestRouteData
    ]);
};
const $a55430c99df8268f$export$7926129229271134 = (0, $bb481050db28f5d2$export$6e4e5611de132e85)($a55430c99df8268f$var$RouteStore, {
    selector: (state)=>state.transitionId ?? 0
});
const $a55430c99df8268f$export$632429935326e9d2 = (0, $bb481050db28f5d2$export$6e4e5611de132e85)($a55430c99df8268f$var$RouteStore, {
    selector: (state)=>!!state.transitionId
});
const $a55430c99df8268f$export$3420e1dc2c4a518c = (0, $bb481050db28f5d2$export$6e4e5611de132e85)($a55430c99df8268f$var$RouteStore, {
    selector: (state)=>state.history
});
const $a55430c99df8268f$export$d2ec911fa7f74821 = (0, $bb481050db28f5d2$export$6e4e5611de132e85)($a55430c99df8268f$var$RouteStore, {
    selector: (state)=>state.matchRoute
});
const $a55430c99df8268f$export$ce9ea1d788472f7b = (0, $bb481050db28f5d2$export$6e4e5611de132e85)($a55430c99df8268f$var$RouteStore, {
    selector: (state, { selector: selector })=>{
        return selector(state.location?.pathname);
    }
});





var $gqzfn = parcelRequire("gqzfn");

var $gqzfn = parcelRequire("gqzfn");
const $b83cd251b8885388$export$47bf0d5265bb1324 = (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createContext(// The app should not be making use of `SessionDataContext` until it's loaded.
// It *should* be safe to assert the presence of SessionData by this point.
undefined);
$b83cd251b8885388$export$47bf0d5265bb1324.displayName = 'SessionDataContext';


const $b9304229d48cfce4$export$3571dffcff931902 = ()=>(0, $gqzfn.useContext)((0, $b83cd251b8885388$export$47bf0d5265bb1324));


/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $5bd4bcd7bfa59eea$export$9d38595f26d62a61 = /*#__PURE__*/ function(AccessStatus) {
    AccessStatus["ANONYMOUS_ACCESS"] = "ANONYMOUS_ACCESS";
    AccessStatus["EXTERNAL_COLLABORATOR_ACCESS"] = "EXTERNAL_COLLABORATOR_ACCESS";
    AccessStatus["EXTERNAL_SHARE_ACCESS"] = "EXTERNAL_SHARE_ACCESS";
    AccessStatus["LICENSED_ADMIN_ACCESS"] = "LICENSED_ADMIN_ACCESS";
    AccessStatus["LICENSED_USE_ACCESS"] = "LICENSED_USE_ACCESS";
    AccessStatus["NOT_PERMITTED"] = "NOT_PERMITTED";
    AccessStatus["UNLICENSED_AUTHENTICATED_ACCESS"] = "UNLICENSED_AUTHENTICATED_ACCESS";
    return AccessStatus;
}({});
var $5bd4bcd7bfa59eea$export$68577d543b14ae02 = /*#__PURE__*/ function(ConfluenceEdition) {
    ConfluenceEdition["FREE"] = "FREE";
    ConfluenceEdition["PREMIUM"] = "PREMIUM";
    ConfluenceEdition["STANDARD"] = "STANDARD";
    return ConfluenceEdition;
}({});
var $5bd4bcd7bfa59eea$export$7dc6752a22ab011a = /*#__PURE__*/ function(Environment) {
    Environment["DEVELOPMENT"] = "DEVELOPMENT";
    Environment["PRODUCTION"] = "PRODUCTION";
    Environment["STAGING"] = "STAGING";
    return Environment;
}({});


const $80551c4b709c6d15$export$cad4fa6c249bffe = ()=>{
    if ((0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_nav4_ga_phase_2')) //if phase 2 is enabled ignore all opt out
    return true;
    // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    if ((0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_nav_4')) //fire the query if nav4 is enabled
    return false;
    if ((0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_nav4_ga_phase_1')) //if nav4 is disabled, but phase 1 is enabled, check the opt status
    return false; //should still skip if admin opt in is enabled
    return true;
};
const $80551c4b709c6d15$var$hasAccess = (accessStatus)=>![
        (0, $5bd4bcd7bfa59eea$export$9d38595f26d62a61).ANONYMOUS_ACCESS,
        (0, $5bd4bcd7bfa59eea$export$9d38595f26d62a61).UNLICENSED_AUTHENTICATED_ACCESS,
        null
    ].includes(accessStatus);
const $80551c4b709c6d15$export$d7e12273c5b6a967 = ()=>{
    const { accessStatus: accessStatus } = (0, $b9304229d48cfce4$export$3571dffcff931902)();
    // Should skip for anonymous and unlicensed users as userPreferences will return error in those cases
    return {
        shouldSkipOptOutQuery: !$80551c4b709c6d15$var$hasAccess(accessStatus) || $80551c4b709c6d15$export$cad4fa6c249bffe()
    };
};


const $045fd194f5429cb1$var$OPT_OUT_CACHE_EXPIRATION_SECONDS = 31536000; // 1 year
const $045fd194f5429cb1$export$77dd43be45cef9eb = ({ onCompleted: onCompleted, onError: onError } = {})=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $7fea6b6f7f18a70b$export$5bf35293e545f20c)();
    // useNav4OptOutMutation does not seem to return a response, success state is tracked with a hook instead
    const [isAdminUpdateSuccessful, setAdminUpdateSuccessful] = (0, $gqzfn.useState)(null);
    const { shouldSkipOptOutQuery: shouldSkipOptOutQuery } = (0, $80551c4b709c6d15$export$d7e12273c5b6a967)();
    const { loading: loading, data: data, error: queryError } = (0, $f54dbbdd58dc6856$export$33c3a40e92be94b0)((0, $d7f2d52a706ecc0f$export$2e2bcd8739ae039)`query useNav4OptOutQuery{userPreferences{nav4OptOut}}`, {
        skip: shouldSkipOptOutQuery
    });
    // Expected error - query will fail for anonymous and unlicensed users
    if (queryError?.message.includes('Cannot find authenticated user.')) (0, $4b7988ce40c8fd3c$export$702f853386561b84)(queryError);
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const [updateNav4OptOutServer] = (0, $706be9e0db767cf6$export$609860bf8b0084c)((0, $d7f2d52a706ecc0f$export$2e2bcd8739ae039)`mutation useNav4OptOutMutation($nav4OptOut:Boolean!){updateUserPreferences(userPreferences:{nav4OptOut:$nav4OptOut}){nav4OptOut}}`);
    const neverOptedOut = !loading && data?.userPreferences?.nav4OptOut === null;
    const { setQueryParams: setQueryParams } = (0, $a55430c99df8268f$export$2467ee40aa778f80)();
    const updateNav4OptOut = (0, $gqzfn.useCallback)(async (newNav4OptOut)=>{
        updateNav4OptOutServer({
            variables: {
                nav4OptOut: newNav4OptOut
            }
        }).then(()=>{
            $045fd194f5429cb1$var$updateNav4OptOutCache(newNav4OptOut);
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'changed',
                    actionSubject: 'navigationVersion',
                    source: 'nav4OptOut',
                    attributes: {
                        originalNavVersion: newNav4OptOut ? '4' : '3',
                        newNavVersion: newNav4OptOut ? '3' : '4'
                    }
                }
            }).fire();
            if (newNav4OptOut && neverOptedOut && !(0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_nav4_ga_phase_1')) // If this is the first time opting out, reload with query param to trigger Nav4OptOutSpotlight
            setQueryParams({
                navOptOut: 'true'
            });
            setAdminUpdateSuccessful(true);
            onCompleted?.();
        }).catch((error)=>{
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'changeFailed',
                    actionSubject: 'navigationVersion',
                    source: 'nav4OptOut',
                    attributes: {
                        error: error
                    }
                }
            }).fire();
            setAdminUpdateSuccessful(false);
            onError?.(error);
        });
    }, [
        updateNav4OptOutServer,
        createAnalyticsEvent,
        neverOptedOut,
        setQueryParams,
        onCompleted,
        onError
    ]);
    const optOutCache = $045fd194f5429cb1$var$parseCacheValue((0, $8b7debc8685a2ab6$export$7691d7c35a352a10)?.getItem((0, $55aebbd7cffee8f3$export$ed97f33186d4b816).NAV4_OPT_OUT_CACHE));
    const optOutServer = data?.userPreferences?.nav4OptOut;
    const nav4OptOut = ((0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_nav_4') || (0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_nav4_ga_phase_1')) && (loading ? optOutCache : optOutServer);
    (0, $gqzfn.useEffect)(()=>{
        if (!loading && optOutServer !== optOutCache) $045fd194f5429cb1$var$updateNav4OptOutCache(optOutServer);
    }, [
        loading,
        optOutCache,
        optOutServer
    ]);
    return {
        nav4OptOut: nav4OptOut,
        updateNav4OptOut: updateNav4OptOut,
        isAdminUpdateSuccessful: isAdminUpdateSuccessful
    };
};
const $045fd194f5429cb1$var$parseCacheValue = (cacheValue)=>{
    if (cacheValue === 'true') return true;
    else if (cacheValue === 'false') return false;
    else return undefined;
};
const $045fd194f5429cb1$export$913ff9805687cd8 = ()=>{
    return (0, $8b7debc8685a2ab6$export$7691d7c35a352a10)?.getItem((0, $55aebbd7cffee8f3$export$ed97f33186d4b816).NAV4_OPT_OUT_CACHE) === 'true';
};
const $045fd194f5429cb1$export$aca664b5b089bc42 = ()=>{
    return (0, $8b7debc8685a2ab6$export$7691d7c35a352a10)?.getItem((0, $55aebbd7cffee8f3$export$ed97f33186d4b816).NAV4_OPT_OUT_CACHE) === 'false';
};
const $045fd194f5429cb1$var$updateNav4OptOutCache = (nav4OptOut)=>{
    if (nav4OptOut) (0, $8b7debc8685a2ab6$export$7691d7c35a352a10).setItem((0, $55aebbd7cffee8f3$export$ed97f33186d4b816).NAV4_OPT_OUT_CACHE, true, $045fd194f5429cb1$var$OPT_OUT_CACHE_EXPIRATION_SECONDS);
    else if (nav4OptOut === false) // if explicitly set to false, we need to save to check in phase_1 since false means "opt-in"
    (0, $8b7debc8685a2ab6$export$7691d7c35a352a10).setItem((0, $55aebbd7cffee8f3$export$ed97f33186d4b816).NAV4_OPT_OUT_CACHE, false, $045fd194f5429cb1$var$OPT_OUT_CACHE_EXPIRATION_SECONDS);
    else // the value is null and has never been set
    (0, $8b7debc8685a2ab6$export$7691d7c35a352a10)?.removeItem((0, $55aebbd7cffee8f3$export$ed97f33186d4b816).NAV4_OPT_OUT_CACHE);
};



const $c2de76413cb8f3c4$export$827babb08d748504 = ()=>{
    if ((0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_nav4_ga_phase_2')) return 2;
    if ((0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_nav4_ga_phase_1')) return 1;
    return 0;
};




const $b1e60184bb3ec7e1$var$OPT_OUT_CACHE_EXPIRATION_SECONDS = 31536000; // 1 year
const $b1e60184bb3ec7e1$export$2157f431c298ed22 = (nav4AdminOptIn)=>{
    if (nav4AdminOptIn) (0, $8b7debc8685a2ab6$export$7691d7c35a352a10).setItem((0, $55aebbd7cffee8f3$export$ed97f33186d4b816).NAV4_ADMIN_OPT_IN_CACHE, true, $b1e60184bb3ec7e1$var$OPT_OUT_CACHE_EXPIRATION_SECONDS);
    else // the value is null and has never been set
    (0, $8b7debc8685a2ab6$export$7691d7c35a352a10)?.removeItem((0, $55aebbd7cffee8f3$export$ed97f33186d4b816).NAV4_ADMIN_OPT_IN_CACHE);
};
const $b1e60184bb3ec7e1$export$4b020a7ac475108f = ()=>{
    return (0, $8b7debc8685a2ab6$export$7691d7c35a352a10)?.getItem((0, $55aebbd7cffee8f3$export$ed97f33186d4b816).NAV4_ADMIN_OPT_IN_CACHE) === 'true';
};


const $f35f58e56b56de67$export$2af1f7a69c1ab0ad = ()=>{
    const currentGAPhase = (0, $c2de76413cb8f3c4$export$827babb08d748504)();
    if (currentGAPhase === 2) return true;
    if ((0, $045fd194f5429cb1$export$913ff9805687cd8)()) return false;
    return(// checks both site opt-in and admin only opt-in
    (0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_nav_4') || (0, $ef003bca5ae3d837$export$9db1624a8af791a4)('confluence_jira_nav4_new_customers', 'willShowNav4', false) || currentGAPhase === 1 && ((0, $b1e60184bb3ec7e1$export$4b020a7ac475108f)() || (0, $045fd194f5429cb1$export$aca664b5b089bc42)()));
};




var $34Zxt = parcelRequire("34Zxt");

class $12387e80c2ebd079$export$a00c080e726db0b {
    initialize() {
        if (typeof document === 'undefined') return {
            teardown: ()=>{}
        };
        if (document.hidden) // if the tab is active, `onVisibilityChange` will result in invariant violation
        this.onVisibilityChange();
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        return {
            teardown: ()=>{
                document.removeEventListener('visibilitychange', this.onVisibilityChange);
            }
        };
    }
    getInactiveMillisecondsSince(timestamp) {
        let inactivityDuration = 0;
        // for-loop will allow us to perform an early exit
        for (const [start, end] of this.inactivityIntervals){
            // cases:
            // - timestamp < start     < end        : Relevant
            // - start     < timestamp < end        : Relevant
            // - start     < timestamp ; end=null   : Relevant
            // - start     < end       < timestamp  : Irrelevant
            const inactivityEnd = end || window.performance.now();
            if (timestamp > inactivityEnd) break;
            inactivityDuration += inactivityEnd - Math.max(start, timestamp);
        }
        return inactivityDuration;
    }
    constructor({ maxIntervalsToStore: maxIntervalsToStore } = {}){
        /**
     * Stores intervals in reverse order (that is, latest interval will be the first item in the array).
     * The items in this array are tuples of [intervalStartTimestamp, intervalEndTimestamp].
     * If `intervalEndTimestamp` is `null`, that means that tab is still inactive.
     * Example value (number would actually be timestamps, but they are exemplified differently for ease of understanding):
     * ```js
     * // if the tab is currently active, but was hidden before
     * [ [500, 600], [300, 400], [100, 200] ]
     *
     * // while the tab is still inactive
     * [ [500, null], [100, 200] ]
     *
     * // if the tab has never been hidden
     * [ ]
     * ```
     */ this.inactivityIntervals = [];
        this.logger = (0, $a6897acd40ed68b1$export$2b1d391cd05230fd)('TabInactivityTracker');
        // in order to not increase memory footprint indefinitely, we'll cap the maximum amount of items
        this.maxIntervalsToStore = void 0;
        this.onVisibilityChange = ()=>{
            if (!document.hidden) {
                // we were inactive before, which means that there is an "unfinished" interval
                // we'll finish it after verifying invariants
                if (this.inactivityIntervals.length === 0 || this.inactivityIntervals[0][1] != null) this.logger.error`Invariant violation: tab is currently active, but inactivity intervals are in inconsistent state`;
                else this.inactivityIntervals[0][1] = window.performance.now();
            } else {
                if (this.inactivityIntervals.length >= this.maxIntervalsToStore) // we're about to add a new interval; but we're also at max array capacity, so we'll
                // intentionally lose the most dated items in the array in the hope that they won't be needed anymore.
                this.inactivityIntervals.splice(this.maxIntervalsToStore - 1);
                // tab just became inactive; we'll create a new "unfinished" interval
                this.inactivityIntervals.unshift([
                    window.performance.now(),
                    null
                ]);
            }
        };
        const DEFAULT_MAX_INTERVALS_TO_STORE = 100;
        this.maxIntervalsToStore = typeof maxIntervalsToStore === 'number' ? maxIntervalsToStore : DEFAULT_MAX_INTERVALS_TO_STORE;
    }
}
const $12387e80c2ebd079$export$39c3eb20723b04b = (0, $34Zxt.default)(()=>{
    const tracker = new $12387e80c2ebd079$export$a00c080e726db0b();
    tracker.initialize();
    return tracker;
});



var $34Zxt = parcelRequire("34Zxt");
class $93bba6ebad0146b8$export$51cec848073e2e7a {
    start() {
        let lastFreezeStart;
        if (typeof document !== 'undefined') {
            document.addEventListener('freeze', ()=>{
                lastFreezeStart = performance.now();
            });
            document.addEventListener('resume', ()=>{
                // probably zero chance of it happening, but still
                if (typeof lastFreezeStart !== 'number') return;
                const now = performance.now();
                for (const callback of this.callbacks.values())callback(now - lastFreezeStart);
            });
        }
    }
    subscribe(name, callback) {
        // We are not subscribe and unsubscribe with callback's reference.
        // Because there are known cases that experiences are not properly stopped.
        // In order prevent from memory leak here we are using the name as the key since the variation is bounded.
        this.callbacks.set(name, callback);
    }
    unsubscribe(name) {
        this.callbacks.delete(name);
    }
    constructor(){
        this.callbacks = new Map();
    }
}
const $93bba6ebad0146b8$export$40336562f0f00c2a = (0, $34Zxt.default)(()=>new $93bba6ebad0146b8$export$51cec848073e2e7a());



// Whenever we want to target view-page experience, we should ensure we're targeting all correlated view-page experiences.
// This is more complete and helps avoid bugs related to view-content experience forwarding to view-page.
const $b56cd77aa456103d$var$VIEW_PAGE_EXPERIENCES = [
    (0, $d4b865e8cc459c1f$export$d4712ac27cc4e72f),
    (0, $d4b865e8cc459c1f$export$cf73dfff88c1f700),
    (0, $d4b865e8cc459c1f$export$5e30e9d7ea54dcd2)
];
// Experience timeouts by default are considered taskFails. Certain experiences should instead treat timeouts as aborts, to reduce unnecessary noise and improve SLI accuracy.
const $b56cd77aa456103d$var$EXPERIENCE_TIMEOUTS_TO_ABORT = [
    (0, $d4b865e8cc459c1f$export$227ea80a7d6d8ef2),
    ...$b56cd77aa456103d$var$VIEW_PAGE_EXPERIENCES,
    (0, $d4b865e8cc459c1f$export$a83700d85c7e0745),
    (0, $d4b865e8cc459c1f$export$bdaf5db6d84a5581),
    (0, $d4b865e8cc459c1f$export$2a57468d23984a9d)
];
// Errors that are thrown by client side and can be ignored, this is to avoid treating these as fails that can impact SLOs.
// ideally we can show the user a flag that shows something is wrong, please avoid adding to this list unless absolutely necessary.
const $b56cd77aa456103d$var$IGNORABLE_CLIENT_SIDE_ERRORS = [
    "can't access dead object"
];
/**
 * A list of experiences that should have debugMessages attached to abort events.
 *
 * This is not a safe default, as at time of addition ~20% of experiences
 * with some events having ~90% abort rates with high volume (>10k per 15m)
 *
 * If adding -- ensure you first review the event and abort volume.
 */ const $b56cd77aa456103d$var$EXPERIENCES_TO_DEBUG_ON_ABORT = [
    (0, $d4b865e8cc459c1f$export$f8e0e16825f0d222)
];
class $b56cd77aa456103d$export$c90b54e658fc4d7c {
    succeed(attributes, publishDebugPoints) {
        if (this.hasStopped) return;
        this.onSuccess && this.onSuccess();
        this.stop({
            action: 'taskSuccess',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getAbsoluteDuration(),
            activeDuration: this.getDurationAdjustedForActive(),
            adjustedDuration: this.getDurationAdjustedForTabActivity(),
            ...publishDebugPoints && {
                debugPoints: this.debugPoints
            },
            attributes: {
                ...(0, $0b946e8b990b9608$export$3dc3660453120ccc)(),
                ...this.getFeatureGateAttributes(),
                ...this.attributes,
                ...attributes
            }
        });
    }
    fail({ error: error, attributes: attributes }) {
        if (this.hasStopped) return;
        if (error?.message && $b56cd77aa456103d$var$IGNORABLE_CLIENT_SIDE_ERRORS.includes(error.message)) {
            this.abort({
                reason: 'Aborted because of client side error',
                attributes: {
                    ...attributes,
                    clientSideError: error.message
                }
            });
            return;
        }
        this.onFailure && this.onFailure();
        this.stop({
            action: 'taskFail',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getAbsoluteDuration(),
            activeDuration: this.getDurationAdjustedForActive(),
            adjustedDuration: this.getDurationAdjustedForTabActivity(),
            debugPoints: this.debugPoints,
            error: error,
            attributes: {
                ...(0, $0b946e8b990b9608$export$3dc3660453120ccc)(),
                ...this.getFeatureGateAttributes(),
                ...this.attributes,
                ...attributes
            }
        });
    }
    abort({ reason: reason, attributes: attributes, checkForTimeout: checkForTimeout = true, publishDebugPoints: /**
     * @deprecated
     * This will not attach debug points in the event that the experience in scenarios where
     * the abort is not coming from consumer code (e.g. when the experience is stopped due
     * to a new experience starting).
     */ publishDebugPoints = false }) {
        if (this.hasStopped) return;
        const adjustedDuration = this.getDurationAdjustedForTabActivity();
        const isTimeout = checkForTimeout && this.timeout != null && adjustedDuration >= this.timeout;
        // Check if the experience should have failed due to timeout
        if (isTimeout) // We want to abort timeouts from view-page and create-page to improve SLO reliability accuracy as they're not guaranteed to be correlated to real user impact. For more info see MODES-4806.
        {
            if (!$b56cd77aa456103d$var$EXPERIENCE_TIMEOUTS_TO_ABORT.includes(this.name)) {
                this.fail({
                    attributes: {
                        originalAbortReason: reason,
                        ...attributes
                    },
                    error: new (0, $4b50c1dadb433c8a$export$d27a2b6293f7631c)(`${this.name} failed to complete in ${this.timeout}ms`)
                });
                return;
            }
        }
        this.onAbort && this.onAbort();
        this.stop({
            action: 'taskAbort',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getAbsoluteDuration(),
            activeDuration: this.getDurationAdjustedForActive(),
            adjustedDuration: adjustedDuration,
            ...$b56cd77aa456103d$var$EXPERIENCES_TO_DEBUG_ON_ABORT.includes(this.name) ? {
                debugPoints: this.debugPoints
            } : {},
            ...publishDebugPoints && {
                debugPoints: this.debugPoints
            },
            reason: isTimeout ? `ExperienceTimeout: ${this.name} failed to complete in ${this.timeout}ms` : reason,
            checkForTimeout: checkForTimeout,
            attributes: {
                originalAbortReason: isTimeout ? reason : undefined,
                ...(0, $0b946e8b990b9608$export$3dc3660453120ccc)(),
                ...this.getFeatureGateAttributes(),
                ...this.attributes,
                ...attributes
            }
        });
    }
    /**
   * Called on experience to stop it with the same action (success / failure / abort) and attributes as another event.
   * For example, compound experience (e.g. edit-page) is failed if sub-experience (e.g. edit-page/publish) fails.
   */ stopOn(event, extraAttributes = {}) {
        if (!event) return;
        if (event.action === 'taskSuccess') this.succeed({});
        else if (event.action === 'taskAbort') this.abort({
            reason: event.reason,
            attributes: {
                ...extraAttributes,
                stoppedOn: event.name,
                stoppedOnPath: this.getStoppedOnPath(event)
            },
            checkForTimeout: event.checkForTimeout
        });
        else if (event.action === 'taskFail') this.fail({
            error: event.error,
            attributes: {
                ...extraAttributes,
                stoppedOn: event.name,
                stoppedOnPath: this.getStoppedOnPath(event)
            }
        });
    }
    updateAttributes(attributes) {
        this.attributes = {
            ...this.attributes,
            ...attributes
        };
    }
    attachDebugPoint(message, attributes = {}) {
        if (this.debugPoints?.some((debugPoint)=>debugPoint.message === message)) // Avoid adding duplicate debug points
        return;
        this.debugPoints.push({
            timestamp: new Date().toISOString(),
            now: window.performance.now(),
            message: message,
            attributes: attributes
        });
    }
    getState() {
        return {
            taskId: this.id,
            timeout: this.timeout,
            hasStopped: this.hasStopped,
            stopState: this.stopState,
            startTime: this.startTime,
            name: this.name,
            attributes: this.attributes
        };
    }
    get hasStopped() {
        return this.stopState !== null;
    }
    stop(event) {
        this.stopState = event.action;
        if (this.onStop) this.onStop(event);
        (0, $93bba6ebad0146b8$export$40336562f0f00c2a)().unsubscribe(this.name);
    }
    getAbsoluteDuration() {
        return Math.round(window.performance.now() - this.startTime);
    }
    getDurationAdjustedForTabActivity() {
        return this.getAbsoluteDuration() - (0, $12387e80c2ebd079$export$39c3eb20723b04b)().getInactiveMillisecondsSince(this.startTime);
    }
    getDurationAdjustedForActive() {
        return this.getAbsoluteDuration() - this.freezeTime;
    }
    getStoppedOnPath(event) {
        if (!event.attributes?.stoppedOnPath) return event.name;
        return `${event.name},${event.attributes.stoppedOnPath}`;
    }
    constructor({ name: name, id: id, timeout: timeout, startTime: startTime = window.performance.now(), attributes: attributes, onStart: onStart, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort }){
        this.name = void 0;
        this.id = void 0;
        this.timeout = void 0;
        this.freezeTime = 0;
        this.stopState = null;
        this.startTime = void 0;
        this.attributes = void 0;
        this.onStop = void 0;
        this.onSuccess = void 0;
        this.onFailure = void 0;
        this.onAbort = void 0;
        this.debugPoints = [];
        // Include certain broad-impact feature gates in experience events
        this.getFeatureGateAttributes = (0, $34Zxt.default)(()=>{
            return {
                isContentWrapperEnabled: (0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_frontend_content_wrapper'),
                isNav4Enabled: (0, $f35f58e56b56de67$export$2af1f7a69c1ab0ad)()
            };
        });
        this.name = name;
        this.id = id;
        this.timeout = timeout;
        this.startTime = startTime;
        this.attributes = attributes;
        this.onSuccess = onSuccess;
        this.onFailure = onFailure;
        this.onAbort = onAbort;
        const startEvent = {
            action: 'taskStart',
            name: name,
            id: id,
            startTime: startTime,
            timeout: timeout,
            attributes: {
                ...(0, $0b946e8b990b9608$export$3dc3660453120ccc)(),
                ...attributes,
                ...this.getFeatureGateAttributes()
            }
        };
        if (onStart) this.onStop = onStart(startEvent);
        (0, $93bba6ebad0146b8$export$40336562f0f00c2a)().subscribe(name, (time)=>{
            this.freezeTime += time;
        });
    }
}




const $b4f5dc9bddcbc766$export$16e3f1b03b231b35 = (event)=>event.action === 'taskSuccess' || event.action === 'taskAbort' || event.action === 'taskFail';
const $b4f5dc9bddcbc766$export$57069f5b2ecc9128 = (event, ...names)=>names.includes(event.name);
const $b4f5dc9bddcbc766$export$7895096fcdde5712 = (event, key, value)=>Boolean(event.attributes?.hasOwnProperty(key) && event.attributes[key] === value);



const $db2847de8e87cb6c$var$EDIT_PAGE_SUBEXPERIENCES = [
    (0, $d4b865e8cc459c1f$export$54650b8dd9597591),
    (0, $d4b865e8cc459c1f$export$92edebd76eb1ad1),
    (0, $d4b865e8cc459c1f$export$4aed0cf42acf9c68)
];
const $db2847de8e87cb6c$var$COMPANY_HUB_EDITOR_SUBEXPERIENCES = [
    (0, $d4b865e8cc459c1f$export$35975591aeab4dd6),
    (0, $d4b865e8cc459c1f$export$7a3dfdccebea9c7b),
    (0, $d4b865e8cc459c1f$export$eef6122c9774ba1c)
];
const $db2847de8e87cb6c$export$b4cbec267823a12e = ()=>{
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$9e0dcc9389703292),
        collect: $db2847de8e87cb6c$export$bb44f104e3c54dae
    });
};
const $db2847de8e87cb6c$export$bb44f104e3c54dae = (events, experience)=>{
    experience.stopOn($db2847de8e87cb6c$export$e2067cc0ba855137(events, 'taskSuccess'));
    experience.stopOn($db2847de8e87cb6c$export$e2067cc0ba855137(events, 'taskFail'));
};
const $db2847de8e87cb6c$export$e2067cc0ba855137 = (events, action)=>{
    return events.find((event)=>event.action === action && (0, $b4f5dc9bddcbc766$export$57069f5b2ecc9128)(event, (0, $d4b865e8cc459c1f$export$dd70d6707192298e)));
};
const $db2847de8e87cb6c$export$2b69dcd5daaf6a2c = ()=>{
    const tracker = (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)();
    const editPageExperienceState = tracker.getExperienceState((0, $d4b865e8cc459c1f$export$dd70d6707192298e));
    const isEditPageRunning = editPageExperienceState && !editPageExperienceState.hasStopped;
    if (!isEditPageRunning) return false;
    // Validate all subexperiences are healthy. If any experience is unhealthy, `every` will immediately return false, otherwise true
    return $db2847de8e87cb6c$var$EDIT_PAGE_SUBEXPERIENCES.every((subexperience)=>{
        const subexperienceState = tracker.getExperienceState(subexperience);
        // Subexperience has not run, so edit-page is still healthy
        if (!subexperienceState) return true;
        // Subexperience has not run for current edit-page's contentId, so edit-page is still healthy
        if (subexperienceState.attributes?.contentId !== editPageExperienceState.attributes?.contentId) return true;
        // Subexperience has run and has finished successfully, so edit-page is still healthy
        if (subexperienceState.stopState === 'taskSuccess') return true;
        // Subexperience has run and has not finished successfully, so edit-page is unhealthy
        return false;
    });
};
const $db2847de8e87cb6c$export$c15dc70f74e1c751 = ()=>{
    const tracker = (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)();
    const hubEditorExperienceState = tracker.getExperienceState((0, $d4b865e8cc459c1f$export$c6d05c48b9430e3c));
    const isHubEditorRunning = hubEditorExperienceState && !hubEditorExperienceState.hasStopped;
    if (!isHubEditorRunning) return false;
    // Validate all subexperiences are healthy. If any experience is unhealthy, `every` will immediately return false, otherwise true
    return $db2847de8e87cb6c$var$COMPANY_HUB_EDITOR_SUBEXPERIENCES.every((subexperience)=>{
        const subexperienceState = tracker.getExperienceState(subexperience);
        // Subexperience has not run, so hub editor experience is still healthy
        if (!subexperienceState) return true;
        // Subexperience has run and has finished successfully, so hub editor experience is still healthy
        if (subexperienceState.stopState === 'taskSuccess') return true;
        // Subexperience has run and has not finished successfully, so hub editor experience is unhealthy
        return false;
    });
};



// eslint-disable-next-line import/no-cycle

const $4554f58440667b87$export$11699410c9e76883 = ({ parentExperience: parentExperience, subExperiences: subExperiences })=>{
    const tracker = (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)();
    const parentExperienceState = tracker.getExperienceState(parentExperience);
    const isParentExperienceRunning = parentExperienceState && !parentExperienceState.hasStopped;
    if (!isParentExperienceRunning) return false;
    const parentExperienceContentId = String(parentExperienceState.attributes?.contentId);
    return $4554f58440667b87$var$areSubExperiencesHealthy({
        parentExperienceContentId: parentExperienceContentId,
        subExperiences: subExperiences
    });
};
const $4554f58440667b87$var$areSubExperiencesHealthy = ({ parentExperienceContentId: parentExperienceContentId, subExperiences: subExperiences = [] })=>{
    const tracker = (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)();
    // Validate all subExperiences are healthy. If any experience is unhealthy, `every` will immediately return false, otherwise true
    return subExperiences.every((subExperience)=>{
        const subExperienceState = tracker.getExperienceState(subExperience);
        // Subexperience has not run, so parent is still healthy
        if (!subExperienceState) return true;
        // Subexperience has not run for current parentExperience's contentId, so parentExperience is still healthy
        const isSubExperienceForDifferentContent = parentExperienceContentId !== subExperienceState.attributes?.contentId;
        if (isSubExperienceForDifferentContent) return true;
        const hasSubExperienceCompletedSuccessfully = subExperienceState.stopState === 'taskSuccess';
        if (hasSubExperienceCompletedSuccessfully) return true;
        // Subexperience has run and has not finished successfully, so parentExperience is unhealthy
        return false;
    });
};


const $59f627305e19cfab$export$77dd5573732a240c = ()=>(0, $4554f58440667b87$export$11699410c9e76883)({
        parentExperience: (0, $d4b865e8cc459c1f$export$5e30e9d7ea54dcd2),
        subExperiences: [
            (0, $d4b865e8cc459c1f$export$d4712ac27cc4e72f)
        ]
    });
const $59f627305e19cfab$export$41f7b734fb3e4a50 = ({ id: id, tracker: tracker, attributes: attributes, startTime: startTime })=>{
    tracker.start({
        name: (0, $d4b865e8cc459c1f$export$5e30e9d7ea54dcd2),
        id: id,
        startTime: startTime,
        attributes: attributes,
        collect: (events, experience)=>{
            const viewExperienceLoadingFailed = events.find(({ action: action, name: name })=>action === 'taskFail' && name === (0, $d4b865e8cc459c1f$export$d4712ac27cc4e72f));
            const viewExperienceLoadingAborted = events.find(({ action: action, name: name })=>action === 'taskAbort' && name === (0, $d4b865e8cc459c1f$export$d4712ac27cc4e72f));
            if (viewExperienceLoadingFailed) experience.fail({
                error: new Error('View page load experience failed')
            });
            else if (viewExperienceLoadingAborted) experience.abort({
                reason: 'View page load experience aborted'
            });
        }
    });
};




var $34Zxt = parcelRequire("34Zxt");


const $33515bae88ccc425$export$fc45374fcefeb0f1 = (0, $34Zxt.default)(()=>{
    return (0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('live_page_exp_to_core_exp_migration') ? (0, $d4b865e8cc459c1f$export$d4712ac27cc4e72f) : (0, $d4b865e8cc459c1f$export$d3dcb341de2e384f);
});
const $33515bae88ccc425$export$44bb710761a63941 = (0, $34Zxt.default)(()=>{
    return (0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('live_page_exp_to_core_exp_migration') ? (0, $d4b865e8cc459c1f$export$dd70d6707192298e) : (0, $d4b865e8cc459c1f$export$f8e950d04ce466ff);
});


function $09236c8503a0584b$var$getExperienceStopReason(error) {
    // message text check is a stop-gap measure due to re-packaging of errors. refactoring is underway.
    if ((0, $ebb54c1f7b9c33e4$export$b8c2308c7b82c3a9)(error)) return `Aborted because of session expiration error: ${error.toString()}`;
    if ((0, $65398bb1ddc9160a$export$bda33884db3cf75b)(error)) return `Aborted because of network error: ${error.toString()}`;
    return undefined;
}
class $09236c8503a0584b$export$12b6b072930fd68f {
    start({ name: name, id: id = (0, (/*@__PURE__*/$parcel$interopDefault($c29b43bb0df96673$exports)))(), timeout: timeout, startTime: startTime, attributes: attributes, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort, collect: collect }) {
        const current = this.experiences[name];
        // Do not restart an experience that has the same id and is still running
        if (current && current.id === id && !current.hasStopped) return;
        // Before replacing a current experience, abort it to ensure it is cleaned up.
        if (current && !current.hasStopped) current.abort({
            reason: 'Aborted because the same experience was started with a new id',
            attributes: {
                newTaskId: id
            }
        });
        const experience = new (0, $b56cd77aa456103d$export$c90b54e658fc4d7c)({
            name: name,
            id: id,
            timeout: timeout,
            startTime: startTime,
            attributes: attributes,
            onSuccess: onSuccess,
            onFailure: onFailure,
            onAbort: onAbort,
            onStart: (startEvent)=>{
                this.emit(startEvent);
                let disposeCollectSubscription = ()=>{};
                if (collect) {
                    const events = [];
                    disposeCollectSubscription = this.subscribe((event)=>{
                        // Ignore already running experiences that started before this
                        // experience started
                        if (event.action === 'taskStart' || events.some((previousEvent)=>previousEvent.name === event.name && previousEvent.action === 'taskStart')) {
                            events.push(event);
                            collect(events, experience);
                        }
                    });
                }
                return (stopEvent)=>{
                    disposeCollectSubscription();
                    this.emit(stopEvent);
                };
            }
        });
        this.experiences[name] = experience;
    }
    succeed({ name: name, attributes: attributes, publishDebugPoints: publishDebugPoints }) {
        const current = this.experiences[name];
        if (!current) return;
        current.succeed(attributes, publishDebugPoints);
    }
    fail({ name: name, error: error, attributes: attributes }) {
        Object.values(this.experiences).forEach((current)=>{
            if (name != null && current.name !== name) return;
            current.fail({
                error: error,
                attributes: attributes
            });
        });
    }
    abort({ name: name, reason: reason, attributes: attributes, checkForTimeout: checkForTimeout, publishDebugPoints: publishDebugPoints }) {
        Object.values(this.experiences).forEach((experience)=>{
            if (name != null && experience.name !== name) return;
            experience.abort({
                reason: reason,
                checkForTimeout: checkForTimeout,
                attributes: attributes,
                publishDebugPoints: publishDebugPoints
            });
        });
    }
    stopOnError({ error: error, name: name, attributes: attributes }) {
        const reason = $09236c8503a0584b$var$getExperienceStopReason(error);
        if (reason) {
            this.abort({
                name: name,
                reason: reason,
                checkForTimeout: false,
                attributes: attributes
            });
            return;
        }
        this.fail({
            name: name,
            error: error,
            attributes: attributes
        });
    }
    subscribe(subscriber) {
        if (typeof subscriber !== 'function') throw new Error('Subscriber must be a function');
        this.subscribers.push(subscriber);
        return ()=>{
            this.subscribers = this.subscribers.filter((x)=>x !== subscriber);
        };
    }
    getExperienceState(experienceName) {
        return this.experiences[experienceName] ? this.experiences[experienceName].getState() : null;
    }
    updateAttributes({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.updateAttributes(attributes);
    }
    attachDebugPoint({ name: name, message: message, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.attachDebugPoint(message, attributes);
    }
    emit(event) {
        this.logger.debug`${event.action} ${event}`;
        this.subscribers.forEach((subscriber)=>{
            try {
                subscriber(event);
            } catch (e) {
                this.logger.error`Error occurred in ExperienceTracker subscriber ${e} when handling event ${event}`;
            }
        });
    }
    constructor(){
        this.experiences = {};
        this.subscribers = [];
        this.logger = (0, $a6897acd40ed68b1$export$2b1d391cd05230fd)('ExperienceTracker');
        (0, $93bba6ebad0146b8$export$40336562f0f00c2a)().start();
        if (typeof window !== 'undefined') window.addEventListener('pagehide', ()=>{
            const livePageEditExperienceName = (0, $33515bae88ccc425$export$44bb710761a63941)();
            const livePageEditExperienceState = this.getExperienceState(livePageEditExperienceName);
            const livePageSessionExperienceState = this.getExperienceState((0, $d4b865e8cc459c1f$export$3814d28dd3802a02));
            const experiencesToSucceed = [
                {
                    name: livePageEditExperienceName,
                    successCondition: livePageEditExperienceState && !livePageEditExperienceState.hasStopped && livePageEditExperienceState.attributes?.isLivePage
                },
                {
                    name: (0, $d4b865e8cc459c1f$export$dd70d6707192298e),
                    successCondition: (0, $db2847de8e87cb6c$export$2b69dcd5daaf6a2c)()
                },
                {
                    name: (0, $d4b865e8cc459c1f$export$5e30e9d7ea54dcd2),
                    successCondition: (0, $59f627305e19cfab$export$77dd5573732a240c)()
                },
                {
                    name: (0, $d4b865e8cc459c1f$export$3814d28dd3802a02),
                    successCondition: livePageSessionExperienceState && !livePageSessionExperienceState.hasStopped
                }
            ];
            experiencesToSucceed.forEach(({ name: name, successCondition: successCondition })=>{
                if (successCondition) this.succeed({
                    name: name
                });
            });
            // Abort the rest of our experiences.
            this.abort({
                reason: 'Window unloading'
            });
        });
    }
}



const $fb98a59fbc7d7496$var$SLA_EXPERIENCES = new Set([
    // Currently not SLA experience, but will be in the future
    (0, $d4b865e8cc459c1f$export$f8e0e16825f0d222),
    (0, $d4b865e8cc459c1f$export$6f58645a9a5f7936),
    (0, $d4b865e8cc459c1f$export$20fbac00cba3c8a),
    // SLA experiences ⬇️
    (0, $d4b865e8cc459c1f$export$f94e85276e6d639f),
    (0, $d4b865e8cc459c1f$export$227ea80a7d6d8ef2),
    (0, $d4b865e8cc459c1f$export$dd70d6707192298e),
    (0, $d4b865e8cc459c1f$export$d4712ac27cc4e72f)
]);
const $fb98a59fbc7d7496$var$activeSlaExperiences = new Map();
const $fb98a59fbc7d7496$var$activeExperiences = new Set();
const $fb98a59fbc7d7496$var$currentRoute = {
    routeName: '',
    successfulExperiences: new Set()
};
const $fb98a59fbc7d7496$var$previousRoute = {
    routeName: '',
    successfulExperiences: new Set()
};
function $fb98a59fbc7d7496$export$6369eb07eb8a8518({ action: action, name: name, id: id, attributes: attributes = {} }) {
    const isSlaExperience = $fb98a59fbc7d7496$var$SLA_EXPERIENCES.has(name);
    if (action === 'taskStart') {
        if (isSlaExperience) {
            // Create a unique experience ID for request headers
            attributes.uniqueExperienceId = (0, (/*@__PURE__*/$parcel$interopDefault($c29b43bb0df96673$exports)))();
            $fb98a59fbc7d7496$var$activeSlaExperiences.set(name, {
                id: id,
                attributes: attributes
            });
        }
        $fb98a59fbc7d7496$var$activeExperiences.add(name);
    } else {
        if (isSlaExperience) {
            // Extract unique experience ID to attach to event attributes for analytics/monitoring logs
            attributes.uniqueExperienceId = $fb98a59fbc7d7496$var$activeSlaExperiences.get(name)?.attributes?.uniqueExperienceId;
            $fb98a59fbc7d7496$var$activeSlaExperiences.delete(name);
        }
        $fb98a59fbc7d7496$var$activeExperiences.delete(name);
        if (action === 'taskSuccess') $fb98a59fbc7d7496$var$currentRoute.successfulExperiences.add(name);
    }
    const slaExperience = $fb98a59fbc7d7496$export$1e7d0a9a962cdd28();
    const experiences = $fb98a59fbc7d7496$var$activeExperiences.size > 0 ? $fb98a59fbc7d7496$var$activeExperiences : null;
    if (slaExperience || experiences) {
        const updatedContext = {};
        if (experiences) updatedContext.activeExperiences = $fb98a59fbc7d7496$var$activeExperiences;
        if (slaExperience) updatedContext.slaExperience = slaExperience.name;
        (0, $d1c1e8e192b1a688$export$39a3b7739331403b)().updateContext(updatedContext);
    }
}
function $fb98a59fbc7d7496$export$1e7d0a9a962cdd28() {
    if ($fb98a59fbc7d7496$var$activeSlaExperiences.size === 0) return null;
    const experienceEntry = Array.from($fb98a59fbc7d7496$var$activeSlaExperiences).pop();
    return {
        ...experienceEntry[1],
        name: experienceEntry[0]
    };
}
const $fb98a59fbc7d7496$export$a1fa58e5690a5a9a = (0, $34Zxt.default)(()=>{
    const tracker = new (0, $09236c8503a0584b$export$12b6b072930fd68f)();
    // Do nothing for search engine crawlers
    if (/bot/i.test(window.navigator.userAgent)) return tracker;
    tracker.subscribe((event)=>{
        //
        // View Page SLA Split
        //
        if (event.name === (0, $d4b865e8cc459c1f$export$cf73dfff88c1f700)) {
            $fb98a59fbc7d7496$var$splitViewContentExperience(tracker, event);
            // View-content was introduced only to split space-overview out of
            // view-page, because view-page is covered by Premium SLA and
            // space-overview was not satisfactorily reliable. View-content is not
            // allowlisted in cc-fe-telemetry so submitting through MonitoringClient
            // below is a waste. Sending through AnalyticsWebClient is a waste too
            // since view-content is not tracked as an SLO and it could be derived
            // from view-page and space-overview which are tracked as separate SLOs
            // already anyway. Splunk found 23 million view-content events in the last
            // 24 hours which is about 3% of experience-tracker events.
            return;
        }
        $fb98a59fbc7d7496$export$6369eb07eb8a8518(event);
        //
        // AnalyticsWebClient
        //
        (0, $b76dfd1db5681318$export$e9ba7ef9458d1a4a)().then((client)=>{
            client.sendOperationalEvent((0, $613e0f6ab39bd308$export$9c05e7ef9f2c8895)($fb98a59fbc7d7496$var$provideGenericAttributes(event)));
        });
        //
        // MonitoringClient
        //
        const isTimeoutError = event.action === 'taskFail' && event?.error?.name === 'ExperienceTimeoutError' || event.action === 'taskAbort' && typeof event?.reason === 'string' && event.reason.startsWith('ExperienceTimeout');
        const isPermissionError = event.name === (0, $d4b865e8cc459c1f$export$dd70d6707192298e) && event.action === 'taskAbort' && (event.reason?.includes?.('401') || event.reason?.includes?.('403'));
        const tags = [
            `action:${event.action}`,
            `isActiveTab:${document.visibilityState === 'visible'}`,
            ...event.action === 'taskFail' || event.action === 'taskAbort' ? [
                `isTimeoutError:${isTimeoutError}`
            ] : [],
            ...event.name === (0, $d4b865e8cc459c1f$export$dd70d6707192298e) && event.action === 'taskAbort' ? [
                `isPermissionError:${isPermissionError}`
            ] : []
        ];
        if (event.attributes) for(const a in event.attributes)tags.push(`${a}:${event.attributes[a]}`);
        if (event.action === 'taskFail' && $fb98a59fbc7d7496$var$SLA_EXPERIENCES.has(event.name)) {
            // in this section, we submit information about SLA-affecting experience failures.
            // We don't submit timeout errors to monitoring systems however; they would be submitted to Analytics instead.
            // cc-fe-telemetry will filter these additional tags before sending to SFX, these are only for "Raw TelemetryEvent" Splunk logs
            if (event?.error?.message) tags.push(`error:${event.error.message}`);
            // Supply additional information from alternative sources, for case where SessionDataQuery is not available
            tags.push(`hostname:${window.location.hostname}`);
            tags.push(`tenantIdMeta:${(0, $b9d7d5d25d527513$export$72427a1521dd0069)('cloud-id')}`);
            (0, $d1c1e8e192b1a688$export$39a3b7739331403b)().incrementCounter(`experience-tracker:${event.name}`, tags);
            if (!(event.error instanceof (0, $4b50c1dadb433c8a$export$d27a2b6293f7631c))) {
                (0, $8a3a8685062675cc$export$c37ca7d37ab54fcc)(event.error, {
                    objectId: event.attributes?.contentId
                });
                (0, $8a3a8685062675cc$export$a986f274521b30d7)(event.error, {
                    failedSlaExperience: event.name,
                    experienceId: event.attributes?.uniqueExperienceId ?? event.id
                });
                (0, $d1c1e8e192b1a688$export$39a3b7739331403b)().submitError(event.error, {
                    attribution: 'sla'
                });
            }
        } else (0, $d1c1e8e192b1a688$export$39a3b7739331403b)().incrementCounter(`experience-tracker:${event.name}`, tags);
    });
    return tracker;
});
function $fb98a59fbc7d7496$export$720dc4209419df4e(name, error, attributes) {
    $fb98a59fbc7d7496$export$a1fa58e5690a5a9a().stopOnError({
        name: name,
        error: error,
        attributes: attributes
    });
}
const $fb98a59fbc7d7496$export$1c9cdc2685ab8d2 = (tracker, event, name = event.name)=>{
    switch(event.action){
        case 'taskStart':
            tracker.start({
                ...event,
                name: name
            });
            break;
        case 'taskSuccess':
            tracker.succeed({
                ...event,
                name: name
            });
            break;
        case 'taskFail':
            tracker.fail({
                ...event,
                name: name
            });
            break;
        case 'taskAbort':
            tracker.abort({
                ...event,
                name: name
            });
    }
};
function $fb98a59fbc7d7496$export$e8918c537d57dc96(routeName) {
    $fb98a59fbc7d7496$var$previousRoute.routeName = $fb98a59fbc7d7496$var$currentRoute.routeName;
    $fb98a59fbc7d7496$var$previousRoute.successfulExperiences = $fb98a59fbc7d7496$var$currentRoute.successfulExperiences;
    $fb98a59fbc7d7496$var$currentRoute.routeName = routeName;
    $fb98a59fbc7d7496$var$currentRoute.successfulExperiences = new Set();
}
function $fb98a59fbc7d7496$export$5259f71d975e46f5() {
    return {
        ...$fb98a59fbc7d7496$var$previousRoute
    };
}
const $fb98a59fbc7d7496$var$splitViewContentExperience = (tracker, event)=>{
    let name;
    if (event.attributes?.contentType === 'space') {
        name = (0, $d4b865e8cc459c1f$export$2a57468d23984a9d);
        const spaceKey = event.attributes?.spaceKey;
        if (typeof spaceKey === 'string' && (0, $a4b9a8903fd62c69$export$5ab9c400208ad907)(spaceKey)) name = (0, $d4b865e8cc459c1f$export$7f2689ec25c432a4);
    } else {
        name = (0, $d4b865e8cc459c1f$export$d4712ac27cc4e72f);
        if (event.action === 'taskStart') (0, $59f627305e19cfab$export$41f7b734fb3e4a50)({
            tracker: tracker,
            attributes: {
                ...event.attributes
            },
            startTime: event.startTime,
            id: event.id
        });
    }
    $fb98a59fbc7d7496$export$1c9cdc2685ab8d2(tracker, event, name);
};
/**
 * Extend the ExperienceEvent with Confluence-specific additional attributes based on available data and type of event.
 *
 * @param event ExperienceEvent
 * @returns ExperienceEvent with additional attributes
 */ const $fb98a59fbc7d7496$var$provideGenericAttributes = (event)=>{
    const errorTraceId = event.action === 'taskFail' && !!event?.error ? (0, $8a3a8685062675cc$export$d08bac32cb78075f)(event.error)?.traceId : undefined;
    // Expected that condition will be extended with && for other attributes added in the future
    if (!errorTraceId) return event;
    event.attributes = {
        ...!!errorTraceId && {
            traceId: errorTraceId
        },
        ...event.attributes
    };
    return event;
};




var $cJmfa = parcelRequire("cJmfa");

const $275fb2ab4eaa5111$export$cdb0163d35da79f3 = '__EP_REACT_PROPS_OBSERVABLE_OBJECT__';



const $35d8577bf71b9edb$export$ab9998995666ebe3 = 'embedded-confluence-iframe';
const $35d8577bf71b9edb$export$f2fe03976fe13de = ()=>{
    return `${$35d8577bf71b9edb$export$ab9998995666ebe3}-${(0, $466a4b1793cac1d8$exports.v4)()}`;
};
const $35d8577bf71b9edb$export$45b0adb7f9689286 = 'passThroughProps';
const $35d8577bf71b9edb$export$78cada8c8749e264 = 'propsUpdated';
const $35d8577bf71b9edb$export$b75934a6b56fd9ba = 'experienceForwarding';


const $4a3c07c89f66e113$export$8195e508b27d5978 = ()=>Boolean(window?.frameElement?.[0, $275fb2ab4eaa5111$export$cdb0163d35da79f3]) || window?.name.includes((0, $35d8577bf71b9edb$export$ab9998995666ebe3));


const $f71353228fb46d0d$export$9c21f25960873ecb = (location)=>{
    if (!location) location = window.location;
    const { query: query } = (0, (/*@__PURE__*/$parcel$interopDefault($cJmfa))).parse(location.search, true);
    return query.embedded === 'true' || Boolean(query.parentProduct) || (0, $4a3c07c89f66e113$export$8195e508b27d5978)();
};





const $6d6794975d4b2dd0$var$fetchGet = (resource)=>{
    // eslint-disable-next-line no-restricted-syntax
    return fetch(resource, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    });
};
const $6d6794975d4b2dd0$var$fetchPartialSessionDataFromAlternateSources = ()=>{
    const fetchUserIdFromIdentity = async ()=>{
        const response = await $6d6794975d4b2dd0$var$fetchGet('/gateway/api/me');
        const responseData = await response.json();
        return responseData?.account_id;
    };
    const fetchTenantIdFromEdge = async ()=>{
        const response = await $6d6794975d4b2dd0$var$fetchGet('/_edge/tenant_info');
        const responseData = await response.json();
        return responseData?.cloudId;
    };
    const isStagingEnvironment = [
        'branch',
        'staging',
        'stg-fedm',
        'dev'
    ].includes("production");
    return Promise.all([
        fetchUserIdFromIdentity(),
        fetchTenantIdFromEdge()
    ]).then(([userId, cloudId])=>{
        return {
            cloudId: cloudId,
            userId: userId,
            environment: isStagingEnvironment ? 'STAGING' : 'PRODUCTION'
        };
    });
};
const $6d6794975d4b2dd0$export$66b82bc0ee0db41d = ()=>{
    return $6d6794975d4b2dd0$var$fetchPartialSessionDataFromAlternateSources().then((data)=>{
        const { cloudId: cloudId, userId: userId, environment: environment } = data;
        const isEmbeddedConfluence = (0, $f71353228fb46d0d$export$9c21f25960873ecb)();
        const product = isEmbeddedConfluence ? 'embeddedConfluence' : 'confluence';
        /*
			 * Analytics Web Client initialization
			 *
			 * `initializeAnalyticsClient` is an asynchronous function. We start it but do not await it here. This allows the
			 * Error App UI, visible to the user, to be rendered ASAP
			 *
			 * The app relies on the consumers of the Analytics Client to await it when they use getAnalyticsWebClient.
			 */ (0, $b76dfd1db5681318$export$7d842b959fcdcd03)({
            cloudId: cloudId,
            userId: userId,
            environment: environment,
            product: product
        });
        // Monitoring context initialization
        (0, $d1c1e8e192b1a688$export$39a3b7739331403b)().updateContext({
            tenantId: cloudId,
            product: product
        });
        // Storage manager initialization
        return (0, $8b7debc8685a2ab6$export$68017d60ff81319c)({
            userId: userId ?? ''
        });
    }).catch(()=>{
    // Unfortunately if we can't initialize the analytics client, we can't log the error
    });
};



var $gqzfn = parcelRequire("gqzfn");
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $3UfL2 = parcelRequire("3UfL2");

var $gqzfn = parcelRequire("gqzfn");

var $gqzfn = parcelRequire("gqzfn");

var $3UfL2 = parcelRequire("3UfL2");

var $gqzfn = parcelRequire("gqzfn");
var $17c64bc07fd45005$exports = {};
'use strict';
var $50ceb1658da30b38$exports = {};
'use strict';

$50ceb1658da30b38$exports = (parcelRequire("bcu32"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $17c64bc07fd45005$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $17c64bc07fd45005$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $17c64bc07fd45005$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $17c64bc07fd45005$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $17c64bc07fd45005$var$TYPE_STATICS = {};
$17c64bc07fd45005$var$TYPE_STATICS[$50ceb1658da30b38$exports.ForwardRef] = $17c64bc07fd45005$var$FORWARD_REF_STATICS;
$17c64bc07fd45005$var$TYPE_STATICS[$50ceb1658da30b38$exports.Memo] = $17c64bc07fd45005$var$MEMO_STATICS;
function $17c64bc07fd45005$var$getStatics(component) {
    // React v16.11 and below
    if ($50ceb1658da30b38$exports.isMemo(component)) return $17c64bc07fd45005$var$MEMO_STATICS;
     // React v16.12 and above
    return $17c64bc07fd45005$var$TYPE_STATICS[component['$$typeof']] || $17c64bc07fd45005$var$REACT_STATICS;
}
var $17c64bc07fd45005$var$defineProperty = Object.defineProperty;
var $17c64bc07fd45005$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $17c64bc07fd45005$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $17c64bc07fd45005$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $17c64bc07fd45005$var$getPrototypeOf = Object.getPrototypeOf;
var $17c64bc07fd45005$var$objectPrototype = Object.prototype;
function $17c64bc07fd45005$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($17c64bc07fd45005$var$objectPrototype) {
            var inheritedComponent = $17c64bc07fd45005$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $17c64bc07fd45005$var$objectPrototype) $17c64bc07fd45005$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $17c64bc07fd45005$var$getOwnPropertyNames(sourceComponent);
        if ($17c64bc07fd45005$var$getOwnPropertySymbols) keys = keys.concat($17c64bc07fd45005$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $17c64bc07fd45005$var$getStatics(targetComponent);
        var sourceStatics = $17c64bc07fd45005$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$17c64bc07fd45005$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $17c64bc07fd45005$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $17c64bc07fd45005$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$17c64bc07fd45005$exports = $17c64bc07fd45005$var$hoistNonReactStatics;



var $3UfL2 = parcelRequire("3UfL2");

var $gqzfn = parcelRequire("gqzfn");
/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */ function $7eab73e273c8d95c$export$f535bb00660c42db(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function $7eab73e273c8d95c$export$76d90c956114f2c2(s, times) {
    if (typeof s.repeat === 'function') return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join('');
}
function $7eab73e273c8d95c$export$489176b9ebc725cc(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
function $7eab73e273c8d95c$export$d21499e79b5c28e2(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        $7eab73e273c8d95c$export$489176b9ebc725cc(map, pl, k, props[k]);
    }
}
function $7eab73e273c8d95c$export$3fae2929ed23c202(map, pl, field) {
    return $7eab73e273c8d95c$export$ca4e2274c058dd9f(map, pl, field)[field];
}
function $7eab73e273c8d95c$export$ca4e2274c058dd9f(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function $7eab73e273c8d95c$export$25c75e09b890f24e(patternPart) {
    return patternPart.type === 'literal';
}
function $7eab73e273c8d95c$export$fdab3c20aae16ddf(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
var $7eab73e273c8d95c$export$9049a02e759202e4 = /-u(?:-[0-9a-z]{2,8})+/gi;
function $7eab73e273c8d95c$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}



var $3UfL2 = parcelRequire("3UfL2");
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $3UfL2 = parcelRequire("3UfL2");

var $3UfL2 = parcelRequire("3UfL2");
var $57a9a58389365f3f$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($57a9a58389365f3f$export$896afd8541959ee5 || ($57a9a58389365f3f$export$896afd8541959ee5 = {}));



var $3UfL2 = parcelRequire("3UfL2");

var $96f218f36a66eae5$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($96f218f36a66eae5$export$b87f371cbc396fcf || ($96f218f36a66eae5$export$b87f371cbc396fcf = {}));
var $96f218f36a66eae5$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($96f218f36a66eae5$export$906452485466fa53 || ($96f218f36a66eae5$export$906452485466fa53 = {}));
function $96f218f36a66eae5$export$cfa10c5697238752(el) {
    return el.type === $96f218f36a66eae5$export$b87f371cbc396fcf.literal;
}
function $96f218f36a66eae5$export$4f55724281bdfaf9(el) {
    return el.type === $96f218f36a66eae5$export$b87f371cbc396fcf.argument;
}
function $96f218f36a66eae5$export$e11187b219e191e1(el) {
    return el.type === $96f218f36a66eae5$export$b87f371cbc396fcf.number;
}
function $96f218f36a66eae5$export$32d811605da75f40(el) {
    return el.type === $96f218f36a66eae5$export$b87f371cbc396fcf.date;
}
function $96f218f36a66eae5$export$34ec46f596b1702f(el) {
    return el.type === $96f218f36a66eae5$export$b87f371cbc396fcf.time;
}
function $96f218f36a66eae5$export$dcfe1c11d168b5a1(el) {
    return el.type === $96f218f36a66eae5$export$b87f371cbc396fcf.select;
}
function $96f218f36a66eae5$export$6c796d116f0a4fbc(el) {
    return el.type === $96f218f36a66eae5$export$b87f371cbc396fcf.plural;
}
function $96f218f36a66eae5$export$c0ece297bdd0c082(el) {
    return el.type === $96f218f36a66eae5$export$b87f371cbc396fcf.pound;
}
function $96f218f36a66eae5$export$5c83de34745812b(el) {
    return el.type === $96f218f36a66eae5$export$b87f371cbc396fcf.tag;
}
function $96f218f36a66eae5$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === 'object' && el.type === $96f218f36a66eae5$export$906452485466fa53.number);
}
function $96f218f36a66eae5$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === 'object' && el.type === $96f218f36a66eae5$export$906452485466fa53.dateTime);
}
function $96f218f36a66eae5$export$f0ac572c1121c662(value) {
    return {
        type: $96f218f36a66eae5$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $96f218f36a66eae5$export$425e864b0ba114f1(value, style) {
    return {
        type: $96f218f36a66eae5$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}


// @generated from regex-gen.ts
var $ca1a8830be176836$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $ca1a8830be176836$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;


/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $d0bef75c557b6c5f$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $d0bef75c557b6c5f$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($d0bef75c557b6c5f$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = [
                    'numeric',
                    '2-digit',
                    'short',
                    'long',
                    'narrow'
                ][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'short' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) throw new RangeError('`e..eee` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            case 'c':
                if (len < 4) throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            // Period
            case 'a':
                result.hour12 = true;
                break;
            case 'b':
            case 'B':
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            // Second
            case 's':
                result.second = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z':
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z':
            case 'O':
            case 'v':
            case 'V':
            case 'X':
            case 'x':
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}



var $3UfL2 = parcelRequire("3UfL2");
// @generated from regex-gen.ts
var $2fce5bdf6b59b15c$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;


function $eb02e10924ccdc68$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error('Number skeleton cannot be empty');
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $2fce5bdf6b59b15c$export$2b8db14d8bcaece7)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) throw new Error('Invalid number skeleton');
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error('Invalid number skeleton');
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $eb02e10924ccdc68$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var $eb02e10924ccdc68$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $eb02e10924ccdc68$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $eb02e10924ccdc68$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $eb02e10924ccdc68$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $eb02e10924ccdc68$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') result.roundingPriority = 'morePrecision';
    else if (str[str.length - 1] === 's') result.roundingPriority = 'lessPrecision';
    str.replace($eb02e10924ccdc68$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === '+') result.minimumSignificantDigits = g1.length;
        else if (g1[0] === '#') result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function $eb02e10924ccdc68$var$parseSign(str) {
    switch(str){
        case 'sign-auto':
            return {
                signDisplay: 'auto'
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting'
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always'
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting'
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero'
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting'
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never'
            };
    }
}
function $eb02e10924ccdc68$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering'
        };
        stem = stem.slice(2);
    } else if (stem[0] === 'E') {
        result = {
            notation: 'scientific'
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        } else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!$eb02e10924ccdc68$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error('Malformed concise eng/scientific notation');
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $eb02e10924ccdc68$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $eb02e10924ccdc68$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $eb02e10924ccdc68$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = $eb02e10924ccdc68$var$icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0, $3UfL2.__assign)((0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, result), {
                    notation: 'scientific'
                }), token.options.reduce(function(all, opt) {
                    return (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, all), $eb02e10924ccdc68$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'engineering':
                result = (0, $3UfL2.__assign)((0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, result), {
                    notation: 'engineering'
                }), token.options.reduce(function(all, opt) {
                    return (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, all), $eb02e10924ccdc68$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) throw new RangeError('integer-width stems only accept a single optional option');
                token.options[0].replace($eb02e10924ccdc68$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error('We currently do not support maximum integer digits');
                    else if (g5) throw new Error('We currently do not support exact integer digits');
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($eb02e10924ccdc68$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($eb02e10924ccdc68$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError('Fraction-precision stems only accept a single optional option');
            token.stem.replace($eb02e10924ccdc68$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === '#') result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') result = (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, result), {
                trailingZeroDisplay: 'stripIfInteger'
            });
            else if (opt) result = (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, result), $eb02e10924ccdc68$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($eb02e10924ccdc68$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, result), $eb02e10924ccdc68$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $eb02e10924ccdc68$var$parseSign(token.stem);
        if (signOpts) result = (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $eb02e10924ccdc68$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}




// @generated from time-data-gen.ts
// prettier-ignore  
var $785c41ce4c837db1$export$a8c9209db4084317 = {
    "AX": [
        "H"
    ],
    "BQ": [
        "H"
    ],
    "CP": [
        "H"
    ],
    "CZ": [
        "H"
    ],
    "DK": [
        "H"
    ],
    "FI": [
        "H"
    ],
    "ID": [
        "H"
    ],
    "IS": [
        "H"
    ],
    "ML": [
        "H"
    ],
    "NE": [
        "H"
    ],
    "RU": [
        "H"
    ],
    "SE": [
        "H"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "AS": [
        "h",
        "H"
    ],
    "BT": [
        "h",
        "H"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "GH": [
        "h",
        "H"
    ],
    "IN": [
        "h",
        "H"
    ],
    "LS": [
        "h",
        "H"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PW": [
        "h",
        "H"
    ],
    "SO": [
        "h",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WS": [
        "h",
        "H"
    ],
    "001": [
        "H",
        "h"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "JP": [
        "H",
        "h",
        "K"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ]
};


function $796988df45994da9$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = $796988df45994da9$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $796988df45994da9$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, $785c41ce4c837db1$export$a8c9209db4084317)[regionTag || ''] || (0, $785c41ce4c837db1$export$a8c9209db4084317)[languageTag || ''] || (0, $785c41ce4c837db1$export$a8c9209db4084317)["".concat(languageTag, "-001")] || (0, $785c41ce4c837db1$export$a8c9209db4084317)['001'];
    return hourCycles[0];
}


var $fe95e3cb6a3a71b7$var$_a;
var $fe95e3cb6a3a71b7$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $ca1a8830be176836$export$523451f94304dd6c).source, "*"));
var $fe95e3cb6a3a71b7$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $ca1a8830be176836$export$523451f94304dd6c).source, "*$"));
function $fe95e3cb6a3a71b7$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $fe95e3cb6a3a71b7$var$hasNativeStartsWith = !!String.prototype.startsWith;
var $fe95e3cb6a3a71b7$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $fe95e3cb6a3a71b7$var$hasNativeFromEntries = !!Object.fromEntries;
var $fe95e3cb6a3a71b7$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $fe95e3cb6a3a71b7$var$hasTrimStart = !!String.prototype.trimStart;
var $fe95e3cb6a3a71b7$var$hasTrimEnd = !!String.prototype.trimEnd;
var $fe95e3cb6a3a71b7$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $fe95e3cb6a3a71b7$var$isSafeInteger = $fe95e3cb6a3a71b7$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $fe95e3cb6a3a71b7$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $fe95e3cb6a3a71b7$var$re = $fe95e3cb6a3a71b7$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $fe95e3cb6a3a71b7$var$REGEX_SUPPORTS_U_AND_Y = (($fe95e3cb6a3a71b7$var$_a = $fe95e3cb6a3a71b7$var$re.exec('a')) === null || $fe95e3cb6a3a71b7$var$_a === void 0 ? void 0 : $fe95e3cb6a3a71b7$var$_a[0]) === 'a';
} catch (_) {
    $fe95e3cb6a3a71b7$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $fe95e3cb6a3a71b7$var$startsWith = $fe95e3cb6a3a71b7$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $fe95e3cb6a3a71b7$var$fromCodePoint = $fe95e3cb6a3a71b7$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $fe95e3cb6a3a71b7$var$fromEntries = // native
$fe95e3cb6a3a71b7$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $fe95e3cb6a3a71b7$var$codePointAt = $fe95e3cb6a3a71b7$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $fe95e3cb6a3a71b7$var$trimStart = $fe95e3cb6a3a71b7$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($fe95e3cb6a3a71b7$var$SPACE_SEPARATOR_START_REGEX, '');
};
var $fe95e3cb6a3a71b7$var$trimEnd = $fe95e3cb6a3a71b7$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($fe95e3cb6a3a71b7$var$SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $fe95e3cb6a3a71b7$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $fe95e3cb6a3a71b7$var$matchIdentifierAtIndex;
if ($fe95e3cb6a3a71b7$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $fe95e3cb6a3a71b7$var$IDENTIFIER_PREFIX_RE_1 = $fe95e3cb6a3a71b7$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    $fe95e3cb6a3a71b7$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $fe95e3cb6a3a71b7$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $fe95e3cb6a3a71b7$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
$fe95e3cb6a3a71b7$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $fe95e3cb6a3a71b7$var$codePointAt(s, index);
        if (c === undefined || $fe95e3cb6a3a71b7$var$_isWhiteSpace(c) || $fe95e3cb6a3a71b7$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $fe95e3cb6a3a71b7$var$fromCodePoint.apply(void 0, match);
};
var $fe95e3cb6a3a71b7$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $96f218f36a66eae5$export$b87f371cbc396fcf).pound,
                    location: $fe95e3cb6a3a71b7$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $57a9a58389365f3f$export$896afd8541959ee5).UNMATCHED_CLOSING_TAG, $fe95e3cb6a3a71b7$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $fe95e3cb6a3a71b7$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, $96f218f36a66eae5$export$b87f371cbc396fcf).literal,
                value: "<".concat(tagName, "/>"),
                location: $fe95e3cb6a3a71b7$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !$fe95e3cb6a3a71b7$var$_isAlpha(this.char())) return this.error((0, $57a9a58389365f3f$export$896afd8541959ee5).INVALID_TAG, $fe95e3cb6a3a71b7$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $57a9a58389365f3f$export$896afd8541959ee5).UNMATCHED_CLOSING_TAG, $fe95e3cb6a3a71b7$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, $57a9a58389365f3f$export$896afd8541959ee5).INVALID_TAG, $fe95e3cb6a3a71b7$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $96f218f36a66eae5$export$b87f371cbc396fcf).tag,
                        value: tagName,
                        children: children,
                        location: $fe95e3cb6a3a71b7$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $57a9a58389365f3f$export$896afd8541959ee5).UNCLOSED_TAG, $fe95e3cb6a3a71b7$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $57a9a58389365f3f$export$896afd8541959ee5).INVALID_TAG, $fe95e3cb6a3a71b7$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $fe95e3cb6a3a71b7$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $fe95e3cb6a3a71b7$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $96f218f36a66eae5$export$b87f371cbc396fcf).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$fe95e3cb6a3a71b7$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $fe95e3cb6a3a71b7$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $fe95e3cb6a3a71b7$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $57a9a58389365f3f$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $fe95e3cb6a3a71b7$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $57a9a58389365f3f$export$896afd8541959ee5).EMPTY_ARGUMENT, $fe95e3cb6a3a71b7$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $57a9a58389365f3f$export$896afd8541959ee5).MALFORMED_ARGUMENT, $fe95e3cb6a3a71b7$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $57a9a58389365f3f$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $fe95e3cb6a3a71b7$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $96f218f36a66eae5$export$b87f371cbc396fcf).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $fe95e3cb6a3a71b7$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $57a9a58389365f3f$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $fe95e3cb6a3a71b7$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $57a9a58389365f3f$export$896afd8541959ee5).MALFORMED_ARGUMENT, $fe95e3cb6a3a71b7$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $fe95e3cb6a3a71b7$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $fe95e3cb6a3a71b7$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $57a9a58389365f3f$export$896afd8541959ee5).EXPECT_ARGUMENT_TYPE, $fe95e3cb6a3a71b7$var$createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $fe95e3cb6a3a71b7$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $57a9a58389365f3f$export$896afd8541959ee5).EXPECT_ARGUMENT_STYLE, $fe95e3cb6a3a71b7$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $fe95e3cb6a3a71b7$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $fe95e3cb6a3a71b7$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $fe95e3cb6a3a71b7$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $fe95e3cb6a3a71b7$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $96f218f36a66eae5$export$b87f371cbc396fcf).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $57a9a58389365f3f$export$896afd8541959ee5).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $796988df45994da9$export$29c5368be8904d27)(skeleton, this.locale);
                        var style = {
                            type: (0, $96f218f36a66eae5$export$906452485466fa53).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $d0bef75c557b6c5f$export$f7b99fb377fe69fa)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, $96f218f36a66eae5$export$b87f371cbc396fcf).date : (0, $96f218f36a66eae5$export$b87f371cbc396fcf).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, $96f218f36a66eae5$export$b87f371cbc396fcf).number : argType === 'date' ? (0, $96f218f36a66eae5$export$b87f371cbc396fcf).date : (0, $96f218f36a66eae5$export$b87f371cbc396fcf).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, $57a9a58389365f3f$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_OPTIONS, $fe95e3cb6a3a71b7$var$createLocation(typeEndPosition_1, (0, $3UfL2.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, $57a9a58389365f3f$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $fe95e3cb6a3a71b7$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $57a9a58389365f3f$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $57a9a58389365f3f$export$896afd8541959ee5).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $fe95e3cb6a3a71b7$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, $96f218f36a66eae5$export$b87f371cbc396fcf).select,
                        value: value,
                        options: $fe95e3cb6a3a71b7$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $96f218f36a66eae5$export$b87f371cbc396fcf).plural,
                        value: value,
                        options: $fe95e3cb6a3a71b7$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $57a9a58389365f3f$export$896afd8541959ee5).INVALID_ARGUMENT_TYPE, $fe95e3cb6a3a71b7$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $57a9a58389365f3f$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $fe95e3cb6a3a71b7$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $57a9a58389365f3f$export$896afd8541959ee5).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $fe95e3cb6a3a71b7$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $eb02e10924ccdc68$export$71cee2f16fba2480)(skeleton);
        } catch (e) {
            return this.error((0, $57a9a58389365f3f$export$896afd8541959ee5).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $96f218f36a66eae5$export$906452485466fa53).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $eb02e10924ccdc68$export$47c6f8480bda3e11)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $57a9a58389365f3f$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $57a9a58389365f3f$export$896afd8541959ee5).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $fe95e3cb6a3a71b7$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, $57a9a58389365f3f$export$896afd8541959ee5).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $57a9a58389365f3f$export$896afd8541959ee5).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, $57a9a58389365f3f$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $57a9a58389365f3f$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $fe95e3cb6a3a71b7$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $fe95e3cb6a3a71b7$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, $57a9a58389365f3f$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $57a9a58389365f3f$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR, $fe95e3cb6a3a71b7$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $57a9a58389365f3f$export$896afd8541959ee5).MISSING_OTHER_CLAUSE, $fe95e3cb6a3a71b7$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $fe95e3cb6a3a71b7$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$fe95e3cb6a3a71b7$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = $fe95e3cb6a3a71b7$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($fe95e3cb6a3a71b7$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $fe95e3cb6a3a71b7$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $fe95e3cb6a3a71b7$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $fe95e3cb6a3a71b7$var$_isAlphaOrSlash(codepoint) {
    return $fe95e3cb6a3a71b7$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $fe95e3cb6a3a71b7$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $fe95e3cb6a3a71b7$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $fe95e3cb6a3a71b7$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}



function $a382295616956c70$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $96f218f36a66eae5$export$dcfe1c11d168b5a1)(el) || (0, $96f218f36a66eae5$export$6c796d116f0a4fbc)(el)) for(var k in el.options){
            delete el.options[k].location;
            $a382295616956c70$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $96f218f36a66eae5$export$e11187b219e191e1)(el) && (0, $96f218f36a66eae5$export$3f9a19cd4152eda3)(el.style)) delete el.style.location;
        else if (((0, $96f218f36a66eae5$export$32d811605da75f40)(el) || (0, $96f218f36a66eae5$export$34ec46f596b1702f)(el)) && (0, $96f218f36a66eae5$export$7680c41f1a55f4cf)(el.style)) delete el.style.location;
        else if ((0, $96f218f36a66eae5$export$5c83de34745812b)(el)) $a382295616956c70$var$pruneLocation(el.children);
    });
}
function $a382295616956c70$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $3UfL2.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $fe95e3cb6a3a71b7$export$7acfa6ed01010e37)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $57a9a58389365f3f$export$896afd8541959ee5)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $a382295616956c70$var$pruneLocation(result.val);
    return result.val;
}


//
// Main
//
function $ca323c62fc346de1$export$2e2bcd8739ae039(fn, options) {
    var cache = options && options.cache ? options.cache : $ca323c62fc346de1$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $ca323c62fc346de1$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $ca323c62fc346de1$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $ca323c62fc346de1$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $ca323c62fc346de1$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $ca323c62fc346de1$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $ca323c62fc346de1$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $ca323c62fc346de1$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $ca323c62fc346de1$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $ca323c62fc346de1$var$monadic : $ca323c62fc346de1$var$variadic;
    return $ca323c62fc346de1$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $ca323c62fc346de1$var$strategyVariadic(fn, options) {
    return $ca323c62fc346de1$var$assemble(fn, this, $ca323c62fc346de1$var$variadic, options.cache.create(), options.serializer);
}
function $ca323c62fc346de1$var$strategyMonadic(fn, options) {
    return $ca323c62fc346de1$var$assemble(fn, this, $ca323c62fc346de1$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $ca323c62fc346de1$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $ca323c62fc346de1$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$ca323c62fc346de1$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$ca323c62fc346de1$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $ca323c62fc346de1$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $ca323c62fc346de1$var$ObjectWithoutPrototypeCache();
    }
};
var $ca323c62fc346de1$export$c5491a8691a23b9e = {
    variadic: $ca323c62fc346de1$var$strategyVariadic,
    monadic: $ca323c62fc346de1$var$strategyMonadic
};




var $3UfL2 = parcelRequire("3UfL2");
var $c3cd14e89459dc3b$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($c3cd14e89459dc3b$export$d4e71bc0b80dc0fb || ($c3cd14e89459dc3b$export$d4e71bc0b80dc0fb = {}));
var $c3cd14e89459dc3b$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $3UfL2.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $c3cd14e89459dc3b$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $3UfL2.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), $c3cd14e89459dc3b$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($c3cd14e89459dc3b$export$7369836851cc1329);
var $c3cd14e89459dc3b$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $3UfL2.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), $c3cd14e89459dc3b$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($c3cd14e89459dc3b$export$7369836851cc1329);
var $c3cd14e89459dc3b$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $3UfL2.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), $c3cd14e89459dc3b$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($c3cd14e89459dc3b$export$7369836851cc1329);


var $35d3d31c7efcd9a5$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($35d3d31c7efcd9a5$export$49694c2877b44c57 || ($35d3d31c7efcd9a5$export$49694c2877b44c57 = {}));
function $35d3d31c7efcd9a5$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $35d3d31c7efcd9a5$export$49694c2877b44c57.literal || part.type !== $35d3d31c7efcd9a5$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $35d3d31c7efcd9a5$export$df0c12a2d414a163(el) {
    return typeof el === 'function';
}
function $35d3d31c7efcd9a5$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $96f218f36a66eae5$export$cfa10c5697238752)(els[0])) return [
        {
            type: $35d3d31c7efcd9a5$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $96f218f36a66eae5$export$cfa10c5697238752)(el)) {
            result.push({
                type: $35d3d31c7efcd9a5$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $96f218f36a66eae5$export$c0ece297bdd0c082)(el)) {
            if (typeof currentPluralValue === 'number') result.push({
                type: $35d3d31c7efcd9a5$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $c3cd14e89459dc3b$export$8bfc137e4d23fdf0)(varName, originalMessage);
        var value = values[varName];
        if ((0, $96f218f36a66eae5$export$4f55724281bdfaf9)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') value = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
            result.push({
                type: typeof value === 'string' ? $35d3d31c7efcd9a5$export$49694c2877b44c57.literal : $35d3d31c7efcd9a5$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $96f218f36a66eae5$export$32d811605da75f40)(el)) {
            var style = typeof el.style === 'string' ? formats.date[el.style] : (0, $96f218f36a66eae5$export$7680c41f1a55f4cf)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $35d3d31c7efcd9a5$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $96f218f36a66eae5$export$34ec46f596b1702f)(el)) {
            var style = typeof el.style === 'string' ? formats.time[el.style] : (0, $96f218f36a66eae5$export$7680c41f1a55f4cf)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $35d3d31c7efcd9a5$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $96f218f36a66eae5$export$e11187b219e191e1)(el)) {
            var style = typeof el.style === 'string' ? formats.number[el.style] : (0, $96f218f36a66eae5$export$3f9a19cd4152eda3)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $35d3d31c7efcd9a5$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $96f218f36a66eae5$export$5c83de34745812b)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$35d3d31c7efcd9a5$export$df0c12a2d414a163(formatFn)) throw new (0, $c3cd14e89459dc3b$export$cbc0db47c750f7c9)(value_1, 'function', originalMessage);
            var parts = $35d3d31c7efcd9a5$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === 'string' ? $35d3d31c7efcd9a5$export$49694c2877b44c57.literal : $35d3d31c7efcd9a5$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $96f218f36a66eae5$export$dcfe1c11d168b5a1)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $c3cd14e89459dc3b$export$565c3afc07dfa382)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $35d3d31c7efcd9a5$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $96f218f36a66eae5$export$6c796d116f0a4fbc)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $c3cd14e89459dc3b$export$7369836851cc1329)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $c3cd14e89459dc3b$export$d4e71bc0b80dc0fb).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $c3cd14e89459dc3b$export$565c3afc07dfa382)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $35d3d31c7efcd9a5$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $35d3d31c7efcd9a5$var$mergeLiteral(result);
}


// -- MessageFormat --------------------------------------------------------
function $d3d147c7a00806ca$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $3UfL2.__assign)((0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $d3d147c7a00806ca$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $d3d147c7a00806ca$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $3UfL2.__assign)({}, defaultConfig));
}
function $d3d147c7a00806ca$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $d3d147c7a00806ca$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $ca323c62fc346de1$export$2e2bcd8739ae039)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $3UfL2.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $d3d147c7a00806ca$var$createFastMemoizeCache(cache.number),
            strategy: (0, $ca323c62fc346de1$export$c5491a8691a23b9e).variadic
        }),
        getDateTimeFormat: (0, $ca323c62fc346de1$export$2e2bcd8739ae039)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $3UfL2.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $d3d147c7a00806ca$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $ca323c62fc346de1$export$c5491a8691a23b9e).variadic
        }),
        getPluralRules: (0, $ca323c62fc346de1$export$2e2bcd8739ae039)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $3UfL2.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $d3d147c7a00806ca$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $ca323c62fc346de1$export$c5491a8691a23b9e).variadic
        })
    };
}
var $d3d147c7a00806ca$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        var _this = this;
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $35d3d31c7efcd9a5$export$49694c2877b44c57).literal || typeof all[all.length - 1] !== 'string') all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || '';
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $35d3d31c7efcd9a5$export$275d4a3bb5f66fda)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            return {
                locale: _this.resolvedLocale.toString()
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, {
                ignoreTag: opts === null || opts === void 0 ? void 0 : opts.ignoreTag,
                locale: this.resolvedLocale
            });
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError('A message must be provided as a String or AST.');
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $d3d147c7a00806ca$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $d3d147c7a00806ca$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $a382295616956c70$export$98e6a39c04603d36);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: 'currency'
            },
            percent: {
                style: 'percent'
            }
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit'
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric'
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            }
        }
    };
    return IntlMessageFormat;
}();


//
// Main
//
function $df9992fc5f904686$export$2e2bcd8739ae039(fn, options) {
    var cache = options && options.cache ? options.cache : $df9992fc5f904686$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $df9992fc5f904686$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $df9992fc5f904686$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $df9992fc5f904686$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $df9992fc5f904686$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $df9992fc5f904686$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $df9992fc5f904686$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $df9992fc5f904686$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $df9992fc5f904686$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $df9992fc5f904686$var$monadic : $df9992fc5f904686$var$variadic;
    return $df9992fc5f904686$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $df9992fc5f904686$var$strategyVariadic(fn, options) {
    return $df9992fc5f904686$var$assemble(fn, this, $df9992fc5f904686$var$variadic, options.cache.create(), options.serializer);
}
function $df9992fc5f904686$var$strategyMonadic(fn, options) {
    return $df9992fc5f904686$var$assemble(fn, this, $df9992fc5f904686$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $df9992fc5f904686$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $df9992fc5f904686$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$df9992fc5f904686$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$df9992fc5f904686$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $df9992fc5f904686$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $df9992fc5f904686$var$ObjectWithoutPrototypeCache();
    }
};
var $df9992fc5f904686$export$c5491a8691a23b9e = {
    variadic: $df9992fc5f904686$var$strategyVariadic,
    monadic: $df9992fc5f904686$var$strategyMonadic
};



var $3UfL2 = parcelRequire("3UfL2");
var $31ecea3bffece3c6$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($31ecea3bffece3c6$export$557d6acb76e8a244 || ($31ecea3bffece3c6$export$557d6acb76e8a244 = {}));
var $31ecea3bffece3c6$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $3UfL2.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, " \n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $31ecea3bffece3c6$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $3UfL2.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $31ecea3bffece3c6$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($31ecea3bffece3c6$export$c016d36112f6ddf8);
var $31ecea3bffece3c6$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $3UfL2.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $31ecea3bffece3c6$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($31ecea3bffece3c6$export$c016d36112f6ddf8);
var $31ecea3bffece3c6$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $3UfL2.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $31ecea3bffece3c6$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($31ecea3bffece3c6$export$c016d36112f6ddf8);
var $31ecea3bffece3c6$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $3UfL2.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        return _super.call(this, $31ecea3bffece3c6$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, " \nLocale: ").concat(locale, "\n"), exception) || this;
    }
    return IntlFormatError;
}($31ecea3bffece3c6$export$c016d36112f6ddf8);
var $31ecea3bffece3c6$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $3UfL2.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, " \nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, " \n"), locale, exception) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MessageFormatError;
}($31ecea3bffece3c6$export$e3b7eee1dbc44895);
var $31ecea3bffece3c6$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $3UfL2.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $31ecea3bffece3c6$export$557d6acb76e8a244.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage ? 'default message' : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($31ecea3bffece3c6$export$c016d36112f6ddf8);


function $63813af6b39852dc$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $63813af6b39852dc$var$defaultErrorHandler = function(error) {};
var $63813af6b39852dc$var$defaultWarnHandler = function(warning) {};
var $63813af6b39852dc$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $63813af6b39852dc$var$defaultErrorHandler,
    onWarn: $63813af6b39852dc$var$defaultWarnHandler
};
function $63813af6b39852dc$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $63813af6b39852dc$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $63813af6b39852dc$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $63813af6b39852dc$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $df9992fc5f904686$export$2e2bcd8739ae039)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $3UfL2.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $63813af6b39852dc$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $df9992fc5f904686$export$c5491a8691a23b9e).variadic
    });
    var getNumberFormat = (0, $df9992fc5f904686$export$2e2bcd8739ae039)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $3UfL2.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $63813af6b39852dc$var$createFastMemoizeCache(cache.number),
        strategy: (0, $df9992fc5f904686$export$c5491a8691a23b9e).variadic
    });
    var getPluralRules = (0, $df9992fc5f904686$export$2e2bcd8739ae039)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $3UfL2.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $63813af6b39852dc$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $df9992fc5f904686$export$c5491a8691a23b9e).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $df9992fc5f904686$export$2e2bcd8739ae039)(function(message, locales, overrideFormats, opts) {
            return new (0, $d3d147c7a00806ca$export$d342343268debc40)(message, locales, overrideFormats, (0, $3UfL2.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $63813af6b39852dc$var$createFastMemoizeCache(cache.message),
            strategy: (0, $df9992fc5f904686$export$c5491a8691a23b9e).variadic
        }),
        getRelativeTimeFormat: (0, $df9992fc5f904686$export$2e2bcd8739ae039)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $3UfL2.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $63813af6b39852dc$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $df9992fc5f904686$export$c5491a8691a23b9e).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $df9992fc5f904686$export$2e2bcd8739ae039)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $3UfL2.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $63813af6b39852dc$var$createFastMemoizeCache(cache.list),
            strategy: (0, $df9992fc5f904686$export$c5491a8691a23b9e).variadic
        }),
        getDisplayNames: (0, $df9992fc5f904686$export$2e2bcd8739ae039)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $3UfL2.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $63813af6b39852dc$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $df9992fc5f904686$export$c5491a8691a23b9e).variadic
        })
    };
}
function $63813af6b39852dc$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $31ecea3bffece3c6$export$549f97e137a05c90)("No ".concat(type, " format named: ").concat(name)));
}


function $346592d1d496bc47$export$45c4bbf6e55bba1f(intl) {
    (0, $7eab73e273c8d95c$export$f5708dca728d7177)(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $346592d1d496bc47$export$b52f8d6fc0d47415 = (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, (0, $63813af6b39852dc$export$b52f8d6fc0d47415)), {
    textComponent: $gqzfn.Fragment
});
function $346592d1d496bc47$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($gqzfn.Children.toArray(parts));
    };
}
function $346592d1d496bc47$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}


function $851fcbc24b6958a0$var$getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}
// TODO: We should provide initial value here
var $851fcbc24b6958a0$var$IntlContext = $gqzfn.createContext(null);
var $851fcbc24b6958a0$var$IntlConsumer = $851fcbc24b6958a0$var$IntlContext.Consumer, $851fcbc24b6958a0$var$IntlProvider = $851fcbc24b6958a0$var$IntlContext.Provider;
var $851fcbc24b6958a0$export$2881499e37b75b9a = $851fcbc24b6958a0$var$IntlProvider;
var $851fcbc24b6958a0$export$841858b892ce1f4c = $851fcbc24b6958a0$var$IntlContext;
function $851fcbc24b6958a0$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? 'intl' : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $gqzfn.createElement($851fcbc24b6958a0$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $346592d1d496bc47$export$45c4bbf6e55bba1f)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $gqzfn.createElement(WrappedComponent, (0, $3UfL2.__assign)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($851fcbc24b6958a0$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($17c64bc07fd45005$exports)))($gqzfn.forwardRef(function(props, ref) {
        return $gqzfn.createElement(WithIntl, (0, $3UfL2.__assign)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($17c64bc07fd45005$exports)))(WithIntl, WrappedComponent);
}



function $261d614963c985eb$export$2e2bcd8739ae039() {
    var intl = $gqzfn.useContext((0, $851fcbc24b6958a0$export$841858b892ce1f4c));
    (0, $346592d1d496bc47$export$45c4bbf6e55bba1f)(intl);
    return intl;
}



function $2313c76058eae75b$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, $3UfL2.__rest)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, $3UfL2.__rest)(nextProps, [
        "values"
    ]);
    return (0, $346592d1d496bc47$export$d36bdfa510afb180)(nextValues, values) && (0, $346592d1d496bc47$export$d36bdfa510afb180)(otherProps, nextOtherProps);
}
function $2313c76058eae75b$var$FormattedMessage(props) {
    var intl = (0, $261d614963c985eb$export$2e2bcd8739ae039)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $gqzfn.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === 'function') return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $gqzfn.createElement(Component, null, $gqzfn.Children.toArray(nodes));
    return $gqzfn.createElement($gqzfn.Fragment, null, nodes);
}
$2313c76058eae75b$var$FormattedMessage.displayName = 'FormattedMessage';
var $2313c76058eae75b$var$MemoizedFormattedMessage = $gqzfn.memo($2313c76058eae75b$var$FormattedMessage, $2313c76058eae75b$var$areEqual);
$2313c76058eae75b$var$MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
var $2313c76058eae75b$export$2e2bcd8739ae039 = $2313c76058eae75b$var$MemoizedFormattedMessage;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $3UfL2 = parcelRequire("3UfL2");

var $gqzfn = parcelRequire("gqzfn");



var $3UfL2 = parcelRequire("3UfL2");




var $fa81c44a795db8cf$var$NUMBER_FORMAT_OPTIONS = [
    'localeMatcher',
    'style',
    'currency',
    'currencyDisplay',
    'unit',
    'unitDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    // ES2020 NumberFormat
    'compactDisplay',
    'currencyDisplay',
    'currencySign',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'numberingSystem'
];
function $fa81c44a795db8cf$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $63813af6b39852dc$export$4ee1db8ce44a209b)(formats, 'number', format, onError) || {};
    var filteredOptions = (0, $63813af6b39852dc$export$d697c39a2985a4c)(options, $fa81c44a795db8cf$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $fa81c44a795db8cf$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $fa81c44a795db8cf$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $31ecea3bffece3c6$export$c016d36112f6ddf8)((0, $31ecea3bffece3c6$export$557d6acb76e8a244).FORMAT_ERROR, 'Error formatting number.', e));
    }
    return String(value);
}
function $fa81c44a795db8cf$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $fa81c44a795db8cf$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $31ecea3bffece3c6$export$c016d36112f6ddf8)((0, $31ecea3bffece3c6$export$557d6acb76e8a244).FORMAT_ERROR, 'Error formatting number.', e));
    }
    return [];
}





var $8513df11ff22aca4$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    'numeric',
    'style'
];
function $8513df11ff22aca4$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $63813af6b39852dc$export$4ee1db8ce44a209b)(formats, 'relative', format, onError) || {};
    var filteredOptions = (0, $63813af6b39852dc$export$d697c39a2985a4c)(options, $8513df11ff22aca4$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $8513df11ff22aca4$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = 'second';
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $c3cd14e89459dc3b$export$7369836851cc1329)("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", (0, $c3cd14e89459dc3b$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    try {
        return $8513df11ff22aca4$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $31ecea3bffece3c6$export$e3b7eee1dbc44895)('Error formatting relative time.', config.locale, e));
    }
    return String(value);
}



var $3UfL2 = parcelRequire("3UfL2");


var $fa8b71aa6f3aacc1$var$DATE_TIME_FORMAT_OPTIONS = [
    'localeMatcher',
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    // 'dayPeriod',
    'numberingSystem'
];
function $fa8b71aa6f3aacc1$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $63813af6b39852dc$export$4ee1db8ce44a209b)(formats, type, format, onError));
    var filteredOptions = (0, $63813af6b39852dc$export$d697c39a2985a4c)(options, $fa8b71aa6f3aacc1$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === 'time' && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, filteredOptions), {
        hour: 'numeric',
        minute: 'numeric'
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $fa8b71aa6f3aacc1$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $fa8b71aa6f3aacc1$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $31ecea3bffece3c6$export$c016d36112f6ddf8)((0, $31ecea3bffece3c6$export$557d6acb76e8a244).FORMAT_ERROR, 'Error formatting date.', e));
    }
    return String(date);
}
function $fa8b71aa6f3aacc1$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $fa8b71aa6f3aacc1$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $31ecea3bffece3c6$export$c016d36112f6ddf8)((0, $31ecea3bffece3c6$export$557d6acb76e8a244).FORMAT_ERROR, 'Error formatting time.', e));
    }
    return String(date);
}
function $fa8b71aa6f3aacc1$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0, $63813af6b39852dc$export$d697c39a2985a4c)(options, $fa8b71aa6f3aacc1$var$DATE_TIME_FORMAT_OPTIONS, timeZone ? {
        timeZone: timeZone
    } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    } catch (e) {
        onError(new (0, $31ecea3bffece3c6$export$c016d36112f6ddf8)((0, $31ecea3bffece3c6$export$557d6acb76e8a244).FORMAT_ERROR, 'Error formatting date time range.', e));
    }
    return String(from);
}
function $fa8b71aa6f3aacc1$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $fa8b71aa6f3aacc1$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).formatToParts(date);
    } catch (e) {
        config.onError(new (0, $31ecea3bffece3c6$export$c016d36112f6ddf8)((0, $31ecea3bffece3c6$export$557d6acb76e8a244).FORMAT_ERROR, 'Error formatting date.', e));
    }
    return [];
}
function $fa8b71aa6f3aacc1$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $fa8b71aa6f3aacc1$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).formatToParts(date);
    } catch (e) {
        config.onError(new (0, $31ecea3bffece3c6$export$c016d36112f6ddf8)((0, $31ecea3bffece3c6$export$557d6acb76e8a244).FORMAT_ERROR, 'Error formatting time.', e));
    }
    return [];
}





var $d5baca915cd57db1$var$PLURAL_FORMAT_OPTIONS = [
    'localeMatcher',
    'type'
];
function $d5baca915cd57db1$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $c3cd14e89459dc3b$export$7369836851cc1329)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $c3cd14e89459dc3b$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    var filteredOptions = (0, $63813af6b39852dc$export$d697c39a2985a4c)(options, $d5baca915cd57db1$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $31ecea3bffece3c6$export$e3b7eee1dbc44895)('Error formatting plural.', locale, e));
    }
    return 'other';
}



var $3UfL2 = parcelRequire("3UfL2");
/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */ function $98a440be037a3fc5$export$f535bb00660c42db(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function $98a440be037a3fc5$export$76d90c956114f2c2(s, times) {
    if (typeof s.repeat === 'function') return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join('');
}
function $98a440be037a3fc5$export$489176b9ebc725cc(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
function $98a440be037a3fc5$export$d21499e79b5c28e2(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        $98a440be037a3fc5$export$489176b9ebc725cc(map, pl, k, props[k]);
    }
}
function $98a440be037a3fc5$export$3fae2929ed23c202(map, pl, field) {
    return $98a440be037a3fc5$export$ca4e2274c058dd9f(map, pl, field)[field];
}
function $98a440be037a3fc5$export$ca4e2274c058dd9f(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function $98a440be037a3fc5$export$25c75e09b890f24e(patternPart) {
    return patternPart.type === 'literal';
}
function $98a440be037a3fc5$export$fdab3c20aae16ddf(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
var $98a440be037a3fc5$export$9049a02e759202e4 = /-u(?:-[0-9a-z]{2,8})+/gi;
function $98a440be037a3fc5$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}





var $3UfL2 = parcelRequire("3UfL2");
var $76e187d312d35f56$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($76e187d312d35f56$export$896afd8541959ee5 || ($76e187d312d35f56$export$896afd8541959ee5 = {}));



var $3UfL2 = parcelRequire("3UfL2");

var $6a00417c031ec97e$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($6a00417c031ec97e$export$b87f371cbc396fcf || ($6a00417c031ec97e$export$b87f371cbc396fcf = {}));
var $6a00417c031ec97e$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($6a00417c031ec97e$export$906452485466fa53 || ($6a00417c031ec97e$export$906452485466fa53 = {}));
function $6a00417c031ec97e$export$cfa10c5697238752(el) {
    return el.type === $6a00417c031ec97e$export$b87f371cbc396fcf.literal;
}
function $6a00417c031ec97e$export$4f55724281bdfaf9(el) {
    return el.type === $6a00417c031ec97e$export$b87f371cbc396fcf.argument;
}
function $6a00417c031ec97e$export$e11187b219e191e1(el) {
    return el.type === $6a00417c031ec97e$export$b87f371cbc396fcf.number;
}
function $6a00417c031ec97e$export$32d811605da75f40(el) {
    return el.type === $6a00417c031ec97e$export$b87f371cbc396fcf.date;
}
function $6a00417c031ec97e$export$34ec46f596b1702f(el) {
    return el.type === $6a00417c031ec97e$export$b87f371cbc396fcf.time;
}
function $6a00417c031ec97e$export$dcfe1c11d168b5a1(el) {
    return el.type === $6a00417c031ec97e$export$b87f371cbc396fcf.select;
}
function $6a00417c031ec97e$export$6c796d116f0a4fbc(el) {
    return el.type === $6a00417c031ec97e$export$b87f371cbc396fcf.plural;
}
function $6a00417c031ec97e$export$c0ece297bdd0c082(el) {
    return el.type === $6a00417c031ec97e$export$b87f371cbc396fcf.pound;
}
function $6a00417c031ec97e$export$5c83de34745812b(el) {
    return el.type === $6a00417c031ec97e$export$b87f371cbc396fcf.tag;
}
function $6a00417c031ec97e$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === 'object' && el.type === $6a00417c031ec97e$export$906452485466fa53.number);
}
function $6a00417c031ec97e$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === 'object' && el.type === $6a00417c031ec97e$export$906452485466fa53.dateTime);
}
function $6a00417c031ec97e$export$f0ac572c1121c662(value) {
    return {
        type: $6a00417c031ec97e$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $6a00417c031ec97e$export$425e864b0ba114f1(value, style) {
    return {
        type: $6a00417c031ec97e$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}


// @generated from regex-gen.ts
var $55c400f081b9c8b0$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $55c400f081b9c8b0$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;



// @generated from time-data-gen.ts
// prettier-ignore  
var $f41c229a247d7c5e$export$a8c9209db4084317 = {
    "AX": [
        "H"
    ],
    "BQ": [
        "H"
    ],
    "CP": [
        "H"
    ],
    "CZ": [
        "H"
    ],
    "DK": [
        "H"
    ],
    "FI": [
        "H"
    ],
    "ID": [
        "H"
    ],
    "IS": [
        "H"
    ],
    "ML": [
        "H"
    ],
    "NE": [
        "H"
    ],
    "RU": [
        "H"
    ],
    "SE": [
        "H"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "AS": [
        "h",
        "H"
    ],
    "BT": [
        "h",
        "H"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "GH": [
        "h",
        "H"
    ],
    "IN": [
        "h",
        "H"
    ],
    "LS": [
        "h",
        "H"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PW": [
        "h",
        "H"
    ],
    "SO": [
        "h",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WS": [
        "h",
        "H"
    ],
    "001": [
        "H",
        "h"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "JP": [
        "H",
        "h",
        "K"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ]
};


function $67d56c14bbda144d$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = $67d56c14bbda144d$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $67d56c14bbda144d$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, $f41c229a247d7c5e$export$a8c9209db4084317)[regionTag || ''] || (0, $f41c229a247d7c5e$export$a8c9209db4084317)[languageTag || ''] || (0, $f41c229a247d7c5e$export$a8c9209db4084317)["".concat(languageTag, "-001")] || (0, $f41c229a247d7c5e$export$a8c9209db4084317)['001'];
    return hourCycles[0];
}


var $a4da1dc02044df95$var$_a;
var $a4da1dc02044df95$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $55c400f081b9c8b0$export$523451f94304dd6c).source, "*"));
var $a4da1dc02044df95$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $55c400f081b9c8b0$export$523451f94304dd6c).source, "*$"));
function $a4da1dc02044df95$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $a4da1dc02044df95$var$hasNativeStartsWith = !!String.prototype.startsWith;
var $a4da1dc02044df95$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $a4da1dc02044df95$var$hasNativeFromEntries = !!Object.fromEntries;
var $a4da1dc02044df95$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $a4da1dc02044df95$var$hasTrimStart = !!String.prototype.trimStart;
var $a4da1dc02044df95$var$hasTrimEnd = !!String.prototype.trimEnd;
var $a4da1dc02044df95$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $a4da1dc02044df95$var$isSafeInteger = $a4da1dc02044df95$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $a4da1dc02044df95$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $a4da1dc02044df95$var$re = $a4da1dc02044df95$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $a4da1dc02044df95$var$REGEX_SUPPORTS_U_AND_Y = (($a4da1dc02044df95$var$_a = $a4da1dc02044df95$var$re.exec('a')) === null || $a4da1dc02044df95$var$_a === void 0 ? void 0 : $a4da1dc02044df95$var$_a[0]) === 'a';
} catch (_) {
    $a4da1dc02044df95$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $a4da1dc02044df95$var$startsWith = $a4da1dc02044df95$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $a4da1dc02044df95$var$fromCodePoint = $a4da1dc02044df95$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $a4da1dc02044df95$var$fromEntries = // native
$a4da1dc02044df95$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $a4da1dc02044df95$var$codePointAt = $a4da1dc02044df95$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $a4da1dc02044df95$var$trimStart = $a4da1dc02044df95$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($a4da1dc02044df95$var$SPACE_SEPARATOR_START_REGEX, '');
};
var $a4da1dc02044df95$var$trimEnd = $a4da1dc02044df95$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($a4da1dc02044df95$var$SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $a4da1dc02044df95$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $a4da1dc02044df95$var$matchIdentifierAtIndex;
if ($a4da1dc02044df95$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $a4da1dc02044df95$var$IDENTIFIER_PREFIX_RE_1 = $a4da1dc02044df95$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    $a4da1dc02044df95$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $a4da1dc02044df95$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $a4da1dc02044df95$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
$a4da1dc02044df95$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $a4da1dc02044df95$var$codePointAt(s, index);
        if (c === undefined || $a4da1dc02044df95$var$_isWhiteSpace(c) || $a4da1dc02044df95$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $a4da1dc02044df95$var$fromCodePoint.apply(void 0, match);
};
var $a4da1dc02044df95$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $6a00417c031ec97e$export$b87f371cbc396fcf).pound,
                    location: $a4da1dc02044df95$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $76e187d312d35f56$export$896afd8541959ee5).UNMATCHED_CLOSING_TAG, $a4da1dc02044df95$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $a4da1dc02044df95$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, $6a00417c031ec97e$export$b87f371cbc396fcf).literal,
                value: "<".concat(tagName, "/>"),
                location: $a4da1dc02044df95$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !$a4da1dc02044df95$var$_isAlpha(this.char())) return this.error((0, $76e187d312d35f56$export$896afd8541959ee5).INVALID_TAG, $a4da1dc02044df95$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $76e187d312d35f56$export$896afd8541959ee5).UNMATCHED_CLOSING_TAG, $a4da1dc02044df95$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, $76e187d312d35f56$export$896afd8541959ee5).INVALID_TAG, $a4da1dc02044df95$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $6a00417c031ec97e$export$b87f371cbc396fcf).tag,
                        value: tagName,
                        children: children,
                        location: $a4da1dc02044df95$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $76e187d312d35f56$export$896afd8541959ee5).UNCLOSED_TAG, $a4da1dc02044df95$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $76e187d312d35f56$export$896afd8541959ee5).INVALID_TAG, $a4da1dc02044df95$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $a4da1dc02044df95$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $a4da1dc02044df95$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $6a00417c031ec97e$export$b87f371cbc396fcf).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$a4da1dc02044df95$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $a4da1dc02044df95$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $a4da1dc02044df95$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $76e187d312d35f56$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $a4da1dc02044df95$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $76e187d312d35f56$export$896afd8541959ee5).EMPTY_ARGUMENT, $a4da1dc02044df95$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $76e187d312d35f56$export$896afd8541959ee5).MALFORMED_ARGUMENT, $a4da1dc02044df95$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $76e187d312d35f56$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $a4da1dc02044df95$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $6a00417c031ec97e$export$b87f371cbc396fcf).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $a4da1dc02044df95$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $76e187d312d35f56$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $a4da1dc02044df95$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $76e187d312d35f56$export$896afd8541959ee5).MALFORMED_ARGUMENT, $a4da1dc02044df95$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $a4da1dc02044df95$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $a4da1dc02044df95$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $76e187d312d35f56$export$896afd8541959ee5).EXPECT_ARGUMENT_TYPE, $a4da1dc02044df95$var$createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $a4da1dc02044df95$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $76e187d312d35f56$export$896afd8541959ee5).EXPECT_ARGUMENT_STYLE, $a4da1dc02044df95$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $a4da1dc02044df95$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $a4da1dc02044df95$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $a4da1dc02044df95$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $a4da1dc02044df95$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $6a00417c031ec97e$export$b87f371cbc396fcf).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $76e187d312d35f56$export$896afd8541959ee5).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $67d56c14bbda144d$export$29c5368be8904d27)(skeleton, this.locale);
                        var style = {
                            type: (0, $6a00417c031ec97e$export$906452485466fa53).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $d0bef75c557b6c5f$export$f7b99fb377fe69fa)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, $6a00417c031ec97e$export$b87f371cbc396fcf).date : (0, $6a00417c031ec97e$export$b87f371cbc396fcf).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, $6a00417c031ec97e$export$b87f371cbc396fcf).number : argType === 'date' ? (0, $6a00417c031ec97e$export$b87f371cbc396fcf).date : (0, $6a00417c031ec97e$export$b87f371cbc396fcf).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, $76e187d312d35f56$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_OPTIONS, $a4da1dc02044df95$var$createLocation(typeEndPosition_1, (0, $3UfL2.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, $76e187d312d35f56$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $a4da1dc02044df95$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $76e187d312d35f56$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $76e187d312d35f56$export$896afd8541959ee5).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $a4da1dc02044df95$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, $6a00417c031ec97e$export$b87f371cbc396fcf).select,
                        value: value,
                        options: $a4da1dc02044df95$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $6a00417c031ec97e$export$b87f371cbc396fcf).plural,
                        value: value,
                        options: $a4da1dc02044df95$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $76e187d312d35f56$export$896afd8541959ee5).INVALID_ARGUMENT_TYPE, $a4da1dc02044df95$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $76e187d312d35f56$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $a4da1dc02044df95$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $76e187d312d35f56$export$896afd8541959ee5).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $a4da1dc02044df95$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $eb02e10924ccdc68$export$71cee2f16fba2480)(skeleton);
        } catch (e) {
            return this.error((0, $76e187d312d35f56$export$896afd8541959ee5).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $6a00417c031ec97e$export$906452485466fa53).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $eb02e10924ccdc68$export$47c6f8480bda3e11)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $76e187d312d35f56$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $76e187d312d35f56$export$896afd8541959ee5).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $a4da1dc02044df95$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, $76e187d312d35f56$export$896afd8541959ee5).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $76e187d312d35f56$export$896afd8541959ee5).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, $76e187d312d35f56$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $76e187d312d35f56$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $a4da1dc02044df95$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $a4da1dc02044df95$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, $76e187d312d35f56$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $76e187d312d35f56$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR, $a4da1dc02044df95$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $76e187d312d35f56$export$896afd8541959ee5).MISSING_OTHER_CLAUSE, $a4da1dc02044df95$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $a4da1dc02044df95$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$a4da1dc02044df95$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = $a4da1dc02044df95$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($a4da1dc02044df95$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $a4da1dc02044df95$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $a4da1dc02044df95$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $a4da1dc02044df95$var$_isAlphaOrSlash(codepoint) {
    return $a4da1dc02044df95$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $a4da1dc02044df95$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $a4da1dc02044df95$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $a4da1dc02044df95$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}



function $d13e45f6f6b99119$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $6a00417c031ec97e$export$dcfe1c11d168b5a1)(el) || (0, $6a00417c031ec97e$export$6c796d116f0a4fbc)(el)) for(var k in el.options){
            delete el.options[k].location;
            $d13e45f6f6b99119$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $6a00417c031ec97e$export$e11187b219e191e1)(el) && (0, $6a00417c031ec97e$export$3f9a19cd4152eda3)(el.style)) delete el.style.location;
        else if (((0, $6a00417c031ec97e$export$32d811605da75f40)(el) || (0, $6a00417c031ec97e$export$34ec46f596b1702f)(el)) && (0, $6a00417c031ec97e$export$7680c41f1a55f4cf)(el.style)) delete el.style.location;
        else if ((0, $6a00417c031ec97e$export$5c83de34745812b)(el)) $d13e45f6f6b99119$var$pruneLocation(el.children);
    });
}
function $d13e45f6f6b99119$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $3UfL2.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $a4da1dc02044df95$export$7acfa6ed01010e37)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $76e187d312d35f56$export$896afd8541959ee5)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $d13e45f6f6b99119$var$pruneLocation(result.val);
    return result.val;
}


function $53dd9787e0050106$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $3UfL2.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $53dd9787e0050106$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $53dd9787e0050106$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $d3d147c7a00806ca$export$d342343268debc40).formats;
    return (0, $3UfL2.__assign)((0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, mfFormats), f1), {
        date: $53dd9787e0050106$var$deepMergeOptions($53dd9787e0050106$var$setTimeZoneInOptions(mfFormats.date, timeZone), $53dd9787e0050106$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $53dd9787e0050106$var$deepMergeOptions($53dd9787e0050106$var$setTimeZoneInOptions(mfFormats.time, timeZone), $53dd9787e0050106$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
function $53dd9787e0050106$export$25868d1e8e76735f(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ''
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $98a440be037a3fc5$export$f5708dca728d7177)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $6a00417c031ec97e$export$b87f371cbc396fcf).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === 'string' && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, defaultRichTextElements), values || {});
    formats = $53dd9787e0050106$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $53dd9787e0050106$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === '') return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $31ecea3bffece3c6$export$2ddcb436d0aa3688)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $31ecea3bffece3c6$export$74a601a3d3f31621)("Error formatting default message for: \"".concat(id, "\", rendering default message verbatim"), locale, messageDescriptor, e));
            return typeof defaultMessage === 'string' ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $3UfL2.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $31ecea3bffece3c6$export$74a601a3d3f31621)("Error formatting message: \"".concat(id, "\", using ").concat(defaultMessage ? 'default message' : 'id', " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $31ecea3bffece3c6$export$74a601a3d3f31621)("Error formatting the default message for: \"".concat(id, "\", rendering message verbatim"), locale, messageDescriptor, e));
    }
    if (typeof message === 'string') return message;
    if (typeof defaultMessage === 'string') return defaultMessage;
    return id;
}



var $3UfL2 = parcelRequire("3UfL2");



var $3980224da46cb49c$var$LIST_FORMAT_OPTIONS = [
    'localeMatcher',
    'type',
    'style'
];
var $3980224da46cb49c$var$now = Date.now();
function $3980224da46cb49c$var$generateToken(i) {
    return "".concat($3980224da46cb49c$var$now, "_").concat(i, "_").concat($3980224da46cb49c$var$now);
}
function $3980224da46cb49c$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $3980224da46cb49c$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== 'string') all.push(val);
        else if (typeof all[all.length - 1] === 'string') all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results;
}
function $3980224da46cb49c$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $c3cd14e89459dc3b$export$7369836851cc1329)("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", (0, $c3cd14e89459dc3b$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    var filteredOptions = (0, $63813af6b39852dc$export$d697c39a2985a4c)(options, $3980224da46cb49c$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function(v, i) {
            if (typeof v === 'object') {
                var id = $3980224da46cb49c$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === 'literal' ? part : (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $31ecea3bffece3c6$export$c016d36112f6ddf8)((0, $31ecea3bffece3c6$export$557d6acb76e8a244).FORMAT_ERROR, 'Error formatting list.', e));
    }
    // @ts-ignore
    return values;
}





var $509e7fad1a7e0133$var$DISPLAY_NAMES_OPTONS = [
    'localeMatcher',
    'style',
    'type',
    'fallback'
];
function $509e7fad1a7e0133$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $c3cd14e89459dc3b$export$7369836851cc1329)("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", (0, $c3cd14e89459dc3b$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    var filteredOptions = (0, $63813af6b39852dc$export$d697c39a2985a4c)(options, $509e7fad1a7e0133$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $31ecea3bffece3c6$export$c016d36112f6ddf8)((0, $31ecea3bffece3c6$export$557d6acb76e8a244).FORMAT_ERROR, 'Error formatting display name.', e));
    }
}


function $53721f37b14e07df$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === 'string';
}
function $53721f37b14e07df$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $53721f37b14e07df$var$messagesContainString(config.messages || {})) config.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution");
}
function $53721f37b14e07df$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $63813af6b39852dc$export$c3f4cd5551df13fd)(cache);
    var resolvedConfig = (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, (0, $63813af6b39852dc$export$b52f8d6fc0d47415)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $31ecea3bffece3c6$export$3ca04dd7fb305893)("\"locale\" was not configured, using \"".concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details")));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $31ecea3bffece3c6$export$c1eaf877d81384b6)("Missing locale data for locale: \"".concat(locale, "\" in Intl.NumberFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $31ecea3bffece3c6$export$c1eaf877d81384b6)("Missing locale data for locale: \"".concat(locale, "\" in Intl.DateTimeFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    $53721f37b14e07df$var$verifyConfigMessages(resolvedConfig);
    return (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $fa81c44a795db8cf$export$f5dd818bff069720).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $fa81c44a795db8cf$export$6871080848f10b2f).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $8513df11ff22aca4$export$b4ea3b48dcf921f6).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $fa8b71aa6f3aacc1$export$3ae94a2503e890a1).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $fa8b71aa6f3aacc1$export$dc1f059bce486b1).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $fa8b71aa6f3aacc1$export$3203edd9e5edd663).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $fa8b71aa6f3aacc1$export$a7fc3a91cb2ec376).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $fa8b71aa6f3aacc1$export$af6e5d7a5c73edeb).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $d5baca915cd57db1$export$bbbd05c900f3568d).bind(null, resolvedConfig, formatters.getPluralRules),
        formatMessage: (0, $53dd9787e0050106$export$25868d1e8e76735f).bind(null, resolvedConfig, formatters),
        $t: (0, $53dd9787e0050106$export$25868d1e8e76735f).bind(null, resolvedConfig, formatters),
        formatList: (0, $3980224da46cb49c$export$e8b8be48b45905bb).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $3980224da46cb49c$export$6f284aad1934db69).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $509e7fad1a7e0133$export$62fe1a4d9e891fa2).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}



function $56be4036c7660e09$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
function $56be4036c7660e09$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $35d3d31c7efcd9a5$export$df0c12a2d414a163)(v) ? (0, $346592d1d496bc47$export$cfec03d26465fa63)(v) : v;
        return acc;
    }, {});
}
var $56be4036c7660e09$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $56be4036c7660e09$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $53dd9787e0050106$export$25868d1e8e76735f).apply(void 0, (0, $3UfL2.__spreadArray)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return $gqzfn.Children.toArray(chunks);
    return chunks;
};
var $56be4036c7660e09$export$7e4cbedfdd7b4c0d = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $3UfL2.__rest)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $56be4036c7660e09$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $53721f37b14e07df$export$7e4cbedfdd7b4c0d)((0, $3UfL2.__assign)((0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, (0, $346592d1d496bc47$export$b52f8d6fc0d47415)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    return (0, $3UfL2.__assign)((0, $3UfL2.__assign)({}, coreIntl), {
        formatMessage: $56be4036c7660e09$var$formatMessage.bind(null, {
            locale: coreIntl.locale,
            timeZone: coreIntl.timeZone,
            fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
            formats: coreIntl.formats,
            defaultLocale: coreIntl.defaultLocale,
            defaultFormats: coreIntl.defaultFormats,
            messages: coreIntl.messages,
            onError: coreIntl.onError,
            defaultRichTextElements: defaultRichTextElements
        }, coreIntl.formatters)
    });
};
var $56be4036c7660e09$var$IntlProvider = /** @class */ function(_super) {
    (0, $3UfL2.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $63813af6b39852dc$export$51c4f4e973f2dc00)();
        _this.state = {
            cache: _this.cache,
            intl: $56be4036c7660e09$export$7e4cbedfdd7b4c0d($56be4036c7660e09$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $56be4036c7660e09$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $56be4036c7660e09$var$processIntlConfig(props);
        if (!(0, $346592d1d496bc47$export$d36bdfa510afb180)(prevConfig, config)) return {
            intl: $56be4036c7660e09$export$7e4cbedfdd7b4c0d(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $346592d1d496bc47$export$45c4bbf6e55bba1f)(this.state.intl);
        return $gqzfn.createElement((0, $851fcbc24b6958a0$export$2881499e37b75b9a), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = 'IntlProvider';
    IntlProvider.defaultProps = (0, $346592d1d496bc47$export$b52f8d6fc0d47415);
    return IntlProvider;
}($gqzfn.PureComponent);
var $56be4036c7660e09$export$2e2bcd8739ae039 = $56be4036c7660e09$var$IntlProvider;


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $gqzfn = parcelRequire("gqzfn");
const $0f383433c892a23d$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $0f383433c892a23d$var$ATOMIC_GROUP_LENGTH = 5;
function $0f383433c892a23d$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(' ') === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(' ');
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $0f383433c892a23d$var$UNDERSCORE_UNICODE ? $0f383433c892a23d$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = '';
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + ' ';
    }
    return str.slice(0, -1);
}


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ parcelRequire("gqzfn");
const $b02fe168b284751f$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $b02fe168b284751f$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};



const $6f277e12a8bad741$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $0f383433c892a23d$export$2e2bcd8739ae039)(actualStyles);
};


function $652da369163c8546$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $b02fe168b284751f$export$c4df1cb0c2b4d77c)();
        },
        cssMap () {
            throw (0, $b02fe168b284751f$export$c4df1cb0c2b4d77c)();
        },
        cx: $6f277e12a8bad741$export$a274e22fb40f762e,
        XCSSProp () {
            throw (0, $b02fe168b284751f$export$c4df1cb0c2b4d77c)();
        }
    };
}


const $754375ca55821e89$var$strictApi = (0, $652da369163c8546$export$39716b4af53f4ad)();
const $754375ca55821e89$export$dbf350e5966cf602 = $754375ca55821e89$var$strictApi.css;
const $754375ca55821e89$export$eb1ecd84a24ee424 = $754375ca55821e89$var$strictApi.cssMap;
$754375ca55821e89$var$strictApi.cssMap;
const $754375ca55821e89$export$a274e22fb40f762e = $754375ca55821e89$var$strictApi.cx;
const $754375ca55821e89$var$XCSSProp = $754375ca55821e89$var$strictApi.XCSSProp;



var $cnjKG = parcelRequire("cnjKG");
/* anchor.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $gqzfn = parcelRequire("gqzfn");

var $3860c2ed5c20be86$var$isProduction = true;
var $3860c2ed5c20be86$var$prefix = 'Invariant failed';
function $3860c2ed5c20be86$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($3860c2ed5c20be86$var$isProduction) throw new Error($3860c2ed5c20be86$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($3860c2ed5c20be86$var$prefix, ": ").concat(provided) : $3860c2ed5c20be86$var$prefix;
    throw new Error(value);
}



var $gqzfn = parcelRequire("gqzfn");


var $gqzfn = parcelRequire("gqzfn");
const $f0c9d308dafae729$export$1d27a74659855e44 = (value)=>{
    const ref = (0, $gqzfn.useRef)(value);
    ref.current = value;
    return ref;
};


function $eb62fec7d3d57e5a$export$a4687b0234b40e28({ fn: fn, action: action, componentName: componentName, actionSubject: actionSubject, packageName: packageName, packageVersion: packageVersion, analyticsData: analyticsData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $7fea6b6f7f18a70b$export$5bf35293e545f20c)();
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    const dataRef = (0, $f0c9d308dafae729$export$1d27a74659855e44)(analyticsData);
    const fnRef = (0, $f0c9d308dafae729$export$1d27a74659855e44)(fn);
    const handler = (0, $gqzfn.useCallback)((value)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        const context = {
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion,
            ...dataRef.current
        };
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}



var $gqzfn = parcelRequire("gqzfn");


var $gqzfn = parcelRequire("gqzfn");
const $b91efc12ac69e378$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $gqzfn.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $b91efc12ac69e378$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $84ae032d365e55f3$exports.jsx)($b91efc12ac69e378$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var $b91efc12ac69e378$export$2e2bcd8739ae039 = $b91efc12ac69e378$var$RouterLinkProvider;


/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $51fa063791668f5e$var$useRouterLink = ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $gqzfn.useContext)((0, $b91efc12ac69e378$export$2931e0ee690eee88));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $51fa063791668f5e$export$2e2bcd8739ae039 = $51fa063791668f5e$var$useRouterLink;


/**
 * An empty function which does nothing.
 */ function $ba3e57b1cd89d056$export$2e2bcd8739ae039() {}




var $gqzfn = parcelRequire("gqzfn");

var $gqzfn = parcelRequire("gqzfn");

var $gqzfn = parcelRequire("gqzfn");
/**
 * generates a UID factory
 * @internal
 * @example
 * const uid = generateUID();
 * uid(object) = 1;
 * uid(object) = 1;
 * uid(anotherObject) = 2;
 */ const $f9aea1877e320a8a$export$bdbb4cbb3078e58d = ()=>{
    let counter = 1;
    const map = new WeakMap();
    /**
     * @borrows {uid}
     */ const uid = (item, index)=>{
        if (typeof item === 'number' || typeof item === 'string') return index ? `idx-${index}` : `val-${item}`;
        if (!map.has(item)) {
            map.set(item, counter++);
            return uid(item);
        }
        return 'uid' + map.get(item);
    };
    return uid;
};
const $f9aea1877e320a8a$export$e2a22331486dcca0 = $f9aea1877e320a8a$export$bdbb4cbb3078e58d();


const $860151b5abbe1f90$export$1921362e86c73c88 = (prefix = '')=>({
        value: 1,
        prefix: prefix,
        uid: (0, $f9aea1877e320a8a$export$bdbb4cbb3078e58d)()
    });
const $860151b5abbe1f90$export$e575061ef2a070eb = $860151b5abbe1f90$export$1921362e86c73c88();
const $860151b5abbe1f90$export$b4d5da5f34fb77ad = $gqzfn.createContext($860151b5abbe1f90$export$1921362e86c73c88());
const $860151b5abbe1f90$export$218c8c3169c024d2 = (source)=>source.value++;
const $860151b5abbe1f90$export$36e24695f02d4503 = (source)=>source ? source.prefix : '';


const $8090240aa8ea99fc$var$generateUID = (context)=>{
    const quartz = context || (0, $860151b5abbe1f90$export$e575061ef2a070eb);
    const prefix = (0, $860151b5abbe1f90$export$36e24695f02d4503)(quartz);
    const id = (0, $860151b5abbe1f90$export$218c8c3169c024d2)(quartz);
    const uid = prefix + id;
    const gen = (item)=>uid + quartz.uid(item);
    return {
        uid: uid,
        gen: gen
    };
};
const $8090240aa8ea99fc$var$useUIDState = ()=>{
    const context = (0, $gqzfn.useContext)((0, $860151b5abbe1f90$export$b4d5da5f34fb77ad));
    const [uid] = (0, $gqzfn.useState)(()=>$8090240aa8ea99fc$var$generateUID(context));
    return uid;
};
const $8090240aa8ea99fc$export$87d05f07e65211f1 = ()=>{
    const { uid: uid } = $8090240aa8ea99fc$var$useUIDState();
    return uid;
};
const $8090240aa8ea99fc$export$bb5ca5fba6fb4f1f = ()=>{
    const { gen: gen } = $8090240aa8ea99fc$var$useUIDState();
    return gen;
};



var $cnjKG = parcelRequire("cnjKG");
// @ts-ignore - useId is not accessible in React 16
const $9aa3362b6655b5c4$var$react18UseId = (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).useId ?? undefined;
function $9aa3362b6655b5c4$export$f680877a34711e37() {
    if ($9aa3362b6655b5c4$var$react18UseId && (0, $cnjKG.fg)('platform-dst-react-18-use-id')) {
        if ((0, $cnjKG.fg)('platform-dst-react-18-use-id-selector-safe')) // tl;dr: React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`
        // in hundreds of tests. So we replace it with a safe string of `_` to match future
        // React 19 functionality: https://github.com/facebook/react/pull/33422
        return $9aa3362b6655b5c4$var$react18UseId().replace(/[:«»]/g, '_');
        return $9aa3362b6655b5c4$var$react18UseId();
    }
    return `uid${(0, $8090240aa8ea99fc$export$87d05f07e65211f1)()}`;
}
const $9aa3362b6655b5c4$export$6be90bcb437e928f = /*#__PURE__*/ (0, $gqzfn.forwardRef)(({ children: children, postfix: postfix = '', prefix: prefix = '' }, ref)=>{
    const id = `${prefix}${$9aa3362b6655b5c4$export$f680877a34711e37()}${postfix}`;
    (0, $gqzfn.useEffect)(()=>{
        if (!ref) return;
        switch(typeof ref){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error(`Unreachable case for unsupported type of ref "${typeof ref}"`);
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, $84ae032d365e55f3$exports.jsx)((0, $84ae032d365e55f3$exports.Fragment), {
        children: typeof children === 'function' ? children({
            id: id
        }) : children
    });
});
function $9aa3362b6655b5c4$export$6ee17796e3d70de2() {
    if ($9aa3362b6655b5c4$var$react18UseId && (0, $cnjKG.fg)('platform-dst-react-18-use-id')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks -- cleanup with feature gating
        const uid = $9aa3362b6655b5c4$export$f680877a34711e37();
        return (id)=>`${uid}-${id.toString()}`;
    }
    return (0, $8090240aa8ea99fc$export$bb5ca5fba6fb4f1f)();
}



var $gqzfn = parcelRequire("gqzfn");
var $c3c35de96704c0cf$export$2e2bcd8739ae039 = (0, $gqzfn.createContext)(null);


/* visually-hidden.tsx generated by @compiled/babel-plugin v0.36.1 */ 
parcelRequire("gqzfn");

const $7a4f411137b62441$var$visuallyHiddenStyles = null; /**
                                    * __Visually hidden__
                                    *
                                    * A composable element to apply a visually hidden effect to children.
                                    * Useful for accessibility compliance.
                                    *
                                    * @example
                                    * ```jsx
                                    * import VisuallyHidden from '@atlaskit/visually-hidden';
                                    *
                                    * export default () => (
                                    *   <div style={{ border: '1px solid black' }}>
                                    *      There is text hidden between the brackets [
                                    *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
                                    *   </div>
                                    * );
                                    * ```
                                    */ 
const $7a4f411137b62441$var$VisuallyHidden = ({ children: children, testId: testId, role: role, id: id })=>{
    return /*#__PURE__*/ (0, $84ae032d365e55f3$exports.jsx)("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $0f383433c892a23d$export$2e2bcd8739ae039)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ]),
        children: children
    });
};
var $7a4f411137b62441$export$2e2bcd8739ae039 = $7a4f411137b62441$var$VisuallyHidden;


/* focusable.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $gqzfn = parcelRequire("gqzfn");

const $d36cfaeff016c41b$var$focusRingStyles = null;
const $d36cfaeff016c41b$var$insetFocusRingStyles = null;
const $d36cfaeff016c41b$var$Focusable = /*#__PURE__*/ (0, $gqzfn.forwardRef)(({ as: Component = 'button', children: children, isInset: isInset, testId: testId, style: style, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    return /*#__PURE__*/ (0, $84ae032d365e55f3$exports.jsx)(Component, {
        ...safeHtmlAttributes,
        ref: ref,
        className: (0, $0f383433c892a23d$export$2e2bcd8739ae039)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu1p6i _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId,
        children: children
    });
});
var $d36cfaeff016c41b$export$2e2bcd8739ae039 = $d36cfaeff016c41b$var$Focusable;


const $42cc07c9eb4dc0e7$var$styles = {
    root: "_4bfu1r31 _1hms8stv _ajmmnqa1 _vchhusvi",
    position: "_kqswh2mm"
};
const $42cc07c9eb4dc0e7$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $42cc07c9eb4dc0e7$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/; /**
                                                              * __Anchor__
                                                              *
                                                              * A primitive for building custom anchor links.
                                                              *
                                                              * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
                                                              * - [Code](https://atlassian.design/components/primitives/anchor/code)
                                                              * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
                                                              */ 
const $42cc07c9eb4dc0e7$var$AnchorNoRef = ({ href: href, children: children, onClick: providedOnClick = (0, $ba3e57b1cd89d056$export$2e2bcd8739ae039), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, style: style, target: target, testId: testId, xcss: xcss, newWindowLabel: newWindowLabel = '(opens new window)', ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $gqzfn.useContext)((0, $c3c35de96704c0cf$export$2e2bcd8739ae039));
    const handleClick = (0, $gqzfn.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const opensNewWindowLabelId = (0, $9aa3362b6655b5c4$export$f680877a34711e37)();
    const onClick = (0, $eb62fec7d3d57e5a$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    }); // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const RouterLink = (0, $51fa063791668f5e$export$2e2bcd8739ae039)();
    const isExternal = typeof href === 'string' && $42cc07c9eb4dc0e7$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $42cc07c9eb4dc0e7$var$IS_NON_HTTP_BASED.test(href); /**
                                                                                    * Renders a router link if:
                                                                                    *
                                                                                    * - a link component is set in the app provider
                                                                                    * - it's not an external link (starting with `http://` or `https://`)
                                                                                    * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
                                                                                    */ 
    const isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    const hrefObjectUsedWithoutRouterLink = RouterLink === undefined && typeof href === 'object';
    (0, $3860c2ed5c20be86$export$2e2bcd8739ae039)(!hrefObjectUsedWithoutRouterLink, `@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider`);
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, $84ae032d365e55f3$exports.jsxs)((0, $d36cfaeff016c41b$export$2e2bcd8739ae039 // @ts-expect-error we don't allow `a` on Focusable for makers as they should use Anchor instead
    ), {
        as: Component,
        className: xcss,
        style: style,
        ref: ref,
        ...safeHtmlAttributes,
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? `${ariaLabel} , ${newWindowLabel}` : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? `${ariaLabelledBy} ${opensNewWindowLabelId}` : ariaLabelledBy,
        xcss: (0, $6f277e12a8bad741$export$a274e22fb40f762e)($42cc07c9eb4dc0e7$var$styles.root, $42cc07c9eb4dc0e7$var$styles.position, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
        children: [
            children,
            target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, $84ae032d365e55f3$exports.jsx)((0, $7a4f411137b62441$export$2e2bcd8739ae039), {
                id: opensNewWindowLabelId,
                children: `, ${newWindowLabel}`
            })
        ]
    });
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const $42cc07c9eb4dc0e7$var$Anchor = /*#__PURE__*/ (0, $gqzfn.forwardRef)($42cc07c9eb4dc0e7$var$AnchorNoRef);
var $42cc07c9eb4dc0e7$export$2e2bcd8739ae039 = $42cc07c9eb4dc0e7$var$Anchor;

/* box.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $gqzfn = parcelRequire("gqzfn");


var $gqzfn = parcelRequire("gqzfn");
const $66282c631e703469$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $gqzfn.createContext)('elevation.surface');
const $66282c631e703469$export$1aeb4f6b93c4540d = ()=>{
    return (0, $gqzfn.useContext)($66282c631e703469$export$1ca2a26fecb070ae);
};
$66282c631e703469$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';


const $83d1105e47241a7e$var$baseStyles = null;
const $83d1105e47241a7e$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhk1fno",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1eds",
    'color.background.accent.lime.subtler.pressed': "_bfhk1hgz",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhkhgj8",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhk1b17",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhk1pbw",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkrw5d",
    'color.background.accent.red.subtler.pressed': "_bfhk69rw",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1tf4",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhkprmn",
    'color.background.accent.orange.subtlest': "_bfhk1g3m",
    'color.background.accent.orange.subtlest.hovered': "_bfhkg4tm",
    'color.background.accent.orange.subtlest.pressed': "_bfhk1ya0",
    'color.background.accent.orange.subtler': "_bfhkf2vu",
    'color.background.accent.orange.subtler.hovered': "_bfhk1lml",
    'color.background.accent.orange.subtler.pressed': "_bfhkuxsx",
    'color.background.accent.orange.subtle': "_bfhk1g6e",
    'color.background.accent.orange.subtle.hovered': "_bfhk1oew",
    'color.background.accent.orange.subtle.pressed': "_bfhk1phk",
    'color.background.accent.orange.bolder': "_bfhkjgng",
    'color.background.accent.orange.bolder.hovered': "_bfhkhi52",
    'color.background.accent.orange.bolder.pressed': "_bfhkf767",
    'color.background.accent.yellow.subtlest': "_bfhk1ozg",
    'color.background.accent.yellow.subtlest.hovered': "_bfhk19g9",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk31d1",
    'color.background.accent.yellow.subtler': "_bfhk3fv2",
    'color.background.accent.yellow.subtler.hovered': "_bfhklg04",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1d44",
    'color.background.accent.yellow.subtle': "_bfhkry5t",
    'color.background.accent.yellow.subtle.hovered': "_bfhk17e6",
    'color.background.accent.yellow.subtle.pressed': "_bfhko0y5",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk32kj",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkv5yf",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhkung8",
    'color.background.accent.green.subtler.pressed': "_bfhk1p19",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk8h4p",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1azz",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1j2h",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkg5py",
    'color.background.accent.teal.subtler.pressed': "_bfhkq7li",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk10ai",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhkse6l",
    'color.background.accent.blue.subtlest': "_bfhkavxe",
    'color.background.accent.blue.subtlest.hovered': "_bfhkay3p",
    'color.background.accent.blue.subtlest.pressed': "_bfhk1xmr",
    'color.background.accent.blue.subtler': "_bfhk4v9p",
    'color.background.accent.blue.subtler.hovered': "_bfhk16e6",
    'color.background.accent.blue.subtler.pressed': "_bfhk1uh7",
    'color.background.accent.blue.subtle': "_bfhk1j89",
    'color.background.accent.blue.subtle.hovered': "_bfhk1f4s",
    'color.background.accent.blue.subtle.pressed': "_bfhkqctv",
    'color.background.accent.blue.bolder': "_bfhkc8cv",
    'color.background.accent.blue.bolder.hovered': "_bfhk1cwi",
    'color.background.accent.blue.bolder.pressed': "_bfhkhcrq",
    'color.background.accent.purple.subtlest': "_bfhkp7j4",
    'color.background.accent.purple.subtlest.hovered': "_bfhkm0d5",
    'color.background.accent.purple.subtlest.pressed': "_bfhkgslw",
    'color.background.accent.purple.subtler': "_bfhk1jkz",
    'color.background.accent.purple.subtler.hovered': "_bfhk1wyu",
    'color.background.accent.purple.subtler.pressed': "_bfhk5fkp",
    'color.background.accent.purple.subtle': "_bfhkdh45",
    'color.background.accent.purple.subtle.hovered': "_bfhk1wob",
    'color.background.accent.purple.subtle.pressed': "_bfhkwz05",
    'color.background.accent.purple.bolder': "_bfhkygwo",
    'color.background.accent.purple.bolder.hovered': "_bfhkadgs",
    'color.background.accent.purple.bolder.pressed': "_bfhk1uro",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1een",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1r0p",
    'color.background.accent.magenta.subtler.pressed': "_bfhkxuzc",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk1ovh",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkwaw3",
    'color.background.accent.gray.subtlest': "_bfhk11bn",
    'color.background.accent.gray.subtlest.hovered': "_bfhk12j4",
    'color.background.accent.gray.subtlest.pressed': "_bfhk1lb4",
    'color.background.accent.gray.subtler': "_bfhk1v33",
    'color.background.accent.gray.subtler.hovered': "_bfhk1f7l",
    'color.background.accent.gray.subtler.pressed': "_bfhkd8a2",
    'color.background.accent.gray.subtle': "_bfhk1t05",
    'color.background.accent.gray.subtle.hovered': "_bfhk1a2l",
    'color.background.accent.gray.subtle.pressed': "_bfhk1z0s",
    'color.background.accent.gray.bolder': "_bfhk1t1b",
    'color.background.accent.gray.bolder.hovered': "_bfhke4nv",
    'color.background.accent.gray.bolder.pressed': "_bfhk82ra",
    'color.background.disabled': "_bfhksyzs",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhk1d5g",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhkm7j4",
    'color.background.neutral.hovered': "_bfhk15ej",
    'color.background.neutral.pressed': "_bfhkip91",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk166n",
    'color.background.neutral.subtle.pressed': "_bfhk1dty",
    'color.background.neutral.bold': "_bfhkcdhy",
    'color.background.neutral.bold.hovered': "_bfhk1bsc",
    'color.background.neutral.bold.pressed': "_bfhk1b6k",
    'color.background.selected': "_bfhkfg4m",
    'color.background.selected.hovered': "_bfhki1yw",
    'color.background.selected.pressed': "_bfhk19ru",
    'color.background.selected.bold': "_bfhk1fvw",
    'color.background.selected.bold.hovered': "_bfhk18hz",
    'color.background.selected.bold.pressed': "_bfhkgr1v",
    'color.background.brand.subtlest': "_bfhk3wxy",
    'color.background.brand.subtlest.hovered': "_bfhkezq1",
    'color.background.brand.subtlest.pressed': "_bfhk2ggb",
    'color.background.brand.bold': "_bfhkb29m",
    'color.background.brand.bold.hovered': "_bfhku1se",
    'color.background.brand.bold.pressed': "_bfhkqkzo",
    'color.background.brand.boldest': "_bfhk15mt",
    'color.background.brand.boldest.hovered': "_bfhk1uwk",
    'color.background.brand.boldest.pressed': "_bfhk17jr",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1io2",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk9pqq",
    'color.background.warning': "_bfhk1tzq",
    'color.background.warning.hovered': "_bfhk1rd4",
    'color.background.warning.pressed': "_bfhk11dh",
    'color.background.warning.bold': "_bfhk190i",
    'color.background.warning.bold.hovered': "_bfhk1i4c",
    'color.background.warning.bold.pressed': "_bfhkrj9s",
    'color.background.success': "_bfhkmv6i",
    'color.background.success.hovered': "_bfhk1jgi",
    'color.background.success.pressed': "_bfhky4f1",
    'color.background.success.bold': "_bfhk8emd",
    'color.background.success.bold.hovered': "_bfhk1q4l",
    'color.background.success.bold.pressed': "_bfhkcrcn",
    'color.background.discovery': "_bfhk1nvp",
    'color.background.discovery.hovered': "_bfhk1xp7",
    'color.background.discovery.pressed': "_bfhkdlkp",
    'color.background.discovery.bold': "_bfhk1lri",
    'color.background.discovery.bold.hovered': "_bfhk1w72",
    'color.background.discovery.bold.pressed': "_bfhkrb53",
    'color.background.information': "_bfhk33gi",
    'color.background.information.hovered': "_bfhk1vps",
    'color.background.information.pressed': "_bfhk1s0z",
    'color.background.information.bold': "_bfhk14wj",
    'color.background.information.bold.hovered': "_bfhk1amz",
    'color.background.information.bold.pressed': "_bfhk5bth",
    'color.blanket': "_bfhk10xm",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkn82g",
    'color.skeleton.subtle': "_bfhkh3tw",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk108i",
    'elevation.surface.pressed': "_bfhk1ji5",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk16qz",
    'elevation.surface.overlay.pressed': "_bfhkvq0a",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk1a0f",
    'elevation.surface.raised.pressed': "_bfhkf7u5",
    'elevation.surface.sunken': "_bfhkqbzx",
    'utility.elevation.surface.current': "_bfhkchd4"
};
const $83d1105e47241a7e$var$CURRENT_SURFACE_CSS_VAR = `--ds-elevation-surface-current`;
const $83d1105e47241a7e$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l108i",
    'elevation.surface.pressed': "_1q1l1ji5",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l16qz",
    'elevation.surface.overlay.pressed': "_1q1lvq0a",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l1a0f",
    'elevation.surface.raised.pressed': "_1q1lf7u5",
    'elevation.surface.sunken': "_1q1lqbzx"
};
const $83d1105e47241a7e$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
const $83d1105e47241a7e$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
const $83d1105e47241a7e$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
const $83d1105e47241a7e$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
}; /**
    * __Box__
    *
    * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
    * Renders a `div` by default.
    *
    * - [Examples](https://atlassian.design/components/primitives/box/examples)
    * - [Code](https://atlassian.design/components/primitives/box/code)
    * - [Usage](https://atlassian.design/components/primitives/box/usage)
    */ 
const $83d1105e47241a7e$var$Box = /*#__PURE__*/ (0, $gqzfn.forwardRef)(({ as: Component = 'div', children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock = padding, paddingBlockStart: paddingBlockStart = paddingBlock, paddingBlockEnd: paddingBlockEnd = paddingBlock, paddingInline: paddingInline = padding, paddingInlineStart: paddingInlineStart = paddingInline, paddingInlineEnd: paddingInlineEnd = paddingInline, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const node = /*#__PURE__*/ (0, $84ae032d365e55f3$exports.jsx)(Component // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    , {
        style: style,
        ref: ref,
        className: (0, $0f383433c892a23d$export$2e2bcd8739ae039)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $83d1105e47241a7e$var$backgroundColorMap[backgroundColor],
            backgroundColor && $83d1105e47241a7e$var$isSurfaceToken(backgroundColor) && $83d1105e47241a7e$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $83d1105e47241a7e$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $83d1105e47241a7e$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $83d1105e47241a7e$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $83d1105e47241a7e$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ]),
        ...safeHtmlAttributes,
        "data-testid": testId,
        children: children
    });
    if (backgroundColor) return /*#__PURE__*/ (0, $84ae032d365e55f3$exports.jsx)((0, $66282c631e703469$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor,
        children: node
    });
    return node;
} // @ts-ignore This typescript error has been surpessed while locally enrolling `@atlaskit/primitives` into Jira
);
var $83d1105e47241a7e$export$2e2bcd8739ae039 = $83d1105e47241a7e$var$Box;
function $83d1105e47241a7e$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $83d1105e47241a7e$var$setSurfaceTokenMap;
}


const $8c5067e6959a4aa3$var$styles = {
    visitedLink: "_ect41gqc _1053w7te _1ienw7te _n0fxw7te _1vhvg3x0",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz14q2 _ect41gqc _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj14q2 _9oik1r31 _1bnxglyw _jf4cnqa1 _30l314q2 _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h16c2",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _ect41gqc _syaz1gjq _1a3b1r31 _4fprglyw _5goinqa1 _f8pj1gjq _9oik1r31 _1bnx8stv _jf4cnqa1 _30l31gjq _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8h1fxt",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _ect41gqc _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
const $8c5067e6959a4aa3$var$iconStyles = null;
const $8c5067e6959a4aa3$var$LinkWithoutRef = ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: preventedClassName, // @ts-expect-error
style: preventedStyle, ...htmlAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $84ae032d365e55f3$exports.jsxs)((0, $42cc07c9eb4dc0e7$export$2e2bcd8739ae039 // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $754375ca55821e89$export$a274e22fb40f762e)(appearance === 'default' && $8c5067e6959a4aa3$var$styles.defaultAppearance, appearance === 'subtle' && $8c5067e6959a4aa3$var$styles.subtleAppearance, appearance === 'inverse' && $8c5067e6959a4aa3$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $8c5067e6959a4aa3$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel,
        children: [
            children,
            target === '_blank' && /*#__PURE__*/ (0, $84ae032d365e55f3$exports.jsxs)((0, $83d1105e47241a7e$export$2e2bcd8739ae039), {
                as: "span",
                xcss: $8c5067e6959a4aa3$var$styles.iconWrapper,
                testId: testId && `${testId}__icon`,
                children: [
                    "\uFEFF",
                    (0, $cnjKG.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $84ae032d365e55f3$exports.jsx)("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        className: (0, $0f383433c892a23d$export$2e2bcd8739ae039)([
                            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
                        ]),
                        children: /*#__PURE__*/ (0, $84ae032d365e55f3$exports.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                            fill: "currentColor"
                        })
                    }) : /*#__PURE__*/ (0, $84ae032d365e55f3$exports.jsxs)("svg", {
                        width: "20",
                        height: "20",
                        viewBox: "0 0 20 20",
                        fill: "currentColor",
                        className: (0, $0f383433c892a23d$export$2e2bcd8739ae039)([
                            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $84ae032d365e55f3$exports.jsx)("path", {
                                d: "M17.5715 3.95926L10.7587 10.772C10.5546 10.9692 10.2811 11.0784 9.99723 11.0759C9.71338 11.0734 9.44185 10.9596 9.24113 10.7589C9.04041 10.5581 8.92655 10.2866 8.92409 10.0027C8.92162 9.7189 9.03074 9.44543 9.22794 9.24125L16.0407 2.4285H14.3237C14.0366 2.4285 13.7613 2.31444 13.5582 2.11142C13.3552 1.90839 13.2411 1.63303 13.2411 1.34591C13.2411 1.05879 13.3552 0.783424 13.5582 0.580399C13.7613 0.377373 14.0366 0.263314 14.3237 0.263314H18.4981C18.5509 0.254962 18.6043 0.250507 18.658 0.250041C18.8017 0.248792 18.9443 0.276183 19.0773 0.330617C19.2104 0.385051 19.3313 0.465437 19.4329 0.567084C19.5346 0.668732 19.6149 0.789606 19.6694 0.922652C19.7238 1.0557 19.7512 1.19825 19.75 1.342C19.7495 1.3956 19.7451 1.44896 19.7367 1.50165V5.67628C19.7367 5.9634 19.6227 6.23877 19.4196 6.44179C19.2166 6.64482 18.9412 6.75888 18.6541 6.75888C18.367 6.75888 18.0916 6.64482 17.8886 6.44179C17.6856 6.23877 17.5715 5.9634 17.5715 5.67628V3.95926Z"
                            }),
                            /*#__PURE__*/ (0, $84ae032d365e55f3$exports.jsx)("path", {
                                d: "M2.41519 17.5848V2.4285H8.91076V0.263314H2.41194C1.22001 0.263314 0.25 1.23007 0.25 2.42201V17.5913C0.250574 18.1638 0.47834 18.7127 0.883283 19.1175C1.28823 19.5222 1.83724 19.7497 2.40978 19.75H17.5769C17.8608 19.7499 18.1418 19.6938 18.404 19.585C18.6662 19.4762 18.9044 19.3168 19.105 19.116C19.3055 18.9151 19.4646 18.6767 19.573 18.4143C19.6814 18.152 19.737 17.8708 19.7367 17.587V11.0893H17.5715V17.5848H2.41519Z"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}; // Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $8c5067e6959a4aa3$var$Link = /*#__PURE__*/ (0, $gqzfn.forwardRef)($8c5067e6959a4aa3$var$LinkWithoutRef);
var $8c5067e6959a4aa3$export$2e2bcd8739ae039 = $8c5067e6959a4aa3$var$Link;



var $bda1dd775425f725$exports = {};
$bda1dd775425f725$exports = JSON.parse("{}");



var $3UfL2 = parcelRequire("3UfL2");

var $gqzfn = parcelRequire("gqzfn");

var $43ecc47acc80a226$var$DisplayName;
(function(DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})($43ecc47acc80a226$var$DisplayName || ($43ecc47acc80a226$var$DisplayName = {}));
var $43ecc47acc80a226$var$DisplayNameParts;
(function(DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})($43ecc47acc80a226$var$DisplayNameParts || ($43ecc47acc80a226$var$DisplayNameParts = {}));
var $43ecc47acc80a226$export$54d4989ed3eea1ea = function(props) {
    var intl = (0, $261d614963c985eb$export$2e2bcd8739ae039)();
    var value = props.value, children = props.children, formatProps = (0, $3UfL2.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatNumberToParts(value, formatProps));
};
$43ecc47acc80a226$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
var $43ecc47acc80a226$export$5ac259c7da6d2188 = function(props) {
    var intl = (0, $261d614963c985eb$export$2e2bcd8739ae039)();
    var value = props.value, children = props.children, formatProps = (0, $3UfL2.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatListToParts(value, formatProps));
};
$43ecc47acc80a226$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
function $43ecc47acc80a226$export$7448277f6036d2ab(name) {
    var ComponentParts = function(props) {
        var intl = (0, $261d614963c985eb$export$2e2bcd8739ae039)();
        var value = props.value, children = props.children, formatProps = (0, $3UfL2.__rest)(props, [
            "value",
            "children"
        ]);
        var date = typeof value === 'string' ? new Date(value || 0) : value;
        var formattedParts = name === 'formatDate' ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = $43ecc47acc80a226$var$DisplayNameParts[name];
    return ComponentParts;
}
function $43ecc47acc80a226$export$b37e14176d001dec(name) {
    var Component = function(props) {
        var intl = (0, $261d614963c985eb$export$2e2bcd8739ae039)();
        var value = props.value, children = props.children, formatProps = (0, $3UfL2.__rest)(props, [
            "value",
            "children"
        ]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === 'function') return children(formattedValue);
        var Text = intl.textComponent || $gqzfn.Fragment;
        return $gqzfn.createElement(Text, null, formattedValue);
    };
    Component.displayName = $43ecc47acc80a226$var$DisplayName[name];
    return Component;
}










function $c3da8283b0e8cf40$export$1adfeb024f5185b(msgs) {
    return msgs;
}
function $c3da8283b0e8cf40$export$747d244ee58120dd(msg) {
    return msg;
}
var $c3da8283b0e8cf40$export$40ae3194919d16b = (0, $43ecc47acc80a226$export$b37e14176d001dec)('formatDate');
var $c3da8283b0e8cf40$export$5b390a54f8a846f7 = (0, $43ecc47acc80a226$export$b37e14176d001dec)('formatTime');
var $c3da8283b0e8cf40$export$db80edc1e6b2f63d = (0, $43ecc47acc80a226$export$b37e14176d001dec)('formatNumber');
var $c3da8283b0e8cf40$export$f52b44e459e6e71d = (0, $43ecc47acc80a226$export$b37e14176d001dec)('formatList');
var $c3da8283b0e8cf40$export$c2336ea5aaab92fa = (0, $43ecc47acc80a226$export$b37e14176d001dec)('formatDisplayName');
var $c3da8283b0e8cf40$export$7fdc7d2c91ce149b = (0, $43ecc47acc80a226$export$7448277f6036d2ab)('formatDate');
var $c3da8283b0e8cf40$export$ec35873761676c2a = (0, $43ecc47acc80a226$export$7448277f6036d2ab)('formatTime');


const $dedcfc2f6a9befa5$export$a7357cdd1f0b0168 = (0, $c3da8283b0e8cf40$export$1adfeb024f5185b)({
    title: {
        id: "error-app.title",
        defaultMessage: "Something went wrong."
    },
    subTitle: {
        id: "error-app.sub-title",
        defaultMessage: "We\u2019re moving mountains to get it sorted."
    },
    detail: {
        id: "error-app.detail",
        defaultMessage: "View our {link} and subscribe for service updates."
    },
    linkName: {
        id: "error-app.link-name",
        defaultMessage: "status page"
    }
});


var $081ae1392598eac1$exports = {};
$081ae1392598eac1$exports = new URL("something-went-wrong.afc195d1.svg", import.meta.url).toString();


var $0eb113e9ad2dec82$exports = {};
$0eb113e9ad2dec82$exports = new URL("atlassianLogo.598181d7.svg", import.meta.url).toString();


const $e435e378975f2891$export$b5ed68f0a0a58a22 = ()=>{
    const DEFAULT_LOCALE = 'en-US';
    const locale = navigator.languages[0] || navigator.language || DEFAULT_LOCALE;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement((0, $56be4036c7660e09$export$2e2bcd8739ae039), {
        locale: locale,
        messages: (0, (/*@__PURE__*/$parcel$interopDefault($bda1dd775425f725$exports))),
        defaultLocale: "en-US"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement("div", {
        style: {
            padding: '19px',
            background: '#F4F5F7',
            margin: '0'
        }
    }, (0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('dst-a11y__replace-anchor-with-link__page-experienc') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement((0, $8c5067e6959a4aa3$export$2e2bcd8739ae039), {
        href: "https://www.atlassian.com"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement("img", {
        alt: "Atlassian",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($0eb113e9ad2dec82$exports))),
        style: {
            width: '145px',
            height: '18px'
        }
    })) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement("a", {
        href: "https://www.atlassian.com"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement("img", {
        alt: "Atlassian",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($0eb113e9ad2dec82$exports))),
        style: {
            width: '145px',
            height: '18px'
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement("div", {
        style: {
            background: '#fff',
            padding: '60px 0',
            textAlign: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($081ae1392598eac1$exports))),
        alt: "",
        style: {
            marginLeft: -20,
            width: '380px',
            height: '246px'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement("h1", {
        style: {
            color: '#253858',
            font: 'bold 36px Helvetica, Arial',
            marginTop: '50px',
            marginBottom: '24px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement((0, $2313c76058eae75b$export$2e2bcd8739ae039), (0, $dedcfc2f6a9befa5$export$a7357cdd1f0b0168).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement("h2", {
        style: {
            color: '#253858',
            font: 'bold 20px Helvetica, Arial',
            margin: '16px 0px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement((0, $2313c76058eae75b$export$2e2bcd8739ae039), (0, $dedcfc2f6a9befa5$export$a7357cdd1f0b0168).subTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement("p", {
        style: {
            color: '#42526E',
            font: 'normal 20px/28px Helvetica, Arial',
            margin: '20px 0'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement((0, $2313c76058eae75b$export$2e2bcd8739ae039), {
        ...(0, $dedcfc2f6a9befa5$export$a7357cdd1f0b0168).detail,
        values: {
            link: // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement("a", {
                target: "_blank",
                id: "statusPageHref",
                href: "https://status.atlassian.com",
                style: {
                    textDecoration: 'underline'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement((0, $2313c76058eae75b$export$2e2bcd8739ae039), (0, $dedcfc2f6a9befa5$export$a7357cdd1f0b0168).linkName))
        }
    }))));
};



var $gqzfn = parcelRequire("gqzfn");

var $9pfwj = parcelRequire("9pfwj");

var $gqzfn = parcelRequire("gqzfn");
function $b80f3e953e5a1331$export$2e2bcd8739ae039(t, e) {
    return $b80f3e953e5a1331$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $b80f3e953e5a1331$export$2e2bcd8739ae039(t, e);
}


function $8fc7fe89b8e82cd1$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $b80f3e953e5a1331$export$2e2bcd8739ae039)(t, o);
}



var $gqzfn = parcelRequire("gqzfn");

function $c78f986904bed3a9$export$2e2bcd8739ae039() {
    return $c78f986904bed3a9$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c78f986904bed3a9$export$2e2bcd8739ae039.apply(null, arguments);
}


function $a70951e40aae9d5e$var$isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function $a70951e40aae9d5e$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $a70951e40aae9d5e$var$resolvePathname(to, from) {
    if (from === undefined) from = '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && $a70951e40aae9d5e$var$isAbsolute(to);
    var isFromAbs = from && $a70951e40aae9d5e$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $a70951e40aae9d5e$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') $a70951e40aae9d5e$var$spliceOne(fromParts, i);
        else if (part === '..') {
            $a70951e40aae9d5e$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $a70951e40aae9d5e$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !$a70951e40aae9d5e$var$isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
var $a70951e40aae9d5e$export$2e2bcd8739ae039 = $a70951e40aae9d5e$var$resolvePathname;


function $99490849de1d8dab$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $99490849de1d8dab$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $99490849de1d8dab$var$valueEqual(item, b[index]);
    });
    if (typeof a === 'object' || typeof b === 'object') {
        var aValue = $99490849de1d8dab$var$valueOf(a);
        var bValue = $99490849de1d8dab$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $99490849de1d8dab$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $99490849de1d8dab$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $99490849de1d8dab$export$2e2bcd8739ae039 = $99490849de1d8dab$var$valueEqual;




function $90bfb951ee26a67b$var$addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function $90bfb951ee26a67b$var$stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function $90bfb951ee26a67b$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function $90bfb951ee26a67b$var$stripBasename(path, prefix) {
    return $90bfb951ee26a67b$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $90bfb951ee26a67b$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function $90bfb951ee26a67b$export$8ccf933b0513f8d0(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function $90bfb951ee26a67b$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function $90bfb951ee26a67b$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = $90bfb951ee26a67b$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $c78f986904bed3a9$export$2e2bcd8739ae039)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, $a70951e40aae9d5e$export$2e2bcd8739ae039)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function $90bfb951ee26a67b$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $99490849de1d8dab$export$2e2bcd8739ae039)(a.state, b.state);
}
function $90bfb951ee26a67b$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $90bfb951ee26a67b$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $90bfb951ee26a67b$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $90bfb951ee26a67b$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $90bfb951ee26a67b$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $90bfb951ee26a67b$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $90bfb951ee26a67b$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var $90bfb951ee26a67b$var$PopStateEvent = 'popstate';
var $90bfb951ee26a67b$var$HashChangeEvent = 'hashchange';
function $90bfb951ee26a67b$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $90bfb951ee26a67b$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$90bfb951ee26a67b$var$canUseDOM && (0, $3860c2ed5c20be86$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canUseHistory = $90bfb951ee26a67b$var$supportsHistory();
    var needsHashChangeListener = !$90bfb951ee26a67b$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $90bfb951ee26a67b$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $90bfb951ee26a67b$var$stripTrailingSlash($90bfb951ee26a67b$var$addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $90bfb951ee26a67b$var$stripBasename(path, basename);
        return $90bfb951ee26a67b$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $90bfb951ee26a67b$var$createTransitionManager();
    function setState(nextState) {
        (0, $c78f986904bed3a9$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($90bfb951ee26a67b$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($90bfb951ee26a67b$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($90bfb951ee26a67b$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $90bfb951ee26a67b$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $90bfb951ee26a67b$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $90bfb951ee26a67b$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($90bfb951ee26a67b$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($90bfb951ee26a67b$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($90bfb951ee26a67b$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($90bfb951ee26a67b$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $90bfb951ee26a67b$var$HashChangeEvent$1 = 'hashchange';
var $90bfb951ee26a67b$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + $90bfb951ee26a67b$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $90bfb951ee26a67b$var$stripLeadingSlash,
        decodePath: $90bfb951ee26a67b$var$addLeadingSlash
    },
    slash: {
        encodePath: $90bfb951ee26a67b$var$addLeadingSlash,
        decodePath: $90bfb951ee26a67b$var$addLeadingSlash
    }
};
function $90bfb951ee26a67b$var$stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $90bfb951ee26a67b$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function $90bfb951ee26a67b$var$pushHashPath(path) {
    window.location.hash = path;
}
function $90bfb951ee26a67b$var$replaceHashPath(path) {
    window.location.replace($90bfb951ee26a67b$var$stripHash(window.location.href) + '#' + path);
}
function $90bfb951ee26a67b$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$90bfb951ee26a67b$var$canUseDOM && (0, $3860c2ed5c20be86$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $90bfb951ee26a67b$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $90bfb951ee26a67b$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? $90bfb951ee26a67b$var$stripTrailingSlash($90bfb951ee26a67b$var$addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = $90bfb951ee26a67b$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($90bfb951ee26a67b$var$getHashPath());
        if (basename) path = $90bfb951ee26a67b$var$stripBasename(path, basename);
        return $90bfb951ee26a67b$export$90c043f1c57770b8(path);
    }
    var transitionManager = $90bfb951ee26a67b$var$createTransitionManager();
    function setState(nextState) {
        (0, $c78f986904bed3a9$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $90bfb951ee26a67b$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $90bfb951ee26a67b$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $90bfb951ee26a67b$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($90bfb951ee26a67b$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($90bfb951ee26a67b$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $90bfb951ee26a67b$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $90bfb951ee26a67b$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $90bfb951ee26a67b$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = $90bfb951ee26a67b$var$stripHash(window.location.href);
        return href + '#' + encodePath(basename + $90bfb951ee26a67b$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $90bfb951ee26a67b$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $90bfb951ee26a67b$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $90bfb951ee26a67b$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $90bfb951ee26a67b$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($90bfb951ee26a67b$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $90bfb951ee26a67b$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $90bfb951ee26a67b$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $90bfb951ee26a67b$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $90bfb951ee26a67b$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($90bfb951ee26a67b$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($90bfb951ee26a67b$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($90bfb951ee26a67b$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $90bfb951ee26a67b$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $90bfb951ee26a67b$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $90bfb951ee26a67b$var$createTransitionManager();
    function setState(nextState) {
        (0, $c78f986904bed3a9$export$2e2bcd8739ae039)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $90bfb951ee26a67b$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? $90bfb951ee26a67b$export$90c043f1c57770b8(entry, undefined, createKey()) : $90bfb951ee26a67b$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $90bfb951ee26a67b$export$fe53371bee54353d;
    function push(path, state) {
        var action = 'PUSH';
        var location = $90bfb951ee26a67b$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $90bfb951ee26a67b$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $90bfb951ee26a67b$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}





var $c6db48baf85f74d9$exports = {};
var $17a691494e01f2c6$exports = {};
$17a691494e01f2c6$exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};


/**
 * Expose `pathToRegexp`.
 */ $c6db48baf85f74d9$exports = $c6db48baf85f74d9$var$pathToRegexp;
$c6db48baf85f74d9$exports.parse = $c6db48baf85f74d9$var$parse;
$c6db48baf85f74d9$exports.compile = $c6db48baf85f74d9$var$compile;
$c6db48baf85f74d9$exports.tokensToFunction = $c6db48baf85f74d9$var$tokensToFunction;
$c6db48baf85f74d9$exports.tokensToRegExp = $c6db48baf85f74d9$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $c6db48baf85f74d9$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $c6db48baf85f74d9$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = $c6db48baf85f74d9$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = prefix || defaultDelimiter;
        var pattern = capture || group;
        var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $c6db48baf85f74d9$var$escapeGroup(pattern) : asterisk ? '.*' : $c6db48baf85f74d9$var$restrictBacktrack(delimiter, prevText)
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
function $c6db48baf85f74d9$var$restrictBacktrack(delimiter, prevText) {
    if (!prevText || prevText.indexOf(delimiter) > -1) return '[^' + $c6db48baf85f74d9$var$escapeString(delimiter) + ']+?';
    return $c6db48baf85f74d9$var$escapeString(prevText) + '|(?:(?!' + $c6db48baf85f74d9$var$escapeString(prevText) + ')[^' + $c6db48baf85f74d9$var$escapeString(delimiter) + '])+?';
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $c6db48baf85f74d9$var$compile(str, options) {
    return $c6db48baf85f74d9$var$tokensToFunction($c6db48baf85f74d9$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $c6db48baf85f74d9$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $c6db48baf85f74d9$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $c6db48baf85f74d9$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', $c6db48baf85f74d9$var$flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $c6db48baf85f74d9$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($17a691494e01f2c6$exports(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $c6db48baf85f74d9$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $c6db48baf85f74d9$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $c6db48baf85f74d9$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $c6db48baf85f74d9$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $c6db48baf85f74d9$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $c6db48baf85f74d9$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $c6db48baf85f74d9$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $c6db48baf85f74d9$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($c6db48baf85f74d9$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', $c6db48baf85f74d9$var$flags(options));
    return $c6db48baf85f74d9$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $c6db48baf85f74d9$var$stringToRegexp(path, keys, options) {
    return $c6db48baf85f74d9$var$tokensToRegExp($c6db48baf85f74d9$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $c6db48baf85f74d9$var$tokensToRegExp(tokens, keys, options) {
    if (!$17a691494e01f2c6$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += $c6db48baf85f74d9$var$escapeString(token);
        else {
            var prefix = $c6db48baf85f74d9$var$escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = $c6db48baf85f74d9$var$escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return $c6db48baf85f74d9$var$attachKeys(new RegExp('^' + route, $c6db48baf85f74d9$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $c6db48baf85f74d9$var$pathToRegexp(path, keys, options) {
    if (!$17a691494e01f2c6$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $c6db48baf85f74d9$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($17a691494e01f2c6$exports(path)) return $c6db48baf85f74d9$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $c6db48baf85f74d9$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}


var $1961e29d44c421a2$exports = {};
'use strict';

$1961e29d44c421a2$exports = (parcelRequire("aOe7g"));


function $70d55912c24e0e61$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}



var $8dd6048ee63ddb53$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $8dd6048ee63ddb53$var$commonjsGlobal = typeof globalThis !== "undefined" // 'global proper'
 ? globalThis : typeof window !== "undefined" ? window // Browser
 : typeof $parcel$global !== "undefined" ? $parcel$global // node.js
 : {};
function $8dd6048ee63ddb53$var$getUniqueId() {
    var key = "__global_unique_id__";
    return $8dd6048ee63ddb53$var$commonjsGlobal[key] = ($8dd6048ee63ddb53$var$commonjsGlobal[key] || 0) + 1;
} // Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $8dd6048ee63ddb53$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else // eslint-disable-next-line no-self-compare
    return x !== x && y !== y;
}
function $8dd6048ee63ddb53$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $8dd6048ee63ddb53$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $8dd6048ee63ddb53$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + $8dd6048ee63ddb53$var$getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_React$Component) {
        (0, $8fc7fe89b8e82cd1$export$2e2bcd8739ae039)(Provider, _React$Component);
        function Provider() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.emitter = $8dd6048ee63ddb53$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($8dd6048ee63ddb53$var$objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : $8dd6048ee63ddb53$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($37198ed473bd55f3$exports))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_React$Component2) {
        (0, $8fc7fe89b8e82cd1$export$2e2bcd8739ae039)(Consumer, _React$Component2);
        function Consumer() {
            var _this2;
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            _this2 = _React$Component2.call.apply(_React$Component2, [
                this
            ].concat(args)) || this;
            _this2.observedBits = void 0;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $8dd6048ee63ddb53$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $8dd6048ee63ddb53$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $8dd6048ee63ddb53$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($37198ed473bd55f3$exports))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
// MIT License
var $8dd6048ee63ddb53$var$createContext = (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createContext || $8dd6048ee63ddb53$var$createReactContext;
// TODO: Replace with React.createContext once we can assume React 16+
var $8dd6048ee63ddb53$var$createNamedContext = function createNamedContext(name) {
    var context = $8dd6048ee63ddb53$var$createContext();
    context.displayName = name;
    return context;
};
var $8dd6048ee63ddb53$export$c213558b66925821 = /*#__PURE__*/ $8dd6048ee63ddb53$var$createNamedContext("Router-History");
var $8dd6048ee63ddb53$export$63baa8ccbe60bb07 = /*#__PURE__*/ $8dd6048ee63ddb53$var$createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var $8dd6048ee63ddb53$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $8fc7fe89b8e82cd1$export$2e2bcd8739ae039)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this._isMounted = true;
        if (this.unlisten) // Any pre-mount location changes have been captured at
        // this point, so unregister the listener.
        this.unlisten();
        if (!this.props.staticContext) this.unlisten = this.props.history.listen(function(location) {
            if (_this2._isMounted) _this2.setState({
                location: location
            });
        });
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement($8dd6048ee63ddb53$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement($8dd6048ee63ddb53$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $8dd6048ee63ddb53$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $8fc7fe89b8e82cd1$export$2e2bcd8739ae039)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $90bfb951ee26a67b$export$2b76ad033c6e6d08)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement($8dd6048ee63ddb53$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).Component);
var $8dd6048ee63ddb53$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $8fc7fe89b8e82cd1$export$2e2bcd8739ae039)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $8dd6048ee63ddb53$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement($8dd6048ee63ddb53$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $3860c2ed5c20be86$export$2e2bcd8739ae039)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement($8dd6048ee63ddb53$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $8dd6048ee63ddb53$var$messageType;
var $8dd6048ee63ddb53$var$cache = {};
var $8dd6048ee63ddb53$var$cacheLimit = 10000;
var $8dd6048ee63ddb53$var$cacheCount = 0;
function $8dd6048ee63ddb53$var$compilePath(path) {
    if ($8dd6048ee63ddb53$var$cache[path]) return $8dd6048ee63ddb53$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($c6db48baf85f74d9$exports))).compile(path);
    if ($8dd6048ee63ddb53$var$cacheCount < $8dd6048ee63ddb53$var$cacheLimit) {
        $8dd6048ee63ddb53$var$cache[path] = generator;
        $8dd6048ee63ddb53$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $8dd6048ee63ddb53$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $8dd6048ee63ddb53$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $8dd6048ee63ddb53$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement($8dd6048ee63ddb53$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $3860c2ed5c20be86$export$2e2bcd8739ae039)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $90bfb951ee26a67b$export$90c043f1c57770b8)(computedMatch ? typeof to === "string" ? $8dd6048ee63ddb53$export$82476f982757e71e(to, computedMatch.params) : (0, $c78f986904bed3a9$export$2e2bcd8739ae039)({}, to, {
            pathname: $8dd6048ee63ddb53$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement($8dd6048ee63ddb53$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $90bfb951ee26a67b$export$90c043f1c57770b8)(prevProps.to);
                if (!(0, $90bfb951ee26a67b$export$c3e8bb440bd55b18)(prevLocation, (0, $c78f986904bed3a9$export$2e2bcd8739ae039)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var $8dd6048ee63ddb53$var$cache$1 = {};
var $8dd6048ee63ddb53$var$cacheLimit$1 = 10000;
var $8dd6048ee63ddb53$var$cacheCount$1 = 0;
function $8dd6048ee63ddb53$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $8dd6048ee63ddb53$var$cache$1[cacheKey] || ($8dd6048ee63ddb53$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($c6db48baf85f74d9$exports)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($8dd6048ee63ddb53$var$cacheCount$1 < $8dd6048ee63ddb53$var$cacheLimit$1) {
        pathCache[path] = result;
        $8dd6048ee63ddb53$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $8dd6048ee63ddb53$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $8dd6048ee63ddb53$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $8dd6048ee63ddb53$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).Children.count(children) === 0;
}
function $8dd6048ee63ddb53$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $8dd6048ee63ddb53$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $8fc7fe89b8e82cd1$export$2e2bcd8739ae039)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement($8dd6048ee63ddb53$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $3860c2ed5c20be86$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $8dd6048ee63ddb53$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $c78f986904bed3a9$export$2e2bcd8739ae039)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && $8dd6048ee63ddb53$var$isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement($8dd6048ee63ddb53$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).Component);
function $8dd6048ee63ddb53$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $8dd6048ee63ddb53$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $c78f986904bed3a9$export$2e2bcd8739ae039)({}, location, {
        pathname: $8dd6048ee63ddb53$var$addLeadingSlash(basename) + location.pathname
    });
}
function $8dd6048ee63ddb53$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $8dd6048ee63ddb53$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $c78f986904bed3a9$export$2e2bcd8739ae039)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $8dd6048ee63ddb53$var$createURL(location) {
    return typeof location === "string" ? location : (0, $90bfb951ee26a67b$export$fe53371bee54353d)(location);
}
function $8dd6048ee63ddb53$var$staticHandler(methodName) {
    return function() {
        (0, $3860c2ed5c20be86$export$2e2bcd8739ae039)(false);
    };
}
function $8dd6048ee63ddb53$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $8dd6048ee63ddb53$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $8fc7fe89b8e82cd1$export$2e2bcd8739ae039)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $8dd6048ee63ddb53$var$noop;
        };
        _this.handleBlock = function() {
            return $8dd6048ee63ddb53$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $8dd6048ee63ddb53$var$addBasename(basename, (0, $90bfb951ee26a67b$export$90c043f1c57770b8)(location));
        context.url = $8dd6048ee63ddb53$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $70d55912c24e0e61$export$2e2bcd8739ae039)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $8dd6048ee63ddb53$var$addLeadingSlash(basename + $8dd6048ee63ddb53$var$createURL(path));
            },
            action: "POP",
            location: $8dd6048ee63ddb53$var$stripBasename(basename, (0, $90bfb951ee26a67b$export$90c043f1c57770b8)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $8dd6048ee63ddb53$var$staticHandler("go"),
            goBack: $8dd6048ee63ddb53$var$staticHandler("goBack"),
            goForward: $8dd6048ee63ddb53$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement($8dd6048ee63ddb53$export$55185c17a0fcbe46, (0, $c78f986904bed3a9$export$2e2bcd8739ae039)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $8dd6048ee63ddb53$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $8fc7fe89b8e82cd1$export$2e2bcd8739ae039)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement($8dd6048ee63ddb53$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $3860c2ed5c20be86$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $8dd6048ee63ddb53$export$81336c211d5ff295(location.pathname, (0, $c78f986904bed3a9$export$2e2bcd8739ae039)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $8dd6048ee63ddb53$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $70d55912c24e0e61$export$2e2bcd8739ae039)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement($8dd6048ee63ddb53$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $3860c2ed5c20be86$export$2e2bcd8739ae039)(false);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement(Component, (0, $c78f986904bed3a9$export$2e2bcd8739ae039)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($17c64bc07fd45005$exports)))(C, Component);
}
var $8dd6048ee63ddb53$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).useContext;
function $8dd6048ee63ddb53$export$3420e1dc2c4a518c() {
    return $8dd6048ee63ddb53$var$useContext($8dd6048ee63ddb53$export$c213558b66925821);
}
function $8dd6048ee63ddb53$export$45d76561a5302f2b() {
    return $8dd6048ee63ddb53$var$useContext($8dd6048ee63ddb53$export$63baa8ccbe60bb07).location;
}
function $8dd6048ee63ddb53$export$99eaa27ddbbb95ef() {
    var match = $8dd6048ee63ddb53$var$useContext($8dd6048ee63ddb53$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $8dd6048ee63ddb53$export$632be4bb944c1bc7(path) {
    var location = $8dd6048ee63ddb53$export$45d76561a5302f2b();
    var match = $8dd6048ee63ddb53$var$useContext($8dd6048ee63ddb53$export$63baa8ccbe60bb07).match;
    return path ? $8dd6048ee63ddb53$export$81336c211d5ff295(location.pathname, path) : match;
}
var $8dd6048ee63ddb53$var$global$1, $8dd6048ee63ddb53$var$key, $8dd6048ee63ddb53$var$buildNames, $8dd6048ee63ddb53$var$initialBuildName, $8dd6048ee63ddb53$var$secondaryBuildName;


var $30ad6ecd922ea319$exports = {};

var $5b0sL = parcelRequire("5b0sL");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $30ad6ecd922ea319$var$isEqual(value, other) {
    return $5b0sL(value, other);
}
$30ad6ecd922ea319$exports = $30ad6ecd922ea319$var$isEqual;



var $gqzfn = parcelRequire("gqzfn");

var $d8f61048a7eb3cc2$export$2e2bcd8739ae039 = (0, $c3c35de96704c0cf$export$2e2bcd8739ae039);
function $d8f61048a7eb3cc2$export$11bcb6e9af2aca35() {
    return (0, $gqzfn.useContext)((0, $c3c35de96704c0cf$export$2e2bcd8739ae039));
}




var $9pfwj = parcelRequire("9pfwj");
var $02e0ab00235ba459$exports = {};
var $d63914810b140081$exports = {};
var $b0ace9e96cba8eea$exports = {};

var $7vaT3 = parcelRequire("7vaT3");

var $9EZcP = parcelRequire("9EZcP");
var $9c10b9bf3f0c9204$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $9c10b9bf3f0c9204$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$9c10b9bf3f0c9204$exports = $9c10b9bf3f0c9204$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $b0ace9e96cba8eea$var$baseMatches(source) {
    var matchData = $9EZcP(source);
    if (matchData.length == 1 && matchData[0][2]) return $9c10b9bf3f0c9204$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $7vaT3(object, source, matchData);
    };
}
$b0ace9e96cba8eea$exports = $b0ace9e96cba8eea$var$baseMatches;


var $94153180b87f877b$exports = {};

var $5b0sL = parcelRequire("5b0sL");
var $921526bd655278d2$exports = {};
var $ace1aa1fc712f2b4$exports = {};
var $f33fa3a5f5577055$exports = {};

var $9X1Pr = parcelRequire("9X1Pr");
var $11972de3086f1cb0$exports = {};

var $9X1Pr = parcelRequire("9X1Pr");
var $b970b8bbd051982e$exports = {};

var $aeQBO = parcelRequire("aeQBO");

var $lqXWM = parcelRequire("lqXWM");
/** `Object#toString` result references. */ var $b970b8bbd051982e$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $b970b8bbd051982e$var$isSymbol(value) {
    return typeof value == 'symbol' || $lqXWM(value) && $aeQBO(value) == $b970b8bbd051982e$var$symbolTag;
}
$b970b8bbd051982e$exports = $b970b8bbd051982e$var$isSymbol;


/** Used to match property names within property paths. */ var $11972de3086f1cb0$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $11972de3086f1cb0$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $11972de3086f1cb0$var$isKey(value, object) {
    if ($9X1Pr(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $b970b8bbd051982e$exports(value)) return true;
    return $11972de3086f1cb0$var$reIsPlainProp.test(value) || !$11972de3086f1cb0$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$11972de3086f1cb0$exports = $11972de3086f1cb0$var$isKey;


var $5adf4ddda8b5cb73$exports = {};
var $d7a3e62229b345ab$exports = {};
var $7aa623fea7e5a8e1$exports = {};

var $1W4Hx = parcelRequire("1W4Hx");
/** Error message constants. */ var $7aa623fea7e5a8e1$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $7aa623fea7e5a8e1$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($7aa623fea7e5a8e1$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($7aa623fea7e5a8e1$var$memoize.Cache || $1W4Hx);
    return memoized;
}
// Expose `MapCache`.
$7aa623fea7e5a8e1$var$memoize.Cache = $1W4Hx;
$7aa623fea7e5a8e1$exports = $7aa623fea7e5a8e1$var$memoize;


/** Used as the maximum memoize cache size. */ var $d7a3e62229b345ab$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $d7a3e62229b345ab$var$memoizeCapped(func) {
    var result = $7aa623fea7e5a8e1$exports(func, function(key) {
        if (cache.size === $d7a3e62229b345ab$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$d7a3e62229b345ab$exports = $d7a3e62229b345ab$var$memoizeCapped;


/** Used to match property names within property paths. */ var $5adf4ddda8b5cb73$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $5adf4ddda8b5cb73$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $5adf4ddda8b5cb73$var$stringToPath = $d7a3e62229b345ab$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($5adf4ddda8b5cb73$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($5adf4ddda8b5cb73$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
$5adf4ddda8b5cb73$exports = $5adf4ddda8b5cb73$var$stringToPath;


var $247f5e9f22f4f2ae$exports = {};
var $cf1a0c4c0777a66f$exports = {};

var $jf0iC = parcelRequire("jf0iC");
var $d7b14ee62c41bda8$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $d7b14ee62c41bda8$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$d7b14ee62c41bda8$exports = $d7b14ee62c41bda8$var$arrayMap;



var $9X1Pr = parcelRequire("9X1Pr");

/** Used as references for various `Number` constants. */ var $cf1a0c4c0777a66f$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $cf1a0c4c0777a66f$var$symbolProto = $jf0iC ? $jf0iC.prototype : undefined, $cf1a0c4c0777a66f$var$symbolToString = $cf1a0c4c0777a66f$var$symbolProto ? $cf1a0c4c0777a66f$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $cf1a0c4c0777a66f$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($9X1Pr(value)) // Recursively convert values (susceptible to call stack limits).
    return $d7b14ee62c41bda8$exports(value, $cf1a0c4c0777a66f$var$baseToString) + '';
    if ($b970b8bbd051982e$exports(value)) return $cf1a0c4c0777a66f$var$symbolToString ? $cf1a0c4c0777a66f$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$cf1a0c4c0777a66f$var$INFINITY ? '-0' : result;
}
$cf1a0c4c0777a66f$exports = $cf1a0c4c0777a66f$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $247f5e9f22f4f2ae$var$toString(value) {
    return value == null ? '' : $cf1a0c4c0777a66f$exports(value);
}
$247f5e9f22f4f2ae$exports = $247f5e9f22f4f2ae$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $f33fa3a5f5577055$var$castPath(value, object) {
    if ($9X1Pr(value)) return value;
    return $11972de3086f1cb0$exports(value, object) ? [
        value
    ] : $5adf4ddda8b5cb73$exports($247f5e9f22f4f2ae$exports(value));
}
$f33fa3a5f5577055$exports = $f33fa3a5f5577055$var$castPath;


var $ebfc077974dafc29$exports = {};

/** Used as references for various `Number` constants. */ var $ebfc077974dafc29$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $ebfc077974dafc29$var$toKey(value) {
    if (typeof value == 'string' || $b970b8bbd051982e$exports(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$ebfc077974dafc29$var$INFINITY ? '-0' : result;
}
$ebfc077974dafc29$exports = $ebfc077974dafc29$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $ace1aa1fc712f2b4$var$baseGet(object, path) {
    path = $f33fa3a5f5577055$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$ebfc077974dafc29$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$ace1aa1fc712f2b4$exports = $ace1aa1fc712f2b4$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $921526bd655278d2$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $ace1aa1fc712f2b4$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$921526bd655278d2$exports = $921526bd655278d2$var$get;


var $594f723d8939ce37$exports = {};
var $049c7702a93d0c06$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $049c7702a93d0c06$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$049c7702a93d0c06$exports = $049c7702a93d0c06$var$baseHasIn;


var $fcc3c84af7e5d930$exports = {};


var $aPIym = parcelRequire("aPIym");

var $9X1Pr = parcelRequire("9X1Pr");

var $720Uz = parcelRequire("720Uz");

var $1zLxR = parcelRequire("1zLxR");

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $fcc3c84af7e5d930$var$hasPath(object, path, hasFunc) {
    path = $f33fa3a5f5577055$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $ebfc077974dafc29$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $1zLxR(length) && $720Uz(key, length) && ($9X1Pr(object) || $aPIym(object));
}
$fcc3c84af7e5d930$exports = $fcc3c84af7e5d930$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $594f723d8939ce37$var$hasIn(object, path) {
    return object != null && $fcc3c84af7e5d930$exports(object, path, $049c7702a93d0c06$exports);
}
$594f723d8939ce37$exports = $594f723d8939ce37$var$hasIn;




var $yKC0q = parcelRequire("yKC0q");


/** Used to compose bitmasks for value comparisons. */ var $94153180b87f877b$var$COMPARE_PARTIAL_FLAG = 1, $94153180b87f877b$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $94153180b87f877b$var$baseMatchesProperty(path, srcValue) {
    if ($11972de3086f1cb0$exports(path) && $yKC0q(srcValue)) return $9c10b9bf3f0c9204$exports($ebfc077974dafc29$exports(path), srcValue);
    return function(object) {
        var objValue = $921526bd655278d2$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $594f723d8939ce37$exports(object, path) : $5b0sL(srcValue, objValue, $94153180b87f877b$var$COMPARE_PARTIAL_FLAG | $94153180b87f877b$var$COMPARE_UNORDERED_FLAG);
    };
}
$94153180b87f877b$exports = $94153180b87f877b$var$baseMatchesProperty;


var $37b60a988d3d7b74$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $37b60a988d3d7b74$var$identity(value) {
    return value;
}
$37b60a988d3d7b74$exports = $37b60a988d3d7b74$var$identity;



var $9X1Pr = parcelRequire("9X1Pr");
var $61133f98dfd5adef$exports = {};
var $89d9d972b372d27e$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $89d9d972b372d27e$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$89d9d972b372d27e$exports = $89d9d972b372d27e$var$baseProperty;


var $99c8dc961f8e5fa7$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $99c8dc961f8e5fa7$var$basePropertyDeep(path) {
    return function(object) {
        return $ace1aa1fc712f2b4$exports(object, path);
    };
}
$99c8dc961f8e5fa7$exports = $99c8dc961f8e5fa7$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $61133f98dfd5adef$var$property(path) {
    return $11972de3086f1cb0$exports(path) ? $89d9d972b372d27e$exports($ebfc077974dafc29$exports(path)) : $99c8dc961f8e5fa7$exports(path);
}
$61133f98dfd5adef$exports = $61133f98dfd5adef$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $d63914810b140081$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $37b60a988d3d7b74$exports;
    if (typeof value == 'object') return $9X1Pr(value) ? $94153180b87f877b$exports(value[0], value[1]) : $b0ace9e96cba8eea$exports(value);
    return $61133f98dfd5adef$exports(value);
}
$d63914810b140081$exports = $d63914810b140081$var$baseIteratee;


var $9d680baa448c6e76$exports = {};
/** Error message constants. */ var $9d680baa448c6e76$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */ function $9d680baa448c6e76$var$negate(predicate) {
    if (typeof predicate != 'function') throw new TypeError($9d680baa448c6e76$var$FUNC_ERROR_TEXT);
    return function() {
        var args = arguments;
        switch(args.length){
            case 0:
                return !predicate.call(this);
            case 1:
                return !predicate.call(this, args[0]);
            case 2:
                return !predicate.call(this, args[0], args[1]);
            case 3:
                return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
    };
}
$9d680baa448c6e76$exports = $9d680baa448c6e76$var$negate;


var $0f7d6babe9c72b4f$exports = {};


var $90e8ec2d9a76e450$exports = {};

var $c102135447807d64$exports = {};
var $fd66b3451a05f82d$exports = {};
var $a38ac3c8a67c88fd$exports = {};
var $07096ecca1e08976$exports = {};

var $8vcXv = parcelRequire("8vcXv");
var $07096ecca1e08976$var$defineProperty = function() {
    try {
        var func = $8vcXv(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
$07096ecca1e08976$exports = $07096ecca1e08976$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $a38ac3c8a67c88fd$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $07096ecca1e08976$exports) $07096ecca1e08976$exports(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
$a38ac3c8a67c88fd$exports = $a38ac3c8a67c88fd$var$baseAssignValue;



var $akjE4 = parcelRequire("akjE4");
/** Used for built-in method references. */ var $fd66b3451a05f82d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $fd66b3451a05f82d$var$hasOwnProperty = $fd66b3451a05f82d$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $fd66b3451a05f82d$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($fd66b3451a05f82d$var$hasOwnProperty.call(object, key) && $akjE4(objValue, value)) || value === undefined && !(key in object)) $a38ac3c8a67c88fd$exports(object, key, value);
}
$fd66b3451a05f82d$exports = $fd66b3451a05f82d$var$assignValue;




var $720Uz = parcelRequire("720Uz");

var $bFI6q = parcelRequire("bFI6q");

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $c102135447807d64$var$baseSet(object, path, value, customizer) {
    if (!$bFI6q(object)) return object;
    path = $f33fa3a5f5577055$exports(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $ebfc077974dafc29$exports(path[index]), newValue = value;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $bFI6q(objValue) ? objValue : $720Uz(path[index + 1]) ? [] : {};
        }
        $fd66b3451a05f82d$exports(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
$c102135447807d64$exports = $c102135447807d64$var$baseSet;



/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function $90e8ec2d9a76e450$var$basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = $ace1aa1fc712f2b4$exports(object, path);
        if (predicate(value, path)) $c102135447807d64$exports(result, $f33fa3a5f5577055$exports(path, object), value);
    }
    return result;
}
$90e8ec2d9a76e450$exports = $90e8ec2d9a76e450$var$basePickBy;


var $75272089352d1549$exports = {};

var $kfv1b = parcelRequire("kfv1b");
var $dd922d8f52ba5dd6$exports = {};

var $2Wmte = parcelRequire("2Wmte");
var $79683a944646ef3c$exports = {};

var $lebe5 = parcelRequire("lebe5");
/** Built-in value references. */ var $79683a944646ef3c$var$getPrototype = $lebe5(Object.getPrototypeOf, Object);
$79683a944646ef3c$exports = $79683a944646ef3c$var$getPrototype;



var $PmheH = parcelRequire("PmheH");

var $bXRS6 = parcelRequire("bXRS6");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $dd922d8f52ba5dd6$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $dd922d8f52ba5dd6$var$getSymbolsIn = !$dd922d8f52ba5dd6$var$nativeGetSymbols ? $bXRS6 : function(object) {
    var result = [];
    while(object){
        $2Wmte(result, $PmheH(object));
        object = $79683a944646ef3c$exports(object);
    }
    return result;
};
$dd922d8f52ba5dd6$exports = $dd922d8f52ba5dd6$var$getSymbolsIn;


var $739031f48e6fcbdc$exports = {};

var $bNP5E = parcelRequire("bNP5E");
var $ddce1d270becea74$exports = {};

var $bFI6q = parcelRequire("bFI6q");

var $d0GOx = parcelRequire("d0GOx");
var $cd93f30430b61a6c$exports = {};
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $cd93f30430b61a6c$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
$cd93f30430b61a6c$exports = $cd93f30430b61a6c$var$nativeKeysIn;


/** Used for built-in method references. */ var $ddce1d270becea74$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ddce1d270becea74$var$hasOwnProperty = $ddce1d270becea74$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $ddce1d270becea74$var$baseKeysIn(object) {
    if (!$bFI6q(object)) return $cd93f30430b61a6c$exports(object);
    var isProto = $d0GOx(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$ddce1d270becea74$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
$ddce1d270becea74$exports = $ddce1d270becea74$var$baseKeysIn;



var $cOzi7 = parcelRequire("cOzi7");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $739031f48e6fcbdc$var$keysIn(object) {
    return $cOzi7(object) ? $bNP5E(object, true) : $ddce1d270becea74$exports(object);
}
$739031f48e6fcbdc$exports = $739031f48e6fcbdc$var$keysIn;


/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $75272089352d1549$var$getAllKeysIn(object) {
    return $kfv1b(object, $739031f48e6fcbdc$exports, $dd922d8f52ba5dd6$exports);
}
$75272089352d1549$exports = $75272089352d1549$var$getAllKeysIn;


/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */ function $0f7d6babe9c72b4f$var$pickBy(object, predicate) {
    if (object == null) return {};
    var props = $d7b14ee62c41bda8$exports($75272089352d1549$exports(object), function(prop) {
        return [
            prop
        ];
    });
    predicate = $d63914810b140081$exports(predicate);
    return $90e8ec2d9a76e450$exports(object, props, function(value, path) {
        return predicate(value, path[0]);
    });
}
$0f7d6babe9c72b4f$exports = $0f7d6babe9c72b4f$var$pickBy;


/**
 * The opposite of `_.pickBy`; this method creates an object composed of
 * the own and inherited enumerable string keyed properties of `object` that
 * `predicate` doesn't return truthy for. The predicate is invoked with two
 * arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omitBy(object, _.isNumber);
 * // => { 'b': '2' }
 */ function $02e0ab00235ba459$var$omitBy(object, predicate) {
    return $0f7d6babe9c72b4f$exports(object, $9d680baa448c6e76$exports($d63914810b140081$exports(predicate)));
}
$02e0ab00235ba459$exports = $02e0ab00235ba459$var$omitBy;


var $6dd0e78dc318f54f$exports = {};
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function $6dd0e78dc318f54f$var$isNil(value) {
    return value == null;
}
$6dd0e78dc318f54f$exports = $6dd0e78dc318f54f$var$isNil;


const $a1f0c4d0ab868c5f$export$8c6bf2df244e6a99 = '/wiki';
const $a1f0c4d0ab868c5f$var$SPACE_ROOT = 'spaces';
const $a1f0c4d0ab868c5f$export$ad28e141050c1e34 = (title)=>{
    if (!title) return;
    const slug = title// replace groups of reservered chars with a space
    // From https://www.ietf.org/rfc/rfc3986.txt
    // unreserved  = ALPHA / DIGIT / "-" / "." / "_" / "~"
    .replaceAll(/[^A-Za-z0-9\-._~]+/g, ' ')// trim the edges
    .trim()// replace spaces with '+'
    .replaceAll(' ', '+');
    // guard against relative url attacks
    if (slug === '.' || slug === '..') return undefined;
    return slug || undefined;
};
const $a1f0c4d0ab868c5f$export$cbc5b385481fb319 = (href, query)=>{
    const parsedUrl = {
        ...(0, $9pfwj.parse)(href, true),
        search: undefined
    };
    parsedUrl.query = {
        ...parsedUrl.query,
        ...query
    };
    parsedUrl.query = (0, (/*@__PURE__*/$parcel$interopDefault($02e0ab00235ba459$exports)))(parsedUrl.query, (0, (/*@__PURE__*/$parcel$interopDefault($6dd0e78dc318f54f$exports))));
    return (0, $9pfwj.format)(parsedUrl);
};
const $a1f0c4d0ab868c5f$export$8189558ac52562eb = (params, href)=>{
    const parsedUrl = {
        ...(0, $9pfwj.parse)(href, true),
        search: undefined
    };
    params.forEach((paramName)=>delete parsedUrl.query[paramName]);
    return (0, $9pfwj.format)(parsedUrl);
};
const $a1f0c4d0ab868c5f$var$removeAllAnchorsFromUrl = (href)=>{
    return href.split('#')[0];
};
const $a1f0c4d0ab868c5f$var$removeAllQueryParamsFromUrl = (href)=>{
    return href.split('?')[0];
};
const $a1f0c4d0ab868c5f$export$64f436133a65fc62 = (href)=>{
    return $a1f0c4d0ab868c5f$var$removeAllAnchorsFromUrl($a1f0c4d0ab868c5f$var$removeAllQueryParamsFromUrl(href));
};
const $a1f0c4d0ab868c5f$export$cefcfecf0835bcd9 = (spaceKey, path = '')=>{
    spaceKey = encodeURIComponent(spaceKey);
    let spacePath = (typeof path === 'string' ? path : path.pathname) || '';
    if (spacePath.startsWith($a1f0c4d0ab868c5f$export$8c6bf2df244e6a99)) spacePath = spacePath.substring($a1f0c4d0ab868c5f$export$8c6bf2df244e6a99.length);
    if (spacePath.startsWith('/')) spacePath = spacePath.substring(1);
    const link = `${$a1f0c4d0ab868c5f$export$8c6bf2df244e6a99}/${$a1f0c4d0ab868c5f$var$SPACE_ROOT}/${spaceKey}${spacePath ? `/${spacePath}` : ''}`;
    if (typeof path === 'string') return link;
    return {
        ...path,
        pathname: link
    };
};
const $a1f0c4d0ab868c5f$var$getBlogRoute = (spaceKey)=>$a1f0c4d0ab868c5f$export$cefcfecf0835bcd9(spaceKey, 'blog');
const $a1f0c4d0ab868c5f$var$getPagesRoute = (spaceKey)=>$a1f0c4d0ab868c5f$export$cefcfecf0835bcd9(spaceKey, 'pages');
const $a1f0c4d0ab868c5f$export$6b45500787cf696 = (spaceKey, id, contentType, createdDate, slug)=>{
    const trailingSlug = slug ? `/${slug}` : '';
    switch(contentType){
        case 'blogpost':
            const [yy, mm, dd] = createdDate.slice(0, 10).split('-');
            return `${$a1f0c4d0ab868c5f$var$getBlogRoute(spaceKey)}/${yy}/${mm}/${dd}/${id}${trailingSlug}`;
        case 'page':
            return `${$a1f0c4d0ab868c5f$var$getPagesRoute(spaceKey)}/${id}${trailingSlug}`;
        default:
            throw new Error(`Expected content type 'blogpost' or 'page', but received '${contentType}'`);
    }
};
const $a1f0c4d0ab868c5f$export$257d483fa4a3254f = /^(http(s)?:)?\/\//;
const $a1f0c4d0ab868c5f$export$bfc29523388820d7 = (url, isContextAware)=>isContextAware && url.toString().indexOf($a1f0c4d0ab868c5f$export$8c6bf2df244e6a99) !== 0 ? $a1f0c4d0ab868c5f$export$8c6bf2df244e6a99 : '';
const $a1f0c4d0ab868c5f$export$6a80a340d4e68de1 = (url, isContextAware)=>{
    if ($a1f0c4d0ab868c5f$export$257d483fa4a3254f.test(url)) return url;
    else return `${$a1f0c4d0ab868c5f$export$bfc29523388820d7(url, isContextAware)}${url}`;
};
const $a1f0c4d0ab868c5f$export$feb8df2d5227ff6c = (urn)=>urn.charAt(0) === '#';



var $9pfwj = parcelRequire("9pfwj");

function $45cec8fdf0833adb$export$b5d8fba258cc9e89(pattern, url) {
    const parsed = (0, $9pfwj.parse)(url, true);
    const pathname = parsed.pathname || '';
    let match = (0, $8dd6048ee63ddb53$export$81336c211d5ff295)(pathname, {
        path: pattern,
        exact: true
    });
    // some of our routes need query params to match
    if (!match) match = (0, $8dd6048ee63ddb53$export$81336c211d5ff295)(`${pathname}${parsed.search}`, {
        path: pattern,
        exact: true
    });
    if (!match) return null;
    // URI decode params
    const decodedParams = {};
    if (match.params) for (const [key, value] of Object.entries(match.params)){
        let decodedValue = value;
        if (typeof value !== 'undefined') {
            try {
                // decodeURIComponent("%") throws "URI malformed" error
                decodedValue = decodeURIComponent(value);
            } catch (e) {}
            decodedParams[key] = decodedValue;
        }
    }
    return {
        url: url,
        pathname: pathname,
        search: parsed.search || '',
        hash: parsed.hash || '',
        pattern: pattern,
        params: decodedParams,
        query: parsed.query || ''
    };
}



var $9pfwj = parcelRequire("9pfwj");
/**
 * Tokenize input string.
 */ function $a27211468d7c6eb9$var$lexer(str) {
    var tokens = [];
    var i = 0;
    while(i < str.length){
        var char = str[i];
        if (char === "*" || char === "+" || char === "?") {
            tokens.push({
                type: "MODIFIER",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "\\") {
            tokens.push({
                type: "ESCAPED_CHAR",
                index: i++,
                value: str[i++]
            });
            continue;
        }
        if (char === "{") {
            tokens.push({
                type: "OPEN",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "}") {
            tokens.push({
                type: "CLOSE",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === ":") {
            var name = "";
            var j = i + 1;
            while(j < str.length){
                var code = str.charCodeAt(j);
                if (// `0-9`
                code >= 48 && code <= 57 || // `A-Z`
                code >= 65 && code <= 90 || // `a-z`
                code >= 97 && code <= 122 || // `_`
                code === 95) {
                    name += str[j++];
                    continue;
                }
                break;
            }
            if (!name) throw new TypeError("Missing parameter name at ".concat(i));
            tokens.push({
                type: "NAME",
                index: i,
                value: name
            });
            i = j;
            continue;
        }
        if (char === "(") {
            var count = 1;
            var pattern = "";
            var j = i + 1;
            if (str[j] === "?") throw new TypeError("Pattern cannot start with \"?\" at ".concat(j));
            while(j < str.length){
                if (str[j] === "\\") {
                    pattern += str[j++] + str[j++];
                    continue;
                }
                if (str[j] === ")") {
                    count--;
                    if (count === 0) {
                        j++;
                        break;
                    }
                } else if (str[j] === "(") {
                    count++;
                    if (str[j + 1] !== "?") throw new TypeError("Capturing groups are not allowed at ".concat(j));
                }
                pattern += str[j++];
            }
            if (count) throw new TypeError("Unbalanced pattern at ".concat(i));
            if (!pattern) throw new TypeError("Missing pattern at ".concat(i));
            tokens.push({
                type: "PATTERN",
                index: i,
                value: pattern
            });
            i = j;
            continue;
        }
        tokens.push({
            type: "CHAR",
            index: i,
            value: str[i++]
        });
    }
    tokens.push({
        type: "END",
        index: i,
        value: ""
    });
    return tokens;
}
function $a27211468d7c6eb9$export$98e6a39c04603d36(str, options) {
    if (options === void 0) options = {};
    var tokens = $a27211468d7c6eb9$var$lexer(str);
    var _a = options.prefixes, prefixes = _a === void 0 ? "./" : _a, _b = options.delimiter, delimiter = _b === void 0 ? "/#?" : _b;
    var result = [];
    var key = 0;
    var i = 0;
    var path = "";
    var tryConsume = function(type) {
        if (i < tokens.length && tokens[i].type === type) return tokens[i++].value;
    };
    var mustConsume = function(type) {
        var value = tryConsume(type);
        if (value !== undefined) return value;
        var _a = tokens[i], nextType = _a.type, index = _a.index;
        throw new TypeError("Unexpected ".concat(nextType, " at ").concat(index, ", expected ").concat(type));
    };
    var consumeText = function() {
        var result = "";
        var value;
        while(value = tryConsume("CHAR") || tryConsume("ESCAPED_CHAR"))result += value;
        return result;
    };
    var isSafe = function(value) {
        for(var _i = 0, delimiter_1 = delimiter; _i < delimiter_1.length; _i++){
            var char = delimiter_1[_i];
            if (value.indexOf(char) > -1) return true;
        }
        return false;
    };
    var safePattern = function(prefix) {
        var prev = result[result.length - 1];
        var prevText = prefix || (prev && typeof prev === "string" ? prev : "");
        if (prev && !prevText) throw new TypeError("Must have text between two parameters, missing text after \"".concat(prev.name, "\""));
        if (!prevText || isSafe(prevText)) return "[^".concat($a27211468d7c6eb9$var$escapeString(delimiter), "]+?");
        return "(?:(?!".concat($a27211468d7c6eb9$var$escapeString(prevText), ")[^").concat($a27211468d7c6eb9$var$escapeString(delimiter), "])+?");
    };
    while(i < tokens.length){
        var char = tryConsume("CHAR");
        var name = tryConsume("NAME");
        var pattern = tryConsume("PATTERN");
        if (name || pattern) {
            var prefix = char || "";
            if (prefixes.indexOf(prefix) === -1) {
                path += prefix;
                prefix = "";
            }
            if (path) {
                result.push(path);
                path = "";
            }
            result.push({
                name: name || key++,
                prefix: prefix,
                suffix: "",
                pattern: pattern || safePattern(prefix),
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        var value = char || tryConsume("ESCAPED_CHAR");
        if (value) {
            path += value;
            continue;
        }
        if (path) {
            result.push(path);
            path = "";
        }
        var open = tryConsume("OPEN");
        if (open) {
            var prefix = consumeText();
            var name_1 = tryConsume("NAME") || "";
            var pattern_1 = tryConsume("PATTERN") || "";
            var suffix = consumeText();
            mustConsume("CLOSE");
            result.push({
                name: name_1 || (pattern_1 ? key++ : ""),
                pattern: name_1 && !pattern_1 ? safePattern(prefix) : pattern_1,
                prefix: prefix,
                suffix: suffix,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        mustConsume("END");
    }
    return result;
}
function $a27211468d7c6eb9$export$ef7acd7185315e22(str, options) {
    return $a27211468d7c6eb9$export$5b9bad9e403cf3d9($a27211468d7c6eb9$export$98e6a39c04603d36(str, options), options);
}
function $a27211468d7c6eb9$export$5b9bad9e403cf3d9(tokens, options) {
    if (options === void 0) options = {};
    var reFlags = $a27211468d7c6eb9$var$flags(options);
    var _a = options.encode, encode = _a === void 0 ? function(x) {
        return x;
    } : _a, _b = options.validate, validate = _b === void 0 ? true : _b;
    // Compile all the tokens into regexps.
    var matches = tokens.map(function(token) {
        if (typeof token === "object") return new RegExp("^(?:".concat(token.pattern, ")$"), reFlags);
    });
    return function(data) {
        var path = "";
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data ? data[token.name] : undefined;
            var optional = token.modifier === "?" || token.modifier === "*";
            var repeat = token.modifier === "*" || token.modifier === "+";
            if (Array.isArray(value)) {
                if (!repeat) throw new TypeError("Expected \"".concat(token.name, "\" to not repeat, but got an array"));
                if (value.length === 0) {
                    if (optional) continue;
                    throw new TypeError("Expected \"".concat(token.name, "\" to not be empty"));
                }
                for(var j = 0; j < value.length; j++){
                    var segment = encode(value[j], token);
                    if (validate && !matches[i].test(segment)) throw new TypeError("Expected all \"".concat(token.name, "\" to match \"").concat(token.pattern, "\", but got \"").concat(segment, "\""));
                    path += token.prefix + segment + token.suffix;
                }
                continue;
            }
            if (typeof value === "string" || typeof value === "number") {
                var segment = encode(String(value), token);
                if (validate && !matches[i].test(segment)) throw new TypeError("Expected \"".concat(token.name, "\" to match \"").concat(token.pattern, "\", but got \"").concat(segment, "\""));
                path += token.prefix + segment + token.suffix;
                continue;
            }
            if (optional) continue;
            var typeOfMessage = repeat ? "an array" : "a string";
            throw new TypeError("Expected \"".concat(token.name, "\" to be ").concat(typeOfMessage));
        }
        return path;
    };
}
function $a27211468d7c6eb9$export$4659b591c19bdf3d(str, options) {
    var keys = [];
    var re = $a27211468d7c6eb9$export$71304158c7e35877(str, keys, options);
    return $a27211468d7c6eb9$export$968e97c88708237a(re, keys, options);
}
function $a27211468d7c6eb9$export$968e97c88708237a(re, keys, options) {
    if (options === void 0) options = {};
    var _a = options.decode, decode = _a === void 0 ? function(x) {
        return x;
    } : _a;
    return function(pathname) {
        var m = re.exec(pathname);
        if (!m) return false;
        var path = m[0], index = m.index;
        var params = Object.create(null);
        var _loop_1 = function(i) {
            if (m[i] === undefined) return "continue";
            var key = keys[i - 1];
            if (key.modifier === "*" || key.modifier === "+") params[key.name] = m[i].split(key.prefix + key.suffix).map(function(value) {
                return decode(value, key);
            });
            else params[key.name] = decode(m[i], key);
        };
        for(var i = 1; i < m.length; i++)_loop_1(i);
        return {
            path: path,
            index: index,
            params: params
        };
    };
}
/**
 * Escape a regular expression string.
 */ function $a27211468d7c6eb9$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
/**
 * Get the flags for a regexp from the options.
 */ function $a27211468d7c6eb9$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 */ function $a27211468d7c6eb9$var$regexpToRegexp(path, keys) {
    if (!keys) return path;
    var groupsRegex = /\((?:\?<(.*?)>)?(?!\?)/g;
    var index = 0;
    var execResult = groupsRegex.exec(path.source);
    while(execResult){
        keys.push({
            // Use parenthesized substring match if available, index otherwise
            name: execResult[1] || index++,
            prefix: "",
            suffix: "",
            modifier: "",
            pattern: ""
        });
        execResult = groupsRegex.exec(path.source);
    }
    return path;
}
/**
 * Transform an array into a regexp.
 */ function $a27211468d7c6eb9$var$arrayToRegexp(paths, keys, options) {
    var parts = paths.map(function(path) {
        return $a27211468d7c6eb9$export$71304158c7e35877(path, keys, options).source;
    });
    return new RegExp("(?:".concat(parts.join("|"), ")"), $a27211468d7c6eb9$var$flags(options));
}
/**
 * Create a path regexp from string input.
 */ function $a27211468d7c6eb9$var$stringToRegexp(path, keys, options) {
    return $a27211468d7c6eb9$export$9a9303716def6456($a27211468d7c6eb9$export$98e6a39c04603d36(path, options), keys, options);
}
function $a27211468d7c6eb9$export$9a9303716def6456(tokens, keys, options) {
    if (options === void 0) options = {};
    var _a = options.strict, strict = _a === void 0 ? false : _a, _b = options.start, start = _b === void 0 ? true : _b, _c = options.end, end = _c === void 0 ? true : _c, _d = options.encode, encode = _d === void 0 ? function(x) {
        return x;
    } : _d, _e = options.delimiter, delimiter = _e === void 0 ? "/#?" : _e, _f = options.endsWith, endsWith = _f === void 0 ? "" : _f;
    var endsWithRe = "[".concat($a27211468d7c6eb9$var$escapeString(endsWith), "]|$");
    var delimiterRe = "[".concat($a27211468d7c6eb9$var$escapeString(delimiter), "]");
    var route = start ? "^" : "";
    // Iterate over the tokens and create our regexp string.
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        if (typeof token === "string") route += $a27211468d7c6eb9$var$escapeString(encode(token));
        else {
            var prefix = $a27211468d7c6eb9$var$escapeString(encode(token.prefix));
            var suffix = $a27211468d7c6eb9$var$escapeString(encode(token.suffix));
            if (token.pattern) {
                if (keys) keys.push(token);
                if (prefix || suffix) {
                    if (token.modifier === "+" || token.modifier === "*") {
                        var mod = token.modifier === "*" ? "?" : "";
                        route += "(?:".concat(prefix, "((?:").concat(token.pattern, ")(?:").concat(suffix).concat(prefix, "(?:").concat(token.pattern, "))*)").concat(suffix, ")").concat(mod);
                    } else route += "(?:".concat(prefix, "(").concat(token.pattern, ")").concat(suffix, ")").concat(token.modifier);
                } else {
                    if (token.modifier === "+" || token.modifier === "*") throw new TypeError("Can not repeat \"".concat(token.name, "\" without a prefix and suffix"));
                    route += "(".concat(token.pattern, ")").concat(token.modifier);
                }
            } else route += "(?:".concat(prefix).concat(suffix, ")").concat(token.modifier);
        }
    }
    if (end) {
        if (!strict) route += "".concat(delimiterRe, "?");
        route += !options.endsWith ? "$" : "(?=".concat(endsWithRe, ")");
    } else {
        var endToken = tokens[tokens.length - 1];
        var isEndDelimited = typeof endToken === "string" ? delimiterRe.indexOf(endToken[endToken.length - 1]) > -1 : endToken === undefined;
        if (!strict) route += "(?:".concat(delimiterRe, "(?=").concat(endsWithRe, "))?");
        if (!isEndDelimited) route += "(?=".concat(delimiterRe, "|").concat(endsWithRe, ")");
    }
    return new RegExp(route, $a27211468d7c6eb9$var$flags(options));
}
function $a27211468d7c6eb9$export$71304158c7e35877(path, keys, options) {
    if (path instanceof RegExp) return $a27211468d7c6eb9$var$regexpToRegexp(path, keys);
    if (Array.isArray(path)) return $a27211468d7c6eb9$var$arrayToRegexp(path, keys, options);
    return $a27211468d7c6eb9$var$stringToRegexp(path, keys, options);
}


const $48a0bef41abd109a$export$1758be3e5622c165 = (pattern, params = {}, options = {})=>{
    const toPath = (0, $a27211468d7c6eb9$export$ef7acd7185315e22)(pattern, {
        encode: decodeURIComponent
    });
    const path = toPath(params);
    const parsed = (0, $9pfwj.parse)(path, true);
    return (0, $9pfwj.format)({
        pathname: parsed.pathname,
        query: {
            ...parsed.query,
            ...options.query || {}
        },
        hash: options.hash
    });
};


class $08784ba8c1603e4f$export$e7b0ac011bb776c6 {
    static matchFirst(routes, url) {
        for (const route of routes){
            if (!(route instanceof $08784ba8c1603e4f$export$e7b0ac011bb776c6)) continue;
            const matchResult = route.match(url);
            if (matchResult) return matchResult;
        }
        return null;
    }
    match(url) {
        const urlMatch = (0, $45cec8fdf0833adb$export$b5d8fba258cc9e89)(this.pattern, url);
        if (urlMatch) {
            if (this.condition && !this.condition(urlMatch)) return null;
            return {
                ...urlMatch,
                name: this.name
            };
        }
        return null;
    }
    toUrl(params, options) {
        return (0, $48a0bef41abd109a$export$1758be3e5622c165)(this.pattern, params, options);
    }
    constructor(props){
        this.name = void 0;
        this.ufoName = void 0;
        this.bifrost = void 0;
        this.pattern = void 0;
        this.condition = void 0;
        this.isTransition = void 0;
        this.name = props.name;
        this.ufoName = props.ufoName;
        this.bifrost = props.bifrost;
        this.pattern = props.pattern;
        this.condition = props.condition ? props.condition : ()=>true;
        this.isTransition = (previous, current)=>{
            if (!previous) return true;
            if (props.isTransition) return previous.name === current.name ? props.isTransition(previous, current) : true;
            return previous.pathname !== current.pathname;
        };
    }
}



var $gqzfn = parcelRequire("gqzfn");
/* eslint-disable prefer-template */ 
const $bc1f03695ae1c02a$export$8c6bf2df244e6a99 = '/wiki';


const $a24239c0837f4ae7$export$e6eb0c6cf0c4b7e3 = 'force_transition';
const $a24239c0837f4ae7$export$b5402fcece797a50 = (prevMatch, currentMatch)=>{
    const currentForceTransitionId = currentMatch?.query?.[$a24239c0837f4ae7$export$e6eb0c6cf0c4b7e3];
    const previousForceTransitionId = prevMatch?.query?.[$a24239c0837f4ae7$export$e6eb0c6cf0c4b7e3];
    return Boolean(currentForceTransitionId && currentForceTransitionId !== previousForceTransitionId);
};


// Please do NOT remove /*@__PURE__*/ in this file.
// These comments hints Terser (webpack's minifier) to remove the definition if they are not used.
//
// Please do NOT change string concatenation to string interpolation.
// String interpolations are compiled to "".concat("").concat("") because even the latest edge don't support them natively.
// This made minifier give up removing the dead code because it can't ensure the function call won't have side effects.
//
// Please keep these optimizations here and follow the existing one if you need to add new ones.
const $0d518026f9d519cf$var$contentTransition = (prev, curr)=>prev.params.contentId !== curr.params.contentId;
const $0d518026f9d519cf$var$spaceTransition = (prev, curr)=>prev.params.spaceKey !== curr.params.spaceKey;
const $0d518026f9d519cf$export$9e15ff8aa6bc996f = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'BASE',
    pattern: '/'
});
const $0d518026f9d519cf$export$2fd309376969662f = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'WIKI',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99),
    bifrost: {
        group: 'default',
        bundling: {
            packageName: 'HomeRoute',
            whichExportToUse: 'HomeRoute'
        },
        enabled: false,
        indexHtml: 'error-app.html',
        trafficToBifrostFeatureFlag: 'bifrost-gateway-wiki-home-route-killswitch'
    }
});
const $0d518026f9d519cf$export$a7c5707626fc90f = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'HOME',
    ufoName: 'confluence-home',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/home/:view?',
    bifrost: {
        group: 'default',
        bundling: {
            packageName: 'HomeRoute',
            whichExportToUse: 'HomeRoute'
        },
        enabled: false,
        indexHtml: 'error-app.html',
        trafficToBifrostFeatureFlag: 'bifrost-gateway-wiki-home-route-killswitch'
    }
});
const $0d518026f9d519cf$export$6ccd7dc0d5aa30b0 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'TEMPLATE_GALLERY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/templates'
});
const $0d518026f9d519cf$export$7d65e474be175151 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CALENDAR',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/calendar/mycalendar.action'
});
const $0d518026f9d519cf$export$ec8a7da990877da3 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'MY_CALENDAR',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/mycalendar'
});
const $0d518026f9d519cf$export$e492b3d04985e9fb = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'MULTIPLE_SUBCALENDAR',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/multiCalendars'
});
const $0d518026f9d519cf$export$57fb93d8931ad943 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EMBEDDED_MULTIPLE_SUBCALENDAR',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/embedded/multiCalendars'
});
const $0d518026f9d519cf$export$aa473411bddb7e17 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'QUESTIONS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/plugins/servlet/ac/com.atlassian.confluence.plugins.confluence-questions/globalQuestionsViewer\\?ac.com.atlassian.confluence.plugins.confluence-questions.pattern=/questions/ask'
});
const $0d518026f9d519cf$export$42bb8ba9cae96927 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'QUESTIONS_NATIVE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/questions'
});
const $0d518026f9d519cf$export$1e92de3a3dba0876 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'QUESTION_NATIVE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/questions/:spaceKey/:questionId',
    /**
   * this will incorrectly match QUESTIONS_TOPIC_NATIVE
   * condition is used to prevent this
   */ condition: ({ params: params })=>Boolean(params.spaceKey && params.spaceKey !== 'topics')
});
const $0d518026f9d519cf$export$dec9f53c339ce8f8 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'QUESTIONS_TOPICS_NATIVE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/questions/topics'
});
const $0d518026f9d519cf$export$f80d02217688b484 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'QUESTIONS_TOPIC_NATIVE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/questions/topics/:topicName'
});
const $0d518026f9d519cf$export$fdfdf584a0978d20 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'QUESTIONS_EXPERTS_NATIVE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/questions/experts'
});
const $0d518026f9d519cf$export$6a85914fb9ca80a2 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CONTENT_HISTORY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/history/:contentId(\\d+)/:contentSlug?'
});
const $0d518026f9d519cf$export$1f238fcead086ec3 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CONTENT_HISTORY_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/viewpreviousversions.action'
});
const $0d518026f9d519cf$export$b74c113024023274 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EDIT_PAGE',
    ufoName: 'edit-page',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/:contentType(pages)/edit/:contentId(\\d+)'
});
const $0d518026f9d519cf$export$45222bf0cb32d6e2 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EDIT_BLOG',
    ufoName: 'edit-page',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/:contentType(blog)/edit/:contentId(\\d+)'
});
const $0d518026f9d519cf$export$7b1285e36c635f1f = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EDIT_PAGE_V2',
    ufoName: 'edit-page',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/:contentType(pages)/edit-v2/:contentId(\\d+)',
    isTransition: $0d518026f9d519cf$var$contentTransition
});
const $0d518026f9d519cf$export$36dcea4e08feb5c9 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EDIT_BLOG_V2',
    ufoName: 'edit-page',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/:contentType(blog)/edit-v2/:contentId(\\d+)',
    isTransition: $0d518026f9d519cf$var$contentTransition
});
const $0d518026f9d519cf$export$e63a462ee45b57cf = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EDIT_PAGE_EMBED',
    ufoName: 'edit-page-embed',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/:contentType(pages)/edit-embed/:contentId(\\d+)'
});
const $0d518026f9d519cf$export$bd17e6e353522e0d = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EDIT_PAGE_SMART_CREATE',
    ufoName: 'edit-page-smart-create',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/:contentType(pages)/edit-smart-create/:contentId(\\d+)'
});
const $0d518026f9d519cf$export$4fe224de953acb46 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SMART_CREATE',
    ufoName: 'space-smart-create',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/space-smart-create'
});
const $0d518026f9d519cf$export$54edf7c16c47aeef = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CREATE_CONTENT',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/create-content/:contentType'
});
const $0d518026f9d519cf$export$d6ae9e544e98926f = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CREATE_PAGE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/:contentType(pages)/create'
});
const $0d518026f9d519cf$export$e8253e1b7e500d1c = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CREATE_BLOG',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/:contentType(blog)/create'
});
const $0d518026f9d519cf$export$9a4ff2d809fc4156 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'DELETE_PAGE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/removepage.action\\?pageId=:contentId(\\d+)'
});
const $0d518026f9d519cf$export$19c176cd0a878008 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ONBOARDING',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/welcome'
});
const $0d518026f9d519cf$export$439074745692fe65 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_DIRECTORY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces'
});
const $0d518026f9d519cf$export$2de9a69f9b51bb83 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/viewspacesummary.action\\?key=:spaceKey([^&]+)'
});
const $0d518026f9d519cf$export$10f0439b47c8fdaf = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_REORDERPAGES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/reorderpages.action\\?key=:spaceKey([^&]+)'
});
const $0d518026f9d519cf$export$d0ac6fa12f3acafa = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_HIDDEN_PAGES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/listorphanedpages.action\\?key=:spaceKey([^&]+)'
});
const $0d518026f9d519cf$export$35123576da2e521 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_UNDEFINED_PAGES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/listundefinedpages.action\\?key=:spaceKey([^&]+)'
});
const $0d518026f9d519cf$export$e18ccd8ffafdf3dd = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_ATTACHMENTS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/listattachmentsforspace.action\\?key=:spaceKey([^&]+)'
});
const $0d518026f9d519cf$export$9c4e8cdcbbacdf8f = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_APPLICATION_LINKS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + 'spaces/listentitylinks.action'
});
const $0d518026f9d519cf$export$f85f59869a8dbbf8 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_RSS_FEEDS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + 'spaces/listrssfeeds.action'
});
const $0d518026f9d519cf$export$d87089dbdd7eeaf3 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_OVERVIEW_REDIRECT_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/viewspace.action\\?key=:spaceKey([^&]+)'
});
const $0d518026f9d519cf$export$dd174db99b3e6fea = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'DELETE_SPACE_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/doremovespace.action\\?key=:spaceKey([^&]+)'
});
const $0d518026f9d519cf$export$ef26ce515f06bc5e = Object.assign(/*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_INDEX',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey',
    /**
   * /spaces/:spaceKey will incorrectly match /spaces/something.action.
   * In that case the request should be sent to Monolith.
   */ condition: ({ params: params })=>Boolean(params.spaceKey && !params.spaceKey.endsWith('.action')),
    isTransition: $0d518026f9d519cf$var$spaceTransition
}), {
    /**
   * Used for optimization purposes. See SPACE_OVERVIEW for more detail.
   */ HOMEPAGE_ID_QUERY_KEY: 'homepageId'
});
const $0d518026f9d519cf$export$65b723bb995d4fb6 = Object.assign(/*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_OVERVIEW',
    ufoName: 'space-overview',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/overview',
    isTransition: $0d518026f9d519cf$var$spaceTransition
}), {
    /**
   * The key/name of the optional space overview URL query parameter which was
   * introduced for optimization purposes only and is used by
   * `@confluence/query-preloaders` to preload space
   * homepage-related queries.
   */ HOMEPAGE_ID_QUERY_KEY: 'homepageId'
});
const $0d518026f9d519cf$export$1009a7f2cc1ac09f = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'HUB',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/hub'
});
const $0d518026f9d519cf$export$4dd08bdd46db5924 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'HUB_EDIT',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/hub/edit'
});
const $0d518026f9d519cf$export$ada7925da580b561 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'COMPANY_HUB',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/company-hub'
});
const $0d518026f9d519cf$export$29df24b01e938adf = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'COMPANY_HUB_ANALYTICS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/company-hub/analytics'
});
const $0d518026f9d519cf$export$e003e97fab6b4368 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'COMPANY_HUB_EDIT',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/company-hub/edit'
});
const $0d518026f9d519cf$export$5f7be6e90830de0c = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'COMPANY_HUB_SETTINGS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/company-hub/settings/:tab(general)?'
});
const $0d518026f9d519cf$export$9257b5b55c8e2555 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'VIEW_PAGE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/pages/:contentId(\\d+)/:contentSlug?',
    isTransition: (previousMatch, currentMatch)=>(0, $a24239c0837f4ae7$export$b5402fcece797a50)(previousMatch, currentMatch) || $0d518026f9d519cf$var$contentTransition(previousMatch, currentMatch),
    bifrost: {
        group: 'default',
        bundling: {
            packageName: 'ViewPageRoute',
            whichExportToUse: 'ViewPageRoute'
        },
        enabled: false,
        indexHtml: 'error-app.html',
        trafficToBifrostFeatureFlag: 'bifrost-gateway-view-page-route-killswitch'
    }
});
const $0d518026f9d519cf$export$475fdaba8e6145bb = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'NEXT_VIEW_PAGE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/next-pages/:contentId(\\d+)/:contentSlug?',
    isTransition: $0d518026f9d519cf$var$contentTransition
});
const $0d518026f9d519cf$export$347d3b5edaae00e0 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'BLOG_HOME',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/blog'
});
const $0d518026f9d519cf$export$91f49e7b30a9d34 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'VIEW_BLOG',
    ufoName: 'blog',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/blog/:contentId(\\d+)/:contentSlug?',
    isTransition: $0d518026f9d519cf$var$contentTransition,
    bifrost: {
        group: 'default',
        bundling: {
            packageName: 'ViewBlogRoute',
            whichExportToUse: 'ViewBlogRoute'
        },
        enabled: false,
        indexHtml: 'error-app.html',
        trafficToBifrostFeatureFlag: 'bifrost-gateway-view-blog-route-killswitch'
    }
});
const $0d518026f9d519cf$export$c259921a01da55b4 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'WHITEBOARD_HOME',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/whiteboard'
});
const $0d518026f9d519cf$export$5b90ced7e51bcea0 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'WHITEBOARD_BOARD',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/whiteboard/:contentId'
});
const $0d518026f9d519cf$export$7d8684a463b78f54 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CONTACT_ADMINISTRATOR',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/contact-administrators'
});
const $0d518026f9d519cf$export$eb54044908e4e0bd = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_SETTINGS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin'
});
const $0d518026f9d519cf$export$506a1a071415f2e = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_GLOBAL_AUTOMATION',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/automation'
});
const $0d518026f9d519cf$export$4e4c6a9eb23f65ec = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_EDIT_EXTERNAL_SHARING',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/public-links'
});
const $0d518026f9d519cf$export$b17d28dbf200fde0 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_FORGE_APPS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/forge\\?id=:id(.+)'
});
const $0d518026f9d519cf$export$5bfa1fef1b53dfdd = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_NEW_GLOBAL_PERMISSIONS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/permissions/global'
});
const $0d518026f9d519cf$export$dd6de41f650dae89 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_COMPANY_HUB_PERMISSIONS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/permissions/hub/:tab(groups|users|guests)?'
});
const $0d518026f9d519cf$export$8c6393d6207d929 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_COMPANY_HOME_BUILDER',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/look-and-feel/company-home-builder'
});
const $0d518026f9d519cf$export$9397e0d80cf06055 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_CUSTOMIZE_NAVIGATION',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/look-and-feel/customize-navigation'
});
const $0d518026f9d519cf$export$f107e7a692a3a54e = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_NEW_GLOBAL_PERMISSIONS_USER_DETAILS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/permissions/global/user/:accountId'
});
const $0d518026f9d519cf$export$5bbec961de23dce7 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_SITE_SPACE_PERMISSIONS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/permissions/space-permissions/:tab(defaults|allspaces|roles)?'
});
const $0d518026f9d519cf$export$f0e8d063cba10e9c = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_AUDIT_LOG',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/auditlogging.action'
});
const $0d518026f9d519cf$export$3039840c47d9a13d = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_BROWSE_SHORTCUTS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/browseshortcuts.action'
});
const $0d518026f9d519cf$export$e1e5a41fa357e66f = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_CREATE_SHORTCUT',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/createshortcut.action'
});
const $0d518026f9d519cf$export$4fcc3f53642c593a = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_REMOVE_SHORTCUT',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/removeshortcut.action'
});
const $0d518026f9d519cf$export$7234e6926944adc0 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_DARK_FEATURES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/darkfeatures.action'
});
const $0d518026f9d519cf$export$b86d7bd984fb9727 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_ENABLE_DARK_FEATURE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/enabledarkfeature.action'
});
const $0d518026f9d519cf$export$1afd9317831e345e = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_DISABLE_DARK_FEATURE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/disabledarkfeature.action'
});
const $0d518026f9d519cf$export$9e8d02f6bdb565e9 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_BETA_FEATURES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/betafeatures'
});
const $0d518026f9d519cf$export$f03a4adc711219ed = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_NEW_FEATURES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/newfeatures'
});
const $0d518026f9d519cf$export$af040d7344c912d1 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_LIVE_EDIT',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/liveedit'
});
const $0d518026f9d519cf$export$70e53b90503ea1b9 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_NBM_MIGRATION',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/nbm-migration'
});
const $0d518026f9d519cf$export$688990fbefa748b3 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_DC_SCRIPT_MIGRATION',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/script-migration'
});
const $0d518026f9d519cf$export$99ff0b9560c4fd04 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_NBM_PERFORMANCE_REPORT',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/nbm-performance-report'
});
const $0d518026f9d519cf$export$2925d036bbc38c7 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_CALENDAR',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/calendars\\?src=sidebar&openAddCalDialog=true'
});
const $0d518026f9d519cf$export$351b62e6f5786a73 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_CALENDARS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/calendars'
});
const $0d518026f9d519cf$export$4a2048bb71da8b4b = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_CALENDARS_SUBCALENDAR',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/calendars/:subCalendarId'
});
const $0d518026f9d519cf$export$7de5b687836953bd = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_EMBEDDED_SUBCALENDAR',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/embedded/calendars/:subCalendarId'
});
const $0d518026f9d519cf$export$27b2e48e28163360 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'DISCOVER',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/discover'
});
const $0d518026f9d519cf$export$f178fb5b1e822288 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ALL_UPDATES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/discover/all-updates'
});
const $0d518026f9d519cf$export$777796688df78f56 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'POPULAR',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/discover/popular'
});
const $0d518026f9d519cf$export$3907c7d8e57f70ba = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'MY_WORK_HOME',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/my'
});
const $0d518026f9d519cf$export$fe97ee265fd89939 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'MY_WORK_DRAFTS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/my/drafts'
});
const $0d518026f9d519cf$export$b71609db3dda2696 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'MY_WORK_RECENT',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/my/recent-work'
});
const $0d518026f9d519cf$export$730392c243a0a367 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'MY_RECENTLY_VISITED',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/my/recently-visited'
});
const $0d518026f9d519cf$export$85bd3cea0cecb26c = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'MY_SAVED_FOR_LATER',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/my/saved-for-later'
});
const $0d518026f9d519cf$export$c8a37c9f76d4d03f = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'RECENT_PAGES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/recent'
});
const $0d518026f9d519cf$export$771b75a6ca136f91 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'RECENT_VISITED',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/recent/visited'
});
const $0d518026f9d519cf$export$8e4a8343b1614a02 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'RECENT_DRAFTS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/recent/draft'
});
const $0d518026f9d519cf$export$2c9cf254b3b24ff = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'RECENT_SAVED',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/recent/saved'
});
const $0d518026f9d519cf$export$d925029e7ceadd51 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'TEMPLATE_MIGRATION_PREVIEW',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/template/migration/preview\\?templateId=:contentId([0-9a-z-]+)'
});
const $0d518026f9d519cf$export$e84c491e2d88d9f6 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EDIT_TEMPLATE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/templates/edit/:contentId([0-9a-z-]+)'
});
const $0d518026f9d519cf$export$4ce9d0d8218b9d84 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SITE_SETTINGS_EDIT_TEMPLATE_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/templates2/editpagetemplate.action',
    condition: ({ query: query })=>Boolean(query.entityId && Object.keys(query).length === 1)
});
const $0d518026f9d519cf$export$a990a60696f54618 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EDIT_TEMPLATE_BLUEPRINT',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/templates/edit/:pluginKey/:moduleKey'
});
const $0d518026f9d519cf$export$f8d71dcb352ebe8c = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EDIT_DEFAULT_BLUEPRINT_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/plugins/createcontent/edit-template.action',
    condition: ({ query: query })=>Boolean(query.key && query.contentTemplateRefId && Object.keys(query).length === 2) || Boolean(query.contentTemplateRefId && Object.keys(query).length === 1)
});
const $0d518026f9d519cf$export$b45af2e1d7abb289 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SITE_SETTINGS_EDIT_SYSTEM_TEMPLATE_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/plugins/createcontent/edit-template.action',
    condition: ({ query: query })=>Boolean(query.pluginKey && query.moduleKey && Object.keys(query).length === 2)
});
const $0d518026f9d519cf$export$c0a209b0b0b16c75 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EDIT_TEMPLATE_SPACE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/templates/edit/:contentId([0-9a-z-]+)'
});
const $0d518026f9d519cf$export$dcee5dee04648c93 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CREATE_TEMPLATE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/templates/create'
});
const $0d518026f9d519cf$export$793ade69cc97583f = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CREATE_TEMPLATE_SITE_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/templates2/createpagetemplate.action'
});
const $0d518026f9d519cf$export$499f432aa493cdd2 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CREATE_TEMPLATE_SPACE_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/templates2/createpagetemplate.action',
    condition: ({ query: query })=>Boolean(query.key && Object.keys(query).length === 1)
});
const $0d518026f9d519cf$export$dcda7f8b6fe54ba = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CREATE_TEMPLATE_SPACE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/templates/create'
});
const $0d518026f9d519cf$export$9e430f65574f5333 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'HELLO_WORLD',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/hello-world'
});
const $0d518026f9d519cf$export$e9d78b13bbb4e56f = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'DASHBOARD_ACTION_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/dashboard.action'
});
const $0d518026f9d519cf$export$d7be6003270f6c2d = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPA_ACTION_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spa.action'
});
const $0d518026f9d519cf$export$b49467be269d2629 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'INDEX_ACTION_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/index.action'
});
const $0d518026f9d519cf$export$e52245e856f5c06 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CREATE_PAGE_ACTION_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/createpage.action'
});
const $0d518026f9d519cf$export$926e3916067d7530 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CREATE_BLOG_ACTION_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/createblogpost.action'
});
const $0d518026f9d519cf$export$e720b1e170b46aae = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CREATE_PAGE_VARIABLES_ACTION_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/createpage-entervariables.action'
});
const $0d518026f9d519cf$export$6c7b95dcf08f3a6d = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'RESUME_DRAFT_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/resumedraft.action'
});
const $0d518026f9d519cf$export$b010f02787df1e6 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'COPY_PAGE_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/copypage.action'
});
const $0d518026f9d519cf$export$ecc28d15af39a8b2 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'VIEW_PAGE_ACTION_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/viewpage.action',
    // viewpage.action should be served from Monolith when it has pageVersion query
    condition: ({ query: query })=>Boolean(query.pageId && Object.keys(query).length === 1)
});
const $0d518026f9d519cf$export$482db086bc8c2289 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_OVERVIEW_INDEX_ACTION_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/overview/index.action'
});
const $0d518026f9d519cf$export$3afea7266d0d139b = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_INDEX_ACTION_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/index.action'
});
const $0d518026f9d519cf$export$4eb80c3a4e6fbe0f = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_PAGES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/pages'
});
const $0d518026f9d519cf$export$bd2c9bb170b3681d = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'VIEW_BLOG_DATE_LEGACY',
    ufoName: 'blog',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/blog/:year(\\d+)/:month(\\d+)/:day(\\d+)/:contentId(\\d+)/:contentSlug?',
    isTransition: $0d518026f9d519cf$var$contentTransition,
    bifrost: {
        group: 'default',
        bundling: {
            packageName: 'ViewBlogRoute',
            whichExportToUse: 'ViewBlogRoute'
        },
        enabled: false,
        indexHtml: 'error-app.html',
        trafficToBifrostFeatureFlag: 'bifrost-gateway-view-blog-route-killswitch'
    }
});
const $0d518026f9d519cf$export$5c9eaf42f32252ea = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ACTION_REDIRECT_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/(.*).action',
    condition: ({ query: query })=>query.key == null
});
const $0d518026f9d519cf$export$7ae0ea91a2dfc4d9 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADVANCED_SEARCH_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/dosearchsite.action'
});
const $0d518026f9d519cf$export$3bd4ec9f05d79904 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADVANCED_SEARCH',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/search',
    bifrost: {
        group: 'default',
        bundling: {
            packageName: 'AdvancedSearchRoute',
            whichExportToUse: 'AdvancedSearchRoute'
        },
        enabled: false,
        indexHtml: 'error-app.html',
        trafficToBifrostFeatureFlag: 'bifrost-gateway-search-route-killswitch'
    }
});
const $0d518026f9d519cf$export$2bc30aa6642650c = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'LABELLED_CONTENT',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/label/:spaceKey/:labelName(.+)'
});
const $0d518026f9d519cf$export$d593e642a326a501 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EXTERNAL_SHARE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/external/:contentId?/:externalToken'
});
const $0d518026f9d519cf$export$6490fab56523ceda = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'PDF_EXPORT_PAGE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pdf/spaces/:spaceKey/pages/:contentId(\\d+)'
});
const $0d518026f9d519cf$export$dcb1d1a9cda087b1 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'PDF_EXPORT_SPACE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pdf/spaces/:spaceKey/pages/overview'
});
const $0d518026f9d519cf$export$6b2db7909585abd7 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'LEGACY_SPACE_PDF_EXPORT',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/flyingpdf/flyingpdf.action\\?key=:spaceKey([^&]+)'
});
const $0d518026f9d519cf$export$2dd65cdecd8b05d7 = new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EXPORT_SPACE_CSV',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/exportspacecsv.action\\?key=:spaceKey'
});
const $0d518026f9d519cf$export$d78f611c1ddf7234 = new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EXPORT_SPACE_XML',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/exportspacexml.action\\?key=:spaceKey'
});
const $0d518026f9d519cf$export$9dc7f7e5e1435bc = new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EXPORT_SPACE_HTML',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/exportspacehtml.action\\?key=:spaceKey'
});
const $0d518026f9d519cf$export$1bc544543b946246 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'VIEW_PAGE_MOBILE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/mobile/spaces/:spaceKey/pages/:contentId(\\d+)/:contentSlug?'
});
const $0d518026f9d519cf$export$d387bb8ca9ce25d1 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'VIEW_BLOG_MOBILE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/mobile/spaces/:spaceKey/blog/:year(\\d+)/:month(\\d+)/:day(\\d+)/:contentId(\\d+)/:contentSlug?'
});
const $0d518026f9d519cf$export$3d8579587b62bb96 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'MOBILE_MACRO_RENDERER',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/mobileapp/macro/:contentId(\\d+)'
});
const $0d518026f9d519cf$export$f7bf92a6467c1557 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'PEOPLE_DIRECTORY_SEARCH',
    pattern: '/people/search'
});
const $0d518026f9d519cf$export$ed260c82a3e70a6a = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CONFLUENCE_PEOPLE_DIRECTORY_SEARCH',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/people/search'
});
const $0d518026f9d519cf$export$a90430d7f36bfe9e = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'MARKETPLACE_FIND_APPS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/marketplace(.*)'
});
const $0d518026f9d519cf$export$22bb05181a4b1501 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'MARKETPLACE_APP_REQUESTS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/marketplace/manage/app-requests'
});
const $0d518026f9d519cf$export$cb73aa9f5b7d1ea0 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'MARKETPLACE_MANAGE_PROMOTIONS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/marketplace/manage/promotions'
});
const $0d518026f9d519cf$export$df78b182760b42f4 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'PEOPLE_DIRECTORY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/people/([\\w:-]+)*'
});
const $0d518026f9d519cf$export$2d3703cff5d9a27 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_RESTRICTED_PAGES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/listpermissionpages.action'
});
const $0d518026f9d519cf$export$60773cf116cf5f30 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_ARCHIVED_PAGES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/archivedpages'
});
const $0d518026f9d519cf$export$40e965fb568c3c83 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'PAGE_DIFF_BY_VERSION',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/diffpagesbyversion.action'
});
const $0d518026f9d519cf$export$cb80c94a905e11b6 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SITE_ANALYTICS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/analytics/:tab(overview|spaces|users|search)?'
});
const $0d518026f9d519cf$export$93b558a6e07dbdac = new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SITE_ANALYTICS_PERMISSIONS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/analytics/permissions'
});
const $0d518026f9d519cf$export$67acd8a63f03bc8 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_ANALYTICS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/analytics/:tab(overview|content|users)?'
});
const $0d518026f9d519cf$export$6b9c632e635b4d77 = new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_ANALYTICS_PERMISSIONS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/analytics/permissions'
});
const $0d518026f9d519cf$export$37a588b556645c19 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'PAGE_ANALYTICS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/analytics/:contentId(\\d+)/:tab(overview|mentions|links)?'
});
const $0d518026f9d519cf$export$aded01fc53d469df = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_QUESTIONS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/display/:spaceKey/customcontent/list/ac%3Acom.atlassian.confluence.plugins.confluence-questions%3Aquestion'
});
const $0d518026f9d519cf$export$cdd412f0619f2d7e = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_QUESTIONS_NATIVE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/questions'
});
const $0d518026f9d519cf$export$aa72b945229db170 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_QUESTION_NATIVE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/questions/:questionId'
});
const $0d518026f9d519cf$export$f0c4a6dc3b3437aa = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_CUSTOM_CONTENT_LIST',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/display/:spaceKey/customcontent/list/:type'
});
const $0d518026f9d519cf$export$1a5e481ee166ad7c = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CUSTOM_CONTENT_VIEW',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/display/:spaceKey/customcontent/:contentId(\\d+)'
});
const $0d518026f9d519cf$export$f39a30a3a5635bab = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_BULK_TOOLS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/bulktools'
});
const $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH = (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/settings';
const $0d518026f9d519cf$export$3101773a7a844077 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_LANDING_PAGE',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/home'
});
const $0d518026f9d519cf$export$f03524b1e395be4a = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_LANDING_PAGE_ALT',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH
});
const $0d518026f9d519cf$export$38b94ff4631b44df = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_AUTOMATION',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/automation'
});
const $0d518026f9d519cf$export$5f63ad7e18293ec2 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_DETAILS',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/details'
});
const $0d518026f9d519cf$export$26dfba554adbf87e = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_ARCHIVE_SPACE',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/archiveSpace'
});
const $0d518026f9d519cf$export$1b93424785e5f745 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_TRASH_SPACE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/removespace.action\\?key=:spaceKey([^&]+)'
});
const $0d518026f9d519cf$export$2cc9af506d64ef72 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_EDITOR_CONVERSION',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/editorConversion'
});
const $0d518026f9d519cf$export$693d9b367ae8d0f7 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_RELATED_PAGES',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/relatedPages'
});
const $0d518026f9d519cf$export$22f8e464aee70413 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_EDIT_FEATURES',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/editFeatures'
});
const $0d518026f9d519cf$export$345aea7dc51bac8a = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_TEMPLATES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/settings/look-and-feel/templates'
});
const $0d518026f9d519cf$export$499a561f6d1a011 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_EDIT_TEMPLATE_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/templates2/editpagetemplate.action',
    condition: ({ query: query })=>Boolean(query.entityId && query.key && Object.keys(query).length === 2)
});
const $0d518026f9d519cf$export$4f46a1e4250ebe18 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_LOOK_AND_FEEL_SETTINGS',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/look-and-feel/:tab(themes|templates|page-layout|pdf-export)'
});
const $0d518026f9d519cf$export$e64d4514fc584fbe = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_PERMISSIONS_SETTINGS',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/permissions/:tab(groups|users|guests|anonymous|public-links|analytics|apps)?'
});
const $0d518026f9d519cf$export$323161697c5fa666 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ROLE_BASED_ACCESS_CONTROL_HUB',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/roles-hub'
});
const $0d518026f9d519cf$export$2f6a532274e0cd9d = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_PERMISSIONS_APPS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/addonpermissions.action\\?key=:spaceKey([^&]+)'
});
const $0d518026f9d519cf$export$a007a4f7553ffc16 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EDIT_SPACE_PERMISSIONS_APPS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/editaddonpermissions.action\\?key=:spaceKey([^&]+)'
});
const $0d518026f9d519cf$export$629e966630a1f92e = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_MEMBERS',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/members'
});
const $0d518026f9d519cf$export$f0e860396acf6277 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_FORGE_APPS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/apps/:appId([0-9a-z-]+)/:envId([0-9a-z-]+)/:forgeManifestRoute([0-9a-z-]+)/:appRoutePath*'
});
const $0d518026f9d519cf$export$4442c9c7bb716896 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'GLOBAL_PAGE_FORGE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/apps/:appId([0-9a-z-]+)/:envId([0-9a-z-]+)/:forgeManifestRoute([0-9a-z-]+)/:appRoutePath*'
});
const $0d518026f9d519cf$export$abe337275802eab4 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'FULL_PAGE_FORGE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/full-page/:appId([0-9a-z-]+)/:envId([0-9a-z-]+)/:appRoutePath*'
});
const $0d518026f9d519cf$export$ffd880217e61385f = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_FORGE_APPS',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/apps/:appId([0-9a-z-]+)/:envId([0-9a-z-]+)/:forgeManifestRoute([0-9a-z-]+)?/:appRoutePath*'
});
const $0d518026f9d519cf$export$8bf619366f9e74f2 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_AVATARS_AND_STATUS',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/avatarsAndStatus'
});
const $0d518026f9d519cf$export$a85b9c60514cd043 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_CONTENT_STATE',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/contentStatuses'
});
const $0d518026f9d519cf$export$19b893a9e64dac94 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_DATA_CLASSIFICATION',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/classifications'
});
const $0d518026f9d519cf$export$3d39129bec795227 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_WATERMARK_CONFIGURATION',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/watermark'
});
const $0d518026f9d519cf$export$939b28e9f8987d97 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_EXPORT_SPACE_UNAVAILABLE',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/exportSpaceUnavailable'
});
const $0d518026f9d519cf$export$3582accdd821993a = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_EXPORT',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/export'
});
const $0d518026f9d519cf$export$871ac71d42c178c5 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_LEGACY_CONTENT',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/legacy-content'
});
const $0d518026f9d519cf$export$b8adcf19ff927cec = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_EXPORT_SPACE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/exportspacewelcome.action\\?key=:spaceKey([^&]+)'
});
const $0d518026f9d519cf$export$751ae19fa150b7c = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_TRASH',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/viewtrash.action\\?key=:spaceKey([^&]+)'
});
const $0d518026f9d519cf$export$526ccce5d32f7beb = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'MOBILE_TAKEOVER_PAGE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/mobileapp'
});
const $0d518026f9d519cf$export$ed19a29c446e24d8 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'DEFAULT_ADMIN_MANAGE_APPS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/plugins/servlet/upm'
});
const $0d518026f9d519cf$export$7de52f6cc232129e = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_APP_AUDIT_LOGS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/plugins/servlet/upm/log'
});
const $0d518026f9d519cf$export$81cfd93b1b89cd07 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_TEMPLATE_LIST_PAGE_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/templates2/listpagetemplates.action\\?key=:spaceKey([^&]+)'
});
const $0d518026f9d519cf$export$31745f3bff21cd = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_TEMPLATES_AND_BLUEPRINTS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/templates-and-blueprints'
});
const $0d518026f9d519cf$export$7af7a1e753a92264 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_APPLICATION_NAVIGATOR',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/application-navigator'
});
const $0d518026f9d519cf$export$28e7e683f23a58d3 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CUSTOM_CONTENTS_ON_PAGE_LIST',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/display/:spaceKey/pages/:contentId(\\d+)/customcontents/:type?'
});
const $0d518026f9d519cf$export$3ce513606c31c918 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_ANNOUNCEMENT_BANNER_RENDERER',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/announcements/:id(.*)?'
});
const $0d518026f9d519cf$export$dfa725d05e18145e = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'USER_ACCESS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/user-access'
});
const $0d518026f9d519cf$export$8674e83405059790 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'PERMISSIONS_EXPORT',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/permissions-export'
});
const $0d518026f9d519cf$export$652395dc5ff9b416 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'IMPORTER_STATUS_DASHBOARD',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/importer-status-dashboard'
});
const $0d518026f9d519cf$export$4d1bccc78b263a8e = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_MANAGER',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/space-manager'
});
const $0d518026f9d519cf$export$df327d9b56ca6b7c = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_CENTER',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/center'
});
const $0d518026f9d519cf$export$53f195d79ef3d4dd = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_CENTER_SPACE',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/mission-control'
});
const $0d518026f9d519cf$export$23e7002e5e9ef89e = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_TEAM_CALENDARS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/teamcalendars'
});
const $0d518026f9d519cf$export$299af9061dea1f09 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_CONFIGURATION',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/configuration'
});
const $0d518026f9d519cf$export$eb5a785192323bd3 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_DEFAULT_SPACE_LOGO',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/default-space-logo'
});
const $0d518026f9d519cf$export$168f3acd059931e0 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_HEADER_AND_FOOTER',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/header-and-footer'
});
const $0d518026f9d519cf$export$3bcebf4f1e82d3ad = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_SECURITY_CONFIGURATION',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/security-configuration'
});
const $0d518026f9d519cf$export$42599f111394c36c = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_SPACE_REPORTS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/space-reports'
});
const $0d518026f9d519cf$export$e05db3c2f69bd3ae = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_COLOR_SCHEME',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/color-scheme'
});
const $0d518026f9d519cf$export$4c6bf75100b3b72 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_CODE_MACRO_CONFIGURATION',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/code-macro-configuration'
});
const $0d518026f9d519cf$export$70914a626e2f0488 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_TRASHED_SPACES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/trashed-spaces'
});
const $0d518026f9d519cf$export$3d0698fcdc33631d = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_IMPORT_SPACES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/space-import'
});
const $0d518026f9d519cf$export$85c61af9d225a707 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_JIRA_MACRO_REPAIR',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/jira-macro-repair'
});
const $0d518026f9d519cf$export$c0d0d3f98d45e5f1 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_MACRO_USAGE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/macro-usage'
});
const $0d518026f9d519cf$export$69df75bd8c217ade = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_MACRO_USAGE_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/pluginusage.action'
});
const $0d518026f9d519cf$export$e8beba40e140a443 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_THEMES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/themes'
});
const $0d518026f9d519cf$export$c471be73599ccae1 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_PDF_EXPORT',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/pdf-export'
});
const $0d518026f9d519cf$export$9859a7a7049d0585 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'DATABASE_CUSTOM_OVERVIEW',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/custom/database/overview'
});
const $0d518026f9d519cf$export$90480461935b54cc = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'DATABASE_CUSTOM_VIEW',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/custom/database/:contentId(\\d+)'
});
const $0d518026f9d519cf$export$851ba2be5095d586 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'DATABASE_VIEW',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/database/:contentId'
});
const $0d518026f9d519cf$export$84b5e15197aaaa12 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EMBED_VIEW',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/embed/:contentId'
});
const $0d518026f9d519cf$export$4dcf771d1a1901ef = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'FOLDER_VIEW',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/folder/:contentId'
});
const $0d518026f9d519cf$export$752c480a913a6712 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_BULK_PERMISSIONS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/permissions/bulk-permissions'
});
const $0d518026f9d519cf$export$16172a64bcdb79f8 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_NOTIFICATIONS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/notifications'
});
const $0d518026f9d519cf$export$59a52cdd0906f4cb = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'TOPICS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/topics/:topicId'
});
const $0d518026f9d519cf$export$57a75dda1f25b360 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'PREMIUM_ADMIN_FEATURES_EXPERIMENT',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/premium-admin-features'
});
const $0d518026f9d519cf$export$3ebf2fc23df50648 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ATTACHMENTS_PAGE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/attachments/:contentId(\\d+)?'
});
const $0d518026f9d519cf$export$96e9320cb2b14c85 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'AI_SEARCH_PAGE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/ai-search/'
});



var $gqzfn = parcelRequire("gqzfn");
const $4b72a15528d34979$var$nullNoop = ()=>null;
const $4b72a15528d34979$var$objNoop = ()=>({});
const $4b72a15528d34979$var$stringNoop = ()=>'';
const $4b72a15528d34979$var$voidNoop = ()=>{};
const $4b72a15528d34979$export$779e8f71c6bb38c = (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createContext({
    getHref: $4b72a15528d34979$var$stringNoop,
    history: null,
    location: null,
    match: null,
    transitionId: null,
    toUrl: $4b72a15528d34979$var$stringNoop,
    matchRoute: $4b72a15528d34979$var$nullNoop,
    matchSupportedRoute: $4b72a15528d34979$var$nullNoop,
    getQueryParams: $4b72a15528d34979$var$objNoop,
    setQueryParams: $4b72a15528d34979$var$voidNoop,
    getHash: $4b72a15528d34979$var$stringNoop,
    setHash: $4b72a15528d34979$var$voidNoop,
    replace: $4b72a15528d34979$var$voidNoop,
    routes: [],
    push: $4b72a15528d34979$var$voidNoop,
    open: $4b72a15528d34979$var$nullNoop,
    onPageReload: $4b72a15528d34979$var$voidNoop,
    preloadRoute: $4b72a15528d34979$var$voidNoop
});
$4b72a15528d34979$export$779e8f71c6bb38c.displayName = 'RoutesContext';


function $1262eee5c487dee7$export$cf1af05a5f90ab81() {
    $1262eee5c487dee7$var$useAnchorEventListener('click', $1262eee5c487dee7$var$spaTransitionOnAnchorClick, false);
    $1262eee5c487dee7$var$useAnchorEventListener('mousedown', $1262eee5c487dee7$var$preloadRouteOnMouseDown, true);
    $1262eee5c487dee7$var$useAnchorEventListener('preloadOnHover', $1262eee5c487dee7$var$preloadRouteOnMouseHover, true);
    return null;
}
function $1262eee5c487dee7$var$createAnchorEventListener(eventListener, routesContext) {
    return (e)=>{
        // Some code already handled this
        if (e.defaultPrevented) return;
        const details = $1262eee5c487dee7$export$bd34341d1dc0003f(e, routesContext);
        if (details) eventListener(e, routesContext, details);
    };
}
function $1262eee5c487dee7$var$isContentEditable(element) {
    return element instanceof HTMLElement && element.isContentEditable;
}
function $1262eee5c487dee7$export$bd34341d1dc0003f(e, routesContext) {
    if (e.type === 'preloadOnHover') {
        const detail = e.detail;
        if (detail?.preloadUrl) {
            const { preloadUrl: preloadUrl, ...preloadOptions } = detail;
            return {
                href: preloadUrl,
                ...preloadOptions
            };
        }
        return;
    }
    if (!('button' in e) || e['button'] !== 0 /* main button */ ) return;
    // Don't handle if modifier keys used
    if (e['ctrlKey'] || e['shiftKey'] || e['altKey'] || e['metaKey']) return;
    const { target: target } = e;
    if (!target || !(target instanceof Element)) return;
    // This might be the child of an anchor (such as the span inside of a smart card),
    // so check for a parent anchor.
    const anchor = target.closest('a');
    if (!anchor) return;
    //ignore hash links, they're handled by scroll handlers that also listen to document click
    if (!(anchor instanceof HTMLAnchorElement) || 'hash' in anchor && anchor['hash']) return;
    // Links in contenteditable elements are not clickable
    // https://product-fabric.atlassian.net/browse/CEMS-951
    // Checking closest 'contentEditable' for anchor,
    // In case there are "contenteditable=false" in between target and anchor.
    // Also check the property, since contenteditable="false" is possible
    const closestContentEditableFromAnchor = anchor.closest('[contenteditable]');
    const closestContentEditableFromTarget = target.closest('[contenteditable]');
    if ($1262eee5c487dee7$var$isContentEditable(closestContentEditableFromAnchor) || $1262eee5c487dee7$var$isContentEditable(closestContentEditableFromTarget)) return;
    const noGlobalAnchorHandler = target.closest('[data-no-global-anchor-handler]');
    if (noGlobalAnchorHandler) return;
    // Only handle anchors with relevant targets
    if (anchor.target && anchor.target !== '_self') return;
    const { href: href } = anchor;
    if (!href) return;
    // CONFCLOUD-69367
    // skip copy page legacy to allow user to edit page title
    // CEMS-1140
    // skip create page legacy to allow user to create a page using newer working fabric creation
    if (!routesContext || typeof routesContext.matchRoute !== 'function') return;
    const match = routesContext.matchRoute(href);
    if (match && (match.name === (0, $0d518026f9d519cf$export$b010f02787df1e6).name || match.name === (0, $0d518026f9d519cf$export$e52245e856f5c06).name)) return;
    return {
        href: href
    };
}
function $1262eee5c487dee7$var$preloadRouteOnMouseDown(_, { preloadRoute: preloadRoute }, { href: href }) {
    preloadRoute(href);
}
function $1262eee5c487dee7$var$preloadRouteOnMouseHover(_, { preloadRoute: preloadRoute }, { href: href, ...preloadOptions }) {
    preloadRoute(href, preloadOptions);
}
function $1262eee5c487dee7$var$spaTransitionOnAnchorClick(e, { push: push }, { href: href }) {
    e.preventDefault();
    push(href, Boolean((0, $0d518026f9d519cf$export$d593e642a326a501).match(window.location.pathname)));
}
function $1262eee5c487dee7$var$useAnchorEventListener(type, anchorEventListener, useCapture) {
    const routesContext = (0, $gqzfn.useContext)((0, $4b72a15528d34979$export$779e8f71c6bb38c));
    const eventListener = (0, $gqzfn.useMemo)(()=>$1262eee5c487dee7$var$createAnchorEventListener(anchorEventListener, routesContext), [
        anchorEventListener,
        routesContext
    ]);
    (0, $gqzfn.useEffect)(()=>{
        if (eventListener) window.addEventListener(type, eventListener, useCapture);
        return ()=>{
            if (eventListener) window.removeEventListener(type, eventListener, useCapture);
        };
    }, [
        eventListener,
        type,
        useCapture
    ]);
}



var $gqzfn = parcelRequire("gqzfn");
const $32f18ec2049bb41d$var$GlobalPromptContext = /*#__PURE__*/ (0, $gqzfn.createContext)(null);
const $32f18ec2049bb41d$export$71d99832f5dd52ec = ()=>(0, $gqzfn.useContext)($32f18ec2049bb41d$var$GlobalPromptContext);
const $32f18ec2049bb41d$export$a082affa499ae96f = ({ children: children, globalPromptHandler: globalPromptHandler })=>{
    const contextValue = (0, $gqzfn.useMemo)(()=>({
            globalPromptHandler: globalPromptHandler
        }), [
        globalPromptHandler
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement($32f18ec2049bb41d$var$GlobalPromptContext.Provider, {
        value: contextValue
    }, children);
};



class $b7f189155d041ca2$export$aea2bc6590a5ea49 {
    /**
   * Registers a prompt string with its associated callback function.
   * This should be used in place of react-router's Prompt functionality. When registered, the callback
   * will be executed on every route change attempt, blocking the route change (the transition).
   *
   * The callback should return:
   * - true to show the prompt and block navigation
   * - false to allow navigation without prompting
   *
   * User interaction flow:
   * - If callback returns true, the user will see a browser confirmation dialog (window.confirm) with the provided message.
   * - If user clicks "OK", the route change continues and the prompt is automatically cleared.
   * - If user clicks "Cancel", the route change is prevented and the prompt remains active.
   * - If the route change is successful even if prompt wasn't shown, the prompt state is cleared automatically.
   *
   * Technical Reminders:
   * - When registering a prompt, ensure your implementation clears the prompt if it is no longer needed, by invoking clear().
   * - There can only be a maximum of one prompt registered at a time. Ensure your code flow won't conflict with existing use cases of registerPrompt.
   *
   * @param {Object} params - The parameters for the prompt registration.
   * @param {string} params.promptString - The message displayed in the browser confirmation dialog.
   * @param {PromptCallback} params.callback - A function that receives route transition info and returns true to show the confirmation dialog, false to allow navigation without prompting.
   */ registerPrompt({ promptString: promptString, callback: callback, onConfirm: onConfirm, onCancel: onCancel }) {
        this.promptString = promptString;
        this.promptCallback = callback;
        this.onConfirm = onConfirm ?? null;
        this.onCancel = onCancel ?? null;
    }
    /**
   * Clears the currently stored prompt string and callback, resetting the handler state.
   * This is done automatically on successful route change, but you should invoke it if you registered the prompt and no longer need it.
   */ clear() {
        this.promptString = null;
        this.promptCallback = null;
        this.onConfirm = null;
        this.onCancel = null;
    }
    /**
   * Gets the current prompt string if it exists and the callback returns true.
   *
   * @param {Object} args - The route transition arguments.
   * @param {RouteMatch | null} args.previousMatch - The previous route match.
   * @param {RouteMatch} args.nextMatch - The next route match.
   * @returns {string | null} The prompt string if conditions are met, null otherwise.
   */ getPromptString(args) {
        if (!this.promptString || !this.promptCallback) return null;
        try {
            const shouldPrompt = this.promptCallback({
                previousMatch: args.previousMatch,
                nextMatch: args.nextMatch
            });
            return shouldPrompt ? this.promptString : null;
        } catch (error) {
            this.logger.error`Error executing prompt callback: ${error}`;
            return null;
        }
    }
    /**
   * Triggers the prompt if it exists and the prompt callback returns true.
   *
   * @param {Object} args - The route transition arguments.
   * @param {RouteMatch | null} args.previousMatch - The previous route match.
   * @param {RouteMatch} args.nextMatch - The next route match.
   * @returns {Object} Returns {isPromptBlocking: true} if transition should be blocked because prompt was shown and user canceled,
   *                   otherwise returns {isPromptBlocking: false}
   */ triggerPrompt({ previousMatch: previousMatch, nextMatch: nextMatch }) {
        if (!this.promptString) return {
            isPromptBlocking: false
        };
        const promptString = this.getPromptString({
            previousMatch: previousMatch,
            nextMatch: nextMatch
        });
        if (promptString) {
            const userConfirmed = window.confirm(promptString);
            if (userConfirmed) {
                this.onConfirm?.();
                this.clear();
            } else {
                this.onCancel?.();
                // User cancelled, block the transition
                return {
                    isPromptBlocking: true
                };
            }
        }
        return {
            isPromptBlocking: false
        };
    }
    constructor(){
        this.logger = (0, $a6897acd40ed68b1$export$2b1d391cd05230fd)('GlobalPromptHandler');
        this.promptString = null;
        this.promptCallback = null;
        this.onConfirm = null;
        this.onCancel = null;
    }
}





var $34Zxt = parcelRequire("34Zxt");



class $e7d32f2c649e2db9$export$46a841557056026b extends Error {
    constructor(message){
        super(message);
        this.name = 'ExternalRejectionError';
    }
}
class $e7d32f2c649e2db9$export$2f8f0e0ec8218c4b {
    /**
   * Registers a transition callback that will be awaited on a route change.
   * The callback will only be invoked if the `onlyCalledIfFunc` returns true or if `onlyCalledIfFunc` is not provided. e.g. To check that a contentId is what you expect it should be. `onlyCalledIfFunc` should be very performant as it will run every route change.
   *
   * PERFORMANCE WARNING: `onlyCalledIfFunc` is executed every route change, and `callback` promise is awaited every time `onlyCalledIfFunc` returns `true` (or if it doesn't exist).
   *                      If either of these functions are not very performant, it could cause undesirable performance degradation on every transition.
   *                      Try to avoid any time-intensive invocations, especially in `onlyCalledIfFunc`. `onlyCalledIfFunc` ideally only runs a condition the `match` that it's passed, e.g. to check `match.params.contentId` or `match.pathname`.
   *                      BEFORE REGISTERING A NEW TRANSITION CALLBACK, you must be confident that the negative performance impact is acceptable.
   *
   * @example registerTransitionCallback({
   *     id: 'unique-id-related-to-my-code',
   *     callback: ({match}) => {
   *         // Do preloading logic, must return a promise
   *         return new Promise((resolve) => {
   *             const nextContentId = match.params?.contentId;
   *             // do logic that is a hard pre-requisite for next route and cannot be lazy/concurrently loaded, ideally shouldn't be slow
   *             resolve(); // route change gets unblocked after these callback promises are resolved
   *         }
   *     },
   *     onlyCalledIfFunc: ({match}) => {
   *         // Optional but recommended
   *         const nextContentId = match.params?.contentId;
   *         // Do very quick logic, ideally no logic that we need to wait for, this function is run every route change
   *         if (isLiveDoc(contentId)) {
   *             return true;
   *         } else {
   *             return false;
   *         }
   *     },
   *     onPerformanceMetricStart: ({match}) => {
   *         // Optional but recommended
   *         const nextContentId = match.params?.contentId;
   *         // Should be used to quickly start any page load performance metrics that you want to track for this route change
   *         // If you don't use this, your existing page load metric will likely start after the preloading and after the route change.
   *         // We want page load metrics to start before preloading, not after.
   *     },
   *     onRouteContinueCallback: async ({match}) => {
   *		   // Optional, must return a promise (i.e. or be async)
   *         const nextContentId = match.params?.contentId;
   *         // Do very quick logic that will run only if we're about to transition routes, runs after callback promise.
   *         // Can be used to do logic that you want to ensure doesn't occur on outdated route changes, e.g. connecting to nextContentId's collab provider
   *     },
   * });
   *
   * @param {Object} params - The parameters for the transition callback.
   * @param {string} params.id - A unique identifier used to inform other components the callback was run, to clean up outdated promises, and to prevent duplicate callback registrations.
   * @param {TransitionCallback} params.callback - The callback function to be executed during a route transition. Must return a promise.
   * @param {OnlyCalledIfFunc} params.onlyCalledIfFunc - A function that determines whether the callback should be called.
   * @param {OnRouteContinueCallback} params.onRouteContinueCallback - Callback function that must return a promise. This is called right after the transition callback promises finish but before we continue the route transition, the returned promise blocks route transition. This function won't be called if route has changed before callback promise resolves.
   * @param {OnPerformanceMetricStartCallback} params.onPerformanceMetricStart - Callback function to start performance metrics. Called as we start running the transition callback promises.
   * @returns {boolean} - Returns `true` if the transition callback was registered, `false` if it was not registered (due to already being registered or being mid-transition).
   */ registerTransitionCallback({ id: id, callback: callback, onlyCalledIfFunc: onlyCalledIfFunc, onRouteContinueCallback: onRouteContinueCallback, onPerformanceMetricStart: onPerformanceMetricStart }) {
        // We want to keep transition callbacks unique to guarantee we aren't duplicating work, so we tie callbacks to an ID. If there are multiple registrations of the same callback ID, we ignore registration attempts if we're already registered.
        // We don't allow registering transition callbacks while transitioning, to avoid race conditions leading to infinite route change loops.
        if (this.transitionProcessingState !== 'not_processing' || this.callbacks.has(id)) return false;
        this.callbacks.set(id, {
            callback: callback,
            onlyCalledIfFunc: onlyCalledIfFunc,
            onRouteContinueCallback: onRouteContinueCallback,
            onPerformanceMetricStart: onPerformanceMetricStart
        });
        return true;
    }
    /**
   * Processes transition callbacks during a route change, checking if we need to create promises from callbacks, and waiting for them to resolve/reject before continuing the route change.
   * `processTransitionCallback` will set `this.isTransitionCallbackRunning` to true, preventing callback registration. RouteManager is responsible for clearing it via `onTransitionComplete`.
   *
   * @param {{ match: Match; onRouteContinue: () => void; transitionId: number; interactionContext?: UFOInteractionContextType | null }} args - The arguments containing the route `match` object, RouteManager `transitionId`, the `onRouteContinue` continuation function, and optional UFO interaction context.
   *                                                                                     `onRouteContinue` is called once promises resolve and should finish executing the route change.
   * @returns {boolean} - Returns `true` if processing transition callback and transition should not continue (until promise finishes and calls onRouteContinue).
   *                      Returns `false` if not processing transition callback and routeChangeHandler should continue running.
   */ processTransitionCallback({ match: match, transitionId: transitionId, onRouteContinue: onRouteContinue, interactionContext: interactionContext, startPageLoadMetrics: startPageLoadMetrics }) {
        try {
            if (!this.callbacks.size) {
                // Update latest route details to keep this.getCurrentRouteCallbackIds() is accurate. If transitionId has changed, accurately reflect that there are no callbackIds for that route change.
                if (transitionId !== this.currentRouteDetails.transitionId) this.currentRouteDetails = {
                    transitionId: transitionId,
                    callbackIds: [],
                    pathname: match?.pathname || ''
                };
                return {
                    isProcessingCallback: false
                };
            }
            this.transitionProcessingState = 'processing';
            const previousPathname = this.latestPathname;
            this.latestPathname = match?.pathname;
            if (this.latestPathname !== previousPathname) // Cancel all currently running promises because we're going to a different route. Helps prevent multiple quick route changes from causing race condition that could send user to outdated route change.
            // If needed, `getCallbackPromises` below will create new promises for the latest route.
            this.cancelActivePromises();
            const { callbackIds: callbackIds } = this.getCallbackIds({
                match: match
            });
            const { callbackPromises: callbackPromises, callbackPromiseIds: callbackPromiseIds, callbackPromiseObjects: callbackPromiseObjects } = this.getCallbackPromises({
                match: match,
                callbackIds: callbackIds
            });
            // Cancel outdated actively running promises that aren't for the latest callbackIds
            this.cleanupOutdatedCallbacks(callbackIds);
            if (!callbackPromises.length) {
                // If there are no callback promises, route change will immediately continue. Reset our callbacks state as we don't want registered callbacks to linger once the user leaves the route. Callbacks should be registered on page/etc load if needed.
                // EDGE CASE: If the user is on a live doc and quickly clicks a non-live-doc like a view page, then quickly clicks back into a live doc before the view page has loaded, the preload-live-doc callback may have been removed, slowing down load time into that live doc.
                //            We'll solve for this in the future by always checking if we should preload a live doc on any route change, by never unregistering that callback
                this.reset();
                return {
                    isProcessingCallback: false
                };
            }
            // Start browser metrics page load
            startPageLoadMetrics?.(match?.name ?? '', match?.ufoName, transitionId, match?.params?.contentId);
            // Ensure UFO page load metric continues tracking the page load from start of preloading. If we don't hold here, UFO metric finishes prematurely on route change.
            // We should stop holding right after the route change is completed.
            const ufoStopHold = interactionContext?.hold?.('GlobalTransitionPreloader');
            callbackPromiseObjects.forEach(({ onPerformanceMetricStart: onPerformanceMetricStart })=>{
                onPerformanceMetricStart?.({
                    match: match
                });
            });
            // Timeout for all promises to prevent indefinite waiting
            const TIMEOUT_MS = 10000; // 10 seconds
            let timeoutId = null;
            // Flag to prevent race conditions between timeout and promise completion
            // Only one of them should trigger the route transition
            let hasRouteTransitionCompleted = false;
            // Set up timeout if feature gate is enabled
            if ((0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_live_doc_smooth_transition_timeout')) timeoutId = setTimeout(()=>{
                // Only execute if route transition hasn't been completed by promise resolution
                if (!hasRouteTransitionCompleted) {
                    hasRouteTransitionCompleted = true;
                    this.logger.error`Callback promises timed out after ${TIMEOUT_MS}ms, forcing route transition`;
                    this.reset();
                    onRouteContinue();
                    (0, $b76dfd1db5681318$export$e9ba7ef9458d1a4a)().then((analyticsWebClient)=>{
                        analyticsWebClient.sendOperationalEvent({
                            action: 'confluence_live_doc_smooth_transition_timeout',
                            actionSubject: 'callback_promises_timed_out',
                            attributes: {
                                callbackPromiseIds: callbackPromiseIds.join(',')
                            },
                            source: 'GlobalTransitionPreloader'
                        });
                    });
                }
            }, TIMEOUT_MS);
            // Handle all the promises and then send the user to the next route if appropriate.
            Promise.allSettled(callbackPromises).then((promiseResults)=>{
                // Only proceed if timeout hasn't already triggered the route transition
                if (hasRouteTransitionCompleted) return;
                // Mark that we're handling the route transition to prevent timeout from also executing
                hasRouteTransitionCompleted = true;
                // Clear timeout if callbacks completed first
                if (timeoutId) clearTimeout(timeoutId);
                const onRouteContinueCallbacks = [];
                let externallyRejectedCount = 0;
                promiseResults.forEach((result, index)=>{
                    if (result.status === 'rejected') {
                        if (callbackPromiseObjects[index].isExternallyRejected) externallyRejectedCount++;
                        else this.logger.error`There was an error with a transition callback promise: ${result.reason}, active callbackPromiseIds: ${callbackPromiseIds.join(',')}`;
                    } else {
                        const { onRouteContinueCallback: onRouteContinueCallback } = callbackPromiseObjects[index];
                        if (onRouteContinueCallback) onRouteContinueCallbacks.push(onRouteContinueCallback);
                    }
                });
                if (externallyRejectedCount < callbackPromises.length) {
                    const onRouteContinueCallbackPromises = onRouteContinueCallbacks.map((callback)=>callback({
                            match: match
                        }));
                    // Only update state if most promises weren't externally rejected (indicating this is still the current transition)
                    this.currentRouteDetails.callbackIds = callbackPromiseIds;
                    this.currentRouteDetails.transitionId = transitionId;
                    this.currentRouteDetails.pathname = match?.pathname || '';
                    this.transitionProcessingState = 'processing_completed';
                    // On successful next route, we clear the currently registered callbacks. Callbacks should be registered on page/etc load if needed.
                    this.callbacks = new Map();
                    this.activelyRunningCallbackPromises = {};
                    Promise.allSettled(onRouteContinueCallbackPromises).then(()=>{
                        // If all promises have been externally rejected, that means these promises are for an outdated route change, the user has since changed routes again, so we don't want to redirect the user to the route.
                        // This avoids race condition scenarios where user goes from Doc A -> Doc B -> Doc C, but ends up on Doc B because its promises finished after Doc C's promises.
                        // On successful next route, we clear the currently registered callbacks. Callbacks should be registered on page/etc load if needed.
                        this.callbacks = new Map();
                        this.activelyRunningCallbackPromises = {};
                        onRouteContinue();
                    });
                }
            });
            return {
                isProcessingCallback: true,
                ufoStopHold: ufoStopHold ? ()=>ufoStopHold?.() : undefined
            };
        } catch (error) {
            this.logger.error`There was an error running processTransitionCallback: ${error}, registered callbackIds: ${Array.from(this.callbacks.keys()).join(',')}`;
        }
        return {
            isProcessingCallback: false
        };
    }
    /**
   * Retrieve callback IDs that ran on the current route. Can be useful to determine if your page was already preloaded or not.
   * Recommended to only run this if you are finished transitioning. If you may be mid-transition (unlikely unless using Prompt), use `getRouteCallbackIdsByMatch`.
   *
   * @returns {string[]} - List of registered transition callback IDs that ran on current route when transitioning into it
   */ getCurrentRouteCallbackIds() {
        return [
            ...this.currentRouteDetails.callbackIds
        ];
    }
    /**
   * Retrieve callback IDs that will be run on the specified match. This function looks at this.transitionProcessingState to determine which callback IDs to return.
   * Recommended to only run this if you may be mid-transition, otherwise `getCurrentRouteCallbackIds` is preferable.
   * Can be useful to determine if the match will be preloaded or not during transition, e.g. to determine whether a Prompt callback shows prompt.
   *
   * @returns {string[]} - List of registered transition callback IDs that will run speciifed match when transitioning into it
   */ getRouteCallbackIdsByMatch(match) {
        if (!match?.pathname) return [];
        /**
     *  - If GlobalTransitionPreloader.processTransitionCallback is processing the same match as the specified match:
     *    - If we're mid-transition ('processing'), we use the memoized callback IDs that were set when `processingTransitionCallback` called `getCallbackIds`.
     *      - If memoized callback IDs don't exist (e.g. calling this too quickly right after processingTransitionCallback is called), we fetch the callback IDs for the specified match.
     *    - If we're finished processing ('processing_completed') but haven't finished transitioning yet, we use the current route callback IDs.
     *
     *  - If the specified match is different from the match being processed, or if we are not processing a match ('not_processing'), then we fetch the callback IDs for the specified match.
     */ if (this.transitionProcessingState === 'processing' && this.cachedCallbackIds?.callbackIds && this.cachedCallbackIds?.pathname === match.pathname) return [
            ...this.cachedCallbackIds.callbackIds
        ];
        else if (this.transitionProcessingState === 'processing_completed' && this.currentRouteDetails.pathname === match.pathname) return [
            ...this.currentRouteDetails.callbackIds
        ];
        else return this.getCallbackIds({
            match: match
        }).callbackIds;
    }
    /**
   * Resets the preloader to its initial state by clearing all registered callbacks,
   * canceling any actively running promises, and resetting internal state.
   * This can be useful for cleanup or testing scenarios.
   */ reset() {
        this.cancelActivePromises();
        this.callbacks = new Map();
        this.activelyRunningCallbackPromises = {};
        this.latestPathname = '';
        this.currentRouteDetails.callbackIds = [];
        this.currentRouteDetails.pathname = '';
        this.cachedCallbackIds = null;
        // If we started processing, mark as processing completed. We only set to not_processing in onTransitionComplete, to disallow registering callbacks mid-transition.
        if (this.transitionProcessingState !== 'not_processing') this.transitionProcessingState = 'processing_completed';
    }
    /**
   * Router is responsible for running this function when the route has technically changed (routeChangeHandler).
   @param {number} transitionId - The transition ID of the route that has completed, coming from RouteManager
   */ onTransitionComplete(transitionId) {
        // When GlobalTransitionPreloader processes transition callbacks, it sets its transition running flag to true.
        // When it's done processing transition callbacks and the route has changed, we should clear the transition running flag.
        // This is used to prevent race conditions caused by problematic globalTransitionPreloader callback registrations during route changes.
        // For instance: If a callback is registered mid-transition, then when `routeBlockHandler` is called a second time by `onRouteContinue`,
        //               processTransitionCallback may try to process it after it has already processed it, leading to an infinite loop.
        this.transitionProcessingState = 'not_processing';
        this.cachedCallbackIds = null;
        // Transition ID from RouteManager is stored in this.currentRouteDetails before we call `routeChangeHandler`.
        // If we processed a transition callback, it'll always be one behind RouteManager
        // If transition IDs are misaligned and currentRouteDetails.callbackIds is non-empty, we're in an invalid state likely due to routeBlockHandler/processTransitionCallback unexpectedly not being triggered
        // If we're in this invalid state, reset the current route details callback IDs to prevent components from thinking we're in a preloaded state when we're not.
        if (this.currentRouteDetails.transitionId + 1 !== transitionId && this.currentRouteDetails.callbackIds.length > 0) {
            this.logger.error`GlobalTransitionPreloader is in an invalid state, transitionId mismatch, callbackIds are non-empty. Resetting callbackIds. Invalid callbackIds are: ${this.currentRouteDetails.callbackIds.join(',')}`;
            this.currentRouteDetails.callbackIds = [];
        }
    }
    /**
   * Generates an array of callback ids that should be processed before the next transition, filtering out
   * callbacks which are not supposed to run based on their `onlyCalledIfFunc` evaluation.
   * Caches most recent array of callback IDs as `this.cachedCallbackIds`
   * @param { match: Match } params The params for the method including the match object.
   * @returns { callbackIds: Array<string> } An object containing an array of callback ids that should be processed
   */ getCallbackIds({ match: match }) {
        const callbackIds = [];
        if (!this.callbacks.size) {
            this.cachedCallbackIds = {
                pathname: match.pathname,
                callbackIds: []
            };
            return {
                callbackIds: callbackIds
            };
        }
        this.callbacks.forEach(({ onlyCalledIfFunc: onlyCalledIfFunc }, callbackId)=>{
            // Call our `onlyCalledIfFunc` if it's set, we're only waiting for this callback promise if it's `true` or if it's not set.
            const isCallAllowed = onlyCalledIfFunc ? onlyCalledIfFunc({
                match: match
            }) : true;
            if (isCallAllowed) callbackIds.push(callbackId);
        });
        // Cache the result for the most recent invocation, may be fetched by `getRouteCallbackIdsByMatch` when we're mid-transition, avoids additional onlyCalledIfFunc calls.
        this.cachedCallbackIds = {
            pathname: match.pathname,
            callbackIds: [
                ...callbackIds
            ]
        };
        return {
            callbackIds: callbackIds
        };
    }
    /**
   * Creates an array of promises from registered callbacks that should be executed
   * during a route transition. This method checks conditions under which each callback
   * should be called and manages the lifecycle of the promises.
   * Will clean up outdated promises.
   *
   * @private
   * @param { match: Match, callbackIds: Array<string> } params - The parameters for the method, containing the match object and callback IDs.
   * @returns { callbackPromises: Array<Promise<void>>, callbackPromiseIds: Array<string> } An object containing an array of promises and their corresponding IDs.
   */ getCallbackPromises({ match: match, callbackIds: callbackIds }) {
        const callbackPromises = [];
        const callbackPromiseIds = []; // Recommendation is to use this to help provide context to promise errors
        const callbackPromiseObjects = [];
        callbackIds.forEach((callbackId)=>{
            const callbackConfig = this.callbacks.get(callbackId);
            if (!callbackConfig) return; // This should never happen
            const { callback: callback, onRouteContinueCallback: onRouteContinueCallback, onPerformanceMetricStart: onPerformanceMetricStart } = callbackConfig;
            const activeCallbackPromise = this.activelyRunningCallbackPromises[callbackId];
            // If we want to trigger a callback promise, return the already running one if we have it, otherwise create a new one.
            if (activeCallbackPromise) {
                callbackPromises.push(activeCallbackPromise.promise);
                callbackPromiseIds.push(callbackId);
                callbackPromiseObjects.push(activeCallbackPromise);
            } else {
                // Start the promise and store the promise and its reject function in state (this.processTransitionCallback may call `reject` if the user changes route)
                let callbackPromiseReject;
                const callbackPromise = new Promise((resolve, reject)=>{
                    callbackPromiseReject = reject;
                    callback({
                        match: match
                    }).then(resolve).catch(reject);
                });
                callbackPromises.push(callbackPromise);
                callbackPromiseIds.push(callbackId);
                const callbackPromiseObject = {
                    promise: callbackPromise,
                    onRouteContinueCallback: onRouteContinueCallback,
                    onPerformanceMetricStart: onPerformanceMetricStart,
                    reject: (reason)=>callbackPromiseReject(new $e7d32f2c649e2db9$export$46a841557056026b(reason)),
                    isExternallyRejected: false
                };
                callbackPromiseObjects.push(callbackPromiseObject);
                this.activelyRunningCallbackPromises[callbackId] = callbackPromiseObject;
            }
        });
        return {
            callbackPromises: callbackPromises,
            callbackPromiseIds: callbackPromiseIds,
            callbackPromiseObjects: callbackPromiseObjects
        };
    }
    /**
   * Cancels all actively running callback promises by rejecting them and marking as externally rejected
   */ cancelActivePromises() {
        Object.entries(this.activelyRunningCallbackPromises).forEach(([callbackId, { reject: reject }])=>{
            reject();
            this.activelyRunningCallbackPromises[callbackId].isExternallyRejected = true;
            delete this.activelyRunningCallbackPromises[callbackId];
        });
    }
    /**
   * Cleans up any callback promises that are no longer valid for the current route.
   * @param validCallbackIds - The callback ids that are valid for the current route.
   */ cleanupOutdatedCallbacks(validCallbackIds) {
        Object.keys(this.activelyRunningCallbackPromises).forEach((activelyRunningCallbackId)=>{
            if (!validCallbackIds.includes(activelyRunningCallbackId)) {
                const activeCallbackPromise = this.activelyRunningCallbackPromises[activelyRunningCallbackId];
                if (activeCallbackPromise) {
                    activeCallbackPromise.reject?.();
                    activeCallbackPromise.isExternallyRejected = true;
                    delete this.activelyRunningCallbackPromises[activelyRunningCallbackId];
                }
            }
        });
    }
    constructor(){
        this.logger = (0, $a6897acd40ed68b1$export$2b1d391cd05230fd)('GlobalTransitionPreloader');
        this.callbacks = new Map();
        this.activelyRunningCallbackPromises = {};
        this.latestPathname = '';
        this.currentRouteDetails = {
            transitionId: -1,
            callbackIds: [],
            pathname: ''
        };
        this.transitionProcessingState = 'not_processing';
        this.cachedCallbackIds = null;
    }
}


const $c22be97ab4c2d58d$export$9675c02ec7fc88a8 = (0, $34Zxt.default)(()=>{
    return new (0, $e7d32f2c649e2db9$export$2f8f0e0ec8218c4b)();
});


const $64a554d15bd769f3$var$NOOP = ()=>{};
function $64a554d15bd769f3$export$b6024a131a1561d9(routes, url) {
    // routes can be module from "import" which is not iterable
    const iterableRoutes = Object.values(routes);
    for (const route of iterableRoutes){
        if (!(route instanceof (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6))) continue;
        const match = route.match(url);
        if (match) // FIXME `route` is a `class` instance so it is not 100% safe to spread!
        // But we've been running with it for quite some time, we're not aware of
        // actual problems and I'm only discovering it now while translating to
        // TypeScript.
        //
        // @ts-ignore
        return {
            ...route,
            ...match
        };
    }
    return null;
}
const $64a554d15bd769f3$export$5050caba5e109cc4 = (queryParams)=>{
    const array = Object.entries(queryParams);
    return array.length ? array.reduce((accumulator, current, index)=>`${accumulator + current[0]}=${encodeURIComponent(current[1])}${index < array.length - 1 ? '&' : ''}`, '?') : '';
};
const $64a554d15bd769f3$var$routeActionHistoryMap = {
    PUSH: ({ location: location1, history: history })=>history.push(location1),
    REPLACE: ({ location: location1, history: history })=>history.replace(location1),
    POP: ({ history: history })=>history.go(-1)
};
class $64a554d15bd769f3$var$RouteManagerInner extends (0, $gqzfn.Component) {
    componentDidMount() {
        const { location: location1, history: history } = this.props;
        const initialMatch = this.matchSupportedRoute(`${location1.pathname}${location1.search}${location1.hash}`);
        let previousMatch = initialMatch;
        const routeChangeHandler = (location1, action)=>{
            // we de-structure `onTransition` prop here instead of in enclosing scope
            // because otherwise changes to `onTransition` props will be ignored (as this function
            // will have a "cached" version of it via closure).
            const { onTransition: onTransition } = this.props;
            // New logic determine if it is a transition by calling isTransition on route.
            const match = this.matchSupportedRoute(`${location1.pathname}${location1.search}${location1.hash}`);
            if (onTransition && match && match.isTransition(previousMatch, match)) {
                if (action === 'PUSH' || action === 'POP') this.transitionId++;
                onTransition(match, this.transitionId, action);
                // Clear any prompt on successful route change
                this.globalPromptHandler.clear();
                // Inform GlobalTransitionPreloader that the transition is complete, allowing app to continue registering GlobalTransitionPreloader callbacks.
                const globalTransitionPreloader = (0, $c22be97ab4c2d58d$export$9675c02ec7fc88a8)();
                globalTransitionPreloader.onTransitionComplete(this.transitionId);
                // Call the pending UFO stop hold function if it exists, then clear it to prevent multiple calls
                if (this.pendingUfoStopHold) {
                    this.pendingUfoStopHold();
                    this.pendingUfoStopHold = undefined;
                }
                // Delete the SSR streaming global on route navigation to prevent it from affecting
                // suspense boundary rendering decisions during client-side navigation
                if (typeof window !== 'undefined' && window.__SSR_REACT_STREAMING__) delete window.__SSR_REACT_STREAMING__;
            }
            previousMatch = match;
        };
        // Return false to cancel transition (route will not change). Otherwise transition continues. Does not support waiting for promises - if we need to do that we should return false and have the promise re-invoke the route change when ready.
        const routeBlockHandler = (location1, action)=>{
            try {
                const match = this.matchSupportedRoute(`${location1.pathname}${location1.search}${location1.hash}`);
                const isTransition = match && match.isTransition(previousMatch, match);
                if (isTransition) {
                    // Check for global prompt. (This replaces react-router's <Prompt> component)
                    const { isPromptBlocking: isPromptBlocking } = this.globalPromptHandler.triggerPrompt({
                        previousMatch: previousMatch,
                        nextMatch: match
                    });
                    if (isPromptBlocking) return false;
                    // Check if we have a transition callback promise that should resolve before continuing transition.
                    // Do not support POP (back/forward) - too many edge cases caused by trying to partially support it.
                    const globalTransitionPreloader = (0, $c22be97ab4c2d58d$export$9675c02ec7fc88a8)();
                    if (action !== 'POP') {
                        const isProcessingTransitionPromise = globalTransitionPreloader.processTransitionCallback?.({
                            match: match,
                            onRouteContinue: ()=>{
                                $64a554d15bd769f3$var$routeActionHistoryMap[action?.toUpperCase()]?.({
                                    location: location1,
                                    history: history
                                });
                            },
                            transitionId: this.transitionId,
                            interactionContext: this.props.interactionContext,
                            startPageLoadMetrics: this.props.startPageLoadMetrics
                        });
                        if (isProcessingTransitionPromise.isProcessingCallback) {
                            // Store the ufoStopHold function to be called in routeChangeHandler
                            this.pendingUfoStopHold = isProcessingTransitionPromise.ufoStopHold;
                            return false;
                        }
                    } else // If user does POP action, reset global transition preloader to ensure no transition callbacks are processed.
                    globalTransitionPreloader.reset();
                }
            } catch  {
            // Everything in this function should have its own try-catch/error handling, but in case of an unexpected error, the user shouldn't be blocked from navigating.
            }
        };
        if (this.props.setBrowserHistoryListener) {
            // Ensure RouteManager's `listen` handler is called before the listen handler registered by ConnectedRouter and redux action
            this.unlistenToHistory = this.props.setBrowserHistoryListener(routeChangeHandler);
            if ((0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_frontend_transition_preloading_system')) this.unlistenToHistoryBlock = history.block(routeBlockHandler);
        } else if ((0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_frontend_transition_preloading_system')) this.unlistenToHistory = history.block((location1, action)=>{
            const routeBlockHandlerResult = routeBlockHandler(location1, action);
            if (routeBlockHandlerResult === false) return false;
            else routeChangeHandler(location1, action);
        });
        else this.unlistenToHistory = history.block(routeChangeHandler);
    }
    componentWillUnmount() {
        this.unlistenToHistory?.();
        this.unlistenToHistoryBlock?.();
    }
    mapRoutes(routeComponents) {
        const supportedRoutes = Object.keys(routeComponents);
        return supportedRoutes.map((name)=>{
            const route = this.getRoute(name);
            const mappedRoute = new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
                name: route.name,
                ufoName: route.ufoName,
                pattern: route.pattern,
                condition: route.condition,
                isTransition: route.isTransition
            });
            // @ts-ignore FIXME Who's using `component` on "mapped" `Route`?
            mappedRoute['component'] = routeComponents[name];
            return mappedRoute;
        });
    }
    getRoute(name) {
        const { namedRoutes: namedRoutes } = this.props;
        const route = namedRoutes[name];
        if (!route) throw new Error(`Unknown route name: ${name}`);
        return route;
    }
    matchAndRenderComponent(match) {
        const { notFound: notFound, routeComponents: routeComponents } = this.props;
        if (match === null) return notFound ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement(notFound) : null;
        else {
            window.performance.mark('CFP-63.route-component-render');
            const memoizedComponent = this.memoizedRouteComponents.get(routeComponents[match.name]);
            return memoizedComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement(memoizedComponent, match) : null;
        }
    }
    getHref() {
        return location.pathname + location.search;
    }
    render() {
        const { children: children } = this.props;
        const routesContextValue = this.getRoutesContextValue();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement((0, $32f18ec2049bb41d$export$a082affa499ae96f), {
            globalPromptHandler: this.globalPromptHandler
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement((0, $a55430c99df8268f$export$52c04f66b1983f2a), routesContextValue, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement((0, $4b72a15528d34979$export$779e8f71c6bb38c).Provider, {
            value: routesContextValue
        }, this.matchAndRenderComponent(routesContextValue.match), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement((0, $gqzfn.Fragment), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement((0, $1262eee5c487dee7$export$cf1af05a5f90ab81), null))));
    }
    constructor(props){
        super(props);
        this.pendingUfoStopHold = void 0;
        this.memoizedRouteComponents = new WeakMap();
        this.globalPromptHandler = new (0, $b7f189155d041ca2$export$aea2bc6590a5ea49)();
        // transitionId is incremented on every push/pop to distinguish a deliberate
        // user navigation from an automatic redirect (replace). An id of 0 indicates that
        // we are currently on the initial load.
        //
        // Ideally this would be in component state, since it is passed down through context,
        // and should trigger a re-render when changed.
        // However, we don't want to re-render with the updated value until the location
        // changes, which unfortunately is controlled by <ConnectedRouter>.
        // At the same time, this state cannot be purely derived from location changes,
        // since we need to look at the action that caused the update.
        // When we remove react-router and can make both state changes atomically then
        // this can move into component state alongside the current location.
        this.transitionId = 0;
        this.pendingQueryParams = {};
        /**
     * Mapping components to named routes
     */ this.routes = this.mapRoutes(this.props.routeComponents);
        this.toUrl = (name, params = {})=>{
            const href = params['href'];
            if (href) return href;
            if (!name) return '';
            const query = params.query || {};
            const hash = params.hash || '';
            return this.getRoute(name).toUrl(params, {
                query: query,
                hash: hash
            });
        };
        this.matchRoute = (url)=>{
            const { namedRoutes: namedRoutes } = this.props;
            return $64a554d15bd769f3$export$b6024a131a1561d9(namedRoutes, url);
        };
        this.matchSupportedRoute = (url)=>{
            const parsed = (0, $9pfwj.parse)(url);
            // Note here we are using location from window not from withRouter
            // history's location doesn't have host field
            // See https://github.com/ReactTraining/react-router/blob/master/packages/react-router/docs/api/history.md
            //What is this doing?
            if (parsed.host && parsed.host !== window.location.host) return null;
            return $64a554d15bd769f3$export$b6024a131a1561d9(this.routes, url);
        };
        this.replace = (url, forceReload = false)=>{
            const { history: history, onPageReload: onPageReload = $64a554d15bd769f3$var$RouteManagerInner.defaultProps.onPageReload } = this.props;
            let match;
            if (!forceReload && (match = this.matchSupportedRoute(url))) // replace only supports pushing a path.
            // here the url might be a full URL that has same domain
            history.replace((0, $9pfwj.format)({
                pathname: match.pathname,
                search: match.search,
                hash: match.hash
            }));
            else {
                onPageReload(url, true);
                // eslint-disable-next-line no-restricted-syntax
                window.location.replace(url);
            }
        };
        this.open = (url, target, features)=>window.open(url, target, features);
        this.defaultPush = (url, forceReload = false)=>{
            const { history: history, onPageReload: onPageReload = $64a554d15bd769f3$var$RouteManagerInner.defaultProps.onPageReload, location: location1 } = this.props;
            let match;
            if (!forceReload && (match = this.matchSupportedRoute((0, $a1f0c4d0ab868c5f$export$feb8df2d5227ff6c)(url) ? (0, $9pfwj.format)({
                pathname: location1.pathname,
                search: location1.search,
                hash: url
            }) : url))) // push only supports pushing a path.
            // here the url might be a full URL that has same domain
            history.push((0, $9pfwj.format)({
                pathname: match.pathname,
                search: match.search,
                hash: match.hash
            }));
            else {
                onPageReload(url, false);
                // eslint-disable-next-line no-restricted-syntax
                window.location.assign(url);
            }
        };
        this.push = (url, forceReload = false)=>{
            const { routePolicy: routePolicy } = this.props;
            if (routePolicy) return routePolicy.push({
                ...this.getRoutesContextValue(),
                push: this.defaultPush
            }, url, forceReload);
            return this.defaultPush(url, forceReload);
        };
        this.getQueryParams = ()=>{
            const { location: location1 } = this.props;
            return (0, $9pfwj.parse)(location1.search, true).query;
        };
        this.setQueryParams = (query, replace = false)=>{
            if (query && typeof query === 'object') {
                const { history: history } = this.props;
                const queryParams = {
                    ...this.getQueryParams(),
                    ...this.pendingQueryParams,
                    ...query
                };
                Object.keys(queryParams).forEach((key)=>{
                    if (queryParams[key] === null || queryParams[key] === undefined) delete queryParams[key];
                });
                const search = this.buildQueryString(queryParams);
                (replace ? history.replace : history.push)({
                    search: search
                });
                Object.assign(this.pendingQueryParams, query);
                // https://github.com/ReactTraining/history/issues/767#issuecomment-573358882
                setTimeout(()=>this.pendingQueryParams = {});
            }
        };
        this.buildQueryString = $64a554d15bd769f3$export$5050caba5e109cc4;
        this.getHash = ()=>{
            const { location: location1 } = this.props;
            return location1.hash ? location1.hash.substring(1) : '';
        };
        this.setHash = (hash)=>{
            const { history: history, location: location1 } = this.props;
            history.replace({
                ...location1,
                hash: hash
            });
        };
        this.preloadRoute = (matchOrUrl, options)=>{
            // URL match and string are among the most common representations in our
            // codebase. RouteManager owns converting between them so reduce the
            // strain on the caller and accept both:
            const match = typeof matchOrUrl === 'string' ? this.matchSupportedRoute(matchOrUrl) : matchOrUrl;
            if (match) {
                const previousMatch = this.matchSupportedRoute(this.getHref());
                const { onPreload: onPreload } = this.props;
                if (onPreload) onPreload(match, previousMatch, options);
            }
        };
        this.getRoutesContextValue = ()=>{
            const { history: history, location: location1, onPageReload: onPageReload } = this.props;
            return {
                getHref: this.getHref,
                history: history,
                location: location1,
                match: this.matchSupportedRoute(`${location1.pathname}${location1.search}${location1.hash}`),
                transitionId: this.transitionId,
                toUrl: this.toUrl,
                matchRoute: this.matchRoute,
                matchSupportedRoute: this.matchSupportedRoute,
                getQueryParams: this.getQueryParams,
                setQueryParams: this.setQueryParams,
                getHash: this.getHash,
                setHash: this.setHash,
                replace: this.replace,
                routes: this.routes,
                push: this.push,
                open: this.open,
                onPageReload: onPageReload || $64a554d15bd769f3$var$NOOP,
                preloadRoute: this.preloadRoute
            };
        };
        const { location: _location, onInitialize: onInitialize, routeComponents: routeComponents } = this.props;
        // Keep a component => memo(component) mapping so later in matchAndRenderComponent we can render the memoized one.
        // We are not re-creating the routeComponents object because several items in the object may share the same reference.
        // If that is the case then our memoized component should sharing the same reference as well.
        for(const key in routeComponents){
            const component = routeComponents[key];
            if (!this.memoizedRouteComponents.has(component)) this.memoizedRouteComponents.set(component, /*#__PURE__*/ (0, $gqzfn.memo)(component, (0, (/*@__PURE__*/$parcel$interopDefault($30ad6ecd922ea319$exports)))));
        }
        const _match = this.matchSupportedRoute(`${_location.pathname}${_location.search}${_location.hash}`);
        if (onInitialize) onInitialize(_match, this.transitionId);
    }
}
$64a554d15bd769f3$var$RouteManagerInner.defaultProps = {
    routeComponents: {},
    namedRoutes: {},
    onPageReload: $64a554d15bd769f3$var$NOOP
};
const $64a554d15bd769f3$var$withInteractionContext = (ChildComponent)=>{
    if (!(0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_frontend_transition_preloading_system')) return ChildComponent;
    const WithInteractionContextComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement((0, $d8f61048a7eb3cc2$export$2e2bcd8739ae039).Consumer, null, (interactionContext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement(ChildComponent, {
                ...props,
                interactionContext: interactionContext
            }));
    WithInteractionContextComponent.displayName = `withInteractionContext(${ChildComponent.displayName || ChildComponent.name})`;
    return WithInteractionContextComponent;
};
const $64a554d15bd769f3$export$1b5af09f58fb97da = (0, $8dd6048ee63ddb53$export$369b6b2b30582e8e)($64a554d15bd769f3$var$withInteractionContext($64a554d15bd769f3$var$RouteManagerInner));
const $64a554d15bd769f3$export$3b81431e16eb41b6 = $64a554d15bd769f3$var$withInteractionContext;




const $4b957fb9fbb0eafa$export$d4971375353d0454 = [
    $0d518026f9d519cf$export$9e15ff8aa6bc996f,
    $0d518026f9d519cf$export$2fd309376969662f,
    $0d518026f9d519cf$export$a7c5707626fc90f,
    $0d518026f9d519cf$export$6ccd7dc0d5aa30b0,
    $0d518026f9d519cf$export$7d65e474be175151,
    $0d518026f9d519cf$export$ec8a7da990877da3,
    $0d518026f9d519cf$export$aa473411bddb7e17,
    $0d518026f9d519cf$export$42bb8ba9cae96927,
    $0d518026f9d519cf$export$dec9f53c339ce8f8,
    $0d518026f9d519cf$export$f80d02217688b484,
    $0d518026f9d519cf$export$fdfdf584a0978d20,
    $0d518026f9d519cf$export$1e92de3a3dba0876,
    $0d518026f9d519cf$export$6a85914fb9ca80a2,
    $0d518026f9d519cf$export$1f238fcead086ec3,
    $0d518026f9d519cf$export$b74c113024023274,
    $0d518026f9d519cf$export$45222bf0cb32d6e2,
    $0d518026f9d519cf$export$7b1285e36c635f1f,
    $0d518026f9d519cf$export$36dcea4e08feb5c9,
    $0d518026f9d519cf$export$e63a462ee45b57cf,
    $0d518026f9d519cf$export$bd17e6e353522e0d,
    $0d518026f9d519cf$export$54edf7c16c47aeef,
    $0d518026f9d519cf$export$d6ae9e544e98926f,
    $0d518026f9d519cf$export$e8253e1b7e500d1c,
    $0d518026f9d519cf$export$9a4ff2d809fc4156,
    $0d518026f9d519cf$export$19c176cd0a878008,
    $0d518026f9d519cf$export$439074745692fe65,
    $0d518026f9d519cf$export$2de9a69f9b51bb83,
    $0d518026f9d519cf$export$10f0439b47c8fdaf,
    $0d518026f9d519cf$export$d87089dbdd7eeaf3,
    $0d518026f9d519cf$export$dd174db99b3e6fea,
    $0d518026f9d519cf$export$ef26ce515f06bc5e,
    $0d518026f9d519cf$export$65b723bb995d4fb6,
    $0d518026f9d519cf$export$4fe224de953acb46,
    $0d518026f9d519cf$export$1009a7f2cc1ac09f,
    $0d518026f9d519cf$export$4dd08bdd46db5924,
    $0d518026f9d519cf$export$ada7925da580b561,
    $0d518026f9d519cf$export$29df24b01e938adf,
    $0d518026f9d519cf$export$e003e97fab6b4368,
    $0d518026f9d519cf$export$5f7be6e90830de0c,
    $0d518026f9d519cf$export$9257b5b55c8e2555,
    $0d518026f9d519cf$export$475fdaba8e6145bb,
    $0d518026f9d519cf$export$347d3b5edaae00e0,
    $0d518026f9d519cf$export$91f49e7b30a9d34,
    $0d518026f9d519cf$export$c259921a01da55b4,
    $0d518026f9d519cf$export$5b90ced7e51bcea0,
    $0d518026f9d519cf$export$7d8684a463b78f54,
    $0d518026f9d519cf$export$eb54044908e4e0bd,
    $0d518026f9d519cf$export$506a1a071415f2e,
    $0d518026f9d519cf$export$4e4c6a9eb23f65ec,
    $0d518026f9d519cf$export$b17d28dbf200fde0,
    $0d518026f9d519cf$export$5bfa1fef1b53dfdd,
    $0d518026f9d519cf$export$dd6de41f650dae89,
    $0d518026f9d519cf$export$8c6393d6207d929,
    $0d518026f9d519cf$export$9397e0d80cf06055,
    $0d518026f9d519cf$export$f107e7a692a3a54e,
    $0d518026f9d519cf$export$5bbec961de23dce7,
    $0d518026f9d519cf$export$2f6a532274e0cd9d,
    $0d518026f9d519cf$export$a007a4f7553ffc16,
    $0d518026f9d519cf$export$f0e8d063cba10e9c,
    $0d518026f9d519cf$export$3039840c47d9a13d,
    $0d518026f9d519cf$export$e1e5a41fa357e66f,
    $0d518026f9d519cf$export$4fcc3f53642c593a,
    $0d518026f9d519cf$export$7234e6926944adc0,
    $0d518026f9d519cf$export$b86d7bd984fb9727,
    $0d518026f9d519cf$export$1afd9317831e345e,
    $0d518026f9d519cf$export$9e8d02f6bdb565e9,
    $0d518026f9d519cf$export$f03a4adc711219ed,
    $0d518026f9d519cf$export$af040d7344c912d1,
    $0d518026f9d519cf$export$2925d036bbc38c7,
    $0d518026f9d519cf$export$351b62e6f5786a73,
    $0d518026f9d519cf$export$4a2048bb71da8b4b,
    $0d518026f9d519cf$export$7de5b687836953bd,
    $0d518026f9d519cf$export$e492b3d04985e9fb,
    $0d518026f9d519cf$export$57fb93d8931ad943,
    $0d518026f9d519cf$export$27b2e48e28163360,
    $0d518026f9d519cf$export$f178fb5b1e822288,
    $0d518026f9d519cf$export$777796688df78f56,
    $0d518026f9d519cf$export$3907c7d8e57f70ba,
    $0d518026f9d519cf$export$fe97ee265fd89939,
    $0d518026f9d519cf$export$b71609db3dda2696,
    $0d518026f9d519cf$export$730392c243a0a367,
    $0d518026f9d519cf$export$85bd3cea0cecb26c,
    $0d518026f9d519cf$export$c8a37c9f76d4d03f,
    $0d518026f9d519cf$export$771b75a6ca136f91,
    $0d518026f9d519cf$export$8e4a8343b1614a02,
    $0d518026f9d519cf$export$2c9cf254b3b24ff,
    $0d518026f9d519cf$export$d925029e7ceadd51,
    $0d518026f9d519cf$export$e84c491e2d88d9f6,
    $0d518026f9d519cf$export$a990a60696f54618,
    $0d518026f9d519cf$export$c0a209b0b0b16c75,
    $0d518026f9d519cf$export$dcee5dee04648c93,
    $0d518026f9d519cf$export$dcda7f8b6fe54ba,
    $0d518026f9d519cf$export$9e430f65574f5333,
    $0d518026f9d519cf$export$e9d78b13bbb4e56f,
    $0d518026f9d519cf$export$d7be6003270f6c2d,
    $0d518026f9d519cf$export$b49467be269d2629,
    $0d518026f9d519cf$export$e52245e856f5c06,
    $0d518026f9d519cf$export$926e3916067d7530,
    $0d518026f9d519cf$export$e720b1e170b46aae,
    $0d518026f9d519cf$export$6c7b95dcf08f3a6d,
    $0d518026f9d519cf$export$b010f02787df1e6,
    $0d518026f9d519cf$export$ecc28d15af39a8b2,
    $0d518026f9d519cf$export$482db086bc8c2289,
    $0d518026f9d519cf$export$3afea7266d0d139b,
    $0d518026f9d519cf$export$4eb80c3a4e6fbe0f,
    $0d518026f9d519cf$export$bd2c9bb170b3681d,
    $0d518026f9d519cf$export$5c9eaf42f32252ea,
    $0d518026f9d519cf$export$7ae0ea91a2dfc4d9,
    $0d518026f9d519cf$export$3bd4ec9f05d79904,
    $0d518026f9d519cf$export$d593e642a326a501,
    $0d518026f9d519cf$export$6490fab56523ceda,
    $0d518026f9d519cf$export$dcb1d1a9cda087b1,
    $0d518026f9d519cf$export$6b2db7909585abd7,
    $0d518026f9d519cf$export$2dd65cdecd8b05d7,
    $0d518026f9d519cf$export$d78f611c1ddf7234,
    $0d518026f9d519cf$export$9dc7f7e5e1435bc,
    $0d518026f9d519cf$export$3582accdd821993a,
    $0d518026f9d519cf$export$871ac71d42c178c5,
    $0d518026f9d519cf$export$1bc544543b946246,
    $0d518026f9d519cf$export$d387bb8ca9ce25d1,
    $0d518026f9d519cf$export$f7bf92a6467c1557,
    $0d518026f9d519cf$export$ed260c82a3e70a6a,
    $0d518026f9d519cf$export$a90430d7f36bfe9e,
    $0d518026f9d519cf$export$22bb05181a4b1501,
    $0d518026f9d519cf$export$cb73aa9f5b7d1ea0,
    $0d518026f9d519cf$export$df78b182760b42f4,
    $0d518026f9d519cf$export$2d3703cff5d9a27,
    $0d518026f9d519cf$export$60773cf116cf5f30,
    $0d518026f9d519cf$export$40e965fb568c3c83,
    $0d518026f9d519cf$export$cb80c94a905e11b6,
    $0d518026f9d519cf$export$93b558a6e07dbdac,
    $0d518026f9d519cf$export$67acd8a63f03bc8,
    $0d518026f9d519cf$export$6b9c632e635b4d77,
    $0d518026f9d519cf$export$37a588b556645c19,
    $0d518026f9d519cf$export$aded01fc53d469df,
    $0d518026f9d519cf$export$cdd412f0619f2d7e,
    $0d518026f9d519cf$export$aa72b945229db170,
    $0d518026f9d519cf$export$f0c4a6dc3b3437aa,
    $0d518026f9d519cf$export$1a5e481ee166ad7c,
    $0d518026f9d519cf$export$f39a30a3a5635bab,
    $0d518026f9d519cf$export$3101773a7a844077,
    $0d518026f9d519cf$export$f03524b1e395be4a,
    $0d518026f9d519cf$export$38b94ff4631b44df,
    $0d518026f9d519cf$export$26dfba554adbf87e,
    $0d518026f9d519cf$export$1b93424785e5f745,
    $0d518026f9d519cf$export$f0e860396acf6277,
    $0d518026f9d519cf$export$4442c9c7bb716896,
    $0d518026f9d519cf$export$abe337275802eab4,
    $0d518026f9d519cf$export$ffd880217e61385f,
    $0d518026f9d519cf$export$8bf619366f9e74f2,
    $0d518026f9d519cf$export$a85b9c60514cd043,
    $0d518026f9d519cf$export$19b893a9e64dac94,
    $0d518026f9d519cf$export$3d39129bec795227,
    $0d518026f9d519cf$export$b8adcf19ff927cec,
    $0d518026f9d519cf$export$939b28e9f8987d97,
    $0d518026f9d519cf$export$d0ac6fa12f3acafa,
    $0d518026f9d519cf$export$693d9b367ae8d0f7,
    $0d518026f9d519cf$export$35123576da2e521,
    $0d518026f9d519cf$export$e18ccd8ffafdf3dd,
    $0d518026f9d519cf$export$9c4e8cdcbbacdf8f,
    $0d518026f9d519cf$export$f85f59869a8dbbf8,
    $0d518026f9d519cf$export$2cc9af506d64ef72,
    $0d518026f9d519cf$export$4f46a1e4250ebe18,
    $0d518026f9d519cf$export$751ae19fa150b7c,
    $0d518026f9d519cf$export$526ccce5d32f7beb,
    $0d518026f9d519cf$export$3d8579587b62bb96,
    $0d518026f9d519cf$export$ed19a29c446e24d8,
    $0d518026f9d519cf$export$7de52f6cc232129e,
    $0d518026f9d519cf$export$81cfd93b1b89cd07,
    $0d518026f9d519cf$export$31745f3bff21cd,
    $0d518026f9d519cf$export$7af7a1e753a92264,
    $0d518026f9d519cf$export$28e7e683f23a58d3,
    $0d518026f9d519cf$export$e64d4514fc584fbe,
    $0d518026f9d519cf$export$323161697c5fa666,
    $0d518026f9d519cf$export$dfa725d05e18145e,
    $0d518026f9d519cf$export$8674e83405059790,
    $0d518026f9d519cf$export$3ce513606c31c918,
    $0d518026f9d519cf$export$652395dc5ff9b416,
    $0d518026f9d519cf$export$4d1bccc78b263a8e,
    $0d518026f9d519cf$export$df327d9b56ca6b7c,
    $0d518026f9d519cf$export$53f195d79ef3d4dd,
    $0d518026f9d519cf$export$23e7002e5e9ef89e,
    $0d518026f9d519cf$export$299af9061dea1f09,
    $0d518026f9d519cf$export$eb5a785192323bd3,
    $0d518026f9d519cf$export$168f3acd059931e0,
    $0d518026f9d519cf$export$3bcebf4f1e82d3ad,
    $0d518026f9d519cf$export$42599f111394c36c,
    $0d518026f9d519cf$export$4c6bf75100b3b72,
    $0d518026f9d519cf$export$e05db3c2f69bd3ae,
    $0d518026f9d519cf$export$851ba2be5095d586,
    $0d518026f9d519cf$export$9859a7a7049d0585,
    $0d518026f9d519cf$export$90480461935b54cc,
    $0d518026f9d519cf$export$84b5e15197aaaa12,
    $0d518026f9d519cf$export$4dcf771d1a1901ef,
    $0d518026f9d519cf$export$22f8e464aee70413,
    $0d518026f9d519cf$export$752c480a913a6712,
    $0d518026f9d519cf$export$16172a64bcdb79f8,
    $0d518026f9d519cf$export$70914a626e2f0488,
    $0d518026f9d519cf$export$85c61af9d225a707,
    $0d518026f9d519cf$export$3d0698fcdc33631d,
    $0d518026f9d519cf$export$c0d0d3f98d45e5f1,
    $0d518026f9d519cf$export$69df75bd8c217ade,
    $0d518026f9d519cf$export$70e53b90503ea1b9,
    $0d518026f9d519cf$export$688990fbefa748b3,
    $0d518026f9d519cf$export$99ff0b9560c4fd04,
    $0d518026f9d519cf$export$629e966630a1f92e,
    $0d518026f9d519cf$export$e8beba40e140a443,
    $0d518026f9d519cf$export$c471be73599ccae1,
    $0d518026f9d519cf$export$793ade69cc97583f,
    $0d518026f9d519cf$export$499f432aa493cdd2,
    $0d518026f9d519cf$export$4ce9d0d8218b9d84,
    $0d518026f9d519cf$export$345aea7dc51bac8a,
    $0d518026f9d519cf$export$499a561f6d1a011,
    $0d518026f9d519cf$export$59a52cdd0906f4cb,
    $0d518026f9d519cf$export$2bc30aa6642650c,
    $0d518026f9d519cf$export$b45af2e1d7abb289,
    $0d518026f9d519cf$export$f8d71dcb352ebe8c,
    $0d518026f9d519cf$export$5f63ad7e18293ec2,
    $0d518026f9d519cf$export$57a75dda1f25b360,
    $0d518026f9d519cf$export$3ebf2fc23df50648,
    $0d518026f9d519cf$export$96e9320cb2b14c85
].reduce((acc, route)=>{
    acc[route.name] = route;
    return acc;
}, {});



var $8c058a9ce2201bdb$exports = {};

var $45ec5d77afad7a6c$exports = {};

var $gfqTY = parcelRequire("gfqTY");
var $9dfd370374659d17$exports = {};
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $9dfd370374659d17$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
$9dfd370374659d17$exports = $9dfd370374659d17$var$arrayEach;



var $2a0e4c190fdd997c$exports = {};
var $33f04050f44b0aad$exports = {};


/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $33f04050f44b0aad$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $a38ac3c8a67c88fd$exports(object, key, newValue);
        else $fd66b3451a05f82d$exports(object, key, newValue);
    }
    return object;
}
$33f04050f44b0aad$exports = $33f04050f44b0aad$var$copyObject;



var $kOHWF = parcelRequire("kOHWF");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $2a0e4c190fdd997c$var$baseAssign(object, source) {
    return object && $33f04050f44b0aad$exports(source, $kOHWF(source), object);
}
$2a0e4c190fdd997c$exports = $2a0e4c190fdd997c$var$baseAssign;


var $d5580916787e0396$exports = {};


/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $d5580916787e0396$var$baseAssignIn(object, source) {
    return object && $33f04050f44b0aad$exports(source, $739031f48e6fcbdc$exports(source), object);
}
$d5580916787e0396$exports = $d5580916787e0396$var$baseAssignIn;



var $cJDXf = parcelRequire("cJDXf");
var $2e83607cadbcdd57$exports = {};
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $2e83607cadbcdd57$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
$2e83607cadbcdd57$exports = $2e83607cadbcdd57$var$copyArray;


var $7d83ced8203a5c15$exports = {};


var $PmheH = parcelRequire("PmheH");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $7d83ced8203a5c15$var$copySymbols(source, object) {
    return $33f04050f44b0aad$exports(source, $PmheH(source), object);
}
$7d83ced8203a5c15$exports = $7d83ced8203a5c15$var$copySymbols;


var $2ddbe6ed2909034d$exports = {};


/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $2ddbe6ed2909034d$var$copySymbolsIn(source, object) {
    return $33f04050f44b0aad$exports(source, $dd922d8f52ba5dd6$exports(source), object);
}
$2ddbe6ed2909034d$exports = $2ddbe6ed2909034d$var$copySymbolsIn;



var $eCkRO = parcelRequire("eCkRO");


var $jaE2r = parcelRequire("jaE2r");
var $5ecf62e22555298a$exports = {};
/** Used for built-in method references. */ var $5ecf62e22555298a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $5ecf62e22555298a$var$hasOwnProperty = $5ecf62e22555298a$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $5ecf62e22555298a$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $5ecf62e22555298a$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
$5ecf62e22555298a$exports = $5ecf62e22555298a$var$initCloneArray;


var $84b1d1e7afebd306$exports = {};
var $c264c7cec130bc65$exports = {};

var $7XhNn = parcelRequire("7XhNn");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $c264c7cec130bc65$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $7XhNn(result).set(new $7XhNn(arrayBuffer));
    return result;
}
$c264c7cec130bc65$exports = $c264c7cec130bc65$var$cloneArrayBuffer;


var $f0ec1916c086dfd4$exports = {};

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $f0ec1916c086dfd4$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $c264c7cec130bc65$exports(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
$f0ec1916c086dfd4$exports = $f0ec1916c086dfd4$var$cloneDataView;


var $594f397d22d8a27f$exports = {};
/** Used to match `RegExp` flags from their coerced string values. */ var $594f397d22d8a27f$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $594f397d22d8a27f$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $594f397d22d8a27f$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
$594f397d22d8a27f$exports = $594f397d22d8a27f$var$cloneRegExp;


var $d3d78b0180c6e27b$exports = {};

var $jf0iC = parcelRequire("jf0iC");
/** Used to convert symbols to primitives and strings. */ var $d3d78b0180c6e27b$var$symbolProto = $jf0iC ? $jf0iC.prototype : undefined, $d3d78b0180c6e27b$var$symbolValueOf = $d3d78b0180c6e27b$var$symbolProto ? $d3d78b0180c6e27b$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $d3d78b0180c6e27b$var$cloneSymbol(symbol) {
    return $d3d78b0180c6e27b$var$symbolValueOf ? Object($d3d78b0180c6e27b$var$symbolValueOf.call(symbol)) : {};
}
$d3d78b0180c6e27b$exports = $d3d78b0180c6e27b$var$cloneSymbol;


var $4bd01e964c27938c$exports = {};

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $4bd01e964c27938c$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $c264c7cec130bc65$exports(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
$4bd01e964c27938c$exports = $4bd01e964c27938c$var$cloneTypedArray;


/** `Object#toString` result references. */ var $84b1d1e7afebd306$var$boolTag = '[object Boolean]', $84b1d1e7afebd306$var$dateTag = '[object Date]', $84b1d1e7afebd306$var$mapTag = '[object Map]', $84b1d1e7afebd306$var$numberTag = '[object Number]', $84b1d1e7afebd306$var$regexpTag = '[object RegExp]', $84b1d1e7afebd306$var$setTag = '[object Set]', $84b1d1e7afebd306$var$stringTag = '[object String]', $84b1d1e7afebd306$var$symbolTag = '[object Symbol]';
var $84b1d1e7afebd306$var$arrayBufferTag = '[object ArrayBuffer]', $84b1d1e7afebd306$var$dataViewTag = '[object DataView]', $84b1d1e7afebd306$var$float32Tag = '[object Float32Array]', $84b1d1e7afebd306$var$float64Tag = '[object Float64Array]', $84b1d1e7afebd306$var$int8Tag = '[object Int8Array]', $84b1d1e7afebd306$var$int16Tag = '[object Int16Array]', $84b1d1e7afebd306$var$int32Tag = '[object Int32Array]', $84b1d1e7afebd306$var$uint8Tag = '[object Uint8Array]', $84b1d1e7afebd306$var$uint8ClampedTag = '[object Uint8ClampedArray]', $84b1d1e7afebd306$var$uint16Tag = '[object Uint16Array]', $84b1d1e7afebd306$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $84b1d1e7afebd306$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $84b1d1e7afebd306$var$arrayBufferTag:
            return $c264c7cec130bc65$exports(object);
        case $84b1d1e7afebd306$var$boolTag:
        case $84b1d1e7afebd306$var$dateTag:
            return new Ctor(+object);
        case $84b1d1e7afebd306$var$dataViewTag:
            return $f0ec1916c086dfd4$exports(object, isDeep);
        case $84b1d1e7afebd306$var$float32Tag:
        case $84b1d1e7afebd306$var$float64Tag:
        case $84b1d1e7afebd306$var$int8Tag:
        case $84b1d1e7afebd306$var$int16Tag:
        case $84b1d1e7afebd306$var$int32Tag:
        case $84b1d1e7afebd306$var$uint8Tag:
        case $84b1d1e7afebd306$var$uint8ClampedTag:
        case $84b1d1e7afebd306$var$uint16Tag:
        case $84b1d1e7afebd306$var$uint32Tag:
            return $4bd01e964c27938c$exports(object, isDeep);
        case $84b1d1e7afebd306$var$mapTag:
            return new Ctor;
        case $84b1d1e7afebd306$var$numberTag:
        case $84b1d1e7afebd306$var$stringTag:
            return new Ctor(object);
        case $84b1d1e7afebd306$var$regexpTag:
            return $594f397d22d8a27f$exports(object);
        case $84b1d1e7afebd306$var$setTag:
            return new Ctor;
        case $84b1d1e7afebd306$var$symbolTag:
            return $d3d78b0180c6e27b$exports(object);
    }
}
$84b1d1e7afebd306$exports = $84b1d1e7afebd306$var$initCloneByTag;


var $500741bec8362763$exports = {};
var $aab0c6107f14ba44$exports = {};

var $bFI6q = parcelRequire("bFI6q");
/** Built-in value references. */ var $aab0c6107f14ba44$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $aab0c6107f14ba44$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$bFI6q(proto)) return {};
        if ($aab0c6107f14ba44$var$objectCreate) return $aab0c6107f14ba44$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
$aab0c6107f14ba44$exports = $aab0c6107f14ba44$var$baseCreate;




var $d0GOx = parcelRequire("d0GOx");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $500741bec8362763$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !$d0GOx(object) ? $aab0c6107f14ba44$exports($79683a944646ef3c$exports(object)) : {};
}
$500741bec8362763$exports = $500741bec8362763$var$initCloneObject;



var $9X1Pr = parcelRequire("9X1Pr");

var $1mK9W = parcelRequire("1mK9W");
var $9a9138c71477fe93$exports = {};
var $a5e5bfd21997feba$exports = {};

var $jaE2r = parcelRequire("jaE2r");

var $lqXWM = parcelRequire("lqXWM");
/** `Object#toString` result references. */ var $a5e5bfd21997feba$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $a5e5bfd21997feba$var$baseIsMap(value) {
    return $lqXWM(value) && $jaE2r(value) == $a5e5bfd21997feba$var$mapTag;
}
$a5e5bfd21997feba$exports = $a5e5bfd21997feba$var$baseIsMap;



var $X4ATL = parcelRequire("X4ATL");

var $a246A = parcelRequire("a246A");
/* Node.js helper references. */ var $9a9138c71477fe93$var$nodeIsMap = $a246A && $a246A.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $9a9138c71477fe93$var$isMap = $9a9138c71477fe93$var$nodeIsMap ? $X4ATL($9a9138c71477fe93$var$nodeIsMap) : $a5e5bfd21997feba$exports;
$9a9138c71477fe93$exports = $9a9138c71477fe93$var$isMap;



var $bFI6q = parcelRequire("bFI6q");
var $8e50b26c52b6235f$exports = {};
var $ba6f57f178a4fd8d$exports = {};

var $jaE2r = parcelRequire("jaE2r");

var $lqXWM = parcelRequire("lqXWM");
/** `Object#toString` result references. */ var $ba6f57f178a4fd8d$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $ba6f57f178a4fd8d$var$baseIsSet(value) {
    return $lqXWM(value) && $jaE2r(value) == $ba6f57f178a4fd8d$var$setTag;
}
$ba6f57f178a4fd8d$exports = $ba6f57f178a4fd8d$var$baseIsSet;



var $X4ATL = parcelRequire("X4ATL");

var $a246A = parcelRequire("a246A");
/* Node.js helper references. */ var $8e50b26c52b6235f$var$nodeIsSet = $a246A && $a246A.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $8e50b26c52b6235f$var$isSet = $8e50b26c52b6235f$var$nodeIsSet ? $X4ATL($8e50b26c52b6235f$var$nodeIsSet) : $ba6f57f178a4fd8d$exports;
$8e50b26c52b6235f$exports = $8e50b26c52b6235f$var$isSet;



var $kOHWF = parcelRequire("kOHWF");

/** Used to compose bitmasks for cloning. */ var $45ec5d77afad7a6c$var$CLONE_DEEP_FLAG = 1, $45ec5d77afad7a6c$var$CLONE_FLAT_FLAG = 2, $45ec5d77afad7a6c$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $45ec5d77afad7a6c$var$argsTag = '[object Arguments]', $45ec5d77afad7a6c$var$arrayTag = '[object Array]', $45ec5d77afad7a6c$var$boolTag = '[object Boolean]', $45ec5d77afad7a6c$var$dateTag = '[object Date]', $45ec5d77afad7a6c$var$errorTag = '[object Error]', $45ec5d77afad7a6c$var$funcTag = '[object Function]', $45ec5d77afad7a6c$var$genTag = '[object GeneratorFunction]', $45ec5d77afad7a6c$var$mapTag = '[object Map]', $45ec5d77afad7a6c$var$numberTag = '[object Number]', $45ec5d77afad7a6c$var$objectTag = '[object Object]', $45ec5d77afad7a6c$var$regexpTag = '[object RegExp]', $45ec5d77afad7a6c$var$setTag = '[object Set]', $45ec5d77afad7a6c$var$stringTag = '[object String]', $45ec5d77afad7a6c$var$symbolTag = '[object Symbol]', $45ec5d77afad7a6c$var$weakMapTag = '[object WeakMap]';
var $45ec5d77afad7a6c$var$arrayBufferTag = '[object ArrayBuffer]', $45ec5d77afad7a6c$var$dataViewTag = '[object DataView]', $45ec5d77afad7a6c$var$float32Tag = '[object Float32Array]', $45ec5d77afad7a6c$var$float64Tag = '[object Float64Array]', $45ec5d77afad7a6c$var$int8Tag = '[object Int8Array]', $45ec5d77afad7a6c$var$int16Tag = '[object Int16Array]', $45ec5d77afad7a6c$var$int32Tag = '[object Int32Array]', $45ec5d77afad7a6c$var$uint8Tag = '[object Uint8Array]', $45ec5d77afad7a6c$var$uint8ClampedTag = '[object Uint8ClampedArray]', $45ec5d77afad7a6c$var$uint16Tag = '[object Uint16Array]', $45ec5d77afad7a6c$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $45ec5d77afad7a6c$var$cloneableTags = {};
$45ec5d77afad7a6c$var$cloneableTags[$45ec5d77afad7a6c$var$argsTag] = $45ec5d77afad7a6c$var$cloneableTags[$45ec5d77afad7a6c$var$arrayTag] = $45ec5d77afad7a6c$var$cloneableTags[$45ec5d77afad7a6c$var$arrayBufferTag] = $45ec5d77afad7a6c$var$cloneableTags[$45ec5d77afad7a6c$var$dataViewTag] = $45ec5d77afad7a6c$var$cloneableTags[$45ec5d77afad7a6c$var$boolTag] = $45ec5d77afad7a6c$var$cloneableTags[$45ec5d77afad7a6c$var$dateTag] = $45ec5d77afad7a6c$var$cloneableTags[$45ec5d77afad7a6c$var$float32Tag] = $45ec5d77afad7a6c$var$cloneableTags[$45ec5d77afad7a6c$var$float64Tag] = $45ec5d77afad7a6c$var$cloneableTags[$45ec5d77afad7a6c$var$int8Tag] = $45ec5d77afad7a6c$var$cloneableTags[$45ec5d77afad7a6c$var$int16Tag] = $45ec5d77afad7a6c$var$cloneableTags[$45ec5d77afad7a6c$var$int32Tag] = $45ec5d77afad7a6c$var$cloneableTags[$45ec5d77afad7a6c$var$mapTag] = $45ec5d77afad7a6c$var$cloneableTags[$45ec5d77afad7a6c$var$numberTag] = $45ec5d77afad7a6c$var$cloneableTags[$45ec5d77afad7a6c$var$objectTag] = $45ec5d77afad7a6c$var$cloneableTags[$45ec5d77afad7a6c$var$regexpTag] = $45ec5d77afad7a6c$var$cloneableTags[$45ec5d77afad7a6c$var$setTag] = $45ec5d77afad7a6c$var$cloneableTags[$45ec5d77afad7a6c$var$stringTag] = $45ec5d77afad7a6c$var$cloneableTags[$45ec5d77afad7a6c$var$symbolTag] = $45ec5d77afad7a6c$var$cloneableTags[$45ec5d77afad7a6c$var$uint8Tag] = $45ec5d77afad7a6c$var$cloneableTags[$45ec5d77afad7a6c$var$uint8ClampedTag] = $45ec5d77afad7a6c$var$cloneableTags[$45ec5d77afad7a6c$var$uint16Tag] = $45ec5d77afad7a6c$var$cloneableTags[$45ec5d77afad7a6c$var$uint32Tag] = true;
$45ec5d77afad7a6c$var$cloneableTags[$45ec5d77afad7a6c$var$errorTag] = $45ec5d77afad7a6c$var$cloneableTags[$45ec5d77afad7a6c$var$funcTag] = $45ec5d77afad7a6c$var$cloneableTags[$45ec5d77afad7a6c$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $45ec5d77afad7a6c$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $45ec5d77afad7a6c$var$CLONE_DEEP_FLAG, isFlat = bitmask & $45ec5d77afad7a6c$var$CLONE_FLAT_FLAG, isFull = bitmask & $45ec5d77afad7a6c$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$bFI6q(value)) return value;
    var isArr = $9X1Pr(value);
    if (isArr) {
        result = $5ecf62e22555298a$exports(value);
        if (!isDeep) return $2e83607cadbcdd57$exports(value, result);
    } else {
        var tag = $jaE2r(value), isFunc = tag == $45ec5d77afad7a6c$var$funcTag || tag == $45ec5d77afad7a6c$var$genTag;
        if ($1mK9W(value)) return $cJDXf(value, isDeep);
        if (tag == $45ec5d77afad7a6c$var$objectTag || tag == $45ec5d77afad7a6c$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $500741bec8362763$exports(value);
            if (!isDeep) return isFlat ? $2ddbe6ed2909034d$exports(value, $d5580916787e0396$exports(result, value)) : $7d83ced8203a5c15$exports(value, $2a0e4c190fdd997c$exports(result, value));
        } else {
            if (!$45ec5d77afad7a6c$var$cloneableTags[tag]) return object ? value : {};
            result = $84b1d1e7afebd306$exports(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $gfqTY);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($8e50b26c52b6235f$exports(value)) value.forEach(function(subValue) {
        result.add($45ec5d77afad7a6c$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($9a9138c71477fe93$exports(value)) value.forEach(function(subValue, key) {
        result.set(key, $45ec5d77afad7a6c$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $75272089352d1549$exports : $eCkRO : isFlat ? $739031f48e6fcbdc$exports : $kOHWF;
    var props = isArr ? undefined : keysFunc(value);
    $9dfd370374659d17$exports(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $fd66b3451a05f82d$exports(result, key, $45ec5d77afad7a6c$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
$45ec5d77afad7a6c$exports = $45ec5d77afad7a6c$var$baseClone;


var $b68dcefe966d1ba0$exports = {};

var $03e11b323ae550f9$exports = {};
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $03e11b323ae550f9$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
$03e11b323ae550f9$exports = $03e11b323ae550f9$var$last;


var $9830e5efa88bc132$exports = {};

var $8be3a25fc8d36933$exports = {};
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $8be3a25fc8d36933$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
$8be3a25fc8d36933$exports = $8be3a25fc8d36933$var$baseSlice;


/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $9830e5efa88bc132$var$parent(object, path) {
    return path.length < 2 ? object : $ace1aa1fc712f2b4$exports(object, $8be3a25fc8d36933$exports(path, 0, -1));
}
$9830e5efa88bc132$exports = $9830e5efa88bc132$var$parent;



/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $b68dcefe966d1ba0$var$baseUnset(object, path) {
    path = $f33fa3a5f5577055$exports(path, object);
    object = $9830e5efa88bc132$exports(object, path);
    return object == null || delete object[$ebfc077974dafc29$exports($03e11b323ae550f9$exports(path))];
}
$b68dcefe966d1ba0$exports = $b68dcefe966d1ba0$var$baseUnset;




var $cf126b894f68dc54$exports = {};
var $784c24890d37913a$exports = {};

var $aeQBO = parcelRequire("aeQBO");


var $lqXWM = parcelRequire("lqXWM");
/** `Object#toString` result references. */ var $784c24890d37913a$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $784c24890d37913a$var$funcProto = Function.prototype, $784c24890d37913a$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $784c24890d37913a$var$funcToString = $784c24890d37913a$var$funcProto.toString;
/** Used to check objects for own properties. */ var $784c24890d37913a$var$hasOwnProperty = $784c24890d37913a$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $784c24890d37913a$var$objectCtorString = $784c24890d37913a$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $784c24890d37913a$var$isPlainObject(value) {
    if (!$lqXWM(value) || $aeQBO(value) != $784c24890d37913a$var$objectTag) return false;
    var proto = $79683a944646ef3c$exports(value);
    if (proto === null) return true;
    var Ctor = $784c24890d37913a$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $784c24890d37913a$var$funcToString.call(Ctor) == $784c24890d37913a$var$objectCtorString;
}
$784c24890d37913a$exports = $784c24890d37913a$var$isPlainObject;


/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $cf126b894f68dc54$var$customOmitClone(value) {
    return $784c24890d37913a$exports(value) ? undefined : value;
}
$cf126b894f68dc54$exports = $cf126b894f68dc54$var$customOmitClone;


var $ff1e841f5967848e$exports = {};
var $4a1aaf6ea22f8e57$exports = {};
var $d1885235d645458c$exports = {};

var $2Wmte = parcelRequire("2Wmte");
var $82599f4b22b87908$exports = {};

var $jf0iC = parcelRequire("jf0iC");

var $aPIym = parcelRequire("aPIym");

var $9X1Pr = parcelRequire("9X1Pr");
/** Built-in value references. */ var $82599f4b22b87908$var$spreadableSymbol = $jf0iC ? $jf0iC.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $82599f4b22b87908$var$isFlattenable(value) {
    return $9X1Pr(value) || $aPIym(value) || !!($82599f4b22b87908$var$spreadableSymbol && value && value[$82599f4b22b87908$var$spreadableSymbol]);
}
$82599f4b22b87908$exports = $82599f4b22b87908$var$isFlattenable;


/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $d1885235d645458c$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $82599f4b22b87908$exports);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $d1885235d645458c$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $2Wmte(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
$d1885235d645458c$exports = $d1885235d645458c$var$baseFlatten;


/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $4a1aaf6ea22f8e57$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $d1885235d645458c$exports(array, 1) : [];
}
$4a1aaf6ea22f8e57$exports = $4a1aaf6ea22f8e57$var$flatten;


var $00d796235c3dfa30$exports = {};
var $e5de56e190cfe196$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $e5de56e190cfe196$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$e5de56e190cfe196$exports = $e5de56e190cfe196$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $00d796235c3dfa30$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $00d796235c3dfa30$var$overRest(func, start, transform) {
    start = $00d796235c3dfa30$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $00d796235c3dfa30$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $e5de56e190cfe196$exports(func, this, otherArgs);
    };
}
$00d796235c3dfa30$exports = $00d796235c3dfa30$var$overRest;


var $282126ca61de9eb4$exports = {};
var $3496cd204ef6ec7c$exports = {};
var $2ca95a726d711049$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $2ca95a726d711049$var$constant(value) {
    return function() {
        return value;
    };
}
$2ca95a726d711049$exports = $2ca95a726d711049$var$constant;




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $3496cd204ef6ec7c$var$baseSetToString = !$07096ecca1e08976$exports ? $37b60a988d3d7b74$exports : function(func, string) {
    return $07096ecca1e08976$exports(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $2ca95a726d711049$exports(string),
        'writable': true
    });
};
$3496cd204ef6ec7c$exports = $3496cd204ef6ec7c$var$baseSetToString;


var $70aa3b11b43aaa1a$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $70aa3b11b43aaa1a$var$HOT_COUNT = 800, $70aa3b11b43aaa1a$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $70aa3b11b43aaa1a$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $70aa3b11b43aaa1a$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $70aa3b11b43aaa1a$var$nativeNow(), remaining = $70aa3b11b43aaa1a$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $70aa3b11b43aaa1a$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$70aa3b11b43aaa1a$exports = $70aa3b11b43aaa1a$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $282126ca61de9eb4$var$setToString = $70aa3b11b43aaa1a$exports($3496cd204ef6ec7c$exports);
$282126ca61de9eb4$exports = $282126ca61de9eb4$var$setToString;


/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $ff1e841f5967848e$var$flatRest(func) {
    return $282126ca61de9eb4$exports($00d796235c3dfa30$exports(func, undefined, $4a1aaf6ea22f8e57$exports), func + '');
}
$ff1e841f5967848e$exports = $ff1e841f5967848e$var$flatRest;



/** Used to compose bitmasks for cloning. */ var $8c058a9ce2201bdb$var$CLONE_DEEP_FLAG = 1, $8c058a9ce2201bdb$var$CLONE_FLAT_FLAG = 2, $8c058a9ce2201bdb$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $8c058a9ce2201bdb$var$omit = $ff1e841f5967848e$exports(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $d7b14ee62c41bda8$exports(paths, function(path) {
        path = $f33fa3a5f5577055$exports(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $33f04050f44b0aad$exports(object, $75272089352d1549$exports(object), result);
    if (isDeep) result = $45ec5d77afad7a6c$exports(result, $8c058a9ce2201bdb$var$CLONE_DEEP_FLAG | $8c058a9ce2201bdb$var$CLONE_FLAT_FLAG | $8c058a9ce2201bdb$var$CLONE_SYMBOLS_FLAG, $cf126b894f68dc54$exports);
    var length = paths.length;
    while(length--)$b68dcefe966d1ba0$exports(result, paths[length]);
    return result;
});
$8c058a9ce2201bdb$exports = $8c058a9ce2201bdb$var$omit;











function $906d8bf292ab46b5$var$traceUFOInteraction(name, interactionType, startTime) {
    const rate = (0, $0d141f9c9c05f1cf$export$9466a8f085fa7d4e)(name, interactionType);
    const pressInteractionsList = (0, $0d141f9c9c05f1cf$export$3c170167645a0eff)();
    const minorInteractions = (pressInteractionsList ?? []).concat((0, $0d141f9c9c05f1cf$export$b150ddad71c80d77)() ?? []);
    if (minorInteractions.includes(name)) {
        const activeInteraction = (0, $d9b1f70c159fe18d$export$2b3954d2e8509985)();
        activeInteraction?.minorInteractions?.push({
            name: name,
            startTime: startTime ?? performance.now()
        });
        return;
    } else (0, $d9b1f70c159fe18d$export$614a7af2affc5dff)('new_interaction', name);
    if ((0, $4659fee6fbb6d2af$export$2e2bcd8739ae039)(rate)) {
        const startTimestamp = startTime ?? performance.now();
        const newId = (0, $466a4b1793cac1d8$exports.v4)();
        (0, $9a27762368c0f25d$export$3109542b68df9ba1).current = newId;
        // covered experiences with tracing instrumentation:
        // inline-result.inline-card-create-submit
        (0, $aae51952f0016112$export$f2e521e495a88544)(newId, interactionType);
        (0, $d9b1f70c159fe18d$export$1a1ed1e1fdb2006b)(newId, name, interactionType === 'hover' ? 'press' : interactionType, startTimestamp, rate, [], (0, $141d3ae8f27fd99b$export$2e2bcd8739ae039).current, (0, $aae51952f0016112$export$b6ac780db3a3cc77)());
    }
}
var $906d8bf292ab46b5$export$2e2bcd8739ae039 = $906d8bf292ab46b5$var$traceUFOInteraction;


function $0583deb72bc53d48$var$traceUFOPress(name, timestamp) {
    return (0, $906d8bf292ab46b5$export$2e2bcd8739ae039)(name, 'press', timestamp);
}
var $0583deb72bc53d48$export$2e2bcd8739ae039 = $0583deb72bc53d48$var$traceUFOPress;



var $b0809950592c8add$exports = {};
var $db155982079085a7$exports = {};


// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $db155982079085a7$var$_nodeId;
var $db155982079085a7$var$_clockseq;
// Previous uuid creation time
var $db155982079085a7$var$_lastMSecs = 0;
var $db155982079085a7$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $db155982079085a7$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $db155982079085a7$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $db155982079085a7$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $8620f91002fd03c7$exports();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $db155982079085a7$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $db155982079085a7$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $db155982079085a7$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $db155982079085a7$var$_lastMSecs + (nsecs - $db155982079085a7$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $db155982079085a7$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    $db155982079085a7$var$_lastMSecs = msecs;
    $db155982079085a7$var$_lastNSecs = nsecs;
    $db155982079085a7$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $0eb3fc9f8addfeea$exports(b);
}
$db155982079085a7$exports = $db155982079085a7$var$v1;



var $b0809950592c8add$var$uuid = $c29b43bb0df96673$exports;
$b0809950592c8add$var$uuid.v1 = $db155982079085a7$exports;
$b0809950592c8add$var$uuid.v4 = $c29b43bb0df96673$exports;
$b0809950592c8add$exports = $b0809950592c8add$var$uuid;


// @ts-ignore
var $9d2a53801800548c$exports = {};
$parcel$export($9d2a53801800548c$exports, "randomBytes", () => $9d2a53801800548c$export$5f828d93ff035aa8, (v) => $9d2a53801800548c$export$5f828d93ff035aa8 = v);
$parcel$export($9d2a53801800548c$exports, "rng", () => $9d2a53801800548c$export$cd94982b18c6332c, (v) => $9d2a53801800548c$export$cd94982b18c6332c = v);
$parcel$export($9d2a53801800548c$exports, "pseudoRandomBytes", () => $9d2a53801800548c$export$1d518568e4f529b0, (v) => $9d2a53801800548c$export$1d518568e4f529b0 = v);
$parcel$export($9d2a53801800548c$exports, "prng", () => $9d2a53801800548c$export$5285b6d41c912b41, (v) => $9d2a53801800548c$export$5285b6d41c912b41 = v);
$parcel$export($9d2a53801800548c$exports, "createHash", () => $9d2a53801800548c$export$2fb37efbf6ae0c0e, (v) => $9d2a53801800548c$export$2fb37efbf6ae0c0e = v);
$parcel$export($9d2a53801800548c$exports, "Hash", () => $9d2a53801800548c$export$ab85ecd77ce6a5cd, (v) => $9d2a53801800548c$export$ab85ecd77ce6a5cd = v);
$parcel$export($9d2a53801800548c$exports, "createHmac", () => $9d2a53801800548c$export$da39cf97e1eb7c91, (v) => $9d2a53801800548c$export$da39cf97e1eb7c91 = v);
$parcel$export($9d2a53801800548c$exports, "Hmac", () => $9d2a53801800548c$export$52a9039d7177394f, (v) => $9d2a53801800548c$export$52a9039d7177394f = v);
$parcel$export($9d2a53801800548c$exports, "getHashes", () => $9d2a53801800548c$export$f7201db400317331, (v) => $9d2a53801800548c$export$f7201db400317331 = v);
$parcel$export($9d2a53801800548c$exports, "pbkdf2", () => $9d2a53801800548c$export$448fa22aedc9dbca, (v) => $9d2a53801800548c$export$448fa22aedc9dbca = v);
$parcel$export($9d2a53801800548c$exports, "pbkdf2Sync", () => $9d2a53801800548c$export$b80c7ba289c8fa56, (v) => $9d2a53801800548c$export$b80c7ba289c8fa56 = v);
$parcel$export($9d2a53801800548c$exports, "Cipher", () => $9d2a53801800548c$export$26e5786e8ac8e530, (v) => $9d2a53801800548c$export$26e5786e8ac8e530 = v);
$parcel$export($9d2a53801800548c$exports, "createCipher", () => $9d2a53801800548c$export$bdd223f16383713e, (v) => $9d2a53801800548c$export$bdd223f16383713e = v);
$parcel$export($9d2a53801800548c$exports, "Cipheriv", () => $9d2a53801800548c$export$20533d26f07f1ee0, (v) => $9d2a53801800548c$export$20533d26f07f1ee0 = v);
$parcel$export($9d2a53801800548c$exports, "createCipheriv", () => $9d2a53801800548c$export$2f64596b8cbf08b4, (v) => $9d2a53801800548c$export$2f64596b8cbf08b4 = v);
$parcel$export($9d2a53801800548c$exports, "Decipher", () => $9d2a53801800548c$export$2ce6d8d0e8b04e1a, (v) => $9d2a53801800548c$export$2ce6d8d0e8b04e1a = v);
$parcel$export($9d2a53801800548c$exports, "createDecipher", () => $9d2a53801800548c$export$12ada9414fbc594c, (v) => $9d2a53801800548c$export$12ada9414fbc594c = v);
$parcel$export($9d2a53801800548c$exports, "Decipheriv", () => $9d2a53801800548c$export$f5e7e39d57cd9700, (v) => $9d2a53801800548c$export$f5e7e39d57cd9700 = v);
$parcel$export($9d2a53801800548c$exports, "createDecipheriv", () => $9d2a53801800548c$export$36b6d6ef312eab39, (v) => $9d2a53801800548c$export$36b6d6ef312eab39 = v);
$parcel$export($9d2a53801800548c$exports, "getCiphers", () => $9d2a53801800548c$export$58a258485f1e49f6, (v) => $9d2a53801800548c$export$58a258485f1e49f6 = v);
$parcel$export($9d2a53801800548c$exports, "listCiphers", () => $9d2a53801800548c$export$dedd8dc3dc62b370, (v) => $9d2a53801800548c$export$dedd8dc3dc62b370 = v);
$parcel$export($9d2a53801800548c$exports, "DiffieHellmanGroup", () => $9d2a53801800548c$export$971862a2fcb1bb40, (v) => $9d2a53801800548c$export$971862a2fcb1bb40 = v);
$parcel$export($9d2a53801800548c$exports, "createDiffieHellmanGroup", () => $9d2a53801800548c$export$c6ff6a88acbeaf40, (v) => $9d2a53801800548c$export$c6ff6a88acbeaf40 = v);
$parcel$export($9d2a53801800548c$exports, "getDiffieHellman", () => $9d2a53801800548c$export$fdc27893e98845cc, (v) => $9d2a53801800548c$export$fdc27893e98845cc = v);
$parcel$export($9d2a53801800548c$exports, "createDiffieHellman", () => $9d2a53801800548c$export$6671fb9a1323bed, (v) => $9d2a53801800548c$export$6671fb9a1323bed = v);
$parcel$export($9d2a53801800548c$exports, "DiffieHellman", () => $9d2a53801800548c$export$d74daf141a551db, (v) => $9d2a53801800548c$export$d74daf141a551db = v);
$parcel$export($9d2a53801800548c$exports, "createSign", () => $9d2a53801800548c$export$45df7cae684751af, (v) => $9d2a53801800548c$export$45df7cae684751af = v);
$parcel$export($9d2a53801800548c$exports, "Sign", () => $9d2a53801800548c$export$1db683ad541682f6, (v) => $9d2a53801800548c$export$1db683ad541682f6 = v);
$parcel$export($9d2a53801800548c$exports, "createVerify", () => $9d2a53801800548c$export$6f65485f87568e37, (v) => $9d2a53801800548c$export$6f65485f87568e37 = v);
$parcel$export($9d2a53801800548c$exports, "Verify", () => $9d2a53801800548c$export$91a8e56769aeb334, (v) => $9d2a53801800548c$export$91a8e56769aeb334 = v);
$parcel$export($9d2a53801800548c$exports, "createECDH", () => $9d2a53801800548c$export$2d4117e99c2179e4, (v) => $9d2a53801800548c$export$2d4117e99c2179e4 = v);
$parcel$export($9d2a53801800548c$exports, "publicEncrypt", () => $9d2a53801800548c$export$512823e338ddb1b7, (v) => $9d2a53801800548c$export$512823e338ddb1b7 = v);
$parcel$export($9d2a53801800548c$exports, "privateEncrypt", () => $9d2a53801800548c$export$9d0e0c0c4a8d30f3, (v) => $9d2a53801800548c$export$9d0e0c0c4a8d30f3 = v);
$parcel$export($9d2a53801800548c$exports, "publicDecrypt", () => $9d2a53801800548c$export$b9d55ff329113abd, (v) => $9d2a53801800548c$export$b9d55ff329113abd = v);
$parcel$export($9d2a53801800548c$exports, "privateDecrypt", () => $9d2a53801800548c$export$7efb24e2fddf99b9, (v) => $9d2a53801800548c$export$7efb24e2fddf99b9 = v);
$parcel$export($9d2a53801800548c$exports, "randomFill", () => $9d2a53801800548c$export$bb1abf2ce84fc7e8, (v) => $9d2a53801800548c$export$bb1abf2ce84fc7e8 = v);
$parcel$export($9d2a53801800548c$exports, "randomFillSync", () => $9d2a53801800548c$export$2f7171e78e524d5e, (v) => $9d2a53801800548c$export$2f7171e78e524d5e = v);
$parcel$export($9d2a53801800548c$exports, "createCredentials", () => $9d2a53801800548c$export$e1d879b482f37d98, (v) => $9d2a53801800548c$export$e1d879b482f37d98 = v);
$parcel$export($9d2a53801800548c$exports, "constants", () => $9d2a53801800548c$export$1a988e7317c65621, (v) => $9d2a53801800548c$export$1a988e7317c65621 = v);
// eslint-disable-next-line no-multi-assign
var $9d2a53801800548c$export$5f828d93ff035aa8;
var $9d2a53801800548c$export$cd94982b18c6332c;
var $9d2a53801800548c$export$1d518568e4f529b0;
var $9d2a53801800548c$export$5285b6d41c912b41;
// eslint-disable-next-line no-multi-assign
var $9d2a53801800548c$export$2fb37efbf6ae0c0e;
var $9d2a53801800548c$export$ab85ecd77ce6a5cd;
// eslint-disable-next-line no-multi-assign
var $9d2a53801800548c$export$da39cf97e1eb7c91;
var $9d2a53801800548c$export$52a9039d7177394f;
var $9d2a53801800548c$export$f7201db400317331;
var $9d2a53801800548c$export$448fa22aedc9dbca;
var $9d2a53801800548c$export$b80c7ba289c8fa56;
var $9d2a53801800548c$export$26e5786e8ac8e530;
var $9d2a53801800548c$export$bdd223f16383713e;
var $9d2a53801800548c$export$20533d26f07f1ee0;
var $9d2a53801800548c$export$2f64596b8cbf08b4;
var $9d2a53801800548c$export$2ce6d8d0e8b04e1a;
var $9d2a53801800548c$export$12ada9414fbc594c;
var $9d2a53801800548c$export$f5e7e39d57cd9700;
var $9d2a53801800548c$export$36b6d6ef312eab39;
var $9d2a53801800548c$export$58a258485f1e49f6;
var $9d2a53801800548c$export$dedd8dc3dc62b370;
var $9d2a53801800548c$export$971862a2fcb1bb40;
var $9d2a53801800548c$export$c6ff6a88acbeaf40;
var $9d2a53801800548c$export$fdc27893e98845cc;
var $9d2a53801800548c$export$6671fb9a1323bed;
var $9d2a53801800548c$export$d74daf141a551db;
var $9d2a53801800548c$export$45df7cae684751af;
var $9d2a53801800548c$export$1db683ad541682f6;
var $9d2a53801800548c$export$6f65485f87568e37;
var $9d2a53801800548c$export$91a8e56769aeb334;
var $9d2a53801800548c$export$2d4117e99c2179e4;
var $9d2a53801800548c$export$512823e338ddb1b7;
var $9d2a53801800548c$export$9d0e0c0c4a8d30f3;
var $9d2a53801800548c$export$b9d55ff329113abd;
var $9d2a53801800548c$export$7efb24e2fddf99b9;
var $9d2a53801800548c$export$bb1abf2ce84fc7e8;
var $9d2a53801800548c$export$2f7171e78e524d5e;
var $9d2a53801800548c$export$e1d879b482f37d98;
var $9d2a53801800548c$export$1a988e7317c65621;
'use strict';

$9d2a53801800548c$export$5f828d93ff035aa8 = $9d2a53801800548c$export$cd94982b18c6332c = $9d2a53801800548c$export$1d518568e4f529b0 = $9d2a53801800548c$export$5285b6d41c912b41 = (parcelRequire("7kZ78"));

$9d2a53801800548c$export$2fb37efbf6ae0c0e = $9d2a53801800548c$export$ab85ecd77ce6a5cd = (parcelRequire("lDOK8"));

$9d2a53801800548c$export$da39cf97e1eb7c91 = $9d2a53801800548c$export$52a9039d7177394f = (parcelRequire("jMEDM"));
var $ebfc55c0fa61163c$exports = {};
'use strict';

$ebfc55c0fa61163c$exports = (parcelRequire("rQEpC"));


var $9d2a53801800548c$var$algoKeys = Object.keys($ebfc55c0fa61163c$exports);
var $9d2a53801800548c$var$hashes = [
    'sha1',
    'sha224',
    'sha256',
    'sha384',
    'sha512',
    'md5',
    'rmd160'
].concat($9d2a53801800548c$var$algoKeys);
$9d2a53801800548c$export$f7201db400317331 = function() {
    return $9d2a53801800548c$var$hashes;
};

var $Hnr6T = parcelRequire("Hnr6T");
$9d2a53801800548c$export$448fa22aedc9dbca = $Hnr6T.pbkdf2;
$9d2a53801800548c$export$b80c7ba289c8fa56 = $Hnr6T.pbkdf2Sync;
var $f30da3dc3b615e7a$export$bdd223f16383713e;
var $f30da3dc3b615e7a$export$26e5786e8ac8e530;
var $f30da3dc3b615e7a$export$2f64596b8cbf08b4;
var $f30da3dc3b615e7a$export$20533d26f07f1ee0;
var $f30da3dc3b615e7a$export$12ada9414fbc594c;
var $f30da3dc3b615e7a$export$2ce6d8d0e8b04e1a;
var $f30da3dc3b615e7a$export$36b6d6ef312eab39;
var $f30da3dc3b615e7a$export$f5e7e39d57cd9700;
var $f30da3dc3b615e7a$export$dedd8dc3dc62b370;
var $f30da3dc3b615e7a$export$58a258485f1e49f6;
var $84d9623adec14108$exports = {};

var $hCwwr = parcelRequire("hCwwr");
var $f4dd1ef2196f5a73$export$eab97d15b1788b8d;
var $f4dd1ef2196f5a73$export$26e5786e8ac8e530;
var $f4dd1ef2196f5a73$export$cc8859615686b300;
var $f4dd1ef2196f5a73$export$8ad3f227af08fcc5;
var $f4dd1ef2196f5a73$export$947646e34766044f;
'use strict';

$f4dd1ef2196f5a73$export$eab97d15b1788b8d = (parcelRequire("knogy"));

$f4dd1ef2196f5a73$export$26e5786e8ac8e530 = (parcelRequire("28rE0"));

$f4dd1ef2196f5a73$export$cc8859615686b300 = (parcelRequire("8e6aA"));

$f4dd1ef2196f5a73$export$8ad3f227af08fcc5 = (parcelRequire("9NKqH"));

$f4dd1ef2196f5a73$export$947646e34766044f = (parcelRequire("84CVV"));



var $ktJSc = parcelRequire("ktJSc");

var $4EeOM = parcelRequire("4EeOM");
var $84d9623adec14108$require$Buffer = $4EeOM.Buffer;
var $84d9623adec14108$var$modes = {
    'des-ede3-cbc': $f4dd1ef2196f5a73$export$8ad3f227af08fcc5.instantiate($f4dd1ef2196f5a73$export$947646e34766044f),
    'des-ede3': $f4dd1ef2196f5a73$export$947646e34766044f,
    'des-ede-cbc': $f4dd1ef2196f5a73$export$8ad3f227af08fcc5.instantiate($f4dd1ef2196f5a73$export$947646e34766044f),
    'des-ede': $f4dd1ef2196f5a73$export$947646e34766044f,
    'des-cbc': $f4dd1ef2196f5a73$export$8ad3f227af08fcc5.instantiate($f4dd1ef2196f5a73$export$cc8859615686b300),
    'des-ecb': $f4dd1ef2196f5a73$export$cc8859615686b300
};
$84d9623adec14108$var$modes.des = $84d9623adec14108$var$modes['des-cbc'];
$84d9623adec14108$var$modes.des3 = $84d9623adec14108$var$modes['des-ede3-cbc'];
$84d9623adec14108$exports = $84d9623adec14108$var$DES;
$ktJSc($84d9623adec14108$var$DES, $hCwwr);
function $84d9623adec14108$var$DES(opts) {
    $hCwwr.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $84d9623adec14108$var$modes[modeName];
    var type;
    if (opts.decrypt) type = 'decrypt';
    else type = 'encrypt';
    var key = opts.key;
    if (!$84d9623adec14108$require$Buffer.isBuffer(key)) key = $84d9623adec14108$require$Buffer.from(key);
    if (modeName === 'des-ede' || modeName === 'des-ede-cbc') key = $84d9623adec14108$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    if (!$84d9623adec14108$require$Buffer.isBuffer(iv)) iv = $84d9623adec14108$require$Buffer.from(iv);
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$84d9623adec14108$var$DES.prototype._update = function(data) {
    return $84d9623adec14108$require$Buffer.from(this._des.update(data));
};
$84d9623adec14108$var$DES.prototype._final = function() {
    return $84d9623adec14108$require$Buffer.from(this._des.final());
};



var $7qWsf = parcelRequire("7qWsf");

var $dTcQB = parcelRequire("dTcQB");
var $e90b5cd450c536dd$exports = {};
$parcel$export($e90b5cd450c536dd$exports, "des-ecb", () => $e90b5cd450c536dd$export$116f8a5cee447347, (v) => $e90b5cd450c536dd$export$116f8a5cee447347 = v);
$parcel$export($e90b5cd450c536dd$exports, "des-cbc", () => $e90b5cd450c536dd$export$7483c4066bfb7ae9, (v) => $e90b5cd450c536dd$export$7483c4066bfb7ae9 = v);
$parcel$export($e90b5cd450c536dd$exports, "des", () => $e90b5cd450c536dd$export$e7a565d2e588bb06, (v) => $e90b5cd450c536dd$export$e7a565d2e588bb06 = v);
$parcel$export($e90b5cd450c536dd$exports, "des-ede3-cbc", () => $e90b5cd450c536dd$export$aaa2f54a426f3eb8, (v) => $e90b5cd450c536dd$export$aaa2f54a426f3eb8 = v);
$parcel$export($e90b5cd450c536dd$exports, "des3", () => $e90b5cd450c536dd$export$eba20568dde4ada, (v) => $e90b5cd450c536dd$export$eba20568dde4ada = v);
$parcel$export($e90b5cd450c536dd$exports, "des-ede3", () => $e90b5cd450c536dd$export$d3b5e5996938f5ae, (v) => $e90b5cd450c536dd$export$d3b5e5996938f5ae = v);
$parcel$export($e90b5cd450c536dd$exports, "des-ede-cbc", () => $e90b5cd450c536dd$export$57c08356130bc99b, (v) => $e90b5cd450c536dd$export$57c08356130bc99b = v);
$parcel$export($e90b5cd450c536dd$exports, "des-ede", () => $e90b5cd450c536dd$export$c7169791d5c1e65d, (v) => $e90b5cd450c536dd$export$c7169791d5c1e65d = v);
var $e90b5cd450c536dd$export$116f8a5cee447347;
var $e90b5cd450c536dd$export$7483c4066bfb7ae9;
var $e90b5cd450c536dd$export$e7a565d2e588bb06;
var $e90b5cd450c536dd$export$aaa2f54a426f3eb8;
var $e90b5cd450c536dd$export$eba20568dde4ada;
var $e90b5cd450c536dd$export$d3b5e5996938f5ae;
var $e90b5cd450c536dd$export$57c08356130bc99b;
var $e90b5cd450c536dd$export$c7169791d5c1e65d;
$e90b5cd450c536dd$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$e90b5cd450c536dd$export$7483c4066bfb7ae9 = $e90b5cd450c536dd$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$e90b5cd450c536dd$export$aaa2f54a426f3eb8 = $e90b5cd450c536dd$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$e90b5cd450c536dd$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$e90b5cd450c536dd$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$e90b5cd450c536dd$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};



var $jCkZB = parcelRequire("jCkZB");
function $f30da3dc3b615e7a$var$createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($dTcQB[suite]) {
        keyLen = $dTcQB[suite].key;
        ivLen = $dTcQB[suite].iv;
    } else if ($e90b5cd450c536dd$exports[suite]) {
        keyLen = $e90b5cd450c536dd$exports[suite].key * 8;
        ivLen = $e90b5cd450c536dd$exports[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $jCkZB(password, false, keyLen, ivLen);
    return $f30da3dc3b615e7a$var$createCipheriv(suite, keys.key, keys.iv);
}
function $f30da3dc3b615e7a$var$createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($dTcQB[suite]) {
        keyLen = $dTcQB[suite].key;
        ivLen = $dTcQB[suite].iv;
    } else if ($e90b5cd450c536dd$exports[suite]) {
        keyLen = $e90b5cd450c536dd$exports[suite].key * 8;
        ivLen = $e90b5cd450c536dd$exports[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $jCkZB(password, false, keyLen, ivLen);
    return $f30da3dc3b615e7a$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $f30da3dc3b615e7a$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($dTcQB[suite]) return $7qWsf.createCipheriv(suite, key, iv);
    if ($e90b5cd450c536dd$exports[suite]) return new $84d9623adec14108$exports({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError('invalid suite type');
}
function $f30da3dc3b615e7a$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($dTcQB[suite]) return $7qWsf.createDecipheriv(suite, key, iv);
    if ($e90b5cd450c536dd$exports[suite]) return new $84d9623adec14108$exports({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError('invalid suite type');
}
function $f30da3dc3b615e7a$var$getCiphers() {
    return Object.keys($e90b5cd450c536dd$exports).concat($7qWsf.getCiphers());
}
$f30da3dc3b615e7a$export$bdd223f16383713e = $f30da3dc3b615e7a$export$26e5786e8ac8e530 = $f30da3dc3b615e7a$var$createCipher;
$f30da3dc3b615e7a$export$2f64596b8cbf08b4 = $f30da3dc3b615e7a$export$20533d26f07f1ee0 = $f30da3dc3b615e7a$var$createCipheriv;
$f30da3dc3b615e7a$export$12ada9414fbc594c = $f30da3dc3b615e7a$export$2ce6d8d0e8b04e1a = $f30da3dc3b615e7a$var$createDecipher;
$f30da3dc3b615e7a$export$36b6d6ef312eab39 = $f30da3dc3b615e7a$export$f5e7e39d57cd9700 = $f30da3dc3b615e7a$var$createDecipheriv;
$f30da3dc3b615e7a$export$dedd8dc3dc62b370 = $f30da3dc3b615e7a$export$58a258485f1e49f6 = $f30da3dc3b615e7a$var$getCiphers;


$9d2a53801800548c$export$26e5786e8ac8e530 = $f30da3dc3b615e7a$export$26e5786e8ac8e530;
$9d2a53801800548c$export$bdd223f16383713e = $f30da3dc3b615e7a$export$bdd223f16383713e;
$9d2a53801800548c$export$20533d26f07f1ee0 = $f30da3dc3b615e7a$export$20533d26f07f1ee0;
$9d2a53801800548c$export$2f64596b8cbf08b4 = $f30da3dc3b615e7a$export$2f64596b8cbf08b4;
$9d2a53801800548c$export$2ce6d8d0e8b04e1a = $f30da3dc3b615e7a$export$2ce6d8d0e8b04e1a;
$9d2a53801800548c$export$12ada9414fbc594c = $f30da3dc3b615e7a$export$12ada9414fbc594c;
$9d2a53801800548c$export$f5e7e39d57cd9700 = $f30da3dc3b615e7a$export$f5e7e39d57cd9700;
$9d2a53801800548c$export$36b6d6ef312eab39 = $f30da3dc3b615e7a$export$36b6d6ef312eab39;
$9d2a53801800548c$export$58a258485f1e49f6 = $f30da3dc3b615e7a$export$58a258485f1e49f6;
$9d2a53801800548c$export$dedd8dc3dc62b370 = $f30da3dc3b615e7a$export$dedd8dc3dc62b370;
var $3a37a937c692c582$export$971862a2fcb1bb40;
var $3a37a937c692c582$export$c6ff6a88acbeaf40;
var $3a37a937c692c582$export$fdc27893e98845cc;
var $3a37a937c692c582$export$6671fb9a1323bed;
var $3a37a937c692c582$export$d74daf141a551db;

var $ekOVf = parcelRequire("ekOVf");
var $3a37a937c692c582$require$Buffer = $ekOVf.Buffer;
var $4d11d4bd74a2750f$exports = {};

var $7kZ78 = parcelRequire("7kZ78");
$4d11d4bd74a2750f$exports = $4d11d4bd74a2750f$var$findPrime;
$4d11d4bd74a2750f$var$findPrime.simpleSieve = $4d11d4bd74a2750f$var$simpleSieve;
$4d11d4bd74a2750f$var$findPrime.fermatTest = $4d11d4bd74a2750f$var$fermatTest;

var $huXFj = parcelRequire("huXFj");
var $4d11d4bd74a2750f$var$TWENTYFOUR = new $huXFj(24);
var $db35291912fbd455$exports = {};

var $huXFj = parcelRequire("huXFj");

var $5nNgF = parcelRequire("5nNgF");
function $db35291912fbd455$var$MillerRabin(rand) {
    this.rand = rand || new $5nNgF.Rand();
}
$db35291912fbd455$exports = $db35291912fbd455$var$MillerRabin;
$db35291912fbd455$var$MillerRabin.create = function create(rand) {
    return new $db35291912fbd455$var$MillerRabin(rand);
};
$db35291912fbd455$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $huXFj(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$db35291912fbd455$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$db35291912fbd455$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $huXFj.mont(n);
    var rone = new $huXFj(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $huXFj(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$db35291912fbd455$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $huXFj.mont(n);
    var rone = new $huXFj(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $huXFj(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};


var $4d11d4bd74a2750f$var$millerRabin = new $db35291912fbd455$exports();
var $4d11d4bd74a2750f$var$ONE = new $huXFj(1);
var $4d11d4bd74a2750f$var$TWO = new $huXFj(2);
var $4d11d4bd74a2750f$var$FIVE = new $huXFj(5);
var $4d11d4bd74a2750f$var$SIXTEEN = new $huXFj(16);
var $4d11d4bd74a2750f$var$EIGHT = new $huXFj(8);
var $4d11d4bd74a2750f$var$TEN = new $huXFj(10);
var $4d11d4bd74a2750f$var$THREE = new $huXFj(3);
var $4d11d4bd74a2750f$var$SEVEN = new $huXFj(7);
var $4d11d4bd74a2750f$var$ELEVEN = new $huXFj(11);
var $4d11d4bd74a2750f$var$FOUR = new $huXFj(4);
var $4d11d4bd74a2750f$var$TWELVE = new $huXFj(12);
var $4d11d4bd74a2750f$var$primes = null;
function $4d11d4bd74a2750f$var$_getPrimes() {
    if ($4d11d4bd74a2750f$var$primes !== null) return $4d11d4bd74a2750f$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $4d11d4bd74a2750f$var$primes = res;
    return res;
}
function $4d11d4bd74a2750f$var$simpleSieve(p) {
    var primes = $4d11d4bd74a2750f$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $4d11d4bd74a2750f$var$fermatTest(p) {
    var red = $huXFj.mont(p);
    return $4d11d4bd74a2750f$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $4d11d4bd74a2750f$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $huXFj([
            0x8c,
            0x7b
        ]);
        else return new $huXFj([
            0x8c,
            0x27
        ]);
    }
    gen = new $huXFj(gen);
    var num, n2;
    while(true){
        num = new $huXFj($7kZ78(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($4d11d4bd74a2750f$var$ONE);
        if (!num.testn(1)) num.iadd($4d11d4bd74a2750f$var$TWO);
        if (!gen.cmp($4d11d4bd74a2750f$var$TWO)) while(num.mod($4d11d4bd74a2750f$var$TWENTYFOUR).cmp($4d11d4bd74a2750f$var$ELEVEN))num.iadd($4d11d4bd74a2750f$var$FOUR);
        else if (!gen.cmp($4d11d4bd74a2750f$var$FIVE)) while(num.mod($4d11d4bd74a2750f$var$TEN).cmp($4d11d4bd74a2750f$var$THREE))num.iadd($4d11d4bd74a2750f$var$FOUR);
        n2 = num.shrn(1);
        if ($4d11d4bd74a2750f$var$simpleSieve(n2) && $4d11d4bd74a2750f$var$simpleSieve(num) && $4d11d4bd74a2750f$var$fermatTest(n2) && $4d11d4bd74a2750f$var$fermatTest(num) && $4d11d4bd74a2750f$var$millerRabin.test(n2) && $4d11d4bd74a2750f$var$millerRabin.test(num)) return num;
    }
}


var $26283a63e066abe9$exports = {};
$26283a63e066abe9$exports = JSON.parse("{\"modp1\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff\"},\"modp2\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff\"},\"modp5\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff\"},\"modp14\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff\"},\"modp15\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff\"},\"modp16\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff\"},\"modp17\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff\"},\"modp18\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dbe115974a3926f12fee5e438777cb6a932df8cd8bec4d073b931ba3bc832b68d9dd300741fa7bf8afc47ed2576f6936ba424663aab639c5ae4f5683423b4742bf1c978238f16cbe39d652de3fdb8befc848ad922222e04a4037c0713eb57a81a23f0c73473fc646cea306b4bcbc8862f8385ddfa9d4b7fa2c087e879683303ed5bdd3a062b3cf5b3a278a66d2a13f83f44f82ddf310ee074ab6a364597e899a0255dc164f31cc50846851df9ab48195ded7ea1b1d510bd7ee74d73faf36bc31ecfa268359046f4eb879f924009438b481c6cd7889a002ed5ee382bc9190da6fc026e479558e4475677e9aa9e3050e2765694dfc81f56e880b96e7160c980dd98edd3dfffffffffffffffff\"}}");


var $a8d75a4112cfdbb1$exports = {};

var $ekOVf = parcelRequire("ekOVf");
var $a8d75a4112cfdbb1$require$Buffer = $ekOVf.Buffer;

var $huXFj = parcelRequire("huXFj");

var $a8d75a4112cfdbb1$var$millerRabin = new $db35291912fbd455$exports();
var $a8d75a4112cfdbb1$var$TWENTYFOUR = new $huXFj(24);
var $a8d75a4112cfdbb1$var$ELEVEN = new $huXFj(11);
var $a8d75a4112cfdbb1$var$TEN = new $huXFj(10);
var $a8d75a4112cfdbb1$var$THREE = new $huXFj(3);
var $a8d75a4112cfdbb1$var$SEVEN = new $huXFj(7);


var $7kZ78 = parcelRequire("7kZ78");
$a8d75a4112cfdbb1$exports = $a8d75a4112cfdbb1$var$DH;
function $a8d75a4112cfdbb1$var$setPublicKey(pub, enc) {
    enc = enc || 'utf8';
    if (!$a8d75a4112cfdbb1$require$Buffer.isBuffer(pub)) pub = new $a8d75a4112cfdbb1$require$Buffer(pub, enc);
    this._pub = new $huXFj(pub);
    return this;
}
function $a8d75a4112cfdbb1$var$setPrivateKey(priv, enc) {
    enc = enc || 'utf8';
    if (!$a8d75a4112cfdbb1$require$Buffer.isBuffer(priv)) priv = new $a8d75a4112cfdbb1$require$Buffer(priv, enc);
    this._priv = new $huXFj(priv);
    return this;
}
var $a8d75a4112cfdbb1$var$primeCache = {};
function $a8d75a4112cfdbb1$var$checkPrime(prime, generator) {
    var gen = generator.toString('hex');
    var hex = [
        gen,
        prime.toString(16)
    ].join('_');
    if (hex in $a8d75a4112cfdbb1$var$primeCache) return $a8d75a4112cfdbb1$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$4d11d4bd74a2750f$exports.simpleSieve || !$4d11d4bd74a2750f$exports.fermatTest(prime) || !$a8d75a4112cfdbb1$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === '02' || gen === '05') // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $a8d75a4112cfdbb1$var$primeCache[hex] = error;
        return error;
    }
    if (!$a8d75a4112cfdbb1$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case '02':
            if (prime.mod($a8d75a4112cfdbb1$var$TWENTYFOUR).cmp($a8d75a4112cfdbb1$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case '05':
            rem = prime.mod($a8d75a4112cfdbb1$var$TEN);
            if (rem.cmp($a8d75a4112cfdbb1$var$THREE) && rem.cmp($a8d75a4112cfdbb1$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $a8d75a4112cfdbb1$var$primeCache[hex] = error;
    return error;
}
function $a8d75a4112cfdbb1$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $huXFj(prime);
    this._prime = $huXFj.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $a8d75a4112cfdbb1$var$setPublicKey;
        this.setPrivateKey = $a8d75a4112cfdbb1$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($a8d75a4112cfdbb1$var$DH.prototype, 'verifyError', {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== 'number') this._primeCode = $a8d75a4112cfdbb1$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$a8d75a4112cfdbb1$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $huXFj($7kZ78(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$a8d75a4112cfdbb1$var$DH.prototype.computeSecret = function(other) {
    other = new $huXFj(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $a8d75a4112cfdbb1$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $a8d75a4112cfdbb1$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $a8d75a4112cfdbb1$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$a8d75a4112cfdbb1$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $a8d75a4112cfdbb1$var$formatReturnValue(this._pub, enc);
};
$a8d75a4112cfdbb1$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $a8d75a4112cfdbb1$var$formatReturnValue(this._priv, enc);
};
$a8d75a4112cfdbb1$var$DH.prototype.getPrime = function(enc) {
    return $a8d75a4112cfdbb1$var$formatReturnValue(this.__prime, enc);
};
$a8d75a4112cfdbb1$var$DH.prototype.getGenerator = function(enc) {
    return $a8d75a4112cfdbb1$var$formatReturnValue(this._gen, enc);
};
$a8d75a4112cfdbb1$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || 'utf8';
    if (!$a8d75a4112cfdbb1$require$Buffer.isBuffer(gen)) gen = new $a8d75a4112cfdbb1$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $huXFj(gen);
    return this;
};
function $a8d75a4112cfdbb1$var$formatReturnValue(bn, enc) {
    var buf = new $a8d75a4112cfdbb1$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}


function $3a37a937c692c582$var$getDiffieHellman(mod) {
    var prime = new $3a37a937c692c582$require$Buffer($26283a63e066abe9$exports[mod].prime, 'hex');
    var gen = new $3a37a937c692c582$require$Buffer($26283a63e066abe9$exports[mod].gen, 'hex');
    return new $a8d75a4112cfdbb1$exports(prime, gen);
}
var $3a37a937c692c582$var$ENCODINGS = {
    'binary': true,
    'hex': true,
    'base64': true
};
function $3a37a937c692c582$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($3a37a937c692c582$require$Buffer.isBuffer(enc) || $3a37a937c692c582$var$ENCODINGS[enc] === undefined) return $3a37a937c692c582$var$createDiffieHellman(prime, 'binary', enc, generator);
    enc = enc || 'binary';
    genc = genc || 'binary';
    generator = generator || new $3a37a937c692c582$require$Buffer([
        2
    ]);
    if (!$3a37a937c692c582$require$Buffer.isBuffer(generator)) generator = new $3a37a937c692c582$require$Buffer(generator, genc);
    if (typeof prime === 'number') return new $a8d75a4112cfdbb1$exports($4d11d4bd74a2750f$exports(prime, generator), generator, true);
    if (!$3a37a937c692c582$require$Buffer.isBuffer(prime)) prime = new $3a37a937c692c582$require$Buffer(prime, enc);
    return new $a8d75a4112cfdbb1$exports(prime, generator, true);
}
$3a37a937c692c582$export$971862a2fcb1bb40 = $3a37a937c692c582$export$c6ff6a88acbeaf40 = $3a37a937c692c582$export$fdc27893e98845cc = $3a37a937c692c582$var$getDiffieHellman;
$3a37a937c692c582$export$6671fb9a1323bed = $3a37a937c692c582$export$d74daf141a551db = $3a37a937c692c582$var$createDiffieHellman;


$9d2a53801800548c$export$971862a2fcb1bb40 = $3a37a937c692c582$export$971862a2fcb1bb40;
$9d2a53801800548c$export$c6ff6a88acbeaf40 = $3a37a937c692c582$export$c6ff6a88acbeaf40;
$9d2a53801800548c$export$fdc27893e98845cc = $3a37a937c692c582$export$fdc27893e98845cc;
$9d2a53801800548c$export$6671fb9a1323bed = $3a37a937c692c582$export$6671fb9a1323bed;
$9d2a53801800548c$export$d74daf141a551db = $3a37a937c692c582$export$d74daf141a551db;
var $41cb19db6dca5b3a$exports = {};
'use strict';

var $4EeOM = parcelRequire("4EeOM");
var $41cb19db6dca5b3a$require$Buffer = $4EeOM.Buffer;

var $lDOK8 = parcelRequire("lDOK8");

var $gAb5Q = parcelRequire("gAb5Q");

var $ktJSc = parcelRequire("ktJSc");
var $a3a3b712f1ada4a0$exports = {};
'use strict';

var $4EeOM = parcelRequire("4EeOM");
var $a3a3b712f1ada4a0$require$Buffer = $4EeOM.Buffer;

var $jMEDM = parcelRequire("jMEDM");

var $jZOuj = parcelRequire("jZOuj");

var $4maog = parcelRequire("4maog");
var $a3a3b712f1ada4a0$require$EC = $4maog.ec;

var $aObYz = parcelRequire("aObYz");

var $juAy9 = parcelRequire("juAy9");
var $37a4820cd738bc60$exports = {};
$37a4820cd738bc60$exports = JSON.parse("{\"1.3.132.0.10\":\"secp256k1\",\"1.3.132.0.33\":\"p224\",\"1.2.840.10045.3.1.1\":\"p192\",\"1.2.840.10045.3.1.7\":\"p256\",\"1.3.132.0.34\":\"p384\",\"1.3.132.0.35\":\"p521\"}");


var $a3a3b712f1ada4a0$var$RSA_PKCS1_PADDING = 1;
function $a3a3b712f1ada4a0$var$sign(hash, key, hashType, signType, tag) {
    var priv = $juAy9(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
        return $a3a3b712f1ada4a0$var$ecSign(hash, priv);
    } else if (priv.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong private key type');
        return $a3a3b712f1ada4a0$var$dsaSign(hash, priv, hashType);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
    if (key.padding !== undefined && key.padding !== $a3a3b712f1ada4a0$var$RSA_PKCS1_PADDING) throw new Error('illegal or unsupported padding mode');
    hash = $a3a3b712f1ada4a0$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $jZOuj(pad, priv);
    return out;
}
function $a3a3b712f1ada4a0$var$ecSign(hash, priv) {
    var curveId = $37a4820cd738bc60$exports[priv.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'));
    var curve = new $a3a3b712f1ada4a0$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return $a3a3b712f1ada4a0$require$Buffer.from(out.toDER());
}
function $a3a3b712f1ada4a0$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $aObYz(0);
    var k;
    var H = $a3a3b712f1ada4a0$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $a3a3b712f1ada4a0$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $a3a3b712f1ada4a0$var$makeKey(q, kv, algo);
        r = $a3a3b712f1ada4a0$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $aObYz(0);
        }
    }
    return $a3a3b712f1ada4a0$var$toDER(r, s);
}
function $a3a3b712f1ada4a0$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return $a3a3b712f1ada4a0$require$Buffer.from(res);
}
function $a3a3b712f1ada4a0$var$getKey(x, q, hash, algo) {
    x = $a3a3b712f1ada4a0$require$Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = $a3a3b712f1ada4a0$require$Buffer.alloc(q.byteLength() - x.length);
        x = $a3a3b712f1ada4a0$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $a3a3b712f1ada4a0$var$bits2octets(hash, q);
    var v = $a3a3b712f1ada4a0$require$Buffer.alloc(hlen);
    v.fill(1);
    var k = $a3a3b712f1ada4a0$require$Buffer.alloc(hlen);
    k = $jMEDM(algo, k).update(v).update($a3a3b712f1ada4a0$require$Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = $jMEDM(algo, k).update(v).digest();
    k = $jMEDM(algo, k).update(v).update($a3a3b712f1ada4a0$require$Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = $jMEDM(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $a3a3b712f1ada4a0$var$bits2int(obits, q) {
    var bits = new $aObYz(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $a3a3b712f1ada4a0$var$bits2octets(bits, q) {
    bits = $a3a3b712f1ada4a0$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = $a3a3b712f1ada4a0$require$Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = $a3a3b712f1ada4a0$require$Buffer.alloc(q.byteLength() - out.length);
        out = $a3a3b712f1ada4a0$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $a3a3b712f1ada4a0$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = $a3a3b712f1ada4a0$require$Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $jMEDM(algo, kv.k).update(kv.v).digest();
            t = $a3a3b712f1ada4a0$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $a3a3b712f1ada4a0$var$bits2int(t, q);
        kv.k = $jMEDM(algo, kv.k).update(kv.v).update($a3a3b712f1ada4a0$require$Buffer.from([
            0
        ])).digest();
        kv.v = $jMEDM(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $a3a3b712f1ada4a0$var$makeR(g, k, p, q) {
    return g.toRed($aObYz.mont(p)).redPow(k).fromRed().mod(q);
}
$a3a3b712f1ada4a0$exports = $a3a3b712f1ada4a0$var$sign;
$a3a3b712f1ada4a0$exports.getKey = $a3a3b712f1ada4a0$var$getKey;
$a3a3b712f1ada4a0$exports.makeKey = $a3a3b712f1ada4a0$var$makeKey;


var $0997fd60e5ec52a8$exports = {};
'use strict';

var $4EeOM = parcelRequire("4EeOM");
var $0997fd60e5ec52a8$require$Buffer = $4EeOM.Buffer;

var $aObYz = parcelRequire("aObYz");

var $4maog = parcelRequire("4maog");
var $0997fd60e5ec52a8$require$EC = $4maog.ec;

var $juAy9 = parcelRequire("juAy9");

function $0997fd60e5ec52a8$var$verify(sig, hash, key, signType, tag) {
    var pub = $juAy9(key);
    if (pub.type === 'ec') {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
        return $0997fd60e5ec52a8$var$ecVerify(sig, hash, pub);
    } else if (pub.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong public key type');
        return $0997fd60e5ec52a8$var$dsaVerify(sig, hash, pub);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
    hash = $0997fd60e5ec52a8$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum += 1;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = $0997fd60e5ec52a8$require$Buffer.from(pad);
    var red = $aObYz.mont(pub.modulus);
    sig = new $aObYz(sig).toRed(red);
    sig = sig.redPow(new $aObYz(pub.publicExponent));
    sig = $0997fd60e5ec52a8$require$Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $0997fd60e5ec52a8$var$ecVerify(sig, hash, pub) {
    var curveId = $37a4820cd738bc60$exports[pub.data.algorithm.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'));
    var curve = new $0997fd60e5ec52a8$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $0997fd60e5ec52a8$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $juAy9.signature.decode(sig, 'der');
    var s = unpacked.s;
    var r = unpacked.r;
    $0997fd60e5ec52a8$var$checkValue(s, q);
    $0997fd60e5ec52a8$var$checkValue(r, q);
    var montp = $aObYz.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $aObYz(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $0997fd60e5ec52a8$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error('invalid sig');
    if (b.cmp(q) >= 0) throw new Error('invalid sig');
}
$0997fd60e5ec52a8$exports = $0997fd60e5ec52a8$var$verify;



var $rQEpC = parcelRequire("rQEpC");
Object.keys($rQEpC).forEach(function(key) {
    $rQEpC[key].id = $41cb19db6dca5b3a$require$Buffer.from($rQEpC[key].id, 'hex');
    $rQEpC[key.toLowerCase()] = $rQEpC[key];
});
function $41cb19db6dca5b3a$var$Sign(algorithm) {
    $gAb5Q.Writable.call(this);
    var data = $rQEpC[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hashType = data.hash;
    this._hash = $lDOK8(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$ktJSc($41cb19db6dca5b3a$var$Sign, $gAb5Q.Writable);
$41cb19db6dca5b3a$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$41cb19db6dca5b3a$var$Sign.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? $41cb19db6dca5b3a$require$Buffer.from(data, enc) : data);
    return this;
};
$41cb19db6dca5b3a$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $a3a3b712f1ada4a0$exports(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $41cb19db6dca5b3a$var$Verify(algorithm) {
    $gAb5Q.Writable.call(this);
    var data = $rQEpC[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hash = $lDOK8(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$ktJSc($41cb19db6dca5b3a$var$Verify, $gAb5Q.Writable);
$41cb19db6dca5b3a$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$41cb19db6dca5b3a$var$Verify.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? $41cb19db6dca5b3a$require$Buffer.from(data, enc) : data);
    return this;
};
$41cb19db6dca5b3a$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    var sigBuffer = typeof sig === 'string' ? $41cb19db6dca5b3a$require$Buffer.from(sig, enc) : sig;
    this.end();
    var hash = this._hash.digest();
    return $0997fd60e5ec52a8$exports(sigBuffer, hash, key, this._signType, this._tag);
};
function $41cb19db6dca5b3a$var$createSign(algorithm) {
    return new $41cb19db6dca5b3a$var$Sign(algorithm);
}
function $41cb19db6dca5b3a$var$createVerify(algorithm) {
    return new $41cb19db6dca5b3a$var$Verify(algorithm);
}
$41cb19db6dca5b3a$exports = {
    Sign: $41cb19db6dca5b3a$var$createSign,
    Verify: $41cb19db6dca5b3a$var$createVerify,
    createSign: $41cb19db6dca5b3a$var$createSign,
    createVerify: $41cb19db6dca5b3a$var$createVerify
};


$9d2a53801800548c$export$45df7cae684751af = $41cb19db6dca5b3a$exports.createSign;
$9d2a53801800548c$export$1db683ad541682f6 = $41cb19db6dca5b3a$exports.Sign;
$9d2a53801800548c$export$6f65485f87568e37 = $41cb19db6dca5b3a$exports.createVerify;
$9d2a53801800548c$export$91a8e56769aeb334 = $41cb19db6dca5b3a$exports.Verify;

$9d2a53801800548c$export$2d4117e99c2179e4 = (parcelRequire("3xUEM"));
var $b43530af106676b3$export$512823e338ddb1b7;
var $b43530af106676b3$export$7efb24e2fddf99b9;
var $b43530af106676b3$export$9d0e0c0c4a8d30f3;
var $b43530af106676b3$export$b9d55ff329113abd;

$b43530af106676b3$export$512823e338ddb1b7 = (parcelRequire("lI3ev"));

$b43530af106676b3$export$7efb24e2fddf99b9 = (parcelRequire("46RSZ"));
$b43530af106676b3$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $b43530af106676b3$export$512823e338ddb1b7(key, buf, true);
};
$b43530af106676b3$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $b43530af106676b3$export$7efb24e2fddf99b9(key, buf, true);
};


$9d2a53801800548c$export$512823e338ddb1b7 = $b43530af106676b3$export$512823e338ddb1b7;
$9d2a53801800548c$export$9d0e0c0c4a8d30f3 = $b43530af106676b3$export$9d0e0c0c4a8d30f3;
$9d2a53801800548c$export$b9d55ff329113abd = $b43530af106676b3$export$b9d55ff329113abd;
$9d2a53801800548c$export$7efb24e2fddf99b9 = $b43530af106676b3$export$7efb24e2fddf99b9;
var $4da1193211d48b04$export$bb1abf2ce84fc7e8;
var $4da1193211d48b04$export$2f7171e78e524d5e;

var $1CHRc = parcelRequire("1CHRc");
'use strict';
function $4da1193211d48b04$var$oldBrowser() {
    throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11');
}

var $4EeOM = parcelRequire("4EeOM");

var $7kZ78 = parcelRequire("7kZ78");
var $4da1193211d48b04$var$Buffer = $4EeOM.Buffer;
var $4da1193211d48b04$var$kBufferMaxLength = $4EeOM.kMaxLength;
var $4da1193211d48b04$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $4da1193211d48b04$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $4da1193211d48b04$var$assertOffset(offset, length) {
    if (typeof offset !== 'number' || offset !== offset) throw new TypeError('offset must be a number');
    if (offset > $4da1193211d48b04$var$kMaxUint32 || offset < 0) throw new TypeError('offset must be a uint32');
    if (offset > $4da1193211d48b04$var$kBufferMaxLength || offset > length) throw new RangeError('offset out of range');
}
function $4da1193211d48b04$var$assertSize(size, offset, length) {
    if (typeof size !== 'number' || size !== size) throw new TypeError('size must be a number');
    if (size > $4da1193211d48b04$var$kMaxUint32 || size < 0) throw new TypeError('size must be a uint32');
    if (size + offset > length || size > $4da1193211d48b04$var$kBufferMaxLength) throw new RangeError('buffer too small');
}
if ($4da1193211d48b04$var$crypto && $4da1193211d48b04$var$crypto.getRandomValues || false) {
    $4da1193211d48b04$export$bb1abf2ce84fc7e8 = $4da1193211d48b04$var$randomFill;
    $4da1193211d48b04$export$2f7171e78e524d5e = $4da1193211d48b04$var$randomFillSync;
} else {
    $4da1193211d48b04$export$bb1abf2ce84fc7e8 = $4da1193211d48b04$var$oldBrowser;
    $4da1193211d48b04$export$2f7171e78e524d5e = $4da1193211d48b04$var$oldBrowser;
}
function $4da1193211d48b04$var$randomFill(buf, offset, size, cb) {
    if (!$4da1193211d48b04$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === 'function') {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === 'function') {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== 'function') throw new TypeError('"cb" argument must be a function');
    $4da1193211d48b04$var$assertOffset(offset, buf.length);
    $4da1193211d48b04$var$assertSize(size, offset, buf.length);
    return $4da1193211d48b04$var$actualFill(buf, offset, size, cb);
}
function $4da1193211d48b04$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $4da1193211d48b04$var$crypto.getRandomValues(uint);
    if (cb) {
        $1CHRc.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $7kZ78(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $7kZ78(size);
    bytes.copy(buf, offset);
    return buf;
}
function $4da1193211d48b04$var$randomFillSync(buf, offset, size) {
    if (typeof offset === 'undefined') offset = 0;
    if (!$4da1193211d48b04$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $4da1193211d48b04$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $4da1193211d48b04$var$assertSize(size, offset, buf.length);
    return $4da1193211d48b04$var$actualFill(buf, offset, size);
}


$9d2a53801800548c$export$bb1abf2ce84fc7e8 = $4da1193211d48b04$export$bb1abf2ce84fc7e8;
$9d2a53801800548c$export$2f7171e78e524d5e = $4da1193211d48b04$export$2f7171e78e524d5e;
$9d2a53801800548c$export$e1d879b482f37d98 = function() {
    throw new Error('sorry, createCredentials is not implemented yet\nwe accept pull requests\nhttps://github.com/browserify/crypto-browserify');
};
$9d2a53801800548c$export$1a988e7317c65621 = {
    DH_CHECK_P_NOT_SAFE_PRIME: 2,
    DH_CHECK_P_NOT_PRIME: 1,
    DH_UNABLE_TO_CHECK_GENERATOR: 4,
    DH_NOT_SUITABLE_GENERATOR: 8,
    NPN_ENABLED: 1,
    ALPN_ENABLED: 1,
    RSA_PKCS1_PADDING: 1,
    RSA_SSLV23_PADDING: 2,
    RSA_NO_PADDING: 3,
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_X931_PADDING: 5,
    RSA_PKCS1_PSS_PADDING: 6,
    POINT_CONVERSION_COMPRESSED: 2,
    POINT_CONVERSION_UNCOMPRESSED: 4,
    POINT_CONVERSION_HYBRID: 6
};


function $4304bf458d474c32$var$hash(algorithm, data, asBytes = false) {
    const hash1 = (0, (/*@__PURE__*/$parcel$interopDefault($9d2a53801800548c$exports))).createHash(algorithm);
    hash1.update(data);
    if (asBytes) return Array.from(hash1.digest());
    return hash1.digest('hex');
}
function $4304bf458d474c32$export$7904c6256691057a(data) {
    return $4304bf458d474c32$var$hash('sha256', data);
}
function $4304bf458d474c32$export$5fdf8c875acfc1b3(data) {
    return $4304bf458d474c32$var$hash('sha256', data, true);
}
function $4304bf458d474c32$export$bf9b056bcf5cf86a(data) {
    return $4304bf458d474c32$var$hash('sha1', data);
}


let $a6bc5eeab5e36340$var$SESSION_SALT;
const $a6bc5eeab5e36340$export$237ebf1f4974c28e = ()=>{
    $a6bc5eeab5e36340$var$SESSION_SALT = (0, (/*@__PURE__*/$parcel$interopDefault($b0809950592c8add$exports)))();
};
const $a6bc5eeab5e36340$var$toStringArray = (arr)=>`[${arr.map((item)=>$a6bc5eeab5e36340$var$toString(item)).join(',')}]`;
const $a6bc5eeab5e36340$var$toString = (o)=>{
    if (o === null) return 'null';
    if (Array.isArray(o)) return $a6bc5eeab5e36340$var$toStringArray(o);
    if (typeof o == 'object') return $a6bc5eeab5e36340$export$66b1d6a1029e925d(o);
    if (typeof o == 'string') return `"${o}"`;
    return `${o.toString()}`;
};
const $a6bc5eeab5e36340$export$66b1d6a1029e925d = (o)=>{
    if (!$a6bc5eeab5e36340$var$SESSION_SALT) $a6bc5eeab5e36340$export$237ebf1f4974c28e();
    const strToHash = `${Object.entries(o).filter(([_, value])=>typeof value !== 'undefined').sort((a, b)=>a[0].localeCompare(b[0])).map(([key, value])=>`${key}:${$a6bc5eeab5e36340$var$toString(value)}`).join()},${$a6bc5eeab5e36340$var$SESSION_SALT}`;
    return (0, $4304bf458d474c32$export$7904c6256691057a)(strToHash);
};


function $7716b8280f14075e$export$69b4b1e5f81fb1ea(queryParams, paramName) {
    const value = queryParams?.[paramName];
    return Array.isArray(value) ? value[0] : value;
}
function $7716b8280f14075e$export$a44568e95e5c4a5c(queryParams, paramName, defaultValue) {
    const value = $7716b8280f14075e$export$69b4b1e5f81fb1ea(queryParams, paramName);
    const intValue = parseInt(value ?? '', 10);
    return isNaN(intValue) ? defaultValue : intValue;
}







var $414efa7e97a6adf9$export$5e180a90f8d3e374 = /*#__PURE__*/ function(ExperienceTimeout) {
    ExperienceTimeout[ExperienceTimeout["DEFAULT"] = 60000] = "DEFAULT";
    ExperienceTimeout[ExperienceTimeout["CREATE_CONTENT"] = 30000] = "CREATE_CONTENT";
    ExperienceTimeout[ExperienceTimeout["CREATE_DIALOG_LOAD"] = 60000] = "CREATE_DIALOG_LOAD";
    ExperienceTimeout[ExperienceTimeout["MACRO_LOAD"] = 60000] = "MACRO_LOAD";
    ExperienceTimeout[ExperienceTimeout["CREATE_COMMENT_PUBLISH"] = 15000] = "CREATE_COMMENT_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["EDITOR_LOAD"] = 25000] = "EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["EDITOR_PUBLISH"] = 60000] = "EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["LIVE_PAGE_PUBLISH"] = 30000] = "LIVE_PAGE_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_LOAD"] = 90000] = "TEMPLATE_EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_PUBLISH"] = 60000] = "TEMPLATE_EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATE_PANEL_LOAD"] = 20000] = "IN_EDITOR_TEMPLATE_PANEL_LOAD";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR"] = 90000] = "IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR";
    ExperienceTimeout[ExperienceTimeout["HOME"] = 20000] = "HOME";
    ExperienceTimeout[ExperienceTimeout["NAVIGATION_LOAD"] = 30000] = "NAVIGATION_LOAD";
    ExperienceTimeout[ExperienceTimeout["PAGE_LOAD"] = 60000] = "PAGE_LOAD";
    ExperienceTimeout[ExperienceTimeout["SELECT_INLINE_COMMMENT"] = 30000] = "SELECT_INLINE_COMMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_INLINE_COMMENT"] = 30000] = "VIEW_INLINE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["SPACE_DIRECTORY"] = 60000] = "SPACE_DIRECTORY";
    ExperienceTimeout[ExperienceTimeout["SPACE_VIEWS"] = 20000] = "SPACE_VIEWS";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE"] = 20000] = "TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_PREVIEW"] = 20000] = "TEMPLATE_PREVIEW";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_SUGGESTIONS"] = 20000] = "TEMPLATE_SUGGESTIONS";
    ExperienceTimeout[ExperienceTimeout["LOOM_PAGE_HEADER_CONTENT_INSERTION"] = 20000] = "LOOM_PAGE_HEADER_CONTENT_INSERTION";
    return ExperienceTimeout;
}({});




const $e8536e8f091b0e90$export$feb7963ae429f97f = (experienceNames)=>{
    const experienceNameSet = new Set(experienceNames);
    return (events, experience)=>{
        // Fail as soon as any sub-experience is failed or aborted
        experience.stopOn(events.find((event)=>experienceNameSet.has(event.name) && (event.action === 'taskFail' || event.action === 'taskAbort')), {
            incompleteSubExperiences: [
                ...experienceNameSet
            ].join(', ')
        });
        // If there's a success remove the experience from the set
        // of experiences we're waiting for.
        events.forEach((event)=>{
            if ((0, $b4f5dc9bddcbc766$export$16e3f1b03b231b35)(event)) experienceNameSet.delete(event.name);
        });
        // Experience is considered complete if all sub-experiences
        // are complete.
        if (experienceNameSet.size === 0) experience.succeed();
    };
};
const $e8536e8f091b0e90$export$79dbdd3e43727beb = (experienceNames)=>(events, experience)=>experience.stopOn(events.find((event)=>(0, $b4f5dc9bddcbc766$export$16e3f1b03b231b35)(event) && (0, $b4f5dc9bddcbc766$export$57069f5b2ecc9128)(event, ...experienceNames)));









const $403f7817f2b75a1a$var$homeSubExperiences = [
    (0, $d4b865e8cc459c1f$export$d660d67b42309542),
    (0, $d4b865e8cc459c1f$export$94f2ecf008a81b99),
    (0, $d4b865e8cc459c1f$export$45d7f7ed7a82bcd),
    (0, $d4b865e8cc459c1f$export$ecf5fd41d4da9bf8),
    (0, $d4b865e8cc459c1f$export$9b242f2ddcd908fc)
];
function $403f7817f2b75a1a$var$collectHomeNav3(events, experience) {
    const homeExperiences = new Set($403f7817f2b75a1a$var$homeSubExperiences);
    // stop as soon as any sub-experience is failed or aborted
    experience.stopOn(events.find((event)=>(event.action === 'taskFail' || event.action === 'taskAbort') && (homeExperiences.has(event.name) || event.name === (0, $d4b865e8cc459c1f$export$8856e11bfa69959d))));
    // if any of the view experiences succeed AND the spaces experience succeeds, the root home experience should succeed
    let viewExperienceDidSucceed = false;
    let spacesExperienceDidSucceed = false;
    events.forEach((event)=>{
        if ((0, $b4f5dc9bddcbc766$export$16e3f1b03b231b35)(event)) {
            if (homeExperiences.has(event.name)) viewExperienceDidSucceed = true;
            if (event.name === (0, $d4b865e8cc459c1f$export$8856e11bfa69959d) && event.action === 'taskSuccess') spacesExperienceDidSucceed = true;
        }
    });
    if (viewExperienceDidSucceed && spacesExperienceDidSucceed) experience.succeed();
}
function $403f7817f2b75a1a$export$4278268ff5675d74() {
    const isNav4Enabled = (0, $f35f58e56b56de67$export$2af1f7a69c1ab0ad)();
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$66f0a82e06e92ea),
        collect: isNav4Enabled ? (0, $e8536e8f091b0e90$export$79dbdd3e43727beb)($403f7817f2b75a1a$var$homeSubExperiences) : $403f7817f2b75a1a$var$collectHomeNav3
    });
}



const $26ff900bc5da1ddf$var$noPermissionOrNotFoundExperiences = [
    (0, $d4b865e8cc459c1f$export$fbbc408e16c59382),
    (0, $d4b865e8cc459c1f$export$dbbd27df623b094f),
    (0, $d4b865e8cc459c1f$export$727b779ceeca0a78),
    (0, $d4b865e8cc459c1f$export$8f404e4bd2a13aa)
];
const $26ff900bc5da1ddf$var$stopOnNoPermissionOrNotFound = (0, $e8536e8f091b0e90$export$79dbdd3e43727beb)($26ff900bc5da1ddf$var$noPermissionOrNotFoundExperiences);
const $26ff900bc5da1ddf$var$stopOnConnectAddon = (0, $e8536e8f091b0e90$export$79dbdd3e43727beb)([
    (0, $d4b865e8cc459c1f$export$fc0c176abc30d17b)
]);
/**
 * Stores the new experiences started due to SPA transition
 */ const $26ff900bc5da1ddf$var$namesStartedInPreviousRoute = [];
/**
 *  Specifies routes that signify completion for each experience.
 *  Used with experienceTracker's collect function to monitor progress of experiences.
 *  For example, 'create page' experience is considered complete when it leads to 'edit page'.
 */ const $26ff900bc5da1ddf$var$redirectRoutesForExperiences = {
    [(0, $d4b865e8cc459c1f$export$227ea80a7d6d8ef2)]: [
        (0, $0d518026f9d519cf$export$7b1285e36c635f1f).name,
        (0, $0d518026f9d519cf$export$36dcea4e08feb5c9).name,
        (0, $0d518026f9d519cf$export$b74c113024023274).name,
        (0, $0d518026f9d519cf$export$45222bf0cb32d6e2).name,
        (0, $0d518026f9d519cf$export$9257b5b55c8e2555).name
    ],
    [(0, $d4b865e8cc459c1f$export$f27db95814bbdf0)]: [
        (0, $0d518026f9d519cf$export$5b90ced7e51bcea0).name
    ],
    [(0, $d4b865e8cc459c1f$export$13566a78bbba7568)]: [
        (0, $0d518026f9d519cf$export$851ba2be5095d586).name
    ],
    [(0, $d4b865e8cc459c1f$export$c6222c9fbf47e43b)]: [
        (0, $0d518026f9d519cf$export$84b5e15197aaaa12).name
    ]
};
const $26ff900bc5da1ddf$var$EXPERIENCES_TO_ABORT_ON_ROUTE_CHANGE = [
    (0, $d4b865e8cc459c1f$export$20fbac00cba3c8a)
];
const $26ff900bc5da1ddf$export$4b786e0ae0cc0857 = {
    [(0, $0d518026f9d519cf$export$65b723bb995d4fb6).name]: 'space',
    [(0, $0d518026f9d519cf$export$ada7925da580b561).name]: 'space',
    [(0, $0d518026f9d519cf$export$e63a462ee45b57cf).name]: 'page',
    [(0, $0d518026f9d519cf$export$7b1285e36c635f1f).name]: 'page',
    [(0, $0d518026f9d519cf$export$36dcea4e08feb5c9).name]: 'blog',
    [(0, $0d518026f9d519cf$export$9257b5b55c8e2555).name]: 'page',
    [(0, $0d518026f9d519cf$export$91f49e7b30a9d34).name]: 'blog',
    [(0, $0d518026f9d519cf$export$bd2c9bb170b3681d).name]: 'blog'
};
const $26ff900bc5da1ddf$export$5396770e9da36673 = (routeName)=>{
    switch(routeName){
        case (0, $0d518026f9d519cf$export$45222bf0cb32d6e2).name:
        case (0, $0d518026f9d519cf$export$b74c113024023274).name:
        case (0, $0d518026f9d519cf$export$d6ae9e544e98926f).name:
            return 'TINY';
        default:
            return 'FABRIC';
    }
};
function $26ff900bc5da1ddf$export$cac1117e2433d80e(match, transitionId, sessionData) {
    if (!match) return;
    const tracker = (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)();
    // Moves current route data to previous route data to ensure `getExperienceTracker.ts getPreviousRouteExperienceData()` works correctly
    (0, $fb98a59fbc7d7496$export$e8918c537d57dc96)(match.name);
    // Live page's edit-page and session experience starts after the route has finished loading and unsubscribed from the tracker, so it's not in the `startExperienceForRoute` function's namesStartedInPreviousRoute array. We will handle finishing it separately in `finishLivePageExperiences`.
    // It's important that `finishLivePageExperiences` is invoked before we attempt to succeed EDIT_PAGE_EXPERIENCE below, as `finishLivePageExperiences` is responsible for succeeding EDIT_PAGE_EXPERIENCE on live pages while setting the experience attribute `isLivePage
    $26ff900bc5da1ddf$var$finishLivePageExperiences();
    $26ff900bc5da1ddf$var$namesStartedInPreviousRoute.forEach((name)=>{
        const allowedRoutes = $26ff900bc5da1ddf$var$redirectRoutesForExperiences[name];
        // For create content routes, we do not want to abort if it is routing to correct page.
        // But, if it is a create experience and routing to a page is is not supposed to be going to,
        // we can assume something is wrong and we abort it.
        if (allowedRoutes && allowedRoutes.includes(match.name)) return;
        if (// If we were on edit-page or view-page/session experience and leave to another route, we should succeed that experience, not abort it.
        name === (0, $d4b865e8cc459c1f$export$dd70d6707192298e) && (0, $db2847de8e87cb6c$export$2b69dcd5daaf6a2c)() || name === (0, $d4b865e8cc459c1f$export$c6d05c48b9430e3c) && (0, $db2847de8e87cb6c$export$c15dc70f74e1c751)() || name === (0, $d4b865e8cc459c1f$export$5e30e9d7ea54dcd2) && (0, $59f627305e19cfab$export$77dd5573732a240c)()) {
            tracker.succeed({
                name: name
            });
            return;
        }
        // For all other situations, we still abort.
        tracker.abort({
            name: name,
            reason: 'Aborted due to SPA started a new experience'
        });
    });
    $26ff900bc5da1ddf$var$namesStartedInPreviousRoute.length = 0;
    const unsubscribe = tracker.subscribe((e)=>{
        if (e.action === 'taskStart') $26ff900bc5da1ddf$var$namesStartedInPreviousRoute.push(e.name);
    });
    if ((0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_frontend_abort_exp_on_route_change')) $26ff900bc5da1ddf$var$EXPERIENCES_TO_ABORT_ON_ROUTE_CHANGE.forEach((name)=>{
        $26ff900bc5da1ddf$var$namesStartedInPreviousRoute.push(name);
    });
    switch(match.name){
        case (0, $0d518026f9d519cf$export$e003e97fab6b4368).name:
            $26ff900bc5da1ddf$var$startCompanyHubEditor(transitionId, sessionData);
            break;
        case (0, $0d518026f9d519cf$export$e63a462ee45b57cf).name:
        case (0, $0d518026f9d519cf$export$7b1285e36c635f1f).name:
        case (0, $0d518026f9d519cf$export$36dcea4e08feb5c9).name:
        case (0, $0d518026f9d519cf$export$b74c113024023274).name:
        case (0, $0d518026f9d519cf$export$45222bf0cb32d6e2).name:
        case (0, $0d518026f9d519cf$export$d6ae9e544e98926f).name:
        case (0, $0d518026f9d519cf$export$4dd08bdd46db5924).name:
            $26ff900bc5da1ddf$var$startEditPage(match, transitionId, sessionData);
            break;
        case (0, $0d518026f9d519cf$export$9257b5b55c8e2555).name:
        case (0, $0d518026f9d519cf$export$91f49e7b30a9d34).name:
        case (0, $0d518026f9d519cf$export$bd2c9bb170b3681d).name:
            $26ff900bc5da1ddf$var$startViewContent(match.params.contentId, transitionId, $26ff900bc5da1ddf$export$4b786e0ae0cc0857[match.name], match.query, sessionData);
            break;
        case (0, $0d518026f9d519cf$export$bd17e6e353522e0d).name:
            $26ff900bc5da1ddf$var$startEditPageSmartCreate(match);
            break;
        case (0, $0d518026f9d519cf$export$5bfa1fef1b53dfdd).name:
            $26ff900bc5da1ddf$var$startViewPublicLinkGlobalSettings(match.query.tab, match.query.space, transitionId);
            break;
        case (0, $0d518026f9d519cf$export$d593e642a326a501).name:
            $26ff900bc5da1ddf$var$startViewPublicLinkSharedPage(match.params.id, transitionId);
            break;
        case (0, $0d518026f9d519cf$export$65b723bb995d4fb6).name:
            $26ff900bc5da1ddf$var$startViewContent(match.params.spaceKey, transitionId, $26ff900bc5da1ddf$export$4b786e0ae0cc0857[match.name], match.query, sessionData, {
                spaceKey: match.params.spaceKey,
                isLandingPage: match.search === '?mode=global'
            });
            break;
        case (0, $0d518026f9d519cf$export$ada7925da580b561).name:
            const spaceKey = (0, $a4b9a8903fd62c69$export$6193f65d76fa4c00)(sessionData) || '';
            $26ff900bc5da1ddf$var$startViewContent(spaceKey, transitionId, $26ff900bc5da1ddf$export$4b786e0ae0cc0857[match.name], match.query, sessionData, {
                spaceKey: spaceKey
            });
            break;
        case (0, $0d518026f9d519cf$export$a7c5707626fc90f).name:
            (0, $403f7817f2b75a1a$export$4278268ff5675d74)();
            break;
        case (0, $0d518026f9d519cf$export$c0a209b0b0b16c75).name:
        case (0, $0d518026f9d519cf$export$e84c491e2d88d9f6).name:
            $26ff900bc5da1ddf$var$startTemplateEditPage(match.params.contentId, transitionId);
            break;
        case (0, $0d518026f9d519cf$export$dcda7f8b6fe54ba).name:
        case (0, $0d518026f9d519cf$export$dcee5dee04648c93).name:
            $26ff900bc5da1ddf$var$startTemplateEditPage(/* id */ undefined, transitionId);
            break;
        case (0, $0d518026f9d519cf$export$3bd4ec9f05d79904).name:
            $26ff900bc5da1ddf$var$startAdvancedSearch(match);
            break;
        case (0, $0d518026f9d519cf$export$60773cf116cf5f30).name:
            $26ff900bc5da1ddf$var$startArchivedPagesList();
            break;
        case (0, $0d518026f9d519cf$export$f39a30a3a5635bab).name:
            $26ff900bc5da1ddf$var$startContentManager();
            break;
        case (0, $0d518026f9d519cf$export$439074745692fe65).name:
            $26ff900bc5da1ddf$var$startSpaceDirectory();
            break;
        case (0, $0d518026f9d519cf$export$6ccd7dc0d5aa30b0).name:
            $26ff900bc5da1ddf$var$startTemplateGallery();
            break;
        case (0, $0d518026f9d519cf$export$4eb80c3a4e6fbe0f).name:
            $26ff900bc5da1ddf$var$startSpacePages();
            break;
        case (0, $0d518026f9d519cf$export$5b90ced7e51bcea0).name:
            $26ff900bc5da1ddf$var$startWhiteboardBoard(match);
            break;
        case (0, $0d518026f9d519cf$export$851ba2be5095d586).name:
            $26ff900bc5da1ddf$var$startDatabaseView(match.params.contentId);
            break;
        case (0, $0d518026f9d519cf$export$84b5e15197aaaa12).name:
            $26ff900bc5da1ddf$var$startEmbedPageView(match.params.contentId);
            break;
        case (0, $0d518026f9d519cf$export$4dcf771d1a1901ef).name:
            $26ff900bc5da1ddf$var$startFolderView(match.params.contentId);
            break;
        case (0, $0d518026f9d519cf$export$e64d4514fc584fbe).name:
            //Adding the other space perms uplift tabs at a later date.
            if (match.params.tab === 'public-links') $26ff900bc5da1ddf$var$startViewPublicLinksSpaceSettings();
            break;
        case (0, $0d518026f9d519cf$export$3ce513606c31c918).name:
            $26ff900bc5da1ddf$var$startViewAdminAnnouncementBannerSettings();
            break;
        case (0, $0d518026f9d519cf$export$4d1bccc78b263a8e).name:
            $26ff900bc5da1ddf$var$startSpaceManager();
            break;
        case (0, $0d518026f9d519cf$export$8c6393d6207d929).name:
        case (0, $0d518026f9d519cf$export$9397e0d80cf06055).name:
            $26ff900bc5da1ddf$var$startCompanyHomeBuilderLoad();
            break;
    }
    const startCreateOperations = ()=>{
        const subType = typeof match?.query?.subType === 'string' ? match.query.subType : null;
        if (match.name === (0, $0d518026f9d519cf$export$54edf7c16c47aeef).name) $26ff900bc5da1ddf$var$startCreateContent(match, sessionData, subType);
        else if (match.query.createDialog) {
            $26ff900bc5da1ddf$var$startCreatePage(String(transitionId), transitionId, subType);
            (0, $db2847de8e87cb6c$export$b4cbec267823a12e)();
        }
    };
    startCreateOperations();
    unsubscribe();
}
function $26ff900bc5da1ddf$var$startCreatePage(id, transitionId, subType) {
    const experienceTracker = (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)();
    experienceTracker.start({
        name: (0, $d4b865e8cc459c1f$export$227ea80a7d6d8ef2),
        id: id,
        attributes: {
            isLivePage: subType?.toLowerCase() === 'live'
        },
        startTime: transitionId === 0 ? 0 : undefined,
        collect (events, experience) {
            experience.stopOn(events.find((event)=>event.action === 'taskFail' && (0, $b4f5dc9bddcbc766$export$57069f5b2ecc9128)(event, (0, $d4b865e8cc459c1f$export$1773354263fb7a1f), (0, $d4b865e8cc459c1f$export$5f80ef7b2915bb38))));
            experience.stopOn(events.find((event)=>event.action === 'taskSuccess' && (0, $b4f5dc9bddcbc766$export$57069f5b2ecc9128)(event, (0, $d4b865e8cc459c1f$export$5f80ef7b2915bb38))));
            experience.stopOn(events.find((event)=>event.action === 'taskAbort' && (0, $b4f5dc9bddcbc766$export$57069f5b2ecc9128)(event, (0, $d4b865e8cc459c1f$export$5f80ef7b2915bb38))));
        }
    });
    experienceTracker.start({
        name: (0, $d4b865e8cc459c1f$export$1773354263fb7a1f),
        id: id,
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).CREATE_DIALOG_LOAD
    });
}
function $26ff900bc5da1ddf$export$b9a409823a06b924(experienceName) {
    const activeTrace = (0, $aae51952f0016112$export$b6ac780db3a3cc77)();
    if (!activeTrace) (0, $0583deb72bc53d48$export$2e2bcd8739ae039)(experienceName.replace(/\//g, '-'));
}
function $26ff900bc5da1ddf$export$478e84e2cc5ff22d(compoundExperience, editorLoadExperience, editorPublishExperience) {
    const experienceTracker = (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)();
    const compoundTaskId = (0, (/*@__PURE__*/$parcel$interopDefault($c29b43bb0df96673$exports)))();
    const compoundExperienceAttributes = {
        ...compoundExperience.attributes,
        compoundTaskId: compoundTaskId
    };
    experienceTracker.start({
        ...compoundExperience,
        id: compoundTaskId,
        attributes: compoundExperienceAttributes,
        collect: (events, experience)=>{
            experience.stopOn(events.find(({ action: action, name: name })=>action === 'taskFail' && name === editorLoadExperience.name));
            experience.stopOn(events.find(({ action: action, name: name })=>(action === 'taskSuccess' || action === 'taskFail') && name === editorPublishExperience.name));
            if (compoundExperience.collect) compoundExperience.collect(events, experience);
        }
    });
    experienceTracker.start({
        ...editorLoadExperience,
        id: editorLoadExperience.id || compoundExperience.id,
        timeout: editorLoadExperience.timeout || (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).EDITOR_LOAD,
        attributes: compoundExperienceAttributes,
        collect: editorLoadExperience.collect
    });
}
function $26ff900bc5da1ddf$export$7df6656d8508e8da(subExperience) {
    const experienceTracker = (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)();
    // Initialize attributes from the original subExperience
    const attributes = {
        ...subExperience.attributes
    };
    // Extract the compound experience name from the sub-experience name if it follows
    // the naming convention "<compound_experience_name>/<sub_experience>"
    const subExperienceName = subExperience.name;
    const nameParts = subExperienceName.split('/');
    // Only attempt to get compound experience if the name includes a separator
    if (nameParts.length > 1) {
        const compoundExperienceName = nameParts[0];
        const compoundExperienceState = experienceTracker.getExperienceState(compoundExperienceName);
        // If compound experience exists, inherit its compoundTaskId
        if (compoundExperienceState) // Link the compound experience's compoundTaskId if available
        {
            if (compoundExperienceState.attributes?.compoundTaskId) attributes.compoundTaskId = compoundExperienceState.attributes.compoundTaskId;
        }
    }
    // Start the sub-experience with the attributes (original or enhanced with compoundTaskId)
    experienceTracker.start({
        ...subExperience,
        attributes: attributes
    });
}
const $26ff900bc5da1ddf$var$stopOnCloseForEditPage = (events, experience, loadExperienceName, closeExperienceName)=>{
    const loadStopExperience = events.find((event)=>event.name === loadExperienceName && (0, $b4f5dc9bddcbc766$export$16e3f1b03b231b35)(event));
    const closeStopExperience = events.find((event)=>event.name === closeExperienceName && (0, $b4f5dc9bddcbc766$export$16e3f1b03b231b35)(event));
    if (!closeStopExperience) return;
    // prettier-ignore
    if ((!loadStopExperience || loadStopExperience.action !== "taskSuccess") && closeStopExperience.action === "taskSuccess") // loading incomplete or failed, therefore editing session was broken and close doesn't indicate a success
    experience.abort({
        reason: "Editor closed before load completed",
        attributes: {
            loadExperienceState: loadStopExperience?.action ?? "incomplete"
        }
    });
    else experience.stopOn(closeStopExperience);
};
function $26ff900bc5da1ddf$var$startEditPageSmartCreate(match) {
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$9c40f417713b17ea),
        id: match.params.contentId,
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).DEFAULT,
        collect: (events, experience)=>{
            const hasNoPermissionOrNotFoundEvent = events.find((event)=>(0, $b4f5dc9bddcbc766$export$16e3f1b03b231b35)(event) && (0, $b4f5dc9bddcbc766$export$57069f5b2ecc9128)(event, ...$26ff900bc5da1ddf$var$noPermissionOrNotFoundExperiences));
            if (hasNoPermissionOrNotFoundEvent) experience.fail({
                error: new Error(`${hasNoPermissionOrNotFoundEvent.name} experience resulted in ${hasNoPermissionOrNotFoundEvent.action} - unexpected for the smart create editor`)
            });
        }
    });
}
function $26ff900bc5da1ddf$var$startEditPage(match, transitionId, sessionData) {
    const isLegacyEditor = $26ff900bc5da1ddf$export$5396770e9da36673(match?.name ?? '') === 'TINY';
    let editPageExperienceName = (0, $d4b865e8cc459c1f$export$dd70d6707192298e);
    if (match.name === (0, $0d518026f9d519cf$export$e63a462ee45b57cf).name) editPageExperienceName = (0, $d4b865e8cc459c1f$export$b6f302e969b56ed5);
    else if (isLegacyEditor) editPageExperienceName = (0, $d4b865e8cc459c1f$export$cd96dc6a09f60949);
    $26ff900bc5da1ddf$export$478e84e2cc5ff22d(/* compoundExperience */ {
        name: editPageExperienceName,
        id: match.params.contentId,
        startTime: transitionId === 0 ? 0 : undefined,
        attributes: {
            editor: $26ff900bc5da1ddf$export$5396770e9da36673(match.name),
            contentType: $26ff900bc5da1ddf$export$4b786e0ae0cc0857[match.name],
            edition: sessionData?.edition,
            shard: sessionData?.shard,
            isCompanyHub: match?.name === (0, $0d518026f9d519cf$export$e003e97fab6b4368).name || match?.name === (0, $0d518026f9d519cf$export$4dd08bdd46db5924).name,
            contentId: match.params.contentId
        },
        // override with full-page-editor specific stop/collect behaviour
        collect: (events, experience)=>{
            $26ff900bc5da1ddf$var$stopOnNoPermissionOrNotFound(events, experience);
            const loadExperienceName = isLegacyEditor ? (0, $d4b865e8cc459c1f$export$9cfef550e5af515d) : (0, $d4b865e8cc459c1f$export$54650b8dd9597591);
            const closeExperienceName = isLegacyEditor ? (0, $d4b865e8cc459c1f$export$1339ae8dc80b092c) : (0, $d4b865e8cc459c1f$export$92edebd76eb1ad1);
            $26ff900bc5da1ddf$var$stopOnCloseForEditPage(events, experience, loadExperienceName, closeExperienceName);
        }
    }, /* editorLoadExperience */ {
        name: isLegacyEditor ? (0, $d4b865e8cc459c1f$export$9cfef550e5af515d) : (0, $d4b865e8cc459c1f$export$54650b8dd9597591),
        collect: (events, experience)=>{
            $26ff900bc5da1ddf$var$stopOnNoPermissionOrNotFound(events, experience);
            const closeExperienceName = isLegacyEditor ? (0, $d4b865e8cc459c1f$export$1339ae8dc80b092c) : (0, $d4b865e8cc459c1f$export$92edebd76eb1ad1);
            const closeExperience = events.find((event)=>(0, $b4f5dc9bddcbc766$export$16e3f1b03b231b35)(event) && event.name === closeExperienceName);
            if (closeExperience) experience.abort({
                reason: 'Editor closed before load completed',
                attributes: {
                    closeExperienceState: closeExperience?.action ?? 'incomplete'
                }
            });
        }
    }, /* editorPublishExperience */ {
        name: isLegacyEditor ? (0, $d4b865e8cc459c1f$export$770ea955fed26e20) : (0, $d4b865e8cc459c1f$export$4aed0cf42acf9c68)
    });
}
function $26ff900bc5da1ddf$var$startCompanyHubEditor(transitionId, sessionData) {
    $26ff900bc5da1ddf$export$478e84e2cc5ff22d(/* compoundExperience */ {
        name: (0, $d4b865e8cc459c1f$export$c6d05c48b9430e3c),
        startTime: transitionId === 0 ? 0 : undefined,
        attributes: {
            editor: 'FABRIC',
            contentType: 'space',
            edition: sessionData?.edition,
            shard: sessionData?.shard,
            isCompanyHub: true
        },
        collect: (events, experience)=>{
            $26ff900bc5da1ddf$var$stopOnNoPermissionOrNotFound(events, experience);
            $26ff900bc5da1ddf$var$stopOnCloseForEditPage(events, experience, (0, $d4b865e8cc459c1f$export$35975591aeab4dd6), (0, $d4b865e8cc459c1f$export$7a3dfdccebea9c7b));
        }
    }, /* editorLoadExperience */ {
        name: (0, $d4b865e8cc459c1f$export$35975591aeab4dd6),
        collect: (events, experience)=>{
            $26ff900bc5da1ddf$var$stopOnNoPermissionOrNotFound(events, experience);
        }
    }, /* editorPublishExperience */ {
        name: (0, $d4b865e8cc459c1f$export$eef6122c9774ba1c)
    });
}
function $26ff900bc5da1ddf$var$startViewContent(id, transitionId, contentType, query, sessionData, attributes) {
    // WS-3261 - We need to track if the view is coming from an external source (email notification, Slack, etc.)
    const isFromExternal = Boolean(query && query.atlOrigin);
    // Track APDEX part of the content (title and content itself)
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$cf73dfff88c1f700),
        id: id,
        startTime: transitionId === 0 ? 0 : undefined,
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).PAGE_LOAD,
        attributes: {
            contentType: contentType,
            isFromExternal: isFromExternal,
            edition: sessionData?.edition,
            shard: sessionData?.shard,
            ...attributes
        },
        collect: (events, experience)=>{
            $26ff900bc5da1ddf$var$stopOnNoPermissionOrNotFound(events, experience);
            $26ff900bc5da1ddf$var$stopOnConnectAddon(events, experience);
        }
    });
}
function $26ff900bc5da1ddf$var$startViewPublicLinkGlobalSettings(tab, space, transitionId) {
    if (tab === 'public-links' && !space) (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$b1f7a84b45eb9afb),
        id: 'public-links',
        startTime: transitionId === 0 ? 0 : undefined,
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).PAGE_LOAD
    });
}
function $26ff900bc5da1ddf$var$startViewPublicLinksSpaceSettings() {
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$ff2fb656c8231637),
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).PAGE_LOAD
    });
}
function $26ff900bc5da1ddf$var$startViewPublicLinkSharedPage(id, transitionId) {
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$c7ff49e7eaa45ff1),
        id: id,
        startTime: transitionId === 0 ? 0 : undefined,
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).PAGE_LOAD
    });
}
function $26ff900bc5da1ddf$var$startTemplateEditPage(id, transitionId) {
    $26ff900bc5da1ddf$export$478e84e2cc5ff22d(/* compoundExperience */ {
        name: (0, $d4b865e8cc459c1f$export$b9892a850189b3e9),
        id: id,
        startTime: transitionId === 0 ? 0 : undefined,
        collect: (events, experience)=>{
            experience.stopOn(events.find((event)=>(0, $b4f5dc9bddcbc766$export$16e3f1b03b231b35)(event) && event.name === (0, $d4b865e8cc459c1f$export$1a3cf6b911b3771)));
        }
    }, /* editorLoadExperience */ {
        name: (0, $d4b865e8cc459c1f$export$3604f7decc6e0567),
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).TEMPLATE_EDITOR_LOAD
    }, /* editorPublishExperience */ {
        name: (0, $d4b865e8cc459c1f$export$a7f90c693668eabe)
    });
}
function $26ff900bc5da1ddf$var$startAdvancedSearch(match) {
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$5393f7f46c9e5055),
        id: (0, $a6bc5eeab5e36340$export$66b1d6a1029e925d)((0, (/*@__PURE__*/$parcel$interopDefault($8c058a9ce2201bdb$exports)))(match.query, [
            'search_id'
        ]))
    });
}
function $26ff900bc5da1ddf$var$startArchivedPagesList() {
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$d74c17e82f5dbc27)
    });
}
function $26ff900bc5da1ddf$var$startContentManager() {
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$d4b4a08489e4dfe2)
    });
}
function $26ff900bc5da1ddf$var$startSpaceDirectory() {
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$6cebb7e0b005cd28),
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).SPACE_DIRECTORY
    });
}
function $26ff900bc5da1ddf$var$startTemplateGallery() {
    const TemplateGallerySubExperiences = [
        (0, $d4b865e8cc459c1f$export$61439b391c5a3aca),
        (0, $d4b865e8cc459c1f$export$82c983e2a60f2e28),
        (0, $d4b865e8cc459c1f$export$81cd8bf6923e1bf1),
        (0, $d4b865e8cc459c1f$export$b6af3a64b182b9d0)
    ];
    const collectTemplateGalleryLoadExperiences = (events, experience)=>{
        (0, $e8536e8f091b0e90$export$feb7963ae429f97f)(TemplateGallerySubExperiences)(events, experience);
    };
    const stopOnRestrictedPage = (0, $e8536e8f091b0e90$export$feb7963ae429f97f)([
        (0, $d4b865e8cc459c1f$export$dbbd27df623b094f)
    ]);
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$54615853abc6859),
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).DEFAULT,
        collect: (events, experience)=>{
            collectTemplateGalleryLoadExperiences(events, experience);
            stopOnRestrictedPage(events, experience);
        }
    });
}
function $26ff900bc5da1ddf$var$startSpacePages() {
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$1fdf87b44bf66203)
    });
}
function $26ff900bc5da1ddf$var$startCreateContent(match, sessionData, subType) {
    const queryParams = match.query;
    const isPersonalSpace = queryParams.spaceKey?.[0] !== undefined ? (queryParams.spaceKey[0] === '~').toString() : 'unknown';
    const flow = (0, $7716b8280f14075e$export$69b4b1e5f81fb1ea)(queryParams, 'source') || 'createContentRoute';
    if (match.params.contentType === 'whiteboard') (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$f27db95814bbdf0),
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).CREATE_CONTENT,
        attributes: {
            flow: flow,
            isPersonalSpace: isPersonalSpace
        },
        collect: (events, experience)=>{
            const whiteboardExperienceStart = events.find((event)=>event.action === 'taskStart' && event.name === (0, $d4b865e8cc459c1f$export$a83700d85c7e0745));
            if (whiteboardExperienceStart) experience.succeed();
        }
    });
    else if (match.params.contentType === 'database') (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$13566a78bbba7568),
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).CREATE_CONTENT,
        attributes: {
            flow: flow,
            isPersonalSpace: isPersonalSpace
        },
        collect: (events, experience)=>{
            const databaseExperienceStart = events.find((event)=>event.action === 'taskStart' && event.name === (0, $d4b865e8cc459c1f$export$f02aef641190ead6));
            if (databaseExperienceStart) experience.succeed();
        }
    });
    else if (match.params.contentType === 'smartLinkEmbed') (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$c6222c9fbf47e43b),
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).CREATE_CONTENT,
        attributes: {
            flow: flow,
            isPersonalSpace: isPersonalSpace
        },
        collect: (events, experience)=>{
            const smartLinkEmbedExperienceStart = events.find((event)=>event.action === 'taskStart' && event.name === (0, $d4b865e8cc459c1f$export$c85a8dac7f241add));
            if (smartLinkEmbedExperienceStart) experience.succeed();
        }
    });
    else if ([
        'page',
        'blog'
    ].includes(match.params.contentType)) (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$227ea80a7d6d8ef2),
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).CREATE_CONTENT,
        attributes: {
            contentType: match.params.contentType,
            flow: flow,
            isCreateContentRoute: true,
            isPersonalSpace: isPersonalSpace,
            edition: sessionData?.edition,
            shard: sessionData?.shard,
            isLivePage: subType?.toLowerCase() === 'live'
        },
        collect: (events, experience)=>{
            const editPageStarted = events.find((event)=>event.action === 'taskStart' && (event.name === (0, $d4b865e8cc459c1f$export$dd70d6707192298e) || event.name === (0, $d4b865e8cc459c1f$export$cd96dc6a09f60949)));
            if (editPageStarted) experience.succeed();
        }
    });
}
function $26ff900bc5da1ddf$var$startWhiteboardBoard(match) {
    const embeddedWhiteboardSubExperiences = [
        (0, $d4b865e8cc459c1f$export$bdaf5db6d84a5581)
    ];
    const whiteboardSubExperiences = [
        (0, $d4b865e8cc459c1f$export$bdaf5db6d84a5581),
        (0, $d4b865e8cc459c1f$export$7fd0425089f6d999),
        (0, $d4b865e8cc459c1f$export$5870dabed6d7b7fc),
        (0, $d4b865e8cc459c1f$export$47f14e5e827cfff3)
    ];
    const objectHeaderWhiteboardSubExperiences = [
        (0, $d4b865e8cc459c1f$export$bdaf5db6d84a5581),
        (0, $d4b865e8cc459c1f$export$7fd0425089f6d999)
    ];
    const subExperiences = (0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_frontend_content_wrapper') ? objectHeaderWhiteboardSubExperiences : whiteboardSubExperiences;
    const isEmbedded = (0, $f71353228fb46d0d$export$9c21f25960873ecb)();
    const contentId = match.params.contentId;
    $26ff900bc5da1ddf$var$startSubExperiencesForMainExperience(contentId, (0, $d4b865e8cc459c1f$export$a83700d85c7e0745), isEmbedded ? embeddedWhiteboardSubExperiences : subExperiences);
}
function $26ff900bc5da1ddf$var$startDatabaseView(contentId) {
    const databaseSubExperiences = [
        (0, $d4b865e8cc459c1f$export$7140ccdb0c7b2b37),
        (0, $d4b865e8cc459c1f$export$7fd0425089f6d999),
        (0, $d4b865e8cc459c1f$export$5870dabed6d7b7fc)
    ];
    const objectHeaderDatabaseSubExperiences = [
        (0, $d4b865e8cc459c1f$export$7140ccdb0c7b2b37),
        (0, $d4b865e8cc459c1f$export$7fd0425089f6d999)
    ];
    const subExperiences = (0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_frontend_content_wrapper') ? objectHeaderDatabaseSubExperiences : databaseSubExperiences;
    const embeddedDatabaseSubExperiences = [
        (0, $d4b865e8cc459c1f$export$7140ccdb0c7b2b37)
    ];
    const isEmbedded = (0, $f71353228fb46d0d$export$9c21f25960873ecb)();
    $26ff900bc5da1ddf$var$startSubExperiencesForMainExperience(contentId, (0, $d4b865e8cc459c1f$export$f02aef641190ead6), isEmbedded ? embeddedDatabaseSubExperiences : subExperiences);
}
function $26ff900bc5da1ddf$var$startSubExperiencesForMainExperience(contentId, mainExperience, subExperiences) {
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: mainExperience,
        collect: (events, experience)=>{
            (0, $e8536e8f091b0e90$export$feb7963ae429f97f)(subExperiences)(events, experience);
            $26ff900bc5da1ddf$var$stopOnNoPermissionOrNotFound(events, experience);
        },
        id: contentId,
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).DEFAULT
    });
    subExperiences.forEach((name)=>{
        (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
            name: name,
            id: contentId
        });
    });
}
function $26ff900bc5da1ddf$var$startEmbedPageView(contentId) {
    const embedPageSubExperiences = [
        (0, $d4b865e8cc459c1f$export$927658f514adba70),
        (0, $d4b865e8cc459c1f$export$7fd0425089f6d999),
        (0, $d4b865e8cc459c1f$export$5870dabed6d7b7fc)
    ];
    const objectHeaderEmbedSubExperiences = [
        (0, $d4b865e8cc459c1f$export$927658f514adba70),
        (0, $d4b865e8cc459c1f$export$7fd0425089f6d999)
    ];
    const subExperiences = (0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_frontend_content_wrapper') ? objectHeaderEmbedSubExperiences : embedPageSubExperiences;
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$c85a8dac7f241add),
        collect: (events, experience)=>{
            (0, $e8536e8f091b0e90$export$feb7963ae429f97f)(subExperiences)(events, experience);
            $26ff900bc5da1ddf$var$stopOnNoPermissionOrNotFound(events, experience);
        },
        id: contentId,
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).DEFAULT
    });
    embedPageSubExperiences.forEach((name)=>{
        (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
            name: name,
            id: contentId
        });
    });
}
function $26ff900bc5da1ddf$var$startFolderView(contentId) {
    const folderSubExperiences = [
        (0, $d4b865e8cc459c1f$export$6237c6dbe5a63f05)
    ];
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$3485e62ad9c27d0b),
        collect: (events, experience)=>{
            (0, $e8536e8f091b0e90$export$feb7963ae429f97f)(folderSubExperiences)(events, experience);
            $26ff900bc5da1ddf$var$stopOnNoPermissionOrNotFound(events, experience);
        },
        id: contentId,
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).DEFAULT
    });
    folderSubExperiences.forEach((name)=>{
        (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
            name: name,
            id: contentId
        });
    });
}
function $26ff900bc5da1ddf$var$startViewAdminAnnouncementBannerSettings() {
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$394294e59b36efb9),
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).DEFAULT
    });
}
function $26ff900bc5da1ddf$var$startSpaceManager() {
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$548adb1a2fe6e6b1),
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).DEFAULT
    });
}
function $26ff900bc5da1ddf$var$startCompanyHomeBuilderLoad() {
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$c9f8ebbba8f73eeb),
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).DEFAULT
    });
}
function $26ff900bc5da1ddf$var$finishLivePageExperiences() {
    const tracker = (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)();
    const livePageExperiencesToSucceed = [
        (0, $33515bae88ccc425$export$44bb710761a63941)(),
        (0, $d4b865e8cc459c1f$export$3814d28dd3802a02)
    ];
    livePageExperiencesToSucceed.forEach((experience)=>{
        const experienceState = tracker.getExperienceState(experience);
        // We want to identify if it's actively running, and if so, succeed it. This aligns with how we succeed non-live-page experiences on transition.
        // We validate the `isLivePage` attribute is `true` before succeeding, to avoid undesirably succeeding edit-page here when it's not a live page
        if (experienceState && !experienceState?.hasStopped && experienceState?.attributes?.isLivePage) tracker.succeed({
            name: experience
        });
    });
}


const $3016628fdaa9d06d$var$routeNamesThatRedirectToHome = [
    (0, $0d518026f9d519cf$export$9e15ff8aa6bc996f).name,
    (0, $0d518026f9d519cf$export$2fd309376969662f).name,
    (0, $0d518026f9d519cf$export$f178fb5b1e822288).name,
    (0, $0d518026f9d519cf$export$e9d78b13bbb4e56f).name
];
const $3016628fdaa9d06d$export$265842b0d6c0fe29 = (url, entryPoint)=>{
    const experienceTracker = (0, $gqzfn.useContext)((0, $15f344f9545a569e$export$a7b0697657ed8bd0));
    (0, $gqzfn.useEffect)(()=>{
        let routeMatch = (0, $64a554d15bd769f3$export$b6024a131a1561d9)((0, $4b957fb9fbb0eafa$export$d4971375353d0454), url);
        // If the route redirects to /home, convert the URL to a HOME URL
        if (!!routeMatch?.name && $3016628fdaa9d06d$var$routeNamesThatRedirectToHome.includes(routeMatch?.name)) {
            const routeQuery = routeMatch?.query;
            const routeHash = routeMatch?.hash;
            const homeUrl = (0, $0d518026f9d519cf$export$a7c5707626fc90f).toUrl(undefined, {
                query: routeQuery,
                hash: routeHash
            });
            routeMatch = (0, $64a554d15bd769f3$export$b6024a131a1561d9)((0, $4b957fb9fbb0eafa$export$d4971375353d0454), homeUrl);
        }
        if (routeMatch) {
            (0, $26ff900bc5da1ddf$export$cac1117e2433d80e)(routeMatch, 0);
            experienceTracker.fail({
                error: new Error('FATAL ERROR: Error SPA rendered'),
                attributes: {
                    entryPoint: entryPoint ?? 'unknown'
                }
            });
        }
    }, [
        experienceTracker,
        url,
        entryPoint
    ]);
};


const $279e71d7cd30ff83$export$f13ee9e4cfc1cf45 = ({ entryPoint: entryPoint })=>{
    const [isInitialized, setInitialized] = (0, $gqzfn.useState)(false);
    (0, $gqzfn.useEffect)(()=>{
        (0, $6d6794975d4b2dd0$export$66b82bc0ee0db41d)().then(()=>{
            setInitialized(true);
        });
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement((0, $15f344f9545a569e$export$a7b0697657ed8bd0).Provider, {
        value: (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement((0, $e435e378975f2891$export$b5ed68f0a0a58a22), null), isInitialized ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement($279e71d7cd30ff83$var$ExperienceFailureForRoot, {
        entryPoint: entryPoint
    }) : null);
};
const $279e71d7cd30ff83$var$ExperienceFailureForRoot = ({ entryPoint: entryPoint })=>{
    (0, $gqzfn.useEffect)(()=>{
        (0, $b76dfd1db5681318$export$e9ba7ef9458d1a4a)().then((client)=>client.sendScreenEvent({
                name: 'standaloneErrorApp'
            }));
    }, []);
    // eslint-disable-next-line no-restricted-syntax
    (0, $3016628fdaa9d06d$export$265842b0d6c0fe29)(window.location.href, entryPoint);
    return null;
};




/**
 * Please note this package is pre-compiled so you are required to
 * run `yarn build` and check-in the generated files in `prebuild` folder.
 */ /**
 * DO NOT ADD ANY ADDITIONAL LOGIC IN THIS FILE.
 * THIS FILE IS NOT ALWAYS LOADED WITH THE ERROR APP.
 *
 * If you need to add any logic to the error app, add it in the `ErrorApp` component or one of its children
 *
 * The Error App can either be rendered by EITHER:
 * 1. loading the prebuilt HTML, which requires this JS file (cc-proxy does this), or
 * 2. directly rendering the (loadable) <ErrorApp> component, which circumvents this JS file (the main
 * CFE SPA does this in `confluence-frontend-server/src/index.js`)
 */ // eslint-disable-next-line react/no-deprecated
(0, (/*@__PURE__*/$parcel$interopDefault($562ef484027f8b93$exports))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gqzfn))).createElement((0, $279e71d7cd30ff83$export$f13ee9e4cfc1cf45), {
    entryPoint: "standaloneErrorApp"
}), document.getElementById('confluence-ui'));
 }, ["ktrqQ"]);

$parcel$global.rlb("kpJNO")
//# sourceMappingURL=error-app.0e6a7bd5.js.map
